import Vue from 'vue';
import t from 'fs';

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

function commonjsRequire (path) {
	throw new Error('Could not dynamically require "' + path + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}

var is$1 = {exports: {}};

/*!
 * is.js 0.8.0
 * Author: Aras Atasaygin
 */

(function (module, exports) {
(function(root, factory) {    // eslint-disable-line no-extra-semi
    {
        // Node. Does not work with strict CommonJS, but
        // only CommonJS-like enviroments that support module.exports,
        // like Node.
        module.exports = factory();
    }
}(commonjsGlobal, function() {

    // Baseline
    /* -------------------------------------------------------------------------- */

    // define 'is' object and current version
    var is = {};
    is.VERSION = '0.8.0';

    // define interfaces
    is.not = {};
    is.all = {};
    is.any = {};

    // cache some methods to call later on
    var toString = Object.prototype.toString;
    var slice = Array.prototype.slice;
    var hasOwnProperty = Object.prototype.hasOwnProperty;

    // helper function which reverses the sense of predicate result
    function not(func) {
        return function() {
            return !func.apply(null, slice.call(arguments));
        };
    }

    // helper function which call predicate function per parameter and return true if all pass
    function all(func) {
        return function() {
            var params = getParams(arguments);
            var length = params.length;
            for (var i = 0; i < length; i++) {
                if (!func.call(null, params[i])) {
                    return false;
                }
            }
            return true;
        };
    }

    // helper function which call predicate function per parameter and return true if any pass
    function any(func) {
        return function() {
            var params = getParams(arguments);
            var length = params.length;
            for (var i = 0; i < length; i++) {
                if (func.call(null, params[i])) {
                    return true;
                }
            }
            return false;
        };
    }

    // build a 'comparator' object for various comparison checks
    var comparator = {
        '<': function(a, b) { return a < b; },
        '<=': function(a, b) { return a <= b; },
        '>': function(a, b) { return a > b; },
        '>=': function(a, b) { return a >= b; }
    };

    // helper function which compares a version to a range
    function compareVersion(version, range) {
        var string = (range + '');
        var n = +(string.match(/\d+/) || NaN);
        var op = string.match(/^[<>]=?|/)[0];
        return comparator[op] ? comparator[op](version, n) : (version == n || n !== n);
    }

    // helper function which extracts params from arguments
    function getParams(args) {
        var params = slice.call(args);
        var length = params.length;
        if (length === 1 && is.array(params[0])) {    // support array
            params = params[0];
        }
        return params;
    }

    // Type checks
    /* -------------------------------------------------------------------------- */

    // is a given value Arguments?
    is.arguments = function(value) {    // fallback check is for IE
        return toString.call(value) === '[object Arguments]' ||
            (value != null && typeof value === 'object' && 'callee' in value);
    };

    // is a given value Array?
    is.array = Array.isArray || function(value) {    // check native isArray first
        return toString.call(value) === '[object Array]';
    };

    // is a given value Boolean?
    is.boolean = function(value) {
        return value === true || value === false || toString.call(value) === '[object Boolean]';
    };

    // is a given value Char?
    is.char = function(value) {
        return is.string(value) && value.length === 1;
    };

    // is a given value Date Object?
    is.date = function(value) {
        return toString.call(value) === '[object Date]';
    };

    // is a given object a DOM node?
    is.domNode = function(object) {
        return is.object(object) && object.nodeType > 0;
    };

    // is a given value Error object?
    is.error = function(value) {
        return toString.call(value) === '[object Error]';
    };

    // is a given value function?
    is['function'] = function(value) {    // fallback check is for IE
        return toString.call(value) === '[object Function]' || typeof value === 'function';
    };

    // is given value a pure JSON object?
    is.json = function(value) {
        return toString.call(value) === '[object Object]';
    };

    // is a given value NaN?
    is.nan = function(value) {    // NaN is number :) Also it is the only value which does not equal itself
        return value !== value;
    };

    // is a given value null?
    is['null'] = function(value) {
        return value === null;
    };

    // is a given value number?
    is.number = function(value) {
        return is.not.nan(value) && toString.call(value) === '[object Number]';
    };

    // is a given value object?
    is.object = function(value) {
        return Object(value) === value;
    };

    // is a given value RegExp?
    is.regexp = function(value) {
        return toString.call(value) === '[object RegExp]';
    };

    // are given values same type?
    // prevent NaN, Number same type check
    is.sameType = function(value, other) {
        var tag = toString.call(value);
        if (tag !== toString.call(other)) {
            return false;
        }
        if (tag === '[object Number]') {
            return !is.any.nan(value, other) || is.all.nan(value, other);
        }
        return true;
    };
    // sameType method does not support 'all' and 'any' interfaces
    is.sameType.api = ['not'];

    // is a given value String?
    is.string = function(value) {
        return toString.call(value) === '[object String]';
    };

    // is a given value undefined?
    is.undefined = function(value) {
        return value === void 0;
    };

    // is a given value window?
    // setInterval method is only available for window object
    is.windowObject = function(value) {
        return value != null && typeof value === 'object' && 'setInterval' in value;
    };

    // Presence checks
    /* -------------------------------------------------------------------------- */

    //is a given value empty? Objects, arrays, strings
    is.empty = function(value) {
        if (is.object(value)) {
            var length = Object.getOwnPropertyNames(value).length;
            if (length === 0 || (length === 1 && is.array(value)) ||
                    (length === 2 && is.arguments(value))) {
                return true;
            }
            return false;
        }
        return value === '';
    };

    // is a given value existy?
    is.existy = function(value) {
        return value != null;
    };

    // is a given value falsy?
    is.falsy = function(value) {
        return !value;
    };

    // is a given value truthy?
    is.truthy = not(is.falsy);

    // Arithmetic checks
    /* -------------------------------------------------------------------------- */

    // is a given number above minimum parameter?
    is.above = function(n, min) {
        return is.all.number(n, min) && n > min;
    };
    // above method does not support 'all' and 'any' interfaces
    is.above.api = ['not'];

    // is a given number decimal?
    is.decimal = function(n) {
        return is.number(n) && n % 1 !== 0;
    };

    // are given values equal? supports numbers, strings, regexes, booleans
    // TODO: Add object and array support
    is.equal = function(value, other) {
        // check 0 and -0 equity with Infinity and -Infinity
        if (is.all.number(value, other)) {
            return value === other && 1 / value === 1 / other;
        }
        // check regexes as strings too
        if (is.all.string(value, other) || is.all.regexp(value, other)) {
            return '' + value === '' + other;
        }
        if (is.all.boolean(value, other)) {
            return value === other;
        }
        return false;
    };
    // equal method does not support 'all' and 'any' interfaces
    is.equal.api = ['not'];

    // is a given number even?
    is.even = function(n) {
        return is.number(n) && n % 2 === 0;
    };

    // is a given number finite?
    is.finite = isFinite || function(n) {
        return is.not.infinite(n) && is.not.nan(n);
    };

    // is a given number infinite?
    is.infinite = function(n) {
        return n === Infinity || n === -Infinity;
    };

    // is a given number integer?
    is.integer = function(n) {
        return is.number(n) && n % 1 === 0;
    };

    // is a given number negative?
    is.negative = function(n) {
        return is.number(n) && n < 0;
    };

    // is a given number odd?
    is.odd = function(n) {
        return is.number(n) && n % 2 === 1;
    };

    // is a given number positive?
    is.positive = function(n) {
        return is.number(n) && n > 0;
    };

    // is a given number above maximum parameter?
    is.under = function(n, max) {
        return is.all.number(n, max) && n < max;
    };
    // least method does not support 'all' and 'any' interfaces
    is.under.api = ['not'];

    // is a given number within minimum and maximum parameters?
    is.within = function(n, min, max) {
        return is.all.number(n, min, max) && n > min && n < max;
    };
    // within method does not support 'all' and 'any' interfaces
    is.within.api = ['not'];

    // Regexp checks
    /* -------------------------------------------------------------------------- */
    // Steven Levithan, Jan Goyvaerts: Regular Expressions Cookbook
    // Scott Gonzalez: Email address validation

    // dateString match m/d/yy and mm/dd/yyyy, allowing any combination of one or two digits for the day and month, and two or four digits for the year
    // eppPhone match extensible provisioning protocol format
    // nanpPhone match north american number plan format
    // time match hours, minutes, and seconds, 24-hour clock
    var regexes = {
        affirmative: /^(?:1|t(?:rue)?|y(?:es)?|ok(?:ay)?)$/,
        alphaNumeric: /^[A-Za-z0-9]+$/,
        caPostalCode: /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z]\s?[0-9][A-Z][0-9]$/,
        creditCard: /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/,
        dateString: /^(1[0-2]|0?[1-9])([\/-])(3[01]|[12][0-9]|0?[1-9])(?:\2)(?:[0-9]{2})?[0-9]{2}$/,
        email: /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i, // eslint-disable-line no-control-regex
        eppPhone: /^\+[0-9]{1,3}\.[0-9]{4,14}(?:x.+)?$/,
        hexadecimal: /^(?:0x)?[0-9a-fA-F]+$/,
        hexColor: /^#?([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/,
        ipv4: /^(?:(?:\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])\.){3}(?:\d|[1-9]\d|1\d{2}|2[0-4]\d|25[0-5])$/,
        ipv6: /^((?=.*::)(?!.*::.+::)(::)?([\dA-F]{1,4}:(:|\b)|){5}|([\dA-F]{1,4}:){6})((([\dA-F]{1,4}((?!\3)::|:\b|$))|(?!\2\3)){2}|(((2[0-4]|1\d|[1-9])?\d|25[0-5])\.?\b){4})$/i,
        nanpPhone: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
        socialSecurityNumber: /^(?!000|666)[0-8][0-9]{2}-?(?!00)[0-9]{2}-?(?!0000)[0-9]{4}$/,
        timeString: /^(2[0-3]|[01]?[0-9]):([0-5]?[0-9]):([0-5]?[0-9])$/,
        ukPostCode: /^[A-Z]{1,2}[0-9RCHNQ][0-9A-Z]?\s?[0-9][ABD-HJLNP-UW-Z]{2}$|^[A-Z]{2}-?[0-9]{4}$/,
        url: /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/i,
        usZipCode: /^[0-9]{5}(?:-[0-9]{4})?$/
    };

    function regexpCheck(regexp, regexes) {
        is[regexp] = function(value) {
            return regexes[regexp].test(value);
        };
    }

    // create regexp checks methods from 'regexes' object
    for (var regexp in regexes) {
        if (regexes.hasOwnProperty(regexp)) {
            regexpCheck(regexp, regexes);
        }
    }

    // simplify IP checks by calling the regex helpers for IPv4 and IPv6
    is.ip = function(value) {
        return is.ipv4(value) || is.ipv6(value);
    };

    // String checks
    /* -------------------------------------------------------------------------- */

    // is a given string or sentence capitalized?
    is.capitalized = function(string) {
        if (is.not.string(string)) {
            return false;
        }
        var words = string.split(' ');
        for (var i = 0; i < words.length; i++) {
            var word = words[i];
            if (word.length) {
                var chr = word.charAt(0);
                if (chr !== chr.toUpperCase()) {
                    return false;
                }
            }
        }
        return true;
    };

    // is string end with a given target parameter?
    is.endWith = function(string, target) {
        if (is.not.string(string)) {
            return false;
        }
        target += '';
        var position = string.length - target.length;
        return position >= 0 && string.indexOf(target, position) === position;
    };
    // endWith method does not support 'all' and 'any' interfaces
    is.endWith.api = ['not'];

    // is a given string include parameter target?
    is.include = function(string, target) {
        return string.indexOf(target) > -1;
    };
    // include method does not support 'all' and 'any' interfaces
    is.include.api = ['not'];

    // is a given string all lowercase?
    is.lowerCase = function(string) {
        return is.string(string) && string === string.toLowerCase();
    };

    // is a given string palindrome?
    is.palindrome = function(string) {
        if (is.not.string(string)) {
            return false;
        }
        string = string.replace(/[^a-zA-Z0-9]+/g, '').toLowerCase();
        var length = string.length - 1;
        for (var i = 0, half = Math.floor(length / 2); i <= half; i++) {
            if (string.charAt(i) !== string.charAt(length - i)) {
                return false;
            }
        }
        return true;
    };

    // is a given value space?
    // horizantal tab: 9, line feed: 10, vertical tab: 11, form feed: 12, carriage return: 13, space: 32
    is.space = function(value) {
        if (is.not.char(value)) {
            return false;
        }
        var charCode = value.charCodeAt(0);
        return (charCode > 8 && charCode < 14) || charCode === 32;
    };

    // is string start with a given target parameter?
    is.startWith = function(string, target) {
        return is.string(string) && string.indexOf(target) === 0;
    };
    // startWith method does not support 'all' and 'any' interfaces
    is.startWith.api = ['not'];

    // is a given string all uppercase?
    is.upperCase = function(string) {
        return is.string(string) && string === string.toUpperCase();
    };

    // Time checks
    /* -------------------------------------------------------------------------- */

    var days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    var months = ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'];

    // is a given dates day equal given day parameter?
    is.day = function(date, day) {
        return is.date(date) && day.toLowerCase() === days[date.getDay()];
    };
    // day method does not support 'all' and 'any' interfaces
    is.day.api = ['not'];

    // is a given date in daylight saving time?
    is.dayLightSavingTime = function(date) {
        var january = new Date(date.getFullYear(), 0, 1);
        var july = new Date(date.getFullYear(), 6, 1);
        var stdTimezoneOffset = Math.max(january.getTimezoneOffset(), july.getTimezoneOffset());
        return date.getTimezoneOffset() < stdTimezoneOffset;
    };

    // is a given date future?
    is.future = function(date) {
        var now = new Date();
        return is.date(date) && date.getTime() > now.getTime();
    };

    // is date within given range?
    is.inDateRange = function(date, start, end) {
        if (is.not.date(date) || is.not.date(start) || is.not.date(end)) {
            return false;
        }
        var stamp = date.getTime();
        return stamp > start.getTime() && stamp < end.getTime();
    };
    // inDateRange method does not support 'all' and 'any' interfaces
    is.inDateRange.api = ['not'];

    // is a given date in last month range?
    is.inLastMonth = function(date) {
        return is.inDateRange(date, new Date(new Date().setMonth(new Date().getMonth() - 1)), new Date());
    };

    // is a given date in last week range?
    is.inLastWeek = function(date) {
        return is.inDateRange(date, new Date(new Date().setDate(new Date().getDate() - 7)), new Date());
    };

    // is a given date in last year range?
    is.inLastYear = function(date) {
        return is.inDateRange(date, new Date(new Date().setFullYear(new Date().getFullYear() - 1)), new Date());
    };

    // is a given date in next month range?
    is.inNextMonth = function(date) {
        return is.inDateRange(date, new Date(), new Date(new Date().setMonth(new Date().getMonth() + 1)));
    };

    // is a given date in next week range?
    is.inNextWeek = function(date) {
        return is.inDateRange(date, new Date(), new Date(new Date().setDate(new Date().getDate() + 7)));
    };

    // is a given date in next year range?
    is.inNextYear = function(date) {
        return is.inDateRange(date, new Date(), new Date(new Date().setFullYear(new Date().getFullYear() + 1)));
    };

    // is the given year a leap year?
    is.leapYear = function(year) {
        return is.number(year) && ((year % 4 === 0 && year % 100 !== 0) || year % 400 === 0);
    };

    // is a given dates month equal given month parameter?
    is.month = function(date, month) {
        return is.date(date) && month.toLowerCase() === months[date.getMonth()];
    };
    // month method does not support 'all' and 'any' interfaces
    is.month.api = ['not'];

    // is a given date past?
    is.past = function(date) {
        var now = new Date();
        return is.date(date) && date.getTime() < now.getTime();
    };

    // is a given date in the parameter quarter?
    is.quarterOfYear = function(date, quarter) {
        return is.date(date) && is.number(quarter) && quarter === Math.floor((date.getMonth() + 3) / 3);
    };
    // quarterOfYear method does not support 'all' and 'any' interfaces
    is.quarterOfYear.api = ['not'];

    // is a given date indicate today?
    is.today = function(date) {
        var now = new Date();
        var todayString = now.toDateString();
        return is.date(date) && date.toDateString() === todayString;
    };

    // is a given date indicate tomorrow?
    is.tomorrow = function(date) {
        var now = new Date();
        var tomorrowString = new Date(now.setDate(now.getDate() + 1)).toDateString();
        return is.date(date) && date.toDateString() === tomorrowString;
    };

    // is a given date weekend?
    // 6: Saturday, 0: Sunday
    is.weekend = function(date) {
        return is.date(date) && (date.getDay() === 6 || date.getDay() === 0);
    };

    // is a given date weekday?
    is.weekday = not(is.weekend);

    // is a given dates year equal given year parameter?
    is.year = function(date, year) {
        return is.date(date) && is.number(year) && year === date.getFullYear();
    };
    // year method does not support 'all' and 'any' interfaces
    is.year.api = ['not'];

    // is a given date indicate yesterday?
    is.yesterday = function(date) {
        var now = new Date();
        var yesterdayString = new Date(now.setDate(now.getDate() - 1)).toDateString();
        return is.date(date) && date.toDateString() === yesterdayString;
    };

    // Environment checks
    /* -------------------------------------------------------------------------- */

    var freeGlobal = is.windowObject(typeof commonjsGlobal == 'object' && commonjsGlobal) && commonjsGlobal;
    var freeSelf = is.windowObject(typeof self == 'object' && self) && self;
    var thisGlobal = is.windowObject(typeof this == 'object' && this) && this;
    var root = freeGlobal || freeSelf || thisGlobal || Function('return this')();

    var document = freeSelf && freeSelf.document;
    var previousIs = root.is;

    // store navigator properties to use later
    var navigator = freeSelf && freeSelf.navigator;
    var appVersion = (navigator && navigator.appVersion || '').toLowerCase();
    var userAgent = (navigator && navigator.userAgent || '').toLowerCase();
    var vendor = (navigator && navigator.vendor || '').toLowerCase();

    // is current device android?
    is.android = function() {
        return /android/.test(userAgent);
    };
    // android method does not support 'all' and 'any' interfaces
    is.android.api = ['not'];

    // is current device android phone?
    is.androidPhone = function() {
        return /android/.test(userAgent) && /mobile/.test(userAgent);
    };
    // androidPhone method does not support 'all' and 'any' interfaces
    is.androidPhone.api = ['not'];

    // is current device android tablet?
    is.androidTablet = function() {
        return /android/.test(userAgent) && !/mobile/.test(userAgent);
    };
    // androidTablet method does not support 'all' and 'any' interfaces
    is.androidTablet.api = ['not'];

    // is current device blackberry?
    is.blackberry = function() {
        return /blackberry/.test(userAgent) || /bb10/.test(userAgent);
    };
    // blackberry method does not support 'all' and 'any' interfaces
    is.blackberry.api = ['not'];

    // is current browser chrome?
    // parameter is optional
    is.chrome = function(range) {
        var match = /google inc/.test(vendor) ? userAgent.match(/(?:chrome|crios)\/(\d+)/) : null;
        return match !== null && compareVersion(match[1], range);
    };
    // chrome method does not support 'all' and 'any' interfaces
    is.chrome.api = ['not'];

    // is current device desktop?
    is.desktop = function() {
        return is.not.mobile() && is.not.tablet();
    };
    // desktop method does not support 'all' and 'any' interfaces
    is.desktop.api = ['not'];

    // is current browser edge?
    // parameter is optional
    is.edge = function(range) {
        var match = userAgent.match(/edge\/(\d+)/);
        return match !== null && compareVersion(match[1], range);
    };
    // edge method does not support 'all' and 'any' interfaces
    is.edge.api = ['not'];

    // is current browser firefox?
    // parameter is optional
    is.firefox = function(range) {
        var match = userAgent.match(/(?:firefox|fxios)\/(\d+)/);
        return match !== null && compareVersion(match[1], range);
    };
    // firefox method does not support 'all' and 'any' interfaces
    is.firefox.api = ['not'];

    // is current browser internet explorer?
    // parameter is optional
    is.ie = function(range) {
        var match = userAgent.match(/(?:msie |trident.+?; rv:)(\d+)/);
        return match !== null && compareVersion(match[1], range);
    };
    // ie method does not support 'all' and 'any' interfaces
    is.ie.api = ['not'];

    // is current device ios?
    is.ios = function() {
        return is.iphone() || is.ipad() || is.ipod();
    };
    // ios method does not support 'all' and 'any' interfaces
    is.ios.api = ['not'];

    // is current device ipad?
    // parameter is optional
    is.ipad = function(range) {
        var match = userAgent.match(/ipad.+?os (\d+)/);
        return match !== null && compareVersion(match[1], range);
    };
    // ipad method does not support 'all' and 'any' interfaces
    is.ipad.api = ['not'];

    // is current device iphone?
    // parameter is optional
    is.iphone = function(range) {
        // original iPhone doesn't have the os portion of the UA
        var match = userAgent.match(/iphone(?:.+?os (\d+))?/);
        return match !== null && compareVersion(match[1] || 1, range);
    };
    // iphone method does not support 'all' and 'any' interfaces
    is.iphone.api = ['not'];

    // is current device ipod?
    // parameter is optional
    is.ipod = function(range) {
        var match = userAgent.match(/ipod.+?os (\d+)/);
        return match !== null && compareVersion(match[1], range);
    };
    // ipod method does not support 'all' and 'any' interfaces
    is.ipod.api = ['not'];

    // is current operating system linux?
    is.linux = function() {
        return /linux/.test(appVersion);
    };
    // linux method does not support 'all' and 'any' interfaces
    is.linux.api = ['not'];

    // is current operating system mac?
    is.mac = function() {
        return /mac/.test(appVersion);
    };
    // mac method does not support 'all' and 'any' interfaces
    is.mac.api = ['not'];

    // is current device mobile?
    is.mobile = function() {
        return is.iphone() || is.ipod() || is.androidPhone() || is.blackberry() || is.windowsPhone();
    };
    // mobile method does not support 'all' and 'any' interfaces
    is.mobile.api = ['not'];

    // is current state offline?
    is.offline = not(is.online);
    // offline method does not support 'all' and 'any' interfaces
    is.offline.api = ['not'];

    // is current state online?
    is.online = function() {
        return !navigator || navigator.onLine === true;
    };
    // online method does not support 'all' and 'any' interfaces
    is.online.api = ['not'];

    // is current browser opera?
    // parameter is optional
    is.opera = function(range) {
        var match = userAgent.match(/(?:^opera.+?version|opr)\/(\d+)/);
        return match !== null && compareVersion(match[1], range);
    };
    // opera method does not support 'all' and 'any' interfaces
    is.opera.api = ['not'];

    // is current browser phantomjs?
    // parameter is optional
    is.phantom = function(range) {
        var match = userAgent.match(/phantomjs\/(\d+)/);
        return match !== null && compareVersion(match[1], range);
    };
    // phantom method does not support 'all' and 'any' interfaces
    is.phantom.api = ['not'];

    // is current browser safari?
    // parameter is optional
    is.safari = function(range) {
        var match = userAgent.match(/version\/(\d+).+?safari/);
        return match !== null && compareVersion(match[1], range);
    };
    // safari method does not support 'all' and 'any' interfaces
    is.safari.api = ['not'];

    // is current device tablet?
    is.tablet = function() {
        return is.ipad() || is.androidTablet() || is.windowsTablet();
    };
    // tablet method does not support 'all' and 'any' interfaces
    is.tablet.api = ['not'];

    // is current device supports touch?
    is.touchDevice = function() {
        return !!document && ('ontouchstart' in freeSelf ||
            ('DocumentTouch' in freeSelf && document instanceof DocumentTouch));
    };
    // touchDevice method does not support 'all' and 'any' interfaces
    is.touchDevice.api = ['not'];

    // is current operating system windows?
    is.windows = function() {
        return /win/.test(appVersion);
    };
    // windows method does not support 'all' and 'any' interfaces
    is.windows.api = ['not'];

    // is current device windows phone?
    is.windowsPhone = function() {
        return is.windows() && /phone/.test(userAgent);
    };
    // windowsPhone method does not support 'all' and 'any' interfaces
    is.windowsPhone.api = ['not'];

    // is current device windows tablet?
    is.windowsTablet = function() {
        return is.windows() && is.not.windowsPhone() && /touch/.test(userAgent);
    };
    // windowsTablet method does not support 'all' and 'any' interfaces
    is.windowsTablet.api = ['not'];

    // Object checks
    /* -------------------------------------------------------------------------- */

    // has a given object got parameterized count property?
    is.propertyCount = function(object, count) {
        if (is.not.object(object) || is.not.number(count)) {
            return false;
        }
        var n = 0;
        for (var property in object) {
            if (hasOwnProperty.call(object, property) && ++n > count) {
                return false;
            }
        }
        return n === count;
    };
    // propertyCount method does not support 'all' and 'any' interfaces
    is.propertyCount.api = ['not'];

    // is given object has parameterized property?
    is.propertyDefined = function(object, property) {
        return is.object(object) && is.string(property) && property in object;
    };
    // propertyDefined method does not support 'all' and 'any' interfaces
    is.propertyDefined.api = ['not'];

    // Array checks
    /* -------------------------------------------------------------------------- */

    // is a given item in an array?
    is.inArray = function(value, array) {
        if (is.not.array(array)) {
            return false;
        }
        for (var i = 0; i < array.length; i++) {
            if (array[i] === value) {
                return true;
            }
        }
        return false;
    };
    // inArray method does not support 'all' and 'any' interfaces
    is.inArray.api = ['not'];

    // is a given array sorted?
    is.sorted = function(array, sign) {
        if (is.not.array(array)) {
            return false;
        }
        var predicate = comparator[sign] || comparator['>='];
        for (var i = 1; i < array.length; i++) {
            if (!predicate(array[i], array[i - 1])) {
                return false;
            }
        }
        return true;
    };

    // API
    // Set 'not', 'all' and 'any' interfaces to methods based on their api property
    /* -------------------------------------------------------------------------- */

    function setInterfaces() {
        var options = is;
        for (var option in options) {
            if (hasOwnProperty.call(options, option) && is['function'](options[option])) {
                var interfaces = options[option].api || ['not', 'all', 'any'];
                for (var i = 0; i < interfaces.length; i++) {
                    if (interfaces[i] === 'not') {
                        is.not[option] = not(is[option]);
                    }
                    if (interfaces[i] === 'all') {
                        is.all[option] = all(is[option]);
                    }
                    if (interfaces[i] === 'any') {
                        is.any[option] = any(is[option]);
                    }
                }
            }
        }
    }
    setInterfaces();

    // Configuration methods
    // Intentionally added after setInterfaces function
    /* -------------------------------------------------------------------------- */

    // change namespace of library to prevent name collisions
    // var preferredName = is.setNamespace();
    // preferredName.odd(3);
    // => true
    is.setNamespace = function() {
        root.is = previousIs;
        return this;
    };

    // set optional regexes to methods
    is.setRegexp = function(regexp, name) {
        for (var r in regexes) {
            if (hasOwnProperty.call(regexes, r) && (name === r)) {
                regexes[r] = regexp;
            }
        }
    };

    return is;
}));
}(is$1));

var is = is$1.exports;

var numeral$1 = {exports: {}};

/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (module) {
(function (global, factory) {
    if (module.exports) {
        module.exports = factory();
    } else {
        global.numeral = factory();
    }
}(commonjsGlobal, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));
}(numeral$1));

var numeral = numeral$1.exports;

var vCalendar_umd_min = {exports: {}};

(function (module, exports) {
(function(e,t){module.exports=t();})("undefined"!==typeof self?self:commonjsGlobal,function(){return function(e){var t={};function r(o){if(t[o])return t[o].exports;var n=t[o]={i:o,l:!1,exports:{}};return e[o].call(n.exports,n,n.exports,r),n.l=!0,n.exports}return r.m=e,r.c=t,r.d=function(e,t,o){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:o});},r.r=function(e){"undefined"!==typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"===typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(r.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var n in e)r.d(o,n,function(t){return e[t]}.bind(null,n));return o},r.n=function(e){var t=e&&e.__esModule?function(){return e["default"]}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s="fb15")}({"00fd":function(e,t,r){var o=r("9e69"),n=Object.prototype,c=n.hasOwnProperty,i=n.toString,a=o?o.toStringTag:void 0;function s(e){var t=c.call(e,a),r=e[a];try{e[a]=void 0;var o=!0;}catch(s){}var n=i.call(e);return o&&(t?e[a]=r:delete e[a]),n}e.exports=s;},"01f9":function(e,t,r){var o=r("2d00"),n=r("5ca1"),c=r("2aba"),i=r("32e9"),a=r("84f2"),s=r("41a0"),u=r("7f20"),d=r("38fd"),l=r("2b4c")("iterator"),f=!([].keys&&"next"in[].keys()),v="@@iterator",b="keys",h="values",p=function(){return this};e.exports=function(e,t,r,g,y,m,x){s(r,t,g);var w,k,O,j=function(e){if(!f&&e in M)return M[e];switch(e){case b:return function(){return new r(this,e)};case h:return function(){return new r(this,e)}}return function(){return new r(this,e)}},D=t+" Iterator",_=y==h,P=!1,M=e.prototype,S=M[l]||M[v]||y&&M[y],E=S||j(y),C=y?_?j("entries"):E:void 0,I="Array"==t&&M.entries||S;if(I&&(O=d(I.call(new e)),O!==Object.prototype&&O.next&&(u(O,D,!0),o||"function"==typeof O[l]||i(O,l,p))),_&&S&&S.name!==h&&(P=!0,E=function(){return S.call(this)}),o&&!x||!f&&!P&&M[l]||i(M,l,E),a[t]=E,a[D]=p,y)if(w={values:_?E:j(h),keys:m?E:j(b),entries:C},x)for(k in w)k in M||c(M,k,w[k]);else n(n.P+n.F*(f||P),t,w);return w};},"02f4":function(e,t,r){var o=r("4588"),n=r("be13");e.exports=function(e){return function(t,r){var c,i,a=String(n(t)),s=o(r),u=a.length;return s<0||s>=u?e?"":void 0:(c=a.charCodeAt(s),c<55296||c>56319||s+1===u||(i=a.charCodeAt(s+1))<56320||i>57343?e?a.charAt(s):c:e?a.slice(s,s+2):i-56320+(c-55296<<10)+65536)}};},"0390":function(e,t,r){var o=r("02f4")(!0);e.exports=function(e,t,r){return t+(r?o(e,t).length:1)};},"03dd":function(e,t,r){var o=r("eac5"),n=r("57a5"),c=Object.prototype,i=c.hasOwnProperty;function a(e){if(!o(e))return n(e);var t=[];for(var r in Object(e))i.call(e,r)&&"constructor"!=r&&t.push(r);return t}e.exports=a;},"0621":function(e,t,r){var o=r("9e69"),n=r("d370"),c=r("6747"),i=o?o.isConcatSpreadable:void 0;function a(e){return c(e)||n(e)||!!(i&&e&&e[i])}e.exports=a;},"0733":function(e,t,r){r.d(t,"b",function(){return c}),r.d(t,"a",function(){return i});var o=r("2fa3"),n=r("9404"),c=function(e,t){if(!e||!e.addEventListener||!Object(n["j"])(t))return null;var r=!1,c=!1,i=function(){return r=!0},a=function(){return r=!1},s=function(e){if(r)return r=!1,c=!0,void t(e);"click"!==e.type||c||t(e),c=!1;};return Object(o["j"])(e,"touchstart",i),Object(o["j"])(e,"touchmove",a),Object(o["j"])(e,"click",s),Object(o["j"])(e,"touchend",s),function(){Object(o["i"])(e,"touchstart",i),Object(o["i"])(e,"touchmove",a),Object(o["i"])(e,"click",s),Object(o["i"])(e,"touchend",s);}},i=function(e,t,r){var c=r.maxSwipeTime,i=r.minHorizontalSwipeDistance,a=r.maxVerticalSwipeDistance;if(!e||!e.addEventListener||!Object(n["j"])(t))return null;var s=0,u=0,d=null,l=!1;function f(e){var t=e.changedTouches[0];s=t.screenX,u=t.screenY,d=(new Date).getTime(),l=!0;}function v(e){if(l){l=!1;var r=e.changedTouches[0],o=r.screenX-s,n=r.screenY-u,f=(new Date).getTime()-d;if(f<c&&Math.abs(o)>=i&&Math.abs(n)<=a){var v={toLeft:!1,toRight:!1};o<0?v.toLeft=!0:v.toRight=!0,t(v);}}}return Object(o["j"])(e,"touchstart",f),Object(o["j"])(e,"touchend",v),function(){Object(o["i"])(e,"touchstart",f),Object(o["i"])(e,"touchend",v);}};},"07c7":function(e,t){function r(){return !1}e.exports=r;},"07e3":function(e,t){var r={}.hasOwnProperty;e.exports=function(e,t){return r.call(e,t)};},"087d":function(e,t){function r(e,t){var r=-1,o=t.length,n=e.length;while(++r<o)e[n+r]=t[r];return e}e.exports=r;},"08cc":function(e,t,r){var o=r("1a8c");function n(e){return e===e&&!o(e)}e.exports=n;},"099a":function(e,t){function r(e,t,r){var o=r-1,n=e.length;while(++o<n)if(e[o]===t)return o;return -1}e.exports=r;},"0a49":function(e,t,r){var o=r("9b43"),n=r("626a"),c=r("4bf8"),i=r("9def"),a=r("cd1c");e.exports=function(e,t){var r=1==e,s=2==e,u=3==e,d=4==e,l=6==e,f=5==e||l,v=t||a;return function(t,a,b){for(var h,p,g=c(t),y=n(g),m=o(a,b,3),x=i(y.length),w=0,k=r?v(t,x):s?v(t,0):void 0;x>w;w++)if((f||w in y)&&(h=y[w],p=m(h,w,g),e))if(r)k[w]=p;else if(p)switch(e){case 3:return !0;case 5:return h;case 6:return w;case 2:k.push(h);}else if(d)return !1;return l?-1:u||d?d:k}};},"0b07":function(e,t,r){var o=r("34ac"),n=r("3698");function c(e,t){var r=n(e,t);return o(r)?r:void 0}e.exports=c;},"0bfb":function(e,t,r){var o=r("cb7c");e.exports=function(){var e=o(this),t="";return e.global&&(t+="g"),e.ignoreCase&&(t+="i"),e.multiline&&(t+="m"),e.unicode&&(t+="u"),e.sticky&&(t+="y"),t};},"0d24":function(e,t,r){(function(e){var o=r("2b3e"),n=r("07c7"),c=t&&!t.nodeType&&t,i=c&&"object"==typeof e&&e&&!e.nodeType&&e,a=i&&i.exports===c,s=a?o.Buffer:void 0,u=s?s.isBuffer:void 0,d=u||n;e.exports=d;}).call(this,r("62e4")(e));},"0d58":function(e,t,r){var o=r("ce10"),n=r("e11e");e.exports=Object.keys||function(e){return o(e,n)};},"0e9c":function(e,t,r){var o=r("a93e"),n=r.n(o);n.a;},"0f0f":function(e,t,r){var o=r("8eeb"),n=r("9934");function c(e,t){return e&&o(t,n(t),e)}e.exports=c;},"0f5c":function(e,t,r){var o=r("159a");function n(e,t,r){return null==e?e:o(e,t,r)}e.exports=n;},"0fc9":function(e,t,r){var o=r("3a38"),n=Math.max,c=Math.min;e.exports=function(e,t){return e=o(e),e<0?n(e+t,0):c(e,t)};},"100e":function(e,t,r){var o=r("cd9d"),n=r("2286"),c=r("c1c9");function i(e,t){return c(n(e,t,o),e+"")}e.exports=i;},1041:function(e,t,r){var o=r("8eeb"),n=r("a029");function c(e,t){return o(e,n(e),t)}e.exports=c;},1169:function(e,t,r){var o=r("2d95");e.exports=Array.isArray||function(e){return "Array"==o(e)};},"11e9":function(e,t,r){var o=r("52a7"),n=r("4630"),c=r("6821"),i=r("6a99"),a=r("69a8"),s=r("c69a"),u=Object.getOwnPropertyDescriptor;t.f=r("9e1e")?u:function(e,t){if(e=c(e),t=i(t,!0),s)try{return u(e,t)}catch(r){}if(a(e,t))return n(!o.f.call(e,t),e[t])};},"126d":function(e,t,r){var o=r("6da8"),n=r("aaec"),c=r("d094");function i(e){return n(e)?c(e):o(e)}e.exports=i;},1290:function(e,t){function r(e){var t=typeof e;return "string"==t||"number"==t||"symbol"==t||"boolean"==t?"__proto__"!==e:null===e}e.exports=r;},1310:function(e,t){function r(e){return null!=e&&"object"==typeof e}e.exports=r;},1368:function(e,t,r){var o=r("da03"),n=function(){var e=/[^.]+$/.exec(o&&o.keys&&o.keys.IE_PROTO||"");return e?"Symbol(src)_1."+e:""}();function c(e){return !!n&&n in e}e.exports=c;},1495:function(e,t,r){var o=r("86cc"),n=r("cb7c"),c=r("0d58");e.exports=r("9e1e")?Object.defineProperties:function(e,t){n(e);var r,i=c(t),a=i.length,s=0;while(a>s)o.f(e,r=i[s++],t[r]);return e};},"159a":function(e,t,r){var o=r("32b3"),n=r("e2e4"),c=r("c098"),i=r("1a8c"),a=r("f4d6");function s(e,t,r,s){if(!i(e))return e;t=n(t,e);var u=-1,d=t.length,l=d-1,f=e;while(null!=f&&++u<d){var v=a(t[u]),b=r;if(u!=l){var h=f[v];b=s?s(h,v,f):void 0,void 0===b&&(b=i(h)?h:c(t[u+1])?[]:{});}o(f,v,b),f=f[v];}return e}e.exports=s;},"15f3":function(e,t,r){var o=r("89d9"),n=r("8604");function c(e,t){return o(e,t,function(t,r){return n(e,r)})}e.exports=c;},1654:function(e,t,r){var o=r("71c1")(!0);r("30f1")(String,"String",function(e){this._t=String(e),this._i=0;},function(){var e,t=this._t,r=this._i;return r>=t.length?{value:void 0,done:!0}:(e=o(t,r),this._i+=e.length,{value:e,done:!1})});},1691:function(e,t){e.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");},1838:function(e,t,r){var o=r("c05f"),n=r("9b02"),c=r("8604"),i=r("f608"),a=r("08cc"),s=r("20ec"),u=r("f4d6"),d=1,l=2;function f(e,t){return i(e)&&a(t)?s(u(e),t):function(r){var i=n(r,e);return void 0===i&&i===t?c(r,e):o(t,i,d|l)}}e.exports=f;},"18d8":function(e,t,r){var o=r("234d"),n=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,c=/\\(\\)?/g,i=o(function(e){var t=[];return 46===e.charCodeAt(0)&&t.push(""),e.replace(n,function(e,r,o,n){t.push(o?n.replace(c,"$1"):r||e);}),t});e.exports=i;},"19cf":function(e,t,r){var o={inject:["sharedState"],computed:{defaults:function(){return this.$vc.defaults},masks:function(){return this.sharedState.masks},theme:function(){return this.sharedState.theme},locale:function(){return this.sharedState.locale},dayPopoverId:function(){return this.sharedState.dayPopoverId}},methods:{format:function(e,t){return this.locale.format(e,t)}}},n=(r("8e6e"),r("ac6a"),r("cadf"),r("456d"),r("bd86")),c=(r("7514"),r("c5f6"),r("a481"),r("768b")),i=r("d225"),a=r("b0b4"),s=r("9404");function u(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),r.push.apply(r,o);}return r}function d(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?u(r,!0).forEach(function(t){Object(n["a"])(e,t,r[t]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):u(r).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t));});}return e}var l=["base","start","end","startEnd"],f=["class","color","fillMode"];function v(e,t,r){e&&t&&r&&(e[t]="".concat(e[t]?"".concat(e[t]," "):"").concat(r));}var b=function(){function e(t){var r=this;Object(i["a"])(this,e),this._config=d({},t),Object(s["u"])(this._config).forEach(function(e){var t=Object(c["a"])(e,1),o=t[0];Object.defineProperty(r,o,{enumerable:!0,get:function(){return this.getConfig(o,{})}});}),this.buildNormalizedAttrs();}return Object(a["a"])(e,[{key:"buildNormalizedAttrs",value:function(){var e=this;this.normalizedAttrs={highlight:{opts:["fillMode","class","contentClass"]},dot:{opts:["class"]},bar:{opts:["class"]},content:{opts:["class"]}},Object(s["u"])(this.normalizedAttrs).map(function(t){var r=Object(c["a"])(t,2),o=r[0],n=r[1],i={base:{},start:{},end:{}};n.opts.forEach(function(t){var r=o,n=Object(s["w"])(t),c=e["".concat(r,"Base").concat(n)],a=e["".concat(r,"StartEnd").concat(n)]||c,u=e["".concat(r,"Start").concat(n)]||a,d=e["".concat(r,"End").concat(n)]||u;Object(s["n"])(c)||(i.base[t]=c),Object(s["n"])(u)||(i.start[t]=u),Object(s["n"])(d)||(i.end[t]=d);}),n.attr=i;});}},{key:"getConfig",value:function(e,t){var r=t.color,o=void 0===r?this._config.color:r,n=t.isDark,c=void 0===n?this._config.isDark:n;if(Object(s["e"])(this._config,e)){var i=Object(s["d"])(this._config,e);return Object(s["l"])(i)&&Object(s["f"])(i,["light","dark"])&&(i=c?i.dark:i.light),Object(s["m"])(i)?i.replace(/{color}/g,o):i}}},{key:"normalizeAttr",value:function(e){var t=e.config,r=e.type,o=this.color,n={},i=this.normalizedAttrs[r].attr;return !0===t||Object(s["m"])(t)?(o=Object(s["m"])(t)?t:o,n=d({},i)):Object(s["l"])(t)&&(n=Object(s["f"])(t,l)?d({},t):{base:d({},t),start:d({},t),end:d({},t)}),Object(s["b"])(n,{start:n.startEnd,end:n.startEnd},i),Object(s["u"])(n).forEach(function(e){var t=Object(c["a"])(e,2),r=t[0],a=t[1],u=o;!0===a||Object(s["m"])(a)?(u=Object(s["m"])(a)?a:u,n[r]={color:u}):Object(s["l"])(a)&&(Object(s["f"])(a,f)?n[r]=d({},a):n[r]={}),Object(s["b"])(n[r],i[r]),Object(s["e"])(n,"".concat(r,".color"))||Object(s["s"])(n,"".concat(r,".color"),u);}),n}},{key:"normalizeHighlight",value:function(e){var t=this,r=this.normalizeAttr({config:e,type:"highlight"});return Object(s["u"])(r).map(function(e){var r,o,n=Object(c["a"])(e,2),i=(n[0],n[1]);switch(Object(s["b"])(i,{isDark:t.isDark,color:t.color}),i.fillMode){case"none":r=t.getConfig("bgLow",i),o=t.getConfig("contentAccent",i);break;case"light":r=t.getConfig("bgAccentLow",i),o=t.getConfig("contentAccent",i);break;default:r=t.getConfig("bgAccentHigh",i),o=t.getConfig("contentAccentContrast",i);break}v(i,"class",r),v(i,"contentClass",o);}),r}},{key:"normalizeDot",value:function(e){var t=this,r=this.normalizeAttr({config:e,type:"dot"});return Object(s["u"])(r).forEach(function(e){var r=Object(c["a"])(e,2),o=(r[0],r[1]);Object(s["b"])(o,{isDark:t.isDark,color:t.color}),v(o,"class",t.getConfig("bgAccentHigh",o));}),r}},{key:"normalizeBar",value:function(e){var t=this,r=this.normalizeAttr({config:e,type:"bar"});return Object(s["u"])(r).forEach(function(e){var r=Object(c["a"])(e,2),o=(r[0],r[1]);Object(s["b"])(o,{isDark:t.isDark,color:t.color}),v(o,"class",t.getConfig("bgAccentHigh",o));}),r}},{key:"normalizeContent",value:function(e){var t=this,r=this.normalizeAttr({config:e,type:"content"});return Object(s["u"])(r).forEach(function(e){var r=Object(c["a"])(e,2),o=(r[0],r[1]);Object(s["b"])(o,{isDark:t.isDark,color:t.color}),v(o,"class",t.getConfig("contentAccent",o));}),r}}]),e}(),h=(r("6b54"),r("386d"),r("4917"),r("3b2b"),/d{1,2}|W{1,4}|M{1,4}|YY(?:YY)?|S{1,3}|Do|ZZ|([HhMsDm])\1?|[aA]|"[^"]*"|'[^']*'/g),p=/\d\d?/,g=/\d{3}/,y=/\d{4}/,m=/[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i,x=/\[([^]*?)\]/gm,w=function(){};function k(e){return function(t,r,o){var n=o[e].indexOf(r.charAt(0).toUpperCase()+r.substr(1).toLowerCase());~n&&(t.month=n);}}function O(e,t){e=String(e),t=t||2;while(e.length<t)e="0".concat(e);return e}var j={D:function(e){return e.getDate()},DD:function(e){return O(e.getDate())},Do:function(e,t){return t.DoFn(e.getDate())},d:function(e){return e.getDay()},dd:function(e){return O(e.getDay())},W:function(e,t){return t.dayNamesNarrow[e.getDay()]},WW:function(e,t){return t.dayNamesShorter[e.getDay()]},WWW:function(e,t){return t.dayNamesShort[e.getDay()]},WWWW:function(e,t){return t.dayNames[e.getDay()]},M:function(e){return e.getMonth()+1},MM:function(e){return O(e.getMonth()+1)},MMM:function(e,t){return t.monthNamesShort[e.getMonth()]},MMMM:function(e,t){return t.monthNames[e.getMonth()]},YY:function(e){return String(e.getFullYear()).substr(2)},YYYY:function(e){return O(e.getFullYear(),4)},h:function(e){return e.getHours()%12||12},hh:function(e){return O(e.getHours()%12||12)},H:function(e){return e.getHours()},HH:function(e){return O(e.getHours())},m:function(e){return e.getMinutes()},mm:function(e){return O(e.getMinutes())},s:function(e){return e.getSeconds()},ss:function(e){return O(e.getSeconds())},S:function(e){return Math.round(e.getMilliseconds()/100)},SS:function(e){return O(Math.round(e.getMilliseconds()/10),2)},SSS:function(e){return O(e.getMilliseconds(),3)},a:function(e,t){return e.getHours()<12?t.amPm[0]:t.amPm[1]},A:function(e,t){return e.getHours()<12?t.amPm[0].toUpperCase():t.amPm[1].toUpperCase()},ZZ:function(e){var t=e.getTimezoneOffset();return (t>0?"-":"+")+O(100*Math.floor(Math.abs(t)/60)+Math.abs(t)%60,4)}},D={D:[p,function(e,t){e.day=t;}],Do:[new RegExp(p.source+m.source),function(e,t){e.day=parseInt(t,10);}],d:[p,w],W:[m,w],M:[p,function(e,t){e.month=t-1;}],MMM:[m,k("monthNamesShort")],MMMM:[m,k("monthNames")],YY:[p,function(e,t){var r=new Date,o=+r.getFullYear().toString().substr(0,2);e.year="".concat(t>68?o-1:o).concat(t);}],YYYY:[y,function(e,t){e.year=t;}],S:[/\d/,function(e,t){e.millisecond=100*t;}],SS:[/\d{2}/,function(e,t){e.millisecond=10*t;}],SSS:[g,function(e,t){e.millisecond=t;}],h:[p,function(e,t){e.hour=t;}],m:[p,function(e,t){e.minute=t;}],s:[p,function(e,t){e.second=t;}],a:[m,function(e,t,r){var o=t.toLowerCase();o===r.amPm[0]?e.isPm=!1:o===r.amPm[1]&&(e.isPm=!0);}],ZZ:[/([\+\-]\d\d:?\d\d|Z)/,function(e,t){"Z"===t&&(t="+00:00");var r="".concat(t).match(/([+-]|\d\d)/gi);if(r){var o=60*r[1]+parseInt(r[2],10);e.timezoneOffset="+"===r[0]?o:-o;}}]};D.DD=D.D,D.dd=D.d,D.WWWW=D.WWW=D.WW=D.W,D.MM=D.M,D.mm=D.m,D.hh=D.H=D.HH=D.h,D.ss=D.s,D.A=D.a;var _=function(e,t,r){if(s["k"]&&(e=new Date(e)),!Object(s["i"])(e))throw new Error("Invalid Date in fecha.format");t=r.masks[t]||t;var o=[];return t=t.replace(x,function(e,t){return o.push(t),"??"}),t=t.replace(h,function(t){return t in j?j[t](e,r):t.slice(1,t.length-1)}),t.replace(/\?\?/g,function(){return o.shift()})},P=function(e,t,r){if("string"!==typeof t)throw new Error("Invalid mask in fecha.parse");if(t=r.masks[t]||t,e.length>1e3)return !1;var o=!0,n={};if(t.replace(h,function(t){if(D[t]){var c=D[t],i=e.search(c[0]);~i?e.replace(c[0],function(t){return c[1](n,t,r),e=e.substr(i+t.length),t}):o=!1;}return D[t]?"":t.slice(1,t.length-1)}),!o)return !1;var c,i=new Date;return !0===n.isPm&&null!=n.hour&&12!==+n.hour?n.hour=+n.hour+12:!1===n.isPm&&12===+n.hour&&(n.hour=0),null!=n.timezoneOffset?(n.minute=+(n.minute||0)-+n.timezoneOffset,c=new Date(Date.UTC(n.year||i.getFullYear(),n.month||0,n.day||1,n.hour||0,n.minute||0,n.second||0,n.millisecond||0))):c=new Date(n.year||i.getFullYear(),n.month||0,n.day||1,n.hour||0,n.minute||0,n.second||0,n.millisecond||0),c},M=function(e,t,r){var o=Object(s["h"])(t)&&t||[Object(s["m"])(t)&&t||"YYYY-MM-DD"];return o.map(function(t){return P(e,t,r)}).find(function(e){return e})||new Date(e)},S=7,E=[31,28,31,30,31,30,31,31,30,31,30,31],C=function(){function e(t,r){var o=r.firstDayOfWeek,n=r.masks;Object(i["a"])(this,e),this.id=t,this.firstDayOfWeek=Object(s["a"])(o,1,S),this.masks=n,this.dayNames=this.getDayNames("long"),this.dayNamesShort=this.getDayNames("short"),this.dayNamesShorter=this.dayNamesShort.map(function(e){return e.substring(0,2)}),this.dayNamesNarrow=this.getDayNames("narrow"),this.monthNames=this.getMonthNames("long"),this.monthNamesShort=this.getMonthNames("short"),this.monthData={},this.getMonthComps=this.getMonthComps.bind(this),this.parse=this.parse.bind(this),this.format=this.format.bind(this),this.toDate=this.toDate.bind(this);}return Object(a["a"])(e,[{key:"parse",value:function(e,t){return M(e,t||this.masks.L,this)}},{key:"format",value:function(e,t){return _(e,t||this.masks.L,this)}},{key:"toDate",value:function(e,t){if(Object(s["i"])(e))return new Date(e.getTime());if(Object(s["k"])(e))return new Date(e);if(Object(s["m"])(e))return this.parse(e,t);if(Object(s["l"])(e)){var r=new Date;return new Date(e.year||r.getFullYear(),e.month||r.getMonth(),e.day||r.getDate())}return e}},{key:"getMonthDates",value:function(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:2e3,t=[],r=0;r<12;r++)t.push(new Date(e,r,15));return t}},{key:"getMonthNames",value:function(e){var t=new Intl.DateTimeFormat(this.id,{month:e,timezome:"UTC"});return this.getMonthDates().map(function(e){return t.format(e)})}},{key:"getWeekdayDates",value:function(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.year,r=void 0===t?2e3:t,o=e.utc,n=void 0!==o&&o,c=e.firstDayOfWeek,i=void 0===c?this.firstDayOfWeek:c,a=[],s=1,u=0;u<S;s++){var d=n?new Date(Date.UTC(r,0,s)):new Date(r,0,s),l=n?d.getUTCDay():d.getDay();(l===i-1||u>0)&&(a.push(d),u++);}return a}},{key:"getDayNames",value:function(e){var t=new Intl.DateTimeFormat(this.id,{weekday:e,timeZone:"UTC"});return this.getWeekdayDates({firstDayOfWeek:1,utc:!0}).map(function(e){return t.format(e)})}},{key:"getMonthComps",value:function(e,t){var r="".concat(e,"-").concat(t),o=this.monthData[r];if(!o){var n=t%4===0&&t%100!==0||t%400===0,c=new Date(t,e-1,1).getDay()+1,i=2===e&&n?29:E[e-1],a=Math.ceil((i+Math.abs(c-this.firstDayOfWeek))/S);o={firstDayOfWeek:this.firstDayOfWeek,inLeapYear:n,firstWeekday:c,days:i,weeks:a,month:e,year:t},this.monthData[r]=o;}return o}},{key:"getThisMonthComps",value:function(){var e=new Date;return this.getMonthComps(e.getMonth()+1,e.getFullYear())}},{key:"getPrevMonthComps",value:function(e,t){return 1===e?this.getMonthComps(12,t-1):this.getMonthComps(e-1,t)}},{key:"getNextMonthComps",value:function(e,t){return 12===e?this.getMonthComps(1,t+1):this.getMonthComps(e+1,t)}},{key:"getCalendarDays",value:function(e){for(var t=e.monthComps,r=e.prevMonthComps,o=e.nextMonthComps,n=[],c=t.firstDayOfWeek,i=t.firstWeekday,a=i+(i<c?S:0)-c,s=!0,u=!1,d=!1,l=new Intl.DateTimeFormat(this.id,{weekday:"long",year:"numeric",month:"long",day:"numeric"}),f=r.days-a+1,v=r.days-f+1,b=Math.floor((f-1)/S+1),h=1,p=r.weeks,g=1,y=r.month,m=r.year,x=new Date,w=x.getDate(),k=x.getMonth()+1,O=x.getFullYear(),j=1;j<=6;j++){for(var D=1,_=c;D<=S;D++,_+=_===S?1-S:1){s&&_===i&&(f=1,v=t.days,b=Math.floor((f-1)/S+1),h=Math.floor((t.days-f)/S+1),p=1,g=t.weeks,y=t.month,m=t.year,s=!1,u=!0);var P=new Date(m,y-1,f),M=this.format(P,"YYYY-MM-DD"),E=D,C=S-D,I=f===w&&y===k&&m===O,A=u&&1===f,Y=u&&f===t.days,T=1===j,L=6===j,F=1===D,N=D===S;n.push({id:M,label:f.toString(),ariaLabel:l.format(P),day:f,dayFromEnd:v,weekday:_,weekdayPosition:E,weekdayPositionFromEnd:C,weekdayOrdinal:b,weekdayOrdinalFromEnd:h,week:p,weekFromEnd:g,month:y,year:m,date:P,dateTime:P.getTime(),isToday:I,isFirstDay:A,isLastDay:Y,inMonth:u,inPrevMonth:s,inNextMonth:d,onTop:T,onBottom:L,onLeft:F,onRight:N,classes:["id-".concat(M),"day-".concat(f),"day-from-end-".concat(v),"weekday-".concat(_),"weekday-position-".concat(E),"weekday-ordinal-".concat(b),"weekday-ordinal-from-end-".concat(h),"week-".concat(p),"week-from-end-".concat(g),{"is-today":I,"is-first-day":A,"is-last-day":Y,"in-month":u,"in-prev-month":s,"in-next-month":d,"on-top":T,"on-bottom":L,"on-left":F,"on-right":N}]}),u&&Y?(u=!1,d=!0,f=1,v=o.days,b=1,h=Math.floor((o.days-f)/S+1),p=1,g=o.weeks,y=o.month,m=o.year):(f++,v--,b=Math.floor((f-1)/S+1),h=Math.floor((t.days-f)/S+1));}p++,g--;}return n}}]),e}();function I(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),r.push.apply(r,o);}return r}function A(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?I(r,!0).forEach(function(t){Object(n["a"])(e,t,r[t]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):I(r).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t));});}return e}var Y={props:{color:String,isDark:Boolean,theme:Object,firstDayOfWeek:Number,masks:Object,locale:[String,Object]},computed:{theme_:function(){if(this.theme instanceof b)return this.theme;var e=Object(s["c"])(this.theme,this.$vc.theme);return e.color=this.passedProp("color",e.color),e.isDark=this.passedProp("isDark",e.isDark),new b(e)},locale_:function(){if(this.locale instanceof C)return this.locale;var e=this.$vc.locales,t=(new Intl.DateTimeFormat).resolvedOptions().locale,r=this.locale,o=Object(s["m"])(r)?r:Object(s["e"])(r,"id")?r.id:t;o=[o,o.substring(0,2)].find(function(t){return Object(s["e"])(e,t)})||t;var n=A({},e[o]);return n.firstDayOfWeek=this.passedProp("firstDayOfWeek",n.firstDayOfWeek),n.masks=Object(s["c"])(this.masks,n.masks),r=Object(s["l"])(r)?Object(s["c"])(r,n):n,new C(o,r)},format:function(){var e=this;return function(t,r){return e.locale_?e.locale_.format(t,r):""}}}},T={methods:{propOrDefault:function(e,t,r){return this.passedProp(e,Object(s["d"])(this.$vc.defaults,t),r)},passedProp:function(e,t,r){if(Object(s["e"])(this.$options.propsData,e)){var o=this[e];return Object(s["l"])(o)&&"merge"===r?Object(s["c"])(o,t):o}return t}}},L=(r("7f7f"),{methods:{safeScopedSlot:function(e,t){var r=arguments.length>2&&void 0!==arguments[2]?arguments[2]:null;return Object(s["j"])(this.$scopedSlots[e])?this.$scopedSlots[e](t):r}}});r.d(t,"a",function(){return F}),r.d(t,"c",function(){return N}),r.d(t,"b",function(){return z}),r.d(t,"d",function(){return $});var F=o,N=Y,z=T,$=L;},"1a2d":function(e,t,r){var o=r("42a2"),n=r("1310"),c="[object Map]";function i(e){return n(e)&&o(e)==c}e.exports=i;},"1a8c":function(e,t){function r(e){var t=typeof e;return null!=e&&("object"==t||"function"==t)}e.exports=r;},"1af6":function(e,t,r){var o=r("63b6");o(o.S,"Array",{isArray:r("9003")});},"1bac":function(e,t,r){var o=r("7d1f"),n=r("a029"),c=r("9934");function i(e){return o(e,c,n)}e.exports=i;},"1bc3":function(e,t,r){var o=r("f772");e.exports=function(e,t){if(!o(e))return e;var r,n;if(t&&"function"==typeof(r=e.toString)&&!o(n=r.call(e)))return n;if("function"==typeof(r=e.valueOf)&&!o(n=r.call(e)))return n;if(!t&&"function"==typeof(r=e.toString)&&!o(n=r.call(e)))return n;throw TypeError("Can't convert object to primitive value")};},"1c3c":function(e,t,r){var o=r("9e69"),n=r("2474"),c=r("9638"),i=r("a2be"),a=r("edfa"),s=r("ac41"),u=1,d=2,l="[object Boolean]",f="[object Date]",v="[object Error]",b="[object Map]",h="[object Number]",p="[object RegExp]",g="[object Set]",y="[object String]",m="[object Symbol]",x="[object ArrayBuffer]",w="[object DataView]",k=o?o.prototype:void 0,O=k?k.valueOf:void 0;function j(e,t,r,o,k,j,D){switch(r){case w:if(e.byteLength!=t.byteLength||e.byteOffset!=t.byteOffset)return !1;e=e.buffer,t=t.buffer;case x:return !(e.byteLength!=t.byteLength||!j(new n(e),new n(t)));case l:case f:case h:return c(+e,+t);case v:return e.name==t.name&&e.message==t.message;case p:case y:return e==t+"";case b:var _=a;case g:var P=o&u;if(_||(_=s),e.size!=t.size&&!P)return !1;var M=D.get(e);if(M)return M==t;o|=d,D.set(e,t);var S=i(_(e),_(t),o,k,j,D);return D["delete"](e),S;case m:if(O)return O.call(e)==O.call(t)}return !1}e.exports=j;},"1c4c":function(e,t,r){var o=r("9b43"),n=r("5ca1"),c=r("4bf8"),i=r("1fa8"),a=r("33a4"),s=r("9def"),u=r("f1ae"),d=r("27ee");n(n.S+n.F*!r("5cc5")(function(e){Array.from(e);}),"Array",{from:function(e){var t,r,n,l,f=c(e),v="function"==typeof this?this:Array,b=arguments.length,h=b>1?arguments[1]:void 0,p=void 0!==h,g=0,y=d(f);if(p&&(h=o(h,b>2?arguments[2]:void 0,2)),void 0==y||v==Array&&a(y))for(t=s(f.length),r=new v(t);t>g;g++)u(r,g,p?h(f[g],g):f[g]);else for(l=y.call(f),r=new v;!(n=l.next()).done;g++)u(r,g,p?i(l,h,[n.value,g],!0):n.value);return r.length=g,r}});},"1ceb":function(e,t,r){var o=r("398a"),n=r.n(o);n.a;},"1cec":function(e,t,r){var o=r("0b07"),n=r("2b3e"),c=o(n,"Promise");e.exports=c;},"1ec9":function(e,t,r){var o=r("f772"),n=r("e53d").document,c=o(n)&&o(n.createElement);e.exports=function(e){return c?n.createElement(e):{}};},"1efc":function(e,t){function r(e){var t=this.has(e)&&delete this.__data__[e];return this.size-=t?1:0,t}e.exports=r;},"1fa8":function(e,t,r){var o=r("cb7c");e.exports=function(e,t,r,n){try{return n?t(o(r)[0],r[1]):t(r)}catch(i){var c=e["return"];throw void 0!==c&&o(c.call(e)),i}};},"1fc8":function(e,t,r){var o=r("4245");function n(e,t){var r=o(this,e),n=r.size;return r.set(e,t),this.size+=r.size==n?0:1,this}e.exports=n;},"20ec":function(e,t){function r(e,t){return function(r){return null!=r&&(r[e]===t&&(void 0!==t||e in Object(r)))}}e.exports=r;},"20fd":function(e,t,r){var o=r("d9f6"),n=r("aebd");e.exports=function(e,t,r){t in e?o.f(e,t,n(0,r)):e[t]=r;};},"214f":function(e,t,r){r("b0c5");var o=r("2aba"),n=r("32e9"),c=r("79e5"),i=r("be13"),a=r("2b4c"),s=r("520a"),u=a("species"),d=!c(function(){var e=/./;return e.exec=function(){var e=[];return e.groups={a:"7"},e},"7"!=="".replace(e,"$<a>")}),l=function(){var e=/(?:)/,t=e.exec;e.exec=function(){return t.apply(this,arguments)};var r="ab".split(e);return 2===r.length&&"a"===r[0]&&"b"===r[1]}();e.exports=function(e,t,r){var f=a(e),v=!c(function(){var t={};return t[f]=function(){return 7},7!=""[e](t)}),b=v?!c(function(){var t=!1,r=/a/;return r.exec=function(){return t=!0,null},"split"===e&&(r.constructor={},r.constructor[u]=function(){return r}),r[f](""),!t}):void 0;if(!v||!b||"replace"===e&&!d||"split"===e&&!l){var h=/./[f],p=r(i,f,""[e],function(e,t,r,o,n){return t.exec===s?v&&!n?{done:!0,value:h.call(t,r,o)}:{done:!0,value:e.call(r,t,o)}:{done:!1}}),g=p[0],y=p[1];o(String.prototype,e,g),n(RegExp.prototype,f,2==t?function(e,t){return y.call(e,this,t)}:function(e){return y.call(e,this)});}};},2285:function(e,t,r){var o=r("6f6a"),n=r.n(o);n.a;},2286:function(e,t,r){var o=r("85e3"),n=Math.max;function c(e,t,r){return t=n(void 0===t?e.length-1:t,0),function(){var c=arguments,i=-1,a=n(c.length-t,0),s=Array(a);while(++i<a)s[i]=c[t+i];i=-1;var u=Array(t+1);while(++i<t)u[i]=c[i];return u[t]=r(s),o(e,this,u)}}e.exports=c;},"230e":function(e,t,r){var o=r("d3f4"),n=r("7726").document,c=o(n)&&o(n.createElement);e.exports=function(e){return c?n.createElement(e):{}};},"234d":function(e,t,r){var o=r("e380"),n=500;function c(e){var t=o(e,function(e){return r.size===n&&r.clear(),e}),r=t.cache;return t}e.exports=c;},2350:function(e,t){function r(e,t){var r=e[1]||"",n=e[3];if(!n)return r;if(t&&"function"===typeof btoa){var c=o(n),i=n.sources.map(function(e){return "/*# sourceURL="+n.sourceRoot+e+" */"});return [r].concat(i).concat([c]).join("\n")}return [r].join("\n")}function o(e){var t=btoa(unescape(encodeURIComponent(JSON.stringify(e)))),r="sourceMappingURL=data:application/json;charset=utf-8;base64,"+t;return "/*# "+r+" */"}e.exports=function(e){var t=[];return t.toString=function(){return this.map(function(t){var o=r(t,e);return t[2]?"@media "+t[2]+"{"+o+"}":o}).join("")},t.i=function(e,r){"string"===typeof e&&(e=[[null,e,""]]);for(var o={},n=0;n<this.length;n++){var c=this[n][0];"number"===typeof c&&(o[c]=!0);}for(n=0;n<e.length;n++){var i=e[n];"number"===typeof i[0]&&o[i[0]]||(r&&!i[2]?i[2]=r:r&&(i[2]="("+i[2]+") and ("+r+")"),t.push(i));}},t};},"23a5":function(e){e.exports={maxSwipeTime:300,minHorizontalSwipeDistance:60,maxVerticalSwipeDistance:80};},"23c6":function(e,t,r){var o=r("2d95"),n=r("2b4c")("toStringTag"),c="Arguments"==o(function(){return arguments}()),i=function(e,t){try{return e[t]}catch(r){}};e.exports=function(e){var t,r,a;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(r=i(t=Object(e),n))?r:c?o(t):"Object"==(a=o(t))&&"function"==typeof t.callee?"Arguments":a};},2411:function(e,t,r){var o=r("f909"),n=r("2ec1"),c=n(function(e,t,r,n){o(e,t,r,n);});e.exports=c;},"241e":function(e,t,r){var o=r("25eb");e.exports=function(e){return Object(o(e))};},"242e":function(e,t,r){var o=r("72af"),n=r("ec69");function c(e,t){return e&&o(e,t,n)}e.exports=c;},2474:function(e,t,r){var o=r("2b3e"),n=o.Uint8Array;e.exports=n;},2478:function(e,t,r){var o=r("4245");function n(e){return o(this,e).get(e)}e.exports=n;},2524:function(e,t,r){var o=r("6044"),n="__lodash_hash_undefined__";function c(e,t){var r=this.__data__;return this.size+=this.has(e)?0:1,r[e]=o&&void 0===t?n:t,this}e.exports=c;},"253c":function(e,t,r){var o=r("3729"),n=r("1310"),c="[object Arguments]";function i(e){return n(e)&&o(e)==c}e.exports=i;},2593:function(e,t,r){var o=r("15f3"),n=r("c6cf"),c=n(function(e,t){return null==e?{}:o(e,t)});e.exports=c;},"25eb":function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on  "+e);return e};},2621:function(e,t){t.f=Object.getOwnPropertySymbols;},"26e8":function(e,t){function r(e,t){return null!=e&&t in Object(e)}e.exports=r;},2768:function(e,t){function r(e){return null==e}e.exports=r;},"27ee":function(e,t,r){var o=r("23c6"),n=r("2b4c")("iterator"),c=r("84f2");e.exports=r("8378").getIteratorMethod=function(e){if(void 0!=e)return e[n]||e["@@iterator"]||c[o(e)]};},2877:function(e,t,r){function o(e,t,r,o,n,c,i,a){var s,u="function"===typeof e?e.options:e;if(t&&(u.render=t,u.staticRenderFns=r,u._compiled=!0),o&&(u.functional=!0),c&&(u._scopeId="data-v-"+c),i?(s=function(e){e=e||this.$vnode&&this.$vnode.ssrContext||this.parent&&this.parent.$vnode&&this.parent.$vnode.ssrContext,e||"undefined"===typeof __VUE_SSR_CONTEXT__||(e=__VUE_SSR_CONTEXT__),n&&n.call(this,e),e&&e._registeredComponents&&e._registeredComponents.add(i);},u._ssrRegister=s):n&&(s=a?function(){n.call(this,this.$root.$options.shadowRoot);}:n),s)if(u.functional){u._injectStyles=s;var d=u.render;u.render=function(e,t){return s.call(t),d(e,t)};}else {var l=u.beforeCreate;u.beforeCreate=l?[].concat(l,s):[s];}return {exports:e,options:u}}r.d(t,"a",function(){return o});},"28a5":function(e,t,r){var o=r("aae3"),n=r("cb7c"),c=r("ebd6"),i=r("0390"),a=r("9def"),s=r("5f1b"),u=r("520a"),d=r("79e5"),l=Math.min,f=[].push,v="split",b="length",h="lastIndex",p=4294967295,g=!d(function(){});r("214f")("split",2,function(e,t,r,d){var y;return y="c"=="abbc"[v](/(b)*/)[1]||4!="test"[v](/(?:)/,-1)[b]||2!="ab"[v](/(?:ab)*/)[b]||4!="."[v](/(.?)(.?)/)[b]||"."[v](/()()/)[b]>1||""[v](/.?/)[b]?function(e,t){var n=String(this);if(void 0===e&&0===t)return [];if(!o(e))return r.call(n,e,t);var c,i,a,s=[],d=(e.ignoreCase?"i":"")+(e.multiline?"m":"")+(e.unicode?"u":"")+(e.sticky?"y":""),l=0,v=void 0===t?p:t>>>0,g=new RegExp(e.source,d+"g");while(c=u.call(g,n)){if(i=g[h],i>l&&(s.push(n.slice(l,c.index)),c[b]>1&&c.index<n[b]&&f.apply(s,c.slice(1)),a=c[0][b],l=i,s[b]>=v))break;g[h]===c.index&&g[h]++;}return l===n[b]?!a&&g.test("")||s.push(""):s.push(n.slice(l)),s[b]>v?s.slice(0,v):s}:"0"[v](void 0,0)[b]?function(e,t){return void 0===e&&0===t?[]:r.call(this,e,t)}:r,[function(r,o){var n=e(this),c=void 0==r?void 0:r[t];return void 0!==c?c.call(r,n,o):y.call(String(n),r,o)},function(e,t){var o=d(y,e,this,t,y!==r);if(o.done)return o.value;var u=n(e),f=String(this),v=c(u,RegExp),b=u.unicode,h=(u.ignoreCase?"i":"")+(u.multiline?"m":"")+(u.unicode?"u":"")+(g?"y":"g"),m=new v(g?u:"^(?:"+u.source+")",h),x=void 0===t?p:t>>>0;if(0===x)return [];if(0===f.length)return null===s(m,f)?[f]:[];var w=0,k=0,O=[];while(k<f.length){m.lastIndex=g?k:0;var j,D=s(m,g?f:f.slice(k));if(null===D||(j=l(a(m.lastIndex+(g?0:k)),f.length))===w)k=i(f,k,b);else {if(O.push(f.slice(w,k)),O.length===x)return O;for(var _=1;_<=D.length-1;_++)if(O.push(D[_]),O.length===x)return O;k=w=j;}}return O.push(f.slice(w)),O}]});},"28c9":function(e,t){function r(){this.__data__=[],this.size=0;}e.exports=r;},"294c":function(e,t){e.exports=function(e){try{return !!e()}catch(t){return !0}};},"29f3":function(e,t){var r=Object.prototype,o=r.toString;function n(e){return o.call(e)}e.exports=n;},"2aba":function(e,t,r){var o=r("7726"),n=r("32e9"),c=r("69a8"),i=r("ca5a")("src"),a=r("fa5b"),s="toString",u=(""+a).split(s);r("8378").inspectSource=function(e){return a.call(e)},(e.exports=function(e,t,r,a){var s="function"==typeof r;s&&(c(r,"name")||n(r,"name",t)),e[t]!==r&&(s&&(c(r,i)||n(r,i,e[t]?""+e[t]:u.join(String(t)))),e===o?e[t]=r:a?e[t]?e[t]=r:n(e,t,r):(delete e[t],n(e,t,r)));})(Function.prototype,s,function(){return "function"==typeof this&&this[i]||a.call(this)});},"2aeb":function(e,t,r){var o=r("cb7c"),n=r("1495"),c=r("e11e"),i=r("613b")("IE_PROTO"),a=function(){},s="prototype",u=function(){var e,t=r("230e")("iframe"),o=c.length,n="<",i=">";t.style.display="none",r("fab2").appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write(n+"script"+i+"document.F=Object"+n+"/script"+i),e.close(),u=e.F;while(o--)delete u[s][c[o]];return u()};e.exports=Object.create||function(e,t){var r;return null!==e?(a[s]=o(e),r=new a,a[s]=null,r[i]=e):r=u(),void 0===t?r:n(r,t)};},"2b03":function(e,t){function r(e,t,r,o){var n=e.length,c=r+(o?1:-1);while(o?c--:++c<n)if(t(e[c],c,e))return c;return -1}e.exports=r;},"2b10":function(e,t){function r(e,t,r){var o=-1,n=e.length;t<0&&(t=-t>n?0:n+t),r=r>n?n:r,r<0&&(r+=n),n=t>r?0:r-t>>>0,t>>>=0;var c=Array(n);while(++o<n)c[o]=e[o+t];return c}e.exports=r;},"2b3e":function(e,t,r){var o=r("585a"),n="object"==typeof self&&self&&self.Object===Object&&self,c=o||n||Function("return this")();e.exports=c;},"2b4c":function(e,t,r){var o=r("5537")("wks"),n=r("ca5a"),c=r("7726").Symbol,i="function"==typeof c,a=e.exports=function(e){return o[e]||(o[e]=i&&c[e]||(i?c:n)("Symbol."+e))};a.store=o;},"2c66":function(e,t,r){var o=r("d612"),n=r("8db3"),c=r("5edf"),i=r("c584"),a=r("750a"),s=r("ac41"),u=200;function d(e,t,r){var d=-1,l=n,f=e.length,v=!0,b=[],h=b;if(r)v=!1,l=c;else if(f>=u){var p=t?null:a(e);if(p)return s(p);v=!1,l=i,h=new o;}else h=t?[]:b;e:while(++d<f){var g=e[d],y=t?t(g):g;if(g=r||0!==g?g:0,v&&y===y){var m=h.length;while(m--)if(h[m]===y)continue e;t&&h.push(y),b.push(g);}else l(h,y,r)||(h!==b&&h.push(y),b.push(g));}return b}e.exports=d;},"2d00":function(e,t){e.exports=!1;},"2d7c":function(e,t){function r(e,t){var r=-1,o=null==e?0:e.length,n=0,c=[];while(++r<o){var i=e[r];t(i,r,e)&&(c[n++]=i);}return c}e.exports=r;},"2d95":function(e,t){var r={}.toString;e.exports=function(e){return r.call(e).slice(8,-1)};},"2dcb":function(e,t,r){var o=r("91e9"),n=o(Object.getPrototypeOf,Object);e.exports=n;},"2ec1":function(e,t,r){var o=r("100e"),n=r("9aff");function c(e){return o(function(t,r){var o=-1,c=r.length,i=c>1?r[c-1]:void 0,a=c>2?r[2]:void 0;i=e.length>3&&"function"==typeof i?(c--,i):void 0,a&&n(r[0],r[1],a)&&(i=c<3?void 0:i,c=1),t=Object(t);while(++o<c){var s=r[o];s&&e(t,s,o,i);}return t})}e.exports=c;},"2fa3":function(e,t,r){r.d(t,"q",function(){return a}),r.d(t,"o",function(){return s}),r.d(t,"n",function(){return u}),r.d(t,"p",function(){return d}),r.d(t,"l",function(){return l}),r.d(t,"a",function(){return f}),r.d(t,"m",function(){return v}),r.d(t,"f",function(){return b}),r.d(t,"d",function(){return h}),r.d(t,"b",function(){return p}),r.d(t,"h",function(){return g}),r.d(t,"j",function(){return y}),r.d(t,"i",function(){return m}),r.d(t,"e",function(){return x}),r.d(t,"k",function(){return w}),r.d(t,"c",function(){return k}),r.d(t,"g",function(){return O});r("8e6e"),r("cadf"),r("456d");var o=r("bd86"),n=(r("6b54"),r("7f7f"),r("ac6a"),r("9404"));function c(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),r.push.apply(r,o);}return r}function i(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?c(r,!0).forEach(function(t){Object(o["a"])(e,t,r[t]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):c(r).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t));});}return e}var a=function(e){return !!(e&&e.month&&e.year)},s=function(e,t){return !(!a(e)||!a(t))&&(e.year===t.year?e.month<t.month:e.year<t.year)},u=function(e,t){return !(!a(e)||!a(t))&&(e.year===t.year?e.month>t.month:e.year>t.year)},d=function(e,t,r){return !!e&&!s(e,t)&&!u(e,r)},l=function(e){return e?{month:e.getMonth()+1,year:e.getFullYear()}:null},f=function(e,t){for(var r=e.month,o=e.year,n=t>0?1:-1,c=0;c<Math.abs(t);c++)r+=n,r>12?(r=1,o++):r<1&&(r=12,o--);return {month:r,year:o}},v=function(){return l(new Date)},b=function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];return t.reduce(function(e,t){return e?t&&u(t,e)?t:e:t})};function h(e,t){var r=Object(n["i"])(e),o=Object(n["i"])(t);return !r&&!o||r===o&&e.getTime()===t.getTime()}var p=function(e){return Object(n["h"])(e)&&e.length},g=function(e,t,r){var o=[];return r.forEach(function(r){var c=r.name||r.toString(),a=r.mixin,s=r.validate;if(Object.prototype.hasOwnProperty.call(e,c)){var u=s?s(e[c]):e[c];t[c]=a&&Object(n["l"])(u)?i({},a,{},u):u,o.push(c);}}),{target:t,assigned:o.length?o:null}},y=function(e,t,r){e&&t&&r&&(document.addEventListener?e.addEventListener(t,r,!1):e.attachEvent("on".concat(t),r));},m=function(e,t,r){e&&t&&(document.removeEventListener?e.removeEventListener(t,r,!1):e.detachEvent("on".concat(t),r));},x=function(e,t){return !!e&&!!t&&(e===t||e.contains(t))},w=function(e,t){" "!==e.key&&"Enter"!==e.key||(t(e),e.preventDefault());},k=function(){function e(){return (65536*(1+Math.random())|0).toString(16).substring(1)}return "".concat(e()+e(),"-").concat(e(),"-").concat(e(),"-").concat(e(),"-").concat(e()).concat(e()).concat(e())};function O(e){var t,r=0,o=0;if(0===e.length)return r;for(o=0;o<e.length;o++)t=e.charCodeAt(o),r=(r<<5)-r+t,r|=0;return r}},"2fcc":function(e,t){function r(e){var t=this.__data__,r=t["delete"](e);return this.size=t.size,r}e.exports=r;},"2fdb":function(e,t,r){var o=r("5ca1"),n=r("d2c8"),c="includes";o(o.P+o.F*r("5147")(c),"String",{includes:function(e){return !!~n(this,e,c).indexOf(e,arguments.length>1?arguments[1]:void 0)}});},3092:function(e,t,r){var o=r("4284"),n=r("badf"),c=r("361d"),i=r("6747"),a=r("9aff");function s(e,t,r){var s=i(e)?o:c;return r&&a(e,t,r)&&(t=void 0),s(e,n(t,3))}e.exports=s;},"30c9":function(e,t,r){var o=r("9520"),n=r("b218");function c(e){return null!=e&&n(e.length)&&!o(e)}e.exports=c;},"30f1":function(e,t,r){var o=r("b8e3"),n=r("63b6"),c=r("9138"),i=r("35e8"),a=r("481b"),s=r("8f60"),u=r("45f2"),d=r("53e2"),l=r("5168")("iterator"),f=!([].keys&&"next"in[].keys()),v="@@iterator",b="keys",h="values",p=function(){return this};e.exports=function(e,t,r,g,y,m,x){s(r,t,g);var w,k,O,j=function(e){if(!f&&e in M)return M[e];switch(e){case b:return function(){return new r(this,e)};case h:return function(){return new r(this,e)}}return function(){return new r(this,e)}},D=t+" Iterator",_=y==h,P=!1,M=e.prototype,S=M[l]||M[v]||y&&M[y],E=S||j(y),C=y?_?j("entries"):E:void 0,I="Array"==t&&M.entries||S;if(I&&(O=d(I.call(new e)),O!==Object.prototype&&O.next&&(u(O,D,!0),o||"function"==typeof O[l]||i(O,l,p))),_&&S&&S.name!==h&&(P=!0,E=function(){return S.call(this)}),o&&!x||!f&&!P&&M[l]||i(M,l,E),a[t]=E,a[D]=p,y)if(w={values:_?E:j(h),keys:m?E:j(b),entries:C},x)for(k in w)k in M||c(M,k,w[k]);else n(n.P+n.F*(f||P),t,w);return w};},"32b3":function(e,t,r){var o=r("872a"),n=r("9638"),c=Object.prototype,i=c.hasOwnProperty;function a(e,t,r){var c=e[t];i.call(e,t)&&n(c,r)&&(void 0!==r||t in e)||o(e,t,r);}e.exports=a;},"32e9":function(e,t,r){var o=r("86cc"),n=r("4630");e.exports=r("9e1e")?function(e,t,r){return o.f(e,t,n(1,r))}:function(e,t,r){return e[t]=r,e};},"32f4":function(e,t,r){var o=r("2d7c"),n=r("d327"),c=Object.prototype,i=c.propertyIsEnumerable,a=Object.getOwnPropertySymbols,s=a?function(e){return null==e?[]:(e=Object(e),o(a(e),function(t){return i.call(e,t)}))}:n;e.exports=s;},"32fc":function(e,t,r){var o=r("e53d").document;e.exports=o&&o.documentElement;},"335c":function(e,t,r){var o=r("6b4c");e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return "String"==o(e)?e.split(""):Object(e)};},"33a4":function(e,t,r){var o=r("84f2"),n=r("2b4c")("iterator"),c=Array.prototype;e.exports=function(e){return void 0!==e&&(o.Array===e||c[n]===e)};},"34ac":function(e,t,r){var o=r("9520"),n=r("1368"),c=r("1a8c"),i=r("dc57"),a=/[\\^$.*+?()[\]{}|]/g,s=/^\[object .+?Constructor\]$/,u=Function.prototype,d=Object.prototype,l=u.toString,f=d.hasOwnProperty,v=RegExp("^"+l.call(f).replace(a,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");function b(e){if(!c(e)||n(e))return !1;var t=o(e)?v:s;return t.test(i(e))}e.exports=b;},"34e9":function(e,t,r){(function(e){r.d(t,"e",function(){return d});r("cadf"),r("456d"),r("ac6a");var o=r("c192");r.d(t,"a",function(){return o["a"]});var n=r("e94a");r.d(t,"b",function(){return n["a"]});var c=r("cc8d");r.d(t,"c",function(){return c["a"]});var i=r("e0a0");r.d(t,"d",function(){return i["a"]});var a=r("a832"),s=r("844c");r.d(t,"f",function(){return s["a"]});r("bdab");var u={Calendar:o["a"],DatePicker:n["a"],Popover:c["a"],PopoverRef:i["a"],PopoverRow:a["a"]};function d(e,t){if(!d.installed){d.installed=!0;var r=Object(s["a"])(e,t);Object.keys(u).forEach(function(t){return e.component("".concat(r.defaults.componentPrefix).concat(t),u[t])});}}var l={install:d},f=null;"undefined"!==typeof window?f=window.Vue:"undefined"!==typeof e&&(f=e.Vue),f&&f.use(l);}).call(this,r("c8ba"));},"35e8":function(e,t,r){var o=r("d9f6"),n=r("aebd");e.exports=r("8e60")?function(e,t,r){return o.f(e,t,n(1,r))}:function(e,t,r){return e[t]=r,e};},"361d":function(e,t,r){var o=r("48a0");function n(e,t){var r;return o(e,function(e,o,n){return r=t(e,o,n),!r}),!!r}e.exports=n;},3698:function(e,t){function r(e,t){return null==e?void 0:e[t]}e.exports=r;},"36c3":function(e,t,r){var o=r("335c"),n=r("25eb");e.exports=function(e){return o(n(e))};},3702:function(e,t,r){var o=r("481b"),n=r("5168")("iterator"),c=Array.prototype;e.exports=function(e){return void 0!==e&&(o.Array===e||c[n]===e)};},3729:function(e,t,r){var o=r("9e69"),n=r("00fd"),c=r("29f3"),i="[object Null]",a="[object Undefined]",s=o?o.toStringTag:void 0;function u(e){return null==e?void 0===e?a:i:s&&s in Object(e)?n(e):c(e)}e.exports=u;},"375a":function(e,t,r){var o=r("b20a"),n=o(function(e,t,r){return e+(r?"-":"")+t.toLowerCase()});e.exports=n;},3818:function(e,t,r){var o=r("7e64"),n=r("8057"),c=r("32b3"),i=r("5b01"),a=r("0f0f"),s=r("e538"),u=r("4359"),d=r("54eb"),l=r("1041"),f=r("a994"),v=r("1bac"),b=r("42a2"),h=r("c87c"),p=r("c2b6"),g=r("fa21"),y=r("6747"),m=r("0d24"),x=r("cc45"),w=r("1a8c"),k=r("d7ee"),O=r("ec69"),j=1,D=2,_=4,P="[object Arguments]",M="[object Array]",S="[object Boolean]",E="[object Date]",C="[object Error]",I="[object Function]",A="[object GeneratorFunction]",Y="[object Map]",T="[object Number]",L="[object Object]",F="[object RegExp]",N="[object Set]",z="[object String]",$="[object Symbol]",R="[object WeakMap]",V="[object ArrayBuffer]",W="[object DataView]",H="[object Float32Array]",U="[object Float64Array]",B="[object Int8Array]",G="[object Int16Array]",q="[object Int32Array]",K="[object Uint8Array]",Z="[object Uint8ClampedArray]",X="[object Uint16Array]",J="[object Uint32Array]",Q={};function ee(e,t,r,M,S,E){var C,Y=t&j,T=t&D,F=t&_;if(r&&(C=S?r(e,M,S,E):r(e)),void 0!==C)return C;if(!w(e))return e;var N=y(e);if(N){if(C=h(e),!Y)return u(e,C)}else {var z=b(e),$=z==I||z==A;if(m(e))return s(e,Y);if(z==L||z==P||$&&!S){if(C=T||$?{}:g(e),!Y)return T?l(e,a(C,e)):d(e,i(C,e))}else {if(!Q[z])return S?e:{};C=p(e,z,Y);}}E||(E=new o);var R=E.get(e);if(R)return R;E.set(e,C),k(e)?e.forEach(function(o){C.add(ee(o,t,r,o,e,E));}):x(e)&&e.forEach(function(o,n){C.set(n,ee(o,t,r,n,e,E));});var V=F?T?v:f:T?keysIn:O,W=N?void 0:V(e);return n(W||e,function(o,n){W&&(n=o,o=e[n]),c(C,n,ee(o,t,r,n,e,E));}),C}Q[P]=Q[M]=Q[V]=Q[W]=Q[S]=Q[E]=Q[H]=Q[U]=Q[B]=Q[G]=Q[q]=Q[Y]=Q[T]=Q[L]=Q[F]=Q[N]=Q[z]=Q[$]=Q[K]=Q[Z]=Q[X]=Q[J]=!0,Q[C]=Q[I]=Q[R]=!1,e.exports=ee;},3846:function(e,t,r){r("9e1e")&&"g"!=/./g.flags&&r("86cc").f(RegExp.prototype,"flags",{configurable:!0,get:r("0bfb")});},3852:function(e,t,r){var o=r("96f3"),n=r("e2c0");function c(e,t){return null!=e&&n(e,t,o)}e.exports=c;},"386d":function(e,t,r){var o=r("cb7c"),n=r("83a1"),c=r("5f1b");r("214f")("search",1,function(e,t,r,i){return [function(r){var o=e(this),n=void 0==r?void 0:r[t];return void 0!==n?n.call(r,o):new RegExp(r)[t](String(o))},function(e){var t=i(r,e,this);if(t.done)return t.value;var a=o(e),s=String(this),u=a.lastIndex;n(u,0)||(a.lastIndex=0);var d=c(a,s);return n(a.lastIndex,u)||(a.lastIndex=u),null===d?-1:d.index}]});},"38fd":function(e,t,r){var o=r("69a8"),n=r("4bf8"),c=r("613b")("IE_PROTO"),i=Object.prototype;e.exports=Object.getPrototypeOf||function(e){return e=n(e),o(e,c)?e[c]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?i:null};},"398a":function(e,t,r){var o=r("7be9");"string"===typeof o&&(o=[[e.i,o,""]]),o.locals&&(e.exports=o.locals);var n=r("499e").default;n("5b039b7a",o,!0,{sourceMap:!1,shadowMode:!1});},"39ff":function(e,t,r){var o=r("0b07"),n=r("2b3e"),c=o(n,"WeakMap");e.exports=c;},"3a38":function(e,t){var r=Math.ceil,o=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?o:r)(e)};},"3b2b":function(e,t,r){var o=r("7726"),n=r("5dbc"),c=r("86cc").f,i=r("9093").f,a=r("aae3"),s=r("0bfb"),u=o.RegExp,d=u,l=u.prototype,f=/a/g,v=/a/g,b=new u(f)!==f;if(r("9e1e")&&(!b||r("79e5")(function(){return v[r("2b4c")("match")]=!1,u(f)!=f||u(v)==v||"/a/i"!=u(f,"i")}))){u=function(e,t){var r=this instanceof u,o=a(e),c=void 0===t;return !r&&o&&e.constructor===u&&c?e:n(b?new d(o&&!c?e.source:e,t):d((o=e instanceof u)?e.source:e,o&&c?s.call(e):t),r?this:l,u)};for(var h=function(e){e in u||c(u,e,{configurable:!0,get:function(){return d[e]},set:function(t){d[e]=t;}});},p=i(d),g=0;p.length>g;)h(p[g++]);l.constructor=u,u.prototype=l,r("2aba")(o,"RegExp",u);}r("7a56")("RegExp");},"3b4a":function(e,t,r){var o=r("0b07"),n=function(){try{var e=o(Object,"defineProperty");return e({},"",{}),e}catch(t){}}();e.exports=n;},"3bb4":function(e,t,r){var o=r("08cc"),n=r("ec69");function c(e){var t=n(e),r=t.length;while(r--){var c=t[r],i=e[c];t[r]=[c,i,o(i)];}return t}e.exports=c;},"3eea":function(e,t,r){var o=r("7948"),n=r("3818"),c=r("4bb5"),i=r("e2e4"),a=r("8eeb"),s=r("e0e7"),u=r("c6cf"),d=r("1bac"),l=1,f=2,v=4,b=u(function(e,t){var r={};if(null==e)return r;var u=!1;t=o(t,function(t){return t=i(t,e),u||(u=t.length>1),t}),a(e,d(e),r),u&&(r=n(r,l|f|v,s));var b=t.length;while(b--)c(r,t[b]);return r});e.exports=b;},"3f84":function(e,t,r){var o=r("85e3"),n=r("100e"),c=r("e031"),i=r("2411"),a=n(function(e){return e.push(void 0,c),o(i,void 0,e)});e.exports=a;},"40c3":function(e,t,r){var o=r("6b4c"),n=r("5168")("toStringTag"),c="Arguments"==o(function(){return arguments}()),i=function(e,t){try{return e[t]}catch(r){}};e.exports=function(e){var t,r,a;return void 0===e?"Undefined":null===e?"Null":"string"==typeof(r=i(t=Object(e),n))?r:c?o(t):"Object"==(a=o(t))&&"function"==typeof t.callee?"Arguments":a};},"41a0":function(e,t,r){var o=r("2aeb"),n=r("4630"),c=r("7f20"),i={};r("32e9")(i,r("2b4c")("iterator"),function(){return this}),e.exports=function(e,t,r){e.prototype=o(i,{next:n(1,r)}),c(e,t+" Iterator");};},"41c3":function(e,t,r){var o=r("1a8c"),n=r("eac5"),c=r("ec8c"),i=Object.prototype,a=i.hasOwnProperty;function s(e){if(!o(e))return c(e);var t=n(e),r=[];for(var i in e)("constructor"!=i||!t&&a.call(e,i))&&r.push(i);return r}e.exports=s;},4245:function(e,t,r){var o=r("1290");function n(e,t){var r=e.__data__;return o(t)?r["string"==typeof t?"string":"hash"]:r.map}e.exports=n;},4284:function(e,t){function r(e,t){var r=-1,o=null==e?0:e.length;while(++r<o)if(t(e[r],r,e))return !0;return !1}e.exports=r;},"42a2":function(e,t,r){var o=r("b5a7"),n=r("79bc"),c=r("1cec"),i=r("c869"),a=r("39ff"),s=r("3729"),u=r("dc57"),d="[object Map]",l="[object Object]",f="[object Promise]",v="[object Set]",b="[object WeakMap]",h="[object DataView]",p=u(o),g=u(n),y=u(c),m=u(i),x=u(a),w=s;(o&&w(new o(new ArrayBuffer(1)))!=h||n&&w(new n)!=d||c&&w(c.resolve())!=f||i&&w(new i)!=v||a&&w(new a)!=b)&&(w=function(e){var t=s(e),r=t==l?e.constructor:void 0,o=r?u(r):"";if(o)switch(o){case p:return h;case g:return d;case y:return f;case m:return v;case x:return b}return t}),e.exports=w;},4359:function(e,t){function r(e,t){var r=-1,o=e.length;t||(t=Array(o));while(++r<o)t[r]=e[r];return t}e.exports=r;},4416:function(e,t){function r(e){var t=null==e?0:e.length;return t?e[t-1]:void 0}e.exports=r;},"44ec":function(e,t,r){var o=r("7ba6");"string"===typeof o&&(o=[[e.i,o,""]]),o.locals&&(e.exports=o.locals);var n=r("499e").default;n("13d0e2e0",o,!0,{sourceMap:!1,shadowMode:!1});},"454f":function(e,t,r){r("46a7");var o=r("584a").Object;e.exports=function(e,t,r){return o.defineProperty(e,t,r)};},"456d":function(e,t,r){var o=r("4bf8"),n=r("0d58");r("5eda")("keys",function(){return function(e){return n(o(e))}});},4588:function(e,t){var r=Math.ceil,o=Math.floor;e.exports=function(e){return isNaN(e=+e)?0:(e>0?o:r)(e)};},"45f2":function(e,t,r){var o=r("d9f6").f,n=r("07e3"),c=r("5168")("toStringTag");e.exports=function(e,t,r){e&&!n(e=r?e:e.prototype,c)&&o(e,c,{configurable:!0,value:t});};},4630:function(e,t){e.exports=function(e,t){return {enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}};},"469f":function(e,t,r){r("6c1c"),r("1654"),e.exports=r("7d7b");},"46a7":function(e,t,r){var o=r("63b6");o(o.S+o.F*!r("8e60"),"Object",{defineProperty:r("d9f6").f});},"47f5":function(e,t,r){var o=r("2b03"),n=r("d9a8"),c=r("099a");function i(e,t,r){return t===t?c(e,t,r):o(e,n,r)}e.exports=i;},"481b":function(e,t){e.exports={};},"48a0":function(e,t,r){var o=r("242e"),n=r("950a"),c=n(o);e.exports=c;},4917:function(e,t,r){var o=r("cb7c"),n=r("9def"),c=r("0390"),i=r("5f1b");r("214f")("match",1,function(e,t,r,a){return [function(r){var o=e(this),n=void 0==r?void 0:r[t];return void 0!==n?n.call(r,o):new RegExp(r)[t](String(o))},function(e){var t=a(r,e,this);if(t.done)return t.value;var s=o(e),u=String(this);if(!s.global)return i(s,u);var d=s.unicode;s.lastIndex=0;var l,f=[],v=0;while(null!==(l=i(s,u))){var b=String(l[0]);f[v]=b,""===b&&(s.lastIndex=c(u,n(s.lastIndex),d)),v++;}return 0===v?null:f}]});},"499e":function(e,t,r){function o(e,t){for(var r=[],o={},n=0;n<t.length;n++){var c=t[n],i=c[0],a=c[1],s=c[2],u=c[3],d={id:e+":"+n,css:a,media:s,sourceMap:u};o[i]?o[i].parts.push(d):r.push(o[i]={id:i,parts:[d]});}return r}r.r(t),r.d(t,"default",function(){return b});var n="undefined"!==typeof document;if("undefined"!==typeof DEBUG&&DEBUG&&!n)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var c={},i=n&&(document.head||document.getElementsByTagName("head")[0]),a=null,s=0,u=!1,d=function(){},l=null,f="data-vue-ssr-id",v="undefined"!==typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());function b(e,t,r,n){u=r,l=n||{};var i=o(e,t);return h(i),function(t){for(var r=[],n=0;n<i.length;n++){var a=i[n],s=c[a.id];s.refs--,r.push(s);}t?(i=o(e,t),h(i)):i=[];for(n=0;n<r.length;n++){s=r[n];if(0===s.refs){for(var u=0;u<s.parts.length;u++)s.parts[u]();delete c[s.id];}}}}function h(e){for(var t=0;t<e.length;t++){var r=e[t],o=c[r.id];if(o){o.refs++;for(var n=0;n<o.parts.length;n++)o.parts[n](r.parts[n]);for(;n<r.parts.length;n++)o.parts.push(g(r.parts[n]));o.parts.length>r.parts.length&&(o.parts.length=r.parts.length);}else {var i=[];for(n=0;n<r.parts.length;n++)i.push(g(r.parts[n]));c[r.id]={id:r.id,refs:1,parts:i};}}}function p(){var e=document.createElement("style");return e.type="text/css",i.appendChild(e),e}function g(e){var t,r,o=document.querySelector("style["+f+'~="'+e.id+'"]');if(o){if(u)return d;o.parentNode.removeChild(o);}if(v){var n=s++;o=a||(a=p()),t=m.bind(null,o,n,!1),r=m.bind(null,o,n,!0);}else o=p(),t=x.bind(null,o),r=function(){o.parentNode.removeChild(o);};return t(e),function(o){if(o){if(o.css===e.css&&o.media===e.media&&o.sourceMap===e.sourceMap)return;t(e=o);}else r();}}var y=function(){var e=[];return function(t,r){return e[t]=r,e.filter(Boolean).join("\n")}}();function m(e,t,r,o){var n=r?"":o.css;if(e.styleSheet)e.styleSheet.cssText=y(t,n);else {var c=document.createTextNode(n),i=e.childNodes;i[t]&&e.removeChild(i[t]),i.length?e.insertBefore(c,i[t]):e.appendChild(c);}}function x(e,t){var r=t.css,o=t.media,n=t.sourceMap;if(o&&e.setAttribute("media",o),l.ssrId&&e.setAttribute(f,t.id),n&&(r+="\n/*# sourceURL="+n.sources[0]+" */",r+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(n))))+" */"),e.styleSheet)e.styleSheet.cssText=r;else {while(e.firstChild)e.removeChild(e.firstChild);e.appendChild(document.createTextNode(r));}}},"49f4":function(e,t,r){var o=r("6044");function n(){this.__data__=o?o(null):{},this.size=0;}e.exports=n;},"4a59":function(e,t,r){var o=r("9b43"),n=r("1fa8"),c=r("33a4"),i=r("cb7c"),a=r("9def"),s=r("27ee"),u={},d={};t=e.exports=function(e,t,r,l,f){var v,b,h,p,g=f?function(){return e}:s(e),y=o(r,l,t?2:1),m=0;if("function"!=typeof g)throw TypeError(e+" is not iterable!");if(c(g)){for(v=a(e.length);v>m;m++)if(p=t?y(i(b=e[m])[0],b[1]):y(e[m]),p===u||p===d)return p}else for(h=g.call(e);!(b=h.next()).done;)if(p=n(h,y,b.value,t),p===u||p===d)return p};t.BREAK=u,t.RETURN=d;},"4bb5":function(e,t,r){var o=r("e2e4"),n=r("4416"),c=r("8296"),i=r("f4d6");function a(e,t){return t=o(t,e),e=c(e,t),null==e||delete e[i(n(t))]}e.exports=a;},"4bf8":function(e,t,r){var o=r("be13");e.exports=function(e){return Object(o(e))};},"4caa":function(e,t,r){var o=r("a919"),n=r("76dd"),c=/[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g,i="\\u0300-\\u036f",a="\\ufe20-\\ufe2f",s="\\u20d0-\\u20ff",u=i+a+s,d="["+u+"]",l=RegExp(d,"g");function f(e){return e=n(e),e&&e.replace(c,o).replace(l,"")}e.exports=f;},"4cfe":function(e,t){function r(e){return void 0===e}e.exports=r;},"4d4c":function(e,t,r){var o=r("6f39"),n=r.n(o);n.a;},"4d8c":function(e,t,r){var o=r("5c69");function n(e){var t=null==e?0:e.length;return t?o(e,1):[]}e.exports=n;},"4ee1":function(e,t,r){var o=r("5168")("iterator"),n=!1;try{var c=[7][o]();c["return"]=function(){n=!0;},Array.from(c,function(){throw 2});}catch(i){}e.exports=function(e,t){if(!t&&!n)return !1;var r=!1;try{var c=[7],a=c[o]();a.next=function(){return {done:r=!0}},c[o]=function(){return a},e(c);}catch(i){}return r};},"4f50":function(e,t,r){var o=r("b760"),n=r("e538"),c=r("c8fe"),i=r("4359"),a=r("fa21"),s=r("d370"),u=r("6747"),d=r("dcbe"),l=r("0d24"),f=r("9520"),v=r("1a8c"),b=r("60ed"),h=r("73ac"),p=r("8adb"),g=r("8de2");function y(e,t,r,y,m,x,w){var k=p(e,r),O=p(t,r),j=w.get(O);if(j)o(e,r,j);else {var D=x?x(k,O,r+"",e,t,w):void 0,_=void 0===D;if(_){var P=u(O),M=!P&&l(O),S=!P&&!M&&h(O);D=O,P||M||S?u(k)?D=k:d(k)?D=i(k):M?(_=!1,D=n(O,!0)):S?(_=!1,D=c(O,!0)):D=[]:b(O)||s(O)?(D=k,s(k)?D=g(k):v(k)&&!f(k)||(D=a(O))):_=!1;}_&&(w.set(O,D),m(D,O,y,x,w),w["delete"](O)),o(e,r,D);}}e.exports=y;},"4f7f":function(e,t,r){var o=r("c26b"),n=r("b39a"),c="Set";e.exports=r("e0b8")(c,function(e){return function(){return e(this,arguments.length>0?arguments[0]:void 0)}},{add:function(e){return o.def(n(this,c),e=0===e?0:e,e)}},o);},"501e":function(e,t,r){var o=r("3729"),n=r("1310"),c="[object Number]";function i(e){return "number"==typeof e||n(e)&&o(e)==c}e.exports=i;},"504c":function(e,t,r){var o=r("9e1e"),n=r("0d58"),c=r("6821"),i=r("52a7").f;e.exports=function(e){return function(t){var r,a=c(t),s=n(a),u=s.length,d=0,l=[];while(u>d)r=s[d++],o&&!i.call(a,r)||l.push(e?[r,a[r]]:a[r]);return l}};},"50d8":function(e,t){function r(e,t){var r=-1,o=Array(e);while(++r<e)o[r]=t(r);return o}e.exports=r;},"50ed":function(e,t){e.exports=function(e,t){return {value:t,done:!!e}};},5147:function(e,t,r){var o=r("2b4c")("match");e.exports=function(e){var t=/./;try{"/./"[e](t);}catch(r){try{return t[o]=!1,!"/./"[e](t)}catch(n){}}return !0};},5168:function(e,t,r){var o=r("dbdb")("wks"),n=r("62a0"),c=r("e53d").Symbol,i="function"==typeof c,a=e.exports=function(e){return o[e]||(o[e]=i&&c[e]||(i?c:n)("Symbol."+e))};a.store=o;},"520a":function(e,t,r){var o=r("0bfb"),n=RegExp.prototype.exec,c=String.prototype.replace,i=n,a="lastIndex",s=function(){var e=/a/,t=/b*/g;return n.call(e,"a"),n.call(t,"a"),0!==e[a]||0!==t[a]}(),u=void 0!==/()??/.exec("")[1],d=s||u;d&&(i=function(e){var t,r,i,d,l=this;return u&&(r=new RegExp("^"+l.source+"$(?!\\s)",o.call(l))),s&&(t=l[a]),i=n.call(l,e),s&&i&&(l[a]=l.global?i.index+i[0].length:t),u&&i&&i.length>1&&c.call(i[0],r,function(){for(d=1;d<arguments.length-2;d++)void 0===arguments[d]&&(i[d]=void 0);}),i}),e.exports=i;},"52a7":function(e,t){t.f={}.propertyIsEnumerable;},"53e2":function(e,t,r){var o=r("07e3"),n=r("241e"),c=r("5559")("IE_PROTO"),i=Object.prototype;e.exports=Object.getPrototypeOf||function(e){return e=n(e),o(e,c)?e[c]:"function"==typeof e.constructor&&e instanceof e.constructor?e.constructor.prototype:e instanceof Object?i:null};},"549b":function(e,t,r){var o=r("d864"),n=r("63b6"),c=r("241e"),i=r("b0dc"),a=r("3702"),s=r("b447"),u=r("20fd"),d=r("7cd6");n(n.S+n.F*!r("4ee1")(function(e){Array.from(e);}),"Array",{from:function(e){var t,r,n,l,f=c(e),v="function"==typeof this?this:Array,b=arguments.length,h=b>1?arguments[1]:void 0,p=void 0!==h,g=0,y=d(f);if(p&&(h=o(h,b>2?arguments[2]:void 0,2)),void 0==y||v==Array&&a(y))for(t=s(f.length),r=new v(t);t>g;g++)u(r,g,p?h(f[g],g):f[g]);else for(l=y.call(f),r=new v;!(n=l.next()).done;g++)u(r,g,p?i(l,h,[n.value,g],!0):n.value);return r.length=g,r}});},"54a1":function(e,t,r){r("6c1c"),r("1654"),e.exports=r("95d5");},"54eb":function(e,t,r){var o=r("8eeb"),n=r("32f4");function c(e,t){return o(e,n(e),t)}e.exports=c;},5537:function(e,t,r){var o=r("8378"),n=r("7726"),c="__core-js_shared__",i=n[c]||(n[c]={});(e.exports=function(e,t){return i[e]||(i[e]=void 0!==t?t:{})})("versions",[]).push({version:o.version,mode:r("2d00")?"pure":"global",copyright:"© 2019 Denis Pushkarev (zloirock.ru)"});},5559:function(e,t,r){var o=r("dbdb")("keys"),n=r("62a0");e.exports=function(e){return o[e]||(o[e]=n(e))};},"55a3":function(e,t){function r(e){return this.__data__.has(e)}e.exports=r;},"57a5":function(e,t,r){var o=r("91e9"),n=o(Object.keys,Object);e.exports=n;},"584a":function(e,t){var r=e.exports={version:"2.6.9"};"number"==typeof __e&&(__e=r);},"585a":function(e,t,r){(function(t){var r="object"==typeof t&&t&&t.Object===Object&&t;e.exports=r;}).call(this,r("c8ba"));},"597b":function(e,t,r){t=e.exports=r("2350")(!1),t.push([e.i,".vc-grid-container[data-v-29dcba24]{position:relative;flex-shrink:1;display:grid;overflow:auto;-webkit-overflow-scrolling:touch}.vc-grid-cell[data-v-29dcba24]{display:flex;justify-content:center;align-items:center}",""]);},"5b01":function(e,t,r){var o=r("8eeb"),n=r("ec69");function c(e,t){return e&&o(t,n(t),e)}e.exports=c;},"5b4e":function(e,t,r){var o=r("36c3"),n=r("b447"),c=r("0fc9");e.exports=function(e){return function(t,r,i){var a,s=o(t),u=n(s.length),d=c(i,u);if(e&&r!=r){while(u>d)if(a=s[d++],a!=a)return !0}else for(;u>d;d++)if((e||d in s)&&s[d]===r)return e||d||0;return !e&&-1}};},"5c69":function(e,t,r){var o=r("087d"),n=r("0621");function c(e,t,r,i,a){var s=-1,u=e.length;r||(r=n),a||(a=[]);while(++s<u){var d=e[s];t>0&&r(d)?t>1?c(d,t-1,r,i,a):o(a,d):i||(a[a.length]=d);}return a}e.exports=c;},"5ca1":function(e,t,r){var o=r("7726"),n=r("8378"),c=r("32e9"),i=r("2aba"),a=r("9b43"),s="prototype",u=function(e,t,r){var d,l,f,v,b=e&u.F,h=e&u.G,p=e&u.S,g=e&u.P,y=e&u.B,m=h?o:p?o[t]||(o[t]={}):(o[t]||{})[s],x=h?n:n[t]||(n[t]={}),w=x[s]||(x[s]={});for(d in h&&(r=t),r)l=!b&&m&&void 0!==m[d],f=(l?m:r)[d],v=y&&l?a(f,o):g&&"function"==typeof f?a(Function.call,f):f,m&&i(m,d,f,e&u.U),x[d]!=f&&c(x,d,v),g&&w[d]!=f&&(w[d]=f);};o.core=n,u.F=1,u.G=2,u.S=4,u.P=8,u.B=16,u.W=32,u.U=64,u.R=128,e.exports=u;},"5cc5":function(e,t,r){var o=r("2b4c")("iterator"),n=!1;try{var c=[7][o]();c["return"]=function(){n=!0;},Array.from(c,function(){throw 2});}catch(i){}e.exports=function(e,t){if(!t&&!n)return !1;var r=!1;try{var c=[7],a=c[o]();a.next=function(){return {done:r=!0}},c[o]=function(){return a},e(c);}catch(i){}return r};},"5d73":function(e,t,r){e.exports=r("469f");},"5d89":function(e,t,r){var o=r("f8af");function n(e,t){var r=t?o(e.buffer):e.buffer;return new e.constructor(r,e.byteOffset,e.byteLength)}e.exports=n;},"5dbc":function(e,t,r){var o=r("d3f4"),n=r("8b97").set;e.exports=function(e,t,r){var c,i=t.constructor;return i!==r&&"function"==typeof i&&(c=i.prototype)!==r.prototype&&o(c)&&n&&n(e,c),e};},"5df3":function(e,t,r){var o=r("02f4")(!0);r("01f9")(String,"String",function(e){this._t=String(e),this._i=0;},function(){var e,t=this._t,r=this._i;return r>=t.length?{value:void 0,done:!0}:(e=o(t,r),this._i+=e.length,{value:e,done:!1})});},"5e2e":function(e,t,r){var o=r("28c9"),n=r("69d5"),c=r("b4c0"),i=r("fba5"),a=r("67ca");function s(e){var t=-1,r=null==e?0:e.length;this.clear();while(++t<r){var o=e[t];this.set(o[0],o[1]);}}s.prototype.clear=o,s.prototype["delete"]=n,s.prototype.get=c,s.prototype.has=i,s.prototype.set=a,e.exports=s;},"5eda":function(e,t,r){var o=r("5ca1"),n=r("8378"),c=r("79e5");e.exports=function(e,t){var r=(n.Object||{})[e]||Object[e],i={};i[e]=t(r),o(o.S+o.F*c(function(){r(1);}),"Object",i);};},"5edf":function(e,t){function r(e,t,r){var o=-1,n=null==e?0:e.length;while(++o<n)if(r(t,e[o]))return !0;return !1}e.exports=r;},"5f1b":function(e,t,r){var o=r("23c6"),n=RegExp.prototype.exec;e.exports=function(e,t){var r=e.exec;if("function"===typeof r){var c=r.call(e,t);if("object"!==typeof c)throw new TypeError("RegExp exec method returned something other than an Object or null");return c}if("RegExp"!==o(e))throw new TypeError("RegExp#exec called on incompatible receiver");return n.call(e,t)};},6044:function(e,t,r){var o=r("0b07"),n=o(Object,"create");e.exports=n;},"60ed":function(e,t,r){var o=r("3729"),n=r("2dcb"),c=r("1310"),i="[object Object]",a=Function.prototype,s=Object.prototype,u=a.toString,d=s.hasOwnProperty,l=u.call(Object);function f(e){if(!c(e)||o(e)!=i)return !1;var t=n(e);if(null===t)return !0;var r=d.call(t,"constructor")&&t.constructor;return "function"==typeof r&&r instanceof r&&u.call(r)==l}e.exports=f;},"613b":function(e,t,r){var o=r("5537")("keys"),n=r("ca5a");e.exports=function(e){return o[e]||(o[e]=n(e))};},6220:function(e,t,r){var o=r("b1d2"),n=r("b047"),c=r("99d3"),i=c&&c.isDate,a=i?n(i):o;e.exports=a;},"626a":function(e,t,r){var o=r("2d95");e.exports=Object("z").propertyIsEnumerable(0)?Object:function(e){return "String"==o(e)?e.split(""):Object(e)};},"62a0":function(e,t){var r=0,o=Math.random();e.exports=function(e){return "Symbol(".concat(void 0===e?"":e,")_",(++r+o).toString(36))};},"62e4":function(e,t){e.exports=function(e){return e.webpackPolyfill||(e.deprecate=function(){},e.paths=[],e.children||(e.children=[]),Object.defineProperty(e,"loaded",{enumerable:!0,get:function(){return e.l}}),Object.defineProperty(e,"id",{enumerable:!0,get:function(){return e.i}}),e.webpackPolyfill=1),e};},"63b6":function(e,t,r){var o=r("e53d"),n=r("584a"),c=r("d864"),i=r("35e8"),a=r("07e3"),s="prototype",u=function(e,t,r){var d,l,f,v=e&u.F,b=e&u.G,h=e&u.S,p=e&u.P,g=e&u.B,y=e&u.W,m=b?n:n[t]||(n[t]={}),x=m[s],w=b?o:h?o[t]:(o[t]||{})[s];for(d in b&&(r=t),r)l=!v&&w&&void 0!==w[d],l&&a(m,d)||(f=l?w[d]:r[d],m[d]=b&&"function"!=typeof w[d]?r[d]:g&&l?c(f,o):y&&w[d]==f?function(e){var t=function(t,r,o){if(this instanceof e){switch(arguments.length){case 0:return new e;case 1:return new e(t);case 2:return new e(t,r)}return new e(t,r,o)}return e.apply(this,arguments)};return t[s]=e[s],t}(f):p&&"function"==typeof f?c(Function.call,f):f,p&&((m.virtual||(m.virtual={}))[d]=f,e&u.R&&x&&!x[d]&&i(x,d,f)));};u.F=1,u.G=2,u.S=4,u.P=8,u.B=16,u.W=32,u.U=64,u.R=128,e.exports=u;},"642a":function(e,t,r){var o=r("966f"),n=r("3bb4"),c=r("20ec");function i(e){var t=n(e);return 1==t.length&&t[0][2]?c(t[0][0],t[0][1]):function(r){return r===e||o(r,e,t)}}e.exports=i;},6551:function(e,t,r){var o=r("7dcd"),n=r.n(o);n.a;},"656b":function(e,t,r){var o=r("e2e4"),n=r("f4d6");function c(e,t){t=o(t,e);var r=0,c=t.length;while(null!=e&&r<c)e=e[n(t[r++])];return r&&r==c?e:void 0}e.exports=c;},6679:function(e,t,r){var o=r("3729"),n=r("1310"),c="[object Boolean]";function i(e){return !0===e||!1===e||n(e)&&o(e)==c}e.exports=i;},6747:function(e,t){var r=Array.isArray;e.exports=r;},6762:function(e,t,r){var o=r("5ca1"),n=r("c366")(!0);o(o.P,"Array",{includes:function(e){return n(this,e,arguments.length>1?arguments[1]:void 0)}}),r("9c6c")("includes");},"67ab":function(e,t,r){var o=r("ca5a")("meta"),n=r("d3f4"),c=r("69a8"),i=r("86cc").f,a=0,s=Object.isExtensible||function(){return !0},u=!r("79e5")(function(){return s(Object.preventExtensions({}))}),d=function(e){i(e,o,{value:{i:"O"+ ++a,w:{}}});},l=function(e,t){if(!n(e))return "symbol"==typeof e?e:("string"==typeof e?"S":"P")+e;if(!c(e,o)){if(!s(e))return "F";if(!t)return "E";d(e);}return e[o].i},f=function(e,t){if(!c(e,o)){if(!s(e))return !0;if(!t)return !1;d(e);}return e[o].w},v=function(e){return u&&b.NEED&&s(e)&&!c(e,o)&&d(e),e},b=e.exports={KEY:o,NEED:!1,fastKey:l,getWeak:f,onFreeze:v};},"67ca":function(e,t,r){var o=r("cb5a");function n(e,t){var r=this.__data__,n=o(r,e);return n<0?(++this.size,r.push([e,t])):r[n][1]=t,this}e.exports=n;},6821:function(e,t,r){var o=r("626a"),n=r("be13");e.exports=function(e){return o(n(e))};},"69a8":function(e,t){var r={}.hasOwnProperty;e.exports=function(e,t){return r.call(e,t)};},"69d5":function(e,t,r){var o=r("cb5a"),n=Array.prototype,c=n.splice;function i(e){var t=this.__data__,r=o(t,e);if(r<0)return !1;var n=t.length-1;return r==n?t.pop():c.call(t,r,1),--this.size,!0}e.exports=i;},"6a99":function(e,t,r){var o=r("d3f4");e.exports=function(e,t){if(!o(e))return e;var r,n;if(t&&"function"==typeof(r=e.toString)&&!o(n=r.call(e)))return n;if("function"==typeof(r=e.valueOf)&&!o(n=r.call(e)))return n;if(!t&&"function"==typeof(r=e.toString)&&!o(n=r.call(e)))return n;throw TypeError("Can't convert object to primitive value")};},"6ac0":function(e,t){function r(e,t,r,o){var n=-1,c=null==e?0:e.length;o&&c&&(r=e[++n]);while(++n<c)r=t(r,e[n],n,e);return r}e.exports=r;},"6b4c":function(e,t){var r={}.toString;e.exports=function(e){return r.call(e).slice(8,-1)};},"6b54":function(e,t,r){r("3846");var o=r("cb7c"),n=r("0bfb"),c=r("9e1e"),i="toString",a=/./[i],s=function(e){r("2aba")(RegExp.prototype,i,e,!0);};r("79e5")(function(){return "/a/b"!=a.call({source:"a",flags:"b"})})?s(function(){var e=o(this);return "/".concat(e.source,"/","flags"in e?e.flags:!c&&e instanceof RegExp?n.call(e):void 0)}):a.name!=i&&s(function(){return a.call(this)});},"6c1c":function(e,t,r){r("c367");for(var o=r("e53d"),n=r("35e8"),c=r("481b"),i=r("5168")("toStringTag"),a="CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","),s=0;s<a.length;s++){var u=a[s],d=o[u],l=d&&d.prototype;l&&!l[i]&&n(l,i,u),c[u]=c.Array;}},"6da8":function(e,t){function r(e){return e.split("")}e.exports=r;},"6e4c":function(e,t,r){t=e.exports=r("2350")(!1),t.push([e.i,".vc-svg-icon[data-v-5572e632]{display:inline-block;stroke:currentColor;stroke-width:0}.vc-svg-icon path[data-v-5572e632]{fill:currentColor}",""]);},"6ecb":function(e,t,r){t=e.exports=r("2350")(!1),t.push([e.i,".vc-day[data-v-b0867174]{position:relative;min-height:var(--day-min-height);width:100%;height:100%;z-index:1}.vc-day-layer[data-v-b0867174]{position:absolute;left:0;right:0;top:0;bottom:0;pointer-events:none}.vc-day-box-center-center[data-v-b0867174]{display:flex;justify-content:center;align-items:center;height:100%;transform-origin:50% 50%}.vc-day-box-left-center[data-v-b0867174]{display:flex;justify-content:flex-start;align-items:center;height:100%;transform-origin:0 50%}.vc-day-box-right-center[data-v-b0867174]{display:flex;justify-content:flex-end;align-items:center;height:100%;transform-origin:100% 50%}.vc-day-box-center-bottom[data-v-b0867174]{display:flex;justify-content:center;align-items:flex-end}.vc-day-content[data-v-b0867174]{display:flex;justify-content:center;align-items:center;width:var(--day-content-width);height:var(--day-content-height);margin:var(--day-content-margin);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.vc-day-content[data-v-b0867174]:hover{background-color:var(--day-content-bg-color-hover)}.vc-day-content:hover.vc-is-dark[data-v-b0867174]{background-color:var(--day-content-dark-bg-color-hover)}.vc-day-content[data-v-b0867174]:focus{background-color:var(--day-content-bg-color-focus)}.vc-day-content:focus.vc-is-dark[data-v-b0867174]{background-color:var(--day-content-dark-bg-color-focus)}.vc-highlights[data-v-b0867174]{overflow:hidden;pointer-events:none;z-index:-1}.vc-highlight[data-v-b0867174]{width:var(--highlight-height);height:var(--highlight-height)}.vc-highlight.vc-highlight-base-start[data-v-b0867174]{width:50%!important;border-radius:0!important;border-right-width:0!important}.vc-highlight.vc-highlight-base-end[data-v-b0867174]{width:50%!important;border-radius:0!important;border-left-width:0!important}.vc-highlight.vc-highlight-base-middle[data-v-b0867174]{width:100%;border-radius:0!important;border-left-width:0!important;border-right-width:0!important;margin:0 -1px}.vc-dots[data-v-b0867174]{display:flex;justify-content:center;align-items:center}.vc-dot[data-v-b0867174]{width:var(--dot-diameter);height:var(--dot-diameter);border-radius:var(--dot-border-radius);transition:all var(--day-content-transition-time)}.vc-dot[data-v-b0867174]:not(:last-child){margin-right:var(--dot-spacing)}.vc-bars[data-v-b0867174]{display:flex;justify-content:flex-start;align-items:center;width:var(--bars-width)}.vc-bar[data-v-b0867174]{flex-grow:1;height:var(--bar-height);transition:all var(--day-content-transition-time)}",""]);},"6f39":function(e,t,r){var o=r("f231");"string"===typeof o&&(o=[[e.i,o,""]]),o.locals&&(e.exports=o.locals);var n=r("499e").default;n("00835756",o,!0,{sourceMap:!1,shadowMode:!1});},"6f6a":function(e,t,r){var o=r("ee59");"string"===typeof o&&(o=[[e.i,o,""]]),o.locals&&(e.exports=o.locals);var n=r("499e").default;n("5ac13234",o,!0,{sourceMap:!1,shadowMode:!1});},"6f6c":function(e,t){var r=/\w*$/;function o(e){var t=new e.constructor(e.source,r.exec(e));return t.lastIndex=e.lastIndex,t}e.exports=o;},"6fcd":function(e,t,r){var o=r("50d8"),n=r("d370"),c=r("6747"),i=r("0d24"),a=r("c098"),s=r("73ac"),u=Object.prototype,d=u.hasOwnProperty;function l(e,t){var r=c(e),u=!r&&n(e),l=!r&&!u&&i(e),f=!r&&!u&&!l&&s(e),v=r||u||l||f,b=v?o(e.length,String):[],h=b.length;for(var p in e)!t&&!d.call(e,p)||v&&("length"==p||l&&("offset"==p||"parent"==p)||f&&("buffer"==p||"byteLength"==p||"byteOffset"==p)||a(p,h))||b.push(p);return b}e.exports=l;},"71c1":function(e,t,r){var o=r("3a38"),n=r("25eb");e.exports=function(e){return function(t,r){var c,i,a=String(n(t)),s=o(r),u=a.length;return s<0||s>=u?e?"":void 0:(c=a.charCodeAt(s),c<55296||c>56319||s+1===u||(i=a.charCodeAt(s+1))<56320||i>57343?e?a.charAt(s):c:e?a.slice(s,s+2):i-56320+(c-55296<<10)+65536)}};},"72af":function(e,t,r){var o=r("99cd"),n=o();e.exports=n;},"72f0":function(e,t){function r(e){return function(){return e}}e.exports=r;},"73ac":function(e,t,r){var o=r("743f"),n=r("b047"),c=r("99d3"),i=c&&c.isTypedArray,a=i?n(i):o;e.exports=a;},"743f":function(e,t,r){var o=r("3729"),n=r("b218"),c=r("1310"),i="[object Arguments]",a="[object Array]",s="[object Boolean]",u="[object Date]",d="[object Error]",l="[object Function]",f="[object Map]",v="[object Number]",b="[object Object]",h="[object RegExp]",p="[object Set]",g="[object String]",y="[object WeakMap]",m="[object ArrayBuffer]",x="[object DataView]",w="[object Float32Array]",k="[object Float64Array]",O="[object Int8Array]",j="[object Int16Array]",D="[object Int32Array]",_="[object Uint8Array]",P="[object Uint8ClampedArray]",M="[object Uint16Array]",S="[object Uint32Array]",E={};function C(e){return c(e)&&n(e.length)&&!!E[o(e)]}E[w]=E[k]=E[O]=E[j]=E[D]=E[_]=E[P]=E[M]=E[S]=!0,E[i]=E[a]=E[m]=E[s]=E[x]=E[u]=E[d]=E[l]=E[f]=E[v]=E[b]=E[h]=E[p]=E[g]=E[y]=!1,e.exports=C;},"750a":function(e,t,r){var o=r("c869"),n=r("bcdf"),c=r("ac41"),i=1/0,a=o&&1/c(new o([,-0]))[1]==i?function(e){return new o(e)}:n;e.exports=a;},7514:function(e,t,r){var o=r("5ca1"),n=r("0a49")(5),c="find",i=!0;c in[]&&Array(1)[c](function(){i=!1;}),o(o.P+o.F*i,"Array",{find:function(e){return n(this,e,arguments.length>1?arguments[1]:void 0)}}),r("9c6c")(c);},7530:function(e,t,r){var o=r("1a8c"),n=Object.create,c=function(){function e(){}return function(t){if(!o(t))return {};if(n)return n(t);e.prototype=t;var r=new e;return e.prototype=void 0,r}}();e.exports=c;},7559:function(e,t){var r=/[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;function o(e){return e.match(r)||[]}e.exports=o;},"75fc":function(e,t,r){var o=r("a745"),n=r.n(o);function c(e){if(n()(e)){for(var t=0,r=new Array(e.length);t<e.length;t++)r[t]=e[t];return r}}var i=r("774e"),a=r.n(i),s=r("c8bb"),u=r.n(s);function d(e){if(u()(Object(e))||"[object Arguments]"===Object.prototype.toString.call(e))return a()(e)}function l(){throw new TypeError("Invalid attempt to spread non-iterable instance")}function f(e){return c(e)||d(e)||l()}r.d(t,"a",function(){return f});},"768b":function(e,t,r){var o=r("a745"),n=r.n(o);function c(e){if(n()(e))return e}var i=r("5d73"),a=r.n(i);function s(e,t){var r=[],o=!0,n=!1,c=void 0;try{for(var i,s=a()(e);!(o=(i=s.next()).done);o=!0)if(r.push(i.value),t&&r.length===t)break}catch(u){n=!0,c=u;}finally{try{o||null==s["return"]||s["return"]();}finally{if(n)throw c}}return r}function u(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}function d(e,t){return c(e)||s(e,t)||u()}r.d(t,"a",function(){return d});},"76dd":function(e,t,r){var o=r("ce86");function n(e){return null==e?"":o(e)}e.exports=n;},7726:function(e,t){var r=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r);},"774e":function(e,t,r){e.exports=r("d2d5");},"77f1":function(e,t,r){var o=r("4588"),n=Math.max,c=Math.min;e.exports=function(e,t){return e=o(e),e<0?n(e+t,0):c(e,t)};},7948:function(e,t){function r(e,t){var r=-1,o=null==e?0:e.length,n=Array(o);while(++r<o)n[r]=t(e[r],r,e);return n}e.exports=r;},"794b":function(e,t,r){e.exports=!r("8e60")&&!r("294c")(function(){return 7!=Object.defineProperty(r("1ec9")("div"),"a",{get:function(){return 7}}).a});},"79aa":function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e};},"79bc":function(e,t,r){var o=r("0b07"),n=r("2b3e"),c=o(n,"Map");e.exports=c;},"79e5":function(e,t){e.exports=function(e){try{return !!e()}catch(t){return !0}};},"7a48":function(e,t,r){var o=r("6044"),n=Object.prototype,c=n.hasOwnProperty;function i(e){var t=this.__data__;return o?void 0!==t[e]:c.call(t,e)}e.exports=i;},"7a56":function(e,t,r){var o=r("7726"),n=r("86cc"),c=r("9e1e"),i=r("2b4c")("species");e.exports=function(e){var t=o[e];c&&t&&!t[i]&&n.f(t,i,{configurable:!0,get:function(){return this}});};},"7b83":function(e,t,r){var o=r("7c64"),n=r("93ed"),c=r("2478"),i=r("a524"),a=r("1fc8");function s(e){var t=-1,r=null==e?0:e.length;this.clear();while(++t<r){var o=e[t];this.set(o[0],o[1]);}}s.prototype.clear=o,s.prototype["delete"]=n,s.prototype.get=c,s.prototype.has=i,s.prototype.set=a,e.exports=s;},"7b97":function(e,t,r){var o=r("7e64"),n=r("a2be"),c=r("1c3c"),i=r("b1e5"),a=r("42a2"),s=r("6747"),u=r("0d24"),d=r("73ac"),l=1,f="[object Arguments]",v="[object Array]",b="[object Object]",h=Object.prototype,p=h.hasOwnProperty;function g(e,t,r,h,g,y){var m=s(e),x=s(t),w=m?v:a(e),k=x?v:a(t);w=w==f?b:w,k=k==f?b:k;var O=w==b,j=k==b,D=w==k;if(D&&u(e)){if(!u(t))return !1;m=!0,O=!1;}if(D&&!O)return y||(y=new o),m||d(e)?n(e,t,r,h,g,y):c(e,t,w,r,h,g,y);if(!(r&l)){var _=O&&p.call(e,"__wrapped__"),P=j&&p.call(t,"__wrapped__");if(_||P){var M=_?e.value():e,S=P?t.value():t;return y||(y=new o),g(M,S,r,h,y)}}return !!D&&(y||(y=new o),i(e,t,r,h,g,y))}e.exports=g;},"7ba6":function(e,t,r){t=e.exports=r("2350")(!1),t.push([e.i,".vc-pane[data-v-d8853504]{flex-grow:1;flex-shrink:1;display:flex;flex-direction:column;justify-content:center;align-items:stretch}.vc-horizontal-divider[data-v-d8853504]{align-self:center}.vc-header[data-v-d8853504]{flex-shrink:0;display:flex;align-items:stretch;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding:var(--header-padding)}.vc-header.align-left[data-v-d8853504]{order:-1;justify-content:flex-start}.vc-header.align-right[data-v-d8853504]{order:1;justify-content:flex-end}.vc-title-layout[data-v-d8853504]{display:flex;justify-content:center;align-items:center;flex-grow:1}.vc-title-layout.align-left[data-v-d8853504]{justify-content:flex-start}.vc-title-layout.align-right[data-v-d8853504]{justify-content:flex-end}.vc-title-wrapper[data-v-d8853504]{position:relative}.vc-title[data-v-d8853504]{cursor:pointer;white-space:nowrap;padding:var(--title-padding)}.vc-title[data-v-d8853504],.vc-weekday[data-v-d8853504]{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.vc-weekday[data-v-d8853504]{display:flex;justify-content:center;align-items:center;flex:1;padding:var(--weekday-padding);cursor:default}.vc-weeks[data-v-d8853504]{flex-shrink:1;flex-grow:1;padding:var(--weeks-padding)}",""]);},"7be9":function(e,t,r){t=e.exports=r("2350")(!1),t.push([e.i,".vc-day-popover-row[data-v-18514c08]{--day-content-transition-time:0.13s ease-in;display:flex;align-items:center;transition:all var(--day-content-transition-time)}.vc-day-popover-row[data-v-18514c08]:not(:first-child){margin-top:3px}.vc-day-popover-row-indicator[data-v-18514c08]{display:flex;justify-content:center;align-items:center;flex-grow:0;width:15px;margin-right:3px}.vc-day-popover-row-indicator span[data-v-18514c08]{transition:all var(--day-content-transition-time)}.vc-day-popover-row-content[data-v-18514c08]{display:flex;align-items:center;flex-wrap:none;flex-grow:1;width:-webkit-max-content;width:max-content}",""]);},"7c64":function(e,t,r){var o=r("e24b"),n=r("5e2e"),c=r("79bc");function i(){this.size=0,this.__data__={hash:new o,map:new(c||n),string:new o};}e.exports=i;},"7cd6":function(e,t,r){var o=r("40c3"),n=r("5168")("iterator"),c=r("481b");e.exports=r("584a").getIteratorMethod=function(e){if(void 0!=e)return e[n]||e["@@iterator"]||c[o(e)]};},"7d1f":function(e,t,r){var o=r("087d"),n=r("6747");function c(e,t,r){var c=t(e);return n(e)?c:o(c,r(e))}e.exports=c;},"7d7b":function(e,t,r){var o=r("e4ae"),n=r("7cd6");e.exports=r("584a").getIterator=function(e){var t=n(e);if("function"!=typeof t)throw TypeError(e+" is not iterable!");return o(t.call(e))};},"7dcd":function(e,t,r){var o=r("6e4c");"string"===typeof o&&(o=[[e.i,o,""]]),o.locals&&(e.exports=o.locals);var n=r("499e").default;n("6070a49c",o,!0,{sourceMap:!1,shadowMode:!1});},"7e64":function(e,t,r){var o=r("5e2e"),n=r("efb6"),c=r("2fcc"),i=r("802a"),a=r("55a3"),s=r("d02c");function u(e){var t=this.__data__=new o(e);this.size=t.size;}u.prototype.clear=n,u.prototype["delete"]=c,u.prototype.get=i,u.prototype.has=a,u.prototype.set=s,e.exports=u;},"7e8e":function(e,t){var r=/[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;function o(e){return r.test(e)}e.exports=o;},"7e90":function(e,t,r){var o=r("d9f6"),n=r("e4ae"),c=r("c3a1");e.exports=r("8e60")?Object.defineProperties:function(e,t){n(e);var r,i=c(t),a=i.length,s=0;while(a>s)o.f(e,r=i[s++],t[r]);return e};},"7ed2":function(e,t){var r="__lodash_hash_undefined__";function o(e){return this.__data__.set(e,r),this}e.exports=o;},"7efe":function(e){e.exports={title:"MMMM YYYY",weekdays:"W",navMonths:"MMM",input:["L","YYYY-MM-DD","YYYY/MM/DD"],dayPopover:"WWW, MMM D, YYYY",data:["L","YYYY-MM-DD","YYYY/MM/DD"]};},"7f20":function(e,t,r){var o=r("86cc").f,n=r("69a8"),c=r("2b4c")("toStringTag");e.exports=function(e,t,r){e&&!n(e=r?e:e.prototype,c)&&o(e,c,{configurable:!0,value:t});};},"7f7f":function(e,t,r){var o=r("86cc").f,n=Function.prototype,c=/^\s*function ([^ (]*)/,i="name";i in n||r("9e1e")&&o(n,i,{configurable:!0,get:function(){try{return (""+this).match(c)[1]}catch(e){return ""}}});},"802a":function(e,t){function r(e){return this.__data__.get(e)}e.exports=r;},8057:function(e,t){function r(e,t){var r=-1,o=null==e?0:e.length;while(++r<o)if(!1===t(e[r],r,e))break;return e}e.exports=r;},8103:function(e,t,r){var o=r("d194"),n=o("toUpperCase");e.exports=n;},8296:function(e,t,r){var o=r("656b"),n=r("2b10");function c(e,t){return t.length<2?e:o(e,n(t,0,-1))}e.exports=c;},8378:function(e,t){var r=e.exports={version:"2.6.9"};"number"==typeof __e&&(__e=r);},8384:function(e,t){function r(e,t,r){return e===e&&(void 0!==r&&(e=e<=r?e:r),void 0!==t&&(e=e>=t?e:t)),e}e.exports=r;},"83a1":function(e,t){e.exports=Object.is||function(e,t){return e===t?0!==e||1/e===1/t:e!=e&&t!=t};},8436:function(e,t){e.exports=function(){};},"844c":function(e,t,r){r("8e6e"),r("ac6a"),r("cadf"),r("456d");var o=r("bd86"),n=r("23a5"),c=r("7efe"),i=r("85a9"),a={color:"blue",isDark:!1,container:{light:"vc-border vc-border-gray-400 vc-rounded-lg vc-text-gray-900 vc-bg-white",dark:"vc-border vc-border-gray-900 vc-rounded-lg vc-text-gray-200 vc-bg-gray-900 vc-shadow"},header:{light:"vc-text-gray-900",dark:"vc-text-gray-200"},title:{light:"vc-text-lg vc-text-gray-800 vc-font-semibold hover:vc-opacity-75",dark:"vc-text-lg vc-text-gray-100 vc-font-semibold hover:vc-opacity-75"},arrows:{light:"vc-text-gray-600 vc-rounded vc-border-transparent hover:vc-opacity-50 focus:vc-border-gray-300",dark:"vc-text-white vc-rounded vc-border-transparent hover:vc-opacity-50 focus:vc-border-gray-700"},weekdays:{light:"vc-text-sm vc-font-bold vc-text-gray-500",dark:"vc-text-sm vc-font-bold vc-text-{color}-200"},navPopoverContainer:{light:"vc-rounded-lg vc-text-sm vc-font-semibold vc-text-white vc-bg-gray-800 vc-border vc-border-gray-700 vc-p-1 vc-shadow",dark:"vc-rounded-lg vc-text-sm vc-font-semibold vc-text-gray-800 vc-bg-white vc-border vc-border-gray-100 vc-p-1 vc-shadow"},navTitle:{light:"vc-text-{color}-100 vc-font-bold vc-leading-snug vc-px-2 vc-py-1 vc-rounded vc-border-2 vc-border-transparent hover:vc-bg-gray-900 focus:vc-border-{color}-600",dark:"vc-text-gray-900 vc-font-bold vc-leading-snug vc-px-2 vc-py-1 vc-rounded vc-border-2 vc-border-transparent hover:vc-bg-gray-200 focus:vc-border-{color}-400"},navArrows:{light:"vc-leading-snug vc-rounded vc-border-2 vc-border-transparent hover:vc-bg-gray-900 focus:vc-border-{color}-600",dark:"vc-leading-snug vc-rounded vc-border-2 vc-border-transparent hover:vc-bg-gray-200 focus:vc-border-{color}-400"},navCell:{light:"vc-w-12 vc-font-semibold vc-cursor-pointer vc-text-center vc-leading-snug vc-py-1 vc-rounded vc-border-2 vc-border-transparent hover:vc-bg-gray-900 hover:vc-shadow-inner hover:vc-text-white focus:vc-border-{color}-600",dark:"vc-w-12 vc-font-semibold vc-cursor-pointer vc-text-center vc-leading-snug vc-py-1 vc-rounded vc-border-2 vc-border-transparent hover:vc-bg-gray-200 hover:vc-text-gray-900 focus:vc-border-{color}-400"},navCellInactive:"vc-border-transparent",navCellInactiveCurrent:{light:"vc-text-{color}-100 vc-font-bold vc-border-{color}-100",dark:"vc-text-{color}-600 vc-font-bold vc-border-{color}-500"},navCellActive:{light:"vc-bg-{color}-100 vc-text-{color}-900 vc-border-transparent vc-font-bold vc-shadow",dark:"vc-bg-{color}-500 vc-text-white vc-border-transparent vc-font-bold vc-shadow"},dayNotInMonth:"vc-opacity-0 vc-pointer-events-none",dayContent:"vc-font-medium vc-text-sm vc-cursor-pointer focus:vc-font-bold vc-rounded-full",dayContentDisabled:{light:"vc-text-sm vc-text-gray-400 vc-font-medium vc-pointer-events-none",dark:"vc-text-sm vc-text-gray-600 vc-font-medium vc-pointer-events-none"},dayPopoverContainer:{light:"vc-rounded vc-text-xs vc-text-white vc-font-medium vc-bg-gray-800 vc-border vc-border-gray-700 vc-px-2 vc-py-1 vc-shadow",dark:"vc-rounded vc-text-xs vc-text-gray-900 vc-font-medium vc-bg-white vc-border vc-border-gray-200 vc-px-2 vc-py-1 vc-shadow"},dayPopoverHeader:{light:"vc-text-xs vc-text-gray-300 vc-font-semibold",dark:"vc-text-xs vc-text-gray-700 vc-font-semibold"},highlightBaseFillMode:"light",highlightStartEndFillMode:"solid",highlightStartEndClass:"vc-rounded-full",bgLow:{light:"vc-bg-white vc-border-2 vc-border-{color}-700",dark:"vc-bg-gray-900 vc-border-2 vc-border-{color}-200"},bgAccentLow:{light:"vc-bg-{color}-200",dark:"vc-bg-{color}-800 vc-opacity-75"},bgAccentHigh:{light:"vc-bg-{color}-600",dark:"vc-bg-{color}-500"},contentAccent:{light:"vc-font-bold vc-text-{color}-900",dark:"vc-font-bold vc-text-{color}-100"},contentAccentContrast:"vc-font-bold vc-text-white",datePickerInput:"vc-shadow vc-appearance-none vc-border vc-rounded vc-w-full vc-py-2 vc-px-3 vc-text-gray-800 vc-bg-white vc-leading-tight focus:vc-outline-none focus:vc-shadow-outline",datePickerInputDrag:"vc-shadow vc-appearance-none vc-border vc-rounded vc-w-full vc-py-2 vc-px-3 vc-text-gray-400 vc-bg-white vc-leading-tight focus:vc-outline-none focus:vc-shadow-outline"},s=r("768b"),u=r("9404"),d={ar:{dow:7,L:"D/‏M/‏YYYY"},bg:{dow:2,L:"D.MM.YYYY"},ca:{dow:2,L:"DD/MM/YYYY"},"zh-CN":{dow:2,L:"YYYY/MM/DD"},"zh-TW":{dow:1,L:"YYYY/MM/DD"},hr:{dow:2,L:"DD.MM.YYYY"},cs:{dow:2,L:"DD.MM.YYYY"},da:{dow:2,L:"DD.MM.YYYY"},nl:{dow:2,L:"DD.MM.YYYY"},"en-US":{dow:1,L:"MM/DD/YYYY"},"en-AU":{dow:2,L:"DD/MM/YYYY"},"en-CA":{dow:1,L:"YYYY-MM-DD"},"en-GB":{dow:2,L:"DD/MM/YYYY"},"en-IE":{dow:2,L:"DD-MM-YYYY"},"en-NZ":{dow:2,L:"DD/MM/YYYY"},eo:{dow:2,L:"YYYY-MM-DD"},fi:{dow:2,L:"Do MMMM[ta] YYYY"},fr:{dow:2,L:"DD/MM/YYYY"},"fr-CA":{dow:1,L:"YYYY-MM-DD"},"fr-CH":{dow:2,L:"DD.MM.YYYY"},de:{dow:2,L:"DD.MM.YYYY"},id:{dow:2,L:"DD/MM/YYYY"},it:{dow:2,L:"DD/MM/YYYY"},ja:{dow:1,L:"YYYY年M月D日"},ko:{dow:1,L:"YYYY.MM.DD"},mk:{dow:2,L:"D.MM.YYYY"},pl:{dow:2,L:"DD.MM.YYYY"},pt:{dow:2,L:"DD/MM/YYYY"},ro:{dow:2,L:"DD.MM.YYYY"},ru:{dow:2,L:"DD.MM.YYYY"},sk:{dow:2,L:"DD.MM.YYYY"},es:{dow:1,L:"DD/MM/YYYY"},sv:{dow:2,L:"YYYY-MM-DD"},th:{dow:1,L:"DD/MM/YYYY"},tr:{dow:2,L:"DD.MM.YYYY"},uk:{dow:2,L:"DD.MM.YYYY"}};d.en=d["en-US"],d.zh=d["zh-CN"],Object(u["u"])(d).forEach(function(e){var t=Object(s["a"])(e,2),r=t[0],o=t[1],n=o.dow,c=o.L;d[r]={firstDayOfWeek:n,masks:{L:c}};});var l=d,f={componentPrefix:"v",navVisibility:"click",titlePosition:"center",transition:"slide-h",touch:n,masks:c,screens:i,theme:a,locales:l,datePicker:{updateOnInput:!0,inputDebounce:1e3,popover:{visibility:"hover-focus",placement:"bottom-start",keepVisibleOnInput:!1}}},v=function(e){return Object(u["m"])(e)&&(e={min:e}),Object(u["h"])(e)||(e=[e]),e.map(function(e){return Object(u["e"])(e,"raw")?e.raw:Object(u["p"])(e,function(e,t){return t=Object(u["d"])({min:"min-width",max:"max-width"},t,t),"(".concat(t,": ").concat(e,")")}).join(" and ")}).join(", ")},b=function(e,t){if(t){var r=!1,o=new e({data:function(){return {matches:[],queries:[]}},methods:{refreshQueries:function(){var e=this;this.queries=Object(u["q"])(t,function(t){var r=window.matchMedia(v(t));return r.addListener(e.refreshMatches),r}),this.refreshMatches();},refreshMatches:function(){this.matches=Object(u["u"])(this.queries).filter(function(e){return e[1].matches}).map(function(e){return e[0]});}}});e.mixin({mounted:function(){r||(o.refreshQueries(),r=!0);},computed:{$screens:function(){return function(e,t){return o.matches.reduce(function(t,r){return Object(u["e"])(e,r)?e[r]:t},Object(u["n"])(t)?e.default:t)}}}});}},h=function(e,t){return new e({data:function(){return {defaults:t,activeRefs:{}}},computed:{theme:function(){return this.defaults.theme},locales:function(){var e=this;return Object(u["q"])(this.defaults.locales,function(t){return t.masks=Object(u["b"])(t.masks,e.defaults.masks),t})}}})};function p(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),r.push.apply(r,o);}return r}function g(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?p(r,!0).forEach(function(t){Object(o["a"])(e,t,r[t]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):p(r).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t));});}return e}r.d(t,"a",function(){return y});var y=function(e,t){var r=Object(u["l"])(t)?g({},t):{};return Object(u["c"])(r,f),b(e,r.screens),e.prototype.$vc=h(e,r)};},"84f2":function(e,t){e.exports={};},"858b":function(e,t,r){var o=r("c522"),n=r.n(o);n.a;},"85a9":function(e){e.exports={sm:"640px",md:"768px",lg:"1024px",xl:"1280px"};},"85e3":function(e,t){function r(e,t,r){switch(r.length){case 0:return e.call(t);case 1:return e.call(t,r[0]);case 2:return e.call(t,r[0],r[1]);case 3:return e.call(t,r[0],r[1],r[2])}return e.apply(t,r)}e.exports=r;},"85f2":function(e,t,r){e.exports=r("454f");},8604:function(e,t,r){var o=r("26e8"),n=r("e2c0");function c(e,t){return null!=e&&n(e,t,o)}e.exports=c;},8615:function(e,t,r){var o=r("5ca1"),n=r("504c")(!1);o(o.S,"Object",{values:function(e){return n(e)}});},"86cc":function(e,t,r){var o=r("cb7c"),n=r("c69a"),c=r("6a99"),i=Object.defineProperty;t.f=r("9e1e")?Object.defineProperty:function(e,t,r){if(o(e),t=c(t,!0),o(r),n)try{return i(e,t,r)}catch(a){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return "value"in r&&(e[t]=r.value),e};},"872a":function(e,t,r){var o=r("3b4a");function n(e,t,r){"__proto__"==t&&o?o(e,t,{configurable:!0,enumerable:!0,value:r,writable:!0}):e[t]=r;}e.exports=n;},"89d9":function(e,t,r){var o=r("656b"),n=r("159a"),c=r("e2e4");function i(e,t,r){var i=-1,a=t.length,s={};while(++i<a){var u=t[i],d=o(e,u);r(d,u)&&n(s,c(u,e),d);}return s}e.exports=i;},"8adb":function(e,t){function r(e,t){if(("constructor"!==t||"function"!==typeof e[t])&&"__proto__"!=t)return e[t]}e.exports=r;},"8b97":function(e,t,r){var o=r("d3f4"),n=r("cb7c"),c=function(e,t){if(n(e),!o(t)&&null!==t)throw TypeError(t+": can't set as prototype!")};e.exports={set:Object.setPrototypeOf||("__proto__"in{}?function(e,t,o){try{o=r("9b43")(Function.call,r("11e9").f(Object.prototype,"__proto__").set,2),o(e,[]),t=!(e instanceof Array);}catch(n){t=!0;}return function(e,r){return c(e,r),t?e.__proto__=r:o(e,r),e}}({},!1):void 0),check:c};},"8db3":function(e,t,r){var o=r("47f5");function n(e,t){var r=null==e?0:e.length;return !!r&&o(e,t,0)>-1}e.exports=n;},"8de2":function(e,t,r){var o=r("8eeb"),n=r("9934");function c(e){return o(e,n(e))}e.exports=c;},"8e60":function(e,t,r){e.exports=!r("294c")(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a});},"8e6e":function(e,t,r){var o=r("5ca1"),n=r("990b"),c=r("6821"),i=r("11e9"),a=r("f1ae");o(o.S,"Object",{getOwnPropertyDescriptors:function(e){var t,r,o=c(e),s=i.f,u=n(o),d={},l=0;while(u.length>l)r=s(o,t=u[l++]),void 0!==r&&a(d,t,r);return d}});},"8eeb":function(e,t,r){var o=r("32b3"),n=r("872a");function c(e,t,r,c){var i=!r;r||(r={});var a=-1,s=t.length;while(++a<s){var u=t[a],d=c?c(r[u],e[u],u,r,e):void 0;void 0===d&&(d=e[u]),i?n(r,u,d):o(r,u,d);}return r}e.exports=c;},"8f60":function(e,t,r){var o=r("a159"),n=r("aebd"),c=r("45f2"),i={};r("35e8")(i,r("5168")("iterator"),function(){return this}),e.exports=function(e,t,r){e.prototype=o(i,{next:n(1,r)}),c(e,t+" Iterator");};},9003:function(e,t,r){var o=r("6b4c");e.exports=Array.isArray||function(e){return "Array"==o(e)};},9093:function(e,t,r){var o=r("ce10"),n=r("e11e").concat("length","prototype");t.f=Object.getOwnPropertyNames||function(e){return o(e,n)};},9138:function(e,t,r){e.exports=r("35e8");},"91e9":function(e,t){function r(e,t){return function(r){return e(t(r))}}e.exports=r;},"93d6":function(e,t,r){var o=r("bf3c"),n=r.n(o);n.a;},"93ed":function(e,t,r){var o=r("4245");function n(e){var t=o(this,e)["delete"](e);return this.size-=t?1:0,t}e.exports=n;},9404:function(e,t,r){r.d(t,"k",function(){return re}),r.d(t,"m",function(){return oe}),r.d(t,"i",function(){return ne}),r.d(t,"h",function(){return ce}),r.d(t,"l",function(){return ie}),r.d(t,"j",function(){return ae}),r.d(t,"n",function(){return se}),r.d(t,"a",function(){return ue}),r.d(t,"w",function(){return de}),r.d(t,"d",function(){return le}),r.d(t,"s",function(){return fe}),r.d(t,"q",function(){return ve}),r.d(t,"u",function(){return be}),r.d(t,"e",function(){return he}),r.d(t,"f",function(){return pe}),r.d(t,"b",function(){return ge}),r.d(t,"c",function(){return ye}),r.d(t,"r",function(){return me}),r.d(t,"p",function(){return xe}),r.d(t,"t",function(){return we}),r.d(t,"g",function(){return ke}),r.d(t,"o",function(){return Oe}),r.d(t,"v",function(){return je});r("6b54");var o=r("6679"),n=r.n(o),c=r("501e"),i=r.n(c),a=r("e2a0"),s=r.n(a),u=r("6220"),d=r.n(u),l=r("dcbe"),f=r.n(l),v=r("9520"),b=r.n(v),h=r("4cfe"),p=r.n(h),g=r("2768"),y=r.n(g),m=r("f678"),x=r.n(m),w=r("375a"),k=r.n(w),O=r("e9a7"),j=r.n(O),D=r("8103"),_=r.n(D),P=r("9b02"),M=r.n(P),S=r("0f5c"),E=r.n(S),C=r("9e86"),I=r.n(C),A=r("f542"),Y=r.n(A),T=r("3852"),L=r.n(T),F=r("95ae"),N=r.n(F),z=r("3f84"),$=r.n(z),R=r("2593"),V=r.n(R),W=r("3eea"),H=r.n(W),U=r("dd61"),B=r.n(U),G=r("3092"),q=r.n(G),K=r("a59b"),Z=r.n(K),X=r("4416"),J=r.n(X),Q=r("eed6"),ee=r.n(Q),te=function(e){return Object.prototype.toString.call(e).slice(8,-1)},re=(n.a,i.a),oe=s.a,ne=function(e){return d()(e)&&!isNaN(e.getTime())},ce=f.a,ie=function(e){return "Object"===te(e)},ae=b.a,se=p.a,ue=(y.a,x.a),de=(k.a,j.a,_.a),le=M.a,fe=E.a,ve=I.a,be=Y.a,he=L.a,pe=function(e,t){return q()(t,function(t){return L()(e,t)})},ge=N.a,ye=$.a,me=(V.a,H.a),xe=B.a,we=q.a,ke=Z.a,Oe=J.a,je=ee.a;},"950a":function(e,t,r){var o=r("30c9");function n(e,t){return function(r,n){if(null==r)return r;if(!o(r))return e(r,n);var c=r.length,i=t?c:-1,a=Object(r);while(t?i--:++i<c)if(!1===n(a[i],i,a))break;return r}}e.exports=n;},9520:function(e,t,r){var o=r("3729"),n=r("1a8c"),c="[object AsyncFunction]",i="[object Function]",a="[object GeneratorFunction]",s="[object Proxy]";function u(e){if(!n(e))return !1;var t=o(e);return t==i||t==a||t==c||t==s}e.exports=u;},"95ae":function(e,t,r){var o=r("100e"),n=r("9638"),c=r("9aff"),i=r("9934"),a=Object.prototype,s=a.hasOwnProperty,u=o(function(e,t){e=Object(e);var r=-1,o=t.length,u=o>2?t[2]:void 0;u&&c(t[0],t[1],u)&&(o=1);while(++r<o){var d=t[r],l=i(d),f=-1,v=l.length;while(++f<v){var b=l[f],h=e[b];(void 0===h||n(h,a[b])&&!s.call(e,b))&&(e[b]=d[b]);}}return e});e.exports=u;},"95d5":function(e,t,r){var o=r("40c3"),n=r("5168")("iterator"),c=r("481b");e.exports=r("584a").isIterable=function(e){var t=Object(e);return void 0!==t[n]||"@@iterator"in t||c.hasOwnProperty(o(t))};},9638:function(e,t){function r(e,t){return e===t||e!==e&&t!==t}e.exports=r;},"966f":function(e,t,r){var o=r("7e64"),n=r("c05f"),c=1,i=2;function a(e,t,r,a){var s=r.length,u=s,d=!a;if(null==e)return !u;e=Object(e);while(s--){var l=r[s];if(d&&l[2]?l[1]!==e[l[0]]:!(l[0]in e))return !1}while(++s<u){l=r[s];var f=l[0],v=e[f],b=l[1];if(d&&l[2]){if(void 0===v&&!(f in e))return !1}else {var h=new o;if(a)var p=a(v,b,f,e,t,h);if(!(void 0===p?n(b,v,c|i,a,h):p))return !1}}return !0}e.exports=a;},"96f3":function(e,t){var r=Object.prototype,o=r.hasOwnProperty;function n(e,t){return null!=e&&o.call(e,t)}e.exports=n;},"97d3":function(e,t,r){var o=r("48a0"),n=r("30c9");function c(e,t){var r=-1,c=n(e)?Array(e.length):[];return o(e,function(e,o,n){c[++r]=t(e,o,n);}),c}e.exports=c;},"990b":function(e,t,r){var o=r("9093"),n=r("2621"),c=r("cb7c"),i=r("7726").Reflect;e.exports=i&&i.ownKeys||function(e){var t=o.f(c(e)),r=n.f;return r?t.concat(r(e)):t};},9934:function(e,t,r){var o=r("6fcd"),n=r("41c3"),c=r("30c9");function i(e){return c(e)?o(e,!0):n(e)}e.exports=i;},"99cd":function(e,t){function r(e){return function(t,r,o){var n=-1,c=Object(t),i=o(t),a=i.length;while(a--){var s=i[e?a:++n];if(!1===r(c[s],s,c))break}return t}}e.exports=r;},"99d3":function(e,t,r){(function(e){var o=r("585a"),n=t&&!t.nodeType&&t,c=n&&"object"==typeof e&&e&&!e.nodeType&&e,i=c&&c.exports===n,a=i&&o.process,s=function(){try{var e=c&&c.require&&c.require("util").types;return e||a&&a.binding&&a.binding("util")}catch(t){}}();e.exports=s;}).call(this,r("62e4")(e));},"9aff":function(e,t,r){var o=r("9638"),n=r("30c9"),c=r("c098"),i=r("1a8c");function a(e,t,r){if(!i(r))return !1;var a=typeof t;return !!("number"==a?n(r)&&c(t,r.length):"string"==a&&t in r)&&o(r[t],e)}e.exports=a;},"9b02":function(e,t,r){var o=r("656b");function n(e,t,r){var n=null==e?void 0:o(e,t);return void 0===n?r:n}e.exports=n;},"9b43":function(e,t,r){var o=r("d8e8");e.exports=function(e,t,r){if(o(e),void 0===t)return e;switch(r){case 1:return function(r){return e.call(t,r)};case 2:return function(r,o){return e.call(t,r,o)};case 3:return function(r,o,n){return e.call(t,r,o,n)}}return function(){return e.apply(t,arguments)}};},"9c6c":function(e,t,r){var o=r("2b4c")("unscopables"),n=Array.prototype;void 0==n[o]&&r("32e9")(n,o,{}),e.exports=function(e){n[o][e]=!0;};},"9def":function(e,t,r){var o=r("4588"),n=Math.min;e.exports=function(e){return e>0?n(o(e),9007199254740991):0};},"9e1e":function(e,t,r){e.exports=!r("79e5")(function(){return 7!=Object.defineProperty({},"a",{get:function(){return 7}}).a});},"9e69":function(e,t,r){var o=r("2b3e"),n=o.Symbol;e.exports=n;},"9e86":function(e,t,r){var o=r("872a"),n=r("242e"),c=r("badf");function i(e,t){var r={};return t=c(t,3),n(e,function(e,n,c){o(r,n,t(e,n,c));}),r}e.exports=i;},a029:function(e,t,r){var o=r("087d"),n=r("2dcb"),c=r("32f4"),i=r("d327"),a=Object.getOwnPropertySymbols,s=a?function(e){var t=[];while(e)o(t,c(e)),e=n(e);return t}:i;e.exports=s;},a159:function(e,t,r){var o=r("e4ae"),n=r("7e90"),c=r("1691"),i=r("5559")("IE_PROTO"),a=function(){},s="prototype",u=function(){var e,t=r("1ec9")("iframe"),o=c.length,n="<",i=">";t.style.display="none",r("32fc").appendChild(t),t.src="javascript:",e=t.contentWindow.document,e.open(),e.write(n+"script"+i+"document.F=Object"+n+"/script"+i),e.close(),u=e.F;while(o--)delete u[s][c[o]];return u()};e.exports=Object.create||function(e,t){var r;return null!==e?(a[s]=o(e),r=new a,a[s]=null,r[i]=e):r=u(),void 0===t?r:n(r,t)};},a2be:function(e,t,r){var o=r("d612"),n=r("4284"),c=r("c584"),i=1,a=2;function s(e,t,r,s,u,d){var l=r&i,f=e.length,v=t.length;if(f!=v&&!(l&&v>f))return !1;var b=d.get(e);if(b&&d.get(t))return b==t;var h=-1,p=!0,g=r&a?new o:void 0;d.set(e,t),d.set(t,e);while(++h<f){var y=e[h],m=t[h];if(s)var x=l?s(m,y,h,t,e,d):s(y,m,h,e,t,d);if(void 0!==x){if(x)continue;p=!1;break}if(g){if(!n(t,function(e,t){if(!c(g,t)&&(y===e||u(y,e,r,s,d)))return g.push(t)})){p=!1;break}}else if(y!==m&&!u(y,m,r,s,d)){p=!1;break}}return d["delete"](e),d["delete"](t),p}e.exports=s;},a2db:function(e,t,r){var o=r("9e69"),n=o?o.prototype:void 0,c=n?n.valueOf:void 0;function i(e){return c?Object(c.call(e)):{}}e.exports=i;},a3fd:function(e,t,r){var o=r("7948");function n(e,t){return o(t,function(t){return [t,e[t]]})}e.exports=n;},a454:function(e,t,r){var o=r("72f0"),n=r("3b4a"),c=r("cd9d"),i=n?function(e,t){return n(e,"toString",{configurable:!0,enumerable:!1,value:o(t),writable:!0})}:c;e.exports=i;},a481:function(e,t,r){var o=r("cb7c"),n=r("4bf8"),c=r("9def"),i=r("4588"),a=r("0390"),s=r("5f1b"),u=Math.max,d=Math.min,l=Math.floor,f=/\$([$&`']|\d\d?|<[^>]*>)/g,v=/\$([$&`']|\d\d?)/g,b=function(e){return void 0===e?e:String(e)};r("214f")("replace",2,function(e,t,r,h){return [function(o,n){var c=e(this),i=void 0==o?void 0:o[t];return void 0!==i?i.call(o,c,n):r.call(String(c),o,n)},function(e,t){var n=h(r,e,this,t);if(n.done)return n.value;var l=o(e),f=String(this),v="function"===typeof t;v||(t=String(t));var g=l.global;if(g){var y=l.unicode;l.lastIndex=0;}var m=[];while(1){var x=s(l,f);if(null===x)break;if(m.push(x),!g)break;var w=String(x[0]);""===w&&(l.lastIndex=a(f,c(l.lastIndex),y));}for(var k="",O=0,j=0;j<m.length;j++){x=m[j];for(var D=String(x[0]),_=u(d(i(x.index),f.length),0),P=[],M=1;M<x.length;M++)P.push(b(x[M]));var S=x.groups;if(v){var E=[D].concat(P,_,f);void 0!==S&&E.push(S);var C=String(t.apply(void 0,E));}else C=p(D,f,_,P,S,t);_>=O&&(k+=f.slice(O,_)+C,O=_+D.length);}return k+f.slice(O)}];function p(e,t,o,c,i,a){var s=o+e.length,u=c.length,d=v;return void 0!==i&&(i=n(i),d=f),r.call(a,d,function(r,n){var a;switch(n.charAt(0)){case"$":return "$";case"&":return e;case"`":return t.slice(0,o);case"'":return t.slice(s);case"<":a=i[n.slice(1,-1)];break;default:var d=+n;if(0===d)return r;if(d>u){var f=l(d/10);return 0===f?r:f<=u?void 0===c[f-1]?n.charAt(1):c[f-1]+n.charAt(1):r}a=c[d-1];}return void 0===a?"":a})}});},a524:function(e,t,r){var o=r("4245");function n(e){return o(this,e).has(e)}e.exports=n;},a59b:function(e,t){function r(e){return e&&e.length?e[0]:void 0}e.exports=r;},a745:function(e,t,r){e.exports=r("f410");},a832:function(e,t,r){var o=function(){var e=this,t=e.$createElement,r=e._self._c||t;return r("div",{staticClass:"vc-day-popover-row"},[e.indicator?r("div",{staticClass:"vc-day-popover-row-indicator"},[r("span",{class:e.indicator.class,style:e.indicator.style})]):e._e(),r("div",{staticClass:"vc-day-popover-row-content"},[e._t("default",[e._v(e._s(e.attribute.popover?e.attribute.popover.label:"No content provided"))])],2)])},n=[],c=r("19cf"),i={name:"VPopoverRow",mixins:[c["a"]],props:{attribute:Object},computed:{indicator:function(){var e=this.attribute,t=e.highlight,r=e.dot,o=e.bar,n=e.content,c=e.popover;if(c&&c.hideIndicator)return null;if(t){var i=t.start,a=i.color,s=i.isDark;return {class:this.theme.getConfig("bgAccentHigh",{color:a,isDark:!s}),style:{width:"10px",height:"5px",borderRadius:"3px"}}}if(r){var u=r.start,d=u.color,l=u.isDark;return {class:this.theme.getConfig("bgAccentHigh",{color:d,isDark:!l}),style:{width:"5px",height:"5px",borderRadius:"50%"}}}if(o){var f=o.start,v=f.color,b=f.isDark;return {class:this.theme.getConfig("bgAccentHigh",{color:v,isDark:!b}),style:{width:"10px",height:"3px"}}}if(n){var h=n.start,p=h.color,g=h.isDark;return {class:this.theme.getConfig("contentContrast",{color:p,isDark:!g})}}return null}}},a=i,s=(r("1ceb"),r("2877")),u=Object(s["a"])(a,o,n,!1,null,"18514c08",null);t["a"]=u.exports;},a919:function(e,t,r){var o=r("ddc6"),n={"À":"A","Á":"A","Â":"A","Ã":"A","Ä":"A","Å":"A","à":"a","á":"a","â":"a","ã":"a","ä":"a","å":"a","Ç":"C","ç":"c","Ð":"D","ð":"d","È":"E","É":"E","Ê":"E","Ë":"E","è":"e","é":"e","ê":"e","ë":"e","Ì":"I","Í":"I","Î":"I","Ï":"I","ì":"i","í":"i","î":"i","ï":"i","Ñ":"N","ñ":"n","Ò":"O","Ó":"O","Ô":"O","Õ":"O","Ö":"O","Ø":"O","ò":"o","ó":"o","ô":"o","õ":"o","ö":"o","ø":"o","Ù":"U","Ú":"U","Û":"U","Ü":"U","ù":"u","ú":"u","û":"u","ü":"u","Ý":"Y","ý":"y","ÿ":"y","Æ":"Ae","æ":"ae","Þ":"Th","þ":"th","ß":"ss","Ā":"A","Ă":"A","Ą":"A","ā":"a","ă":"a","ą":"a","Ć":"C","Ĉ":"C","Ċ":"C","Č":"C","ć":"c","ĉ":"c","ċ":"c","č":"c","Ď":"D","Đ":"D","ď":"d","đ":"d","Ē":"E","Ĕ":"E","Ė":"E","Ę":"E","Ě":"E","ē":"e","ĕ":"e","ė":"e","ę":"e","ě":"e","Ĝ":"G","Ğ":"G","Ġ":"G","Ģ":"G","ĝ":"g","ğ":"g","ġ":"g","ģ":"g","Ĥ":"H","Ħ":"H","ĥ":"h","ħ":"h","Ĩ":"I","Ī":"I","Ĭ":"I","Į":"I","İ":"I","ĩ":"i","ī":"i","ĭ":"i","į":"i","ı":"i","Ĵ":"J","ĵ":"j","Ķ":"K","ķ":"k","ĸ":"k","Ĺ":"L","Ļ":"L","Ľ":"L","Ŀ":"L","Ł":"L","ĺ":"l","ļ":"l","ľ":"l","ŀ":"l","ł":"l","Ń":"N","Ņ":"N","Ň":"N","Ŋ":"N","ń":"n","ņ":"n","ň":"n","ŋ":"n","Ō":"O","Ŏ":"O","Ő":"O","ō":"o","ŏ":"o","ő":"o","Ŕ":"R","Ŗ":"R","Ř":"R","ŕ":"r","ŗ":"r","ř":"r","Ś":"S","Ŝ":"S","Ş":"S","Š":"S","ś":"s","ŝ":"s","ş":"s","š":"s","Ţ":"T","Ť":"T","Ŧ":"T","ţ":"t","ť":"t","ŧ":"t","Ũ":"U","Ū":"U","Ŭ":"U","Ů":"U","Ű":"U","Ų":"U","ũ":"u","ū":"u","ŭ":"u","ů":"u","ű":"u","ų":"u","Ŵ":"W","ŵ":"w","Ŷ":"Y","ŷ":"y","Ÿ":"Y","Ź":"Z","Ż":"Z","Ž":"Z","ź":"z","ż":"z","ž":"z","Ĳ":"IJ","ĳ":"ij","Œ":"Oe","œ":"oe","ŉ":"'n","ſ":"s"},c=o(n);e.exports=c;},a93e:function(e,t,r){var o=r("6ecb");"string"===typeof o&&(o=[[e.i,o,""]]),o.locals&&(e.exports=o.locals);var n=r("499e").default;n("a2521288",o,!0,{sourceMap:!1,shadowMode:!1});},a994:function(e,t,r){var o=r("7d1f"),n=r("32f4"),c=r("ec69");function i(e){return o(e,c,n)}e.exports=i;},aa77:function(e,t,r){var o=r("5ca1"),n=r("be13"),c=r("79e5"),i=r("fdef"),a="["+i+"]",s="​",u=RegExp("^"+a+a+"*"),d=RegExp(a+a+"*$"),l=function(e,t,r){var n={},a=c(function(){return !!i[e]()||s[e]()!=s}),u=n[e]=a?t(f):i[e];r&&(n[r]=u),o(o.P+o.F*a,"String",n);},f=l.trim=function(e,t){return e=String(n(e)),1&t&&(e=e.replace(u,"")),2&t&&(e=e.replace(d,"")),e};e.exports=l;},aae3:function(e,t,r){var o=r("d3f4"),n=r("2d95"),c=r("2b4c")("match");e.exports=function(e){var t;return o(e)&&(void 0!==(t=e[c])?!!t:"RegExp"==n(e))};},aaec:function(e,t){var r="\\ud800-\\udfff",o="\\u0300-\\u036f",n="\\ufe20-\\ufe2f",c="\\u20d0-\\u20ff",i=o+n+c,a="\\ufe0e\\ufe0f",s="\\u200d",u=RegExp("["+s+r+i+a+"]");function d(e){return u.test(e)}e.exports=d;},ac41:function(e,t){function r(e){var t=-1,r=Array(e.size);return e.forEach(function(e){r[++t]=e;}),r}e.exports=r;},ac6a:function(e,t,r){for(var o=r("cadf"),n=r("0d58"),c=r("2aba"),i=r("7726"),a=r("32e9"),s=r("84f2"),u=r("2b4c"),d=u("iterator"),l=u("toStringTag"),f=s.Array,v={CSSRuleList:!0,CSSStyleDeclaration:!1,CSSValueList:!1,ClientRectList:!1,DOMRectList:!1,DOMStringList:!1,DOMTokenList:!0,DataTransferItemList:!1,FileList:!1,HTMLAllCollection:!1,HTMLCollection:!1,HTMLFormElement:!1,HTMLSelectElement:!1,MediaList:!0,MimeTypeArray:!1,NamedNodeMap:!1,NodeList:!0,PaintRequestList:!1,Plugin:!1,PluginArray:!1,SVGLengthList:!1,SVGNumberList:!1,SVGPathSegList:!1,SVGPointList:!1,SVGStringList:!1,SVGTransformList:!1,SourceBufferList:!1,StyleSheetList:!0,TextTrackCueList:!1,TextTrackList:!1,TouchList:!1},b=n(v),h=0;h<b.length;h++){var p,g=b[h],y=v[g],m=i[g],x=m&&m.prototype;if(x&&(x[d]||a(x,d,f),x[l]||a(x,l,g),s[g]=f,y))for(p in o)x[p]||c(x,p,o[p],!0);}},aebd:function(e,t){e.exports=function(e,t){return {enumerable:!(1&e),configurable:!(2&e),writable:!(4&e),value:t}};},b047:function(e,t){function r(e){return function(t){return e(t)}}e.exports=r;},b0b4:function(e,t,r){r.d(t,"a",function(){return i});var o=r("85f2"),n=r.n(o);function c(e,t){for(var r=0;r<t.length;r++){var o=t[r];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),n()(e,o.key,o);}}function i(e,t,r){return t&&c(e.prototype,t),r&&c(e,r),e}},b0c5:function(e,t,r){var o=r("520a");r("5ca1")({target:"RegExp",proto:!0,forced:o!==/./.exec},{exec:o});},b0dc:function(e,t,r){var o=r("e4ae");e.exports=function(e,t,r,n){try{return n?t(o(r)[0],r[1]):t(r)}catch(i){var c=e["return"];throw void 0!==c&&o(c.call(e)),i}};},b1d2:function(e,t,r){var o=r("3729"),n=r("1310"),c="[object Date]";function i(e){return n(e)&&o(e)==c}e.exports=i;},b1e5:function(e,t,r){var o=r("a994"),n=1,c=Object.prototype,i=c.hasOwnProperty;function a(e,t,r,c,a,s){var u=r&n,d=o(e),l=d.length,f=o(t),v=f.length;if(l!=v&&!u)return !1;var b=l;while(b--){var h=d[b];if(!(u?h in t:i.call(t,h)))return !1}var p=s.get(e);if(p&&s.get(t))return p==t;var g=!0;s.set(e,t),s.set(t,e);var y=u;while(++b<l){h=d[b];var m=e[h],x=t[h];if(c)var w=u?c(x,m,h,t,e,s):c(m,x,h,e,t,s);if(!(void 0===w?m===x||a(m,x,r,c,s):w)){g=!1;break}y||(y="constructor"==h);}if(g&&!y){var k=e.constructor,O=t.constructor;k!=O&&"constructor"in e&&"constructor"in t&&!("function"==typeof k&&k instanceof k&&"function"==typeof O&&O instanceof O)&&(g=!1);}return s["delete"](e),s["delete"](t),g}e.exports=a;},b20a:function(e,t,r){var o=r("6ac0"),n=r("4caa"),c=r("ea72"),i="['’]",a=RegExp(i,"g");function s(e){return function(t){return o(c(n(t).replace(a,"")),e,"")}}e.exports=s;},b218:function(e,t){var r=9007199254740991;function o(e){return "number"==typeof e&&e>-1&&e%1==0&&e<=r}e.exports=o;},b39a:function(e,t,r){var o=r("d3f4");e.exports=function(e,t){if(!o(e)||e._t!==t)throw TypeError("Incompatible receiver, "+t+" required!");return e};},b3e9:function(e,t,r){t=e.exports=r("2350")(!1),t.push([e.i,".vc-container{--slide-translate:22px;--slide-duration:0.15s;--slide-timing:ease;--header-padding:10px 10px 0 10px;--title-padding:0 8px;--arrows-padding:10px;--arrow-font-size:26px;--weekday-padding:5px 0;--weeks-padding:5px 6px 7px 6px;--arrow-horizontal-offset:10px;--arrow-vertical-offset:11px;--nav-container-width:170px;--day-min-height:28px;--day-content-width:28px;--day-content-height:28px;--day-content-margin:1.6px auto;--day-content-transition-time:0.13s ease-in;--day-content-bg-color-hover:rgba(204,214,224,0.3);--day-content-dark-bg-color-hover:rgba(114,129,151,0.3);--day-content-bg-color-focus:rgba(204,214,224,0.4);--day-content-dark-bg-color-focus:rgba(114,129,151,0.4);--highlight-height:28px;--dot-diameter:5px;--dot-border-radius:50%;--dot-spacing:3px;--bar-height:3px;--bars-width:75%;font-family:BlinkMacSystemFont,-apple-system,Segoe UI,Roboto,Oxygen,Ubuntu,Cantarell,Fira Sans,Droid Sans,Helvetica Neue,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;width:-webkit-max-content;width:max-content}.vc-arrows-container{width:100%;position:absolute;top:0;display:flex;justify-content:space-between;padding:var(--arrows-padding);pointer-events:none}.vc-arrows-container.title-left{justify-content:flex-end}.vc-arrows-container.title-right{justify-content:flex-start}",""]);},b447:function(e,t,r){var o=r("3a38"),n=Math.min;e.exports=function(e){return e>0?n(o(e),9007199254740991):0};},b4b0:function(e,t,r){var o=r("1a8c"),n=r("ffd6"),c=NaN,i=/^\s+|\s+$/g,a=/^[-+]0x[0-9a-f]+$/i,s=/^0b[01]+$/i,u=/^0o[0-7]+$/i,d=parseInt;function l(e){if("number"==typeof e)return e;if(n(e))return c;if(o(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=o(t)?t+"":t;}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(i,"");var r=s.test(e);return r||u.test(e)?d(e.slice(2),r?2:8):a.test(e)?c:+e}e.exports=l;},b4c0:function(e,t,r){var o=r("cb5a");function n(e){var t=this.__data__,r=o(t,e);return r<0?void 0:t[r][1]}e.exports=n;},b5a7:function(e,t,r){var o=r("0b07"),n=r("2b3e"),c=o(n,"DataView");e.exports=c;},b5e7:function(e,t,r){var o=r("44ec"),n=r.n(o);n.a;},b760:function(e,t,r){var o=r("872a"),n=r("9638");function c(e,t,r){(void 0===r||n(e[t],r))&&(void 0!==r||t in e)||o(e,t,r);}e.exports=c;},b8e3:function(e,t){e.exports=!0;},badf:function(e,t,r){var o=r("642a"),n=r("1838"),c=r("cd9d"),i=r("6747"),a=r("f9ce");function s(e){return "function"==typeof e?e:null==e?c:"object"==typeof e?i(e)?n(e[0],e[1]):o(e):a(e)}e.exports=s;},bbc0:function(e,t,r){var o=r("6044"),n="__lodash_hash_undefined__",c=Object.prototype,i=c.hasOwnProperty;function a(e){var t=this.__data__;if(o){var r=t[e];return r===n?void 0:r}return i.call(t,e)?t[e]:void 0}e.exports=a;},bcdf:function(e,t){function r(){}e.exports=r;},bd86:function(e,t,r){r.d(t,"a",function(){return c});var o=r("85f2"),n=r.n(o);function c(e,t,r){return t in e?n()(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}},bdab:function(e,t,r){var o=r("f498");"string"===typeof o&&(o=[[e.i,o,""]]),o.locals&&(e.exports=o.locals);var n=r("499e").default;n("1ee16f20",o,!0,{sourceMap:!1,shadowMode:!1});},bdc4:function(e,t,r){t=e.exports=r("2350")(!1),t.push([e.i,"[data-v-2e61d7e7] .vc-container{border:none}",""]);},be13:function(e,t){e.exports=function(e){if(void 0==e)throw TypeError("Can't call method on  "+e);return e};},bf3c:function(e,t,r){var o=r("bdc4");"string"===typeof o&&(o=[[e.i,o,""]]),o.locals&&(e.exports=o.locals);var n=r("499e").default;n("b9468f48",o,!0,{sourceMap:!1,shadowMode:!1});},c05f:function(e,t,r){var o=r("7b97"),n=r("1310");function c(e,t,r,i,a){return e===t||(null==e||null==t||!n(e)&&!n(t)?e!==e&&t!==t:o(e,t,r,i,c,a))}e.exports=c;},c098:function(e,t){var r=9007199254740991,o=/^(?:0|[1-9]\d*)$/;function n(e,t){var n=typeof e;return t=null==t?r:t,!!t&&("number"==n||"symbol"!=n&&o.test(e))&&e>-1&&e%1==0&&e<t}e.exports=n;},c192:function(e,t,r){r("8e6e"),r("456d"),r("7514"),r("6b54");var o,n,c=r("768b"),i=r("75fc"),a=(r("c5f6"),r("ac6a"),r("cadf"),r("8615"),r("bd86")),s=r("cc8d"),u=r("a832"),d={vLeading:"vertical-leading",vTrailing:"vertical-trailing",hLeading:"horizontal-leading",hTrailing:"horizontal-trailing"},l={render:function(e){var t=this,r=function(e){var r=e.nodes,o=e.position,n=e.row,c=e.column;return r.length>=o?r[o-1]:t.$scopedSlots.default?t.$scopedSlots.default({position:o,row:n,column:c}):null},o=function(){for(var o=[],n=t.$slots.default&&t.$slots.default.filter(function(e){return void 0!==e.tag})||[],c=function(c,i){for(var s=function(a){var s=c-t.rows-1,u=a-t.columns-1;o.push(e("div",{class:["vc-grid-cell","vc-grid-cell-row-".concat(c),"vc-grid-cell-row-".concat(s),"vc-grid-cell-col-".concat(a),"vc-grid-cell-col-".concat(u)],style:{"grid-row":c,"grid-column":a},on:{keydown:function(e){return t.handleCellKeydown({row:c,column:a,event:e})}}},[r({nodes:n,position:i++,row:c,column:a})]));},u=1;u<=t.columns;u++)s(u);a=i;},i=1,a=1;i<=t.rows;i++)c(i,a);return o};return e("div",{class:"vc-grid-container",style:this.containerStyle},Object(i["a"])(o()))},props:{count:Number,rows:{type:Number,default:1},columns:{type:Number,default:1},gap:{type:String,default:"0px"},autofit:Boolean,columnWidth:{type:String,default:"1fr"},disableFocus:{type:Boolean,default:!1}},computed:{containerStyle:function(){return {gridTemplateColumns:this.gridTemplateColumns,gridGap:this.gap}},gridTemplateColumns:function(){return "repeat(".concat(this.autofit?"auto-fit":this.columns,", ").concat(this.columnWidth,")")}},methods:{handleCellKeydown:function(e){var t=e.row,r=e.column,o=e.event;if(!this.disableFocus){var n={row:t,column:r,alt:!1,handled:!1};switch(o.key){case"ArrowUp":n.row--;break;case"ArrowDown":n.row++;break;case"ArrowLeft":n.column--;break;case"ArrowRight":n.column++;break;case"Home":n.column=1;break;case"End":n.column=this.columns;break;case"PageUp":n.alt=o.altKey,n.direction=d.vLeading;break;case"PageDown":n.alt=o.altKey,n.direction=d.vTrailing;break;default:return}if(n.row<1?(n.direction=d.vLeading,n.row=this.rows):n.row>this.rows&&(n.direction=d.vTrailing,n.row=1),n.column<1?(n.direction=d.hLeading,n.column=this.columns):n.column>this.columns&&(n.direction=d.hTrailing,n.column=1),n.direction&&this.$emit("rollover",n),!n.handled){var c=".vc-grid-cell-row-".concat(n.row,".vc-grid-cell-col-").concat(n.column),i=this.$el.querySelector(c);i&&this.tryFocus(i);}o.stopPropagation(),o.preventDefault();}},tryFocus:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.$el;this.$nextTick(function(){var t=[".vc-grid-focus",'button, [href], input, select, textarea, [tabindex="0"]','[tabindex]:not([tabindex="undefined"])'],r=t.map(function(t){return e.querySelector(t)}).find(function(e){return e});return !!r&&(r.focus(),!0)});}}},f=l,v=(r("858b"),r("2877")),b=Object(v["a"])(f,o,n,!1,null,"29dcba24",null),h=b.exports,p=r("e0a0"),g=function(){var e=this,t=e.$createElement,r=e._self._c||t;return r("div",{staticClass:"vc-nav-container"},[r("grid",{ref:"headerGrid",attrs:{columns:3},on:{rollover:e.onHeaderRollover}},[r("span",{ref:"prevButton",staticClass:"vc-nav-arrow vc-flex vc-justify-center vc-items-center vc-mr-auto",class:e.theme.navArrows,attrs:{role:"button",tabindex:"-1"},on:{click:e.movePrev,keydown:function(t){return e.onSpaceOrEnter(t,e.movePrev)}}},[e._t("nav-left-button",[r("svg-icon",{attrs:{name:"left-arrow",width:"20px",height:"24px"}})])],2),r("span",{ref:"titleButton",staticClass:"vc-nav-title vc-grid-focus",class:e.theme.navTitle,style:{whiteSpace:"nowrap"},attrs:{role:"button",tabindex:"0"},on:{click:e.toggleMode,keydown:function(t){return e.onSpaceOrEnter(t,e.toggleMode)}}},[e._v("\n      "+e._s(e.title)+"\n    ")]),r("span",{ref:"nextButton",staticClass:"vc-nav-arrow vc-flex vc-justify-center vc-items-center vc-ml-auto",class:e.theme.navArrows,attrs:{role:"button",tabindex:"-1"},on:{click:e.moveNext,keydown:function(t){return e.onSpaceOrEnter(t,e.moveNext)}}},[e._t("nav-right-button",[r("svg-icon",{attrs:{name:"right-arrow",width:"20px",height:"24px"}})])],2)]),r("grid",{ref:"itemsGrid",attrs:{rows:4,columns:3,gap:"2px 5px"},on:{rollover:e.onItemsRollover}},e._l(e.activeItems,function(t){return r("span",{key:t.label,ref:"items",refInFor:!0,class:e.getItemClasses(t),attrs:{role:"button","aria-label":t.ariaLabel,tabindex:t.isDisabled?void 0:t.isActive?0:-1},on:{click:t.click,keydown:function(r){return e.onSpaceOrEnter(r,t.click)}}},[e._v("\n      "+e._s(t.label)+"\n    ")])}),0)],1)},y=[],m=function(){var e=this,t=e.$createElement,r=e._self._c||t;return r("svg",e._g({staticClass:"vc-svg-icon",attrs:{width:e.width,height:e.height,viewBox:e.viewBox}},e.$listeners),[r("path",{attrs:{d:e.path}})])},x=[],w=(r("7f7f"),"26px"),k="0 0 32 32",O={"left-arrow":{viewBox:"0 -1 16 34",path:"M11.196 10c0 0.143-0.071 0.304-0.179 0.411l-7.018 7.018 7.018 7.018c0.107 0.107 0.179 0.268 0.179 0.411s-0.071 0.304-0.179 0.411l-0.893 0.893c-0.107 0.107-0.268 0.179-0.411 0.179s-0.304-0.071-0.411-0.179l-8.321-8.321c-0.107-0.107-0.179-0.268-0.179-0.411s0.071-0.304 0.179-0.411l8.321-8.321c0.107-0.107 0.268-0.179 0.411-0.179s0.304 0.071 0.411 0.179l0.893 0.893c0.107 0.107 0.179 0.25 0.179 0.411z"},"right-arrow":{viewBox:"-5 -1 16 34",path:"M10.625 17.429c0 0.143-0.071 0.304-0.179 0.411l-8.321 8.321c-0.107 0.107-0.268 0.179-0.411 0.179s-0.304-0.071-0.411-0.179l-0.893-0.893c-0.107-0.107-0.179-0.25-0.179-0.411 0-0.143 0.071-0.304 0.179-0.411l7.018-7.018-7.018-7.018c-0.107-0.107-0.179-0.268-0.179-0.411s0.071-0.304 0.179-0.411l0.893-0.893c0.107-0.107 0.268-0.179 0.411-0.179s0.304 0.071 0.411 0.179l8.321 8.321c0.107 0.107 0.179 0.268 0.179 0.411z"}},j={props:["name"],data:function(){return {width:w,height:w,viewBox:k,path:"",isBaseline:!1}},mounted:function(){this.updateIcon();},watch:{name:function(){this.updateIcon();}},methods:{updateIcon:function(){var e=O[this.name];e&&(this.width=e.width||w,this.height=e.height||w,this.viewBox=e.viewBox,this.path=e.path);}}},D=j,_=(r("6551"),Object(v["a"])(D,m,x,!1,null,"5572e632",null)),P=_.exports,M=r("19cf"),S=r("9404"),E=r("2fa3"),C=12,I={components:{Grid:h,SvgIcon:P},mixins:[M["a"]],props:{value:{type:Object,default:function(){return {month:0,year:0}}},validator:{type:Function,default:function(){return function(){return !0}}}},data:function(){return {monthMode:!0,yearIndex:0,yearGroupIndex:0,onSpaceOrEnter:E["k"]}},computed:{month:function(){return this.value&&this.value.month||0},year:function(){return this.value&&this.value.year||0},title:function(){return this.monthMode?this.yearIndex:"".concat(this.firstYear," - ").concat(this.lastYear)},monthItems:function(){var e=this,t=Object(E["l"])(new Date),r=t.month,o=t.year;return this.locale.getMonthDates().map(function(t,n){var c=n+1;return {label:e.locale.format(t,e.masks.navMonths),ariaLabel:e.locale.format(t,"MMMM YYYY"),isActive:c===e.month&&e.yearIndex===e.year,isCurrent:c===r&&e.yearIndex===o,isDisabled:!e.validator({month:c,year:e.yearIndex}),click:function(){return e.monthClick(c)}}})},yearItems:function(){for(var e=this,t=Object(E["l"])(new Date),r=(t._,t.year),o=this.yearGroupIndex*C,n=o+C,c=[],i=function(t){c.push({year:t,label:t,ariaLabel:t,isActive:t===e.year,isCurrent:t===r,isDisabled:!e.validator({month:e.month,year:t}),click:function(){return e.yearClick(t)}});},a=o;a<n;a+=1)i(a);return c},activeItems:function(){return this.monthMode?this.monthItems:this.yearItems},firstYear:function(){return Object(S["g"])(this.yearItems.map(function(e){return e.year}))},lastYear:function(){return Object(S["o"])(this.yearItems.map(function(e){return e.year}))}},watch:{year:function(){this.yearIndex=this.year;},yearIndex:function(e){this.yearGroupIndex=this.getYearGroupIndex(e);}},created:function(){this.yearIndex=this.year;},mounted:function(){this.$refs.itemsGrid.tryFocus();},methods:{getItemClasses:function(e){var t=e.isActive,r=e.isCurrent,o=e.isDisabled,n=[this.theme.navCell];return t?n.push(this.theme.navCellActive,"vc-grid-focus"):r?n.push(this.theme.navCellInactiveCurrent):n.push(this.theme.navCellInactive),o&&n.push("vc-opacity-25 vc-pointer-events-none"),n},getYearGroupIndex:function(e){return Math.floor(e/C)},monthClick:function(e){this.$emit("input",{month:e,year:this.yearIndex});},yearClick:function(e){this.yearIndex=e,this.monthMode=!0,this.$refs.itemsGrid.tryFocus();},toggleMode:function(){this.monthMode=!this.monthMode;},movePrev:function(){this.monthMode&&this.movePrevYear(),this.movePrevYearGroup();},moveNext:function(){this.monthMode&&this.moveNextYear(),this.moveNextYearGroup();},movePrevYear:function(){this.yearIndex--;},moveNextYear:function(){this.yearIndex++;},movePrevYearGroup:function(){this.yearGroupIndex--;},moveNextYearGroup:function(){this.yearGroupIndex++;},onHeaderRollover:function(e){switch(e.direction){case"vertical-trailing":this.$refs.itemsGrid.tryFocus();break}e.handled=!0;},onItemsRollover:function(e){switch(e.direction){case"horizontal-leading":this.movePrev();break;case"horizontal-trailing":this.moveNext();break;case"vertical-leading":this.$refs.headerGrid.tryFocus(),e.handled=!0;break;case"vertical-trailing":e.handled=!0;break}}}},A=I,Y=Object(v["a"])(A,g,y,!1,null,null,null),T=Y.exports;function L(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),r.push.apply(r,o);}return r}function F(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?L(r,!0).forEach(function(t){Object(a["a"])(e,t,r[t]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):L(r).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t));});}return e}var N,z,$={name:"CalendarDay",mixins:[M["a"],M["d"]],render:function(e){var t=this,r=function(){return t.hasBackgrounds&&e("div",{class:"vc-highlights vc-day-layer"},t.backgrounds.map(function(t){var r=t.key,o=t.wrapperClass,n=t.class;return e("div",{key:r,class:o},[e("div",{class:n})])}))},o=function(){return t.safeScopedSlot("day-content",{day:t.day,attributes:t.day.attributes,attributesMap:t.day.attributesMap,dayProps:t.dayContentProps,dayEvents:t.dayContentEvents})||e("span",{class:t.dayContentClass,attrs:F({},t.dayContentProps),on:t.dayContentEvents,ref:"content"},[t.day.label])},n=function(){if(!t.hasPopovers)return o();var r=t.popoverState,n=r.visibility,c=r.placement,i=r.isInteractive;return e(p["a"],{props:{id:t.dayPopoverId,args:t.dayEvent,visibility:n,placement:c,isInteractive:i}},[o()])},c=function(){return t.hasDots&&e("div",{class:"vc-day-layer vc-day-box-center-bottom"},[e("div",{class:"vc-dots"},t.dots.map(function(t){var r=t.key,o=t.class;return e("span",{class:o,key:r})}))])},s=function(){return t.hasBars&&e("div",{class:"vc-day-layer vc-day-box-center-bottom"},[e("div",{class:"vc-bars"},t.bars.map(function(t){var r=t.key,o=t.class;return e("span",{class:o,key:r})}))])};return e("div",{class:["vc-day"].concat(Object(i["a"])(this.day.classes),[{"vc-day-box-center-center":!this.$scopedSlots["day-content"]}])},[e("div",{class:["vc-h-full",Object(a["a"])({},this.theme.dayNotInMonth,!this.inMonth)]},[r(),n(),c(),s()])])},inject:["sharedState"],props:{day:{type:Object,required:!0}},data:function(){return {glyphs:{},popoverState:{}}},computed:{label:function(){return this.day.label},dateTime:function(){return this.day.dateTime},inMonth:function(){return this.day.inMonth},isDisabled:function(){return this.day.isDisabled},backgrounds:function(){return this.glyphs.backgrounds},hasBackgrounds:function(){return !!Object(E["b"])(this.backgrounds)},content:function(){return this.glyphs.content},dots:function(){return this.glyphs.dots},hasDots:function(){return !!Object(E["b"])(this.dots)},bars:function(){return this.glyphs.bars},hasBars:function(){return !!Object(E["b"])(this.bars)},popovers:function(){return this.glyphs.popovers},hasPopovers:function(){return !!Object(E["b"])(this.popovers)},dayContentClass:function(){var e=Object(S["d"])(Object(S["o"])(this.content),"class")||"";return "vc-day-content vc-focusable ".concat(this.isDisabled?this.theme.dayContentDisabled:this.theme.dayContent," ").concat(this.theme.isDark?"vc-is-dark":""," ").concat(e)},dayContentProps:function(){return {tabindex:this.day.isFocusable?"0":this.day.inMonth?"-1":void 0,"aria-label":this.day.ariaLabel}},dayContentEvents:function(){return {click:this.click,mouseenter:this.mouseenter,mouseleave:this.mouseleave,focusin:this.focusin,focusout:this.focusout,keydown:this.keydown}},dayEvent:function(){return F({},this.day,{el:this.$refs.content,popovers:this.popovers})}},watch:{theme:function(){this.refresh();},popovers:function(){var e=["click","focus","hover","visible"],t="",r=!1,o=-1;this.popovers.forEach(function(n){var c=e.indexOf(n.visibility);o=c>o?c:o,t=t||n.placement,r=r||n.isInteractive;}),this.popoverState={visibility:o>=0?e[o]:"hidden",placement:t||"bottom",isInteractive:r};}},methods:{getDayEvent:function(e){return F({},this.dayEvent,{event:e})},click:function(e){this.$emit("dayclick",this.getDayEvent(e));},mouseenter:function(e){this.$emit("daymouseenter",this.getDayEvent(e));},mouseleave:function(e){this.$emit("daymouseleave",this.getDayEvent(e));},focusin:function(e){this.$emit("dayfocusin",this.getDayEvent(e));},focusout:function(e){this.$emit("dayfocusout",this.getDayEvent(e));},keydown:function(e){this.$emit("daykeydown",this.getDayEvent(e));},refresh:function(){var e=this;if(this.day.refresh){this.day.refresh=!1;var t={backgrounds:[],dots:[],bars:[],popovers:[],content:[]};this.day.attributes=Object.values(this.day.attributesMap||{}).sort(function(e,t){return e.order-t.order}),this.day.attributes.forEach(function(r){var o=r.targetDate,n=o.isDate,c=o.isComplex,i=o.startTime,a=o.endTime,s=i===e.dateTime,u=a===e.dateTime,d=s&&u,l=s||u,f={isDate:n,isComplex:c,onStart:s,onEnd:u,onStartAndEnd:d,onStartOrEnd:l};e.processHighlight(r,f,t),e.processContent(r,f,t),e.processDot(r,f,t),e.processBar(r,f,t),e.processPopover(r,t);}),this.glyphs=t;}},processHighlight:function(e,t,r){var o=e.key,n=e.highlight,c=t.isDate,i=t.isComplex,a=t.onStart,s=t.onEnd,u=t.onStartAndEnd,d=r.backgrounds,l=r.content;if(n){var f=n.base,v=n.start,b=n.end;c||i?(d.push({key:o,wrapperClass:"vc-day-layer vc-day-box-center-center",class:"vc-highlight ".concat(v.class)}),l.push({key:"".concat(o,"-content"),class:v.contentClass})):u?(d.push({key:o,wrapperClass:"vc-day-layer vc-day-box-center-center",class:"vc-highlight ".concat(v.class)}),l.push({key:"".concat(o,"-content"),class:v.contentClass})):a?(d.push({key:"".concat(o,"-base"),wrapperClass:"vc-day-layer vc-day-box-right-center",class:"vc-highlight vc-highlight-base-start ".concat(f.class)}),d.push({key:o,wrapperClass:"vc-day-layer vc-day-box-center-center",class:"vc-highlight ".concat(v.class)}),l.push({key:"".concat(o,"-content"),class:v.contentClass})):s?(d.push({key:"".concat(o,"-base"),wrapperClass:"vc-day-layer vc-day-box-left-center",class:"vc-highlight vc-highlight-base-end ".concat(f.class)}),d.push({key:o,wrapperClass:"vc-day-layer vc-day-box-center-center",class:"vc-highlight ".concat(b.class)}),l.push({key:"".concat(o,"-content"),class:b.contentClass})):(d.push({key:"".concat(o,"-middle"),wrapperClass:"vc-day-layer vc-day-box-center-center",class:"vc-highlight vc-highlight-base-middle ".concat(f.class)}),l.push({key:"".concat(o,"-content"),class:f.contentClass}));}},processContent:function(e,t,r){var o=e.key,n=e.content,c=t.isDate,i=t.onStart,a=t.onEnd,s=r.content;if(n){var u=n.base,d=n.start,l=n.end;c||i?s.push({key:o,class:d.class}):a?s.push({key:o,class:l.class}):s.push({key:o,class:u.class});}},processDot:function(e,t,r){var o=e.key,n=e.dot,c=t.isDate,i=t.onStart,a=t.onEnd,s=r.dots;if(n){var u=n.base,d=n.start,l=n.end;c||i?s.push({key:o,class:"vc-dot ".concat(d.class)}):a?s.push({key:o,class:"vc-dot ".concat(l.class)}):s.push({key:o,class:"vc-dot ".concat(u.class)});}},processBar:function(e,t,r){var o=e.key,n=e.bar,c=t.isDate,i=t.onStart,a=t.onEnd,s=r.bars;if(n){var u=n.base,d=n.start,l=n.end;c||i?s.push({key:o,class:"vc-bar ".concat(d.class)}):a?s.push({key:o,class:"vc-bar ".concat(l.class)}):s.push({key:o,class:"vc-bar ".concat(u.class)});}},processPopover:function(e,t){var r=t.popovers;if(e.popover){var o=e.popover,n=o.label,c=o.labelClass,i=o.labelStyle,a=o.hideIndicator,s=o.visibility,u=o.placement,d=o.isInteractive;r.splice(0,0,{key:e.key,customData:e.customData,attribute:e,label:n,labelClass:c,labelStyle:i,hideIndicator:a,visibility:s||(n?"hover":"click"),placement:u||"bottom",isInteractive:void 0!==d?d:!n});}}}},R=$,V=(r("0e9c"),Object(v["a"])(R,N,z,!1,null,"b0867174",null)),W=V.exports;function H(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),r.push.apply(r,o);}return r}function U(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?H(r,!0).forEach(function(t){Object(a["a"])(e,t,r[t]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):H(r).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t));});}return e}var B,G,q,K,Z={mixins:[M["b"],M["a"],M["d"]],render:function(e){var t=this,r=this.safeScopedSlot("header",this.page)||e("div",{class:["vc-header",this.theme.header]},[e("div",{class:"vc-title-layout align-".concat(this.titlePosition)},[e("div",{class:"vc-title-wrapper"},[e(p["a"],{props:{id:this.navPopoverId,visibility:this.navVisibility_,placement:this.navPlacement,isInteractive:!0}},[e("div",{class:["vc-title",this.theme.title]},[this.safeScopedSlot("header-title",this.page,this.page.title)])]),e(s["a"],{props:{id:this.navPopoverId,contentClass:this.theme.navPopoverContainer}},[e(T,{props:{value:this.page,validator:this.canMove},on:{input:function(e){return t.move(e)}},scopedSlots:this.$scopedSlots})])])])]),o=e(h,{class:"vc-weeks",props:{rows:7,columns:7,columnWidth:"1fr",disableFocus:!0}},[].concat(Object(i["a"])(this.weekdayLabels.map(function(r,o){return e("div",{key:o+1,class:["vc-weekday",t.theme.weekdays]},[r])})),Object(i["a"])(this.page.days.map(function(r){return e(W,{attrs:U({},t.$attrs,{day:r}),on:U({},t.$listeners),scopedSlots:t.$scopedSlots,key:r.id,ref:"days",refInFor:!0})}))));return e("div",{class:"vc-pane",ref:"pane"},[r,o])},props:{page:Object,titlePosition:String,navVisibility:String,canMove:{type:Function,default:function(){return !0}}},data:function(){return {navPopoverId:Object(E["c"])()}},computed:{navVisibility_:function(){return this.propOrDefault("navVisibility","navVisibility")},navPlacement:function(){switch(this.titlePosition){case"left":return "bottom-start";case"right":return "bottom-end";default:return "bottom"}},weekdayLabels:function(){var e=this;return this.locale.getWeekdayDates().map(function(t){return e.format(t,e.masks.weekdays)})}},methods:{move:function(e){this.$emit("update:page",e);},refresh:function(){this.$refs.days.forEach(function(e){return e.refresh()});}}},X=Z,J=(r("b5e7"),Object(v["a"])(X,B,G,!1,null,"d8853504",null)),Q=J.exports,ee={name:"CustomTransition",render:function(e){return e("transition",{props:{name:this.name_,appear:this.appear},on:{beforeEnter:this.beforeEnter,afterEnter:this.afterEnter}},[this.$slots.default])},props:{name:String,appear:Boolean},computed:{name_:function(){return this.name||"none"}},methods:{beforeEnter:function(e){this.$emit("beforeEnter",e),this.$emit("beforeTransition",e);},afterEnter:function(e){this.$emit("afterEnter",e),this.$emit("afterTransition",e);}}},te=ee,re=(r("2285"),Object(v["a"])(te,q,K,!1,null,"5be4b00c",null)),oe=re.exports,ne=(r("1c4c"),r("5df3"),r("4f7f"),r("d225")),ce=r("b0b4"),ie=r("cfe5"),ae=function(){function e(t,r,o){var n=this,c=t.key,i=t.hashcode,a=t.highlight,s=t.content,u=t.dot,d=t.bar,l=t.popover,f=t.dates,v=t.excludeDates,b=t.excludeMode,h=t.customData,p=t.order,g=t.pinPage;Object(ne["a"])(this,e),this.key=Object(S["n"])(c)?Object(E["c"])():c,this.hashcode=i,this.customData=h,this.order=p||0,this.dateOpts={order:p,locale:o},this.pinPage=g,a&&(this.highlight=r.normalizeHighlight(a)),s&&(this.content=r.normalizeContent(s)),u&&(this.dot=r.normalizeDot(u)),d&&(this.bar=r.normalizeBar(d)),l&&(this.popover=l),f&&(this.dates=Object(S["h"])(f)?f:[f]),this.hasDates=Object(E["b"])(this.dates),v&&(this.excludeDates=Object(S["h"])(v)?v:[v]),this.hasExcludeDates=Object(E["b"])(this.excludeDates),this.excludeMode=b||"intersects",this.dates=(this.hasDates&&this.dates||this.hasExcludeDates&&[{}]||[]).map(function(e){return e&&(e instanceof ie["d"]?e:new ie["d"](e,n.dateOpts))}).filter(function(e){return e}),this.excludeDates=(this.hasExcludeDates&&this.excludeDates||[]).map(function(e){return e&&(e instanceof ie["d"]?e:new ie["d"](e,n.dateOpts))}).filter(function(e){return e}),this.isComplex=Object(S["t"])(f,function(e){return e.isComplex});}return Object(ce["a"])(e,[{key:"intersectsDate",value:function(e){return !this.excludesDate(e)&&(this.dates.find(function(t){return t.intersectsDate(e)})||!1)}},{key:"includesDate",value:function(e){return e=e instanceof ie["d"]?e:new ie["d"](e,this.dateOpts),!this.excludesDate(e)&&(this.dates.find(function(t){return t.includesDate(e)})||!1)}},{key:"excludesDate",value:function(e){var t=this;return e=e instanceof ie["d"]?e:new ie["d"](e,this.dateOpts),this.hasExcludeDates&&this.excludeDates.find(function(r){return "intersects"===t.excludeMode&&r.intersectsDate(e)||"includes"===t.excludeMode&&r.includesDate(e)})}},{key:"includesDay",value:function(e){return !this.excludesDay(e)&&(this.dates.find(function(t){return t.includesDay(e)})||!1)}},{key:"excludesDay",value:function(e){return this.hasExcludeDates&&this.excludeDates.find(function(t){return t.includesDay(e)})}}]),e}();function se(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),r.push.apply(r,o);}return r}function ue(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?se(r,!0).forEach(function(t){Object(a["a"])(e,t,r[t]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):se(r).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t));});}return e}var de=function(){function e(t,r,o){Object(ne["a"])(this,e),this.theme=t,this.locale=r,this.map={},this.refresh(o,!0);}return Object(ce["a"])(e,[{key:"refresh",value:function(e,t){var r=this,o={},n=[],c=null,i=[],a=t?new Set:new Set(Object.keys(this.map));return Object(E["b"])(e)&&e.forEach(function(e,s){if(e&&e.dates){var u=e.key?e.key.toString():s.toString(),d=e.order||0,l=Object(E["g"])(JSON.stringify(e)),f=r.map[u];!t&&f&&f.hashcode===l?a.delete(u):(f=new ae(ue({key:u,order:d,hashcode:l},e),r.theme,r.locale),i.push(f)),f&&f.pinPage&&(c=f),o[u]=f,n.push(f);}}),this.map=o,this.list=n,this.pinAttr=c,{adds:i,deletes:Array.from(a)}}}]),e}(),le=r("0733");function fe(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),r.push.apply(r,o);}return r}function ve(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?fe(r,!0).forEach(function(t){Object(a["a"])(e,t,r[t]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):fe(r).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t));});}return e}var be,he,pe={name:"VCalendar",render:function(e){var t=this,r=this.pages.map(function(r,o){return e(Q,{attrs:ve({},t.$attrs,{attributes:t.store}),props:{titlePosition:t.titlePosition_,page:r,minPage:t.minPage_,maxPage:t.maxPage_,canMove:t.canMove},on:ve({},t.$listeners,{"update:page":function(e){return t.refreshPages({page:e,position:o+1})},dayfocusin:function(e){t.lastFocusedDay=e,t.$emit("dayfocusin",e);},dayfocusout:function(e){t.lastFocusedDay=null,t.$emit("dayfocusout",e);}}),scopedSlots:t.$scopedSlots,key:r.key,ref:"pages",refInFor:!0})}),o=function(r){var o=function(){return r?t.movePrev():t.moveNext()},n=function(e){return Object(E["k"])(e,o)},c=r?!t.canMovePrev:!t.canMoveNext;return e("div",{class:["vc-flex vc-justify-center vc-items-center vc-cursor-pointer vc-select-none ".concat(c?"vc-opacity-25 vc-pointer-events-none vc-cursor-not-allowed":"vc-pointer-events-auto"),t.theme_.arrows],attrs:{role:"button",tabindex:"0"},on:{click:o,keydown:n}},[(r?t.safeScopedSlot("header-left-button",{click:o}):t.safeScopedSlot("header-right-button",{click:o}))||e(P,{props:{name:r?"left-arrow":"right-arrow"}})])},n=function(){return e(s["a"],{props:{id:t.sharedState.dayPopoverId,contentClass:t.theme_.dayPopoverContainer},scopedSlots:{default:function(r){var o=r.args,n=r.updateLayout,c=r.hide,i=Object.values(o.attributes).filter(function(e){return e.popover}),a=t.locale_.masks,s=t.format,d=s(o.date,a.dayPopover);return t.safeScopedSlot("day-popover",{day:o,attributes:i,masks:a,format:s,dayTitle:d,updateLayout:n,hide:c})||e("div",[a.dayPopover&&e("div",{class:["vc-text-center",t.theme_.dayPopoverHeader]},[d]),i.map(function(t){return e(u["a"],{key:t.key,props:{attribute:t}})})])}}})},c=function(){return e("div",{attrs:{"data-helptext":"Press the arrow keys to navigate by day, Home and End to navigate to week ends, PageUp and PageDown to navigate by month, Alt+PageUp and Alt+PageDown to navigate by year"},class:["vc-container","vc-relative","vc-reset",{"vc-min-w-full":t.isExpanded},t.theme_.container],on:{keydown:t.handleKeydown},ref:"container"},[e("div",{class:["vc-w-full vc-relative",{"vc-overflow-hidden":t.inTransition}]},[e(oe,{props:{name:t.transitionName},on:{beforeEnter:function(){t.inTransition=!0;},afterEnter:function(){t.inTransition=!1;}}},[e(h,{class:"grid",props:{rows:t.rows,columns:t.columns,columnWidth:"minmax(256px, 1fr)",disableFocus:!0},attrs:ve({},t.$attrs),key:Object(E["b"])(t.pages)?t.pages[0].key:""},r)]),e("div",{class:["vc-arrows-container title-".concat(t.titlePosition_)]},[o(!0),o(!1)])]),n()])};return c()},mixins:[M["b"],M["c"],M["d"]],provide:function(){return {sharedState:this.sharedState}},props:{rows:{type:Number,default:1},columns:{type:Number,default:1},step:Number,titlePosition:String,isExpanded:Boolean,fromDate:Date,toDate:Date,fromPage:Object,toPage:Object,minDate:null,maxDate:null,minPage:Object,maxPage:Object,disabledDates:null,availableDates:null,transition:String,attributes:[Object,Array],disablePageSwipe:Boolean},data:function(){return {pages:[],store:null,lastFocusedDay:null,focusableDay:(new Date).getDate(),transitionName:"",inTransition:!1,sharedState:{dayPopoverId:Object(E["c"])(),theme:{},masks:{},locale:{}}}},computed:{titlePosition_:function(){return this.propOrDefault("titlePosition","titlePosition")},minPage_:function(){return this.minPage||Object(E["l"])(this.locale_.toDate(this.minDate))},maxPage_:function(){return this.maxPage||Object(E["l"])(this.locale_.toDate(this.maxDate))},count:function(){return this.rows*this.columns},step_:function(){return this.step||this.count},canMovePrev:function(){return !Object(E["q"])(this.minPage_)||Object(E["n"])(this.pages[0],this.minPage_)},canMoveNext:function(){return !Object(E["q"])(this.maxPage_)||Object(E["o"])(this.pages[this.pages.length-1],this.maxPage_)},disabledAttribute:function(){var e=[];this.disabledDates&&(e=Object(S["h"])(this.disabledDates)?this.disabledDates:[this.disabledDates]);var t=this.locale_.toDate(this.minDate),r=this.locale_.toDate(this.maxDate);return t&&e.push({start:null,end:Object(ie["a"])(t,-1)}),r&&e.push({start:Object(ie["a"])(r,1),end:null}),new ae({key:"disabled",dates:e,excludeDates:this.availableDates,excludeMode:"includes",order:100},this.theme_,this.locale_)}},watch:{locale_:function(){this.refreshLocale(),this.refreshPages({page:Object(S["g"])(this.pages),ignoreCache:!0}),this.initStore();},theme_:function(){this.refreshTheme(),this.initStore();},fromPage:function(){this.refreshPages();},toPage:function(){this.refreshPages();},count:function(){this.refreshPages();},attributes:function(e){var t=this.store.refresh(e),r=t.adds,o=t.deletes;this.refreshAttrs(this.pages,r,o);},pages:function(e){this.refreshAttrs(e,this.store.list,null,!0);},disabledAttribute:function(){this.refreshDisabledDays();},lastFocusedDay:function(e){e&&(this.focusableDay=e.day,this.refreshFocusableDays());}},created:function(){this.refreshLocale(),this.refreshTheme(),this.initStore(),this.refreshPages();},mounted:function(){var e=this;if(!this.disablePageSwipe){var t=Object(le["a"])(this.$refs.container,function(t){var r=t.toLeft,o=t.toRight;r?e.moveNext():o&&e.movePrev();},this.$vc.defaults.touch);this.$once("beforeDestroy",function(){return t()});}},methods:{refreshLocale:function(){this.sharedState.locale=this.locale_,this.sharedState.masks=this.locale_.masks;},refreshTheme:function(){this.sharedState.theme=this.theme_;},canMove:function(e){return Object(E["p"])(e,this.minPage_,this.maxPage_)},movePrev:function(){this.move(-this.step_);},moveNext:function(){this.move(this.step_);},move:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.completion,o=void 0===r?null:r,n=t.position,c=void 0===n?1:n,i=Object(S["k"])(e)?Object(E["a"])(this.pages[0],e):e;this.refreshPages({page:i,position:c}),o&&this.$nextTick(function(){return o()});},refreshPages:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=t.page,o=t.position,n=void 0===o?1:o,c=t.ignoreCache,a=null;if(Object(E["q"])(r)){var s=n>0?1-n:-(this.count+n);a=Object(E["a"])(r,s);}else if(a=this.fromPage||Object(E["l"])(this.locale_.toDate(this.fromDate)),!Object(E["q"])(a)){var u=this.toPage||Object(E["l"])(this.locale_.toDate(this.toPage));a=Object(E["q"])(u)?Object(E["a"])(u,1-this.count):this.getPageForAttributes();}a=Object(E["q"])(a)?a:Object(E["m"])();var d=Object(E["a"])(a,this.count-1);Object(E["o"])(a,this.minPage_)?a=this.minPage_:Object(E["n"])(d,this.maxPage_)&&(a=Object(E["a"])(this.maxPage_,1-this.count));var l=Object(i["a"])(Array(this.count).keys()).map(function(t){return e.buildPage(Object(E["a"])(a,t),c)});this.refreshDisabledDays(l),this.refreshFocusableDays(l),this.transitionName=this.getPageTransition(this.pages[0],l[0]),this.pages=l,this.$emit("update:frompage",a),this.$emit("update:fromPage",a),this.$emit("update:topage",d),this.$emit("update:toPage",d);},refreshDisabledDays:function(e){var t=this;this.getPageDays(e).forEach(function(e){return e.isDisabled=!!t.disabledAttribute&&t.disabledAttribute.includesDay(e)});},refreshFocusableDays:function(e){var t=this;this.getPageDays(e).forEach(function(e){return e.isFocusable=e.inMonth&&e.day===t.focusableDay});},getPageDays:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.pages;return e.reduce(function(e,t){return e.concat(t.days)},[])},getPageTransition:function(e,t){if("none"===this.transition)return this.transition;if("fade"===this.transition||!this.transition&&this.count>1||!Object(E["q"])(e)||!Object(E["q"])(t))return "fade";var r=Object(E["o"])(t,e);return "slide-v"===this.transition?r?"slide-down":"slide-up":r?"slide-right":"slide-left"},getPageForAttributes:function(){var e=null,t=this.store.pinAttr;if(t&&t.hasDates){var r=Object(c["a"])(t.dates,1),o=r[0];o=o.start||o.date,e=Object(E["l"])(this.locale_.toDate(o));}return e},buildPage:function(e,t){var r=this,o=e.month,n=e.year,c="".concat(n.toString(),"-").concat(o.toString()),i=this.pages.find(function(e){return e.key===c});if(!i||t){var a=new Date(n,o-1,15),s=this.locale_.getMonthComps(o,n),u=this.locale_.getPrevMonthComps(o,n),d=this.locale_.getNextMonthComps(o,n);i={key:c,month:o,year:n,title:this.locale_.format(a,this.locale_.masks.title),shortMonthLabel:this.locale_.format(a,"MMM"),monthLabel:this.locale_.format(a,"MMMM"),shortYearLabel:n.toString().substring(2),yearLabel:n.toString(),monthComps:s,prevMonthComps:u,nextMonthComps:d,canMove:function(e){return r.canMove(e)},move:function(e){return r.move(e)},moveThisMonth:function(){return r.moveThisMonth()},movePrevMonth:function(){return r.move(u)},moveNextMonth:function(){return r.move(d)},refresh:!0},i.days=this.locale_.getCalendarDays(i);}return i},initStore:function(){this.store=new de(this.theme_,this.locale_,this.attributes),this.refreshAttrs(this.pages,this.store.list,[],!0);},refreshAttrs:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:[],o=arguments.length>2&&void 0!==arguments[2]?arguments[2]:[],n=arguments.length>3?arguments[3]:void 0;Object(E["b"])(t)&&(t.forEach(function(e){e.days.forEach(function(e){var t={};n?e.refresh=Object(E["b"])(e.attributes):Object(S["f"])(e.attributesMap,o)?(t=Object(S["r"])(e.attributesMap,o),e.refresh=!0):t=e.attributesMap||{},r.forEach(function(r){var o=r.includesDay(e);if(o){var n=ve({},r,{targetDate:o});t[r.key]=n,e.refresh=!0;}}),e.refresh&&(e.attributesMap=t);});}),this.$nextTick(function(){e.$refs.pages.forEach(function(e){return e.refresh()});}));},showPageRange:function(e){var t,r;if(Object(S["i"])(e))t=Object(E["l"])(e);else {if(!Object(S["l"])(e))return;var o=e.month,n=e.year,c=e.from,i=e.to;Object(S["k"])(o)&&Object(S["k"])(n)?t=e:(c||i)&&(t=Object(S["i"])(c)?Object(E["l"])(c):c,r=Object(S["i"])(i)?Object(E["l"])(i):i);}var a=Object(S["o"])(this.pages),s=t;Object(E["n"])(r,a)&&(s=Object(E["a"])(r,-(this.pages.length-1))),Object(E["o"])(t,s)&&(s=t),this.refreshPages({page:s});},handleKeydown:function(e){var t=this.lastFocusedDay;null!=t&&(t.event=e,this.handleDayKeydown(t));},handleDayKeydown:function(e){var t=e.date,r=e.event,o=null;switch(r.key){case"ArrowLeft":o=Object(ie["a"])(t,-1);break;case"ArrowRight":o=Object(ie["a"])(t,1);break;case"ArrowUp":o=Object(ie["a"])(t,-7);break;case"ArrowDown":o=Object(ie["a"])(t,7);break;case"Home":o=Object(ie["a"])(t,1-e.weekdayPosition);break;case"End":o=Object(ie["a"])(t,e.weekdayPositionFromEnd);break;case"PageUp":o=r.altKey?Object(ie["c"])(t,-1):Object(ie["b"])(t,-1);break;case"PageDown":o=r.altKey?Object(ie["c"])(t,1):Object(ie["b"])(t,1);break}o&&(r.preventDefault(),this.setFocusedDate(o));},setFocusedDate:function(e){var t=this;if(e&&Object(E["b"])(this.pages)){var r=new ie["d"](e,{locale:this.locale_}),o=this.getPageDays().find(function(e){return e.inMonth&&r.includesDay(e)});if(o){var n=this.$el.querySelector(".id-".concat(o.id,".in-month .vc-focusable"));n&&n.focus();}else {var c=Object(E["l"])(e),i=Object(E["o"])(c,this.pages[0])?-1:1;this.move(c,{completion:function(){return t.setFocusedDate(e)},position:i});}}}}},ge=pe,ye=(r("de5e"),Object(v["a"])(ge,be,he,!1,null,null,null));t["a"]=ye.exports;},c1c9:function(e,t,r){var o=r("a454"),n=r("f3c1"),c=n(o);e.exports=c;},c26b:function(e,t,r){var o=r("86cc").f,n=r("2aeb"),c=r("dcbc"),i=r("9b43"),a=r("f605"),s=r("4a59"),u=r("01f9"),d=r("d53b"),l=r("7a56"),f=r("9e1e"),v=r("67ab").fastKey,b=r("b39a"),h=f?"_s":"size",p=function(e,t){var r,o=v(t);if("F"!==o)return e._i[o];for(r=e._f;r;r=r.n)if(r.k==t)return r};e.exports={getConstructor:function(e,t,r,u){var d=e(function(e,o){a(e,d,t,"_i"),e._t=t,e._i=n(null),e._f=void 0,e._l=void 0,e[h]=0,void 0!=o&&s(o,r,e[u],e);});return c(d.prototype,{clear:function(){for(var e=b(this,t),r=e._i,o=e._f;o;o=o.n)o.r=!0,o.p&&(o.p=o.p.n=void 0),delete r[o.i];e._f=e._l=void 0,e[h]=0;},delete:function(e){var r=b(this,t),o=p(r,e);if(o){var n=o.n,c=o.p;delete r._i[o.i],o.r=!0,c&&(c.n=n),n&&(n.p=c),r._f==o&&(r._f=n),r._l==o&&(r._l=c),r[h]--;}return !!o},forEach:function(e){b(this,t);var r,o=i(e,arguments.length>1?arguments[1]:void 0,3);while(r=r?r.n:this._f){o(r.v,r.k,this);while(r&&r.r)r=r.p;}},has:function(e){return !!p(b(this,t),e)}}),f&&o(d.prototype,"size",{get:function(){return b(this,t)[h]}}),d},def:function(e,t,r){var o,n,c=p(e,t);return c?c.v=r:(e._l=c={i:n=v(t,!0),k:t,v:r,p:o=e._l,n:void 0,r:!1},e._f||(e._f=c),o&&(o.n=c),e[h]++,"F"!==n&&(e._i[n]=c)),e},getEntry:p,setStrong:function(e,t,r){u(e,t,function(e,r){this._t=b(e,t),this._k=r,this._l=void 0;},function(){var e=this,t=e._k,r=e._l;while(r&&r.r)r=r.p;return e._t&&(e._l=r=r?r.n:e._t._f)?d(0,"keys"==t?r.k:"values"==t?r.v:[r.k,r.v]):(e._t=void 0,d(1))},r?"entries":"values",!r,!0),l(t);}};},c2b6:function(e,t,r){var o=r("f8af"),n=r("5d89"),c=r("6f6c"),i=r("a2db"),a=r("c8fe"),s="[object Boolean]",u="[object Date]",d="[object Map]",l="[object Number]",f="[object RegExp]",v="[object Set]",b="[object String]",h="[object Symbol]",p="[object ArrayBuffer]",g="[object DataView]",y="[object Float32Array]",m="[object Float64Array]",x="[object Int8Array]",w="[object Int16Array]",k="[object Int32Array]",O="[object Uint8Array]",j="[object Uint8ClampedArray]",D="[object Uint16Array]",_="[object Uint32Array]";function P(e,t,r){var P=e.constructor;switch(t){case p:return o(e);case s:case u:return new P(+e);case g:return n(e,r);case y:case m:case x:case w:case k:case O:case j:case D:case _:return a(e,r);case d:return new P;case l:case b:return new P(e);case f:return c(e);case v:return new P;case h:return i(e)}}e.exports=P;},c32f:function(e,t,r){var o=r("2b10");function n(e,t,r){var n=e.length;return r=void 0===r?n:r,!t&&r>=n?e:o(e,t,r)}e.exports=n;},c366:function(e,t,r){var o=r("6821"),n=r("9def"),c=r("77f1");e.exports=function(e){return function(t,r,i){var a,s=o(t),u=n(s.length),d=c(i,u);if(e&&r!=r){while(u>d)if(a=s[d++],a!=a)return !0}else for(;u>d;d++)if((e||d in s)&&s[d]===r)return e||d||0;return !e&&-1}};},c367:function(e,t,r){var o=r("8436"),n=r("50ed"),c=r("481b"),i=r("36c3");e.exports=r("30f1")(Array,"Array",function(e,t){this._t=i(e),this._i=0,this._k=t;},function(){var e=this._t,t=this._k,r=this._i++;return !e||r>=e.length?(this._t=void 0,n(1)):n(0,"keys"==t?r:"values"==t?e[r]:[r,e[r]])},"values"),c.Arguments=c.Array,o("keys"),o("values"),o("entries");},c3a1:function(e,t,r){var o=r("e6f3"),n=r("1691");e.exports=Object.keys||function(e){return o(e,n)};},c3fc:function(e,t,r){var o=r("42a2"),n=r("1310"),c="[object Set]";function i(e){return n(e)&&o(e)==c}e.exports=i;},c522:function(e,t,r){var o=r("597b");"string"===typeof o&&(o=[[e.i,o,""]]),o.locals&&(e.exports=o.locals);var n=r("499e").default;n("2de761b9",o,!0,{sourceMap:!1,shadowMode:!1});},c584:function(e,t){function r(e,t){return e.has(t)}e.exports=r;},c5f6:function(e,t,r){var o=r("7726"),n=r("69a8"),c=r("2d95"),i=r("5dbc"),a=r("6a99"),s=r("79e5"),u=r("9093").f,d=r("11e9").f,l=r("86cc").f,f=r("aa77").trim,v="Number",b=o[v],h=b,p=b.prototype,g=c(r("2aeb")(p))==v,y="trim"in String.prototype,m=function(e){var t=a(e,!1);if("string"==typeof t&&t.length>2){t=y?t.trim():f(t,3);var r,o,n,c=t.charCodeAt(0);if(43===c||45===c){if(r=t.charCodeAt(2),88===r||120===r)return NaN}else if(48===c){switch(t.charCodeAt(1)){case 66:case 98:o=2,n=49;break;case 79:case 111:o=8,n=55;break;default:return +t}for(var i,s=t.slice(2),u=0,d=s.length;u<d;u++)if(i=s.charCodeAt(u),i<48||i>n)return NaN;return parseInt(s,o)}}return +t};if(!b(" 0o1")||!b("0b1")||b("+0x1")){b=function(e){var t=arguments.length<1?0:e,r=this;return r instanceof b&&(g?s(function(){p.valueOf.call(r);}):c(r)!=v)?i(new h(m(t)),r,b):m(t)};for(var x,w=r("9e1e")?u(h):"MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger".split(","),k=0;w.length>k;k++)n(h,x=w[k])&&!n(b,x)&&l(b,x,d(h,x));b.prototype=p,p.constructor=b,r("2aba")(o,v,b);}},c603:function(e,t,r){var o=r("b3e9");"string"===typeof o&&(o=[[e.i,o,""]]),o.locals&&(e.exports=o.locals);var n=r("499e").default;n("69b213fc",o,!0,{sourceMap:!1,shadowMode:!1});},c69a:function(e,t,r){e.exports=!r("9e1e")&&!r("79e5")(function(){return 7!=Object.defineProperty(r("230e")("div"),"a",{get:function(){return 7}}).a});},c6cf:function(e,t,r){var o=r("4d8c"),n=r("2286"),c=r("c1c9");function i(e){return c(n(e,void 0,o),e+"")}e.exports=i;},c869:function(e,t,r){var o=r("0b07"),n=r("2b3e"),c=o(n,"Set");e.exports=c;},c87c:function(e,t){var r=Object.prototype,o=r.hasOwnProperty;function n(e){var t=e.length,r=new e.constructor(t);return t&&"string"==typeof e[0]&&o.call(e,"index")&&(r.index=e.index,r.input=e.input),r}e.exports=n;},c8ba:function(e,t){var r;r=function(){return this}();try{r=r||new Function("return this")();}catch(o){"object"===typeof window&&(r=window);}e.exports=r;},c8bb:function(e,t,r){e.exports=r("54a1");},c8fe:function(e,t,r){var o=r("f8af");function n(e,t){var r=t?o(e.buffer):e.buffer;return new e.constructor(r,e.byteOffset,e.length)}e.exports=n;},ca5a:function(e,t){var r=0,o=Math.random();e.exports=function(e){return "Symbol(".concat(void 0===e?"":e,")_",(++r+o).toString(36))};},cadf:function(e,t,r){var o=r("9c6c"),n=r("d53b"),c=r("84f2"),i=r("6821");e.exports=r("01f9")(Array,"Array",function(e,t){this._t=i(e),this._i=0,this._k=t;},function(){var e=this._t,t=this._k,r=this._i++;return !e||r>=e.length?(this._t=void 0,n(1)):n(0,"keys"==t?r:"values"==t?e[r]:[r,e[r]])},"values"),c.Arguments=c.Array,o("keys"),o("values"),o("entries");},cb5a:function(e,t,r){var o=r("9638");function n(e,t){var r=e.length;while(r--)if(o(e[r][0],t))return r;return -1}e.exports=n;},cb7c:function(e,t,r){var o=r("d3f4");e.exports=function(e){if(!o(e))throw TypeError(e+" is not an object!");return e};},cc45:function(e,t,r){var o=r("1a2d"),n=r("b047"),c=r("99d3"),i=c&&c.isMap,a=i?n(i):o;e.exports=a;},cc8d:function(e,t,r){r("8e6e"),r("ac6a"),r("cadf"),r("456d");var o=r("bd86"),n=(r("6762"),r("2fdb"),r("28a5"),r("f0bd")),c=r("2fa3"),i=r("0733"),a=r("9404");function s(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),r.push.apply(r,o);}return r}function u(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?s(r,!0).forEach(function(t){Object(o["a"])(e,t,r[t]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):s(r).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t));});}return e}var d,l,f={render:function(e){return e("div",{class:["vc-popover-content-wrapper",{"is-interactive":this.isInteractive}],ref:"popover"},[e("transition",{props:{name:this.transition,appear:!0},on:{afterLeave:this.afterLeave}},[this.isVisible&&e("div",{class:["vc-popover-content","direction-".concat(this.direction),this.contentClass]},[this.content,e("span",{class:["vc-popover-caret","direction-".concat(this.direction),"align-".concat(this.alignment)]})])])])},props:{id:{type:String,required:!0},transition:{type:String,default:"slide-fade"},contentClass:String},data:function(){return {ref:null,args:null,visibility:"",placement:"bottom",isInteractive:!1,delay:10,popperEl:null}},computed:{content:function(){var e=this;return Object(a["j"])(this.$scopedSlots.default)&&this.$scopedSlots.default({direction:this.direction,alignment:this.alignment,args:this.args,updateLayout:this.scheduleUpdate,hide:function(){return e.onHide({ref:e.ref})}})||this.$slots.default},popperOptions:function(){return {placement:this.placement,onCreate:this.onPopperUpdate,onUpdate:this.onPopperUpdate,modifiers:{hide:{enabled:!1},preventOverflow:{enabled:!1}}}},isVisible:function(){return !(!this.ref||!this.$scopedSlots.default&&!this.$slots.default||"hidden"===this.visibility)},direction:function(){return this.placement.split("-")[0]||"bottom"},alignment:function(){var e="left"===this.direction||"right"===this.direction,t=this.placement.split("-");return t=t.length>1?t[1]:"",["start","top","left"].includes(t)?e?"top":"left":["end","bottom","right"].includes(t)?e?"bottom":"right":e?"middle":"center"}},watch:{ref:function(e){this.setupPopper(),this.$vc.activeRefs=u({},this.$vc.activeRefs,Object(o["a"])({},this.id,e));}},created:function(){var e=this;this.$vc.$on("show:".concat(this.id),this.onShow),this.$vc.$on("hide:".concat(this.id),this.onHide),this.$vc.$on("update:".concat(this.id),this.onUpdate),this.$once("beforeDestroy",function(){e.$vc.$off("show:".concat(e.id),e.onShow),e.$vc.$off("hide:".concat(e.id),e.onHide),e.$vc.$off("update:".concat(e.id),e.onUpdate);});},mounted:function(){this.popoverEl=this.$refs.popover,this.addEvents();},beforeDestroy:function(){this.removeEvents();},methods:{addEvents:function(){Object(c["j"])(this.popoverEl,"click",this.onClick),Object(c["j"])(this.popoverEl,"mouseover",this.onMouseOver),Object(c["j"])(this.popoverEl,"mouseleave",this.onMouseLeave),Object(c["j"])(this.popoverEl,"focusin",this.onFocusIn),Object(c["j"])(this.popoverEl,"blur",this.onBlur),this.removeDocHandler=Object(i["b"])(document,this.onDocumentClick);},removeEvents:function(){Object(c["i"])(this.popoverEl,"click",this.onClick),Object(c["i"])(this.popoverEl,"mouseover",this.onMouseOver),Object(c["i"])(this.popoverEl,"mouseleave",this.onMouseLeave),Object(c["i"])(this.popoverEl,"focusin",this.onFocusIn),Object(c["i"])(this.popoverEl,"blur",this.onBlur),this.removeDocHandler&&this.removeDocHandler();},onClick:function(e){e.stopPropagation();},onMouseOver:function(){this.isInteractive&&"hover"===this.visibility&&clearTimeout(this._timer);},onMouseLeave:function(){this.isInteractive&&"hover"===this.visibility&&this.onHide({ref:this.ref});},onFocusIn:function(){this.isInteractive&&"focus"===this.visibility&&clearTimeout(this._timer);},onBlur:function(){this.isInteractive&&"focus"===this.visibility&&this.onHide({ref:this.ref});},onDocumentClick:function(e){this.$refs.popover&&this.ref&&(Object(c["e"])(this.popoverEl,e.target)||Object(c["e"])(this.ref,e.target)||(this.ref=null));},onShow:function(e){var t=e.ref,r=e.args,o=e.visibility,n=e.placement,c=e.isInteractive;clearTimeout(this._timer),this.args=r,this.visibility=o,this.placement=n,this.isInteractive=c,this.ref=t;},onHide:function(e){var t=this,r=e.ref,o=e.delay;clearTimeout(this._timer),this._timer=setTimeout(function(){r===t.ref&&(t.ref=null,t.args=null,t.visibility="");},o);},onUpdate:function(e){var t=e.args;this.args=t,this.setupPopper();},setupPopper:function(){var e=this;this.$nextTick(function(){e.ref&&e.$refs.popover&&(e.popper&&e.popper.reference!==e.ref&&(e.popper.destroy(),e.popper=null),e.popper?e.popper.scheduleUpdate():e.popper=new n["a"](e.ref,e.popoverEl,e.popperOptions));});},onPopperUpdate:function(e){this.placement=e.placement;},scheduleUpdate:function(){this.popper&&this.popper.scheduleUpdate();},afterLeave:function(){this.destroyPopper();},destroyPopper:function(){this.popper&&(this.popper.destroy(),this.popper=null);}}},v=f,b=(r("4d4c"),r("2877")),h=Object(b["a"])(v,d,l,!1,null,"5dd7f738",null);t["a"]=h.exports;},cd1c:function(e,t,r){var o=r("e853");e.exports=function(e,t){return new(o(e))(t)};},cd9d:function(e,t){function r(e){return e}e.exports=r;},ce10:function(e,t,r){var o=r("69a8"),n=r("6821"),c=r("c366")(!1),i=r("613b")("IE_PROTO");e.exports=function(e,t){var r,a=n(e),s=0,u=[];for(r in a)r!=i&&o(a,r)&&u.push(r);while(t.length>s)o(a,r=t[s++])&&(~c(u,r)||u.push(r));return u};},ce86:function(e,t,r){var o=r("9e69"),n=r("7948"),c=r("6747"),i=r("ffd6"),a=1/0,s=o?o.prototype:void 0,u=s?s.toString:void 0;function d(e){if("string"==typeof e)return e;if(c(e))return n(e,d)+"";if(i(e))return u?u.call(e):"";var t=e+"";return "0"==t&&1/e==-a?"-0":t}e.exports=d;},cebd:function(e,t){function r(e){var t=-1,r=Array(e.size);return e.forEach(function(e){r[++t]=[e,e];}),r}e.exports=r;},cfe5:function(e,t,r){r.d(t,"a",function(){return l}),r.d(t,"b",function(){return f}),r.d(t,"c",function(){return v}),r.d(t,"d",function(){return b});r("8e6e"),r("7514"),r("6762"),r("2fdb"),r("ac6a"),r("cadf"),r("456d");var o=r("bd86"),n=r("d225"),c=r("b0b4"),i=r("2fa3"),a=r("9404");function s(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),r.push.apply(r,o);}return r}function u(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?s(r,!0).forEach(function(t){Object(o["a"])(e,t,r[t]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):s(r).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t));});}return e}var d=864e5;function l(e,t){var r=new Date(e);return r.setDate(r.getDate()+t),r}function f(e,t){var r=new Date(e);return r.setMonth(e.getMonth()+t),r}function v(e,t){var r=new Date(e);return r.setFullYear(e.getFullYear()+t),r}var b=function(){function e(t,r){var o=r.order,c=void 0===o?0:o,s=r.locale;if(Object(n["a"])(this,e),this.isDateInfo=!0,this.isRange=Object(a["l"])(t)||Object(a["j"])(t),this.isDate=!this.isRange,this.order=c,this.locale=s,this.mask=s.masks.data,this.getMonthComps=s.getMonthComps,this.firstDayOfWeek=s.firstDayOfWeek,this.opts={order:c,locale:s},this.isDate){this.type="date";var d=this.toDate(t);d=Object(a["i"])(d)?d:new Date,d.setHours(0,0,0,0),this.date=d,this.dateTime=d.getTime();}if(this.isRange){if(this.type="range",Object(a["j"])(t))this.on={and:t};else {var f=this.toDate(t.start),v=this.toDate(t.end);if(f&&v&&f>v){var b=f;f=v,v=b;}else f&&t.span>=1&&(v=l(f,t.span-1));f&&(Object(a["i"])(f)?f.setHours(0,0,0,0):f=null),v&&(Object(a["i"])(v)?v.setHours(0,0,0,0):v=null),this.start=f,this.end=v,this.startTime=f&&f.getTime(),this.endTime=v&&v.getTime(),f&&v&&(this.daySpan=this.diffInDays(f,v),this.weekSpan=this.diffInWeeks(f,v),this.monthSpan=this.diffInMonths(f,v),this.yearSpan=this.diffInYears(f,v));var h=Object(i["h"])(t,{},e.patternProps);if(h.assigned&&(this.on={and:h.target}),t.on){var p=(Object(a["h"])(t.on)?t.on:[t.on]).map(function(t){if(Object(a["j"])(t))return t;var r=Object(i["h"])(t,{},e.patternProps);return r.assigned?r.target:null}).filter(function(e){return e});p.length&&(this.on=u({},this.on,{or:p}));}}this.isComplex=!!this.on;}}return Object(c["a"])(e,[{key:"toDate",value:function(e){var t=this.locale.masks.data;return this.locale.toDate(e,t)}},{key:"findShallowIntersectingRange",value:function(e,t){var r=e.toRange(),o=t.toRange(),n=null,c=null;return r.start?n=o.start?r.start<o.start?r.start:o.start:r.start:o.start&&(n=o.start),r.end&&(!n||r.end>=n)&&(c=r.end),o.end&&(!n||o.end>=n)&&(!c||o.end<c)&&(c=o.end),{start:n,end:c}}},{key:"getDayFromDate",value:function(e){if(!e)return null;var t=e.getMonth()+1,r=e.getUTCFullYear(),o=this.getMonthComps(t,r),n=e.getDate(),c=o.days-n+1,i=e.getDay()+1,a=Math.floor((n-1)/7+1),s=Math.floor((o.days-n)/7+1),u=Math.ceil((n+Math.abs(o.firstWeekday-o.firstDayOfWeek))/7),d=o.weeks-u+1;return {day:n,dayFromEnd:c,weekday:i,weekdayOrdinal:a,weekdayOrdinalFromEnd:s,week:u,weekFromEnd:d,month:t,year:r,date:e,dateTime:e.getTime()}}},{key:"startOfWeek",value:function(e){var t=e.getDay()+1,r=t>=this.firstDayOfWeek?this.firstDayOfWeek-t:-(7-(this.firstDayOfWeek-t));return l(e,r)}},{key:"diffInDays",value:function(e,t){return Math.round((t-e)/d)}},{key:"diffInWeeks",value:function(e,t){return this.diffInDays(this.startOfWeek(e),this.startOfWeek(t))}},{key:"diffInYears",value:function(e,t){return t.getUTCFullYear()-e.getUTCFullYear()}},{key:"diffInMonths",value:function(e,t){return 12*this.diffInYears(e,t)+(t.getMonth()-e.getMonth())}},{key:"iterateDatesInRange",value:function(e,t){var r=e.start,o=e.end;if(!r||!o||!Object(a["j"])(t))return null;for(var n={i:0,date:r,day:this.getDayFromDate(r),finished:!1},c=null;!n.finished&&n.date<=o;n.i++)c=t(n),n.date=l(n.date,1),n.day=this.getDayFromDate(n.date);return c}},{key:"intersectsDate",value:function(t){var r=this,o=t.isDateInfo?t:new e(t,this.opts);if(!this.shallowIntersectsDate(o))return null;if(!this.on)return this;var n=this.findShallowIntersectingRange(this,o),c=!1;return this.iterateDatesInRange(n,function(e){r.matchesDay(e.day)&&(c=c||o.matchesDay(e.day),e.finished=c);}),c}},{key:"shallowIntersectsDate",value:function(t){return this.dateShallowIntersectsDate(this,t.isDate?t:new e(t,this.opts))}},{key:"dateShallowIntersectsDate",value:function(e,t){return e.isDate?t.isDate?e.dateTime===t.dateTime:this.dateShallowIncludesDate(t,e):t.isDate?this.dateShallowIncludesDate(e,t):!(e.start&&t.end&&e.start>t.end)&&!(e.end&&t.start&&e.end<t.start)}},{key:"includesDate",value:function(t){var r=this,o=t.isDateInfo?t:new e(t,this.opts);if(!this.shallowIncludesDate(o))return !1;if(!this.on)return !0;var n=this.findShallowIntersectingRange(this,o),c=!0;return this.iterateDatesInRange(n,function(e){r.matchesDay(e.day)&&(c=c&&o.matchesDay(e.day),e.finished=!c);}),c}},{key:"shallowIncludesDate",value:function(t){return this.dateShallowIncludesDate(this,t.isDate?t:new e(t,this.opts))}},{key:"dateShallowIncludesDate",value:function(e,t){return e.isDate?t.isDate?e.dateTime===t.dateTime:!(!t.startTime||!t.endTime)&&(e.dateTime===t.startTime&&e.dateTime===t.endTime):t.isDate?!(e.start&&t.date<e.start)&&!(e.end&&t.date>e.end):!(e.start&&(!t.start||t.start<e.start))&&!(e.end&&(!t.end||t.end>e.end))}},{key:"includesDay",value:function(e){return this.shallowIncludesDate(e.date)&&this.matchesDay(e)?this:null}},{key:"matchesDay",value:function(t){var r=this;return !this.on||!(this.on.and&&!e.testConfig(this.on.and,t,this))&&!(this.on.or&&!this.on.or.some(function(o){return e.testConfig(o,t,r)}))}},{key:"toRange",value:function(){return this.isDate?new e({start:this.date,end:this.date},this.opts):new e({start:this.start,end:this.end},this.opts)}},{key:"compare",value:function(e){if(this.order!==e.order)return this.order-e.order;if(this.type!==e.type)return this.isDate?1:-1;if(this.isDate)return 0;var t=this.start-e.start;return 0!==t?t:this.end-e.end}}],[{key:"testConfig",value:function(t,r,o){return Object(a["j"])(t)?t(r):Object(a["l"])(t)?Object.keys(t).every(function(n){return e.patterns[n].test(r,t[n],o)}):null}},{key:"patterns",get:function(){return {dailyInterval:{test:function(e,t,r){return r.diffInDays(r.start||new Date,e.date)%t===0}},weeklyInterval:{test:function(e,t,r){return r.diffInWeeks(r.start||new Date,e.date)%t===0}},monthlyInterval:{test:function(e,t,r){return r.diffInMonths(r.start||new Date,e.date)%t===0}},yearlyInterval:{test:function(){return function(e,t,r){return r.diffInYears(r.start||new Date,e.date)%t===0}}},days:{validate:function(e){return Object(a["h"])(e)?e:[parseInt(e,10)]},test:function(e,t){return t.includes(e.day)||t.includes(-e.dayFromEnd)}},weekdays:{validate:function(e){return Object(a["h"])(e)?e:[parseInt(e,10)]},test:function(e,t){return t.includes(e.weekday)}},ordinalWeekdays:{validate:function(e){return Object.keys(e).reduce(function(t,r){var o=e[r];return o?(t[r]=Object(a["h"])(o)?o:[parseInt(o,10)],t):t},{})},test:function(e,t){return Object.keys(t).map(function(e){return parseInt(e,10)}).find(function(r){return t[r].includes(e.weekday)&&(r===e.weekdayOrdinal||r===-e.weekdayOrdinalFromEnd)})}},weekends:{validate:function(e){return e},test:function(e){return 1===e.weekday||7===e.weekday}},workweek:{validate:function(e){return e},test:function(e){return e.weekday>=2&&e.weekday<=6}},weeks:{validate:function(e){return Object(a["h"])(e)?e:[parseInt(e,10)]},test:function(e,t){return t.includes(e.week)||t.includes(-e.weekFromEnd)}},months:{validate:function(e){return Object(a["h"])(e)?e:[parseInt(e,10)]},test:function(e,t){return t.includes(e.month)}},years:{validate:function(e){return Object(a["h"])(e)?e:[parseInt(e,10)]},test:function(e,t){return t.includes(e.year)}}}}},{key:"patternProps",get:function(){return Object.keys(e.patterns).map(function(t){return {name:t,validate:e.patterns[t].validate}})}}]),e}();},d02c:function(e,t,r){var o=r("5e2e"),n=r("79bc"),c=r("7b83"),i=200;function a(e,t){var r=this.__data__;if(r instanceof o){var a=r.__data__;if(!n||a.length<i-1)return a.push([e,t]),this.size=++r.size,this;r=this.__data__=new c(a);}return r.set(e,t),this.size=r.size,this}e.exports=a;},d094:function(e,t){var r="\\ud800-\\udfff",o="\\u0300-\\u036f",n="\\ufe20-\\ufe2f",c="\\u20d0-\\u20ff",i=o+n+c,a="\\ufe0e\\ufe0f",s="["+r+"]",u="["+i+"]",d="\\ud83c[\\udffb-\\udfff]",l="(?:"+u+"|"+d+")",f="[^"+r+"]",v="(?:\\ud83c[\\udde6-\\uddff]){2}",b="[\\ud800-\\udbff][\\udc00-\\udfff]",h="\\u200d",p=l+"?",g="["+a+"]?",y="(?:"+h+"(?:"+[f,v,b].join("|")+")"+g+p+")*",m=g+p+y,x="(?:"+[f+u+"?",u,v,b,s].join("|")+")",w=RegExp(d+"(?="+d+")|"+x+m,"g");function k(e){return e.match(w)||[]}e.exports=k;},d194:function(e,t,r){var o=r("c32f"),n=r("aaec"),c=r("126d"),i=r("76dd");function a(e){return function(t){t=i(t);var r=n(t)?c(t):void 0,a=r?r[0]:t.charAt(0),s=r?o(r,1).join(""):t.slice(1);return a[e]()+s}}e.exports=a;},d225:function(e,t,r){function o(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}r.d(t,"a",function(){return o});},d2c8:function(e,t,r){var o=r("aae3"),n=r("be13");e.exports=function(e,t,r){if(o(t))throw TypeError("String#"+r+" doesn't accept regex!");return String(n(e))};},d2d5:function(e,t,r){r("1654"),r("549b"),e.exports=r("584a").Array.from;},d327:function(e,t){function r(){return []}e.exports=r;},d370:function(e,t,r){var o=r("253c"),n=r("1310"),c=Object.prototype,i=c.hasOwnProperty,a=c.propertyIsEnumerable,s=o(function(){return arguments}())?o:function(e){return n(e)&&i.call(e,"callee")&&!a.call(e,"callee")};e.exports=s;},d3f4:function(e,t){e.exports=function(e){return "object"===typeof e?null!==e:"function"===typeof e};},d53b:function(e,t){e.exports=function(e,t){return {value:t,done:!!e}};},d612:function(e,t,r){var o=r("7b83"),n=r("7ed2"),c=r("dc0f");function i(e){var t=-1,r=null==e?0:e.length;this.__data__=new o;while(++t<r)this.add(e[t]);}i.prototype.add=i.prototype.push=n,i.prototype.has=c,e.exports=i;},d7ee:function(e,t,r){var o=r("c3fc"),n=r("b047"),c=r("99d3"),i=c&&c.isSet,a=i?n(i):o;e.exports=a;},d864:function(e,t,r){var o=r("79aa");e.exports=function(e,t,r){if(o(e),void 0===t)return e;switch(r){case 1:return function(r){return e.call(t,r)};case 2:return function(r,o){return e.call(t,r,o)};case 3:return function(r,o,n){return e.call(t,r,o,n)}}return function(){return e.apply(t,arguments)}};},d8e8:function(e,t){e.exports=function(e){if("function"!=typeof e)throw TypeError(e+" is not a function!");return e};},d9a8:function(e,t){function r(e){return e!==e}e.exports=r;},d9f6:function(e,t,r){var o=r("e4ae"),n=r("794b"),c=r("1bc3"),i=Object.defineProperty;t.f=r("8e60")?Object.defineProperty:function(e,t,r){if(o(e),t=c(t,!0),o(r),n)try{return i(e,t,r)}catch(a){}if("get"in r||"set"in r)throw TypeError("Accessors not supported!");return "value"in r&&(e[t]=r.value),e};},da03:function(e,t,r){var o=r("2b3e"),n=o["__core-js_shared__"];e.exports=n;},dbdb:function(e,t,r){var o=r("584a"),n=r("e53d"),c="__core-js_shared__",i=n[c]||(n[c]={});(e.exports=function(e,t){return i[e]||(i[e]=void 0!==t?t:{})})("versions",[]).push({version:o.version,mode:r("b8e3")?"pure":"global",copyright:"© 2019 Denis Pushkarev (zloirock.ru)"});},dc0f:function(e,t){function r(e){return this.__data__.has(e)}e.exports=r;},dc57:function(e,t){var r=Function.prototype,o=r.toString;function n(e){if(null!=e){try{return o.call(e)}catch(t){}try{return e+""}catch(t){}}return ""}e.exports=n;},dcbc:function(e,t,r){var o=r("2aba");e.exports=function(e,t,r){for(var n in t)o(e,n,t[n],r);return e};},dcbe:function(e,t,r){var o=r("30c9"),n=r("1310");function c(e){return n(e)&&o(e)}e.exports=c;},dd61:function(e,t,r){var o=r("7948"),n=r("badf"),c=r("97d3"),i=r("6747");function a(e,t){var r=i(e)?o:c;return r(e,n(t,3))}e.exports=a;},ddc6:function(e,t){function r(e){return function(t){return null==e?void 0:e[t]}}e.exports=r;},de5e:function(e,t,r){var o=r("c603"),n=r.n(o);n.a;},e031:function(e,t,r){var o=r("f909"),n=r("1a8c");function c(e,t,r,i,a,s){return n(e)&&n(t)&&(s.set(t,e),o(e,t,void 0,c,s),s["delete"](t)),e}e.exports=c;},e0a0:function(e,t,r){r("6762"),r("2fdb"),r("c5f6");var o,n,c=r("2fa3"),i={props:{id:{type:String,default:"default"},element:null,args:null,visibility:{type:String,default:"hover-focus",validator:function(e){return -1!==["hover-focus","hover","focus","click","visible","hidden"].indexOf(e)}},placement:{type:String,default:"bottom"},isInteractive:Boolean,showDelay:{type:Number,default:10},hideDelay:{type:Number,default:150}},data:function(){return {reference:null,isHovered:!1,isFocused:!1}},computed:{isActive:function(){return this.$vc.activeRefs&&this.$vc.activeRefs[this.id]===this.reference}},render:function(){return this.$slots.default[0]},watch:{visibility:function(){this.refreshVisibility();},args:function(){var e=this;this.$nextTick(function(){e.isActive&&e.update();});}},mounted:function(){var e=this;this.reference=this.element||this.$slots.default[0].elm,this.addEvents(),this.$once("beforeDestroy",function(){return e.removeEvents()}),this.refreshVisibility();},methods:{addEvents:function(){Object(c["j"])(this.reference,"click",this.onClick),Object(c["j"])(this.reference,"mouseover",this.onMouseOver),Object(c["j"])(this.reference,"mouseleave",this.onMouseLeave),Object(c["j"])(this.reference,"focusin",this.onFocusIn),Object(c["j"])(this.reference,"focusout",this.onFocusOut);},removeEvents:function(){Object(c["i"])(this.reference,"click",this.onClick),Object(c["i"])(this.reference,"mouseover",this.onMouseOver),Object(c["i"])(this.reference,"mouseleave",this.onMouseLeave),Object(c["i"])(this.reference,"focusin",this.onFocusIn),Object(c["i"])(this.reference,"focusout",this.onFocusOut);},onClick:function(){"click"===this.visibility&&this.toggle();},onMouseOver:function(){this.isHovered||(this.isHovered=!0,this.visibility.includes("hover")&&this.refreshVisibility());},onMouseLeave:function(){this.isHovered&&(this.isHovered=!1,("hover"===this.visibility||"hover-focus"===this.visibility&&!this.isFocused)&&this.refreshVisibility());},onFocusIn:function(){this.isFocused||(this.isFocused=!0,this.visibility.includes("focus")&&this.refreshVisibility());},onFocusOut:function(e){this.isFocused&&!Object(c["e"])(this.reference,e.relatedTarget)&&(this.isFocused=!1,this.visibility.includes("focus")&&this.refreshVisibility());},refreshVisibility:function(){switch(this.visibility){case"hover":this.isHovered?this.show():this.isActive&&this.hide();break;case"focus":this.isFocused?this.show():this.isActive&&this.hide();break;case"hover-focus":this.isHovered||this.isFocused?this.show({visibility:this.isFocused?"focus":"hover"}):this.isActive&&this.hide();break;case"visible":this.show();break;case"hidden":this.isActive&&this.hide();break}},toggle:function(){var e=this;this.isActive?this.hide():this.$nextTick(function(){e.show();});},show:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.visibility;this.$vc.$emit("show:".concat(this.id),{ref:this.reference,args:this.args,visibility:t||this.visibility,placement:this.placement,isInteractive:this.isInteractive,delay:this.showDelay});},hide:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.delay,r=void 0===t?this.hideDelay:t;this.$vc.$emit("hide:".concat(this.id),{ref:this.reference,delay:r});},update:function(){this.$vc.$emit("update:".concat(this.id),{ref:this.reference,args:this.args});}}},a=i,s=r("2877"),u=Object(s["a"])(a,o,n,!1,null,null,null);t["a"]=u.exports;},e0b8:function(e,t,r){var o=r("7726"),n=r("5ca1"),c=r("2aba"),i=r("dcbc"),a=r("67ab"),s=r("4a59"),u=r("f605"),d=r("d3f4"),l=r("79e5"),f=r("5cc5"),v=r("7f20"),b=r("5dbc");e.exports=function(e,t,r,h,p,g){var y=o[e],m=y,x=p?"set":"add",w=m&&m.prototype,k={},O=function(e){var t=w[e];c(w,e,"delete"==e?function(e){return !(g&&!d(e))&&t.call(this,0===e?0:e)}:"has"==e?function(e){return !(g&&!d(e))&&t.call(this,0===e?0:e)}:"get"==e?function(e){return g&&!d(e)?void 0:t.call(this,0===e?0:e)}:"add"==e?function(e){return t.call(this,0===e?0:e),this}:function(e,r){return t.call(this,0===e?0:e,r),this});};if("function"==typeof m&&(g||w.forEach&&!l(function(){(new m).entries().next();}))){var j=new m,D=j[x](g?{}:-0,1)!=j,_=l(function(){j.has(1);}),P=f(function(e){new m(e);}),M=!g&&l(function(){var e=new m,t=5;while(t--)e[x](t,t);return !e.has(-0)});P||(m=t(function(t,r){u(t,m,e);var o=b(new y,t,m);return void 0!=r&&s(r,p,o[x],o),o}),m.prototype=w,w.constructor=m),(_||M)&&(O("delete"),O("has"),p&&O("get")),(M||D)&&O(x),g&&w.clear&&delete w.clear;}else m=h.getConstructor(t,e,p,x),i(m.prototype,r),a.NEED=!0;return v(m,e),k[e]=m,n(n.G+n.W+n.F*(m!=y),k),g||h.setStrong(m,e,p),m};},e0e7:function(e,t,r){var o=r("60ed");function n(e){return o(e)?void 0:e}e.exports=n;},e11e:function(e,t){e.exports="constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");},e24b:function(e,t,r){var o=r("49f4"),n=r("1efc"),c=r("bbc0"),i=r("7a48"),a=r("2524");function s(e){var t=-1,r=null==e?0:e.length;this.clear();while(++t<r){var o=e[t];this.set(o[0],o[1]);}}s.prototype.clear=o,s.prototype["delete"]=n,s.prototype.get=c,s.prototype.has=i,s.prototype.set=a,e.exports=s;},e2a0:function(e,t,r){var o=r("3729"),n=r("6747"),c=r("1310"),i="[object String]";function a(e){return "string"==typeof e||!n(e)&&c(e)&&o(e)==i}e.exports=a;},e2c0:function(e,t,r){var o=r("e2e4"),n=r("d370"),c=r("6747"),i=r("c098"),a=r("b218"),s=r("f4d6");function u(e,t,r){t=o(t,e);var u=-1,d=t.length,l=!1;while(++u<d){var f=s(t[u]);if(!(l=null!=e&&r(e,f)))break;e=e[f];}return l||++u!=d?l:(d=null==e?0:e.length,!!d&&a(d)&&i(f,d)&&(c(e)||n(e)))}e.exports=u;},e2e4:function(e,t,r){var o=r("6747"),n=r("f608"),c=r("18d8"),i=r("76dd");function a(e,t){return o(e)?e:n(e,t)?[e]:c(i(e))}e.exports=a;},e380:function(e,t,r){var o=r("7b83"),n="Expected a function";function c(e,t){if("function"!=typeof e||null!=t&&"function"!=typeof t)throw new TypeError(n);var r=function(){var o=arguments,n=t?t.apply(this,o):o[0],c=r.cache;if(c.has(n))return c.get(n);var i=e.apply(this,o);return r.cache=c.set(n,i)||c,i};return r.cache=new(c.Cache||o),r}c.Cache=o,e.exports=c;},e3f8:function(e,t,r){var o=r("656b");function n(e){return function(t){return o(t,e)}}e.exports=n;},e4ae:function(e,t,r){var o=r("f772");e.exports=function(e){if(!o(e))throw TypeError(e+" is not an object!");return e};},e538:function(e,t,r){(function(e){var o=r("2b3e"),n=t&&!t.nodeType&&t,c=n&&"object"==typeof e&&e&&!e.nodeType&&e,i=c&&c.exports===n,a=i?o.Buffer:void 0,s=a?a.allocUnsafe:void 0;function u(e,t){if(t)return e.slice();var r=e.length,o=s?s(r):new e.constructor(r);return e.copy(o),o}e.exports=u;}).call(this,r("62e4")(e));},e53d:function(e,t){var r=e.exports="undefined"!=typeof window&&window.Math==Math?window:"undefined"!=typeof self&&self.Math==Math?self:Function("return this")();"number"==typeof __g&&(__g=r);},e6f3:function(e,t,r){var o=r("07e3"),n=r("36c3"),c=r("5b4e")(!1),i=r("5559")("IE_PROTO");e.exports=function(e,t){var r,a=n(e),s=0,u=[];for(r in a)r!=i&&o(a,r)&&u.push(r);while(t.length>s)o(a,r=t[s++])&&(~c(u,r)||u.push(r));return u};},e853:function(e,t,r){var o=r("d3f4"),n=r("1169"),c=r("2b4c")("species");e.exports=function(e){var t;return n(e)&&(t=e.constructor,"function"!=typeof t||t!==Array&&!n(t.prototype)||(t=void 0),o(t)&&(t=t[c],null===t&&(t=void 0))),void 0===t?Array:t};},e94a:function(e,t,r){r("8e6e"),r("ac6a"),r("cadf"),r("456d");var o=r("75fc"),n=(r("c5f6"),r("bd86")),c=r("c192"),i=r("cc8d"),a=r("e0a0"),s=r("d225"),u=r("b0b4"),d=r("2fa3"),l=r("9404"),f=function(){function e(t){var r=t.format,o=t.parse;Object(s["a"])(this,e),this._format=r,this._parse=o;}return Object(u["a"])(e,[{key:"hasValue",value:function(e){return Object(l["i"])(e)}},{key:"format",value:function(e){return this.hasValue(e)?this._format(e):""}},{key:"parse",value:function(e){var t=this._parse(e);return Object(l["i"])(t)?t:null}},{key:"normalize",value:function(e){return e&&new Date(e)}},{key:"filterDisabled",value:function(e){var t=e.value,r=e.isRequired,o=e.disabled,n=e.fallbackValue;return !this.hasValue(t)&&r?n:this.hasValue(t)&&o&&o.intersectsDate(t)?null:t}},{key:"valuesAreEqual",value:function(e,t){return Object(d["d"])(e,t)}},{key:"getPageRange",value:function(e){if(!this.hasValue(e))return null;var t=Object(d["l"])(e);return {from:t,to:t}}},{key:"handleDayClick",value:function(e,t){t.dateIsValid(e.date)&&(this.valuesAreEqual(e.date,t.value_)?t.isRequired||(t.value_=null):(t.doFormatInput=!0,t.doHidePopover=!0,t.value_=e.date));}},{key:"handleDayMouseEnter",value:function(){}}]),e}(),v=(r("6762"),r("2fdb"),r("28a5"),function(){function e(t){var r=t.format,o=t.parse;Object(s["a"])(this,e),this._format=r,this._parse=o;}return Object(u["a"])(e,[{key:"hasValue",value:function(e){return Object(d["b"])(e)}},{key:"format",value:function(e){var t=this;return this.hasValue(e)?e.map(function(e){return t._format(e)}).join(", "):""}},{key:"parse",value:function(e){var t=this;return Object(l["m"])(e)?e.split(",").map(function(e){return t._parse(e)}).filter(function(e){return Object(l["i"])(e)}):[]}},{key:"normalize",value:function(e){return this.hasValue(e)?Object(l["v"])(e).sort(function(e,t){return e.getTime()-t.getTime()}):[]}},{key:"filterDisabled",value:function(e){var t=e.value,r=e.isRequired,o=e.disabled,n=e.fallbackValue;if(!this.hasValue(t))return [];if(!o)return t;var c=t.filter(function(e){return !o.intersectsDate(e)});return !this.hasValue(c)&&r?n:c}},{key:"valuesAreEqual",value:function(e,t){var r=this.hasValue(e),o=this.hasValue(t);return !r&&!o||r===o&&e.length===t.length&&(!e.some(function(e){return !t.includes(e)})&&!t.some(function(t){return !e.includes(t)}))}},{key:"getPageRange",value:function(e){if(!this.hasValue(e))return null;var t=Object(d["l"])(e[0]),r=Object(d["f"])(Object(d["l"])(Object(l["o"])(e)),Object(d["a"])(t,1));return {from:t,to:r}}},{key:"handleDayClick",value:function(e,t){if(t.dateIsValid(e.date)){var r=[];this.hasValue(t.value_)?t.value_.some(function(t){return t.getTime()===e.dateTime})?(r=t.value_.filter(function(t){return !Object(d["d"])(t,e.date)}),!this.hasValue(r)&&t.isRequired&&(r=[e.date])):r=[].concat(Object(o["a"])(t.value_),[e.date]):r=[e.date],this.doFormatInput=!0,this.doHidePopover=!1,t.value_=this.normalize(r);}}},{key:"handleDayMouseEnter",value:function(){}}]),e}()),b=r("cfe5"),h=function(){function e(t){var r=t.locale,o=t.format,n=t.parse;Object(s["a"])(this,e),this._locale=r,this._format=o,this._parse=n;}return Object(u["a"])(e,[{key:"hasValue",value:function(e){return Object(l["l"])(e)&&Object(l["i"])(e.start)&&Object(l["i"])(e.end)}},{key:"normalize",value:function(e){if(!this.hasValue(e))return null;var t=new b["d"]({start:new Date(e.start),end:new Date(e.end)},{locale:this._locale}),r=t.start,o=t.end;return {start:r,end:o}}},{key:"format",value:function(e){var t=this.normalize(e);if(!t)return "";var r=t.start,o=t.end,n=this._format(r),c=this._format(o);return n&&c?"".concat(n," - ").concat(c):""}},{key:"parse",value:function(e){var t,r,o=e.split("-").map(function(e){return e.trim()});return o.length>=2&&(t=this._parse(o[0]),r=this._parse(o[1])),t&&r?this.normalize({start:t,end:r}):null}},{key:"filterDisabled",value:function(e){var t=e.value,r=e.isRequired,o=e.disabled,n=e.fallbackValue,c=r?n:null;return !this.hasValue(t)||o&&o.intersectsDate(t)||(c=t),c}},{key:"valuesAreEqual",value:function(e,t){var r=this.hasValue(e),o=this.hasValue(t);return !r&&!o||r===o&&(Object(d["d"])(e.start,t.start)&&Object(d["d"])(e.end,t.end))}},{key:"getPageRange",value:function(e){if(!this.hasValue(e))return null;var t=Object(d["l"])(e.start),r=Object(d["f"])(Object(d["l"])(e.end),Object(d["a"])(t,1));return {from:t,to:r}}},{key:"handleDayClick",value:function(e,t){var r=e.dateTime;if(t.dragValue){var o=this.normalize({start:new Date(t.dragValue.start.getTime()),end:new Date(r)});t.dateIsValid(o)&&(t.doFormatInput=!0,t.doHidePopover=!0,t.dragValue=null,t.value_=o);}else {var n={start:new Date(r),end:new Date(r)};t.dateIsValid(n)&&(t.dragValue=n);}}},{key:"handleDayMouseEnter",value:function(e,t){var r=e.dateTime;if(t.dragValue){var o={start:new Date(t.dragValue.start.getTime()),end:new Date(r)};t.dateIsValid(o)&&(t.dragValue=o);}}}]),e}(),p=r("19cf"),g=r("0733");function y(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter(function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable})),r.push.apply(r,o);}return r}function m(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?y(r,!0).forEach(function(t){Object(n["a"])(e,t,r[t]);}):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):y(r).forEach(function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t));});}return e}var x,w,k={name:"VDatePicker",render:function(e){var t=this,r=function(){return e(c["a"],{attrs:m({},t.$attrs,{attributes:t.attributes_,theme:t.theme_,locale:t.locale_}),props:{},on:m({},t.$listeners,{dayclick:t.onDayClick,daymouseenter:t.onDayMouseEnter,daykeydown:t.onDayKeydown,dayfocusin:t.onDayFocusIn}),scopedSlots:t.$scopedSlots,ref:"calendar"})};if(this.isInline)return r();var o=this.safeScopedSlot("default",{inputClass:this.inputClass,inputProps:this.inputProps_,inputEvents:this.inputEvents,isDragging:!!this.dragValue,updateValue:this.updateValue,hidePopover:this.hidePopover})||e("input",{class:this.inputClass,attrs:this.inputProps_,on:this.inputEvents}),n=this.popover_,s=n.visibility,u=n.placement;return e("span",{class:"vc-reset"},[e(a["a"],{props:{id:this.datePickerPopoverId,visibility:s,placement:u,isInteractive:!0}},[o]),e(i["a"],{props:{id:this.datePickerPopoverId,placement:"bottom-start",contentClass:this.theme_.container},scopedSlots:{default:function(){return r()}},ref:"popover"})])},mixins:[p["c"],p["b"],p["d"]],props:{mode:{type:String,default:"single"},value:{type:null,required:!0},isRequired:Boolean,isInline:Boolean,updateOnInput:Boolean,inputDebounce:Number,inputProps:{type:Object,default:function(){return {}}},popover:{type:Object,default:function(){return {}}},dragAttribute:Object,selectAttribute:Object,attributes:Array},data:function(){return {value_:null,dragValue:null,inputValue:"",doFormatInput:!0,doHidePopover:!1,doAdjustPageRange:!1,updateTimeout:null,datePickerPopoverId:Object(d["c"])()}},computed:{updateOnInput_:function(){return this.propOrDefault("updateOnInput","datePicker.updateOnInput")},inputDebounce_:function(){return this.propOrDefault("inputDebounce","datePicker.inputDebounce")},inputMasks:function(){var e=this.locale_.masks.input;return Object(l["h"])(e)&&e||[e]},inputClass:function(){var e=this.inputProps.class||this.theme_.datePickerInput,t=this.inputProps.dragClass||this.theme_.datePickerInputDrag;return this.picker.hasValue(this.dragValue)&&t||e},inputProps_:function(){var e=m({},this.inputProps,{value:this.inputValue,type:"input"});return delete e.class,delete e.dragClass,e},inputEvents:function(){return {input:this.inputInput,change:this.inputChange,keyup:this.inputKeyup}},popover_:function(){return this.propOrDefault("popover","datePicker.popover","merge")},canHidePopover:function(){return !(this.popover.keepVisibleOnInput||"visible"!==this.popover_.visibility)},selectAttribute_:function(){if(!this.picker.hasValue(this.value_))return null;var e=m({key:"select-drag"},this.selectAttribute,{dates:this.value_,pinPage:!0}),t=e.dot,r=e.bar,o=e.highlight,n=e.content;return t||r||o||n||(e.highlight=!0),e},dragAttribute_:function(){if("range"!==this.mode||!this.picker.hasValue(this.dragValue))return null;var e=m({key:"select-drag"},this.dragAttribute,{dates:this.dragValue}),t=e.dot,r=e.bar,o=e.highlight,n=e.content;return t||r||o||n||(e.highlight={startEnd:{fillMode:"none"}}),e},attributes_:function(){var e=Object(l["h"])(this.attributes)?Object(o["a"])(this.attributes):[];return this.dragAttribute_?e.push(this.dragAttribute_):this.selectAttribute_&&e.push(this.selectAttribute_),e},picker:function(){var e=this,t={locale:this.locale_,format:function(t){return e.locale_.format(t,e.inputMasks[0])},parse:function(t){return e.locale_.parse(t,e.inputMasks)}};switch(this.mode){case"multiple":return new v(t);case"range":return new h(t);default:return new f(t)}}},watch:{mode:function(){this.value_=null;},value:function(){this.refreshValue();},value_:function(e){this.$emit("input",e),this.handleValueChange();},dragValue:function(e){this.formatInput(),this.$emit("drag",this.picker.normalize(e));}},created:function(){this.refreshValue();},mounted:function(){var e=this;Object(d["j"])(document,"keydown",this.onDocumentKeyDown);var t=Object(g["b"])(document,function(t){document.body.contains(t.target)&&!Object(d["e"])(e.$el,t.target)&&e.dragValue&&(e.dragValue=null);});this.$once("beforeDestroy",function(){Object(d["i"])(document,"keydown",e.onDocumentKeyDown),t();});},methods:{refreshValue:function(){this.picker.valuesAreEqual(this.value,this.value_)||(this.value_=this.value);},dateIsValid:function(e){var t=this.$refs.calendar.disabledAttribute;return !!t&&!t.intersectsDate(e)},onDocumentKeyDown:function(e){this.dragValue&&27===e.keyCode&&(this.dragValue=null);},onDayClick:function(e){this.picker.handleDayClick(e,this),this.$emit("dayclick",e);},onDayMouseEnter:function(e){this.picker.handleDayMouseEnter(e,this),this.$emit("daymouseenter",e);},onDayFocusIn:function(e){this.picker.handleDayMouseEnter(e,this),this.$emit("dayfocusin",e);},onDayKeydown:function(e){switch(e.event.key){case" ":case"Enter":this.picker.handleDayClick(e,this),e.event.preventDefault();break;case"Escape":this.hidePopover();}this.$emit("daykeydown",e);},inputInput:function(e){this.inputValue=e.target.value,this.updateOnInput_&&this.updateValue(this.inputValue,{formatInput:!1,hidePopover:!1,adjustPageRange:!0,debounce:this.inputDebounce_});},inputChange:function(){this.updateValue(this.inputValue,{formatInput:!0,hidePopover:!1,adjustPageRange:!1});},inputKeyup:function(e){27===e.keyCode&&this.updateValue(this.value_,{formatInput:!0,hidePopover:!0,adjustPageRange:!1});},updateValue:function(){var e=this,t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.inputValue,r=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},o=r.formatInput,n=r.hidePopover,c=r.adjustPageRange,i=r.debounce;clearTimeout(this.updateTimeout),void 0===i||i<0?this.forceUpdateValue(t,{formatInput:o,hidePopover:n,adjustPageRange:c}):this.updateTimeout=setTimeout(function(){e.updateTimeout=null,e.forceUpdateValue(t,{formatInput:o,hidePopover:n,adjustPageRange:c});},i);},forceUpdateValue:function(e,t){var r=t.formatInput,o=t.hidePopover,n=t.adjustPageRange;this.inputValue=Object(l["m"])(e)?e:this.inputValue;var c=Object(l["m"])(e)?this.picker.parse(e):e,i=this.picker.filterDisabled({value:this.picker.normalize(c),fallbackValue:this.value_});this.doFormatInput=r,this.doHidePopover=o,this.doAdjustPageRange=n,this.picker.valuesAreEqual(this.value_,i)?this.handleValueChange():this.value_=i;},handleValueChange:function(){this.isInline||(this.doFormatInput&&this.formatInput(),this.doHidePopover&&this.hidePopover(),this.doAdjustPageRange&&this.adjustPageRange()),this.doFormatInput=!0,this.doHidePopover=!1,this.doAdjustPageRange=!1;},formatInput:function(){var e=this;this.$nextTick(function(){var t=e.picker.hasValue(e.dragValue)?e.dragValue:e.value_;e.inputValue=e.picker.format(t);});},hidePopover:function(){var e=this.$refs.popover;e&&e.onHide({ref:e.ref,delay:400});},adjustPageRange:function(){this.picker.hasValue(this.value_)&&this.$refs.calendar&&this.$refs.calendar.showPageRange(this.picker.getPageRange(this.value_));}}},O=k,j=(r("93d6"),r("2877")),D=Object(j["a"])(O,x,w,!1,null,"2e61d7e7",null);t["a"]=D.exports;},e9a7:function(e,t,r){var o=r("76dd"),n=r("8103");function c(e){return n(o(e).toLowerCase())}e.exports=c;},ea72:function(e,t,r){var o=r("7559"),n=r("7e8e"),c=r("76dd"),i=r("f4d9");function a(e,t,r){return e=c(e),t=r?void 0:t,void 0===t?n(e)?i(e):o(e):e.match(t)||[]}e.exports=a;},eac5:function(e,t){var r=Object.prototype;function o(e){var t=e&&e.constructor,o="function"==typeof t&&t.prototype||r;return e===o}e.exports=o;},ebd6:function(e,t,r){var o=r("cb7c"),n=r("d8e8"),c=r("2b4c")("species");e.exports=function(e,t){var r,i=o(e).constructor;return void 0===i||void 0==(r=o(i)[c])?t:n(r)};},ec47:function(e,t,r){var o=r("a3fd"),n=r("42a2"),c=r("edfa"),i=r("cebd"),a="[object Map]",s="[object Set]";function u(e){return function(t){var r=n(t);return r==a?c(t):r==s?i(t):o(t,e(t))}}e.exports=u;},ec69:function(e,t,r){var o=r("6fcd"),n=r("03dd"),c=r("30c9");function i(e){return c(e)?o(e):n(e)}e.exports=i;},ec8c:function(e,t){function r(e){var t=[];if(null!=e)for(var r in Object(e))t.push(r);return t}e.exports=r;},edfa:function(e,t){function r(e){var t=-1,r=Array(e.size);return e.forEach(function(e,o){r[++t]=[o,e];}),r}e.exports=r;},ee59:function(e,t,r){t=e.exports=r("2350")(!1),t.push([e.i,".none-enter-active[data-v-5be4b00c],.none-leave-active[data-v-5be4b00c]{transition-duration:0s}.fade-enter-active[data-v-5be4b00c],.fade-leave-active[data-v-5be4b00c],.slide-down-enter-active[data-v-5be4b00c],.slide-down-leave-active[data-v-5be4b00c],.slide-left-enter-active[data-v-5be4b00c],.slide-left-leave-active[data-v-5be4b00c],.slide-right-enter-active[data-v-5be4b00c],.slide-right-leave-active[data-v-5be4b00c],.slide-up-enter-active[data-v-5be4b00c],.slide-up-leave-active[data-v-5be4b00c]{transition:transform var(--slide-duration) var(--slide-timing),opacity var(--slide-duration) var(--slide-timing);-webkit-backface-visibility:hidden;backface-visibility:hidden}.fade-leave-active[data-v-5be4b00c],.none-leave-active[data-v-5be4b00c],.slide-down-leave-active[data-v-5be4b00c],.slide-left-leave-active[data-v-5be4b00c],.slide-right-leave-active[data-v-5be4b00c],.slide-up-leave-active[data-v-5be4b00c]{position:absolute;width:100%}.fade-enter[data-v-5be4b00c],.fade-leave-to[data-v-5be4b00c],.none-enter[data-v-5be4b00c],.none-leave-to[data-v-5be4b00c],.slide-down-enter[data-v-5be4b00c],.slide-down-leave-to[data-v-5be4b00c],.slide-left-enter[data-v-5be4b00c],.slide-left-leave-to[data-v-5be4b00c],.slide-right-enter[data-v-5be4b00c],.slide-right-leave-to[data-v-5be4b00c],.slide-up-enter[data-v-5be4b00c],.slide-up-leave-to[data-v-5be4b00c]{opacity:0}.slide-left-enter[data-v-5be4b00c],.slide-right-leave-to[data-v-5be4b00c]{transform:translateX(var(--slide-translate))}.slide-left-leave-to[data-v-5be4b00c],.slide-right-enter[data-v-5be4b00c]{transform:translateX(calc(-1*var(--slide-translate)))}.slide-down-leave-to[data-v-5be4b00c],.slide-up-enter[data-v-5be4b00c]{transform:translateY(var(--slide-translate))}.slide-down-enter[data-v-5be4b00c],.slide-up-leave-to[data-v-5be4b00c]{transform:translateY(calc(-1*var(--slide-translate)))}",""]);},eed6:function(e,t,r){var o=r("2c66");function n(e){return e&&e.length?o(e):[]}e.exports=n;},ef5d:function(e,t){function r(e){return function(t){return null==t?void 0:t[e]}}e.exports=r;},efb6:function(e,t,r){var o=r("5e2e");function n(){this.__data__=new o,this.size=0;}e.exports=n;},f0bd:function(e,t,r){(function(e){for(
/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.15.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var r="undefined"!==typeof window&&"undefined"!==typeof document,o=["Edge","Trident","Firefox"],n=0,c=0;c<o.length;c+=1)if(r&&navigator.userAgent.indexOf(o[c])>=0){n=1;break}function i(e){var t=!1;return function(){t||(t=!0,window.Promise.resolve().then(function(){t=!1,e();}));}}function a(e){var t=!1;return function(){t||(t=!0,setTimeout(function(){t=!1,e();},n));}}var s=r&&window.Promise,u=s?i:a;function d(e){var t={};return e&&"[object Function]"===t.toString.call(e)}function l(e,t){if(1!==e.nodeType)return [];var r=e.ownerDocument.defaultView,o=r.getComputedStyle(e,null);return t?o[t]:o}function f(e){return "HTML"===e.nodeName?e:e.parentNode||e.host}function v(e){if(!e)return document.body;switch(e.nodeName){case"HTML":case"BODY":return e.ownerDocument.body;case"#document":return e.body}var t=l(e),r=t.overflow,o=t.overflowX,n=t.overflowY;return /(auto|scroll|overlay)/.test(r+n+o)?e:v(f(e))}var b=r&&!(!window.MSInputMethodContext||!document.documentMode),h=r&&/MSIE 10/.test(navigator.userAgent);function p(e){return 11===e?b:10===e?h:b||h}function g(e){if(!e)return document.documentElement;var t=p(10)?document.body:null,r=e.offsetParent||null;while(r===t&&e.nextElementSibling)r=(e=e.nextElementSibling).offsetParent;var o=r&&r.nodeName;return o&&"BODY"!==o&&"HTML"!==o?-1!==["TH","TD","TABLE"].indexOf(r.nodeName)&&"static"===l(r,"position")?g(r):r:e?e.ownerDocument.documentElement:document.documentElement}function y(e){var t=e.nodeName;return "BODY"!==t&&("HTML"===t||g(e.firstElementChild)===e)}function m(e){return null!==e.parentNode?m(e.parentNode):e}function x(e,t){if(!e||!e.nodeType||!t||!t.nodeType)return document.documentElement;var r=e.compareDocumentPosition(t)&Node.DOCUMENT_POSITION_FOLLOWING,o=r?e:t,n=r?t:e,c=document.createRange();c.setStart(o,0),c.setEnd(n,0);var i=c.commonAncestorContainer;if(e!==i&&t!==i||o.contains(n))return y(i)?i:g(i);var a=m(e);return a.host?x(a.host,t):x(e,m(t).host)}function w(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"top",r="top"===t?"scrollTop":"scrollLeft",o=e.nodeName;if("BODY"===o||"HTML"===o){var n=e.ownerDocument.documentElement,c=e.ownerDocument.scrollingElement||n;return c[r]}return e[r]}function k(e,t){var r=arguments.length>2&&void 0!==arguments[2]&&arguments[2],o=w(t,"top"),n=w(t,"left"),c=r?-1:1;return e.top+=o*c,e.bottom+=o*c,e.left+=n*c,e.right+=n*c,e}function O(e,t){var r="x"===t?"Left":"Top",o="Left"===r?"Right":"Bottom";return parseFloat(e["border"+r+"Width"],10)+parseFloat(e["border"+o+"Width"],10)}function j(e,t,r,o){return Math.max(t["offset"+e],t["scroll"+e],r["client"+e],r["offset"+e],r["scroll"+e],p(10)?parseInt(r["offset"+e])+parseInt(o["margin"+("Height"===e?"Top":"Left")])+parseInt(o["margin"+("Height"===e?"Bottom":"Right")]):0)}function D(e){var t=e.body,r=e.documentElement,o=p(10)&&getComputedStyle(r);return {height:j("Height",t,r,o),width:j("Width",t,r,o)}}var _=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},P=function(){function e(e,t){for(var r=0;r<t.length;r++){var o=t[r];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o);}}return function(t,r,o){return r&&e(t.prototype,r),o&&e(t,o),t}}(),M=function(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e},S=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o]);}return e};function E(e){return S({},e,{right:e.left+e.width,bottom:e.top+e.height})}function C(e){var t={};try{if(p(10)){t=e.getBoundingClientRect();var r=w(e,"top"),o=w(e,"left");t.top+=r,t.left+=o,t.bottom+=r,t.right+=o;}else t=e.getBoundingClientRect();}catch(f){}var n={left:t.left,top:t.top,width:t.right-t.left,height:t.bottom-t.top},c="HTML"===e.nodeName?D(e.ownerDocument):{},i=c.width||e.clientWidth||n.right-n.left,a=c.height||e.clientHeight||n.bottom-n.top,s=e.offsetWidth-i,u=e.offsetHeight-a;if(s||u){var d=l(e);s-=O(d,"x"),u-=O(d,"y"),n.width-=s,n.height-=u;}return E(n)}function I(e,t){var r=arguments.length>2&&void 0!==arguments[2]&&arguments[2],o=p(10),n="HTML"===t.nodeName,c=C(e),i=C(t),a=v(e),s=l(t),u=parseFloat(s.borderTopWidth,10),d=parseFloat(s.borderLeftWidth,10);r&&n&&(i.top=Math.max(i.top,0),i.left=Math.max(i.left,0));var f=E({top:c.top-i.top-u,left:c.left-i.left-d,width:c.width,height:c.height});if(f.marginTop=0,f.marginLeft=0,!o&&n){var b=parseFloat(s.marginTop,10),h=parseFloat(s.marginLeft,10);f.top-=u-b,f.bottom-=u-b,f.left-=d-h,f.right-=d-h,f.marginTop=b,f.marginLeft=h;}return (o&&!r?t.contains(a):t===a&&"BODY"!==a.nodeName)&&(f=k(f,t)),f}function A(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],r=e.ownerDocument.documentElement,o=I(e,r),n=Math.max(r.clientWidth,window.innerWidth||0),c=Math.max(r.clientHeight,window.innerHeight||0),i=t?0:w(r),a=t?0:w(r,"left"),s={top:i-o.top+o.marginTop,left:a-o.left+o.marginLeft,width:n,height:c};return E(s)}function Y(e){var t=e.nodeName;if("BODY"===t||"HTML"===t)return !1;if("fixed"===l(e,"position"))return !0;var r=f(e);return !!r&&Y(r)}function T(e){if(!e||!e.parentElement||p())return document.documentElement;var t=e.parentElement;while(t&&"none"===l(t,"transform"))t=t.parentElement;return t||document.documentElement}function L(e,t,r,o){var n=arguments.length>4&&void 0!==arguments[4]&&arguments[4],c={top:0,left:0},i=n?T(e):x(e,t);if("viewport"===o)c=A(i,n);else {var a=void 0;"scrollParent"===o?(a=v(f(t)),"BODY"===a.nodeName&&(a=e.ownerDocument.documentElement)):a="window"===o?e.ownerDocument.documentElement:o;var s=I(a,i,n);if("HTML"!==a.nodeName||Y(i))c=s;else {var u=D(e.ownerDocument),d=u.height,l=u.width;c.top+=s.top-s.marginTop,c.bottom=d+s.top,c.left+=s.left-s.marginLeft,c.right=l+s.left;}}r=r||0;var b="number"===typeof r;return c.left+=b?r:r.left||0,c.top+=b?r:r.top||0,c.right-=b?r:r.right||0,c.bottom-=b?r:r.bottom||0,c}function F(e){var t=e.width,r=e.height;return t*r}function N(e,t,r,o,n){var c=arguments.length>5&&void 0!==arguments[5]?arguments[5]:0;if(-1===e.indexOf("auto"))return e;var i=L(r,o,c,n),a={top:{width:i.width,height:t.top-i.top},right:{width:i.right-t.right,height:i.height},bottom:{width:i.width,height:i.bottom-t.bottom},left:{width:t.left-i.left,height:i.height}},s=Object.keys(a).map(function(e){return S({key:e},a[e],{area:F(a[e])})}).sort(function(e,t){return t.area-e.area}),u=s.filter(function(e){var t=e.width,o=e.height;return t>=r.clientWidth&&o>=r.clientHeight}),d=u.length>0?u[0].key:s[0].key,l=e.split("-")[1];return d+(l?"-"+l:"")}function z(e,t,r){var o=arguments.length>3&&void 0!==arguments[3]?arguments[3]:null,n=o?T(t):x(t,r);return I(r,n,o)}function $(e){var t=e.ownerDocument.defaultView,r=t.getComputedStyle(e),o=parseFloat(r.marginTop||0)+parseFloat(r.marginBottom||0),n=parseFloat(r.marginLeft||0)+parseFloat(r.marginRight||0),c={width:e.offsetWidth+n,height:e.offsetHeight+o};return c}function R(e){var t={left:"right",right:"left",bottom:"top",top:"bottom"};return e.replace(/left|right|bottom|top/g,function(e){return t[e]})}function V(e,t,r){r=r.split("-")[0];var o=$(e),n={width:o.width,height:o.height},c=-1!==["right","left"].indexOf(r),i=c?"top":"left",a=c?"left":"top",s=c?"height":"width",u=c?"width":"height";return n[i]=t[i]+t[s]/2-o[s]/2,n[a]=r===a?t[a]-o[u]:t[R(a)],n}function W(e,t){return Array.prototype.find?e.find(t):e.filter(t)[0]}function H(e,t,r){if(Array.prototype.findIndex)return e.findIndex(function(e){return e[t]===r});var o=W(e,function(e){return e[t]===r});return e.indexOf(o)}function U(e,t,r){var o=void 0===r?e:e.slice(0,H(e,"name",r));return o.forEach(function(e){e["function"]&&console.warn("`modifier.function` is deprecated, use `modifier.fn`!");var r=e["function"]||e.fn;e.enabled&&d(r)&&(t.offsets.popper=E(t.offsets.popper),t.offsets.reference=E(t.offsets.reference),t=r(t,e));}),t}function B(){if(!this.state.isDestroyed){var e={instance:this,styles:{},arrowStyles:{},attributes:{},flipped:!1,offsets:{}};e.offsets.reference=z(this.state,this.popper,this.reference,this.options.positionFixed),e.placement=N(this.options.placement,e.offsets.reference,this.popper,this.reference,this.options.modifiers.flip.boundariesElement,this.options.modifiers.flip.padding),e.originalPlacement=e.placement,e.positionFixed=this.options.positionFixed,e.offsets.popper=V(this.popper,e.offsets.reference,e.placement),e.offsets.popper.position=this.options.positionFixed?"fixed":"absolute",e=U(this.modifiers,e),this.state.isCreated?this.options.onUpdate(e):(this.state.isCreated=!0,this.options.onCreate(e));}}function G(e,t){return e.some(function(e){var r=e.name,o=e.enabled;return o&&r===t})}function q(e){for(var t=[!1,"ms","Webkit","Moz","O"],r=e.charAt(0).toUpperCase()+e.slice(1),o=0;o<t.length;o++){var n=t[o],c=n?""+n+r:e;if("undefined"!==typeof document.body.style[c])return c}return null}function K(){return this.state.isDestroyed=!0,G(this.modifiers,"applyStyle")&&(this.popper.removeAttribute("x-placement"),this.popper.style.position="",this.popper.style.top="",this.popper.style.left="",this.popper.style.right="",this.popper.style.bottom="",this.popper.style.willChange="",this.popper.style[q("transform")]=""),this.disableEventListeners(),this.options.removeOnDestroy&&this.popper.parentNode.removeChild(this.popper),this}function Z(e){var t=e.ownerDocument;return t?t.defaultView:window}function X(e,t,r,o){var n="BODY"===e.nodeName,c=n?e.ownerDocument.defaultView:e;c.addEventListener(t,r,{passive:!0}),n||X(v(c.parentNode),t,r,o),o.push(c);}function J(e,t,r,o){r.updateBound=o,Z(e).addEventListener("resize",r.updateBound,{passive:!0});var n=v(e);return X(n,"scroll",r.updateBound,r.scrollParents),r.scrollElement=n,r.eventsEnabled=!0,r}function Q(){this.state.eventsEnabled||(this.state=J(this.reference,this.options,this.state,this.scheduleUpdate));}function ee(e,t){return Z(e).removeEventListener("resize",t.updateBound),t.scrollParents.forEach(function(e){e.removeEventListener("scroll",t.updateBound);}),t.updateBound=null,t.scrollParents=[],t.scrollElement=null,t.eventsEnabled=!1,t}function te(){this.state.eventsEnabled&&(cancelAnimationFrame(this.scheduleUpdate),this.state=ee(this.reference,this.state));}function re(e){return ""!==e&&!isNaN(parseFloat(e))&&isFinite(e)}function oe(e,t){Object.keys(t).forEach(function(r){var o="";-1!==["width","height","top","right","bottom","left"].indexOf(r)&&re(t[r])&&(o="px"),e.style[r]=t[r]+o;});}function ne(e,t){Object.keys(t).forEach(function(r){var o=t[r];!1!==o?e.setAttribute(r,t[r]):e.removeAttribute(r);});}function ce(e){return oe(e.instance.popper,e.styles),ne(e.instance.popper,e.attributes),e.arrowElement&&Object.keys(e.arrowStyles).length&&oe(e.arrowElement,e.arrowStyles),e}function ie(e,t,r,o,n){var c=z(n,t,e,r.positionFixed),i=N(r.placement,c,t,e,r.modifiers.flip.boundariesElement,r.modifiers.flip.padding);return t.setAttribute("x-placement",i),oe(t,{position:r.positionFixed?"fixed":"absolute"}),r}function ae(e,t){var r=e.offsets,o=r.popper,n=r.reference,c=Math.round,i=Math.floor,a=function(e){return e},s=c(n.width),u=c(o.width),d=-1!==["left","right"].indexOf(e.placement),l=-1!==e.placement.indexOf("-"),f=s%2===u%2,v=s%2===1&&u%2===1,b=t?d||l||f?c:i:a,h=t?c:a;return {left:b(v&&!l&&t?o.left-1:o.left),top:h(o.top),bottom:h(o.bottom),right:b(o.right)}}var se=r&&/Firefox/i.test(navigator.userAgent);function ue(e,t){var r=t.x,o=t.y,n=e.offsets.popper,c=W(e.instance.modifiers,function(e){return "applyStyle"===e.name}).gpuAcceleration;void 0!==c&&console.warn("WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!");var i=void 0!==c?c:t.gpuAcceleration,a=g(e.instance.popper),s=C(a),u={position:n.position},d=ae(e,window.devicePixelRatio<2||!se),l="bottom"===r?"top":"bottom",f="right"===o?"left":"right",v=q("transform"),b=void 0,h=void 0;if(h="bottom"===l?"HTML"===a.nodeName?-a.clientHeight+d.bottom:-s.height+d.bottom:d.top,b="right"===f?"HTML"===a.nodeName?-a.clientWidth+d.right:-s.width+d.right:d.left,i&&v)u[v]="translate3d("+b+"px, "+h+"px, 0)",u[l]=0,u[f]=0,u.willChange="transform";else {var p="bottom"===l?-1:1,y="right"===f?-1:1;u[l]=h*p,u[f]=b*y,u.willChange=l+", "+f;}var m={"x-placement":e.placement};return e.attributes=S({},m,e.attributes),e.styles=S({},u,e.styles),e.arrowStyles=S({},e.offsets.arrow,e.arrowStyles),e}function de(e,t,r){var o=W(e,function(e){var r=e.name;return r===t}),n=!!o&&e.some(function(e){return e.name===r&&e.enabled&&e.order<o.order});if(!n){var c="`"+t+"`",i="`"+r+"`";console.warn(i+" modifier is required by "+c+" modifier in order to work, be sure to include it before "+c+"!");}return n}function le(e,t){var r;if(!de(e.instance.modifiers,"arrow","keepTogether"))return e;var o=t.element;if("string"===typeof o){if(o=e.instance.popper.querySelector(o),!o)return e}else if(!e.instance.popper.contains(o))return console.warn("WARNING: `arrow.element` must be child of its popper element!"),e;var n=e.placement.split("-")[0],c=e.offsets,i=c.popper,a=c.reference,s=-1!==["left","right"].indexOf(n),u=s?"height":"width",d=s?"Top":"Left",f=d.toLowerCase(),v=s?"left":"top",b=s?"bottom":"right",h=$(o)[u];a[b]-h<i[f]&&(e.offsets.popper[f]-=i[f]-(a[b]-h)),a[f]+h>i[b]&&(e.offsets.popper[f]+=a[f]+h-i[b]),e.offsets.popper=E(e.offsets.popper);var p=a[f]+a[u]/2-h/2,g=l(e.instance.popper),y=parseFloat(g["margin"+d],10),m=parseFloat(g["border"+d+"Width"],10),x=p-e.offsets.popper[f]-y-m;return x=Math.max(Math.min(i[u]-h,x),0),e.arrowElement=o,e.offsets.arrow=(r={},M(r,f,Math.round(x)),M(r,v,""),r),e}function fe(e){return "end"===e?"start":"start"===e?"end":e}var ve=["auto-start","auto","auto-end","top-start","top","top-end","right-start","right","right-end","bottom-end","bottom","bottom-start","left-end","left","left-start"],be=ve.slice(3);function he(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1],r=be.indexOf(e),o=be.slice(r+1).concat(be.slice(0,r));return t?o.reverse():o}var pe={FLIP:"flip",CLOCKWISE:"clockwise",COUNTERCLOCKWISE:"counterclockwise"};function ge(e,t){if(G(e.instance.modifiers,"inner"))return e;if(e.flipped&&e.placement===e.originalPlacement)return e;var r=L(e.instance.popper,e.instance.reference,t.padding,t.boundariesElement,e.positionFixed),o=e.placement.split("-")[0],n=R(o),c=e.placement.split("-")[1]||"",i=[];switch(t.behavior){case pe.FLIP:i=[o,n];break;case pe.CLOCKWISE:i=he(o);break;case pe.COUNTERCLOCKWISE:i=he(o,!0);break;default:i=t.behavior;}return i.forEach(function(a,s){if(o!==a||i.length===s+1)return e;o=e.placement.split("-")[0],n=R(o);var u=e.offsets.popper,d=e.offsets.reference,l=Math.floor,f="left"===o&&l(u.right)>l(d.left)||"right"===o&&l(u.left)<l(d.right)||"top"===o&&l(u.bottom)>l(d.top)||"bottom"===o&&l(u.top)<l(d.bottom),v=l(u.left)<l(r.left),b=l(u.right)>l(r.right),h=l(u.top)<l(r.top),p=l(u.bottom)>l(r.bottom),g="left"===o&&v||"right"===o&&b||"top"===o&&h||"bottom"===o&&p,y=-1!==["top","bottom"].indexOf(o),m=!!t.flipVariations&&(y&&"start"===c&&v||y&&"end"===c&&b||!y&&"start"===c&&h||!y&&"end"===c&&p),x=!!t.flipVariationsByContent&&(y&&"start"===c&&b||y&&"end"===c&&v||!y&&"start"===c&&p||!y&&"end"===c&&h),w=m||x;(f||g||w)&&(e.flipped=!0,(f||g)&&(o=i[s+1]),w&&(c=fe(c)),e.placement=o+(c?"-"+c:""),e.offsets.popper=S({},e.offsets.popper,V(e.instance.popper,e.offsets.reference,e.placement)),e=U(e.instance.modifiers,e,"flip"));}),e}function ye(e){var t=e.offsets,r=t.popper,o=t.reference,n=e.placement.split("-")[0],c=Math.floor,i=-1!==["top","bottom"].indexOf(n),a=i?"right":"bottom",s=i?"left":"top",u=i?"width":"height";return r[a]<c(o[s])&&(e.offsets.popper[s]=c(o[s])-r[u]),r[s]>c(o[a])&&(e.offsets.popper[s]=c(o[a])),e}function me(e,t,r,o){var n=e.match(/((?:\-|\+)?\d*\.?\d*)(.*)/),c=+n[1],i=n[2];if(!c)return e;if(0===i.indexOf("%")){var a=void 0;switch(i){case"%p":a=r;break;case"%":case"%r":default:a=o;}var s=E(a);return s[t]/100*c}if("vh"===i||"vw"===i){var u=void 0;return u="vh"===i?Math.max(document.documentElement.clientHeight,window.innerHeight||0):Math.max(document.documentElement.clientWidth,window.innerWidth||0),u/100*c}return c}function xe(e,t,r,o){var n=[0,0],c=-1!==["right","left"].indexOf(o),i=e.split(/(\+|\-)/).map(function(e){return e.trim()}),a=i.indexOf(W(i,function(e){return -1!==e.search(/,|\s/)}));i[a]&&-1===i[a].indexOf(",")&&console.warn("Offsets separated by white space(s) are deprecated, use a comma (,) instead.");var s=/\s*,\s*|\s+/,u=-1!==a?[i.slice(0,a).concat([i[a].split(s)[0]]),[i[a].split(s)[1]].concat(i.slice(a+1))]:[i];return u=u.map(function(e,o){var n=(1===o?!c:c)?"height":"width",i=!1;return e.reduce(function(e,t){return ""===e[e.length-1]&&-1!==["+","-"].indexOf(t)?(e[e.length-1]=t,i=!0,e):i?(e[e.length-1]+=t,i=!1,e):e.concat(t)},[]).map(function(e){return me(e,n,t,r)})}),u.forEach(function(e,t){e.forEach(function(r,o){re(r)&&(n[t]+=r*("-"===e[o-1]?-1:1));});}),n}function we(e,t){var r=t.offset,o=e.placement,n=e.offsets,c=n.popper,i=n.reference,a=o.split("-")[0],s=void 0;return s=re(+r)?[+r,0]:xe(r,c,i,a),"left"===a?(c.top+=s[0],c.left-=s[1]):"right"===a?(c.top+=s[0],c.left+=s[1]):"top"===a?(c.left+=s[0],c.top-=s[1]):"bottom"===a&&(c.left+=s[0],c.top+=s[1]),e.popper=c,e}function ke(e,t){var r=t.boundariesElement||g(e.instance.popper);e.instance.reference===r&&(r=g(r));var o=q("transform"),n=e.instance.popper.style,c=n.top,i=n.left,a=n[o];n.top="",n.left="",n[o]="";var s=L(e.instance.popper,e.instance.reference,t.padding,r,e.positionFixed);n.top=c,n.left=i,n[o]=a,t.boundaries=s;var u=t.priority,d=e.offsets.popper,l={primary:function(e){var r=d[e];return d[e]<s[e]&&!t.escapeWithReference&&(r=Math.max(d[e],s[e])),M({},e,r)},secondary:function(e){var r="right"===e?"left":"top",o=d[r];return d[e]>s[e]&&!t.escapeWithReference&&(o=Math.min(d[r],s[e]-("right"===e?d.width:d.height))),M({},r,o)}};return u.forEach(function(e){var t=-1!==["left","top"].indexOf(e)?"primary":"secondary";d=S({},d,l[t](e));}),e.offsets.popper=d,e}function Oe(e){var t=e.placement,r=t.split("-")[0],o=t.split("-")[1];if(o){var n=e.offsets,c=n.reference,i=n.popper,a=-1!==["bottom","top"].indexOf(r),s=a?"left":"top",u=a?"width":"height",d={start:M({},s,c[s]),end:M({},s,c[s]+c[u]-i[u])};e.offsets.popper=S({},i,d[o]);}return e}function je(e){if(!de(e.instance.modifiers,"hide","preventOverflow"))return e;var t=e.offsets.reference,r=W(e.instance.modifiers,function(e){return "preventOverflow"===e.name}).boundaries;if(t.bottom<r.top||t.left>r.right||t.top>r.bottom||t.right<r.left){if(!0===e.hide)return e;e.hide=!0,e.attributes["x-out-of-boundaries"]="";}else {if(!1===e.hide)return e;e.hide=!1,e.attributes["x-out-of-boundaries"]=!1;}return e}function De(e){var t=e.placement,r=t.split("-")[0],o=e.offsets,n=o.popper,c=o.reference,i=-1!==["left","right"].indexOf(r),a=-1===["top","left"].indexOf(r);return n[i?"left":"top"]=c[r]-(a?n[i?"width":"height"]:0),e.placement=R(t),e.offsets.popper=E(n),e}var _e={shift:{order:100,enabled:!0,fn:Oe},offset:{order:200,enabled:!0,fn:we,offset:0},preventOverflow:{order:300,enabled:!0,fn:ke,priority:["left","right","top","bottom"],padding:5,boundariesElement:"scrollParent"},keepTogether:{order:400,enabled:!0,fn:ye},arrow:{order:500,enabled:!0,fn:le,element:"[x-arrow]"},flip:{order:600,enabled:!0,fn:ge,behavior:"flip",padding:5,boundariesElement:"viewport",flipVariations:!1,flipVariationsByContent:!1},inner:{order:700,enabled:!1,fn:De},hide:{order:800,enabled:!0,fn:je},computeStyle:{order:850,enabled:!0,fn:ue,gpuAcceleration:!0,x:"bottom",y:"right"},applyStyle:{order:900,enabled:!0,fn:ce,onLoad:ie,gpuAcceleration:void 0}},Pe={placement:"bottom",positionFixed:!1,eventsEnabled:!0,removeOnDestroy:!1,onCreate:function(){},onUpdate:function(){},modifiers:_e},Me=function(){function e(t,r){var o=this,n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};_(this,e),this.scheduleUpdate=function(){return requestAnimationFrame(o.update)},this.update=u(this.update.bind(this)),this.options=S({},e.Defaults,n),this.state={isDestroyed:!1,isCreated:!1,scrollParents:[]},this.reference=t&&t.jquery?t[0]:t,this.popper=r&&r.jquery?r[0]:r,this.options.modifiers={},Object.keys(S({},e.Defaults.modifiers,n.modifiers)).forEach(function(t){o.options.modifiers[t]=S({},e.Defaults.modifiers[t]||{},n.modifiers?n.modifiers[t]:{});}),this.modifiers=Object.keys(this.options.modifiers).map(function(e){return S({name:e},o.options.modifiers[e])}).sort(function(e,t){return e.order-t.order}),this.modifiers.forEach(function(e){e.enabled&&d(e.onLoad)&&e.onLoad(o.reference,o.popper,o.options,e,o.state);}),this.update();var c=this.options.eventsEnabled;c&&this.enableEventListeners(),this.state.eventsEnabled=c;}return P(e,[{key:"update",value:function(){return B.call(this)}},{key:"destroy",value:function(){return K.call(this)}},{key:"enableEventListeners",value:function(){return Q.call(this)}},{key:"disableEventListeners",value:function(){return te.call(this)}}]),e}();Me.Utils=("undefined"!==typeof window?window:e).PopperUtils,Me.placements=ve,Me.Defaults=Pe,t["a"]=Me;}).call(this,r("c8ba"));},f1ae:function(e,t,r){var o=r("86cc"),n=r("4630");e.exports=function(e,t,r){t in e?o.f(e,t,n(0,r)):e[t]=r;};},f231:function(e,t,r){t=e.exports=r("2350")(!1),t.push([e.i,'.vc-popover-content-wrapper[data-v-5dd7f738]{--popover-horizontal-content-offset:8px;--popover-vertical-content-offset:10px;--popover-slide-translation:15px;--popover-transition-time:0.14s ease-in-out;--popover-caret-horizontal-offset:18px;--popover-caret-vertical-offset:8px;position:absolute;display:block;outline:none;z-index:10}.vc-popover-content-wrapper[data-v-5dd7f738]:not(.is-interactive){pointer-events:none}.vc-popover-content[data-v-5dd7f738]{position:relative;z-index:10}.vc-popover-content.direction-bottom[data-v-5dd7f738]{margin-top:var(--popover-vertical-content-offset)}.vc-popover-content.direction-top[data-v-5dd7f738]{margin-bottom:var(--popover-vertical-content-offset)}.vc-popover-content.direction-left[data-v-5dd7f738]{margin-right:var(--popover-horizontal-content-offset)}.vc-popover-content.direction-right[data-v-5dd7f738]{margin-left:var(--popover-horizontal-content-offset)}.vc-popover-caret[data-v-5dd7f738]{content:"";position:absolute;display:block;width:12px;height:12px;border-top:inherit;border-left:inherit;background:inherit;z-index:-1}.vc-popover-caret.direction-bottom[data-v-5dd7f738]{top:0}.vc-popover-caret.direction-bottom.align-left[data-v-5dd7f738]{transform:translateY(-50%) rotate(45deg)}.vc-popover-caret.direction-bottom.align-center[data-v-5dd7f738]{transform:translateX(-50%) translateY(-50%) rotate(45deg)}.vc-popover-caret.direction-bottom.align-right[data-v-5dd7f738]{transform:translateY(-50%) rotate(45deg)}.vc-popover-caret.direction-top[data-v-5dd7f738]{top:100%}.vc-popover-caret.direction-top.align-left[data-v-5dd7f738]{transform:translateY(-50%) rotate(-135deg)}.vc-popover-caret.direction-top.align-center[data-v-5dd7f738]{transform:translateX(-50%) translateY(-50%) rotate(-135deg)}.vc-popover-caret.direction-top.align-right[data-v-5dd7f738]{transform:translateY(-50%) rotate(-135deg)}.vc-popover-caret.direction-left[data-v-5dd7f738]{left:100%}.vc-popover-caret.direction-left.align-top[data-v-5dd7f738]{transform:translateX(-50%) rotate(135deg)}.vc-popover-caret.direction-left.align-middle[data-v-5dd7f738]{transform:translateY(-50%) translateX(-50%) rotate(135deg)}.vc-popover-caret.direction-left.align-bottom[data-v-5dd7f738]{transform:translateX(-50%) rotate(135deg)}.vc-popover-caret.direction-right[data-v-5dd7f738]{left:0}.vc-popover-caret.direction-right.align-top[data-v-5dd7f738]{transform:translateX(-50%) rotate(-45deg)}.vc-popover-caret.direction-right.align-middle[data-v-5dd7f738]{transform:translateY(-50%) translateX(-50%) rotate(-45deg)}.vc-popover-caret.direction-right.align-bottom[data-v-5dd7f738]{transform:translateX(-50%) rotate(-45deg)}.vc-popover-caret.align-left[data-v-5dd7f738]{left:var(--popover-caret-horizontal-offset)}.vc-popover-caret.align-center[data-v-5dd7f738]{left:50%}.vc-popover-caret.align-right[data-v-5dd7f738]{right:var(--popover-caret-horizontal-offset)}.vc-popover-caret.align-top[data-v-5dd7f738]{top:var(--popover-caret-vertical-offset)}.vc-popover-caret.align-middle[data-v-5dd7f738]{top:50%}.vc-popover-caret.align-bottom[data-v-5dd7f738]{bottom:var(--popover-caret-vertical-offset)}.fade-enter-active[data-v-5dd7f738],.fade-leave-active[data-v-5dd7f738],.slide-fade-enter-active[data-v-5dd7f738],.slide-fade-leave-active[data-v-5dd7f738]{transition:all var(--popover-transition-time);pointer-events:none}.fade-enter[data-v-5dd7f738],.fade-leave-to[data-v-5dd7f738],.slide-fade-enter[data-v-5dd7f738],.slide-fade-leave-to[data-v-5dd7f738]{opacity:0}.slide-fade-enter.direction-bottom[data-v-5dd7f738],.slide-fade-leave-to.direction-bottom[data-v-5dd7f738]{transform:translateY(calc(-1*var(--popover-slide-translation)))}.slide-fade-enter.direction-top[data-v-5dd7f738],.slide-fade-leave-to.direction-top[data-v-5dd7f738]{transform:translateY(var(--popover-slide-translation))}.slide-fade-enter.direction-left[data-v-5dd7f738],.slide-fade-leave-to.direction-left[data-v-5dd7f738]{transform:translateX(var(--popover-slide-translation))}.slide-fade-enter.direction-right[data-v-5dd7f738],.slide-fade-leave-to.direction-right[data-v-5dd7f738]{transform:translateX(calc(-1*var(--popover-slide-translation)))}',""]);},f3c1:function(e,t){var r=800,o=16,n=Date.now;function c(e){var t=0,c=0;return function(){var i=n(),a=o-(i-c);if(c=i,a>0){if(++t>=r)return arguments[0]}else t=0;return e.apply(void 0,arguments)}}e.exports=c;},f410:function(e,t,r){r("1af6"),e.exports=r("584a").Array.isArray;},f498:function(e,t,r){t=e.exports=r("2350")(!1),t.push([e.i,".vc-reset,.vc-reset *{line-height:1.5;box-sizing:border-box;border-width:0;border-style:solid;border-color:#e2e8f0}.vc-reset:focus,.vc-reset :focus{outline:none}.vc-reset [role=button],.vc-reset button{cursor:pointer}.vc-appearance-none{-webkit-appearance:none;-moz-appearance:none;appearance:none}.vc-bg-fixed{background-attachment:fixed}.vc-bg-local{background-attachment:local}.vc-bg-scroll{background-attachment:scroll}.vc-bg-transparent{background-color:transparent}.vc-bg-black{background-color:#000}.vc-bg-white{background-color:#fff}.vc-bg-gray-100{background-color:#f7fafc}.vc-bg-gray-200{background-color:#edf2f7}.vc-bg-gray-300{background-color:#e2e8f0}.vc-bg-gray-400{background-color:#cbd5e0}.vc-bg-gray-500{background-color:#a0aec0}.vc-bg-gray-600{background-color:#718096}.vc-bg-gray-700{background-color:#4a5568}.vc-bg-gray-800{background-color:#2d3748}.vc-bg-gray-900{background-color:#1a202c}.vc-bg-red-100{background-color:#fff5f5}.vc-bg-red-200{background-color:#fed7d7}.vc-bg-red-300{background-color:#feb2b2}.vc-bg-red-400{background-color:#fc8181}.vc-bg-red-500{background-color:#f56565}.vc-bg-red-600{background-color:#e53e3e}.vc-bg-red-700{background-color:#c53030}.vc-bg-red-800{background-color:#9b2c2c}.vc-bg-red-900{background-color:#742a2a}.vc-bg-orange-100{background-color:#fffaf0}.vc-bg-orange-200{background-color:#feebc8}.vc-bg-orange-300{background-color:#fbd38d}.vc-bg-orange-400{background-color:#f6ad55}.vc-bg-orange-500{background-color:#ed8936}.vc-bg-orange-600{background-color:#dd6b20}.vc-bg-orange-700{background-color:#c05621}.vc-bg-orange-800{background-color:#9c4221}.vc-bg-orange-900{background-color:#7b341e}.vc-bg-yellow-100{background-color:ivory}.vc-bg-yellow-200{background-color:#fefcbf}.vc-bg-yellow-300{background-color:#faf089}.vc-bg-yellow-400{background-color:#f6e05e}.vc-bg-yellow-500{background-color:#ecc94b}.vc-bg-yellow-600{background-color:#d69e2e}.vc-bg-yellow-700{background-color:#b7791f}.vc-bg-yellow-800{background-color:#975a16}.vc-bg-yellow-900{background-color:#744210}.vc-bg-green-100{background-color:#f0fff4}.vc-bg-green-200{background-color:#c6f6d5}.vc-bg-green-300{background-color:#9ae6b4}.vc-bg-green-400{background-color:#68d391}.vc-bg-green-500{background-color:#48bb78}.vc-bg-green-600{background-color:#38a169}.vc-bg-green-700{background-color:#2f855a}.vc-bg-green-800{background-color:#276749}.vc-bg-green-900{background-color:#22543d}.vc-bg-teal-100{background-color:#e6fffa}.vc-bg-teal-200{background-color:#b2f5ea}.vc-bg-teal-300{background-color:#81e6d9}.vc-bg-teal-400{background-color:#4fd1c5}.vc-bg-teal-500{background-color:#38b2ac}.vc-bg-teal-600{background-color:#319795}.vc-bg-teal-700{background-color:#2c7a7b}.vc-bg-teal-800{background-color:#285e61}.vc-bg-teal-900{background-color:#234e52}.vc-bg-blue-100{background-color:#ebf8ff}.vc-bg-blue-200{background-color:#bee3f8}.vc-bg-blue-300{background-color:#90cdf4}.vc-bg-blue-400{background-color:#63b3ed}.vc-bg-blue-500{background-color:#4299e1}.vc-bg-blue-600{background-color:#3182ce}.vc-bg-blue-700{background-color:#2b6cb0}.vc-bg-blue-800{background-color:#2c5282}.vc-bg-blue-900{background-color:#2a4365}.vc-bg-indigo-100{background-color:#ebf4ff}.vc-bg-indigo-200{background-color:#c3dafe}.vc-bg-indigo-300{background-color:#a3bffa}.vc-bg-indigo-400{background-color:#7f9cf5}.vc-bg-indigo-500{background-color:#667eea}.vc-bg-indigo-600{background-color:#5a67d8}.vc-bg-indigo-700{background-color:#4c51bf}.vc-bg-indigo-800{background-color:#434190}.vc-bg-indigo-900{background-color:#3c366b}.vc-bg-purple-100{background-color:#faf5ff}.vc-bg-purple-200{background-color:#e9d8fd}.vc-bg-purple-300{background-color:#d6bcfa}.vc-bg-purple-400{background-color:#b794f4}.vc-bg-purple-500{background-color:#9f7aea}.vc-bg-purple-600{background-color:#805ad5}.vc-bg-purple-700{background-color:#6b46c1}.vc-bg-purple-800{background-color:#553c9a}.vc-bg-purple-900{background-color:#44337a}.vc-bg-pink-100{background-color:#fff5f7}.vc-bg-pink-200{background-color:#fed7e2}.vc-bg-pink-300{background-color:#fbb6ce}.vc-bg-pink-400{background-color:#f687b3}.vc-bg-pink-500{background-color:#ed64a6}.vc-bg-pink-600{background-color:#d53f8c}.vc-bg-pink-700{background-color:#b83280}.vc-bg-pink-800{background-color:#97266d}.vc-bg-pink-900{background-color:#702459}.hover\\:vc-bg-transparent:hover{background-color:transparent}.hover\\:vc-bg-black:hover{background-color:#000}.hover\\:vc-bg-white:hover{background-color:#fff}.hover\\:vc-bg-gray-100:hover{background-color:#f7fafc}.hover\\:vc-bg-gray-200:hover{background-color:#edf2f7}.hover\\:vc-bg-gray-300:hover{background-color:#e2e8f0}.hover\\:vc-bg-gray-400:hover{background-color:#cbd5e0}.hover\\:vc-bg-gray-500:hover{background-color:#a0aec0}.hover\\:vc-bg-gray-600:hover{background-color:#718096}.hover\\:vc-bg-gray-700:hover{background-color:#4a5568}.hover\\:vc-bg-gray-800:hover{background-color:#2d3748}.hover\\:vc-bg-gray-900:hover{background-color:#1a202c}.hover\\:vc-bg-red-100:hover{background-color:#fff5f5}.hover\\:vc-bg-red-200:hover{background-color:#fed7d7}.hover\\:vc-bg-red-300:hover{background-color:#feb2b2}.hover\\:vc-bg-red-400:hover{background-color:#fc8181}.hover\\:vc-bg-red-500:hover{background-color:#f56565}.hover\\:vc-bg-red-600:hover{background-color:#e53e3e}.hover\\:vc-bg-red-700:hover{background-color:#c53030}.hover\\:vc-bg-red-800:hover{background-color:#9b2c2c}.hover\\:vc-bg-red-900:hover{background-color:#742a2a}.hover\\:vc-bg-orange-100:hover{background-color:#fffaf0}.hover\\:vc-bg-orange-200:hover{background-color:#feebc8}.hover\\:vc-bg-orange-300:hover{background-color:#fbd38d}.hover\\:vc-bg-orange-400:hover{background-color:#f6ad55}.hover\\:vc-bg-orange-500:hover{background-color:#ed8936}.hover\\:vc-bg-orange-600:hover{background-color:#dd6b20}.hover\\:vc-bg-orange-700:hover{background-color:#c05621}.hover\\:vc-bg-orange-800:hover{background-color:#9c4221}.hover\\:vc-bg-orange-900:hover{background-color:#7b341e}.hover\\:vc-bg-yellow-100:hover{background-color:ivory}.hover\\:vc-bg-yellow-200:hover{background-color:#fefcbf}.hover\\:vc-bg-yellow-300:hover{background-color:#faf089}.hover\\:vc-bg-yellow-400:hover{background-color:#f6e05e}.hover\\:vc-bg-yellow-500:hover{background-color:#ecc94b}.hover\\:vc-bg-yellow-600:hover{background-color:#d69e2e}.hover\\:vc-bg-yellow-700:hover{background-color:#b7791f}.hover\\:vc-bg-yellow-800:hover{background-color:#975a16}.hover\\:vc-bg-yellow-900:hover{background-color:#744210}.hover\\:vc-bg-green-100:hover{background-color:#f0fff4}.hover\\:vc-bg-green-200:hover{background-color:#c6f6d5}.hover\\:vc-bg-green-300:hover{background-color:#9ae6b4}.hover\\:vc-bg-green-400:hover{background-color:#68d391}.hover\\:vc-bg-green-500:hover{background-color:#48bb78}.hover\\:vc-bg-green-600:hover{background-color:#38a169}.hover\\:vc-bg-green-700:hover{background-color:#2f855a}.hover\\:vc-bg-green-800:hover{background-color:#276749}.hover\\:vc-bg-green-900:hover{background-color:#22543d}.hover\\:vc-bg-teal-100:hover{background-color:#e6fffa}.hover\\:vc-bg-teal-200:hover{background-color:#b2f5ea}.hover\\:vc-bg-teal-300:hover{background-color:#81e6d9}.hover\\:vc-bg-teal-400:hover{background-color:#4fd1c5}.hover\\:vc-bg-teal-500:hover{background-color:#38b2ac}.hover\\:vc-bg-teal-600:hover{background-color:#319795}.hover\\:vc-bg-teal-700:hover{background-color:#2c7a7b}.hover\\:vc-bg-teal-800:hover{background-color:#285e61}.hover\\:vc-bg-teal-900:hover{background-color:#234e52}.hover\\:vc-bg-blue-100:hover{background-color:#ebf8ff}.hover\\:vc-bg-blue-200:hover{background-color:#bee3f8}.hover\\:vc-bg-blue-300:hover{background-color:#90cdf4}.hover\\:vc-bg-blue-400:hover{background-color:#63b3ed}.hover\\:vc-bg-blue-500:hover{background-color:#4299e1}.hover\\:vc-bg-blue-600:hover{background-color:#3182ce}.hover\\:vc-bg-blue-700:hover{background-color:#2b6cb0}.hover\\:vc-bg-blue-800:hover{background-color:#2c5282}.hover\\:vc-bg-blue-900:hover{background-color:#2a4365}.hover\\:vc-bg-indigo-100:hover{background-color:#ebf4ff}.hover\\:vc-bg-indigo-200:hover{background-color:#c3dafe}.hover\\:vc-bg-indigo-300:hover{background-color:#a3bffa}.hover\\:vc-bg-indigo-400:hover{background-color:#7f9cf5}.hover\\:vc-bg-indigo-500:hover{background-color:#667eea}.hover\\:vc-bg-indigo-600:hover{background-color:#5a67d8}.hover\\:vc-bg-indigo-700:hover{background-color:#4c51bf}.hover\\:vc-bg-indigo-800:hover{background-color:#434190}.hover\\:vc-bg-indigo-900:hover{background-color:#3c366b}.hover\\:vc-bg-purple-100:hover{background-color:#faf5ff}.hover\\:vc-bg-purple-200:hover{background-color:#e9d8fd}.hover\\:vc-bg-purple-300:hover{background-color:#d6bcfa}.hover\\:vc-bg-purple-400:hover{background-color:#b794f4}.hover\\:vc-bg-purple-500:hover{background-color:#9f7aea}.hover\\:vc-bg-purple-600:hover{background-color:#805ad5}.hover\\:vc-bg-purple-700:hover{background-color:#6b46c1}.hover\\:vc-bg-purple-800:hover{background-color:#553c9a}.hover\\:vc-bg-purple-900:hover{background-color:#44337a}.hover\\:vc-bg-pink-100:hover{background-color:#fff5f7}.hover\\:vc-bg-pink-200:hover{background-color:#fed7e2}.hover\\:vc-bg-pink-300:hover{background-color:#fbb6ce}.hover\\:vc-bg-pink-400:hover{background-color:#f687b3}.hover\\:vc-bg-pink-500:hover{background-color:#ed64a6}.hover\\:vc-bg-pink-600:hover{background-color:#d53f8c}.hover\\:vc-bg-pink-700:hover{background-color:#b83280}.hover\\:vc-bg-pink-800:hover{background-color:#97266d}.hover\\:vc-bg-pink-900:hover{background-color:#702459}.vc-bg-bottom{background-position:bottom}.vc-bg-center{background-position:50%}.vc-bg-left{background-position:0}.vc-bg-left-bottom{background-position:0 100%}.vc-bg-left-top{background-position:0 0}.vc-bg-right{background-position:100%}.vc-bg-right-bottom{background-position:100% 100%}.vc-bg-right-top{background-position:100% 0}.vc-bg-top{background-position:top}.vc-bg-repeat{background-repeat:repeat}.vc-bg-no-repeat{background-repeat:no-repeat}.vc-bg-repeat-x{background-repeat:repeat-x}.vc-bg-repeat-y{background-repeat:repeat-y}.vc-bg-repeat-round{background-repeat:round}.vc-bg-repeat-space{background-repeat:space}.vc-bg-auto{background-size:auto}.vc-bg-cover{background-size:cover}.vc-bg-contain{background-size:contain}.vc-border-collapse{border-collapse:collapse}.vc-border-separate{border-collapse:separate}.vc-border-transparent{border-color:transparent}.vc-border-black{border-color:#000}.vc-border-white{border-color:#fff}.vc-border-gray-100{border-color:#f7fafc}.vc-border-gray-200{border-color:#edf2f7}.vc-border-gray-300{border-color:#e2e8f0}.vc-border-gray-400{border-color:#cbd5e0}.vc-border-gray-500{border-color:#a0aec0}.vc-border-gray-600{border-color:#718096}.vc-border-gray-700{border-color:#4a5568}.vc-border-gray-800{border-color:#2d3748}.vc-border-gray-900{border-color:#1a202c}.vc-border-red-100{border-color:#fff5f5}.vc-border-red-200{border-color:#fed7d7}.vc-border-red-300{border-color:#feb2b2}.vc-border-red-400{border-color:#fc8181}.vc-border-red-500{border-color:#f56565}.vc-border-red-600{border-color:#e53e3e}.vc-border-red-700{border-color:#c53030}.vc-border-red-800{border-color:#9b2c2c}.vc-border-red-900{border-color:#742a2a}.vc-border-orange-100{border-color:#fffaf0}.vc-border-orange-200{border-color:#feebc8}.vc-border-orange-300{border-color:#fbd38d}.vc-border-orange-400{border-color:#f6ad55}.vc-border-orange-500{border-color:#ed8936}.vc-border-orange-600{border-color:#dd6b20}.vc-border-orange-700{border-color:#c05621}.vc-border-orange-800{border-color:#9c4221}.vc-border-orange-900{border-color:#7b341e}.vc-border-yellow-100{border-color:ivory}.vc-border-yellow-200{border-color:#fefcbf}.vc-border-yellow-300{border-color:#faf089}.vc-border-yellow-400{border-color:#f6e05e}.vc-border-yellow-500{border-color:#ecc94b}.vc-border-yellow-600{border-color:#d69e2e}.vc-border-yellow-700{border-color:#b7791f}.vc-border-yellow-800{border-color:#975a16}.vc-border-yellow-900{border-color:#744210}.vc-border-green-100{border-color:#f0fff4}.vc-border-green-200{border-color:#c6f6d5}.vc-border-green-300{border-color:#9ae6b4}.vc-border-green-400{border-color:#68d391}.vc-border-green-500{border-color:#48bb78}.vc-border-green-600{border-color:#38a169}.vc-border-green-700{border-color:#2f855a}.vc-border-green-800{border-color:#276749}.vc-border-green-900{border-color:#22543d}.vc-border-teal-100{border-color:#e6fffa}.vc-border-teal-200{border-color:#b2f5ea}.vc-border-teal-300{border-color:#81e6d9}.vc-border-teal-400{border-color:#4fd1c5}.vc-border-teal-500{border-color:#38b2ac}.vc-border-teal-600{border-color:#319795}.vc-border-teal-700{border-color:#2c7a7b}.vc-border-teal-800{border-color:#285e61}.vc-border-teal-900{border-color:#234e52}.vc-border-blue-100{border-color:#ebf8ff}.vc-border-blue-200{border-color:#bee3f8}.vc-border-blue-300{border-color:#90cdf4}.vc-border-blue-400{border-color:#63b3ed}.vc-border-blue-500{border-color:#4299e1}.vc-border-blue-600{border-color:#3182ce}.vc-border-blue-700{border-color:#2b6cb0}.vc-border-blue-800{border-color:#2c5282}.vc-border-blue-900{border-color:#2a4365}.vc-border-indigo-100{border-color:#ebf4ff}.vc-border-indigo-200{border-color:#c3dafe}.vc-border-indigo-300{border-color:#a3bffa}.vc-border-indigo-400{border-color:#7f9cf5}.vc-border-indigo-500{border-color:#667eea}.vc-border-indigo-600{border-color:#5a67d8}.vc-border-indigo-700{border-color:#4c51bf}.vc-border-indigo-800{border-color:#434190}.vc-border-indigo-900{border-color:#3c366b}.vc-border-purple-100{border-color:#faf5ff}.vc-border-purple-200{border-color:#e9d8fd}.vc-border-purple-300{border-color:#d6bcfa}.vc-border-purple-400{border-color:#b794f4}.vc-border-purple-500{border-color:#9f7aea}.vc-border-purple-600{border-color:#805ad5}.vc-border-purple-700{border-color:#6b46c1}.vc-border-purple-800{border-color:#553c9a}.vc-border-purple-900{border-color:#44337a}.vc-border-pink-100{border-color:#fff5f7}.vc-border-pink-200{border-color:#fed7e2}.vc-border-pink-300{border-color:#fbb6ce}.vc-border-pink-400{border-color:#f687b3}.vc-border-pink-500{border-color:#ed64a6}.vc-border-pink-600{border-color:#d53f8c}.vc-border-pink-700{border-color:#b83280}.vc-border-pink-800{border-color:#97266d}.vc-border-pink-900{border-color:#702459}.hover\\:vc-border-transparent:hover{border-color:transparent}.hover\\:vc-border-black:hover{border-color:#000}.hover\\:vc-border-white:hover{border-color:#fff}.hover\\:vc-border-gray-100:hover{border-color:#f7fafc}.hover\\:vc-border-gray-200:hover{border-color:#edf2f7}.hover\\:vc-border-gray-300:hover{border-color:#e2e8f0}.hover\\:vc-border-gray-400:hover{border-color:#cbd5e0}.hover\\:vc-border-gray-500:hover{border-color:#a0aec0}.hover\\:vc-border-gray-600:hover{border-color:#718096}.hover\\:vc-border-gray-700:hover{border-color:#4a5568}.hover\\:vc-border-gray-800:hover{border-color:#2d3748}.hover\\:vc-border-gray-900:hover{border-color:#1a202c}.hover\\:vc-border-red-100:hover{border-color:#fff5f5}.hover\\:vc-border-red-200:hover{border-color:#fed7d7}.hover\\:vc-border-red-300:hover{border-color:#feb2b2}.hover\\:vc-border-red-400:hover{border-color:#fc8181}.hover\\:vc-border-red-500:hover{border-color:#f56565}.hover\\:vc-border-red-600:hover{border-color:#e53e3e}.hover\\:vc-border-red-700:hover{border-color:#c53030}.hover\\:vc-border-red-800:hover{border-color:#9b2c2c}.hover\\:vc-border-red-900:hover{border-color:#742a2a}.hover\\:vc-border-orange-100:hover{border-color:#fffaf0}.hover\\:vc-border-orange-200:hover{border-color:#feebc8}.hover\\:vc-border-orange-300:hover{border-color:#fbd38d}.hover\\:vc-border-orange-400:hover{border-color:#f6ad55}.hover\\:vc-border-orange-500:hover{border-color:#ed8936}.hover\\:vc-border-orange-600:hover{border-color:#dd6b20}.hover\\:vc-border-orange-700:hover{border-color:#c05621}.hover\\:vc-border-orange-800:hover{border-color:#9c4221}.hover\\:vc-border-orange-900:hover{border-color:#7b341e}.hover\\:vc-border-yellow-100:hover{border-color:ivory}.hover\\:vc-border-yellow-200:hover{border-color:#fefcbf}.hover\\:vc-border-yellow-300:hover{border-color:#faf089}.hover\\:vc-border-yellow-400:hover{border-color:#f6e05e}.hover\\:vc-border-yellow-500:hover{border-color:#ecc94b}.hover\\:vc-border-yellow-600:hover{border-color:#d69e2e}.hover\\:vc-border-yellow-700:hover{border-color:#b7791f}.hover\\:vc-border-yellow-800:hover{border-color:#975a16}.hover\\:vc-border-yellow-900:hover{border-color:#744210}.hover\\:vc-border-green-100:hover{border-color:#f0fff4}.hover\\:vc-border-green-200:hover{border-color:#c6f6d5}.hover\\:vc-border-green-300:hover{border-color:#9ae6b4}.hover\\:vc-border-green-400:hover{border-color:#68d391}.hover\\:vc-border-green-500:hover{border-color:#48bb78}.hover\\:vc-border-green-600:hover{border-color:#38a169}.hover\\:vc-border-green-700:hover{border-color:#2f855a}.hover\\:vc-border-green-800:hover{border-color:#276749}.hover\\:vc-border-green-900:hover{border-color:#22543d}.hover\\:vc-border-teal-100:hover{border-color:#e6fffa}.hover\\:vc-border-teal-200:hover{border-color:#b2f5ea}.hover\\:vc-border-teal-300:hover{border-color:#81e6d9}.hover\\:vc-border-teal-400:hover{border-color:#4fd1c5}.hover\\:vc-border-teal-500:hover{border-color:#38b2ac}.hover\\:vc-border-teal-600:hover{border-color:#319795}.hover\\:vc-border-teal-700:hover{border-color:#2c7a7b}.hover\\:vc-border-teal-800:hover{border-color:#285e61}.hover\\:vc-border-teal-900:hover{border-color:#234e52}.hover\\:vc-border-blue-100:hover{border-color:#ebf8ff}.hover\\:vc-border-blue-200:hover{border-color:#bee3f8}.hover\\:vc-border-blue-300:hover{border-color:#90cdf4}.hover\\:vc-border-blue-400:hover{border-color:#63b3ed}.hover\\:vc-border-blue-500:hover{border-color:#4299e1}.hover\\:vc-border-blue-600:hover{border-color:#3182ce}.hover\\:vc-border-blue-700:hover{border-color:#2b6cb0}.hover\\:vc-border-blue-800:hover{border-color:#2c5282}.hover\\:vc-border-blue-900:hover{border-color:#2a4365}.hover\\:vc-border-indigo-100:hover{border-color:#ebf4ff}.hover\\:vc-border-indigo-200:hover{border-color:#c3dafe}.hover\\:vc-border-indigo-300:hover{border-color:#a3bffa}.hover\\:vc-border-indigo-400:hover{border-color:#7f9cf5}.hover\\:vc-border-indigo-500:hover{border-color:#667eea}.hover\\:vc-border-indigo-600:hover{border-color:#5a67d8}.hover\\:vc-border-indigo-700:hover{border-color:#4c51bf}.hover\\:vc-border-indigo-800:hover{border-color:#434190}.hover\\:vc-border-indigo-900:hover{border-color:#3c366b}.hover\\:vc-border-purple-100:hover{border-color:#faf5ff}.hover\\:vc-border-purple-200:hover{border-color:#e9d8fd}.hover\\:vc-border-purple-300:hover{border-color:#d6bcfa}.hover\\:vc-border-purple-400:hover{border-color:#b794f4}.hover\\:vc-border-purple-500:hover{border-color:#9f7aea}.hover\\:vc-border-purple-600:hover{border-color:#805ad5}.hover\\:vc-border-purple-700:hover{border-color:#6b46c1}.hover\\:vc-border-purple-800:hover{border-color:#553c9a}.hover\\:vc-border-purple-900:hover{border-color:#44337a}.hover\\:vc-border-pink-100:hover{border-color:#fff5f7}.hover\\:vc-border-pink-200:hover{border-color:#fed7e2}.hover\\:vc-border-pink-300:hover{border-color:#fbb6ce}.hover\\:vc-border-pink-400:hover{border-color:#f687b3}.hover\\:vc-border-pink-500:hover{border-color:#ed64a6}.hover\\:vc-border-pink-600:hover{border-color:#d53f8c}.hover\\:vc-border-pink-700:hover{border-color:#b83280}.hover\\:vc-border-pink-800:hover{border-color:#97266d}.hover\\:vc-border-pink-900:hover{border-color:#702459}.focus\\:vc-border-transparent:focus{border-color:transparent}.focus\\:vc-border-black:focus{border-color:#000}.focus\\:vc-border-white:focus{border-color:#fff}.focus\\:vc-border-gray-100:focus{border-color:#f7fafc}.focus\\:vc-border-gray-200:focus{border-color:#edf2f7}.focus\\:vc-border-gray-300:focus{border-color:#e2e8f0}.focus\\:vc-border-gray-400:focus{border-color:#cbd5e0}.focus\\:vc-border-gray-500:focus{border-color:#a0aec0}.focus\\:vc-border-gray-600:focus{border-color:#718096}.focus\\:vc-border-gray-700:focus{border-color:#4a5568}.focus\\:vc-border-gray-800:focus{border-color:#2d3748}.focus\\:vc-border-gray-900:focus{border-color:#1a202c}.focus\\:vc-border-red-100:focus{border-color:#fff5f5}.focus\\:vc-border-red-200:focus{border-color:#fed7d7}.focus\\:vc-border-red-300:focus{border-color:#feb2b2}.focus\\:vc-border-red-400:focus{border-color:#fc8181}.focus\\:vc-border-red-500:focus{border-color:#f56565}.focus\\:vc-border-red-600:focus{border-color:#e53e3e}.focus\\:vc-border-red-700:focus{border-color:#c53030}.focus\\:vc-border-red-800:focus{border-color:#9b2c2c}.focus\\:vc-border-red-900:focus{border-color:#742a2a}.focus\\:vc-border-orange-100:focus{border-color:#fffaf0}.focus\\:vc-border-orange-200:focus{border-color:#feebc8}.focus\\:vc-border-orange-300:focus{border-color:#fbd38d}.focus\\:vc-border-orange-400:focus{border-color:#f6ad55}.focus\\:vc-border-orange-500:focus{border-color:#ed8936}.focus\\:vc-border-orange-600:focus{border-color:#dd6b20}.focus\\:vc-border-orange-700:focus{border-color:#c05621}.focus\\:vc-border-orange-800:focus{border-color:#9c4221}.focus\\:vc-border-orange-900:focus{border-color:#7b341e}.focus\\:vc-border-yellow-100:focus{border-color:ivory}.focus\\:vc-border-yellow-200:focus{border-color:#fefcbf}.focus\\:vc-border-yellow-300:focus{border-color:#faf089}.focus\\:vc-border-yellow-400:focus{border-color:#f6e05e}.focus\\:vc-border-yellow-500:focus{border-color:#ecc94b}.focus\\:vc-border-yellow-600:focus{border-color:#d69e2e}.focus\\:vc-border-yellow-700:focus{border-color:#b7791f}.focus\\:vc-border-yellow-800:focus{border-color:#975a16}.focus\\:vc-border-yellow-900:focus{border-color:#744210}.focus\\:vc-border-green-100:focus{border-color:#f0fff4}.focus\\:vc-border-green-200:focus{border-color:#c6f6d5}.focus\\:vc-border-green-300:focus{border-color:#9ae6b4}.focus\\:vc-border-green-400:focus{border-color:#68d391}.focus\\:vc-border-green-500:focus{border-color:#48bb78}.focus\\:vc-border-green-600:focus{border-color:#38a169}.focus\\:vc-border-green-700:focus{border-color:#2f855a}.focus\\:vc-border-green-800:focus{border-color:#276749}.focus\\:vc-border-green-900:focus{border-color:#22543d}.focus\\:vc-border-teal-100:focus{border-color:#e6fffa}.focus\\:vc-border-teal-200:focus{border-color:#b2f5ea}.focus\\:vc-border-teal-300:focus{border-color:#81e6d9}.focus\\:vc-border-teal-400:focus{border-color:#4fd1c5}.focus\\:vc-border-teal-500:focus{border-color:#38b2ac}.focus\\:vc-border-teal-600:focus{border-color:#319795}.focus\\:vc-border-teal-700:focus{border-color:#2c7a7b}.focus\\:vc-border-teal-800:focus{border-color:#285e61}.focus\\:vc-border-teal-900:focus{border-color:#234e52}.focus\\:vc-border-blue-100:focus{border-color:#ebf8ff}.focus\\:vc-border-blue-200:focus{border-color:#bee3f8}.focus\\:vc-border-blue-300:focus{border-color:#90cdf4}.focus\\:vc-border-blue-400:focus{border-color:#63b3ed}.focus\\:vc-border-blue-500:focus{border-color:#4299e1}.focus\\:vc-border-blue-600:focus{border-color:#3182ce}.focus\\:vc-border-blue-700:focus{border-color:#2b6cb0}.focus\\:vc-border-blue-800:focus{border-color:#2c5282}.focus\\:vc-border-blue-900:focus{border-color:#2a4365}.focus\\:vc-border-indigo-100:focus{border-color:#ebf4ff}.focus\\:vc-border-indigo-200:focus{border-color:#c3dafe}.focus\\:vc-border-indigo-300:focus{border-color:#a3bffa}.focus\\:vc-border-indigo-400:focus{border-color:#7f9cf5}.focus\\:vc-border-indigo-500:focus{border-color:#667eea}.focus\\:vc-border-indigo-600:focus{border-color:#5a67d8}.focus\\:vc-border-indigo-700:focus{border-color:#4c51bf}.focus\\:vc-border-indigo-800:focus{border-color:#434190}.focus\\:vc-border-indigo-900:focus{border-color:#3c366b}.focus\\:vc-border-purple-100:focus{border-color:#faf5ff}.focus\\:vc-border-purple-200:focus{border-color:#e9d8fd}.focus\\:vc-border-purple-300:focus{border-color:#d6bcfa}.focus\\:vc-border-purple-400:focus{border-color:#b794f4}.focus\\:vc-border-purple-500:focus{border-color:#9f7aea}.focus\\:vc-border-purple-600:focus{border-color:#805ad5}.focus\\:vc-border-purple-700:focus{border-color:#6b46c1}.focus\\:vc-border-purple-800:focus{border-color:#553c9a}.focus\\:vc-border-purple-900:focus{border-color:#44337a}.focus\\:vc-border-pink-100:focus{border-color:#fff5f7}.focus\\:vc-border-pink-200:focus{border-color:#fed7e2}.focus\\:vc-border-pink-300:focus{border-color:#fbb6ce}.focus\\:vc-border-pink-400:focus{border-color:#f687b3}.focus\\:vc-border-pink-500:focus{border-color:#ed64a6}.focus\\:vc-border-pink-600:focus{border-color:#d53f8c}.focus\\:vc-border-pink-700:focus{border-color:#b83280}.focus\\:vc-border-pink-800:focus{border-color:#97266d}.focus\\:vc-border-pink-900:focus{border-color:#702459}.vc-rounded-none{border-radius:0}.vc-rounded-sm{border-radius:18px}.vc-rounded{border-radius:4px}.vc-rounded-lg{border-radius:8px}.vc-rounded-full{border-radius:9999px}.vc-rounded-t-none{border-top-left-radius:0;border-top-right-radius:0}.vc-rounded-r-none{border-top-right-radius:0;border-bottom-right-radius:0}.vc-rounded-b-none{border-bottom-right-radius:0;border-bottom-left-radius:0}.vc-rounded-l-none{border-top-left-radius:0;border-bottom-left-radius:0}.vc-rounded-t-sm{border-top-left-radius:18px;border-top-right-radius:18px}.vc-rounded-r-sm{border-top-right-radius:18px;border-bottom-right-radius:18px}.vc-rounded-b-sm{border-bottom-right-radius:18px;border-bottom-left-radius:18px}.vc-rounded-l-sm{border-top-left-radius:18px;border-bottom-left-radius:18px}.vc-rounded-t{border-top-left-radius:4px;border-top-right-radius:4px}.vc-rounded-r{border-top-right-radius:4px}.vc-rounded-b,.vc-rounded-r{border-bottom-right-radius:4px}.vc-rounded-b,.vc-rounded-l{border-bottom-left-radius:4px}.vc-rounded-l{border-top-left-radius:4px}.vc-rounded-t-lg{border-top-left-radius:8px;border-top-right-radius:8px}.vc-rounded-r-lg{border-top-right-radius:8px;border-bottom-right-radius:8px}.vc-rounded-b-lg{border-bottom-right-radius:8px;border-bottom-left-radius:8px}.vc-rounded-l-lg{border-top-left-radius:8px;border-bottom-left-radius:8px}.vc-rounded-t-full{border-top-left-radius:9999px;border-top-right-radius:9999px}.vc-rounded-r-full{border-top-right-radius:9999px;border-bottom-right-radius:9999px}.vc-rounded-b-full{border-bottom-right-radius:9999px;border-bottom-left-radius:9999px}.vc-rounded-l-full{border-top-left-radius:9999px;border-bottom-left-radius:9999px}.vc-rounded-tl-none{border-top-left-radius:0}.vc-rounded-tr-none{border-top-right-radius:0}.vc-rounded-br-none{border-bottom-right-radius:0}.vc-rounded-bl-none{border-bottom-left-radius:0}.vc-rounded-tl-sm{border-top-left-radius:18px}.vc-rounded-tr-sm{border-top-right-radius:18px}.vc-rounded-br-sm{border-bottom-right-radius:18px}.vc-rounded-bl-sm{border-bottom-left-radius:18px}.vc-rounded-tl{border-top-left-radius:4px}.vc-rounded-tr{border-top-right-radius:4px}.vc-rounded-br{border-bottom-right-radius:4px}.vc-rounded-bl{border-bottom-left-radius:4px}.vc-rounded-tl-lg{border-top-left-radius:8px}.vc-rounded-tr-lg{border-top-right-radius:8px}.vc-rounded-br-lg{border-bottom-right-radius:8px}.vc-rounded-bl-lg{border-bottom-left-radius:8px}.vc-rounded-tl-full{border-top-left-radius:9999px}.vc-rounded-tr-full{border-top-right-radius:9999px}.vc-rounded-br-full{border-bottom-right-radius:9999px}.vc-rounded-bl-full{border-bottom-left-radius:9999px}.vc-border-solid{border-style:solid}.vc-border-dashed{border-style:dashed}.vc-border-dotted{border-style:dotted}.vc-border-none{border-style:none}.vc-border-0{border-width:0}.vc-border-2{border-width:2px}.vc-border-4{border-width:4px}.vc-border-8{border-width:8px}.vc-border{border-width:1px}.vc-border-t-0{border-top-width:0}.vc-border-r-0{border-right-width:0}.vc-border-b-0{border-bottom-width:0}.vc-border-l-0{border-left-width:0}.vc-border-t-2{border-top-width:2px}.vc-border-r-2{border-right-width:2px}.vc-border-b-2{border-bottom-width:2px}.vc-border-l-2{border-left-width:2px}.vc-border-t-4{border-top-width:4px}.vc-border-r-4{border-right-width:4px}.vc-border-b-4{border-bottom-width:4px}.vc-border-l-4{border-left-width:4px}.vc-border-t-8{border-top-width:8px}.vc-border-r-8{border-right-width:8px}.vc-border-b-8{border-bottom-width:8px}.vc-border-l-8{border-left-width:8px}.vc-border-t{border-top-width:1px}.vc-border-r{border-right-width:1px}.vc-border-b{border-bottom-width:1px}.vc-border-l{border-left-width:1px}.vc-cursor-pointer{cursor:pointer}.vc-cursor-not-allowed{cursor:not-allowed}.vc-flex{display:flex}.vc-items-center{align-items:center}.vc-justify-center{justify-content:center}.vc-font-medium{font-weight:500}.vc-font-semibold{font-weight:600}.focus\\:vc-font-bold:focus,.vc-font-bold{font-weight:700}.vc-h-full{height:100%}.vc-leading-tight{line-height:1.25}.vc-leading-snug{line-height:1.375}.vc-mr-auto{margin-right:auto}.vc-ml-auto{margin-left:auto}.vc-min-w-full{min-width:100%}.vc-opacity-0{opacity:0}.vc-opacity-25{opacity:.25}.vc-opacity-75{opacity:.75}.hover\\:vc-opacity-50:hover{opacity:.5}.hover\\:vc-opacity-75:hover{opacity:.75}.focus\\:vc-outline-none:focus{outline:0}.vc-overflow-hidden{overflow:hidden}.vc-p-1{padding:4px}.vc-py-1{padding-top:4px;padding-bottom:4px}.vc-py-2{padding-top:8px;padding-bottom:8px}.vc-px-2{padding-left:8px;padding-right:8px}.vc-px-3{padding-left:12px;padding-right:12px}.vc-pointer-events-none{pointer-events:none}.vc-pointer-events-auto{pointer-events:auto}.vc-relative{position:relative}.vc-shadow{box-shadow:0 1px 3px 0 rgba(0,0,0,.1),0 1px 2px 0 rgba(0,0,0,.06)}.hover\\:vc-shadow-inner:hover{box-shadow:inset 0 2px 4px 0 rgba(0,0,0,.06)}.focus\\:vc-shadow-outline:focus{box-shadow:0 0 0 3px rgba(66,153,225,.5)}.vc-text-left{text-align:left}.vc-text-center{text-align:center}.vc-text-right{text-align:right}.vc-text-justify{text-align:justify}.vc-text-transparent{color:transparent}.vc-text-black{color:#000}.vc-text-white{color:#fff}.vc-text-gray-100{color:#f7fafc}.vc-text-gray-200{color:#edf2f7}.vc-text-gray-300{color:#e2e8f0}.vc-text-gray-400{color:#cbd5e0}.vc-text-gray-500{color:#a0aec0}.vc-text-gray-600{color:#718096}.vc-text-gray-700{color:#4a5568}.vc-text-gray-800{color:#2d3748}.vc-text-gray-900{color:#1a202c}.vc-text-red-100{color:#fff5f5}.vc-text-red-200{color:#fed7d7}.vc-text-red-300{color:#feb2b2}.vc-text-red-400{color:#fc8181}.vc-text-red-500{color:#f56565}.vc-text-red-600{color:#e53e3e}.vc-text-red-700{color:#c53030}.vc-text-red-800{color:#9b2c2c}.vc-text-red-900{color:#742a2a}.vc-text-orange-100{color:#fffaf0}.vc-text-orange-200{color:#feebc8}.vc-text-orange-300{color:#fbd38d}.vc-text-orange-400{color:#f6ad55}.vc-text-orange-500{color:#ed8936}.vc-text-orange-600{color:#dd6b20}.vc-text-orange-700{color:#c05621}.vc-text-orange-800{color:#9c4221}.vc-text-orange-900{color:#7b341e}.vc-text-yellow-100{color:ivory}.vc-text-yellow-200{color:#fefcbf}.vc-text-yellow-300{color:#faf089}.vc-text-yellow-400{color:#f6e05e}.vc-text-yellow-500{color:#ecc94b}.vc-text-yellow-600{color:#d69e2e}.vc-text-yellow-700{color:#b7791f}.vc-text-yellow-800{color:#975a16}.vc-text-yellow-900{color:#744210}.vc-text-green-100{color:#f0fff4}.vc-text-green-200{color:#c6f6d5}.vc-text-green-300{color:#9ae6b4}.vc-text-green-400{color:#68d391}.vc-text-green-500{color:#48bb78}.vc-text-green-600{color:#38a169}.vc-text-green-700{color:#2f855a}.vc-text-green-800{color:#276749}.vc-text-green-900{color:#22543d}.vc-text-teal-100{color:#e6fffa}.vc-text-teal-200{color:#b2f5ea}.vc-text-teal-300{color:#81e6d9}.vc-text-teal-400{color:#4fd1c5}.vc-text-teal-500{color:#38b2ac}.vc-text-teal-600{color:#319795}.vc-text-teal-700{color:#2c7a7b}.vc-text-teal-800{color:#285e61}.vc-text-teal-900{color:#234e52}.vc-text-blue-100{color:#ebf8ff}.vc-text-blue-200{color:#bee3f8}.vc-text-blue-300{color:#90cdf4}.vc-text-blue-400{color:#63b3ed}.vc-text-blue-500{color:#4299e1}.vc-text-blue-600{color:#3182ce}.vc-text-blue-700{color:#2b6cb0}.vc-text-blue-800{color:#2c5282}.vc-text-blue-900{color:#2a4365}.vc-text-indigo-100{color:#ebf4ff}.vc-text-indigo-200{color:#c3dafe}.vc-text-indigo-300{color:#a3bffa}.vc-text-indigo-400{color:#7f9cf5}.vc-text-indigo-500{color:#667eea}.vc-text-indigo-600{color:#5a67d8}.vc-text-indigo-700{color:#4c51bf}.vc-text-indigo-800{color:#434190}.vc-text-indigo-900{color:#3c366b}.vc-text-purple-100{color:#faf5ff}.vc-text-purple-200{color:#e9d8fd}.vc-text-purple-300{color:#d6bcfa}.vc-text-purple-400{color:#b794f4}.vc-text-purple-500{color:#9f7aea}.vc-text-purple-600{color:#805ad5}.vc-text-purple-700{color:#6b46c1}.vc-text-purple-800{color:#553c9a}.vc-text-purple-900{color:#44337a}.vc-text-pink-100{color:#fff5f7}.vc-text-pink-200{color:#fed7e2}.vc-text-pink-300{color:#fbb6ce}.vc-text-pink-400{color:#f687b3}.vc-text-pink-500{color:#ed64a6}.vc-text-pink-600{color:#d53f8c}.vc-text-pink-700{color:#b83280}.vc-text-pink-800{color:#97266d}.vc-text-pink-900{color:#702459}.hover\\:vc-text-transparent:hover{color:transparent}.hover\\:vc-text-black:hover{color:#000}.hover\\:vc-text-white:hover{color:#fff}.hover\\:vc-text-gray-100:hover{color:#f7fafc}.hover\\:vc-text-gray-200:hover{color:#edf2f7}.hover\\:vc-text-gray-300:hover{color:#e2e8f0}.hover\\:vc-text-gray-400:hover{color:#cbd5e0}.hover\\:vc-text-gray-500:hover{color:#a0aec0}.hover\\:vc-text-gray-600:hover{color:#718096}.hover\\:vc-text-gray-700:hover{color:#4a5568}.hover\\:vc-text-gray-800:hover{color:#2d3748}.hover\\:vc-text-gray-900:hover{color:#1a202c}.hover\\:vc-text-red-100:hover{color:#fff5f5}.hover\\:vc-text-red-200:hover{color:#fed7d7}.hover\\:vc-text-red-300:hover{color:#feb2b2}.hover\\:vc-text-red-400:hover{color:#fc8181}.hover\\:vc-text-red-500:hover{color:#f56565}.hover\\:vc-text-red-600:hover{color:#e53e3e}.hover\\:vc-text-red-700:hover{color:#c53030}.hover\\:vc-text-red-800:hover{color:#9b2c2c}.hover\\:vc-text-red-900:hover{color:#742a2a}.hover\\:vc-text-orange-100:hover{color:#fffaf0}.hover\\:vc-text-orange-200:hover{color:#feebc8}.hover\\:vc-text-orange-300:hover{color:#fbd38d}.hover\\:vc-text-orange-400:hover{color:#f6ad55}.hover\\:vc-text-orange-500:hover{color:#ed8936}.hover\\:vc-text-orange-600:hover{color:#dd6b20}.hover\\:vc-text-orange-700:hover{color:#c05621}.hover\\:vc-text-orange-800:hover{color:#9c4221}.hover\\:vc-text-orange-900:hover{color:#7b341e}.hover\\:vc-text-yellow-100:hover{color:ivory}.hover\\:vc-text-yellow-200:hover{color:#fefcbf}.hover\\:vc-text-yellow-300:hover{color:#faf089}.hover\\:vc-text-yellow-400:hover{color:#f6e05e}.hover\\:vc-text-yellow-500:hover{color:#ecc94b}.hover\\:vc-text-yellow-600:hover{color:#d69e2e}.hover\\:vc-text-yellow-700:hover{color:#b7791f}.hover\\:vc-text-yellow-800:hover{color:#975a16}.hover\\:vc-text-yellow-900:hover{color:#744210}.hover\\:vc-text-green-100:hover{color:#f0fff4}.hover\\:vc-text-green-200:hover{color:#c6f6d5}.hover\\:vc-text-green-300:hover{color:#9ae6b4}.hover\\:vc-text-green-400:hover{color:#68d391}.hover\\:vc-text-green-500:hover{color:#48bb78}.hover\\:vc-text-green-600:hover{color:#38a169}.hover\\:vc-text-green-700:hover{color:#2f855a}.hover\\:vc-text-green-800:hover{color:#276749}.hover\\:vc-text-green-900:hover{color:#22543d}.hover\\:vc-text-teal-100:hover{color:#e6fffa}.hover\\:vc-text-teal-200:hover{color:#b2f5ea}.hover\\:vc-text-teal-300:hover{color:#81e6d9}.hover\\:vc-text-teal-400:hover{color:#4fd1c5}.hover\\:vc-text-teal-500:hover{color:#38b2ac}.hover\\:vc-text-teal-600:hover{color:#319795}.hover\\:vc-text-teal-700:hover{color:#2c7a7b}.hover\\:vc-text-teal-800:hover{color:#285e61}.hover\\:vc-text-teal-900:hover{color:#234e52}.hover\\:vc-text-blue-100:hover{color:#ebf8ff}.hover\\:vc-text-blue-200:hover{color:#bee3f8}.hover\\:vc-text-blue-300:hover{color:#90cdf4}.hover\\:vc-text-blue-400:hover{color:#63b3ed}.hover\\:vc-text-blue-500:hover{color:#4299e1}.hover\\:vc-text-blue-600:hover{color:#3182ce}.hover\\:vc-text-blue-700:hover{color:#2b6cb0}.hover\\:vc-text-blue-800:hover{color:#2c5282}.hover\\:vc-text-blue-900:hover{color:#2a4365}.hover\\:vc-text-indigo-100:hover{color:#ebf4ff}.hover\\:vc-text-indigo-200:hover{color:#c3dafe}.hover\\:vc-text-indigo-300:hover{color:#a3bffa}.hover\\:vc-text-indigo-400:hover{color:#7f9cf5}.hover\\:vc-text-indigo-500:hover{color:#667eea}.hover\\:vc-text-indigo-600:hover{color:#5a67d8}.hover\\:vc-text-indigo-700:hover{color:#4c51bf}.hover\\:vc-text-indigo-800:hover{color:#434190}.hover\\:vc-text-indigo-900:hover{color:#3c366b}.hover\\:vc-text-purple-100:hover{color:#faf5ff}.hover\\:vc-text-purple-200:hover{color:#e9d8fd}.hover\\:vc-text-purple-300:hover{color:#d6bcfa}.hover\\:vc-text-purple-400:hover{color:#b794f4}.hover\\:vc-text-purple-500:hover{color:#9f7aea}.hover\\:vc-text-purple-600:hover{color:#805ad5}.hover\\:vc-text-purple-700:hover{color:#6b46c1}.hover\\:vc-text-purple-800:hover{color:#553c9a}.hover\\:vc-text-purple-900:hover{color:#44337a}.hover\\:vc-text-pink-100:hover{color:#fff5f7}.hover\\:vc-text-pink-200:hover{color:#fed7e2}.hover\\:vc-text-pink-300:hover{color:#fbb6ce}.hover\\:vc-text-pink-400:hover{color:#f687b3}.hover\\:vc-text-pink-500:hover{color:#ed64a6}.hover\\:vc-text-pink-600:hover{color:#d53f8c}.hover\\:vc-text-pink-700:hover{color:#b83280}.hover\\:vc-text-pink-800:hover{color:#97266d}.hover\\:vc-text-pink-900:hover{color:#702459}.vc-text-xs{font-size:12px}.vc-text-sm{font-size:14px}.vc-text-base{font-size:16px}.vc-text-lg{font-size:18px}.vc-text-xl{font-size:20px}.vc-text-2xl{font-size:24px}.vc-select-none{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.vc-w-12{width:48px}.vc-w-full{width:100%}@media (min-width:640px){.sm\\:vc-bg-fixed{background-attachment:fixed}.sm\\:vc-bg-local{background-attachment:local}.sm\\:vc-bg-scroll{background-attachment:scroll}.sm\\:vc-bg-bottom{background-position:bottom}.sm\\:vc-bg-center{background-position:50%}.sm\\:vc-bg-left{background-position:0}.sm\\:vc-bg-left-bottom{background-position:0 100%}.sm\\:vc-bg-left-top{background-position:0 0}.sm\\:vc-bg-right{background-position:100%}.sm\\:vc-bg-right-bottom{background-position:100% 100%}.sm\\:vc-bg-right-top{background-position:100% 0}.sm\\:vc-bg-top{background-position:top}.sm\\:vc-bg-repeat{background-repeat:repeat}.sm\\:vc-bg-no-repeat{background-repeat:no-repeat}.sm\\:vc-bg-repeat-x{background-repeat:repeat-x}.sm\\:vc-bg-repeat-y{background-repeat:repeat-y}.sm\\:vc-bg-repeat-round{background-repeat:round}.sm\\:vc-bg-repeat-space{background-repeat:space}.sm\\:vc-bg-auto{background-size:auto}.sm\\:vc-bg-cover{background-size:cover}.sm\\:vc-bg-contain{background-size:contain}.sm\\:vc-border-collapse{border-collapse:collapse}.sm\\:vc-border-separate{border-collapse:separate}.sm\\:vc-border-solid{border-style:solid}.sm\\:vc-border-dashed{border-style:dashed}.sm\\:vc-border-dotted{border-style:dotted}.sm\\:vc-border-none{border-style:none}.sm\\:vc-border-0{border-width:0}.sm\\:vc-border-2{border-width:2px}.sm\\:vc-border-4{border-width:4px}.sm\\:vc-border-8{border-width:8px}.sm\\:vc-border{border-width:1px}.sm\\:vc-border-t-0{border-top-width:0}.sm\\:vc-border-r-0{border-right-width:0}.sm\\:vc-border-b-0{border-bottom-width:0}.sm\\:vc-border-l-0{border-left-width:0}.sm\\:vc-border-t-2{border-top-width:2px}.sm\\:vc-border-r-2{border-right-width:2px}.sm\\:vc-border-b-2{border-bottom-width:2px}.sm\\:vc-border-l-2{border-left-width:2px}.sm\\:vc-border-t-4{border-top-width:4px}.sm\\:vc-border-r-4{border-right-width:4px}.sm\\:vc-border-b-4{border-bottom-width:4px}.sm\\:vc-border-l-4{border-left-width:4px}.sm\\:vc-border-t-8{border-top-width:8px}.sm\\:vc-border-r-8{border-right-width:8px}.sm\\:vc-border-b-8{border-bottom-width:8px}.sm\\:vc-border-l-8{border-left-width:8px}.sm\\:vc-border-t{border-top-width:1px}.sm\\:vc-border-r{border-right-width:1px}.sm\\:vc-border-b{border-bottom-width:1px}.sm\\:vc-border-l{border-left-width:1px}.sm\\:vc-text-left{text-align:left}.sm\\:vc-text-center{text-align:center}.sm\\:vc-text-right{text-align:right}.sm\\:vc-text-justify{text-align:justify}.sm\\:vc-text-xs{font-size:12px}.sm\\:vc-text-sm{font-size:14px}.sm\\:vc-text-base{font-size:16px}.sm\\:vc-text-lg{font-size:18px}.sm\\:vc-text-xl{font-size:20px}.sm\\:vc-text-2xl{font-size:24px}}@media (min-width:768px){.md\\:vc-bg-fixed{background-attachment:fixed}.md\\:vc-bg-local{background-attachment:local}.md\\:vc-bg-scroll{background-attachment:scroll}.md\\:vc-bg-bottom{background-position:bottom}.md\\:vc-bg-center{background-position:50%}.md\\:vc-bg-left{background-position:0}.md\\:vc-bg-left-bottom{background-position:0 100%}.md\\:vc-bg-left-top{background-position:0 0}.md\\:vc-bg-right{background-position:100%}.md\\:vc-bg-right-bottom{background-position:100% 100%}.md\\:vc-bg-right-top{background-position:100% 0}.md\\:vc-bg-top{background-position:top}.md\\:vc-bg-repeat{background-repeat:repeat}.md\\:vc-bg-no-repeat{background-repeat:no-repeat}.md\\:vc-bg-repeat-x{background-repeat:repeat-x}.md\\:vc-bg-repeat-y{background-repeat:repeat-y}.md\\:vc-bg-repeat-round{background-repeat:round}.md\\:vc-bg-repeat-space{background-repeat:space}.md\\:vc-bg-auto{background-size:auto}.md\\:vc-bg-cover{background-size:cover}.md\\:vc-bg-contain{background-size:contain}.md\\:vc-border-collapse{border-collapse:collapse}.md\\:vc-border-separate{border-collapse:separate}.md\\:vc-border-solid{border-style:solid}.md\\:vc-border-dashed{border-style:dashed}.md\\:vc-border-dotted{border-style:dotted}.md\\:vc-border-none{border-style:none}.md\\:vc-border-0{border-width:0}.md\\:vc-border-2{border-width:2px}.md\\:vc-border-4{border-width:4px}.md\\:vc-border-8{border-width:8px}.md\\:vc-border{border-width:1px}.md\\:vc-border-t-0{border-top-width:0}.md\\:vc-border-r-0{border-right-width:0}.md\\:vc-border-b-0{border-bottom-width:0}.md\\:vc-border-l-0{border-left-width:0}.md\\:vc-border-t-2{border-top-width:2px}.md\\:vc-border-r-2{border-right-width:2px}.md\\:vc-border-b-2{border-bottom-width:2px}.md\\:vc-border-l-2{border-left-width:2px}.md\\:vc-border-t-4{border-top-width:4px}.md\\:vc-border-r-4{border-right-width:4px}.md\\:vc-border-b-4{border-bottom-width:4px}.md\\:vc-border-l-4{border-left-width:4px}.md\\:vc-border-t-8{border-top-width:8px}.md\\:vc-border-r-8{border-right-width:8px}.md\\:vc-border-b-8{border-bottom-width:8px}.md\\:vc-border-l-8{border-left-width:8px}.md\\:vc-border-t{border-top-width:1px}.md\\:vc-border-r{border-right-width:1px}.md\\:vc-border-b{border-bottom-width:1px}.md\\:vc-border-l{border-left-width:1px}.md\\:vc-text-left{text-align:left}.md\\:vc-text-center{text-align:center}.md\\:vc-text-right{text-align:right}.md\\:vc-text-justify{text-align:justify}.md\\:vc-text-xs{font-size:12px}.md\\:vc-text-sm{font-size:14px}.md\\:vc-text-base{font-size:16px}.md\\:vc-text-lg{font-size:18px}.md\\:vc-text-xl{font-size:20px}.md\\:vc-text-2xl{font-size:24px}}@media (min-width:1024px){.lg\\:vc-bg-fixed{background-attachment:fixed}.lg\\:vc-bg-local{background-attachment:local}.lg\\:vc-bg-scroll{background-attachment:scroll}.lg\\:vc-bg-bottom{background-position:bottom}.lg\\:vc-bg-center{background-position:50%}.lg\\:vc-bg-left{background-position:0}.lg\\:vc-bg-left-bottom{background-position:0 100%}.lg\\:vc-bg-left-top{background-position:0 0}.lg\\:vc-bg-right{background-position:100%}.lg\\:vc-bg-right-bottom{background-position:100% 100%}.lg\\:vc-bg-right-top{background-position:100% 0}.lg\\:vc-bg-top{background-position:top}.lg\\:vc-bg-repeat{background-repeat:repeat}.lg\\:vc-bg-no-repeat{background-repeat:no-repeat}.lg\\:vc-bg-repeat-x{background-repeat:repeat-x}.lg\\:vc-bg-repeat-y{background-repeat:repeat-y}.lg\\:vc-bg-repeat-round{background-repeat:round}.lg\\:vc-bg-repeat-space{background-repeat:space}.lg\\:vc-bg-auto{background-size:auto}.lg\\:vc-bg-cover{background-size:cover}.lg\\:vc-bg-contain{background-size:contain}.lg\\:vc-border-collapse{border-collapse:collapse}.lg\\:vc-border-separate{border-collapse:separate}.lg\\:vc-border-solid{border-style:solid}.lg\\:vc-border-dashed{border-style:dashed}.lg\\:vc-border-dotted{border-style:dotted}.lg\\:vc-border-none{border-style:none}.lg\\:vc-border-0{border-width:0}.lg\\:vc-border-2{border-width:2px}.lg\\:vc-border-4{border-width:4px}.lg\\:vc-border-8{border-width:8px}.lg\\:vc-border{border-width:1px}.lg\\:vc-border-t-0{border-top-width:0}.lg\\:vc-border-r-0{border-right-width:0}.lg\\:vc-border-b-0{border-bottom-width:0}.lg\\:vc-border-l-0{border-left-width:0}.lg\\:vc-border-t-2{border-top-width:2px}.lg\\:vc-border-r-2{border-right-width:2px}.lg\\:vc-border-b-2{border-bottom-width:2px}.lg\\:vc-border-l-2{border-left-width:2px}.lg\\:vc-border-t-4{border-top-width:4px}.lg\\:vc-border-r-4{border-right-width:4px}.lg\\:vc-border-b-4{border-bottom-width:4px}.lg\\:vc-border-l-4{border-left-width:4px}.lg\\:vc-border-t-8{border-top-width:8px}.lg\\:vc-border-r-8{border-right-width:8px}.lg\\:vc-border-b-8{border-bottom-width:8px}.lg\\:vc-border-l-8{border-left-width:8px}.lg\\:vc-border-t{border-top-width:1px}.lg\\:vc-border-r{border-right-width:1px}.lg\\:vc-border-b{border-bottom-width:1px}.lg\\:vc-border-l{border-left-width:1px}.lg\\:vc-text-left{text-align:left}.lg\\:vc-text-center{text-align:center}.lg\\:vc-text-right{text-align:right}.lg\\:vc-text-justify{text-align:justify}.lg\\:vc-text-xs{font-size:12px}.lg\\:vc-text-sm{font-size:14px}.lg\\:vc-text-base{font-size:16px}.lg\\:vc-text-lg{font-size:18px}.lg\\:vc-text-xl{font-size:20px}.lg\\:vc-text-2xl{font-size:24px}}@media (min-width:1280px){.xl\\:vc-bg-fixed{background-attachment:fixed}.xl\\:vc-bg-local{background-attachment:local}.xl\\:vc-bg-scroll{background-attachment:scroll}.xl\\:vc-bg-bottom{background-position:bottom}.xl\\:vc-bg-center{background-position:50%}.xl\\:vc-bg-left{background-position:0}.xl\\:vc-bg-left-bottom{background-position:0 100%}.xl\\:vc-bg-left-top{background-position:0 0}.xl\\:vc-bg-right{background-position:100%}.xl\\:vc-bg-right-bottom{background-position:100% 100%}.xl\\:vc-bg-right-top{background-position:100% 0}.xl\\:vc-bg-top{background-position:top}.xl\\:vc-bg-repeat{background-repeat:repeat}.xl\\:vc-bg-no-repeat{background-repeat:no-repeat}.xl\\:vc-bg-repeat-x{background-repeat:repeat-x}.xl\\:vc-bg-repeat-y{background-repeat:repeat-y}.xl\\:vc-bg-repeat-round{background-repeat:round}.xl\\:vc-bg-repeat-space{background-repeat:space}.xl\\:vc-bg-auto{background-size:auto}.xl\\:vc-bg-cover{background-size:cover}.xl\\:vc-bg-contain{background-size:contain}.xl\\:vc-border-collapse{border-collapse:collapse}.xl\\:vc-border-separate{border-collapse:separate}.xl\\:vc-border-solid{border-style:solid}.xl\\:vc-border-dashed{border-style:dashed}.xl\\:vc-border-dotted{border-style:dotted}.xl\\:vc-border-none{border-style:none}.xl\\:vc-border-0{border-width:0}.xl\\:vc-border-2{border-width:2px}.xl\\:vc-border-4{border-width:4px}.xl\\:vc-border-8{border-width:8px}.xl\\:vc-border{border-width:1px}.xl\\:vc-border-t-0{border-top-width:0}.xl\\:vc-border-r-0{border-right-width:0}.xl\\:vc-border-b-0{border-bottom-width:0}.xl\\:vc-border-l-0{border-left-width:0}.xl\\:vc-border-t-2{border-top-width:2px}.xl\\:vc-border-r-2{border-right-width:2px}.xl\\:vc-border-b-2{border-bottom-width:2px}.xl\\:vc-border-l-2{border-left-width:2px}.xl\\:vc-border-t-4{border-top-width:4px}.xl\\:vc-border-r-4{border-right-width:4px}.xl\\:vc-border-b-4{border-bottom-width:4px}.xl\\:vc-border-l-4{border-left-width:4px}.xl\\:vc-border-t-8{border-top-width:8px}.xl\\:vc-border-r-8{border-right-width:8px}.xl\\:vc-border-b-8{border-bottom-width:8px}.xl\\:vc-border-l-8{border-left-width:8px}.xl\\:vc-border-t{border-top-width:1px}.xl\\:vc-border-r{border-right-width:1px}.xl\\:vc-border-b{border-bottom-width:1px}.xl\\:vc-border-l{border-left-width:1px}.xl\\:vc-text-left{text-align:left}.xl\\:vc-text-center{text-align:center}.xl\\:vc-text-right{text-align:right}.xl\\:vc-text-justify{text-align:justify}.xl\\:vc-text-xs{font-size:12px}.xl\\:vc-text-sm{font-size:14px}.xl\\:vc-text-base{font-size:16px}.xl\\:vc-text-lg{font-size:18px}.xl\\:vc-text-xl{font-size:20px}.xl\\:vc-text-2xl{font-size:24px}}",""]);},f4d6:function(e,t,r){var o=r("ffd6"),n=1/0;function c(e){if("string"==typeof e||o(e))return e;var t=e+"";return "0"==t&&1/e==-n?"-0":t}e.exports=c;},f4d9:function(e,t){var r="\\ud800-\\udfff",o="\\u0300-\\u036f",n="\\ufe20-\\ufe2f",c="\\u20d0-\\u20ff",i=o+n+c,a="\\u2700-\\u27bf",s="a-z\\xdf-\\xf6\\xf8-\\xff",u="\\xac\\xb1\\xd7\\xf7",d="\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf",l="\\u2000-\\u206f",f=" \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",v="A-Z\\xc0-\\xd6\\xd8-\\xde",b="\\ufe0e\\ufe0f",h=u+d+l+f,p="['’]",g="["+h+"]",y="["+i+"]",m="\\d+",x="["+a+"]",w="["+s+"]",k="[^"+r+h+m+a+s+v+"]",O="\\ud83c[\\udffb-\\udfff]",j="(?:"+y+"|"+O+")",D="[^"+r+"]",_="(?:\\ud83c[\\udde6-\\uddff]){2}",P="[\\ud800-\\udbff][\\udc00-\\udfff]",M="["+v+"]",S="\\u200d",E="(?:"+w+"|"+k+")",C="(?:"+M+"|"+k+")",I="(?:"+p+"(?:d|ll|m|re|s|t|ve))?",A="(?:"+p+"(?:D|LL|M|RE|S|T|VE))?",Y=j+"?",T="["+b+"]?",L="(?:"+S+"(?:"+[D,_,P].join("|")+")"+T+Y+")*",F="\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])",N="\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])",z=T+Y+L,$="(?:"+[x,_,P].join("|")+")"+z,R=RegExp([M+"?"+w+"+"+I+"(?="+[g,M,"$"].join("|")+")",C+"+"+A+"(?="+[g,M+E,"$"].join("|")+")",M+"?"+E+"+"+I,M+"+"+A,N,F,m,$].join("|"),"g");function V(e){return e.match(R)||[]}e.exports=V;},f542:function(e,t,r){var o=r("ec47"),n=r("ec69"),c=o(n);e.exports=c;},f605:function(e,t){e.exports=function(e,t,r,o){if(!(e instanceof t)||void 0!==o&&o in e)throw TypeError(r+": incorrect invocation!");return e};},f608:function(e,t,r){var o=r("6747"),n=r("ffd6"),c=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,i=/^\w*$/;function a(e,t){if(o(e))return !1;var r=typeof e;return !("number"!=r&&"symbol"!=r&&"boolean"!=r&&null!=e&&!n(e))||(i.test(e)||!c.test(e)||null!=t&&e in Object(t))}e.exports=a;},f678:function(e,t,r){var o=r("8384"),n=r("b4b0");function c(e,t,r){return void 0===r&&(r=t,t=void 0),void 0!==r&&(r=n(r),r=r===r?r:0),void 0!==t&&(t=n(t),t=t===t?t:0),o(n(e),t,r)}e.exports=c;},f6fd:function(e,t){(function(e){var t="currentScript",r=e.getElementsByTagName("script");t in e||Object.defineProperty(e,t,{get:function(){try{throw new Error}catch(o){var e,t=(/.*at [^\(]*\((.*):.+:.+\)$/gi.exec(o.stack)||[!1])[1];for(e in r)if(r[e].src==t||"interactive"==r[e].readyState)return r[e];return null}}});})(document);},f772:function(e,t){e.exports=function(e){return "object"===typeof e?null!==e:"function"===typeof e};},f8af:function(e,t,r){var o=r("2474");function n(e){var t=new e.constructor(e.byteLength);return new o(t).set(new o(e)),t}e.exports=n;},f909:function(e,t,r){var o=r("7e64"),n=r("b760"),c=r("72af"),i=r("4f50"),a=r("1a8c"),s=r("9934"),u=r("8adb");function d(e,t,r,l,f){e!==t&&c(t,function(c,s){if(f||(f=new o),a(c))i(e,t,s,r,d,l,f);else {var v=l?l(u(e,s),c,s+"",e,t,f):void 0;void 0===v&&(v=c),n(e,s,v);}},s);}e.exports=d;},f9ce:function(e,t,r){var o=r("ef5d"),n=r("e3f8"),c=r("f608"),i=r("f4d6");function a(e){return c(e)?o(i(e)):n(e)}e.exports=a;},fa21:function(e,t,r){var o=r("7530"),n=r("2dcb"),c=r("eac5");function i(e){return "function"!=typeof e.constructor||c(e)?{}:o(n(e))}e.exports=i;},fa5b:function(e,t,r){e.exports=r("5537")("native-function-to-string",Function.toString);},fab2:function(e,t,r){var o=r("7726").document;e.exports=o&&o.documentElement;},fb15:function(e,t,r){var o;(r.r(t),"undefined"!==typeof window)&&(r("f6fd"),(o=window.document.currentScript)&&(o=o.src.match(/(.+\/)[^\/]+\.js(\?.*)?$/))&&(r.p=o[1]));var n=r("34e9");r.d(t,"setupCalendar",function(){return n["f"]}),r.d(t,"Calendar",function(){return n["a"]}),r.d(t,"DatePicker",function(){return n["b"]}),r.d(t,"Popover",function(){return n["c"]}),r.d(t,"PopoverRef",function(){return n["d"]});t["default"]=n["e"];},fba5:function(e,t,r){var o=r("cb5a");function n(e){return o(this.__data__,e)>-1}e.exports=n;},fdef:function(e,t){e.exports="\t\n\v\f\r   ᠎             　\u2028\u2029\ufeff";},ffd6:function(e,t,r){var o=r("3729"),n=r("1310"),c="[object Symbol]";function i(e){return "symbol"==typeof e||n(e)&&o(e)==c}e.exports=i;}})});

}(vCalendar_umd_min));

var VCalendar = /*@__PURE__*/getDefaultExportFromCjs(vCalendar_umd_min.exports);

var e="undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{};function r(){throw new Error("setTimeout has not been defined")}function n(){throw new Error("clearTimeout has not been defined")}var i=r,o=n;function a(t){if(i===setTimeout)return setTimeout(t,0);if((i===r||!i)&&setTimeout)return i=setTimeout,setTimeout(t,0);try{return i(t,0)}catch(e){try{return i.call(null,t,0)}catch(e){return i.call(this,t,0)}}}"function"==typeof e.setTimeout&&(i=setTimeout),"function"==typeof e.clearTimeout&&(o=clearTimeout);var s,l=[],c=!1,u=-1;function h(){c&&s&&(c=!1,s.length?l=s.concat(l):u=-1,l.length&&p());}function p(){if(!c){var t=a(h);c=!0;for(var e=l.length;e;){for(s=l,l=[];++u<e;)s&&s[u].run();u=-1,e=l.length;}s=null,c=!1,function(t){if(o===clearTimeout)return clearTimeout(t);if((o===n||!o)&&clearTimeout)return o=clearTimeout,clearTimeout(t);try{return o(t)}catch(e){try{return o.call(null,t)}catch(e){return o.call(this,t)}}}(t);}}function f(t,e){this.fun=t,this.array=e;}f.prototype.run=function(){this.fun.apply(null,this.array);};function d(){}var g=d,m=d,v=d,y=d,_=d,b=d,k=d;var w=e.performance||{},S=w.now||w.mozNow||w.msNow||w.oNow||w.webkitNow||function(){return (new Date).getTime()};var P=new Date;var E={nextTick:function(t){var e=new Array(arguments.length-1);if(arguments.length>1)for(var r=1;r<arguments.length;r++)e[r-1]=arguments[r];l.push(new f(t,e)),1!==l.length||c||a(p);},title:"browser",browser:!0,env:{},argv:[],version:"",versions:{},on:g,addListener:m,once:v,off:y,removeListener:_,removeAllListeners:b,emit:k,binding:function(t){throw new Error("process.binding is not supported")},cwd:function(){return "/"},chdir:function(t){throw new Error("process.chdir is not supported")},umask:function(){return 0},hrtime:function(t){var e=.001*S.call(w),r=Math.floor(e),n=Math.floor(e%1*1e9);return t&&(r-=t[0],(n-=t[1])<0&&(r--,n+=1e9)),[r,n]},platform:"browser",release:{},config:{},uptime:function(){return (new Date-P)/1e3}},x=["compactDisplay","currency","currencyDisplay","currencySign","localeMatcher","notation","numberingSystem","signDisplay","style","unit","unitDisplay","useGrouping","minimumIntegerDigits","minimumFractionDigits","maximumFractionDigits","minimumSignificantDigits","maximumSignificantDigits"],C=["dateStyle","timeStyle","calendar","localeMatcher","hour12","hourCycle","timeZone","formatMatcher","weekday","era","year","month","day","hour","minute","second","timeZoneName"];
/*!
 * vue-i18n v8.28.2 
 * (c) 2022 kazuya kawaguchi
 * Released under the MIT License.
 */function I(t,e){"undefined"!=typeof console&&(console.warn("[vue-i18n] "+t),e&&console.warn(e.stack));}function O(t,e){"undefined"!=typeof console&&(console.error("[vue-i18n] "+t),e&&console.error(e.stack));}var N=Array.isArray;function L(t){return null!==t&&"object"==typeof t}function A(t){return "string"==typeof t}var T=Object.prototype.toString,M="[object Object]";function D(t){return T.call(t)===M}function R(t){return null==t}function F(t){return "function"==typeof t}function B(){for(var t=[],e=arguments.length;e--;)t[e]=arguments[e];var r=null,n=null;return 1===t.length?L(t[0])||N(t[0])?n=t[0]:"string"==typeof t[0]&&(r=t[0]):2===t.length&&("string"==typeof t[0]&&(r=t[0]),(L(t[1])||N(t[1]))&&(n=t[1])),{locale:r,params:n}}function $$1(t){return JSON.parse(JSON.stringify(t))}function j(t,e){return !!~t.indexOf(e)}var H=Object.prototype.hasOwnProperty;function V(t,e){return H.call(t,e)}function U(t){for(var e=arguments,r=Object(t),n=1;n<arguments.length;n++){var i=e[n];if(null!=i){var o=void 0;for(o in i)V(i,o)&&(L(i[o])?r[o]=U(r[o],i[o]):r[o]=i[o]);}}return r}function W(t,e){if(t===e)return !0;var r=L(t),n=L(e);if(!r||!n)return !r&&!n&&String(t)===String(e);try{var i=N(t),o=N(e);if(i&&o)return t.length===e.length&&t.every((function(t,r){return W(t,e[r])}));if(i||o)return !1;var a=Object.keys(t),s=Object.keys(e);return a.length===s.length&&a.every((function(r){return W(t[r],e[r])}))}catch(t){return !1}}var Y={name:"i18n",functional:!0,props:{tag:{type:[String,Boolean,Object],default:"span"},path:{type:String,required:!0},locale:{type:String},places:{type:[Array,Object]}},render:function(t,e){var r=e.data,n=e.parent,i=e.props,o=e.slots,a=n.$i18n;if(a){var s=i.path,l=i.locale,c=i.places,u=o(),h=a.i(s,l,function(t){var e;for(e in t)if("default"!==e)return !1;return Boolean(e)}(u)||c?function(t,e){var r=e?function(t){"production"!==E.env.NODE_ENV&&I("`places` prop is deprecated in next major version. Please switch to Vue slots.");return Array.isArray(t)?t.reduce(q$1,{}):Object.assign({},t)}(e):{};if(!t)return r;t=t.filter((function(t){return t.tag||""!==t.text.trim()}));var n=t.every(K);"production"!==E.env.NODE_ENV&&n&&I("`place` attribute is deprecated in next major version. Please switch to Vue slots.");return t.reduce(n?z:q$1,r)}(u.default,c):u),p=i.tag&&!0!==i.tag||!1===i.tag?i.tag:"span";return p?t(p,r,h):h}"production"!==E.env.NODE_ENV&&I("Cannot find VueI18n instance!");}};function z(t,e){return e.data&&e.data.attrs&&e.data.attrs.place&&(t[e.data.attrs.place]=e),t}function q$1(t,e,r){return t[r]=e,t}function K(t){return Boolean(t.data&&t.data.attrs&&t.data.attrs.place)}var J,G={name:"i18n-n",functional:!0,props:{tag:{type:[String,Boolean,Object],default:"span"},value:{type:Number,required:!0},format:{type:[String,Object]},locale:{type:String}},render:function(t,e){var r=e.props,n=e.parent,i=e.data,o=n.$i18n;if(!o)return "production"!==E.env.NODE_ENV&&I("Cannot find VueI18n instance!"),null;var a=null,s=null;A(r.format)?a=r.format:L(r.format)&&(r.format.key&&(a=r.format.key),s=Object.keys(r.format).reduce((function(t,e){var n;return j(x,e)?Object.assign({},t,((n={})[e]=r.format[e],n)):t}),null));var l=r.locale||o.locale,c=o._ntp(r.value,l,a,s),u=c.map((function(t,e){var r,n=i.scopedSlots&&i.scopedSlots[t.type];return n?n(((r={})[t.type]=t.value,r.index=e,r.parts=c,r)):t.value})),h=r.tag&&!0!==r.tag||!1===r.tag?r.tag:"span";return h?t(h,{attrs:i.attrs,class:i.class,staticClass:i.staticClass},u):u}};function Z(t,e,r){tt(t,r)&&et(t,e,r);}function X(t,e,r,n){if(tt(t,r)){var i=r.context.$i18n;(function(t,e){var r=e.context;return t._locale===r.$i18n.locale})(t,r)&&W(e.value,e.oldValue)&&W(t._localeMessage,i.getLocaleMessage(i.locale))||et(t,e,r);}}function Q(t,e,r,n){if(r.context){var i=r.context.$i18n||{};e.modifiers.preserve||i.preserveDirectiveContent||(t.textContent=""),t._vt=void 0,delete t._vt,t._locale=void 0,delete t._locale,t._localeMessage=void 0,delete t._localeMessage;}else I("Vue instance does not exists in VNode context");}function tt(t,e){var r=e.context;return r?!!r.$i18n||(I("VueI18n instance does not exists in Vue instance"),!1):(I("Vue instance does not exists in VNode context"),!1)}function et(t,e,r){var n,i,o=function(t){var e,r,n,i;A(t)?e=t:D(t)&&(e=t.path,r=t.locale,n=t.args,i=t.choice);return {path:e,locale:r,args:n,choice:i}}(e.value),a=o.path,s=o.locale,l=o.args,c=o.choice;if(a||s||l)if(a){var u=r.context;t._vt=t.textContent=null!=c?(n=u.$i18n).tc.apply(n,[a,c].concat(rt(s,l))):(i=u.$i18n).t.apply(i,[a].concat(rt(s,l))),t._locale=u.$i18n.locale,t._localeMessage=u.$i18n.getLocaleMessage(u.$i18n.locale);}else I("`path` is required in v-t directive");else I("value type not supported");}function rt(t,e){var r=[];return t&&r.push(t),e&&(Array.isArray(e)||D(e))&&r.push(e),r}function nt(t,e){if(void 0===e&&(e={bridge:!1}),"production"!==E.env.NODE_ENV&&nt.installed&&t===J)I("already installed.");else {nt.installed=!0;var r=(J=t).version&&Number(J.version.split(".")[0])||-1;if("production"!==E.env.NODE_ENV&&r<2)I("vue-i18n ("+nt.version+") need to use Vue 2.0 or later (Vue: "+J.version+").");else !function(t){t.prototype.hasOwnProperty("$i18n")||Object.defineProperty(t.prototype,"$i18n",{get:function(){return this._i18n}}),t.prototype.$t=function(t){for(var e=[],r=arguments.length-1;r-- >0;)e[r]=arguments[r+1];var n=this.$i18n;return n._t.apply(n,[t,n.locale,n._getMessages(),this].concat(e))},t.prototype.$tc=function(t,e){for(var r=[],n=arguments.length-2;n-- >0;)r[n]=arguments[n+2];var i=this.$i18n;return i._tc.apply(i,[t,i.locale,i._getMessages(),this,e].concat(r))},t.prototype.$te=function(t,e){var r=this.$i18n;return r._te(t,r.locale,r._getMessages(),e)},t.prototype.$d=function(t){for(var e,r=[],n=arguments.length-1;n-- >0;)r[n]=arguments[n+1];return (e=this.$i18n).d.apply(e,[t].concat(r))},t.prototype.$n=function(t){for(var e,r=[],n=arguments.length-1;n-- >0;)r[n]=arguments[n+1];return (e=this.$i18n).n.apply(e,[t].concat(r))};}(J),J.mixin(function(t){function e(){this!==this.$root&&this.$options.__INTLIFY_META__&&this.$el&&this.$el.setAttribute("data-intlify",this.$options.__INTLIFY_META__);}return void 0===t&&(t=!1),t?{mounted:e}:{beforeCreate:function(){var t=this.$options;if(t.i18n=t.i18n||(t.__i18nBridge||t.__i18n?{}:null),t.i18n)if(t.i18n instanceof Ot){if(t.__i18nBridge||t.__i18n)try{var e=t.i18n&&t.i18n.messages?t.i18n.messages:{};(t.__i18nBridge||t.__i18n).forEach((function(t){e=U(e,JSON.parse(t));})),Object.keys(e).forEach((function(r){t.i18n.mergeLocaleMessage(r,e[r]);}));}catch(t){"production"!==E.env.NODE_ENV&&O("Cannot parse locale messages via custom blocks.",t);}this._i18n=t.i18n,this._i18nWatcher=this._i18n.watchI18nData();}else if(D(t.i18n)){var r=this.$root&&this.$root.$i18n&&this.$root.$i18n instanceof Ot?this.$root.$i18n:null;if(r&&(t.i18n.root=this.$root,t.i18n.formatter=r.formatter,t.i18n.fallbackLocale=r.fallbackLocale,t.i18n.formatFallbackMessages=r.formatFallbackMessages,t.i18n.silentTranslationWarn=r.silentTranslationWarn,t.i18n.silentFallbackWarn=r.silentFallbackWarn,t.i18n.pluralizationRules=r.pluralizationRules,t.i18n.preserveDirectiveContent=r.preserveDirectiveContent),t.__i18nBridge||t.__i18n)try{var n=t.i18n&&t.i18n.messages?t.i18n.messages:{};(t.__i18nBridge||t.__i18n).forEach((function(t){n=U(n,JSON.parse(t));})),t.i18n.messages=n;}catch(t){"production"!==E.env.NODE_ENV&&I("Cannot parse locale messages via custom blocks.",t);}var i=t.i18n.sharedMessages;i&&D(i)&&(t.i18n.messages=U(t.i18n.messages,i)),this._i18n=new Ot(t.i18n),this._i18nWatcher=this._i18n.watchI18nData(),(void 0===t.i18n.sync||t.i18n.sync)&&(this._localeWatcher=this.$i18n.watchLocale()),r&&r.onComponentInstanceCreated(this._i18n);}else "production"!==E.env.NODE_ENV&&I("Cannot be interpreted 'i18n' option.");else this.$root&&this.$root.$i18n&&this.$root.$i18n instanceof Ot?this._i18n=this.$root.$i18n:t.parent&&t.parent.$i18n&&t.parent.$i18n instanceof Ot&&(this._i18n=t.parent.$i18n);},beforeMount:function(){var t=this.$options;t.i18n=t.i18n||(t.__i18nBridge||t.__i18n?{}:null),t.i18n?t.i18n instanceof Ot||D(t.i18n)?(this._i18n.subscribeDataChanging(this),this._subscribing=!0):"production"!==E.env.NODE_ENV&&I("Cannot be interpreted 'i18n' option."):(this.$root&&this.$root.$i18n&&this.$root.$i18n instanceof Ot||t.parent&&t.parent.$i18n&&t.parent.$i18n instanceof Ot)&&(this._i18n.subscribeDataChanging(this),this._subscribing=!0);},mounted:e,beforeDestroy:function(){if(this._i18n){var t=this;this.$nextTick((function(){t._subscribing&&(t._i18n.unsubscribeDataChanging(t),delete t._subscribing),t._i18nWatcher&&(t._i18nWatcher(),t._i18n.destroyVM(),delete t._i18nWatcher),t._localeWatcher&&(t._localeWatcher(),delete t._localeWatcher);}));}}}}(e.bridge)),J.directive("t",{bind:Z,update:X,unbind:Q}),J.component(Y.name,Y),J.component(G.name,G),J.config.optionMergeStrategies.i18n=function(t,e){return void 0===e?t:e};}}var it=function(){this._caches=Object.create(null);};it.prototype.interpolate=function(t,e){if(!e)return [t];var r=this._caches[t];return r||(r=function(t){var e=[],r=0,n="";for(;r<t.length;){var i=t[r++];if("{"===i){n&&e.push({type:"text",value:n}),n="";var o="";for(i=t[r++];void 0!==i&&"}"!==i;)o+=i,i=t[r++];var a="}"===i,s=ot.test(o)?"list":a&&at.test(o)?"named":"unknown";e.push({value:o,type:s});}else "%"===i?"{"!==t[r]&&(n+=i):n+=i;}return n&&e.push({type:"text",value:n}),e}(t),this._caches[t]=r),function(t,e){var r=[],n=0,i=Array.isArray(e)?"list":L(e)?"named":"unknown";if("unknown"===i)return r;for(;n<t.length;){var o=t[n];switch(o.type){case"text":r.push(o.value);break;case"list":r.push(e[parseInt(o.value,10)]);break;case"named":"named"===i?r.push(e[o.value]):"production"!==E.env.NODE_ENV&&I("Type of token '"+o.type+"' and format of value '"+i+"' don't match!");break;case"unknown":"production"!==E.env.NODE_ENV&&I("Detect 'unknown' type of token!");}n++;}return r}(r,e)};var ot=/^(?:\d)+/,at=/^(?:\w)+/;var st=0,lt=1,ct=2,ut=3,ht=0,pt$1=4,ft=5,dt=6,gt=7,mt=8,vt=[];vt[ht]={ws:[ht],ident:[3,st],"[":[pt$1],eof:[gt]},vt[1]={ws:[1],".":[2],"[":[pt$1],eof:[gt]},vt[2]={ws:[2],ident:[3,st],0:[3,st],number:[3,st]},vt[3]={ident:[3,st],0:[3,st],number:[3,st],ws:[1,lt],".":[2,lt],"[":[pt$1,lt],eof:[gt,lt]},vt[pt$1]={"'":[ft,st],'"':[dt,st],"[":[pt$1,ct],"]":[1,ut],eof:mt,else:[pt$1,st]},vt[ft]={"'":[pt$1,st],eof:mt,else:[ft,st]},vt[dt]={'"':[pt$1,st],eof:mt,else:[dt,st]};var yt=/^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;function _t(t){if(null==t)return "eof";switch(t.charCodeAt(0)){case 91:case 93:case 46:case 34:case 39:return t;case 95:case 36:case 45:return "ident";case 9:case 10:case 13:case 160:case 65279:case 8232:case 8233:return "ws"}return "ident"}function bt(t){var e,r,n,i=t.trim();return ("0"!==t.charAt(0)||!isNaN(t))&&(n=i,yt.test(n)?(r=(e=i).charCodeAt(0))!==e.charCodeAt(e.length-1)||34!==r&&39!==r?e:e.slice(1,-1):"*"+i)}var kt=function(){this._cache=Object.create(null);};kt.prototype.parsePath=function(t){var e=this._cache[t];return e||(e=function(t){var e,r,n,i,o,a,s,l=[],c=-1,u=ht,h=0,p=[];function f(){var e=t[c+1];if(u===ft&&"'"===e||u===dt&&'"'===e)return c++,n="\\"+e,p[st](),!0}for(p[lt]=function(){void 0!==r&&(l.push(r),r=void 0);},p[st]=function(){void 0===r?r=n:r+=n;},p[ct]=function(){p[st](),h++;},p[ut]=function(){if(h>0)h--,u=pt$1,p[st]();else {if(h=0,void 0===r)return !1;if(!1===(r=bt(r)))return !1;p[lt]();}};null!==u;)if(c++,"\\"!==(e=t[c])||!f()){if(i=_t(e),(o=(s=vt[u])[i]||s.else||mt)===mt)return;if(u=o[0],(a=p[o[1]])&&(n=void 0===(n=o[2])?e:n,!1===a()))return;if(u===gt)return l}}(t),e&&(this._cache[t]=e)),e||[]},kt.prototype.getPathValue=function(t,e){if(!L(t))return null;var r=this.parsePath(e);if(0===r.length)return null;for(var n=r.length,i=t,o=0;o<n;){var a=i[r[o]];if(null==a)return null;i=a,o++;}return i};var wt,St=/<\/?[\w\s="/.':;#-\/]+>/,Pt=/(?:@(?:\.[a-zA-Z]+)?:(?:[\w\-_|./]+|\([\w\-_:|./]+\)))/g,Et=/^@(?:\.([a-zA-Z]+))?:/,xt=/[()]/g,Ct={upper:function(t){return t.toLocaleUpperCase()},lower:function(t){return t.toLocaleLowerCase()},capitalize:function(t){return ""+t.charAt(0).toLocaleUpperCase()+t.substr(1)}},It=new it,Ot=function(t){var e=this;void 0===t&&(t={}),!J&&"undefined"!=typeof window&&window.Vue&&nt(window.Vue);var r=t.locale||"en-US",n=!1!==t.fallbackLocale&&(t.fallbackLocale||"en-US"),i=t.messages||{},o=t.dateTimeFormats||t.datetimeFormats||{},a=t.numberFormats||{};this._vm=null,this._formatter=t.formatter||It,this._modifiers=t.modifiers||{},this._missing=t.missing||null,this._root=t.root||null,this._sync=void 0===t.sync||!!t.sync,this._fallbackRoot=void 0===t.fallbackRoot||!!t.fallbackRoot,this._fallbackRootWithEmptyString=void 0===t.fallbackRootWithEmptyString||!!t.fallbackRootWithEmptyString,this._formatFallbackMessages=void 0!==t.formatFallbackMessages&&!!t.formatFallbackMessages,this._silentTranslationWarn=void 0!==t.silentTranslationWarn&&t.silentTranslationWarn,this._silentFallbackWarn=void 0!==t.silentFallbackWarn&&!!t.silentFallbackWarn,this._dateTimeFormatters={},this._numberFormatters={},this._path=new kt,this._dataListeners=new Set,this._componentInstanceCreatedListener=t.componentInstanceCreatedListener||null,this._preserveDirectiveContent=void 0!==t.preserveDirectiveContent&&!!t.preserveDirectiveContent,this.pluralizationRules=t.pluralizationRules||{},this._warnHtmlInMessage=t.warnHtmlInMessage||"off",this._postTranslation=t.postTranslation||null,this._escapeParameterHtml=t.escapeParameterHtml||!1,"__VUE_I18N_BRIDGE__"in t&&(this.__VUE_I18N_BRIDGE__=t.__VUE_I18N_BRIDGE__),this.getChoiceIndex=function(t,r){var n=Object.getPrototypeOf(e);if(n&&n.getChoiceIndex)return n.getChoiceIndex.call(e,t,r);var i,o;return e.locale in e.pluralizationRules?e.pluralizationRules[e.locale].apply(e,[t,r]):(i=t,o=r,i=Math.abs(i),2===o?i?i>1?1:0:1:i?Math.min(i,2):0)},this._exist=function(t,r){return !(!t||!r)&&(!R(e._path.getPathValue(t,r))||!!t[r])},"warn"!==this._warnHtmlInMessage&&"error"!==this._warnHtmlInMessage||Object.keys(i).forEach((function(t){e._checkLocaleMessage(t,e._warnHtmlInMessage,i[t]);})),this._initVM({locale:r,fallbackLocale:n,messages:i,dateTimeFormats:o,numberFormats:a});},Nt={vm:{configurable:!0},messages:{configurable:!0},dateTimeFormats:{configurable:!0},numberFormats:{configurable:!0},availableLocales:{configurable:!0},locale:{configurable:!0},fallbackLocale:{configurable:!0},formatFallbackMessages:{configurable:!0},missing:{configurable:!0},formatter:{configurable:!0},silentTranslationWarn:{configurable:!0},silentFallbackWarn:{configurable:!0},preserveDirectiveContent:{configurable:!0},warnHtmlInMessage:{configurable:!0},postTranslation:{configurable:!0},sync:{configurable:!0}};Ot.prototype._checkLocaleMessage=function(t,e,r){var n=function(t,e,r,i){if(D(r))Object.keys(r).forEach((function(o){var a=r[o];D(a)?(i.push(o),i.push("."),n(t,e,a,i),i.pop(),i.pop()):(i.push(o),n(t,e,a,i),i.pop());}));else if(N(r))r.forEach((function(r,o){D(r)?(i.push("["+o+"]"),i.push("."),n(t,e,r,i),i.pop(),i.pop()):(i.push("["+o+"]"),n(t,e,r,i),i.pop());}));else if(A(r)){if(St.test(r)){var o="Detected HTML in message '"+r+"' of keypath '"+i.join("")+"' at '"+e+"'. Consider component interpolation with '<i18n>' to avoid XSS. See https://bit.ly/2ZqJzkp";"warn"===t?I(o):"error"===t&&O(o);}}};n(e,t,r,[]);},Ot.prototype._initVM=function(t){var e=J.config.silent;J.config.silent=!0,this._vm=new J({data:t,__VUE18N__INSTANCE__:!0}),J.config.silent=e;},Ot.prototype.destroyVM=function(){this._vm.$destroy();},Ot.prototype.subscribeDataChanging=function(t){this._dataListeners.add(t);},Ot.prototype.unsubscribeDataChanging=function(t){!function(t,e){if(t.delete(e));}(this._dataListeners,t);},Ot.prototype.watchI18nData=function(){var t=this;return this._vm.$watch("$data",(function(){for(var e,r,n=(e=t._dataListeners,r=[],e.forEach((function(t){return r.push(t)})),r),i=n.length;i--;)J.nextTick((function(){n[i]&&n[i].$forceUpdate();}));}),{deep:!0})},Ot.prototype.watchLocale=function(t){if(t){if(!this.__VUE_I18N_BRIDGE__)return null;var e=this,r=this._vm;return this.vm.$watch("locale",(function(n){r.$set(r,"locale",n),e.__VUE_I18N_BRIDGE__&&t&&(t.locale.value=n),r.$forceUpdate();}),{immediate:!0})}if(!this._sync||!this._root)return null;var n=this._vm;return this._root.$i18n.vm.$watch("locale",(function(t){n.$set(n,"locale",t),n.$forceUpdate();}),{immediate:!0})},Ot.prototype.onComponentInstanceCreated=function(t){this._componentInstanceCreatedListener&&this._componentInstanceCreatedListener(t,this);},Nt.vm.get=function(){return this._vm},Nt.messages.get=function(){return $$1(this._getMessages())},Nt.dateTimeFormats.get=function(){return $$1(this._getDateTimeFormats())},Nt.numberFormats.get=function(){return $$1(this._getNumberFormats())},Nt.availableLocales.get=function(){return Object.keys(this.messages).sort()},Nt.locale.get=function(){return this._vm.locale},Nt.locale.set=function(t){this._vm.$set(this._vm,"locale",t);},Nt.fallbackLocale.get=function(){return this._vm.fallbackLocale},Nt.fallbackLocale.set=function(t){this._localeChainCache={},this._vm.$set(this._vm,"fallbackLocale",t);},Nt.formatFallbackMessages.get=function(){return this._formatFallbackMessages},Nt.formatFallbackMessages.set=function(t){this._formatFallbackMessages=t;},Nt.missing.get=function(){return this._missing},Nt.missing.set=function(t){this._missing=t;},Nt.formatter.get=function(){return this._formatter},Nt.formatter.set=function(t){this._formatter=t;},Nt.silentTranslationWarn.get=function(){return this._silentTranslationWarn},Nt.silentTranslationWarn.set=function(t){this._silentTranslationWarn=t;},Nt.silentFallbackWarn.get=function(){return this._silentFallbackWarn},Nt.silentFallbackWarn.set=function(t){this._silentFallbackWarn=t;},Nt.preserveDirectiveContent.get=function(){return this._preserveDirectiveContent},Nt.preserveDirectiveContent.set=function(t){this._preserveDirectiveContent=t;},Nt.warnHtmlInMessage.get=function(){return this._warnHtmlInMessage},Nt.warnHtmlInMessage.set=function(t){var e=this,r=this._warnHtmlInMessage;if(this._warnHtmlInMessage=t,r!==t&&("warn"===t||"error"===t)){var n=this._getMessages();Object.keys(n).forEach((function(t){e._checkLocaleMessage(t,e._warnHtmlInMessage,n[t]);}));}},Nt.postTranslation.get=function(){return this._postTranslation},Nt.postTranslation.set=function(t){this._postTranslation=t;},Nt.sync.get=function(){return this._sync},Nt.sync.set=function(t){this._sync=t;},Ot.prototype._getMessages=function(){return this._vm.messages},Ot.prototype._getDateTimeFormats=function(){return this._vm.dateTimeFormats},Ot.prototype._getNumberFormats=function(){return this._vm.numberFormats},Ot.prototype._warnDefault=function(t,e,r,n,i,o){if(!R(r))return r;if(this._missing){var a=this._missing.apply(null,[t,e,n,i]);if(A(a))return a}else "production"===E.env.NODE_ENV||this._isSilentTranslationWarn(e)||I("Cannot translate the value of keypath '"+e+"'. Use the value of keypath as default.");if(this._formatFallbackMessages){var s=B.apply(void 0,i);return this._render(e,o,s.params,e)}return e},Ot.prototype._isFallbackRoot=function(t){return (this._fallbackRootWithEmptyString?!t:R(t))&&!R(this._root)&&this._fallbackRoot},Ot.prototype._isSilentFallbackWarn=function(t){return this._silentFallbackWarn instanceof RegExp?this._silentFallbackWarn.test(t):this._silentFallbackWarn},Ot.prototype._isSilentFallback=function(t,e){return this._isSilentFallbackWarn(e)&&(this._isFallbackRoot()||t!==this.fallbackLocale)},Ot.prototype._isSilentTranslationWarn=function(t){return this._silentTranslationWarn instanceof RegExp?this._silentTranslationWarn.test(t):this._silentTranslationWarn},Ot.prototype._interpolate=function(t,e,r,n,i,o,a){if(!e)return null;var s,l=this._path.getPathValue(e,r);if(N(l)||D(l))return l;if(R(l)){if(!D(e))return null;if(!A(s=e[r])&&!F(s))return "production"===E.env.NODE_ENV||this._isSilentTranslationWarn(r)||this._isSilentFallback(t,r)||I("Value of key '"+r+"' is not a string or function !"),null}else {if(!A(l)&&!F(l))return "production"===E.env.NODE_ENV||this._isSilentTranslationWarn(r)||this._isSilentFallback(t,r)||I("Value of key '"+r+"' is not a string or function!"),null;s=l;}return A(s)&&(s.indexOf("@:")>=0||s.indexOf("@.")>=0)&&(s=this._link(t,e,s,n,"raw",o,a)),this._render(s,i,o,r)},Ot.prototype._link=function(t,e,r,n,i,o,a){var s=r,l=s.match(Pt);for(var c in l)if(l.hasOwnProperty(c)){var u=l[c],h=u.match(Et),p=h[0],f=h[1],d=u.replace(p,"").replace(xt,"");if(j(a,d))return "production"!==E.env.NODE_ENV&&I('Circular reference found. "'+u+'" is already visited in the chain of '+a.reverse().join(" <- ")),s;a.push(d);var g=this._interpolate(t,e,d,n,"raw"===i?"string":i,"raw"===i?void 0:o,a);if(this._isFallbackRoot(g)){if("production"===E.env.NODE_ENV||this._isSilentTranslationWarn(d)||I("Fall back to translate the link placeholder '"+d+"' with root locale."),!this._root)throw Error("unexpected error");var m=this._root.$i18n;g=m._translate(m._getMessages(),m.locale,m.fallbackLocale,d,n,i,o);}g=this._warnDefault(t,d,g,n,N(o)?o:[o],i),this._modifiers.hasOwnProperty(f)?g=this._modifiers[f](g):Ct.hasOwnProperty(f)&&(g=Ct[f](g)),a.pop(),s=g?s.replace(u,g):s;}return s},Ot.prototype._createMessageContext=function(t,e,r,n){var i=this,o=N(t)?t:[],a=L(t)?t:{},s=this._getMessages(),l=this.locale;return {list:function(t){return o[t]},named:function(t){return a[t]},values:t,formatter:e,path:r,messages:s,locale:l,linked:function(t){return i._interpolate(l,s[l]||{},t,null,n,void 0,[t])}}},Ot.prototype._render=function(t,e,r,n){if(F(t))return t(this._createMessageContext(r,this._formatter||It,n,e));var i=this._formatter.interpolate(t,r,n);return i||(i=It.interpolate(t,r,n)),"string"!==e||A(i)?i:i.join("")},Ot.prototype._appendItemToChain=function(t,e,r){var n=!1;return j(t,e)||(n=!0,e&&(n="!"!==e[e.length-1],e=e.replace(/!/g,""),t.push(e),r&&r[e]&&(n=r[e]))),n},Ot.prototype._appendLocaleToChain=function(t,e,r){var n,i=e.split("-");do{var o=i.join("-");n=this._appendItemToChain(t,o,r),i.splice(-1,1);}while(i.length&&!0===n);return n},Ot.prototype._appendBlockToChain=function(t,e,r){for(var n=!0,i=0;i<e.length&&"boolean"==typeof n;i++){var o=e[i];A(o)&&(n=this._appendLocaleToChain(t,o,r));}return n},Ot.prototype._getLocaleChain=function(t,e){if(""===t)return [];this._localeChainCache||(this._localeChainCache={});var r=this._localeChainCache[t];if(!r){e||(e=this.fallbackLocale),r=[];for(var n,i=[t];N(i);)i=this._appendBlockToChain(r,i,e);(i=A(n=N(e)?e:L(e)?e.default?e.default:null:e)?[n]:n)&&this._appendBlockToChain(r,i,null),this._localeChainCache[t]=r;}return r},Ot.prototype._translate=function(t,e,r,n,i,o,a){for(var s,l=this._getLocaleChain(e,r),c=0;c<l.length;c++){var u=l[c];if(!R(s=this._interpolate(u,t[u],n,i,o,a,[n])))return u===e||"production"===E.env.NODE_ENV||this._isSilentTranslationWarn(n)||this._isSilentFallbackWarn(n)||I("Fall back to translate the keypath '"+n+"' with '"+u+"' locale."),s}return null},Ot.prototype._t=function(t,e,r,n){for(var i,o=[],a=arguments.length-4;a-- >0;)o[a]=arguments[a+4];if(!t)return "";var s,l=B.apply(void 0,o);this._escapeParameterHtml&&(l.params=(null!=(s=l.params)&&Object.keys(s).forEach((function(t){"string"==typeof s[t]&&(s[t]=s[t].replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&apos;"));})),s));var c=l.locale||e,u=this._translate(r,c,this.fallbackLocale,t,n,"string",l.params);if(this._isFallbackRoot(u)){if("production"===E.env.NODE_ENV||this._isSilentTranslationWarn(t)||this._isSilentFallbackWarn(t)||I("Fall back to translate the keypath '"+t+"' with root locale."),!this._root)throw Error("unexpected error");return (i=this._root).$t.apply(i,[t].concat(o))}return u=this._warnDefault(c,t,u,n,o,"string"),this._postTranslation&&null!=u&&(u=this._postTranslation(u,t)),u},Ot.prototype.t=function(t){for(var e,r=[],n=arguments.length-1;n-- >0;)r[n]=arguments[n+1];return (e=this)._t.apply(e,[t,this.locale,this._getMessages(),null].concat(r))},Ot.prototype._i=function(t,e,r,n,i){var o=this._translate(r,e,this.fallbackLocale,t,n,"raw",i);if(this._isFallbackRoot(o)){if("production"===E.env.NODE_ENV||this._isSilentTranslationWarn(t)||I("Fall back to interpolate the keypath '"+t+"' with root locale."),!this._root)throw Error("unexpected error");return this._root.$i18n.i(t,e,i)}return this._warnDefault(e,t,o,n,[i],"raw")},Ot.prototype.i=function(t,e,r){return t?(A(e)||(e=this.locale),this._i(t,e,this._getMessages(),null,r)):""},Ot.prototype._tc=function(t,e,r,n,i){for(var o,a=[],s=arguments.length-5;s-- >0;)a[s]=arguments[s+5];if(!t)return "";void 0===i&&(i=1);var l={count:i,n:i},c=B.apply(void 0,a);return c.params=Object.assign(l,c.params),a=null===c.locale?[c.params]:[c.locale,c.params],this.fetchChoice((o=this)._t.apply(o,[t,e,r,n].concat(a)),i)},Ot.prototype.fetchChoice=function(t,e){if(!t||!A(t))return null;var r=t.split("|");return r[e=this.getChoiceIndex(e,r.length)]?r[e].trim():t},Ot.prototype.tc=function(t,e){for(var r,n=[],i=arguments.length-2;i-- >0;)n[i]=arguments[i+2];return (r=this)._tc.apply(r,[t,this.locale,this._getMessages(),null,e].concat(n))},Ot.prototype._te=function(t,e,r){for(var n=[],i=arguments.length-3;i-- >0;)n[i]=arguments[i+3];var o=B.apply(void 0,n).locale||e;return this._exist(r[o],t)},Ot.prototype.te=function(t,e){return this._te(t,this.locale,this._getMessages(),e)},Ot.prototype.getLocaleMessage=function(t){return $$1(this._vm.messages[t]||{})},Ot.prototype.setLocaleMessage=function(t,e){"warn"!==this._warnHtmlInMessage&&"error"!==this._warnHtmlInMessage||this._checkLocaleMessage(t,this._warnHtmlInMessage,e),this._vm.$set(this._vm.messages,t,e);},Ot.prototype.mergeLocaleMessage=function(t,e){"warn"!==this._warnHtmlInMessage&&"error"!==this._warnHtmlInMessage||this._checkLocaleMessage(t,this._warnHtmlInMessage,e),this._vm.$set(this._vm.messages,t,U(void 0!==this._vm.messages[t]&&Object.keys(this._vm.messages[t]).length?Object.assign({},this._vm.messages[t]):{},e));},Ot.prototype.getDateTimeFormat=function(t){return $$1(this._vm.dateTimeFormats[t]||{})},Ot.prototype.setDateTimeFormat=function(t,e){this._vm.$set(this._vm.dateTimeFormats,t,e),this._clearDateTimeFormat(t,e);},Ot.prototype.mergeDateTimeFormat=function(t,e){this._vm.$set(this._vm.dateTimeFormats,t,U(this._vm.dateTimeFormats[t]||{},e)),this._clearDateTimeFormat(t,e);},Ot.prototype._clearDateTimeFormat=function(t,e){for(var r in e){var n=t+"__"+r;this._dateTimeFormatters.hasOwnProperty(n)&&delete this._dateTimeFormatters[n];}},Ot.prototype._localizeDateTime=function(t,e,r,n,i,o){for(var a=e,s=n[a],l=this._getLocaleChain(e,r),c=0;c<l.length;c++){var u=a,h=l[c];if(a=h,!R(s=n[h])&&!R(s[i]))break;h===e||"production"===E.env.NODE_ENV||this._isSilentTranslationWarn(i)||this._isSilentFallbackWarn(i)||I("Fall back to '"+h+"' datetime formats from '"+u+"' datetime formats.");}if(R(s)||R(s[i]))return null;var p,f=s[i];if(o)p=new Intl.DateTimeFormat(a,Object.assign({},f,o));else {var d=a+"__"+i;(p=this._dateTimeFormatters[d])||(p=this._dateTimeFormatters[d]=new Intl.DateTimeFormat(a,f));}return p.format(t)},Ot.prototype._d=function(t,e,r,n){if("production"!==E.env.NODE_ENV&&!Ot.availabilities.dateTimeFormat)return I("Cannot format a Date value due to not supported Intl.DateTimeFormat."),"";if(!r)return (n?new Intl.DateTimeFormat(e,n):new Intl.DateTimeFormat(e)).format(t);var i=this._localizeDateTime(t,e,this.fallbackLocale,this._getDateTimeFormats(),r,n);if(this._isFallbackRoot(i)){if("production"===E.env.NODE_ENV||this._isSilentTranslationWarn(r)||this._isSilentFallbackWarn(r)||I("Fall back to datetime localization of root: key '"+r+"'."),!this._root)throw Error("unexpected error");return this._root.$i18n.d(t,r,e)}return i||""},Ot.prototype.d=function(t){for(var e=[],r=arguments.length-1;r-- >0;)e[r]=arguments[r+1];var n=this.locale,i=null,o=null;return 1===e.length?(A(e[0])?i=e[0]:L(e[0])&&(e[0].locale&&(n=e[0].locale),e[0].key&&(i=e[0].key)),o=Object.keys(e[0]).reduce((function(t,r){var n;return j(C,r)?Object.assign({},t,((n={})[r]=e[0][r],n)):t}),null)):2===e.length&&(A(e[0])&&(i=e[0]),A(e[1])&&(n=e[1])),this._d(t,n,i,o)},Ot.prototype.getNumberFormat=function(t){return $$1(this._vm.numberFormats[t]||{})},Ot.prototype.setNumberFormat=function(t,e){this._vm.$set(this._vm.numberFormats,t,e),this._clearNumberFormat(t,e);},Ot.prototype.mergeNumberFormat=function(t,e){this._vm.$set(this._vm.numberFormats,t,U(this._vm.numberFormats[t]||{},e)),this._clearNumberFormat(t,e);},Ot.prototype._clearNumberFormat=function(t,e){for(var r in e){var n=t+"__"+r;this._numberFormatters.hasOwnProperty(n)&&delete this._numberFormatters[n];}},Ot.prototype._getNumberFormatter=function(t,e,r,n,i,o){for(var a=e,s=n[a],l=this._getLocaleChain(e,r),c=0;c<l.length;c++){var u=a,h=l[c];if(a=h,!R(s=n[h])&&!R(s[i]))break;h===e||"production"===E.env.NODE_ENV||this._isSilentTranslationWarn(i)||this._isSilentFallbackWarn(i)||I("Fall back to '"+h+"' number formats from '"+u+"' number formats.");}if(R(s)||R(s[i]))return null;var p,f=s[i];if(o)p=new Intl.NumberFormat(a,Object.assign({},f,o));else {var d=a+"__"+i;(p=this._numberFormatters[d])||(p=this._numberFormatters[d]=new Intl.NumberFormat(a,f));}return p},Ot.prototype._n=function(t,e,r,n){if(!Ot.availabilities.numberFormat)return "production"!==E.env.NODE_ENV&&I("Cannot format a Number value due to not supported Intl.NumberFormat."),"";if(!r)return (n?new Intl.NumberFormat(e,n):new Intl.NumberFormat(e)).format(t);var i=this._getNumberFormatter(t,e,this.fallbackLocale,this._getNumberFormats(),r,n),o=i&&i.format(t);if(this._isFallbackRoot(o)){if("production"===E.env.NODE_ENV||this._isSilentTranslationWarn(r)||this._isSilentFallbackWarn(r)||I("Fall back to number localization of root: key '"+r+"'."),!this._root)throw Error("unexpected error");return this._root.$i18n.n(t,Object.assign({},{key:r,locale:e},n))}return o||""},Ot.prototype.n=function(t){for(var e=[],r=arguments.length-1;r-- >0;)e[r]=arguments[r+1];var n=this.locale,i=null,o=null;return 1===e.length?A(e[0])?i=e[0]:L(e[0])&&(e[0].locale&&(n=e[0].locale),e[0].key&&(i=e[0].key),o=Object.keys(e[0]).reduce((function(t,r){var n;return j(x,r)?Object.assign({},t,((n={})[r]=e[0][r],n)):t}),null)):2===e.length&&(A(e[0])&&(i=e[0]),A(e[1])&&(n=e[1])),this._n(t,n,i,o)},Ot.prototype._ntp=function(t,e,r,n){if(!Ot.availabilities.numberFormat)return "production"!==E.env.NODE_ENV&&I("Cannot format to parts a Number value due to not supported Intl.NumberFormat."),[];if(!r)return (n?new Intl.NumberFormat(e,n):new Intl.NumberFormat(e)).formatToParts(t);var i=this._getNumberFormatter(t,e,this.fallbackLocale,this._getNumberFormats(),r,n),o=i&&i.formatToParts(t);if(this._isFallbackRoot(o)){if("production"===E.env.NODE_ENV||this._isSilentTranslationWarn(r)||I("Fall back to format number to parts of root: key '"+r+"' ."),!this._root)throw Error("unexpected error");return this._root.$i18n._ntp(t,e,r,n)}return o||[]},Object.defineProperties(Ot.prototype,Nt),Object.defineProperty(Ot,"availabilities",{get:function(){if(!wt){var t="undefined"!=typeof Intl;wt={dateTimeFormat:t&&void 0!==Intl.DateTimeFormat,numberFormat:t&&void 0!==Intl.NumberFormat};}return wt}}),Ot.install=nt,Ot.version="8.28.2";var At=[],Tt=[],Mt="undefined"!=typeof Uint8Array?Uint8Array:Array,Dt=!1;function Rt(){Dt=!0;for(var t="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",e=0,r=t.length;e<r;++e)At[e]=t[e],Tt[t.charCodeAt(e)]=e;Tt["-".charCodeAt(0)]=62,Tt["_".charCodeAt(0)]=63;}function Ft(t,e,r){for(var n,i,o=[],a=e;a<r;a+=3)n=(t[a]<<16)+(t[a+1]<<8)+t[a+2],o.push(At[(i=n)>>18&63]+At[i>>12&63]+At[i>>6&63]+At[63&i]);return o.join("")}function Bt(t){var e;Dt||Rt();for(var r=t.length,n=r%3,i="",o=[],a=16383,s=0,l=r-n;s<l;s+=a)o.push(Ft(t,s,s+a>l?l:s+a));return 1===n?(e=t[r-1],i+=At[e>>2],i+=At[e<<4&63],i+="=="):2===n&&(e=(t[r-2]<<8)+t[r-1],i+=At[e>>10],i+=At[e>>4&63],i+=At[e<<2&63],i+="="),o.push(i),o.join("")}function $t(t,e,r,n,i){var o,a,s=8*i-n-1,l=(1<<s)-1,c=l>>1,u=-7,h=r?i-1:0,p=r?-1:1,f=t[e+h];for(h+=p,o=f&(1<<-u)-1,f>>=-u,u+=s;u>0;o=256*o+t[e+h],h+=p,u-=8);for(a=o&(1<<-u)-1,o>>=-u,u+=n;u>0;a=256*a+t[e+h],h+=p,u-=8);if(0===o)o=1-c;else {if(o===l)return a?NaN:1/0*(f?-1:1);a+=Math.pow(2,n),o-=c;}return (f?-1:1)*a*Math.pow(2,o-n)}function jt(t,e,r,n,i,o){var a,s,l,c=8*o-i-1,u=(1<<c)-1,h=u>>1,p=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,f=n?0:o-1,d=n?1:-1,g=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(s=isNaN(e)?1:0,a=u):(a=Math.floor(Math.log(e)/Math.LN2),e*(l=Math.pow(2,-a))<1&&(a--,l*=2),(e+=a+h>=1?p/l:p*Math.pow(2,1-h))*l>=2&&(a++,l/=2),a+h>=u?(s=0,a=u):a+h>=1?(s=(e*l-1)*Math.pow(2,i),a+=h):(s=e*Math.pow(2,h-1)*Math.pow(2,i),a=0));i>=8;t[r+f]=255&s,f+=d,s/=256,i-=8);for(a=a<<i|s,c+=i;c>0;t[r+f]=255&a,f+=d,a/=256,c-=8);t[r+f-d]|=128*g;}var Ht={}.toString,Vt=Array.isArray||function(t){return "[object Array]"==Ht.call(t)};function Ut(){return Yt.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function Wt(t,e){if(Ut()<e)throw new RangeError("Invalid typed array length");return Yt.TYPED_ARRAY_SUPPORT?(t=new Uint8Array(e)).__proto__=Yt.prototype:(null===t&&(t=new Yt(e)),t.length=e),t}function Yt(t,e,r){if(!(Yt.TYPED_ARRAY_SUPPORT||this instanceof Yt))return new Yt(t,e,r);if("number"==typeof t){if("string"==typeof e)throw new Error("If encoding is specified then the first argument must be a string");return Kt(this,t)}return zt(this,t,e,r)}function zt(t,e,r,n){if("number"==typeof e)throw new TypeError('"value" argument must not be a number');return "undefined"!=typeof ArrayBuffer&&e instanceof ArrayBuffer?function(t,e,r,n){if(e.byteLength,r<0||e.byteLength<r)throw new RangeError("'offset' is out of bounds");if(e.byteLength<r+(n||0))throw new RangeError("'length' is out of bounds");e=void 0===r&&void 0===n?new Uint8Array(e):void 0===n?new Uint8Array(e,r):new Uint8Array(e,r,n);Yt.TYPED_ARRAY_SUPPORT?(t=e).__proto__=Yt.prototype:t=Jt(t,e);return t}(t,e,r,n):"string"==typeof e?function(t,e,r){"string"==typeof r&&""!==r||(r="utf8");if(!Yt.isEncoding(r))throw new TypeError('"encoding" must be a valid string encoding');var n=0|Xt(e,r);t=Wt(t,n);var i=t.write(e,r);i!==n&&(t=t.slice(0,i));return t}(t,e,r):function(t,e){if(Zt(e)){var r=0|Gt(e.length);return 0===(t=Wt(t,r)).length||e.copy(t,0,0,r),t}if(e){if("undefined"!=typeof ArrayBuffer&&e.buffer instanceof ArrayBuffer||"length"in e)return "number"!=typeof e.length||(n=e.length)!=n?Wt(t,0):Jt(t,e);if("Buffer"===e.type&&Vt(e.data))return Jt(t,e.data)}var n;throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}(t,e)}function qt(t){if("number"!=typeof t)throw new TypeError('"size" argument must be a number');if(t<0)throw new RangeError('"size" argument must not be negative')}function Kt(t,e){if(qt(e),t=Wt(t,e<0?0:0|Gt(e)),!Yt.TYPED_ARRAY_SUPPORT)for(var r=0;r<e;++r)t[r]=0;return t}function Jt(t,e){var r=e.length<0?0:0|Gt(e.length);t=Wt(t,r);for(var n=0;n<r;n+=1)t[n]=255&e[n];return t}function Gt(t){if(t>=Ut())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+Ut().toString(16)+" bytes");return 0|t}function Zt(t){return !(null==t||!t._isBuffer)}function Xt(t,e){if(Zt(t))return t.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(t)||t instanceof ArrayBuffer))return t.byteLength;"string"!=typeof t&&(t=""+t);var r=t.length;if(0===r)return 0;for(var n=!1;;)switch(e){case"ascii":case"latin1":case"binary":return r;case"utf8":case"utf-8":case void 0:return Ee(t).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*r;case"hex":return r>>>1;case"base64":return xe(t).length;default:if(n)return Ee(t).length;e=(""+e).toLowerCase(),n=!0;}}function Qt(t,e,r){var n=!1;if((void 0===e||e<0)&&(e=0),e>this.length)return "";if((void 0===r||r>this.length)&&(r=this.length),r<=0)return "";if((r>>>=0)<=(e>>>=0))return "";for(t||(t="utf8");;)switch(t){case"hex":return de(this,e,r);case"utf8":case"utf-8":return ue(this,e,r);case"ascii":return pe(this,e,r);case"latin1":case"binary":return fe(this,e,r);case"base64":return ce(this,e,r);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return ge(this,e,r);default:if(n)throw new TypeError("Unknown encoding: "+t);t=(t+"").toLowerCase(),n=!0;}}function te(t,e,r){var n=t[e];t[e]=t[r],t[r]=n;}function ee(t,e,r,n,i){if(0===t.length)return -1;if("string"==typeof r?(n=r,r=0):r>2147483647?r=2147483647:r<-2147483648&&(r=-2147483648),r=+r,isNaN(r)&&(r=i?0:t.length-1),r<0&&(r=t.length+r),r>=t.length){if(i)return -1;r=t.length-1;}else if(r<0){if(!i)return -1;r=0;}if("string"==typeof e&&(e=Yt.from(e,n)),Zt(e))return 0===e.length?-1:re(t,e,r,n,i);if("number"==typeof e)return e&=255,Yt.TYPED_ARRAY_SUPPORT&&"function"==typeof Uint8Array.prototype.indexOf?i?Uint8Array.prototype.indexOf.call(t,e,r):Uint8Array.prototype.lastIndexOf.call(t,e,r):re(t,[e],r,n,i);throw new TypeError("val must be string, number or Buffer")}function re(t,e,r,n,i){var o,a=1,s=t.length,l=e.length;if(void 0!==n&&("ucs2"===(n=String(n).toLowerCase())||"ucs-2"===n||"utf16le"===n||"utf-16le"===n)){if(t.length<2||e.length<2)return -1;a=2,s/=2,l/=2,r/=2;}function c(t,e){return 1===a?t[e]:t.readUInt16BE(e*a)}if(i){var u=-1;for(o=r;o<s;o++)if(c(t,o)===c(e,-1===u?0:o-u)){if(-1===u&&(u=o),o-u+1===l)return u*a}else -1!==u&&(o-=o-u),u=-1;}else for(r+l>s&&(r=s-l),o=r;o>=0;o--){for(var h=!0,p=0;p<l;p++)if(c(t,o+p)!==c(e,p)){h=!1;break}if(h)return o}return -1}function ne(t,e,r,n){r=Number(r)||0;var i=t.length-r;n?(n=Number(n))>i&&(n=i):n=i;var o=e.length;if(o%2!=0)throw new TypeError("Invalid hex string");n>o/2&&(n=o/2);for(var a=0;a<n;++a){var s=parseInt(e.substr(2*a,2),16);if(isNaN(s))return a;t[r+a]=s;}return a}function ie(t,e,r,n){return Ce(Ee(e,t.length-r),t,r,n)}function oe(t,e,r,n){return Ce(function(t){for(var e=[],r=0;r<t.length;++r)e.push(255&t.charCodeAt(r));return e}(e),t,r,n)}function ae(t,e,r,n){return oe(t,e,r,n)}function se(t,e,r,n){return Ce(xe(e),t,r,n)}function le(t,e,r,n){return Ce(function(t,e){for(var r,n,i,o=[],a=0;a<t.length&&!((e-=2)<0);++a)n=(r=t.charCodeAt(a))>>8,i=r%256,o.push(i),o.push(n);return o}(e,t.length-r),t,r,n)}function ce(t,e,r){return 0===e&&r===t.length?Bt(t):Bt(t.slice(e,r))}function ue(t,e,r){r=Math.min(t.length,r);for(var n=[],i=e;i<r;){var o,a,s,l,c=t[i],u=null,h=c>239?4:c>223?3:c>191?2:1;if(i+h<=r)switch(h){case 1:c<128&&(u=c);break;case 2:128==(192&(o=t[i+1]))&&(l=(31&c)<<6|63&o)>127&&(u=l);break;case 3:o=t[i+1],a=t[i+2],128==(192&o)&&128==(192&a)&&(l=(15&c)<<12|(63&o)<<6|63&a)>2047&&(l<55296||l>57343)&&(u=l);break;case 4:o=t[i+1],a=t[i+2],s=t[i+3],128==(192&o)&&128==(192&a)&&128==(192&s)&&(l=(15&c)<<18|(63&o)<<12|(63&a)<<6|63&s)>65535&&l<1114112&&(u=l);}null===u?(u=65533,h=1):u>65535&&(u-=65536,n.push(u>>>10&1023|55296),u=56320|1023&u),n.push(u),i+=h;}return function(t){var e=t.length;if(e<=he)return String.fromCharCode.apply(String,t);var r="",n=0;for(;n<e;)r+=String.fromCharCode.apply(String,t.slice(n,n+=he));return r}(n)}Yt.TYPED_ARRAY_SUPPORT=void 0===e.TYPED_ARRAY_SUPPORT||e.TYPED_ARRAY_SUPPORT,Ut(),Yt.poolSize=8192,Yt._augment=function(t){return t.__proto__=Yt.prototype,t},Yt.from=function(t,e,r){return zt(null,t,e,r)},Yt.TYPED_ARRAY_SUPPORT&&(Yt.prototype.__proto__=Uint8Array.prototype,Yt.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&Yt[Symbol.species]),Yt.alloc=function(t,e,r){return function(t,e,r,n){return qt(e),e<=0?Wt(t,e):void 0!==r?"string"==typeof n?Wt(t,e).fill(r,n):Wt(t,e).fill(r):Wt(t,e)}(null,t,e,r)},Yt.allocUnsafe=function(t){return Kt(null,t)},Yt.allocUnsafeSlow=function(t){return Kt(null,t)},Yt.isBuffer=function(t){return null!=t&&(!!t._isBuffer||Ie(t)||function(t){return "function"==typeof t.readFloatLE&&"function"==typeof t.slice&&Ie(t.slice(0,0))}(t))},Yt.compare=function(t,e){if(!Zt(t)||!Zt(e))throw new TypeError("Arguments must be Buffers");if(t===e)return 0;for(var r=t.length,n=e.length,i=0,o=Math.min(r,n);i<o;++i)if(t[i]!==e[i]){r=t[i],n=e[i];break}return r<n?-1:n<r?1:0},Yt.isEncoding=function(t){switch(String(t).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"latin1":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return !0;default:return !1}},Yt.concat=function(t,e){if(!Vt(t))throw new TypeError('"list" argument must be an Array of Buffers');if(0===t.length)return Yt.alloc(0);var r;if(void 0===e)for(e=0,r=0;r<t.length;++r)e+=t[r].length;var n=Yt.allocUnsafe(e),i=0;for(r=0;r<t.length;++r){var o=t[r];if(!Zt(o))throw new TypeError('"list" argument must be an Array of Buffers');o.copy(n,i),i+=o.length;}return n},Yt.byteLength=Xt,Yt.prototype._isBuffer=!0,Yt.prototype.swap16=function(){var t=this.length;if(t%2!=0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var e=0;e<t;e+=2)te(this,e,e+1);return this},Yt.prototype.swap32=function(){var t=this.length;if(t%4!=0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var e=0;e<t;e+=4)te(this,e,e+3),te(this,e+1,e+2);return this},Yt.prototype.swap64=function(){var t=this.length;if(t%8!=0)throw new RangeError("Buffer size must be a multiple of 64-bits");for(var e=0;e<t;e+=8)te(this,e,e+7),te(this,e+1,e+6),te(this,e+2,e+5),te(this,e+3,e+4);return this},Yt.prototype.toString=function(){var t=0|this.length;return 0===t?"":0===arguments.length?ue(this,0,t):Qt.apply(this,arguments)},Yt.prototype.equals=function(t){if(!Zt(t))throw new TypeError("Argument must be a Buffer");return this===t||0===Yt.compare(this,t)},Yt.prototype.inspect=function(){var t="";return this.length>0&&(t=this.toString("hex",0,50).match(/.{2}/g).join(" "),this.length>50&&(t+=" ... ")),"<Buffer "+t+">"},Yt.prototype.compare=function(t,e,r,n,i){if(!Zt(t))throw new TypeError("Argument must be a Buffer");if(void 0===e&&(e=0),void 0===r&&(r=t?t.length:0),void 0===n&&(n=0),void 0===i&&(i=this.length),e<0||r>t.length||n<0||i>this.length)throw new RangeError("out of range index");if(n>=i&&e>=r)return 0;if(n>=i)return -1;if(e>=r)return 1;if(this===t)return 0;for(var o=(i>>>=0)-(n>>>=0),a=(r>>>=0)-(e>>>=0),s=Math.min(o,a),l=this.slice(n,i),c=t.slice(e,r),u=0;u<s;++u)if(l[u]!==c[u]){o=l[u],a=c[u];break}return o<a?-1:a<o?1:0},Yt.prototype.includes=function(t,e,r){return -1!==this.indexOf(t,e,r)},Yt.prototype.indexOf=function(t,e,r){return ee(this,t,e,r,!0)},Yt.prototype.lastIndexOf=function(t,e,r){return ee(this,t,e,r,!1)},Yt.prototype.write=function(t,e,r,n){if(void 0===e)n="utf8",r=this.length,e=0;else if(void 0===r&&"string"==typeof e)n=e,r=this.length,e=0;else {if(!isFinite(e))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");e|=0,isFinite(r)?(r|=0,void 0===n&&(n="utf8")):(n=r,r=void 0);}var i=this.length-e;if((void 0===r||r>i)&&(r=i),t.length>0&&(r<0||e<0)||e>this.length)throw new RangeError("Attempt to write outside buffer bounds");n||(n="utf8");for(var o=!1;;)switch(n){case"hex":return ne(this,t,e,r);case"utf8":case"utf-8":return ie(this,t,e,r);case"ascii":return oe(this,t,e,r);case"latin1":case"binary":return ae(this,t,e,r);case"base64":return se(this,t,e,r);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return le(this,t,e,r);default:if(o)throw new TypeError("Unknown encoding: "+n);n=(""+n).toLowerCase(),o=!0;}},Yt.prototype.toJSON=function(){return {type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};var he=4096;function pe(t,e,r){var n="";r=Math.min(t.length,r);for(var i=e;i<r;++i)n+=String.fromCharCode(127&t[i]);return n}function fe(t,e,r){var n="";r=Math.min(t.length,r);for(var i=e;i<r;++i)n+=String.fromCharCode(t[i]);return n}function de(t,e,r){var n=t.length;(!e||e<0)&&(e=0),(!r||r<0||r>n)&&(r=n);for(var i="",o=e;o<r;++o)i+=Pe(t[o]);return i}function ge(t,e,r){for(var n=t.slice(e,r),i="",o=0;o<n.length;o+=2)i+=String.fromCharCode(n[o]+256*n[o+1]);return i}function me(t,e,r){if(t%1!=0||t<0)throw new RangeError("offset is not uint");if(t+e>r)throw new RangeError("Trying to access beyond buffer length")}function ve(t,e,r,n,i,o){if(!Zt(t))throw new TypeError('"buffer" argument must be a Buffer instance');if(e>i||e<o)throw new RangeError('"value" argument is out of bounds');if(r+n>t.length)throw new RangeError("Index out of range")}function ye(t,e,r,n){e<0&&(e=65535+e+1);for(var i=0,o=Math.min(t.length-r,2);i<o;++i)t[r+i]=(e&255<<8*(n?i:1-i))>>>8*(n?i:1-i);}function _e(t,e,r,n){e<0&&(e=4294967295+e+1);for(var i=0,o=Math.min(t.length-r,4);i<o;++i)t[r+i]=e>>>8*(n?i:3-i)&255;}function be(t,e,r,n,i,o){if(r+n>t.length)throw new RangeError("Index out of range");if(r<0)throw new RangeError("Index out of range")}function ke(t,e,r,n,i){return i||be(t,0,r,4),jt(t,e,r,n,23,4),r+4}function we(t,e,r,n,i){return i||be(t,0,r,8),jt(t,e,r,n,52,8),r+8}Yt.prototype.slice=function(t,e){var r,n=this.length;if((t=~~t)<0?(t+=n)<0&&(t=0):t>n&&(t=n),(e=void 0===e?n:~~e)<0?(e+=n)<0&&(e=0):e>n&&(e=n),e<t&&(e=t),Yt.TYPED_ARRAY_SUPPORT)(r=this.subarray(t,e)).__proto__=Yt.prototype;else {var i=e-t;r=new Yt(i,void 0);for(var o=0;o<i;++o)r[o]=this[o+t];}return r},Yt.prototype.readUIntLE=function(t,e,r){t|=0,e|=0,r||me(t,e,this.length);for(var n=this[t],i=1,o=0;++o<e&&(i*=256);)n+=this[t+o]*i;return n},Yt.prototype.readUIntBE=function(t,e,r){t|=0,e|=0,r||me(t,e,this.length);for(var n=this[t+--e],i=1;e>0&&(i*=256);)n+=this[t+--e]*i;return n},Yt.prototype.readUInt8=function(t,e){return e||me(t,1,this.length),this[t]},Yt.prototype.readUInt16LE=function(t,e){return e||me(t,2,this.length),this[t]|this[t+1]<<8},Yt.prototype.readUInt16BE=function(t,e){return e||me(t,2,this.length),this[t]<<8|this[t+1]},Yt.prototype.readUInt32LE=function(t,e){return e||me(t,4,this.length),(this[t]|this[t+1]<<8|this[t+2]<<16)+16777216*this[t+3]},Yt.prototype.readUInt32BE=function(t,e){return e||me(t,4,this.length),16777216*this[t]+(this[t+1]<<16|this[t+2]<<8|this[t+3])},Yt.prototype.readIntLE=function(t,e,r){t|=0,e|=0,r||me(t,e,this.length);for(var n=this[t],i=1,o=0;++o<e&&(i*=256);)n+=this[t+o]*i;return n>=(i*=128)&&(n-=Math.pow(2,8*e)),n},Yt.prototype.readIntBE=function(t,e,r){t|=0,e|=0,r||me(t,e,this.length);for(var n=e,i=1,o=this[t+--n];n>0&&(i*=256);)o+=this[t+--n]*i;return o>=(i*=128)&&(o-=Math.pow(2,8*e)),o},Yt.prototype.readInt8=function(t,e){return e||me(t,1,this.length),128&this[t]?-1*(255-this[t]+1):this[t]},Yt.prototype.readInt16LE=function(t,e){e||me(t,2,this.length);var r=this[t]|this[t+1]<<8;return 32768&r?4294901760|r:r},Yt.prototype.readInt16BE=function(t,e){e||me(t,2,this.length);var r=this[t+1]|this[t]<<8;return 32768&r?4294901760|r:r},Yt.prototype.readInt32LE=function(t,e){return e||me(t,4,this.length),this[t]|this[t+1]<<8|this[t+2]<<16|this[t+3]<<24},Yt.prototype.readInt32BE=function(t,e){return e||me(t,4,this.length),this[t]<<24|this[t+1]<<16|this[t+2]<<8|this[t+3]},Yt.prototype.readFloatLE=function(t,e){return e||me(t,4,this.length),$t(this,t,!0,23,4)},Yt.prototype.readFloatBE=function(t,e){return e||me(t,4,this.length),$t(this,t,!1,23,4)},Yt.prototype.readDoubleLE=function(t,e){return e||me(t,8,this.length),$t(this,t,!0,52,8)},Yt.prototype.readDoubleBE=function(t,e){return e||me(t,8,this.length),$t(this,t,!1,52,8)},Yt.prototype.writeUIntLE=function(t,e,r,n){(t=+t,e|=0,r|=0,n)||ve(this,t,e,r,Math.pow(2,8*r)-1,0);var i=1,o=0;for(this[e]=255&t;++o<r&&(i*=256);)this[e+o]=t/i&255;return e+r},Yt.prototype.writeUIntBE=function(t,e,r,n){(t=+t,e|=0,r|=0,n)||ve(this,t,e,r,Math.pow(2,8*r)-1,0);var i=r-1,o=1;for(this[e+i]=255&t;--i>=0&&(o*=256);)this[e+i]=t/o&255;return e+r},Yt.prototype.writeUInt8=function(t,e,r){return t=+t,e|=0,r||ve(this,t,e,1,255,0),Yt.TYPED_ARRAY_SUPPORT||(t=Math.floor(t)),this[e]=255&t,e+1},Yt.prototype.writeUInt16LE=function(t,e,r){return t=+t,e|=0,r||ve(this,t,e,2,65535,0),Yt.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8):ye(this,t,e,!0),e+2},Yt.prototype.writeUInt16BE=function(t,e,r){return t=+t,e|=0,r||ve(this,t,e,2,65535,0),Yt.TYPED_ARRAY_SUPPORT?(this[e]=t>>>8,this[e+1]=255&t):ye(this,t,e,!1),e+2},Yt.prototype.writeUInt32LE=function(t,e,r){return t=+t,e|=0,r||ve(this,t,e,4,4294967295,0),Yt.TYPED_ARRAY_SUPPORT?(this[e+3]=t>>>24,this[e+2]=t>>>16,this[e+1]=t>>>8,this[e]=255&t):_e(this,t,e,!0),e+4},Yt.prototype.writeUInt32BE=function(t,e,r){return t=+t,e|=0,r||ve(this,t,e,4,4294967295,0),Yt.TYPED_ARRAY_SUPPORT?(this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t):_e(this,t,e,!1),e+4},Yt.prototype.writeIntLE=function(t,e,r,n){if(t=+t,e|=0,!n){var i=Math.pow(2,8*r-1);ve(this,t,e,r,i-1,-i);}var o=0,a=1,s=0;for(this[e]=255&t;++o<r&&(a*=256);)t<0&&0===s&&0!==this[e+o-1]&&(s=1),this[e+o]=(t/a>>0)-s&255;return e+r},Yt.prototype.writeIntBE=function(t,e,r,n){if(t=+t,e|=0,!n){var i=Math.pow(2,8*r-1);ve(this,t,e,r,i-1,-i);}var o=r-1,a=1,s=0;for(this[e+o]=255&t;--o>=0&&(a*=256);)t<0&&0===s&&0!==this[e+o+1]&&(s=1),this[e+o]=(t/a>>0)-s&255;return e+r},Yt.prototype.writeInt8=function(t,e,r){return t=+t,e|=0,r||ve(this,t,e,1,127,-128),Yt.TYPED_ARRAY_SUPPORT||(t=Math.floor(t)),t<0&&(t=255+t+1),this[e]=255&t,e+1},Yt.prototype.writeInt16LE=function(t,e,r){return t=+t,e|=0,r||ve(this,t,e,2,32767,-32768),Yt.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8):ye(this,t,e,!0),e+2},Yt.prototype.writeInt16BE=function(t,e,r){return t=+t,e|=0,r||ve(this,t,e,2,32767,-32768),Yt.TYPED_ARRAY_SUPPORT?(this[e]=t>>>8,this[e+1]=255&t):ye(this,t,e,!1),e+2},Yt.prototype.writeInt32LE=function(t,e,r){return t=+t,e|=0,r||ve(this,t,e,4,2147483647,-2147483648),Yt.TYPED_ARRAY_SUPPORT?(this[e]=255&t,this[e+1]=t>>>8,this[e+2]=t>>>16,this[e+3]=t>>>24):_e(this,t,e,!0),e+4},Yt.prototype.writeInt32BE=function(t,e,r){return t=+t,e|=0,r||ve(this,t,e,4,2147483647,-2147483648),t<0&&(t=4294967295+t+1),Yt.TYPED_ARRAY_SUPPORT?(this[e]=t>>>24,this[e+1]=t>>>16,this[e+2]=t>>>8,this[e+3]=255&t):_e(this,t,e,!1),e+4},Yt.prototype.writeFloatLE=function(t,e,r){return ke(this,t,e,!0,r)},Yt.prototype.writeFloatBE=function(t,e,r){return ke(this,t,e,!1,r)},Yt.prototype.writeDoubleLE=function(t,e,r){return we(this,t,e,!0,r)},Yt.prototype.writeDoubleBE=function(t,e,r){return we(this,t,e,!1,r)},Yt.prototype.copy=function(t,e,r,n){if(r||(r=0),n||0===n||(n=this.length),e>=t.length&&(e=t.length),e||(e=0),n>0&&n<r&&(n=r),n===r)return 0;if(0===t.length||0===this.length)return 0;if(e<0)throw new RangeError("targetStart out of bounds");if(r<0||r>=this.length)throw new RangeError("sourceStart out of bounds");if(n<0)throw new RangeError("sourceEnd out of bounds");n>this.length&&(n=this.length),t.length-e<n-r&&(n=t.length-e+r);var i,o=n-r;if(this===t&&r<e&&e<n)for(i=o-1;i>=0;--i)t[i+e]=this[i+r];else if(o<1e3||!Yt.TYPED_ARRAY_SUPPORT)for(i=0;i<o;++i)t[i+e]=this[i+r];else Uint8Array.prototype.set.call(t,this.subarray(r,r+o),e);return o},Yt.prototype.fill=function(t,e,r,n){if("string"==typeof t){if("string"==typeof e?(n=e,e=0,r=this.length):"string"==typeof r&&(n=r,r=this.length),1===t.length){var i=t.charCodeAt(0);i<256&&(t=i);}if(void 0!==n&&"string"!=typeof n)throw new TypeError("encoding must be a string");if("string"==typeof n&&!Yt.isEncoding(n))throw new TypeError("Unknown encoding: "+n)}else "number"==typeof t&&(t&=255);if(e<0||this.length<e||this.length<r)throw new RangeError("Out of range index");if(r<=e)return this;var o;if(e>>>=0,r=void 0===r?this.length:r>>>0,t||(t=0),"number"==typeof t)for(o=e;o<r;++o)this[o]=t;else {var a=Zt(t)?t:Ee(new Yt(t,n).toString()),s=a.length;for(o=0;o<r-e;++o)this[o+e]=a[o%s];}return this};var Se=/[^+\/0-9A-Za-z-_]/g;function Pe(t){return t<16?"0"+t.toString(16):t.toString(16)}function Ee(t,e){var r;e=e||1/0;for(var n=t.length,i=null,o=[],a=0;a<n;++a){if((r=t.charCodeAt(a))>55295&&r<57344){if(!i){if(r>56319){(e-=3)>-1&&o.push(239,191,189);continue}if(a+1===n){(e-=3)>-1&&o.push(239,191,189);continue}i=r;continue}if(r<56320){(e-=3)>-1&&o.push(239,191,189),i=r;continue}r=65536+(i-55296<<10|r-56320);}else i&&(e-=3)>-1&&o.push(239,191,189);if(i=null,r<128){if((e-=1)<0)break;o.push(r);}else if(r<2048){if((e-=2)<0)break;o.push(r>>6|192,63&r|128);}else if(r<65536){if((e-=3)<0)break;o.push(r>>12|224,r>>6&63|128,63&r|128);}else {if(!(r<1114112))throw new Error("Invalid code point");if((e-=4)<0)break;o.push(r>>18|240,r>>12&63|128,r>>6&63|128,63&r|128);}}return o}function xe(t){return function(t){var e,r,n,i,o,a;Dt||Rt();var s=t.length;if(s%4>0)throw new Error("Invalid string. Length must be a multiple of 4");o="="===t[s-2]?2:"="===t[s-1]?1:0,a=new Mt(3*s/4-o),n=o>0?s-4:s;var l=0;for(e=0,r=0;e<n;e+=4,r+=3)i=Tt[t.charCodeAt(e)]<<18|Tt[t.charCodeAt(e+1)]<<12|Tt[t.charCodeAt(e+2)]<<6|Tt[t.charCodeAt(e+3)],a[l++]=i>>16&255,a[l++]=i>>8&255,a[l++]=255&i;return 2===o?(i=Tt[t.charCodeAt(e)]<<2|Tt[t.charCodeAt(e+1)]>>4,a[l++]=255&i):1===o&&(i=Tt[t.charCodeAt(e)]<<10|Tt[t.charCodeAt(e+1)]<<4|Tt[t.charCodeAt(e+2)]>>2,a[l++]=i>>8&255,a[l++]=255&i),a}(function(t){if((t=function(t){return t.trim?t.trim():t.replace(/^\s+|\s+$/g,"")}(t).replace(Se,"")).length<2)return "";for(;t.length%4!=0;)t+="=";return t}(t))}function Ce(t,e,r,n){for(var i=0;i<n&&!(i+r>=e.length||i>=t.length);++i)e[i+r]=t[i];return i}function Ie(t){return !!t.constructor&&"function"==typeof t.constructor.isBuffer&&t.constructor.isBuffer(t)}var Oe={get(t){let e={};const r=localStorage.getItem(t);if(r){const t=Yt.from(r,"base64").toString("utf-8");e=JSON.parse(t);}return e},set(t,e){if("object"==typeof e&&null!==e){const r=this.get(t)||{};e=Object.assign(r,e);}const r=Yt.from(JSON.stringify(e),"utf-8").toString("base64");localStorage.setItem(t,r);},remove(t){localStorage.removeItem(t);}};const Ne=(t,e)=>{for(let r in e)try{e[r].constructor==Object?t[r]=Ne(t[r],e[r]):t[r]=e[r];}catch(n){t[r]=e[r];}return t};var Le={changeLocale(t){e.conf.language.lang.locale=t,Object.keys(e.i18nt).forEach((r=>e.i18nt[r].locale=t)),e.i18n.locale=t;const r=Oe.get("ts-conf").lang||{};Oe.set("ts-conf",{lang:{...r,locale:t}});},registerLangAsScope({lang:t,scope:r}){(!e.conf||e.conf&&!e.conf.language)&&(e.conf={...e.conf,language:{messages:{}}}),(({lang:t,scope:r})=>{let n=e.conf.language.messages;Object.keys(t).forEach((i=>{const o=Ne(n[i]||{},{[r]:t[i]});e.conf.language.messages[i]=o,e.i18nt&&Object.keys(e.i18nt).forEach((t=>e.i18nt[t].setLocaleMessage(i,o))),e.i18n&&e.i18n.setLocaleMessage(i,o);}));})({lang:t,scope:r});}};var Te="undefined"!=typeof globalThis?globalThis:"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{};function Me(t){throw new Error('Could not dynamically require "'+t+'". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.')}var De={exports:{}},Re={exports:{}},Fe={},Be={__esModule:!0};Be.extend=Ue,Be.indexOf=function(t,e){for(var r=0,n=t.length;r<n;r++)if(t[r]===e)return r;return -1},Be.escapeExpression=function(t){if("string"!=typeof t){if(t&&t.toHTML)return t.toHTML();if(null==t)return "";if(!t)return t+"";t=""+t;}if(!He.test(t))return t;return t.replace(je,Ve)},Be.isEmpty=function(t){return !t&&0!==t||!(!ze(t)||0!==t.length)},Be.createFrame=function(t){var e=Ue({},t);return e._parent=t,e},Be.blockParams=function(t,e){return t.path=e,t},Be.appendContextPath=function(t,e){return (t?t+".":"")+e};var $e={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;","=":"&#x3D;"},je=/[&<>"'`=]/g,He=/[&<>"'`=]/;function Ve(t){return $e[t]}function Ue(t){for(var e=1;e<arguments.length;e++)for(var r in arguments[e])Object.prototype.hasOwnProperty.call(arguments[e],r)&&(t[r]=arguments[e][r]);return t}var We=Object.prototype.toString;Be.toString=We;var Ye=function(t){return "function"==typeof t};Ye(/x/)&&(Be.isFunction=Ye=function(t){return "function"==typeof t&&"[object Function]"===We.call(t)}),Be.isFunction=Ye;var ze=Array.isArray||function(t){return !(!t||"object"!=typeof t)&&"[object Array]"===We.call(t)};Be.isArray=ze;var qe={exports:{}};!function(t,e){e.__esModule=!0;var r=["description","fileName","lineNumber","endLineNumber","message","name","number","stack"];function n(t,e){var i=e&&e.loc,o=void 0,a=void 0,s=void 0,l=void 0;i&&(o=i.start.line,a=i.end.line,s=i.start.column,l=i.end.column,t+=" - "+o+":"+s);for(var c=Error.prototype.constructor.call(this,t),u=0;u<r.length;u++)this[r[u]]=c[r[u]];Error.captureStackTrace&&Error.captureStackTrace(this,n);try{i&&(this.lineNumber=o,this.endLineNumber=a,Object.defineProperty?(Object.defineProperty(this,"column",{value:s,enumerable:!0}),Object.defineProperty(this,"endColumn",{value:l,enumerable:!0})):(this.column=s,this.endColumn=l));}catch(t){}}n.prototype=new Error,e.default=n,t.exports=e.default;}(qe,qe.exports);var Ke={},Je={exports:{}};!function(t,e){e.__esModule=!0;var r=Be;e.default=function(t){t.registerHelper("blockHelperMissing",(function(e,n){var i=n.inverse,o=n.fn;if(!0===e)return o(this);if(!1===e||null==e)return i(this);if(r.isArray(e))return e.length>0?(n.ids&&(n.ids=[n.name]),t.helpers.each(e,n)):i(this);if(n.data&&n.ids){var a=r.createFrame(n.data);a.contextPath=r.appendContextPath(n.data.contextPath,n.name),n={data:a};}return o(e,n)}));},t.exports=e.default;}(Je,Je.exports);var Ge={exports:{}};!function(t,e){e.__esModule=!0;var r,n=Be,i=(r=qe.exports)&&r.__esModule?r:{default:r};e.default=function(t){t.registerHelper("each",(function(t,e){if(!e)throw new i.default("Must pass iterator to #each");var r,o=e.fn,a=e.inverse,s=0,l="",c=void 0,u=void 0;function h(e,r,i){c&&(c.key=e,c.index=r,c.first=0===r,c.last=!!i,u&&(c.contextPath=u+e)),l+=o(t[e],{data:c,blockParams:n.blockParams([t[e],e],[u+e,null])});}if(e.data&&e.ids&&(u=n.appendContextPath(e.data.contextPath,e.ids[0])+"."),n.isFunction(t)&&(t=t.call(this)),e.data&&(c=n.createFrame(e.data)),t&&"object"==typeof t)if(n.isArray(t))for(var p=t.length;s<p;s++)s in t&&h(s,s,s===t.length-1);else if(Te.Symbol&&t[Te.Symbol.iterator]){for(var f=[],d=t[Te.Symbol.iterator](),g=d.next();!g.done;g=d.next())f.push(g.value);for(p=(t=f).length;s<p;s++)h(s,s,s===t.length-1);}else r=void 0,Object.keys(t).forEach((function(t){void 0!==r&&h(r,s-1),r=t,s++;})),void 0!==r&&h(r,s-1,!0);return 0===s&&(l=a(this)),l}));},t.exports=e.default;}(Ge,Ge.exports);var Ze={exports:{}};!function(t,e){e.__esModule=!0;var r,n=(r=qe.exports)&&r.__esModule?r:{default:r};e.default=function(t){t.registerHelper("helperMissing",(function(){if(1!==arguments.length)throw new n.default('Missing helper: "'+arguments[arguments.length-1].name+'"')}));},t.exports=e.default;}(Ze,Ze.exports);var Xe={exports:{}};!function(t,e){e.__esModule=!0;var r,n=Be,i=(r=qe.exports)&&r.__esModule?r:{default:r};e.default=function(t){t.registerHelper("if",(function(t,e){if(2!=arguments.length)throw new i.default("#if requires exactly one argument");return n.isFunction(t)&&(t=t.call(this)),!e.hash.includeZero&&!t||n.isEmpty(t)?e.inverse(this):e.fn(this)})),t.registerHelper("unless",(function(e,r){if(2!=arguments.length)throw new i.default("#unless requires exactly one argument");return t.helpers.if.call(this,e,{fn:r.inverse,inverse:r.fn,hash:r.hash})}));},t.exports=e.default;}(Xe,Xe.exports);var Qe,tr,er={exports:{}};Qe=er,(tr=er.exports).__esModule=!0,tr.default=function(t){t.registerHelper("log",(function(){for(var e=[void 0],r=arguments[arguments.length-1],n=0;n<arguments.length-1;n++)e.push(arguments[n]);var i=1;null!=r.hash.level?i=r.hash.level:r.data&&null!=r.data.level&&(i=r.data.level),e[0]=i,t.log.apply(t,e);}));},Qe.exports=tr.default;var rr={exports:{}};!function(t,e){e.__esModule=!0,e.default=function(t){t.registerHelper("lookup",(function(t,e,r){return t?r.lookupProperty(t,e):t}));},t.exports=e.default;}(rr,rr.exports);var nr={exports:{}};function ir(t){return t&&t.__esModule?t:{default:t}}!function(t,e){e.__esModule=!0;var r,n=Be,i=(r=qe.exports)&&r.__esModule?r:{default:r};e.default=function(t){t.registerHelper("with",(function(t,e){if(2!=arguments.length)throw new i.default("#with requires exactly one argument");n.isFunction(t)&&(t=t.call(this));var r=e.fn;if(n.isEmpty(t))return e.inverse(this);var o=e.data;return e.data&&e.ids&&((o=n.createFrame(e.data)).contextPath=n.appendContextPath(e.data.contextPath,e.ids[0])),r(t,{data:o,blockParams:n.blockParams([t],[o&&o.contextPath])})}));},t.exports=e.default;}(nr,nr.exports),Ke.__esModule=!0,Ke.registerDefaultHelpers=function(t){or.default(t),ar.default(t),sr.default(t),lr.default(t),cr.default(t),ur.default(t),hr.default(t);},Ke.moveHelperToHooks=function(t,e,r){t.helpers[e]&&(t.hooks[e]=t.helpers[e],r||delete t.helpers[e]);};var or=ir(Je.exports),ar=ir(Ge.exports),sr=ir(Ze.exports),lr=ir(Xe.exports),cr=ir(er.exports),ur=ir(rr.exports),hr=ir(nr.exports);var pr={},fr={exports:{}};!function(t,e){e.__esModule=!0;var r=Be;e.default=function(t){t.registerDecorator("inline",(function(t,e,n,i){var o=t;return e.partials||(e.partials={},o=function(i,o){var a=n.partials;n.partials=r.extend({},a,e.partials);var s=t(i,o);return n.partials=a,s}),e.partials[i.args[0]]=i.fn,o}));},t.exports=e.default;}(fr,fr.exports),pr.__esModule=!0,pr.registerDefaultDecorators=function(t){gr.default(t);};var dr,gr=(dr=fr.exports)&&dr.__esModule?dr:{default:dr};var mr={exports:{}};!function(t,e){e.__esModule=!0;var r=Be,n={methodMap:["debug","info","warn","error"],level:"info",lookupLevel:function(t){if("string"==typeof t){var e=r.indexOf(n.methodMap,t.toLowerCase());t=e>=0?e:parseInt(t,10);}return t},log:function(t){if(t=n.lookupLevel(t),"undefined"!=typeof console&&n.lookupLevel(n.level)<=t){var e=n.methodMap[t];console[e]||(e="log");for(var r=arguments.length,i=Array(r>1?r-1:0),o=1;o<r;o++)i[o-1]=arguments[o];console[e].apply(console,i);}}};e.default=n,t.exports=e.default;}(mr,mr.exports);var vr={},yr={__esModule:!0,createNewLookupObject:function(){for(var t=arguments.length,e=Array(t),r=0;r<t;r++)e[r]=arguments[r];return _r.extend.apply(void 0,[Object.create(null)].concat(e))}},_r=Be;vr.__esModule=!0,vr.createProtoAccessControl=function(t){var e=Object.create(null);e.constructor=!1,e.__defineGetter__=!1,e.__defineSetter__=!1,e.__lookupGetter__=!1;var r=Object.create(null);return r.__proto__=!1,{properties:{whitelist:br.createNewLookupObject(r,t.allowedProtoProperties),defaultValue:t.allowProtoPropertiesByDefault},methods:{whitelist:br.createNewLookupObject(e,t.allowedProtoMethods),defaultValue:t.allowProtoMethodsByDefault}}},vr.resultIsAllowed=function(t,e,r){return Sr("function"==typeof t?e.methods:e.properties,r)},vr.resetLoggedProperties=function(){Object.keys(wr).forEach((function(t){delete wr[t];}));};var br=yr,kr=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(mr.exports),wr=Object.create(null);function Sr(t,e){return void 0!==t.whitelist[e]?!0===t.whitelist[e]:void 0!==t.defaultValue?t.defaultValue:(function(t){!0!==wr[t]&&(wr[t]=!0,kr.log("error",'Handlebars: Access has been denied to resolve the property "'+t+'" because it is not an "own property" of its parent.\nYou can add a runtime option to disable the check or this warning:\nSee https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details'));}(e),!1)}function Pr(t){return t&&t.__esModule?t:{default:t}}Fe.__esModule=!0,Fe.HandlebarsEnvironment=Ar;var Er=Be,xr=Pr(qe.exports),Cr=Ke,Ir=pr,Or=Pr(mr.exports),Nr=vr;Fe.VERSION="4.7.7";Fe.COMPILER_REVISION=8;Fe.LAST_COMPATIBLE_COMPILER_REVISION=7;Fe.REVISION_CHANGES={1:"<= 1.0.rc.2",2:"== 1.0.0-rc.3",3:"== 1.0.0-rc.4",4:"== 1.x.x",5:"== 2.0.0-alpha.x",6:">= 2.0.0-beta.1",7:">= 4.0.0 <4.3.0",8:">= 4.3.0"};var Lr="[object Object]";function Ar(t,e,r){this.helpers=t||{},this.partials=e||{},this.decorators=r||{},Cr.registerDefaultHelpers(this),Ir.registerDefaultDecorators(this);}Ar.prototype={constructor:Ar,logger:Or.default,log:Or.default.log,registerHelper:function(t,e){if(Er.toString.call(t)===Lr){if(e)throw new xr.default("Arg not supported with multiple helpers");Er.extend(this.helpers,t);}else this.helpers[t]=e;},unregisterHelper:function(t){delete this.helpers[t];},registerPartial:function(t,e){if(Er.toString.call(t)===Lr)Er.extend(this.partials,t);else {if(void 0===e)throw new xr.default('Attempting to register a partial called "'+t+'" as undefined');this.partials[t]=e;}},unregisterPartial:function(t){delete this.partials[t];},registerDecorator:function(t,e){if(Er.toString.call(t)===Lr){if(e)throw new xr.default("Arg not supported with multiple decorators");Er.extend(this.decorators,t);}else this.decorators[t]=e;},unregisterDecorator:function(t){delete this.decorators[t];},resetLoggedPropertyAccesses:function(){Nr.resetLoggedProperties();}};var Tr=Or.default.log;Fe.log=Tr,Fe.createFrame=Er.createFrame,Fe.logger=Or.default;var Mr={exports:{}};!function(t,e){function r(t){this.string=t;}e.__esModule=!0,r.prototype.toString=r.prototype.toHTML=function(){return ""+this.string},e.default=r,t.exports=e.default;}(Mr,Mr.exports);var Dr={},Rr={};Rr.__esModule=!0,Rr.wrapHelper=function(t,e){if("function"!=typeof t)return t;return function(){return arguments[arguments.length-1]=e(arguments[arguments.length-1]),t.apply(this,arguments)}},Dr.__esModule=!0,Dr.checkRevision=function(t){var e=t&&t[0]||1,r=$r.COMPILER_REVISION;if(e>=$r.LAST_COMPATIBLE_COMPILER_REVISION&&e<=$r.COMPILER_REVISION)return;if(e<$r.LAST_COMPATIBLE_COMPILER_REVISION){var n=$r.REVISION_CHANGES[r],i=$r.REVISION_CHANGES[e];throw new Br.default("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version ("+n+") or downgrade your runtime to an older version ("+i+").")}throw new Br.default("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version ("+t[1]+").")},Dr.template=function(t,e){if(!e)throw new Br.default("No environment passed to template");if(!t||!t.main)throw new Br.default("Unknown template object: "+typeof t);t.main.decorator=t.main_d,e.VM.checkRevision(t.compiler);var r=t.compiler&&7===t.compiler[0];var n={strict:function(t,e,r){if(!t||!(e in t))throw new Br.default('"'+e+'" not defined in '+t,{loc:r});return n.lookupProperty(t,e)},lookupProperty:function(t,e){var r=t[e];return null==r||Object.prototype.hasOwnProperty.call(t,e)||Vr.resultIsAllowed(r,n.protoAccessControl,e)?r:void 0},lookup:function(t,e){for(var r=t.length,i=0;i<r;i++){if(null!=(t[i]&&n.lookupProperty(t[i],e)))return t[i][e]}},lambda:function(t,e){return "function"==typeof t?t.call(e):t},escapeExpression:Fr.escapeExpression,invokePartial:function(r,n,i){i.hash&&(n=Fr.extend({},n,i.hash),i.ids&&(i.ids[0]=!0)),r=e.VM.resolvePartial.call(this,r,n,i);var o=Fr.extend({},i,{hooks:this.hooks,protoAccessControl:this.protoAccessControl}),a=e.VM.invokePartial.call(this,r,n,o);if(null==a&&e.compile&&(i.partials[i.name]=e.compile(r,t.compilerOptions,e),a=i.partials[i.name](n,o)),null!=a){if(i.indent){for(var s=a.split("\n"),l=0,c=s.length;l<c&&(s[l]||l+1!==c);l++)s[l]=i.indent+s[l];a=s.join("\n");}return a}throw new Br.default("The partial "+i.name+" could not be compiled when running in runtime-only mode")},fn:function(e){var r=t[e];return r.decorator=t[e+"_d"],r},programs:[],program:function(t,e,r,n,i){var o=this.programs[t],a=this.fn(t);return e||i||n||r?o=Ur(this,t,a,e,r,n,i):o||(o=this.programs[t]=Ur(this,t,a)),o},data:function(t,e){for(;t&&e--;)t=t._parent;return t},mergeIfNeeded:function(t,e){var r=t||e;return t&&e&&t!==e&&(r=Fr.extend({},e,t)),r},nullContext:Object.seal({}),noop:e.VM.noop,compilerInfo:t.compiler};function i(e){var r=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],o=r.data;i._setup(r),!r.partial&&t.useData&&(o=function(t,e){e&&"root"in e||((e=e?$r.createFrame(e):{}).root=t);return e}(e,o));var a=void 0,s=t.useBlockParams?[]:void 0;function l(e){return ""+t.main(n,e,n.helpers,n.partials,o,s,a)}return t.useDepths&&(a=r.depths?e!=r.depths[0]?[e].concat(r.depths):r.depths:[e]),(l=Yr(t.main,l,n,r.depths||[],o,s))(e,r)}return i.isTop=!0,i._setup=function(i){if(i.partial)n.protoAccessControl=i.protoAccessControl,n.helpers=i.helpers,n.partials=i.partials,n.decorators=i.decorators,n.hooks=i.hooks;else {var o=Fr.extend({},e.helpers,i.helpers);!function(t,e){Object.keys(t).forEach((function(r){var n=t[r];t[r]=function(t,e){var r=e.lookupProperty;return Hr.wrapHelper(t,(function(t){return Fr.extend({lookupProperty:r},t)}))}(n,e);}));}(o,n),n.helpers=o,t.usePartial&&(n.partials=n.mergeIfNeeded(i.partials,e.partials)),(t.usePartial||t.useDecorators)&&(n.decorators=Fr.extend({},e.decorators,i.decorators)),n.hooks={},n.protoAccessControl=Vr.createProtoAccessControl(i);var a=i.allowCallsToHelperMissing||r;jr.moveHelperToHooks(n,"helperMissing",a),jr.moveHelperToHooks(n,"blockHelperMissing",a);}},i._child=function(e,r,i,o){if(t.useBlockParams&&!i)throw new Br.default("must pass block params");if(t.useDepths&&!o)throw new Br.default("must pass parent depths");return Ur(n,e,t[e],r,0,i,o)},i},Dr.wrapProgram=Ur,Dr.resolvePartial=function(t,e,r){t?t.call||r.name||(r.name=t,t=r.partials[t]):t="@partial-block"===r.name?r.data["partial-block"]:r.partials[r.name];return t},Dr.invokePartial=function(t,e,r){var n=r.data&&r.data["partial-block"];r.partial=!0,r.ids&&(r.data.contextPath=r.ids[0]||r.data.contextPath);var i=void 0;r.fn&&r.fn!==Wr&&function(){r.data=$r.createFrame(r.data);var t=r.fn;i=r.data["partial-block"]=function(e){var r=arguments.length<=1||void 0===arguments[1]?{}:arguments[1];return r.data=$r.createFrame(r.data),r.data["partial-block"]=n,t(e,r)},t.partials&&(r.partials=Fr.extend({},r.partials,t.partials));}();void 0===t&&i&&(t=i);if(void 0===t)throw new Br.default("The partial "+r.name+" could not be found");if(t instanceof Function)return t(e,r)},Dr.noop=Wr;var Fr=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(Be),Br=function(t){return t&&t.__esModule?t:{default:t}}(qe.exports),$r=Fe,jr=Ke,Hr=Rr,Vr=vr;function Ur(t,e,r,n,i,o,a){function s(e){var i=arguments.length<=1||void 0===arguments[1]?{}:arguments[1],s=a;return !a||e==a[0]||e===t.nullContext&&null===a[0]||(s=[e].concat(a)),r(t,e,t.helpers,t.partials,i.data||n,o&&[i.blockParams].concat(o),s)}return (s=Yr(r,s,t,a,n,o)).program=e,s.depth=a?a.length:0,s.blockParams=i||0,s}function Wr(){return ""}function Yr(t,e,r,n,i,o){if(t.decorator){var a={};e=t.decorator(e,a,r,n&&n[0],i,o,n),Fr.extend(e,a);}return e}var zr={exports:{}};!function(t,e){e.__esModule=!0,e.default=function(t){var e=void 0!==Te?Te:window,r=e.Handlebars;t.noConflict=function(){return e.Handlebars===t&&(e.Handlebars=r),t};},t.exports=e.default;}(zr,zr.exports),function(t,e){function r(t){return t&&t.__esModule?t:{default:t}}function n(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}e.__esModule=!0;var i=n(Fe),o=r(Mr.exports),a=r(qe.exports),s=n(Be),l=n(Dr),c=r(zr.exports);function u(){var t=new i.HandlebarsEnvironment;return s.extend(t,i),t.SafeString=o.default,t.Exception=a.default,t.Utils=s,t.escapeExpression=s.escapeExpression,t.VM=l,t.template=function(e){return l.template(e,t)},t}var h=u();h.create=u,c.default(h),h.default=h,e.default=h,t.exports=e.default;}(Re,Re.exports);var qr={exports:{}};!function(t,e){e.__esModule=!0;var r={helpers:{helperExpression:function(t){return "SubExpression"===t.type||("MustacheStatement"===t.type||"BlockStatement"===t.type)&&!!(t.params&&t.params.length||t.hash)},scopedId:function(t){return /^\.|this\b/.test(t.original)},simpleId:function(t){return 1===t.parts.length&&!r.helpers.scopedId(t)&&!t.depth}}};e.default=r,t.exports=e.default;}(qr,qr.exports);var Kr={},Jr={exports:{}};!function(t,e){e.__esModule=!0;var r=function(){var t={trace:function(){},yy:{},symbols_:{error:2,root:3,program:4,EOF:5,program_repetition0:6,statement:7,mustache:8,block:9,rawBlock:10,partial:11,partialBlock:12,content:13,COMMENT:14,CONTENT:15,openRawBlock:16,rawBlock_repetition0:17,END_RAW_BLOCK:18,OPEN_RAW_BLOCK:19,helperName:20,openRawBlock_repetition0:21,openRawBlock_option0:22,CLOSE_RAW_BLOCK:23,openBlock:24,block_option0:25,closeBlock:26,openInverse:27,block_option1:28,OPEN_BLOCK:29,openBlock_repetition0:30,openBlock_option0:31,openBlock_option1:32,CLOSE:33,OPEN_INVERSE:34,openInverse_repetition0:35,openInverse_option0:36,openInverse_option1:37,openInverseChain:38,OPEN_INVERSE_CHAIN:39,openInverseChain_repetition0:40,openInverseChain_option0:41,openInverseChain_option1:42,inverseAndProgram:43,INVERSE:44,inverseChain:45,inverseChain_option0:46,OPEN_ENDBLOCK:47,OPEN:48,mustache_repetition0:49,mustache_option0:50,OPEN_UNESCAPED:51,mustache_repetition1:52,mustache_option1:53,CLOSE_UNESCAPED:54,OPEN_PARTIAL:55,partialName:56,partial_repetition0:57,partial_option0:58,openPartialBlock:59,OPEN_PARTIAL_BLOCK:60,openPartialBlock_repetition0:61,openPartialBlock_option0:62,param:63,sexpr:64,OPEN_SEXPR:65,sexpr_repetition0:66,sexpr_option0:67,CLOSE_SEXPR:68,hash:69,hash_repetition_plus0:70,hashSegment:71,ID:72,EQUALS:73,blockParams:74,OPEN_BLOCK_PARAMS:75,blockParams_repetition_plus0:76,CLOSE_BLOCK_PARAMS:77,path:78,dataName:79,STRING:80,NUMBER:81,BOOLEAN:82,UNDEFINED:83,NULL:84,DATA:85,pathSegments:86,SEP:87,$accept:0,$end:1},terminals_:{2:"error",5:"EOF",14:"COMMENT",15:"CONTENT",18:"END_RAW_BLOCK",19:"OPEN_RAW_BLOCK",23:"CLOSE_RAW_BLOCK",29:"OPEN_BLOCK",33:"CLOSE",34:"OPEN_INVERSE",39:"OPEN_INVERSE_CHAIN",44:"INVERSE",47:"OPEN_ENDBLOCK",48:"OPEN",51:"OPEN_UNESCAPED",54:"CLOSE_UNESCAPED",55:"OPEN_PARTIAL",60:"OPEN_PARTIAL_BLOCK",65:"OPEN_SEXPR",68:"CLOSE_SEXPR",72:"ID",73:"EQUALS",75:"OPEN_BLOCK_PARAMS",77:"CLOSE_BLOCK_PARAMS",80:"STRING",81:"NUMBER",82:"BOOLEAN",83:"UNDEFINED",84:"NULL",85:"DATA",87:"SEP"},productions_:[0,[3,2],[4,1],[7,1],[7,1],[7,1],[7,1],[7,1],[7,1],[7,1],[13,1],[10,3],[16,5],[9,4],[9,4],[24,6],[27,6],[38,6],[43,2],[45,3],[45,1],[26,3],[8,5],[8,5],[11,5],[12,3],[59,5],[63,1],[63,1],[64,5],[69,1],[71,3],[74,3],[20,1],[20,1],[20,1],[20,1],[20,1],[20,1],[20,1],[56,1],[56,1],[79,2],[78,1],[86,3],[86,1],[6,0],[6,2],[17,0],[17,2],[21,0],[21,2],[22,0],[22,1],[25,0],[25,1],[28,0],[28,1],[30,0],[30,2],[31,0],[31,1],[32,0],[32,1],[35,0],[35,2],[36,0],[36,1],[37,0],[37,1],[40,0],[40,2],[41,0],[41,1],[42,0],[42,1],[46,0],[46,1],[49,0],[49,2],[50,0],[50,1],[52,0],[52,2],[53,0],[53,1],[57,0],[57,2],[58,0],[58,1],[61,0],[61,2],[62,0],[62,1],[66,0],[66,2],[67,0],[67,1],[70,1],[70,2],[76,1],[76,2]],performAction:function(t,e,r,n,i,o,a){var s=o.length-1;switch(i){case 1:return o[s-1];case 2:this.$=n.prepareProgram(o[s]);break;case 3:case 4:case 5:case 6:case 7:case 8:case 20:case 27:case 28:case 33:case 34:case 40:case 41:this.$=o[s];break;case 9:this.$={type:"CommentStatement",value:n.stripComment(o[s]),strip:n.stripFlags(o[s],o[s]),loc:n.locInfo(this._$)};break;case 10:this.$={type:"ContentStatement",original:o[s],value:o[s],loc:n.locInfo(this._$)};break;case 11:this.$=n.prepareRawBlock(o[s-2],o[s-1],o[s],this._$);break;case 12:this.$={path:o[s-3],params:o[s-2],hash:o[s-1]};break;case 13:this.$=n.prepareBlock(o[s-3],o[s-2],o[s-1],o[s],!1,this._$);break;case 14:this.$=n.prepareBlock(o[s-3],o[s-2],o[s-1],o[s],!0,this._$);break;case 15:this.$={open:o[s-5],path:o[s-4],params:o[s-3],hash:o[s-2],blockParams:o[s-1],strip:n.stripFlags(o[s-5],o[s])};break;case 16:case 17:this.$={path:o[s-4],params:o[s-3],hash:o[s-2],blockParams:o[s-1],strip:n.stripFlags(o[s-5],o[s])};break;case 18:this.$={strip:n.stripFlags(o[s-1],o[s-1]),program:o[s]};break;case 19:var l=n.prepareBlock(o[s-2],o[s-1],o[s],o[s],!1,this._$),c=n.prepareProgram([l],o[s-1].loc);c.chained=!0,this.$={strip:o[s-2].strip,program:c,chain:!0};break;case 21:this.$={path:o[s-1],strip:n.stripFlags(o[s-2],o[s])};break;case 22:case 23:this.$=n.prepareMustache(o[s-3],o[s-2],o[s-1],o[s-4],n.stripFlags(o[s-4],o[s]),this._$);break;case 24:this.$={type:"PartialStatement",name:o[s-3],params:o[s-2],hash:o[s-1],indent:"",strip:n.stripFlags(o[s-4],o[s]),loc:n.locInfo(this._$)};break;case 25:this.$=n.preparePartialBlock(o[s-2],o[s-1],o[s],this._$);break;case 26:this.$={path:o[s-3],params:o[s-2],hash:o[s-1],strip:n.stripFlags(o[s-4],o[s])};break;case 29:this.$={type:"SubExpression",path:o[s-3],params:o[s-2],hash:o[s-1],loc:n.locInfo(this._$)};break;case 30:this.$={type:"Hash",pairs:o[s],loc:n.locInfo(this._$)};break;case 31:this.$={type:"HashPair",key:n.id(o[s-2]),value:o[s],loc:n.locInfo(this._$)};break;case 32:this.$=n.id(o[s-1]);break;case 35:this.$={type:"StringLiteral",value:o[s],original:o[s],loc:n.locInfo(this._$)};break;case 36:this.$={type:"NumberLiteral",value:Number(o[s]),original:Number(o[s]),loc:n.locInfo(this._$)};break;case 37:this.$={type:"BooleanLiteral",value:"true"===o[s],original:"true"===o[s],loc:n.locInfo(this._$)};break;case 38:this.$={type:"UndefinedLiteral",original:void 0,value:void 0,loc:n.locInfo(this._$)};break;case 39:this.$={type:"NullLiteral",original:null,value:null,loc:n.locInfo(this._$)};break;case 42:this.$=n.preparePath(!0,o[s],this._$);break;case 43:this.$=n.preparePath(!1,o[s],this._$);break;case 44:o[s-2].push({part:n.id(o[s]),original:o[s],separator:o[s-1]}),this.$=o[s-2];break;case 45:this.$=[{part:n.id(o[s]),original:o[s]}];break;case 46:case 48:case 50:case 58:case 64:case 70:case 78:case 82:case 86:case 90:case 94:this.$=[];break;case 47:case 49:case 51:case 59:case 65:case 71:case 79:case 83:case 87:case 91:case 95:case 99:case 101:o[s-1].push(o[s]);break;case 98:case 100:this.$=[o[s]];}},table:[{3:1,4:2,5:[2,46],6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{1:[3]},{5:[1,4]},{5:[2,2],7:5,8:6,9:7,10:8,11:9,12:10,13:11,14:[1,12],15:[1,20],16:17,19:[1,23],24:15,27:16,29:[1,21],34:[1,22],39:[2,2],44:[2,2],47:[2,2],48:[1,13],51:[1,14],55:[1,18],59:19,60:[1,24]},{1:[2,1]},{5:[2,47],14:[2,47],15:[2,47],19:[2,47],29:[2,47],34:[2,47],39:[2,47],44:[2,47],47:[2,47],48:[2,47],51:[2,47],55:[2,47],60:[2,47]},{5:[2,3],14:[2,3],15:[2,3],19:[2,3],29:[2,3],34:[2,3],39:[2,3],44:[2,3],47:[2,3],48:[2,3],51:[2,3],55:[2,3],60:[2,3]},{5:[2,4],14:[2,4],15:[2,4],19:[2,4],29:[2,4],34:[2,4],39:[2,4],44:[2,4],47:[2,4],48:[2,4],51:[2,4],55:[2,4],60:[2,4]},{5:[2,5],14:[2,5],15:[2,5],19:[2,5],29:[2,5],34:[2,5],39:[2,5],44:[2,5],47:[2,5],48:[2,5],51:[2,5],55:[2,5],60:[2,5]},{5:[2,6],14:[2,6],15:[2,6],19:[2,6],29:[2,6],34:[2,6],39:[2,6],44:[2,6],47:[2,6],48:[2,6],51:[2,6],55:[2,6],60:[2,6]},{5:[2,7],14:[2,7],15:[2,7],19:[2,7],29:[2,7],34:[2,7],39:[2,7],44:[2,7],47:[2,7],48:[2,7],51:[2,7],55:[2,7],60:[2,7]},{5:[2,8],14:[2,8],15:[2,8],19:[2,8],29:[2,8],34:[2,8],39:[2,8],44:[2,8],47:[2,8],48:[2,8],51:[2,8],55:[2,8],60:[2,8]},{5:[2,9],14:[2,9],15:[2,9],19:[2,9],29:[2,9],34:[2,9],39:[2,9],44:[2,9],47:[2,9],48:[2,9],51:[2,9],55:[2,9],60:[2,9]},{20:25,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:36,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{4:37,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],39:[2,46],44:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{4:38,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],44:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{15:[2,48],17:39,18:[2,48]},{20:41,56:40,64:42,65:[1,43],72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{4:44,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{5:[2,10],14:[2,10],15:[2,10],18:[2,10],19:[2,10],29:[2,10],34:[2,10],39:[2,10],44:[2,10],47:[2,10],48:[2,10],51:[2,10],55:[2,10],60:[2,10]},{20:45,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:46,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:47,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:41,56:48,64:42,65:[1,43],72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{33:[2,78],49:49,65:[2,78],72:[2,78],80:[2,78],81:[2,78],82:[2,78],83:[2,78],84:[2,78],85:[2,78]},{23:[2,33],33:[2,33],54:[2,33],65:[2,33],68:[2,33],72:[2,33],75:[2,33],80:[2,33],81:[2,33],82:[2,33],83:[2,33],84:[2,33],85:[2,33]},{23:[2,34],33:[2,34],54:[2,34],65:[2,34],68:[2,34],72:[2,34],75:[2,34],80:[2,34],81:[2,34],82:[2,34],83:[2,34],84:[2,34],85:[2,34]},{23:[2,35],33:[2,35],54:[2,35],65:[2,35],68:[2,35],72:[2,35],75:[2,35],80:[2,35],81:[2,35],82:[2,35],83:[2,35],84:[2,35],85:[2,35]},{23:[2,36],33:[2,36],54:[2,36],65:[2,36],68:[2,36],72:[2,36],75:[2,36],80:[2,36],81:[2,36],82:[2,36],83:[2,36],84:[2,36],85:[2,36]},{23:[2,37],33:[2,37],54:[2,37],65:[2,37],68:[2,37],72:[2,37],75:[2,37],80:[2,37],81:[2,37],82:[2,37],83:[2,37],84:[2,37],85:[2,37]},{23:[2,38],33:[2,38],54:[2,38],65:[2,38],68:[2,38],72:[2,38],75:[2,38],80:[2,38],81:[2,38],82:[2,38],83:[2,38],84:[2,38],85:[2,38]},{23:[2,39],33:[2,39],54:[2,39],65:[2,39],68:[2,39],72:[2,39],75:[2,39],80:[2,39],81:[2,39],82:[2,39],83:[2,39],84:[2,39],85:[2,39]},{23:[2,43],33:[2,43],54:[2,43],65:[2,43],68:[2,43],72:[2,43],75:[2,43],80:[2,43],81:[2,43],82:[2,43],83:[2,43],84:[2,43],85:[2,43],87:[1,50]},{72:[1,35],86:51},{23:[2,45],33:[2,45],54:[2,45],65:[2,45],68:[2,45],72:[2,45],75:[2,45],80:[2,45],81:[2,45],82:[2,45],83:[2,45],84:[2,45],85:[2,45],87:[2,45]},{52:52,54:[2,82],65:[2,82],72:[2,82],80:[2,82],81:[2,82],82:[2,82],83:[2,82],84:[2,82],85:[2,82]},{25:53,38:55,39:[1,57],43:56,44:[1,58],45:54,47:[2,54]},{28:59,43:60,44:[1,58],47:[2,56]},{13:62,15:[1,20],18:[1,61]},{33:[2,86],57:63,65:[2,86],72:[2,86],80:[2,86],81:[2,86],82:[2,86],83:[2,86],84:[2,86],85:[2,86]},{33:[2,40],65:[2,40],72:[2,40],80:[2,40],81:[2,40],82:[2,40],83:[2,40],84:[2,40],85:[2,40]},{33:[2,41],65:[2,41],72:[2,41],80:[2,41],81:[2,41],82:[2,41],83:[2,41],84:[2,41],85:[2,41]},{20:64,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{26:65,47:[1,66]},{30:67,33:[2,58],65:[2,58],72:[2,58],75:[2,58],80:[2,58],81:[2,58],82:[2,58],83:[2,58],84:[2,58],85:[2,58]},{33:[2,64],35:68,65:[2,64],72:[2,64],75:[2,64],80:[2,64],81:[2,64],82:[2,64],83:[2,64],84:[2,64],85:[2,64]},{21:69,23:[2,50],65:[2,50],72:[2,50],80:[2,50],81:[2,50],82:[2,50],83:[2,50],84:[2,50],85:[2,50]},{33:[2,90],61:70,65:[2,90],72:[2,90],80:[2,90],81:[2,90],82:[2,90],83:[2,90],84:[2,90],85:[2,90]},{20:74,33:[2,80],50:71,63:72,64:75,65:[1,43],69:73,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{72:[1,79]},{23:[2,42],33:[2,42],54:[2,42],65:[2,42],68:[2,42],72:[2,42],75:[2,42],80:[2,42],81:[2,42],82:[2,42],83:[2,42],84:[2,42],85:[2,42],87:[1,50]},{20:74,53:80,54:[2,84],63:81,64:75,65:[1,43],69:82,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{26:83,47:[1,66]},{47:[2,55]},{4:84,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],39:[2,46],44:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{47:[2,20]},{20:85,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{4:86,6:3,14:[2,46],15:[2,46],19:[2,46],29:[2,46],34:[2,46],47:[2,46],48:[2,46],51:[2,46],55:[2,46],60:[2,46]},{26:87,47:[1,66]},{47:[2,57]},{5:[2,11],14:[2,11],15:[2,11],19:[2,11],29:[2,11],34:[2,11],39:[2,11],44:[2,11],47:[2,11],48:[2,11],51:[2,11],55:[2,11],60:[2,11]},{15:[2,49],18:[2,49]},{20:74,33:[2,88],58:88,63:89,64:75,65:[1,43],69:90,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{65:[2,94],66:91,68:[2,94],72:[2,94],80:[2,94],81:[2,94],82:[2,94],83:[2,94],84:[2,94],85:[2,94]},{5:[2,25],14:[2,25],15:[2,25],19:[2,25],29:[2,25],34:[2,25],39:[2,25],44:[2,25],47:[2,25],48:[2,25],51:[2,25],55:[2,25],60:[2,25]},{20:92,72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:74,31:93,33:[2,60],63:94,64:75,65:[1,43],69:95,70:76,71:77,72:[1,78],75:[2,60],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:74,33:[2,66],36:96,63:97,64:75,65:[1,43],69:98,70:76,71:77,72:[1,78],75:[2,66],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:74,22:99,23:[2,52],63:100,64:75,65:[1,43],69:101,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{20:74,33:[2,92],62:102,63:103,64:75,65:[1,43],69:104,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{33:[1,105]},{33:[2,79],65:[2,79],72:[2,79],80:[2,79],81:[2,79],82:[2,79],83:[2,79],84:[2,79],85:[2,79]},{33:[2,81]},{23:[2,27],33:[2,27],54:[2,27],65:[2,27],68:[2,27],72:[2,27],75:[2,27],80:[2,27],81:[2,27],82:[2,27],83:[2,27],84:[2,27],85:[2,27]},{23:[2,28],33:[2,28],54:[2,28],65:[2,28],68:[2,28],72:[2,28],75:[2,28],80:[2,28],81:[2,28],82:[2,28],83:[2,28],84:[2,28],85:[2,28]},{23:[2,30],33:[2,30],54:[2,30],68:[2,30],71:106,72:[1,107],75:[2,30]},{23:[2,98],33:[2,98],54:[2,98],68:[2,98],72:[2,98],75:[2,98]},{23:[2,45],33:[2,45],54:[2,45],65:[2,45],68:[2,45],72:[2,45],73:[1,108],75:[2,45],80:[2,45],81:[2,45],82:[2,45],83:[2,45],84:[2,45],85:[2,45],87:[2,45]},{23:[2,44],33:[2,44],54:[2,44],65:[2,44],68:[2,44],72:[2,44],75:[2,44],80:[2,44],81:[2,44],82:[2,44],83:[2,44],84:[2,44],85:[2,44],87:[2,44]},{54:[1,109]},{54:[2,83],65:[2,83],72:[2,83],80:[2,83],81:[2,83],82:[2,83],83:[2,83],84:[2,83],85:[2,83]},{54:[2,85]},{5:[2,13],14:[2,13],15:[2,13],19:[2,13],29:[2,13],34:[2,13],39:[2,13],44:[2,13],47:[2,13],48:[2,13],51:[2,13],55:[2,13],60:[2,13]},{38:55,39:[1,57],43:56,44:[1,58],45:111,46:110,47:[2,76]},{33:[2,70],40:112,65:[2,70],72:[2,70],75:[2,70],80:[2,70],81:[2,70],82:[2,70],83:[2,70],84:[2,70],85:[2,70]},{47:[2,18]},{5:[2,14],14:[2,14],15:[2,14],19:[2,14],29:[2,14],34:[2,14],39:[2,14],44:[2,14],47:[2,14],48:[2,14],51:[2,14],55:[2,14],60:[2,14]},{33:[1,113]},{33:[2,87],65:[2,87],72:[2,87],80:[2,87],81:[2,87],82:[2,87],83:[2,87],84:[2,87],85:[2,87]},{33:[2,89]},{20:74,63:115,64:75,65:[1,43],67:114,68:[2,96],69:116,70:76,71:77,72:[1,78],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{33:[1,117]},{32:118,33:[2,62],74:119,75:[1,120]},{33:[2,59],65:[2,59],72:[2,59],75:[2,59],80:[2,59],81:[2,59],82:[2,59],83:[2,59],84:[2,59],85:[2,59]},{33:[2,61],75:[2,61]},{33:[2,68],37:121,74:122,75:[1,120]},{33:[2,65],65:[2,65],72:[2,65],75:[2,65],80:[2,65],81:[2,65],82:[2,65],83:[2,65],84:[2,65],85:[2,65]},{33:[2,67],75:[2,67]},{23:[1,123]},{23:[2,51],65:[2,51],72:[2,51],80:[2,51],81:[2,51],82:[2,51],83:[2,51],84:[2,51],85:[2,51]},{23:[2,53]},{33:[1,124]},{33:[2,91],65:[2,91],72:[2,91],80:[2,91],81:[2,91],82:[2,91],83:[2,91],84:[2,91],85:[2,91]},{33:[2,93]},{5:[2,22],14:[2,22],15:[2,22],19:[2,22],29:[2,22],34:[2,22],39:[2,22],44:[2,22],47:[2,22],48:[2,22],51:[2,22],55:[2,22],60:[2,22]},{23:[2,99],33:[2,99],54:[2,99],68:[2,99],72:[2,99],75:[2,99]},{73:[1,108]},{20:74,63:125,64:75,65:[1,43],72:[1,35],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{5:[2,23],14:[2,23],15:[2,23],19:[2,23],29:[2,23],34:[2,23],39:[2,23],44:[2,23],47:[2,23],48:[2,23],51:[2,23],55:[2,23],60:[2,23]},{47:[2,19]},{47:[2,77]},{20:74,33:[2,72],41:126,63:127,64:75,65:[1,43],69:128,70:76,71:77,72:[1,78],75:[2,72],78:26,79:27,80:[1,28],81:[1,29],82:[1,30],83:[1,31],84:[1,32],85:[1,34],86:33},{5:[2,24],14:[2,24],15:[2,24],19:[2,24],29:[2,24],34:[2,24],39:[2,24],44:[2,24],47:[2,24],48:[2,24],51:[2,24],55:[2,24],60:[2,24]},{68:[1,129]},{65:[2,95],68:[2,95],72:[2,95],80:[2,95],81:[2,95],82:[2,95],83:[2,95],84:[2,95],85:[2,95]},{68:[2,97]},{5:[2,21],14:[2,21],15:[2,21],19:[2,21],29:[2,21],34:[2,21],39:[2,21],44:[2,21],47:[2,21],48:[2,21],51:[2,21],55:[2,21],60:[2,21]},{33:[1,130]},{33:[2,63]},{72:[1,132],76:131},{33:[1,133]},{33:[2,69]},{15:[2,12],18:[2,12]},{14:[2,26],15:[2,26],19:[2,26],29:[2,26],34:[2,26],47:[2,26],48:[2,26],51:[2,26],55:[2,26],60:[2,26]},{23:[2,31],33:[2,31],54:[2,31],68:[2,31],72:[2,31],75:[2,31]},{33:[2,74],42:134,74:135,75:[1,120]},{33:[2,71],65:[2,71],72:[2,71],75:[2,71],80:[2,71],81:[2,71],82:[2,71],83:[2,71],84:[2,71],85:[2,71]},{33:[2,73],75:[2,73]},{23:[2,29],33:[2,29],54:[2,29],65:[2,29],68:[2,29],72:[2,29],75:[2,29],80:[2,29],81:[2,29],82:[2,29],83:[2,29],84:[2,29],85:[2,29]},{14:[2,15],15:[2,15],19:[2,15],29:[2,15],34:[2,15],39:[2,15],44:[2,15],47:[2,15],48:[2,15],51:[2,15],55:[2,15],60:[2,15]},{72:[1,137],77:[1,136]},{72:[2,100],77:[2,100]},{14:[2,16],15:[2,16],19:[2,16],29:[2,16],34:[2,16],44:[2,16],47:[2,16],48:[2,16],51:[2,16],55:[2,16],60:[2,16]},{33:[1,138]},{33:[2,75]},{33:[2,32]},{72:[2,101],77:[2,101]},{14:[2,17],15:[2,17],19:[2,17],29:[2,17],34:[2,17],39:[2,17],44:[2,17],47:[2,17],48:[2,17],51:[2,17],55:[2,17],60:[2,17]}],defaultActions:{4:[2,1],54:[2,55],56:[2,20],60:[2,57],73:[2,81],82:[2,85],86:[2,18],90:[2,89],101:[2,53],104:[2,93],110:[2,19],111:[2,77],116:[2,97],119:[2,63],122:[2,69],135:[2,75],136:[2,32]},parseError:function(t,e){throw new Error(t)},parse:function(t){var e=this,r=[0],n=[null],i=[],o=this.table,a="",s=0,l=0;this.lexer.setInput(t),this.lexer.yy=this.yy,this.yy.lexer=this.lexer,this.yy.parser=this,void 0===this.lexer.yylloc&&(this.lexer.yylloc={});var c=this.lexer.yylloc;i.push(c);var u=this.lexer.options&&this.lexer.options.ranges;"function"==typeof this.yy.parseError&&(this.parseError=this.yy.parseError);for(var h,p,f,d,g,m,v,y,_,b={};;){if(p=r[r.length-1],this.defaultActions[p]?f=this.defaultActions[p]:(null==h&&(_=void 0,"number"!=typeof(_=e.lexer.lex()||1)&&(_=e.symbols_[_]||_),h=_),f=o[p]&&o[p][h]),void 0===f||!f.length||!f[0]){var k="";for(g in y=[],o[p])this.terminals_[g]&&g>2&&y.push("'"+this.terminals_[g]+"'");k=this.lexer.showPosition?"Parse error on line "+(s+1)+":\n"+this.lexer.showPosition()+"\nExpecting "+y.join(", ")+", got '"+(this.terminals_[h]||h)+"'":"Parse error on line "+(s+1)+": Unexpected "+(1==h?"end of input":"'"+(this.terminals_[h]||h)+"'"),this.parseError(k,{text:this.lexer.match,token:this.terminals_[h]||h,line:this.lexer.yylineno,loc:c,expected:y});}if(f[0]instanceof Array&&f.length>1)throw new Error("Parse Error: multiple actions possible at state: "+p+", token: "+h);switch(f[0]){case 1:r.push(h),n.push(this.lexer.yytext),i.push(this.lexer.yylloc),r.push(f[1]),h=null,l=this.lexer.yyleng,a=this.lexer.yytext,s=this.lexer.yylineno,c=this.lexer.yylloc;break;case 2:if(m=this.productions_[f[1]][1],b.$=n[n.length-m],b._$={first_line:i[i.length-(m||1)].first_line,last_line:i[i.length-1].last_line,first_column:i[i.length-(m||1)].first_column,last_column:i[i.length-1].last_column},u&&(b._$.range=[i[i.length-(m||1)].range[0],i[i.length-1].range[1]]),void 0!==(d=this.performAction.call(b,a,l,s,this.yy,f[1],n,i)))return d;m&&(r=r.slice(0,-1*m*2),n=n.slice(0,-1*m),i=i.slice(0,-1*m)),r.push(this.productions_[f[1]][0]),n.push(b.$),i.push(b._$),v=o[r[r.length-2]][r[r.length-1]],r.push(v);break;case 3:return !0}}return !0}},e=function(){var t={EOF:1,parseError:function(t,e){if(!this.yy.parser)throw new Error(t);this.yy.parser.parseError(t,e);},setInput:function(t){return this._input=t,this._more=this._less=this.done=!1,this.yylineno=this.yyleng=0,this.yytext=this.matched=this.match="",this.conditionStack=["INITIAL"],this.yylloc={first_line:1,first_column:0,last_line:1,last_column:0},this.options.ranges&&(this.yylloc.range=[0,0]),this.offset=0,this},input:function(){var t=this._input[0];return this.yytext+=t,this.yyleng++,this.offset++,this.match+=t,this.matched+=t,t.match(/(?:\r\n?|\n).*/g)?(this.yylineno++,this.yylloc.last_line++):this.yylloc.last_column++,this.options.ranges&&this.yylloc.range[1]++,this._input=this._input.slice(1),t},unput:function(t){var e=t.length,r=t.split(/(?:\r\n?|\n)/g);this._input=t+this._input,this.yytext=this.yytext.substr(0,this.yytext.length-e-1),this.offset-=e;var n=this.match.split(/(?:\r\n?|\n)/g);this.match=this.match.substr(0,this.match.length-1),this.matched=this.matched.substr(0,this.matched.length-1),r.length-1&&(this.yylineno-=r.length-1);var i=this.yylloc.range;return this.yylloc={first_line:this.yylloc.first_line,last_line:this.yylineno+1,first_column:this.yylloc.first_column,last_column:r?(r.length===n.length?this.yylloc.first_column:0)+n[n.length-r.length].length-r[0].length:this.yylloc.first_column-e},this.options.ranges&&(this.yylloc.range=[i[0],i[0]+this.yyleng-e]),this},more:function(){return this._more=!0,this},less:function(t){this.unput(this.match.slice(t));},pastInput:function(){var t=this.matched.substr(0,this.matched.length-this.match.length);return (t.length>20?"...":"")+t.substr(-20).replace(/\n/g,"")},upcomingInput:function(){var t=this.match;return t.length<20&&(t+=this._input.substr(0,20-t.length)),(t.substr(0,20)+(t.length>20?"...":"")).replace(/\n/g,"")},showPosition:function(){var t=this.pastInput(),e=new Array(t.length+1).join("-");return t+this.upcomingInput()+"\n"+e+"^"},next:function(){if(this.done)return this.EOF;var t,e,r,n,i;this._input||(this.done=!0),this._more||(this.yytext="",this.match="");for(var o=this._currentRules(),a=0;a<o.length&&(!(r=this._input.match(this.rules[o[a]]))||e&&!(r[0].length>e[0].length)||(e=r,n=a,this.options.flex));a++);return e?((i=e[0].match(/(?:\r\n?|\n).*/g))&&(this.yylineno+=i.length),this.yylloc={first_line:this.yylloc.last_line,last_line:this.yylineno+1,first_column:this.yylloc.last_column,last_column:i?i[i.length-1].length-i[i.length-1].match(/\r?\n?/)[0].length:this.yylloc.last_column+e[0].length},this.yytext+=e[0],this.match+=e[0],this.matches=e,this.yyleng=this.yytext.length,this.options.ranges&&(this.yylloc.range=[this.offset,this.offset+=this.yyleng]),this._more=!1,this._input=this._input.slice(e[0].length),this.matched+=e[0],t=this.performAction.call(this,this.yy,this,o[n],this.conditionStack[this.conditionStack.length-1]),this.done&&this._input&&(this.done=!1),t||void 0):""===this._input?this.EOF:this.parseError("Lexical error on line "+(this.yylineno+1)+". Unrecognized text.\n"+this.showPosition(),{text:"",token:null,line:this.yylineno})},lex:function(){var t=this.next();return void 0!==t?t:this.lex()},begin:function(t){this.conditionStack.push(t);},popState:function(){return this.conditionStack.pop()},_currentRules:function(){return this.conditions[this.conditionStack[this.conditionStack.length-1]].rules},topState:function(){return this.conditionStack[this.conditionStack.length-2]},pushState:function(t){this.begin(t);},options:{},performAction:function(t,e,r,n){function i(t,r){return e.yytext=e.yytext.substring(t,e.yyleng-r+t)}switch(r){case 0:if("\\\\"===e.yytext.slice(-2)?(i(0,1),this.begin("mu")):"\\"===e.yytext.slice(-1)?(i(0,1),this.begin("emu")):this.begin("mu"),e.yytext)return 15;break;case 1:case 5:return 15;case 2:return this.popState(),15;case 3:return this.begin("raw"),15;case 4:return this.popState(),"raw"===this.conditionStack[this.conditionStack.length-1]?15:(i(5,9),"END_RAW_BLOCK");case 6:case 22:return this.popState(),14;case 7:return 65;case 8:return 68;case 9:return 19;case 10:return this.popState(),this.begin("raw"),23;case 11:return 55;case 12:return 60;case 13:return 29;case 14:return 47;case 15:case 16:return this.popState(),44;case 17:return 34;case 18:return 39;case 19:return 51;case 20:case 23:return 48;case 21:this.unput(e.yytext),this.popState(),this.begin("com");break;case 24:return 73;case 25:case 26:case 41:return 72;case 27:return 87;case 28:break;case 29:return this.popState(),54;case 30:return this.popState(),33;case 31:return e.yytext=i(1,2).replace(/\\"/g,'"'),80;case 32:return e.yytext=i(1,2).replace(/\\'/g,"'"),80;case 33:return 85;case 34:case 35:return 82;case 36:return 83;case 37:return 84;case 38:return 81;case 39:return 75;case 40:return 77;case 42:return e.yytext=e.yytext.replace(/\\([\\\]])/g,"$1"),72;case 43:return "INVALID";case 44:return 5}},rules:[/^(?:[^\x00]*?(?=(\{\{)))/,/^(?:[^\x00]+)/,/^(?:[^\x00]{2,}?(?=(\{\{|\\\{\{|\\\\\{\{|$)))/,/^(?:\{\{\{\{(?=[^\/]))/,/^(?:\{\{\{\{\/[^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=[=}\s\/.])\}\}\}\})/,/^(?:[^\x00]+?(?=(\{\{\{\{)))/,/^(?:[\s\S]*?--(~)?\}\})/,/^(?:\()/,/^(?:\))/,/^(?:\{\{\{\{)/,/^(?:\}\}\}\})/,/^(?:\{\{(~)?>)/,/^(?:\{\{(~)?#>)/,/^(?:\{\{(~)?#\*?)/,/^(?:\{\{(~)?\/)/,/^(?:\{\{(~)?\^\s*(~)?\}\})/,/^(?:\{\{(~)?\s*else\s*(~)?\}\})/,/^(?:\{\{(~)?\^)/,/^(?:\{\{(~)?\s*else\b)/,/^(?:\{\{(~)?\{)/,/^(?:\{\{(~)?&)/,/^(?:\{\{(~)?!--)/,/^(?:\{\{(~)?![\s\S]*?\}\})/,/^(?:\{\{(~)?\*?)/,/^(?:=)/,/^(?:\.\.)/,/^(?:\.(?=([=~}\s\/.)|])))/,/^(?:[\/.])/,/^(?:\s+)/,/^(?:\}(~)?\}\})/,/^(?:(~)?\}\})/,/^(?:"(\\["]|[^"])*")/,/^(?:'(\\[']|[^'])*')/,/^(?:@)/,/^(?:true(?=([~}\s)])))/,/^(?:false(?=([~}\s)])))/,/^(?:undefined(?=([~}\s)])))/,/^(?:null(?=([~}\s)])))/,/^(?:-?[0-9]+(?:\.[0-9]+)?(?=([~}\s)])))/,/^(?:as\s+\|)/,/^(?:\|)/,/^(?:([^\s!"#%-,\.\/;->@\[-\^`\{-~]+(?=([=~}\s\/.)|]))))/,/^(?:\[(\\\]|[^\]])*\])/,/^(?:.)/,/^(?:$)/],conditions:{mu:{rules:[7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44],inclusive:!1},emu:{rules:[2],inclusive:!1},com:{rules:[6],inclusive:!1},raw:{rules:[3,4,5],inclusive:!1},INITIAL:{rules:[0,1,44],inclusive:!0}}};return t}();function r(){this.yy={};}return t.lexer=e,r.prototype=t,t.Parser=r,new r}();e.default=r,t.exports=e.default;}(Jr,Jr.exports);var Gr={exports:{}},Zr={exports:{}};!function(t,e){e.__esModule=!0;var r=function(t){return t&&t.__esModule?t:{default:t}}(qe.exports);function n(){this.parents=[];}function i(t){this.acceptRequired(t,"path"),this.acceptArray(t.params),this.acceptKey(t,"hash");}function o(t){i.call(this,t),this.acceptKey(t,"program"),this.acceptKey(t,"inverse");}function a(t){this.acceptRequired(t,"name"),this.acceptArray(t.params),this.acceptKey(t,"hash");}n.prototype={constructor:n,mutating:!1,acceptKey:function(t,e){var i=this.accept(t[e]);if(this.mutating){if(i&&!n.prototype[i.type])throw new r.default('Unexpected node type "'+i.type+'" found when accepting '+e+" on "+t.type);t[e]=i;}},acceptRequired:function(t,e){if(this.acceptKey(t,e),!t[e])throw new r.default(t.type+" requires "+e)},acceptArray:function(t){for(var e=0,r=t.length;e<r;e++)this.acceptKey(t,e),t[e]||(t.splice(e,1),e--,r--);},accept:function(t){if(t){if(!this[t.type])throw new r.default("Unknown type: "+t.type,t);this.current&&this.parents.unshift(this.current),this.current=t;var e=this[t.type](t);return this.current=this.parents.shift(),!this.mutating||e?e:!1!==e?t:void 0}},Program:function(t){this.acceptArray(t.body);},MustacheStatement:i,Decorator:i,BlockStatement:o,DecoratorBlock:o,PartialStatement:a,PartialBlockStatement:function(t){a.call(this,t),this.acceptKey(t,"program");},ContentStatement:function(){},CommentStatement:function(){},SubExpression:i,PathExpression:function(){},StringLiteral:function(){},NumberLiteral:function(){},BooleanLiteral:function(){},UndefinedLiteral:function(){},NullLiteral:function(){},Hash:function(t){this.acceptArray(t.pairs);},HashPair:function(t){this.acceptRequired(t,"value");}},e.default=n,t.exports=e.default;}(Zr,Zr.exports),function(t,e){e.__esModule=!0;var r=function(t){return t&&t.__esModule?t:{default:t}}(Zr.exports);function n(){var t=arguments.length<=0||void 0===arguments[0]?{}:arguments[0];this.options=t;}function i(t,e,r){void 0===e&&(e=t.length);var n=t[e-1],i=t[e-2];return n?"ContentStatement"===n.type?(i||!r?/\r?\n\s*?$/:/(^|\r?\n)\s*?$/).test(n.original):void 0:r}function o(t,e,r){void 0===e&&(e=-1);var n=t[e+1],i=t[e+2];return n?"ContentStatement"===n.type?(i||!r?/^\s*?\r?\n/:/^\s*?(\r?\n|$)/).test(n.original):void 0:r}function a(t,e,r){var n=t[null==e?0:e+1];if(n&&"ContentStatement"===n.type&&(r||!n.rightStripped)){var i=n.value;n.value=n.value.replace(r?/^\s+/:/^[ \t]*\r?\n?/,""),n.rightStripped=n.value!==i;}}function s(t,e,r){var n=t[null==e?t.length-1:e-1];if(n&&"ContentStatement"===n.type&&(r||!n.leftStripped)){var i=n.value;return n.value=n.value.replace(r?/\s+$/:/[ \t]+$/,""),n.leftStripped=n.value!==i,n.leftStripped}}n.prototype=new r.default,n.prototype.Program=function(t){var e=!this.options.ignoreStandalone,r=!this.isRootSeen;this.isRootSeen=!0;for(var n=t.body,l=0,c=n.length;l<c;l++){var u=n[l],h=this.accept(u);if(h){var p=i(n,l,r),f=o(n,l,r),d=h.openStandalone&&p,g=h.closeStandalone&&f,m=h.inlineStandalone&&p&&f;h.close&&a(n,l,!0),h.open&&s(n,l,!0),e&&m&&(a(n,l),s(n,l)&&"PartialStatement"===u.type&&(u.indent=/([ \t]+$)/.exec(n[l-1].original)[1])),e&&d&&(a((u.program||u.inverse).body),s(n,l)),e&&g&&(a(n,l),s((u.inverse||u.program).body));}}return t},n.prototype.BlockStatement=n.prototype.DecoratorBlock=n.prototype.PartialBlockStatement=function(t){this.accept(t.program),this.accept(t.inverse);var e=t.program||t.inverse,r=t.program&&t.inverse,n=r,l=r;if(r&&r.chained)for(n=r.body[0].program;l.chained;)l=l.body[l.body.length-1].program;var c={open:t.openStrip.open,close:t.closeStrip.close,openStandalone:o(e.body),closeStandalone:i((n||e).body)};if(t.openStrip.close&&a(e.body,null,!0),r){var u=t.inverseStrip;u.open&&s(e.body,null,!0),u.close&&a(n.body,null,!0),t.closeStrip.open&&s(l.body,null,!0),!this.options.ignoreStandalone&&i(e.body)&&o(n.body)&&(s(e.body),a(n.body));}else t.closeStrip.open&&s(e.body,null,!0);return c},n.prototype.Decorator=n.prototype.MustacheStatement=function(t){return t.strip},n.prototype.PartialStatement=n.prototype.CommentStatement=function(t){var e=t.strip||{};return {inlineStandalone:!0,open:e.open,close:e.close}},e.default=n,t.exports=e.default;}(Gr,Gr.exports);var Xr={};Xr.__esModule=!0,Xr.SourceLocation=function(t,e){this.source=t,this.start={line:e.first_line,column:e.first_column},this.end={line:e.last_line,column:e.last_column};},Xr.id=function(t){return /^\[.*\]$/.test(t)?t.substring(1,t.length-1):t},Xr.stripFlags=function(t,e){return {open:"~"===t.charAt(2),close:"~"===e.charAt(e.length-3)}},Xr.stripComment=function(t){return t.replace(/^\{\{~?!-?-?/,"").replace(/-?-?~?\}\}$/,"")},Xr.preparePath=function(t,e,r){r=this.locInfo(r);for(var n=t?"@":"",i=[],o=0,a=0,s=e.length;a<s;a++){var l=e[a].part,c=e[a].original!==l;if(n+=(e[a].separator||"")+l,c||".."!==l&&"."!==l&&"this"!==l)i.push(l);else {if(i.length>0)throw new Qr.default("Invalid path: "+n,{loc:r});".."===l&&o++;}}return {type:"PathExpression",data:t,depth:o,parts:i,original:n,loc:r}},Xr.prepareMustache=function(t,e,r,n,i,o){var a=n.charAt(3)||n.charAt(2),s="{"!==a&&"&"!==a;return {type:/\*/.test(n)?"Decorator":"MustacheStatement",path:t,params:e,hash:r,escaped:s,strip:i,loc:this.locInfo(o)}},Xr.prepareRawBlock=function(t,e,r,n){tn(t,r),n=this.locInfo(n);var i={type:"Program",body:e,strip:{},loc:n};return {type:"BlockStatement",path:t.path,params:t.params,hash:t.hash,program:i,openStrip:{},inverseStrip:{},closeStrip:{},loc:n}},Xr.prepareBlock=function(t,e,r,n,i,o){n&&n.path&&tn(t,n);var a=/\*/.test(t.open);e.blockParams=t.blockParams;var s=void 0,l=void 0;if(r){if(a)throw new Qr.default("Unexpected inverse block on decorator",r);r.chain&&(r.program.body[0].closeStrip=n.strip),l=r.strip,s=r.program;}i&&(i=s,s=e,e=i);return {type:a?"DecoratorBlock":"BlockStatement",path:t.path,params:t.params,hash:t.hash,program:e,inverse:s,openStrip:t.strip,inverseStrip:l,closeStrip:n&&n.strip,loc:this.locInfo(o)}},Xr.prepareProgram=function(t,e){if(!e&&t.length){var r=t[0].loc,n=t[t.length-1].loc;r&&n&&(e={source:r.source,start:{line:r.start.line,column:r.start.column},end:{line:n.end.line,column:n.end.column}});}return {type:"Program",body:t,strip:{},loc:e}},Xr.preparePartialBlock=function(t,e,r,n){return tn(t,r),{type:"PartialBlockStatement",name:t.path,params:t.params,hash:t.hash,program:e,openStrip:t.strip,closeStrip:r&&r.strip,loc:this.locInfo(n)}};var Qr=function(t){return t&&t.__esModule?t:{default:t}}(qe.exports);function tn(t,e){if(e=e.path?e.path.original:e,t.path.original!==e){var r={loc:t.path.loc};throw new Qr.default(t.path.original+" doesn't match "+e,r)}}function en$1(t){return t&&t.__esModule?t:{default:t}}Kr.__esModule=!0,Kr.parseWithoutProcessing=ln,Kr.parse=function(t,e){var r=ln(t,e);return new nn.default(e).accept(r)};var rn=en$1(Jr.exports),nn=en$1(Gr.exports),on$1=function(t){if(t&&t.__esModule)return t;var e={};if(null!=t)for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(e[r]=t[r]);return e.default=t,e}(Xr),an=Be;Kr.parser=rn.default;var sn={};function ln(t,e){return "Program"===t.type?t:(rn.default.yy=sn,sn.locInfo=function(t){return new sn.SourceLocation(e&&e.srcName,t)},rn.default.parse(t))}an.extend(sn,on$1);var cn={};function un(t){return t&&t.__esModule?t:{default:t}}cn.__esModule=!0,cn.Compiler=gn,cn.precompile=function(t,e,r){if(null==t||"string"!=typeof t&&"Program"!==t.type)throw new hn.default("You must pass a string or Handlebars AST to Handlebars.precompile. You passed "+t);"data"in(e=e||{})||(e.data=!0);e.compat&&(e.useDepths=!0);var n=r.parse(t,e),i=(new r.Compiler).compile(n,e);return (new r.JavaScriptCompiler).compile(i,e)},cn.compile=function(t,e,r){void 0===e&&(e={});if(null==t||"string"!=typeof t&&"Program"!==t.type)throw new hn.default("You must pass a string or Handlebars AST to Handlebars.compile. You passed "+t);"data"in(e=pn.extend({},e))||(e.data=!0);e.compat&&(e.useDepths=!0);var n=void 0;function i(){var n=r.parse(t,e),i=(new r.Compiler).compile(n,e),o=(new r.JavaScriptCompiler).compile(i,e,void 0,!0);return r.template(o)}function o(t,e){return n||(n=i()),n.call(this,t,e)}return o._setup=function(t){return n||(n=i()),n._setup(t)},o._child=function(t,e,r,o){return n||(n=i()),n._child(t,e,r,o)},o};var hn=un(qe.exports),pn=Be,fn=un(qr.exports),dn=[].slice;function gn(){}function mn(t,e){if(t===e)return !0;if(pn.isArray(t)&&pn.isArray(e)&&t.length===e.length){for(var r=0;r<t.length;r++)if(!mn(t[r],e[r]))return !1;return !0}}function vn(t){if(!t.path.parts){var e=t.path;t.path={type:"PathExpression",data:!1,depth:0,parts:[e.original+""],original:e.original+"",loc:e.loc};}}gn.prototype={compiler:gn,equals:function(t){var e=this.opcodes.length;if(t.opcodes.length!==e)return !1;for(var r=0;r<e;r++){var n=this.opcodes[r],i=t.opcodes[r];if(n.opcode!==i.opcode||!mn(n.args,i.args))return !1}e=this.children.length;for(r=0;r<e;r++)if(!this.children[r].equals(t.children[r]))return !1;return !0},guid:0,compile:function(t,e){return this.sourceNode=[],this.opcodes=[],this.children=[],this.options=e,this.stringParams=e.stringParams,this.trackIds=e.trackIds,e.blockParams=e.blockParams||[],e.knownHelpers=pn.extend(Object.create(null),{helperMissing:!0,blockHelperMissing:!0,each:!0,if:!0,unless:!0,with:!0,log:!0,lookup:!0},e.knownHelpers),this.accept(t)},compileProgram:function(t){var e=(new this.compiler).compile(t,this.options),r=this.guid++;return this.usePartial=this.usePartial||e.usePartial,this.children[r]=e,this.useDepths=this.useDepths||e.useDepths,r},accept:function(t){if(!this[t.type])throw new hn.default("Unknown type: "+t.type,t);this.sourceNode.unshift(t);var e=this[t.type](t);return this.sourceNode.shift(),e},Program:function(t){this.options.blockParams.unshift(t.blockParams);for(var e=t.body,r=e.length,n=0;n<r;n++)this.accept(e[n]);return this.options.blockParams.shift(),this.isSimple=1===r,this.blockParams=t.blockParams?t.blockParams.length:0,this},BlockStatement:function(t){vn(t);var e=t.program,r=t.inverse;e=e&&this.compileProgram(e),r=r&&this.compileProgram(r);var n=this.classifySexpr(t);"helper"===n?this.helperSexpr(t,e,r):"simple"===n?(this.simpleSexpr(t),this.opcode("pushProgram",e),this.opcode("pushProgram",r),this.opcode("emptyHash"),this.opcode("blockValue",t.path.original)):(this.ambiguousSexpr(t,e,r),this.opcode("pushProgram",e),this.opcode("pushProgram",r),this.opcode("emptyHash"),this.opcode("ambiguousBlockValue")),this.opcode("append");},DecoratorBlock:function(t){var e=t.program&&this.compileProgram(t.program),r=this.setupFullMustacheParams(t,e,void 0),n=t.path;this.useDecorators=!0,this.opcode("registerDecorator",r.length,n.original);},PartialStatement:function(t){this.usePartial=!0;var e=t.program;e&&(e=this.compileProgram(t.program));var r=t.params;if(r.length>1)throw new hn.default("Unsupported number of partial arguments: "+r.length,t);r.length||(this.options.explicitPartialContext?this.opcode("pushLiteral","undefined"):r.push({type:"PathExpression",parts:[],depth:0}));var n=t.name.original,i="SubExpression"===t.name.type;i&&this.accept(t.name),this.setupFullMustacheParams(t,e,void 0,!0);var o=t.indent||"";this.options.preventIndent&&o&&(this.opcode("appendContent",o),o=""),this.opcode("invokePartial",i,n,o),this.opcode("append");},PartialBlockStatement:function(t){this.PartialStatement(t);},MustacheStatement:function(t){this.SubExpression(t),t.escaped&&!this.options.noEscape?this.opcode("appendEscaped"):this.opcode("append");},Decorator:function(t){this.DecoratorBlock(t);},ContentStatement:function(t){t.value&&this.opcode("appendContent",t.value);},CommentStatement:function(){},SubExpression:function(t){vn(t);var e=this.classifySexpr(t);"simple"===e?this.simpleSexpr(t):"helper"===e?this.helperSexpr(t):this.ambiguousSexpr(t);},ambiguousSexpr:function(t,e,r){var n=t.path,i=n.parts[0],o=null!=e||null!=r;this.opcode("getContext",n.depth),this.opcode("pushProgram",e),this.opcode("pushProgram",r),n.strict=!0,this.accept(n),this.opcode("invokeAmbiguous",i,o);},simpleSexpr:function(t){var e=t.path;e.strict=!0,this.accept(e),this.opcode("resolvePossibleLambda");},helperSexpr:function(t,e,r){var n=this.setupFullMustacheParams(t,e,r),i=t.path,o=i.parts[0];if(this.options.knownHelpers[o])this.opcode("invokeKnownHelper",n.length,o);else {if(this.options.knownHelpersOnly)throw new hn.default("You specified knownHelpersOnly, but used the unknown helper "+o,t);i.strict=!0,i.falsy=!0,this.accept(i),this.opcode("invokeHelper",n.length,i.original,fn.default.helpers.simpleId(i));}},PathExpression:function(t){this.addDepth(t.depth),this.opcode("getContext",t.depth);var e=t.parts[0],r=fn.default.helpers.scopedId(t),n=!t.depth&&!r&&this.blockParamIndex(e);n?this.opcode("lookupBlockParam",n,t.parts):e?t.data?(this.options.data=!0,this.opcode("lookupData",t.depth,t.parts,t.strict)):this.opcode("lookupOnContext",t.parts,t.falsy,t.strict,r):this.opcode("pushContext");},StringLiteral:function(t){this.opcode("pushString",t.value);},NumberLiteral:function(t){this.opcode("pushLiteral",t.value);},BooleanLiteral:function(t){this.opcode("pushLiteral",t.value);},UndefinedLiteral:function(){this.opcode("pushLiteral","undefined");},NullLiteral:function(){this.opcode("pushLiteral","null");},Hash:function(t){var e=t.pairs,r=0,n=e.length;for(this.opcode("pushHash");r<n;r++)this.pushParam(e[r].value);for(;r--;)this.opcode("assignToHash",e[r].key);this.opcode("popHash");},opcode:function(t){this.opcodes.push({opcode:t,args:dn.call(arguments,1),loc:this.sourceNode[0].loc});},addDepth:function(t){t&&(this.useDepths=!0);},classifySexpr:function(t){var e=fn.default.helpers.simpleId(t.path),r=e&&!!this.blockParamIndex(t.path.parts[0]),n=!r&&fn.default.helpers.helperExpression(t),i=!r&&(n||e);if(i&&!n){var o=t.path.parts[0],a=this.options;a.knownHelpers[o]?n=!0:a.knownHelpersOnly&&(i=!1);}return n?"helper":i?"ambiguous":"simple"},pushParams:function(t){for(var e=0,r=t.length;e<r;e++)this.pushParam(t[e]);},pushParam:function(t){var e=null!=t.value?t.value:t.original||"";if(this.stringParams)e.replace&&(e=e.replace(/^(\.?\.\/)*/g,"").replace(/\//g,".")),t.depth&&this.addDepth(t.depth),this.opcode("getContext",t.depth||0),this.opcode("pushStringParam",e,t.type),"SubExpression"===t.type&&this.accept(t);else {if(this.trackIds){var r=void 0;if(!t.parts||fn.default.helpers.scopedId(t)||t.depth||(r=this.blockParamIndex(t.parts[0])),r){var n=t.parts.slice(1).join(".");this.opcode("pushId","BlockParam",r,n);}else (e=t.original||e).replace&&(e=e.replace(/^this(?:\.|$)/,"").replace(/^\.\//,"").replace(/^\.$/,"")),this.opcode("pushId",t.type,e);}this.accept(t);}},setupFullMustacheParams:function(t,e,r,n){var i=t.params;return this.pushParams(i),this.opcode("pushProgram",e),this.opcode("pushProgram",r),t.hash?this.accept(t.hash):this.opcode("emptyHash",n),i},blockParamIndex:function(t){for(var e=0,r=this.options.blockParams.length;e<r;e++){var n=this.options.blockParams[e],i=n&&pn.indexOf(n,t);if(n&&i>=0)return [e,i]}}};var yn={exports:{}},_n={exports:{}};!function(t,e){e.__esModule=!0;var r=Be,n=void 0;try{var i=require("source-map");n=i.SourceNode;}catch(t){}function o(t,e,n){if(r.isArray(t)){for(var i=[],o=0,a=t.length;o<a;o++)i.push(e.wrap(t[o],n));return i}return "boolean"==typeof t||"number"==typeof t?t+"":t}function a(t){this.srcFile=t,this.source=[];}n||((n=function(t,e,r,n){this.src="",n&&this.add(n);}).prototype={add:function(t){r.isArray(t)&&(t=t.join("")),this.src+=t;},prepend:function(t){r.isArray(t)&&(t=t.join("")),this.src=t+this.src;},toStringWithSourceMap:function(){return {code:this.toString()}},toString:function(){return this.src}}),a.prototype={isEmpty:function(){return !this.source.length},prepend:function(t,e){this.source.unshift(this.wrap(t,e));},push:function(t,e){this.source.push(this.wrap(t,e));},merge:function(){var t=this.empty();return this.each((function(e){t.add(["  ",e,"\n"]);})),t},each:function(t){for(var e=0,r=this.source.length;e<r;e++)t(this.source[e]);},empty:function(){var t=this.currentLocation||{start:{}};return new n(t.start.line,t.start.column,this.srcFile)},wrap:function(t){var e=arguments.length<=1||void 0===arguments[1]?this.currentLocation||{start:{}}:arguments[1];return t instanceof n?t:(t=o(t,this,e),new n(e.start.line,e.start.column,this.srcFile,t))},functionCall:function(t,e,r){return r=this.generateList(r),this.wrap([t,e?"."+e+"(":"(",r,")"])},quotedString:function(t){return '"'+(t+"").replace(/\\/g,"\\\\").replace(/"/g,'\\"').replace(/\n/g,"\\n").replace(/\r/g,"\\r").replace(/\u2028/g,"\\u2028").replace(/\u2029/g,"\\u2029")+'"'},objectLiteral:function(t){var e=this,r=[];Object.keys(t).forEach((function(n){var i=o(t[n],e);"undefined"!==i&&r.push([e.quotedString(n),":",i]);}));var n=this.generateList(r);return n.prepend("{"),n.add("}"),n},generateList:function(t){for(var e=this.empty(),r=0,n=t.length;r<n;r++)r&&e.add(","),e.add(o(t[r],this));return e},generateArray:function(t){var e=this.generateList(t);return e.prepend("["),e.add("]"),e}},e.default=a,t.exports=e.default;}(_n,_n.exports),function(t,e){function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0;var n=Fe,i=r(qe.exports),o=Be,a=r(_n.exports);function s(t){this.value=t;}function l(){}l.prototype={nameLookup:function(t,e){return this.internalNameLookup(t,e)},depthedLookup:function(t){return [this.aliasable("container.lookup"),"(depths, ",JSON.stringify(t),")"]},compilerInfo:function(){var t=n.COMPILER_REVISION;return [t,n.REVISION_CHANGES[t]]},appendToBuffer:function(t,e,r){return o.isArray(t)||(t=[t]),t=this.source.wrap(t,e),this.environment.isSimple?["return ",t,";"]:r?["buffer += ",t,";"]:(t.appendToBuffer=!0,t)},initializeBuffer:function(){return this.quotedString("")},internalNameLookup:function(t,e){return this.lookupPropertyFunctionIsUsed=!0,["lookupProperty(",t,",",JSON.stringify(e),")"]},lookupPropertyFunctionIsUsed:!1,compile:function(t,e,r,n){this.environment=t,this.options=e,this.stringParams=this.options.stringParams,this.trackIds=this.options.trackIds,this.precompile=!n,this.name=this.environment.name,this.isChild=!!r,this.context=r||{decorators:[],programs:[],environments:[]},this.preamble(),this.stackSlot=0,this.stackVars=[],this.aliases={},this.registers={list:[]},this.hashes=[],this.compileStack=[],this.inlineStack=[],this.blockParams=[],this.compileChildren(t,e),this.useDepths=this.useDepths||t.useDepths||t.useDecorators||this.options.compat,this.useBlockParams=this.useBlockParams||t.useBlockParams;var o=t.opcodes,a=void 0,s=void 0,l=void 0,c=void 0;for(l=0,c=o.length;l<c;l++)a=o[l],this.source.currentLocation=a.loc,s=s||a.loc,this[a.opcode].apply(this,a.args);if(this.source.currentLocation=s,this.pushSource(""),this.stackSlot||this.inlineStack.length||this.compileStack.length)throw new i.default("Compile completed with content left on stack");this.decorators.isEmpty()?this.decorators=void 0:(this.useDecorators=!0,this.decorators.prepend(["var decorators = container.decorators, ",this.lookupPropertyFunctionVarDeclaration(),";\n"]),this.decorators.push("return fn;"),n?this.decorators=Function.apply(this,["fn","props","container","depth0","data","blockParams","depths",this.decorators.merge()]):(this.decorators.prepend("function(fn, props, container, depth0, data, blockParams, depths) {\n"),this.decorators.push("}\n"),this.decorators=this.decorators.merge()));var u=this.createFunctionContext(n);if(this.isChild)return u;var h={compiler:this.compilerInfo(),main:u};this.decorators&&(h.main_d=this.decorators,h.useDecorators=!0);var p=this.context,f=p.programs,d=p.decorators;for(l=0,c=f.length;l<c;l++)f[l]&&(h[l]=f[l],d[l]&&(h[l+"_d"]=d[l],h.useDecorators=!0));return this.environment.usePartial&&(h.usePartial=!0),this.options.data&&(h.useData=!0),this.useDepths&&(h.useDepths=!0),this.useBlockParams&&(h.useBlockParams=!0),this.options.compat&&(h.compat=!0),n?h.compilerOptions=this.options:(h.compiler=JSON.stringify(h.compiler),this.source.currentLocation={start:{line:1,column:0}},h=this.objectLiteral(h),e.srcName?(h=h.toStringWithSourceMap({file:e.destName})).map=h.map&&h.map.toString():h=h.toString()),h},preamble:function(){this.lastContext=0,this.source=new a.default(this.options.srcName),this.decorators=new a.default(this.options.srcName);},createFunctionContext:function(t){var e=this,r="",n=this.stackVars.concat(this.registers.list);n.length>0&&(r+=", "+n.join(", "));var i=0;Object.keys(this.aliases).forEach((function(t){var n=e.aliases[t];n.children&&n.referenceCount>1&&(r+=", alias"+ ++i+"="+t,n.children[0]="alias"+i);})),this.lookupPropertyFunctionIsUsed&&(r+=", "+this.lookupPropertyFunctionVarDeclaration());var o=["container","depth0","helpers","partials","data"];(this.useBlockParams||this.useDepths)&&o.push("blockParams"),this.useDepths&&o.push("depths");var a=this.mergeSource(r);return t?(o.push(a),Function.apply(this,o)):this.source.wrap(["function(",o.join(","),") {\n  ",a,"}"])},mergeSource:function(t){var e=this.environment.isSimple,r=!this.forceBuffer,n=void 0,i=void 0,o=void 0,a=void 0;return this.source.each((function(t){t.appendToBuffer?(o?t.prepend("  + "):o=t,a=t):(o&&(i?o.prepend("buffer += "):n=!0,a.add(";"),o=a=void 0),i=!0,e||(r=!1));})),r?o?(o.prepend("return "),a.add(";")):i||this.source.push('return "";'):(t+=", buffer = "+(n?"":this.initializeBuffer()),o?(o.prepend("return buffer + "),a.add(";")):this.source.push("return buffer;")),t&&this.source.prepend("var "+t.substring(2)+(n?"":";\n")),this.source.merge()},lookupPropertyFunctionVarDeclaration:function(){return "\n      lookupProperty = container.lookupProperty || function(parent, propertyName) {\n        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {\n          return parent[propertyName];\n        }\n        return undefined\n    }\n    ".trim()},blockValue:function(t){var e=this.aliasable("container.hooks.blockHelperMissing"),r=[this.contextName(0)];this.setupHelperArgs(t,0,r);var n=this.popStack();r.splice(1,0,n),this.push(this.source.functionCall(e,"call",r));},ambiguousBlockValue:function(){var t=this.aliasable("container.hooks.blockHelperMissing"),e=[this.contextName(0)];this.setupHelperArgs("",0,e,!0),this.flushInline();var r=this.topStack();e.splice(1,0,r),this.pushSource(["if (!",this.lastHelper,") { ",r," = ",this.source.functionCall(t,"call",e),"}"]);},appendContent:function(t){this.pendingContent?t=this.pendingContent+t:this.pendingLocation=this.source.currentLocation,this.pendingContent=t;},append:function(){if(this.isInline())this.replaceStack((function(t){return [" != null ? ",t,' : ""']})),this.pushSource(this.appendToBuffer(this.popStack()));else {var t=this.popStack();this.pushSource(["if (",t," != null) { ",this.appendToBuffer(t,void 0,!0)," }"]),this.environment.isSimple&&this.pushSource(["else { ",this.appendToBuffer("''",void 0,!0)," }"]);}},appendEscaped:function(){this.pushSource(this.appendToBuffer([this.aliasable("container.escapeExpression"),"(",this.popStack(),")"]));},getContext:function(t){this.lastContext=t;},pushContext:function(){this.pushStackLiteral(this.contextName(this.lastContext));},lookupOnContext:function(t,e,r,n){var i=0;n||!this.options.compat||this.lastContext?this.pushContext():this.push(this.depthedLookup(t[i++])),this.resolvePath("context",t,i,e,r);},lookupBlockParam:function(t,e){this.useBlockParams=!0,this.push(["blockParams[",t[0],"][",t[1],"]"]),this.resolvePath("context",e,1);},lookupData:function(t,e,r){t?this.pushStackLiteral("container.data(data, "+t+")"):this.pushStackLiteral("data"),this.resolvePath("data",e,0,!0,r);},resolvePath:function(t,e,r,n,i){var o=this;if(this.options.strict||this.options.assumeObjects)this.push(function(t,e,r,n){var i=e.popStack(),o=0,a=r.length;t&&a--;for(;o<a;o++)i=e.nameLookup(i,r[o],n);return t?[e.aliasable("container.strict"),"(",i,", ",e.quotedString(r[o]),", ",JSON.stringify(e.source.currentLocation)," )"]:i}(this.options.strict&&i,this,e,t));else for(var a=e.length;r<a;r++)this.replaceStack((function(i){var a=o.nameLookup(i,e[r],t);return n?[" && ",a]:[" != null ? ",a," : ",i]}));},resolvePossibleLambda:function(){this.push([this.aliasable("container.lambda"),"(",this.popStack(),", ",this.contextName(0),")"]);},pushStringParam:function(t,e){this.pushContext(),this.pushString(e),"SubExpression"!==e&&("string"==typeof t?this.pushString(t):this.pushStackLiteral(t));},emptyHash:function(t){this.trackIds&&this.push("{}"),this.stringParams&&(this.push("{}"),this.push("{}")),this.pushStackLiteral(t?"undefined":"{}");},pushHash:function(){this.hash&&this.hashes.push(this.hash),this.hash={values:{},types:[],contexts:[],ids:[]};},popHash:function(){var t=this.hash;this.hash=this.hashes.pop(),this.trackIds&&this.push(this.objectLiteral(t.ids)),this.stringParams&&(this.push(this.objectLiteral(t.contexts)),this.push(this.objectLiteral(t.types))),this.push(this.objectLiteral(t.values));},pushString:function(t){this.pushStackLiteral(this.quotedString(t));},pushLiteral:function(t){this.pushStackLiteral(t);},pushProgram:function(t){null!=t?this.pushStackLiteral(this.programExpression(t)):this.pushStackLiteral(null);},registerDecorator:function(t,e){var r=this.nameLookup("decorators",e,"decorator"),n=this.setupHelperArgs(e,t);this.decorators.push(["fn = ",this.decorators.functionCall(r,"",["fn","props","container",n])," || fn;"]);},invokeHelper:function(t,e,r){var n=this.popStack(),i=this.setupHelper(t,e),o=[];r&&o.push(i.name),o.push(n),this.options.strict||o.push(this.aliasable("container.hooks.helperMissing"));var a=["(",this.itemsSeparatedBy(o,"||"),")"],s=this.source.functionCall(a,"call",i.callParams);this.push(s);},itemsSeparatedBy:function(t,e){var r=[];r.push(t[0]);for(var n=1;n<t.length;n++)r.push(e,t[n]);return r},invokeKnownHelper:function(t,e){var r=this.setupHelper(t,e);this.push(this.source.functionCall(r.name,"call",r.callParams));},invokeAmbiguous:function(t,e){this.useRegister("helper");var r=this.popStack();this.emptyHash();var n=this.setupHelper(0,t,e),i=["(","(helper = ",this.lastHelper=this.nameLookup("helpers",t,"helper")," || ",r,")"];this.options.strict||(i[0]="(helper = ",i.push(" != null ? helper : ",this.aliasable("container.hooks.helperMissing"))),this.push(["(",i,n.paramsInit?["),(",n.paramsInit]:[],"),","(typeof helper === ",this.aliasable('"function"')," ? ",this.source.functionCall("helper","call",n.callParams)," : helper))"]);},invokePartial:function(t,e,r){var n=[],i=this.setupParams(e,1,n);t&&(e=this.popStack(),delete i.name),r&&(i.indent=JSON.stringify(r)),i.helpers="helpers",i.partials="partials",i.decorators="container.decorators",t?n.unshift(e):n.unshift(this.nameLookup("partials",e,"partial")),this.options.compat&&(i.depths="depths"),i=this.objectLiteral(i),n.push(i),this.push(this.source.functionCall("container.invokePartial","",n));},assignToHash:function(t){var e=this.popStack(),r=void 0,n=void 0,i=void 0;this.trackIds&&(i=this.popStack()),this.stringParams&&(n=this.popStack(),r=this.popStack());var o=this.hash;r&&(o.contexts[t]=r),n&&(o.types[t]=n),i&&(o.ids[t]=i),o.values[t]=e;},pushId:function(t,e,r){"BlockParam"===t?this.pushStackLiteral("blockParams["+e[0]+"].path["+e[1]+"]"+(r?" + "+JSON.stringify("."+r):"")):"PathExpression"===t?this.pushString(e):"SubExpression"===t?this.pushStackLiteral("true"):this.pushStackLiteral("null");},compiler:l,compileChildren:function(t,e){for(var r=t.children,n=void 0,i=void 0,o=0,a=r.length;o<a;o++){n=r[o],i=new this.compiler;var s=this.matchExistingProgram(n);if(null==s){this.context.programs.push("");var l=this.context.programs.length;n.index=l,n.name="program"+l,this.context.programs[l]=i.compile(n,e,this.context,!this.precompile),this.context.decorators[l]=i.decorators,this.context.environments[l]=n,this.useDepths=this.useDepths||i.useDepths,this.useBlockParams=this.useBlockParams||i.useBlockParams,n.useDepths=this.useDepths,n.useBlockParams=this.useBlockParams;}else n.index=s.index,n.name="program"+s.index,this.useDepths=this.useDepths||s.useDepths,this.useBlockParams=this.useBlockParams||s.useBlockParams;}},matchExistingProgram:function(t){for(var e=0,r=this.context.environments.length;e<r;e++){var n=this.context.environments[e];if(n&&n.equals(t))return n}},programExpression:function(t){var e=this.environment.children[t],r=[e.index,"data",e.blockParams];return (this.useBlockParams||this.useDepths)&&r.push("blockParams"),this.useDepths&&r.push("depths"),"container.program("+r.join(", ")+")"},useRegister:function(t){this.registers[t]||(this.registers[t]=!0,this.registers.list.push(t));},push:function(t){return t instanceof s||(t=this.source.wrap(t)),this.inlineStack.push(t),t},pushStackLiteral:function(t){this.push(new s(t));},pushSource:function(t){this.pendingContent&&(this.source.push(this.appendToBuffer(this.source.quotedString(this.pendingContent),this.pendingLocation)),this.pendingContent=void 0),t&&this.source.push(t);},replaceStack:function(t){var e=["("],r=void 0,n=void 0,o=void 0;if(!this.isInline())throw new i.default("replaceStack on non-inline");var a=this.popStack(!0);if(a instanceof s)e=["(",r=[a.value]],o=!0;else {n=!0;var l=this.incrStack();e=["((",this.push(l)," = ",a,")"],r=this.topStack();}var c=t.call(this,r);o||this.popStack(),n&&this.stackSlot--,this.push(e.concat(c,")"));},incrStack:function(){return this.stackSlot++,this.stackSlot>this.stackVars.length&&this.stackVars.push("stack"+this.stackSlot),this.topStackName()},topStackName:function(){return "stack"+this.stackSlot},flushInline:function(){var t=this.inlineStack;this.inlineStack=[];for(var e=0,r=t.length;e<r;e++){var n=t[e];if(n instanceof s)this.compileStack.push(n);else {var i=this.incrStack();this.pushSource([i," = ",n,";"]),this.compileStack.push(i);}}},isInline:function(){return this.inlineStack.length},popStack:function(t){var e=this.isInline(),r=(e?this.inlineStack:this.compileStack).pop();if(!t&&r instanceof s)return r.value;if(!e){if(!this.stackSlot)throw new i.default("Invalid stack pop");this.stackSlot--;}return r},topStack:function(){var t=this.isInline()?this.inlineStack:this.compileStack,e=t[t.length-1];return e instanceof s?e.value:e},contextName:function(t){return this.useDepths&&t?"depths["+t+"]":"depth"+t},quotedString:function(t){return this.source.quotedString(t)},objectLiteral:function(t){return this.source.objectLiteral(t)},aliasable:function(t){var e=this.aliases[t];return e?(e.referenceCount++,e):((e=this.aliases[t]=this.source.wrap(t)).aliasable=!0,e.referenceCount=1,e)},setupHelper:function(t,e,r){var n=[];return {params:n,paramsInit:this.setupHelperArgs(e,t,n,r),name:this.nameLookup("helpers",e,"helper"),callParams:[this.aliasable(this.contextName(0)+" != null ? "+this.contextName(0)+" : (container.nullContext || {})")].concat(n)}},setupParams:function(t,e,r){var n={},i=[],o=[],a=[],s=!r,l=void 0;s&&(r=[]),n.name=this.quotedString(t),n.hash=this.popStack(),this.trackIds&&(n.hashIds=this.popStack()),this.stringParams&&(n.hashTypes=this.popStack(),n.hashContexts=this.popStack());var c=this.popStack(),u=this.popStack();(u||c)&&(n.fn=u||"container.noop",n.inverse=c||"container.noop");for(var h=e;h--;)l=this.popStack(),r[h]=l,this.trackIds&&(a[h]=this.popStack()),this.stringParams&&(o[h]=this.popStack(),i[h]=this.popStack());return s&&(n.args=this.source.generateArray(r)),this.trackIds&&(n.ids=this.source.generateArray(a)),this.stringParams&&(n.types=this.source.generateArray(o),n.contexts=this.source.generateArray(i)),this.options.data&&(n.data="data"),this.useBlockParams&&(n.blockParams="blockParams"),n},setupHelperArgs:function(t,e,r,n){var i=this.setupParams(t,e,r);return i.loc=JSON.stringify(this.source.currentLocation),i=this.objectLiteral(i),n?(this.useRegister("options"),r.push("options"),["options=",i]):r?(r.push(i),""):i}},function(){for(var t="break else new var case finally return void catch for switch while continue function this with default if throw delete in try do instanceof typeof abstract enum int short boolean export interface static byte extends long super char final native synchronized class float package throws const goto private transient debugger implements protected volatile double import public let yield await null true false".split(" "),e=l.RESERVED_WORDS={},r=0,n=t.length;r<n;r++)e[t[r]]=!0;}(),l.isValidJavaScriptVariableName=function(t){return !l.RESERVED_WORDS[t]&&/^[a-zA-Z_$][0-9a-zA-Z_$]*$/.test(t)},e.default=l,t.exports=e.default;}(yn,yn.exports),function(t,e){function r(t){return t&&t.__esModule?t:{default:t}}e.__esModule=!0;var n=r(Re.exports),i=r(qr.exports),o=Kr,a=cn,s=r(yn.exports),l=r(Zr.exports),c=r(zr.exports),u=n.default.create;function h(){var t=u();return t.compile=function(e,r){return a.compile(e,r,t)},t.precompile=function(e,r){return a.precompile(e,r,t)},t.AST=i.default,t.Compiler=a.Compiler,t.JavaScriptCompiler=s.default,t.Parser=o.parser,t.parse=o.parse,t.parseWithoutProcessing=o.parseWithoutProcessing,t}var p=h();p.create=h,c.default(p),p.Visitor=l.default,p.default=p,e.default=p,t.exports=e.default;}(De,De.exports);var bn={};bn.__esModule=!0,bn.print=function(t){return (new wn).accept(t)},bn.PrintVisitor=wn;var kn=function(t){return t&&t.__esModule?t:{default:t}}(Zr.exports);function wn(){this.padding=0;}wn.prototype=new kn.default,wn.prototype.pad=function(t){for(var e="",r=0,n=this.padding;r<n;r++)e+="  ";return e+=t+"\n"},wn.prototype.Program=function(t){var e="",r=t.body,n=void 0,i=void 0;if(t.blockParams){var o="BLOCK PARAMS: [";for(n=0,i=t.blockParams.length;n<i;n++)o+=" "+t.blockParams[n];o+=" ]",e+=this.pad(o);}for(n=0,i=r.length;n<i;n++)e+=this.accept(r[n]);return this.padding--,e},wn.prototype.MustacheStatement=function(t){return this.pad("{{ "+this.SubExpression(t)+" }}")},wn.prototype.Decorator=function(t){return this.pad("{{ DIRECTIVE "+this.SubExpression(t)+" }}")},wn.prototype.BlockStatement=wn.prototype.DecoratorBlock=function(t){var e="";return e+=this.pad(("DecoratorBlock"===t.type?"DIRECTIVE ":"")+"BLOCK:"),this.padding++,e+=this.pad(this.SubExpression(t)),t.program&&(e+=this.pad("PROGRAM:"),this.padding++,e+=this.accept(t.program),this.padding--),t.inverse&&(t.program&&this.padding++,e+=this.pad("{{^}}"),this.padding++,e+=this.accept(t.inverse),this.padding--,t.program&&this.padding--),this.padding--,e},wn.prototype.PartialStatement=function(t){var e="PARTIAL:"+t.name.original;return t.params[0]&&(e+=" "+this.accept(t.params[0])),t.hash&&(e+=" "+this.accept(t.hash)),this.pad("{{> "+e+" }}")},wn.prototype.PartialBlockStatement=function(t){var e="PARTIAL BLOCK:"+t.name.original;return t.params[0]&&(e+=" "+this.accept(t.params[0])),t.hash&&(e+=" "+this.accept(t.hash)),e+=" "+this.pad("PROGRAM:"),this.padding++,e+=this.accept(t.program),this.padding--,this.pad("{{> "+e+" }}")},wn.prototype.ContentStatement=function(t){return this.pad("CONTENT[ '"+t.value+"' ]")},wn.prototype.CommentStatement=function(t){return this.pad("{{! '"+t.value+"' }}")},wn.prototype.SubExpression=function(t){for(var e,r=t.params,n=[],i=0,o=r.length;i<o;i++)n.push(this.accept(r[i]));return r="["+n.join(", ")+"]",e=t.hash?" "+this.accept(t.hash):"",this.accept(t.path)+" "+r+e},wn.prototype.PathExpression=function(t){var e=t.parts.join("/");return (t.data?"@":"")+"PATH:"+e},wn.prototype.StringLiteral=function(t){return '"'+t.value+'"'},wn.prototype.NumberLiteral=function(t){return "NUMBER{"+t.value+"}"},wn.prototype.BooleanLiteral=function(t){return "BOOLEAN{"+t.value+"}"},wn.prototype.UndefinedLiteral=function(){return "UNDEFINED"},wn.prototype.NullLiteral=function(){return "NULL"},wn.prototype.Hash=function(t){for(var e=t.pairs,r=[],n=0,i=e.length;n<i;n++)r.push(this.accept(e[n]));return "HASH{"+r.join(", ")+"}"},wn.prototype.HashPair=function(t){return t.key+"="+this.accept(t.value)};var Sn=De.exports.default,Pn=bn;Sn.PrintVisitor=Pn.PrintVisitor,Sn.print=Pn.print;function xn(e,r){var n=t.readFileSync(r,"utf8");e.exports=Sn.compile(n);}void 0!==Me&&Me.extensions&&(Me.extensions[".handlebars"]=xn,Me.extensions[".hbs"]=xn);const On=Le;

var bus = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _vue = _interopRequireDefault(Vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var bus = new _vue["default"]();
var _default = bus;
exports["default"] = _default;
}(bus));

var vClientTable = {};

var vuex = {};

var src = {exports: {}};

(function (module, exports) {
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPlainObject = exports.clone = exports.recursive = exports.merge = exports.main = void 0;
module.exports = exports = main;
exports.default = main;
function main() {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        items[_i] = arguments[_i];
    }
    return merge.apply(void 0, items);
}
exports.main = main;
main.clone = clone;
main.isPlainObject = isPlainObject;
main.recursive = recursive;
function merge() {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        items[_i] = arguments[_i];
    }
    return _merge(items[0] === true, false, items);
}
exports.merge = merge;
function recursive() {
    var items = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        items[_i] = arguments[_i];
    }
    return _merge(items[0] === true, true, items);
}
exports.recursive = recursive;
function clone(input) {
    if (Array.isArray(input)) {
        var output = [];
        for (var index = 0; index < input.length; ++index)
            output.push(clone(input[index]));
        return output;
    }
    else if (isPlainObject(input)) {
        var output = {};
        for (var index in input)
            output[index] = clone(input[index]);
        return output;
    }
    else {
        return input;
    }
}
exports.clone = clone;
function isPlainObject(input) {
    return input && typeof input === 'object' && !Array.isArray(input);
}
exports.isPlainObject = isPlainObject;
function _recursiveMerge(base, extend) {
    if (!isPlainObject(base))
        return extend;
    for (var key in extend) {
        if (key === '__proto__' || key === 'constructor' || key === 'prototype')
            continue;
        base[key] = (isPlainObject(base[key]) && isPlainObject(extend[key])) ?
            _recursiveMerge(base[key], extend[key]) :
            extend[key];
    }
    return base;
}
function _merge(isClone, isRecursive, items) {
    var result;
    if (isClone || !isPlainObject(result = items.shift()))
        result = {};
    for (var index = 0; index < items.length; ++index) {
        var item = items[index];
        if (!isPlainObject(item))
            continue;
        for (var key in item) {
            if (key === '__proto__' || key === 'constructor' || key === 'prototype')
                continue;
            var value = isClone ? clone(item[key]) : item[key];
            result[key] = isRecursive ? _recursiveMerge(result[key], value) : value;
        }
    }
    return result;
}
}(src, src.exports));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _merge = _interopRequireDefault(src.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _default(source) {
  var extra = source == 'server' ? serverExtra() : clientExtra();
  return _merge["default"].recursive(true, {
    props: {
      name: {
        type: String,
        required: true
      }
    },
    computed: {
      state: function state() {
        return this.$store.state[this.name] ? this.$store.state[this.name] : {};
      },
      Page: function Page() {
        return this.state.page;
      },
      count: function count() {
        return this.state.count;
      },
      Columns: function Columns() {
        return this.state.columns ? this.state.columns : [];
      },
      tableData: function tableData() {
        return this.state.data ? this.state.data : [];
      },
      page: function page() {
        return this.state.page;
      },
      limit: function limit() {
        return this.state.limit;
      },
      customQueries: function customQueries() {
        return this.state.customQueries;
      },
      query: function query() {
        return this.state.query;
      },
      orderBy: function orderBy() {
        return {
          column: this.state.sortBy,
          ascending: this.state.ascending
        };
      }
    },
    methods: {
      commit: function commit(action, payload) {
        return this.$store.commit("".concat(this.name, "/").concat(action), payload);
      },
      orderByColumn: function orderByColumn(column, ev) {
        if (!this.sortable(column)) return;

        if (ev.shiftKey && this.orderBy.column && this.hasMultiSort) {
          this.setUserMultiSort(column);
        } else {
          var ascending = this.orderBy.column === column ? !this.orderBy.ascending : this._initialOrderAscending(column);
          var orderBy = {
            column: column,
            ascending: ascending
          };
          this.updateState('orderBy', orderBy);
          this.commit('SORT', orderBy);
          this.dispatch('sorted', orderBy);
        }
      },
      setLimit: function setLimit(e) {
        var limit = _typeof(e) === 'object' ? parseInt(e.target.value) : e;
        this.updateState('perPage', limit);
        this.commit("SET_LIMIT", limit);
        this.dispatch("limit", limit);
      },
      setOrder: function setOrder(column, ascending) {
        this.updateState('orderBy', {
          column: column,
          ascending: ascending
        });
        this.commit('SORT', {
          column: column,
          ascending: ascending
        });
      },
      setPage: function setPage(page) {
        this.dispatch('pagination', page);
        this.commit("PAGINATE", page);
      }
    }
  }, extra);
}

function serverExtra() {
  return {
    methods: {
      setData: function setData(data) {
        this.commit('SET_DATA', data);
        setTimeout(function () {
          this.dispatch('loaded', data);
        }.bind(this), 0);
      },
      setRequestParams: function setRequestParams() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var sendRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
        var data = this.convertParams(params);

        if (typeof data.query !== 'undefined') {
          this._setFiltersDOM(data.query);
        }

        this.commit('SET_STATE', data);

        if (sendRequest) {
          this.getData();
        }
      },
      convertParams: function convertParams(params) {
        if (params.order) {
          params.orderBy = params.order;
          delete params.order;
        }

        if (typeof params.filters !== 'undefined') {
          params.query = params.filters;
          delete params.filters;
        }

        return params;
      }
    }
  };
}

function clientExtra() {
  return {};
}
}(vuex));

var normal = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default() {
  return {
    computed: {
      Columns: function Columns() {
        return this.columns;
      }
    }
  };
}
}(normal));

var table = {};

function _typeof$c(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$c = function _typeof(obj) { return typeof obj; }; } else { _typeof$c = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$c(obj); }

var initQuery = function () {
  var init = this.opts.initFilters;
  if (!this.opts.filterByColumn) return init.hasOwnProperty('GENERIC') ? init.GENERIC : '';
  var query = {};
  var filterable = this.opts.filterable && _typeof$c(this.opts.filterable) == 'object' ? this.opts.filterable : this.columns;
  filterable.forEach(function (column) {
    query[column] = getInitialValue(init, column);
  }.bind(this));
  return query;
};

function getInitialValue(init, column) {
  if (!init.hasOwnProperty(column)) return '';
  if (typeof init[column].start == 'undefined') return init[column];
  return {
    start: init[column].start.format('YYYY-MM-DD HH:mm:ss'),
    end: init[column].end.format('YYYY-MM-DD HH:mm:ss')
  };
}

var resetQuery = function () {
  if (this.opts.filterByColumn) {
    var query = {};

    for (var key in this.query) {
      query[key] = '';
    }
  } else {
    var query = '';
  }

  this.setFilter(query);
};

var initCustomFilters = function () {
  var customQueries = {};
  var init = this.opts.initFilters;
  var key;
  this.opts.customFilters.forEach(function (filter) {
    key = this.source == 'client' ? filter.name : filter;
    customQueries[key] = init.hasOwnProperty(key) ? init[key] : '';
  }.bind(this));
  return customQueries;
};

var merge$4 = src.exports;

var initOptions = function (defaults, globalOptions, localOptions) {
  if (globalOptions) defaults = merge$4.recursive(defaults, globalOptions);
  localOptions = merge$4.recursive(defaults, localOptions);
  return localOptions;
};

var sortableClass = function (column) {
  var c = this.sortable(column) ? 'VueTables__sortable ' : '';
  c += this.columnClass(column);

  if (this.orderBy.column === column) {
    c += "".concat(column, "-sorted-") + (this.orderBy.ascending ? 'asc' : 'desc');
  }

  return c;
};

var sortableChevronClass = function (column) {
  var cls = this.opts.sortIcon.base + ' ';
  if (!this.sortable(column)) return;

  if (this.opts.sortIcon.is && !this._currentlySorted(column)) {
    cls += this.opts.sortIcon.is + ' ';
  }

  if (this.hasMultiSort && this.orderBy.column && this.userMultiSorting[this.orderBy.column]) {
    var col = this.userMultiSorting[this.orderBy.column].filter(function (c) {
      return c.column === column;
    })[0];
    if (col) cls += col.ascending ? this.opts.sortIcon.up : this.opts.sortIcon.down;
  }

  if (column == this.orderBy.column) {
    cls += this.orderBy.ascending == 1 ? this.opts.sortIcon.up : this.opts.sortIcon.down;
  }

  return cls;
};

var display = function (text, replacements) {
  if (!this.opts.texts) return '';
  var text = this.opts.texts[text];
  if (replacements) for (var key in replacements) {
    // console.log(key)
    text = text.replace('{' + key + '}', replacements[key]);
  }
  return text;
};

var orderByColumn = function (colName, ev) {
  if (!this.sortable(colName)) return;
  this.setPage(1, true);

  if (ev && ev.shiftKey && this.orderBy.column && this.hasMultiSort) {
    this.setUserMultiSort(colName);
  } else {
    this.userMultiSorting = {};
    this.orderBy.ascending = colName == this.orderBy.column ? !this.orderBy.ascending : this._initialOrderAscending(colName);
    this.orderBy.column = colName;
    this.updateState('orderBy', this.orderBy);
    this.dispatch('sorted', JSON.parse(JSON.stringify(this.orderBy)));
  }

  if (this.source == 'server') {
    this.getData();
  }
};

var ucfirst = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

function _default(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
}(ucfirst));

var _ucfirst = _interopRequireDefault$a(ucfirst);

function _interopRequireDefault$a(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var getHeading = function (value, h) {
  if (typeof value !== 'string') return '';

  if (typeof this.$parent.$slots["h__".concat(value)] !== 'undefined') {
    return this.$parent.$slots["h__".concat(value)];
  }

  var derivedHeading = (0, _ucfirst["default"])(value.split("_").join(" "));
  if (!this.opts.headings.hasOwnProperty(value)) return derivedHeading;

  if (typeof this.opts.headings[value] === 'function') {
    if (h) return this.opts.headings[value].call(this.$parent, h);
    return derivedHeading;
  }

  return this.opts.headings[value];
};

var getHeadingTooltip = function (value, h) {
  if (typeof value !== 'string') return '';
  var derivedHeadingTooltip = '';
  if (!this.opts.headingsTooltips.hasOwnProperty(value)) return derivedHeadingTooltip;

  if (typeof this.opts.headingsTooltips[value] === 'function') {
    if (h) return this.opts.headingsTooltips[value].call(this.$parent, h);
    return derivedHeadingTooltip;
  }

  return this.opts.headingsTooltips[value];
};

var sortable = function (column) {
  var sortAll = typeof this.opts.sortable == 'boolean' && this.opts.sortable;
  if (sortAll) return true;
  return this.opts.sortable.indexOf(column) > -1;
};

var serverSearch = function (e, dateEvent) {
  // we need to handle the store this.query to make sure we're not mutating outside of it
  var query = this.vuex ? JSON.parse(JSON.stringify(this.query)) : this.query; // in case we pass an object manually (mostly used for init-date-filters should refactor

  if (Object.prototype.toString.call(e).slice(8, -1) == 'Object') {
    query = this.vuex ? JSON.parse(JSON.stringify(e)) : e;
    if (!this.vuex) this.query = query;
    var name = dateEvent.target.name;
    var value = dateEvent.target.value;

    if (name) {
      this.dispatch('filter', {
        name: name,
        value: value
      });
      this.dispatch("filter::".concat(name), value);
    } else {
      this.dispatch('filter', value);
    }

    this.updateState('query', query);
  } else if (e) {
    var _name = this.getName(e.target.name);

    var _value = e.target.value;

    if (_name) {
      query[_name] = _value;
    } else {
      query = _value;
    }

    if (!this.vuex) this.query = query;

    if (_name) {
      this.dispatch('filter', {
        name: _name,
        value: _value
      });
      this.dispatch("filter::".concat(_name), _value);
    } else {
      this.dispatch('filter', _value);
    }

    this.updateState('query', query);
  }

  return search$1(this, query);
};

function search$1(that, query) {
  if (that.vuex) {
    that.commit('SET_FILTER', query);
  } else {
    that.page = 1;
    that.updateState('page', 1);
    that.getData();
  }
}

var initOrderBy = function () {
  if (!this.opts.orderBy) return;
  this.orderBy.column = this.opts.orderBy.column;
  this.orderBy.ascending = this.opts.orderBy.hasOwnProperty('ascending') ? this.opts.orderBy.ascending : true;
};

var merge$3 = src.exports;

var initDateFilters = function () {
  if (typeof $ === 'undefined' || typeof $(this.$el).daterangepicker === 'undefined') {
    console.error('Date filters require jquery and daterangepicker');
    return;
  }

  var el;
  var that = this;
  var query = this.vuex ? JSON.parse(JSON.stringify(this.query)) : this.query;
  var columnOptions;
  var dpOptions;

  var search = function search(query, e) {
    return that.source == 'client' ? that.search(that.data, e) : that.serverSearch(query, e);
  };

  var datepickerOptions = merge$3.recursive(this.opts.datepickerOptions, {
    autoUpdateInput: false,
    singleDatePicker: false
  });
  that.datepickerColumns.forEach(function (column) {
    var range = that._getInitialDateRange(column);

    if (range) {
      that._setDatepickerText(column, range.start, range.end);

      range = {
        startDate: range.start,
        endDate: range.end
      };
    } else {
      range = {};
    }

    el = $(that.$el).find("#VueTables__" + $.escapeSelector(column) + "-filter");
    columnOptions = typeof that.opts.datepickerPerColumnOptions[column] !== 'undefined' ? that.opts.datepickerPerColumnOptions[column] : {};
    columnOptions = merge$3.recursive(columnOptions, {
      locale: {
        format: that.dateFormat(column)
      }
    });
    dpOptions = merge$3(true, datepickerOptions);

    if (columnOptions.ranges === false) {
      dpOptions.ranges = {};
    }

    var drp = el.data('daterangerpicker');

    if (drp) {
      drp.remove();
    }

    el.daterangepicker(merge$3.recursive(dpOptions, columnOptions, range));
    el.on('apply.daterangepicker', function (ev, picker) {
      query[column] = {
        start: picker.startDate.format('YYYY-MM-DD HH:mm:ss'),
        end: picker.endDate.format('YYYY-MM-DD HH:mm:ss')
      };
      if (!that.vuex) that.query = query;

      that._setDatepickerText(column, picker.startDate, picker.endDate);

      that.updateState('query', query);
      search(query, {
        target: {
          name: that._getColumnName(column),
          value: query[column]
        }
      });
    });
    el.on('cancel.daterangepicker', function (ev, picker) {
      query[column] = '';
      if (!that.vuex) that.query = query;
      picker.setStartDate(moment());
      picker.setEndDate(moment());
      that.updateState('query', query);
      $(this).html("<span class='VueTables__filter-placeholder'>" + that.display('filterBy', {
        column: that.getHeading(column)
      }) + "</span>");
      search(query, {
        target: {
          name: that._getColumnName(column),
          value: query[column]
        }
      });
    });
  });
};

var merge$2 = src.exports;

var setFilter = function (filter) {
  var sendRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (!this.opts.filterable) {
    console.warn("vue-tables-2: Unable to set filter. Filtering is disabled (filterable: false)");
    return;
  }

  if (this.opts.filterByColumn && typeof filter === 'string') {
    console.warn("vue-tables-2: Unable to set filter. Filter value must be an object (`filterByColumn` is set to `true`)");
    return;
  }

  if (!this.opts.filterByColumn && typeof filter !== 'string') {
    console.warn("vue-tables-2: Unable to set filter. Filter value must be a string (`filterByColumn` is set to `false`)");
    return;
  }
  var mergedFilter = this.opts.filterByColumn ? merge$2(true, this.query, filter) : filter;

  if (this.vuex) {
    this.commit('SET_FILTER', mergedFilter);
  } else {
    this.query = mergedFilter;
    this.setPage(1, true);
  }

  this.updateState('query', mergedFilter);

  this._setFiltersDOM(filter);

  if (this.source == 'server' && sendRequest) {
    this.getData();
  }
};

var setPage = function (page) {
  var preventRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  page = parseInt(page);

  if (page < 1) {
    page = 1;
  }

  if (page > this.totalPages && this.opts.pagination.virtual) {
    return;
  }

  if (this.totalPages > 0 && page > this.totalPages) {
    page = this.totalPages;
  }

  this.page = page;
  this.updateState('page', page);
  this.dispatch('pagination', page);
  if (this.source == 'server' && !preventRequest) this.getData();
};

var setOrder = function (column, ascending) {
  var sendRequest = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  this.orderBy.column = column;
  this.orderBy.ascending = ascending;
  this.updateState('orderBy', {
    column: column,
    ascending: ascending
  });

  if (this.source == 'server' && sendRequest) {
    this.getData();
  }
};

var filterable = function (column) {
  if (!this.opts.filterable) return false;
  return typeof this.opts.filterable == 'boolean' && this.opts.filterable || this.opts.filterable.indexOf(column) > -1;
};

var isTextFilter = function (column) {
  return this.query.hasOwnProperty(column) && this.opts.dateColumns.indexOf(column) == -1 && !this.opts.listColumns.hasOwnProperty(column);
};

var isDateFilter = function (column) {
  return this.query.hasOwnProperty(column) && this.opts.dateColumns.indexOf(column) > -1;
};

var isListFilter = function (column) {
  return this.opts.listColumns.hasOwnProperty(column);
};

var highlightMatches = function (value, column, h) {
  var query = this.opts.filterByColumn ? this.query[column] : this.query;
  if (!query) return value;
  query = new RegExp("(" + escapeRegex(query) + ")", "i");
  return h("span", {
    "class": 'VueTables__highlight'
  }, matches$1(value, query, h));
};

function matches$1(value, query, h) {
  var pieces = String(value).split(query);
  return pieces.map(function (piece) {
    if (query.test(piece)) {
      return h("b", {}, piece);
    }

    return piece;
  });
}

function escapeRegex(s) {
  return typeof s === 'string' ? s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&') : s;
}

var isValidMomentObject = function (val) {
  return val && typeof val.isValid == 'function' && val.isValid();
};

var validMoment = isValidMomentObject;

var formatDate = function (value, dateFormat) {
  if (!validMoment(value)) return value;
  return value.format(dateFormat);
};

var intersect$1 = function intersect(first) {
  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  return rest.reduce(function (accum, current) {
    return accum.filter(function (x) {
      return current.indexOf(x) !== -1;
    });
  }, first);
};

var arrayIntersect_module = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': intersect$1
});

var require$$0$1 = /*@__PURE__*/getAugmentedNamespace(arrayIntersect_module);

function _typeof$b(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$b = function _typeof(obj) { return typeof obj; }; } else { _typeof$b = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$b(obj); }

var intersection = require$$0$1["default"];

var hasDateFilters = function () {
  var opts = this.opts;
  return opts.dateColumns.length && opts.filterByColumn && (typeof opts.filterable == 'boolean' && opts.filterable || _typeof$b(opts.filterable) == 'object' && intersection(opts.filterable, opts.dateColumns).length);
};

var optionText = function (value, column) {
  var list = this.listColumnsObject[column];
  if (typeof list[value] == 'undefined') return value;
  return list[value];
};

var render = function (row, column, index, h) {
  var value = this._getValue(row, column);

  if (this.templatesKeys.indexOf(column) == -1) {
    if (typeof value === 'undefined' || !this.opts.highlightMatches || this.filterableColumns.indexOf(column) === -1) {
      return value;
    }

    return this.highlightMatch(value, column, h);
  }

  var template = this.opts.templates[column];
  template = typeof template == 'function' ? template.apply(this.$root, [h, row, index, column]) : h(template, {
    attrs: {
      data: row,
      column: column,
      index: index
    }
  });
  return template;
};

var rowWasClicked = function (row, index, event) {
  var data;
  var id = this.opts.uniqueKey;

  if (this.source == 'client' && typeof row[id] !== 'undefined') {
    data = this.tableData.filter(function (r) {
      return row[id] === r[id];
    })[0];
  } else {
    data = row;
  }

  this.dispatch('row-click', {
    row: data,
    index: index,
    event: event
  });
};

function _typeof$a(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$a = function _typeof(obj) { return typeof obj; }; } else { _typeof$a = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$a(obj); }

var setLimit = function (e) {
  var sendRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  this.limit = _typeof$a(e) === 'object' ? e.target.value : e;
  this.updateState('perPage', this.limit);
  this.dispatch('limit', parseInt(this.limit));

  if (sendRequest) {
    this.setPage(1);
  }
};

var getOpenChildRows = function () {
  var _this = this;

  var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

  if (!this.opts.childRow || typeof this.opts.childRow === 'function') {
    throw new Error('vue-tables-2: Child row undefined or not a component');
  }

  var Rows = rows ? this.openChildRows.filter(function (row) {
    return rows.includes(row);
  }) : this.openChildRows;
  if (!Rows.length) return [];
  return this.$parent.$refs.vt_table.$refs.vt_table_body.$children[0].$children.filter(function (child) {
    return child.$options.name === 'VtChildRow' && Rows.includes(child.$children[0].$children[0].data[_this.opts.uniqueKey]);
  }).map(function (child) {
    return child.$children[0].$children[0];
  });
};

var _bus$4 = _interopRequireDefault$9(bus);

function _interopRequireDefault$9(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var dispatch = function (event, payload) {
  if (this.vuex) {
    if (event.split('::').length > 1) return;
    this.commit(event.toUpperCase().replace('-', '_'), payload);
  }

  this.$parent.$emit(event, payload);

  _bus$4["default"].$emit("vue-tables.".concat(event), payload);

  if (this.name) {
    _bus$4["default"].$emit("vue-tables.".concat(this.name, ".").concat(event), payload);
  }
};

var toggleChildRow = function (rowId, e) {
  if (e) e.stopPropagation();

  if (this.openChildRows.includes(rowId)) {
    var index = this.openChildRows.indexOf(rowId);
    this.openChildRows.splice(index, 1);
  } else {
    this.openChildRows.push(rowId);
  }
};

var childRowTogglerClass = function (rowId) {
  return this.openChildRows.includes(rowId) ? 'VueTables__child-row-toggler--open' : 'VueTables__child-row-toggler--closed';
};

var sendRequest = function (data) {
  if (typeof this.opts.requestFunction === 'function') {
    return this.opts.requestFunction.call(this, data);
  }

  if (typeof axios !== 'undefined') {
    if (this.cancelToken) {
      // cancel prev request
      this.cancelToken.cancel();
    }

    this.cancelToken = axios.CancelToken.source();
    return axios.get(this.url, {
      params: data,
      cancelToken: this.cancelToken.token
    })["catch"](function (e) {
      this.cancelToken = null;
      this.dispatch('error', e);
      this.loadingError = true;
    }.bind(this));
  }

  if (typeof this.$http !== 'undefined') return this.$http.get(this.url, {
    params: data
  }).then(function (data) {
    return data.json();
  }.bind(this), function (e) {
    this.dispatch('error', e);
    this.loadingError = true;
  }.bind(this));
  if (typeof $ != 'undefined') return $.getJSON(this.url, data).fail(function (e) {
    this.dispatch('error', e);
    this.loadingError = true;
  }.bind(this));
  throw "vue-tables: No supported ajax library was found. (jQuery, axios or vue-resource). To use a different library you can write your own request function (see the `requestFunction` option)";
};

var getResponseData = function (response) {
  if (typeof axios !== 'undefined') return response.data;
  return response;
};

var getSortFn = function (column) {
  var ascending = this.orderBy.ascending;
  this.currentlySorting = {
    column: column,
    ascending: ascending
  };
  if (typeof this.opts.customSorting[column] == 'undefined') return this.defaultSort(column, ascending);
  return this.opts.customSorting[column](ascending);
};

var initState = function () {
  var state = {
    page: 1,
    query: this.query,
    orderBy: this.orderBy,
    perPage: this.opts.perPage,
    customQueries: this.customQueries
  };
  this.storage.setItem(this.stateKey, JSON.stringify(state));
  return state;
};

var updateState = function (key, value) {
  if (!this.opts.saveState || !this.activeState) return;

  try {
    var currentState = JSON.parse(this.storage.getItem(this.stateKey));
  } catch (e) {
    var currentState = this.initState();
  }

  currentState[key] = value;
  this.storage.setItem(this.stateKey, JSON.stringify(currentState));
};

var columnClass = function (column) {
  var c = this.opts.columnsClasses;
  return c.hasOwnProperty(column) ? c[column] : '';
};

var getName = function (name) {
  if (!name) return name;
  name = name.split('__');
  name.shift();
  return name.join('__').split('@@@').join('.');
};

var toggleColumn = function (column) {
  var _this = this;

  if (!this.userControlsColumns) {
    this.userColumnsDisplay = JSON.parse(JSON.stringify(this.allColumns));
    this.userControlsColumns = true;
  }

  if (this.userColumnsDisplay.includes(column)) {
    // can't have no columns
    if (this.userColumnsDisplay.length === 1) return;
    var index = this.userColumnsDisplay.indexOf(column);
    this.userColumnsDisplay.splice(index, 1);
  } else {
    this.userColumnsDisplay.push(column);
  }

  this.updateState('userControlsColumns', true);
  this.updateState('userColumnsDisplay', this.userColumnsDisplay);
  this.$nextTick(function () {
    _this._setFiltersDOM(_this.query);

    if (_this.userColumnsDisplay.includes(column) && _this.opts.dateColumns.includes(column)) {
      _this.initDateFilters();
    }
  });
};

var setUserMultiSort = function (secondaryCol) {
  var primaryCol = this.orderBy.column;
  var primaryAsc = this.orderBy.ascending;
  if (!this.userMultiSorting[primaryCol]) this.$set(this.userMultiSorting, primaryCol, []);
  var multi = this.userMultiSorting[primaryCol];

  if (primaryCol === secondaryCol) {
    if (!multi.length || primaryAsc) {
      // primary is the only sorted column or is ascending
      this.orderBy.ascending = !this.orderBy.ascending;
    } else {
      // remove primary column and make secondary primary
      this.orderBy = multi.shift();
      this.userMultiSorting = {};
      this.$set(this.userMultiSorting, this.orderBy.column, multi);
    }
  } else {
    var secondary = multi.filter(function (col) {
      return col.column == secondaryCol;
    })[0];

    if (secondary) {
      if (!secondary.ascending) {
        // remove sort
        this.$set(this.userMultiSorting, primaryCol, multi.filter(function (col) {
          return col.column != secondaryCol;
        }));
        if (!this.userMultiSorting[primaryCol].length) this.userMultiSorting = {};
      } else {
        // change direction
        secondary.ascending = !secondary.ascending;
      }
    } else {
      // add sort
      multi.push({
        column: secondaryCol,
        ascending: true
      });
    }
  } // force re-compilation of the filteredData computed property


  this.time = Date.now();
  this.dispatch('sorted', getMultiSortData(this.orderBy, this.userMultiSorting));
};

function getMultiSortData(main, secondary) {
  var cols = [JSON.parse(JSON.stringify(main))];
  cols = cols.concat(secondary[main.column]);
  return cols;
}

var cellClasses = function (column, row) {
  if (!this.opts.cellClasses[column]) return '';
  return this.opts.cellClasses[column].filter(function (item) {
    return item.condition(row);
  }).map(function (item) {
    return item["class"];
  }).join(' ');
};

function _typeof$9(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$9 = function _typeof(obj) { return typeof obj; }; } else { _typeof$9 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$9(obj); }

var setFiltersDom = function (query) {
  var el;

  if (this.opts.filterByColumn) {
    for (var column in query) {
      var columnName = this._getColumnName(column);

      if (this.isDateFilter(column)) {
        if (query[column] && _typeof$9(query[column]) === 'object') {
          var start = typeof query[column].start === 'string' ? moment(query[column].start, 'YYYY-MM-DD') : query[column].start;
          var end = typeof query[column].end === 'string' ? moment(query[column].end, 'YYYY-MM-DD') : query[column].end;

          this._setDatepickerText(column, start, end);
        } else {
          $(this.$el).find("#VueTables__" + $.escapeSelector(column) + "-filter").html("<span class='VueTables__filter-placeholder'>" + this.display('filterBy', {
            column: this.getHeading(column)
          }) + "</span>");
        }

        continue;
      }

      el = this.$el.querySelector("[name='".concat(columnName.replace("'", "\\'"), "']"));

      if (el) {
        el.value = query[column];
      } else if (this.columns.indexOf(column) === -1) {
        console.error("vue-tables-2: Error in setting filter value. Column '".concat(column, "' does not exist."));
      }
    }
  } else {
    var el = this.$el.querySelector('.VueTables__search__input');
    if (el) el.value = query;
  }
};

var currentlySorted = function (column) {
  var userMultiSort = Object.keys(this.userMultiSorting);
  if (!userMultiSort.length || this.orderBy.column === column) return this.orderBy.column === column;
  return !!this.userMultiSorting[userMultiSort[0]].filter(function (col) {
    return col.column == column;
  }).length;
};

var getChildRowTemplate = function (h, row, index, scopedSlot) {
  // scoped slot
  if (scopedSlot) return scopedSlot({
    row: row,
    index: index
  });
  var childRow = this.opts.childRow; // function

  if (typeof childRow === 'function') return childRow.apply(this, [h, row]); // component

  return h(childRow, {
    attrs: {
      data: row
    }
  });
};

var toggleColumnsDropdown = function () {
  this.displayColumnsDropdown = !this.displayColumnsDropdown;
};

var onlyColumn = function (column) {
  return this.userColumnsDisplay.length === 1 && this.userColumnsDisplay[0] === column;
};

var onPagination = function (page) {
  if (this.vuex) return;
  this.setPage(page);
  this.dispatch('pagination', page);
};

var toggleGroupDirection = function () {
  if (this.orderBy.column != this.groupBy[0]) {
    this.setOrder(this.groupBy[0], true);
  } else {
    this.setOrder(this.groupBy[0], !this.orderBy.ascending);
  }
};

var getInitialDateRange = function (column) {
  if (typeof this.opts.initFilters[column] !== 'undefined') {
    return this.opts.initFilters[column];
  }

  if (typeof this.query[column] !== 'undefined' && this.query[column].start) {
    return {
      start: moment(this.query[column].start, 'YYYY-MM-DD HH:mm:ss'),
      end: moment(this.query[column].end, 'YYYY-MM-DD HH:mm:ss')
    };
  }

  return false;
};

var setDatepickerText = function (column, start, end) {
  var dateFormat = this.dateFormat(column);
  var el = typeof column === 'string' ? $(this.$el).find("#VueTables__" + $.escapeSelector(column) + "-filter") : column;
  el.text(start.format(dateFormat) + " - " + end.format(dateFormat));
};

var initialOrderAscending = function (column) {
  return !this.opts.descOrderColumns.includes(column);
};

var dateFormat = function (column) {
  if (this.opts.dateFormatPerColumn.hasOwnProperty(column)) {
    return this.opts.dateFormatPerColumn[column];
  }

  return this.opts.dateFormat;
};

var setColumnsDropdownCloseListener = function () {
  var _this = this;

  if (this.opts.columnsDropdown) {
    var stopProp = function stopProp(e) {
      return e.stopPropagation();
    };

    var handler = function handler() {
      if (_this.displayColumnsDropdown) {
        _this.displayColumnsDropdown = false;
      }
    };

    this.$refs.columnsdropdown.addEventListener('click', stopProp);
    document.addEventListener('click', handler);
    this.$once('hook:beforeDestroy', function () {
      document.removeEventListener('click', handler);

      _this.$refs.columnsdropdown.removeEventListener('click', stopProp);
    });
  }
};

var getValue$1 = function (row, column) {
  if (column.indexOf('.') === -1) return row[column];
  var p = column.split('.');
  var value = row[p[0]];
  if (!value) return '';

  for (var i = 1; i < p.length; i++) {
    value = value[p[i]]; // If the nested structure doesn't exist return an empty string

    if (typeof value === 'undefined') return '';
  }

  return value;
};

var getColumnName = function (column) {
  return 'vf__' + column.split('.').join('@@@');
};

var shouldShowColumnOnInit = function (column) {
  if (this.opts.visibleColumns) {
    return this.opts.visibleColumns.includes(column);
  }

  if (this.opts.hiddenColumns) {
    return !this.opts.hiddenColumns.includes(column);
  }

  return true;
};

var setEditingCell = function _setEditingCell(row, column) {
  return function (editing) {
    var _this = this;

    if (editing) {
      this.editing.push({
        id: row[this.opts.uniqueKey],
        column: column,
        originalValue: row[column]
      });
    } else {
      this.editing = this.editing.filter(function (e) {
        return e.id !== row[_this.opts.uniqueKey];
      });
    }
  }.bind(this);
};

var revertValue = function _revertVal(row, column) {
  return function () {
    var _this = this;

    row[column] = this.editing.find(function (e) {
      return e.id === row[_this.opts.uniqueKey];
    }).originalValue;
  }.bind(this);
};

var lodash_clonedeep = {exports: {}};

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

(function (module, exports) {
/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;
}(lodash_clonedeep, lodash_clonedeep.exports));

var cloneDeep = lodash_clonedeep.exports;

var clone$2 = lodash_clonedeep.exports;

var updateValue = function _updateValue(row, column) {
  return function (e) {
    var _this = this;

    var oldVal = row[column];
    row[column] = getValue(e);
    var data = clone$2(this.data).map(function (r) {
      if (r[_this.opts.uniqueKey] === row[_this.opts.uniqueKey]) {
        return row;
      }

      return r;
    });
    this.dispatch('input', data);
    this.dispatch('update', {
      row: row,
      column: column,
      oldVal: oldVal,
      newVal: row[column]
    });
  }.bind(this);
};

function getValue(val) {
  if (val.target) {
    return val.target.type === 'checkbox' ? val.target.checked : val.target.value;
  }

  return val;
}

var filterType = function (column) {
  if (!this.opts.filterable) return false;
  if (this.isTextFilter(column)) return 'vt-text-filter';
  if (this.isDateFilter(column)) return 'vt-date-filter';
  if (this.isListFilter(column)) return 'vt-list-filter';
};

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */

function debounce$3(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  }
  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
}
// Adds compatibility for ES modules
debounce$3.debounce = debounce$3;

var debounce_1 = debounce$3;

var _debounce = _interopRequireDefault$8(debounce_1);

function _interopRequireDefault$8(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var search = function (debounceVal) {
  var search = this.source === 'client' ? this.search.bind(this, this.data) : this.serverSearch.bind(this);

  if (!debounceVal) {
    return search;
  }

  var debouncedSearch = (0, _debounce["default"])(search, debounceVal);
  return function (e) {
    // ignore tab
    if (e.keyCode === 9) return; // search immediately on enter

    if (e.keyCode === 13) {
      debouncedSearch.clear();
      search.apply(void 0, arguments);
    } else {
      debouncedSearch.apply(void 0, arguments);
    }
  };
};

var setCustomFilters = function (filters) {
  var sendRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  for (var key in filters) {
    this.customQueries[key] = filters[key];
  }

  this.updateState('customQueries', this.customQueries);

  if (this.source === 'server' && sendRequest) {
    this.getData();
  }
};

var toggleRowSelection = function (e, row, index, disabled) {
  var _this = this;

  e.stopPropagation();
  if (disabled) return;
  var id = this.opts.uniqueKey;

  if (this.opts.selectable.mode === 'single') {
    this.selectedRows = !this.isRowSelected(row) ? [row] : [];
  } else {
    var prevIndex = this.selectedIndex;
    this.selectedIndex = index; // Handle multiple select via Shift+Click

    if (e.shiftKey && prevIndex !== this.selectedIndex) {
      // Get the subset of the message list between the
      // two indicies.
      var subset = this.filteredData.slice(Math.min(prevIndex, this.selectedIndex) - 1, Math.max(prevIndex, this.selectedIndex)); // Determine the operation based on the checked state
      // of the clicked checkbox.

      var toggleFn = !this.isRowSelected(row) ? addCheckedSubset : removeCheckedSubset;
      this.selectedRows = toggleFn(this.selectedRows, subset).filter(function (row) {
        return !_this.opts.selectable.only || _this.opts.selectable.only(row);
      });
    } else {
      if (!this.isRowSelected(row)) {
        this.selectedRows.push(row);
      } else {
        this.selectedRows = this.selectedRows.filter(function (R) {
          return R[id] !== row[id];
        });
      }
    }
  }

  this.dispatch('select', this.selectedRows);
};

var notInArr = function notInArr(item) {
  return this.indexOf(item) === -1;
};

function addCheckedSubset(current, add) {
  if (!current.length) return add; // Add only items which are not already checked

  return current.concat(add.filter(notInArr, current));
}

function removeCheckedSubset(current, remove) {
  // Return only items which are not in subset
  return current.filter(notInArr, remove);
}

var isRowSelected = function (row) {
  var id = this.opts.uniqueKey;
  return !!this.selectedRows.find(function (Row) {
    return Row[id] === row[id];
  });
};

var toggleAllRows = function (e) {
  var _this = this;

  var data;

  if (this.source === 'client') {
    data = this.opts.selectable.selectAllMode === 'page' ? this.filteredData : this.allFilteredData;
  } else {
    data = this.data;
  }

  if (e.target.checked) {
    if (this.opts.selectable.only) {
      this.selectedRows = data.filter(function (row) {
        return _this.opts.selectable.only(row);
      });
    } else {
      this.selectedRows = data;
    }
  } else {
    this.selectedRows = [];
  }

  this.dispatch('select', this.selectedRows);
};

var resetSelectedRows = function () {
  this.selectedRows = [];
  var toggler = document.getElementById('vt-toggle-all');
  toggler.checked = false;
  this.dispatch('select', this.selectedRows);
};

var selectRow = function (rowId) {
  var _this = this;

  if (alreadySelected(rowId, this.selectedRows, this.opts.uniqueKey)) {
    console.warn("Row ".concat(rowId, " already selected"));
    return;
  }

  var row = this.data.find(function (row) {
    return String(row[_this.opts.uniqueKey]) === String(rowId);
  });

  if (!row) {
    console.warn("Row ".concat(rowId, " was not found"));
    return;
  }

  this.selectedRows.push(row);
  return this.selectedRows;
};

function alreadySelected(rowId, selectedRows, IdKey) {
  return !!selectedRows.find(function (row) {
    return String(row[IdKey]) === String(rowId);
  });
}

var selectRows = function (rowIds) {
  var _this = this;

  rowIds.forEach(function (id) {
    return _this.selectRow(id);
  });
  return this.selectedRows;
};

var unselectRow = function (rowId) {
  var _this = this;

  this.selectedRows = this.selectedRows.filter(function (row) {
    return String(row[_this.opts.uniqueKey]) !== String(rowId);
  });
  return this.selectedRows;
};

var unselectRows = function (rowIds) {
  var _this = this;

  rowIds = rowIds.map(function (id) {
    return String(id);
  });
  this.selectedRows = this.selectedRows.filter(function (row) {
    return !rowIds.includes(String(row[_this.opts.uniqueKey]));
  });
  return this.selectedRows;
};

var toggleRow = function (rowId) {
  var _this = this;

  if (!!this.selectedRows.find(function (row) {
    return String(row[_this.opts.uniqueKey]) === String(rowId);
  })) {
    this.unselectRow(rowId);
  } else {
    this.selectRow(rowId);
  }

  return this.selectedRows;
};

var selectAllRows = function () {
  this.selectedRows = this.data;
  return this.selectedRows;
};

var methods = {
  initQuery: initQuery,
  resetQuery: resetQuery,
  initCustomFilters: initCustomFilters,
  initOptions: initOptions,
  sortableClass: sortableClass,
  sortableChevronClass: sortableChevronClass,
  display: display,
  orderByColumn: orderByColumn,
  getHeading: getHeading,
  getHeadingTooltip: getHeadingTooltip,
  sortable: sortable,
  serverSearch: serverSearch,
  initOrderBy: initOrderBy,
  initDateFilters: initDateFilters,
  setFilter: setFilter,
  setPage: setPage,
  setOrder: setOrder,
  filterable: filterable,
  isTextFilter: isTextFilter,
  isDateFilter: isDateFilter,
  isListFilter: isListFilter,
  highlightMatch: highlightMatches,
  formatDate: formatDate,
  hasDateFilters: hasDateFilters,
  optionText: optionText,
  render: render,
  rowWasClicked: rowWasClicked,
  setLimit: setLimit,
  getOpenChildRows: getOpenChildRows,
  dispatch: dispatch,
  toggleChildRow: toggleChildRow,
  childRowTogglerClass: childRowTogglerClass,
  sendRequest: sendRequest,
  getResponseData: getResponseData,
  getSortFn: getSortFn,
  initState: initState,
  updateState: updateState,
  columnClass: columnClass,
  getName: getName,
  toggleColumn: toggleColumn,
  setUserMultiSort: setUserMultiSort,
  _cellClasses: cellClasses,
  _setFiltersDOM: setFiltersDom,
  _currentlySorted: currentlySorted,
  _getChildRowTemplate: getChildRowTemplate,
  _toggleColumnsDropdown: toggleColumnsDropdown,
  _onlyColumn: onlyColumn,
  _onPagination: onPagination,
  _toggleGroupDirection: toggleGroupDirection,
  _getInitialDateRange: getInitialDateRange,
  _setDatepickerText: setDatepickerText,
  _initialOrderAscending: initialOrderAscending,
  dateFormat: dateFormat,
  _setColumnsDropdownCloseListener: setColumnsDropdownCloseListener,
  _getValue: getValue$1,
  _getColumnName: getColumnName,
  _shouldShowColumnOnInit: shouldShowColumnOnInit,
  _setEditingCell: setEditingCell,
  _revertValue: revertValue,
  _updateValue: updateValue,
  _filterType: filterType,
  _search: search,
  setCustomFilters: setCustomFilters,
  toggleRowSelection: toggleRowSelection,
  isRowSelected: isRowSelected,
  toggleAllRows: toggleAllRows,
  resetSelectedRows: resetSelectedRows,
  selectRow: selectRow,
  selectRows: selectRows,
  unselectRow: unselectRow,
  unselectRows: unselectRows,
  toggleRow: toggleRow,
  selectAllRows: selectAllRows
};

var listColumnsObject = function () {
  var columns = Object.keys(this.opts.listColumns);
  var res = {};
  columns.forEach(function (column) {
    res[column] = {};
    this.opts.listColumns[column].forEach(function (item) {
      res[column][item.id] = item.text;
    });
  }.bind(this));
  return res;
};

var allColumns = function () {
  var _this = this;

  var display = this.columnsDisplay; // default - return all columns

  if (!display && !this.userControlsColumns) {
    return this.Columns.filter(function (col) {
      return _this._shouldShowColumnOnInit(col);
    });
  } // user toggled columns - return user selected columns


  if (this.userControlsColumns) {
    return this.columns.filter(function (column) {
      return _this.userColumnsDisplay.includes(column);
    });
  }

  if (this.opts.ssr) return this.Columns; // developer defined columns display

  return this.Columns.filter(function (column) {
    if (!_this._shouldShowColumnOnInit(column)) {
      return false;
    }

    if (!display[column]) return true;
    var range = display[column];
    var operator = range[2];
    var inRange = (!range[0] || _this.windowWidth >= range[0]) && (!range[1] || _this.windowWidth < range[1]);
    return operator == 'not' ? !inRange : inRange;
  });
};

var templatesKeys = function () {
  return Object.keys(this.opts.templates);
};

var defaults$6 = function () {
  return {
    alwaysShowPerPageSelect: false,
    hidePerPageSelect: false,
    dateColumns: [],
    listColumns: {},
    datepickerOptions: {
      locale: {
        cancelLabel: "Clear"
      }
    },
    datepickerPerColumnOptions: {},
    initialPage: 1,
    perPage: 10,
    perPageValues: [10, 25, 50, 100],
    groupBy: false,
    collapseGroups: false,
    destroyEventBus: false,
    sendEmptyFilters: false,
    params: {},
    sortable: true,
    filterable: true,
    groupMeta: [],
    initFilters: {},
    sendInitialRequest: true,
    customFilters: [],
    templates: {},
    debounce: 250,
    dateFormat: "DD/MM/YYYY",
    dateFormatPerColumn: {},
    toMomentFormat: false,
    skin: false,
    columnsDisplay: {},
    columnsDropdown: false,
    texts: {
      count: "Showing {from} to {to} of {count} records|{count} records|One record",
      first: "First",
      last: "Last",
      filter: "Filter:",
      filterPlaceholder: "Search query",
      limit: "Records:",
      page: "Page:",
      noResults: "No matching records",
      noRequest: "Please select at least one filter to fetch results",
      filterBy: "Filter by {column}",
      loading: "Loading...",
      defaultOption: "Select {column}",
      columns: "Columns",
      loadingError: "Error loading results"
    },
    sortIcon: {
      is: "glyphicon-sort",
      base: "glyphicon",
      up: "glyphicon-chevron-up",
      down: "glyphicon-chevron-down"
    },
    addSortedClassToCells: false,
    sortingAlgorithm: function sortingAlgorithm(data, column) {
      return data.sort(this.getSortFn(column));
    },
    filterAlgorithm: {},
    customSorting: {},
    multiSorting: {},
    clientMultiSorting: true,
    serverMultiSorting: false,
    filterByColumn: false,
    highlightMatches: false,
    orderBy: false,
    descOrderColumns: [],
    footerHeadings: false,
    headings: {},
    headingsTooltips: {},
    stickyHeader: false,
    stickHeaderBackground: 'white',
    selectable: {
      selectAllMode: 'all',
      programmatic: false
    },
    pagination: {
      show: true,
      dropdown: false,
      virtual: false,
      chunk: 10,
      edge: false,
      align: "center",
      nav: "fixed"
    },
    childRow: false,
    childRowTogglerFirst: true,
    disabledChildRows: false,
    showChildRowToggler: true,
    uniqueKey: "id",
    requestFunction: false,
    useDrawCounter: false,
    requestAdapter: function requestAdapter(data) {
      return data;
    },
    responseAdapter: function responseAdapter(resp) {
      var data = this.getResponseData(resp);
      return {
        data: data.data,
        count: data.count
      };
    },
    requestKeys: {
      query: "query",
      limit: "limit",
      orderBy: "orderBy",
      ascending: "ascending",
      page: "page",
      byColumn: "byColumn",
      draw: "draw"
    },
    rowClassCallback: false,
    preserveState: false,
    saveState: false,
    storage: "local",
    columnsClasses: {},
    summary: false,
    caption: false,
    cellClasses: {},
    visibleColumns: false,
    hiddenColumns: false,
    resizableColumns: true,
    editableColumns: [],
    tabbable: true,
    componentsOverride: {}
  };
};

var opts = function () {
  var defaults = defaults$6();

  return this.initOptions(defaults, this.globalOptions, this.options);
};

var tableData = function () {
  return this.data;
};

var storage = function () {
  if (typeof localStorage === 'undefined') return {};
  return this.opts.storage === 'local' ? localStorage : sessionStorage;
};

var filterableColumns = function () {
  return this.opts.filterable && this.opts.filterable.length ? this.opts.filterable : this.Columns;
};

var intersect = require$$0$1["default"];

var datepickerColumns = function () {
  if (this.opts.filterable === true) {
    return this.opts.dateColumns;
  }

  if (this.opts.filterable === false) {
    return [];
  }

  return intersect(this.opts.filterable, this.opts.dateColumns);
};

var hasChildRow = function () {
  return !!(this.opts.childRow || this.$parent.$scopedSlots.child_row);
};

var colspan = function () {
  var span = this.allColumns.length;
  if (this.hasChildRow) span++;
  if (this.opts.selectable.mode) span++;
  return span;
};

function _typeof$8(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$8 = function _typeof(obj) { return typeof obj; }; } else { _typeof$8 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$8(obj); }

var hasGenericFilter = function () {
  return !this.opts.filterByColumn && (typeof this.opts.filterable === 'boolean' && this.opts.filterable || _typeof$8(this.opts.filterable) === 'object' && this.opts.filterable.length);
};

var perPageValues = function () {
  var _this = this;

  var perpageValues = [];
  this.opts.perPageValues.every(function (value) {
    var isLastEntry = value >= _this.count;
    perpageValues.push(value);
    return !isLastEntry;
  });
  return perpageValues;
};

var computed = {
  listColumnsObject: listColumnsObject,
  allColumns: allColumns,
  templatesKeys: templatesKeys,
  opts: opts,
  tableData: tableData,
  storage: storage,
  filterableColumns: filterableColumns,
  datepickerColumns: datepickerColumns,
  hasChildRow: hasChildRow,
  colspan: colspan,
  hasGenericFilter: hasGenericFilter,
  perPageValues: perPageValues,
  filtersCount: function filtersCount() {
    return this.opts.filterByColumn ? Object.values(this.query).filter(function (val) {
      return !!val;
    }).length : !!this.query ? 1 : 0;
  },
  stateKey: function stateKey() {
    var key = this.name ? this.name : this.id;
    return 'vuetables_' + key;
  },
  Page: function Page() {
    return this.page;
  },
  tabIndex: function tabIndex() {
    return this.opts.tabbable ? 0 : -1;
  }
};

var _bus$3 = _interopRequireDefault$7(bus);

function _interopRequireDefault$7(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var beforeDestroy = function () {
  var _this = this;

  var el;

  if (this.opts.destroyEventBus) {
    _bus$3["default"].$off();

    _bus$3["default"].$destroy();
  }

  if (this.vuex && !this.opts.preserveState) {
    this.$store.unregisterModule(this.name);
  }

  if (this.opts.filterByColumn) {
    this.datepickerColumns.forEach(function (column) {
      el = $(_this.$el).find("#VueTables__" + $.escapeSelector(column) + "-filter").data('daterangepicker');
      if (el) el.remove();
    });
  }
};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var methods$1 = methods;

var computed$1 = computed;

var beforeDestroy$1 = beforeDestroy;

function _default() {
  return {
    methods: methods$1,
    computed: computed$1,
    beforeDestroy: beforeDestroy$1
  };
}
}(table));

var data$2 = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _merge = _interopRequireDefault(src.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _default(useVuex, source) {
  var page = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var data = {
    vuex: true,
    activeState: false,
    userColumnsDisplay: [],
    userControlsColumns: false,
    displayColumnsDropdown: false,
    selectedRows: [],
    collapsedGroups: []
  };
  if (useVuex) return data;
  data = (0, _merge["default"])(data, {
    vuex: false,
    count: 0,
    customQueries: {},
    query: null,
    page: page,
    limit: 10,
    windowWidth: typeof window !== 'undefined' ? window.innerWidth : null,
    orderBy: {
      column: false,
      ascending: true
    }
  });
  if (source == 'server') data.data = [];
  return data;
}
}(data$2));

function _typeof$7(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$7 = function _typeof(obj) { return typeof obj; }; } else { _typeof$7 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$7(obj); }

var resizeableColumns = function (table, hasChildRow, isChildRowTogglerFirst, resizeableColumns, stickyHeader) {
  var row = table.getElementsByTagName("tr")[0],
      cols = row ? Array.from(row.children) : undefined;
  if (!cols) return;

  if (_typeof$7(resizeableColumns) === 'object') {
    cols = cols.filter(function (col) {
      return resizeableColumns.includes(col.id.split('--')[1]);
    });
  }

  if (!stickyHeader) {
    table.style.overflow = "hidden";
  }

  var tableHeight = table.offsetHeight;
  var i = hasChildRow && isChildRowTogglerFirst ? 1 : 0;
  var till = hasChildRow && !isChildRowTogglerFirst ? cols.length - 2 : cols.length;

  for (; i < till; i++) {
    if (cols[i].getElementsByClassName('resize-handle').length) {
      continue;
    }

    var div = createDiv(tableHeight);
    div.className = "resize-handle";
    cols[i].appendChild(div);
    cols[i].style.position = stickyHeader ? "sticky" : "relative";
    setListeners(div);
  }

  function setListeners(div) {
    var pageX, curCol, nxtCol, curColWidth, nxtColWidth;
    div.addEventListener("mousedown", function (e) {
      e.preventDefault();
      e.stopPropagation();
      curCol = e.target.parentElement;
      nxtCol = curCol.nextElementSibling;
      pageX = e.pageX;
      var padding = paddingDiff(curCol);
      curColWidth = curCol.offsetWidth - padding;
      if (nxtCol) nxtColWidth = nxtCol.offsetWidth - padding;
    }); // div.addEventListener("mouseover", function(e) {
    //   e.target.style.borderRight = "2px solid #0000ff";
    // });

    div.addEventListener("mouseout", function (e) {
      e.target.style.borderRight = "";
    });
    document.addEventListener("mousemove", function (e) {
      if (curCol) {
        var diffX = e.pageX - pageX;
        if (nxtCol) nxtCol.style.width = nxtColWidth - diffX + "px";
        curCol.style.width = curColWidth + diffX + "px";
      }
    });
    document.addEventListener("mouseup", function (e) {
      if (e.target.nodeName === 'INPUT') return;
      e.stopPropagation();
      curCol = undefined;
      nxtCol = undefined;
      pageX = undefined;
      nxtColWidth = undefined;
      curColWidth = undefined;
    });
  }

  function createDiv(height) {
    var div = document.createElement("div");
    div.style.top = 0;
    div.style.right = 0;
    div.style.width = "5px";
    div.style.position = "absolute";
    div.style.cursor = "col-resize";
    div.style.userSelect = "none";
    div.style.height = height + "px";
    return div;
  }

  function paddingDiff(col) {
    if (getStyleVal(col, "box-sizing") == "border-box") {
      return 0;
    }

    var padLeft = getStyleVal(col, "padding-left");
    var padRight = getStyleVal(col, "padding-right");
    return parseInt(padLeft) + parseInt(padRight);
  }

  function getStyleVal(elm, css) {
    return window.getComputedStyle(elm, null).getPropertyValue(css);
  }
};

var VtClientTable = {};

var VtPerPageSelector$1 = {};

var RLPerPageSelector = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: "RLPerPageSelector",
  inject: ['opts', 'limit', 'setLimit', 'perPageValues', 'id', 'theme', 'display', 'componentsOverride'],
  render: function render() {
    var _this = this;

    return this.$scopedSlots["default"]({
      opts: this.opts(),
      perPageValues: this.perPageValues(),
      theme: this.theme,
      limit: this.limit(),
      setLimit: this.setLimit,
      id: this.id,
      selectClass: this.theme.select,
      display: this.display,
      selectAttrs: {
        id: "VueTables__limit_".concat(this.id),
        "class": this.theme.select,
        value: this.limit()
      },
      selectEvents: {
        change: function change(e) {
          return _this.setLimit(e);
        }
      },
      override: this.componentsOverride.perPageSelector
    });
  }
};
exports["default"] = _default;
}(RLPerPageSelector));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLPerPageSelector = _interopRequireDefault(RLPerPageSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtPerPageSelector',
  components: {
    RLPerPageSelector: _RLPerPageSelector["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-per-page-selector", {
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("div", {
            "class": "VueTables__limit-field"
          }, [h("label", {
            "class": props.labelClass,
            attrs: {
              "for": "VueTables__limit_".concat(props.id)
            }
          }, [props.display('limit')]), h("select", {
            attrs: {
              id: props.selectAttrs.id
            },
            "class": props.selectAttrs["class"],
            on: {
              "change": props.selectEvents.change
            }
          }, [props.perPageValues.map(function (val) {
            return h("option", {
              domProps: {
                "value": val,
                "selected": val === props.selectAttrs.value
              }
            }, [val]);
          })])]);
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtPerPageSelector$1));

var VtPerPageSelector = /*@__PURE__*/getDefaultExportFromCjs(VtPerPageSelector$1);

var VtTable$1 = {};

var RLTable = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLTable',
  inject: ['opts', 'theme', 'colspan', 'slots', 'componentsOverride'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      tableAttrs: {
        summary: this.opts().summary,
        "class": "VueTables__table ".concat(this.opts().skin ? this.opts().skin : this.theme.table)
      },
      slots: this.slots(),
      colspan: this.colspan(),
      caption: this.opts().caption,
      override: this.componentsOverride.table
    });
  }
};
exports["default"] = _default;
}(RLTable));

var VtTableHead$1 = {};

var RLTableHead = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLTableHead',
  inject: ['opts', 'slots', 'componentsOverride'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      slots: this.slots(),
      override: this.componentsOverride.tableHead
    });
  }
};
exports["default"] = _default;
}(RLTableHead));

var VtHeadingsRow$1 = {};

var RLHeadingsRow = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLHeadingRow',
  inject: ['opts', 'theme', 'hasChildRow', 'allColumns', 'toggleAllRows', 'componentsOverride'],
  render: function render() {
    return this.$scopedSlots["default"]({
      override: this.componentsOverride.headingsRow,
      theme: this.theme,
      opts: this.opts(),
      columns: this.allColumns(),
      selectable: this.opts().selectable.mode && !this.opts().selectable.programmatic,
      toggleAll: this.toggleAllRows,
      hasChildRow: this.hasChildRow,
      childRowTogglerFirst: this.hasChildRow() && this.opts().showChildRowToggler && this.opts().childRowTogglerFirst,
      childRowTogglerLast: this.hasChildRow() && this.opts().showChildRowToggler && !this.opts().childRowTogglerFirst
    });
  }
};
exports["default"] = _default;
}(RLHeadingsRow));

var VtTableHeading$1 = {};

var RLTableHeading = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLTableHeading',
  props: ['column'],
  provide: function provide() {
    var _this = this;

    return {
      column: function column() {
        return _this.column;
      }
    };
  },
  inject: ['opts', 'theme', 'sortableClass', 'getHeadingTooltip', 'getHeading', 'orderByColumn', 'componentsOverride', 'tabIndex'],
  render: function render(h) {
    var _this2 = this;

    return this.$scopedSlots["default"]({
      opts: this.opts(),
      thAttrs: {
        "class": "".concat(this.sortableClass(this.column), " ").concat(this.theme.th).trim(),
        tabIndex: this.tabIndex(),
        style: this.getStyle(),
        title: this.getHeadingTooltip(this.column)
      },
      thEvents: {
        keypress: function keypress(e) {
          if (e.key === "Enter") {
            this.orderByColumn(this.column, e);
          }
        },
        click: function click(e) {
          if (e.target.className !== "resize-handle") {
            _this2.orderByColumn(_this2.column, e);
          }
        }
      },
      spanAttrs: {
        title: this.getHeadingTooltip(this.column)
      },
      heading: this.getHeading(this.column, h),
      override: this.componentsOverride.tableHeading
    });
  },
  methods: {
    getStyle: function getStyle() {
      var cls = '';

      if (this.opts().stickyHeader) {
        cls += 'position:sticky; top:0;';
      }

      if (this.opts().stickyHeaderBackground) {
        cls += "background:".concat(this.opts().stickyHeaderBackground, ";");
      }

      return cls;
    }
  }
};
exports["default"] = _default;
}(RLTableHeading));

var VtSortControl$1 = {};

var RLSortControl = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLSortControl',
  inject: ['opts', 'column', 'theme', 'sortable', 'hasMultiSort', 'orderBy', 'userMultiSorting', 'sortableChevronClass', 'componentsOverride'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      sortable: this.sortable(this.column()),
      "class": "VueTables__sort-icon ".concat(this.theme.right, " ").concat(this.sortableChevronClass(this.column())),
      sortStatus: this.sortStatus,
      override: this.componentsOverride.sortControl
    });
  },
  computed: {
    OrderBy: function OrderBy() {
      return this.orderBy();
    },
    UserMultiSorting: function UserMultiSorting() {
      return this.userMultiSorting();
    },
    sortStatus: function sortStatus() {
      var _this = this;

      if (this.hasMultiSort && this.OrderBy.column && this.UserMultiSorting[this.OrderBy.column]) {
        var col = this.UserMultiSorting[this.OrderBy.column].filter(function (c) {
          return c.column === _this.column();
        })[0];
        if (col) return {
          sorted: true,
          asc: col.ascending
        };
      }

      if (this.column() === this.OrderBy.column) {
        return {
          sorted: true,
          asc: this.OrderBy.ascending
        };
      }

      return {
        sorted: false,
        asc: false
      };
    }
  },
  methods: {}
};
exports["default"] = _default;
}(RLSortControl));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLSortControl = _interopRequireDefault(RLSortControl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtSortControl',
  components: {
    RLSortControl: _RLSortControl["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-sort-control", {
      scopedSlots: {
        "default": function _default(props) {
          return props.sortable ? props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("span", {
            "class": props["class"]
          }) : '';
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtSortControl$1));

var VtSortControl = /*@__PURE__*/getDefaultExportFromCjs(VtSortControl$1);

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLTableHeading = _interopRequireDefault(RLTableHeading);

var _VtSortControl = _interopRequireDefault(VtSortControl$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtTableHeading',
  props: ['column'],
  components: {
    RLTableHeading: _RLTableHeading["default"],
    VtSortControl: _VtSortControl["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-table-heading", {
      attrs: {
        column: this.column
      },
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("th", {
            on: {
              "keypress": props.thEvents.keypress,
              "click": props.thEvents.click
            },
            "class": props.thAttrs["class"],
            attrs: {
              title: props.thAttrs.title,
              tabindex: props.thAttrs.tabIndex
            },
            style: props.thAttrs.style
          }, [h("span", {
            "class": "VueTables__heading",
            attrs: {
              title: props.title
            }
          }, [props.heading]), h("vt-sort-control")]);
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtTableHeading$1));

var VtTableHeading = /*@__PURE__*/getDefaultExportFromCjs(VtTableHeading$1);

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLHeadingsRow = _interopRequireDefault(RLHeadingsRow);

var _VtTableHeading = _interopRequireDefault(VtTableHeading$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtHeadingsRow',
  components: {
    RLHeadingsRow: _RLHeadingsRow["default"],
    VtTableHeading: _VtTableHeading["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-headings-row", {
      scopedSlots: {
        "default": function _default(props) {
          if (props.override) {
            return h(props.override, {
              attrs: {
                props: props
              }
            });
          }

          var headings = [];

          if (props.selectable) {
            var checkbox = props.opts.selectable.mode === 'single' ? '' : h("input", {
              attrs: {
                id: "vt-toggle-all",
                type: "checkbox"
              },
              on: {
                "click": function click(e) {
                  return props.toggleAll(e);
                }
              }
            });
            headings.push(h("th", {
              "class": "VueTables__select-row VueTables__select-all ".concat(props.theme.th),
              style: props.opts.stickyHeader ? 'position:sticky; top:0; background:white;' : ''
            }, [checkbox]));
          }

          if (props.childRowTogglerFirst) {
            headings.push(h("th", {
              "class": props.theme.th
            }));
          }

          props.columns.map(function (column) {
            headings.push(h("vt-table-heading", {
              attrs: {
                column: column
              }
            }));
          });

          if (props.childRowTogglerLast) {
            headings.push(h("th", {
              "class": props.theme.th
            }));
          }

          return h("tr", [headings]);
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtHeadingsRow$1));

var VtHeadingsRow = /*@__PURE__*/getDefaultExportFromCjs(VtHeadingsRow$1);

var VtFiltersRow$1 = {};

var RLFiltersRow = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLFiltersRow',
  inject: ['opts', 'theme', 'allColumns', 'filterable', 'filterType', 'slots', 'columnClass', 'hasChildRow', 'componentsOverride'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      columns: this.allColumns(),
      filterable: this.filterable,
      filterType: this.filterType,
      slots: this.slots(),
      columnClass: this.columnClass,
      hasChildRow: this.hasChildRow(),
      override: this.componentsOverride.filtersRow,
      theme: this.theme
    });
  }
};
exports["default"] = _default;
}(RLFiltersRow));

var VtTextFilter = {};

var RLTextFilter = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLTextFilter',
  inject: ['opts', 'search', 'query', 'theme', 'getHeading', 'display', 'getColumnName', 'componentsOverride'],
  props: ['column'],
  render: function render(h) {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      column: this.column,
      debounce: this.opts().debounce,
      theme: this.theme,
      search: this.search,
      query: this.query(),
      getHeading: this.getHeading,
      getColumnName: this.getColumnName,
      display: this.display,
      override: this.componentsOverride.textFilter
    });
  }
};
exports["default"] = _default;
}(RLTextFilter));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLTextFilter = _interopRequireDefault(RLTextFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtTextFilter',
  props: ['column'],
  components: {
    RLTextFilter: _RLTextFilter["default"]
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    return h("r-l-text-filter", {
      attrs: {
        column: this.column
      },
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("input", {
            on: {
              "keyup": props.search(props.debounce)
            },
            "class": props.theme.input,
            attrs: {
              name: props.getColumnName(_this.column),
              type: "text",
              placeholder: props.display('filterBy', {
                column: props.getHeading(_this.column)
              }),
              autocomplete: "off"
            }
          });
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtTextFilter));

var VtListFilter = {};

var RLListFilter = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLListFilter',
  inject: ['search', 'query', 'theme', 'getHeading', 'display', 'getColumnName', 'opts', 'componentsOverride'],
  props: ['column'],
  render: function render(h) {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      theme: this.theme,
      search: this.search,
      query: this.query(),
      getHeading: this.getHeading,
      display: this.display,
      items: this.opts().listColumns[this.column].filter(function (item) {
        return !item.hide;
      }),
      defaultOption: this.display('defaultOption', {
        column: this.opts().headings[this.column] ? this.opts().headings[this.column] : this.column
      }),
      name: this.getColumnName(this.column),
      value: this.query()[this.column],
      column: this.column,
      override: this.componentsOverride.listFilter
    });
  }
};
exports["default"] = _default;
}(RLListFilter));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLListFilter = _interopRequireDefault(RLListFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtListFilter',
  props: ['column'],
  components: {
    RLListFilter: _RLListFilter["default"]
  },
  render: function render() {
    var _this = this;

    var h = arguments[0];
    return h("r-l-list-filter", {
      attrs: {
        column: this.column
      },
      scopedSlots: {
        "default": function _default(props) {
          var options = [];
          var selected;
          props.items.map(function (option) {
            selected = String(option.id) === String(props.query[_this.column]) && props.query[_this.column] !== '';
            options.push(h("option", {
              domProps: {
                "value": option.id,
                "selected": selected
              }
            }, [option.text]));
          });
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("div", {
            "class": "VueTables__list-filter",
            attrs: {
              id: 'VueTables__' + _this.column + '-filter'
            }
          }, [h("select", {
            "class": props.theme.select,
            on: {
              "change": props.search(false)
            },
            attrs: {
              name: props.name
            },
            domProps: {
              "value": props.value
            }
          }, [h("option", {
            attrs: {
              value: ""
            }
          }, [props.defaultOption]), options])]);
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtListFilter));

var VtDateFilter = {};

var RLDateFilter = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLDateFilter',
  inject: ['getHeading', 'display', 'componentsOverride', 'opts'],
  props: ['column'],
  render: function render(h) {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      column: this.column,
      placeholder: this.display('filterBy', {
        column: this.getHeading(this.column)
      }),
      display: this.display,
      override: this.componentsOverride.dateFilter
    });
  }
};
exports["default"] = _default;
}(RLDateFilter));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLDateFilter = _interopRequireDefault(RLDateFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtDateFilter',
  props: ['column'],
  components: {
    RLDateFilter: _RLDateFilter["default"]
  },
  render: function render(h) {
    var _this = this;

    return h("r-l-date-filter", {
      attrs: {
        column: this.column
      },
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("div", {
            "class": "VueTables__date-filter",
            attrs: {
              id: 'VueTables__' + _this.column + '-filter'
            }
          }, [h("span", {
            "class": "VueTables__filter-placeholder"
          }, [props.placeholder])]);
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtDateFilter));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLFiltersRow = _interopRequireDefault(RLFiltersRow);

var _VtTextFilter = _interopRequireDefault(VtTextFilter);

var _VtListFilter = _interopRequireDefault(VtListFilter);

var _VtDateFilter = _interopRequireDefault(VtDateFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _default2 = {
  name: 'VtFiltersRow',
  components: {
    RLFiltersRow: _RLFiltersRow["default"],
    VtTextFilter: _VtTextFilter["default"],
    VtListFilter: _VtListFilter["default"],
    VtDateFilter: _VtDateFilter["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-filters-row", {
      scopedSlots: {
        "default": function _default(props) {
          var filters = [];

          if (props.opts.selectable.mode) {
            filters.push(h("th", {
              "class": "VueTables__select-row"
            }));
          }

          if (props.hasChildRow && props.opts.childRowTogglerFirst && props.opts.showChildRowToggler) filters.push(h("th"));
          props.columns.map(function (column) {
            var filter = '';

            if (props.filterable(column)) {
              filter = h(props.filterType(column), {
                props: {
                  column: column
                }
              });
            }

            if (typeof props.slots["filter__".concat(column)] !== 'undefined') {
              filter = filter ? h("div", [filter, props.slots["filter__".concat(column)]]) : props.slots["filter__".concat(column)];
            }

            filters.push(h("th", {
              "class": "".concat(props.columnClass(column), " ").concat(props.theme.th)
            }, [!!filter ? h("div", _defineProperty({
              "class": "VueTables__column-filter"
            }, "class", 'VueTables__' + column + '-filter-wrapper'), [filter]) : '']));
          });
          if (props.hasChildRow && !props.opts.childRowTogglerFirst && props.opts.showChildRowToggler) filters.push(h("th"));
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("tr", {
            "class": "VueTables__filters-row ".concat(props.theme.tr)
          }, [filters]);
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtFiltersRow$1));

var VtFiltersRow = /*@__PURE__*/getDefaultExportFromCjs(VtFiltersRow$1);

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLTableHead = _interopRequireDefault(RLTableHead);

var _VtHeadingsRow = _interopRequireDefault(VtHeadingsRow$1);

var _VtFiltersRow = _interopRequireDefault(VtFiltersRow$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtTableHead',
  components: {
    RLTableHead: _RLTableHead["default"],
    VtHeadingsRow: _VtHeadingsRow["default"],
    VtFiltersRow: _VtFiltersRow["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-table-head", {
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("thead", [props.slots.prependHead, h("vt-headings-row"), props.slots.beforeFilters, props.opts.filterByColumn && props.opts.filterable ? h("vt-filters-row") : '', props.slots.afterFilters]);
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtTableHead$1));

var VtTableHead = /*@__PURE__*/getDefaultExportFromCjs(VtTableHead$1);

var VtTableBody$1 = {};

var RLTableBody = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLTableBody',
  inject: ['opts', 'theme', 'source', 'filteredData', 'tableData', 'colspan', 'openChildRows', 'collapsedGroups', 'scopedSlots', 'slots', 'componentsOverride', 'page', 'limit', 'groupBy'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      theme: this.theme,
      source: this.source,
      canToggleGroups: this.opts().toggleGroups,
      collapsedGroups: this.collapsedGroups(),
      data: this.source === 'client' ? this.filteredData() : this.tableData(),
      colspan: this.colspan(),
      loading: true,
      hasChildRow: this.opts().childRow || this.scopedSlots()['child_row'],
      openChildRows: this.openChildRows(),
      uniqueRowId: this.opts().uniqueKey,
      groupBy: this.groupBy,
      slots: this.slots(),
      override: this.componentsOverride.tableBody,
      initialIndex: (this.page() - 1) * this.limit()
    });
  }
};
exports["default"] = _default;
}(RLTableBody));

var VtNoResultsRow$1 = {};

var RLNoResultsRow = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLNoResultsRow',
  inject: ['colspan', 'display', 'theme', 'componentsOverride', 'loading', 'loadingError', 'initialRequestSent', 'tabIndex', 'opts'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      colspan: this.colspan(),
      loading: this.loading(),
      loadingError: this.loadingError(),
      display: this.display,
      tabIndex: this.tabIndex(),
      "class": this.getClass(),
      tdClass: this.theme.td,
      initialRequestSent: this.initialRequestSent(),
      message: this.display(this.message),
      override: this.componentsOverride.noResultsRow
    });
  },
  methods: {
    getClass: function getClass() {
      if (this.loadingError()) {
        return 'VueTables__error';
      }

      if (this.loading()) {
        return 'VueTables__loading';
      }

      return 'VueTables__no-results';
    }
  },
  computed: {
    message: function message() {
      if (this.loadingError()) {
        return 'loadingError';
      }

      if (this.loading()) {
        return 'loading';
      }

      if (!this.opts().sendInitialRequest && !this.initialRequestSent()) {
        return 'noRequest';
      }

      return 'noResults';
    }
  }
};
exports["default"] = _default;
}(RLNoResultsRow));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLNoResultsRow = _interopRequireDefault(RLNoResultsRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtNoResultsRow',
  components: {
    RLNoResultsRow: _RLNoResultsRow["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-no-results-row", {
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("tr", {
            "class": props["class"]
          }, [h("td", {
            "class": "text-center ".concat(props.tdClass),
            attrs: {
              tabindex: props.tabIndex,
              colspan: props.colspan
            }
          }, [props.message])]);
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtNoResultsRow$1));

var VtNoResultsRow = /*@__PURE__*/getDefaultExportFromCjs(VtNoResultsRow$1);

var VtTableRow$1 = {};

var nestRE = /^(attrs|props|on|nativeOn|class|style|hook)$/;

var babelHelperVueJsxMergeProps = function mergeJSXProps (objs) {
  return objs.reduce(function (a, b) {
    var aa, bb, key, nestedKey, temp;
    for (key in b) {
      aa = a[key];
      bb = b[key];
      if (aa && nestRE.test(key)) {
        // normalize class
        if (key === 'class') {
          if (typeof aa === 'string') {
            temp = aa;
            a[key] = aa = {};
            aa[temp] = true;
          }
          if (typeof bb === 'string') {
            temp = bb;
            b[key] = bb = {};
            bb[temp] = true;
          }
        }
        if (key === 'on' || key === 'nativeOn' || key === 'hook') {
          // merge functions
          for (nestedKey in bb) {
            aa[nestedKey] = mergeFn(aa[nestedKey], bb[nestedKey]);
          }
        } else if (Array.isArray(aa)) {
          a[key] = aa.concat(bb);
        } else if (Array.isArray(bb)) {
          a[key] = [aa].concat(bb);
        } else {
          for (nestedKey in bb) {
            aa[nestedKey] = bb[nestedKey];
          }
        }
      } else {
        a[key] = b[key];
      }
    }
    return a
  }, {})
};

function mergeFn (a, b) {
  return function () {
    a && a.apply(this, arguments);
    b && b.apply(this, arguments);
  }
}

var RLTableRow = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLTableRow',
  props: ['row', 'index'],
  inject: ['allColumns', 'opts', 'rowWasClicked', 'hasChildRow', 'theme', 'componentsOverride', 'isRowSelected'],
  provide: function provide() {
    var _this = this;

    return {
      row: function row() {
        return _this.row;
      },
      index: function index() {
        return _this.index;
      }
    };
  },
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      columns: this.allColumns(),
      hasChildRow: this.hasChildRow(),
      selectable: this.opts().selectable.mode && !this.opts().selectable.programmatic,
      rowId: this.row[this.opts().uniqueKey],
      row: this.row,
      rowAttrs: {
        "class": this.getClass(),
        attrs: this.opts().rowAttributesCallback ? this.opts().rowAttributesCallback(this.row) : {}
      },
      rowEvents: {
        click: this.rowWasClicked.bind(this, this.row, this.index),
        dblclick: this.rowWasClicked.bind(this, this.row, this.index)
      },
      childRowTogglerFirst: this.hasChildRow() && this.opts().showChildRowToggler && this.opts().childRowTogglerFirst,
      childRowTogglerLast: this.hasChildRow() && this.opts().showChildRowToggler && !this.opts().childRowTogglerFirst,
      override: this.componentsOverride.tableRow
    });
  },
  methods: {
    getClass: function getClass() {
      var cls = [];

      if (this.opts().rowClassCallback) {
        cls.push(this.opts().rowClassCallback(this.row));
      }

      cls.push(this.theme.tr);

      if (this.index % 2 === 0) {
        cls.push(this.theme.trEven);
      } else {
        cls.push(this.theme.trOdd);
      }

      if (this.opts().selectable.mode && this.isRowSelected(this.row)) {
        cls.push('VueTables__row--selected');
      }

      return cls.join(' ');
    }
  }
};
exports["default"] = _default;
}(RLTableRow));

var VtTableCell$1 = {};

var RLTableCell = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _merge = _interopRequireDefault(src.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  name: 'RLTableCell',
  inject: ['row', 'theme', 'scopedSlots', 'orderBy', 'opts', 'render', 'index', 'setEditingCell', 'updateValue', 'revertValue', 'editing', 'getValue', 'columnClass', 'cellClasses', 'componentsOverride', 'isListFilter', 'optionText', 'source', 'dateFormat', 'formatDate', 'tabIndex'],
  props: ['column'],
  render: function render(h) {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      row: this.Row,
      column: this.column,
      content: this.content(h),
      classes: "".concat(this.theme.td, " ").concat(this.columnClass(this.column), " ").concat(this.cellClasses(this.column, this.Row), " ").concat(this.sortedClass(this.column)).trim(),
      tabIndex: this.tabIndex(),
      override: this.componentsOverride.tableCell
    });
  },
  computed: {
    Row: function Row() {
      return this.row();
    },
    options: function options() {
      return this.opts();
    }
  },
  methods: {
    content: function content(h) {
      if (this.options.templates[this.column]) {
        return this.render(this.Row, this.column, this.index(), h);
      }

      if (this.scopedSlots()[this.column]) {
        var data = {
          row: this.Row,
          column: this.column,
          index: this.index()
        };

        if (this.options.editableColumns.includes(this.column)) {
          data = (0, _merge["default"])(data, this.getEditFunctions());
        }

        return this.scopedSlots()[this.column](data);
      }

      return this.formatCellContent(this.getValue(this.Row, this.column), this.column);
    },
    sortedClass: function sortedClass(column) {
      if (!this.options.addSortedClassToCells) return '';
      return this.orderBy().column === column ? "".concat(column, "-sorted-") + (this.orderBy().ascending ? 'asc' : 'desc') : '';
    },
    formatCellContent: function formatCellContent(value, column) {
      if (this.source === 'client' && this.options.dateColumns.includes(column)) {
        return this.formatDate(value, this.dateFormat(column));
      }

      if (this.isListFilter(column)) {
        return this.optionText(value, column);
      }

      return value;
    },
    isEditing: function isEditing() {
      return function () {
        var _this = this;

        return this.editing().find(function (e) {
          return e.id === _this.Row[_this.options.uniqueKey] && e.column === _this.column;
        });
      }.bind(this);
    },
    getEditFunctions: function getEditFunctions() {
      return {
        update: this.updateValue(this.Row, this.column),
        isEditing: this.isEditing(),
        setEditing: this.setEditingCell(this.Row, this.column),
        revertValue: this.revertValue(this.Row, this.column)
      };
    }
  }
};
exports["default"] = _default;
}(RLTableCell));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLTableCell = _interopRequireDefault(RLTableCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtTableCell',
  props: ['column'],
  components: {
    RLTableCell: _RLTableCell["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-table-cell", {
      attrs: {
        column: this.column
      },
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("td", {
            attrs: {
              tabindex: props.tabIndex
            },
            "class": props.classes
          }, [props.content]);
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtTableCell$1));

var VtTableCell = /*@__PURE__*/getDefaultExportFromCjs(VtTableCell$1);

var VtChildRowToggler$1 = {};

var RLChildRowToggler = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLChildRowToggler',
  props: ['rowId'],
  inject: ['toggleChildRow', 'opts', 'theme', 'childRowTogglerClass', 'componentsOverride', 'tabIndex', 'row'],
  render: function render(h) {
    var toggleable = this.isToggleable(this.opts().disabledChildRows);
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      "class": this.childRowTogglerClass.bind(this, this.rowId),
      toggle: toggleable ? this.toggleChildRow.bind(this, this.rowId) : function () {},
      override: this.componentsOverride.childRowToggler,
      tabIndex: this.tabIndex(),
      theme: this.theme,
      toggleable: toggleable
    });
  },
  methods: {
    isToggleable: function isToggleable(callback) {
      if (!callback) {
        return true;
      }

      return !callback(this.row());
    }
  }
};
exports["default"] = _default;
}(RLChildRowToggler));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLChildRowToggler = _interopRequireDefault(RLChildRowToggler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtChildRowToggler',
  props: ['rowId'],
  components: {
    RLChildRowToggler: _RLChildRowToggler["default"]
  },
  render: function render(h) {
    return h("r-l-child-row-toggler", {
      attrs: {
        "row-id": this.rowId
      },
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("td", {
            attrs: {
              tabindex: props.tabIndex
            },
            "class": props.theme.td,
            on: {
              "keypress": function keypress(e) {
                if (e.key === 'Enter') {
                  props.toggle();
                }
              },
              "click": props.toggle
            }
          }, [props.toggleable ? h("span", {
            "class": "VueTables__child-row-toggler " + props["class"]()
          }) : '']);
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtChildRowToggler$1));

var VtChildRowToggler = /*@__PURE__*/getDefaultExportFromCjs(VtChildRowToggler$1);

var VtRowSelector$1 = {};

var RLRowSelector = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLRowSelector',
  inject: ['opts', 'theme', 'colspan', 'slots', 'toggleRowSelection', 'isRowSelected', 'componentsOverride', 'row', 'index', 'page', 'limit'],
  render: function render() {
    return this.$scopedSlots["default"]({
      tdClass: this.theme.td,
      mode: this.opts().selectable.mode,
      type: this.opts().selectable.mode === 'single' ? 'radio' : 'checkbox',
      row: this.row(),
      index: this.index() - (this.page() - 1) * this.limit(),
      toggleRow: this.toggleRowSelection,
      selected: this.isRowSelected(this.row()),
      disabled: this.opts().selectable.only && !this.opts().selectable.only(this.row()),
      override: this.componentsOverride.rowSelector
    });
  }
};
exports["default"] = _default;
}(RLRowSelector));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLRowSelector = _interopRequireDefault(RLRowSelector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtRowSelector',
  components: {
    RLRowSelector: _RLRowSelector["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-row-selector", {
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("td", {
            "class": "VueTables__select-row VueTables__select-single ".concat(props.tdClass),
            on: {
              "click": function click(e) {
                return props.toggleRow(e, props.row, props.index, props.disabled);
              }
            }
          }, [h("input", {
            attrs: {
              type: props.type,
              name: "selected_row[]",
              disabled: props.disabled
            },
            "class": "vt-select-row",
            domProps: {
              "checked": props.selected
            }
          })]);
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtRowSelector$1));

var VtRowSelector = /*@__PURE__*/getDefaultExportFromCjs(VtRowSelector$1);

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _babelHelperVueJsxMergeProps = _interopRequireDefault(babelHelperVueJsxMergeProps);

var _RLTableRow = _interopRequireDefault(RLTableRow);

var _VtTableCell = _interopRequireDefault(VtTableCell$1);

var _VtChildRowToggler = _interopRequireDefault(VtChildRowToggler$1);

var _VtRowSelector = _interopRequireDefault(VtRowSelector$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtTableRow',
  props: ['row', 'index'],
  components: {
    RLTableRow: _RLTableRow["default"],
    VtTableCell: _VtTableCell["default"],
    VtChildRowToggler: _VtChildRowToggler["default"],
    VtRowSelector: _VtRowSelector["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-table-row", {
      attrs: {
        row: this.row,
        index: this.index
      },
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("tr", (0, _babelHelperVueJsxMergeProps["default"])([{
            "class": "VueTables__row " + props.rowAttrs["class"]
          }, {
            attrs: props.rowAttrs.attrs
          }, {
            on: {
              "click": props.rowEvents.click,
              "dblclick": props.rowEvents.click
            }
          }]), [props.selectable ? h("vt-row-selector") : '', props.childRowTogglerFirst ? h("vt-child-row-toggler", {
            attrs: {
              "row-id": props.rowId
            }
          }) : '', props.columns.map(function (column) {
            return h("vt-table-cell", {
              attrs: {
                column: column
              }
            });
          }), props.childRowTogglerLast ? h("vt-child-row-toggler", {
            attrs: {
              "row-id": props.rowId
            }
          }) : '']);
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtTableRow$1));

var VtTableRow = /*@__PURE__*/getDefaultExportFromCjs(VtTableRow$1);

var VtGroupRow = {};

var RLGroupRow = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLGroupRow',
  props: ['value', 'level'],
  inject: ['colspan', 'opts', 'theme', 'toggleGroupDirection', 'toggleGroup', 'groupToggleIcon', 'getGroupSlot', 'groupBy', 'componentsOverride'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      theme: this.theme,
      colspan: this.colspan(),
      toggleGroupDirection: this.level === 1 ? this.toggleGroupDirection : function () {},
      canToggleGroup: this.opts().toggleGroups,
      toggleGroup: this.toggleGroup,
      groupValue: this.value,
      level: this.level,
      groupToggleIcon: this.groupToggleIcon,
      slot: this.getGroupSlot(this.value),
      override: this.componentsOverride.groupRow
    });
  }
};
exports["default"] = _default;
}(RLGroupRow));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLGroupRow = _interopRequireDefault(RLGroupRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtGroupRow',
  components: {
    RLGroupRow: _RLGroupRow["default"]
  },
  props: ['level', 'value'],
  render: function render() {
    var h = arguments[0];
    return h("r-l-group-row", {
      attrs: {
        level: this.level,
        value: this.value
      },
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("tr", {
            "class": "VueTables__group-row VueTables__group-row--".concat(props.level),
            on: {
              "click": props.toggleGroupDirection
            }
          }, [h("td", {
            attrs: {
              colspan: props.colspan
            }
          }, [props.canToggleGroup ? h("button", {
            "class": props.theme.button,
            on: {
              "click": props.toggleGroup.bind(this, props.groupValue)
            }
          }, [props.groupValue, h("span", {
            "class": "VueTables__group-toggler ".concat(props.groupToggleIcon(props.groupValue))
          })]) : '', !props.canToggleGroup ? h("span", [props.groupValue]) : '', props.slot])]);
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtGroupRow));

var VtChildRow$1 = {};

var RLChildRow = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLChildRow',
  props: ['row', 'index'],
  inject: ['colspan', 'scopedSlots', 'getChildRowTemplate', 'opts', 'componentsOverride'],
  render: function render(h) {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      childRow: this.getChildRowTemplate(h, this.row, this.index, this.scopedSlots()['child_row']),
      colspan: this.colspan(),
      "class": this.opts().rowClassCallback ? this.opts().rowClassCallback(this.row) : '',
      override: this.componentsOverride.childRow
    });
  }
};
exports["default"] = _default;
}(RLChildRow));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLChildRow = _interopRequireDefault(RLChildRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtChildRow',
  props: ['row', 'index'],
  components: {
    RLChildRow: _RLChildRow["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-child-row", {
      attrs: {
        row: this.row,
        index: this.index
      },
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("tr", {
            "class": 'VueTables__child-row ' + props["class"]
          }, [h("td", {
            attrs: {
              colspan: props.colspan
            }
          }, [props.childRow])]);
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtChildRow$1));

var VtChildRow = /*@__PURE__*/getDefaultExportFromCjs(VtChildRow$1);

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLTableBody = _interopRequireDefault(RLTableBody);

var _VtNoResultsRow = _interopRequireDefault(VtNoResultsRow$1);

var _VtTableRow = _interopRequireDefault(VtTableRow$1);

var _VtGroupRow = _interopRequireDefault(VtGroupRow);

var _VtChildRow = _interopRequireDefault(VtChildRow$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtTableBody',
  components: {
    RLTableBody: _RLTableBody["default"],
    VtNoResultsRow: _VtNoResultsRow["default"],
    VtTableRow: _VtTableRow["default"],
    VtChildRow: _VtChildRow["default"],
    VtGroupRow: _VtGroupRow["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-table-body", {
      scopedSlots: {
        "default": function _default(props) {
          var rows = [];

          if (props.groupBy) {
            var addRows = function addRows(data) {
              var rows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
              var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
              data.forEach(function (group) {
                rows.push(h("vt-group-row", {
                  attrs: {
                    level: level,
                    type: group.type,
                    value: group.value
                  }
                }));

                if (level === props.groupBy.length) {
                  if (!props.canToggleGroups || !props.collapsedGroups.includes(group.value)) {
                    group.data.forEach(function (row, index) {
                      rows.push(h("vt-table-row", {
                        attrs: {
                          row: row,
                          index: props.initialIndex + index + 1
                        }
                      }));

                      if (props.hasChildRow && props.openChildRows.includes(row[props.uniqueRowId])) {
                        rows.push(h("vt-child-row", {
                          attrs: {
                            row: row,
                            index: props.initialIndex + index + 1
                          }
                        }));
                      }
                    });
                  }
                } else {
                  if (!props.canToggleGroups || !props.collapsedGroups.includes(group.value)) {
                    addRows(group.data, rows, level + 1);
                  }
                }
              });
              return rows;
            };

            rows = addRows(props.data);
          } else {
            props.data.forEach(function (row, index) {
              rows.push(h("vt-table-row", {
                attrs: {
                  row: row,
                  index: props.initialIndex + index + 1
                }
              }));

              if (props.hasChildRow && props.openChildRows.includes(row[props.uniqueRowId])) {
                rows.push(h("vt-child-row", {
                  attrs: {
                    row: row,
                    index: props.initialIndex + index + 1
                  }
                }));
              }
            });
          }

          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("tbody", {
            "class": props.theme.tbody
          }, [props.slots.prependBody, props.data.length === 0 ? h("vt-no-results-row") : '', rows, props.slots.appendBody]);
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtTableBody$1));

var VtTableBody = /*@__PURE__*/getDefaultExportFromCjs(VtTableBody$1);

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLTable = _interopRequireDefault(RLTable);

var _VtTableHead = _interopRequireDefault(VtTableHead$1);

var _VtTableBody = _interopRequireDefault(VtTableBody$1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtTable',
  components: {
    RLTable: _RLTable["default"],
    VtTableHead: _VtTableHead["default"],
    VtTableBody: _VtTableBody["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-table", {
      scopedSlots: {
        "default": function _default(props) {
          var caption = props.caption ? h("caption", [props.caption]) : '';
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("table", {
            "class": props.tableAttrs["class"],
            attrs: {
              summary: props.tableAttrs.summary
            },
            style: 'border-collapse: collapse; width:100%'
          }, [caption, h("vt-table-head"), props.slots.beforeBody, h("vt-table-body", {
            ref: "vt_table_body"
          }), props.slots.afterBody]);
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtTable$1));

var VtTable = /*@__PURE__*/getDefaultExportFromCjs(VtTable$1);

var VtPagination$1 = {};

var RLPagination = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _merge = _interopRequireDefault(src.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  name: "RLPagination",
  inject: ['opts', 'count', 'limit', 'vuex', 'name', 'id', 'theme', 'page', 'setPage', 'totalPages', 'componentsOverride'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      setPage: this.setPage,
      options: this.opts().pagination,
      virtualScroll: this.opts().virtualScroll,
      page: this.page(),
      records: this.count(),
      perPage: parseInt(this.limit()),
      name: this.vuex ? this.name : this.id,
      vuex: this.vuex,
      theme: this.theme,
      texts: this.opts().texts,
      totalPages: this.totalPages(),
      optionsObj: {
        theme: (0, _merge["default"])(this.theme.pagination, {
          wrapper: "".concat(this.theme.row, " ").concat(this.theme.column, " ").concat(this.theme.contentCenter),
          count: "".concat(this.theme.center, " ").concat(this.theme.column)
        }),
        chunk: this.opts().pagination.chunk,
        chunksNavigation: this.opts().pagination.nav,
        edgeNavigation: this.opts().pagination.edge,
        texts: {
          count: this.opts().texts.count,
          first: this.opts().texts.first,
          last: this.opts().texts.last
        }
      },
      override: this.componentsOverride.pagination
    });
  }
};
exports["default"] = _default;
}(RLPagination));

var main$1 = {exports: {}};

var Pagination = {exports: {}};

var template = function (props) {

    return function (h) {

        var theme = this.theme;
        var prevChunk = '';
        var nextChunk = '';
        var firstPage = '';
        var lastPage = '';
        var items = this.pages.map(function (page) {

            return h(
                'li',
                { 'class': 'VuePagination__pagination-item ' + theme.item + ' ' + this.activeClass(page),
                    on: {
                        'click': this.setPage.bind(this, page)
                    }
                },
                [h(
                    'a',
                    { 'class': theme.link + ' ' + this.activeClass(page),
                        attrs: { role: 'button' }
                    },
                    [this.formatNumber(page)]
                )]
            );
        }.bind(this));

        if (this.opts.edgeNavigation && this.totalChunks > 1) {
            firstPage = h(
                'li',
                { 'class': 'VuePagination__pagination-item ' + theme.item + ' ' + (this.page === 1 ? theme.disabled : '') + ' VuePagination__pagination-item-first-page',
                    on: {
                        'click': this.setPage.bind(this, 1)
                    }
                },
                [h(
                    'a',
                    { 'class': theme.link,
                        attrs: { disabled: this.page === 1 }
                    },
                    [this.opts.texts.first]
                )]
            );

            lastPage = h(
                'li',
                { 'class': 'VuePagination__pagination-item ' + theme.item + ' ' + (this.page === this.totalPages ? theme.disabled : '') + ' VuePagination__pagination-item-last-page',
                    on: {
                        'click': this.setPage.bind(this, this.totalPages)
                    }
                },
                [h(
                    'a',
                    { 'class': theme.link,
                        attrs: { disabled: this.page === this.totalPages }
                    },
                    [this.opts.texts.last]
                )]
            );
        }

        if (this.opts.chunksNavigation === 'fixed') {

            prevChunk = h(
                'li',
                { 'class': 'VuePagination__pagination-item ' + theme.item + ' ' + theme.prev + ' VuePagination__pagination-item-prev-chunk ' + this.allowedChunkClass(-1),
                    on: {
                        'click': this.setChunk.bind(this, -1)
                    }
                },
                [h(
                    'a',
                    { 'class': theme.link,
                        attrs: { disabled: !!this.allowedChunkClass(-1) }
                    },
                    [this.opts.texts.prevChunk]
                )]
            );

            nextChunk = h(
                'li',
                { 'class': 'VuePagination__pagination-item ' + theme.item + ' ' + theme.next + ' VuePagination__pagination-item-next-chunk ' + this.allowedChunkClass(1),
                    on: {
                        'click': this.setChunk.bind(this, 1)
                    }
                },
                [h(
                    'a',
                    { 'class': theme.link,
                        attrs: { disabled: !!this.allowedChunkClass(1) }
                    },
                    [this.opts.texts.nextChunk]
                )]
            );
        }

        return h(
            'div',
            { 'class': 'VuePagination ' + theme.wrapper },
            [h(
                'nav',
                { 'class': '' + theme.nav },
                [h(
                    'ul',
                    {
                        directives: [{
                            name: 'show',
                            value: this.totalPages > 1
                        }],

                        'class': theme.list + ' VuePagination__pagination' },
                    [firstPage, prevChunk, h(
                        'li',
                        { 'class': 'VuePagination__pagination-item ' + theme.item + ' ' + theme.prev + ' VuePagination__pagination-item-prev-page ' + this.allowedPageClass(this.page - 1),
                            on: {
                                'click': this.prev.bind(this)
                            }
                        },
                        [h(
                            'a',
                            { 'class': theme.link,
                                attrs: { disabled: !!this.allowedPageClass(this.page - 1)
                                }
                            },
                            [this.opts.texts.prevPage]
                        )]
                    ), items, h(
                        'li',
                        { 'class': 'VuePagination__pagination-item ' + theme.item + ' ' + theme.next + ' VuePagination__pagination-item-next-page ' + this.allowedPageClass(this.page + 1),
                            on: {
                                'click': this.next.bind(this)
                            }
                        },
                        [h(
                            'a',
                            { 'class': theme.link,
                                attrs: { disabled: !!this.allowedPageClass(this.page + 1)
                                }
                            },
                            [this.opts.texts.nextPage]
                        )]
                    ), nextChunk, lastPage]
                ), h(
                    'p',
                    {
                        directives: [{
                            name: 'show',
                            value: parseInt(this.records)
                        }],

                        'class': 'VuePagination__count ' + theme.count },
                    [this.count]
                )]
            )]
        );
    }.bind(props);
};

var RenderlessPagination = {exports: {}};

var config = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    return {
        format: true,
        chunk: 10,
        chunksNavigation: 'fixed',
        edgeNavigation: false,
        theme: 'bootstrap3',
        template: null,
        texts: {
            count: 'Showing {from} to {to} of {count} records|{count} records|One record',
            first: 'First',
            last: 'Last',
            nextPage: '>',
            nextChunk: '>>',
            prevPage: '<',
            prevChunk: '<<'
        }
    };
};

module.exports = exports['default'];
}(config, config.exports));

var bootstrap3$1 = {
    nav: '',
    count: '',
    wrapper: '',
    list: 'pagination',
    item: 'page-item',
    link: 'page-link',
    next: '',
    prev: '',
    active: 'active',
    disabled: 'disabled'
};

var bootstrap4$1 = {
    nav: '',
    count: '',
    wrapper: '',
    list: 'pagination',
    item: 'page-item',
    link: 'page-link',
    next: '',
    prev: '',
    active: 'active',
    disabled: 'disabled'
};

var bulma$1 = {
    nav: '',
    count: '',
    wrapper: 'pagination',
    list: 'pagination-list',
    item: '',
    link: 'pagination-link',
    next: '',
    prev: '',
    active: 'is-current',
    disabled: '' // uses the disabled HTML attirbute
};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _config = config.exports;

var _config2 = _interopRequireDefault(_config);

var _merge = src.exports;

var _merge2 = _interopRequireDefault(_merge);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    inject: ['Page', 'records', 'perPage'],
    props: {
        itemClass: {
            required: false,
            default: 'VuePagination__pagination-item'
        }
    },
    render: function render() {
        var _this = this;

        return this.$scopedSlots.default({
            override: this.opts.template,
            showPagination: this.totalPages > 1,
            pages: this.pages,
            pageEvents: function pageEvents(page) {
                return {
                    click: function click() {
                        return _this.setPage(page);
                    },
                    keydown: function keydown(e) {
                        if (e.key === 'ArrowRight') {
                            _this.next();
                        }

                        if (e.key === 'ArrowLeft') {
                            _this.prev();
                        }
                    }
                };
            },
            activeClass: this.activeClass,
            hasEdgeNav: this.opts.edgeNavigation && this.totalChunks > 1,
            setPage: this.setPage,
            setFirstPage: this.setPage.bind(this, 1),
            setLastPage: this.setPage.bind(this, this.totalPages),
            hasChunksNav: this.opts.chunksNavigation === 'fixed',
            setPrevChunk: this.prevChunk,
            setNextChunk: this.nextChunk,
            setPrevPage: this.prev,
            firstPageProps: {
                class: this.Theme.link,
                disabled: this.page === 1
            },
            lastPageProps: {
                class: this.Theme.link,
                disabled: this.page === this.totalPages
            },
            prevProps: {
                class: this.Theme.link,
                disabled: !!this.allowedPageClass(this.page - 1)
            },
            nextProps: {
                class: this.Theme.link,
                disabled: !!this.allowedPageClass(this.page + 1)
            },
            pageClasses: function pageClasses(page) {
                return _this.itemClass + ' ' + _this.Theme.item + ' ' + _this.activeClass(page);
            },
            prevChunkProps: {
                class: this.Theme.link,
                disabled: !this.allowedChunk(-1)
            },
            nextChunkProps: {
                class: this.Theme.link,
                disabled: !this.allowedChunk(1)
            },
            setNextPage: this.next,
            theme: {
                nav: this.Theme.nav,
                list: 'VuePagination__pagination ' + this.Theme.list,
                item: this.Theme.item,
                disabled: this.Theme.disabled,
                prev: this.itemClass + ' ' + this.itemClass + '-prev-page ' + this.Theme.item + ' ' + this.Theme.prev + ' ' + this.allowedPageClass(this.page - 1),
                next: this.itemClass + '  ' + this.itemClass + '-next-page ' + this.Theme.item + ' ' + this.Theme.next + ' ' + this.allowedPageClass(this.page + 1),
                prevChunk: this.itemClass + ' ' + this.Theme.item + ' ' + this.Theme.prev + ' ' + this.itemClass + '-prev-chunk ' + this.allowedChunkClass(-1),
                nextChunk: this.itemClass + ' ' + this.Theme.item + ' ' + this.Theme.next + ' ' + this.itemClass + '-next-chunk ' + this.allowedChunkClass(1),
                firstPage: this.itemClass + ' ' + this.Theme.item + ' ' + (this.page === 1 ? this.Theme.disabled : '') + ' ' + this.itemClass + '-first-page',
                lastPage: this.itemClass + ' ' + this.Theme.item + ' ' + (this.page === this.totalPages ? this.Theme.disabled : '') + ' ' + this.itemClass + '-last-page',
                link: this.Theme.link,
                page: this.itemClass + ' ' + this.Theme.item,
                wrapper: this.Theme.wrapper,
                count: 'VuePagination__count ' + this.Theme.count
            },
            hasRecords: this.hasRecords,
            count: this.count,
            texts: this.opts.texts,
            opts: this.opts,
            allowedChunkClass: this.allowedChunkClass,
            allowedPageClass: this.allowedPageClass,
            setChunk: this.setChunk,
            prev: this.prev,
            next: this.next,
            totalPages: this.totalPages,
            totalChunks: this.totalChunks,
            page: this.Page(),
            records: this.records(),
            perPage: this.perPage(),
            formatNumber: this.formatNumber
        });
    },

    data: function data() {
        return {
            firstPage: this.$parent.value,
            For: this.$parent.for,
            Options: this.$parent.options
        };
    },
    watch: {
        page: function page(val) {
            if (this.opts.chunksNavigation === 'scroll' && this.allowedPage(val) && !this.inDisplay(val)) {
                if (val === this.totalPages) {
                    var first = val - this.opts.chunk + 1;
                    this.firstPage = first >= 1 ? first : 1;
                } else {
                    this.firstPage = val;
                }
            }

            this.$parent.$emit('paginate', val);
        }
    },
    computed: {
        Records: function Records() {
            return this.records();
        },
        PerPage: function PerPage() {
            return this.perPage();
        },
        opts: function opts() {
            return _merge2.default.recursive((0, _config2.default)(), this.Options);
        },
        Theme: function Theme() {

            if (_typeof(this.opts.theme) === 'object') {
                return this.opts.theme;
            }

            var themes = {
                bootstrap3: bootstrap3$1,
                bootstrap4: bootstrap4$1,
                bulma: bulma$1
            };

            if (_typeof(themes[this.opts.theme]) === undefined) {
                throw 'vue-pagination-2: the theme ' + this.opts.theme + ' does not exist';
            }

            return themes[this.opts.theme];
        },
        page: function page() {
            return this.Page();
        },

        pages: function pages() {

            if (!this.Records) return [];

            return range(this.paginationStart, this.pagesInCurrentChunk);
        },
        totalPages: function totalPages() {
            return this.Records ? Math.ceil(this.Records / this.PerPage) : 1;
        },
        totalChunks: function totalChunks() {
            return Math.ceil(this.totalPages / this.opts.chunk);
        },
        currentChunk: function currentChunk() {
            return Math.ceil(this.page / this.opts.chunk);
        },
        paginationStart: function paginationStart() {
            if (this.opts.chunksNavigation === 'scroll') {
                return this.firstPage;
            }

            return (this.currentChunk - 1) * this.opts.chunk + 1;
        },
        pagesInCurrentChunk: function pagesInCurrentChunk() {
            return this.paginationStart + this.opts.chunk <= this.totalPages ? this.opts.chunk : this.totalPages - this.paginationStart + 1;
        },
        hasRecords: function hasRecords() {
            return parseInt(this.Records) > 0;
        },

        count: function count() {

            if (/{page}/.test(this.opts.texts.count)) {

                if (this.totalPages <= 1) return '';

                return this.opts.texts.count.replace('{page}', this.page).replace('{pages}', this.totalPages);
            }

            var parts = this.opts.texts.count.split('|');
            var from = (this.page - 1) * this.PerPage + 1;
            var to = this.page == this.totalPages ? this.Records : from + this.PerPage - 1;
            var i = Math.min(this.Records == 1 ? 2 : this.totalPages == 1 ? 1 : 0, parts.length - 1);

            return parts[i].replace('{count}', this.formatNumber(this.Records)).replace('{from}', this.formatNumber(from)).replace('{to}', this.formatNumber(to));
        }
    },
    methods: {
        setPage: function setPage(page) {
            if (this.allowedPage(page)) {
                this.paginate(page);
            }
        },
        paginate: function paginate(page) {
            var _this2 = this;

            this.$parent.$emit('input', page);

            this.$nextTick(function () {
                if (_this2.$el) {
                    var el = _this2.$el.querySelector('li.' + _this2.Theme.active + ' a');
                    if (el) {
                        el.focus();
                    }
                }
            });
        },

        next: function next() {
            return this.setPage(this.page + 1);
        },
        prev: function prev() {
            return this.setPage(this.page - 1);
        },
        inDisplay: function inDisplay(page) {

            var start = this.firstPage;
            var end = start + this.opts.chunk - 1;

            return page >= start && page <= end;
        },

        nextChunk: function nextChunk() {
            return this.setChunk(1);
        },
        prevChunk: function prevChunk() {
            return this.setChunk(-1);
        },
        setChunk: function setChunk(direction) {
            this.setPage((this.currentChunk - 1 + direction) * this.opts.chunk + 1);
        },
        allowedPage: function allowedPage(page) {
            return page >= 1 && page <= this.totalPages;
        },
        allowedChunk: function allowedChunk(direction) {
            return direction == 1 && this.currentChunk < this.totalChunks || direction == -1 && this.currentChunk > 1;
        },
        allowedPageClass: function allowedPageClass(direction) {
            return this.allowedPage(direction) ? '' : this.Theme.disabled;
        },
        allowedChunkClass: function allowedChunkClass(direction) {
            return this.allowedChunk(direction) ? '' : this.Theme.disabled;
        },
        activeClass: function activeClass(page) {
            return this.page == page ? this.Theme.active : '';
        },
        formatNumber: function formatNumber(num) {

            if (!this.opts.format) return num;

            return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }
};


function range(start, count) {
    return Array.apply(0, Array(count)).map(function (element, index) {
        return index + start;
    });
}
module.exports = exports['default'];
}(RenderlessPagination, RenderlessPagination.exports));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _template = template;

var _template2 = _interopRequireDefault(_template);

var _RenderlessPagination = RenderlessPagination.exports;

var _RenderlessPagination2 = _interopRequireDefault(_RenderlessPagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Pagination',
    components: { RenderlessPagination: _RenderlessPagination2.default },
    provide: function provide() {
        var _this = this;

        return {
            Page: function Page() {
                return _this.value;
            },
            perPage: function perPage() {
                return _this.perPage;
            },
            records: function records() {
                return _this.records;
            }
        };
    },
    render: function render(h) {
        return h('renderless-pagination', { scopedSlots: {
                default: function _default(props) {
                    return props.override ? h(props.override, {
                        attrs: { props: props }
                    }) : (0, _template2.default)(props)(h);
                }
            }
        });
    },

    props: {
        value: {
            type: Number,
            required: true,
            validator: function validator(val) {
                return val > 0;
            }
        },
        records: {
            type: Number,
            required: true
        },
        perPage: {
            type: Number,
            default: 25
        },
        options: {
            type: Object
        }
    },
    data: function data() {
        return {
            aProps: {
                role: "button"
            }
        };
    }
};
module.exports = exports['default'];
}(Pagination, Pagination.exports));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Pagination = Pagination.exports;

var _Pagination2 = _interopRequireDefault(_Pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Pagination2.default;
module.exports = exports['default'];
}(main$1, main$1.exports));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLPagination = _interopRequireDefault(RLPagination);

var _vuePagination = _interopRequireDefault(main$1.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtPagination',
  components: {
    RLPagination: _RLPagination["default"],
    Pagination: _vuePagination["default"]
  },
  render: function render(h) {
    return h("r-l-pagination", {
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("pagination", {
            attrs: {
              options: props.optionsObj,
              records: props.records,
              "per-page": props.perPage,
              value: props.page
            },
            on: {
              "input": function input(page) {
                return props.setPage(page);
              }
            }
          });
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtPagination$1));

var VtPagination = /*@__PURE__*/getDefaultExportFromCjs(VtPagination$1);

var VtDropdownPagination = {};

var RLDropdownPagination = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: "RLDropdownPagination",
  inject: ['limit', 'count', 'theme', 'page', 'setPage', 'totalPages', 'componentsOverride', 'id', 'opts'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      name: this.id,
      setPage: this.setPage,
      page: this.page(),
      records: this.count(),
      perPage: parseInt(this.limit()),
      theme: this.theme,
      totalPages: this.totalPages(),
      override: this.componentsOverride.dropdownPagination
    });
  }
};
exports["default"] = _default;
}(RLDropdownPagination));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLDropdownPagination = _interopRequireDefault(RLDropdownPagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VTDropdownPagination',
  components: {
    RLDropdownPagination: _RLDropdownPagination["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-dropdown-pagination", {
      scopedSlots: {
        "default": function _default(props) {
          var id = "VueTables__dropdown-pagination_" + props.name;
          var pages = [];

          for (var pag = 1; pag <= props.totalPages; pag++) {
            pages.push(h("option", {
              domProps: {
                "value": pag
              }
            }, [pag]));
          }

          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("select", {
            "class": "".concat(props.theme.select, " dropdown-pagination"),
            attrs: {
              name: "page",
              id: id
            },
            ref: "page",
            domProps: {
              "value": props.page
            },
            on: {
              "change": function change(e) {
                return props.setPage(e.target.value);
              }
            }
          }, [pages]);
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtDropdownPagination));

var VtGenericFilter$1 = {};

var RLGenericFilter = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLGenericFilter',
  inject: ['opts', 'theme', 'source', 'search', 'query', 'display', 'id', 'componentsOverride'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      theme: this.theme,
      search: this.search,
      query: this.query(),
      display: this.display,
      id: this.id,
      override: this.componentsOverride.genericFilter
    });
  }
};
exports["default"] = _default;
}(RLGenericFilter));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLGenericFilter = _interopRequireDefault(RLGenericFilter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtGenericFilter',
  components: {
    RLGenericFilter: _RLGenericFilter["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-generic-filter", {
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("div", {
            "class": "VueTables__search-field"
          }, [h("label", {
            attrs: {
              "for": "VueTables__search_".concat(props.id)
            },
            "class": props.theme.label
          }, [props.display("filter")]), h("input", {
            "class": "VueTables__search__input ".concat(props.theme.input, " ").concat(props.theme.small),
            ref: "filter",
            attrs: {
              type: "text",
              placeholder: props.display('filterPlaceholder'),
              id: "VueTables__search_".concat(props.id),
              autocomplete: "off"
            },
            on: {
              "keyup": props.search(props.opts.debounce)
            }
          })]);
        }
      }
    });
  },
  methods: {
    focus: function focus() {
      this.$refs.filter.focus();
    },
    blur: function blur() {
      this.$refs.filter.blur();
    }
  }
};
exports["default"] = _default2;
}(VtGenericFilter$1));

var VtGenericFilter = /*@__PURE__*/getDefaultExportFromCjs(VtGenericFilter$1);

var VtColumnsDropdown$1 = {};

var RLColumnsDropdown = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  name: 'RLColumnsDropdown',
  inject: ['getHeading', 'display', 'opts', 'theme', 'allColumns', 'onlyColumn', 'toggleColumn', 'toggleColumnsDropdown', 'displayColumnsDropdown', 'origColumns', 'componentsOverride'],
  render: function render() {
    return this.$scopedSlots["default"]({
      opts: this.opts(),
      theme: this.theme,
      getHeading: this.getHeading,
      display: this.display,
      onlyColumn: this.onlyColumn,
      toggleColumn: this.toggleColumn,
      toggleColumnsDropdown: this.toggleColumnsDropdown,
      displayColumnsDropdown: this.displayColumnsDropdown(),
      origColumns: this.origColumns,
      columns: this.allColumns(),
      override: this.componentsOverride.columnsDropdown
    });
  }
};
exports["default"] = _default;
}(RLColumnsDropdown));

var dropdownWrapper = function (h, classes, columns, display) {
  if (classes.framework === 'bulma') {
    return h("div", {
      "class": classes.menu,
      style: display ? 'display:block' : 'display:none'
    }, [h("div", {
      "class": classes.content
    }, [columns])]);
  }

  if (classes.framework === 'bootstrap4') {
    return h("div", {
      "class": classes.menu,
      style: display ? 'display:block' : 'display:none'
    }, [columns]);
  }

  return h("ul", {
    "class": classes.menu,
    style: display ? 'display:block' : 'display:none'
  }, [columns]);
};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLColumnsDropdown = _interopRequireDefault(RLColumnsDropdown);

var _dropdownWrapper = _interopRequireDefault(dropdownWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtColumnsDropdown',
  components: {
    RLColumnsDropdown: _RLColumnsDropdown["default"]
  },
  render: function render(h) {
    return h("r-l-columns-dropdown", {
      scopedSlots: {
        "default": function _default(props) {
          if (props.override) {
            return h(props.override, {
              attrs: {
                props: props
              }
            });
          }

          var content;
          var cols = props.origColumns.map(function (column) {
            content = h("a", {
              "class": props.theme.dropdown.item,
              attrs: {
                href: "#"
              },
              on: {
                "click": function click() {
                  return props.toggleColumn(column);
                }
              }
            }, [h("input", {
              attrs: {
                type: "checkbox",
                disabled: props.onlyColumn(column)
              },
              domProps: {
                "value": column,
                "checked": props.columns.includes(column)
              },
              "class": props.theme.dropdown.checkbox
            }), h("span", {
              "class": props.theme.dropdown.text
            }, [props.getHeading(column)])]);
            return props.theme.framework === 'bulma' ? content : h("li", [content]);
          });
          return h("div", {
            "class": "VueTables__columns-dropdown"
          }, [h("button", {
            attrs: {
              type: "button"
            },
            "class": "".concat(props.theme.button, " ").concat(props.theme.dropdown.trigger),
            on: {
              "click": props.toggleColumnsDropdown
            }
          }, [props.display('columns'), h("span", {
            "class": "".concat(props.theme.icon, " ").concat(props.theme.small)
          }, [h("i", {
            "class": props.theme.dropdown.caret
          })])]), (0, _dropdownWrapper["default"])(h, props.theme.dropdown, cols, props.displayColumnsDropdown)]);
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtColumnsDropdown$1));

var VtColumnsDropdown = /*@__PURE__*/getDefaultExportFromCjs(VtColumnsDropdown$1);

var Observer$1 = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var _default = {
  data: function data() {
    return {
      observer: null
    };
  },
  render: function render() {
    var h = arguments[0];
    return h("div", {
      "class": 'observer'
    });
  },
  mounted: function mounted() {
    var _this = this;

    this.observer = new IntersectionObserver(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 1),
          entry = _ref2[0];

      if (entry && entry.isIntersecting) {
        _this.$emit("intersect");
      }
    }, {
      root: this.$parent.$el.querySelector('.table-responsive')
    });
    this.observer.observe(this.$el);
  },
  destroyed: function destroyed() {
    this.observer.disconnect();
  }
};
exports["default"] = _default;
}(Observer$1));

var Observer = /*@__PURE__*/getDefaultExportFromCjs(Observer$1);

var VtPaginationCount = {};

var RLPaginationCount = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  inject: ['page', 'limit', 'opts', 'allFilteredData', 'source', 'tableData', 'count'],
  render: function render() {
    return this.$scopedSlots["default"]({
      from: this.opts().pagination.virtual ? 1 : (this.page() - 1) * this.limit() + 1,
      to: this.getTo(),
      total: this.source === 'client' ? this.allFilteredData().length : this.count()
    });
  },
  methods: {
    getTo: function getTo() {
      if (this.source === 'client') {
        return this.page() * this.limit() > this.allFilteredData().length ? this.allFilteredData().length : this.page() * this.limit();
      }

      return this.tableData().length;
    }
  }
};
exports["default"] = _default;
}(RLPaginationCount));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _RLPaginationCount = _interopRequireDefault(RLPaginationCount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtPaginationCount',
  components: {
    RLPaginationCount: _RLPaginationCount["default"]
  },
  render: function render() {
    var h = arguments[0];
    return h("r-l-pagination-count", {
      scopedSlots: {
        "default": function _default(props) {
          return h("p", {
            directives: [{
              name: "show",
              value: props.total
            }]
          }, ["Showing records ", props.from, " to ", props.to, " out of ", props.total]);
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtPaginationCount));

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _VtPerPageSelector = _interopRequireDefault(VtPerPageSelector$1);

var _VtTable = _interopRequireDefault(VtTable$1);

var _VtPagination = _interopRequireDefault(VtPagination$1);

var _VtDropdownPagination = _interopRequireDefault(VtDropdownPagination);

var _VtGenericFilter = _interopRequireDefault(VtGenericFilter$1);

var _VtColumnsDropdown = _interopRequireDefault(VtColumnsDropdown$1);

var _Observer = _interopRequireDefault(Observer$1);

var _VtPaginationCount = _interopRequireDefault(VtPaginationCount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtClientTable',
  components: {
    VtPerPageSelector: _VtPerPageSelector["default"],
    VtTable: _VtTable["default"],
    VtPagination: _VtPagination["default"],
    VtDropdownPagination: _VtDropdownPagination["default"],
    VtColumnsDropdown: _VtColumnsDropdown["default"],
    VtGenericFilter: _VtGenericFilter["default"],
    VtPaginationCount: _VtPaginationCount["default"],
    Observer: _Observer["default"]
  },
  props: {
    columns: {
      type: Array,
      required: true
    },
    data: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: false
    },
    options: {
      type: Object,
      required: false,
      "default": function _default() {
        return {};
      }
    }
  },
  methods: {
    setLoadingState: function setLoadingState(isLoading) {
      this.$refs.table.loading = isLoading;
    },
    setFilter: function setFilter(val) {
      this.$refs.table.setFilter(val);
    },
    setPage: function setPage(val) {
      this.$refs.table.setPage(val);
    },
    setOrder: function setOrder(column, asc) {
      this.$refs.table.setOrder(column, asc);
    },
    setLimit: function setLimit(limit) {
      this.$refs.table.setLimit(limit);
    },
    toggleChildRow: function toggleChildRow(rowId) {
      this.$refs.table.toggleChildRow(rowId);
    },
    getOpenChildRows: function getOpenChildRows() {
      var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return this.$refs.table.getOpenChildRows(rows);
    },
    resetQuery: function resetQuery() {
      this.$refs.table.resetQuery();
    },
    resetSelectedRows: function resetSelectedRows() {
      this.$refs.table.resetSelectedRows();
    },
    selectRow: function selectRow(id) {
      return this.$refs.table.selectRow(id);
    },
    unselectRow: function unselectRow(id) {
      return this.$refs.table.unselectRow(id);
    },
    selectRows: function selectRows(ids) {
      return this.$refs.table.selectRows(ids);
    },
    unselectRows: function unselectRows(ids) {
      return this.$refs.table.unselectRows(ids);
    },
    toggleRow: function toggleRow(id) {
      return this.$refs.table.toggleRow(id);
    },
    selectAllRows: function selectAllRows() {
      return this.$refs.table.selectAllRows();
    },
    setCustomFilters: function setCustomFilters(params) {
      var sendRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return this.$refs.table.setCustomFilters(params, sendRequest);
    },
    downloadCsv: function downloadCsv() {
      var filename = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'table.csv';
      return this.$refs.table.downloadCsv(filename);
    }
  },
  computed: {
    filteredData: function filteredData() {
      return this.$refs.table.filteredData;
    },
    allFilteredData: function allFilteredData() {
      return this.$refs.table.allFilteredData;
    },
    selectedRows: function selectedRows() {
      return this.$refs.table.selectedRows;
    }
  },
  provide: function provide() {
    var _this = this;

    return {
      scopedSlots: function scopedSlots() {
        return _this.$scopedSlots;
      },
      slots: function slots() {
        return _this.$slots;
      }
    };
  },
  model: {
    prop: "data"
  },
  render: function render(h) {
    return h("r-l-client-table", {
      attrs: {
        data: this.data,
        columns: this.columns,
        name: this.name,
        options: this.options
      },
      ref: "table",
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("div", {
            "class": "VueTables VueTables--" + props.source
          }, [h("div", {
            "class": props.theme.row
          }, [h("div", {
            "class": props.theme.column
          }, [!props.opts.filterByColumn && props.opts.filterable ? h("div", {
            "class": "".concat(props.theme.field, " ").concat(props.theme.inline, " ").concat(props.theme.left, " VueTables__search")
          }, [props.slots.beforeFilter, h("vt-generic-filter", {
            ref: "genericFilter"
          }), props.slots.afterFilter]) : '', props.slots.afterFilterWrapper, (props.perPageValues.length > 1 || props.opts.alwaysShowPerPageSelect) && !props.opts.pagination.virtual ? h("div", {
            "class": "".concat(props.theme.field, " ").concat(props.theme.inline, " ").concat(props.theme.right, " VueTables__limit")
          }, [props.slots.beforeLimit, h("vt-per-page-selector"), props.slots.afterLimit]) : '', props.opts.pagination.dropdown && props.totalPages > 1 ? h("div", {
            "class": "VueTables__pagination-wrapper"
          }, [h("div", {
            "class": "".concat(props.theme.field, " ").concat(props.theme.inline, " ").concat(props.theme.right, " VueTables__dropdown-pagination")
          }, [h("vt-dropdown-pagination")])]) : '', props.opts.columnsDropdown ? h("div", {
            "class": "VueTables__columns-dropdown-wrapper ".concat(props.theme.right, " ").concat(props.theme.dropdown.container)
          }, [h("vt-columns-dropdown")]) : ''])]), props.slots.beforeTable, h("div", {
            "class": "table-responsive VueTables__wrapper",
            style: props.styles()
          }, [h("vt-table", {
            ref: "vt_table"
          }), props.opts.pagination.virtual ? h("observer", {
            on: {
              "intersect": function intersect() {
                return props.setPage(props.page + 1);
              }
            }
          }) : '']), props.slots.afterTable, props.opts.pagination.virtual || !props.opts.pagination.show ? '' : h("vt-pagination"), props.opts.pagination.virtual || props.opts.pagination.dropdown ? h("vt-pagination-count") : '']);
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtClientTable));

var themes = {};

var bootstrap3 = function () {
  return {
    framework: 'bootstrap3',
    table: 'table table-striped table-bordered table-hover',
    tbody: '',
    th: '',
    td: '',
    tr: '',
    trEven: '',
    trOdd: '',
    row: 'row',
    column: 'col-md-12',
    label: '',
    input: 'form-control',
    select: 'form-control',
    field: 'form-group',
    inline: 'form-inline',
    right: 'pull-right',
    left: 'pull-left',
    center: 'text-center',
    contentCenter: '',
    small: '',
    nomargin: '',
    groupTr: 'info',
    button: 'btn btn-secondary',
    icon: '',
    dropdown: {
      container: 'dropdown',
      trigger: 'dropdown-toggle',
      menu: 'dropdown-menu',
      content: '',
      item: '',
      caret: 'caret'
    },
    pagination: {
      nav: 'text-center',
      count: '',
      wrapper: '',
      list: 'pagination',
      item: 'page-item',
      link: 'page-link',
      next: '',
      prev: '',
      active: 'active',
      disabled: 'disabled'
    }
  };
};

var bootstrap4 = function () {
  return {
    framework: 'bootstrap4',
    table: 'table table-striped table-bordered table-hover',
    tbody: '',
    row: 'row',
    th: '',
    td: '',
    tr: '',
    trEven: '',
    trOdd: '',
    column: 'col-md-12',
    label: '',
    input: 'form-control',
    select: 'form-control',
    field: 'form-group',
    inline: 'form-inline',
    right: 'float-right',
    left: 'float-left',
    center: 'text-center',
    contentCenter: 'justify-content-center',
    nomargin: 'm-0',
    groupTr: 'table-info',
    small: '',
    button: 'btn btn-secondary',
    dropdown: {
      container: 'dropdown',
      trigger: 'dropdown-toggle',
      menu: 'dropdown-menu',
      content: '',
      item: 'dropdown-item',
      caret: 'caret'
    },
    pagination: {
      nav: 'text-center',
      count: '',
      wrapper: '',
      list: 'pagination',
      item: 'page-item',
      link: 'page-link',
      next: '',
      prev: '',
      active: 'active',
      disabled: 'disabled',
      icon: ''
    }
  };
};

var bulma = function () {
  return {
    framework: 'bulma',
    table: 'table is-bordered is-striped is-hoverable is-fullwidth',
    tbody: '',
    row: 'columns',
    th: '',
    td: '',
    tr: '',
    trEven: '',
    trOdd: '',
    column: 'column is-12',
    label: 'label',
    input: 'input',
    select: 'select',
    field: 'field',
    inline: 'is-horizontal',
    right: 'is-pulled-right',
    left: 'is-pulled-left',
    center: 'has-text-centered',
    contentCenter: 'is-centered',
    icon: 'icon',
    small: 'is-small',
    nomargin: 'marginless',
    button: 'button',
    groupTr: 'is-selected',
    dropdown: {
      container: 'dropdown',
      trigger: 'dropdown-trigger',
      menu: 'dropdown-menu',
      content: 'dropdown-content',
      item: 'dropdown-item',
      caret: 'fa fa-angle-down'
    },
    pagination: {
      nav: 'has-text-centered',
      count: '',
      wrapper: 'pagination',
      list: 'pagination-list',
      item: '',
      link: 'pagination-link',
      next: '',
      prev: '',
      active: 'is-current',
      disabled: ''
    }
  };
};

var tailwind = function () {
  return {
    framework: 'tailwind',
    table: 'table-auto',
    tbody: '',
    th: 'border px-4 py-2',
    td: 'border px-4 py-2',
    tr: '',
    trEven: 'bg-gray-100',
    trOdd: '',
    row: 'grid-rows-1',
    column: 'flex',
    label: 'label',
    input: 'p-1 border',
    select: 'p-1 border',
    field: 'flex-initial m-2',
    inline: 'is-horizontal',
    right: 'is-pulled-right',
    left: 'is-pulled-left',
    center: 'text-center',
    contentCenter: 'is-centered',
    icon: 'icon',
    small: 'is-small',
    nomargin: 'marginless',
    button: 'button',
    groupTr: 'is-selected',
    dropdown: {
      container: 'dropdown flex-initial m-2 relative',
      trigger: 'dropdown-trigger border round p-1',
      menu: 'dropdown-menu absolute z-50 bg-white border p-2',
      content: 'dropdown-content truncate flex-1',
      item: 'dropdown-item mb-1 flex',
      caret: 'fa fa-angle-down',
      checkbox: 'mt-1',
      text: 'text-left ml-1'
    },
    pagination: {
      nav: 'mt-1 text-center',
      count: 'text-center',
      wrapper: 'pagination',
      list: 'flex',
      item: 'm-1 border rounded',
      link: 'block w-7 p-2',
      next: '',
      prev: '',
      active: 'bg-blue-700 text-white',
      disabled: 'text-gray-400'
    }
  };
};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  bootstrap3: bootstrap3(),
  bootstrap4: bootstrap4(),
  bulma: bulma(),
  tailwind: tailwind()
};
exports["default"] = _default;
}(themes));

var data$1 = function () {
  return {
    id: makeId(),
    allFilteredData: [],
    openChildRows: [],
    windowWidth: typeof window !== 'undefined' ? window.innerWidth : null,
    userMultiSorting: {},
    editing: [],
    selectedIndex: false,
    loadingError: false,
    cancelToken: null,
    drawCounter: 0
  };
};

function makeId() {
  var text = "";
  var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

  for (var i = 0; i < 5; i++) {
    text += possible.charAt(Math.floor(Math.random() * possible.length));
  }

  return text;
}

var isEmpty = function (obj) {
  // null and undefined are "empty"
  if (obj == null) return true; // Assume if it has a length property with a non-zero value
  // that that property is correct.

  if (obj.length > 0) return false;
  if (obj.length === 0) return true; // Otherwise, does it have any properties of its own?

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) return false;
  }

  return true;
};

var state = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _merge = _interopRequireDefault(src.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _default(self) {
  var state = {
    page: self.opts.initialPage ? self.opts.initialPage : 1,
    limit: self.opts.perPage,
    count: self.source == 'server' ? 0 : self.data.length,
    columns: self.columns,
    data: self.source == 'client' ? self.data : [],
    query: self.initQuery(),
    customQueries: self.initCustomFilters(),
    sortBy: self.opts.orderBy && self.opts.orderBy.column ? self.opts.orderBy.column : false,
    ascending: self.opts.orderBy && self.opts.orderBy.hasOwnProperty('ascending') ? self.opts.orderBy.ascending : true
  };

  if (typeof self.$store.state[self.name] !== 'undefined') {
    return (0, _merge["default"])(true, self.$store.state[self.name], state);
  }

  return state;
}
}(state));

var mutations = {};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _merge = _interopRequireDefault(src.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _default(self) {
  var _ref, _merge$recursive;

  var extra = self.source == 'server' ? (_ref = {}, _defineProperty(_ref, "".concat(self.name, "/SET_DATA"), function SET_DATA(state, response) {
    var data = self.opts.responseAdapter.call(self, response);
    state.data = self.opts.pagination.virtual && state.page !== 1 ? state.data.concat(data.data) : data.data;
    state.count = parseInt(data.count);
  }), _defineProperty(_ref, "".concat(self.name, "/ERROR"), function ERROR(state, payload) {}), _defineProperty(_ref, "".concat(self.name, "/SET_COUNT"), function SET_COUNT(state, count) {
    state.count = count;
  }), _ref) : _defineProperty({}, "".concat(self.name, "/SET_COUNT"), function SET_COUNT(state, count) {
    state.count = count;
  });
  return _merge["default"].recursive(true, (_merge$recursive = {}, _defineProperty(_merge$recursive, "".concat(self.name, "/PAGINATE"), function PAGINATE(state, page) {
    if (page === 0) {
      page = 1;
    }

    state.page = page;
    self.updateState('page', page);
    if (self.source == 'server') self.getData();
    self.commit('PAGINATION', page);
  }), _defineProperty(_merge$recursive, "".concat(self.name, "/SET_FILTER"), function SET_FILTER(state, filter) {
    state.page = 1;
    self.updateState('page', 1);
    state.query = filter;

    if (self.source == 'server') {
      self.getData();
    }
  }), _defineProperty(_merge$recursive, "".concat(self.name, "/PAGINATION"), function PAGINATION(state, page) {}), _defineProperty(_merge$recursive, "".concat(self.name, "/SET_CUSTOM_FILTER"), function SET_CUSTOM_FILTER(state, _ref3) {
    var filter = _ref3.filter,
        value = _ref3.value;
    state.customQueries[filter] = value;
    state.page = 1;
    self.updateState('page', 1);
    self.updateState('customQueries', state.customQueries);

    if (self.source == 'server') {
      self.getData();
    }
  }), _defineProperty(_merge$recursive, "".concat(self.name, "/SET_STATE"), function SET_STATE(state, _ref4) {
    var page = _ref4.page,
        query = _ref4.query,
        customQueries = _ref4.customQueries,
        limit = _ref4.limit,
        orderBy = _ref4.orderBy;

    if (customQueries) {
      state.customQueries = customQueries;
    }

    if (typeof query !== 'undefined') {
      state.query = query;
    }

    if (page) {
      state.page = page;
    }

    if (limit) {
      state.limit = limit;
    }

    if (typeof orderBy !== 'undefined') {
      state.ascending = orderBy.ascending;
      state.sortBy = orderBy.column;
    }
  }), _defineProperty(_merge$recursive, "".concat(self.name, "/SET_LIMIT"), function SET_LIMIT(state, limit) {
    state.page = 1;
    self.updateState('page', 1);
    state.limit = limit;
    if (self.source == 'server') self.getData();
  }), _defineProperty(_merge$recursive, "".concat(self.name, "/SORT"), function SORT(state, _ref5) {
    var column = _ref5.column,
        ascending = _ref5.ascending;
    state.ascending = ascending;
    state.sortBy = column;
    if (self.source == 'server') self.getData();
  }), _defineProperty(_merge$recursive, "".concat(self.name, "/SET_CLIENT_DATA"), function SET_CLIENT_DATA(state, data) {
    state.data = data;
  }), _defineProperty(_merge$recursive, "".concat(self.name, "/SORTED"), function SORTED(state, data) {}), _defineProperty(_merge$recursive, "".concat(self.name, "/ROW_CLICK"), function ROW_CLICK(state, row) {}), _defineProperty(_merge$recursive, "".concat(self.name, "/FILTER"), function FILTER(state, row) {}), _defineProperty(_merge$recursive, "".concat(self.name, "/LIMIT"), function LIMIT(state, limit) {}), _defineProperty(_merge$recursive, "".concat(self.name, "/INPUT"), function INPUT(state, payload) {}), _defineProperty(_merge$recursive, "".concat(self.name, "/UPDATE"), function UPDATE(state, payload) {}), _defineProperty(_merge$recursive, "".concat(self.name, "/LOADING"), function LOADING(state, payload) {}), _defineProperty(_merge$recursive, "".concat(self.name, "/LOADED"), function LOADED(state, payload) {}), _defineProperty(_merge$recursive, "".concat(self.name, "/SELECT"), function SELECT(state, payload) {}), _merge$recursive), extra);
}
}(mutations));

var _state = _interopRequireDefault$6(state);

var _mutations = _interopRequireDefault$6(mutations);

var _merge$2 = _interopRequireDefault$6(src.exports);

function _interopRequireDefault$6(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var registerModule = function (self) {
  var Module = {
    state: (0, _state["default"])(self),
    mutations: (0, _mutations["default"])(self)
  };
  var hasModule = self.$store.hasModule ? self.$store.hasModule(self.name) : self.$store.state && self.$store.state[self.name];

  if (hasModule) {
    Module.state = _merge$2["default"].recursive(Module.state, self.$store.state[self.name]);
    self.$store.unregisterModule(self.name);
  }

  self.$store.registerModule(self.name, Module);
};

var is_empty = isEmpty;

var registerVuexModule = registerModule;

var created = function (self) {
  if (self.vuex) {
    registerVuexModule(self);
  } else {
    self.limit = self.opts.perPage;
  }

  if (is_empty(self.opts.columnsDisplay) || typeof window === 'undefined') return;
  self.columnsDisplay = getColumnsDisplay(self.opts.columnsDisplay);
  window.addEventListener('resize', function () {
    self.windowWidth = window.innerWidth;
  }.bind(self));
};

function getColumnsDisplay(columnsDisplay) {
  var res = {};
  var range;
  var device;
  var operator;

  for (var column in columnsDisplay) {
    operator = getOperator(columnsDisplay[column]);

    try {
      device = getDevice(columnsDisplay[column]);
      range = getRange(device, operator);
      res[column] = range.concat([operator]);
    } catch (err) {
      console.warn('Unknown device ' + device);
    }
  }

  return res;
}

function getRange(device, operator) {
  var devices = {
    desktopHuge: [1920, null],
    desktopLarge: [1280, 1920],
    desktop: [1024, 1280],
    tablet: [480, 1024],
    mobile: [0, 480],
    tabletL: [768, 1024],
    tabletP: [480, 768],
    mobileL: [320, 480],
    mobileP: [0, 320]
  };

  switch (operator) {
    case 'min':
      return [devices[device][0], null];

    case 'max':
      return [0, devices[device][1]];

    default:
      return devices[device];
  }
}

function getOperator(val) {
  var pieces = val.split('_');
  if (['not', 'min', 'max'].indexOf(pieces[0]) > -1) return pieces[0];
  return false;
}

function getDevice(val) {
  var pieces = val.split('_');
  return pieces.length > 1 ? pieces[1] : pieces[0];
}

var provide$2 = function () {
  var _this = this;

  return {
    count: function count() {
      return _this.count;
    },
    rowWasClicked: this.rowWasClicked,
    render: this.render,
    groupBy: this.groupBy,
    opts: function opts() {
      return _this.opts;
    },
    limit: function limit() {
      return _this.limit;
    },
    setLimit: this.setLimit,
    perPageValues: function perPageValues() {
      return _this.perPageValues;
    },
    page: function page() {
      return _this.page;
    },
    id: this.id,
    theme: this.theme,
    display: this.display,
    origColumns: this.columns,
    allColumns: function allColumns() {
      return _this.allColumns;
    },
    sortableClass: this.sortableClass,
    getHeadingTooltip: this.getHeadingTooltip,
    getHeading: this.getHeading,
    sortable: this.sortable,
    sortableChevronClass: this.sortableChevronClass,
    orderByColumn: this.orderByColumn,
    allFilteredData: function allFilteredData() {
      return _this.allFilteredData;
    },
    filteredData: function filteredData() {
      return _this.filteredData;
    },
    tableData: function tableData() {
      return _this.tableData;
    },
    source: this.source,
    colspan: function colspan() {
      return _this.colspan;
    },
    setEditingCell: this._setEditingCell,
    revertValue: this._revertValue,
    updateValue: this._updateValue,
    editing: function editing() {
      return _this.editing;
    },
    hasChildRow: function hasChildRow() {
      return _this.hasChildRow;
    },
    getChildRowTemplate: this._getChildRowTemplate,
    openChildRows: function openChildRows() {
      return _this.openChildRows;
    },
    vuex: this.vuex,
    name: this.name,
    setPage: this.setPage,
    totalPages: function totalPages() {
      return _this.totalPages;
    },
    query: function query() {
      return _this.query;
    },
    filterable: this.filterable,
    filterType: this._filterType,
    columnClass: this.columnClass,
    search: this._search,
    getColumnName: this._getColumnName,
    onlyColumn: this._onlyColumn,
    toggleColumn: this.toggleColumn,
    toggleColumnsDropdown: this._toggleColumnsDropdown,
    displayColumnsDropdown: function displayColumnsDropdown() {
      return _this.displayColumnsDropdown;
    },
    childRowTogglerClass: this.childRowTogglerClass,
    toggleChildRow: this.toggleChildRow,
    componentsOverride: this.componentsOverride,
    getValue: this._getValue,
    cellClasses: this._cellClasses,
    toggleGroup: this.toggleGroup,
    groupToggleIcon: this.groupToggleIcon,
    getGroupSlot: this.getGroupSlot,
    toggleGroupDirection: this._toggleGroupDirection,
    collapsedGroups: function collapsedGroups() {
      return _this.collapsedGroups;
    },
    userMultiSorting: function userMultiSorting() {
      return _this.userMultiSorting;
    },
    hasMultiSort: this.hasMultiSort,
    orderBy: function orderBy() {
      return _this.orderBy;
    },
    isListFilter: this.isListFilter,
    optionText: this.optionText,
    dateFormat: this.dateFormat,
    formatDate: this.formatDate,
    tabIndex: function tabIndex() {
      return _this.tabIndex;
    },
    toggleRowSelection: this.toggleRowSelection,
    toggleAllRows: this.toggleAllRows,
    isRowSelected: this.isRowSelected,
    loading: function loading() {
      return _this.loading;
    },
    loadingError: function loadingError() {
      return _this.loadingError;
    },
    initialRequestSent: function initialRequestSent() {
      return _this.initialRequestSent;
    }
  };
};

var _resizeableColumns$2 = _interopRequireDefault$5(resizeableColumns);

function _interopRequireDefault$5(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var watch$2 = {
  columns: function columns() {
    var _this = this;

    if (this.opts.resizableColumns) {
      this.$nextTick(function () {
        (0, _resizeableColumns$2["default"])(_this.$el.querySelector("table"), _this.hasChildRow, _this.opts.childRowTogglerFirst, _this.resizableColumns, _this.opts.stickyHeader);
      });
    }
  }
};

var RLDataTable = function () {
  var _this = this;

  return this.$scopedSlots["default"]({
    source: this.source,
    theme: this.theme,
    opts: this.opts,
    perPageValues: this.perPageValues,
    totalPages: this.totalPages,
    slots: this.$parent.$slots,
    page: this.page,
    setPage: this.setPage,
    virtualPagination: this.opts.pagination.virtual,
    loading: this.loading,
    override: this.componentsOverride.dataTable,
    styles: function styles() {
      var cls = [];

      if (_this.opts.pagination.virtual || _this.opts.stickyHeader) {
        cls.push('overflow-x:unset');
      }

      if (_this.opts.pagination.virtual) {
        cls.push('overflow-y:scroll');
      }

      return cls.join(';');
    }
  });
};

var q = function () {
  return this.opts.filterByColumn ? JSON.stringify(this.query) : this.query;
};

var customQ = function () {
  return JSON.stringify(this.customQueries);
};

var totalPages = function () {
  return Math.ceil(this.count / this.limit);
};

var clone$1 = lodash_clonedeep.exports;

var filteredData = function () {
  this.dispatch('loading');
  var data = clone$1(this.tableData);
  var column = this.orderBy.column;
  data = this.search(data);

  if (column) {
    // dummy var to force compilation
    if (this.time) this.time = this.time;
    data = this.opts.sortingAlgorithm.call(this, data, column);
  } else if (this.groupBy) {
    data = this.opts.sortingAlgorithm.call(this, data, this.groupBy[0]);
  }

  if (this.vuex) {
    if (this.count != data.length) this.commit('SET_COUNT', data.length);
  } else {
    this.count = data.length;
  }

  this.allFilteredData = JSON.parse(JSON.stringify(data));
  var offset = this.opts.pagination.virtual ? 0 : (this.page - 1) * this.limit;
  var limit = this.opts.pagination.virtual ? this.limit * this.page : this.limit;
  var res = data.splice(offset, limit);

  if (this.groupBy) {
    return toArray(groupData(res, JSON.parse(JSON.stringify(this.groupBy))), this.groupBy);
  }

  this.dispatch('loaded');
  return res;
};

function groupData(data, keys) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var key;
  var result = data.reduce(function (r, a) {
    key = a[keys[i]];
    r[key] = r[key] || [];
    r[key].push(a);
    return r;
  }, Object.create(null));
  i++;

  if (typeof keys[i] === 'string') {
    for (var k in result) {
      result[k] = groupData(result[k], keys, i);
    }
  }

  return result;
}

function toArray(data, groupBy) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var res = [];

  for (var item in data) {
    res.push({
      value: item,
      type: groupBy[i],
      data: typeof groupBy[i + 1] === 'undefined' ? data[item] : toArray(data[item], groupBy, i + 1)
    });
  }

  return res;
}

var transformDateStringsToMoment = function () {
  this.data.forEach(function (row, index) {
    this.opts.dateColumns.forEach(function (column) {
      row[column] = row[column] ? moment(row[column], this.opts.toMomentFormat) : '';
    }.bind(this));
  }.bind(this));
};

var _bus$2 = _interopRequireDefault$4(bus);

function _interopRequireDefault$4(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var registerClientFilters = function () {
  var _this = this;

  var event = 'vue-tables';
  if (this.name) event += '.' + this.name;
  this.opts.customFilters.forEach(function (filter) {
    _bus$2["default"].$off("".concat(event, ".filter::").concat(filter.name));

    _bus$2["default"].$on("".concat(event, ".filter::").concat(filter.name), function (value) {
      _this.setPage(1);

      _this.customQueries[filter.name] = value;

      _this.updateState('customQueries', _this.customQueries);
    });
  });
};

function _typeof$6(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$6 = function _typeof(obj) { return typeof obj; }; } else { _typeof$6 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$6(obj); }

var objectFilledKeysCount = function (obj) {
  var count = 0;

  for (var prop in obj) {
    var isDateRange = _typeof$6(obj[prop]) == 'object';
    if (isDateRange || obj[prop] && (!isNaN(obj[prop]) || obj[prop].trim())) count++;
  }

  return count;
};

var customFilters = function (data, customFilters, customQueries) {
  var passing;
  return data.filter(function (row) {
    passing = true;
    customFilters.forEach(function (filter) {
      var value = customQueries[filter.name];
      if (value && !filter.callback(row, value)) passing = false;
    });
    return passing;
  });
};

function _typeof$5(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$5 = function _typeof(obj) { return typeof obj; }; } else { _typeof$5 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$5(obj); }

var object_filled_keys_count = objectFilledKeysCount;

var is_valid_moment_object = isValidMomentObject;

var filterByCustomFilters = customFilters;

var clientSearch = function (data, e) {
  if (e) {
    var _query = this.query;
    this.setPage(1, true);
    var name = this.getName(e.target.name);
    var value = _typeof$5(e.target.value) === 'object' ? e.target.value : '' + e.target.value;

    if (name) {
      _query[name] = value;
    } else {
      _query = value;
    }

    this.vuex ? this.commit('SET_FILTER', _query) : this.query = _query;
    this.updateState('query', _query);

    if (name) {
      this.dispatch('filter', {
        name: name,
        value: value
      });
      this.dispatch("filter::".concat(name), value);
    } else {
      this.dispatch('filter', value);
    }
  }

  var query = this.query;
  var totalQueries = !query ? 0 : 1;
  if (!this.opts) return data;

  if (this.opts.filterByColumn) {
    totalQueries = object_filled_keys_count(query);
  }

  var value;
  var found;
  var currentQuery;
  var dateFormat;
  var filterByDate;
  var isListFilter;
  var data = filterByCustomFilters(data, this.opts.customFilters, this.customQueries);
  if (!totalQueries) return data;
  return data.filter(function (row, index) {
    found = 0;
    this.filterableColumns.forEach(function (column) {
      filterByDate = this.opts.dateColumns.indexOf(column) > -1 && this.opts.filterByColumn;
      isListFilter = this.isListFilter(column) && this.opts.filterByColumn;
      dateFormat = this.dateFormat(column);
      value = this._getValue(row, column);

      if (is_valid_moment_object(value) && !filterByDate) {
        value = value.format(dateFormat);
      }

      currentQuery = this.opts.filterByColumn ? query[column] : query;
      currentQuery = setCurrentQuery(currentQuery);

      if (currentQuery) {
        if (this.opts.filterAlgorithm[column]) {
          if (this.opts.filterAlgorithm[column].call(this.$parent.$parent, row, this.opts.filterByColumn ? query[column] : query)) found++;
        } else {
          if (foundMatch(currentQuery, value, isListFilter)) found++;
        }
      }
    }.bind(this));
    return found >= totalQueries;
  }.bind(this));
};

function setCurrentQuery(query) {
  if (!query) return '';
  if (typeof query == 'string') return query.toLowerCase(); // Date Range

  return query;
}

function foundMatch(query, value, isListFilter) {
  if (['string', 'number', 'boolean'].indexOf(_typeof$5(value)) > -1) {
    value = String(value).toLowerCase();
  } // List Filter


  if (isListFilter) {
    return value == query;
  } //Text Filter


  if (typeof value === 'string') {
    return value.indexOf(query) > -1;
  } // Date range


  if (is_valid_moment_object(value)) {
    var start = moment(query.start, 'YYYY-MM-DD HH:mm:ss');
    var end = moment(query.end, 'YYYY-MM-DD HH:mm:ss');
    return value >= start && value <= end;
  }

  if (_typeof$5(value) === 'object') {
    for (var key in value) {
      if (foundMatch(query, value[key])) return true;
    }

    return false;
  }

  return value >= start && value <= end;
}

var defaultSort = function (column, ascending) {
  var multiIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;
  var sort = this.defaultSort;
  var multiSort = this.userMultiSorting[this.currentlySorting.column] ? this.userMultiSorting[this.currentlySorting.column] : this.opts.multiSorting[this.currentlySorting.column];
  var asc = this.currentlySorting.ascending;
  var self = this;
  return function (a, b) {
    var aVal = self._getValue(a, column) || '';
    var bVal = self._getValue(b, column) || '';
    var dir = ascending ? 1 : -1;
    var secondaryAsc;
    if (typeof aVal === 'string') aVal = aVal.toLowerCase();
    if (typeof bVal === 'string') bVal = bVal.toLowerCase();

    if (aVal === bVal && multiSort && multiSort[multiIndex + 1]) {
      var sortData = multiSort[multiIndex + 1];

      if (typeof sortData.ascending !== 'undefined') {
        secondaryAsc = sortData.ascending;
      } else {
        secondaryAsc = sortData.matchDir ? asc : !asc;
      }

      return sort(sortData.column, secondaryAsc, multiIndex + 1)(a, b);
    }

    return aVal > bVal ? dir : -dir;
  };
};

var getGroupSlot = function (value) {
  if (this.$parent.$scopedSlots && this.$parent.$scopedSlots['__group_meta']) {
    var data = this.opts.groupMeta.find(function (val) {
      return val.value === value;
    });
    if (!data) return '';
    return this.$parent.$scopedSlots['__group_meta'](data);
  }

  return '';
};

var _vuex$1 = _interopRequireDefault$3(vuex);

var _normal$1 = _interopRequireDefault$3(normal);

var _merge$1 = _interopRequireDefault$3(src.exports);

var _table$1 = _interopRequireDefault$3(table);

var _data2$1 = _interopRequireDefault$3(data$2);

var _resizeableColumns$1 = _interopRequireDefault$3(resizeableColumns);

var _VtClientTable = _interopRequireDefault$3(VtClientTable);

var _themes$1 = _interopRequireDefault$3(themes);

function _interopRequireDefault$3(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _data$1 = data$1;

var _created$1 = created;

var provide$1 = provide$2;

var watch$1 = watch$2;

vClientTable.install = function (Vue, globalOptions, useVuex) {
  var theme = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "bootstrap3";
  var componentsOverride = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

  var client = _merge$1["default"].recursive(true, (0, _table$1["default"])(), {
    name: "r-l-client-table",
    render: RLDataTable,
    provide: provide$1,
    props: {
      columns: {
        type: Array,
        required: true
      },
      data: {
        type: Array,
        required: true
      },
      name: {
        type: String,
        required: false
      },
      options: {
        type: Object,
        required: false,
        "default": function _default() {
          return {};
        }
      }
    },
    created: function created() {
      _created$1(this);

      if (this.opts.toMomentFormat) this.transformDateStringsToMoment();

      if (!this.vuex) {
        this.initOrderBy();
        this.query = this.initQuery();
        this.customQueries = this.initCustomFilters();
      }
    },
    mounted: function mounted() {
      var _this = this;

      this._setFiltersDOM(this.query);

      if (this.opts.resizableColumns) {
        (0, _resizeableColumns$1["default"])(this.$el.querySelector("table"), this.hasChildRow, this.opts.childRowTogglerFirst, this.resizableColumns, this.opts.stickyHeader);
      } // this._setColumnsDropdownCloseListener();


      if (this.groupBy && this.groupBy.length > 1) {
        this.options.multiSorting = {};
        this.options.multiSorting[this.groupBy[0]] = [{
          column: this.groupBy[1],
          matchDir: true
        }]; // force compilation of this.opts

        Vue.set(this.options, this.options);
      }

      if (!this.vuex) {
        this.registerClientFilters();
        if (this.options.initialPage) this.setPage(this.options.initialPage);
      }

      if (this.groupBy && !this.orderBy) {
        this.orderBy.column = this.groupBy[0];
      }

      this.loadState();

      if (this.hasDateFilters()) {
        this.initDateFilters();
      } // listen for data being removed
      // and nav to last page if current page is greater than total pages


      this.$watch('data', function () {
        if (_this.page > _this.totalPages) {
          _this.setPage(_this.totalPages);
        }

        if (_this.vuex) {
          _this.commit('SET_CLIENT_DATA', _this.data);
        }
      });
    },
    model: {
      prop: "data"
    },
    watch: watch$1,
    data: function data() {
      return _merge$1["default"].recursive(_data$1(), {
        source: "client",
        theme: typeof theme === 'string' ? _themes$1["default"][theme] : theme(),
        loading: false,
        globalOptions: globalOptions,
        componentsOverride: componentsOverride,
        currentlySorting: {},
        time: Date.now()
      }, (0, _data2$1["default"])(useVuex, "client", this.options.initialPage));
    },
    computed: {
      q: q,
      customQ: customQ,
      totalPages: totalPages,
      filteredData: filteredData,
      groupBy: function groupBy() {
        return typeof this.opts.groupBy === 'string' ? [this.opts.groupBy] : this.opts.groupBy;
      },
      hasMultiSort: function hasMultiSort() {
        return this.opts.clientMultiSorting;
      }
    },
    methods: {
      transformDateStringsToMoment: transformDateStringsToMoment,
      registerClientFilters: registerClientFilters,
      search: clientSearch,
      defaultSort: defaultSort,
      getGroupSlot: getGroupSlot,
      toggleGroup: function toggleGroup(group, e) {
        e.stopPropagation();
        var i = this.collapsedGroups.indexOf(group);

        if (i >= 0) {
          this.collapsedGroups.splice(i, 1);
        } else {
          this.collapsedGroups.push(group);
        }
      },
      groupToggleIcon: function groupToggleIcon(group) {
        var cls = this.opts.sortIcon.base + " ";
        cls += this.collapsedGroups.indexOf(group) > -1 ? this.opts.sortIcon.down : this.opts.sortIcon.up;
        return cls;
      },
      downloadCsv: function downloadCsv() {
        var _this2 = this;

        var filename = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'table.csv';
        var r;
        var rows = [this.columns].concat(this.allFilteredData.map(function (row) {
          r = {};

          _this2.columns.forEach(function (column) {
            r[column] = row[column];
          });

          return Object.values(r);
        }));
        var csvContent = "data:text/csv;charset=utf-8," + rows.map(function (e) {
          return e.join(",");
        }).join("\n");
        var encodedUri = encodeURI(csvContent);
        var link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", filename);
        document.body.appendChild(link); // Required for FF

        link.click(); // This will download the data file

        link.remove();
      },
      loadState: function loadState() {
        if (!this.opts.saveState) return;

        if (!this.storage.getItem(this.stateKey)) {
          this.initState();
          this.activeState = true;
          return;
        }

        var state = JSON.parse(this.storage.getItem(this.stateKey));
        if (this.opts.filterable) this.setFilter(state.query);
        this.setOrder(state.orderBy.column, state.orderBy.ascending);

        if (this.vuex) {
          this.commit("SET_LIMIT", state.perPage);
        } else {
          this.limit = state.perPage;
        }

        this.setPage(state.page);
        this.activeState = true;

        if (state.userControlsColumns) {
          this.userColumnsDisplay = state.userColumnsDisplay;
          this.userControlsColumns = state.userControlsColumns;
        } // TODO: Custom Queries

      }
    }
  });

  var state = useVuex ? (0, _vuex$1["default"])() : (0, _normal$1["default"])();
  client = _merge$1["default"].recursive(client, state);
  Vue.component("r-l-client-table", client);
  Vue.component("v-client-table", _VtClientTable["default"]);
  return _VtClientTable["default"];
};

var vServerTable = {};

var VtServerTable = {};

var resetCustomFilters = function () {
  for (var key in this.$refs.table.customQueries) {
    this.$refs.table.customQueries[key] = null;
  }

  this.$refs.table.updateState('customQueries', this.customQueries);
  this.$refs.table.refresh();
};

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _VtPerPageSelector = _interopRequireDefault(VtPerPageSelector$1);

var _VtTable = _interopRequireDefault(VtTable$1);

var _VtPagination = _interopRequireDefault(VtPagination$1);

var _VtDropdownPagination = _interopRequireDefault(VtDropdownPagination);

var _VtGenericFilter = _interopRequireDefault(VtGenericFilter$1);

var _VtColumnsDropdown = _interopRequireDefault(VtColumnsDropdown$1);

var _Observer = _interopRequireDefault(Observer$1);

var _VtPaginationCount = _interopRequireDefault(VtPaginationCount);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default2 = {
  name: 'VtServerTable',
  components: {
    VtPerPageSelector: _VtPerPageSelector["default"],
    VtTable: _VtTable["default"],
    VtPagination: _VtPagination["default"],
    VtDropdownPagination: _VtDropdownPagination["default"],
    VtColumnsDropdown: _VtColumnsDropdown["default"],
    VtGenericFilter: _VtGenericFilter["default"],
    VtPaginationCount: _VtPaginationCount["default"],
    Observer: _Observer["default"]
  },
  props: {
    columns: {
      type: Array,
      required: true
    },
    url: {
      type: String,
      required: false
    },
    name: {
      type: String,
      required: false
    },
    options: {
      type: Object,
      required: false,
      "default": function _default() {
        return {};
      }
    }
  },
  computed: {
    customQueries: {
      get: function get() {
        return this.$refs.table.customQueries;
      },
      set: function set(val) {
        this.$refs.table.customQueries = val;
      }
    },
    data: function data() {
      return this.$refs.table.tableData;
    },
    selectedRows: function selectedRows() {
      return this.$refs.table.selectedRows;
    }
  },
  methods: {
    refresh: function refresh() {
      this.$refs.table.refresh();
    },
    getData: function getData() {
      return this.$refs.table.getData();
    },
    setFilter: function setFilter(val) {
      this.$refs.table.setFilter(val);
    },
    setPage: function setPage(val) {
      this.$refs.table.setPage(val);
    },
    setOrder: function setOrder(column, asc) {
      this.$refs.table.setOrder(column, asc);
    },
    setLimit: function setLimit(limit) {
      this.$refs.table.setLimit(limit);
    },
    toggleChildRow: function toggleChildRow(rowId) {
      this.$refs.table.toggleChildRow(rowId);
    },
    getOpenChildRows: function getOpenChildRows() {
      var rows = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      return this.$refs.table.getOpenChildRows(rows);
    },
    getResponseData: function getResponseData(response) {
      return this.$refs.table.getResponseData(response);
    },
    resetQuery: function resetQuery() {
      this.$refs.table.resetQuery();
    },
    resetSelectedRows: function resetSelectedRows() {
      this.$refs.table.resetSelectedRows();
    },
    selectRow: function selectRow(id) {
      return this.$refs.table.selectRow(id);
    },
    unselectRow: function unselectRow(id) {
      return this.$refs.table.unselectRow(id);
    },
    selectRows: function selectRows(ids) {
      return this.$refs.table.selectRows(ids);
    },
    unselectRows: function unselectRows(ids) {
      return this.$refs.table.unselectRows(ids);
    },
    toggleRow: function toggleRow(id) {
      return this.$refs.table.toggleRow(id);
    },
    selectAllRows: function selectAllRows() {
      return this.$refs.table.selectAllRows();
    },
    getRequestParams: function getRequestParams() {
      return this.$refs.table.getRequestParams();
    },
    setRequestParams: function setRequestParams(params) {
      var sendRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return this.$refs.table.setRequestParams(params, sendRequest);
    },
    setCustomFilters: function setCustomFilters(params) {
      var sendRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return this.$refs.table.setCustomFilters(params, sendRequest);
    },
    resetCustomFilters: resetCustomFilters
  },
  provide: function provide() {
    var _this = this;

    return {
      scopedSlots: function scopedSlots() {
        return _this.$scopedSlots;
      },
      slots: function slots() {
        return _this.$slots;
      }
    };
  },
  model: {
    prop: "data"
  },
  render: function render(h) {
    return h("r-l-server-table", {
      attrs: {
        url: this.url,
        columns: this.columns,
        name: this.name,
        options: this.options
      },
      ref: "table",
      scopedSlots: {
        "default": function _default(props) {
          return props.override ? h(props.override, {
            attrs: {
              props: props
            }
          }) : h("div", {
            "class": "VueTables VueTables--" + props.source
          }, [h("div", {
            "class": props.theme.row
          }, [h("div", {
            "class": props.theme.column
          }, [!props.opts.filterByColumn && props.opts.filterable ? h("div", {
            "class": "".concat(props.theme.field, " ").concat(props.theme.inline, " ").concat(props.theme.left, " VueTables__search")
          }, [props.slots.beforeFilter, h("vt-generic-filter", {
            ref: "genericFilter"
          }), props.slots.afterFilter]) : '', props.slots.afterFilterWrapper, (props.perPageValues.length > 1 || props.opts.alwaysShowPerPageSelect) && !props.opts.pagination.virtual ? h("div", {
            "class": "".concat(props.theme.field, " ").concat(props.theme.inline, " ").concat(props.theme.right, " VueTables__limit")
          }, [props.slots.beforeLimit, h("vt-per-page-selector"), props.slots.afterLimit]) : '', props.opts.pagination.dropdown && props.totalPages > 1 ? h("div", {
            "class": "VueTables__pagination-wrapper"
          }, [h("div", {
            "class": "".concat(props.theme.field, " ").concat(props.theme.inline, " ").concat(props.theme.right, " VueTables__dropdown-pagination")
          }, [h("vt-dropdown-pagination")])]) : '', props.opts.columnsDropdown ? h("div", {
            "class": "VueTables__columns-dropdown-wrapper ".concat(props.theme.right, " ").concat(props.theme.dropdown.container)
          }, [h("vt-columns-dropdown")]) : ''])]), props.slots.beforeTable, h("div", {
            "class": "table-responsive",
            style: props.styles()
          }, [h("vt-table", {
            ref: "vt_table"
          }), props.opts.pagination.virtual && !props.loading ? h("observer", {
            on: {
              "intersect": function intersect() {
                return props.setPage(props.page + 1);
              }
            }
          }) : '']), props.slots.afterTable, props.opts.pagination.virtual || !props.opts.pagination.show ? '' : h("vt-pagination"), props.opts.pagination.virtual || props.opts.pagination.dropdown ? h("vt-pagination-count") : '']);
        }
      }
    });
  }
};
exports["default"] = _default2;
}(VtServerTable));

var refresh = function () {
  this.serverSearch();
};

var getData = function (promiseOnly) {
  var additionalData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var emitLoading = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (!this.opts.sendInitialRequest && !this.initialRequestSent) {
    this.initialRequestSent = true;
    this.loading = true;
  }

  var data = this.opts.requestAdapter(this.getRequestParams(additionalData));
  this.drawCounter++;

  if (emitLoading) {
    this.dispatch('loading', data);
  }

  var promise = this.sendRequest(data);
  if (promiseOnly) return promise;
  return promise.then(function (response) {
    if (typeof response !== 'undefined') {
      this.cancelToken = null;
      this.loading = false;
      this.loadingError = false;
      return this.setData(response);
    } else {
      return false;
    }
  }.bind(this));
};

function _typeof$4(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$4 = function _typeof(obj) { return typeof obj; }; } else { _typeof$4 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$4(obj); }

var setData = function (response) {
  var data = this.opts.responseAdapter.call(this, response);

  if (this.opts.useDrawCounter) {
    if (typeof data.draw === 'undefined') {
      console.error("Cannot find `draw` property in response. This response parameter is required when useDrawCounter is set to true");
      return;
    }

    if (this.drawCounter !== data.draw) {
      return;
    }
  }

  if (this.opts.pagination.virtual && this.page !== 1) {
    this.data = this.data.concat(data.data);
  } else {
    this.data = data.data;
  }

  if (isNaN(data.count)) {
    console.error("vue-tables-2: invalid 'count' property. Expected number, got ".concat(_typeof$4(data.count)));
    console.error('count equals', data.count);
    throw new Error();
  }

  this.count = parseInt(data.count);
  setTimeout(function () {
    this.dispatch('loaded', response);
  }.bind(this), 0);
};

var _bus$1 = _interopRequireDefault$2(bus);

function _interopRequireDefault$2(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var registerServerFilters = function () {
  var event = 'vue-tables';
  if (this.name) event += '.' + this.name;
  this.opts.customFilters.forEach(function (filter) {
    _bus$1["default"].$off("".concat(event, ".filter::").concat(filter));

    _bus$1["default"].$on("".concat(event, ".filter::").concat(filter), function (value) {
      this.customQueries[filter] = value;
      this.updateState('customQueries', this.customQueries);
      this.refresh();
    }.bind(this));
  }.bind(this));
};

function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var merge$1 = src.exports;

var getRequestParams = function () {
  var _data;

  var additionalData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var keys = this.opts.requestKeys;
  var data = (_data = {}, _defineProperty$2(_data, keys.query, this.filteredQuery), _defineProperty$2(_data, keys.limit, this.limit), _defineProperty$2(_data, keys.ascending, this.orderBy.ascending ? 1 : 0), _defineProperty$2(_data, keys.page, parseInt(this.page)), _defineProperty$2(_data, keys.byColumn, this.opts.filterByColumn ? 1 : 0), _data);
  if (this.orderBy.hasOwnProperty('column') && this.orderBy.column) data[keys.orderBy] = this.orderBy.column;
  data = merge$1(data, this.opts.params, this.customQueries, additionalData);

  if (this.hasMultiSort && this.orderBy.column && this.userMultiSorting[this.orderBy.column]) {
    data.multiSort = this.userMultiSorting[this.orderBy.column];
  }

  return data;
};

var setRequestParams = function () {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var sendRequest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

  if (params.page) {
    this.setPage(params.page, true);
  }

  if (params.limit) {
    this.setLimit(params.limit, false);
  }

  if (params.order) {
    this.setOrder(params.order.column, params.order.ascending, false);
  }

  if (params.filters) {
    this.setFilter(params.filters, false);
  }

  if (params.customFilters) {
    this.setCustomFilters(params.customFilters, false);
  }

  if (sendRequest) {
    this.getData();
  }
};

function _typeof$3(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }

var filteredQuery = function () {
  if (_typeof$3(this.query) !== 'object' || this.opts.sendEmptyFilters) {
    return this.query;
  }

  var result = {};

  for (var key in this.query) {
    if (this.query[key] !== '' && this.filterable(key)) {
      result[key] = this.query[key];
    }
  }

  return result;
};

var _merge = _interopRequireDefault$1(src.exports);

var _data2 = _interopRequireDefault$1(data$2);

var _vuex = _interopRequireDefault$1(vuex);

var _normal = _interopRequireDefault$1(normal);

var _table = _interopRequireDefault$1(table);

var _resizeableColumns = _interopRequireDefault$1(resizeableColumns);

var _VtServerTable = _interopRequireDefault$1(VtServerTable);

var _themes = _interopRequireDefault$1(themes);

function _interopRequireDefault$1(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _data = data$1;

var _created = created;

var provide = provide$2;

var watch = watch$2;

vServerTable.install = function (Vue, globalOptions, useVuex) {
  var theme = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "bootstrap3";
  var componentsOverride = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
  var state = useVuex ? (0, _vuex["default"])("server") : (0, _normal["default"])();

  var server = _merge["default"].recursive(true, (0, _table["default"])(), {
    name: "r-l-server-table",
    render: RLDataTable,
    props: {
      columns: {
        type: Array,
        required: true
      },
      url: {
        type: String
      },
      name: {
        type: String,
        required: false
      },
      options: {
        type: Object,
        required: false,
        "default": function _default() {
          return {};
        }
      }
    },
    provide: provide,
    created: function created() {
      if (!this.opts.requestFunction && !this.url) {
        throw 'vue-tables-2: you must provide either a "url" prop or a custom request function. Aborting';
      }

      _created(this);

      if (!this.vuex) {
        this.query = this.initQuery();
        this.initOrderBy();
        this.customQueries = this.initCustomFilters();
      }

      if (this.opts.sendInitialRequest) {
        this.loadState();
        this.getData(true).then(function (response) {
          if (typeof response === 'undefined') return;
          this.setData(response);
          this.loading = false;

          if (this.hasDateFilters()) {
            setTimeout(function () {
              this.initDateFilters();
            }.bind(this), 0);
          }
        }.bind(this));
      } else {
        this.loading = false;
      }
    },
    mounted: function mounted() {
      this._setFiltersDOM(this.query);

      if (this.opts.resizableColumns) {
        (0, _resizeableColumns["default"])(this.$el.querySelector("table"), this.hasChildRow, this.opts.childRowTogglerFirst, this.opts.resizableColumns, this.opts.stickyHeader);
      } // this._setColumnsDropdownCloseListener();


      if (this.vuex) return;
      this.registerServerFilters();
      if (this.options.initialPage) this.setPage(this.options.initialPage, true);
    },
    data: function data() {
      return _merge["default"].recursive(_data(), {
        source: "server",
        loading: true,
        initialRequestSent: false,
        lastKeyStrokeAt: false,
        globalOptions: globalOptions,
        componentsOverride: componentsOverride,
        theme: typeof theme === 'string' ? _themes["default"][theme] : theme()
      }, (0, _data2["default"])(useVuex, "server", this.options.initialPage));
    },
    methods: {
      refresh: refresh,
      getData: getData,
      setData: setData,
      serverSearch: serverSearch,
      registerServerFilters: registerServerFilters,
      getRequestParams: getRequestParams,
      setRequestParams: setRequestParams,
      loadState: function loadState() {
        var _this = this;

        if (!this.opts.saveState) return;

        if (!this.storage.getItem(this.stateKey)) {
          this.initState();
          this.activeState = true;
          return;
        }

        var state = JSON.parse(this.storage.getItem(this.stateKey));

        if (this.vuex) {
          this.commit("SET_STATE", {
            query: state.query,
            customQueries: state.customQueries,
            page: state.page,
            limit: state.perPage,
            orderBy: state.orderBy
          });
        } else {
          this.page = state.page;
          this.query = state.query;
          this.customQueries = state.customQueries;
          this.limit = state.perPage;
          this.orderBy = state.orderBy;
        }

        if (!this.opts.pagination.dropdown && this.$refs.pagination) {
          setTimeout(function () {
            _this.$refs.pagination.Page = state.page;
          }, 0);
        }

        if (this.opts.filterable) {
          setTimeout(function () {
            _this._setFiltersDOM(state.query);
          }, 0);
        }

        this.activeState = true;
      }
    },
    watch: (0, _merge["default"])({
      url: function url() {
        this.refresh();
      }
    }, watch),
    computed: {
      totalPages: totalPages,
      filteredQuery: filteredQuery,
      hasMultiSort: function hasMultiSort() {
        return this.opts.serverMultiSorting;
      }
    }
  }, state);

  Vue.component("r-l-server-table", server);
  Vue.component("v-server-table", _VtServerTable["default"]);
  return _VtServerTable["default"];
};

var _bus = _interopRequireDefault(bus);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ClientTable = vClientTable;

var ServerTable = vServerTable;

var compiled = {
  ClientTable: ClientTable,
  ServerTable: ServerTable,
  Event: _bus["default"]
};

var loadThirdPartyAqua = function loadThirdPartyAqua() {
  if (document.getElementById('aq-icons__auto') === null) {
    var link = document.createElement('link');
    link.id = 'aq-icons__auto';
    link.rel = 'stylesheet';
    link.href = 'https://resources.masivapp.com/fonts/icons/aqua/aq-styles-icons.css';
    document.head.appendChild(link);
  }
};
var ThirdParty = {
  loadThirdPartyAqua: loadThirdPartyAqua
};

var DOCUMENT = {
  name: 'document',
  items: ['Maximize', 'Undo', 'Redo', '-']
};
var STYLES = {
  name: 'styles',
  items: ['Format', 'Font', 'FontSize', 'TextColor', 'BGColor']
};
var FONTSTYLES = {
  name: 'fontStyles',
  items: ['Bold', 'Italic', 'Underline', 'Strike', 'Blockquote', '-', 'Link', 'Unlink']
};
var PARAGRAPH = {
  name: 'paragraph',
  items: ['EmojiPanel', 'NumberedList', 'BulletedList', 'Outdent', 'Indent', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock']
};
var INSERT = {
  name: 'insert',
  items: ['Image', 'Table', 'HorizontalRule', 'PageBreak']
};
var TOOLS = {
  name: 'tools',
  items: ['RemoveFormat', '-', 'Source']
};
var buttons_packs = {
  DOCUMENT: DOCUMENT,
  STYLES: STYLES,
  FONTSTYLES: FONTSTYLES,
  PARAGRAPH: PARAGRAPH,
  INSERT: INSERT,
  TOOLS: TOOLS
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _typeof$2(obj) {
  "@babel/helpers - typeof";

  return _typeof$2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof$2(obj);
}

function _toPrimitive(input, hint) {
  if (_typeof$2(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof$2(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof$2(key) === "symbol" ? key : String(key);
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _defineProperty$1(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

var EVENT_NAME_CLICK = 'click';
var EVENT_NAME_OPEN = 'open';
var EVENT_NAME_CLOSE = 'close';
var EVENT_NAME_CLOSE_CANCEL = 'closeCancel';
var EVENT_NAME_CLOSE_OK = 'closeOk';
var EVENT_NAME_CHANGE = 'change';
var EVENT_NAME_GLOBAL_SHOW_DIALOG = 'aq::show::dialog';
var EVENT_NAME_GLOBAL_HIDE_DIALOG = 'aq::hide::dialog';
var EVENT_NAME_GLOBAL_SHOW_DRAWER = 'aq::show::drawer';
var EVENT_NAME_GLOBAL_HIDE_DRAWER = 'aq::hide::drawer';
var EVENT_NAME_GLOBAL_SHOW_COLLAPSE = 'aq::show::collapse';
var EVENT_NAME_GLOBAL_HIDE_COLLAPSE = 'aq::hide::collapse';
var EVENT_NAME_GLOBAL_TOGGLE_COLLAPSE = 'aq::toggle::collapse';

var EVENTS = /*#__PURE__*/Object.freeze({
	__proto__: null,
	EVENT_NAME_CLICK: EVENT_NAME_CLICK,
	EVENT_NAME_OPEN: EVENT_NAME_OPEN,
	EVENT_NAME_CLOSE: EVENT_NAME_CLOSE,
	EVENT_NAME_CLOSE_CANCEL: EVENT_NAME_CLOSE_CANCEL,
	EVENT_NAME_CLOSE_OK: EVENT_NAME_CLOSE_OK,
	EVENT_NAME_CHANGE: EVENT_NAME_CHANGE,
	EVENT_NAME_GLOBAL_SHOW_DIALOG: EVENT_NAME_GLOBAL_SHOW_DIALOG,
	EVENT_NAME_GLOBAL_HIDE_DIALOG: EVENT_NAME_GLOBAL_HIDE_DIALOG,
	EVENT_NAME_GLOBAL_SHOW_DRAWER: EVENT_NAME_GLOBAL_SHOW_DRAWER,
	EVENT_NAME_GLOBAL_HIDE_DRAWER: EVENT_NAME_GLOBAL_HIDE_DRAWER,
	EVENT_NAME_GLOBAL_SHOW_COLLAPSE: EVENT_NAME_GLOBAL_SHOW_COLLAPSE,
	EVENT_NAME_GLOBAL_HIDE_COLLAPSE: EVENT_NAME_GLOBAL_HIDE_COLLAPSE,
	EVENT_NAME_GLOBAL_TOGGLE_COLLAPSE: EVENT_NAME_GLOBAL_TOGGLE_COLLAPSE
});

var AqDialog$1 = /*#__PURE__*/function () {
  function AqDialog(vm) {
    _classCallCheck(this, AqDialog);
    _defineProperty$1(this, "pRoot", void 0);
    Object.assign(this, {
      pVm: vm,
      pRoot: vm.$root
    });
    Object.defineProperties(this, {
      pVm: {
        enumerable: true,
        configurable: false,
        writable: false
      },
      pRoot: {
        enumerable: true,
        configurable: false,
        writable: false
      }
    });
  }
  _createClass(AqDialog, [{
    key: "show",
    value: function show(id) {
      if (id && this.pRoot) {
        this.pRoot.$emit(EVENT_NAME_GLOBAL_SHOW_DIALOG, {
          value: id
        });
      }
    }
  }, {
    key: "hide",
    value: function hide(id) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (id && this.pRoot) {
        this.pRoot.$emit(EVENT_NAME_GLOBAL_HIDE_DIALOG, {
          value: id,
          type: type
        });
      }
    }
  }]);
  return AqDialog;
}();

var AqDrawer$1 = /*#__PURE__*/function () {
  function AqDrawer(vm) {
    _classCallCheck(this, AqDrawer);
    _defineProperty$1(this, "pRoot", void 0);
    Object.assign(this, {
      pVm: vm,
      pRoot: vm.$root
    });
    Object.defineProperties(this, {
      pVm: {
        enumerable: true,
        configurable: false,
        writable: false
      },
      pRoot: {
        enumerable: true,
        configurable: false,
        writable: false
      }
    });
  }
  _createClass(AqDrawer, [{
    key: "show",
    value: function show(id) {
      if (id && this.pRoot) {
        this.pRoot.$emit(EVENT_NAME_GLOBAL_SHOW_DRAWER, {
          value: id
        });
      }
    }
  }, {
    key: "hide",
    value: function hide(id) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      if (id && this.pRoot) {
        this.pRoot.$emit(EVENT_NAME_GLOBAL_SHOW_DRAWER, {
          value: id,
          type: type
        });
      }
    }
  }]);
  return AqDrawer;
}();

var PROTOTYPE_DIALOG_NAME = '$aqDialog';
var PROTOTYPE_DIALOG_NAME_PRIV = '_aq__modal';
var PROTOTYPE_DRAWER_NAME = '$aqDrawer';
var PROTOTYPE_DRAWER_NAME_PRIV = '_aq__drawer';
var PROTOTYPE_TRANSLATE_NAME = '$aqT';

var useMixins = function useMixins() {
  Vue.mixin({
    beforeCreate: function beforeCreate() {
      this[PROTOTYPE_DIALOG_NAME_PRIV] = new AqDialog$1(this);
      this[PROTOTYPE_DRAWER_NAME_PRIV] = new AqDrawer$1(this);
    }
  });
};

function getTranslation(text) {
  var _global$i18n, _global$i18n2, _global$i18n3;
  var tText = typeof text === 'function' ? text() : text;
  var isObject = _typeof$2((_global$i18n = global.i18n) === null || _global$i18n === void 0 ? void 0 : _global$i18n.t(tText)) === 'object';
  if (isObject) {
    return text;
  }
  if (tText && tText !== '' && (_global$i18n2 = global.i18n) !== null && _global$i18n2 !== void 0 && _global$i18n2.t && _typeof$2((_global$i18n3 = global.i18n) === null || _global$i18n3 === void 0 ? void 0 : _global$i18n3.t(tText)) !== 'object') {
    var _global$i18n4;
    return (_global$i18n4 = global.i18n) === null || _global$i18n4 === void 0 ? void 0 : _global$i18n4.t(tText);
  }
  if (this !== null && this !== void 0 && this.$t && typeof this.$t !== 'undefined') {
    return this.$t(tText);
  }
  return text;
}

var hasOwnProperty$1 = function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
};
var defineProperty = function defineProperty(obj, prop, descriptor) {
  return Object.defineProperty(obj, prop, descriptor);
};
var usePrototypes = function usePrototypes() {
  if (!hasOwnProperty$1(Vue.prototype, PROTOTYPE_DIALOG_NAME)) {
    defineProperty(Vue.prototype, PROTOTYPE_DIALOG_NAME, {
      get: function get() {
        return this[PROTOTYPE_DIALOG_NAME_PRIV];
      }
    });
  }
  if (!hasOwnProperty$1(Vue.prototype, PROTOTYPE_DRAWER_NAME)) {
    defineProperty(Vue.prototype, PROTOTYPE_DRAWER_NAME, {
      get: function get() {
        return this[PROTOTYPE_DRAWER_NAME_PRIV];
      }
    });
  }
  Vue.prototype[PROTOTYPE_TRANSLATE_NAME] = getTranslation;
};

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$1(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (process.env.NODE_ENV !== "production") {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
    }

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle$1(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (process.env.NODE_ENV !== "production") {
    var transitionProperty = getComputedStyle$1(state.elements.popper).transitionProperty || '';

    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
    }
  }

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;

    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
    }
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip$1(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$2 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip$1,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce$2(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
    .filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).forEach(function (key) {
      switch (key) {
        case 'name':
          if (typeof modifier.name !== 'string') {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
          }

          break;

        case 'enabled':
          if (typeof modifier.enabled !== 'boolean') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
          }

          break;

        case 'phase':
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
          }

          break;

        case 'fn':
          if (typeof modifier.fn !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'effect':
          if (modifier.effect != null && typeof modifier.effect !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'requires':
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
          }

          break;

        case 'requiresIfExists':
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
          }

          break;

        case 'options':
        case 'data':
          break;

        default:
          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
            return "\"" + s + "\"";
          }).join(', ') + "; but \"" + key + "\" was provided.");
      }

      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (process.env.NODE_ENV !== "production") {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);

          if (getBasePlacement(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === 'flip';
            });

            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
            }
          }

          var _getComputedStyle = getComputedStyle$1(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
          // cause bugs with positioning, so we'll warn the consumer


          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
          }
        }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (process.env.NODE_ENV !== "production") {
            console.error(INVALID_ELEMENT_ERROR);
          }

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (process.env.NODE_ENV !== "production") {
            __debug_loops__ += 1;

            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce$2(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(INVALID_ELEMENT_ERROR);
      }

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$2, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

var CONFIG_AQUA_POPOVER_TEST_MODE = 'aquaPopoverTestMode';

var DOM_AQUA_POPOVERS = 'aqua-popovers';
var DOM_AQUA_POPOVERS_RIGHT_BOTTOM = 'aqua-popovers-right-bottom';

var createAquaPopoversContainer = function createAquaPopoversContainer() {
  var container = document.getElementById(DOM_AQUA_POPOVERS);
  if (!container) {
    var element = document.createElement('div');
    var body = document.getElementsByTagName('body')[0];
    element.id = DOM_AQUA_POPOVERS;
    body.appendChild(element);
  }
};
var createFixedContainer = function createFixedContainer() {
  createAquaPopoversContainer();
  var container = document.getElementById(DOM_AQUA_POPOVERS_RIGHT_BOTTOM);
  if (!container) {
    var element = document.createElement('div');
    element.classList.add('aq-scroll-bar');
    var parent = document.getElementById(DOM_AQUA_POPOVERS);
    element.id = DOM_AQUA_POPOVERS_RIGHT_BOTTOM;
    parent.appendChild(element);
  }
};
var existsChildren = function existsChildren(_ref) {
  var _parent$children;
  var parent = _ref.parent,
    children = _ref.children;
  var exists = false;
  if (parent && children && ((_parent$children = parent.children) === null || _parent$children === void 0 ? void 0 : _parent$children.length) > 0) {
    for (var index = 0; index < ((_parent$children2 = parent.children) === null || _parent$children2 === void 0 ? void 0 : _parent$children2.length) && !exists; index += 1) {
      var _parent$children2;
      exists = parent.children[index].isSameNode(children);
    }
  }
  return exists;
};
var appendEl = function appendEl(_ref2) {
  var _document;
  var parent = _ref2.parent,
    children = _ref2.children;
  createAquaPopoversContainer();
  var finalParent = (_document = document) === null || _document === void 0 ? void 0 : _document.getElementById(DOM_AQUA_POPOVERS);
  if (parent) {
    finalParent = parent;
  }
  if (finalParent && !existsChildren({
    parent: finalParent,
    children: children
  })) {
    finalParent.append(children);
  }
};
var removeEl = function removeEl(_ref3) {
  var children = _ref3.children;
  if (children && children.parentNode && existsChildren({
    parent: children.parentNode,
    children: children
  })) {
    children.parentNode.removeChild(children);
  }
};

var aqZIndex = {};
var numberZIndex = 1;
var getZIndex = function getZIndex(idComponent) {
  var zIndexBase = 13000;
  if (!(idComponent in aqZIndex)) {
    var lastElement = {
      zIndex: zIndexBase - 30,
      index: 0
    };
    Object.keys(aqZIndex).forEach(function (key) {
      if (aqZIndex[key].index > lastElement.index) {
        lastElement = aqZIndex[key];
      }
    });
    aqZIndex[idComponent] = {
      zIndex: lastElement.zIndex + 30,
      index: numberZIndex
    };
    numberZIndex += 1;
  }
  return aqZIndex[idComponent].zIndex;
};
var deleteZIndex = function deleteZIndex(idComponent) {
  delete aqZIndex[idComponent];
};

var aqId = 0;
var randomId = function randomId() {
  return Math.random().toString(36).slice(2);
};
var AquaRamdomId = function AquaRamdomId() {
  var elName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  aqId += 1;
  return "aq-unique".concat(elName, "-id-").concat(randomId()).concat(aqId);
};

var idMixin = {
  data: function data() {
    return {
      uid: ''
    };
  },
  watch: {
    id: function id() {
      this.validateUid();
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    }
  },
  methods: {
    validateUid: function validateUid() {
      var _this$id;
      var uid = ((_this$id = this.id) === null || _this$id === void 0 ? void 0 : _this$id.length) > 0 ? this.id : this.uid;
      this.uid = (uid === null || uid === void 0 ? void 0 : uid.length) > 0 ? uid : AquaRamdomId('-mix-elem');
    }
  },
  created: function created() {
    this.validateUid();
  }
};

var zIndexMixin = {
  mixins: [idMixin],
  data: function data() {
    return {
      baseZIndex: 0,
      visible: false
    };
  },
  watch: {
    visible: function visible(newVal) {
      var _this = this;
      if (!this.disabledZIndex) {
        if (newVal) {
          setTimeout(function () {
            _this.setZIndex();
          }, 10);
        } else {
          this.deleteZIndex();
        }
      }
    }
  },
  methods: {
    setZIndex: function setZIndex() {
      this.baseZIndex = getZIndex(this.uid);
    },
    deleteZIndex: function deleteZIndex$1() {
      deleteZIndex(this.uid);
    }
  }
  /* created() {
    this.setZIndex();
  },
  beforeDestroy() {
    this.deleteZIndex();
  }, */
};

var sizeMixin = {
  props: {
    maxHeight: {
      type: [Number, String],
      default: undefined
    },
    minHeight: {
      type: [Number, String],
      default: undefined
    },
    maxWidth: {
      type: [Number, String],
      default: undefined
    },
    minWidth: {
      type: [Number, String],
      default: undefined
    },
    height: {
      type: [Number, String],
      default: undefined
    },
    width: {
      type: [Number, String],
      default: undefined
    }
  },
  computed: {
    mixinSizeStyle: function mixinSizeStyle() {
      return {
        maxHeight: this.mixinSizeGetValue(this.maxHeight),
        minHeight: this.mixinSizeGetValue(this.minHeight),
        maxWidth: this.mixinSizeGetValue(this.maxWidth),
        minWidth: this.mixinSizeGetValue(this.minWidth),
        height: this.mixinSizeGetValue(this.height),
        width: this.mixinSizeGetValue(this.width)
      };
    }
  },
  methods: {
    mixinSizeGetValue: function mixinSizeGetValue(value) {
      return typeof value === 'string' || typeof value === 'undefined' ? value : "".concat(value, "px");
    }
  }
};

function ownKeys$h(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$i(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$h(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$h(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var script$1Q = {
  name: 'AqTooltip',
  data: function data() {
    return {
      hover: false,
      poperInstance: null,
      timeoutId: -1
    };
  },
  mixins: [zIndexMixin, sizeMixin],
  props: {
    value: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    showTooltip: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    directive: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    parent: {
      type: HTMLElement,
      default: function _default() {
        return null;
      }
    },
    content: {
      type: [String, Function, Object],
      default: function _default() {
        return '';
      }
    },
    position: {
      type: String,
      default: function _default() {
        return 'top';
      },
      validator: function validator(value) {
        return ['top', 'left', 'right', 'bottom'].indexOf(value) !== -1;
      }
    }
  },
  watch: {
    isShow: function isShow(newVal) {
      if (newVal) {
        this.setZIndex();
      } else {
        this.deleteZIndex();
      }
    }
  },
  computed: {
    hasDefaultSlot: function hasDefaultSlot() {
      return !!this.$slots.default;
    },
    getPosition: function getPosition() {
      return "aq-tooltip__text--".concat(this.position);
    },
    getIsParent: function getIsParent() {
      return this.parent !== null;
    },
    isShow: function isShow() {
      return this.value && (this.hasDefaultSlot || this.directive) && this.showTooltip && this.hover;
    },
    zIndexTooltip: function zIndexTooltip() {
      return _objectSpread$i(_objectSpread$i({
        zIndex: this.baseZIndex
      }, this.mixinSizeStyle), {}, {
        maxWidth: this.getMixinSizeStyle
      });
    },
    getMixinSizeStyle: function getMixinSizeStyle() {
      var localWidth = !this.mixinSizeStyle.width ? this.content.width : this.mixinSizeStyle.width;
      var viewPortWidth = global.window.innerWidth / 3;
      return localWidth || "".concat(viewPortWidth, "px");
    },
    getContent: function getContent() {
      var _this$content;
      return (_this$content = this.content) !== null && _this$content !== void 0 && _this$content.text ? this.content.text : this.content;
    },
    getIsContent: function getIsContent() {
      var _this$$aqT;
      return ((_this$$aqT = this.$aqT(this.getContent)) === null || _this$$aqT === void 0 ? void 0 : _this$$aqT.length) > 0;
    }
  },
  methods: {
    show: function show() {
      clearTimeout(this.timeoutId);
      this.hover = true;
      this.addPopoverInstance();
      this.poperInstance.update();
      this.addScrollEvent();
    },
    showDirective: function showDirective() {
      this.show();
      this.setZIndex();
    },
    hide: function hide() {
      var _this = this;
      this.hover = false;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(function () {
        _this.destroyPoperInstance();
        _this.removeScrollEvent();
      }, 400);
    },
    hideDirective: function hideDirective() {
      this.hide();
      this.deleteZIndex();
    },
    addScrollEvent: function addScrollEvent() {
      if (!this.getIsParent) {
        document.addEventListener('scroll', this.hide);
      }
    },
    removeScrollEvent: function removeScrollEvent() {
      if (!this.getIsParent) {
        document.removeEventListener('scroll', this.hide);
      }
    },
    destroyPoperInstance: function destroyPoperInstance() {
      if (this.poperInstance !== null) {
        this.poperInstance.destroy();
      }
      this.poperInstance = null;
    },
    addPopoverInstance: function addPopoverInstance() {
      if (this.poperInstance === null) {
        var arrow = this.$refs.arrow;
        var parent = this.parent || this.$refs.contentTooltip;
        if (parent && this.$refs.text_tooltip && arrow && !global[CONFIG_AQUA_POPOVER_TEST_MODE]) {
          this.poperInstance = createPopper(parent, this.$refs.text_tooltip, {
            placement: this.position,
            modifiers: [{
              name: 'arrow',
              options: {
                element: arrow,
                padding: 5
              }
            }, {
              name: 'offset',
              options: {
                offset: [1, 7]
              }
            }]
          });
        }
      }
    }
  },
  mounted: function mounted() {
    appendEl({
      children: this.$refs.text_tooltip
    });
  },
  beforeDestroy: function beforeDestroy() {
    removeEl({
      children: this.$refs.text_tooltip
    });
  }
};

function normalizeComponent$1(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
var __vue_script__$1Q = script$1Q;

/* template */
var __vue_render__$1Q = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-tooltip mui-tooltip",
    attrs: {
      "id": _vm.uid
    }
  }, [_c('div', {
    ref: "contentTooltip",
    staticStyle: {
      "height": "100%"
    },
    on: {
      "mouseover": function mouseover($event) {
        return _vm.show();
      },
      "mouseleave": function mouseleave($event) {
        return _vm.hide();
      }
    }
  }, [_vm._t("content")], 2), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-transtion-4"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isShow,
      expression: "isShow"
    }],
    ref: "text_tooltip",
    class: ['aq-tooltip__text', _vm.getPosition],
    style: _vm.zIndexTooltip,
    attrs: {
      "id": _vm.uid ? _vm.uid + '-content' : ''
    }
  }, [_vm.getIsContent ? [_vm._v("\n        " + _vm._s(_vm.$aqT(_vm.getContent)) + "\n      ")] : [_vm._t("default")], _vm._v(" "), _c('div', {
    ref: "arrow",
    staticClass: "aq-tooltip__arrow"
  })], 2)])], 1);
};
var __vue_staticRenderFns__$1Q = [];

/* style */
var __vue_inject_styles__$1Q = undefined;
/* scoped */
var __vue_scope_id__$1Q = undefined;
/* module identifier */
var __vue_module_identifier__$1Q = undefined;
/* functional template */
var __vue_is_functional_template__$1Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1Q = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1Q,
  staticRenderFns: __vue_staticRenderFns__$1Q
}, __vue_inject_styles__$1Q, __vue_script__$1Q, __vue_scope_id__$1Q, __vue_is_functional_template__$1Q, __vue_module_identifier__$1Q, false, undefined, undefined, undefined);
var AqTooltip = __vue_component__$1Q;

function ownKeys$g(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$h(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$g(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$g(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var aquaTooltips = [];
var createTooltip = function createTooltip(parent, content) {
  var _localContent$width$m;
  var modifiers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var localContent = {};
  var localWidth = null;
  var viewPortWidth = global.window.innerWidth / 3;
  if (_typeof$2(content) === 'object') {
    var _content;
    localContent = (_content = content) !== null && _content !== void 0 && _content.width ? _objectSpread$h({}, content) : {
      text: content.text,
      width: '0px'
    };
  } else localContent = {
    text: content,
    width: '0px'
  };
  localWidth = (_localContent$width$m = localContent.width.match(/\d/g)) === null || _localContent$width$m === void 0 ? void 0 : _localContent$width$m.join('');
  localContent.width = localWidth > 0 && localWidth <= viewPortWidth ? localContent.width : "".concat(viewPortWidth, "px");

  // eslint-disable-next-line no-param-reassign
  content = localContent;
  if (parent && !parent.getAttribute('aq-tooltip-id') && content !== '') {
    createAquaPopoversContainer();
    var placements = ['top', 'left', 'right', 'bottom'];
    var position = function position() {
      var placement = 'top';
      for (var i = 0; i < (placements === null || placements === void 0 ? void 0 : placements.length); i += 1) {
        var pos = placements[i];
        if (modifiers[pos]) {
          placement = pos;
        }
      }
      return placement;
    };
    var aquaPopovers = document.getElementById(DOM_AQUA_POPOVERS);
    var uid = AquaRamdomId('-tooltip');
    var Tooltip = Vue.extend(AqTooltip);
    var instance = new Tooltip({
      propsData: {
        content: content,
        position: position(),
        parent: parent,
        id: uid,
        directive: true
      }
    });
    instance.$slots.default = [''];
    aquaTooltips.push(instance);
    instance.$mount();
    parent.addEventListener('mouseover', instance.showDirective);
    parent.addEventListener('mouseleave', instance.hideDirective);
    parent.addEventListener('scroll', instance.hideDirective);
    parent.setAttribute('aq-tooltip-id', uid);
    aquaPopovers.appendChild(instance.$refs.text_tooltip);
  }
};
var cleanTooltip = function cleanTooltip(el) {
  var aquaPopovers = document.getElementById(DOM_AQUA_POPOVERS);
  aquaPopovers.childNodes.forEach(function (x) {
    if (String(x.className).includes('aq-tooltip')) {
      var indexRemove = -1;
      aquaTooltips.forEach(function (component, index) {
        if (x.id === el.getAttribute('aq-tooltip-id') && component.$el.id === x.id || x.id.replace('-content', '') === el.getAttribute('aq-tooltip-id') && component.$el.id === x.id.replace('-content', '')) {
          component.$destroy();
          indexRemove = index;
        }
      });
      if (indexRemove !== -1) {
        el.removeAttribute('aq-tooltip-id');
        var instance = aquaTooltips.splice(indexRemove, 1);
        if ((instance === null || instance === void 0 ? void 0 : instance.length) > 0) {
          el.removeEventListener('mouseover', instance[0].showDirective);
          el.removeEventListener('mouseleave', instance[0].hideDirective);
          el.removeEventListener('scroll', instance[0].hideDirective);
        }
        x.remove();
      }
    }
  });
};
var AqTooltipDirective = {
  bind: function bind(el, binding) {
    createTooltip(el, binding.value, binding.modifiers);
  },
  update: function update(el, binding) {
    if (binding.oldValue !== binding.value) {
      cleanTooltip(el);
      createTooltip(el, binding.value, binding.modifiers);
    }
  },
  unbind: function unbind(el) {
    cleanTooltip(el);
  }
};

var updateSpinner = function updateSpinner(parent, content) {
  var directiveContent = _typeof$2(content) === 'object' ? content.value : content;
  if (parent && directiveContent) {
    var backdropLoader = document.createElement('div');
    var divSpinner = document.createElement('div');
    divSpinner.classList.add('aq-spinner');
    divSpinner.innerHTML = "\n    <div class=\"aq-spinner-load-animation\">\n      <div class=\"aq-spinner-load-animation__1\"></div>\n      <div class=\"aq-spinner-load-animation__2\"></div>\n      <div class=\"aq-spinner-load-animation__3\"></div>\n    </div>\n    ";
    divSpinner.style.position = _typeof$2(content) === 'object' && content.isGlobal ? 'fixed' : '';
    backdropLoader.setAttribute('class', 'aq-spinner-backdrop');
    backdropLoader.style.position = _typeof$2(content) === 'object' && content.isGlobal ? 'fixed' : '';
    if (parent.style.position !== 'absolute') {
      // eslint-disable-next-line no-param-reassign
      parent.style.position = 'relative';
    }
    parent.classList.add('aq-spinner-directive');
    parent.appendChild(backdropLoader);
    parent.appendChild(divSpinner);
  } else if (!directiveContent) {
    parent.classList.remove('aq-spinner-directive');
    var childs = parent.childNodes;
    var remove = [];
    childs.forEach(function (x) {
      var _x$className;
      if ((_x$className = x.className) !== null && _x$className !== void 0 && _x$className.includes('aq-spinner')) {
        remove.push(x);
      }
    });
    remove.forEach(function (x) {
      x.remove();
    });
  }
};
var AqSpinnerDirective = {
  bind: function bind(el, binding) {
    updateSpinner(el, binding.value, binding.modifiers);
  },
  update: function update(el, binding) {
    if (binding.oldValue !== binding.value) {
      updateSpinner(el, binding.value, binding.modifiers);
    }
  },
  unbind: function unbind(el) {
    updateSpinner(el, false);
  }
};

var eventOn = function eventOn(el, eventName, handler) {
  if (el && el.addEventListener) {
    el.addEventListener(eventName, handler);
  }
};
var eventOff = function eventOff(el, eventName, handler) {
  if (el && el.addEventListener) {
    el.removeEventListener(eventName, handler);
  }
};
var dispatchEvent$1 = function dispatchEvent(context, componentName, eventName) {
  var parent = context.$parent || context.$root;
  var name = parent.$options.name;
  while (parent && (!name || name !== componentName)) {
    parent = parent.$parent;
    if (parent) {
      name = parent.$options.name;
    }
  }
  if (parent) {
    var _parent;
    for (var _len = arguments.length, rest = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
      rest[_key - 3] = arguments[_key];
    }
    (_parent = parent).$emit.apply(_parent, [eventName].concat(rest));
  }
};
var emitEventDirective = function emitEventDirective(_ref) {
  var _Object$keys;
  var binding = _ref.binding,
    target = _ref.target,
    currentTarget = _ref.currentTarget,
    vnode = _ref.vnode,
    eventShow = _ref.eventShow,
    eventHide = _ref.eventHide,
    eventTarget = _ref.eventTarget,
    toParent = _ref.toParent,
    customEvent = _ref.customEvent;
  var keys = ((_Object$keys = Object.keys(binding.modifiers)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0 ? Object.keys(binding.modifiers)[0] : '';
  if (toParent && keys !== '') {
    dispatchEvent$1(vnode.componentInstance, eventTarget, "_".concat(eventHide), {
      type: keys,
      noId: true
    });
  } else {
    var eventName = customEvent && customEvent !== '' ? customEvent : eventShow;
    vnode.context.$root.$emit(eventName, {
      target: target,
      currentTarget: currentTarget,
      value: binding.value
    });
  }
};

var propertyModal = '__aq_modal_directive__';
var bind$5 = function bind(el, binding, vnode) {
  var target = binding;
  var trigger = el;
  var handler = function handler(event) {
    var currentTarget = event.currentTarget;
    // TODO: validar si el elemento no esta inhabilitado
    var type = event.type;
    var keyCode = event.keyCode;
    if (type === 'click' || type === 'keydown' && (keyCode === 13 || keyCode === 32)) {
      emitEventDirective({
        binding: binding,
        target: target,
        currentTarget: currentTarget,
        vnode: vnode,
        eventShow: EVENT_NAME_GLOBAL_SHOW_DIALOG,
        eventHide: EVENT_NAME_GLOBAL_HIDE_DIALOG,
        eventTarget: 'aq-dialog',
        toParent: true
      });
    }
  };
  trigger[propertyModal] = {
    handler: handler,
    target: target,
    trigger: trigger
  };
  eventOn(trigger, 'click', handler);
};
var unbind$2 = function unbind(el) {
  var oldProp = el[propertyModal] || {};
  var trigger = oldProp.trigger;
  var handler = oldProp.handler;
  var triggerx = el;
  if (trigger && handler) {
    eventOff(trigger, 'click', handler);
    eventOff(el, 'click', handler);
  }
  delete triggerx[propertyModal];
};
var componentUpdated$2 = function componentUpdated(el, binding, vnode) {
  var target = binding;
  var trigger = el;
  var oldProp = el[propertyModal] || {};
  if (target !== oldProp.target || trigger !== oldProp.trigger) {
    unbind$2(el);
    bind$5(el, binding, vnode);
  }
};
var AqDialogDirective = {
  inserted: componentUpdated$2,
  bind: bind$5,
  componentUpdated: componentUpdated$2,
  unbind: unbind$2
};

var propertyDrawer = '__aq_drawer_directive__';
var bind$4 = function bind(el, binding, vnode) {
  var target = binding;
  var trigger = el;
  var handler = function handler(event) {
    var currentTarget = event.currentTarget;
    // TODO: validar si el elemento no esta inhabilitado
    var type = event.type;
    var keyCode = event.keyCode;
    if (type === 'click' || type === 'keydown' && (keyCode === 13 || keyCode === 32)) {
      emitEventDirective({
        binding: binding,
        target: target,
        currentTarget: currentTarget,
        vnode: vnode,
        eventShow: EVENT_NAME_GLOBAL_SHOW_DRAWER,
        eventHide: EVENT_NAME_GLOBAL_HIDE_DRAWER,
        eventTarget: 'aq-drawer',
        toParent: true
      });
    }
  };
  trigger[propertyDrawer] = {
    handler: handler,
    target: target,
    trigger: trigger
  };
  eventOn(trigger, 'click', handler);
};
var unbind$1 = function unbind(el) {
  var oldProp = el[propertyDrawer] || {};
  var trigger = oldProp.trigger;
  var handler = oldProp.handler;
  var triggerx = el;
  if (trigger && handler) {
    eventOff(trigger, 'click', handler);
    eventOff(el, 'click', handler);
  }
  delete triggerx[propertyDrawer];
};
var componentUpdated$1 = function componentUpdated(el, binding, vnode) {
  var target = binding;
  var trigger = el;
  var oldProp = el[propertyDrawer] || {};
  if (target !== oldProp.target || trigger !== oldProp.trigger) {
    unbind$1(el);
    bind$4(el, binding, vnode);
  }
};
var AqDrawerDirective = {
  inserted: componentUpdated$1,
  bind: bind$4,
  componentUpdated: componentUpdated$1,
  unbind: unbind$1
};

var propertyCollapse = '__aq_collapse_directive__';
var bind$3 = function bind(el, binding, vnode) {
  var target = binding;
  var trigger = el;
  var handler = function handler(event) {
    var currentTarget = event.currentTarget;
    // TODO: validar si el elemento no esta inhabilitado
    var type = event.type;
    var keyCode = event.keyCode;
    if (type === 'click' || type === 'keydown' && (keyCode === 13 || keyCode === 32)) {
      var _Object$keys;
      var keys = ((_Object$keys = Object.keys(binding.modifiers)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0 ? Object.keys(binding.modifiers)[0] : '';
      var customEvent = '';
      switch (keys) {
        case 'show':
          customEvent = EVENT_NAME_GLOBAL_SHOW_COLLAPSE;
          break;
        case 'close':
          customEvent = EVENT_NAME_GLOBAL_HIDE_COLLAPSE;
          break;
        case 'toggle':
        default:
          customEvent = EVENT_NAME_GLOBAL_TOGGLE_COLLAPSE;
      }
      emitEventDirective({
        binding: binding,
        target: target,
        currentTarget: currentTarget,
        vnode: vnode,
        eventShow: EVENT_NAME_GLOBAL_SHOW_COLLAPSE,
        eventHide: EVENT_NAME_GLOBAL_HIDE_COLLAPSE,
        eventTarget: 'aq-collapse',
        toParent: false,
        customEvent: customEvent
      });
    }
  };
  trigger[propertyCollapse] = {
    handler: handler,
    target: target,
    trigger: trigger
  };
  eventOn(trigger, 'click', handler);
};
var unbind = function unbind(el) {
  var oldProp = el[propertyCollapse] || {};
  var trigger = oldProp.trigger;
  var handler = oldProp.handler;
  var triggerx = el;
  if (trigger && handler) {
    eventOff(trigger, 'click', handler);
    eventOff(el, 'click', handler);
  }
  delete triggerx[propertyCollapse];
};
var componentUpdated = function componentUpdated(el, binding, vnode) {
  var target = binding;
  var trigger = el;
  var oldProp = el[propertyCollapse] || {};
  if (target !== oldProp.target || trigger !== oldProp.trigger) {
    unbind(el);
    bind$3(el, binding, vnode);
  }
};
var AqCollapseDirective = {
  inserted: componentUpdated,
  bind: bind$3,
  componentUpdated: componentUpdated,
  unbind: unbind
};

var lazyLoad = {
  inserted: function inserted(el, binding) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var value = binding.value;
          value();
          observer.unobserve(el);
        }
      });
    });
    observer.observe(el);
  }
};

var useDirectives = function useDirectives() {
  Vue.directive('aq-tooltip', AqTooltipDirective);
  Vue.directive('aq-spinner', AqSpinnerDirective);
  Vue.directive('aq-dialog', AqDialogDirective);
  Vue.directive('aq-drawer', AqDrawerDirective);
  Vue.directive('aq-collapse', AqCollapseDirective);
  Vue.directive('lazy', lazyLoad);
};

var setOptions = function setOptions(options) {
  if (options && options.popoverTest) {
    global[CONFIG_AQUA_POPOVER_TEST_MODE] = true;
  }
};

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$1P = {
  name: 'aq-button',
  props: {
    icon: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'button',
      validator: function validator(x) {
        return ['', 'button', 'submit', 'reset'].includes(x.toLowerCase());
      }
    },
    size: {
      type: String,
      default: 'medium',
      validator: function validator(x) {
        return ['', 'small', 'medium', 'large'].includes(x.toLowerCase());
      }
    },
    disclosure: {
      type: Boolean,
      default: false
    },
    badge: {
      type: Object,
      default: null
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    plain: {
      type: Boolean,
      default: false
    },
    orientation: {
      type: String,
      default: 'horizontal',
      validator: function validator(x) {
        return ['', 'horizontal', 'vertical'].includes(x);
      }
    }
  },
  data: function data() {
    return {
      isTextVisible: false
    };
  },
  computed: {
    isIconVisible: function isIconVisible() {
      var _this$icon;
      return ((_this$icon = this.icon) === null || _this$icon === void 0 ? void 0 : _this$icon.length) > 0;
    },
    classPadding: function classPadding() {
      var classP = 'aq-button--padding';
      if (this.isIconVisible && this.disclosure && this.isTextVisible) {
        classP = "".concat(classP, "-1");
      } else if (this.isIconVisible && this.isTextVisible) {
        classP = "".concat(classP, "-2");
      } else if (this.isIconVisible && this.disclosure) {
        classP = "".concat(classP, "-3");
      } else if (this.disclosure && this.isTextVisible) {
        classP = "".concat(classP, "-5");
      } else if (this.isIconVisible) {
        classP = "".concat(classP, "-4");
      } else if (this.isTextVisible) {
        classP = "".concat(classP, "-6");
      }
      return classP;
    },
    hasBadge: function hasBadge() {
      var _this$badge;
      return this.badge !== null && this.size !== 'small' && !this.isLoading && !!((_this$badge = this.badge) !== null && _this$badge !== void 0 && _this$badge.number);
    },
    classColor: function classColor() {
      var classC = 'aq-button';
      var colors = ['blue', 'green', 'red'];
      var color = colors.indexOf(this.color);
      var extra = '';
      if (this.outline) {
        extra = '-outline';
      } else if (this.plain) {
        extra = '-plain';
      }
      if (color !== -1) {
        classC = "".concat(classC, "--").concat(colors[color]);
      }
      classC = "".concat(classC).concat(extra);
      return classC;
    },
    classSize: function classSize() {
      var _this$size;
      var size = ((_this$size = this.size) === null || _this$size === void 0 ? void 0 : _this$size.length) > 0 ? this.size.toLowerCase() : 'medium';
      return "aq-button--size-".concat(size);
    }
  },
  methods: {
    getBadgeInfo: function getBadgeInfo(key) {
      var _this$badge2;
      return _typeof$2(this.badge) === 'object' ? (_this$badge2 = this.badge) === null || _this$badge2 === void 0 ? void 0 : _this$badge2[key] : '';
    },
    getIsTextVisible: function getIsTextVisible() {
      if (typeof this.$slots.default !== 'undefined') {
        var _trim;
        this.isTextVisible = ((_trim = (this.$slots.default[0].text || '').trim()) === null || _trim === void 0 ? void 0 : _trim.length) > 0;
      }
    },
    onClick: function onClick(event) {
      if (this.disabled) {
        return;
      }
      this.$emit('click', event);
    },
    onHover: function onHover(event) {
      if (this.disabled) {
        return;
      }
      this.$emit('hover', event);
    }
  },
  mounted: function mounted() {
    this.getIsTextVisible();
  },
  updated: function updated() {
    this.getIsTextVisible();
  }
};

/* script */
var __vue_script__$1P = script$1P;

/* template */
var __vue_render__$1P = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('button', {
    class: ['aq-button button', _vm.classPadding, _vm.classColor, _vm.classSize, {
      'is-loading': _vm.isLoading,
      'is-disabled': _vm.disabled
    }],
    attrs: {
      "type": _vm.type
    },
    on: {
      "click": function click($event) {
        return _vm.onClick($event);
      },
      "mouseover": function mouseover($event) {
        return _vm.onHover($event);
      }
    }
  }, [_vm.isIconVisible ? _c('span', {
    class: ['icon is-small', 'aq-button__icon', {
      'aq-button__icon--margin': _vm.isTextVisible && _vm.orientation === 'horizontal'
    }]
  }, [_c('em', {
    class: _vm.icon
  })]) : _vm._e(), _vm._v(" "), [_vm._t("default"), _vm._v(" "), _vm.hasBadge ? _c('aq-badge', {
    staticClass: "aq-button__badge",
    attrs: {
      "state": _vm.getBadgeInfo('state'),
      "number": _vm.getBadgeInfo('number'),
      "disabled": _vm.disabled
    }
  }) : _vm._e()], _vm._v(" "), _vm.disclosure && !_vm.hasBadge ? _c('em', {
    staticClass: "aq-icon-chevron-down aq-button__icon-disclosure"
  }) : _vm._e()], 2);
};
var __vue_staticRenderFns__$1P = [];

/* style */
var __vue_inject_styles__$1P = undefined;
/* scoped */
var __vue_scope_id__$1P = undefined;
/* module identifier */
var __vue_module_identifier__$1P = undefined;
/* functional template */
var __vue_is_functional_template__$1P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1P = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1P,
  staticRenderFns: __vue_staticRenderFns__$1P
}, __vue_inject_styles__$1P, __vue_script__$1P, __vue_scope_id__$1P, __vue_is_functional_template__$1P, __vue_module_identifier__$1P, false, undefined, undefined, undefined);
var AqButton = __vue_component__$1P;

//
//
//
//
//
//
//
//
//
//
//
//

var script$1O = {
  props: {
    orientation: {
      type: String,
      default: 'vertical',
      validator: function validator(x) {
        return ['vertical', 'horizontal'].includes(x.toLowerCase());
      }
    },
    plain: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
var __vue_script__$1O = script$1O;

/* template */
var __vue_render__$1O = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-button-group', 'aq-button-group--' + _vm.orientation, {
      'aq-button-group--plain': _vm.plain
    }]
  }, [_vm._t("default")], 2);
};
var __vue_staticRenderFns__$1O = [];

/* style */
var __vue_inject_styles__$1O = undefined;
/* scoped */
var __vue_scope_id__$1O = undefined;
/* module identifier */
var __vue_module_identifier__$1O = undefined;
/* functional template */
var __vue_is_functional_template__$1O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1O = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1O,
  staticRenderFns: __vue_staticRenderFns__$1O
}, __vue_inject_styles__$1O, __vue_script__$1O, __vue_scope_id__$1O, __vue_is_functional_template__$1O, __vue_module_identifier__$1O, false, undefined, undefined, undefined);
var AqButtonGroup = __vue_component__$1O;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$1N = {
  name: 'aq-button-split',
  props: {
    icon: {
      type: String,
      default: ''
    },
    iconSplit: {
      type: String,
      default: 'aq-icon-chevron-down'
    },
    text: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'button',
      validator: function validator(x) {
        return ['button', 'submit', 'reset'].includes(x.toLowerCase());
      }
    },
    size: {
      type: String,
      default: 'medium',
      validator: function validator(x) {
        return ['', 'small', 'medium', 'large'].includes(x.toLowerCase());
      }
    },
    items: {
      type: Array,
      default: function _default() {
        return [{}];
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    outline: {
      type: Boolean,
      default: false
    },
    plain: {
      type: Boolean,
      default: false
    },
    badge: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      key: 1
    };
  },
  watch: {
    isLoading: function isLoading() {
      this.key += 1;
    }
  },
  computed: {
    isColor: function isColor() {
      var colorDivider = '';
      if (this.disabled || !this.plain && !this.outline && this.color !== '' && this.color !== 'default') {
        colorDivider = 'white';
      } else if (!this.plain && !this.disabled || !this.outline && !this.disabled) {
        colorDivider = this.color;
      } else if (!this.outline && !this.plain && this.color === '') {
        colorDivider = 'default';
      }
      return colorDivider;
    },
    isSize: function isSize() {
      return this.size.toLowerCase();
    }
  },
  methods: {
    onClickLeft: function onClickLeft(event) {
      this.$emit('clickLeft', event);
    },
    onClickRight: function onClickRight(event) {
      this.$emit('clickRight', event);
    },
    selectItem: function selectItem(event) {
      this.$emit('selectItem', event);
    }
  }
};

/* script */
var __vue_script__$1N = script$1N;

/* template */
var __vue_render__$1N = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    key: _vm.key,
    class: ['aq-button-split']
  }, [_c('div', {
    class: ['button-split', {
      'is-loading': _vm.isLoading
    }]
  }, [_c('aq-button', {
    class: ['aq-button-split__left_button', {
      'button-split-button': _vm.isLoading
    }],
    attrs: {
      "color": _vm.color,
      "size": _vm.size,
      "icon": _vm.icon,
      "disabled": _vm.disabled,
      "outline": _vm.outline,
      "plain": _vm.plain,
      "type": _vm.type,
      "badge": _vm.badge
    },
    on: {
      "click": function click($event) {
        return _vm.onClickLeft($event);
      }
    }
  }, [_vm._v(_vm._s(_vm.text) + "\n      "), _c('div', {
    class: {
      'button-split-divider': _vm.isLoading
    }
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('aq-divider', {
    class: ['aq-button-split__divider', 'aq-button-split__divider--' + _vm.isColor, 'aq-button-split__divider--' + _vm.isSize, {
      'button-split-divider': _vm.isLoading
    }],
    attrs: {
      "orientation": "vertical"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "aq-button-split__right"
  }, [_c('aq-dropdown', {
    attrs: {
      "closeOnClick": "",
      "disabled": _vm.disabled
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_c('aq-dropdown-content', _vm._l(_vm.items, function (item, index) {
          return _c('aq-dropdown-item', {
            key: index,
            on: {
              "click": function click($event) {
                return _vm.selectItem(item.id);
              }
            }
          }, [_vm._v("\n              " + _vm._s(_vm.$aqT(item.name)) + "\n            ")]);
        }), 1)];
      },
      proxy: true
    }])
  }, [_c('aq-button', {
    class: ['aq-button-split__right_button', {
      'button-split-button': _vm.isLoading
    }],
    attrs: {
      "color": _vm.color,
      "size": _vm.size,
      "icon": _vm.iconSplit,
      "disabled": _vm.disabled,
      "outline": _vm.outline,
      "plain": _vm.plain,
      "type": _vm.type
    },
    on: {
      "click": function click($event) {
        return _vm.onClickRight($event);
      }
    }
  })], 1)], 1)], 1)]);
};
var __vue_staticRenderFns__$1N = [];

/* style */
var __vue_inject_styles__$1N = undefined;
/* scoped */
var __vue_scope_id__$1N = undefined;
/* module identifier */
var __vue_module_identifier__$1N = undefined;
/* functional template */
var __vue_is_functional_template__$1N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1N = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1N,
  staticRenderFns: __vue_staticRenderFns__$1N
}, __vue_inject_styles__$1N, __vue_script__$1N, __vue_scope_id__$1N, __vue_is_functional_template__$1N, __vue_module_identifier__$1N, false, undefined, undefined, undefined);
var AqButtonSplit = __vue_component__$1N;

//
//
//
//
//
//

var script$1M = {
  methods: {
    clicked: function clicked() {
      this.$emit('click');
    }
  }
};

/* script */
var __vue_script__$1M = script$1M;

/* template */
var __vue_render__$1M = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "mui-menu-item",
    on: {
      "click": _vm.clicked
    }
  }, [_vm._t("default")], 2);
};
var __vue_staticRenderFns__$1M = [];

/* style */
var __vue_inject_styles__$1M = undefined;
/* scoped */
var __vue_scope_id__$1M = undefined;
/* module identifier */
var __vue_module_identifier__$1M = undefined;
/* functional template */
var __vue_is_functional_template__$1M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1M = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1M,
  staticRenderFns: __vue_staticRenderFns__$1M
}, __vue_inject_styles__$1M, __vue_script__$1M, __vue_scope_id__$1M, __vue_is_functional_template__$1M, __vue_module_identifier__$1M, false, undefined, undefined, undefined);
var AqMenuItem = __vue_component__$1M;

//
//
//
//
//
//

var script$1L = {};

/* script */
var __vue_script__$1L = script$1L;

/* template */
var __vue_render__$1L = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_vm._t("default")], 2);
};
var __vue_staticRenderFns__$1L = [];

/* style */
var __vue_inject_styles__$1L = undefined;
/* scoped */
var __vue_scope_id__$1L = undefined;
/* module identifier */
var __vue_module_identifier__$1L = undefined;
/* functional template */
var __vue_is_functional_template__$1L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1L = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1L,
  staticRenderFns: __vue_staticRenderFns__$1L
}, __vue_inject_styles__$1L, __vue_script__$1L, __vue_scope_id__$1L, __vue_is_functional_template__$1L, __vue_module_identifier__$1L, false, undefined, undefined, undefined);
var AqMenuContent = __vue_component__$1L;

//
var script$1K = {
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    label: {
      type: [String, Function],
      default: ''
    },
    idParent: {
      type: String,
      default: ''
    },
    closeOnClick: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isVisible: false
    };
  },
  methods: {
    show: function show() {
      var _this = this;
      this.calculatePosition();
      document.addEventListener('click', this.documentOutside);
      document.addEventListener('scroll', this.calculatePosition);
      this.addClassActive();
      setTimeout(function () {
        _this.isVisible = true;
        _this.setVisible(true);
        _this.calculatePosition();
      });
    },
    hide: function hide() {
      this.isVisible = false;
      this.setVisible(false);
      document.removeEventListener('click', this.documentOutside);
      document.removeEventListener('scroll', this.calculatePosition);
      this.removeClassActive();
    },
    documentOutside: function documentOutside(evt) {
      if (this.isVisible) {
        var refMenu = this.$refs.menu;
        var refPopover = this.$refs.menu_container;
        if ((refMenu.contains(evt.target) || refPopover.contains(evt.target)) && this.closeOnClick || !refMenu.contains(evt.target) && !refPopover.contains(evt.target)) {
          this.hide();
        }
      }
    },
    calculatePosition: function calculatePosition() {
      if (this.isVisible) {
        var container = this.$refs.menu_container;
        var parent = this.$refs.menu_parent;
        var rect = parent.getBoundingClientRect();
        if (typeof container !== 'undefined') {
          var getSizes = function getSizes(el) {
            var elStyle = window.getComputedStyle(el);
            var elDisplay = elStyle.display;
            var elPosition = elStyle.position;
            var elVisibility = elStyle.visibility;
            var elMaxHeight = elStyle.maxHeight.replace('px', '').replace('%', '');
            var wantedHeight = 0;
            var wantedWidth = 0;
            if (elDisplay !== 'none' && elMaxHeight !== '0') {
              return {
                height: el.offsetHeight,
                width: el.offsetWidth
              };
            }
            var elTemp = el;
            elTemp.style.display = 'flex';
            wantedHeight = elTemp.offsetHeight;
            wantedWidth = elTemp.offsetWidth;
            elTemp.style.display = 'block';
            elTemp.style.position = elPosition;
            elTemp.style.visibility = elVisibility;
            return {
              height: wantedHeight,
              width: wantedWidth
            };
          };
          var width = window.innerWidth;
          var height = window.innerHeight;
          var widthParent = parseInt(getComputedStyle(parent).width, 10);
          var heightParent = parseInt(getComputedStyle(parent).height, 10);
          var availableSpace = {
            width: width + widthParent - parseInt(rect.right, 10),
            height: height - (parseInt(rect.top, 10) + heightParent)
          };
          if (availableSpace.height < getSizes(container).height) {
            container.style.top = null;
            container.style.bottom = "".concat(availableSpace.height + heightParent, "px");
          } else {
            container.style.bottom = null;
            container.style.top = "".concat(parseInt(rect.top, 10) + heightParent, "px ");
          }
          if (getSizes(container).width + 24 <= availableSpace.width) {
            container.style.right = null;
            container.style.left = "".concat(rect.left, "px");
          } else {
            container.style.left = null;
            var right = availableSpace.width - widthParent - 20;
            if (right <= 0) {
              right = 4;
            }
            container.style.right = "".concat(right, "px");
          }
        }
      }
    },
    setVisible: function setVisible(isVisible) {
      var container = this.$refs.menu_container;
      container.style.display = isVisible ? 'block' : 'none';
    },
    toogleShow: function toogleShow() {
      if (this.isVisible) {
        this.hide();
      } else {
        this.show();
      }
    },
    addListenerParent: function addListenerParent() {
      var parent = document.getElementById(this.idParent);
      if (parent !== null) {
        parent.addEventListener('scroll', this.calculatePosition);
      }
    },
    removeListenerParent: function removeListenerParent() {
      var parent = document.getElementById(this.idParent);
      if (parent !== null) {
        parent.removeEventListener('scroll', this.calculatePosition);
      }
    },
    addClassActive: function addClassActive() {
      var parent = document.getElementById(this.idParent);
      if (parent !== null) {
        parent.classList.add('mui-menu--active');
      }
    },
    removeClassActive: function removeClassActive() {
      var parent = document.getElementById(this.idParent);
      if (parent !== null) {
        parent.classList.remove('mui-menu--active');
      }
    }
  },
  mounted: function mounted() {
    this.addListenerParent();
    appendEl({
      children: this.$refs.menu_container
    });
    this.$root.$on('aq::popovers::close', this.hide);
  },
  beforeDestroy: function beforeDestroy() {
    this.removeListenerParent();
    this.hide();
    removeEl({
      children: this.$refs.menu_container
    });
    this.$root.$off('aq::popovers::close', this.hide);
  }
};

/* script */
var __vue_script__$1K = script$1K;

/* template */
var __vue_render__$1K = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "menu",
    staticClass: "mui-menu"
  }, [_c('div', {
    ref: "menu_parent",
    staticClass: "mui-menu__activator"
  }, [_vm.label.length > 0 ? [_c('button', {
    staticClass: "mui-button mui-button--default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.toogleShow();
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.label) + "\n      ")])] : [_c('div', {
    staticClass: "mui-menu__activator",
    on: {
      "click": function click($event) {
        return _vm.toogleShow();
      }
    }
  }, [_vm._t("activator", null, {
    "isActive": _vm.isVisible
  })], 2)]], 2), _vm._v(" "), _c('div', {
    ref: "menu_container",
    class: ['mui-menu__container', {
      'mui-menu__container--show': _vm.isVisible,
      'mui-menu__container--hide': !_vm.isVisible
    }]
  }, [_vm.items.length > 0 ? _c('div', _vm._l(_vm.items, function (item, i) {
    var _obj, _obj$1;
    return _c('a', {
      key: i,
      class: ['mui-menu-item', (_obj = {}, _obj[item.class] = item.class && item.class.length > 0, _obj)],
      attrs: {
        "href": item.url,
        "rel": "noopener"
      }
    }, [item.icon && item.icon.length > 0 ? _c('em', {
      class: [item.icon, (_obj$1 = {}, _obj$1[item.classIcon] = item.classIcon && item.classIcon.length > 0, _obj$1)]
    }) : _vm._e(), _vm._v("\n        " + _vm._s(item.label) + "\n      ")]);
  }), 0) : _c('div', [_vm._t("content")], 2)])]);
};
var __vue_staticRenderFns__$1K = [];

/* style */
var __vue_inject_styles__$1K = undefined;
/* scoped */
var __vue_scope_id__$1K = undefined;
/* module identifier */
var __vue_module_identifier__$1K = undefined;
/* functional template */
var __vue_is_functional_template__$1K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1K = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1K,
  staticRenderFns: __vue_staticRenderFns__$1K
}, __vue_inject_styles__$1K, __vue_script__$1K, __vue_scope_id__$1K, __vue_is_functional_template__$1K, __vue_module_identifier__$1K, false, undefined, undefined, undefined);
var AqMenu = __vue_component__$1K;

//
//
//
//
//
//

var script$1J = {
  methods: {
    clicked: function clicked() {
      this.$emit('click');
    }
  }
};

/* script */
var __vue_script__$1J = script$1J;

/* template */
var __vue_render__$1J = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-dropdown-item",
    on: {
      "click": _vm.clicked
    }
  }, [_vm._t("default")], 2);
};
var __vue_staticRenderFns__$1J = [];

/* style */
var __vue_inject_styles__$1J = undefined;
/* scoped */
var __vue_scope_id__$1J = undefined;
/* module identifier */
var __vue_module_identifier__$1J = undefined;
/* functional template */
var __vue_is_functional_template__$1J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1J = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1J,
  staticRenderFns: __vue_staticRenderFns__$1J
}, __vue_inject_styles__$1J, __vue_script__$1J, __vue_scope_id__$1J, __vue_is_functional_template__$1J, __vue_module_identifier__$1J, false, undefined, undefined, undefined);
var AqDropdownItem = __vue_component__$1J;

//
//
//
//
//
//

var script$1I = {};

/* script */
var __vue_script__$1I = script$1I;

/* template */
var __vue_render__$1I = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_vm._t("default")], 2);
};
var __vue_staticRenderFns__$1I = [];

/* style */
var __vue_inject_styles__$1I = undefined;
/* scoped */
var __vue_scope_id__$1I = undefined;
/* module identifier */
var __vue_module_identifier__$1I = undefined;
/* functional template */
var __vue_is_functional_template__$1I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1I = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1I,
  staticRenderFns: __vue_staticRenderFns__$1I
}, __vue_inject_styles__$1I, __vue_script__$1I, __vue_scope_id__$1I, __vue_is_functional_template__$1I, __vue_module_identifier__$1I, false, undefined, undefined, undefined);
var AqDropdownContent = __vue_component__$1I;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$1H = {
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    label: {
      type: [String, Function],
      default: ''
    },
    idParent: {
      type: [String, Function],
      default: ''
    },
    dataCallback: {
      type: Function,
      default: null
    },
    closeOnClick: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isVisible: false
    };
  },
  methods: {
    addClassActive: function addClassActive() {
      var parent = document.getElementById(this.idParent) || this.$refs.menu;
      if (parent !== null) {
        parent.classList.add('aq-dropdown--active');
      }
    },
    removeClassActive: function removeClassActive() {
      var parent = document.getElementById(this.idParent) || this.$refs.menu;
      if (parent !== null) {
        parent.classList.remove('aq-dropdown--active');
      }
    },
    validateClick: function validateClick(item) {
      if ('callback' in item && typeof item.callback === 'function') {
        item.callback(this.dataCallback);
      } else {
        this.$emit('click', item);
      }
    },
    onVisible: function onVisible(value) {
      this.isVisible = value;
    },
    getItemClassLength: function getItemClassLength(item) {
      var _item$class;
      return (item === null || item === void 0 ? void 0 : (_item$class = item.class) === null || _item$class === void 0 ? void 0 : _item$class.length) > 0;
    },
    getItemIconLength: function getItemIconLength(item) {
      var _item$icon;
      return (item === null || item === void 0 ? void 0 : (_item$icon = item.icon) === null || _item$icon === void 0 ? void 0 : _item$icon.length) > 0;
    },
    getItemClassIconLength: function getItemClassIconLength(item) {
      var _item$classIcon;
      return (item === null || item === void 0 ? void 0 : (_item$classIcon = item.classIcon) === null || _item$classIcon === void 0 ? void 0 : _item$classIcon.length) > 0;
    }
  },
  computed: {
    getLabelLength: function getLabelLength() {
      var _this$label;
      return ((_this$label = this.label) === null || _this$label === void 0 ? void 0 : _this$label.length) > 0;
    },
    getItemsLength: function getItemsLength() {
      var _this$items;
      return ((_this$items = this.items) === null || _this$items === void 0 ? void 0 : _this$items.length) > 0;
    }
  }
};

/* script */
var __vue_script__$1H = script$1H;

/* template */
var __vue_render__$1H = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "menu",
    class: ['aq-dropdown', {
      'aq-dropdown--active': _vm.isVisible
    }]
  }, [_c('aq-list-menu', {
    attrs: {
      "closeOnClick": _vm.closeOnClick,
      "disabled": _vm.disabled
    },
    on: {
      "active": _vm.onVisible
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_vm.getItemsLength ? _c('div', _vm._l(_vm.items, function (item, i) {
          var _obj, _obj$1;
          return _c('div', {
            key: i,
            class: ['aq-dropdown-item', (_obj = {}, _obj[item.class] = item.class && _vm.getItemClassLength(item), _obj)],
            on: {
              "click": function click($event) {
                return _vm.validateClick(item);
              }
            }
          }, [item.icon && _vm.getItemIconLength(item) ? _c('em', {
            class: [item.icon, (_obj$1 = {}, _obj$1[item.classIcon] = item.classIcon && _vm.getItemClassIconLength(item), _obj$1)]
          }) : _vm._e(), _vm._v(" "), _c('span', {
            staticClass: "aq-dropdown-item__text"
          }, [_vm._v(_vm._s(item.text))])]);
        }), 0) : _c('div', [_vm._t("content")], 2)];
      },
      proxy: true
    }])
  }, [_vm.getLabelLength ? [_c('aq-button', [_vm._v("\n        " + _vm._s(_vm.$aqT(_vm.label)) + "\n      ")])] : [_vm._t("default", function () {
    return [_vm._t("activator", null, {
      "isActive": _vm.isVisible
    })];
  }, {
    "isActive": _vm.isVisible
  })]], 2)], 1);
};
var __vue_staticRenderFns__$1H = [];

/* style */
var __vue_inject_styles__$1H = undefined;
/* scoped */
var __vue_scope_id__$1H = undefined;
/* module identifier */
var __vue_module_identifier__$1H = undefined;
/* functional template */
var __vue_is_functional_template__$1H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1H = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1H,
  staticRenderFns: __vue_staticRenderFns__$1H
}, __vue_inject_styles__$1H, __vue_script__$1H, __vue_scope_id__$1H, __vue_is_functional_template__$1H, __vue_module_identifier__$1H, false, undefined, undefined, undefined);
var AqDropdown = __vue_component__$1H;

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithoutHoles$1(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray$1(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _nonIterableSpread$1() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray$1(arr) {
  return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread$1();
}

var dist = {exports: {}};

/*!
 * vue-virtual-scroll-list v2.3.4
 * open source under the MIT license
 * https://github.com/tangbc/vue-virtual-scroll-list#readme
 */

(function (module, exports) {
(function (global, factory) {
  module.exports = factory(Vue) ;
}(commonjsGlobal, (function (Vue) {
  Vue = Vue && Object.prototype.hasOwnProperty.call(Vue, 'default') ? Vue['default'] : Vue;

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(object);
      if (enumerableOnly) symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
      keys.push.apply(keys, symbols);
    }

    return keys;
  }

  function _objectSpread2(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i] != null ? arguments[i] : {};

      if (i % 2) {
        ownKeys(Object(source), true).forEach(function (key) {
          _defineProperty(target, key, source[key]);
        });
      } else if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
      } else {
        ownKeys(Object(source)).forEach(function (key) {
          Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
      }
    }

    return target;
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
  }

  function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
  }

  function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
  }

  function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;

    for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

    return arr2;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  /**
   * virtual list core calculating center
   */
  var DIRECTION_TYPE = {
    FRONT: 'FRONT',
    // scroll up or left
    BEHIND: 'BEHIND' // scroll down or right

  };
  var CALC_TYPE = {
    INIT: 'INIT',
    FIXED: 'FIXED',
    DYNAMIC: 'DYNAMIC'
  };
  var LEADING_BUFFER = 0;

  var Virtual = /*#__PURE__*/function () {
    function Virtual(param, callUpdate) {
      _classCallCheck(this, Virtual);

      this.init(param, callUpdate);
    }

    _createClass(Virtual, [{
      key: "init",
      value: function init(param, callUpdate) {
        // param data
        this.param = param;
        this.callUpdate = callUpdate; // size data

        this.sizes = new Map();
        this.firstRangeTotalSize = 0;
        this.firstRangeAverageSize = 0;
        this.lastCalcIndex = 0;
        this.fixedSizeValue = 0;
        this.calcType = CALC_TYPE.INIT; // scroll data

        this.offset = 0;
        this.direction = ''; // range data

        this.range = Object.create(null);

        if (param) {
          this.checkRange(0, param.keeps - 1);
        } // benchmark test data
        // this.__bsearchCalls = 0
        // this.__getIndexOffsetCalls = 0

      }
    }, {
      key: "destroy",
      value: function destroy() {
        this.init(null, null);
      } // return current render range

    }, {
      key: "getRange",
      value: function getRange() {
        var range = Object.create(null);
        range.start = this.range.start;
        range.end = this.range.end;
        range.padFront = this.range.padFront;
        range.padBehind = this.range.padBehind;
        return range;
      }
    }, {
      key: "isBehind",
      value: function isBehind() {
        return this.direction === DIRECTION_TYPE.BEHIND;
      }
    }, {
      key: "isFront",
      value: function isFront() {
        return this.direction === DIRECTION_TYPE.FRONT;
      } // return start index offset

    }, {
      key: "getOffset",
      value: function getOffset(start) {
        return (start < 1 ? 0 : this.getIndexOffset(start)) + this.param.slotHeaderSize;
      }
    }, {
      key: "updateParam",
      value: function updateParam(key, value) {
        var _this = this;

        if (this.param && key in this.param) {
          // if uniqueIds change, find out deleted id and remove from size map
          if (key === 'uniqueIds') {
            this.sizes.forEach(function (v, key) {
              if (!value.includes(key)) {
                _this.sizes["delete"](key);
              }
            });
          }

          this.param[key] = value;
        }
      } // save each size map by id

    }, {
      key: "saveSize",
      value: function saveSize(id, size) {
        this.sizes.set(id, size); // we assume size type is fixed at the beginning and remember first size value
        // if there is no size value different from this at next comming saving
        // we think it's a fixed size list, otherwise is dynamic size list

        if (this.calcType === CALC_TYPE.INIT) {
          this.fixedSizeValue = size;
          this.calcType = CALC_TYPE.FIXED;
        } else if (this.calcType === CALC_TYPE.FIXED && this.fixedSizeValue !== size) {
          this.calcType = CALC_TYPE.DYNAMIC; // it's no use at all

          delete this.fixedSizeValue;
        } // calculate the average size only in the first range


        if (this.calcType !== CALC_TYPE.FIXED && typeof this.firstRangeTotalSize !== 'undefined') {
          if (this.sizes.size < Math.min(this.param.keeps, this.param.uniqueIds.length)) {
            this.firstRangeTotalSize = _toConsumableArray(this.sizes.values()).reduce(function (acc, val) {
              return acc + val;
            }, 0);
            this.firstRangeAverageSize = Math.round(this.firstRangeTotalSize / this.sizes.size);
          } else {
            // it's done using
            delete this.firstRangeTotalSize;
          }
        }
      } // in some special situation (e.g. length change) we need to update in a row
      // try goiong to render next range by a leading buffer according to current direction

    }, {
      key: "handleDataSourcesChange",
      value: function handleDataSourcesChange() {
        var start = this.range.start;

        if (this.isFront()) {
          start = start - LEADING_BUFFER;
        } else if (this.isBehind()) {
          start = start + LEADING_BUFFER;
        }

        start = Math.max(start, 0);
        this.updateRange(this.range.start, this.getEndByStart(start));
      } // when slot size change, we also need force update

    }, {
      key: "handleSlotSizeChange",
      value: function handleSlotSizeChange() {
        this.handleDataSourcesChange();
      } // calculating range on scroll

    }, {
      key: "handleScroll",
      value: function handleScroll(offset) {
        this.direction = offset < this.offset ? DIRECTION_TYPE.FRONT : DIRECTION_TYPE.BEHIND;
        this.offset = offset;

        if (!this.param) {
          return;
        }

        if (this.direction === DIRECTION_TYPE.FRONT) {
          this.handleFront();
        } else if (this.direction === DIRECTION_TYPE.BEHIND) {
          this.handleBehind();
        }
      } // ----------- public method end -----------

    }, {
      key: "handleFront",
      value: function handleFront() {
        var overs = this.getScrollOvers(); // should not change range if start doesn't exceed overs

        if (overs > this.range.start) {
          return;
        } // move up start by a buffer length, and make sure its safety


        var start = Math.max(overs - this.param.buffer, 0);
        this.checkRange(start, this.getEndByStart(start));
      }
    }, {
      key: "handleBehind",
      value: function handleBehind() {
        var overs = this.getScrollOvers(); // range should not change if scroll overs within buffer

        if (overs < this.range.start + this.param.buffer) {
          return;
        }

        this.checkRange(overs, this.getEndByStart(overs));
      } // return the pass overs according to current scroll offset

    }, {
      key: "getScrollOvers",
      value: function getScrollOvers() {
        // if slot header exist, we need subtract its size
        var offset = this.offset - this.param.slotHeaderSize;

        if (offset <= 0) {
          return 0;
        } // if is fixed type, that can be easily


        if (this.isFixedType()) {
          return Math.floor(offset / this.fixedSizeValue);
        }

        var low = 0;
        var middle = 0;
        var middleOffset = 0;
        var high = this.param.uniqueIds.length;

        while (low <= high) {
          // this.__bsearchCalls++
          middle = low + Math.floor((high - low) / 2);
          middleOffset = this.getIndexOffset(middle);

          if (middleOffset === offset) {
            return middle;
          } else if (middleOffset < offset) {
            low = middle + 1;
          } else if (middleOffset > offset) {
            high = middle - 1;
          }
        }

        return low > 0 ? --low : 0;
      } // return a scroll offset from given index, can efficiency be improved more here?
      // although the call frequency is very high, its only a superposition of numbers

    }, {
      key: "getIndexOffset",
      value: function getIndexOffset(givenIndex) {
        if (!givenIndex) {
          return 0;
        }

        var offset = 0;
        var indexSize = 0;

        for (var index = 0; index < givenIndex; index++) {
          // this.__getIndexOffsetCalls++
          indexSize = this.sizes.get(this.param.uniqueIds[index]);
          offset = offset + (typeof indexSize === 'number' ? indexSize : this.getEstimateSize());
        } // remember last calculate index


        this.lastCalcIndex = Math.max(this.lastCalcIndex, givenIndex - 1);
        this.lastCalcIndex = Math.min(this.lastCalcIndex, this.getLastIndex());
        return offset;
      } // is fixed size type

    }, {
      key: "isFixedType",
      value: function isFixedType() {
        return this.calcType === CALC_TYPE.FIXED;
      } // return the real last index

    }, {
      key: "getLastIndex",
      value: function getLastIndex() {
        return this.param.uniqueIds.length - 1;
      } // in some conditions range is broke, we need correct it
      // and then decide whether need update to next range

    }, {
      key: "checkRange",
      value: function checkRange(start, end) {
        var keeps = this.param.keeps;
        var total = this.param.uniqueIds.length; // datas less than keeps, render all

        if (total <= keeps) {
          start = 0;
          end = this.getLastIndex();
        } else if (end - start < keeps - 1) {
          // if range length is less than keeps, corrent it base on end
          start = end - keeps + 1;
        }

        if (this.range.start !== start) {
          this.updateRange(start, end);
        }
      } // setting to a new range and rerender

    }, {
      key: "updateRange",
      value: function updateRange(start, end) {
        this.range.start = start;
        this.range.end = end;
        this.range.padFront = this.getPadFront();
        this.range.padBehind = this.getPadBehind();
        this.callUpdate(this.getRange());
      } // return end base on start

    }, {
      key: "getEndByStart",
      value: function getEndByStart(start) {
        var theoryEnd = start + this.param.keeps - 1;
        var truelyEnd = Math.min(theoryEnd, this.getLastIndex());
        return truelyEnd;
      } // return total front offset

    }, {
      key: "getPadFront",
      value: function getPadFront() {
        if (this.isFixedType()) {
          return this.fixedSizeValue * this.range.start;
        } else {
          return this.getIndexOffset(this.range.start);
        }
      } // return total behind offset

    }, {
      key: "getPadBehind",
      value: function getPadBehind() {
        var end = this.range.end;
        var lastIndex = this.getLastIndex();

        if (this.isFixedType()) {
          return (lastIndex - end) * this.fixedSizeValue;
        } // if it's all calculated, return the exactly offset


        if (this.lastCalcIndex === lastIndex) {
          return this.getIndexOffset(lastIndex) - this.getIndexOffset(end);
        } else {
          // if not, use a estimated value
          return (lastIndex - end) * this.getEstimateSize();
        }
      } // get the item estimate size

    }, {
      key: "getEstimateSize",
      value: function getEstimateSize() {
        return this.isFixedType() ? this.fixedSizeValue : this.firstRangeAverageSize || this.param.estimateSize;
      }
    }]);

    return Virtual;
  }();

  /**
   * props declaration for default, item and slot component
   */
  var VirtualProps = {
    dataKey: {
      type: [String, Function],
      required: true
    },
    dataSources: {
      type: Array,
      required: true
    },
    dataComponent: {
      type: [Object, Function],
      required: true
    },
    keeps: {
      type: Number,
      "default": 30
    },
    extraProps: {
      type: Object
    },
    estimateSize: {
      type: Number,
      "default": 50
    },
    direction: {
      type: String,
      "default": 'vertical' // the other value is horizontal

    },
    start: {
      type: Number,
      "default": 0
    },
    offset: {
      type: Number,
      "default": 0
    },
    topThreshold: {
      type: Number,
      "default": 0
    },
    bottomThreshold: {
      type: Number,
      "default": 0
    },
    pageMode: {
      type: Boolean,
      "default": false
    },
    rootTag: {
      type: String,
      "default": 'div'
    },
    wrapTag: {
      type: String,
      "default": 'div'
    },
    wrapClass: {
      type: String,
      "default": ''
    },
    wrapStyle: {
      type: Object
    },
    itemTag: {
      type: String,
      "default": 'div'
    },
    itemClass: {
      type: String,
      "default": ''
    },
    itemClassAdd: {
      type: Function
    },
    itemStyle: {
      type: Object
    },
    headerTag: {
      type: String,
      "default": 'div'
    },
    headerClass: {
      type: String,
      "default": ''
    },
    headerStyle: {
      type: Object
    },
    footerTag: {
      type: String,
      "default": 'div'
    },
    footerClass: {
      type: String,
      "default": ''
    },
    footerStyle: {
      type: Object
    },
    itemScopedSlots: {
      type: Object
    }
  };
  var ItemProps = {
    index: {
      type: Number
    },
    event: {
      type: String
    },
    tag: {
      type: String
    },
    horizontal: {
      type: Boolean
    },
    source: {
      type: Object
    },
    component: {
      type: [Object, Function]
    },
    slotComponent: {
      type: Function
    },
    uniqueKey: {
      type: [String, Number]
    },
    extraProps: {
      type: Object
    },
    scopedSlots: {
      type: Object
    }
  };
  var SlotProps = {
    event: {
      type: String
    },
    uniqueKey: {
      type: String
    },
    tag: {
      type: String
    },
    horizontal: {
      type: Boolean
    }
  };

  var Wrapper = {
    created: function created() {
      this.shapeKey = this.horizontal ? 'offsetWidth' : 'offsetHeight';
    },
    mounted: function mounted() {
      var _this = this;

      if (typeof ResizeObserver !== 'undefined') {
        this.resizeObserver = new ResizeObserver(function () {
          _this.dispatchSizeChange();
        });
        this.resizeObserver.observe(this.$el);
      }
    },
    // since componet will be reused, so disptach when updated
    updated: function updated() {
      this.dispatchSizeChange();
    },
    beforeDestroy: function beforeDestroy() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    },
    methods: {
      getCurrentSize: function getCurrentSize() {
        return this.$el ? this.$el[this.shapeKey] : 0;
      },
      // tell parent current size identify by unqiue key
      dispatchSizeChange: function dispatchSizeChange() {
        this.$parent.$emit(this.event, this.uniqueKey, this.getCurrentSize(), this.hasInitial);
      }
    }
  }; // wrapping for item

  var Item = Vue.component('virtual-list-item', {
    mixins: [Wrapper],
    props: ItemProps,
    render: function render(h) {
      var tag = this.tag,
          component = this.component,
          _this$extraProps = this.extraProps,
          extraProps = _this$extraProps === void 0 ? {} : _this$extraProps,
          index = this.index,
          source = this.source,
          _this$scopedSlots = this.scopedSlots,
          scopedSlots = _this$scopedSlots === void 0 ? {} : _this$scopedSlots,
          uniqueKey = this.uniqueKey,
          slotComponent = this.slotComponent;

      var props = _objectSpread2({}, extraProps, {
        source: source,
        index: index
      });

      return h(tag, {
        key: uniqueKey,
        attrs: {
          role: 'listitem'
        }
      }, [slotComponent ? h('div', slotComponent({
        item: source,
        index: index,
        scope: props
      })) : h(component, {
        props: props,
        scopedSlots: scopedSlots
      })]);
    }
  }); // wrapping for slot

  var Slot = Vue.component('virtual-list-slot', {
    mixins: [Wrapper],
    props: SlotProps,
    render: function render(h) {
      var tag = this.tag,
          uniqueKey = this.uniqueKey;
      return h(tag, {
        key: uniqueKey,
        attrs: {
          role: uniqueKey
        }
      }, this.$slots["default"]);
    }
  });

  /**
   * virtual list default component
   */
  var EVENT_TYPE = {
    ITEM: 'item_resize',
    SLOT: 'slot_resize'
  };
  var SLOT_TYPE = {
    HEADER: 'thead',
    // string value also use for aria role attribute
    FOOTER: 'tfoot'
  };
  var VirtualList = Vue.component('virtual-list', {
    props: VirtualProps,
    data: function data() {
      return {
        range: null
      };
    },
    watch: {
      'dataSources.length': function dataSourcesLength() {
        this.virtual.updateParam('uniqueIds', this.getUniqueIdFromDataSources());
        this.virtual.handleDataSourcesChange();
      },
      keeps: function keeps(newValue) {
        this.virtual.updateParam('keeps', newValue);
        this.virtual.handleSlotSizeChange();
      },
      start: function start(newValue) {
        this.scrollToIndex(newValue);
      },
      offset: function offset(newValue) {
        this.scrollToOffset(newValue);
      }
    },
    created: function created() {
      this.isHorizontal = this.direction === 'horizontal';
      this.directionKey = this.isHorizontal ? 'scrollLeft' : 'scrollTop';
      this.installVirtual(); // listen item size change

      this.$on(EVENT_TYPE.ITEM, this.onItemResized); // listen slot size change

      if (this.$slots.header || this.$slots.footer) {
        this.$on(EVENT_TYPE.SLOT, this.onSlotResized);
      }
    },
    activated: function activated() {
      // set back offset when awake from keep-alive
      this.scrollToOffset(this.virtual.offset);

      if (this.pageMode) {
        document.addEventListener('scroll', this.onScroll, {
          passive: false
        });
      }
    },
    deactivated: function deactivated() {
      if (this.pageMode) {
        document.removeEventListener('scroll', this.onScroll);
      }
    },
    mounted: function mounted() {
      // set position
      if (this.start) {
        this.scrollToIndex(this.start);
      } else if (this.offset) {
        this.scrollToOffset(this.offset);
      } // in page mode we bind scroll event to document


      if (this.pageMode) {
        this.updatePageModeFront();
        document.addEventListener('scroll', this.onScroll, {
          passive: false
        });
      }
    },
    beforeDestroy: function beforeDestroy() {
      this.virtual.destroy();

      if (this.pageMode) {
        document.removeEventListener('scroll', this.onScroll);
      }
    },
    methods: {
      // get item size by id
      getSize: function getSize(id) {
        return this.virtual.sizes.get(id);
      },
      // get the total number of stored (rendered) items
      getSizes: function getSizes() {
        return this.virtual.sizes.size;
      },
      // return current scroll offset
      getOffset: function getOffset() {
        if (this.pageMode) {
          return document.documentElement[this.directionKey] || document.body[this.directionKey];
        } else {
          var root = this.$refs.root;
          return root ? Math.ceil(root[this.directionKey]) : 0;
        }
      },
      // return client viewport size
      getClientSize: function getClientSize() {
        var key = this.isHorizontal ? 'clientWidth' : 'clientHeight';

        if (this.pageMode) {
          return document.documentElement[key] || document.body[key];
        } else {
          var root = this.$refs.root;
          return root ? Math.ceil(root[key]) : 0;
        }
      },
      // return all scroll size
      getScrollSize: function getScrollSize() {
        var key = this.isHorizontal ? 'scrollWidth' : 'scrollHeight';

        if (this.pageMode) {
          return document.documentElement[key] || document.body[key];
        } else {
          var root = this.$refs.root;
          return root ? Math.ceil(root[key]) : 0;
        }
      },
      // set current scroll position to a expectant offset
      scrollToOffset: function scrollToOffset(offset) {
        if (this.pageMode) {
          document.body[this.directionKey] = offset;
          document.documentElement[this.directionKey] = offset;
        } else {
          var root = this.$refs.root;

          if (root) {
            root[this.directionKey] = offset;
          }
        }
      },
      // set current scroll position to a expectant index
      scrollToIndex: function scrollToIndex(index) {
        // scroll to bottom
        if (index >= this.dataSources.length - 1) {
          this.scrollToBottom();
        } else {
          var offset = this.virtual.getOffset(index);
          this.scrollToOffset(offset);
        }
      },
      // set current scroll position to bottom
      scrollToBottom: function scrollToBottom() {
        var _this = this;

        var shepherd = this.$refs.shepherd;

        if (shepherd) {
          var offset = shepherd[this.isHorizontal ? 'offsetLeft' : 'offsetTop'];
          this.scrollToOffset(offset); // check if it's really scrolled to the bottom
          // maybe list doesn't render and calculate to last range
          // so we need retry in next event loop until it really at bottom

          setTimeout(function () {
            if (_this.getOffset() + _this.getClientSize() + 1 < _this.getScrollSize()) {
              _this.scrollToBottom();
            }
          }, 3);
        }
      },
      // when using page mode we need update slot header size manually
      // taking root offset relative to the browser as slot header size
      updatePageModeFront: function updatePageModeFront() {
        var root = this.$refs.root;

        if (root) {
          var rect = root.getBoundingClientRect();
          var defaultView = root.ownerDocument.defaultView;
          var offsetFront = this.isHorizontal ? rect.left + defaultView.pageXOffset : rect.top + defaultView.pageYOffset;
          this.virtual.updateParam('slotHeaderSize', offsetFront);
        }
      },
      // reset all state back to initial
      reset: function reset() {
        this.virtual.destroy();
        this.scrollToOffset(0);
        this.installVirtual();
      },
      // ----------- public method end -----------
      installVirtual: function installVirtual() {
        this.virtual = new Virtual({
          slotHeaderSize: 0,
          slotFooterSize: 0,
          keeps: this.keeps,
          estimateSize: this.estimateSize,
          buffer: Math.round(this.keeps / 3),
          // recommend for a third of keeps
          uniqueIds: this.getUniqueIdFromDataSources()
        }, this.onRangeChanged); // sync initial range

        this.range = this.virtual.getRange();
      },
      getUniqueIdFromDataSources: function getUniqueIdFromDataSources() {
        var dataKey = this.dataKey;
        return this.dataSources.map(function (dataSource) {
          return typeof dataKey === 'function' ? dataKey(dataSource) : dataSource[dataKey];
        });
      },
      // event called when each item mounted or size changed
      onItemResized: function onItemResized(id, size) {
        this.virtual.saveSize(id, size);
        this.$emit('resized', id, size);
      },
      // event called when slot mounted or size changed
      onSlotResized: function onSlotResized(type, size, hasInit) {
        if (type === SLOT_TYPE.HEADER) {
          this.virtual.updateParam('slotHeaderSize', size);
        } else if (type === SLOT_TYPE.FOOTER) {
          this.virtual.updateParam('slotFooterSize', size);
        }

        if (hasInit) {
          this.virtual.handleSlotSizeChange();
        }
      },
      // here is the rerendering entry
      onRangeChanged: function onRangeChanged(range) {
        this.range = range;
      },
      onScroll: function onScroll(evt) {
        var offset = this.getOffset();
        var clientSize = this.getClientSize();
        var scrollSize = this.getScrollSize(); // iOS scroll-spring-back behavior will make direction mistake

        if (offset < 0 || offset + clientSize > scrollSize + 1 || !scrollSize) {
          return;
        }

        this.virtual.handleScroll(offset);
        this.emitEvent(offset, clientSize, scrollSize, evt);
      },
      // emit event in special position
      emitEvent: function emitEvent(offset, clientSize, scrollSize, evt) {
        this.$emit('scroll', evt, this.virtual.getRange());

        if (this.virtual.isFront() && !!this.dataSources.length && offset - this.topThreshold <= 0) {
          this.$emit('totop');
        } else if (this.virtual.isBehind() && offset + clientSize + this.bottomThreshold >= scrollSize) {
          this.$emit('tobottom');
        }
      },
      // get the real render slots based on range data
      // in-place patch strategy will try to reuse components as possible
      // so those components that are reused will not trigger lifecycle mounted
      getRenderSlots: function getRenderSlots(h) {
        var slots = [];
        var _this$range = this.range,
            start = _this$range.start,
            end = _this$range.end;
        var dataSources = this.dataSources,
            dataKey = this.dataKey,
            itemClass = this.itemClass,
            itemTag = this.itemTag,
            itemStyle = this.itemStyle,
            isHorizontal = this.isHorizontal,
            extraProps = this.extraProps,
            dataComponent = this.dataComponent,
            itemScopedSlots = this.itemScopedSlots;
        var slotComponent = this.$scopedSlots && this.$scopedSlots.item;

        for (var index = start; index <= end; index++) {
          var dataSource = dataSources[index];

          if (dataSource) {
            var uniqueKey = typeof dataKey === 'function' ? dataKey(dataSource) : dataSource[dataKey];

            if (typeof uniqueKey === 'string' || typeof uniqueKey === 'number') {
              slots.push(h(Item, {
                props: {
                  index: index,
                  tag: itemTag,
                  event: EVENT_TYPE.ITEM,
                  horizontal: isHorizontal,
                  uniqueKey: uniqueKey,
                  source: dataSource,
                  extraProps: extraProps,
                  component: dataComponent,
                  slotComponent: slotComponent,
                  scopedSlots: itemScopedSlots
                },
                style: itemStyle,
                "class": "".concat(itemClass).concat(this.itemClassAdd ? ' ' + this.itemClassAdd(index) : '')
              }));
            } else {
              console.warn("Cannot get the data-key '".concat(dataKey, "' from data-sources."));
            }
          } else {
            console.warn("Cannot get the index '".concat(index, "' from data-sources."));
          }
        }

        return slots;
      }
    },
    // render function, a closer-to-the-compiler alternative to templates
    // https://vuejs.org/v2/guide/render-function.html#The-Data-Object-In-Depth
    render: function render(h) {
      var _this$$slots = this.$slots,
          header = _this$$slots.header,
          footer = _this$$slots.footer;
      var _this$range2 = this.range,
          padFront = _this$range2.padFront,
          padBehind = _this$range2.padBehind;
      var isHorizontal = this.isHorizontal,
          pageMode = this.pageMode,
          rootTag = this.rootTag,
          wrapTag = this.wrapTag,
          wrapClass = this.wrapClass,
          wrapStyle = this.wrapStyle,
          headerTag = this.headerTag,
          headerClass = this.headerClass,
          headerStyle = this.headerStyle,
          footerTag = this.footerTag,
          footerClass = this.footerClass,
          footerStyle = this.footerStyle;
      var paddingStyle = {
        padding: isHorizontal ? "0px ".concat(padBehind, "px 0px ").concat(padFront, "px") : "".concat(padFront, "px 0px ").concat(padBehind, "px")
      };
      var wrapperStyle = wrapStyle ? Object.assign({}, wrapStyle, paddingStyle) : paddingStyle;
      return h(rootTag, {
        ref: 'root',
        on: {
          '&scroll': !pageMode && this.onScroll
        }
      }, [// header slot
      header ? h(Slot, {
        "class": headerClass,
        style: headerStyle,
        props: {
          tag: headerTag,
          event: EVENT_TYPE.SLOT,
          uniqueKey: SLOT_TYPE.HEADER
        }
      }, header) : null, // main list
      h(wrapTag, {
        "class": wrapClass,
        attrs: {
          role: 'group'
        },
        style: wrapperStyle
      }, this.getRenderSlots(h)), // footer slot
      footer ? h(Slot, {
        "class": footerClass,
        style: footerStyle,
        props: {
          tag: footerTag,
          event: EVENT_TYPE.SLOT,
          uniqueKey: SLOT_TYPE.FOOTER
        }
      }, footer) : null, // an empty element use to scroll to bottom
      h('div', {
        ref: 'shepherd',
        style: {
          width: isHorizontal ? '0px' : '100%',
          height: isHorizontal ? '100%' : '0px'
        }
      })]);
    }
  });

  return VirtualList;

})));
}(dist));

var VirtualList = dist.exports;

function ownKeys$f(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$g(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$f(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$f(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var addItemDropdown = function addItemDropdown(item, isLabelGroup, items, selected) {
  var _item$option, _item$option2;
  var isDivider = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  items.push(_objectSpread$g(_objectSpread$g({
    selectAll: false
  }, item), {}, {
    originalData: _objectSpread$g({}, item.option),
    selected: selected,
    icon: (_item$option = item.option) === null || _item$option === void 0 ? void 0 : _item$option.icon,
    isLabelGroup: isLabelGroup,
    index: items.length,
    tempSelected: false,
    indeterminate: false,
    disabled: !!((_item$option2 = item.option) !== null && _item$option2 !== void 0 && _item$option2.disabled),
    visible: item.level === 0,
    isDivider: isDivider
  }));
};
var getSelection = function getSelection(value, values, valueKey, changeSelected) {
  if (values && values !== null && values !== void 0 && values.length && Array.isArray(values)) {
    var indexVal = values.findIndex(function (val) {
      return val[valueKey] === value;
    });
    if (indexVal !== -1) {
      // eslint-disable-next-line
      changeSelected.change = true;
      values.splice(indexVal, 1);
      return true;
    }
  } else if (values && _typeof$2(values) === 'object' && values[valueKey] === value) {
    // eslint-disable-next-line
    changeSelected.change = true;
    return true;
  } else if ((typeof values === 'string' || typeof values === 'number') && values === value) {
    // eslint-disable-next-line
    changeSelected.change = true;
    return true;
  }
  return false;
};
var addOptions = function addOptions(options, oldValue, changeSelected, level, items, valueKey, textKey, refId) {
  options.forEach(function (option) {
    var _addItemDropdown;
    var value = valueKey in option ? option[valueKey] : '';
    addItemDropdown((_addItemDropdown = {}, _defineProperty$1(_addItemDropdown, valueKey, value), _defineProperty$1(_addItemDropdown, textKey, option[textKey]), _defineProperty$1(_addItemDropdown, "level", level), _defineProperty$1(_addItemDropdown, "option", option), _defineProperty$1(_addItemDropdown, "groupId", refId.groupId), _addItemDropdown),
    // TODO: Validar la forma de hacer el 'label'
    option.isLabelGroup, items, getSelection(value, oldValue, valueKey, changeSelected), option.isDivider);
    if ('options' in option) {
      // eslint-disable-next-line
      refId.groupId += 1;
      addOptions(option.options, oldValue, changeSelected, level + 1, items, valueKey, textKey, refId);
    }
  });
};
var parseDataDropdown = function parseDataDropdown() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var oldValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var allowSelectAll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var multiple = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var valueKey = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'id';
  var textKey = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'name';
  var items = [];
  var changeSelected = {
    change: false
  };
  // al seleccionar el item x se valida x.level < x.siguiente.level para seleccionar todos los hijos
  var level = 0;
  var refId = {
    groupId: 0
  };

  // Select All
  if ((options === null || options === void 0 ? void 0 : options.length) > 0 && allowSelectAll && multiple) {
    var _addItemDropdown2;
    addItemDropdown((_addItemDropdown2 = {}, _defineProperty$1(_addItemDropdown2, valueKey, ''), _defineProperty$1(_addItemDropdown2, textKey, 'Select All'), _defineProperty$1(_addItemDropdown2, "selectAll", true), _addItemDropdown2), false, items);
  }
  addOptions(options, cloneDeep(oldValue), changeSelected, level, items, valueKey, textKey, refId);
  return {
    items: items,
    change: changeSelected.change
  };
};
var compareValuesByPosition = function compareValuesByPosition(val1, val2) {
  var valueKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'id';
  var isKeys = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var equals = true;
  if ((val1 === null || val1 === void 0 ? void 0 : val1.length) !== (val2 === null || val2 === void 0 ? void 0 : val2.length)) {
    equals = false;
  } else {
    for (var index = 0; index < (val1 === null || val1 === void 0 ? void 0 : val1.length); index += 1) {
      var element = val1[index];
      var item1 = isKeys ? element : element[valueKey];
      var item2 = isKeys ? val2[index] : val2[index][valueKey];
      if (item1 !== item2) {
        equals = false;
        break;
      }
    }
  }
  return equals;
};

var CODE_DOWN = 40;
var CODE_ENTER = 13;
var CODE_ESC = 27;
var CODE_UP = 38;

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".flag{width:52px;height:39px;display:inline-block;background:url(data:image/png;base64,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)}.f-and,.f-andorra{background-position:0 -42px}.f-ae,.f-are{background-position:0 -82px}.f-af,.f-afg{background-position:0 -123px}.f-ag,.f-atg{background-position:0 -164px}.f-ai,.f-aia{background-position:0 -205px}.f-al,.f-alb{background-position:0 -246px}.f-am,.f-arm{background-position:0 -287px}.f-an,.f-ant{background-position:0 -328px}.f-ago,.f-ao{background-position:0 -369px}.f-aq,.f-ata{background-position:0 -410px}.f-ar,.f-arg{background-position:0 -451px}.f-as,.f-asm{background-position:0 -492px}.f-at,.f-aut{background-position:0 -533px}.f-au,.f-aus{background-position:0 -574px}.f-abw,.f-aw{background-position:0 -615px}.f-ala,.f-ax{background-position:0 -657px}.f-az,.f-aze{background-position:0 -698px}.f-ba,.f-bih{background-position:0 -738px}.f-bb,.f-brb{background-position:0 -779px}.f-bd,.f-bgd{background-position:0 -820px}.f-be,.f-bel{background-position:0 -861px}.f-bf,.f-bfa{background-position:0 -902px}.f-bg,.f-bgr{background-position:0 -943px}.f-bh,.f-bhr{background-position:0 -984px}.f-bdi,.f-bi{background-position:0 -1025px}.f-ben,.f-bj{background-position:0 -1067px}.f-bl,.f-blm{background-position:0 -1107px}.f-bm,.f-bmu{background-position:0 -1148px}.f-bn,.f-brn{background-position:0 -1189px}.f-bo,.f-bol{background-position:0 -1230px}.f-bes,.f-bq{background-position:0 -1272px}.f-br,.f-bra{background-position:0 -1312px}.f-bhs,.f-bs{background-position:0 -1353px}.f-bt,.f-btn{background-position:0 -1394px}.f-bv,.f-bvt{background-position:0 -1435px}.f-bw,.f-bwa{background-position:0 -1477px}.f-blr,.f-by{background-position:0 -1517px}.f-blz,.f-bz{background-position:0 -1558px}.f-ca,.f-can{background-position:0 -1599px}.f-cc,.f-cck{background-position:0 -1640px}.f-cd,.f-cod{background-position:0 -1681px}.f-caf,.f-cf{background-position:0 -1722px}.f-cg,.f-cog{background-position:0 -1763px}.f-ch,.f-che{background-position:0 -1804px}.f-ci,.f-civ{background-position:0 -1845px}.f-ck,.f-cok{background-position:0 -1886px}.f-chl,.f-cl{background-position:0 -1927px}.f-cm,.f-cmr{background-position:0 -1968px}.f-chn,.f-cn{background-position:0 -2009px}.f-co,.f-col{background-position:0 -2050px}.f-cr,.f-cri{background-position:0 -2091px}.f-cu,.f-cub{background-position:0 -2132px}.f-cpv,.f-cv{background-position:0 -2173px}.f-cuw,.f-cw{background-position:0 -2214px}.f-cx,.f-cxr{background-position:0 -2255px}.f-cy,.f-cyp{background-position:0 -2296px}.f-cz,.f-cze{background-position:0 -2337px}.f-de,.f-deu{background-position:0 -2377px}.f-dj,.f-dji{background-position:0 -2419px}.f-dk,.f-dnk{background-position:0 -2460px}.f-dm,.f-dma{background-position:0 -2501px}.f-do,.f-dom{background-position:0 -2542px}.f-dz,.f-dza{background-position:0 -2583px}.f-ec,.f-ecu{background-position:0 -2624px}.f-ee,.f-est{background-position:0 -2665px}.f-eg,.f-egy{background-position:0 -2706px}.f-eh,.f-esh{background-position:0 -2747px}.f-er,.f-eri{background-position:0 -2787px}.f-es-ca{background-position:0 -2829px}.f-es,.f-esp{background-position:0 -2870px}.f-et,.f-eth{background-position:0 -2911px}.f-eu{background-position:0 -2953px}.f-fi,.f-fin{background-position:0 -2993px}.f-fj,.f-fji{background-position:0 -3034px}.f-fk,.f-flk{background-position:0 -3075px}.f-fm,.f-fsm{background-position:0 -3116px}.f-fo,.f-fro{background-position:0 -3157px}.f-fr,.f-fra{background-position:0 -3198px}.f-ga,.f-gab{background-position:0 -3239px}.f-gb-eng{background-position:0 -3280px}.f-gb-nir{background-position:0 -3321px}.f-gb-sct{background-position:0 -3362px}.f-gb-wls{background-position:0 -3403px}.f-gb,.f-gbr{background-position:0 -3444px}.f-gd,.f-grd{background-position:0 -3485px}.f-ge,.f-geo{background-position:0 -3526px}.f-gf,.f-guf{background-position:0 -3567px}.f-gg,.f-ggy{background-position:0 -3608px}.f-gh,.f-gha{background-position:0 -3649px}.f-gi,.f-gib{background-position:0 -3690px}.f-gl,.f-grl{background-position:0 -3731px}.f-gm,.f-gmb{background-position:0 -3771px}.f-gin,.f-gn{background-position:0 -3813px}.f-glp,.f-gp{background-position:0 -3854px}.f-gnq,.f-gq{background-position:0 -3895px}.f-gr,.f-grc{background-position:0 -3936px}.f-gs,.f-sgs{background-position:0 -3977px}.f-gt,.f-gtm{background-position:0 -4018px}.f-gu,.f-gum{background-position:0 -4059px}.f-gnb,.f-gw{background-position:0 -4100px}.f-guy,.f-gy{background-position:0 -4141px}.f-hk,.f-hkg{background-position:0 -4182px}.f-hm,.f-hmd{background-position:0 -4223px}.f-hn,.f-hnd{background-position:0 -4264px}.f-hr,.f-hrv{background-position:0 -4305px}.f-ht,.f-hti{background-position:0 -4347px}.f-hu,.f-hun{background-position:0 -4387px}.f-id,.f-idn{background-position:0 -4428px}.f-ie,.f-irl{background-position:0 -4468px}.f-il,.f-isr{background-position:0 -4510px}.f-im,.f-imn{background-position:0 -4551px}.f-in,.f-ind{background-position:0 -4593px}.f-io,.f-iot{background-position:0 -4633px}.f-iq,.f-irq{background-position:0 -4674px}.f-ir,.f-irn{background-position:0 -4715px}.f-is,.f-isl{background-position:0 -4756px}.f-it,.f-ita{background-position:0 -4797px}.f-je,.f-jey{background-position:0 -4838px}.f-jam,.f-jm{background-position:0 -4879px}.f-jo,.f-jor{background-position:0 -4920px}.f-jp,.f-jpn{background-position:0 -4961px}.f-ke,.f-ken{background-position:0 -5002px}.f-kg,.f-kgz{background-position:0 -5043px}.f-kh,.f-khm{background-position:0 -5084px}.f-ki,.f-kir{background-position:0 -5125px}.f-com,.f-km{background-position:0 -5166px}.f-kn,.f-kna{background-position:0 -5207px}.f-kp,.f-prk{background-position:0 -5248px}.f-kor,.f-kr{background-position:0 -5289px}.f-kw,.f-kwt{background-position:0 -5330px}.f-cym,.f-ky{background-position:0 -5371px}.f-kaz,.f-kz{background-position:0 -5412px}.f-la,.f-lao{background-position:0 -5453px}.f-lb,.f-lbn{background-position:0 -5494px}.f-lc,.f-lca{background-position:0 -5535px}.f-li,.f-lie{background-position:0 -5576px}.f-lk,.f-lka{background-position:0 -5617px}.f-lbr,.f-lr{background-position:0 -5658px}.f-ls,.f-lso{background-position:0 -5698px}.f-lt,.f-ltu{background-position:0 -5740px}.f-lu,.f-lux{background-position:0 -5781px}.f-lv,.f-lva{background-position:0 -5822px}.f-lby,.f-ly{background-position:0 -5862px}.f-ma,.f-mar{background-position:0 -5904px}.f-mc,.f-mco{background-position:0 -5945px}.f-md,.f-mda{background-position:0 -5986px}.f-me,.f-mne{background-position:0 -6028px}.f-maf,.f-mf{background-position:0 -6068px}.f-mdg,.f-mg{background-position:0 -6109px}.f-mh,.f-mhl{background-position:0 -6150px}.f-mk,.f-mkd{background-position:0 -6191px}.f-ml,.f-mli{background-position:0 -6233px}.f-mm,.f-mmr{background-position:0 -6273px}.f-mn,.f-mng{background-position:0 -6314px}.f-mac,.f-mo{background-position:0 -6355px}.f-mnp,.f-mp{background-position:0 -6397px}.f-mq,.f-mtq{background-position:0 -6437px}.f-mr,.f-mrt{background-position:0 -6478px}.f-ms,.f-msr{background-position:0 -6519px}.f-mlt,.f-mt{background-position:0 -6560px}.f-mu,.f-mus{background-position:0 -6601px}.f-mdv,.f-mv{background-position:0 -6642px}.f-mw,.f-mwi{background-position:0 -6682px}.f-mex,.f-mx{background-position:0 -6724px}.f-my,.f-mys{background-position:0 -6765px}.f-moz,.f-mz{background-position:0 -6806px}.f-na,.f-nam{background-position:0 -6847px}.f-nc,.f-ncl{background-position:0 -6888px}.f-ne,.f-ner{background-position:0 -6929px}.f-nf,.f-nfk{background-position:0 -6970px}.f-ng,.f-nga{background-position:0 -7011px}.f-ni,.f-nic{background-position:0 -7052px}.f-nl,.f-nld{background-position:0 -7093px}.f-no,.f-nor{background-position:0 -7134px}.f-np,.f-npl{background-position:0 -7175px}.f-nr,.f-nru{background-position:0 -7217px}.f-niu,.f-nu{background-position:0 -7257px}.f-nz,.f-nzl{background-position:0 -7298px}.f-om,.f-omn{background-position:0 -7339px}.f-pa,.f-pan{background-position:0 -7380px}.f-pe,.f-per{background-position:0 -7421px}.f-pf,.f-pyf{background-position:0 -7463px}.f-pg,.f-png{background-position:0 -7503px}.f-ph,.f-phl{background-position:0 -7544px}.f-pak,.f-pk{background-position:0 -7585px}.f-pl,.f-pol{background-position:0 -7626px}.f-pm,.f-spm{background-position:0 -7667px}.f-pcn,.f-pn{background-position:0 -7708px}.f-pr,.f-pri{background-position:0 -7749px}.f-ps,.f-pse{background-position:0 -7790px}.f-prt,.f-pt{background-position:0 -7831px}.f-plw,.f-pw{background-position:0 -7873px}.f-pry,.f-py{background-position:0 -7913px}.f-qa,.f-qat{background-position:0 -7954px}.f-re,.f-reu{background-position:0 -7995px}.f-ro,.f-rou{background-position:0 -8036px}.f-rs,.f-srb{background-position:0 -8077px}.f-ru,.f-rus{background-position:0 -8117px}.f-rw,.f-rwa{background-position:0 -8159px}.f-sa,.f-sau{background-position:0 -8200px}.f-sb,.f-slb{background-position:0 -8241px}.f-sc,.f-syc{background-position:0 -8282px}.f-sd,.f-sdn{background-position:0 -8323px}.f-se,.f-swe{background-position:0 -8364px}.f-sg,.f-sgp{background-position:0 -8405px}.f-sh,.f-shn{background-position:0 -8446px}.f-si,.f-svn{background-position:0 -8487px}.f-sj,.f-sjm{background-position:0 -8528px}.f-sk,.f-svk{background-position:0 -8569px}.f-sl,.f-sle{background-position:0 -8610px}.f-sm,.f-smr{background-position:0 -8651px}.f-sen,.f-sn{background-position:0 -8693px}.f-so,.f-som{background-position:0 -8733px}.f-sr,.f-sur{background-position:0 -8774px}.f-ss,.f-ssd{background-position:0 -8815px}.f-st,.f-stp{background-position:0 -8856px}.f-slv,.f-sv{background-position:0 -8897px}.f-sx,.f-sxm{background-position:0 -8938px}.f-sy,.f-syr{background-position:0 -8979px}.f-swz,.f-sz{background-position:0 -9020px}.f-tc,.f-tca{background-position:0 -9061px}.f-tcd,.f-td{background-position:0 -9102px}.f-atf,.f-tf{background-position:0 -9142px}.f-tg,.f-tgo{background-position:0 -9184px}.f-th,.f-tha{background-position:0 -9225px}.f-tj,.f-tjk{background-position:0 -9266px}.f-tk,.f-tkl{background-position:0 -9307px}.f-tl,.f-tls{background-position:0 -9348px}.f-tkm,.f-tm{background-position:0 -9389px}.f-tn,.f-tun{background-position:0 -9430px}.f-to,.f-ton{background-position:0 -9472px}.f-tr,.f-tur{background-position:0 -9512px}.f-tt,.f-tto{background-position:0 -9552px}.f-tuv,.f-tv{background-position:0 -9594px}.f-tw,.f-twn{background-position:0 -9635px}.f-tz,.f-tza{background-position:0 -9676px}.f-ua,.f-ukr{background-position:0 -9717px}.f-ug,.f-uga{background-position:0 -9757px}.f-um,.f-umi{background-position:0 -9799px}.f-un{background-position:0 -9840px}.f-us,.f-usa{background-position:0 -9881px}.f-ury,.f-uy{background-position:0 -9922px}.f-uz,.f-uzb{background-position:0 -9963px}.f-va,.f-vat{background-position:0 -10004px}.f-vc,.f-vct{background-position:0 -10045px}.f-ve,.f-ven{background-position:0 -10086px}.f-vg,.f-vgb{background-position:0 -10127px}.f-vi,.f-vir{background-position:0 -10168px}.f-vn,.f-vnm{background-position:0 -10209px}.f-vu,.f-vut{background-position:0 -10250px}.f-wf,.f-wlf{background-position:0 -10291px}.f-ws,.f-wsm{background-position:0 -10331px}.f-xk{background-position:0 -10373px}.f-ye,.f-yem{background-position:0 -10414px}.f-myt,.f-yt{background-position:0 -10455px}.f-za,.f-zaf{background-position:0 -10496px}.f-zm,.f-zmb{background-position:0 -10538px}.f-zw,.f-zwe{background-position:0 -10578px}.f-su,.f-sun{background-position:0 -10619px;height:26px}";
styleInject(css_248z);

//
var script$1G = {
  name: 'CountryFlag',
  props: {
    country: {
      type: String,
      required: true
    },
    rounded: {
      type: Boolean,
      default: false
    },
    shadow: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      validator: function (value) {
        return value === 'small' || value === 'normal' || value === 'big';
      },
      default: 'normal'
    },
    background: {
      type: String,
      default: ''
    }
  },
  computed: {
    flagIconClass() {
      return {
        [`flag ${this.flagIconCountry}`]: true,
        [`rounded`]: this.rounded,
        [`shadow`]: this.shadow,
        [this.flagMargin]: true
      };
    },

    flagIconCountry() {
      let country = this.country.toLowerCase();
      country = country === 'ad' ? 'andorra' : country;
      return `f-${country}`;
    },

    flagMargin() {
      switch (this.size) {
        case 'small':
          return 'small-flag';

        case 'normal':
          return 'normal-flag';

        case 'big':
          return 'big-flag';

        default:
          return 'normal-flag';
      }
    }

  }
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

const isOldIE = typeof navigator !== 'undefined' &&
    /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());
function createInjector(context) {
    return (id, style) => addStyle(id, style);
}
let HEAD;
const styles = {};
function addStyle(id, css) {
    const group = isOldIE ? css.media || 'default' : id;
    const style = styles[group] || (styles[group] = { ids: new Set(), styles: [] });
    if (!style.ids.has(id)) {
        style.ids.add(id);
        let code = css.source;
        if (css.map) {
            // https://developer.chrome.com/devtools/docs/javascript-debugging
            // this makes source maps inside style tags work properly in Chrome
            code += '\n/*# sourceURL=' + css.map.sources[0] + ' */';
            // http://stackoverflow.com/a/26603875
            code +=
                '\n/*# sourceMappingURL=data:application/json;base64,' +
                    btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
                    ' */';
        }
        if (!style.element) {
            style.element = document.createElement('style');
            style.element.type = 'text/css';
            if (css.media)
                style.element.setAttribute('media', css.media);
            if (HEAD === undefined) {
                HEAD = document.head || document.getElementsByTagName('head')[0];
            }
            HEAD.appendChild(style.element);
        }
        if ('styleSheet' in style.element) {
            style.styles.push(code);
            style.element.styleSheet.cssText = style.styles
                .filter(Boolean)
                .join('\n');
        }
        else {
            const index = style.ids.size - 1;
            const textNode = document.createTextNode(code);
            const nodes = style.element.childNodes;
            if (nodes[index])
                style.element.removeChild(nodes[index]);
            if (nodes.length)
                style.element.insertBefore(textNode, nodes[index]);
            else
                style.element.appendChild(textNode);
        }
    }
}

/* script */
const __vue_script__$1G = script$1G;
/* template */

var __vue_render__$1G = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _vm.country ? _c('span', {
    class: _vm.flagIconClass
  }) : _vm._e();
};

var __vue_staticRenderFns__$1G = [];
/* style */

const __vue_inject_styles__$1G = function (inject) {
  if (!inject) return;
  inject("data-v-e8c23852_0", {
    source: ".small-flag[data-v-e8c23852]{margin:-.9em -1.2em -.9em -1.2em;transform:scale(.25);-ms-transform:scale(.25);-webkit-transform:scale(.25);-moz-transform:scale(.25)}.normal-flag[data-v-e8c23852]{margin:0 -.9em -.6em -.7em;transform:scale(.5);-ms-transform:scale(.5);-webkit-transform:scale(.5);-moz-transform:scale(.5)}.big-flag[data-v-e8c23852]{margin:0}.small-flag.rounded[data-v-e8c23852]{-moz-border-radius:15px;border-radius:15px}.normal-flag.rounded[data-v-e8c23852]{-moz-border-radius:10px;border-radius:10px}.big-flag.rounded[data-v-e8c23852]{-moz-border-radius:8px;border-radius:8px}.small-flag.shadow[data-v-e8c23852]{-webkit-box-shadow:0 2px 4px -1px rgb(0 0 0 / 20%),0 4px 5px 0 rgb(0 0 0 / 14%),0 1px 10px 0 rgb(0 0 0 / 12%);-moz-box-shadow:0 2px 4px -1px rgb(0 0 0 / 20%),0 4px 5px 0 rgb(0 0 0 / 14%),0 1px 10px 0 rgb(0 0 0 / 12%);box-shadow:0 2px 4px -1px rgb(0 0 0 / 20%),0 4px 5px 0 rgb(0 0 0 / 14%),0 1px 10px 0 rgb(0 0 0 / 12%)}.normal-flag.shadow[data-v-e8c23852]{-webkit-box-shadow:0 2px 4px -1px rgb(0 0 0 / 20%),0 4px 5px 0 rgb(0 0 0 / 14%),0 1px 10px 0 rgb(0 0 0 / 12%);-moz-box-shadow:0 2px 4px -1px rgb(0 0 0 / 20%),0 4px 5px 0 rgb(0 0 0 / 14%),0 1px 10px 0 rgb(0 0 0 / 12%);box-shadow:0 2px 4px -1px rgb(0 0 0 / 20%),0 4px 5px 0 rgb(0 0 0 / 14%),0 1px 10px 0 rgb(0 0 0 / 12%)}.big-flag.shadow[data-v-e8c23852]{-webkit-box-shadow:0 2px 4px -1px rgb(0 0 0 / 20%),0 4px 5px 0 rgb(0 0 0 / 14%),0 1px 10px 0 rgb(0 0 0 / 12%);-moz-box-shadow:0 2px 4px -1px rgb(0 0 0 / 20%),0 4px 5px 0 rgb(0 0 0 / 14%),0 1px 10px 0 rgb(0 0 0 / 12%);box-shadow:0 2px 4px -1px rgb(0 0 0 / 20%),0 4px 5px 0 rgb(0 0 0 / 14%),0 1px 10px 0 rgb(0 0 0 / 12%)}",
    map: undefined,
    media: undefined
  });
};
/* scoped */


const __vue_scope_id__$1G = "data-v-e8c23852";
/* module identifier */

const __vue_module_identifier__$1G = undefined;
/* functional template */

const __vue_is_functional_template__$1G = false;
/* style inject SSR */

/* style inject shadow dom */

const __vue_component__$1G = /*#__PURE__*/normalizeComponent({
  render: __vue_render__$1G,
  staticRenderFns: __vue_staticRenderFns__$1G
}, __vue_inject_styles__$1G, __vue_script__$1G, __vue_scope_id__$1G, __vue_is_functional_template__$1G, __vue_module_identifier__$1G, false, createInjector, undefined, undefined);

// Import vue component
// IIFE injects install function into component, allowing component
// to be registered via Vue.use() as well as Vue.component(),

var entry_esm = /*#__PURE__*/(() => {
  // Get component instance
  const installable = __vue_component__$1G; // Attach install function executed by Vue.use()

  installable.install = Vue => {
    Vue.component('CountryFlag', installable);
  };

  return installable;
})(); // It's possible to expose named exports when writing components that can
// also be used as directives, etc. - eg. import { RollupDemoDirective } from 'rollup-demo';
// export const RollupDemoDirective = directive;

var CountryFlag = entry_esm;

//
var script$1F = {
  components: {
    CountryFlag: CountryFlag
  },
  props: {
    index: {
      type: Number,
      default: -1
    },
    filterText: {
      type: String,
      default: ''
    },
    template: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    },
    valueKey: {
      type: String,
      default: 'id'
    },
    textKey: {
      type: String,
      default: 'text'
    },
    highlight: {
      type: Boolean,
      default: true
    },
    showCheckbox: {
      type: Boolean,
      default: true
    },
    selectAll: {
      type: Boolean,
      default: true
    },
    deselectAll: {
      type: Boolean,
      default: true
    },
    multiple: {
      type: Boolean,
      default: false
    },
    finalOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    source: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    isFlagSelector: {
      type: Boolean,
      default: false
    },
    showRadio: {
      type: Boolean,
      default: false
    },
    idForRadioVariant: {
      type: String,
      default: ''
    },
    notificationBanner: {
      type: Boolean,
      default: false
    },
    isFullName: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      localStyles: {},
      pointerSelectAll: {},
      pointerDeselectAll: {},
      pointerStyle: {}
    };
  },
  watch: {
    isTemporal: function isTemporal() {
      dispatchEvent$1(this, 'list-menu', 'scroll');
    },
    disabled: function disabled() {
      this.setDisabled();
    },
    'source.disabled': {
      handler: function handler() {
        this.getDisabledStyle();
      },
      deep: true
    }
  },
  computed: {
    textItem: function textItem() {
      var _this$source$original;
      var complete = true;
      var beforeSelected = '';
      var selected = '';
      var afterSelected = '';
      var text = this.isFlagSelector ? this.$aqT((_this$source$original = this.source.originalData) === null || _this$source$original === void 0 ? void 0 : _this$source$original.naming) : this.$aqT(this.source[this.textKey]);
      var index = String(text).toLowerCase().indexOf(this.filterText);
      if (index >= 0) {
        var _this$filterText, _this$filterText2;
        index = +index;
        complete = false;
        beforeSelected = typeof text === 'string' ? text === null || text === void 0 ? void 0 : text.substring(0, index) : "".concat(text);
        selected = typeof text === 'string' ? text === null || text === void 0 ? void 0 : text.substring(index, index + ((_this$filterText = this.filterText) === null || _this$filterText === void 0 ? void 0 : _this$filterText.length)) : "".concat(text);
        afterSelected = typeof text === 'string' ? text === null || text === void 0 ? void 0 : text.substring(index + ((_this$filterText2 = this.filterText) === null || _this$filterText2 === void 0 ? void 0 : _this$filterText2.length)) : "".concat(text);
      }
      return {
        complete: complete,
        beforeSelected: beforeSelected,
        selected: selected,
        afterSelected: afterSelected,
        text: text
      };
    },
    icon: function icon() {
      return this.source.icon || null;
    },
    isTemporal: function isTemporal() {
      return this.source.tempSelected;
    },
    disabled: function disabled() {
      var _this$source$option, _this$source, _this$source$original2;
      return this.source.disabled || ((_this$source$option = this.source.option) === null || _this$source$option === void 0 ? void 0 : _this$source$option.disabled) || ((_this$source = this.source) === null || _this$source === void 0 ? void 0 : (_this$source$original2 = _this$source.originalData) === null || _this$source$original2 === void 0 ? void 0 : _this$source$original2.disabled);
    },
    iconDownVisible: function iconDownVisible() {
      var _this$finalOptions;
      var visible = false;
      if (((_this$finalOptions = this.finalOptions) === null || _this$finalOptions === void 0 ? void 0 : _this$finalOptions.length) > 0 && this.type === 'list') {
        var _this$finalOptions2;
        visible = ((_this$finalOptions2 = this.finalOptions[this.source.index + 1]) === null || _this$finalOptions2 === void 0 ? void 0 : _this$finalOptions2.level) > this.source.level;
      }
      return visible;
    },
    iconDownActive: function iconDownActive() {
      var _this$finalOptions3;
      var active = false;
      if (((_this$finalOptions3 = this.finalOptions) === null || _this$finalOptions3 === void 0 ? void 0 : _this$finalOptions3.length) > 0 && this.type === 'list') {
        var _this$finalOptions4, _this$finalOptions5;
        active = ((_this$finalOptions4 = this.finalOptions[this.source.index + 1]) === null || _this$finalOptions4 === void 0 ? void 0 : _this$finalOptions4.level) > this.source.level && ((_this$finalOptions5 = this.finalOptions[this.source.index + 1]) === null || _this$finalOptions5 === void 0 ? void 0 : _this$finalOptions5.visible);
      }
      return active;
    },
    dataTemplate: function dataTemplate() {
      var _this$template;
      var finalString = '';
      if (((_this$template = this.template) === null || _this$template === void 0 ? void 0 : _this$template.length) > 0) {
        var x = this.template;
        finalString = x;
        var reg = /#=(.*?)#/gm;
        var m = reg.exec(x);
        while (m !== null) {
          if (m.index === reg.lastIndex) {
            reg.lastIndex += 1;
          }
          finalString = finalString.replace(m[0], "".concat(typeof this.source[String(m[1]).trim()] === 'undefined' ? '?' : String(this.$aqT(this.source[m[1]])).trim()));
          m = reg.exec(x);
        }
      }
      return finalString;
    },
    getTemplateLength: function getTemplateLength() {
      var _this$template2;
      return (_this$template2 = this.template) === null || _this$template2 === void 0 ? void 0 : _this$template2.length;
    },
    getFlag: function getFlag() {
      var _this$source2, _this$source2$option, _this$source2$option$;
      return (_this$source2 = this.source) === null || _this$source2 === void 0 ? void 0 : (_this$source2$option = _this$source2.option) === null || _this$source2$option === void 0 ? void 0 : (_this$source2$option$ = _this$source2$option.flag) === null || _this$source2$option$ === void 0 ? void 0 : _this$source2$option$.toLowerCase();
    }
  },
  methods: {
    clicked: function clicked() {
      this.$emit('click');
    },
    setVisible: function setVisible() {
      var _this$finalOptions6, _this$source$option2;
      dispatchEvent$1(this, 'list-menu', 'setVisible', this.source.index, !((_this$finalOptions6 = this.finalOptions[this.source.index + 1]) !== null && _this$finalOptions6 !== void 0 && _this$finalOptions6.visible), (_this$source$option2 = this.source.option) === null || _this$source$option2 === void 0 ? void 0 : _this$source$option2.flag);
    },
    onClickItem: function onClickItem(selectAll, valueOption) {
      if (valueOption) {
        if (valueOption.disabled || valueOption.option.disabled || valueOption.originalData.disabled) return;
      }
      if (this.disabled && selectAll && this.multiple) return;
      if (this.source.selectAll) {
        if (selectAll !== null) {
          dispatchEvent$1(this, 'list-menu', 'selectAll', selectAll);
        }
      } else if (!this.source.isLabelGroup) {
        if (this.showRadio) {
          var inputRadio = document.getElementById("".concat(this.idForRadioVariant, "-optionRadio").concat(valueOption === null || valueOption === void 0 ? void 0 : valueOption.option.value));
          if (inputRadio) inputRadio.checked = true;
        }
        dispatchEvent$1(this, 'list-menu', 'simpleValueChange', this.source.index, !this.source.selected);
      }
    },
    setStyles: function setStyles() {
      var left = (this.source.level + 1) * 12;
      this.localStyles = {
        paddingLeft: "".concat(left, "px")
      };
    },
    getDisabled: function getDisabled(option) {
      return option === null || option === void 0 ? void 0 : option.disabled;
    },
    setDisabled: function setDisabled() {
      var _this$source$option3, _this$source3, _this$source3$origina;
      this.pointerSelectAll.pointerEvents = this.disabled || (_this$source$option3 = this.source.option) !== null && _this$source$option3 !== void 0 && _this$source$option3.disabled || (_this$source3 = this.source) !== null && _this$source3 !== void 0 && (_this$source3$origina = _this$source3.originalData) !== null && _this$source3$origina !== void 0 && _this$source3$origina.disabled ? 'none' : 'auto';
      this.pointerDeselectAll.pointerEvents = 'auto';
    },
    getDisabledStyle: function getDisabledStyle() {
      this.pointerStyle.pointerEvents = this.source.disabled ? 'none' : 'auto';
    },
    getIndeterminate: function getIndeterminate(source) {
      var _source$originalData, _source$option;
      return (source === null || source === void 0 ? void 0 : source.indeterminate) || (source === null || source === void 0 ? void 0 : (_source$originalData = source.originalData) === null || _source$originalData === void 0 ? void 0 : _source$originalData.indeterminate) || (source === null || source === void 0 ? void 0 : (_source$option = source.option) === null || _source$option === void 0 ? void 0 : _source$option.indeterminate);
    }
  },
  mounted: function mounted() {
    if (this.showRadio) {
      var _this$source4;
      var inputRadio = document.getElementById("".concat(this.idForRadioVariant, "-optionRadio").concat(this === null || this === void 0 ? void 0 : (_this$source4 = this.source) === null || _this$source4 === void 0 ? void 0 : _this$source4.index));
      if (inputRadio) {
        inputRadio.checked = this === null || this === void 0 ? void 0 : this.source.selected;
      }
    }
    this.setStyles();
    this.setDisabled();
  }
};

/* script */
var __vue_script__$1F = script$1F;

/* template */
var __vue_render__$1F = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-dropdown-item', {
      'aq-dropdown-item--temporal': _vm.source.tempSelected,
      'aq-dropdown-item--selected': _vm.source.selected,
      'aq-dropdown-item--select-all': _vm.source.selectAll,
      'aq-dropdown-item--disabled': _vm.disabled || _vm.getDisabled(_vm.source.option),
      'aq-dropdown-item--label-variant': _vm.source.isLabelGroup,
      'aq-dropdown-item--divider-variant': _vm.source.isDivider
    }],
    style: _vm.localStyles,
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) {
          return null;
        }
        return _vm.onClickItem(false, _vm.source);
      }
    }
  }, [_vm.multiple && !_vm.source.isLabelGroup && _vm.showCheckbox && !_vm.source.selectAll && !_vm.source.isDivider ? _c('aq-checkbox', {
    style: _vm.pointerStyle,
    attrs: {
      "disabled": _vm.getDisabled(_vm.source.option),
      "indeterminate": _vm.getIndeterminate(_vm.source)
    },
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) {
          return null;
        }
        return _vm.onClickItem(false, _vm.source);
      }
    },
    model: {
      value: _vm.source.selected,
      callback: function callback($$v) {
        _vm.$set(_vm.source, "selected", $$v);
      },
      expression: "source.selected"
    }
  }) : _vm._e(), _vm._v(" "), !_vm.multiple && !_vm.source.isLabelGroup && _vm.showRadio && !_vm.source.selectAll && !_vm.source.isDivider ? _c('aq-radio', {
    class: ['aq-dropdown-item__text--radio-variant', {}],
    style: _vm.pointerStyle,
    attrs: {
      "disabled": _vm.getDisabled(_vm.source.option),
      "id": _vm.idForRadioVariant + "-optionRadio" + _vm.source.option.value.toString(),
      "name": _vm.idForRadioVariant + "-selectedOptionRadio",
      "v-model": _vm.source.selected
    },
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) {
          return null;
        }
        return _vm.onClickItem(false, _vm.source);
      }
    }
  }) : _vm._e(), _vm._v(" "), !_vm.source.selectAll ? _c('div', {
    class: ['aq-dropdown-item__text', {
      'aq-dropdown-item__text--no-margin': !_vm.showCheckbox && !_vm.showRadio,
      'aq-dropdown-item__text--radio-variant': _vm.showRadio && !_vm.showCheckbox
    }],
    on: {
      "click": function click($event) {
        return _vm.onClickItem(false, _vm.source);
      }
    }
  }, [_vm.iconDownVisible ? _c('button', {
    staticClass: "aq-dropdown-item__button-list-down button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.setVisible.apply(null, arguments);
      }
    }
  }, [_c('em', {
    class: ['aq-icon-chevron-right aq-dropdown-item__icon-list-down', {
      'aq-dropdown-item__icon-list-down--active': _vm.iconDownActive
    }]
  })]) : _vm._e(), _vm._v(" "), _vm.icon && !_vm.isFlagSelector ? _c('em', {
    class: _vm.icon
  }) : _vm._e(), _vm._v(" "), _vm.isFlagSelector ? [_vm.isFullName ? _c('div', {
    staticClass: "aq-dropdown-item__country"
  }, [_vm.isFlagSelector ? _c('country-flag', {
    staticClass: "aq-dropdown-item__flag--country",
    attrs: {
      "country": _vm.getFlag,
      "size": "normal"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.source.option.naming))])], 1) : _c('div', {
    directives: [{
      name: "aq-tooltip",
      rawName: "v-aq-tooltip",
      value: _vm.source.option.name,
      expression: "source.option.name"
    }],
    staticClass: "aq-dropdown-item__country"
  }, [_vm.isFlagSelector ? _c('country-flag', {
    staticClass: "aq-dropdown-item__flag--country",
    attrs: {
      "country": _vm.getFlag,
      "size": "normal"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.source.option.naming))])], 1)] : _vm._e(), _vm._v(" "), !_vm.source.selectAll ? _vm._t("default", function () {
    return [!_vm.source.isLabelGroup && _vm.highlight && !_vm.source.selectAll && _vm.getTemplateLength === 0 && !_vm.isFlagSelector && !_vm.source.isDivider ? [_c('span', [_vm._v(_vm._s(_vm.textItem.complete ? _vm.textItem.text : _vm.textItem.beforeSelected))]), _vm._v(" "), _c('span', {
      staticClass: "aq-dropdown-item__text--selected"
    }, [_vm._v(_vm._s(_vm.textItem.selected))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.textItem.afterSelected))])] : _vm._e(), _vm._v(" "), _vm.source.isLabelGroup && !_vm.source.isDivider || !_vm.source.isLabelGroup && !_vm.highlight && _vm.getTemplateLength === 0 && !_vm.source.isDivider ? [_c('aq-label', [_vm._v(" " + _vm._s(_vm.$aqT(_vm.textItem.text)))])] : _vm._e(), _vm._v(" "), !_vm.source.isLabelGroup && _vm.getTemplateLength > 0 && !_vm.source.selectAll && !_vm.source.isDivider ? [_c('span', {
      staticStyle: {
        "width": "100%"
      },
      domProps: {
        "innerHTML": _vm._s(_vm.dataTemplate)
      },
      on: {
        "click": _vm.onClickItemTemplate
      }
    })] : _vm._e(), _vm._v(" "), _vm.source.isDivider ? [_c('aq-divider', {
      attrs: {
        "orientation": "horizontal"
      }
    })] : _vm._e()];
  }, {
    "text": _vm.textItem.text,
    "source": _vm.source.originalData
  }) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _vm.source.selectAll ? _c('div', {
    staticClass: "aq-dropdown-item__buttons-select-all"
  }, [_c('div', [_c('aq-button', {
    staticClass: "aq-dropdown-item__button-select-all-left",
    style: _vm.pointerSelectAll,
    attrs: {
      "disabled": !_vm.selectAll || _vm.notificationBanner
    },
    on: {
      "click": function click($event) {
        return _vm.onClickItem(true);
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('aqua.selectAll')) + "\n      ")])], 1), _vm._v(" "), _c('div', [_c('aq-button', {
    staticClass: "aq-dropdown-item__button-select-all-right",
    style: _vm.pointerDeselectAll,
    attrs: {
      "disabled": !_vm.deselectAll
    },
    on: {
      "click": function click($event) {
        return _vm.onClickItem(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('aqua.deselectAll')))])], 1)]) : _vm._e(), _vm._v(" "), _vm.source.selectAll ? _c('span', {
    staticClass: "aq-dropdown-item__separator"
  }) : _vm._e()], 1);
};
var __vue_staticRenderFns__$1F = [];

/* style */
var __vue_inject_styles__$1F = undefined;
/* scoped */
var __vue_scope_id__$1F = undefined;
/* module identifier */
var __vue_module_identifier__$1F = undefined;
/* functional template */
var __vue_is_functional_template__$1F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1F = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1F,
  staticRenderFns: __vue_staticRenderFns__$1F
}, __vue_inject_styles__$1F, __vue_script__$1F, __vue_scope_id__$1F, __vue_is_functional_template__$1F, __vue_module_identifier__$1F, false, undefined, undefined, undefined);
var AqListMenuItem = __vue_component__$1F;

function ownKeys$e(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$f(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$e(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$e(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable no-param-reassign */

var script$1E = {
  name: 'list-menu',
  components: {
    'virtual-list': VirtualList
  },
  mixins: [sizeMixin],
  props: {
    keeps: {
      type: Number,
      default: 24
    },
    estimateSize: {
      type: Number,
      default: 30
    },
    label: {
      type: String,
      default: ''
    },
    valueKey: {
      type: String,
      default: 'id'
    },
    textKey: {
      type: String,
      default: 'name'
    },
    popoverWidth: {
      type: String,
      default: 'auto'
    },
    returnMode: {
      type: String,
      default: ''
    },
    filter: {
      type: String,
      default: ''
    },
    idParent: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'list',
      validator: function validator(x) {
        return ['', 'list', 'select'].includes(x.toLowerCase());
      }
    },
    closeOnClick: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: false
    },
    cleanOnEscape: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowSelectAll: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    focus: {
      type: Boolean,
      default: true
    },
    valueArray: {
      type: Boolean,
      default: false
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    oldValue: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    value: function value(newVal, oldVal) {
      this.validateValue(newVal, oldVal);
    },
    options: function options() {
      this.parseData();
    }
  },
  data: function data() {
    return {
      isVisible: false,
      Item: AqListMenuItem,
      finalOptions: [],
      indexTemporal: -1,
      selected: [],
      poperInstance: null,
      popoverStyle: {
        width: 'auto'
      }
    };
  },
  computed: {
    extraProps: function extraProps() {
      return {
        valueKey: this.valueKey,
        textKey: this.textKey,
        multiple: this.multiple,
        selectAll: this.selectAllProp,
        deselectAll: this.deselectAllProp,
        filterText: this.filter,
        type: this.type,
        finalOptions: this.finalOptions
      };
    },
    selectAllProp: function selectAllProp() {
      var _this$finalOptions, _this$selected;
      return ((_this$finalOptions = this.finalOptions) === null || _this$finalOptions === void 0 ? void 0 : _this$finalOptions.length) - 1 !== ((_this$selected = this.selected) === null || _this$selected === void 0 ? void 0 : _this$selected.length);
    },
    deselectAllProp: function deselectAllProp() {
      var _this$selected2;
      return ((_this$selected2 = this.selected) === null || _this$selected2 === void 0 ? void 0 : _this$selected2.length) > 0;
    },
    filterOptions: function filterOptions() {
      var _this$filter,
        _this = this;
      // TODO: implementar funcion resetTemporal()
      var items = this.finalOptions;
      if (((_this$filter = this.filter) === null || _this$filter === void 0 ? void 0 : _this$filter.length) > 0) {
        var _items;
        items = this.finalOptions.filter(function (item) {
          return item.isLabelGroup || item.selectAll || String(_this.$aqT(item[_this.textKey])).toLowerCase().indexOf(String(_this.filter).toLowerCase()) !== -1;
        });
        items = items.map(function (item, index, arr) {
          if (arr[index].isLabelGroup) {
            if (typeof arr[index + 1] !== 'undefined' && arr[index + 1].isLabelGroup) {
              return false;
            }
            if (index === (arr === null || arr === void 0 ? void 0 : arr.length) - 1) {
              return false;
            }
          }
          return item;
        }).filter(function (item) {
          return !!item;
        });
        if (((_items = items) === null || _items === void 0 ? void 0 : _items.length) === 1 && items[0].selectAll) {
          items = [];
        }
      }
      return items;
    },
    zIndex: function zIndex() {
      return _objectSpread$f({
        zIndex: this.baseZIndex
      }, this.popoverStyle);
    },
    getIsOptions: function getIsOptions() {
      var _this$options;
      return this.options && ((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.length) > 0;
    },
    getIsFilterOptions: function getIsFilterOptions() {
      var _this$filterOptions;
      return ((_this$filterOptions = this.filterOptions) === null || _this$filterOptions === void 0 ? void 0 : _this$filterOptions.length) > 0;
    }
  },
  methods: {
    validateValue: function validateValue(newVal, oldVal) {
      if (this.valueIsValid(newVal) && this.valueIsValid(oldVal)) {
        if (this.multiple) {
          this.validateMultipleValue(newVal);
        } else {
          this.validateUniqueValue(newVal, oldVal);
        }
      }
    },
    valueIsValid: function valueIsValid(val) {
      return val !== undefined && val !== null && val !== false;
    },
    clickOnPopover: function clickOnPopover(event) {
      var refPopover = this.$refs.dropdown_container;
      return refPopover.contains(event.target);
    },
    withParent: function withParent(evt) {
      var _this$idParent;
      var outside = false;
      if (((_this$idParent = this.idParent) === null || _this$idParent === void 0 ? void 0 : _this$idParent.length) > 0) {
        var refPopover = this.$refs.dropdown_container;
        var element = document.getElementById(this.idParent);
        outside = element ? !element.contains(evt.target) : false;
        outside = outside && !refPopover.contains(evt.target);
      }
      return outside;
    },
    setPopoverWidth: function setPopoverWidth() {
      if (this.popoverWidth === 'full') {
        this.popoverStyle.width = "".concat(this.$refs.parent_dropdown.scrollWidth, "px");
      } else {
        this.popoverStyle.width = this.popoverWidth;
      }
    },
    validateClick: function validateClick(item) {
      if ('onClick' in item && typeof item.onClick === 'function') {
        item.onClick(item);
      }
    },
    addPopover: function addPopover() {
      var parent = this.$refs.parent_dropdown;
      var container = this.$refs.dropdown_container;
      if (parent && container && !global[CONFIG_AQUA_POPOVER_TEST_MODE]) {
        this.poperInstance = createPopper(parent, container, {
          placement: 'bottom-start',
          modifiers: [{
            name: 'offset',
            options: {
              offset: [1, 3]
            }
          }]
        });
      }
    },
    parseData: function parseData() {
      var _this$oldValue;
      var _parseDataDropdown = parseDataDropdown(this.options, this.oldValue, this.allowSelectAll, this.multiple, this.valueKey, this.textKey),
        items = _parseDataDropdown.items,
        change = _parseDataDropdown.change;
      this.finalOptions = items;
      if (change || this.oldValue && ((_this$oldValue = this.oldValue) === null || _this$oldValue === void 0 ? void 0 : _this$oldValue.length) > 0 && !change) {
        this.emitValue(this.getSelected());
      }
    },
    keyUp: function keyUp() {
      if (this.indexTemporal - 1 >= 0) {
        var initial = this.indexTemporal;
        this.indexTemporal -= 1;
        if (this.finalOptions[this.indexTemporal].isLabelGroup || this.finalOptions[this.indexTemporal].selectAll) {
          this.indexTemporal -= 1;
          if (this.indexTemporal === -1) {
            this.indexTemporal = initial;
          }
        }
      }
    },
    keyDown: function keyDown() {
      var _this$finalOptions2;
      if (this.indexTemporal + 1 < ((_this$finalOptions2 = this.finalOptions) === null || _this$finalOptions2 === void 0 ? void 0 : _this$finalOptions2.length)) {
        if (this.indexTemporal === -1) {
          this.indexTemporal = this.allowSelectAll ? 1 : 0;
        } else {
          this.indexTemporal += 1;
        }
        if (this.finalOptions[this.indexTemporal].isLabelGroup) {
          this.indexTemporal += 1;
        }
      }
    },
    keyEnter: function keyEnter() {
      var item = this.finalOptions[this.indexTemporal];
      if (item) {
        this.selectItem({
          index: item.index,
          value: !item.selected
        });
      }
    },
    keyEsc: function keyEsc() {
      if (this.cleanOnEscape) {
        this.cleanSelections();
      }
    },
    keyDownEvent: function keyDownEvent(event) {
      var beforeTemp = this.indexTemporal;
      if (event.keyCode === CODE_UP) {
        event.preventDefault();
        this.keyUp();
      } else if (event.keyCode === CODE_DOWN) {
        event.preventDefault();
        this.keyDown();
      } else if (event.keyCode === CODE_ENTER) {
        event.preventDefault();
        this.keyEnter();
      } else if (event.keyCode === CODE_ESC) {
        event.preventDefault();
        this.keyEsc();
      } else {
        this.$emit('setWithFilter', true);
      }
      if (beforeTemp !== -1) {
        if (this.finalOptions[beforeTemp]) {
          this.finalOptions[beforeTemp].tempSelected = false;
        }
      }
      if (this.indexTemporal !== -1) {
        this.finalOptions[this.indexTemporal].tempSelected = true;
      }
    },
    getLastIndex: function getLastIndex(index) {
      var indexLastItem = 0;
      for (var i = index; i < ((_this$finalOptions3 = this.finalOptions) === null || _this$finalOptions3 === void 0 ? void 0 : _this$finalOptions3.length); i += 1) {
        var _this$finalOptions3;
        if (this.finalOptions[i + 1] && this.finalOptions[i + 1].level === 0) {
          indexLastItem = i;
          break;
        }
      }
      if (indexLastItem === 0) {
        var _this$finalOptions4;
        indexLastItem = ((_this$finalOptions4 = this.finalOptions) === null || _this$finalOptions4 === void 0 ? void 0 : _this$finalOptions4.length) - 1;
      }
      return indexLastItem;
    },
    setLevels: function setLevels(level, levels, i) {
      if (level in levels && levels[level] !== null) {
        levels[level] = {
          total: levels[level].total + 1,
          selected: this.finalOptions[i].selected ? levels[level].selected + 1 : levels[level].selected,
          indeterminate: this.finalOptions[i].indeterminate ? levels[level].indeterminate + 1 : levels[level].indeterminate
        };
      } else {
        levels[level] = {
          total: 1,
          selected: this.finalOptions[i].selected ? 1 : 0,
          indeterminate: this.finalOptions[i].indeterminate ? 1 : 0
        };
      }
    },
    setValueArr: function setValueArr(level, levels, i, equalValue) {
      if (!equalValue) {
        levels[level] = _objectSpread$f(_objectSpread$f({}, levels[level]), {}, {
          total: levels[level].total,
          selected: this.finalOptions[i].selected ? levels[level].selected + 1 : levels[level].selected - 1
        });
      }
    },
    setIndeterminateArr: function setIndeterminateArr(level, levels, i, equalState) {
      if (!equalState) {
        levels[level] = _objectSpread$f(_objectSpread$f({}, levels[level]), {}, {
          indeterminate: this.finalOptions[i].indeterminate ? levels[level].indeterminate + 1 : levels[level].indeterminate - 1
        });
      }
    },
    // eslint-disable-next-line
    getIsIndeterminate: function getIsIndeterminate(levels, childrenLevel) {
      return levels[childrenLevel] && (levels[childrenLevel].selected > 0 && levels[childrenLevel].total > levels[childrenLevel].selected || levels[childrenLevel].indeterminate > 0);
    },
    selectUpTree: function selectUpTree(_ref) {
      var index = _ref.index;
      if (this.multiple) {
        var indexLastItem = this.getLastIndex(index);
        var levels = {};
        var isLevelZero = false;
        for (var i = indexLastItem; i >= 0 && !isLevelZero; i -= 1) {
          var level = this.finalOptions[i].level;
          isLevelZero = level === 0;
          this.setLevels(level, levels, i);
          if (this.finalOptions[i + 1] && level < this.finalOptions[i + 1].level) {
            var childrenLevel = level + 1;
            var equalValue = this.finalOptions[i].selected;
            var equalState = this.finalOptions[i].indeterminate;
            this.finalOptions[i].selected = levels[childrenLevel].total === levels[childrenLevel].selected;
            this.finalOptions[i].indeterminate = this.getIsIndeterminate(levels, childrenLevel);
            equalValue = equalValue === this.finalOptions[i].selected;
            equalState = equalState === this.finalOptions[i].indeterminate;
            this.setValueArr(level, levels, i, equalValue);
            this.setIndeterminateArr(level, levels, i, equalState);
            levels[childrenLevel] = null;
          }
        }
      }
    },
    selectTree: function selectTree(_ref2) {
      var index = _ref2.index,
        value = _ref2.value;
      if (this.multiple) {
        var level = this.finalOptions[index].level;
        var stop = false;
        var i = index;
        if (this.finalOptions[i + 1] && level !== this.finalOptions[i + 1].level) {
          while (!stop) {
            stop = !this.finalOptions[i + 1] || level >= this.finalOptions[i + 1].level;
            this.finalOptions[i].selected = value;
            i += 1;
          }
        }
      }
    },
    setSelected: function setSelected(selected) {
      this.selected = selected;
    },
    getSelected: function getSelected() {
      return this.finalOptions.filter(function (option) {
        return option.selected && !option.indeterminate;
      });
    },
    cleanSelections: function cleanSelections() {
      this.selectAll(false, true);
    },
    selectAll: function selectAll(select, emit) {
      if (select) {
        this.filterOptions.forEach(function (option) {
          if (!option.selectAll) {
            option.selected = true;
            option.indeterminate = false;
          }
        });
        if (emit) {
          this.emitValue(this.getSelected());
        }
      } else {
        this.finalOptions.forEach(function (option) {
          option.selected = false;
          option.indeterminate = false;
        });
        if (emit) {
          this.emitValue([]);
        }
      }
    },
    selectItem: function selectItem(_ref3) {
      var _this$selected3, _this$selected$;
      var index = _ref3.index,
        value = _ref3.value;
      if (((_this$selected3 = this.selected) === null || _this$selected3 === void 0 ? void 0 : _this$selected3.length) > 0 && !this.multiple && index === ((_this$selected$ = this.selected[0]) === null || _this$selected$ === void 0 ? void 0 : _this$selected$.index)) {
        return;
      }
      if (!this.multiple) {
        this.selectAll(false, false);
      }
      this.finalOptions[index].selected = value;
      if (this.multiple) {
        this.selectTree({
          index: index,
          value: value
        });
        this.selectUpTree({
          index: index
        });
      }
      this.emitValue(this.getSelected());
    },
    emitValue: function emitValue(value) {
      this.setSelected(value);
      this.$emit(EVENT_NAME_CHANGE, value);
      this.updatePoperInstance();
    },
    updatePoperInstance: function updatePoperInstance() {
      if (this.poperInstance) {
        this.poperInstance.update();
      }
    },
    selectItems: function selectItems(newVal) {
      var _this2 = this;
      var items = [];
      this.selectAll(false, false);
      var finalOptionsCopy = _toConsumableArray$1(this.finalOptions);
      var indexVal = 0;
      var isValueKeys = this.returnMode === 'keys';
      var _loop = function _loop() {
        var item = newVal[indexVal];
        var valueItem = item;
        if (!isValueKeys && _this2.valueKey in item) {
          valueItem = item[_this2.valueKey];
        }
        var i = 0;
        var find = finalOptionsCopy.find(function (x, index) {
          i = index;
          return valueItem === x[_this2.valueKey];
        });
        if (typeof find !== 'undefined') {
          _this2.finalOptions[find.index].selected = true;
          items.push(find);
          finalOptionsCopy.splice(i, 1);
        }
        indexVal += 1;
      };
      while (indexVal < (newVal === null || newVal === void 0 ? void 0 : newVal.length)) {
        _loop();
      }
      if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
        items.sort(function (a, b) {
          if (a.index < b.index) {
            return -1;
          }
          return 1;
        });
        items.forEach(function (item) {
          _this2.selectTree({
            index: item.index,
            value: true
          });
          _this2.selectUpTree({
            index: item.index
          });
        });
      }
      this.emitValue(this.getSelected());
    },
    validateMultipleValue: function validateMultipleValue(newVal) {
      if (!compareValuesByPosition(newVal, this.oldValue, this.valueKey)) {
        this.selectItems(newVal);
      }
    },
    getParseArrayValue: function getParseArrayValue(value) {
      var item;
      if (this.valueArray) {
        var _value = _slicedToArray(value, 1);
        item = _value[0];
        if ((value === null || value === void 0 ? void 0 : value.length) === 0) {
          if (this.returnMode === 'keys') {
            item = '';
          } else {
            item = {};
          }
        }
      } else {
        item = value;
      }
      return item;
    },
    validateUniqueValue: function validateUniqueValue(newVal, oldVal) {
      var _this3 = this;
      var item = null;
      var newValTemp = this.getParseArrayValue(newVal);
      var oldValTemp = this.getParseArrayValue(oldVal);
      if (this.returnMode === 'keys') {
        if (newValTemp !== oldValTemp) {
          item = this.finalOptions.find(function (itemF) {
            return itemF[_this3.valueKey] === newValTemp;
          });
        }
      } else if (newValTemp[this.valueKey] !== oldValTemp[this.valueKey]) {
        item = this.finalOptions.find(function (itemF) {
          return itemF[_this3.valueKey] === newValTemp[_this3.valueKey];
        });
      }
      if (item) {
        this.selectItem({
          index: item.index,
          value: true
        });
      }
    },
    definePopoverInstance: function definePopoverInstance() {
      if (!this.poperInstance) {
        this.addPopover();
      }
    }
  },
  created: function created() {
    var _this4 = this;
    this.$on('simpleValueChange', function (index, value) {
      _this4.selectItem({
        index: index,
        value: value
      });
    });
    this.$on('scroll', function () {
      var element = document.querySelector('.aq-dropdown-item--temporal');
      if (element) {
        _this4.$refs.virutal_list.$el.scrollTop = element.offsetTop - 32;
      }
    });
    this.$on('selectAll', function (value) {
      _this4.selectAll(value, true);
    });
  },
  mounted: function mounted() {
    var _this5 = this;
    this.definePopoverInstance();
    this.parseData();
    setTimeout(function () {
      _this5.validateValue(_this5.value, _this5.oldValue);
    });
  }
};

/* script */
var __vue_script__$1E = script$1E;

/* template */
var __vue_render__$1E = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.getIsOptions ? _c('div', [_vm.getIsFilterOptions ? [_c('virtual-list', {
    ref: "virutal_list",
    staticClass: "aq-dropdown__virtual-list aq-scroll-bar",
    style: _vm.mixinSizeStyle,
    attrs: {
      "data-key": _vm.valueKey,
      "data-sources": _vm.filterOptions,
      "data-component": _vm.Item,
      "keeps": _vm.keeps,
      "estimate-size": _vm.estimateSize,
      "extra-props": _vm.extraProps
    }
  })] : [_c('div', {
    staticClass: "aq-autocomplete-container__no-data"
  }, [_vm._v(_vm._s(_vm.$t('aqua.emptyState')))])]], 2) : _vm._e();
};
var __vue_staticRenderFns__$1E = [];

/* style */
var __vue_inject_styles__$1E = undefined;
/* scoped */
var __vue_scope_id__$1E = undefined;
/* module identifier */
var __vue_module_identifier__$1E = undefined;
/* functional template */
var __vue_is_functional_template__$1E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1E = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1E,
  staticRenderFns: __vue_staticRenderFns__$1E
}, __vue_inject_styles__$1E, __vue_script__$1E, __vue_scope_id__$1E, __vue_is_functional_template__$1E, __vue_module_identifier__$1E, false, undefined, undefined, undefined);
var AqList = __vue_component__$1E;

var PopoverMixin = {
  data: function data() {
    return {
      parentPopover: null
    };
  },
  methods: {
    validateAncestorPopover: function validateAncestorPopover() {
      var parent = this.$parent || this.$root;
      var name = parent.$options.name;
      while (parent && (!name || name !== 'aq-popover')) {
        parent = parent.$parent;
        if (parent) {
          name = parent.$options.name;
        }
      }
      if (parent && name === 'aq-popover') {
        this.parentPopover = parent;
      }
    },
    addToPopover: function addToPopover() {
      if (this.parentPopover) {
        this.parentPopover.popoverChild.push(this);
      }
    },
    removeToPopover: function removeToPopover() {
      if (this.parentPopover) {
        this.parentPopover.popoverChild.splice(this.parentPopover.popoverChild.indexOf(this), 1);
      }
    }
  },
  created: function created() {
    this.validateAncestorPopover();
  },
  mounted: function mounted() {
    this.addToPopover();
  },
  beforeDestroy: function beforeDestroy() {
    this.removeToPopover();
  }
};

function ownKeys$d(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$e(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$d(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$d(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable no-param-reassign */

var script$1D = {
  name: 'list-menu',
  components: {
    'virtual-list': VirtualList,
    ListMenuItem: AqListMenuItem
  },
  mixins: [PopoverMixin, zIndexMixin],
  props: {
    label: {
      type: String,
      default: ''
    },
    valueKey: {
      type: String,
      default: 'id'
    },
    textKey: {
      type: String,
      default: 'text'
    },
    popoverWidth: {
      type: String,
      default: 'auto'
    },
    returnMode: {
      type: String,
      default: ''
    },
    filter: {
      type: String,
      default: ''
    },
    idParent: {
      type: String,
      default: ''
    },
    closeOnClick: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: false
    },
    cleanOnEscape: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    allowSelectAll: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    focus: {
      type: Boolean,
      default: false
    },
    valueArray: {
      type: Boolean,
      default: false
    },
    value: {
      default: function _default() {
        return [];
      }
    },
    oldValue: {
      default: function _default() {
        return [];
      }
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    slotFooter: {
      type: Boolean,
      default: false
    },
    maxSelect: {
      type: Number,
      default: -1
    },
    infoBanner: {
      type: Object,
      default: function _default() {}
    },
    emptyStateMessage: {
      type: [String, Function],
      default: ''
    },
    isFlagSelector: {
      type: Boolean,
      default: false
    },
    showCheckbox: {
      type: Boolean,
      default: true
    },
    showRadio: {
      type: Boolean,
      default: false
    },
    hasPrefix: {
      type: Boolean,
      default: false
    },
    isFullName: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: function value(newVal, oldVal) {
      this.validateValue(newVal, oldVal);
    },
    options: function options() {
      this.parseData();
    },
    isVisible: function isVisible(newVal) {
      this.$emit('active', newVal);
    }
  },
  data: function data() {
    return {
      isVisible: false,
      Item: AqListMenuItem,
      finalOptions: [],
      indexTemporal: -1,
      selected: [],
      poperInstance: null,
      popoverStyle: {
        width: 'auto'
      },
      notificationBanner: false
    };
  },
  computed: {
    extraProps: function extraProps() {
      return {
        valueKey: this.valueKey,
        textKey: this.textKey,
        multiple: this.multiple,
        selectAll: this.selectAllProp,
        deselectAll: this.deselectAllProp,
        filterText: this.filter
      };
    },
    selectAllProp: function selectAllProp() {
      var _this$finalOptions, _this$selected;
      return ((_this$finalOptions = this.finalOptions) === null || _this$finalOptions === void 0 ? void 0 : _this$finalOptions.length) - 1 !== ((_this$selected = this.selected) === null || _this$selected === void 0 ? void 0 : _this$selected.length);
    },
    deselectAllProp: function deselectAllProp() {
      var _this$selected2;
      return ((_this$selected2 = this.selected) === null || _this$selected2 === void 0 ? void 0 : _this$selected2.length) > 0;
    },
    filterOptions: function filterOptions() {
      var _this$filter,
        _this = this;
      // TODO: implementar funcion resetTemporal()
      var items = this.finalOptions;
      if (((_this$filter = this.filter) === null || _this$filter === void 0 ? void 0 : _this$filter.length) > 0) {
        var _items;
        items = this.finalOptions.filter(function (item) {
          var _item$originalData;
          return item.isLabelGroup || item.selectAll || String(_this.$aqT(_this.isFlagSelector ? item === null || item === void 0 ? void 0 : (_item$originalData = item.originalData) === null || _item$originalData === void 0 ? void 0 : _item$originalData.naming : item[_this.textKey])).toLowerCase().indexOf(String(_this.filter).toLowerCase()) !== -1;
        });
        items = items.map(function (item, index, arr) {
          if (arr[index].isLabelGroup) {
            if (typeof arr[index + 1] !== 'undefined' && arr[index + 1].isLabelGroup) {
              return false;
            }
            if (index === (arr === null || arr === void 0 ? void 0 : arr.length) - 1) {
              return false;
            }
          }
          return item;
        }).filter(function (item) {
          return !!item;
        });
        if (((_items = items) === null || _items === void 0 ? void 0 : _items.length) === 1 && items[0].selectAll) {
          items = [];
        }
      }
      return items;
    },
    zIndex: function zIndex() {
      return _objectSpread$e({
        zIndex: this.baseZIndex
      }, this.popoverStyle);
    },
    hasFooterSlot: function hasFooterSlot() {
      return typeof this.$slots.footer !== 'undefined';
    },
    getBannerTitle: function getBannerTitle() {
      var _this$infoBanner;
      return (_this$infoBanner = this.infoBanner) !== null && _this$infoBanner !== void 0 && _this$infoBanner.title ? this.$aqT(this.infoBanner.title) : '';
    },
    getCloseBanner: function getCloseBanner() {
      var _this$infoBanner2;
      return (_this$infoBanner2 = this.infoBanner) !== null && _this$infoBanner2 !== void 0 && _this$infoBanner2.close ? this.infoBanner.close : false;
    },
    getBannerMessage: function getBannerMessage() {
      var _this$infoBanner3;
      return (_this$infoBanner3 = this.infoBanner) !== null && _this$infoBanner3 !== void 0 && _this$infoBanner3.message ? this.infoBanner.message : '';
    },
    getBannerState: function getBannerState() {
      var _this$infoBanner4;
      return (_this$infoBanner4 = this.infoBanner) !== null && _this$infoBanner4 !== void 0 && _this$infoBanner4.state ? this.infoBanner.state : 'warning';
    },
    showBannerNotification: function showBannerNotification() {
      var _this$infoBanner5;
      return this.notificationBanner && ((_this$infoBanner5 = this.infoBanner) === null || _this$infoBanner5 === void 0 ? void 0 : _this$infoBanner5.visible);
    },
    getLabelLength: function getLabelLength() {
      var _this$label;
      return ((_this$label = this.label) === null || _this$label === void 0 ? void 0 : _this$label.length) > 0;
    },
    getIsOptions: function getIsOptions() {
      var _this$options;
      return this.options && ((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.length) > 0;
    },
    getIsFilterOptions: function getIsFilterOptions() {
      var _this$filterOptions;
      return ((_this$filterOptions = this.filterOptions) === null || _this$filterOptions === void 0 ? void 0 : _this$filterOptions.length) > 0;
    },
    hasHeaderSlot: function hasHeaderSlot() {
      return typeof this.$slots.header !== 'undefined';
    }
  },
  methods: {
    validateValue: function validateValue(newVal, oldVal) {
      if (this.valueIsValid(newVal) && this.valueIsValid(oldVal)) {
        if (this.multiple) {
          this.validateMultipleValue(newVal);
        } else {
          this.validateUniqueValue(newVal, oldVal);
        }
      }
    },
    valueIsValid: function valueIsValid(val) {
      return val !== undefined && val !== null && val !== false;
    },
    show: function show() {
      var _this2 = this;
      if (!this.disabled) {
        this.definePopoverInstance();
        this.isVisible = true;
        this.setPopoverWidth();
        this.$emit(EVENT_NAME_OPEN);
        this.updatePoperInstance();
        if (this.focus) {
          setTimeout(function () {
            _this2.$refs.dropdown_container.focus();
          });
        }
        this.setZIndex();
        document.addEventListener('click', this.documentOutside);
        document.addEventListener('keydown', this.keyDownEvent);
      }
    },
    hide: function hide() {
      if (this.isVisible) {
        this.isVisible = false;
        this.$emit(EVENT_NAME_CLOSE);
        this.deleteZIndex();
        document.removeEventListener('click', this.documentOutside);
        document.removeEventListener('keydown', this.keyDownEvent);
      }
    },
    documentOutside: function documentOutside(evt) {
      if (this.isVisible) {
        var refMenu = this.$refs.menu;
        var refPopover = this.$refs.dropdown_container;
        if (refPopover.contains(evt.target) && this.closeOnClick || this.withParent(evt) || !refMenu.contains(evt.target) && !refPopover.contains(evt.target)) {
          this.hide();
        }
      }
    },
    clickOnPopover: function clickOnPopover(event) {
      var refPopover = this.$refs.dropdown_container;
      return refPopover.contains(event.target);
    },
    withParent: function withParent(evt) {
      var _this$idParent;
      var outside = false;
      if (((_this$idParent = this.idParent) === null || _this$idParent === void 0 ? void 0 : _this$idParent.length) > 0) {
        var refPopover = this.$refs.dropdown_container;
        var element = document.getElementById(this.idParent);
        outside = element ? !element.contains(evt.target) : false;
        outside = outside && !refPopover.contains(evt.target);
      }
      return outside;
    },
    toggleShow: function toggleShow() {
      if (this.isVisible) {
        this.hide();
      } else {
        this.show();
      }
    },
    setPopoverWidth: function setPopoverWidth() {
      if (this.popoverWidth === 'full') {
        this.popoverStyle.width = "".concat(this.$refs.parent_dropdown.scrollWidth, "px");
      } else {
        this.popoverStyle.width = this.popoverWidth;
      }
    },
    validateClick: function validateClick(item) {
      if ('onClick' in item && typeof item.onClick === 'function') {
        item.onClick(item);
      }
    },
    addPopover: function addPopover() {
      var parent = this.$refs.parent_dropdown;
      var container = this.$refs.dropdown_container;
      if (parent && container && !global[CONFIG_AQUA_POPOVER_TEST_MODE]) {
        this.poperInstance = createPopper(parent, container, {
          placement: 'bottom-start',
          modifiers: [{
            name: 'offset',
            options: {
              offset: [1, 3]
            }
          }]
        });
      }
    },
    parseData: function parseData() {
      var _this$oldValue2;
      var value;
      if (this.multiple) {
        var _this$oldValue;
        value = ((_this$oldValue = this.oldValue) === null || _this$oldValue === void 0 ? void 0 : _this$oldValue.length) > 0 ? this.oldValue : this.value;
      } else {
        var _Object$keys;
        value = ((_Object$keys = Object.keys(this.oldValue)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0 ? this.oldValue : this.value;
      }
      var _parseDataDropdown = parseDataDropdown(this.options, value, this.allowSelectAll, this.multiple, this.valueKey, this.textKey),
        items = _parseDataDropdown.items,
        change = _parseDataDropdown.change;
      this.finalOptions = items;
      if (change || this.oldValue && ((_this$oldValue2 = this.oldValue) === null || _this$oldValue2 === void 0 ? void 0 : _this$oldValue2.length) > 0 && !change) {
        this.emitValue(this.getSelected());
      }
    },
    keyUp: function keyUp() {
      if (this.indexTemporal - 1 >= 0) {
        var initial = this.indexTemporal;
        this.indexTemporal -= 1;
        if (this.finalOptions[this.indexTemporal].isLabelGroup || this.finalOptions[this.indexTemporal].selectAll) {
          this.indexTemporal -= 1;
          if (this.indexTemporal === -1) {
            this.indexTemporal = initial;
          }
        }
      }
    },
    keyDown: function keyDown() {
      var _this$finalOptions2;
      if (this.indexTemporal + 1 < ((_this$finalOptions2 = this.finalOptions) === null || _this$finalOptions2 === void 0 ? void 0 : _this$finalOptions2.length)) {
        if (this.indexTemporal === -1) {
          this.indexTemporal = this.allowSelectAll ? 1 : 0;
        } else {
          this.indexTemporal += 1;
        }
        if (this.finalOptions[this.indexTemporal].isLabelGroup) {
          this.indexTemporal += 1;
        }
      }
    },
    keyEnter: function keyEnter() {
      var item = this.finalOptions[this.indexTemporal];
      if (item) {
        this.selectItem({
          index: item.index,
          value: !item.selected
        });
      }
    },
    keyEsc: function keyEsc() {
      if (this.cleanOnEscape) {
        this.cleanSelections();
      }
    },
    keyDownEvent: function keyDownEvent(event) {
      var beforeTemp = this.indexTemporal;
      if (event.keyCode === CODE_UP) {
        event.preventDefault();
        this.keyUp();
      } else if (event.keyCode === CODE_DOWN) {
        event.preventDefault();
        this.keyDown();
      } else if (event.keyCode === CODE_ENTER) {
        event.preventDefault();
        this.keyEnter();
      } else if (event.keyCode === CODE_ESC) {
        event.preventDefault();
        this.keyEsc();
      } else {
        this.$emit('setWithFilter', true);
      }
      if (beforeTemp !== -1) {
        if (this.finalOptions[beforeTemp]) {
          this.finalOptions[beforeTemp].tempSelected = false;
        }
      }
      if (this.indexTemporal !== -1) {
        this.finalOptions[this.indexTemporal].tempSelected = true;
      }
    },
    getLastIndex: function getLastIndex(index) {
      var indexLastItem = 0;
      for (var i = index; i < ((_this$finalOptions3 = this.finalOptions) === null || _this$finalOptions3 === void 0 ? void 0 : _this$finalOptions3.length); i += 1) {
        var _this$finalOptions3;
        if (this.finalOptions[i + 1] && this.finalOptions[i + 1].level === 0) {
          indexLastItem = i;
          break;
        }
      }
      if (indexLastItem === 0) {
        var _this$finalOptions4;
        indexLastItem = ((_this$finalOptions4 = this.finalOptions) === null || _this$finalOptions4 === void 0 ? void 0 : _this$finalOptions4.length) - 1;
      }
      return indexLastItem;
    },
    setLevels: function setLevels(level, levels, i) {
      if (level in levels && levels[level] !== null) {
        levels[level] = {
          total: levels[level].total + 1,
          selected: this.finalOptions[i].selected ? levels[level].selected + 1 : levels[level].selected,
          indeterminate: this.finalOptions[i].indeterminate ? levels[level].indeterminate + 1 : levels[level].indeterminate
        };
      } else {
        levels[level] = {
          total: 1,
          selected: this.finalOptions[i].selected ? 1 : 0,
          indeterminate: this.finalOptions[i].indeterminate ? 1 : 0
        };
      }
    },
    setValueArr: function setValueArr(level, levels, i, equalValue) {
      if (!equalValue) {
        levels[level] = _objectSpread$e(_objectSpread$e({}, levels[level]), {}, {
          total: levels[level].total,
          selected: this.finalOptions[i].selected ? levels[level].selected + 1 : levels[level].selected - 1
        });
      }
    },
    setIndeterminateArr: function setIndeterminateArr(level, levels, i, equalState) {
      if (!equalState) {
        levels[level] = _objectSpread$e(_objectSpread$e({}, levels[level]), {}, {
          indeterminate: this.finalOptions[i].indeterminate ? levels[level].indeterminate + 1 : levels[level].indeterminate - 1
        });
      }
    },
    // eslint-disable-next-line
    getIsIndeterminate: function getIsIndeterminate(levels, childrenLevel) {
      return levels[childrenLevel] && (levels[childrenLevel].selected > 0 && levels[childrenLevel].total > levels[childrenLevel].selected || levels[childrenLevel].indeterminate > 0);
    },
    selectUpTree: function selectUpTree(_ref) {
      var index = _ref.index;
      if (this.multiple) {
        var indexLastItem = this.getLastIndex(index);
        var levels = {};
        var isLevelZero = false;
        for (var i = indexLastItem; i >= 0 && !isLevelZero; i -= 1) {
          var level = this.finalOptions[i].level;
          isLevelZero = level === 0;
          this.setLevels(level, levels, i);
          if (this.finalOptions[i + 1] && level < this.finalOptions[i + 1].level) {
            var childrenLevel = level + 1;
            var equalValue = this.finalOptions[i].selected;
            var equalState = this.finalOptions[i].indeterminate;
            this.finalOptions[i].selected = levels[childrenLevel].total === levels[childrenLevel].selected;
            this.finalOptions[i].indeterminate = this.getIsIndeterminate(levels, childrenLevel);
            equalValue = equalValue === this.finalOptions[i].selected;
            equalState = equalState === this.finalOptions[i].indeterminate;
            this.setValueArr(level, levels, i, equalValue);
            this.setIndeterminateArr(level, levels, i, equalState);
            levels[childrenLevel] = null;
          }
        }
      }
    },
    selectTree: function selectTree(_ref2) {
      var index = _ref2.index,
        value = _ref2.value;
      if (this.multiple) {
        var level = this.finalOptions[index].level;
        var stop = false;
        var i = index;
        if (this.finalOptions[i + 1] && level !== this.finalOptions[i + 1].level) {
          while (!stop) {
            stop = !this.finalOptions[i + 1] || level >= this.finalOptions[i + 1].level;
            this.finalOptions[i].selected = value;
            i += 1;
          }
        }
      }
    },
    setSelected: function setSelected(selected) {
      this.selected = selected;
    },
    getSelected: function getSelected() {
      return this.finalOptions.filter(function (option) {
        return option.selected && !option.indeterminate;
      });
    },
    cleanSelections: function cleanSelections() {
      this.selectAll(false, true);
      this.hide();
    },
    selectAll: function selectAll(select, emit) {
      if (select) {
        this.filterOptions.forEach(function (option) {
          if (!option.selectAll) {
            option.selected = true;
            option.indeterminate = false;
          }
        });
        if (emit) {
          this.emitValue(this.getSelected());
        }
      } else {
        this.finalOptions.forEach(function (option) {
          option.selected = false;
          option.indeterminate = false;
        });
        if (emit) {
          this.emitValue([]);
        }
      }
    },
    selectItem: function selectItem(_ref3) {
      var _this$selected3, _this$selected$;
      var index = _ref3.index,
        value = _ref3.value;
      if (((_this$selected3 = this.selected) === null || _this$selected3 === void 0 ? void 0 : _this$selected3.length) > 0 && !this.multiple && index === ((_this$selected$ = this.selected[0]) === null || _this$selected$ === void 0 ? void 0 : _this$selected$.index)) {
        return;
      }
      if (!this.multiple) {
        this.selectAll(false, false);
      }
      this.finalOptions[index].selected = value;
      if (this.multiple) {
        this.selectTree({
          index: index,
          value: value
        });
        this.selectUpTree({
          index: index
        });
      }
      this.emitValue(this.getSelected());
    },
    emitValue: function emitValue(value) {
      this.notificationBanner = this.multiple && (value === null || value === void 0 ? void 0 : value.length) >= this.maxSelect && this.maxSelect > 0;
      this.setDisabled();
      this.setSelected(value);
      this.$emit(EVENT_NAME_CHANGE, value);
      this.updatePoperInstance();
    },
    updatePoperInstance: function updatePoperInstance() {
      if (this.poperInstance) {
        this.poperInstance.update();
      }
    },
    selectItems: function selectItems(newVal) {
      var _this3 = this;
      var items = [];
      this.selectAll(false, false);
      var finalOptionsCopy = _toConsumableArray$1(this.finalOptions);
      var indexVal = 0;
      var isValueKeys = this.returnMode === 'keys';
      var _loop = function _loop() {
        var item = newVal[indexVal];
        var valueItem = item;
        if (!isValueKeys && _this3.valueKey in item) {
          valueItem = item[_this3.valueKey];
        }
        var i = 0;
        var find = finalOptionsCopy.find(function (x, index) {
          i = index;
          return valueItem === x[_this3.valueKey];
        });
        if (typeof find !== 'undefined') {
          _this3.finalOptions[find.index].selected = true;
          items.push(find);
          finalOptionsCopy.splice(i, 1);
        }
        indexVal += 1;
      };
      while (indexVal < (newVal === null || newVal === void 0 ? void 0 : newVal.length)) {
        _loop();
      }
      if ((items === null || items === void 0 ? void 0 : items.length) > 0) {
        items.sort(function (a, b) {
          if (a.index < b.index) {
            return -1;
          }
          return 1;
        });
        items.forEach(function (item) {
          _this3.selectTree({
            index: item.index,
            value: true
          });
          _this3.selectUpTree({
            index: item.index
          });
        });
      }
      this.emitValue(this.getSelected());
    },
    validateMultipleValue: function validateMultipleValue(newVal) {
      if (!compareValuesByPosition(newVal, this.oldValue, this.valueKey)) {
        this.selectItems(newVal);
      }
    },
    getParseArrayValue: function getParseArrayValue(value) {
      var item;
      if (this.valueArray) {
        var _value = _slicedToArray(value, 1);
        item = _value[0];
        if ((value === null || value === void 0 ? void 0 : value.length) === 0) {
          if (this.returnMode === 'keys') {
            item = '';
          } else {
            item = {};
          }
        }
      } else {
        item = value;
      }
      return item;
    },
    validateUniqueValue: function validateUniqueValue(newVal, oldVal) {
      var _this4 = this;
      var item = null;
      var newValTemp = this.getParseArrayValue(newVal);
      var oldValTemp = this.getParseArrayValue(oldVal);
      if (this.returnMode === 'keys') {
        if (newValTemp !== oldValTemp) {
          item = this.finalOptions.find(function (itemF) {
            return itemF[_this4.valueKey] === newValTemp;
          });
        }
      } else if (newValTemp[this.valueKey] !== oldValTemp[this.valueKey]) {
        item = this.finalOptions.find(function (itemF) {
          return itemF[_this4.valueKey] === newValTemp[_this4.valueKey];
        });
      }
      if (item) {
        this.selectItem({
          index: item.index,
          value: true
        });
      } else if (this.validateValueKey(newVal)) {
        this.selectAll(false, true);
      }
    },
    validateValueKey: function validateValueKey(newVal) {
      var val = newVal;
      if (this.valueArray && Array.isArray(newVal)) {
        var _newVal = _slicedToArray(newVal, 1);
        val = _newVal[0];
      }
      return val && (val === '' || typeof val !== 'number' && typeof val !== 'string' && !(this.valueKey in val));
    },
    definePopoverInstance: function definePopoverInstance() {
      if (!this.poperInstance) {
        this.addPopover();
      }
    },
    setDisabled: function setDisabled() {
      if (this.notificationBanner) {
        this.finalOptions.forEach(function (option) {
          if (!option.selected) {
            option.disabled = true;
          }
        });
      } else {
        this.finalOptions.forEach(function (option) {
          if (!option.selected) {
            option.disabled = false;
          }
        });
      }
    },
    getIsLabeGroup: function getIsLabeGroup(item) {
      return item === null || item === void 0 ? void 0 : item.isLabelGroup;
    }
  },
  created: function created() {
    var _this5 = this;
    this.$on('simpleValueChange', function (index, value) {
      _this5.selectItem({
        index: index,
        value: value
      });
      if (_this5.closeOnSelect) {
        _this5.hide();
      }
    });
    this.$on('scroll', function () {
      var element = document.querySelector('.aq-dropdown-item--temporal');
      if (element) {
        _this5.$refs.virutal_list.$el.scrollTop = element.offsetTop - 32;
      }
    });
    this.$on('selectAll', function (value) {
      _this5.selectAll(value, true);
    });
    this.idForRadioVariant = this.showRadio ? AquaRamdomId('-list-menu') : '';
  },
  mounted: function mounted() {
    var _this6 = this;
    this.definePopoverInstance();
    appendEl({
      children: this.$refs.dropdown_container
    });
    this.parseData();
    this.$root.$on('aq::popovers::close', this.hide);
    setTimeout(function () {
      _this6.validateValue(_this6.value, _this6.oldValue);
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.hide();
    removeEl({
      children: this.$refs.dropdown_container
    });
    this.$root.$off('aq::popovers::close', this.hide);
  }
};

/* script */
var __vue_script__$1D = script$1D;

/* template */
var __vue_render__$1D = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "menu",
    staticClass: "aq-dropdown"
  }, [_c('div', {
    ref: "parent_dropdown",
    staticClass: "aq-dropdown__activator",
    on: {
      "click": function click($event) {
        return _vm.show();
      }
    }
  }, [_vm._t("default", function () {
    return [_vm.getLabelLength ? [_c('aq-button', {
      on: {
        "click": function click($event) {
          return _vm.toggleShow();
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$aqT(_vm.label)) + "\n        ")])] : [_vm._v(" Slot default ")]];
  }, {
    "isActive": _vm.isVisible
  })], 2), _vm._v(" "), _c('div', {
    ref: "dropdown_container",
    class: ['aq-dropdown__container', {
      'aq-dropdown__container--show': _vm.isVisible,
      'aq-dropdown__container--hide': !_vm.isVisible
    }],
    style: _vm.zIndex,
    attrs: {
      "tabindex": "1"
    }
  }, [_vm.getIsOptions ? _c('div', [_vm.showBannerNotification ? _c('aq-banner', {
    staticClass: "aq-dropdown__banner",
    attrs: {
      "title": _vm.getBannerTitle,
      "close": _vm.getCloseBanner,
      "state": _vm.getBannerState
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$aqT(_vm.getBannerMessage)))]) : _vm._e(), _vm._v(" "), _vm.getIsFilterOptions ? [_c('virtual-list', {
    ref: "virutal_list",
    staticClass: "aq-dropdown__virtual-list aq-scroll-bar",
    attrs: {
      "data-key": _vm.valueKey,
      "data-sources": _vm.filterOptions,
      "data-component": _vm.Item,
      "keeps": 24,
      "estimate-size": 30,
      "extra-props": _vm.extraProps,
      "isFlagSelector": _vm.isFlagSelector,
      "hasPrefix": _vm.hasPrefix,
      "isFullName": _vm.isFullName
    },
    scopedSlots: _vm._u([_vm.hasHeaderSlot ? {
      key: "header",
      fn: function fn() {
        return [_vm._t("header")];
      },
      proxy: true
    } : null, {
      key: "item",
      fn: function fn(ref) {
        var scope = ref.scope;
        return [_c('ListMenuItem', _vm._b({
          attrs: {
            "isFlagSelector": _vm.isFlagSelector,
            "showCheckbox": _vm.showCheckbox,
            "showRadio": _vm.showRadio,
            "idForRadioVariant": _vm.idForRadioVariant,
            "hasPrefix": _vm.hasPrefix,
            "notificationBanner": _vm.notificationBanner,
            "isFullName": _vm.isFullName
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function fn(ref) {
              var text = ref.text;
              var source = ref.source;
              return [!_vm.getIsLabeGroup(source) ? _vm._t("item", null, {
                "text": text,
                "source": source
              }) : _vm._e()];
            }
          }], null, true)
        }, 'ListMenuItem', scope, false))];
      }
    }], null, true)
  })] : [_vm.hasHeaderSlot ? _vm._t("header") : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aq-autocomplete-container__no-data"
  }, [_vm._v("\n          " + _vm._s(_vm.emptyStateMessage !== '' ? _vm.$aqT(_vm.emptyStateMessage) : _vm.$t('aqua.emptyState')) + "\n        ")])]], 2) : _c('div', [_vm._t("content", function () {
    return [_vm.hasHeaderSlot ? [_vm._t("header")] : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "aq-autocomplete-container__no-data"
    }, [_vm._v("\n          " + _vm._s(_vm.emptyStateMessage !== '' ? _vm.$aqT(_vm.emptyStateMessage) : _vm.$t('aqua.emptyState')) + "\n        ")])];
  })], 2), _vm._v(" "), _vm.hasFooterSlot ? _c('div', [[_c('aq-divider', {
    attrs: {
      "horizontal": ""
    }
  }), _vm._v(" "), _vm._t("footer")]], 2) : _vm._e()])]);
};
var __vue_staticRenderFns__$1D = [];

/* style */
var __vue_inject_styles__$1D = undefined;
/* scoped */
var __vue_scope_id__$1D = undefined;
/* module identifier */
var __vue_module_identifier__$1D = undefined;
/* functional template */
var __vue_is_functional_template__$1D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1D = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1D,
  staticRenderFns: __vue_staticRenderFns__$1D
}, __vue_inject_styles__$1D, __vue_script__$1D, __vue_scope_id__$1D, __vue_is_functional_template__$1D, __vue_module_identifier__$1D, false, undefined, undefined, undefined);
var AqListMenu = __vue_component__$1D;

//
var script$1C = {
  name: 'tree-menu-item',
  props: {
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    currentId: {
      type: [String, Number],
      default: function _default() {
        return 0;
      }
    },
    valueKey: {
      type: String,
      default: function _default() {
        return 'id';
      }
    },
    textKey: {
      type: String,
      default: function _default() {
        return 'name';
      }
    },
    optionsKey: {
      type: String,
      default: function _default() {
        return 'options';
      }
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },
  computed: {
    hasChildren: function hasChildren() {
      var _this$options;
      return ((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.length) > 0;
    },
    customStyle: function customStyle() {
      var _this$item;
      return {
        paddingLeft: "".concat(((_this$item = this.item) === null || _this$item === void 0 ? void 0 : _this$item.level) * 16 + 20 + (!this.hasChildren ? 24 : 0), "px")
      };
    },
    getItem: function getItem() {
      var _this$item2, _this$item2$icon;
      return ((_this$item2 = this.item) === null || _this$item2 === void 0 ? void 0 : (_this$item2$icon = _this$item2.icon) === null || _this$item2$icon === void 0 ? void 0 : _this$item2$icon.length) > 0 ? this.item.icon : 'aq-icon-folder';
    }
  },
  methods: {
    toggle: function toggle() {
      if (this.$refs.collapse && this.item.isOpen) {
        this.$refs.collapse.style.height = "".concat(this.$refs.collapse.scrollHeight, "px");
      }
      this.item.isOpen = !this.item.isOpen;
    },
    selectValue: function selectValue() {
      dispatchEvent$1(this, 'aq-tree-menu', 'select-item', this.item);
    },
    beforeEnter: function beforeEnter(el) {
      el.style.height = '0';
    },
    enter: function enter(el) {
      el.style.height = "".concat(el.scrollHeight, "px");
      setTimeout(function () {
        el.style.height = 'auto';
      }, 200);
    },
    beforeLeave: function beforeLeave(el) {
      el.style.height = "".concat(el.scrollHeight, "px");
    },
    leave: function leave(el) {
      el.style.height = '0';
    }
  }
};

/* script */
var __vue_script__$1C = script$1C;

/* template */
var __vue_render__$1C = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-tree-menu-item"
  }, [_c('div', {
    class: ['aq-tree-menu-item__content', {
      'aq-tree-menu-item__content--active': _vm.item[_vm.valueKey] === _vm.currentId
    }],
    style: _vm.customStyle,
    on: {
      "click": _vm.selectValue
    }
  }, [_vm.hasChildren ? _c('aq-button', {
    class: ['aq-tree-menu-item__icon-down', {
      'aq-tree-menu-item__icon-down--open': _vm.item.isOpen
    }],
    attrs: {
      "plain": "",
      "size": "small",
      "icon": "aq-icon-chevron-down"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.toggle.apply(null, arguments);
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aq-tree-menu-item__content-info aq-tree-menu-item__icon-item"
  }, [_c('em', {
    class: _vm.getItem
  }), _vm._v(" "), _c('span', {
    staticClass: "aq-tree-menu-item__text"
  }, [_vm._t("default")], 2)])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "collapse"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "before-leave": _vm.beforeLeave,
      "leave": _vm.leave
    }
  }, [_vm.hasChildren && _vm.item.isOpen ? _c('div', {
    ref: "collapse",
    staticClass: "aq-tree-menu-item__child"
  }, _vm._l(_vm.options, function (option, i) {
    return _c('tree-menu-item', {
      key: i,
      attrs: {
        "options": option[_vm.optionsKey],
        "item": option,
        "currentId": _vm.currentId,
        "valueKey": _vm.valueKey,
        "textKey": _vm.textKey,
        "optionsKey": _vm.optionsKey
      }
    }, [_vm._v(_vm._s(option[_vm.textKey]))]);
  }), 1) : _vm._e()])], 1);
};
var __vue_staticRenderFns__$1C = [];

/* style */
var __vue_inject_styles__$1C = undefined;
/* scoped */
var __vue_scope_id__$1C = undefined;
/* module identifier */
var __vue_module_identifier__$1C = undefined;
/* functional template */
var __vue_is_functional_template__$1C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1C = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1C,
  staticRenderFns: __vue_staticRenderFns__$1C
}, __vue_inject_styles__$1C, __vue_script__$1C, __vue_scope_id__$1C, __vue_is_functional_template__$1C, __vue_module_identifier__$1C, false, undefined, undefined, undefined);
var TreeMenuItem = __vue_component__$1C;

function ownKeys$c(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$d(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$c(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$c(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var script$1B = {
  name: 'aq-tree-menu',
  components: {
    TreeMenuItem: TreeMenuItem
  },
  mixins: [sizeMixin],
  props: {
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    valueKey: {
      type: String,
      default: function _default() {
        return 'id';
      }
    },
    textKey: {
      type: String,
      default: function _default() {
        return 'name';
      }
    },
    optionsKey: {
      type: String,
      default: function _default() {
        return 'options';
      }
    }
  },
  data: function data() {
    return {
      localOptions: [],
      currentItem: {}
    };
  },
  watch: {
    options: {
      handler: function handler() {
        this.setLocalOptions();
      },
      immediate: true
    },
    localOptions: {
      handler: function handler() {
        this.emitLocalOptions();
      },
      deep: true
    },
    value: {
      handler: function handler() {
        this.onValueChange();
      }
    }
  },
  computed: {
    currentId: function currentId() {
      var _this$currentItem;
      return (_this$currentItem = this.currentItem) !== null && _this$currentItem !== void 0 && _this$currentItem[this.valueKey] ? this.currentItem[this.valueKey] : 0;
    }
  },
  methods: {
    getLevel: function getLevel(item, level) {
      var _item$this$optionsKey2,
        _this = this;
      var closeAll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var isOpen = null;
      if (closeAll) {
        isOpen = false;
      } else {
        var _item$this$optionsKey;
        isOpen = !!(((_item$this$optionsKey = item[this.optionsKey]) === null || _item$this$optionsKey === void 0 ? void 0 : _item$this$optionsKey.length) > 0 && item.isOpen);
      }
      var newItem = _objectSpread$d(_objectSpread$d({}, item), {}, {
        level: level,
        isOpen: isOpen
      });
      if (((_item$this$optionsKey2 = item[this.optionsKey]) === null || _item$this$optionsKey2 === void 0 ? void 0 : _item$this$optionsKey2.length) > 0) {
        newItem[this.optionsKey] = item[this.optionsKey].map(function (option) {
          return _this.getLevel(option, level + 1);
        });
      }
      return newItem;
    },
    setLocalOptions: function setLocalOptions() {
      var _this2 = this;
      var closeAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      this.localOptions = this.options.map(function (item) {
        return _this2.getLevel(item, 0, closeAll);
      });
      this.emitLocalOptions();
    },
    emitLocalOptions: function emitLocalOptions() {
      this.$emit('parsedOptions', this.localOptions);
    },
    onSelect: function onSelect(item) {
      this.currentItem = item;
      this.$emit('input', item);
    },
    registerSelectEvent: function registerSelectEvent() {
      this.$on('select-item', this.onSelect);
    },
    unRegisterSelectEvent: function unRegisterSelectEvent() {
      this.$off('select-item', this.onSelect);
    },
    onValueChange: function onValueChange() {
      this.currentItem = this.value;
    },
    closeAllFiles: function closeAllFiles() {
      this.setLocalOptions(true);
    }
  },
  mounted: function mounted() {
    this.registerSelectEvent();
    this.onValueChange();
  },
  beforeDestroy: function beforeDestroy() {
    this.unRegisterSelectEvent();
  }
};

/* script */
var __vue_script__$1B = script$1B;

/* template */
var __vue_render__$1B = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-tree-menu aq-scroll-bar",
    style: _vm.mixinSizeStyle
  }, _vm._l(_vm.localOptions, function (option, i) {
    return _c('TreeMenuItem', {
      key: i,
      attrs: {
        "options": option[_vm.optionsKey],
        "item": option,
        "currentId": _vm.currentId,
        "valueKey": _vm.valueKey,
        "textKey": _vm.textKey,
        "optionsKey": _vm.optionsKey
      }
    }, [_vm._v("\n    " + _vm._s(option[_vm.textKey]) + "\n  ")]);
  }), 1);
};
var __vue_staticRenderFns__$1B = [];

/* style */
var __vue_inject_styles__$1B = undefined;
/* scoped */
var __vue_scope_id__$1B = undefined;
/* module identifier */
var __vue_module_identifier__$1B = undefined;
/* functional template */
var __vue_is_functional_template__$1B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1B = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1B,
  staticRenderFns: __vue_staticRenderFns__$1B
}, __vue_inject_styles__$1B, __vue_script__$1B, __vue_scope_id__$1B, __vue_is_functional_template__$1B, __vue_module_identifier__$1B, false, undefined, undefined, undefined);
var AqTreeMenu = __vue_component__$1B;

var howler = {};

/*!
 *  howler.js v2.2.3
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */

(function (exports) {
(function() {

  /** Global Methods **/
  /***************************************************************************/

  /**
   * Create the global controller. All contained methods and properties apply
   * to all sounds that are currently playing or will be in the future.
   */
  var HowlerGlobal = function() {
    this.init();
  };
  HowlerGlobal.prototype = {
    /**
     * Initialize the global Howler object.
     * @return {Howler}
     */
    init: function() {
      var self = this || Howler;

      // Create a global ID counter.
      self._counter = 1000;

      // Pool of unlocked HTML5 Audio objects.
      self._html5AudioPool = [];
      self.html5PoolSize = 10;

      // Internal properties.
      self._codecs = {};
      self._howls = [];
      self._muted = false;
      self._volume = 1;
      self._canPlayEvent = 'canplaythrough';
      self._navigator = (typeof window !== 'undefined' && window.navigator) ? window.navigator : null;

      // Public properties.
      self.masterGain = null;
      self.noAudio = false;
      self.usingWebAudio = true;
      self.autoSuspend = true;
      self.ctx = null;

      // Set to false to disable the auto audio unlocker.
      self.autoUnlock = true;

      // Setup the various state values for global tracking.
      self._setup();

      return self;
    },

    /**
     * Get/set the global volume for all sounds.
     * @param  {Float} vol Volume from 0.0 to 1.0.
     * @return {Howler/Float}     Returns self or current volume.
     */
    volume: function(vol) {
      var self = this || Howler;
      vol = parseFloat(vol);

      // If we don't have an AudioContext created yet, run the setup.
      if (!self.ctx) {
        setupAudioContext();
      }

      if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
        self._volume = vol;

        // Don't update any of the nodes if we are muted.
        if (self._muted) {
          return self;
        }

        // When using Web Audio, we just need to adjust the master gain.
        if (self.usingWebAudio) {
          self.masterGain.gain.setValueAtTime(vol, Howler.ctx.currentTime);
        }

        // Loop through and change volume for all HTML5 audio nodes.
        for (var i=0; i<self._howls.length; i++) {
          if (!self._howls[i]._webAudio) {
            // Get all of the sounds in this Howl group.
            var ids = self._howls[i]._getSoundIds();

            // Loop through all sounds and change the volumes.
            for (var j=0; j<ids.length; j++) {
              var sound = self._howls[i]._soundById(ids[j]);

              if (sound && sound._node) {
                sound._node.volume = sound._volume * vol;
              }
            }
          }
        }

        return self;
      }

      return self._volume;
    },

    /**
     * Handle muting and unmuting globally.
     * @param  {Boolean} muted Is muted or not.
     */
    mute: function(muted) {
      var self = this || Howler;

      // If we don't have an AudioContext created yet, run the setup.
      if (!self.ctx) {
        setupAudioContext();
      }

      self._muted = muted;

      // With Web Audio, we just need to mute the master gain.
      if (self.usingWebAudio) {
        self.masterGain.gain.setValueAtTime(muted ? 0 : self._volume, Howler.ctx.currentTime);
      }

      // Loop through and mute all HTML5 Audio nodes.
      for (var i=0; i<self._howls.length; i++) {
        if (!self._howls[i]._webAudio) {
          // Get all of the sounds in this Howl group.
          var ids = self._howls[i]._getSoundIds();

          // Loop through all sounds and mark the audio node as muted.
          for (var j=0; j<ids.length; j++) {
            var sound = self._howls[i]._soundById(ids[j]);

            if (sound && sound._node) {
              sound._node.muted = (muted) ? true : sound._muted;
            }
          }
        }
      }

      return self;
    },

    /**
     * Handle stopping all sounds globally.
     */
    stop: function() {
      var self = this || Howler;

      // Loop through all Howls and stop them.
      for (var i=0; i<self._howls.length; i++) {
        self._howls[i].stop();
      }

      return self;
    },

    /**
     * Unload and destroy all currently loaded Howl objects.
     * @return {Howler}
     */
    unload: function() {
      var self = this || Howler;

      for (var i=self._howls.length-1; i>=0; i--) {
        self._howls[i].unload();
      }

      // Create a new AudioContext to make sure it is fully reset.
      if (self.usingWebAudio && self.ctx && typeof self.ctx.close !== 'undefined') {
        self.ctx.close();
        self.ctx = null;
        setupAudioContext();
      }

      return self;
    },

    /**
     * Check for codec support of specific extension.
     * @param  {String} ext Audio file extention.
     * @return {Boolean}
     */
    codecs: function(ext) {
      return (this || Howler)._codecs[ext.replace(/^x-/, '')];
    },

    /**
     * Setup various state values for global tracking.
     * @return {Howler}
     */
    _setup: function() {
      var self = this || Howler;

      // Keeps track of the suspend/resume state of the AudioContext.
      self.state = self.ctx ? self.ctx.state || 'suspended' : 'suspended';

      // Automatically begin the 30-second suspend process
      self._autoSuspend();

      // Check if audio is available.
      if (!self.usingWebAudio) {
        // No audio is available on this system if noAudio is set to true.
        if (typeof Audio !== 'undefined') {
          try {
            var test = new Audio();

            // Check if the canplaythrough event is available.
            if (typeof test.oncanplaythrough === 'undefined') {
              self._canPlayEvent = 'canplay';
            }
          } catch(e) {
            self.noAudio = true;
          }
        } else {
          self.noAudio = true;
        }
      }

      // Test to make sure audio isn't disabled in Internet Explorer.
      try {
        var test = new Audio();
        if (test.muted) {
          self.noAudio = true;
        }
      } catch (e) {}

      // Check for supported codecs.
      if (!self.noAudio) {
        self._setupCodecs();
      }

      return self;
    },

    /**
     * Check for browser support for various codecs and cache the results.
     * @return {Howler}
     */
    _setupCodecs: function() {
      var self = this || Howler;
      var audioTest = null;

      // Must wrap in a try/catch because IE11 in server mode throws an error.
      try {
        audioTest = (typeof Audio !== 'undefined') ? new Audio() : null;
      } catch (err) {
        return self;
      }

      if (!audioTest || typeof audioTest.canPlayType !== 'function') {
        return self;
      }

      var mpegTest = audioTest.canPlayType('audio/mpeg;').replace(/^no$/, '');

      // Opera version <33 has mixed MP3 support, so we need to check for and block it.
      var ua = self._navigator ? self._navigator.userAgent : '';
      var checkOpera = ua.match(/OPR\/([0-6].)/g);
      var isOldOpera = (checkOpera && parseInt(checkOpera[0].split('/')[1], 10) < 33);
      var checkSafari = ua.indexOf('Safari') !== -1 && ua.indexOf('Chrome') === -1;
      var safariVersion = ua.match(/Version\/(.*?) /);
      var isOldSafari = (checkSafari && safariVersion && parseInt(safariVersion[1], 10) < 15);

      self._codecs = {
        mp3: !!(!isOldOpera && (mpegTest || audioTest.canPlayType('audio/mp3;').replace(/^no$/, ''))),
        mpeg: !!mpegTest,
        opus: !!audioTest.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ''),
        ogg: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
        oga: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
        wav: !!(audioTest.canPlayType('audio/wav; codecs="1"') || audioTest.canPlayType('audio/wav')).replace(/^no$/, ''),
        aac: !!audioTest.canPlayType('audio/aac;').replace(/^no$/, ''),
        caf: !!audioTest.canPlayType('audio/x-caf;').replace(/^no$/, ''),
        m4a: !!(audioTest.canPlayType('audio/x-m4a;') || audioTest.canPlayType('audio/m4a;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
        m4b: !!(audioTest.canPlayType('audio/x-m4b;') || audioTest.canPlayType('audio/m4b;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
        mp4: !!(audioTest.canPlayType('audio/x-mp4;') || audioTest.canPlayType('audio/mp4;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
        weba: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, '')),
        webm: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, '')),
        dolby: !!audioTest.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ''),
        flac: !!(audioTest.canPlayType('audio/x-flac;') || audioTest.canPlayType('audio/flac;')).replace(/^no$/, '')
      };

      return self;
    },

    /**
     * Some browsers/devices will only allow audio to be played after a user interaction.
     * Attempt to automatically unlock audio on the first user interaction.
     * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
     * @return {Howler}
     */
    _unlockAudio: function() {
      var self = this || Howler;

      // Only run this if Web Audio is supported and it hasn't already been unlocked.
      if (self._audioUnlocked || !self.ctx) {
        return;
      }

      self._audioUnlocked = false;
      self.autoUnlock = false;

      // Some mobile devices/platforms have distortion issues when opening/closing tabs and/or web views.
      // Bugs in the browser (especially Mobile Safari) can cause the sampleRate to change from 44100 to 48000.
      // By calling Howler.unload(), we create a new AudioContext with the correct sampleRate.
      if (!self._mobileUnloaded && self.ctx.sampleRate !== 44100) {
        self._mobileUnloaded = true;
        self.unload();
      }

      // Scratch buffer for enabling iOS to dispose of web audio buffers correctly, as per:
      // http://stackoverflow.com/questions/24119684
      self._scratchBuffer = self.ctx.createBuffer(1, 1, 22050);

      // Call this method on touch start to create and play a buffer,
      // then check if the audio actually played to determine if
      // audio has now been unlocked on iOS, Android, etc.
      var unlock = function(e) {
        // Create a pool of unlocked HTML5 Audio objects that can
        // be used for playing sounds without user interaction. HTML5
        // Audio objects must be individually unlocked, as opposed
        // to the WebAudio API which only needs a single activation.
        // This must occur before WebAudio setup or the source.onended
        // event will not fire.
        while (self._html5AudioPool.length < self.html5PoolSize) {
          try {
            var audioNode = new Audio();

            // Mark this Audio object as unlocked to ensure it can get returned
            // to the unlocked pool when released.
            audioNode._unlocked = true;

            // Add the audio node to the pool.
            self._releaseHtml5Audio(audioNode);
          } catch (e) {
            self.noAudio = true;
            break;
          }
        }

        // Loop through any assigned audio nodes and unlock them.
        for (var i=0; i<self._howls.length; i++) {
          if (!self._howls[i]._webAudio) {
            // Get all of the sounds in this Howl group.
            var ids = self._howls[i]._getSoundIds();

            // Loop through all sounds and unlock the audio nodes.
            for (var j=0; j<ids.length; j++) {
              var sound = self._howls[i]._soundById(ids[j]);

              if (sound && sound._node && !sound._node._unlocked) {
                sound._node._unlocked = true;
                sound._node.load();
              }
            }
          }
        }

        // Fix Android can not play in suspend state.
        self._autoResume();

        // Create an empty buffer.
        var source = self.ctx.createBufferSource();
        source.buffer = self._scratchBuffer;
        source.connect(self.ctx.destination);

        // Play the empty buffer.
        if (typeof source.start === 'undefined') {
          source.noteOn(0);
        } else {
          source.start(0);
        }

        // Calling resume() on a stack initiated by user gesture is what actually unlocks the audio on Android Chrome >= 55.
        if (typeof self.ctx.resume === 'function') {
          self.ctx.resume();
        }

        // Setup a timeout to check that we are unlocked on the next event loop.
        source.onended = function() {
          source.disconnect(0);

          // Update the unlocked state and prevent this check from happening again.
          self._audioUnlocked = true;

          // Remove the touch start listener.
          document.removeEventListener('touchstart', unlock, true);
          document.removeEventListener('touchend', unlock, true);
          document.removeEventListener('click', unlock, true);
          document.removeEventListener('keydown', unlock, true);

          // Let all sounds know that audio has been unlocked.
          for (var i=0; i<self._howls.length; i++) {
            self._howls[i]._emit('unlock');
          }
        };
      };

      // Setup a touch start listener to attempt an unlock in.
      document.addEventListener('touchstart', unlock, true);
      document.addEventListener('touchend', unlock, true);
      document.addEventListener('click', unlock, true);
      document.addEventListener('keydown', unlock, true);

      return self;
    },

    /**
     * Get an unlocked HTML5 Audio object from the pool. If none are left,
     * return a new Audio object and throw a warning.
     * @return {Audio} HTML5 Audio object.
     */
    _obtainHtml5Audio: function() {
      var self = this || Howler;

      // Return the next object from the pool if one exists.
      if (self._html5AudioPool.length) {
        return self._html5AudioPool.pop();
      }

      //.Check if the audio is locked and throw a warning.
      var testPlay = new Audio().play();
      if (testPlay && typeof Promise !== 'undefined' && (testPlay instanceof Promise || typeof testPlay.then === 'function')) {
        testPlay.catch(function() {
          console.warn('HTML5 Audio pool exhausted, returning potentially locked audio object.');
        });
      }

      return new Audio();
    },

    /**
     * Return an activated HTML5 Audio object to the pool.
     * @return {Howler}
     */
    _releaseHtml5Audio: function(audio) {
      var self = this || Howler;

      // Don't add audio to the pool if we don't know if it has been unlocked.
      if (audio._unlocked) {
        self._html5AudioPool.push(audio);
      }

      return self;
    },

    /**
     * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
     * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
     * @return {Howler}
     */
    _autoSuspend: function() {
      var self = this;

      if (!self.autoSuspend || !self.ctx || typeof self.ctx.suspend === 'undefined' || !Howler.usingWebAudio) {
        return;
      }

      // Check if any sounds are playing.
      for (var i=0; i<self._howls.length; i++) {
        if (self._howls[i]._webAudio) {
          for (var j=0; j<self._howls[i]._sounds.length; j++) {
            if (!self._howls[i]._sounds[j]._paused) {
              return self;
            }
          }
        }
      }

      if (self._suspendTimer) {
        clearTimeout(self._suspendTimer);
      }

      // If no sound has played after 30 seconds, suspend the context.
      self._suspendTimer = setTimeout(function() {
        if (!self.autoSuspend) {
          return;
        }

        self._suspendTimer = null;
        self.state = 'suspending';

        // Handle updating the state of the audio context after suspending.
        var handleSuspension = function() {
          self.state = 'suspended';

          if (self._resumeAfterSuspend) {
            delete self._resumeAfterSuspend;
            self._autoResume();
          }
        };

        // Either the state gets suspended or it is interrupted.
        // Either way, we need to update the state to suspended.
        self.ctx.suspend().then(handleSuspension, handleSuspension);
      }, 30000);

      return self;
    },

    /**
     * Automatically resume the Web Audio AudioContext when a new sound is played.
     * @return {Howler}
     */
    _autoResume: function() {
      var self = this;

      if (!self.ctx || typeof self.ctx.resume === 'undefined' || !Howler.usingWebAudio) {
        return;
      }

      if (self.state === 'running' && self.ctx.state !== 'interrupted' && self._suspendTimer) {
        clearTimeout(self._suspendTimer);
        self._suspendTimer = null;
      } else if (self.state === 'suspended' || self.state === 'running' && self.ctx.state === 'interrupted') {
        self.ctx.resume().then(function() {
          self.state = 'running';

          // Emit to all Howls that the audio has resumed.
          for (var i=0; i<self._howls.length; i++) {
            self._howls[i]._emit('resume');
          }
        });

        if (self._suspendTimer) {
          clearTimeout(self._suspendTimer);
          self._suspendTimer = null;
        }
      } else if (self.state === 'suspending') {
        self._resumeAfterSuspend = true;
      }

      return self;
    }
  };

  // Setup the global audio controller.
  var Howler = new HowlerGlobal();

  /** Group Methods **/
  /***************************************************************************/

  /**
   * Create an audio group controller.
   * @param {Object} o Passed in properties for this group.
   */
  var Howl = function(o) {
    var self = this;

    // Throw an error if no source is provided.
    if (!o.src || o.src.length === 0) {
      console.error('An array of source files must be passed with any new Howl.');
      return;
    }

    self.init(o);
  };
  Howl.prototype = {
    /**
     * Initialize a new Howl group object.
     * @param  {Object} o Passed in properties for this group.
     * @return {Howl}
     */
    init: function(o) {
      var self = this;

      // If we don't have an AudioContext created yet, run the setup.
      if (!Howler.ctx) {
        setupAudioContext();
      }

      // Setup user-defined default properties.
      self._autoplay = o.autoplay || false;
      self._format = (typeof o.format !== 'string') ? o.format : [o.format];
      self._html5 = o.html5 || false;
      self._muted = o.mute || false;
      self._loop = o.loop || false;
      self._pool = o.pool || 5;
      self._preload = (typeof o.preload === 'boolean' || o.preload === 'metadata') ? o.preload : true;
      self._rate = o.rate || 1;
      self._sprite = o.sprite || {};
      self._src = (typeof o.src !== 'string') ? o.src : [o.src];
      self._volume = o.volume !== undefined ? o.volume : 1;
      self._xhr = {
        method: o.xhr && o.xhr.method ? o.xhr.method : 'GET',
        headers: o.xhr && o.xhr.headers ? o.xhr.headers : null,
        withCredentials: o.xhr && o.xhr.withCredentials ? o.xhr.withCredentials : false,
      };

      // Setup all other default properties.
      self._duration = 0;
      self._state = 'unloaded';
      self._sounds = [];
      self._endTimers = {};
      self._queue = [];
      self._playLock = false;

      // Setup event listeners.
      self._onend = o.onend ? [{fn: o.onend}] : [];
      self._onfade = o.onfade ? [{fn: o.onfade}] : [];
      self._onload = o.onload ? [{fn: o.onload}] : [];
      self._onloaderror = o.onloaderror ? [{fn: o.onloaderror}] : [];
      self._onplayerror = o.onplayerror ? [{fn: o.onplayerror}] : [];
      self._onpause = o.onpause ? [{fn: o.onpause}] : [];
      self._onplay = o.onplay ? [{fn: o.onplay}] : [];
      self._onstop = o.onstop ? [{fn: o.onstop}] : [];
      self._onmute = o.onmute ? [{fn: o.onmute}] : [];
      self._onvolume = o.onvolume ? [{fn: o.onvolume}] : [];
      self._onrate = o.onrate ? [{fn: o.onrate}] : [];
      self._onseek = o.onseek ? [{fn: o.onseek}] : [];
      self._onunlock = o.onunlock ? [{fn: o.onunlock}] : [];
      self._onresume = [];

      // Web Audio or HTML5 Audio?
      self._webAudio = Howler.usingWebAudio && !self._html5;

      // Automatically try to enable audio.
      if (typeof Howler.ctx !== 'undefined' && Howler.ctx && Howler.autoUnlock) {
        Howler._unlockAudio();
      }

      // Keep track of this Howl group in the global controller.
      Howler._howls.push(self);

      // If they selected autoplay, add a play event to the load queue.
      if (self._autoplay) {
        self._queue.push({
          event: 'play',
          action: function() {
            self.play();
          }
        });
      }

      // Load the source file unless otherwise specified.
      if (self._preload && self._preload !== 'none') {
        self.load();
      }

      return self;
    },

    /**
     * Load the audio file.
     * @return {Howler}
     */
    load: function() {
      var self = this;
      var url = null;

      // If no audio is available, quit immediately.
      if (Howler.noAudio) {
        self._emit('loaderror', null, 'No audio support.');
        return;
      }

      // Make sure our source is in an array.
      if (typeof self._src === 'string') {
        self._src = [self._src];
      }

      // Loop through the sources and pick the first one that is compatible.
      for (var i=0; i<self._src.length; i++) {
        var ext, str;

        if (self._format && self._format[i]) {
          // If an extension was specified, use that instead.
          ext = self._format[i];
        } else {
          // Make sure the source is a string.
          str = self._src[i];
          if (typeof str !== 'string') {
            self._emit('loaderror', null, 'Non-string found in selected audio sources - ignoring.');
            continue;
          }

          // Extract the file extension from the URL or base64 data URI.
          ext = /^data:audio\/([^;,]+);/i.exec(str);
          if (!ext) {
            ext = /\.([^.]+)$/.exec(str.split('?', 1)[0]);
          }

          if (ext) {
            ext = ext[1].toLowerCase();
          }
        }

        // Log a warning if no extension was found.
        if (!ext) {
          console.warn('No file extension was found. Consider using the "format" property or specify an extension.');
        }

        // Check if this extension is available.
        if (ext && Howler.codecs(ext)) {
          url = self._src[i];
          break;
        }
      }

      if (!url) {
        self._emit('loaderror', null, 'No codec support for selected audio sources.');
        return;
      }

      self._src = url;
      self._state = 'loading';

      // If the hosting page is HTTPS and the source isn't,
      // drop down to HTML5 Audio to avoid Mixed Content errors.
      if (window.location.protocol === 'https:' && url.slice(0, 5) === 'http:') {
        self._html5 = true;
        self._webAudio = false;
      }

      // Create a new sound object and add it to the pool.
      new Sound(self);

      // Load and decode the audio data for playback.
      if (self._webAudio) {
        loadBuffer(self);
      }

      return self;
    },

    /**
     * Play a sound or resume previous playback.
     * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Number}          Sound ID.
     */
    play: function(sprite, internal) {
      var self = this;
      var id = null;

      // Determine if a sprite, sound id or nothing was passed
      if (typeof sprite === 'number') {
        id = sprite;
        sprite = null;
      } else if (typeof sprite === 'string' && self._state === 'loaded' && !self._sprite[sprite]) {
        // If the passed sprite doesn't exist, do nothing.
        return null;
      } else if (typeof sprite === 'undefined') {
        // Use the default sound sprite (plays the full audio length).
        sprite = '__default';

        // Check if there is a single paused sound that isn't ended.
        // If there is, play that sound. If not, continue as usual.
        if (!self._playLock) {
          var num = 0;
          for (var i=0; i<self._sounds.length; i++) {
            if (self._sounds[i]._paused && !self._sounds[i]._ended) {
              num++;
              id = self._sounds[i]._id;
            }
          }

          if (num === 1) {
            sprite = null;
          } else {
            id = null;
          }
        }
      }

      // Get the selected node, or get one from the pool.
      var sound = id ? self._soundById(id) : self._inactiveSound();

      // If the sound doesn't exist, do nothing.
      if (!sound) {
        return null;
      }

      // Select the sprite definition.
      if (id && !sprite) {
        sprite = sound._sprite || '__default';
      }

      // If the sound hasn't loaded, we must wait to get the audio's duration.
      // We also need to wait to make sure we don't run into race conditions with
      // the order of function calls.
      if (self._state !== 'loaded') {
        // Set the sprite value on this sound.
        sound._sprite = sprite;

        // Mark this sound as not ended in case another sound is played before this one loads.
        sound._ended = false;

        // Add the sound to the queue to be played on load.
        var soundId = sound._id;
        self._queue.push({
          event: 'play',
          action: function() {
            self.play(soundId);
          }
        });

        return soundId;
      }

      // Don't play the sound if an id was passed and it is already playing.
      if (id && !sound._paused) {
        // Trigger the play event, in order to keep iterating through queue.
        if (!internal) {
          self._loadQueue('play');
        }

        return sound._id;
      }

      // Make sure the AudioContext isn't suspended, and resume it if it is.
      if (self._webAudio) {
        Howler._autoResume();
      }

      // Determine how long to play for and where to start playing.
      var seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
      var duration = Math.max(0, ((self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000) - seek);
      var timeout = (duration * 1000) / Math.abs(sound._rate);
      var start = self._sprite[sprite][0] / 1000;
      var stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
      sound._sprite = sprite;

      // Mark the sound as ended instantly so that this async playback
      // doesn't get grabbed by another call to play while this one waits to start.
      sound._ended = false;

      // Update the parameters of the sound.
      var setParams = function() {
        sound._paused = false;
        sound._seek = seek;
        sound._start = start;
        sound._stop = stop;
        sound._loop = !!(sound._loop || self._sprite[sprite][2]);
      };

      // End the sound instantly if seek is at the end.
      if (seek >= stop) {
        self._ended(sound);
        return;
      }

      // Begin the actual playback.
      var node = sound._node;
      if (self._webAudio) {
        // Fire this when the sound is ready to play to begin Web Audio playback.
        var playWebAudio = function() {
          self._playLock = false;
          setParams();
          self._refreshBuffer(sound);

          // Setup the playback params.
          var vol = (sound._muted || self._muted) ? 0 : sound._volume;
          node.gain.setValueAtTime(vol, Howler.ctx.currentTime);
          sound._playStart = Howler.ctx.currentTime;

          // Play the sound using the supported method.
          if (typeof node.bufferSource.start === 'undefined') {
            sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
          } else {
            sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
          }

          // Start a new timer if none is present.
          if (timeout !== Infinity) {
            self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
          }

          if (!internal) {
            setTimeout(function() {
              self._emit('play', sound._id);
              self._loadQueue();
            }, 0);
          }
        };

        if (Howler.state === 'running' && Howler.ctx.state !== 'interrupted') {
          playWebAudio();
        } else {
          self._playLock = true;

          // Wait for the audio context to resume before playing.
          self.once('resume', playWebAudio);

          // Cancel the end timer.
          self._clearTimer(sound._id);
        }
      } else {
        // Fire this when the sound is ready to play to begin HTML5 Audio playback.
        var playHtml5 = function() {
          node.currentTime = seek;
          node.muted = sound._muted || self._muted || Howler._muted || node.muted;
          node.volume = sound._volume * Howler.volume();
          node.playbackRate = sound._rate;

          // Some browsers will throw an error if this is called without user interaction.
          try {
            var play = node.play();

            // Support older browsers that don't support promises, and thus don't have this issue.
            if (play && typeof Promise !== 'undefined' && (play instanceof Promise || typeof play.then === 'function')) {
              // Implements a lock to prevent DOMException: The play() request was interrupted by a call to pause().
              self._playLock = true;

              // Set param values immediately.
              setParams();

              // Releases the lock and executes queued actions.
              play
                .then(function() {
                  self._playLock = false;
                  node._unlocked = true;
                  if (!internal) {
                    self._emit('play', sound._id);
                  } else {
                    self._loadQueue();
                  }
                })
                .catch(function() {
                  self._playLock = false;
                  self._emit('playerror', sound._id, 'Playback was unable to start. This is most commonly an issue ' +
                    'on mobile devices and Chrome where playback was not within a user interaction.');

                  // Reset the ended and paused values.
                  sound._ended = true;
                  sound._paused = true;
                });
            } else if (!internal) {
              self._playLock = false;
              setParams();
              self._emit('play', sound._id);
            }

            // Setting rate before playing won't work in IE, so we set it again here.
            node.playbackRate = sound._rate;

            // If the node is still paused, then we can assume there was a playback issue.
            if (node.paused) {
              self._emit('playerror', sound._id, 'Playback was unable to start. This is most commonly an issue ' +
                'on mobile devices and Chrome where playback was not within a user interaction.');
              return;
            }

            // Setup the end timer on sprites or listen for the ended event.
            if (sprite !== '__default' || sound._loop) {
              self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
            } else {
              self._endTimers[sound._id] = function() {
                // Fire ended on this audio node.
                self._ended(sound);

                // Clear this listener.
                node.removeEventListener('ended', self._endTimers[sound._id], false);
              };
              node.addEventListener('ended', self._endTimers[sound._id], false);
            }
          } catch (err) {
            self._emit('playerror', sound._id, err);
          }
        };

        // If this is streaming audio, make sure the src is set and load again.
        if (node.src === 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA') {
          node.src = self._src;
          node.load();
        }

        // Play immediately if ready, or wait for the 'canplaythrough'e vent.
        var loadedNoReadyState = (window && window.ejecta) || (!node.readyState && Howler._navigator.isCocoonJS);
        if (node.readyState >= 3 || loadedNoReadyState) {
          playHtml5();
        } else {
          self._playLock = true;
          self._state = 'loading';

          var listener = function() {
            self._state = 'loaded';
            
            // Begin playback.
            playHtml5();

            // Clear this listener.
            node.removeEventListener(Howler._canPlayEvent, listener, false);
          };
          node.addEventListener(Howler._canPlayEvent, listener, false);

          // Cancel the end timer.
          self._clearTimer(sound._id);
        }
      }

      return sound._id;
    },

    /**
     * Pause playback and save current position.
     * @param  {Number} id The sound ID (empty to pause all in group).
     * @return {Howl}
     */
    pause: function(id) {
      var self = this;

      // If the sound hasn't loaded or a play() promise is pending, add it to the load queue to pause when capable.
      if (self._state !== 'loaded' || self._playLock) {
        self._queue.push({
          event: 'pause',
          action: function() {
            self.pause(id);
          }
        });

        return self;
      }

      // If no id is passed, get all ID's to be paused.
      var ids = self._getSoundIds(id);

      for (var i=0; i<ids.length; i++) {
        // Clear the end timer.
        self._clearTimer(ids[i]);

        // Get the sound.
        var sound = self._soundById(ids[i]);

        if (sound && !sound._paused) {
          // Reset the seek position.
          sound._seek = self.seek(ids[i]);
          sound._rateSeek = 0;
          sound._paused = true;

          // Stop currently running fades.
          self._stopFade(ids[i]);

          if (sound._node) {
            if (self._webAudio) {
              // Make sure the sound has been created.
              if (!sound._node.bufferSource) {
                continue;
              }

              if (typeof sound._node.bufferSource.stop === 'undefined') {
                sound._node.bufferSource.noteOff(0);
              } else {
                sound._node.bufferSource.stop(0);
              }

              // Clean up the buffer source.
              self._cleanBuffer(sound._node);
            } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
              sound._node.pause();
            }
          }
        }

        // Fire the pause event, unless `true` is passed as the 2nd argument.
        if (!arguments[1]) {
          self._emit('pause', sound ? sound._id : null);
        }
      }

      return self;
    },

    /**
     * Stop playback and reset to start.
     * @param  {Number} id The sound ID (empty to stop all in group).
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Howl}
     */
    stop: function(id, internal) {
      var self = this;

      // If the sound hasn't loaded, add it to the load queue to stop when capable.
      if (self._state !== 'loaded' || self._playLock) {
        self._queue.push({
          event: 'stop',
          action: function() {
            self.stop(id);
          }
        });

        return self;
      }

      // If no id is passed, get all ID's to be stopped.
      var ids = self._getSoundIds(id);

      for (var i=0; i<ids.length; i++) {
        // Clear the end timer.
        self._clearTimer(ids[i]);

        // Get the sound.
        var sound = self._soundById(ids[i]);

        if (sound) {
          // Reset the seek position.
          sound._seek = sound._start || 0;
          sound._rateSeek = 0;
          sound._paused = true;
          sound._ended = true;

          // Stop currently running fades.
          self._stopFade(ids[i]);

          if (sound._node) {
            if (self._webAudio) {
              // Make sure the sound's AudioBufferSourceNode has been created.
              if (sound._node.bufferSource) {
                if (typeof sound._node.bufferSource.stop === 'undefined') {
                  sound._node.bufferSource.noteOff(0);
                } else {
                  sound._node.bufferSource.stop(0);
                }

                // Clean up the buffer source.
                self._cleanBuffer(sound._node);
              }
            } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
              sound._node.currentTime = sound._start || 0;
              sound._node.pause();

              // If this is a live stream, stop download once the audio is stopped.
              if (sound._node.duration === Infinity) {
                self._clearSound(sound._node);
              }
            }
          }

          if (!internal) {
            self._emit('stop', sound._id);
          }
        }
      }

      return self;
    },

    /**
     * Mute/unmute a single sound or all sounds in this Howl group.
     * @param  {Boolean} muted Set to true to mute and false to unmute.
     * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
     * @return {Howl}
     */
    mute: function(muted, id) {
      var self = this;

      // If the sound hasn't loaded, add it to the load queue to mute when capable.
      if (self._state !== 'loaded'|| self._playLock) {
        self._queue.push({
          event: 'mute',
          action: function() {
            self.mute(muted, id);
          }
        });

        return self;
      }

      // If applying mute/unmute to all sounds, update the group's value.
      if (typeof id === 'undefined') {
        if (typeof muted === 'boolean') {
          self._muted = muted;
        } else {
          return self._muted;
        }
      }

      // If no id is passed, get all ID's to be muted.
      var ids = self._getSoundIds(id);

      for (var i=0; i<ids.length; i++) {
        // Get the sound.
        var sound = self._soundById(ids[i]);

        if (sound) {
          sound._muted = muted;

          // Cancel active fade and set the volume to the end value.
          if (sound._interval) {
            self._stopFade(sound._id);
          }

          if (self._webAudio && sound._node) {
            sound._node.gain.setValueAtTime(muted ? 0 : sound._volume, Howler.ctx.currentTime);
          } else if (sound._node) {
            sound._node.muted = Howler._muted ? true : muted;
          }

          self._emit('mute', sound._id);
        }
      }

      return self;
    },

    /**
     * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
     *   volume() -> Returns the group's volume value.
     *   volume(id) -> Returns the sound id's current volume.
     *   volume(vol) -> Sets the volume of all sounds in this Howl group.
     *   volume(vol, id) -> Sets the volume of passed sound id.
     * @return {Howl/Number} Returns self or current volume.
     */
    volume: function() {
      var self = this;
      var args = arguments;
      var vol, id;

      // Determine the values based on arguments.
      if (args.length === 0) {
        // Return the value of the groups' volume.
        return self._volume;
      } else if (args.length === 1 || args.length === 2 && typeof args[1] === 'undefined') {
        // First check if this is an ID, and if not, assume it is a new volume.
        var ids = self._getSoundIds();
        var index = ids.indexOf(args[0]);
        if (index >= 0) {
          id = parseInt(args[0], 10);
        } else {
          vol = parseFloat(args[0]);
        }
      } else if (args.length >= 2) {
        vol = parseFloat(args[0]);
        id = parseInt(args[1], 10);
      }

      // Update the volume or return the current volume.
      var sound;
      if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
        // If the sound hasn't loaded, add it to the load queue to change volume when capable.
        if (self._state !== 'loaded'|| self._playLock) {
          self._queue.push({
            event: 'volume',
            action: function() {
              self.volume.apply(self, args);
            }
          });

          return self;
        }

        // Set the group volume.
        if (typeof id === 'undefined') {
          self._volume = vol;
        }

        // Update one or all volumes.
        id = self._getSoundIds(id);
        for (var i=0; i<id.length; i++) {
          // Get the sound.
          sound = self._soundById(id[i]);

          if (sound) {
            sound._volume = vol;

            // Stop currently running fades.
            if (!args[2]) {
              self._stopFade(id[i]);
            }

            if (self._webAudio && sound._node && !sound._muted) {
              sound._node.gain.setValueAtTime(vol, Howler.ctx.currentTime);
            } else if (sound._node && !sound._muted) {
              sound._node.volume = vol * Howler.volume();
            }

            self._emit('volume', sound._id);
          }
        }
      } else {
        sound = id ? self._soundById(id) : self._sounds[0];
        return sound ? sound._volume : 0;
      }

      return self;
    },

    /**
     * Fade a currently playing sound between two volumes (if no id is passed, all sounds will fade).
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id (omit to fade all sounds).
     * @return {Howl}
     */
    fade: function(from, to, len, id) {
      var self = this;

      // If the sound hasn't loaded, add it to the load queue to fade when capable.
      if (self._state !== 'loaded' || self._playLock) {
        self._queue.push({
          event: 'fade',
          action: function() {
            self.fade(from, to, len, id);
          }
        });

        return self;
      }

      // Make sure the to/from/len values are numbers.
      from = Math.min(Math.max(0, parseFloat(from)), 1);
      to = Math.min(Math.max(0, parseFloat(to)), 1);
      len = parseFloat(len);

      // Set the volume to the start position.
      self.volume(from, id);

      // Fade the volume of one or all sounds.
      var ids = self._getSoundIds(id);
      for (var i=0; i<ids.length; i++) {
        // Get the sound.
        var sound = self._soundById(ids[i]);

        // Create a linear fade or fall back to timeouts with HTML5 Audio.
        if (sound) {
          // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
          if (!id) {
            self._stopFade(ids[i]);
          }

          // If we are using Web Audio, let the native methods do the actual fade.
          if (self._webAudio && !sound._muted) {
            var currentTime = Howler.ctx.currentTime;
            var end = currentTime + (len / 1000);
            sound._volume = from;
            sound._node.gain.setValueAtTime(from, currentTime);
            sound._node.gain.linearRampToValueAtTime(to, end);
          }

          self._startFadeInterval(sound, from, to, len, ids[i], typeof id === 'undefined');
        }
      }

      return self;
    },

    /**
     * Starts the internal interval to fade a sound.
     * @param  {Object} sound Reference to sound to fade.
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id to fade.
     * @param  {Boolean} isGroup   If true, set the volume on the group.
     */
    _startFadeInterval: function(sound, from, to, len, id, isGroup) {
      var self = this;
      var vol = from;
      var diff = to - from;
      var steps = Math.abs(diff / 0.01);
      var stepLen = Math.max(4, (steps > 0) ? len / steps : len);
      var lastTick = Date.now();

      // Store the value being faded to.
      sound._fadeTo = to;

      // Update the volume value on each interval tick.
      sound._interval = setInterval(function() {
        // Update the volume based on the time since the last tick.
        var tick = (Date.now() - lastTick) / len;
        lastTick = Date.now();
        vol += diff * tick;

        // Round to within 2 decimal points.
        vol = Math.round(vol * 100) / 100;

        // Make sure the volume is in the right bounds.
        if (diff < 0) {
          vol = Math.max(to, vol);
        } else {
          vol = Math.min(to, vol);
        }

        // Change the volume.
        if (self._webAudio) {
          sound._volume = vol;
        } else {
          self.volume(vol, sound._id, true);
        }

        // Set the group's volume.
        if (isGroup) {
          self._volume = vol;
        }

        // When the fade is complete, stop it and fire event.
        if ((to < from && vol <= to) || (to > from && vol >= to)) {
          clearInterval(sound._interval);
          sound._interval = null;
          sound._fadeTo = null;
          self.volume(to, sound._id);
          self._emit('fade', sound._id);
        }
      }, stepLen);
    },

    /**
     * Internal method that stops the currently playing fade when
     * a new fade starts, volume is changed or the sound is stopped.
     * @param  {Number} id The sound id.
     * @return {Howl}
     */
    _stopFade: function(id) {
      var self = this;
      var sound = self._soundById(id);

      if (sound && sound._interval) {
        if (self._webAudio) {
          sound._node.gain.cancelScheduledValues(Howler.ctx.currentTime);
        }

        clearInterval(sound._interval);
        sound._interval = null;
        self.volume(sound._fadeTo, id);
        sound._fadeTo = null;
        self._emit('fade', id);
      }

      return self;
    },

    /**
     * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
     *   loop() -> Returns the group's loop value.
     *   loop(id) -> Returns the sound id's loop value.
     *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
     *   loop(loop, id) -> Sets the loop value of passed sound id.
     * @return {Howl/Boolean} Returns self or current loop value.
     */
    loop: function() {
      var self = this;
      var args = arguments;
      var loop, id, sound;

      // Determine the values for loop and id.
      if (args.length === 0) {
        // Return the grou's loop value.
        return self._loop;
      } else if (args.length === 1) {
        if (typeof args[0] === 'boolean') {
          loop = args[0];
          self._loop = loop;
        } else {
          // Return this sound's loop value.
          sound = self._soundById(parseInt(args[0], 10));
          return sound ? sound._loop : false;
        }
      } else if (args.length === 2) {
        loop = args[0];
        id = parseInt(args[1], 10);
      }

      // If no id is passed, get all ID's to be looped.
      var ids = self._getSoundIds(id);
      for (var i=0; i<ids.length; i++) {
        sound = self._soundById(ids[i]);

        if (sound) {
          sound._loop = loop;
          if (self._webAudio && sound._node && sound._node.bufferSource) {
            sound._node.bufferSource.loop = loop;
            if (loop) {
              sound._node.bufferSource.loopStart = sound._start || 0;
              sound._node.bufferSource.loopEnd = sound._stop;

              // If playing, restart playback to ensure looping updates.
              if (self.playing(ids[i])) {
                self.pause(ids[i], true);
                self.play(ids[i], true);
              }
            }
          }
        }
      }

      return self;
    },

    /**
     * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   rate() -> Returns the first sound node's current playback rate.
     *   rate(id) -> Returns the sound id's current playback rate.
     *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
     *   rate(rate, id) -> Sets the playback rate of passed sound id.
     * @return {Howl/Number} Returns self or the current playback rate.
     */
    rate: function() {
      var self = this;
      var args = arguments;
      var rate, id;

      // Determine the values based on arguments.
      if (args.length === 0) {
        // We will simply return the current rate of the first node.
        id = self._sounds[0]._id;
      } else if (args.length === 1) {
        // First check if this is an ID, and if not, assume it is a new rate value.
        var ids = self._getSoundIds();
        var index = ids.indexOf(args[0]);
        if (index >= 0) {
          id = parseInt(args[0], 10);
        } else {
          rate = parseFloat(args[0]);
        }
      } else if (args.length === 2) {
        rate = parseFloat(args[0]);
        id = parseInt(args[1], 10);
      }

      // Update the playback rate or return the current value.
      var sound;
      if (typeof rate === 'number') {
        // If the sound hasn't loaded, add it to the load queue to change playback rate when capable.
        if (self._state !== 'loaded' || self._playLock) {
          self._queue.push({
            event: 'rate',
            action: function() {
              self.rate.apply(self, args);
            }
          });

          return self;
        }

        // Set the group rate.
        if (typeof id === 'undefined') {
          self._rate = rate;
        }

        // Update one or all volumes.
        id = self._getSoundIds(id);
        for (var i=0; i<id.length; i++) {
          // Get the sound.
          sound = self._soundById(id[i]);

          if (sound) {
            // Keep track of our position when the rate changed and update the playback
            // start position so we can properly adjust the seek position for time elapsed.
            if (self.playing(id[i])) {
              sound._rateSeek = self.seek(id[i]);
              sound._playStart = self._webAudio ? Howler.ctx.currentTime : sound._playStart;
            }
            sound._rate = rate;

            // Change the playback rate.
            if (self._webAudio && sound._node && sound._node.bufferSource) {
              sound._node.bufferSource.playbackRate.setValueAtTime(rate, Howler.ctx.currentTime);
            } else if (sound._node) {
              sound._node.playbackRate = rate;
            }

            // Reset the timers.
            var seek = self.seek(id[i]);
            var duration = ((self._sprite[sound._sprite][0] + self._sprite[sound._sprite][1]) / 1000) - seek;
            var timeout = (duration * 1000) / Math.abs(sound._rate);

            // Start a new end timer if sound is already playing.
            if (self._endTimers[id[i]] || !sound._paused) {
              self._clearTimer(id[i]);
              self._endTimers[id[i]] = setTimeout(self._ended.bind(self, sound), timeout);
            }

            self._emit('rate', sound._id);
          }
        }
      } else {
        sound = self._soundById(id);
        return sound ? sound._rate : self._rate;
      }

      return self;
    },

    /**
     * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   seek() -> Returns the first sound node's current seek position.
     *   seek(id) -> Returns the sound id's current seek position.
     *   seek(seek) -> Sets the seek position of the first sound node.
     *   seek(seek, id) -> Sets the seek position of passed sound id.
     * @return {Howl/Number} Returns self or the current seek position.
     */
    seek: function() {
      var self = this;
      var args = arguments;
      var seek, id;

      // Determine the values based on arguments.
      if (args.length === 0) {
        // We will simply return the current position of the first node.
        if (self._sounds.length) {
          id = self._sounds[0]._id;
        }
      } else if (args.length === 1) {
        // First check if this is an ID, and if not, assume it is a new seek position.
        var ids = self._getSoundIds();
        var index = ids.indexOf(args[0]);
        if (index >= 0) {
          id = parseInt(args[0], 10);
        } else if (self._sounds.length) {
          id = self._sounds[0]._id;
          seek = parseFloat(args[0]);
        }
      } else if (args.length === 2) {
        seek = parseFloat(args[0]);
        id = parseInt(args[1], 10);
      }

      // If there is no ID, bail out.
      if (typeof id === 'undefined') {
        return 0;
      }

      // If the sound hasn't loaded, add it to the load queue to seek when capable.
      if (typeof seek === 'number' && (self._state !== 'loaded' || self._playLock)) {
        self._queue.push({
          event: 'seek',
          action: function() {
            self.seek.apply(self, args);
          }
        });

        return self;
      }

      // Get the sound.
      var sound = self._soundById(id);

      if (sound) {
        if (typeof seek === 'number' && seek >= 0) {
          // Pause the sound and update position for restarting playback.
          var playing = self.playing(id);
          if (playing) {
            self.pause(id, true);
          }

          // Move the position of the track and cancel timer.
          sound._seek = seek;
          sound._ended = false;
          self._clearTimer(id);

          // Update the seek position for HTML5 Audio.
          if (!self._webAudio && sound._node && !isNaN(sound._node.duration)) {
            sound._node.currentTime = seek;
          }

          // Seek and emit when ready.
          var seekAndEmit = function() {
            // Restart the playback if the sound was playing.
            if (playing) {
              self.play(id, true);
            }

            self._emit('seek', id);
          };

          // Wait for the play lock to be unset before emitting (HTML5 Audio).
          if (playing && !self._webAudio) {
            var emitSeek = function() {
              if (!self._playLock) {
                seekAndEmit();
              } else {
                setTimeout(emitSeek, 0);
              }
            };
            setTimeout(emitSeek, 0);
          } else {
            seekAndEmit();
          }
        } else {
          if (self._webAudio) {
            var realTime = self.playing(id) ? Howler.ctx.currentTime - sound._playStart : 0;
            var rateSeek = sound._rateSeek ? sound._rateSeek - sound._seek : 0;
            return sound._seek + (rateSeek + realTime * Math.abs(sound._rate));
          } else {
            return sound._node.currentTime;
          }
        }
      }

      return self;
    },

    /**
     * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
     * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
     * @return {Boolean} True if playing and false if not.
     */
    playing: function(id) {
      var self = this;

      // Check the passed sound ID (if any).
      if (typeof id === 'number') {
        var sound = self._soundById(id);
        return sound ? !sound._paused : false;
      }

      // Otherwise, loop through all sounds and check if any are playing.
      for (var i=0; i<self._sounds.length; i++) {
        if (!self._sounds[i]._paused) {
          return true;
        }
      }

      return false;
    },

    /**
     * Get the duration of this sound. Passing a sound id will return the sprite duration.
     * @param  {Number} id The sound id to check. If none is passed, return full source duration.
     * @return {Number} Audio duration in seconds.
     */
    duration: function(id) {
      var self = this;
      var duration = self._duration;

      // If we pass an ID, get the sound and return the sprite length.
      var sound = self._soundById(id);
      if (sound) {
        duration = self._sprite[sound._sprite][1] / 1000;
      }

      return duration;
    },

    /**
     * Returns the current loaded state of this Howl.
     * @return {String} 'unloaded', 'loading', 'loaded'
     */
    state: function() {
      return this._state;
    },

    /**
     * Unload and destroy the current Howl object.
     * This will immediately stop all sound instances attached to this group.
     */
    unload: function() {
      var self = this;

      // Stop playing any active sounds.
      var sounds = self._sounds;
      for (var i=0; i<sounds.length; i++) {
        // Stop the sound if it is currently playing.
        if (!sounds[i]._paused) {
          self.stop(sounds[i]._id);
        }

        // Remove the source or disconnect.
        if (!self._webAudio) {
          // Set the source to 0-second silence to stop any downloading (except in IE).
          self._clearSound(sounds[i]._node);

          // Remove any event listeners.
          sounds[i]._node.removeEventListener('error', sounds[i]._errorFn, false);
          sounds[i]._node.removeEventListener(Howler._canPlayEvent, sounds[i]._loadFn, false);
          sounds[i]._node.removeEventListener('ended', sounds[i]._endFn, false);

          // Release the Audio object back to the pool.
          Howler._releaseHtml5Audio(sounds[i]._node);
        }

        // Empty out all of the nodes.
        delete sounds[i]._node;

        // Make sure all timers are cleared out.
        self._clearTimer(sounds[i]._id);
      }

      // Remove the references in the global Howler object.
      var index = Howler._howls.indexOf(self);
      if (index >= 0) {
        Howler._howls.splice(index, 1);
      }

      // Delete this sound from the cache (if no other Howl is using it).
      var remCache = true;
      for (i=0; i<Howler._howls.length; i++) {
        if (Howler._howls[i]._src === self._src || self._src.indexOf(Howler._howls[i]._src) >= 0) {
          remCache = false;
          break;
        }
      }

      if (cache && remCache) {
        delete cache[self._src];
      }

      // Clear global errors.
      Howler.noAudio = false;

      // Clear out `self`.
      self._state = 'unloaded';
      self._sounds = [];
      self = null;

      return null;
    },

    /**
     * Listen to a custom event.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
     * @return {Howl}
     */
    on: function(event, fn, id, once) {
      var self = this;
      var events = self['_on' + event];

      if (typeof fn === 'function') {
        events.push(once ? {id: id, fn: fn, once: once} : {id: id, fn: fn});
      }

      return self;
    },

    /**
     * Remove a custom event. Call without parameters to remove all events.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to remove. Leave empty to remove all.
     * @param  {Number}   id    (optional) Only remove events for this sound.
     * @return {Howl}
     */
    off: function(event, fn, id) {
      var self = this;
      var events = self['_on' + event];
      var i = 0;

      // Allow passing just an event and ID.
      if (typeof fn === 'number') {
        id = fn;
        fn = null;
      }

      if (fn || id) {
        // Loop through event store and remove the passed function.
        for (i=0; i<events.length; i++) {
          var isId = (id === events[i].id);
          if (fn === events[i].fn && isId || !fn && isId) {
            events.splice(i, 1);
            break;
          }
        }
      } else if (event) {
        // Clear out all events of this type.
        self['_on' + event] = [];
      } else {
        // Clear out all events of every type.
        var keys = Object.keys(self);
        for (i=0; i<keys.length; i++) {
          if ((keys[i].indexOf('_on') === 0) && Array.isArray(self[keys[i]])) {
            self[keys[i]] = [];
          }
        }
      }

      return self;
    },

    /**
     * Listen to a custom event and remove it once fired.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @return {Howl}
     */
    once: function(event, fn, id) {
      var self = this;

      // Setup the event listener.
      self.on(event, fn, id, 1);

      return self;
    },

    /**
     * Emit all events of a specific type and pass the sound id.
     * @param  {String} event Event name.
     * @param  {Number} id    Sound ID.
     * @param  {Number} msg   Message to go with event.
     * @return {Howl}
     */
    _emit: function(event, id, msg) {
      var self = this;
      var events = self['_on' + event];

      // Loop through event store and fire all functions.
      for (var i=events.length-1; i>=0; i--) {
        // Only fire the listener if the correct ID is used.
        if (!events[i].id || events[i].id === id || event === 'load') {
          setTimeout(function(fn) {
            fn.call(this, id, msg);
          }.bind(self, events[i].fn), 0);

          // If this event was setup with `once`, remove it.
          if (events[i].once) {
            self.off(event, events[i].fn, events[i].id);
          }
        }
      }

      // Pass the event type into load queue so that it can continue stepping.
      self._loadQueue(event);

      return self;
    },

    /**
     * Queue of actions initiated before the sound has loaded.
     * These will be called in sequence, with the next only firing
     * after the previous has finished executing (even if async like play).
     * @return {Howl}
     */
    _loadQueue: function(event) {
      var self = this;

      if (self._queue.length > 0) {
        var task = self._queue[0];

        // Remove this task if a matching event was passed.
        if (task.event === event) {
          self._queue.shift();
          self._loadQueue();
        }

        // Run the task if no event type is passed.
        if (!event) {
          task.action();
        }
      }

      return self;
    },

    /**
     * Fired when playback ends at the end of the duration.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */
    _ended: function(sound) {
      var self = this;
      var sprite = sound._sprite;

      // If we are using IE and there was network latency we may be clipping
      // audio before it completes playing. Lets check the node to make sure it
      // believes it has completed, before ending the playback.
      if (!self._webAudio && sound._node && !sound._node.paused && !sound._node.ended && sound._node.currentTime < sound._stop) {
        setTimeout(self._ended.bind(self, sound), 100);
        return self;
      }

      // Should this sound loop?
      var loop = !!(sound._loop || self._sprite[sprite][2]);

      // Fire the ended event.
      self._emit('end', sound._id);

      // Restart the playback for HTML5 Audio loop.
      if (!self._webAudio && loop) {
        self.stop(sound._id, true).play(sound._id);
      }

      // Restart this timer if on a Web Audio loop.
      if (self._webAudio && loop) {
        self._emit('play', sound._id);
        sound._seek = sound._start || 0;
        sound._rateSeek = 0;
        sound._playStart = Howler.ctx.currentTime;

        var timeout = ((sound._stop - sound._start) * 1000) / Math.abs(sound._rate);
        self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
      }

      // Mark the node as paused.
      if (self._webAudio && !loop) {
        sound._paused = true;
        sound._ended = true;
        sound._seek = sound._start || 0;
        sound._rateSeek = 0;
        self._clearTimer(sound._id);

        // Clean up the buffer source.
        self._cleanBuffer(sound._node);

        // Attempt to auto-suspend AudioContext if no sounds are still playing.
        Howler._autoSuspend();
      }

      // When using a sprite, end the track.
      if (!self._webAudio && !loop) {
        self.stop(sound._id, true);
      }

      return self;
    },

    /**
     * Clear the end timer for a sound playback.
     * @param  {Number} id The sound ID.
     * @return {Howl}
     */
    _clearTimer: function(id) {
      var self = this;

      if (self._endTimers[id]) {
        // Clear the timeout or remove the ended listener.
        if (typeof self._endTimers[id] !== 'function') {
          clearTimeout(self._endTimers[id]);
        } else {
          var sound = self._soundById(id);
          if (sound && sound._node) {
            sound._node.removeEventListener('ended', self._endTimers[id], false);
          }
        }

        delete self._endTimers[id];
      }

      return self;
    },

    /**
     * Return the sound identified by this ID, or return null.
     * @param  {Number} id Sound ID
     * @return {Object}    Sound object or null.
     */
    _soundById: function(id) {
      var self = this;

      // Loop through all sounds and find the one with this ID.
      for (var i=0; i<self._sounds.length; i++) {
        if (id === self._sounds[i]._id) {
          return self._sounds[i];
        }
      }

      return null;
    },

    /**
     * Return an inactive sound from the pool or create a new one.
     * @return {Sound} Sound playback object.
     */
    _inactiveSound: function() {
      var self = this;

      self._drain();

      // Find the first inactive node to recycle.
      for (var i=0; i<self._sounds.length; i++) {
        if (self._sounds[i]._ended) {
          return self._sounds[i].reset();
        }
      }

      // If no inactive node was found, create a new one.
      return new Sound(self);
    },

    /**
     * Drain excess inactive sounds from the pool.
     */
    _drain: function() {
      var self = this;
      var limit = self._pool;
      var cnt = 0;
      var i = 0;

      // If there are less sounds than the max pool size, we are done.
      if (self._sounds.length < limit) {
        return;
      }

      // Count the number of inactive sounds.
      for (i=0; i<self._sounds.length; i++) {
        if (self._sounds[i]._ended) {
          cnt++;
        }
      }

      // Remove excess inactive sounds, going in reverse order.
      for (i=self._sounds.length - 1; i>=0; i--) {
        if (cnt <= limit) {
          return;
        }

        if (self._sounds[i]._ended) {
          // Disconnect the audio source when using Web Audio.
          if (self._webAudio && self._sounds[i]._node) {
            self._sounds[i]._node.disconnect(0);
          }

          // Remove sounds until we have the pool size.
          self._sounds.splice(i, 1);
          cnt--;
        }
      }
    },

    /**
     * Get all ID's from the sounds pool.
     * @param  {Number} id Only return one ID if one is passed.
     * @return {Array}    Array of IDs.
     */
    _getSoundIds: function(id) {
      var self = this;

      if (typeof id === 'undefined') {
        var ids = [];
        for (var i=0; i<self._sounds.length; i++) {
          ids.push(self._sounds[i]._id);
        }

        return ids;
      } else {
        return [id];
      }
    },

    /**
     * Load the sound back into the buffer source.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */
    _refreshBuffer: function(sound) {
      var self = this;

      // Setup the buffer source for playback.
      sound._node.bufferSource = Howler.ctx.createBufferSource();
      sound._node.bufferSource.buffer = cache[self._src];

      // Connect to the correct node.
      if (sound._panner) {
        sound._node.bufferSource.connect(sound._panner);
      } else {
        sound._node.bufferSource.connect(sound._node);
      }

      // Setup looping and playback rate.
      sound._node.bufferSource.loop = sound._loop;
      if (sound._loop) {
        sound._node.bufferSource.loopStart = sound._start || 0;
        sound._node.bufferSource.loopEnd = sound._stop || 0;
      }
      sound._node.bufferSource.playbackRate.setValueAtTime(sound._rate, Howler.ctx.currentTime);

      return self;
    },

    /**
     * Prevent memory leaks by cleaning up the buffer source after playback.
     * @param  {Object} node Sound's audio node containing the buffer source.
     * @return {Howl}
     */
    _cleanBuffer: function(node) {
      var self = this;
      var isIOS = Howler._navigator && Howler._navigator.vendor.indexOf('Apple') >= 0;

      if (Howler._scratchBuffer && node.bufferSource) {
        node.bufferSource.onended = null;
        node.bufferSource.disconnect(0);
        if (isIOS) {
          try { node.bufferSource.buffer = Howler._scratchBuffer; } catch(e) {}
        }
      }
      node.bufferSource = null;

      return self;
    },

    /**
     * Set the source to a 0-second silence to stop any downloading (except in IE).
     * @param  {Object} node Audio node to clear.
     */
    _clearSound: function(node) {
      var checkIE = /MSIE |Trident\//.test(Howler._navigator && Howler._navigator.userAgent);
      if (!checkIE) {
        node.src = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA';
      }
    }
  };

  /** Single Sound Methods **/
  /***************************************************************************/

  /**
   * Setup the sound object, which each node attached to a Howl group is contained in.
   * @param {Object} howl The Howl parent group.
   */
  var Sound = function(howl) {
    this._parent = howl;
    this.init();
  };
  Sound.prototype = {
    /**
     * Initialize a new Sound object.
     * @return {Sound}
     */
    init: function() {
      var self = this;
      var parent = self._parent;

      // Setup the default parameters.
      self._muted = parent._muted;
      self._loop = parent._loop;
      self._volume = parent._volume;
      self._rate = parent._rate;
      self._seek = 0;
      self._paused = true;
      self._ended = true;
      self._sprite = '__default';

      // Generate a unique ID for this sound.
      self._id = ++Howler._counter;

      // Add itself to the parent's pool.
      parent._sounds.push(self);

      // Create the new node.
      self.create();

      return self;
    },

    /**
     * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
     * @return {Sound}
     */
    create: function() {
      var self = this;
      var parent = self._parent;
      var volume = (Howler._muted || self._muted || self._parent._muted) ? 0 : self._volume;

      if (parent._webAudio) {
        // Create the gain node for controlling volume (the source will connect to this).
        self._node = (typeof Howler.ctx.createGain === 'undefined') ? Howler.ctx.createGainNode() : Howler.ctx.createGain();
        self._node.gain.setValueAtTime(volume, Howler.ctx.currentTime);
        self._node.paused = true;
        self._node.connect(Howler.masterGain);
      } else if (!Howler.noAudio) {
        // Get an unlocked Audio object from the pool.
        self._node = Howler._obtainHtml5Audio();

        // Listen for errors (http://dev.w3.org/html5/spec-author-view/spec.html#mediaerror).
        self._errorFn = self._errorListener.bind(self);
        self._node.addEventListener('error', self._errorFn, false);

        // Listen for 'canplaythrough' event to let us know the sound is ready.
        self._loadFn = self._loadListener.bind(self);
        self._node.addEventListener(Howler._canPlayEvent, self._loadFn, false);

        // Listen for the 'ended' event on the sound to account for edge-case where
        // a finite sound has a duration of Infinity.
        self._endFn = self._endListener.bind(self);
        self._node.addEventListener('ended', self._endFn, false);

        // Setup the new audio node.
        self._node.src = parent._src;
        self._node.preload = parent._preload === true ? 'auto' : parent._preload;
        self._node.volume = volume * Howler.volume();

        // Begin loading the source.
        self._node.load();
      }

      return self;
    },

    /**
     * Reset the parameters of this sound to the original state (for recycle).
     * @return {Sound}
     */
    reset: function() {
      var self = this;
      var parent = self._parent;

      // Reset all of the parameters of this sound.
      self._muted = parent._muted;
      self._loop = parent._loop;
      self._volume = parent._volume;
      self._rate = parent._rate;
      self._seek = 0;
      self._rateSeek = 0;
      self._paused = true;
      self._ended = true;
      self._sprite = '__default';

      // Generate a new ID so that it isn't confused with the previous sound.
      self._id = ++Howler._counter;

      return self;
    },

    /**
     * HTML5 Audio error listener callback.
     */
    _errorListener: function() {
      var self = this;

      // Fire an error event and pass back the code.
      self._parent._emit('loaderror', self._id, self._node.error ? self._node.error.code : 0);

      // Clear the event listener.
      self._node.removeEventListener('error', self._errorFn, false);
    },

    /**
     * HTML5 Audio canplaythrough listener callback.
     */
    _loadListener: function() {
      var self = this;
      var parent = self._parent;

      // Round up the duration to account for the lower precision in HTML5 Audio.
      parent._duration = Math.ceil(self._node.duration * 10) / 10;

      // Setup a sprite if none is defined.
      if (Object.keys(parent._sprite).length === 0) {
        parent._sprite = {__default: [0, parent._duration * 1000]};
      }

      if (parent._state !== 'loaded') {
        parent._state = 'loaded';
        parent._emit('load');
        parent._loadQueue();
      }

      // Clear the event listener.
      self._node.removeEventListener(Howler._canPlayEvent, self._loadFn, false);
    },

    /**
     * HTML5 Audio ended listener callback.
     */
    _endListener: function() {
      var self = this;
      var parent = self._parent;

      // Only handle the `ended`` event if the duration is Infinity.
      if (parent._duration === Infinity) {
        // Update the parent duration to match the real audio duration.
        // Round up the duration to account for the lower precision in HTML5 Audio.
        parent._duration = Math.ceil(self._node.duration * 10) / 10;

        // Update the sprite that corresponds to the real duration.
        if (parent._sprite.__default[1] === Infinity) {
          parent._sprite.__default[1] = parent._duration * 1000;
        }

        // Run the regular ended method.
        parent._ended(self);
      }

      // Clear the event listener since the duration is now correct.
      self._node.removeEventListener('ended', self._endFn, false);
    }
  };

  /** Helper Methods **/
  /***************************************************************************/

  var cache = {};

  /**
   * Buffer a sound from URL, Data URI or cache and decode to audio source (Web Audio API).
   * @param  {Howl} self
   */
  var loadBuffer = function(self) {
    var url = self._src;

    // Check if the buffer has already been cached and use it instead.
    if (cache[url]) {
      // Set the duration from the cache.
      self._duration = cache[url].duration;

      // Load the sound into this Howl.
      loadSound(self);

      return;
    }

    if (/^data:[^;]+;base64,/.test(url)) {
      // Decode the base64 data URI without XHR, since some browsers don't support it.
      var data = atob(url.split(',')[1]);
      var dataView = new Uint8Array(data.length);
      for (var i=0; i<data.length; ++i) {
        dataView[i] = data.charCodeAt(i);
      }

      decodeAudioData(dataView.buffer, self);
    } else {
      // Load the buffer from the URL.
      var xhr = new XMLHttpRequest();
      xhr.open(self._xhr.method, url, true);
      xhr.withCredentials = self._xhr.withCredentials;
      xhr.responseType = 'arraybuffer';

      // Apply any custom headers to the request.
      if (self._xhr.headers) {
        Object.keys(self._xhr.headers).forEach(function(key) {
          xhr.setRequestHeader(key, self._xhr.headers[key]);
        });
      }

      xhr.onload = function() {
        // Make sure we get a successful response back.
        var code = (xhr.status + '')[0];
        if (code !== '0' && code !== '2' && code !== '3') {
          self._emit('loaderror', null, 'Failed loading audio file with status: ' + xhr.status + '.');
          return;
        }

        decodeAudioData(xhr.response, self);
      };
      xhr.onerror = function() {
        // If there is an error, switch to HTML5 Audio.
        if (self._webAudio) {
          self._html5 = true;
          self._webAudio = false;
          self._sounds = [];
          delete cache[url];
          self.load();
        }
      };
      safeXhrSend(xhr);
    }
  };

  /**
   * Send the XHR request wrapped in a try/catch.
   * @param  {Object} xhr XHR to send.
   */
  var safeXhrSend = function(xhr) {
    try {
      xhr.send();
    } catch (e) {
      xhr.onerror();
    }
  };

  /**
   * Decode audio data from an array buffer.
   * @param  {ArrayBuffer} arraybuffer The audio data.
   * @param  {Howl}        self
   */
  var decodeAudioData = function(arraybuffer, self) {
    // Fire a load error if something broke.
    var error = function() {
      self._emit('loaderror', null, 'Decoding audio data failed.');
    };

    // Load the sound on success.
    var success = function(buffer) {
      if (buffer && self._sounds.length > 0) {
        cache[self._src] = buffer;
        loadSound(self, buffer);
      } else {
        error();
      }
    };

    // Decode the buffer into an audio source.
    if (typeof Promise !== 'undefined' && Howler.ctx.decodeAudioData.length === 1) {
      Howler.ctx.decodeAudioData(arraybuffer).then(success).catch(error);
    } else {
      Howler.ctx.decodeAudioData(arraybuffer, success, error);
    }
  };

  /**
   * Sound is now loaded, so finish setting everything up and fire the loaded event.
   * @param  {Howl} self
   * @param  {Object} buffer The decoded buffer sound source.
   */
  var loadSound = function(self, buffer) {
    // Set the duration.
    if (buffer && !self._duration) {
      self._duration = buffer.duration;
    }

    // Setup a sprite if none is defined.
    if (Object.keys(self._sprite).length === 0) {
      self._sprite = {__default: [0, self._duration * 1000]};
    }

    // Fire the loaded event.
    if (self._state !== 'loaded') {
      self._state = 'loaded';
      self._emit('load');
      self._loadQueue();
    }
  };

  /**
   * Setup the audio context when available, or switch to HTML5 Audio mode.
   */
  var setupAudioContext = function() {
    // If we have already detected that Web Audio isn't supported, don't run this step again.
    if (!Howler.usingWebAudio) {
      return;
    }

    // Check if we are using Web Audio and setup the AudioContext if we are.
    try {
      if (typeof AudioContext !== 'undefined') {
        Howler.ctx = new AudioContext();
      } else if (typeof webkitAudioContext !== 'undefined') {
        Howler.ctx = new webkitAudioContext();
      } else {
        Howler.usingWebAudio = false;
      }
    } catch(e) {
      Howler.usingWebAudio = false;
    }

    // If the audio context creation still failed, set using web audio to false.
    if (!Howler.ctx) {
      Howler.usingWebAudio = false;
    }

    // Check if a webview is being used on iOS8 or earlier (rather than the browser).
    // If it is, disable Web Audio as it causes crashing.
    var iOS = (/iP(hone|od|ad)/.test(Howler._navigator && Howler._navigator.platform));
    var appVersion = Howler._navigator && Howler._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    var version = appVersion ? parseInt(appVersion[1], 10) : null;
    if (iOS && version && version < 9) {
      var safari = /safari/.test(Howler._navigator && Howler._navigator.userAgent.toLowerCase());
      if (Howler._navigator && !safari) {
        Howler.usingWebAudio = false;
      }
    }

    // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
    if (Howler.usingWebAudio) {
      Howler.masterGain = (typeof Howler.ctx.createGain === 'undefined') ? Howler.ctx.createGainNode() : Howler.ctx.createGain();
      Howler.masterGain.gain.setValueAtTime(Howler._muted ? 0 : Howler._volume, Howler.ctx.currentTime);
      Howler.masterGain.connect(Howler.ctx.destination);
    }

    // Re-run the setup on Howler.
    Howler._setup();
  };

  // Add support for CommonJS libraries such as browserify.
  {
    exports.Howler = Howler;
    exports.Howl = Howl;
  }

  // Add to global in Node.js (for testing, etc).
  if (typeof commonjsGlobal !== 'undefined') {
    commonjsGlobal.HowlerGlobal = HowlerGlobal;
    commonjsGlobal.Howler = Howler;
    commonjsGlobal.Howl = Howl;
    commonjsGlobal.Sound = Sound;
  } else if (typeof window !== 'undefined') {  // Define globally in case AMD is not available or unused.
    window.HowlerGlobal = HowlerGlobal;
    window.Howler = Howler;
    window.Howl = Howl;
    window.Sound = Sound;
  }
})();


/*!
 *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
 *  
 *  howler.js v2.2.3
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */

(function() {

  // Setup default properties.
  HowlerGlobal.prototype._pos = [0, 0, 0];
  HowlerGlobal.prototype._orientation = [0, 0, -1, 0, 1, 0];

  /** Global Methods **/
  /***************************************************************************/

  /**
   * Helper method to update the stereo panning position of all current Howls.
   * Future Howls will not use this value unless explicitly set.
   * @param  {Number} pan A value of -1.0 is all the way left and 1.0 is all the way right.
   * @return {Howler/Number}     Self or current stereo panning value.
   */
  HowlerGlobal.prototype.stereo = function(pan) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self.ctx || !self.ctx.listener) {
      return self;
    }

    // Loop through all Howls and update their stereo panning.
    for (var i=self._howls.length-1; i>=0; i--) {
      self._howls[i].stereo(pan);
    }

    return self;
  };

  /**
   * Get/set the position of the listener in 3D cartesian space. Sounds using
   * 3D position will be relative to the listener's position.
   * @param  {Number} x The x-position of the listener.
   * @param  {Number} y The y-position of the listener.
   * @param  {Number} z The z-position of the listener.
   * @return {Howler/Array}   Self or current listener position.
   */
  HowlerGlobal.prototype.pos = function(x, y, z) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self.ctx || !self.ctx.listener) {
      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    y = (typeof y !== 'number') ? self._pos[1] : y;
    z = (typeof z !== 'number') ? self._pos[2] : z;

    if (typeof x === 'number') {
      self._pos = [x, y, z];

      if (typeof self.ctx.listener.positionX !== 'undefined') {
        self.ctx.listener.positionX.setTargetAtTime(self._pos[0], Howler.ctx.currentTime, 0.1);
        self.ctx.listener.positionY.setTargetAtTime(self._pos[1], Howler.ctx.currentTime, 0.1);
        self.ctx.listener.positionZ.setTargetAtTime(self._pos[2], Howler.ctx.currentTime, 0.1);
      } else {
        self.ctx.listener.setPosition(self._pos[0], self._pos[1], self._pos[2]);
      }
    } else {
      return self._pos;
    }

    return self;
  };

  /**
   * Get/set the direction the listener is pointing in the 3D cartesian space.
   * A front and up vector must be provided. The front is the direction the
   * face of the listener is pointing, and up is the direction the top of the
   * listener is pointing. Thus, these values are expected to be at right angles
   * from each other.
   * @param  {Number} x   The x-orientation of the listener.
   * @param  {Number} y   The y-orientation of the listener.
   * @param  {Number} z   The z-orientation of the listener.
   * @param  {Number} xUp The x-orientation of the top of the listener.
   * @param  {Number} yUp The y-orientation of the top of the listener.
   * @param  {Number} zUp The z-orientation of the top of the listener.
   * @return {Howler/Array}     Returns self or the current orientation vectors.
   */
  HowlerGlobal.prototype.orientation = function(x, y, z, xUp, yUp, zUp) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self.ctx || !self.ctx.listener) {
      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    var or = self._orientation;
    y = (typeof y !== 'number') ? or[1] : y;
    z = (typeof z !== 'number') ? or[2] : z;
    xUp = (typeof xUp !== 'number') ? or[3] : xUp;
    yUp = (typeof yUp !== 'number') ? or[4] : yUp;
    zUp = (typeof zUp !== 'number') ? or[5] : zUp;

    if (typeof x === 'number') {
      self._orientation = [x, y, z, xUp, yUp, zUp];

      if (typeof self.ctx.listener.forwardX !== 'undefined') {
        self.ctx.listener.forwardX.setTargetAtTime(x, Howler.ctx.currentTime, 0.1);
        self.ctx.listener.forwardY.setTargetAtTime(y, Howler.ctx.currentTime, 0.1);
        self.ctx.listener.forwardZ.setTargetAtTime(z, Howler.ctx.currentTime, 0.1);
        self.ctx.listener.upX.setTargetAtTime(xUp, Howler.ctx.currentTime, 0.1);
        self.ctx.listener.upY.setTargetAtTime(yUp, Howler.ctx.currentTime, 0.1);
        self.ctx.listener.upZ.setTargetAtTime(zUp, Howler.ctx.currentTime, 0.1);
      } else {
        self.ctx.listener.setOrientation(x, y, z, xUp, yUp, zUp);
      }
    } else {
      return or;
    }

    return self;
  };

  /** Group Methods **/
  /***************************************************************************/

  /**
   * Add new properties to the core init.
   * @param  {Function} _super Core init method.
   * @return {Howl}
   */
  Howl.prototype.init = (function(_super) {
    return function(o) {
      var self = this;

      // Setup user-defined default properties.
      self._orientation = o.orientation || [1, 0, 0];
      self._stereo = o.stereo || null;
      self._pos = o.pos || null;
      self._pannerAttr = {
        coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : 360,
        coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : 360,
        coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : 0,
        distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : 'inverse',
        maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : 10000,
        panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : 'HRTF',
        refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : 1,
        rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : 1
      };

      // Setup event listeners.
      self._onstereo = o.onstereo ? [{fn: o.onstereo}] : [];
      self._onpos = o.onpos ? [{fn: o.onpos}] : [];
      self._onorientation = o.onorientation ? [{fn: o.onorientation}] : [];

      // Complete initilization with howler.js core's init function.
      return _super.call(this, o);
    };
  })(Howl.prototype.init);

  /**
   * Get/set the stereo panning of the audio source for this sound or all in the group.
   * @param  {Number} pan  A value of -1.0 is all the way left and 1.0 is all the way right.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Number}    Returns self or the current stereo panning value.
   */
  Howl.prototype.stereo = function(pan, id) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // If the sound hasn't loaded, add it to the load queue to change stereo pan when capable.
    if (self._state !== 'loaded') {
      self._queue.push({
        event: 'stereo',
        action: function() {
          self.stereo(pan, id);
        }
      });

      return self;
    }

    // Check for PannerStereoNode support and fallback to PannerNode if it doesn't exist.
    var pannerType = (typeof Howler.ctx.createStereoPanner === 'undefined') ? 'spatial' : 'stereo';

    // Setup the group's stereo panning if no ID is passed.
    if (typeof id === 'undefined') {
      // Return the group's stereo panning if no parameters are passed.
      if (typeof pan === 'number') {
        self._stereo = pan;
        self._pos = [pan, 0, 0];
      } else {
        return self._stereo;
      }
    }

    // Change the streo panning of one or all sounds in group.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      // Get the sound.
      var sound = self._soundById(ids[i]);

      if (sound) {
        if (typeof pan === 'number') {
          sound._stereo = pan;
          sound._pos = [pan, 0, 0];

          if (sound._node) {
            // If we are falling back, make sure the panningModel is equalpower.
            sound._pannerAttr.panningModel = 'equalpower';

            // Check if there is a panner setup and create a new one if not.
            if (!sound._panner || !sound._panner.pan) {
              setupPanner(sound, pannerType);
            }

            if (pannerType === 'spatial') {
              if (typeof sound._panner.positionX !== 'undefined') {
                sound._panner.positionX.setValueAtTime(pan, Howler.ctx.currentTime);
                sound._panner.positionY.setValueAtTime(0, Howler.ctx.currentTime);
                sound._panner.positionZ.setValueAtTime(0, Howler.ctx.currentTime);
              } else {
                sound._panner.setPosition(pan, 0, 0);
              }
            } else {
              sound._panner.pan.setValueAtTime(pan, Howler.ctx.currentTime);
            }
          }

          self._emit('stereo', sound._id);
        } else {
          return sound._stereo;
        }
      }
    }

    return self;
  };

  /**
   * Get/set the 3D spatial position of the audio source for this sound or group relative to the global listener.
   * @param  {Number} x  The x-position of the audio source.
   * @param  {Number} y  The y-position of the audio source.
   * @param  {Number} z  The z-position of the audio source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial position: [x, y, z].
   */
  Howl.prototype.pos = function(x, y, z, id) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // If the sound hasn't loaded, add it to the load queue to change position when capable.
    if (self._state !== 'loaded') {
      self._queue.push({
        event: 'pos',
        action: function() {
          self.pos(x, y, z, id);
        }
      });

      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    y = (typeof y !== 'number') ? 0 : y;
    z = (typeof z !== 'number') ? -0.5 : z;

    // Setup the group's spatial position if no ID is passed.
    if (typeof id === 'undefined') {
      // Return the group's spatial position if no parameters are passed.
      if (typeof x === 'number') {
        self._pos = [x, y, z];
      } else {
        return self._pos;
      }
    }

    // Change the spatial position of one or all sounds in group.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      // Get the sound.
      var sound = self._soundById(ids[i]);

      if (sound) {
        if (typeof x === 'number') {
          sound._pos = [x, y, z];

          if (sound._node) {
            // Check if there is a panner setup and create a new one if not.
            if (!sound._panner || sound._panner.pan) {
              setupPanner(sound, 'spatial');
            }

            if (typeof sound._panner.positionX !== 'undefined') {
              sound._panner.positionX.setValueAtTime(x, Howler.ctx.currentTime);
              sound._panner.positionY.setValueAtTime(y, Howler.ctx.currentTime);
              sound._panner.positionZ.setValueAtTime(z, Howler.ctx.currentTime);
            } else {
              sound._panner.setPosition(x, y, z);
            }
          }

          self._emit('pos', sound._id);
        } else {
          return sound._pos;
        }
      }
    }

    return self;
  };

  /**
   * Get/set the direction the audio source is pointing in the 3D cartesian coordinate
   * space. Depending on how direction the sound is, based on the `cone` attributes,
   * a sound pointing away from the listener can be quiet or silent.
   * @param  {Number} x  The x-orientation of the source.
   * @param  {Number} y  The y-orientation of the source.
   * @param  {Number} z  The z-orientation of the source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial orientation: [x, y, z].
   */
  Howl.prototype.orientation = function(x, y, z, id) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // If the sound hasn't loaded, add it to the load queue to change orientation when capable.
    if (self._state !== 'loaded') {
      self._queue.push({
        event: 'orientation',
        action: function() {
          self.orientation(x, y, z, id);
        }
      });

      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    y = (typeof y !== 'number') ? self._orientation[1] : y;
    z = (typeof z !== 'number') ? self._orientation[2] : z;

    // Setup the group's spatial orientation if no ID is passed.
    if (typeof id === 'undefined') {
      // Return the group's spatial orientation if no parameters are passed.
      if (typeof x === 'number') {
        self._orientation = [x, y, z];
      } else {
        return self._orientation;
      }
    }

    // Change the spatial orientation of one or all sounds in group.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      // Get the sound.
      var sound = self._soundById(ids[i]);

      if (sound) {
        if (typeof x === 'number') {
          sound._orientation = [x, y, z];

          if (sound._node) {
            // Check if there is a panner setup and create a new one if not.
            if (!sound._panner) {
              // Make sure we have a position to setup the node with.
              if (!sound._pos) {
                sound._pos = self._pos || [0, 0, -0.5];
              }

              setupPanner(sound, 'spatial');
            }

            if (typeof sound._panner.orientationX !== 'undefined') {
              sound._panner.orientationX.setValueAtTime(x, Howler.ctx.currentTime);
              sound._panner.orientationY.setValueAtTime(y, Howler.ctx.currentTime);
              sound._panner.orientationZ.setValueAtTime(z, Howler.ctx.currentTime);
            } else {
              sound._panner.setOrientation(x, y, z);
            }
          }

          self._emit('orientation', sound._id);
        } else {
          return sound._orientation;
        }
      }
    }

    return self;
  };

  /**
   * Get/set the panner node's attributes for a sound or group of sounds.
   * This method can optionall take 0, 1 or 2 arguments.
   *   pannerAttr() -> Returns the group's values.
   *   pannerAttr(id) -> Returns the sound id's values.
   *   pannerAttr(o) -> Set's the values of all sounds in this Howl group.
   *   pannerAttr(o, id) -> Set's the values of passed sound id.
   *
   *   Attributes:
   *     coneInnerAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      inside of which there will be no volume reduction.
   *     coneOuterAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      outside of which the volume will be reduced to a constant value of `coneOuterGain`.
   *     coneOuterGain - (0 by default) A parameter for directional audio sources, this is the gain outside of the
   *                     `coneOuterAngle`. It is a linear value in the range `[0, 1]`.
   *     distanceModel - ('inverse' by default) Determines algorithm used to reduce volume as audio moves away from
   *                     listener. Can be `linear`, `inverse` or `exponential.
   *     maxDistance - (10000 by default) The maximum distance between source and listener, after which the volume
   *                   will not be reduced any further.
   *     refDistance - (1 by default) A reference distance for reducing volume as source moves further from the listener.
   *                   This is simply a variable of the distance model and has a different effect depending on which model
   *                   is used and the scale of your coordinates. Generally, volume will be equal to 1 at this distance.
   *     rolloffFactor - (1 by default) How quickly the volume reduces as source moves from listener. This is simply a
   *                     variable of the distance model and can be in the range of `[0, 1]` with `linear` and `[0, ∞]`
   *                     with `inverse` and `exponential`.
   *     panningModel - ('HRTF' by default) Determines which spatialization algorithm is used to position audio.
   *                     Can be `HRTF` or `equalpower`.
   *
   * @return {Howl/Object} Returns self or current panner attributes.
   */
  Howl.prototype.pannerAttr = function() {
    var self = this;
    var args = arguments;
    var o, id, sound;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // Determine the values based on arguments.
    if (args.length === 0) {
      // Return the group's panner attribute values.
      return self._pannerAttr;
    } else if (args.length === 1) {
      if (typeof args[0] === 'object') {
        o = args[0];

        // Set the grou's panner attribute values.
        if (typeof id === 'undefined') {
          if (!o.pannerAttr) {
            o.pannerAttr = {
              coneInnerAngle: o.coneInnerAngle,
              coneOuterAngle: o.coneOuterAngle,
              coneOuterGain: o.coneOuterGain,
              distanceModel: o.distanceModel,
              maxDistance: o.maxDistance,
              refDistance: o.refDistance,
              rolloffFactor: o.rolloffFactor,
              panningModel: o.panningModel
            };
          }

          self._pannerAttr = {
            coneInnerAngle: typeof o.pannerAttr.coneInnerAngle !== 'undefined' ? o.pannerAttr.coneInnerAngle : self._coneInnerAngle,
            coneOuterAngle: typeof o.pannerAttr.coneOuterAngle !== 'undefined' ? o.pannerAttr.coneOuterAngle : self._coneOuterAngle,
            coneOuterGain: typeof o.pannerAttr.coneOuterGain !== 'undefined' ? o.pannerAttr.coneOuterGain : self._coneOuterGain,
            distanceModel: typeof o.pannerAttr.distanceModel !== 'undefined' ? o.pannerAttr.distanceModel : self._distanceModel,
            maxDistance: typeof o.pannerAttr.maxDistance !== 'undefined' ? o.pannerAttr.maxDistance : self._maxDistance,
            refDistance: typeof o.pannerAttr.refDistance !== 'undefined' ? o.pannerAttr.refDistance : self._refDistance,
            rolloffFactor: typeof o.pannerAttr.rolloffFactor !== 'undefined' ? o.pannerAttr.rolloffFactor : self._rolloffFactor,
            panningModel: typeof o.pannerAttr.panningModel !== 'undefined' ? o.pannerAttr.panningModel : self._panningModel
          };
        }
      } else {
        // Return this sound's panner attribute values.
        sound = self._soundById(parseInt(args[0], 10));
        return sound ? sound._pannerAttr : self._pannerAttr;
      }
    } else if (args.length === 2) {
      o = args[0];
      id = parseInt(args[1], 10);
    }

    // Update the values of the specified sounds.
    var ids = self._getSoundIds(id);
    for (var i=0; i<ids.length; i++) {
      sound = self._soundById(ids[i]);

      if (sound) {
        // Merge the new values into the sound.
        var pa = sound._pannerAttr;
        pa = {
          coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : pa.coneInnerAngle,
          coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : pa.coneOuterAngle,
          coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : pa.coneOuterGain,
          distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : pa.distanceModel,
          maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : pa.maxDistance,
          refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : pa.refDistance,
          rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : pa.rolloffFactor,
          panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : pa.panningModel
        };

        // Update the panner values or create a new panner if none exists.
        var panner = sound._panner;
        if (panner) {
          panner.coneInnerAngle = pa.coneInnerAngle;
          panner.coneOuterAngle = pa.coneOuterAngle;
          panner.coneOuterGain = pa.coneOuterGain;
          panner.distanceModel = pa.distanceModel;
          panner.maxDistance = pa.maxDistance;
          panner.refDistance = pa.refDistance;
          panner.rolloffFactor = pa.rolloffFactor;
          panner.panningModel = pa.panningModel;
        } else {
          // Make sure we have a position to setup the node with.
          if (!sound._pos) {
            sound._pos = self._pos || [0, 0, -0.5];
          }

          // Create a new panner node.
          setupPanner(sound, 'spatial');
        }
      }
    }

    return self;
  };

  /** Single Sound Methods **/
  /***************************************************************************/

  /**
   * Add new properties to the core Sound init.
   * @param  {Function} _super Core Sound init method.
   * @return {Sound}
   */
  Sound.prototype.init = (function(_super) {
    return function() {
      var self = this;
      var parent = self._parent;

      // Setup user-defined default properties.
      self._orientation = parent._orientation;
      self._stereo = parent._stereo;
      self._pos = parent._pos;
      self._pannerAttr = parent._pannerAttr;

      // Complete initilization with howler.js core Sound's init function.
      _super.call(this);

      // If a stereo or position was specified, set it up.
      if (self._stereo) {
        parent.stereo(self._stereo);
      } else if (self._pos) {
        parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
      }
    };
  })(Sound.prototype.init);

  /**
   * Override the Sound.reset method to clean up properties from the spatial plugin.
   * @param  {Function} _super Sound reset method.
   * @return {Sound}
   */
  Sound.prototype.reset = (function(_super) {
    return function() {
      var self = this;
      var parent = self._parent;

      // Reset all spatial plugin properties on this sound.
      self._orientation = parent._orientation;
      self._stereo = parent._stereo;
      self._pos = parent._pos;
      self._pannerAttr = parent._pannerAttr;

      // If a stereo or position was specified, set it up.
      if (self._stereo) {
        parent.stereo(self._stereo);
      } else if (self._pos) {
        parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
      } else if (self._panner) {
        // Disconnect the panner.
        self._panner.disconnect(0);
        self._panner = undefined;
        parent._refreshBuffer(self);
      }

      // Complete resetting of the sound.
      return _super.call(this);
    };
  })(Sound.prototype.reset);

  /** Helper Methods **/
  /***************************************************************************/

  /**
   * Create a new panner node and save it on the sound.
   * @param  {Sound} sound Specific sound to setup panning on.
   * @param {String} type Type of panner to create: 'stereo' or 'spatial'.
   */
  var setupPanner = function(sound, type) {
    type = type || 'spatial';

    // Create the new panner node.
    if (type === 'spatial') {
      sound._panner = Howler.ctx.createPanner();
      sound._panner.coneInnerAngle = sound._pannerAttr.coneInnerAngle;
      sound._panner.coneOuterAngle = sound._pannerAttr.coneOuterAngle;
      sound._panner.coneOuterGain = sound._pannerAttr.coneOuterGain;
      sound._panner.distanceModel = sound._pannerAttr.distanceModel;
      sound._panner.maxDistance = sound._pannerAttr.maxDistance;
      sound._panner.refDistance = sound._pannerAttr.refDistance;
      sound._panner.rolloffFactor = sound._pannerAttr.rolloffFactor;
      sound._panner.panningModel = sound._pannerAttr.panningModel;

      if (typeof sound._panner.positionX !== 'undefined') {
        sound._panner.positionX.setValueAtTime(sound._pos[0], Howler.ctx.currentTime);
        sound._panner.positionY.setValueAtTime(sound._pos[1], Howler.ctx.currentTime);
        sound._panner.positionZ.setValueAtTime(sound._pos[2], Howler.ctx.currentTime);
      } else {
        sound._panner.setPosition(sound._pos[0], sound._pos[1], sound._pos[2]);
      }

      if (typeof sound._panner.orientationX !== 'undefined') {
        sound._panner.orientationX.setValueAtTime(sound._orientation[0], Howler.ctx.currentTime);
        sound._panner.orientationY.setValueAtTime(sound._orientation[1], Howler.ctx.currentTime);
        sound._panner.orientationZ.setValueAtTime(sound._orientation[2], Howler.ctx.currentTime);
      } else {
        sound._panner.setOrientation(sound._orientation[0], sound._orientation[1], sound._orientation[2]);
      }
    } else {
      sound._panner = Howler.ctx.createStereoPanner();
      sound._panner.pan.setValueAtTime(sound._stereo, Howler.ctx.currentTime);
    }

    sound._panner.connect(sound._node);

    // Update the connections.
    if (!sound._paused) {
      sound._parent.pause(sound._id, true).play(sound._id, true);
    }
  };
})();
}(howler));

function mathClamp(number, {minimum, maximum}) {
	if (minimum > maximum) {
		throw new RangeError('`minimum` should be lower than `maximum`');
	}

	if (number < minimum) {
		return minimum;
	}

	if (number > maximum) {
		return maximum;
	}

	return number;
}

var objectValues = object => Object.keys(object).map(i => object[i]);

var values = objectValues;

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

var assign = objectAssign;

/* eslint-disable */
var Audio$1 = {
  props: {
    /**
     * A string type url of audio file
     */
    audioSource: {
      type: String,
      required: true,
      validator: function validator(audioSource) {
        // Every audioSource must be a non-empty string
        return typeof audioSource === 'string' && (audioSource === null || audioSource === void 0 ? void 0 : audioSource.length) > 0;
      }
    },
    /**
     * Whether to start the playback
     * when the component is mounted
     */
    autoplay: {
      type: Boolean,
      default: false
    },
    /**
     * Whether to start the playback again
     * automatically after it is done playing
     */
    loop: {
      type: Boolean,
      default: false
    },
    /**
     * Whether to start downloading the audio
     * file when the component is mounted
     */
    preload: {
      type: Boolean,
      default: true
    },
    /**
     * Whether to force HTML5 Audio
     */
    html5: {
      type: Boolean,
      default: false
    },
    /**
     * An array of audio file types
     */
    formats: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     * Whether to enable the withCredentials flag on XHR
     * requests used to fetch audio files when using Web Audio API
     */
    xhrWithCredentials: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this = this;
    return {
      /**
       * The Howl instance used for playback
       */
      _howl: null,
      /**
       * Whether audio is currently playing
       */
      playing: false,
      /**
       * Whether the audio playback is muted
       */
      muted: false,
      /**
       * The volume of the playback on a scale of 0 to 1
       */
      volume: 1.0,
      /**
       * The rate (speed) of the playback on a scale of 0.5 to 4
       */
      rate: 1.0,
      /**
       * The position of playback in seconds
       */
      seek: 0,
      /**
       * The duration of the audio in seconds
       */
      duration: 0,
      /**
       * Functions that poll the Howl instance
       * to update various data
       */
      _polls: {
        seek: {
          id: null,
          interval: 1000 / 4,
          // 4 times per second (4Hz)
          hook: function hook() {
            _this.seek = _this.$data._howl.seek();
          }
        }
      },
      /**
       * A list of howl events to listen to and
       * functions to call when they are triggered
       */
      _howlEvents: [{
        name: 'load',
        hook: function hook() {
          _this.duration = _this.$data._howl.duration();
        }
      }, 'loaderror', 'playerror', {
        name: 'play',
        hook: function hook() {
          _this.playing = true;
        }
      }, {
        name: 'end',
        hook: function hook() {
          _this.playing = false;
        }
      }, {
        name: 'pause',
        hook: function hook() {
          _this.playing = false;
        }
      }, {
        name: 'stop',
        hook: function hook() {
          _this.playing = false;
          if (_this.$data._howl != null) {
            _this.seek = _this.$data._howl.seek();
          }
        }
      }, 'mute', {
        name: 'volume',
        hook: function hook() {
          _this.volume = _this.$data._howl.volume();
        }
      }, {
        name: 'rate',
        hook: function hook() {
          _this.rate = _this.$data._howl.rate();
        }
      }, {
        name: 'seek',
        hook: function hook() {
          if (!_this.playing) _this.seek = _this.$data._howl.seek();
        }
      }, 'fade']
    };
  },
  computed: {
    /**
     * The progress of the playback on a scale of 0 to 1
     */
    progress: function progress() {
      if (this.duration === 0) return 0;
      return this.seek / this.duration;
    }
  },
  created: function created() {
    this._initialize();
  },
  beforeDestroy: function beforeDestroy() {
    this._cleanup();
  },
  watch: {
    playing: function playing(_playing) {
      // Update the seek
      this.seek = this.$data._howl.seek();
      if (_playing) {
        // Start the seek poll
        this.$data._polls.seek.id = setInterval(this.$data._polls.seek.hook, this.$data._polls.seek.interval);
      } else {
        // Stop the seek poll
        clearInterval(this.$data._polls.seek.id);
      }
    },
    audioSource: function audioSource(_audioSource) {
      this._reinitialize();
    }
  },
  methods: {
    /**
     * Reinitialize the Howler player
     */
    _reinitialize: function _reinitialize() {
      this._cleanup(false);
      this._initialize();
    },
    /**
     * Initialize the Howler player
     */
    _initialize: function _initialize() {
      var _this2 = this;
      this.$data._howl = new howler.Howl({
        src: this.audioSource,
        volume: this.volume,
        html5: this.html5,
        loop: this.loop,
        preload: this.preload,
        autoplay: this.autoplay,
        mute: this.muted,
        rate: this.rate,
        format: this.formats,
        xhrWithCredentials: this.xhrWithCredentials
      });
      var duration = this.$data._howl.duration();
      this.duration = duration;
      if (duration > 0) {
        // The audio file(s) have been cached. Howler won't
        // emit a load event, so we will do this manually
        this.$emit('load');
      }

      // Bind to all Howl events
      this.$data._howlEvents = this.$data._howlEvents.map(function (event) {
        // Normalize string shorthands to objects
        if (typeof event === 'string') {
          event = {
            name: event
          };
        }

        // Create a handler
        var handler = function handler(id, details) {
          if (typeof event.hook === 'function') event.hook(id, details);
          _this2.$emit(event.name, id, details);
        };

        // Bind the handler
        _this2.$data._howl.on(event.name, handler);

        // Return the name and handler to unbind later
        return assign({}, event, {
          handler: handler
        });
      });
    },
    /**
     * Clean up the Howler player
     */
    _cleanup: function _cleanup() {
      var _this3 = this;
      var resetSettings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      // Stop all playback
      if (this.$data._howl) {
        this.stop();
      }

      // Stop all polls
      values(this.$data._polls).forEach(function (poll) {
        if (poll.id != null) clearInterval(poll.id);
      });

      // Clear all event listeners
      this.$data._howlEvents.map(function (event) {
        if (event.handler) {
          if (_this3.$data._howl) {
            _this3.$data._howl.off(event.name, event.handler);
          }
          var _event = assign({}, event);
          delete _event.handler;
          return _event;
        }
        return event;
      });

      // Destroy the Howl instance
      this.$data._howl = null;
      this.duration = 0;
      if (resetSettings) {
        this.muted = false;
        this.volume = 1.0;
        this.rate = 1.0;
      }
    },
    /**
     * Start the playback
     */
    play: function play() {
      if (!this.playing) this.$data._howl.play();
    },
    /**
     * Pause the playback
     */
    pause: function pause() {
      if (this.playing) this.$data._howl.pause();
    },
    /**
     * Toggle playing or pausing the playback
     */
    togglePlayback: function togglePlayback() {
      if (!this.playing) {
        this.$data._howl.play();
      } else {
        this.$data._howl.pause();
      }
    },
    /**
     * Stop the playback (also resets the seek to 0)
     */
    stop: function stop() {
      this.$data._howl.stop();
    },
    /**
     * Mute the playback
     */
    mute: function mute() {
      this.$data._howl.mute(true);
      this.muted = true;
    },
    /**
     * Unmute the playback
     */
    unmute: function unmute() {
      this.$data._howl.mute(false);
      this.muted = false;
    },
    /**
     * Toggle muting and unmuting the playback
     */
    toggleMute: function toggleMute() {
      this.$data._howl.mute(!this.muted);
      this.muted = !this.muted;
    },
    /**
     * Set the volume of the playback
     * @param {Number} volume - The new volume.
     * The value is clamped between 0 and 1
     */
    setVolume: function setVolume(volume) {
      if (typeof volume !== 'number') {
        throw new Error("volume must be a number, got a ".concat(_typeof$2(volume), " instead"));
      }
      this.$data._howl.volume(mathClamp(volume, 0));
    },
    /**
     * Set the rate (speed) of the playback
     * @param {Number} rate - The new rate.
     * The value is clamped between 0.5 and 4
     */
    setRate: function setRate(rate) {
      if (typeof rate !== 'number') {
        throw new Error("rate must be a number, got a ".concat(_typeof$2(rate), " instead"));
      }
      this.$data._howl.rate(mathClamp(rate, 0.5));
    },
    /**
     * Set the position of the playback
     * @param {Number} seek - The new position in seconds.
     * The value is clamped between 0 and the duration
     */
    setSeek: function setSeek(seek) {
      if (typeof seek !== 'number') {
        throw new Error("seek must be a number, got a ".concat(_typeof$2(seek), " instead"));
      }
      this.$data._howl.seek(mathClamp(seek, 0, this.duration));
    },
    /**
     * Set the progress of the playback
     * @param {Number} progress - The new progress.
     * The value is clamped between 0 and 1
     */
    setProgress: function setProgress(progress) {
      if (typeof progress !== 'number') {
        throw new Error("progress must be a number, got a ".concat(_typeof$2(progress), " instead"));
      }
      this.setSeek(mathClamp(progress, 0) * this.duration);
    }
  }
};

//
var script$1A = {
  name: 'MiniAudio',
  mixins: [Audio$1],
  props: {
    width: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    advance: {
      type: Boolean,
      default: true
    },
    error: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      min: 0,
      max: 100,
      slider: null,
      thunk: null,
      per: 0,
      rate: 1,
      isMute: true,
      curVolume: 0.5,
      totalWidth: 500
    };
  },
  watch: {
    curProgress: function curProgress(v) {
      if (!document.onmouseup) {
        this.per = v;
      }
    }
  },
  computed: {
    curProgress: function curProgress() {
      var curProgress = (Math.round(this.progress * 10000) / 100.0).toFixed(2);
      return curProgress;
    },
    scale: function scale() {
      var scale = (this.per - this.min) / (this.max - this.min);
      return scale;
    },
    pWidth: function pWidth() {
      if (this.slider) {
        return this.slider.offsetWidth * this.scale + 'px';
      } else {
        return 0 + 'px';
      }
    },
    left: function left() {
      if (this.slider) {
        return this.slider.offsetWidth * this.scale - this.thunk.offsetWidth / 2 + 'px';
      } else {
        return 0 + 'px';
      }
    }
  },
  methods: {
    handleModifyProgress: function handleModifyProgress(e) {
      if (e.target.className === 'slider' || e.target.className === 'process') {
        var scale = e.offsetX / this.slider.offsetWidth;
        this.setProgress(scale);
      }
    },
    handleToggleMute: function handleToggleMute() {
      this.isMute ? this.isMute = false : this.isMute = true;
      this.toggleMute();
    },
    _sToMs: function _sToMs(s) {
      var _h, _s;
      if (typeof s !== 'number') return '00' + ':' + '00';
      s = parseInt(s);
      var h;
      h = Math.floor(s / 60);
      s = s % 60;
      h += '';
      s += '';
      h = ((_h = h) === null || _h === void 0 ? void 0 : _h.length) == 1 ? '0' + h : h;
      s = ((_s = s) === null || _s === void 0 ? void 0 : _s.length) == 1 ? '0' + s : s;
      return h + ':' + s;
    }
  },
  mounted: function mounted() {
    var _this = this;
    if (this.width && typeof this.width === 'number') {
      this.totalWidth = this.width + 'px';
    }
    this.setVolume(this.curVolume);
    this.slider = this.$refs.slider;
    this.thunk = this.$refs.trunk;
    this.thunk.onmousedown = function (e) {
      var pWidth = parseInt(_this.pWidth);
      var disX = e.clientX;
      document.onmousemove = function (e) {
        var newWidth = e.clientX - disX + pWidth;
        var scale = newWidth / _this.slider.offsetWidth;
        _this.per = Math.ceil((_this.max - _this.min) * scale + _this.min);
        _this.per = Math.max(_this.per, _this.min);
        _this.per = Math.min(_this.per, _this.max);
      };
      document.onmouseup = function () {
        document.onmousemove = document.onmouseup = null;
        _this.setProgress(_this.scale);
      };
      return false;
    };
  }
};

/* script */
var __vue_script__$1A = script$1A;

/* template */
var __vue_render__$1A = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-voice-player__content']
  }, [_c('div', {
    staticClass: "operate operate_button"
  }, [_c('aq-button', {
    class: ['aq-voice-player__button', {
      'aq-voice-player--button--disabled': _vm.disabled
    }],
    on: {
      "click": _vm.togglePlayback
    }
  }, [_c('em', {
    class: [{
      'aq-voice-player--disabled': _vm.disabled,
      'aq-icon-play-fill': !_vm.playing,
      'aq-icon-pause': _vm.playing
    }]
  })]), _vm._v(" "), _vm.advance ? _c('span', {
    class: {
      'aq-voice-player--disabled': _vm.disabled
    }
  }, [_vm._v(_vm._s(_vm._sToMs(_vm.seek)))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    ref: "slider",
    class: ['slider', {
      slider__disabled: _vm.disabled
    }],
    on: {
      "click": _vm.handleModifyProgress
    }
  }, [_c('div', {
    staticClass: "progressInfo"
  }), _vm._v(" "), _c('div', {
    staticClass: "process",
    style: {
      width: _vm.pWidth
    }
  }), _vm._v(" "), _c('div', {
    ref: "trunk",
    staticClass: "thunk",
    style: {
      left: _vm.left
    }
  }, [_c('div', {
    staticClass: "block"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "operate"
  }, [_c('span', {
    class: ['last', {
      'aq-voice-player--disabled': _vm.disabled
    }]
  }, [_vm._v(_vm._s(_vm._sToMs(_vm.duration)))])]), _vm._v(" "), _vm.error ? _c('em', {
    staticClass: "aq-icon-alert-circle-fill aq-voice-player__content--error"
  }) : _vm._e()]);
};
var __vue_staticRenderFns__$1A = [];

/* style */
var __vue_inject_styles__$1A = undefined;
/* scoped */
var __vue_scope_id__$1A = undefined;
/* module identifier */
var __vue_module_identifier__$1A = undefined;
/* functional template */
var __vue_is_functional_template__$1A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1A = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1A,
  staticRenderFns: __vue_staticRenderFns__$1A
}, __vue_inject_styles__$1A, __vue_script__$1A, __vue_scope_id__$1A, __vue_is_functional_template__$1A, __vue_module_identifier__$1A, false, undefined, undefined, undefined);
var MiniAudio = __vue_component__$1A;

var LabelMixin = {
  props: {
    info: {
      type: [String, Function],
      default: ''
    },
    label: {
      type: [String, Function],
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltipWidth: {
      type: String,
      default: ''
    }
  },
  computed: {
    isLabelVisible: function isLabelVisible() {
      var _this$$aqT;
      return ((_this$$aqT = this.$aqT(this.label)) === null || _this$$aqT === void 0 ? void 0 : _this$$aqT.length) > 0;
    },
    bindsLabel: function bindsLabel() {
      return {
        info: this.info,
        required: this.required,
        disabled: this.disabled,
        tooltipWidth: this.tooltipWidth
      };
    }
  }
};

var helperTextMixin = {
  props: {
    error: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    helperText: {
      type: [String, Function],
      default: function _default() {
        return '';
      }
    }
  },
  computed: {
    isHelperTextVisible: function isHelperTextVisible() {
      var _this$$aqT;
      return ((_this$$aqT = this.$aqT(this.helperText)) === null || _this$$aqT === void 0 ? void 0 : _this$$aqT.length) > 0;
    },
    bindsHelperText: function bindsHelperText() {
      return {
        text: this.helperText,
        error: !this.disabled && !this.readonly && this.error
      };
    }
  }
};

//
var script$1z = {
  name: 'aq-voice-player',
  mixins: [LabelMixin, sizeMixin, helperTextMixin],
  props: {
    audioSource: {
      type: String,
      required: true,
      validator: function validator(audioSource) {
        return typeof audioSource === 'string' && (audioSource === null || audioSource === void 0 ? void 0 : audioSource.length) > 0;
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    advance: {
      type: Boolean,
      default: true
    },
    autoplay: {
      type: Boolean,
      default: false
    },
    loop: {
      type: Boolean,
      default: false
    },
    /**
     * Whether to start downloading the audio
     * file when the component is mounted
     */
    preload: {
      type: Boolean,
      default: true
    },
    html5: {
      type: Boolean,
      default: false
    },
    /**
     * An array of audio file types
     */
    formats: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    /**
     * Whether to enable the withCredentials flag on XHR
     * requests used to fetch audio files when using Web Audio API
     */
    xhrWithCredentials: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  components: {
    miniAudio: MiniAudio
  },
  data: function data() {
    return {};
  },
  computed: {}
};

/* script */
var __vue_script__$1z = script$1z;

/* template */
var __vue_render__$1z = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-voice-player', {
      'aq-voice-player--disabled': _vm.disabled
    }],
    style: _vm.mixinSizeStyle
  }, [_vm.isLabelVisible ? _c('div', {
    staticClass: "aq-voice-player__label"
  }, [_vm.isLabelVisible ? _c('aq-label', _vm._b({}, 'aq-label', _vm.bindsLabel, false), [_vm._v("\n      " + _vm._s(_vm.$aqT(_vm.label)) + "\n    ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('miniAudio', {
    attrs: {
      "width": _vm.width,
      "audioSource": _vm.audioSource,
      "disabled": _vm.disabled,
      "autoplay": _vm.autoplay,
      "advance": _vm.advance,
      "error": _vm.error
    }
  }), _vm._v(" "), _vm.isHelperTextVisible ? _c('div', {
    staticClass: "aq-radio-group__helper-text"
  }, [_vm.isHelperTextVisible ? _c('aq-helper-text', _vm._b({}, 'aq-helper-text', _vm.bindsHelperText, false)) : _vm._e()], 1) : _vm._e()], 1);
};
var __vue_staticRenderFns__$1z = [];

/* style */
var __vue_inject_styles__$1z = undefined;
/* scoped */
var __vue_scope_id__$1z = undefined;
/* module identifier */
var __vue_module_identifier__$1z = undefined;
/* functional template */
var __vue_is_functional_template__$1z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1z = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1z,
  staticRenderFns: __vue_staticRenderFns__$1z
}, __vue_inject_styles__$1z, __vue_script__$1z, __vue_scope_id__$1z, __vue_is_functional_template__$1z, __vue_module_identifier__$1z, false, undefined, undefined, undefined);
var AqVoicePlayer = __vue_component__$1z;

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN$1 = 0 / 0;

/** `Object#toString` result references. */
var symbolTag$1 = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim$1 = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex$1 = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary$1 = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal$1 = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt$1 = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal$1 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$1 = freeGlobal$1 || freeSelf$1 || Function('return this')();

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString$1 = objectProto$1.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax$1 = Math.max,
    nativeMin$1 = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now$1 = function() {
  return root$1.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce$1(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  wait = toNumber$1(wait) || 0;
  if (isObject$2(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax$1(toNumber$1(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin$1(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now$1();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now$1());
  }

  function debounced() {
    var time = now$1(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$2(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike$1(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$1(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$1(value) && objectToString$1.call(value) == symbolTag$1);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol$1(value)) {
    return NAN$1;
  }
  if (isObject$2(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$2(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim$1, '');
  var isBinary = reIsBinary$1.test(value);
  return (isBinary || reIsOctal$1.test(value))
    ? freeParseInt$1(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex$1.test(value) ? NAN$1 : +value);
}

var lodash_debounce = debounce$1;

function ownKeys$b(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$c(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$b(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$b(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var script$1y = {
  name: 'VtTableHeading',
  components: {
    VtSortControl: VtSortControl,
    vnodes: {
      functional: true,
      render: function render(h, ctx) {
        return _typeof$2(ctx.props.vnodes) === 'object' ? ctx.props.vnodes : [ctx.props.vnodes];
      }
    }
  },
  props: ['props'],
  data: function data() {
    return {
      style: {},
      isLastPinned: false,
      interval: null,
      hover: false,
      thEvents: null,
      sorterEvent: null,
      heading: '',
      id: ''
    };
  },
  computed: {
    enableReorder: function enableReorder() {
      var visible = true;
      if ('enableReorder' in this.props.opts) {
        visible = this.props.opts.enableReorder;
      } else if (this.columnsOptions[this.heading] && 'enableReorder' in this.columnsOptions[this.heading]) {
        visible = this.columnsOptions[this.heading].enableReorder;
      }
      return visible;
    },
    enablePin: function enablePin() {
      var visible = true;
      if ('enablePin' in this.props.opts) {
        visible = this.props.opts.enablePin;
      } else if (this.columnsOptions[this.heading] && 'enablePin' in this.columnsOptions[this.heading]) {
        visible = this.columnsOptions[this.heading].enablePin;
      }
      return visible;
    },
    enableSort: function enableSort() {
      var visible = true;
      if ('enableSort' in this.props.opts) {
        visible = this.props.opts.enableSort;
      } else if (this.columnsOptions[this.heading] && 'enableSort' in this.columnsOptions[this.heading]) {
        visible = this.columnsOptions[this.heading].enableSort;
      }
      return visible;
    },
    originalColumns: function originalColumns() {
      return this.props.columns;
    },
    columnsOptions: function columnsOptions() {
      return this.props.opts.columnsOptions;
    },
    isPinned: {
      get: function get() {
        var _this$columnsOptions$;
        return (_this$columnsOptions$ = this.columnsOptions[this.heading]) === null || _this$columnsOptions$ === void 0 ? void 0 : _this$columnsOptions$.pinned;
      },
      set: function set(val) {
        this.columnsOptions[this.heading].pinned = val;
      }
    },
    align: function align() {
      var _this$props$opts, _this$props$opts$colu;
      var align = ((_this$props$opts = this.props.opts) === null || _this$props$opts === void 0 ? void 0 : (_this$props$opts$colu = _this$props$opts.columnsOptions[this.heading]) === null || _this$props$opts$colu === void 0 ? void 0 : _this$props$opts$colu.align) || 'left';
      return "aq-table-heading__text-title--".concat(align);
    }
  },
  watch: {
    originalColumns: {
      handler: function handler() {
        var _this = this;
        this.setSize();
        // TODO: Es la mejor aproximacion?
        setTimeout(function () {
          _this.setSize();
        });
      },
      deep: true
    },
    columnsOptions: {
      handler: function handler() {
        var _this2 = this;
        this.setSize();
        setTimeout(function () {
          _this2.isLastPinned = _this2.props.opts.lastPinned === _this2.heading;
          _this2.setSize();
        });
      },
      deep: true
    },
    '$parent.$parent.$attrs': {
      handler: function handler() {
        this.setHeading();
      }
    }
  },
  methods: {
    setSize: function setSize() {
      if (this.heading !== '') {
        var _this$columnsOptions$2, _this$columnsOptions$3, _this$columnsOptions$4;
        this.id = this.heading;
        var width = ((_this$columnsOptions$2 = this.columnsOptions[this.heading]) === null || _this$columnsOptions$2 === void 0 ? void 0 : _this$columnsOptions$2.width) || 'auto';
        var width2 = (_this$columnsOptions$3 = this.columnsOptions[this.heading]) !== null && _this$columnsOptions$3 !== void 0 && _this$columnsOptions$3.realWidth ? "".concat((_this$columnsOptions$4 = this.columnsOptions[this.heading]) === null || _this$columnsOptions$4 === void 0 ? void 0 : _this$columnsOptions$4.realWidth, "px") : 'auto';
        var position = this.isPinned ? 'sticky' : 'relative';
        var zIndex = this.isPinned ? 2 : 1;
        var columnStyle = {
          position: position,
          zIndex: zIndex,
          left: "".concat(this.getLeft(), "px"),
          minWidth: width
        };
        this.style = _objectSpread$c({
          width: width2,
          minWidth: width
        }, columnStyle);
        this.columnsOptions[this.heading].style = _objectSpread$c({}, columnStyle);
      } else {
        console.log('heading is not defined');
      }
    },
    getLeft: function getLeft() {
      var el = this.$refs.heading;
      var left = 0;
      if (el && this.isPinned) {
        var nextElement = el.previousElementSibling;
        while (nextElement !== null) {
          if (nextElement.getAttribute('pinned')) {
            left += nextElement.offsetWidth;
          }
          nextElement = nextElement.previousElementSibling;
        }
      }
      return left;
    },
    pinned: function pinned() {
      this.isPinned = !this.isPinned;
    },
    setHeading: function setHeading() {
      this.heading = this.$parent.$parent.$attrs.nameColumn;
    },
    setListeners: function setListeners(div) {
      var _this3 = this;
      var pageX;
      var curCol;
      var curColWidth;
      var funcDebounce = lodash_debounce(this.setSizeC, 150);
      div.addEventListener('mousedown', function (e) {
        e.preventDefault();
        e.stopPropagation();
        curCol = e.target.parentElement;
        pageX = e.pageX;
        var padding = _this3.paddingDiff(curCol);
        curColWidth = curCol.offsetWidth - padding;
      });
      div.addEventListener('mouseout', function (e) {
        e.target.style.borderRight = '';
      });
      document.addEventListener('mousemove', function (e) {
        if (curCol) {
          var diffX = e.pageX - pageX;
          curCol.style.minWidth = "".concat(curColWidth + diffX, "px");
          funcDebounce(curCol.style.minWidth);
        }
      });
      document.addEventListener('mouseup', function (e) {
        if (e.target.nodeName === 'INPUT') return;
        e.stopPropagation();
        curCol = undefined;
        pageX = undefined;
        curColWidth = undefined;
      });
    },
    paddingDiff: function paddingDiff(col) {
      if (this.getStyleVal(col, 'box-sizing') === 'border-box') {
        return 0;
      }
      var padLeft = this.getStyleVal(col, 'padding-left');
      var padRight = this.getStyleVal(col, 'padding-right');
      return parseInt(padLeft, 10) + parseInt(padRight, 10);
    },
    getStyleVal: function getStyleVal(elm, css) {
      return window.getComputedStyle(elm, null).getPropertyValue(css);
    },
    addResizable: function addResizable() {
      var _this$$refs, _this$$refs$heading;
      if ((_this$$refs = this.$refs) !== null && _this$$refs !== void 0 && (_this$$refs$heading = _this$$refs.heading) !== null && _this$$refs$heading !== void 0 && _this$$refs$heading.childNodes[1]) {
        this.setListeners(this.$refs.heading.childNodes[1]);
      }
    },
    setSizeC: function setSizeC(width) {
      this.columnsOptions[this.heading].width = width;
    },
    getTooltipVisible: function getTooltipVisible() {
      var visible = false;
      var title = this.$refs.title;
      if (title) {
        visible = title.scrollWidth > title.offsetWidth;
      }
      return visible;
    }
  },
  created: function created() {
    var thEvents = this.props.thEvents;
    this.sorterEvent = {
      click: thEvents.click
    };
    delete thEvents.click;
    this.thEvents = thEvents;
  },
  mounted: function mounted() {
    var _this4 = this;
    this.setHeading();
    this.setSize();
    setTimeout(function () {
      _this4.setSize();
    });
    setTimeout(function () {
      _this4.addResizable();
    }, 1000);
    global.vtEvent.$on('aq-table.setWidthHeader', this.setSize);
  },
  beforeDestroy: function beforeDestroy() {
    global.vtEvent.$off('aq-table.setWidthHeader', this.setSize);
  }
};

/* script */
var __vue_script__$1y = script$1y;

/* template */
var __vue_render__$1y = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('th', _vm._g(_vm._b({
    ref: "heading",
    class: ['aq-table-heading', {
      'last-left-fixed-column': _vm.isLastPinned
    }],
    style: _vm.style,
    attrs: {
      "pinned": _vm.isPinned,
      "id": _vm.heading
    },
    on: {
      "mouseover": function mouseover($event) {
        _vm.hover = true;
      },
      "mouseleave": function mouseleave($event) {
        _vm.hover = false;
      }
    }
  }, 'th', _vm.props.thAttrs, false), _vm.thEvents), [_c('div', {
    staticClass: "aq-table-heading__content"
  }, [_c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.hover && _vm.enableReorder,
      expression: "hover && enableReorder"
    }],
    staticClass: "aq-table-heading__reorder aq-icon-six-dots aq-table__dropdown-handler"
  }), _vm._v(" "), _c('span', {
    class: ['aq-table-heading__title VueTables__heading', {
      'aq-table-heading__title--left': _vm.hover && _vm.enableReorder
    }],
    attrs: {
      "title": _vm.props.title
    }
  }, [_c('aq-tooltip', {
    attrs: {
      "showTooltip": _vm.getTooltipVisible()
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_c('span', {
          ref: "title",
          class: ['aq-table-heading__text-title', _vm.align]
        }, [_c('vnodes', {
          attrs: {
            "vnodes": _vm.props.heading
          }
        })], 1)];
      },
      proxy: true
    }], null, true)
  }, [_vm._v(" "), _c('vnodes', {
    attrs: {
      "vnodes": _vm.props.heading
    }
  })], 1)], 1), _vm._v(" "), _c('em', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.enablePin,
      expression: "enablePin"
    }],
    class: ['aq-table-heading__pin', {
      'aq-icon-pin': !_vm.isPinned,
      'aq-icon-pin-fill': _vm.isPinned
    }],
    on: {
      "click": _vm.pinned
    }
  }), _vm._v(" "), _c('span', _vm._g({
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.enableSort,
      expression: "enableSort"
    }],
    staticClass: "aq-table-heading__sort"
  }, _vm.sorterEvent), [_c('vt-sort-control')], 1)])]);
};
var __vue_staticRenderFns__$1y = [];

/* style */
var __vue_inject_styles__$1y = undefined;
/* scoped */
var __vue_scope_id__$1y = undefined;
/* module identifier */
var __vue_module_identifier__$1y = undefined;
/* functional template */
var __vue_is_functional_template__$1y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1y = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1y,
  staticRenderFns: __vue_staticRenderFns__$1y
}, __vue_inject_styles__$1y, __vue_script__$1y, __vue_scope_id__$1y, __vue_is_functional_template__$1y, __vue_module_identifier__$1y, false, undefined, undefined, undefined);
var TableHeading = __vue_component__$1y;

//
//
//
//

var script$1x = {
  name: 'VtSortControl',
  props: ['props'],
  computed: {
    icon: function icon() {
      // sortStatus = { sorted: Boolean, asc: Boolean }

      // if not sorted return base icon
      if (!this.props.sortStatus.sorted) return 'aq-icon-chevron-up-down';

      // return sort direction icon
      return this.props.sortStatus.asc ? 'aq-icon-chevron-up' : 'aq-icon-chevron-down';
    }
  }
};

/* script */
var __vue_script__$1x = script$1x;

/* template */
var __vue_render__$1x = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('em', {
    class: _vm.icon,
    attrs: {
      "props.sortable": ""
    }
  });
};
var __vue_staticRenderFns__$1x = [];

/* style */
var __vue_inject_styles__$1x = undefined;
/* scoped */
var __vue_scope_id__$1x = undefined;
/* module identifier */
var __vue_module_identifier__$1x = undefined;
/* functional template */
var __vue_is_functional_template__$1x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1x = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1x,
  staticRenderFns: __vue_staticRenderFns__$1x
}, __vue_inject_styles__$1x, __vue_script__$1x, __vue_scope_id__$1x, __vue_is_functional_template__$1x, __vue_module_identifier__$1x, false, undefined, undefined, undefined);
var SortControl = __vue_component__$1x;

var vuedraggable_umd = {exports: {}};

/**!
 * Sortable 1.10.2
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function _typeof$1(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof$1 = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$1(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

function _objectSpread$b(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var version = "1.10.2";

function userAgent(pattern) {
  if (typeof window !== 'undefined' && window.navigator) {
    return !!
    /*@__PURE__*/
    navigator.userAgent.match(pattern);
  }
}

var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);

var captureMode = {
  capture: false,
  passive: false
};

function on(el, event, fn) {
  el.addEventListener(event, fn, !IE11OrLess && captureMode);
}

function off(el, event, fn) {
  el.removeEventListener(event, fn, !IE11OrLess && captureMode);
}

function matches(
/**HTMLElement*/
el,
/**String*/
selector) {
  if (!selector) return;
  selector[0] === '>' && (selector = selector.substring(1));

  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector);
      }
    } catch (_) {
      return false;
    }
  }

  return false;
}

function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}

function closest(
/**HTMLElement*/
el,
/**String*/
selector,
/**HTMLElement*/
ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;

    do {
      if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && matches(el, selector) : matches(el, selector)) || includeCTX && el === ctx) {
        return el;
      }

      if (el === ctx) break;
      /* jshint boss:true */
    } while (el = getParentOrHost(el));
  }

  return null;
}

var R_SPACE = /\s+/g;

function toggleClass(el, name, state) {
  if (el && name) {
    if (el.classList) {
      el.classList[state ? 'add' : 'remove'](name);
    } else {
      var className = (' ' + el.className + ' ').replace(R_SPACE, ' ').replace(' ' + name + ' ', ' ');
      el.className = (className + (state ? ' ' + name : '')).replace(R_SPACE, ' ');
    }
  }
}

function css(el, prop, val) {
  var style = el && el.style;

  if (style) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, '');
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }

      return prop === void 0 ? val : val[prop];
    } else {
      if (!(prop in style) && prop.indexOf('webkit') === -1) {
        prop = '-webkit-' + prop;
      }

      style[prop] = val + (typeof val === 'string' ? '' : 'px');
    }
  }
}

function matrix(el, selfOnly) {
  var appliedTransforms = '';

  if (typeof el === 'string') {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, 'transform');

      if (transform && transform !== 'none') {
        appliedTransforms = transform + ' ' + appliedTransforms;
      }
      /* jshint boss:true */

    } while (!selfOnly && (el = el.parentNode));
  }

  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  /*jshint -W056 */

  return matrixFn && new matrixFn(appliedTransforms);
}

function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName),
        i = 0,
        n = list.length;

    if (iterator) {
      for (; i < n; i++) {
        iterator(list[i], i);
      }
    }

    return list;
  }

  return [];
}

function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;

  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */


function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window) return;
  var elRect, top, left, bottom, right, height, width;

  if (el !== window && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top = elRect.top;
    left = elRect.left;
    bottom = elRect.bottom;
    right = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top = 0;
    left = 0;
    bottom = window.innerHeight;
    right = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }

  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    // Adjust for translate()
    container = container || el.parentNode; // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
    // Not needed on <= IE11

    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, 'transform') !== 'none' || relativeToNonStaticParent && css(container, 'position') !== 'static')) {
          var containerRect = container.getBoundingClientRect(); // Set relative to edges of padding box of container

          top -= containerRect.top + parseInt(css(container, 'border-top-width'));
          left -= containerRect.left + parseInt(css(container, 'border-left-width'));
          bottom = top + elRect.height;
          right = left + elRect.width;
          break;
        }
        /* jshint boss:true */

      } while (container = container.parentNode);
    }
  }

  if (undoScale && el !== window) {
    // Adjust for scale()
    var elMatrix = matrix(container || el),
        scaleX = elMatrix && elMatrix.a,
        scaleY = elMatrix && elMatrix.d;

    if (elMatrix) {
      top /= scaleY;
      left /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom = top + height;
      right = left + width;
    }
  }

  return {
    top: top,
    left: left,
    bottom: bottom,
    right: right,
    width: width,
    height: height
  };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */


function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true),
      elSideVal = getRect(el)[elSide];
  /* jshint boss:true */

  while (parent) {
    var parentSideVal = getRect(parent)[parentSide],
        visible = void 0;

    if (parentSide === 'top' || parentSide === 'left') {
      visible = elSideVal >= parentSideVal;
    } else {
      visible = elSideVal <= parentSideVal;
    }

    if (!visible) return parent;
    if (parent === getWindowScrollingElement()) break;
    parent = getParentAutoScrollElement(parent, false);
  }

  return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */


function getChild(el, childNum, options) {
  var currentChild = 0,
      i = 0,
      children = el.children;

  while (i < children.length) {
    if (children[i].style.display !== 'none' && children[i] !== Sortable.ghost && children[i] !== Sortable.dragged && closest(children[i], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children[i];
      }

      currentChild++;
    }

    i++;
  }

  return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */


function lastChild(el, selector) {
  var last = el.lastElementChild;

  while (last && (last === Sortable.ghost || css(last, 'display') === 'none' || selector && !matches(last, selector))) {
    last = last.previousElementSibling;
  }

  return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */


function index$1(el, selector) {
  var index = 0;

  if (!el || !el.parentNode) {
    return -1;
  }
  /* jshint boss:true */


  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== Sortable.clone && (!selector || matches(el, selector))) {
      index++;
    }
  }

  return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */


function getRelativeScrollOffset(el) {
  var offsetLeft = 0,
      offsetTop = 0,
      winScroller = getWindowScrollingElement();

  if (el) {
    do {
      var elMatrix = matrix(el),
          scaleX = elMatrix.a,
          scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }

  return [offsetLeft, offsetTop];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */


function indexOfObject(arr, obj) {
  for (var i in arr) {
    if (!arr.hasOwnProperty(i)) continue;

    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
    }
  }

  return -1;
}

function getParentAutoScrollElement(el, includeSelf) {
  // skip to window
  if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;

  do {
    // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);

      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
        if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
        if (gotSelf || includeSelf) return elem;
        gotSelf = true;
      }
    }
    /* jshint boss:true */

  } while (elem = elem.parentNode);

  return getWindowScrollingElement();
}

function extend$1(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }

  return dst;
}

function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}

var _throttleTimeout;

function throttle$2(callback, ms) {
  return function () {
    if (!_throttleTimeout) {
      var args = arguments,
          _this = this;

      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }

      _throttleTimeout = setTimeout(function () {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}

function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}

function scrollBy(el, x, y) {
  el.scrollLeft += x;
  el.scrollTop += y;
}

function clone(el) {
  var Polymer = window.Polymer;
  var $ = window.jQuery || window.Zepto;

  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($) {
    return $(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}

function setRect(el, rect) {
  css(el, 'position', 'absolute');
  css(el, 'top', rect.top);
  css(el, 'left', rect.left);
  css(el, 'width', rect.width);
  css(el, 'height', rect.height);
}

function unsetRect(el) {
  css(el, 'position', '');
  css(el, 'top', '');
  css(el, 'left', '');
  css(el, 'width', '');
  css(el, 'height', '');
}

var expando = 'Sortable' + new Date().getTime();

function AnimationStateManager() {
  var animationStates = [],
      animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation) return;
      var children = [].slice.call(this.el.children);
      children.forEach(function (child) {
        if (css(child, 'display') === 'none' || child === Sortable.ghost) return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });

        var fromRect = _objectSpread$b({}, animationStates[animationStates.length - 1].rect); // If animating: compensate for current animation


        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);

          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }

        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state) {
      animationStates.push(state);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target: target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;

      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === 'function') callback();
        return;
      }

      var animating = false,
          animationTime = 0;
      animationStates.forEach(function (state) {
        var time = 0,
            target = state.target,
            fromRect = target.fromRect,
            toRect = getRect(target),
            prevFromRect = target.prevFromRect,
            prevToRect = target.prevToRect,
            animatingRect = state.rect,
            targetMatrix = matrix(target, true);

        if (targetMatrix) {
          // Compensate for current animation
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }

        target.toRect = toRect;

        if (target.thisAnimationDuration) {
          // Could also check if animatingRect is between fromRect and toRect
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
          (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            // If returning to same place as started from animation and on same axis
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        } // if fromRect != toRect: animate


        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;

          if (!time) {
            time = _this.options.animation;
          }

          _this.animate(target, animatingRect, toRect, time);
        }

        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function () {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);

      if (!animating) {
        if (typeof callback === 'function') callback();
      } else {
        animationCallbackId = setTimeout(function () {
          if (typeof callback === 'function') callback();
        }, animationTime);
      }

      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, 'transition', '');
        css(target, 'transform', '');
        var elMatrix = matrix(this.el),
            scaleX = elMatrix && elMatrix.a,
            scaleY = elMatrix && elMatrix.d,
            translateX = (currentRect.left - toRect.left) / (scaleX || 1),
            translateY = (currentRect.top - toRect.top) / (scaleY || 1);
        target.animatingX = !!translateX;
        target.animatingY = !!translateY;
        css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
        repaint(target); // repaint

        css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
        css(target, 'transform', 'translate3d(0,0,0)');
        typeof target.animated === 'number' && clearTimeout(target.animated);
        target.animated = setTimeout(function () {
          css(target, 'transition', '');
          css(target, 'transform', '');
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}

function repaint(target) {
  return target.offsetWidth;
}

function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}

var plugins = [];
var defaults$5 = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    // Set default static properties
    for (var option in defaults$5) {
      if (defaults$5.hasOwnProperty(option) && !(option in plugin)) {
        plugin[option] = defaults$5[option];
      }
    }

    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent(eventName, sortable, evt) {
    var _this = this;

    this.eventCanceled = false;

    evt.cancel = function () {
      _this.eventCanceled = true;
    };

    var eventNameGlobal = eventName + 'Global';
    plugins.forEach(function (plugin) {
      if (!sortable[plugin.pluginName]) return; // Fire global events if it exists in this sortable

      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread$b({
          sortable: sortable
        }, evt));
      } // Only fire plugin event if plugin is enabled in this sortable,
      // and plugin has event defined


      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread$b({
          sortable: sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults, options) {
    plugins.forEach(function (plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized; // Add default options from plugin

      _extends$1(defaults, initialized.defaults);
    });

    for (var option in sortable.options) {
      if (!sortable.options.hasOwnProperty(option)) continue;
      var modified = this.modifyOption(sortable, option, sortable.options[option]);

      if (typeof modified !== 'undefined') {
        sortable.options[option] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function (plugin) {
      if (typeof plugin.eventProperties !== 'function') return;

      _extends$1(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function (plugin) {
      // Plugin must exist on the Sortable
      if (!sortable[plugin.pluginName]) return; // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin

      if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};

function dispatchEvent(_ref) {
  var sortable = _ref.sortable,
      rootEl = _ref.rootEl,
      name = _ref.name,
      targetEl = _ref.targetEl,
      cloneEl = _ref.cloneEl,
      toEl = _ref.toEl,
      fromEl = _ref.fromEl,
      oldIndex = _ref.oldIndex,
      newIndex = _ref.newIndex,
      oldDraggableIndex = _ref.oldDraggableIndex,
      newDraggableIndex = _ref.newDraggableIndex,
      originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl && rootEl[expando];
  if (!sortable) return;
  var evt,
      options = sortable.options,
      onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1); // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent(name, true, true);
  }

  evt.to = toEl || rootEl;
  evt.from = fromEl || rootEl;
  evt.item = targetEl || rootEl;
  evt.clone = cloneEl;
  evt.oldIndex = oldIndex;
  evt.newIndex = newIndex;
  evt.oldDraggableIndex = oldDraggableIndex;
  evt.newDraggableIndex = newDraggableIndex;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;

  var allEventProperties = _objectSpread$b({}, extraEventProperties, PluginManager.getEventProperties(name, sortable));

  for (var option in allEventProperties) {
    evt[option] = allEventProperties[option];
  }

  if (rootEl) {
    rootEl.dispatchEvent(evt);
  }

  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}

var pluginEvent = function pluginEvent(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      originalEvent = _ref.evt,
      data = _objectWithoutProperties(_ref, ["evt"]);

  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread$b({
    dragEl: dragEl,
    parentEl: parentEl,
    ghostEl: ghostEl,
    rootEl: rootEl,
    nextEl: nextEl,
    lastDownEl: lastDownEl,
    cloneEl: cloneEl,
    cloneHidden: cloneHidden,
    dragStarted: moved,
    putSortable: putSortable,
    activeSortable: Sortable.active,
    originalEvent: originalEvent,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable: sortable,
        name: name,
        originalEvent: originalEvent
      });
    }
  }, data));
};

function _dispatchEvent(info) {
  dispatchEvent(_objectSpread$b({
    putSortable: putSortable,
    cloneEl: cloneEl,
    targetEl: dragEl,
    rootEl: rootEl,
    oldIndex: oldIndex,
    oldDraggableIndex: oldDraggableIndex,
    newIndex: newIndex,
    newDraggableIndex: newDraggableIndex
  }, info));
}

var dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    oldIndex,
    newIndex,
    oldDraggableIndex,
    newDraggableIndex,
    activeGroup,
    putSortable,
    awaitingDragStarted = false,
    ignoreNextClick = false,
    sortables = [],
    tapEvt,
    touchEvt,
    lastDx,
    lastDy,
    tapDistanceLeft,
    tapDistanceTop,
    moved,
    lastTarget,
    lastDirection,
    pastFirstInvertThresh = false,
    isCircumstantialInvert = false,
    targetMoveDistance,
    // For positioning ghost absolutely
ghostRelativeParent,
    ghostRelativeParentInitialScroll = [],
    // (left, top)
_silent = false,
    savedInputChecked = [];
/** @const */

var documentExists = typeof document !== 'undefined',
    PositionGhostAbsolutely = IOS,
    CSSFloatProperty = Edge || IE11OrLess ? 'cssFloat' : 'float',
    // This will not pass for IE9, because IE9 DnD only works on anchors
supportDraggable = documentExists && !ChromeForAndroid && !IOS && 'draggable' in document.createElement('div'),
    supportCssPointerEvents = function () {
  if (!documentExists) return; // false when <= IE11

  if (IE11OrLess) {
    return false;
  }

  var el = document.createElement('x');
  el.style.cssText = 'pointer-events:auto';
  return el.style.pointerEvents === 'auto';
}(),
    _detectDirection = function _detectDirection(el, options) {
  var elCSS = css(el),
      elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth),
      child1 = getChild(el, 0, options),
      child2 = getChild(el, 1, options),
      firstChildCSS = child1 && css(child1),
      secondChildCSS = child2 && css(child2),
      firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width,
      secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;

  if (elCSS.display === 'flex') {
    return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
  }

  if (elCSS.display === 'grid') {
    return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
  }

  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
    var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
    return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
  }

  return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === 'none' || child2 && elCSS[CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
},
    _dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
  var dragElS1Opp = vertical ? dragRect.left : dragRect.top,
      dragElS2Opp = vertical ? dragRect.right : dragRect.bottom,
      dragElOppLength = vertical ? dragRect.width : dragRect.height,
      targetS1Opp = vertical ? targetRect.left : targetRect.top,
      targetS2Opp = vertical ? targetRect.right : targetRect.bottom,
      targetOppLength = vertical ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
},

/**
 * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
 * @param  {Number} x      X position
 * @param  {Number} y      Y position
 * @return {HTMLElement}   Element of the first found nearest Sortable
 */
_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
  var ret;
  sortables.some(function (sortable) {
    if (lastChild(sortable)) return;
    var rect = getRect(sortable),
        threshold = sortable[expando].options.emptyInsertThreshold,
        insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold,
        insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;

    if (threshold && insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
},
    _prepareGroup = function _prepareGroup(options) {
  function toFn(value, pull) {
    return function (to, from, dragEl, evt) {
      var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;

      if (value == null && (pull || sameGroup)) {
        // Default pull value
        // Default pull and put value if same group
        return true;
      } else if (value == null || value === false) {
        return false;
      } else if (pull && value === 'clone') {
        return value;
      } else if (typeof value === 'function') {
        return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
      } else {
        var otherGroup = (pull ? to : from).options.group.name;
        return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
      }
    };
  }

  var group = {};
  var originalGroup = options.group;

  if (!originalGroup || _typeof$1(originalGroup) != 'object') {
    originalGroup = {
      name: originalGroup
    };
  }

  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
},
    _hideGhostForTarget = function _hideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', 'none');
  }
},
    _unhideGhostForTarget = function _unhideGhostForTarget() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, 'display', '');
  }
}; // #1184 fix - Prevent click event on fallback if dragged but item not changed position


if (documentExists) {
  document.addEventListener('click', function (evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}

var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;

    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);

    if (nearest) {
      // Create imitation event
      var event = {};

      for (var i in evt) {
        if (evt.hasOwnProperty(i)) {
          event[i] = evt[i];
        }
      }

      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;

      nearest[expando]._onDragOver(event);
    }
  }
};

var _checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */


function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }

  this.el = el; // root element

  this.options = options = _extends$1({}, options); // Export instance

  el[expando] = this;
  var defaults = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: 'sortable-ghost',
    chosenClass: 'sortable-chosen',
    dragClass: 'sortable-drag',
    ignore: 'a, img',
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl) {
      dataTransfer.setData('Text', dragEl.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: 'data-id',
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: 'sortable-fallback',
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== false && 'PointerEvent' in window,
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults); // Set default options

  for (var name in defaults) {
    !(name in options) && (options[name] = defaults[name]);
  }

  _prepareGroup(options); // Bind all private methods


  for (var fn in this) {
    if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
      this[fn] = this[fn].bind(this);
    }
  } // Setup drag mode


  this.nativeDraggable = options.forceFallback ? false : supportDraggable;

  if (this.nativeDraggable) {
    // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
  } // Bind events


  if (options.supportPointer) {
    on(el, 'pointerdown', this._onTapStart);
  } else {
    on(el, 'mousedown', this._onTapStart);
    on(el, 'touchstart', this._onTapStart);
  }

  if (this.nativeDraggable) {
    on(el, 'dragover', this);
    on(el, 'dragenter', this);
  }

  sortables.push(this.el); // Restore sorting

  options.store && options.store.get && this.sort(options.store.get(this) || []); // Add animation state manager

  _extends$1(this, AnimationStateManager());
}

Sortable.prototype =
/** @lends Sortable.prototype */
{
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(
  /** Event|TouchEvent */
  evt) {
    if (!evt.cancelable) return;

    var _this = this,
        el = this.el,
        options = this.options,
        preventOnFilter = options.preventOnFilter,
        type = evt.type,
        touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt,
        target = (touch || evt).target,
        originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target,
        filter = options.filter;

    _saveInputCheckedState(el); // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.


    if (dragEl) {
      return;
    }

    if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) {
      return; // only left button and enabled
    } // cancel dnd if original target is content editable


    if (originalTarget.isContentEditable) {
      return;
    }

    target = closest(target, options.draggable, el, false);

    if (target && target.animated) {
      return;
    }

    if (lastDownEl === target) {
      // Ignoring duplicate `down`
      return;
    } // Get the index of the dragged element within its parent


    oldIndex = index$1(target);
    oldDraggableIndex = index$1(target, options.draggable); // Check filter

    if (typeof filter === 'function') {
      if (filter.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: 'filter',
          targetEl: target,
          toEl: el,
          fromEl: el
        });

        pluginEvent('filter', _this, {
          evt: evt
        });
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    } else if (filter) {
      filter = filter.split(',').some(function (criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);

        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: 'filter',
            targetEl: target,
            fromEl: el,
            toEl: el
          });

          pluginEvent('filter', _this, {
            evt: evt
          });
          return true;
        }
      });

      if (filter) {
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return; // cancel dnd
      }
    }

    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    } // Prepare `dragstart`


    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart(
  /** Event */
  evt,
  /** Touch */
  touch,
  /** HTMLElement */
  target) {
    var _this = this,
        el = _this.el,
        options = _this.options,
        ownerDocument = el.ownerDocument,
        dragStartFn;

    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style['will-change'] = 'all';

      dragStartFn = function dragStartFn() {
        pluginEvent('delayEnded', _this, {
          evt: evt
        });

        if (Sortable.eventCanceled) {
          _this._onDrop();

          return;
        } // Delayed drag has been triggered
        // we can re-enable the events: touchmove/mousemove


        _this._disableDelayedDragEvents();

        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        } // Bind the events: dragstart/dragend


        _this._triggerDragStart(evt, touch); // Drag start event


        _dispatchEvent({
          sortable: _this,
          name: 'choose',
          originalEvent: evt
        }); // Chosen item


        toggleClass(dragEl, options.chosenClass, true);
      }; // Disable "draggable"


      options.ignore.split(',').forEach(function (criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, 'dragover', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mousemove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'touchmove', nearestEmptyInsertDetectEvent);
      on(ownerDocument, 'mouseup', _this._onDrop);
      on(ownerDocument, 'touchend', _this._onDrop);
      on(ownerDocument, 'touchcancel', _this._onDrop); // Make dragEl draggable (must be before delay for FireFox)

      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }

      pluginEvent('delayStart', this, {
        evt: evt
      }); // Delay is impossible for native DnD in Edge or IE

      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();

          return;
        } // If the user moves the pointer or let go the click or touch
        // before the delay has been reached:
        // disable the delayed drag


        on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
        on(ownerDocument, 'touchend', _this._disableDelayedDrag);
        on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
        on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
        on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(
  /** TouchEvent|PointerEvent **/
  e) {
    var touch = e.touches ? e.touches[0] : e;

    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);

    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._disableDelayedDrag);
    off(ownerDocument, 'touchend', this._disableDelayedDrag);
    off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
    off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
    off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(
  /** Event */
  evt,
  /** Touch */
  touch) {
    touch = touch || evt.pointerType == 'touch' && evt;

    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, 'pointermove', this._onTouchMove);
      } else if (touch) {
        on(document, 'touchmove', this._onTouchMove);
      } else {
        on(document, 'mousemove', this._onTouchMove);
      }
    } else {
      on(dragEl, 'dragend', this);
      on(rootEl, 'dragstart', this._onDragStart);
    }

    try {
      if (document.selection) {
        // Timeout neccessary for IE9
        _nextTick(function () {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {}
  },
  _dragStarted: function _dragStarted(fallback, evt) {

    awaitingDragStarted = false;

    if (rootEl && dragEl) {
      pluginEvent('dragStarted', this, {
        evt: evt
      });

      if (this.nativeDraggable) {
        on(document, 'dragover', _checkOutsideTargetEl);
      }

      var options = this.options; // Apply effect

      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost(); // Drag start event

      _dispatchEvent({
        sortable: this,
        name: 'start',
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;

      _hideGhostForTarget();

      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;

      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent) break;
        parent = target;
      }

      dragEl.parentNode[expando]._isOutsideThisEl(target);

      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target: target,
              rootEl: parent
            });

            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }

          target = parent; // store last element
        }
        /* jshint boss:true */
        while (parent = parent.parentNode);
      }

      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(
  /**TouchEvent*/
  evt) {
    if (tapEvt) {
      var options = this.options,
          fallbackTolerance = options.fallbackTolerance,
          fallbackOffset = options.fallbackOffset,
          touch = evt.touches ? evt.touches[0] : evt,
          ghostMatrix = ghostEl && matrix(ghostEl, true),
          scaleX = ghostEl && ghostMatrix && ghostMatrix.a,
          scaleY = ghostEl && ghostMatrix && ghostMatrix.d,
          relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent),
          dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1),
          dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1); // only set the status to dragging, when we are actually dragging

      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }

        this._onDragStart(evt, true);
      }

      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }

        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, 'webkitTransform', cssMatrix);
        css(ghostEl, 'mozTransform', cssMatrix);
        css(ghostEl, 'msTransform', cssMatrix);
        css(ghostEl, 'transform', cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }

      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    // Bug if using scale(): https://stackoverflow.com/questions/2637058
    // Not being adjusted for
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl,
          rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container),
          options = this.options; // Position absolutely

      if (PositionGhostAbsolutely) {
        // Get relatively positioned parent
        ghostRelativeParent = container;

        while (css(ghostRelativeParent, 'position') === 'static' && css(ghostRelativeParent, 'transform') === 'none' && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }

        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }

        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }

      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, 'transition', '');
      css(ghostEl, 'transform', '');
      css(ghostEl, 'box-sizing', 'border-box');
      css(ghostEl, 'margin', 0);
      css(ghostEl, 'top', rect.top);
      css(ghostEl, 'left', rect.left);
      css(ghostEl, 'width', rect.width);
      css(ghostEl, 'height', rect.height);
      css(ghostEl, 'opacity', '0.8');
      css(ghostEl, 'position', PositionGhostAbsolutely ? 'absolute' : 'fixed');
      css(ghostEl, 'zIndex', '100000');
      css(ghostEl, 'pointerEvents', 'none');
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl); // Set transform-origin

      css(ghostEl, 'transform-origin', tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + '% ' + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + '%');
    }
  },
  _onDragStart: function _onDragStart(
  /**Event*/
  evt,
  /**boolean*/
  fallback) {
    var _this = this;

    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent('dragStart', this, {
      evt: evt
    });

    if (Sortable.eventCanceled) {
      this._onDrop();

      return;
    }

    pluginEvent('setupClone', this);

    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.draggable = false;
      cloneEl.style['will-change'] = '';

      this._hideClone();

      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    } // #1143: IFrame support workaround


    _this.cloneId = _nextTick(function () {
      pluginEvent('clone', _this);
      if (Sortable.eventCanceled) return;

      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }

      _this._hideClone();

      _dispatchEvent({
        sortable: _this,
        name: 'clone'
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true); // Set proper drop events

    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      // Undo what was set in _prepareDragStart before drag started
      off(document, 'mouseup', _this._onDrop);
      off(document, 'touchend', _this._onDrop);
      off(document, 'touchcancel', _this._onDrop);

      if (dataTransfer) {
        dataTransfer.effectAllowed = 'move';
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }

      on(document, 'drop', _this); // #1276 fix:

      css(dragEl, 'transform', 'translateZ(0)');
    }

    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on(document, 'selectstart', _this);
    moved = true;

    if (Safari) {
      css(document.body, 'user-select', 'none');
    }
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function _onDragOver(
  /**Event*/
  evt) {
    var el = this.el,
        target = evt.target,
        dragRect,
        targetRect,
        revert,
        options = this.options,
        group = options.group,
        activeSortable = Sortable.active,
        isOwner = activeGroup === group,
        canSort = options.sort,
        fromSortable = putSortable || activeSortable,
        vertical,
        _this = this,
        completedFired = false;

    if (_silent) return;

    function dragOverEvent(name, extra) {
      pluginEvent(name, _this, _objectSpread$b({
        evt: evt,
        isOwner: isOwner,
        axis: vertical ? 'vertical' : 'horizontal',
        revert: revert,
        dragRect: dragRect,
        targetRect: targetRect,
        canSort: canSort,
        fromSortable: fromSortable,
        target: target,
        completed: completed,
        onMove: function onMove(target, after) {
          return _onMove(rootEl, el, dragEl, dragRect, target, getRect(target), evt, after);
        },
        changed: changed
      }, extra));
    } // Capture animation state


    function capture() {
      dragOverEvent('dragOverAnimationCapture');

      _this.captureAnimationState();

      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    } // Return invocation when dragEl is inserted (or completed)


    function completed(insertion) {
      dragOverEvent('dragOverCompleted', {
        insertion: insertion
      });

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }

        if (_this !== fromSortable) {
          // Set ghost class to new sortable's ghost class
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }

        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        } // Animation


        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }

        _this.animateAll(function () {
          dragOverEvent('dragOverAnimationComplete');
          _this._ignoreWhileAnimating = null;
        });

        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      } // Null lastTarget if it is not inside a previously swapped element


      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      } // no bubbling and not fallback


      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target); // Do not detect for empty insert if already inserted


        !insertion && nearestEmptyInsertDetectEvent(evt);
      }

      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    } // Call when dragEl has been inserted


    function changed() {
      newIndex = index$1(dragEl);
      newDraggableIndex = index$1(dragEl, options.draggable);

      _dispatchEvent({
        sortable: _this,
        name: 'change',
        toEl: el,
        newIndex: newIndex,
        newDraggableIndex: newDraggableIndex,
        originalEvent: evt
      });
    }

    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }

    target = closest(target, options.draggable, el, true);
    dragOverEvent('dragOver');
    if (Sortable.eventCanceled) return completedFired;

    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }

    ignoreNextClick = false;

    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = !rootEl.contains(dragEl)) // Reverting item into the original list
    : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === 'vertical';
      dragRect = getRect(dragEl);
      dragOverEvent('dragOverValid');
      if (Sortable.eventCanceled) return completedFired;

      if (revert) {
        parentEl = rootEl; // actualization

        capture();

        this._hideClone();

        dragOverEvent('revert');

        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }

        return completed(true);
      }

      var elLastChild = lastChild(el, options.draggable);

      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        // If already at end of list: Do not insert
        if (elLastChild === dragEl) {
          return completed(false);
        } // assign target only if condition is true


        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }

        if (target) {
          targetRect = getRect(target);
        }

        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          el.appendChild(dragEl);
          parentEl = el; // actualization

          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0,
            targetBeforeFirstSwap,
            differentLevel = dragEl.parentNode !== el,
            differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical),
            side1 = vertical ? 'top' : 'left',
            scrolledPastTop = isScrolledPast(target, 'top', 'top') || isScrolledPast(dragEl, 'top', 'top'),
            scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;

        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }

        direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;

        if (direction !== 0) {
          // Check if target is beside dragEl in respective direction (ignoring hidden elements)
          var dragIndex = index$1(dragEl);

          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, 'display') === 'none' || sibling === ghostEl));
        } // If dragEl is already beside target: Do not insert


        if (direction === 0 || sibling === target) {
          return completed(false);
        }

        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling,
            after = false;
        after = direction === 1;

        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);

        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }

          _silent = true;
          setTimeout(_unsilent, 30);
          capture();

          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          } // Undo chrome's scroll adjustment (has no effect on other browsers)


          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }

          parentEl = dragEl.parentNode; // actualization
          // must be done before animation

          if (targetBeforeFirstSwap !== undefined && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }

          changed();
          return completed(true);
        }
      }

      if (el.contains(dragEl)) {
        return completed(false);
      }
    }

    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, 'mousemove', this._onTouchMove);
    off(document, 'touchmove', this._onTouchMove);
    off(document, 'pointermove', this._onTouchMove);
    off(document, 'dragover', nearestEmptyInsertDetectEvent);
    off(document, 'mousemove', nearestEmptyInsertDetectEvent);
    off(document, 'touchmove', nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, 'mouseup', this._onDrop);
    off(ownerDocument, 'touchend', this._onDrop);
    off(ownerDocument, 'pointerup', this._onDrop);
    off(ownerDocument, 'touchcancel', this._onDrop);
    off(document, 'selectstart', this);
  },
  _onDrop: function _onDrop(
  /**Event*/
  evt) {
    var el = this.el,
        options = this.options; // Get the index of the dragged element within its parent

    newIndex = index$1(dragEl);
    newDraggableIndex = index$1(dragEl, options.draggable);
    pluginEvent('drop', this, {
      evt: evt
    });
    parentEl = dragEl && dragEl.parentNode; // Get again after plugin event

    newIndex = index$1(dragEl);
    newDraggableIndex = index$1(dragEl, options.draggable);

    if (Sortable.eventCanceled) {
      this._nulling();

      return;
    }

    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);

    _cancelNextTick(this.cloneId);

    _cancelNextTick(this._dragStartId); // Unbind events


    if (this.nativeDraggable) {
      off(document, 'drop', this);
      off(el, 'dragstart', this._onDragStart);
    }

    this._offMoveEvents();

    this._offUpEvents();

    if (Safari) {
      css(document.body, 'user-select', '');
    }

    css(dragEl, 'transform', '');

    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }

      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);

      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        // Remove clone(s)
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }

      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, 'dragend', this);
        }

        _disableDraggable(dragEl);

        dragEl.style['will-change'] = ''; // Remove classes
        // ghostClass is added in dragStarted

        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }

        toggleClass(dragEl, this.options.chosenClass, false); // Drag stop event

        _dispatchEvent({
          sortable: this,
          name: 'unchoose',
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });

        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            // Add event
            _dispatchEvent({
              rootEl: parentEl,
              name: 'add',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            }); // Remove event


            _dispatchEvent({
              sortable: this,
              name: 'remove',
              toEl: parentEl,
              originalEvent: evt
            }); // drag from one list and drop into another


            _dispatchEvent({
              rootEl: parentEl,
              name: 'sort',
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });

            _dispatchEvent({
              sortable: this,
              name: 'sort',
              toEl: parentEl,
              originalEvent: evt
            });
          }

          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              // drag & drop within the same list
              _dispatchEvent({
                sortable: this,
                name: 'update',
                toEl: parentEl,
                originalEvent: evt
              });

              _dispatchEvent({
                sortable: this,
                name: 'sort',
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }

        if (Sortable.active) {
          /* jshint eqnull:true */
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }

          _dispatchEvent({
            sortable: this,
            name: 'end',
            toEl: parentEl,
            originalEvent: evt
          }); // Save sorting


          this.save();
        }
      }
    }

    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent('nulling', this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function (el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(
  /**Event*/
  evt) {
    switch (evt.type) {
      case 'drop':
      case 'dragend':
        this._onDrop(evt);

        break;

      case 'dragenter':
      case 'dragover':
        if (dragEl) {
          this._onDragOver(evt);

          _globalDragOver(evt);
        }

        break;

      case 'selectstart':
        evt.preventDefault();
        break;
    }
  },

  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function toArray() {
    var order = [],
        el,
        children = this.el.children,
        i = 0,
        n = children.length,
        options = this.options;

    for (; i < n; i++) {
      el = children[i];

      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }

    return order;
  },

  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function sort(order) {
    var items = {},
        rootEl = this.el;
    this.toArray().forEach(function (id, i) {
      var el = rootEl.children[i];

      if (closest(el, this.options.draggable, rootEl, false)) {
        items[id] = el;
      }
    }, this);
    order.forEach(function (id) {
      if (items[id]) {
        rootEl.removeChild(items[id]);
        rootEl.appendChild(items[id]);
      }
    });
  },

  /**
   * Save the current sorting
   */
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },

  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function closest$1(el, selector) {
    return closest(el, selector || this.options.draggable, this.el, false);
  },

  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function option(name, value) {
    var options = this.options;

    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);

      if (typeof modifiedValue !== 'undefined') {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }

      if (name === 'group') {
        _prepareGroup(options);
      }
    }
  },

  /**
   * Destroy
   */
  destroy: function destroy() {
    pluginEvent('destroy', this);
    var el = this.el;
    el[expando] = null;
    off(el, 'mousedown', this._onTapStart);
    off(el, 'touchstart', this._onTapStart);
    off(el, 'pointerdown', this._onTapStart);

    if (this.nativeDraggable) {
      off(el, 'dragover', this);
      off(el, 'dragenter', this);
    } // Remove draggable attributes


    Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function (el) {
      el.removeAttribute('draggable');
    });

    this._onDrop();

    this._disableDelayedDragEvents();

    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent('hideClone', this);
      if (Sortable.eventCanceled) return;
      css(cloneEl, 'display', 'none');

      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }

      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable) {
    if (putSortable.lastPutMode !== 'clone') {
      this._hideClone();

      return;
    }

    if (cloneHidden) {
      pluginEvent('showClone', this);
      if (Sortable.eventCanceled) return; // show clone at dragEl or original position

      if (rootEl.contains(dragEl) && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }

      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }

      css(cloneEl, 'display', '');
      cloneHidden = false;
    }
  }
};

function _globalDragOver(
/**Event*/
evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = 'move';
  }

  evt.cancelable && evt.preventDefault();
}

function _onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt,
      sortable = fromEl[expando],
      onMoveFn = sortable.options.onMove,
      retVal; // Support for new CustomEvent feature

  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent('move', {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent('Event');
    evt.initEvent('move', true, true);
  }

  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);

  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }

  return retVal;
}

function _disableDraggable(el) {
  el.draggable = false;
}

function _unsilent() {
  _silent = false;
}

function _ghostIsLast(evt, vertical, sortable) {
  var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var spacer = 10;
  return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}

function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX,
      targetLength = vertical ? targetRect.height : targetRect.width,
      targetS1 = vertical ? targetRect.top : targetRect.left,
      targetS2 = vertical ? targetRect.bottom : targetRect.right,
      invert = false;

  if (!invertSwap) {
    // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
      // check if past first invert threshold on side opposite of lastDirection
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        // past first invert threshold, do not restrict inverted threshold to dragEl shadow
        pastFirstInvertThresh = true;
      }

      if (!pastFirstInvertThresh) {
        // dragEl shadow (target move distance shadow)
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance // over dragEl shadow
        : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      // Regular
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }

  invert = invert || invertSwap;

  if (invert) {
    // Invert of regular
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }

  return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */


function _getInsertDirection(target) {
  if (index$1(dragEl) < index$1(target)) {
    return 1;
  } else {
    return -1;
  }
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */


function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent,
      i = str.length,
      sum = 0;

  while (i--) {
    sum += str.charCodeAt(i);
  }

  return sum.toString(36);
}

function _saveInputCheckedState(root) {
  savedInputChecked.length = 0;
  var inputs = root.getElementsByTagName('input');
  var idx = inputs.length;

  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}

function _nextTick(fn) {
  return setTimeout(fn, 0);
}

function _cancelNextTick(id) {
  return clearTimeout(id);
} // Fixed #973:


if (documentExists) {
  on(document, 'touchmove', function (evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
} // Export utils


Sortable.utils = {
  on: on,
  off: off,
  css: css,
  find: find,
  is: function is(el, selector) {
    return !!closest(el, selector, el, false);
  },
  extend: extend$1,
  throttle: throttle$2,
  closest: closest,
  toggleClass: toggleClass,
  clone: clone,
  index: index$1,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild: getChild
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */

Sortable.get = function (element) {
  return element[expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */


Sortable.mount = function () {
  for (var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins[_key] = arguments[_key];
  }

  if (plugins[0].constructor === Array) plugins = plugins[0];
  plugins.forEach(function (plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }

    if (plugin.utils) Sortable.utils = _objectSpread$b({}, Sortable.utils, plugin.utils);
    PluginManager.mount(plugin);
  });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */


Sortable.create = function (el, options) {
  return new Sortable(el, options);
}; // Export


Sortable.version = version;

var autoScrolls = [],
    scrollEl,
    scrollRootEl,
    scrolling = false,
    lastAutoScrollX,
    lastAutoScrollY,
    touchEvt$1,
    pointerElemChangedInterval;

function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    }; // Bind all private methods

    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }
  }

  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;

      if (this.sortable.nativeDraggable) {
        on(document, 'dragover', this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on(document, 'pointermove', this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on(document, 'touchmove', this._handleFallbackAutoScroll);
        } else {
          on(document, 'mousemove', this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;

      // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop() {
      if (this.sortable.nativeDraggable) {
        off(document, 'dragover', this._handleAutoScroll);
      } else {
        off(document, 'pointermove', this._handleFallbackAutoScroll);
        off(document, 'touchmove', this._handleFallbackAutoScroll);
        off(document, 'mousemove', this._handleFallbackAutoScroll);
      }

      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this = this;

      var x = (evt.touches ? evt.touches[0] : evt).clientX,
          y = (evt.touches ? evt.touches[0] : evt).clientY,
          elem = document.elementFromPoint(x, y);
      touchEvt$1 = evt; // IE does not seem to have native autoscroll,
      // Edge's autoscroll seems too conditional,
      // MACOS Safari does not have autoscroll,
      // Firefox and Chrome are good

      if (fallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback); // Listener for pointer element change

        var ogElemScroller = getParentAutoScrollElement(elem, true);

        if (scrolling && (!pointerElemChangedInterval || x !== lastAutoScrollX || y !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval(); // Detect for pointer elem change, emulating native DnD behaviour

          pointerElemChangedInterval = setInterval(function () {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x, y), true);

            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }

            autoScroll(evt, _this.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x;
          lastAutoScrollY = y;
        }
      } else {
        // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }

        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends$1(AutoScroll, {
    pluginName: 'scroll',
    initializeByDefault: true
  });
}

function clearAutoScrolls() {
  autoScrolls.forEach(function (autoScroll) {
    clearInterval(autoScroll.pid);
  });
  autoScrolls = [];
}

function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}

var autoScroll = throttle$2(function (evt, options, rootEl, isFallback) {
  // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
  if (!options.scroll) return;
  var x = (evt.touches ? evt.touches[0] : evt).clientX,
      y = (evt.touches ? evt.touches[0] : evt).clientY,
      sens = options.scrollSensitivity,
      speed = options.scrollSpeed,
      winScroller = getWindowScrollingElement();
  var scrollThisInstance = false,
      scrollCustomFn; // New scroll root, set scrollEl

  if (scrollRootEl !== rootEl) {
    scrollRootEl = rootEl;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;

    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl, true);
    }
  }

  var layersOut = 0;
  var currentParent = scrollEl;

  do {
    var el = currentParent,
        rect = getRect(el),
        top = rect.top,
        bottom = rect.bottom,
        left = rect.left,
        right = rect.right,
        width = rect.width,
        height = rect.height,
        canScrollX = void 0,
        canScrollY = void 0,
        scrollWidth = el.scrollWidth,
        scrollHeight = el.scrollHeight,
        elCSS = css(el),
        scrollPosX = el.scrollLeft,
        scrollPosY = el.scrollTop;

    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
      canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
    }

    var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);

    if (!autoScrolls[layersOut]) {
      for (var i = 0; i <= layersOut; i++) {
        if (!autoScrolls[i]) {
          autoScrolls[i] = {};
        }
      }
    }

    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);

      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        /* jshint loopfunc:true */

        autoScrolls[layersOut].pid = setInterval(function () {
          // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1); // To move ghost if it is positioned absolutely

          }

          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;

          if (typeof scrollCustomFn === 'function') {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== 'continue') {
              return;
            }
          }

          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }.bind({
          layer: layersOut
        }), 24);
      }
    }

    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));

  scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);

var drop = function drop(_ref) {
  var originalEvent = _ref.originalEvent,
      putSortable = _ref.putSortable,
      dragEl = _ref.dragEl,
      activeSortable = _ref.activeSortable,
      dispatchSortableEvent = _ref.dispatchSortableEvent,
      hideGhostForTarget = _ref.hideGhostForTarget,
      unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent) return;
  var toSortable = putSortable || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();

  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent('spill');
    this.onSpill({
      dragEl: dragEl,
      putSortable: putSortable
    });
  }
};

function Revert() {}

Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl = _ref3.dragEl,
        putSortable = _ref3.putSortable;
    this.sortable.captureAnimationState();

    if (putSortable) {
      putSortable.captureAnimationState();
    }

    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);

    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl);
    }

    this.sortable.animateAll();

    if (putSortable) {
      putSortable.animateAll();
    }
  },
  drop: drop
};

_extends$1(Revert, {
  pluginName: 'revertOnSpill'
});

function Remove() {}

Remove.prototype = {
  onSpill: function onSpill(_ref4) {
    var dragEl = _ref4.dragEl,
        putSortable = _ref4.putSortable;
    var parentSortable = putSortable || this.sortable;
    parentSortable.captureAnimationState();
    dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
    parentSortable.animateAll();
  },
  drop: drop
};

_extends$1(Remove, {
  pluginName: 'removeOnSpill'
});

var lastSwapEl;

function SwapPlugin() {
  function Swap() {
    this.defaults = {
      swapClass: 'sortable-swap-highlight'
    };
  }

  Swap.prototype = {
    dragStart: function dragStart(_ref) {
      var dragEl = _ref.dragEl;
      lastSwapEl = dragEl;
    },
    dragOverValid: function dragOverValid(_ref2) {
      var completed = _ref2.completed,
          target = _ref2.target,
          onMove = _ref2.onMove,
          activeSortable = _ref2.activeSortable,
          changed = _ref2.changed,
          cancel = _ref2.cancel;
      if (!activeSortable.options.swap) return;
      var el = this.sortable.el,
          options = this.options;

      if (target && target !== el) {
        var prevSwapEl = lastSwapEl;

        if (onMove(target) !== false) {
          toggleClass(target, options.swapClass, true);
          lastSwapEl = target;
        } else {
          lastSwapEl = null;
        }

        if (prevSwapEl && prevSwapEl !== lastSwapEl) {
          toggleClass(prevSwapEl, options.swapClass, false);
        }
      }

      changed();
      completed(true);
      cancel();
    },
    drop: function drop(_ref3) {
      var activeSortable = _ref3.activeSortable,
          putSortable = _ref3.putSortable,
          dragEl = _ref3.dragEl;
      var toSortable = putSortable || this.sortable;
      var options = this.options;
      lastSwapEl && toggleClass(lastSwapEl, options.swapClass, false);

      if (lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
        if (dragEl !== lastSwapEl) {
          toSortable.captureAnimationState();
          if (toSortable !== activeSortable) activeSortable.captureAnimationState();
          swapNodes(dragEl, lastSwapEl);
          toSortable.animateAll();
          if (toSortable !== activeSortable) activeSortable.animateAll();
        }
      }
    },
    nulling: function nulling() {
      lastSwapEl = null;
    }
  };
  return _extends$1(Swap, {
    pluginName: 'swap',
    eventProperties: function eventProperties() {
      return {
        swapItem: lastSwapEl
      };
    }
  });
}

function swapNodes(n1, n2) {
  var p1 = n1.parentNode,
      p2 = n2.parentNode,
      i1,
      i2;
  if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
  i1 = index$1(n1);
  i2 = index$1(n2);

  if (p1.isEqualNode(p2) && i1 < i2) {
    i2++;
  }

  p1.insertBefore(n2, p1.children[i1]);
  p2.insertBefore(n1, p2.children[i2]);
}

var multiDragElements = [],
    multiDragClones = [],
    lastMultiDragSelect,
    // for selection with modifier key down (SHIFT)
multiDragSortable,
    initialFolding = false,
    // Initial multi-drag fold when drag started
folding = false,
    // Folding any other time
dragStarted = false,
    dragEl$1,
    clonesFromRect,
    clonesHidden;

function MultiDragPlugin() {
  function MultiDrag(sortable) {
    // Bind all private methods
    for (var fn in this) {
      if (fn.charAt(0) === '_' && typeof this[fn] === 'function') {
        this[fn] = this[fn].bind(this);
      }
    }

    if (sortable.options.supportPointer) {
      on(document, 'pointerup', this._deselectMultiDrag);
    } else {
      on(document, 'mouseup', this._deselectMultiDrag);
      on(document, 'touchend', this._deselectMultiDrag);
    }

    on(document, 'keydown', this._checkKeyDown);
    on(document, 'keyup', this._checkKeyUp);
    this.defaults = {
      selectedClass: 'sortable-selected',
      multiDragKey: null,
      setData: function setData(dataTransfer, dragEl) {
        var data = '';

        if (multiDragElements.length && multiDragSortable === sortable) {
          multiDragElements.forEach(function (multiDragElement, i) {
            data += (!i ? '' : ', ') + multiDragElement.textContent;
          });
        } else {
          data = dragEl.textContent;
        }

        dataTransfer.setData('Text', data);
      }
    };
  }

  MultiDrag.prototype = {
    multiDragKeyDown: false,
    isMultiDrag: false,
    delayStartGlobal: function delayStartGlobal(_ref) {
      var dragged = _ref.dragEl;
      dragEl$1 = dragged;
    },
    delayEnded: function delayEnded() {
      this.isMultiDrag = ~multiDragElements.indexOf(dragEl$1);
    },
    setupClone: function setupClone(_ref2) {
      var sortable = _ref2.sortable,
          cancel = _ref2.cancel;
      if (!this.isMultiDrag) return;

      for (var i = 0; i < multiDragElements.length; i++) {
        multiDragClones.push(clone(multiDragElements[i]));
        multiDragClones[i].sortableIndex = multiDragElements[i].sortableIndex;
        multiDragClones[i].draggable = false;
        multiDragClones[i].style['will-change'] = '';
        toggleClass(multiDragClones[i], this.options.selectedClass, false);
        multiDragElements[i] === dragEl$1 && toggleClass(multiDragClones[i], this.options.chosenClass, false);
      }

      sortable._hideClone();

      cancel();
    },
    clone: function clone(_ref3) {
      var sortable = _ref3.sortable,
          rootEl = _ref3.rootEl,
          dispatchSortableEvent = _ref3.dispatchSortableEvent,
          cancel = _ref3.cancel;
      if (!this.isMultiDrag) return;

      if (!this.options.removeCloneOnHide) {
        if (multiDragElements.length && multiDragSortable === sortable) {
          insertMultiDragClones(true, rootEl);
          dispatchSortableEvent('clone');
          cancel();
        }
      }
    },
    showClone: function showClone(_ref4) {
      var cloneNowShown = _ref4.cloneNowShown,
          rootEl = _ref4.rootEl,
          cancel = _ref4.cancel;
      if (!this.isMultiDrag) return;
      insertMultiDragClones(false, rootEl);
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', '');
      });
      cloneNowShown();
      clonesHidden = false;
      cancel();
    },
    hideClone: function hideClone(_ref5) {
      var _this = this;

      _ref5.sortable;
          var cloneNowHidden = _ref5.cloneNowHidden,
          cancel = _ref5.cancel;
      if (!this.isMultiDrag) return;
      multiDragClones.forEach(function (clone) {
        css(clone, 'display', 'none');

        if (_this.options.removeCloneOnHide && clone.parentNode) {
          clone.parentNode.removeChild(clone);
        }
      });
      cloneNowHidden();
      clonesHidden = true;
      cancel();
    },
    dragStartGlobal: function dragStartGlobal(_ref6) {
      _ref6.sortable;

      if (!this.isMultiDrag && multiDragSortable) {
        multiDragSortable.multiDrag._deselectMultiDrag();
      }

      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.sortableIndex = index$1(multiDragElement);
      }); // Sort multi-drag elements

      multiDragElements = multiDragElements.sort(function (a, b) {
        return a.sortableIndex - b.sortableIndex;
      });
      dragStarted = true;
    },
    dragStarted: function dragStarted(_ref7) {
      var _this2 = this;

      var sortable = _ref7.sortable;
      if (!this.isMultiDrag) return;

      if (this.options.sort) {
        // Capture rects,
        // hide multi drag elements (by positioning them absolute),
        // set multi drag elements rects to dragRect,
        // show multi drag elements,
        // animate to rects,
        // unset rects & remove from DOM
        sortable.captureAnimationState();

        if (this.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            css(multiDragElement, 'position', 'absolute');
          });
          var dragRect = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRect);
          });
          folding = true;
          initialFolding = true;
        }
      }

      sortable.animateAll(function () {
        folding = false;
        initialFolding = false;

        if (_this2.options.animation) {
          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
        } // Remove all auxiliary multidrag items from el, if sorting enabled


        if (_this2.options.sort) {
          removeMultiDragElements();
        }
      });
    },
    dragOver: function dragOver(_ref8) {
      var target = _ref8.target,
          completed = _ref8.completed,
          cancel = _ref8.cancel;

      if (folding && ~multiDragElements.indexOf(target)) {
        completed(false);
        cancel();
      }
    },
    revert: function revert(_ref9) {
      var fromSortable = _ref9.fromSortable,
          rootEl = _ref9.rootEl,
          sortable = _ref9.sortable,
          dragRect = _ref9.dragRect;

      if (multiDragElements.length > 1) {
        // Setup unfold animation
        multiDragElements.forEach(function (multiDragElement) {
          sortable.addAnimationState({
            target: multiDragElement,
            rect: folding ? getRect(multiDragElement) : dragRect
          });
          unsetRect(multiDragElement);
          multiDragElement.fromRect = dragRect;
          fromSortable.removeAnimationState(multiDragElement);
        });
        folding = false;
        insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref10) {
      var sortable = _ref10.sortable,
          isOwner = _ref10.isOwner,
          insertion = _ref10.insertion,
          activeSortable = _ref10.activeSortable,
          parentEl = _ref10.parentEl,
          putSortable = _ref10.putSortable;
      var options = this.options;

      if (insertion) {
        // Clones must be hidden before folding animation to capture dragRectAbsolute properly
        if (isOwner) {
          activeSortable._hideClone();
        }

        initialFolding = false; // If leaving sort:false root, or already folding - Fold to new location

        if (options.animation && multiDragElements.length > 1 && (folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
          // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
          var dragRectAbsolute = getRect(dragEl$1, false, true, true);
          multiDragElements.forEach(function (multiDragElement) {
            if (multiDragElement === dragEl$1) return;
            setRect(multiDragElement, dragRectAbsolute); // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
            // while folding, and so that we can capture them again because old sortable will no longer be fromSortable

            parentEl.appendChild(multiDragElement);
          });
          folding = true;
        } // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out


        if (!isOwner) {
          // Only remove if not folding (folding will remove them anyways)
          if (!folding) {
            removeMultiDragElements();
          }

          if (multiDragElements.length > 1) {
            var clonesHiddenBefore = clonesHidden;

            activeSortable._showClone(sortable); // Unfold animation for clones if showing from hidden


            if (activeSortable.options.animation && !clonesHidden && clonesHiddenBefore) {
              multiDragClones.forEach(function (clone) {
                activeSortable.addAnimationState({
                  target: clone,
                  rect: clonesFromRect
                });
                clone.fromRect = clonesFromRect;
                clone.thisAnimationDuration = null;
              });
            }
          } else {
            activeSortable._showClone(sortable);
          }
        }
      }
    },
    dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
      var dragRect = _ref11.dragRect,
          isOwner = _ref11.isOwner,
          activeSortable = _ref11.activeSortable;
      multiDragElements.forEach(function (multiDragElement) {
        multiDragElement.thisAnimationDuration = null;
      });

      if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
        clonesFromRect = _extends$1({}, dragRect);
        var dragMatrix = matrix(dragEl$1, true);
        clonesFromRect.top -= dragMatrix.f;
        clonesFromRect.left -= dragMatrix.e;
      }
    },
    dragOverAnimationComplete: function dragOverAnimationComplete() {
      if (folding) {
        folding = false;
        removeMultiDragElements();
      }
    },
    drop: function drop(_ref12) {
      var evt = _ref12.originalEvent,
          rootEl = _ref12.rootEl,
          parentEl = _ref12.parentEl,
          sortable = _ref12.sortable,
          dispatchSortableEvent = _ref12.dispatchSortableEvent,
          oldIndex = _ref12.oldIndex,
          putSortable = _ref12.putSortable;
      var toSortable = putSortable || this.sortable;
      if (!evt) return;
      var options = this.options,
          children = parentEl.children; // Multi-drag selection

      if (!dragStarted) {
        if (options.multiDragKey && !this.multiDragKeyDown) {
          this._deselectMultiDrag();
        }

        toggleClass(dragEl$1, options.selectedClass, !~multiDragElements.indexOf(dragEl$1));

        if (!~multiDragElements.indexOf(dragEl$1)) {
          multiDragElements.push(dragEl$1);
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'select',
            targetEl: dragEl$1,
            originalEvt: evt
          }); // Modifier activated, select from last to dragEl

          if (evt.shiftKey && lastMultiDragSelect && sortable.el.contains(lastMultiDragSelect)) {
            var lastIndex = index$1(lastMultiDragSelect),
                currentIndex = index$1(dragEl$1);

            if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) {
              // Must include lastMultiDragSelect (select it), in case modified selection from no selection
              // (but previous selection existed)
              var n, i;

              if (currentIndex > lastIndex) {
                i = lastIndex;
                n = currentIndex;
              } else {
                i = currentIndex;
                n = lastIndex + 1;
              }

              for (; i < n; i++) {
                if (~multiDragElements.indexOf(children[i])) continue;
                toggleClass(children[i], options.selectedClass, true);
                multiDragElements.push(children[i]);
                dispatchEvent({
                  sortable: sortable,
                  rootEl: rootEl,
                  name: 'select',
                  targetEl: children[i],
                  originalEvt: evt
                });
              }
            }
          } else {
            lastMultiDragSelect = dragEl$1;
          }

          multiDragSortable = toSortable;
        } else {
          multiDragElements.splice(multiDragElements.indexOf(dragEl$1), 1);
          lastMultiDragSelect = null;
          dispatchEvent({
            sortable: sortable,
            rootEl: rootEl,
            name: 'deselect',
            targetEl: dragEl$1,
            originalEvt: evt
          });
        }
      } // Multi-drag drop


      if (dragStarted && this.isMultiDrag) {
        // Do not "unfold" after around dragEl if reverted
        if ((parentEl[expando].options.sort || parentEl !== rootEl) && multiDragElements.length > 1) {
          var dragRect = getRect(dragEl$1),
              multiDragIndex = index$1(dragEl$1, ':not(.' + this.options.selectedClass + ')');
          if (!initialFolding && options.animation) dragEl$1.thisAnimationDuration = null;
          toSortable.captureAnimationState();

          if (!initialFolding) {
            if (options.animation) {
              dragEl$1.fromRect = dragRect;
              multiDragElements.forEach(function (multiDragElement) {
                multiDragElement.thisAnimationDuration = null;

                if (multiDragElement !== dragEl$1) {
                  var rect = folding ? getRect(multiDragElement) : dragRect;
                  multiDragElement.fromRect = rect; // Prepare unfold animation

                  toSortable.addAnimationState({
                    target: multiDragElement,
                    rect: rect
                  });
                }
              });
            } // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
            // properly they must all be removed


            removeMultiDragElements();
            multiDragElements.forEach(function (multiDragElement) {
              if (children[multiDragIndex]) {
                parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
              } else {
                parentEl.appendChild(multiDragElement);
              }

              multiDragIndex++;
            }); // If initial folding is done, the elements may have changed position because they are now
            // unfolding around dragEl, even though dragEl may not have his index changed, so update event
            // must be fired here as Sortable will not.

            if (oldIndex === index$1(dragEl$1)) {
              var update = false;
              multiDragElements.forEach(function (multiDragElement) {
                if (multiDragElement.sortableIndex !== index$1(multiDragElement)) {
                  update = true;
                  return;
                }
              });

              if (update) {
                dispatchSortableEvent('update');
              }
            }
          } // Must be done after capturing individual rects (scroll bar)


          multiDragElements.forEach(function (multiDragElement) {
            unsetRect(multiDragElement);
          });
          toSortable.animateAll();
        }

        multiDragSortable = toSortable;
      } // Remove clones if necessary


      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') {
        multiDragClones.forEach(function (clone) {
          clone.parentNode && clone.parentNode.removeChild(clone);
        });
      }
    },
    nullingGlobal: function nullingGlobal() {
      this.isMultiDrag = dragStarted = false;
      multiDragClones.length = 0;
    },
    destroyGlobal: function destroyGlobal() {
      this._deselectMultiDrag();

      off(document, 'pointerup', this._deselectMultiDrag);
      off(document, 'mouseup', this._deselectMultiDrag);
      off(document, 'touchend', this._deselectMultiDrag);
      off(document, 'keydown', this._checkKeyDown);
      off(document, 'keyup', this._checkKeyUp);
    },
    _deselectMultiDrag: function _deselectMultiDrag(evt) {
      if (typeof dragStarted !== "undefined" && dragStarted) return; // Only deselect if selection is in this sortable

      if (multiDragSortable !== this.sortable) return; // Only deselect if target is not item in this sortable

      if (evt && closest(evt.target, this.options.draggable, this.sortable.el, false)) return; // Only deselect if left click

      if (evt && evt.button !== 0) return;

      while (multiDragElements.length) {
        var el = multiDragElements[0];
        toggleClass(el, this.options.selectedClass, false);
        multiDragElements.shift();
        dispatchEvent({
          sortable: this.sortable,
          rootEl: this.sortable.el,
          name: 'deselect',
          targetEl: el,
          originalEvt: evt
        });
      }
    },
    _checkKeyDown: function _checkKeyDown(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = true;
      }
    },
    _checkKeyUp: function _checkKeyUp(evt) {
      if (evt.key === this.options.multiDragKey) {
        this.multiDragKeyDown = false;
      }
    }
  };
  return _extends$1(MultiDrag, {
    // Static methods & properties
    pluginName: 'multiDrag',
    utils: {
      /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */
      select: function select(el) {
        var sortable = el.parentNode[expando];
        if (!sortable || !sortable.options.multiDrag || ~multiDragElements.indexOf(el)) return;

        if (multiDragSortable && multiDragSortable !== sortable) {
          multiDragSortable.multiDrag._deselectMultiDrag();

          multiDragSortable = sortable;
        }

        toggleClass(el, sortable.options.selectedClass, true);
        multiDragElements.push(el);
      },

      /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */
      deselect: function deselect(el) {
        var sortable = el.parentNode[expando],
            index = multiDragElements.indexOf(el);
        if (!sortable || !sortable.options.multiDrag || !~index) return;
        toggleClass(el, sortable.options.selectedClass, false);
        multiDragElements.splice(index, 1);
      }
    },
    eventProperties: function eventProperties() {
      var _this3 = this;

      var oldIndicies = [],
          newIndicies = [];
      multiDragElements.forEach(function (multiDragElement) {
        oldIndicies.push({
          multiDragElement: multiDragElement,
          index: multiDragElement.sortableIndex
        }); // multiDragElements will already be sorted if folding

        var newIndex;

        if (folding && multiDragElement !== dragEl$1) {
          newIndex = -1;
        } else if (folding) {
          newIndex = index$1(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
        } else {
          newIndex = index$1(multiDragElement);
        }

        newIndicies.push({
          multiDragElement: multiDragElement,
          index: newIndex
        });
      });
      return {
        items: _toConsumableArray(multiDragElements),
        clones: [].concat(multiDragClones),
        oldIndicies: oldIndicies,
        newIndicies: newIndicies
      };
    },
    optionListeners: {
      multiDragKey: function multiDragKey(key) {
        key = key.toLowerCase();

        if (key === 'ctrl') {
          key = 'Control';
        } else if (key.length > 1) {
          key = key.charAt(0).toUpperCase() + key.substr(1);
        }

        return key;
      }
    }
  });
}

function insertMultiDragElements(clonesInserted, rootEl) {
  multiDragElements.forEach(function (multiDragElement, i) {
    var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(multiDragElement, target);
    } else {
      rootEl.appendChild(multiDragElement);
    }
  });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */


function insertMultiDragClones(elementsInserted, rootEl) {
  multiDragClones.forEach(function (clone, i) {
    var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];

    if (target) {
      rootEl.insertBefore(clone, target);
    } else {
      rootEl.appendChild(clone);
    }
  });
}

function removeMultiDragElements() {
  multiDragElements.forEach(function (multiDragElement) {
    if (multiDragElement === dragEl$1) return;
    multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
  });
}

Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);

var sortable_esm = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': Sortable,
	MultiDrag: MultiDragPlugin,
	Sortable: Sortable,
	Swap: SwapPlugin
});

var require$$0 = /*@__PURE__*/getAugmentedNamespace(sortable_esm);

(function (module, exports) {
(function webpackUniversalModuleDefinition(root, factory) {
	module.exports = factory(require$$0);
})((typeof self !== 'undefined' ? self : commonjsGlobal), function(__WEBPACK_EXTERNAL_MODULE_a352__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "01f9":
/***/ (function(module, exports, __webpack_require__) {

var LIBRARY = __webpack_require__("2d00");
var $export = __webpack_require__("5ca1");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var $iterCreate = __webpack_require__("41a0");
var setToStringTag = __webpack_require__("7f20");
var getPrototypeOf = __webpack_require__("38fd");
var ITERATOR = __webpack_require__("2b4c")('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),

/***/ "02f4":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var defined = __webpack_require__("be13");
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),

/***/ "0390":
/***/ (function(module, exports, __webpack_require__) {

var at = __webpack_require__("02f4")(true);

 // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? at(S, index).length : 1);
};


/***/ }),

/***/ "0bfb":
/***/ (function(module, exports, __webpack_require__) {

// 21.2.5.3 get RegExp.prototype.flags
var anObject = __webpack_require__("cb7c");
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ "0d58":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__("ce10");
var enumBugKeys = __webpack_require__("e11e");

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),

/***/ "1495":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var anObject = __webpack_require__("cb7c");
var getKeys = __webpack_require__("0d58");

module.exports = __webpack_require__("9e1e") ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),

/***/ "214f":
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("b0c5");
var redefine = __webpack_require__("2aba");
var hide = __webpack_require__("32e9");
var fails = __webpack_require__("79e5");
var defined = __webpack_require__("be13");
var wks = __webpack_require__("2b4c");
var regexpExec = __webpack_require__("520a");

var SPECIES = wks('species');

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  // #replace needs built-in support for named groups.
  // #match works fine because it just return the exec results, even if it has
  // a "grops" property.
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
})();

module.exports = function (KEY, length, exec) {
  var SYMBOL = wks(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;
    re.exec = function () { execCalled = true; return null; };
    if (KEY === 'split') {
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
    }
    re[SYMBOL]('');
    return !execCalled;
  }) : undefined;

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var fns = exec(
      defined,
      SYMBOL,
      ''[KEY],
      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
        if (regexp.exec === regexpExec) {
          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
            // The native String method already delegates to @@method (this
            // polyfilled function), leasing to infinite recursion.
            // We avoid it by directly calling the native @@method method.
            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
          }
          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
        }
        return { done: false };
      }
    );
    var strfn = fns[0];
    var rxfn = fns[1];

    redefine(String.prototype, KEY, strfn);
    hide(RegExp.prototype, SYMBOL, length == 2
      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
      ? function (string, arg) { return rxfn.call(string, this, arg); }
      // 21.2.5.6 RegExp.prototype[@@match](string)
      // 21.2.5.9 RegExp.prototype[@@search](string)
      : function (string) { return rxfn.call(string, this); }
    );
  }
};


/***/ }),

/***/ "230e":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
var document = __webpack_require__("7726").document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),

/***/ "23c6":
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__("2d95");
var TAG = __webpack_require__("2b4c")('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),

/***/ "2621":
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ "2aba":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var has = __webpack_require__("69a8");
var SRC = __webpack_require__("ca5a")('src');
var $toString = __webpack_require__("fa5b");
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__("8378").inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),

/***/ "2aeb":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__("cb7c");
var dPs = __webpack_require__("1495");
var enumBugKeys = __webpack_require__("e11e");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__("230e")('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__("fab2").appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),

/***/ "2b4c":
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__("5537")('wks');
var uid = __webpack_require__("ca5a");
var Symbol = __webpack_require__("7726").Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),

/***/ "2d00":
/***/ (function(module, exports) {

module.exports = false;


/***/ }),

/***/ "2d95":
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),

/***/ "2fdb":
/***/ (function(module, exports, __webpack_require__) {
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

var $export = __webpack_require__("5ca1");
var context = __webpack_require__("d2c8");
var INCLUDES = 'includes';

$export($export.P + $export.F * __webpack_require__("5147")(INCLUDES), 'String', {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~context(this, searchString, INCLUDES)
      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ "32e9":
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__("86cc");
var createDesc = __webpack_require__("4630");
module.exports = __webpack_require__("9e1e") ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ "38fd":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__("69a8");
var toObject = __webpack_require__("4bf8");
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),

/***/ "41a0":
/***/ (function(module, exports, __webpack_require__) {

var create = __webpack_require__("2aeb");
var descriptor = __webpack_require__("4630");
var setToStringTag = __webpack_require__("7f20");
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__("32e9")(IteratorPrototype, __webpack_require__("2b4c")('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),

/***/ "456d":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__("4bf8");
var $keys = __webpack_require__("0d58");

__webpack_require__("5eda")('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),

/***/ "4588":
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),

/***/ "4630":
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ "4bf8":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),

/***/ "5147":
/***/ (function(module, exports, __webpack_require__) {

var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (KEY) {
  var re = /./;
  try {
    '/./'[KEY](re);
  } catch (e) {
    try {
      re[MATCH] = false;
      return !'/./'[KEY](re);
    } catch (f) { /* empty */ }
  } return true;
};


/***/ }),

/***/ "520a":
/***/ (function(module, exports, __webpack_require__) {


var regexpFlags = __webpack_require__("0bfb");

var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
var nativeReplace = String.prototype.replace;

var patchedExec = nativeExec;

var LAST_INDEX = 'lastIndex';

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/,
      re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
})();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

if (PATCH) {
  patchedExec = function exec(str) {
    var re = this;
    var lastIndex, reCopy, match, i;

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

    match = nativeExec.call(re, str);

    if (UPDATES_LAST_INDEX_WRONG && match) {
      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      // eslint-disable-next-line no-loop-func
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ "52a7":
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),

/***/ "5537":
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__("8378");
var global = __webpack_require__("7726");
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__("2d00") ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),

/***/ "5ca1":
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__("7726");
var core = __webpack_require__("8378");
var hide = __webpack_require__("32e9");
var redefine = __webpack_require__("2aba");
var ctx = __webpack_require__("9b43");
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),

/***/ "5eda":
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__("5ca1");
var core = __webpack_require__("8378");
var fails = __webpack_require__("79e5");
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),

/***/ "5f1b":
/***/ (function(module, exports, __webpack_require__) {


var classof = __webpack_require__("23c6");
var builtinExec = RegExp.prototype.exec;

 // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw new TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }
  if (classof(R) !== 'RegExp') {
    throw new TypeError('RegExp#exec called on incompatible receiver');
  }
  return builtinExec.call(R, S);
};


/***/ }),

/***/ "613b":
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__("5537")('keys');
var uid = __webpack_require__("ca5a");
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),

/***/ "626a":
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__("2d95");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),

/***/ "6762":
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/Array.prototype.includes
var $export = __webpack_require__("5ca1");
var $includes = __webpack_require__("c366")(true);

$export($export.P, 'Array', {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

__webpack_require__("9c6c")('includes');


/***/ }),

/***/ "6821":
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__("626a");
var defined = __webpack_require__("be13");
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),

/***/ "69a8":
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),

/***/ "6a99":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__("d3f4");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ "7333":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys = __webpack_require__("0d58");
var gOPS = __webpack_require__("2621");
var pIE = __webpack_require__("52a7");
var toObject = __webpack_require__("4bf8");
var IObject = __webpack_require__("626a");
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__("79e5")(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
  } return T;
} : $assign;


/***/ }),

/***/ "7726":
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),

/***/ "77f1":
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__("4588");
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),

/***/ "79e5":
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),

/***/ "7f20":
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__("86cc").f;
var has = __webpack_require__("69a8");
var TAG = __webpack_require__("2b4c")('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),

/***/ "8378":
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.5' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),

/***/ "84f2":
/***/ (function(module, exports) {

module.exports = {};


/***/ }),

/***/ "86cc":
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__("cb7c");
var IE8_DOM_DEFINE = __webpack_require__("c69a");
var toPrimitive = __webpack_require__("6a99");
var dP = Object.defineProperty;

exports.f = __webpack_require__("9e1e") ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ "9b43":
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__("d8e8");
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ "9c6c":
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__("2b4c")('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__("32e9")(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ "9def":
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__("4588");
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),

/***/ "9e1e":
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__("79e5")(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "a352":
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_a352__;

/***/ }),

/***/ "a481":
/***/ (function(module, exports, __webpack_require__) {


var anObject = __webpack_require__("cb7c");
var toObject = __webpack_require__("4bf8");
var toLength = __webpack_require__("9def");
var toInteger = __webpack_require__("4588");
var advanceStringIndex = __webpack_require__("0390");
var regExpExec = __webpack_require__("5f1b");
var max = Math.max;
var min = Math.min;
var floor = Math.floor;
var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// @@replace logic
__webpack_require__("214f")('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
  return [
    // `String.prototype.replace` method
    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = defined(this);
      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
      return fn !== undefined
        ? fn.call(searchValue, O, replaceValue)
        : $replace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
    function (regexp, replaceValue) {
      var res = maybeCallNative($replace, regexp, this, replaceValue);
      if (res.done) return res.value;

      var rx = anObject(regexp);
      var S = String(this);
      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);
      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regExpExec(rx, S);
        if (result === null) break;
        results.push(result);
        if (!global) break;
        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }
      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];
        var matched = String(result[0]);
        var position = max(min(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];

    // https://tc39.github.io/ecma262/#sec-getsubstitution
  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
    var tailPos = position + matched.length;
    var m = captures.length;
    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
    if (namedCaptures !== undefined) {
      namedCaptures = toObject(namedCaptures);
      symbols = SUBSTITUTION_SYMBOLS;
    }
    return $replace.call(replacement, symbols, function (match, ch) {
      var capture;
      switch (ch.charAt(0)) {
        case '$': return '$';
        case '&': return matched;
        case '`': return str.slice(0, position);
        case "'": return str.slice(tailPos);
        case '<':
          capture = namedCaptures[ch.slice(1, -1)];
          break;
        default: // \d\d?
          var n = +ch;
          if (n === 0) return match;
          if (n > m) {
            var f = floor(n / 10);
            if (f === 0) return match;
            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
            return match;
          }
          capture = captures[n - 1];
      }
      return capture === undefined ? '' : capture;
    });
  }
});


/***/ }),

/***/ "aae3":
/***/ (function(module, exports, __webpack_require__) {

// 7.2.8 IsRegExp(argument)
var isObject = __webpack_require__("d3f4");
var cof = __webpack_require__("2d95");
var MATCH = __webpack_require__("2b4c")('match');
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
};


/***/ }),

/***/ "ac6a":
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__("cadf");
var getKeys = __webpack_require__("0d58");
var redefine = __webpack_require__("2aba");
var global = __webpack_require__("7726");
var hide = __webpack_require__("32e9");
var Iterators = __webpack_require__("84f2");
var wks = __webpack_require__("2b4c");
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),

/***/ "b0c5":
/***/ (function(module, exports, __webpack_require__) {

var regexpExec = __webpack_require__("520a");
__webpack_require__("5ca1")({
  target: 'RegExp',
  proto: true,
  forced: regexpExec !== /./.exec
}, {
  exec: regexpExec
});


/***/ }),

/***/ "be13":
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),

/***/ "c366":
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__("6821");
var toLength = __webpack_require__("9def");
var toAbsoluteIndex = __webpack_require__("77f1");
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),

/***/ "c649":
/***/ (function(module, __webpack_exports__, __webpack_require__) {
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return insertNodeAt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return camelize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return console; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return removeNode; });
/* harmony import */ __webpack_require__("a481");


function getConsole() {
  if (typeof window !== "undefined") {
    return window.console;
  }

  return global.console;
}

var console = getConsole();

function cached(fn) {
  var cache = Object.create(null);
  return function cachedFn(str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str));
  };
}

var regex = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(regex, function (_, c) {
    return c ? c.toUpperCase() : "";
  });
});

function removeNode(node) {
  if (node.parentElement !== null) {
    node.parentElement.removeChild(node);
  }
}

function insertNodeAt(fatherNode, node, position) {
  var refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
  fatherNode.insertBefore(node, refNode);
}


/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__("c8ba")));

/***/ }),

/***/ "c69a":
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__("9e1e") && !__webpack_require__("79e5")(function () {
  return Object.defineProperty(__webpack_require__("230e")('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),

/***/ "c8ba":
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ "ca5a":
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),

/***/ "cadf":
/***/ (function(module, exports, __webpack_require__) {

var addToUnscopables = __webpack_require__("9c6c");
var step = __webpack_require__("d53b");
var Iterators = __webpack_require__("84f2");
var toIObject = __webpack_require__("6821");

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__("01f9")(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),

/***/ "cb7c":
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__("d3f4");
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),

/***/ "ce10":
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__("69a8");
var toIObject = __webpack_require__("6821");
var arrayIndexOf = __webpack_require__("c366")(false);
var IE_PROTO = __webpack_require__("613b")('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),

/***/ "d2c8":
/***/ (function(module, exports, __webpack_require__) {

// helper for String#{startsWith, endsWith, includes}
var isRegExp = __webpack_require__("aae3");
var defined = __webpack_require__("be13");

module.exports = function (that, searchString, NAME) {
  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
  return String(defined(that));
};


/***/ }),

/***/ "d3f4":
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),

/***/ "d53b":
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),

/***/ "d8e8":
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),

/***/ "e11e":
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),

/***/ "f559":
/***/ (function(module, exports, __webpack_require__) {
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

var $export = __webpack_require__("5ca1");
var toLength = __webpack_require__("9def");
var context = __webpack_require__("d2c8");
var STARTS_WITH = 'startsWith';
var $startsWith = ''[STARTS_WITH];

$export($export.P + $export.F * __webpack_require__("5147")(STARTS_WITH), 'String', {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = context(this, searchString, STARTS_WITH);
    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = String(searchString);
    return $startsWith
      ? $startsWith.call(that, search, index)
      : that.slice(index, index + search.length) === search;
  }
});


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "f751":
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__("5ca1");

$export($export.S + $export.F, 'Object', { assign: __webpack_require__("7333") });


/***/ }),

/***/ "fa5b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__("5537")('native-function-to-string', Function.toString);


/***/ }),

/***/ "fab2":
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__("7726").document;
module.exports = document && document.documentElement;


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  {
    __webpack_require__("f6fd");
  }

  var setPublicPath_i;
  if ((setPublicPath_i = window.document.currentScript) && (setPublicPath_i = setPublicPath_i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = setPublicPath_i[1]; // eslint-disable-line
  }
}

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.assign.js
__webpack_require__("f751");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.starts-with.js
__webpack_require__("f559");

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom.iterable.js
__webpack_require__("ac6a");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.array.iterator.js
__webpack_require__("cadf");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.object.keys.js
__webpack_require__("456d");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es7.array.includes.js
__webpack_require__("6762");

// EXTERNAL MODULE: ./node_modules/core-js/modules/es6.string.includes.js
__webpack_require__("2fdb");

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: external {"commonjs":"sortablejs","commonjs2":"sortablejs","amd":"sortablejs","root":"Sortable"}
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_ = __webpack_require__("a352");
var external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_);

// EXTERNAL MODULE: ./src/util/helper.js
var helper = __webpack_require__("c649");

// CONCATENATED MODULE: ./src/vuedraggable.js












function buildAttribute(object, propName, value) {
  if (value === undefined) {
    return object;
  }

  object = object || {};
  object[propName] = value;
  return object;
}

function computeVmIndex(vnodes, element) {
  return vnodes.map(function (elt) {
    return elt.elm;
  }).indexOf(element);
}

function _computeIndexes(slots, children, isTransition, footerOffset) {
  if (!slots) {
    return [];
  }

  var elmFromNodes = slots.map(function (elt) {
    return elt.elm;
  });
  var footerIndex = children.length - footerOffset;

  var rawIndexes = _toConsumableArray(children).map(function (elt, idx) {
    return idx >= footerIndex ? elmFromNodes.length : elmFromNodes.indexOf(elt);
  });

  return isTransition ? rawIndexes.filter(function (ind) {
    return ind !== -1;
  }) : rawIndexes;
}

function emit(evtName, evtData) {
  var _this = this;

  this.$nextTick(function () {
    return _this.$emit(evtName.toLowerCase(), evtData);
  });
}

function delegateAndEmit(evtName) {
  var _this2 = this;

  return function (evtData) {
    if (_this2.realList !== null) {
      _this2["onDrag" + evtName](evtData);
    }

    emit.call(_this2, evtName, evtData);
  };
}

function isTransitionName(name) {
  return ["transition-group", "TransitionGroup"].includes(name);
}

function vuedraggable_isTransition(slots) {
  if (!slots || slots.length !== 1) {
    return false;
  }

  var _slots = _slicedToArray(slots, 1),
      componentOptions = _slots[0].componentOptions;

  if (!componentOptions) {
    return false;
  }

  return isTransitionName(componentOptions.tag);
}

function getSlot(slot, scopedSlot, key) {
  return slot[key] || (scopedSlot[key] ? scopedSlot[key]() : undefined);
}

function computeChildrenAndOffsets(children, slot, scopedSlot) {
  var headerOffset = 0;
  var footerOffset = 0;
  var header = getSlot(slot, scopedSlot, "header");

  if (header) {
    headerOffset = header.length;
    children = children ? [].concat(_toConsumableArray(header), _toConsumableArray(children)) : _toConsumableArray(header);
  }

  var footer = getSlot(slot, scopedSlot, "footer");

  if (footer) {
    footerOffset = footer.length;
    children = children ? [].concat(_toConsumableArray(children), _toConsumableArray(footer)) : _toConsumableArray(footer);
  }

  return {
    children: children,
    headerOffset: headerOffset,
    footerOffset: footerOffset
  };
}

function getComponentAttributes($attrs, componentData) {
  var attributes = null;

  var update = function update(name, value) {
    attributes = buildAttribute(attributes, name, value);
  };

  var attrs = Object.keys($attrs).filter(function (key) {
    return key === "id" || key.startsWith("data-");
  }).reduce(function (res, key) {
    res[key] = $attrs[key];
    return res;
  }, {});
  update("attrs", attrs);

  if (!componentData) {
    return attributes;
  }

  var on = componentData.on,
      props = componentData.props,
      componentDataAttrs = componentData.attrs;
  update("on", on);
  update("props", props);
  Object.assign(attributes.attrs, componentDataAttrs);
  return attributes;
}

var eventsListened = ["Start", "Add", "Remove", "Update", "End"];
var eventsToEmit = ["Choose", "Unchoose", "Sort", "Filter", "Clone"];
var readonlyProperties = ["Move"].concat(eventsListened, eventsToEmit).map(function (evt) {
  return "on" + evt;
});
var draggingElement = null;
var props = {
  options: Object,
  list: {
    type: Array,
    required: false,
    default: null
  },
  value: {
    type: Array,
    required: false,
    default: null
  },
  noTransitionOnDrag: {
    type: Boolean,
    default: false
  },
  clone: {
    type: Function,
    default: function _default(original) {
      return original;
    }
  },
  element: {
    type: String,
    default: "div"
  },
  tag: {
    type: String,
    default: null
  },
  move: {
    type: Function,
    default: null
  },
  componentData: {
    type: Object,
    required: false,
    default: null
  }
};
var draggableComponent = {
  name: "draggable",
  inheritAttrs: false,
  props: props,
  data: function data() {
    return {
      transitionMode: false,
      noneFunctionalComponentMode: false
    };
  },
  render: function render(h) {
    var slots = this.$slots.default;
    this.transitionMode = vuedraggable_isTransition(slots);

    var _computeChildrenAndOf = computeChildrenAndOffsets(slots, this.$slots, this.$scopedSlots),
        children = _computeChildrenAndOf.children,
        headerOffset = _computeChildrenAndOf.headerOffset,
        footerOffset = _computeChildrenAndOf.footerOffset;

    this.headerOffset = headerOffset;
    this.footerOffset = footerOffset;
    var attributes = getComponentAttributes(this.$attrs, this.componentData);
    return h(this.getTag(), attributes, children);
  },
  created: function created() {
    if (this.list !== null && this.value !== null) {
      helper["b" /* console */].error("Value and list props are mutually exclusive! Please set one or another.");
    }

    if (this.element !== "div") {
      helper["b" /* console */].warn("Element props is deprecated please use tag props instead. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#element-props");
    }

    if (this.options !== undefined) {
      helper["b" /* console */].warn("Options props is deprecated, add sortable options directly as vue.draggable item, or use v-bind. See https://github.com/SortableJS/Vue.Draggable/blob/master/documentation/migrate.md#options-props");
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.noneFunctionalComponentMode = this.getTag().toLowerCase() !== this.$el.nodeName.toLowerCase() && !this.getIsFunctional();

    if (this.noneFunctionalComponentMode && this.transitionMode) {
      throw new Error("Transition-group inside component is not supported. Please alter tag value or remove transition-group. Current tag value: ".concat(this.getTag()));
    }

    var optionsAdded = {};
    eventsListened.forEach(function (elt) {
      optionsAdded["on" + elt] = delegateAndEmit.call(_this3, elt);
    });
    eventsToEmit.forEach(function (elt) {
      optionsAdded["on" + elt] = emit.bind(_this3, elt);
    });
    var attributes = Object.keys(this.$attrs).reduce(function (res, key) {
      res[Object(helper["a" /* camelize */])(key)] = _this3.$attrs[key];
      return res;
    }, {});
    var options = Object.assign({}, this.options, attributes, optionsAdded, {
      onMove: function onMove(evt, originalEvent) {
        return _this3.onDragMove(evt, originalEvent);
      }
    });
    !("draggable" in options) && (options.draggable = ">*");
    this._sortable = new external_commonjs_sortablejs_commonjs2_sortablejs_amd_sortablejs_root_Sortable_default.a(this.rootContainer, options);
    this.computeIndexes();
  },
  beforeDestroy: function beforeDestroy() {
    if (this._sortable !== undefined) this._sortable.destroy();
  },
  computed: {
    rootContainer: function rootContainer() {
      return this.transitionMode ? this.$el.children[0] : this.$el;
    },
    realList: function realList() {
      return this.list ? this.list : this.value;
    }
  },
  watch: {
    options: {
      handler: function handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    $attrs: {
      handler: function handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    realList: function realList() {
      this.computeIndexes();
    }
  },
  methods: {
    getIsFunctional: function getIsFunctional() {
      var fnOptions = this._vnode.fnOptions;
      return fnOptions && fnOptions.functional;
    },
    getTag: function getTag() {
      return this.tag || this.element;
    },
    updateOptions: function updateOptions(newOptionValue) {
      for (var property in newOptionValue) {
        var value = Object(helper["a" /* camelize */])(property);

        if (readonlyProperties.indexOf(value) === -1) {
          this._sortable.option(value, newOptionValue[property]);
        }
      }
    },
    getChildrenNodes: function getChildrenNodes() {
      if (this.noneFunctionalComponentMode) {
        return this.$children[0].$slots.default;
      }

      var rawNodes = this.$slots.default;
      return this.transitionMode ? rawNodes[0].child.$slots.default : rawNodes;
    },
    computeIndexes: function computeIndexes() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.visibleIndexes = _computeIndexes(_this4.getChildrenNodes(), _this4.rootContainer.children, _this4.transitionMode, _this4.footerOffset);
      });
    },
    getUnderlyingVm: function getUnderlyingVm(htmlElt) {
      var index = computeVmIndex(this.getChildrenNodes() || [], htmlElt);

      if (index === -1) {
        //Edge case during move callback: related element might be
        //an element different from collection
        return null;
      }

      var element = this.realList[index];
      return {
        index: index,
        element: element
      };
    },
    getUnderlyingPotencialDraggableComponent: function getUnderlyingPotencialDraggableComponent(_ref) {
      var vue = _ref.__vue__;

      if (!vue || !vue.$options || !isTransitionName(vue.$options._componentTag)) {
        if (!("realList" in vue) && vue.$children.length === 1 && "realList" in vue.$children[0]) return vue.$children[0];
        return vue;
      }

      return vue.$parent;
    },
    emitChanges: function emitChanges(evt) {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.$emit("change", evt);
      });
    },
    alterList: function alterList(onList) {
      if (this.list) {
        onList(this.list);
        return;
      }

      var newList = _toConsumableArray(this.value);

      onList(newList);
      this.$emit("input", newList);
    },
    spliceList: function spliceList() {
      var _arguments = arguments;

      var spliceList = function spliceList(list) {
        return list.splice.apply(list, _toConsumableArray(_arguments));
      };

      this.alterList(spliceList);
    },
    updatePosition: function updatePosition(oldIndex, newIndex) {
      var updatePosition = function updatePosition(list) {
        return list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
      };

      this.alterList(updatePosition);
    },
    getRelatedContextFromMoveEvent: function getRelatedContextFromMoveEvent(_ref2) {
      var to = _ref2.to,
          related = _ref2.related;
      var component = this.getUnderlyingPotencialDraggableComponent(to);

      if (!component) {
        return {
          component: component
        };
      }

      var list = component.realList;
      var context = {
        list: list,
        component: component
      };

      if (to !== related && list && component.getUnderlyingVm) {
        var destination = component.getUnderlyingVm(related);

        if (destination) {
          return Object.assign(destination, context);
        }
      }

      return context;
    },
    getVmIndex: function getVmIndex(domIndex) {
      var indexes = this.visibleIndexes;
      var numberIndexes = indexes.length;
      return domIndex > numberIndexes - 1 ? numberIndexes : indexes[domIndex];
    },
    getComponent: function getComponent() {
      return this.$slots.default[0].componentInstance;
    },
    resetTransitionData: function resetTransitionData(index) {
      if (!this.noTransitionOnDrag || !this.transitionMode) {
        return;
      }

      var nodes = this.getChildrenNodes();
      nodes[index].data = null;
      var transitionContainer = this.getComponent();
      transitionContainer.children = [];
      transitionContainer.kept = undefined;
    },
    onDragStart: function onDragStart(evt) {
      this.context = this.getUnderlyingVm(evt.item);
      evt.item._underlying_vm_ = this.clone(this.context.element);
      draggingElement = evt.item;
    },
    onDragAdd: function onDragAdd(evt) {
      var element = evt.item._underlying_vm_;

      if (element === undefined) {
        return;
      }

      Object(helper["d" /* removeNode */])(evt.item);
      var newIndex = this.getVmIndex(evt.newIndex);
      this.spliceList(newIndex, 0, element);
      this.computeIndexes();
      var added = {
        element: element,
        newIndex: newIndex
      };
      this.emitChanges({
        added: added
      });
    },
    onDragRemove: function onDragRemove(evt) {
      Object(helper["c" /* insertNodeAt */])(this.rootContainer, evt.item, evt.oldIndex);

      if (evt.pullMode === "clone") {
        Object(helper["d" /* removeNode */])(evt.clone);
        return;
      }

      var oldIndex = this.context.index;
      this.spliceList(oldIndex, 1);
      var removed = {
        element: this.context.element,
        oldIndex: oldIndex
      };
      this.resetTransitionData(oldIndex);
      this.emitChanges({
        removed: removed
      });
    },
    onDragUpdate: function onDragUpdate(evt) {
      Object(helper["d" /* removeNode */])(evt.item);
      Object(helper["c" /* insertNodeAt */])(evt.from, evt.item, evt.oldIndex);
      var oldIndex = this.context.index;
      var newIndex = this.getVmIndex(evt.newIndex);
      this.updatePosition(oldIndex, newIndex);
      var moved = {
        element: this.context.element,
        oldIndex: oldIndex,
        newIndex: newIndex
      };
      this.emitChanges({
        moved: moved
      });
    },
    updateProperty: function updateProperty(evt, propertyName) {
      evt.hasOwnProperty(propertyName) && (evt[propertyName] += this.headerOffset);
    },
    computeFutureIndex: function computeFutureIndex(relatedContext, evt) {
      if (!relatedContext.element) {
        return 0;
      }

      var domChildren = _toConsumableArray(evt.to.children).filter(function (el) {
        return el.style["display"] !== "none";
      });

      var currentDOMIndex = domChildren.indexOf(evt.related);
      var currentIndex = relatedContext.component.getVmIndex(currentDOMIndex);
      var draggedInList = domChildren.indexOf(draggingElement) !== -1;
      return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
    },
    onDragMove: function onDragMove(evt, originalEvent) {
      var onMove = this.move;

      if (!onMove || !this.realList) {
        return true;
      }

      var relatedContext = this.getRelatedContextFromMoveEvent(evt);
      var draggedContext = this.context;
      var futureIndex = this.computeFutureIndex(relatedContext, evt);
      Object.assign(draggedContext, {
        futureIndex: futureIndex
      });
      var sendEvt = Object.assign({}, evt, {
        relatedContext: relatedContext,
        draggedContext: draggedContext
      });
      return onMove(sendEvt, originalEvent);
    },
    onDragEnd: function onDragEnd() {
      this.computeIndexes();
      draggingElement = null;
    }
  }
};

if (typeof window !== "undefined" && "Vue" in window) {
  window.Vue.component("draggable", draggableComponent);
}

/* harmony default export */ var vuedraggable = (draggableComponent);
// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js


/* harmony default export */ __webpack_exports__["default"] = (vuedraggable);



/***/ })

/******/ })["default"];
});

}(vuedraggable_umd));

var draggable = /*@__PURE__*/getDefaultExportFromCjs(vuedraggable_umd.exports);

//
var script$1w = {
  name: 'MyHeadingsRow',
  props: ['props'],
  components: {
    VtTableHeading: VtTableHeading,
    draggable: draggable
  },
  computed: {
    originalColumns: function originalColumns() {
      return this.props.columns;
    },
    columnsOptions: function columnsOptions() {
      return this.props.opts.columnsOptions;
    },
    dragOptions: function dragOptions() {
      return {
        animation: 200,
        disabled: false,
        ghostClass: 'ghost'
      };
    }
  },
  watch: {
    originalColumns: {
      handler: function handler() {
        this.setColumns();
        this.setLast();
      },
      deep: true
    },
    'props.opts.columnsOptions': {
      handler: function handler() {
        var _this = this;
        this.$nextTick(function () {
          _this.setLast();
        });
      },
      deep: true
    }
  },
  data: function data() {
    return {
      columns: [],
      drag: false,
      check: false,
      firstLoad: true
    };
  },
  methods: {
    updateColumns: function updateColumns() {
      global.vtEvent.$emit('aq-table.setColumns', {
        data: this.columns,
        id: this.props.opts.uniqueIdHeader
      });
    },
    setColumns: function setColumns() {
      this.columns = this.props.columns;
    },
    setLast: function setLast() {
      var last = null;
      var children = this.$refs.parent.$el.children;
      for (var index = 0; index < (children === null || children === void 0 ? void 0 : children.length); index += 1) {
        var element = children[index];
        if (element.getAttribute('pinned')) {
          last = element;
        }
      }
      this.props.opts.lastPinned = last ? last.id : 'none';
    },
    setCheck: function setCheck(e) {
      this.props.toggleAll(e);
    },
    setSize: function setSize() {
      global.vtEvent.$emit('aq-table.setWidthHeader');
    }
  },
  created: function created() {
    this.setColumns();
    this.props.opts.lastPinned = 'none';
  },
  mounted: function mounted() {
    global.vtEvent.$on('vue-tables.loaded', this.setSize);
  },
  beforeDestroy: function beforeDestroy() {
    global.vtEvent.$off('vue-tables.loaded', this.setSize);
  }
};

/* script */
var __vue_script__$1w = script$1w;

/* template */
var __vue_render__$1w = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('draggable', _vm._b({
    ref: "parent",
    staticStyle: {
      "height": "56px"
    },
    attrs: {
      "tag": "tr",
      "handle": ".aq-table__dropdown-handler"
    },
    on: {
      "start": function start($event) {
        _vm.drag = true;
      },
      "end": function end($event) {
        _vm.drag = false;
      },
      "update": _vm.updateColumns
    },
    model: {
      value: _vm.columns,
      callback: function callback($$v) {
        _vm.columns = $$v;
      },
      expression: "columns"
    }
  }, 'draggable', _vm.dragOptions, false), [_c('template', {
    slot: "header"
  }, [_vm.props.selectable ? _c('th', {
    staticClass: "aq-table__child-row-header",
    attrs: {
      "scope": "row"
    }
  }, [_c('div', {
    staticClass: "aq-table__child-row-header-check"
  }, [_c('aq-checkbox', {
    attrs: {
      "id": "vt-toggle-all"
    },
    on: {
      "click": function click($event) {
        return _vm.setCheck($event);
      }
    },
    model: {
      value: _vm.check,
      callback: function callback($$v) {
        _vm.check = $$v;
      },
      expression: "check"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _vm.props.childRowTogglerFirst ? _c('th', {
    staticClass: "aq-table__child-row-header",
    attrs: {
      "scope": "row"
    }
  }) : _vm._e()]), _vm._v(" "), _vm._l(_vm.columns, function (column, i) {
    return _c('vt-table-heading', {
      key: i,
      attrs: {
        "column": column,
        "nameColumn": column
      }
    });
  }), _vm._v(" "), _vm.props.childRowTogglerLast ? _c('th', {
    staticClass: "aq-table__child-row-header",
    attrs: {
      "slot": "footer",
      "scope": "row"
    },
    slot: "footer"
  }) : _vm._e()], 2);
};
var __vue_staticRenderFns__$1w = [];

/* style */
var __vue_inject_styles__$1w = undefined;
/* scoped */
var __vue_scope_id__$1w = "data-v-413aa182";
/* module identifier */
var __vue_module_identifier__$1w = undefined;
/* functional template */
var __vue_is_functional_template__$1w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1w = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1w,
  staticRenderFns: __vue_staticRenderFns__$1w
}, __vue_inject_styles__$1w, __vue_script__$1w, __vue_scope_id__$1w, __vue_is_functional_template__$1w, __vue_module_identifier__$1w, false, undefined, undefined, undefined);
var HeadingsRow = __vue_component__$1w;

//
var script$1v = {
  name: 'MyTable',
  props: ['props'],
  components: {
    VtTableHead: VtTableHead,
    VtTableBody: VtTableBody,
    vnodes: {
      functional: true,
      props: {
        props: {
          type: Object,
          default: function _default() {
            return {};
          }
        }
      },
      render: function render(h, ctx) {
        return ctx.props.vnodes;
      }
    }
  }
};

/* script */
var __vue_script__$1v = script$1v;

/* template */
var __vue_render__$1v = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_c('table', _vm._b({}, 'table', _vm.props.tableAttrs, false), [_vm.props.caption ? _c('caption', [_vm._v("\n      " + _vm._s(_vm.props.caption) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('vt-table-head'), _vm._v(" "), _c('vnodes', {
    attrs: {
      "vnodes": _vm.props.slots.beforeBody
    }
  }), _vm._v(" "), _c('vt-table-body', {
    ref: "vt_table_body"
  }), _vm._v(" "), _c('vnodes', {
    attrs: {
      "vnodes": _vm.props.slots.afterBody,
      "props": _vm.props
    }
  })], 1)]);
};
var __vue_staticRenderFns__$1v = [];

/* style */
var __vue_inject_styles__$1v = undefined;
/* scoped */
var __vue_scope_id__$1v = undefined;
/* module identifier */
var __vue_module_identifier__$1v = undefined;
/* functional template */
var __vue_is_functional_template__$1v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1v = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1v,
  staticRenderFns: __vue_staticRenderFns__$1v
}, __vue_inject_styles__$1v, __vue_script__$1v, __vue_scope_id__$1v, __vue_is_functional_template__$1v, __vue_module_identifier__$1v, false, undefined, undefined, undefined);
var Table = __vue_component__$1v;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$1u = {
  name: 'MyTableCell',
  props: ['props'],
  components: {
    vnodes: {
      functional: true,
      render: function render(h, ctx) {
        return _typeof$2(ctx.props.vnodes) === 'object' ? ctx.props.vnodes : [ctx.props.vnodes];
      }
    }
  },
  computed: {
    originalColumns: function originalColumns() {
      return this.props.columns;
    },
    columnsOptions: function columnsOptions() {
      return this.props.opts.columnsOptions;
    },
    align: function align() {
      var _this$props$opts, _this$props$opts$colu;
      var align = ((_this$props$opts = this.props.opts) === null || _this$props$opts === void 0 ? void 0 : (_this$props$opts$colu = _this$props$opts.columnsOptions[this.props.column]) === null || _this$props$opts$colu === void 0 ? void 0 : _this$props$opts$colu.align) || 'left';
      return "aq-table-cell__div--".concat(align);
    },
    isClamp: function isClamp() {
      var _this$props$opts2, _this$props$opts2$col, _this$props$opts3, _this$props$opts3$col;
      return ((_this$props$opts2 = this.props.opts) === null || _this$props$opts2 === void 0 ? void 0 : (_this$props$opts2$col = _this$props$opts2.columnsOptions[this.props.column]) === null || _this$props$opts2$col === void 0 ? void 0 : _this$props$opts2$col.lineClamp) && !((_this$props$opts3 = this.props.opts) !== null && _this$props$opts3 !== void 0 && (_this$props$opts3$col = _this$props$opts3.columnsOptions[this.props.column]) !== null && _this$props$opts3$col !== void 0 && _this$props$opts3$col.hideTooltipClamp);
    },
    getTooltipWidth: function getTooltipWidth() {
      var _this$props$opts4, _this$props$opts4$col, _this$props$opts5;
      return (_this$props$opts4 = this.props.opts) !== null && _this$props$opts4 !== void 0 && (_this$props$opts4$col = _this$props$opts4.columnsOptions[this.props.column]) !== null && _this$props$opts4$col !== void 0 && _this$props$opts4$col.tooltipWidth ? (_this$props$opts5 = this.props.opts) === null || _this$props$opts5 === void 0 ? void 0 : _this$props$opts5.columnsOptions[this.props.column].tooltipWidth : '';
    }
  },
  watch: {
    originalColumns: {
      handler: function handler() {
        this.setStyle();
        this.setWidth(); /*
                         setTimeout(() => {
                         this.setWidth();
                         }); */
      },

      deep: true
    },
    columnsOptions: {
      handler: function handler() {
        var _this = this;
        this.setWidth();
        this.setStyle();
        setTimeout(function () {
          _this.lastPinned = _this.props.opts.lastPinned === _this.props.column;
        });
      },
      deep: true
    }
  },
  data: function data() {
    return {
      style: {},
      styleDiv: {},
      lastPinned: false,
      tooltipVisible: false
    };
  },
  methods: {
    setStyleDiv: function setStyleDiv() {
      var _this$props$opts6, _this$props$opts6$col;
      if ((_this$props$opts6 = this.props.opts) !== null && _this$props$opts6 !== void 0 && (_this$props$opts6$col = _this$props$opts6.columnsOptions[this.props.column]) !== null && _this$props$opts6$col !== void 0 && _this$props$opts6$col.lineClamp) {
        var _this$props$opts7, _this$props$opts7$col;
        this.styleDiv = {
          overflow: 'hidden',
          'text-overflow': 'ellipsis',
          'white-space': 'initial',
          display: '-webkit-box',
          '-webkit-line-clamp': "".concat((_this$props$opts7 = this.props.opts) === null || _this$props$opts7 === void 0 ? void 0 : (_this$props$opts7$col = _this$props$opts7.columnsOptions[this.props.column]) === null || _this$props$opts7$col === void 0 ? void 0 : _this$props$opts7$col.lineClamp),
          'webkit-box-orient': 'vertical'
        };
      }
    },
    validateHeight: function validateHeight() {
      var div = this.$refs.div;
      if (div && div.$el.offsetHeight < div.$el.scrollHeight) {
        this.tooltipVisible = true;
      }
    },
    setStyle: function setStyle() {
      var _this$props$opts8, _this$props$opts8$col;
      var style = (_this$props$opts8 = this.props.opts) === null || _this$props$opts8 === void 0 ? void 0 : (_this$props$opts8$col = _this$props$opts8.columnsOptions[this.props.column]) === null || _this$props$opts8$col === void 0 ? void 0 : _this$props$opts8$col.style;
      if (style) {
        this.style = style;
      }
    },
    setWidth: function setWidth() {
      var firstRow = this.$el.getAttribute('firstRow');
      if (firstRow) {
        var _this$$refs, _this$$refs$cell;
        this.props.opts.columnsOptions[this.props.column].realWidth = (_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : (_this$$refs$cell = _this$$refs.cell) === null || _this$$refs$cell === void 0 ? void 0 : _this$$refs$cell.offsetWidth;
        global.vtEvent.$emit('aq-table.setWidthHeader');
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    this.setStyleDiv();
    this.setStyle();
    setTimeout(function () {
      _this2.setWidth();
      _this2.validateHeight();
    });
    this.lastPinned = this.props.opts.lastPinned === this.props.column;
    global.vtEvent.$on('aq-table.changeWidth', this.setWidth);
  },
  beforeDestroy: function beforeDestroy() {
    global.vtEvent.$off('aq-table.changeWidth', this.setWidth);
  }
};

/* script */
var __vue_script__$1u = script$1u;

/* template */
var __vue_render__$1u = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('td', {
    ref: "cell",
    class: [_vm.props.classes, 'aq-table-cell', {
      'last-left-fixed-column': _vm.lastPinned
    }],
    style: _vm.style,
    attrs: {
      "tabindex": _vm.props.tabIndex
    }
  }, [_c('div', {
    class: ['aq-table-cell__div', _vm.align]
  }, [_vm.isClamp ? _c('aq-tooltip', {
    ref: "div",
    style: _vm.styleDiv,
    attrs: {
      "showTooltip": _vm.tooltipVisible,
      "width": _vm.getTooltipWidth
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_c('vnodes', {
          attrs: {
            "vnodes": _vm.props.content
          }
        })];
      },
      proxy: true
    }], null, false, 1157221444)
  }, [_vm._v(" "), [_c('vnodes', {
    attrs: {
      "vnodes": _vm.props.content
    }
  })]], 2) : _c('vnodes', {
    attrs: {
      "vnodes": _vm.props.content
    }
  })], 1)]);
};
var __vue_staticRenderFns__$1u = [];

/* style */
var __vue_inject_styles__$1u = undefined;
/* scoped */
var __vue_scope_id__$1u = undefined;
/* module identifier */
var __vue_module_identifier__$1u = undefined;
/* functional template */
var __vue_is_functional_template__$1u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1u = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1u,
  staticRenderFns: __vue_staticRenderFns__$1u
}, __vue_inject_styles__$1u, __vue_script__$1u, __vue_scope_id__$1u, __vue_is_functional_template__$1u, __vue_module_identifier__$1u, false, undefined, undefined, undefined);
var TableCell = __vue_component__$1u;

/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle$1 (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle$1(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver$1 = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver$1.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver$1;
})();

var script$1t = {
  name: 'MyDataTable',
  props: ['props'],
  components: {
    VtGenericFilter: VtGenericFilter,
    VtTable: VtTable,
    VtPagination: VtPagination,
    VtColumnsDropdown: VtColumnsDropdown,
    // VtPaginationCount,
    Observer: Observer,
    vnodes: {
      functional: true,
      render: function render(h, ctx) {
        return ctx.props.vnodes;
      }
    }
  },
  computed: {
    style: function style() {
      var _this$props$opts, _this$props$opts2;
      return {
        maxHeight: (_this$props$opts = this.props.opts) !== null && _this$props$opts !== void 0 && _this$props$opts.maxHeight ? (_this$props$opts2 = this.props.opts) === null || _this$props$opts2 === void 0 ? void 0 : _this$props$opts2.maxHeight : 'auto'
      };
    },
    columnsOptions: function columnsOptions() {
      return this.props.opts.columnsOptions;
    },
    numberSelected: function numberSelected() {
      var _this$selected;
      return (_this$selected = this.selected) === null || _this$selected === void 0 ? void 0 : _this$selected.length;
    },
    textTag: function textTag() {
      return this.numberSelected === 1 ? "".concat(this.numberSelected, " item") : "".concat(this.numberSelected, " items");
    },
    showDividerToolbar: function showDividerToolbar() {
      return this.numberSelected > 0 && this.props.slots.beforeTable !== undefined || this.props.opts.title && this.props.slots.beforeTable !== undefined;
    },
    getTooltipWidth: function getTooltipWidth() {
      var _this$props$opts3;
      return (_this$props$opts3 = this.props.opts) !== null && _this$props$opts3 !== void 0 && _this$props$opts3.infoTitleWidth ? this.props.opts.infoTitleWidth : '';
    },
    infoIsVisible: function infoIsVisible() {
      var _this$props$opts4, _this$props$opts5, _this$props$opts6, _this$props$opts7;
      return ((_this$props$opts4 = this.props.opts) === null || _this$props$opts4 === void 0 ? void 0 : _this$props$opts4.infoTitle) && ((_this$props$opts5 = this.props.opts) === null || _this$props$opts5 === void 0 ? void 0 : _this$props$opts5.infoTitle) !== '' && ((_this$props$opts6 = this.props.opts) === null || _this$props$opts6 === void 0 ? void 0 : _this$props$opts6.title) && ((_this$props$opts7 = this.props.opts) === null || _this$props$opts7 === void 0 ? void 0 : _this$props$opts7.title) !== '';
    },
    getInfoTitle: function getInfoTitle() {
      return this.infoIsVisible ? this.$aqT(this.props.opts.infoTitle) : '';
    }
  },
  data: function data() {
    return {
      classActive: false,
      headerElement: {},
      searchVisible: false,
      selected: [],
      loaded: false,
      tableName: '',
      resizeObserver: null
    };
  },
  watch: {
    columnsOptions: {
      handler: function handler() {
        this.setStylesHeader();
      },
      deep: true
    }
  },
  methods: {
    setClassShadow: function setClassShadow() {
      var _this$$refs, _this$$refs$table_res;
      this.classActive = ((_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : (_this$$refs$table_res = _this$$refs.table_responsive) === null || _this$$refs$table_res === void 0 ? void 0 : _this$$refs$table_res.scrollLeft) !== 0;
      this.setStylesHeader();
      this.setStylesFooter();
    },
    setStylesHeader: function setStylesHeader() {
      var _Object$keys;
      this.validateHeader();
      if (this.headerElement && (_Object$keys = Object.keys(this.headerElement)) !== null && _Object$keys !== void 0 && _Object$keys.length) {
        var _this$$refs2, _this$$refs2$table_re;
        this.headerElement.scrollLeft = (_this$$refs2 = this.$refs) === null || _this$$refs2 === void 0 ? void 0 : (_this$$refs2$table_re = _this$$refs2.table_responsive) === null || _this$$refs2$table_re === void 0 ? void 0 : _this$$refs2$table_re.scrollLeft;
        if (this.loaded) {
          this.$refs.table_responsive.style.marginTop = "".concat(this.headerElement.offsetHeight - 1, "px");
        }
      }
    },
    setStylesFooter: function setStylesFooter() {
      var footerElement = document.querySelector("#".concat(this.props.opts.uniqueIdHeader, "__footer"));
      if (footerElement) {
        var _this$$refs3, _this$$refs3$table_re;
        footerElement.scrollLeft = (_this$$refs3 = this.$refs) === null || _this$$refs3 === void 0 ? void 0 : (_this$$refs3$table_re = _this$$refs3.table_responsive) === null || _this$$refs3$table_re === void 0 ? void 0 : _this$$refs3$table_re.scrollLeft;
      }
    },
    setHeaderElement: function setHeaderElement() {
      this.headerElement = document.getElementById(this.props.opts.uniqueIdHeader);
    },
    setScrollHeader: function setScrollHeader() {
      var _this = this;
      setTimeout(function () {
        if (_this.headerElement) {
          var _this$$refs4, _this$$refs4$table_re, _this$$refs5, _this$$refs5$table_re;
          if (((_this$$refs4 = _this.$refs) === null || _this$$refs4 === void 0 ? void 0 : (_this$$refs4$table_re = _this$$refs4.table_responsive) === null || _this$$refs4$table_re === void 0 ? void 0 : _this$$refs4$table_re.scrollHeight) > ((_this$$refs5 = _this.$refs) === null || _this$$refs5 === void 0 ? void 0 : (_this$$refs5$table_re = _this$$refs5.table_responsive) === null || _this$$refs5$table_re === void 0 ? void 0 : _this$$refs5$table_re.offsetHeight)) {
            _this.headerElement.style.overflowY = 'scroll';
          } else if (_this.headerElement !== null) {
            _this.headerElement.style.overflowY = 'hidden';
          }
        }
        _this.setScrollHorizontalFooter();
      });
    },
    setScrollHorizontalFooter: function setScrollHorizontalFooter() {
      var footerElement = document.querySelector("#".concat(this.props.opts.uniqueIdHeader, "__footer"));
      if (footerElement) {
        var _this$$refs6, _this$$refs6$table_re, _this$headerElement, _this$headerElement$s;
        var width = (_this$$refs6 = this.$refs) === null || _this$$refs6 === void 0 ? void 0 : (_this$$refs6$table_re = _this$$refs6.table_responsive) === null || _this$$refs6$table_re === void 0 ? void 0 : _this$$refs6$table_re.offsetWidth;
        if (((_this$headerElement = this.headerElement) === null || _this$headerElement === void 0 ? void 0 : (_this$headerElement$s = _this$headerElement.style) === null || _this$headerElement$s === void 0 ? void 0 : _this$headerElement$s.overflowY) === 'scroll') {
          width -= 14;
        }
        footerElement.style.width = "".concat(width, "px");
      }
    },
    setScrollFooter: function setScrollFooter() {
      var _this$$refs7, _this$$refs7$table_re, _this$$refs8, _this$$refs8$table_re;
      var footerElement = document.querySelector("#".concat(this.props.opts.uniqueIdHeader, "__footer"));
      if (footerElement) {
        footerElement.style.bottom = '0px';
      }
      if (((_this$$refs7 = this.$refs) === null || _this$$refs7 === void 0 ? void 0 : (_this$$refs7$table_re = _this$$refs7.table_responsive) === null || _this$$refs7$table_re === void 0 ? void 0 : _this$$refs7$table_re.scrollWidth) > ((_this$$refs8 = this.$refs) === null || _this$$refs8 === void 0 ? void 0 : (_this$$refs8$table_re = _this$$refs8.table_responsive) === null || _this$$refs8$table_re === void 0 ? void 0 : _this$$refs8$table_re.offsetWidth)) {
        if (footerElement) {
          footerElement.style.bottom = '14px';
        }
      }
    },
    setSizeTotalsRow: function setSizeTotalsRow() {
      this.setScrollHorizontalFooter();
      this.setScrollFooter();
    },
    addListeners: function addListeners() {
      this.$refs.table_responsive.addEventListener('scroll', this.setClassShadow);
      window.addEventListener('resize', this.setSizeTotalsRow);
      global.vtEvent.$on('vue-tables.select', this.onSelect);
      global.vtEvent.$on('aq-table.visible', this.onVisibleChange);
      global.vtEvent.$on('aq-table.toggleShowColumn', this.toggleShowColumn);
      global.vtEvent.$on('aq-table.setColumns', this.setColumns);
      global.vtEvent.$on('aq-table.alignScroll', this.setClassShadow); // alignScroll?
      global.vtEvent.$on('aq-table.scrollHeader', this.setScrollHeader);
      global.vtEvent.$on('aq-table.dataLoaded', this.onDataLoaded);
      global.vtEvent.$on('aq-table.setHeader', this.setHeader);
      global.vtEvent.$on("vue-tables".concat(this.tableName, ".loading"), this.changeIsLoadingStatus(true));
      global.vtEvent.$on("vue-tables".concat(this.tableName, ".loaded"), this.changeIsLoadingStatus(false));
      global.vtEvent.$on('aq-table.totalRowsMounted', this.updateScrollFooter);
      this.resizeObserver.observe(document.querySelector("#table-".concat(this.props.opts.uniqueIdHeader)));
    },
    rmListeners: function rmListeners() {
      this.$refs.table_responsive.removeEventListener('scroll', this.setClassShadow);
      window.removeEventListener('resize', this.setSizeTotalsRow);
      global.vtEvent.$off('vue-tables.select', this.onSelect);
      global.vtEvent.$off('aq-table.visible', this.onVisibleChange);
      global.vtEvent.$off('aq-table.toggleShowColumn', this.toggleShowColumn);
      global.vtEvent.$off('aq-table.setColumns', this.setColumns);
      global.vtEvent.$off('aq-table.alignScroll', this.setClassShadow);
      global.vtEvent.$off('aq-table.scrollHeader', this.setScrollHeader);
      global.vtEvent.$off('aq-table.dataLoaded', this.onDataLoaded);
      global.vtEvent.$off('aq-table.setHeader', this.setHeader);
      global.vtEvent.$off("vue-tables".concat(this.tableName, ".loading"), this.changeIsLoadingStatus(true));
      global.vtEvent.$off("vue-tables".concat(this.tableName, ".loaded"), this.changeIsLoadingStatus(false));
      global.vtEvent.$off('aq-table.totalRowsMounted', this.updateScrollFooter);
      this.resizeObserver.disconnect();
    },
    onVisibleChange: function onVisibleChange(_ref) {
      var data = _ref.data,
        id = _ref.id;
      if (this.compareId(id)) {
        this.searchVisible = data;
      }
    },
    onSelect: function onSelect() {
      this.selected = this.$parent.selectedRows;
    },
    toggleShowColumn: function toggleShowColumn(_ref2) {
      var id = _ref2.id;
      this.setStylesHeader();
      if (this.compareId(id)) {
        this.setScrollFooter();
      }
    },
    cancelSelected: function cancelSelected() {
      this.$parent.resetSelectedRows();
      this.$parent.toggleAllRows({
        target: {
          checked: false
        }
      });
    },
    setColumns: function setColumns(_ref3) {
      var data = _ref3.data,
        id = _ref3.id;
      if (this.compareId(id)) {
        var temp1 = [].concat(_toConsumableArray$1(data), _toConsumableArray$1(this.$parent.columns));
        var temp2 = temp1.filter(function (item, pos) {
          return temp1.indexOf(item) === pos;
        });
        if (this.props.opts.setColumns) {
          if (!this.props.opts.aqua) {
            this.props.opts.aqua = {};
          }
          this.props.opts.aqua.columsOrder = temp2;
          this.props.opts.setColumns(temp2);
        }
        setTimeout(function () {
          global.vtEvent.$emit('aq-table.changeWidth');
        });
      }
    },
    onDataLoaded: function onDataLoaded(_ref4) {
      var _this2 = this;
      var data = _ref4.data,
        id = _ref4.id;
      this.setIdHeader();
      if ((data === null || data === void 0 ? void 0 : data.length) > 0 && this.compareId(id)) {
        var _this$headerElement2;
        if ((_this$headerElement2 = this.headerElement) !== null && _this$headerElement2 !== void 0 && _this$headerElement2.style) {
          this.headerElement.style.position = 'absolute';
        }
        this.loaded = true;
        setTimeout(function () {
          _this2.setStylesHeader();
          _this2.setScrollFooter();
          _this2.setStylesFooter();
          global.vtEvent.$emit('aq-table.changeWidth');
        });
      }
    },
    setIdHeader: function setIdHeader() {
      var _this3 = this;
      if (!this.props.opts.uniqueIdHeader) {
        this.props.opts.uniqueIdHeader = AquaRamdomId('-data-table');
        this.setHeaderElement();
        setTimeout(function () {
          if (_this3.loaded) {
            var _this3$headerElement;
            _this3.setStylesHeader();
            if ((_this3$headerElement = _this3.headerElement) !== null && _this3$headerElement !== void 0 && _this3$headerElement.style) {
              _this3.headerElement.style.position = 'absolute';
            }
            setTimeout(function () {
              _this3.setStylesHeader();
              _this3.setScrollFooter();
              _this3.setStylesFooter();
            });
          }
        });
      }
    },
    compareId: function compareId(id) {
      return this.props.opts.uniqueIdHeader === id;
    },
    setHeader: function setHeader() {
      var _this4 = this;
      setTimeout(function () {
        global.vtEvent.$emit('aq-table.changeWidth');
        _this4.setStylesHeader();
        _this4.setScrollHeader();
      });
    },
    validateHeader: function validateHeader() {
      this.setIdHeader();
      this.setHeaderElement();
    },
    changeIsLoadingStatus: function changeIsLoadingStatus(status) {
      var _this5 = this;
      return function () {
        setTimeout(function () {
          global.vtEvent.$emit('aq-table.isLoading', {
            value: status,
            id: _this5.props.opts.uniqueIdHeader
          });
          if (status) {
            _this5.setScrollHeader();
            _this5.setScrollFooter();
          }
        });
      };
    },
    createResizeListener: function createResizeListener() {
      var emitResize = function emitResize() {
        return global.vtEvent.$emit('aq-table.setWidthHeader');
      };
      this.resizeObserver = new index(lodash_debounce(emitResize, 30));
    },
    updateScrollFooter: function updateScrollFooter(_ref5) {
      var id = _ref5.id;
      if (this.compareId(id)) {
        this.setScrollFooter();
      }
    }
  },
  created: function created() {
    this.setIdHeader();
  },
  mounted: function mounted() {
    var _this6 = this;
    if (typeof this.$parent.name !== 'undefined') {
      this.tableName = ".".concat(this.$parent.name);
    }
    this.setIdHeader();
    if (!this.props.opts.aqua) {
      this.props.opts.aqua = {};
    }
    this.setHeaderElement();
    this.setStylesHeader();
    setTimeout(function () {
      _this6.setStylesHeader();
    });
    this.createResizeListener();
    this.addListeners();
    this.onSelect(this.$parent.selectedRows);
  },
  beforeDestroy: function beforeDestroy() {
    this.rmListeners();
  }
};

/* script */
var __vue_script__$1t = script$1t;

/* template */
var __vue_render__$1t = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: "aq-table-general-container VueTables VueTables--" + _vm.props.source,
    attrs: {
      "id": 'table-' + _vm.props.opts.uniqueIdHeader
    }
  }, [_c('div', {
    class: ['aq-table__top-options', {
      'aq-table__top-options--search-visible': _vm.searchVisible
    }]
  }, [_c('div', {
    staticClass: "aq-table__top-options-left-content"
  }, [_c('div', {
    class: [{
      'aq-table__title': _vm.props.opts.title
    }]
  }, [_vm.props.opts.title ? _c('aq-subheading', {
    attrs: {
      "info": _vm.getInfoTitle,
      "tooltipWidth": _vm.getTooltipWidth
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$aqT(_vm.props.opts.title)) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.numberSelected > 0,
      expression: "numberSelected > 0"
    }],
    staticClass: "aq-table__top-options-selections"
  }, [_c('aq-tag', {
    attrs: {
      "text": _vm.textTag,
      "close": ""
    },
    on: {
      "close": function close($event) {
        return _vm.cancelSelected();
      }
    }
  }), _vm._v(" "), [_c('vnodes', {
    attrs: {
      "vnodes": _vm.props.slots.selectionOptions
    }
  })]], 2), _vm._v(" "), _vm.showDividerToolbar ? _c('aq-divider', {
    attrs: {
      "orientation": "vertical"
    }
  }) : _vm._e(), _vm._v(" "), _c('vnodes', {
    attrs: {
      "vnodes": _vm.props.slots.beforeTable
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "aq-table__top-options-table"
  }, [_c('div'), _vm._v(" "), _c('div', {
    staticClass: "aq-table__top-options-filters"
  }, [!_vm.props.opts.filterByColumn && _vm.props.opts.filterable ? _c('vt-generic-filter', {
    ref: "genericFilter"
  }) : _vm._e(), _vm._v(" "), _c('vnodes', {
    attrs: {
      "vnodes": _vm.props.slots.beforeColumnsDropdown
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.props.opts.columnsDropdown,
      expression: "props.opts.columnsDropdown"
    }],
    class: "VueTables__columns-dropdown-wrapper " + _vm.props.theme.right + " " + _vm.props.theme.dropdown.container
  }, [_c('vt-columns-dropdown')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "aq-table__top-options-export"
  }, [_c('vnodes', {
    attrs: {
      "vnodes": _vm.props.slots.headerRight
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "aq-table__relative-container"
  }, [_c('div', {
    ref: "table_responsive",
    class: ['table-responsive aq-scroll-bar', {
      'aq-table-shadow': _vm.classActive
    }],
    style: _vm.style
  }, [_c('vt-table', {
    ref: "vt_table"
  }), _vm._v(" "), _vm.props.opts.pagination.virtual && !_vm.props.loading ? _c('observer', {
    on: {
      "intersect": function intersect($event) {
        return _vm.props.setPage(_vm.props.page + 1);
      }
    }
  }) : _vm._e()], 1)]), _vm._v(" "), !_vm.props.opts.pagination.virtual && _vm.props.opts.pagination.show ? _c('vt-pagination') : _vm._e()], 1);
};
var __vue_staticRenderFns__$1t = [];

/* style */
var __vue_inject_styles__$1t = undefined;
/* scoped */
var __vue_scope_id__$1t = undefined;
/* module identifier */
var __vue_module_identifier__$1t = undefined;
/* functional template */
var __vue_is_functional_template__$1t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1t = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1t,
  staticRenderFns: __vue_staticRenderFns__$1t
}, __vue_inject_styles__$1t, __vue_script__$1t, __vue_scope_id__$1t, __vue_is_functional_template__$1t, __vue_module_identifier__$1t, false, undefined, undefined, undefined);
var DataTable = __vue_component__$1t;

//
var script$1s = {
  name: 'MyTableHead',
  props: ['props'],
  components: {
    VtHeadingsRow: VtHeadingsRow,
    VtFiltersRow: VtFiltersRow,
    vnodes: {
      functional: true,
      render: function render(h, ctx) {
        return ctx.props.vnodes;
      }
    }
  }
};

/* script */
var __vue_script__$1s = script$1s;

/* template */
var __vue_render__$1s = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('thead', {
    staticClass: "aq-table-heading aq-scroll-bar--wo-color",
    attrs: {
      "id": _vm.props.opts.uniqueIdHeader
    }
  }, [_c('vnodes', {
    attrs: {
      "vnodes": _vm.props.slots.prependHead
    }
  }), _vm._v(" "), _c('vt-headings-row'), _vm._v(" "), _c('vnodes', {
    attrs: {
      "vnodes": _vm.props.slots.beforeFilters
    }
  }), _vm._v(" "), _vm.props.opts.filterByColumn && _vm.props.opts.filterable ? _c('vt-filters-row') : _vm._e(), _vm._v(" "), _c('vnodes', {
    attrs: {
      "vnodes": _vm.props.slots.afterFilters
    }
  })], 1);
};
var __vue_staticRenderFns__$1s = [];

/* style */
var __vue_inject_styles__$1s = undefined;
/* scoped */
var __vue_scope_id__$1s = undefined;
/* module identifier */
var __vue_module_identifier__$1s = undefined;
/* functional template */
var __vue_is_functional_template__$1s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1s = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1s,
  staticRenderFns: __vue_staticRenderFns__$1s
}, __vue_inject_styles__$1s, __vue_script__$1s, __vue_scope_id__$1s, __vue_is_functional_template__$1s, __vue_module_identifier__$1s, false, undefined, undefined, undefined);
var TableHead = __vue_component__$1s;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$1r = {
  name: 'MyPerPageSelector',
  props: ['props']
};

/* script */
var __vue_script__$1r = script$1r;

/* template */
var __vue_render__$1r = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "VueTables__limit-field"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('aqua.itemsPerPage')))]), _vm._v(" "), _c('aq-dropdown', {
    attrs: {
      "closeOnClick": ""
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_c('aq-dropdown-content', _vm._l(_vm.props.perPageValues, function (val) {
          return _c('aq-dropdown-item', {
            key: val,
            on: {
              "click": function click($event) {
                return _vm.props.selectEvents.change(val);
              }
            }
          }, [_vm._v("\n          " + _vm._s(val) + "\n        ")]);
        }), 1)];
      },
      proxy: true
    }])
  }, [_c('template', {
    slot: "activator"
  }, [_c('aq-button', {
    attrs: {
      "disclosure": "",
      "outline": ""
    }
  }, [_vm._v(_vm._s(_vm.props.selectAttrs.value))])], 1)], 2)], 1);
};
var __vue_staticRenderFns__$1r = [];

/* style */
var __vue_inject_styles__$1r = undefined;
/* scoped */
var __vue_scope_id__$1r = undefined;
/* module identifier */
var __vue_module_identifier__$1r = undefined;
/* functional template */
var __vue_is_functional_template__$1r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1r = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1r,
  staticRenderFns: __vue_staticRenderFns__$1r
}, __vue_inject_styles__$1r, __vue_script__$1r, __vue_scope_id__$1r, __vue_is_functional_template__$1r, __vue_module_identifier__$1r, false, undefined, undefined, undefined);
var PerPageSelector = __vue_component__$1r;

//
var script$1q = {
  name: 'MyGenericFilter',
  props: ['props'],
  data: function data() {
    return {
      visible: false,
      search: '',
      keyEvent: null,
      searchFunction: null,
      autocomplete: 'nope'
    };
  },
  methods: {
    focus: function focus() {
      this.$refs.filter.focus();
    },
    blur: function blur() {
      this.$refs.filter.blur();
    },
    keyUp: function keyUp(e) {
      this.keyEvent = e;
      this.props.search(0)(e);
    },
    setSearchFunction: function setSearchFunction() {
      var _this$props, _this$props$opts, _this$props2, _this$props2$opts;
      var timeDebounce = (_this$props = this.props) !== null && _this$props !== void 0 && (_this$props$opts = _this$props.opts) !== null && _this$props$opts !== void 0 && _this$props$opts.debounce ? (_this$props2 = this.props) === null || _this$props2 === void 0 ? void 0 : (_this$props2$opts = _this$props2.opts) === null || _this$props2$opts === void 0 ? void 0 : _this$props2$opts.debounce : 0;
      this.searchFunction = lodash_debounce(this.keyUp, timeDebounce);
    },
    setVisible: function setVisible() {
      this.visible = !this.visible;
      global.vtEvent.$emit('aq-table.visible', {
        data: this.visible,
        id: this.props.opts.uniqueIdHeader
      });
    },
    resetSearch: function resetSearch() {
      var _this = this;
      this.search = '';
      this.props.query = '';
      if (this.keyEvent !== null) {
        this.props.search(this.props.opts.debounce)(this.keyEvent);
      }
      setTimeout(function () {
        _this.setVisible();
      });
    }
  },
  created: function created() {
    this.setSearchFunction();
  }
};

/* script */
var __vue_script__$1q = script$1q;

/* template */
var __vue_render__$1q = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "VueTables__search-field aq-table__search-field"
  }, [_c('aq-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    ref: "filter",
    staticClass: "aq-table__search-field__field",
    attrs: {
      "placeholder": _vm.props.display('filterPlaceholder'),
      "id": "VueTables__search_" + _vm.props.id,
      "autocomplete": _vm.autocomplete,
      "disclosure": "",
      "icon-disclosure": "aq-icon-close"
    },
    on: {
      "keyup": function keyup(e) {
        return _vm.searchFunction(e);
      },
      "clickDisclosure": _vm.resetSearch
    },
    scopedSlots: _vm._u([{
      key: "sublabel",
      fn: function fn() {
        return [_c('em', {
          staticClass: "aq-icon-search"
        })];
      },
      proxy: true
    }]),
    model: {
      value: _vm.search,
      callback: function callback($$v) {
        _vm.search = $$v;
      },
      expression: "search"
    }
  }), _vm._v(" "), !_vm.visible ? _c('aq-button', {
    attrs: {
      "icon": "aq-icon-search",
      "plain": ""
    },
    on: {
      "click": _vm.setVisible
    }
  }) : _vm._e()], 1);
};
var __vue_staticRenderFns__$1q = [];

/* style */
var __vue_inject_styles__$1q = undefined;
/* scoped */
var __vue_scope_id__$1q = undefined;
/* module identifier */
var __vue_module_identifier__$1q = undefined;
/* functional template */
var __vue_is_functional_template__$1q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1q = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1q,
  staticRenderFns: __vue_staticRenderFns__$1q
}, __vue_inject_styles__$1q, __vue_script__$1q, __vue_scope_id__$1q, __vue_is_functional_template__$1q, __vue_module_identifier__$1q, false, undefined, undefined, undefined);
var GenericFilter = __vue_component__$1q;

//
var script$1p = {
  name: 'MyTableRow',
  props: ['props'],
  components: {
    VtTableCell: VtTableCell,
    VtChildRowToggler: VtChildRowToggler,
    VtRowSelector: VtRowSelector
  },
  data: function data() {
    return {
      isFirstRow: false
    };
  },
  watch: {
    'props.columns': {
      handler: function handler() {
        this.getFirst();
      }
    }
  },
  methods: {
    getFirst: function getFirst() {
      this.isFirstRow = this.$parent.$parent.$parent.$el.firstElementChild.isSameNode(this.$parent.$parent.$el);
    }
  },
  mounted: function mounted() {
    this.getFirst();
  }
};

/* script */
var __vue_script__$1p = script$1p;

/* template */
var __vue_render__$1p = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('tr', _vm._b({
    class: "VueTables__row " + _vm.props.rowAttrs.class,
    on: {
      "click": _vm.props.rowEvents.click
    }
  }, 'tr', _vm.props.rowAttrs.attrs, false), [_vm.props.selectable ? _c('vt-row-selector') : _vm._e(), _vm._v(" "), _vm.props.childRowTogglerFirst ? _c('vt-child-row-toggler', {
    attrs: {
      "row-id": _vm.props.rowId
    }
  }) : _vm._e(), _vm._v(" "), _vm._l(_vm.props.columns, function (column, i) {
    return _c('vt-table-cell', {
      key: i,
      attrs: {
        "column": column,
        "rowId": _vm.props.rowId,
        "firstRow": _vm.isFirstRow
      }
    });
  }), _vm._v(" "), _vm.props.childRowTogglerLast ? _c('vt-child-row-toggler', {
    attrs: {
      "row-id": _vm.props.rowId
    }
  }) : _vm._e()], 2);
};
var __vue_staticRenderFns__$1p = [];

/* style */
var __vue_inject_styles__$1p = undefined;
/* scoped */
var __vue_scope_id__$1p = undefined;
/* module identifier */
var __vue_module_identifier__$1p = undefined;
/* functional template */
var __vue_is_functional_template__$1p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1p = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1p,
  staticRenderFns: __vue_staticRenderFns__$1p
}, __vue_inject_styles__$1p, __vue_script__$1p, __vue_scope_id__$1p, __vue_is_functional_template__$1p, __vue_module_identifier__$1p, false, undefined, undefined, undefined);
var TableRow = __vue_component__$1p;

//
var script$1o = {
  name: 'MyTableBody',
  props: ['props'],
  data: function data() {
    return {
      isLoading: false,
      notResultKey: 0
    };
  },
  components: {
    VtNoResultsRow: VtNoResultsRow,
    VtTableRow: VtTableRow,
    //eslint-disable-line
    VtChildRow: VtChildRow,
    //eslint-disable-line
    vnodes: {
      functional: true,
      render: function render(h, ctx) {
        return ctx.props.vnodes;
      }
    },
    TableRows: {
      functional: true,
      render: function render(h, ctx) {
        var props = ctx.data.attrs;
        // TODO: add group row
        var data = [h('vt-table-row', {
          props: props
        })];
        if (props.renderChildRow) {
          data.push(h('vt-child-row', {
            props: props
          }));
        }
        return data;
      }
    }
  },
  watch: {
    'props.data': {
      handler: function handler() {
        this.setScrollHeader();
        this.setPositionHeader();
      }
    }
  },
  methods: {
    setWidthTemp: function setWidthTemp() {
      global.vtEvent.$emit('aq-table.changeWidth');
    },
    setScrollHeader: function setScrollHeader() {
      global.vtEvent.$emit('aq-table.scrollHeader');
    },
    setPositionHeader: function setPositionHeader() {
      global.vtEvent.$emit('aq-table.dataLoaded', {
        data: this.props.data,
        id: this.props.opts.uniqueIdHeader
      });
    },
    addListeners: function addListeners() {
      window.addEventListener('resize', this.setWidthTemp);
      global.vtEvent.$on('aq-table.toggleShowColumn', this.toggleShowColumn);
      global.vtEvent.$on('aq-table.isLoading', this.changeIsLoadingStatus);
    },
    rmListeners: function rmListeners() {
      window.removeEventListener('resize', this.setWidthTemp);
      global.vtEvent.$off('aq-table.toggleShowColumn', this.toggleShowColumn);
      global.vtEvent.$off('aq-table.isLoading', this.changeIsLoadingStatus);
    },
    toggleShowColumn: function toggleShowColumn() {
      var _this = this;
      setTimeout(function () {
        _this.setWidthTemp();
      });
    },
    changeIsLoadingStatus: function changeIsLoadingStatus(_ref) {
      var value = _ref.value,
        id = _ref.id;
      if (id === this.props.opts.uniqueIdHeader && value !== this.isLoading) {
        this.isLoading = value;
        this.props.opts.isLoading = value;
        this.notResultKey += 1;
      }
    }
  },
  computed: {
    getPropsLength: function getPropsLength() {
      var _this$props, _this$props$data;
      return (_this$props = this.props) === null || _this$props === void 0 ? void 0 : (_this$props$data = _this$props.data) === null || _this$props$data === void 0 ? void 0 : _this$props$data.length;
    }
  },
  created: function created() {
    this.setWidthTemp();
  },
  mounted: function mounted() {
    var _this2 = this;
    this.addListeners();
    this.setWidthTemp();
    this.setPositionHeader();
    setTimeout(function () {
      _this2.setPositionHeader();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.rmListeners();
  }
};

/* script */
var __vue_script__$1o = script$1o;

/* template */
var __vue_render__$1o = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('tbody', [_c('vnodes', {
    attrs: {
      "vnodes": _vm.props.slots.prependBody
    }
  }), _vm._v(" "), _vm.getPropsLength === 0 || _vm.isLoading ? _c('vt-no-results-row', {
    key: _vm.notResultKey
  }) : _vm._e(), _vm._v(" "), !_vm.isLoading ? _vm._l(_vm.props.data, function (row, index) {
    return _c('table-rows', {
      key: index,
      attrs: {
        "row": row,
        "index": _vm.props.initialIndex + index + 1,
        "renderChildRow": _vm.props.hasChildRow && _vm.props.openChildRows.includes(row[_vm.props.uniqueRowId])
      }
    });
  }) : _vm._e(), _vm._v(" "), !_vm.isLoading ? _c('vnodes', {
    attrs: {
      "vnodes": _vm.props.slots.appendBody
    }
  }) : _vm._e()], 2);
};
var __vue_staticRenderFns__$1o = [];

/* style */
var __vue_inject_styles__$1o = undefined;
/* scoped */
var __vue_scope_id__$1o = undefined;
/* module identifier */
var __vue_module_identifier__$1o = undefined;
/* functional template */
var __vue_is_functional_template__$1o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1o = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1o,
  staticRenderFns: __vue_staticRenderFns__$1o
}, __vue_inject_styles__$1o, __vue_script__$1o, __vue_scope_id__$1o, __vue_is_functional_template__$1o, __vue_module_identifier__$1o, false, undefined, undefined, undefined);
var TableBody = __vue_component__$1o;

//
//
//
//
//
//
//
//
//
//
//

var script$1n = {
  name: 'MyChildRowToggler',
  props: ['props']
};

/* script */
var __vue_script__$1n = script$1n;

/* template */
var __vue_render__$1n = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('td', {
    staticClass: "aq-table__child-row-body",
    attrs: {
      "tabindex": _vm.props.tabIndex
    },
    on: {
      "keypress": function keypress($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }
        return _vm.props.toggle.apply(null, arguments);
      },
      "click": _vm.props.toggle
    }
  }, [_c('em', {
    class: "VueTables__child-row-toggler aq-icon-chevron-down " + _vm.props.class()
  })]);
};
var __vue_staticRenderFns__$1n = [];

/* style */
var __vue_inject_styles__$1n = undefined;
/* scoped */
var __vue_scope_id__$1n = undefined;
/* module identifier */
var __vue_module_identifier__$1n = undefined;
/* functional template */
var __vue_is_functional_template__$1n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1n = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1n,
  staticRenderFns: __vue_staticRenderFns__$1n
}, __vue_inject_styles__$1n, __vue_script__$1n, __vue_scope_id__$1n, __vue_is_functional_template__$1n, __vue_module_identifier__$1n, false, undefined, undefined, undefined);
var ChildRowToggler = __vue_component__$1n;

//
//
//
//
//
//
//
//
//
//
//

var script$1m = {
  name: 'MyVtRowSelector',
  props: ['props'],
  data: function data() {
    return {
      test: null,
      check: false
    };
  },
  watch: {
    'props.selected': {
      handler: function handler() {
        this.setValue();
      }
    }
  },
  methods: {
    click: function click(event, row, index, disabled) {
      this.props.toggleRow(event, row, index, disabled);
    },
    setValue: function setValue() {
      var _this = this;
      setTimeout(function () {
        _this.check = _this.props.selected;
      });
    }
  },
  mounted: function mounted() {
    this.setValue();
  }
};

/* script */
var __vue_script__$1m = script$1m;

/* template */
var __vue_render__$1m = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('td', {
    class: "VueTables__select-row VueTables__select-single aq-table__row-selector " + _vm.props.tdClass,
    on: {
      "click": function click($event) {
        return _vm.click($event, _vm.props.row, _vm.props.index, _vm.props.disabled);
      }
    }
  }, [_c('div', {
    staticClass: "aq-table__row-selector-check"
  }, [_c('aq-checkbox', {
    attrs: {
      "disabled": _vm.props.disabled
    },
    model: {
      value: _vm.check,
      callback: function callback($$v) {
        _vm.check = $$v;
      },
      expression: "check"
    }
  })], 1)]);
};
var __vue_staticRenderFns__$1m = [];

/* style */
var __vue_inject_styles__$1m = undefined;
/* scoped */
var __vue_scope_id__$1m = "data-v-6e52cd39";
/* module identifier */
var __vue_module_identifier__$1m = undefined;
/* functional template */
var __vue_is_functional_template__$1m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1m = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1m,
  staticRenderFns: __vue_staticRenderFns__$1m
}, __vue_inject_styles__$1m, __vue_script__$1m, __vue_scope_id__$1m, __vue_is_functional_template__$1m, __vue_module_identifier__$1m, false, undefined, undefined, undefined);
var RowSelector = __vue_component__$1m;

//
//
//
//
//
//

var script$1l = {
  props: {
    checked: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: [String, Function],
      default: function _default() {
        return '';
      }
    }
  },
  watch: {
    checked: function checked() {
      this.check = this.checked;
    }
  },
  data: function data() {
    return {
      check: false
    };
  },
  methods: {
    click: function click() {
      var _this = this;
      setTimeout(function () {
        _this.check = _this.checked;
      });
    }
  },
  mounted: function mounted() {
    this.check = this.checked;
  }
};

/* script */
var __vue_script__$1l = script$1l;

/* template */
var __vue_render__$1l = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('span', [_c('aq-checkbox', {
    attrs: {
      "disabled": _vm.disabled,
      "label": _vm.label
    },
    on: {
      "click": function click($event) {
        return _vm.click($event);
      }
    },
    model: {
      value: _vm.check,
      callback: function callback($$v) {
        _vm.check = $$v;
      },
      expression: "check"
    }
  })], 1);
};
var __vue_staticRenderFns__$1l = [];

/* style */
var __vue_inject_styles__$1l = undefined;
/* scoped */
var __vue_scope_id__$1l = undefined;
/* module identifier */
var __vue_module_identifier__$1l = undefined;
/* functional template */
var __vue_is_functional_template__$1l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1l = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1l,
  staticRenderFns: __vue_staticRenderFns__$1l
}, __vue_inject_styles__$1l, __vue_script__$1l, __vue_scope_id__$1l, __vue_is_functional_template__$1l, __vue_module_identifier__$1l, false, undefined, undefined, undefined);
var CustomCheck = __vue_component__$1l;

//
var script$1k = {
  name: 'MyColumnsDropdown',
  props: ['props'],
  components: {
    CustomCheck: CustomCheck
  },
  methods: {
    toggleColumn: function toggleColumn(column) {
      global.vtEvent.$emit('aq-table.toggleShowColumn', {
        id: this.props.opts.uniqueIdHeader
      });
      this.props.toggleColumn(column);
      this.setColumns();
    },
    getHeading: function getHeading(column) {
      var _this$props$opts;
      var heading = column;
      if ((_this$props$opts = this.props.opts) !== null && _this$props$opts !== void 0 && _this$props$opts.headings[column]) {
        heading = this.props.opts.headings[column];
      }
      return heading;
    },
    setColumns: function setColumns() {
      var _this = this;
      this.setColumnsNow();
      setTimeout(function () {
        _this.setColumnsNow();
      });
    },
    setColumnsNow: function setColumnsNow() {
      if (!this.props.opts.aqua) {
        this.props.opts.aqua = {};
      }
      this.props.opts.aqua.columns = this.props.columns;
    }
  },
  mounted: function mounted() {
    this.setColumns();
  }
};

/* script */
var __vue_script__$1k = script$1k;

/* template */
var __vue_render__$1k = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "VueTables__columns-dropdown-wrapper"
  }, [_c('div', {
    class: "VueTables__columns-dropdown"
  }, [_c('aq-dropdown', {
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn() {
        return [_c('aq-button', {
          attrs: {
            "icon": "aq-icon-table",
            "plain": ""
          }
        })];
      },
      proxy: true
    }, {
      key: "content",
      fn: function fn() {
        return [_c('aq-dropdown-content', _vm._l(_vm.props.origColumns, function (column, i) {
          return _c('aq-dropdown-item', {
            key: i,
            on: {
              "click": function click($event) {
                return _vm.toggleColumn(column);
              }
            }
          }, [_c('custom-check', {
            attrs: {
              "checked": _vm.props.columns.includes(column),
              "disabled": _vm.props.onlyColumn(column),
              "label": _vm.getHeading(column)
            }
          })], 1);
        }), 1)];
      },
      proxy: true
    }])
  }, [_vm._v(" "), _vm._v(" "), void 0], 2)], 1)]);
};
var __vue_staticRenderFns__$1k = [];

/* style */
var __vue_inject_styles__$1k = undefined;
/* scoped */
var __vue_scope_id__$1k = undefined;
/* module identifier */
var __vue_module_identifier__$1k = undefined;
/* functional template */
var __vue_is_functional_template__$1k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1k = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1k,
  staticRenderFns: __vue_staticRenderFns__$1k
}, __vue_inject_styles__$1k, __vue_script__$1k, __vue_scope_id__$1k, __vue_is_functional_template__$1k, __vue_module_identifier__$1k, false, undefined, undefined, undefined);
var ColumnsDropdown = __vue_component__$1k;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$1j = {
  name: 'MyNoResultsRow',
  props: ['props'],
  data: function data() {
    return {
      key: 1
    };
  },
  watch: {
    'props.opts.texts.noResults': {
      type: {
        handler: function handler() {
          this.key += 1;
        },
        deep: true
      }
    }
  },
  computed: {
    isNoRequest: function isNoRequest() {
      return !this.props.opts.initialRequestSent ? 'noRequest' : 'noResults';
    }
  },
  methods: {
    display: function display(text, replacements) {
      var aux = text;
      if (!this.props.opts.texts) return '';
      if (this.props.opts.message) {
        aux = this.props.opts.message;
      } else {
        aux = this.isNoRequest === 'noRequest' ? this.props.opts.texts.noRequest : this.props.opts.texts.noResults;
      }
      if (replacements) {
        Object.keys(replacements).forEach(function (key) {
          aux = text.replace("{".concat(key, "}"), replacements[key]);
        });
      }
      return aux;
    }
  }
};

/* script */
var __vue_script__$1j = script$1j;

/* template */
var __vue_render__$1j = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('tr', {
    key: _vm.key,
    staticClass: "VueTables__no-results aq-table__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "tabindex": _vm.props.tabIndex,
      "colspan": _vm.props.colspan
    }
  }, [_vm.props.opts.isLoading ? _c('div', [_c('span', [_vm._v("\n        " + _vm._s(_vm.$t(_vm.$aqT(_vm.props.opts.loadingMessage)) || 'Loading data') + "\n      ")])]) : _c('div', [_vm.props.opts.texts.noResults ? _c('span', [_vm._v("\n        " + _vm._s(_vm.props.opts.initialRequestSent ? _vm.$t(_vm.$aqT(_vm.props.opts.texts.noResults)) : '') + "\n      ")]) : _vm._e(), _vm._v(" "), _vm.props.opts.texts.noRequest ? _c('span', [_vm._v("\n        " + _vm._s(!_vm.props.opts.initialRequestSent ? _vm.$t(_vm.$aqT(_vm.props.opts.texts.noRequest)) : '') + "\n      ")]) : _vm._e(), _vm._v(" "), _vm.props.opts.message ? _c('span', [_vm._v("\n        " + _vm._s(_vm.$t(_vm.$aqT(_vm.display(_vm.props.message)))) + "\n      ")]) : _vm._e()])])]);
};
var __vue_staticRenderFns__$1j = [];

/* style */
var __vue_inject_styles__$1j = undefined;
/* scoped */
var __vue_scope_id__$1j = undefined;
/* module identifier */
var __vue_module_identifier__$1j = undefined;
/* functional template */
var __vue_is_functional_template__$1j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1j = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1j,
  staticRenderFns: __vue_staticRenderFns__$1j
}, __vue_inject_styles__$1j, __vue_script__$1j, __vue_scope_id__$1j, __vue_is_functional_template__$1j, __vue_module_identifier__$1j, false, undefined, undefined, undefined);
var NoResultsRow = __vue_component__$1j;

var eventsMixin = {
  methods: {
    onClick: function onClick(event) {
      this.$emit('click', event);
    },
    onClickSelf: function onClickSelf(event) {
      this.$emit('click.self', event);
    },
    onClickStop: function onClickStop(event) {
      this.$emit('click.stop', event);
    }
  }
};

//
var script$1i = {
  name: 'aq-card',
  mixins: [sizeMixin, eventsMixin],
  props: {
    img: {
      type: String,
      default: ''
    },
    lazyImg: {
      type: String,
      default: 'https://masivapp-public-resources.s3.amazonaws.com/img/general/default_image.svg'
    },
    isLazy: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      localImage: ''
    };
  },
  watch: {
    img: function img(newVal) {
      this.localImage = newVal || this.lazyImg;
    }
  },
  computed: {
    imageVisible: function imageVisible() {
      var _this$localImage;
      return ((_this$localImage = this.localImage) === null || _this$localImage === void 0 ? void 0 : _this$localImage.length) > 0;
    }
  },
  methods: {
    onMouseDown: function onMouseDown() {
      this.$el.classList.add('aq-card--selected');
    },
    onMouseUp: function onMouseUp() {
      var elementClass = this.$el.classList;
      if (elementClass.contains('aq-card--selected')) {
        this.$el.classList.remove('aq-card--selected');
      }
    },
    hover: function hover() {
      this.$emit('hover');
    },
    leave: function leave() {
      var elementClass = this.$el.classList;
      if (elementClass.contains('aq-card--selected')) {
        this.$el.classList.remove('aq-card--selected');
      }
      this.$emit('leave');
    },
    loadImage: function loadImage() {
      if (this.isLazy) {
        this.localImage = this.img || this.lazyImg;
      }
    }
  },
  mounted: function mounted() {
    if (this.isLazy) {
      this.localImage = this.lazyImg;
    } else {
      this.localImage = this.img;
    }
  }
};

/* script */
var __vue_script__$1i = script$1i;

/* template */
var __vue_render__$1i = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-card",
    style: _vm.mixinSizeStyle,
    on: {
      "click": [_vm.onClick, function ($event) {
        if ($event.target !== $event.currentTarget) {
          return null;
        }
        return _vm.onClickSelf.apply(null, arguments);
      }],
      "mousedown": _vm.onMouseDown,
      "mouseup": _vm.onMouseUp,
      "mouseover": _vm.hover,
      "mouseleave": _vm.leave
    }
  }, [_vm.imageVisible ? _c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: _vm.loadImage,
      expression: "loadImage"
    }],
    staticClass: "aq-card__image",
    attrs: {
      "src": _vm.localImage,
      "alt": "image-card"
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2);
};
var __vue_staticRenderFns__$1i = [];

/* style */
var __vue_inject_styles__$1i = undefined;
/* scoped */
var __vue_scope_id__$1i = undefined;
/* module identifier */
var __vue_module_identifier__$1i = undefined;
/* functional template */
var __vue_is_functional_template__$1i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1i = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1i,
  staticRenderFns: __vue_staticRenderFns__$1i
}, __vue_inject_styles__$1i, __vue_script__$1i, __vue_scope_id__$1i, __vue_is_functional_template__$1i, __vue_module_identifier__$1i, false, undefined, undefined, undefined);
var AqCard = __vue_component__$1i;

//
var script$1h = {
  name: 'aq-card-header',
  mixins: [eventsMixin],
  props: {
    reorder: {
      type: Boolean,
      default: false
    },
    returnIcon: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      parentHasContent: true
    };
  },
  methods: {
    onClickReturn: function onClickReturn() {
      this.$emit('return');
    },
    clickContent: function clickContent() {
      this.$emit('click', {});
    }
  },
  mounted: function mounted() {
    var slots = this.$parent.$slots.default;
    if (slots.length > 0) {
      var hasContent = !!slots.filter(function (x) {
        var _x$tag;
        return ((_x$tag = x.tag) === null || _x$tag === void 0 ? void 0 : _x$tag.indexOf('aq-card-content')) !== -1;
      }).length;
      this.parentHasContent = hasContent;
    }
  }
};

/* script */
var __vue_script__$1h = script$1h;

/* template */
var __vue_render__$1h = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-card-header', !_vm.parentHasContent && 'aq-card-header--borderless'],
    on: {
      "click": [_vm.onClick, function ($event) {
        if ($event.target !== $event.currentTarget) {
          return null;
        }
        return _vm.onClickSelf.apply(null, arguments);
      }]
    }
  }, [_vm.returnIcon && !_vm.reorder ? _c('div', {
    staticClass: "aq-card-header__return-icon",
    on: {
      "click": _vm.onClickReturn
    }
  }, [_c('em', {
    staticClass: "aq-icon-chevron-left"
  })]) : _vm._e(), _vm._v(" "), _vm.reorder && !_vm.returnIcon ? _c('div', {
    staticClass: "aq-card-header__reorder"
  }, [_c('em', {
    staticClass: "aq-icon-six-dots"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    class: ['aq-card-header__left', {
      'aq-card-header__left--margin-return': _vm.returnIcon
    }],
    on: {
      "click": _vm.clickContent
    }
  }, [_c('div', {
    staticClass: "aq-card-header__title"
  }, [_vm._t("title", function () {
    return [_vm._t("default", function () {
      return [_vm._v(" slot default ")];
    })];
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "aq-card-header__subtitle"
  }, [_vm._t("subtitle")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "aq-card-header__right"
  }, [_vm._t("options")], 2)]);
};
var __vue_staticRenderFns__$1h = [];

/* style */
var __vue_inject_styles__$1h = undefined;
/* scoped */
var __vue_scope_id__$1h = undefined;
/* module identifier */
var __vue_module_identifier__$1h = undefined;
/* functional template */
var __vue_is_functional_template__$1h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1h = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1h,
  staticRenderFns: __vue_staticRenderFns__$1h
}, __vue_inject_styles__$1h, __vue_script__$1h, __vue_scope_id__$1h, __vue_is_functional_template__$1h, __vue_module_identifier__$1h, false, undefined, undefined, undefined);
var AqCardHeader = __vue_component__$1h;

//
//
//
//
//
//

var script$1g = {
  name: 'aq-card-content',
  data: function data() {
    return {};
  }
};

/* script */
var __vue_script__$1g = script$1g;

/* template */
var __vue_render__$1g = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-card-content aq-scroll-bar"
  }, [_vm._t("default", function () {
    return [_vm._v("CardContent")];
  })], 2);
};
var __vue_staticRenderFns__$1g = [];

/* style */
var __vue_inject_styles__$1g = undefined;
/* scoped */
var __vue_scope_id__$1g = undefined;
/* module identifier */
var __vue_module_identifier__$1g = undefined;
/* functional template */
var __vue_is_functional_template__$1g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1g = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1g,
  staticRenderFns: __vue_staticRenderFns__$1g
}, __vue_inject_styles__$1g, __vue_script__$1g, __vue_scope_id__$1g, __vue_is_functional_template__$1g, __vue_module_identifier__$1g, false, undefined, undefined, undefined);
var AqCardContent = __vue_component__$1g;

//
//
//
//
//
//

var script$1f = {
  name: 'aq-card-footer',
  data: function data() {
    return {};
  }
};

/* script */
var __vue_script__$1f = script$1f;

/* template */
var __vue_render__$1f = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-card-footer"
  }, [_vm._t("default", function () {
    return [_vm._v("CardFooter")];
  })], 2);
};
var __vue_staticRenderFns__$1f = [];

/* style */
var __vue_inject_styles__$1f = undefined;
/* scoped */
var __vue_scope_id__$1f = undefined;
/* module identifier */
var __vue_module_identifier__$1f = undefined;
/* functional template */
var __vue_is_functional_template__$1f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1f = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1f,
  staticRenderFns: __vue_staticRenderFns__$1f
}, __vue_inject_styles__$1f, __vue_script__$1f, __vue_scope_id__$1f, __vue_is_functional_template__$1f, __vue_module_identifier__$1f, false, undefined, undefined, undefined);
var AqCardFooter = __vue_component__$1f;

//
var script$1e = {
  name: 'aq-card-group',
  mixins: [sizeMixin]
};

/* script */
var __vue_script__$1e = script$1e;

/* template */
var __vue_render__$1e = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-card-group",
    style: _vm.mixinSizeStyle
  }, [_vm._t("default")], 2);
};
var __vue_staticRenderFns__$1e = [];

/* style */
var __vue_inject_styles__$1e = undefined;
/* scoped */
var __vue_scope_id__$1e = undefined;
/* module identifier */
var __vue_module_identifier__$1e = undefined;
/* functional template */
var __vue_is_functional_template__$1e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1e = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1e,
  staticRenderFns: __vue_staticRenderFns__$1e
}, __vue_inject_styles__$1e, __vue_script__$1e, __vue_scope_id__$1e, __vue_is_functional_template__$1e, __vue_module_identifier__$1e, false, undefined, undefined, undefined);
var AqCardGroup = __vue_component__$1e;

//
var script$1d = {
  provide: function provide() {
    return {
      collapse: this
    };
  },
  inject: {
    collapseGroup: {
      default: null
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    accordion: {
      type: String,
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    showBorder: {
      type: Boolean,
      default: true
    },
    showDivider: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    value: function value(newVal) {
      this.onValueChanged(newVal);
    },
    header: function header(newVal) {
      this.headerVisible = newVal;
    },
    visible: {
      handler: function handler() {
        this.setActive();
      },
      immediate: true
    }
  },
  data: function data() {
    return {
      visible: false,
      headerVisible: false,
      header: null,
      content: null,
      showDividerGroup: true
    };
  },
  computed: {
    border: function border() {
      var _this$collapseGroup;
      return (!!this.header || !!this.content && this.visible) && ((_this$collapseGroup = this.collapseGroup) === null || _this$collapseGroup === void 0 ? void 0 : _this$collapseGroup.showBorder) || this.showBorder && !this.collapseGroup;
    }
  },
  methods: {
    onValueChanged: function onValueChanged(newVal) {
      if (newVal) {
        this.show();
      } else {
        this.hide();
      }
    },
    setActive: function setActive() {
      if (this.content) {
        this.content.isActive = this.visible;
      }
      if (this.header) {
        this.header.isActive = this.visible;
      }
    },
    registerHeader: function registerHeader(vm) {
      this.header = vm;
    },
    registerContent: function registerContent(vm) {
      this.content = vm;
    },
    showOnParent: function showOnParent() {
      if (this.collapseGroup) {
        this.collapseGroup.show(this);
      }
    },
    show: function show() {
      if (!this.visible) {
        this.showOnParent();
        this.visible = true;
        this.$emit(EVENT_NAME_OPEN);
      }
    },
    hide: function hide() {
      if (this.visible) {
        this.visible = false;
        this.$emit(EVENT_NAME_CLOSE);
      }
    },
    toggle: function toggle() {
      if (this.visible) {
        this.hide();
      } else {
        this.show();
      }
    },
    validateHeader: function validateHeader() {
      var _this$$slots;
      this.headerVisible = this.header || !!((_this$$slots = this.$slots) !== null && _this$$slots !== void 0 && _this$$slots.header);
    },
    eventOpenCollapse: function eventOpenCollapse(data) {
      if ('value' in data && data.value === this.id) {
        this.onValueChanged(true);
      }
    },
    eventCloseCollapse: function eventCloseCollapse(data) {
      if ('value' in data && data.value === this.id || 'noId' in data) {
        this.onValueChanged(false);
      }
    },
    eventToggleCollapse: function eventToggleCollapse(data) {
      if ('value' in data && data.value === this.id) {
        this.onValueChanged(!this.visible);
      }
    },
    eventsOn: function eventsOn() {
      this.$root.$on(EVENT_NAME_GLOBAL_SHOW_COLLAPSE, this.eventOpenCollapse);
      this.$root.$on(EVENT_NAME_GLOBAL_HIDE_COLLAPSE, this.eventCloseCollapse);
      this.$root.$on(EVENT_NAME_GLOBAL_TOGGLE_COLLAPSE, this.eventToggleCollapse);
      this.$on("_".concat(EVENT_NAME_GLOBAL_SHOW_COLLAPSE), this.eventOpenCollapse);
      this.$on("_".concat(EVENT_NAME_GLOBAL_HIDE_COLLAPSE), this.eventCloseCollapse);
      this.$on("_".concat(EVENT_NAME_GLOBAL_TOGGLE_COLLAPSE), this.eventToggleCollapse);
    },
    eventsOff: function eventsOff() {
      this.$root.$off(EVENT_NAME_GLOBAL_SHOW_COLLAPSE, this.eventOpenCollapse);
      this.$root.$off(EVENT_NAME_GLOBAL_HIDE_COLLAPSE, this.eventCloseCollapse);
      this.$root.$off(EVENT_NAME_GLOBAL_TOGGLE_COLLAPSE, this.eventToggleCollapse);
      this.$off("_".concat(EVENT_NAME_GLOBAL_SHOW_COLLAPSE), this.eventOpenCollapse);
      this.$off("_".concat(EVENT_NAME_GLOBAL_HIDE_COLLAPSE), this.eventCloseCollapse);
      this.$off("_".concat(EVENT_NAME_GLOBAL_TOGGLE_COLLAPSE), this.eventToggleCollapse);
    }
  },
  mounted: function mounted() {
    var _this$collapseGroup2;
    this.validateHeader();
    this.eventsOn();
    this.setActive();
    if (this.collapseGroup) {
      this.collapseGroup.registerCollapse(this);
    }
    this.onValueChanged(this.value);
    this.showDividerGroup = (_this$collapseGroup2 = this.collapseGroup) === null || _this$collapseGroup2 === void 0 ? void 0 : _this$collapseGroup2.showDividerGroup;
    this.individualDivider = typeof this.showDividerGroup === 'undefined' && this.showDivider;
  },
  beforeDestroy: function beforeDestroy() {
    this.eventsOff();
    if (this.collapseGroup) {
      this.collapseGroup.unregisterCollapse(this);
    }
  }
};

/* script */
var __vue_script__$1d = script$1d;

/* template */
var __vue_render__$1d = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-collapse', {
      'aq-collapse--border': _vm.border,
      'aq-collapse--active': _vm.visible
    }],
    attrs: {
      "id": _vm.id
    }
  }, [_vm._t("default")], 2);
};
var __vue_staticRenderFns__$1d = [];

/* style */
var __vue_inject_styles__$1d = undefined;
/* scoped */
var __vue_scope_id__$1d = undefined;
/* module identifier */
var __vue_module_identifier__$1d = undefined;
/* functional template */
var __vue_is_functional_template__$1d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1d = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1d,
  staticRenderFns: __vue_staticRenderFns__$1d
}, __vue_inject_styles__$1d, __vue_script__$1d, __vue_scope_id__$1d, __vue_is_functional_template__$1d, __vue_module_identifier__$1d, false, undefined, undefined, undefined);
var AqCollapse = __vue_component__$1d;

//
var script$1c = {
  mixins: [eventsMixin],
  inject: ['collapse'],
  props: {
    disableToggle: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      visible: false,
      isActive: false
    };
  },
  computed: {
    showDivider: function showDivider() {
      var _this$collapse, _this$collapse2, _this$collapse3, _this$collapse4;
      return this.isActive && (this === null || this === void 0 ? void 0 : (_this$collapse = this.collapse) === null || _this$collapse === void 0 ? void 0 : _this$collapse.showDividerGroup) && !(this !== null && this !== void 0 && (_this$collapse2 = this.collapse) !== null && _this$collapse2 !== void 0 && _this$collapse2.individualDivider) || this.isActive && !(this !== null && this !== void 0 && (_this$collapse3 = this.collapse) !== null && _this$collapse3 !== void 0 && _this$collapse3.showDividerGroup) && (this === null || this === void 0 ? void 0 : (_this$collapse4 = this.collapse) === null || _this$collapse4 === void 0 ? void 0 : _this$collapse4.individualDivider);
    }
  },
  methods: {
    toggle: function toggle(permission) {
      if (!permission) {
        this.onClick();
      }
      if (this.collapse) {
        if (permission) {
          this.collapse.toggle();
          return;
        }
        if (this.disableToggle && this.isActive) {
          return;
        }
        this.collapse.toggle();
      }
    }
  },
  mounted: function mounted() {
    if (this.collapse) {
      this.collapse.registerHeader(this);
    }
  }
};

/* script */
var __vue_script__$1c = script$1c;

/* template */
var __vue_render__$1c = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-collapse-header', {
      'aq-collapse-header--active': _vm.showDivider
    }],
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) {
          return null;
        }
        return _vm.toggle(false);
      }
    }
  }, [_c('div', {
    class: ['aq-collapse-header__icon', {
      'aq-collapse-header__icon--active': _vm.isActive
    }],
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        return _vm.toggle(true);
      }
    }
  }, [_c('em', {
    staticClass: "aq-icon-chevron-down"
  })]), _vm._v(" "), _c('div', {
    staticClass: "aq-collapse-header__left",
    on: {
      "click": function click($event) {
        return _vm.toggle(false);
      }
    }
  }, [_c('div', {
    staticClass: "aq-collapse-header__title"
  }, [_vm._t("title", function () {
    return [_vm._t("default", function () {
      return [_vm._v(" slot default ")];
    })];
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "aq-collapse-header__subtitle"
  }, [_vm._t("subtitle")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "aq-collapse-header__right"
  }, [_vm._t("options")], 2)]);
};
var __vue_staticRenderFns__$1c = [];

/* style */
var __vue_inject_styles__$1c = undefined;
/* scoped */
var __vue_scope_id__$1c = undefined;
/* module identifier */
var __vue_module_identifier__$1c = undefined;
/* functional template */
var __vue_is_functional_template__$1c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1c = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1c,
  staticRenderFns: __vue_staticRenderFns__$1c
}, __vue_inject_styles__$1c, __vue_script__$1c, __vue_scope_id__$1c, __vue_is_functional_template__$1c, __vue_module_identifier__$1c, false, undefined, undefined, undefined);
var AqCollapseHeader = __vue_component__$1c;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-param-reassign */

var script$1b = {
  inject: ['collapse'],
  watch: {
    isActive: {
      handler: function handler(val, oldVal) {
        var _this = this;
        if (val) this.isBooted = true;
        if (this.$refs.collapse && this.visible) {
          this.$refs.collapse.style.height = "".concat(this.$refs.collapse.scrollHeight, "px");
        }
        if (oldVal == null) {
          this.visible = val;
        } else {
          this.$nextTick(function () {
            _this.visible = val;
          });
        }
      },
      immediate: true
    }
  },
  data: function data() {
    return {
      isActive: false,
      isBooted: false,
      visible: false
    };
  },
  methods: {
    beforeEnter: function beforeEnter(el) {
      el.style.height = '0';
    },
    enter: function enter(el) {
      el.style.height = "".concat(el.scrollHeight, "px");
      setTimeout(function () {
        el.style.height = 'auto';
      }, 200);
    },
    beforeLeave: function beforeLeave(el) {
      el.style.height = "".concat(el.scrollHeight, "px");
    },
    leave: function leave(el) {
      el.style.height = '0';
    }
  },
  mounted: function mounted() {
    if (this.collapse) {
      this.collapse.registerContent(this);
    }
  }
};

/* script */
var __vue_script__$1b = script$1b;

/* template */
var __vue_render__$1b = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('transition', {
    attrs: {
      "name": "collapse"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "before-leave": _vm.beforeLeave,
      "leave": _vm.leave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    ref: "collapse",
    staticClass: "aq-collapse-content"
  }, [_c('div', {
    staticClass: "aq-collapse-content__inner"
  }, [_vm._t("default")], 2)])]);
};
var __vue_staticRenderFns__$1b = [];

/* style */
var __vue_inject_styles__$1b = undefined;
/* scoped */
var __vue_scope_id__$1b = undefined;
/* module identifier */
var __vue_module_identifier__$1b = undefined;
/* functional template */
var __vue_is_functional_template__$1b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1b = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1b,
  staticRenderFns: __vue_staticRenderFns__$1b
}, __vue_inject_styles__$1b, __vue_script__$1b, __vue_scope_id__$1b, __vue_is_functional_template__$1b, __vue_module_identifier__$1b, false, undefined, undefined, undefined);
var AqCollapseContent = __vue_component__$1b;

//
//
//
//
//
//

var script$1a = {
  provide: function provide() {
    return {
      collapseGroup: this
    };
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    accordion: {
      type: Boolean,
      default: false
    },
    showBorder: {
      type: Boolean,
      default: true
    },
    showDividerGroup: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      collapses: []
    };
  },
  methods: {
    show: function show(vm) {
      this.collapses.forEach(function (collapse) {
        if (collapse !== vm) {
          collapse.hide();
        }
      });
    },
    hideAll: function hideAll() {
      this.collapses.forEach(function (collapse) {
        collapse.hide();
      });
    },
    registerCollapse: function registerCollapse(vm) {
      this.collapses.push(vm);
    },
    unregisterCollapse: function unregisterCollapse(vm) {
      this.collapses.splice(this.collapses.indexOf(vm), 1);
    }
  }
};

/* script */
var __vue_script__$1a = script$1a;

/* template */
var __vue_render__$1a = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-collapse-group"
  }, [_vm._t("default")], 2);
};
var __vue_staticRenderFns__$1a = [];

/* style */
var __vue_inject_styles__$1a = undefined;
/* scoped */
var __vue_scope_id__$1a = undefined;
/* module identifier */
var __vue_module_identifier__$1a = undefined;
/* functional template */
var __vue_is_functional_template__$1a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1a = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1a,
  staticRenderFns: __vue_staticRenderFns__$1a
}, __vue_inject_styles__$1a, __vue_script__$1a, __vue_scope_id__$1a, __vue_is_functional_template__$1a, __vue_module_identifier__$1a, false, undefined, undefined, undefined);
var AqCollapseGroup = __vue_component__$1a;

//
var script$19 = {
  components: {
    VtPerPageSelector: VtPerPageSelector
  },
  props: {
    props: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    page: {
      type: Number,
      default: -1
    },
    totalPages: {
      type: Number,
      default: 1
    },
    records: {
      type: Number,
      default: 0
    },
    perPage: {
      type: Number,
      default: -1
    },
    chunk: {
      type: Number,
      default: 5
    },
    setPage: {
      type: Function,
      default: null
    },
    setPerPageValue: {
      type: Function,
      default: null
    },
    perPageValues: {
      type: Array,
      default: function _default() {
        return [10, 25, 50, 100];
      }
    },
    value: {
      type: Number,
      default: 1
    },
    isSmall: {
      type: Boolean,
      default: false
    },
    align: {
      type: String,
      default: 'right',
      validator: function validator(x) {
        return ['', 'left', 'center', 'right'].includes(x.toLowerCase());
      }
    },
    showItemsPerPage: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    perPage: function perPage() {
      this.onChangePerPageVT();
    },
    'props.perPage': function propsPerPage() {
      this.onChangePerPageVT();
    },
    records: function records() {
      this.onChangeRecordsVT();
    },
    'props.records': function propsRecords() {
      this.onChangeRecordsVT();
    },
    value: function value() {
      this.onValueChange();
    },
    page: function page(val) {
      this.onPageChange(val);
    }
  },
  data: function data() {
    return {
      currentChunk: 1,
      startPage: 1,
      endPage: 1,
      vueTables: false,
      localTotalPages: 1,
      localPage: 1,
      localPerPage: 10
    };
  },
  computed: {
    finalPage: function finalPage() {
      var page = this.localPage;
      if (this.vueTables) {
        page = this.props.page;
      } else if (this.page !== -1) {
        page = this.page;
      }
      return page;
    },
    finalTotalPages: {
      get: function get() {
        return this.vueTables ? this.props.totalPages : this.localTotalPages;
      },
      set: function set(val) {
        this.localTotalPages = val;
      }
    },
    finalRecords: function finalRecords() {
      return this.vueTables ? this.props.records : this.records;
    },
    finalPerPage: function finalPerPage() {
      var perPage = this.localPerPage;
      if (this.vueTables) {
        perPage = this.props.perPage;
      } else if (this.perPage !== -1) {
        perPage = this.perPage;
      }
      return perPage;
    },
    finalChunk: function finalChunk() {
      var chunk = this.chunk;
      if (this.vueTables) {
        chunk = this.props.options.chunk;
      }
      if (this.finalPerPage * chunk > this.finalRecords) {
        chunk = Math.round(this.finalRecords / this.finalPerPage);
      }
      if (chunk === 0) {
        chunk = 1;
      }
      return chunk;
    },
    finalSetPage: function finalSetPage() {
      var setPage = this.localSetPage;
      if (this.vueTables) {
        setPage = this.props.setPage;
      } else if (this.setPage !== null) {
        setPage = this.setPage;
      }
      return setPage;
    },
    finalPerPageValues: function finalPerPageValues() {
      return this.vueTables ? this.props.perPageValues : this.perPageValues;
    },
    finalSetPerPageValue: function finalSetPerPageValue() {
      var setPerPageValue = this.localsetPerPageValue;
      if (this.vueTables) {
        setPerPageValue = this.props.selectEvents.change;
      } else if (this.setPerPageValue !== null) {
        setPerPageValue = this.setPerPageValue;
      }
      return setPerPageValue;
    },
    nextPageActive: function nextPageActive() {
      return this.finalPage < this.finalTotalPages;
    },
    prevPageActive: function prevPageActive() {
      return this.finalPage > 1;
    },
    prevChunkActive: function prevChunkActive() {
      return this.currentChunk > 1;
    },
    nextChunkActive: function nextChunkActive() {
      return this.currentChunk !== this.totalChunks;
    },
    startEllipse: function startEllipse() {
      return this.currentChunk > 1;
    },
    totalChunks: function totalChunks() {
      var totalChunks = this.finalPerPage >= this.finalRecords ? 1 : this.finalTotalPages / this.finalChunk;
      if (totalChunks < 1) {
        return 1;
      }
      return Number.isInteger(totalChunks) ? totalChunks : parseInt("".concat(totalChunks), 10) + 1;
    },
    endEllipse: function endEllipse() {
      return this.totalChunks > 1 && this.currentChunk !== this.totalChunks;
    },
    numberOfElements: function numberOfElements() {
      var to = this.finalPerPage * this.finalPage;
      var from = to - this.finalPerPage + 1;
      var total = this.finalRecords;
      return {
        from: this.finalRecords > 0 ? from : 0,
        to: to < total ? to : total,
        total: total
      };
    },
    getAlign: function getAlign() {
      return this.isSmall ? "aq-table__pagination__paginator--small-".concat(this.align) : '';
    },
    showArrows: function showArrows() {
      return this.endPage - this.startPage > 0;
    }
  },
  methods: {
    onChangePerPageVT: function onChangePerPageVT() {
      this.updateTotalPages();
      this.firstPage();
      this.setEndPage();
    },
    onChangeRecordsVT: function onChangeRecordsVT() {
      this.updateTotalPages();
      this.setEndPage();
    },
    onValueChange: function onValueChange() {
      this.localPage = this.value;
    },
    onPageChange: function onPageChange(val) {
      this.$emit('onValueChange', val);
    },
    localSetPage: function localSetPage(val) {
      this.localPage = val;
      this.onPageChange(val);
    },
    localsetPerPageValue: function localsetPerPageValue(val) {
      this.localPerPage = val;
      this.$emit('changePerPage', val);
    },
    range: function range(start, end) {
      return Array(end - start + 1).fill(0).map(function (_, idx) {
        return start + idx;
      });
    },
    nextPage: function nextPage() {
      if (this.finalPage + 1 > this.endPage) {
        this.nextChunk();
      } else {
        this.finalSetPage(this.finalPage + 1);
      }
    },
    prevPage: function prevPage() {
      if (this.finalPage - 1 < this.startPage) {
        this.prevChunk(false);
      }
      if (this.finalPage - 1 > 0) {
        this.finalSetPage(this.finalPage - 1);
      }
    },
    nextChunk: function nextChunk() {
      var tempChunk = this.finalChunk * this.currentChunk + 1;
      if (tempChunk <= this.finalTotalPages) {
        var endPage = tempChunk + this.finalChunk - 1;
        this.startPage = tempChunk;
        this.endPage = endPage <= this.finalTotalPages ? endPage : this.finalTotalPages;
        this.finalSetPage(tempChunk);
        this.currentChunk += 1;
      }
    },
    prevChunk: function prevChunk(setPage) {
      var tempChunk = this.finalChunk * (this.currentChunk - 1);
      if (tempChunk > 0) {
        this.startPage = tempChunk - this.finalChunk + 1;
        this.endPage = tempChunk <= this.finalTotalPages ? tempChunk : this.finalTotalPages;
        if (setPage) {
          this.finalSetPage(tempChunk - this.finalChunk + 1);
        }
        this.currentChunk -= 1;
      }
    },
    firstPage: function firstPage() {
      this.finalSetPage(1);
      this.currentChunk = 1;
      this.startPage = 1;
      this.endPage = this.finalPerPage >= this.finalRecords ? 1 : this.finalChunk;
    },
    lastPage: function lastPage() {
      this.finalSetPage(this.finalTotalPages);
      var startPage = 1;
      var tempChunk = this.finalChunk * this.currentChunk + 1;
      while (tempChunk <= this.finalTotalPages) {
        startPage = tempChunk;
        this.currentChunk += 1;
        tempChunk = this.finalChunk * this.currentChunk + 1;
      }
      this.startPage = startPage;
      this.endPage = this.finalTotalPages;
    },
    setEndPage: function setEndPage() {
      this.endPage = this.finalChunk < this.finalTotalPages ? this.finalChunk : this.finalTotalPages;
    },
    setVueTables: function setVueTables() {
      var _Object$keys, _Object$keys2;
      if (((_Object$keys = Object.keys(this.props)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0 && ((_Object$keys2 = Object.keys(this.props.options)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2.length) > 0) {
        this.vueTables = true;
      }
    },
    initialize: function initialize() {
      if (!this.vueTables) {
        this.onChangeRecordsVT();
      }
    },
    updateTotalPages: function updateTotalPages() {
      this.finalTotalPages = Math.round(this.finalRecords / this.finalPerPage);
    }
  },
  created: function created() {
    this.setVueTables();
    this.initialize();
  },
  mounted: function mounted() {
    this.onValueChange();
    this.localTotalPages = this.totalPages;
    this.updateTotalPages();
    this.endPage = this.finalPerPage >= this.finalRecords ? 1 : this.finalChunk;
  }
};

/* script */
var __vue_script__$19 = script$19;

/* template */
var __vue_render__$19 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-table__pagination"
  }, [_c('div', {
    staticClass: "aq-table__pagination__per-page"
  }, [_c('div', {
    staticClass: "aq-table__pagination__per-page-selector"
  }, [_vm.vueTables ? [_c('vt-per-page-selector')] : [!_vm.isSmall ? _c('div', {
    staticClass: "VueTables__limit-field"
  }, [_vm.showItemsPerPage ? _c('label', [_vm._v(_vm._s(_vm.$t('aqua.itemsPerPage')))]) : _vm._e(), _vm._v(" "), _c('aq-dropdown', {
    attrs: {
      "closeOnClick": ""
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_c('aq-dropdown-content', _vm._l(_vm.finalPerPageValues, function (val) {
          return _c('aq-dropdown-item', {
            key: val,
            on: {
              "click": function click($event) {
                return _vm.finalSetPerPageValue(val);
              }
            }
          }, [_vm._v("\n                  " + _vm._s(val) + "\n                ")]);
        }), 1)];
      },
      proxy: true
    }], null, false, 2948008347)
  }, [_c('template', {
    slot: "activator"
  }, [_c('aq-button', {
    attrs: {
      "disclosure": "",
      "outline": ""
    }
  }, [_vm._v(_vm._s(_vm.finalPerPage))])], 1)], 2)], 1) : _vm._e()]], 2), _vm._v(" "), !_vm.isSmall ? _c('aq-divider', {
    attrs: {
      "orientation": "vertical"
    }
  }) : _vm._e(), _vm._v(" "), !_vm.isSmall ? _c('div', [_vm._v("\n      " + _vm._s(_vm.$t('aqua.numberOfElements', [_vm.numberOfElements.from, _vm.numberOfElements.to, _vm.numberOfElements.total])) + "\n    ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    class: "aq-table__pagination__paginator " + _vm.getAlign
  }, [_vm.showArrows ? _c('span', {
    class: ['aq-table__pagination__item', {
      'aq-table__pagination__item--disabled': !_vm.prevChunkActive
    }],
    on: {
      "click": _vm.firstPage
    }
  }, [_c('em', {
    staticClass: "aq-icon-chevron-double-left"
  })]) : _vm._e(), _vm._v(" "), _vm.showArrows ? _c('span', {
    class: ['aq-table__pagination__item', {
      'aq-table__pagination__item--disabled': !_vm.prevPageActive
    }],
    on: {
      "click": _vm.prevPage
    }
  }, [_c('em', {
    staticClass: "aq-icon-chevron-left"
  })]) : _vm._e(), _vm._v(" "), _vm.startEllipse ? _c('span', {
    class: ['aq-table__pagination__item'],
    on: {
      "click": _vm.firstPage
    }
  }, [_vm._v("\n      1\n    ")]) : _vm._e(), _vm._v(" "), _vm.startEllipse ? _c('span', {
    staticClass: "aq-table__pagination__item",
    on: {
      "click": function click($event) {
        return _vm.prevChunk(true);
      }
    }
  }, [_vm._v("...")]) : _vm._e(), _vm._v(" "), _vm._l(_vm.range(_vm.startPage, _vm.endPage), function (n) {
    return _c('span', {
      key: n,
      class: ['aq-table__pagination__item', {
        'aq-table__pagination__item--active': _vm.finalPage === n
      }],
      on: {
        "click": function click($event) {
          return _vm.finalSetPage(n);
        }
      }
    }, [_vm._v("\n      " + _vm._s(n) + "\n    ")]);
  }), _vm._v(" "), _vm.endEllipse ? _c('span', {
    staticClass: "aq-table__pagination__item",
    on: {
      "click": _vm.nextChunk
    }
  }, [_vm._v("...")]) : _vm._e(), _vm._v(" "), _vm.endEllipse ? _c('span', {
    class: ['aq-table__pagination__item'],
    on: {
      "click": _vm.lastPage
    }
  }, [_vm._v("\n      " + _vm._s(_vm.finalTotalPages) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.showArrows ? _c('span', {
    class: ['aq-table__pagination__item', {
      'aq-table__pagination__item--disabled': !_vm.nextPageActive
    }],
    on: {
      "click": _vm.nextPage
    }
  }, [_c('em', {
    staticClass: "aq-icon-chevron-right"
  })]) : _vm._e(), _vm._v(" "), _vm.showArrows ? _c('span', {
    class: ['aq-table__pagination__item', {
      'aq-table__pagination__item--disabled': !_vm.nextChunkActive
    }],
    on: {
      "click": _vm.lastPage
    }
  }, [_c('em', {
    staticClass: "aq-icon-chevron-double-right"
  })]) : _vm._e()], 2)]);
};
var __vue_staticRenderFns__$19 = [];

/* style */
var __vue_inject_styles__$19 = undefined;
/* scoped */
var __vue_scope_id__$19 = undefined;
/* module identifier */
var __vue_module_identifier__$19 = undefined;
/* functional template */
var __vue_is_functional_template__$19 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$19 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$19,
  staticRenderFns: __vue_staticRenderFns__$19
}, __vue_inject_styles__$19, __vue_script__$19, __vue_scope_id__$19, __vue_is_functional_template__$19, __vue_module_identifier__$19, false, undefined, undefined, undefined);
var AqPagination = __vue_component__$19;

//
var script$18 = {
  props: ['options'],
  watch: {
    'opts.columnsOptions': {
      handler: function handler() {
        var _this = this;
        // TODO: revisar el porque se actualizan todos los columnsOptions
        setTimeout(function () {
          _this.setColumnsOptions();
        }, 40);
      },
      deep: true
    }
  },
  data: function data() {
    return {
      columnsOptions: [],
      columns: [],
      styleStatic: {},
      scrollLeft: 0
    };
  },
  computed: {
    opts: function opts() {
      return this.$parent.props.opts;
    },
    dataTable: function dataTable() {
      var _this$$parent, _this$$parent$props, _this$$parent2, _this$$parent2$props;
      return (_this$$parent = this.$parent) !== null && _this$$parent !== void 0 && (_this$$parent$props = _this$$parent.props) !== null && _this$$parent$props !== void 0 && _this$$parent$props.data ? (_this$$parent2 = this.$parent) === null || _this$$parent2 === void 0 ? void 0 : (_this$$parent2$props = _this$$parent2.props) === null || _this$$parent2$props === void 0 ? void 0 : _this$$parent2$props.data : [];
    },
    isSelectable: function isSelectable() {
      var _this$opts$selectable;
      return (_this$opts$selectable = this.opts.selectable) === null || _this$opts$selectable === void 0 ? void 0 : _this$opts$selectable.mode;
    },
    uniqueId: function uniqueId() {
      var _this$opts, _this$opts2, _this$opts2$uniqueIdH, _this$opts3;
      return (_this$opts = this.opts) !== null && _this$opts !== void 0 && _this$opts.uniqueIdHeader && ((_this$opts2 = this.opts) === null || _this$opts2 === void 0 ? void 0 : (_this$opts2$uniqueIdH = _this$opts2.uniqueIdHeader) === null || _this$opts2$uniqueIdH === void 0 ? void 0 : _this$opts2$uniqueIdH.length) > 0 ? "".concat((_this$opts3 = this.opts) === null || _this$opts3 === void 0 ? void 0 : _this$opts3.uniqueIdHeader, "__footer") : '';
    },
    columsOrder: function columsOrder() {
      return this.opts.aqua ? this.opts.aqua.columsOrder : [];
    },
    getDatatableLength: function getDatatableLength() {
      var _this$dataTable;
      return ((_this$dataTable = this.dataTable) === null || _this$dataTable === void 0 ? void 0 : _this$dataTable.length) > 0;
    }
  },
  methods: {
    getStyle: function getStyle(column) {
      var _this$columnsOptions$, _this$columnsOptions$2;
      var style = (_this$columnsOptions$ = this.columnsOptions[column]) === null || _this$columnsOptions$ === void 0 ? void 0 : _this$columnsOptions$.style;
      if (style && (_this$columnsOptions$2 = this.columnsOptions[column]) !== null && _this$columnsOptions$2 !== void 0 && _this$columnsOptions$2.realWidth) {
        var _this$columnsOptions$3;
        style.width = "".concat((_this$columnsOptions$3 = this.columnsOptions[column]) === null || _this$columnsOptions$3 === void 0 ? void 0 : _this$columnsOptions$3.realWidth, "px");
      }
      return style;
    },
    setStyleStatic: function setStyleStatic() {
      var element = document.querySelector("#".concat(this.uniqueId));
      if (element) {
        this.styleStatic = {
          height: "".concat(element.offsetHeight, "px")
        };
      }
    },
    setColumns: function setColumns() {
      var _this2 = this;
      setTimeout(function () {
        var _this2$opts$aqua, _this2$opts$aqua2;
        var columsOrder = (_this2$opts$aqua = _this2.opts.aqua) !== null && _this2$opts$aqua !== void 0 && _this2$opts$aqua.columsOrder ? (_this2$opts$aqua2 = _this2.opts.aqua) === null || _this2$opts$aqua2 === void 0 ? void 0 : _this2$opts$aqua2.columsOrder : [];
        if ((columsOrder === null || columsOrder === void 0 ? void 0 : columsOrder.length) > 0 && _this2.opts.aqua.columns) {
          _this2.columns = columsOrder.filter(function (val) {
            return _this2.opts.aqua.columns.includes(val);
          });
        } else {
          var _this2$opts$aqua3;
          _this2.columns = (_this2$opts$aqua3 = _this2.opts.aqua) === null || _this2$opts$aqua3 === void 0 ? void 0 : _this2$opts$aqua3.columns;
        }
      });
      setTimeout(function () {
        var _this2$$refs;
        if ((_this2$$refs = _this2.$refs) !== null && _this2$$refs !== void 0 && _this2$$refs.total_row) {
          _this2.$refs.total_row.scrollLeft = _this2.scrollLeft;
        }
      });
    },
    setColumnsOptions: function setColumnsOptions() {
      var _this$$refs,
        _this3 = this;
      if ((_this$$refs = this.$refs) !== null && _this$$refs !== void 0 && _this$$refs.total_row) {
        this.scrollLeft = this.$refs.total_row.scrollLeft;
      }
      this.columnsOptions = cloneDeep(this.opts.columnsOptions);
      this.columns = [];
      this.setColumns();
      setTimeout(function () {
        _this3.setStyleStatic();
      });
    },
    getLastPinned: function getLastPinned(column) {
      var _this$opts4;
      return ((_this$opts4 = this.opts) === null || _this$opts4 === void 0 ? void 0 : _this$opts4.lastPinned) === column;
    },
    align: function align(column) {
      var _this$opts5, _this$opts5$columnsOp;
      var align = ((_this$opts5 = this.opts) === null || _this$opts5 === void 0 ? void 0 : (_this$opts5$columnsOp = _this$opts5.columnsOptions[column]) === null || _this$opts5$columnsOp === void 0 ? void 0 : _this$opts5$columnsOp.align) || 'left';
      return "aq-table-cell--".concat(align);
    }
  },
  mounted: function mounted() {
    var _this4 = this;
    this.setColumns();
    setTimeout(function () {
      _this4.setStyleStatic();
    }, 120);
    setTimeout(function () {
      _this4.setColumnsOptions();
    }, 100);
    window.addEventListener('resize', this.setColumnsOptions);
    global.vtEvent.$emit('aq-table.totalRowsMounted', {
      id: this.opts.uniqueIdHeader
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.setColumnsOptions);
  }
};

/* script */
var __vue_script__$18 = script$18;

/* template */
var __vue_render__$18 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.getDatatableLength ? _c('tr', {
    staticClass: "VueTables__row aq-totals-row__static",
    attrs: {
      "id": _vm.uniqueId + '-static'
    }
  }, [_c('td', {
    style: _vm.styleStatic
  }), _vm._v(" "), [_c('tr', {
    ref: "total_row",
    staticClass: "VueTables__row aq-totals-row",
    attrs: {
      "id": _vm.uniqueId
    }
  }, [_vm.isSelectable ? _c('td', {
    staticClass: "VueTables__select-row VueTables__select-single aq-table__row-selector",
    attrs: {
      "tabindex": "0"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l(_vm.columns, function (column, index) {
    return _c('td', {
      key: index,
      class: ['aq-table-cell', _vm.align(column), {
        'last-left-fixed-column': _vm.getLastPinned(column)
      }],
      style: _vm.getStyle(column),
      attrs: {
        "tabindex": "0"
      }
    }, [_vm._t(column)], 2);
  })], 2)]], 2) : _vm._e();
};
var __vue_staticRenderFns__$18 = [];

/* style */
var __vue_inject_styles__$18 = undefined;
/* scoped */
var __vue_scope_id__$18 = undefined;
/* module identifier */
var __vue_module_identifier__$18 = undefined;
/* functional template */
var __vue_is_functional_template__$18 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$18 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$18,
  staticRenderFns: __vue_staticRenderFns__$18
}, __vue_inject_styles__$18, __vue_script__$18, __vue_scope_id__$18, __vue_is_functional_template__$18, __vue_module_identifier__$18, false, undefined, undefined, undefined);
var AqTotalsRow = __vue_component__$18;

//
var script$17 = {
  name: 'aq-setting-group',
  mixins: [sizeMixin]
};

/* script */
var __vue_script__$17 = script$17;

/* template */
var __vue_render__$17 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-setting-group",
    style: _vm.mixinSizeStyle
  }, [_c('aq-step-group', {
    attrs: {
      "vertical": ""
    }
  }, [_vm._t("default")], 2)], 1);
};
var __vue_staticRenderFns__$17 = [];

/* style */
var __vue_inject_styles__$17 = undefined;
/* scoped */
var __vue_scope_id__$17 = undefined;
/* module identifier */
var __vue_module_identifier__$17 = undefined;
/* functional template */
var __vue_is_functional_template__$17 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$17 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$17,
  staticRenderFns: __vue_staticRenderFns__$17
}, __vue_inject_styles__$17, __vue_script__$17, __vue_scope_id__$17, __vue_is_functional_template__$17, __vue_module_identifier__$17, false, undefined, undefined, undefined);
var AqSettingGroup = __vue_component__$17;

//
var script$16 = {
  name: 'aq-setting-step',
  mixins: [sizeMixin],
  props: {
    options: {
      type: Array,
      default: function _default() {
        return [{}];
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {},
  methods: {
    slotEdit: function slotEdit(id) {
      return "edit-".concat(id);
    },
    slotSummary: function slotSummary(id) {
      return "summary-".concat(id);
    },
    clickTertiary: function clickTertiary(id) {
      this.$emit('clickTertiary', id);
    },
    clickSecondary: function clickSecondary(id) {
      this.$emit('clickSecondary', id);
    },
    clickPrimary: function clickPrimary(id) {
      this.$emit('clickPrimary', id);
    },
    clickEdit: function clickEdit(id) {
      this.$emit('clickEdit', id);
    }
  }
};

/* script */
var __vue_script__$16 = script$16;

/* template */
var __vue_render__$16 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-setting-step",
    style: _vm.mixinSizeStyle
  }, _vm._l(_vm.options, function (option, index) {
    return _c('aq-step', {
      key: index,
      attrs: {
        "complete": option.stepComplete,
        "active": option.stepActive
      }
    }, [_c('aq-setting-content', {
      attrs: {
        "option": option
      },
      on: {
        "clickEdit": function clickEdit($event) {
          return _vm.clickEdit(option.id);
        },
        "clickPrimary": function clickPrimary($event) {
          return _vm.clickPrimary(option.id);
        },
        "clickSecondary": function clickSecondary($event) {
          return _vm.clickSecondary(option.id);
        },
        "clickTertiary": function clickTertiary($event) {
          return _vm.clickTertiary(option.id);
        }
      }
    }, [_c('template', {
      slot: _vm.slotEdit(option.id)
    }, [_vm._t(_vm.slotEdit(option.id))], 2), _vm._v(" "), _c('template', {
      slot: _vm.slotSummary(option.id)
    }, [_vm._t(_vm.slotSummary(option.id))], 2)], 2)], 1);
  }), 1);
};
var __vue_staticRenderFns__$16 = [];

/* style */
var __vue_inject_styles__$16 = undefined;
/* scoped */
var __vue_scope_id__$16 = undefined;
/* module identifier */
var __vue_module_identifier__$16 = undefined;
/* functional template */
var __vue_is_functional_template__$16 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$16 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$16,
  staticRenderFns: __vue_staticRenderFns__$16
}, __vue_inject_styles__$16, __vue_script__$16, __vue_scope_id__$16, __vue_is_functional_template__$16, __vue_module_identifier__$16, false, undefined, undefined, undefined);
var AqSettingStep = __vue_component__$16;

//
var script$15 = {
  name: 'aq-setting-header',
  mixins: [LabelMixin],
  props: {
    state: {
      type: String,
      default: 'default'
    },
    option: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    id: {
      type: String,
      default: ''
    },
    contentState: {
      type: String,
      default: 'initial',
      validator: function validator(x) {
        return ['initial', 'editing', 'summary', 'done'].includes(x.toLowerCase());
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    showSlots: function showSlots() {
      var editStatus = true;
      if (this.option.contentState.toLowerCase() === 'editing' || this.option.contentState.toLowerCase() === 'done') {
        editStatus = false;
        return editStatus;
      }
      return editStatus;
    },
    getState: function getState() {
      return this.option.state.toLowerCase();
    },
    getIcon: function getIcon() {
      var icon = '';
      switch (this.option.state.toLowerCase()) {
        case 'default':
          icon = 'aq-icon-check-circle';
          break;
        case 'success':
          icon = 'aq-icon-check-circle-fill';
          break;
        case 'error':
          icon = 'aq-icon-alert-circle-fill';
          break;
        case 'warning':
          icon = 'aq-icon-alert-fill';
          break;
        default:
          icon = 'aq-icon-check-circle';
      }
      return icon;
    },
    initial: function initial() {
      var _this$option;
      return ((_this$option = this.option) === null || _this$option === void 0 ? void 0 : _this$option.contentState) === 'initial' ? 'aq-setting-header--initial' : '';
    },
    showEditButton: function showEditButton() {
      var _this$option2, _this$option3;
      return ((_this$option2 = this.option) === null || _this$option2 === void 0 ? void 0 : _this$option2.buttonEdit) && ((_this$option3 = this.option) === null || _this$option3 === void 0 ? void 0 : _this$option3.buttonEdit) !== '';
    },
    getSubtitle: function getSubtitle() {
      var _this$option4, _this$option5;
      return ((_this$option4 = this.option) === null || _this$option4 === void 0 ? void 0 : _this$option4.subtitle) && ((_this$option5 = this.option) === null || _this$option5 === void 0 ? void 0 : _this$option5.subtitle) !== '';
    },
    infoIsVisible: function infoIsVisible() {
      var _this$option6, _this$option$info;
      return ((_this$option6 = this.option) === null || _this$option6 === void 0 ? void 0 : _this$option6.info) && ((_this$option$info = this.option.info) === null || _this$option$info === void 0 ? void 0 : _this$option$info.length) > 0;
    }
  },
  methods: {
    openSetting: function openSetting(id) {
      this.$emit('clickEdit', id);
    }
  }
};

/* script */
var __vue_script__$15 = script$15;

/* template */
var __vue_render__$15 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-setting-header', _vm.initial]
  }, [_c('div', {
    staticClass: "aq-setting-header__left-icon"
  }, [_c('em', {
    class: [_vm.getIcon, 'aq-setting-header__state--' + _vm.getState]
  })]), _vm._v(" "), _c('div', {
    staticClass: "aq-setting-header__left"
  }, [_c('div', {
    staticClass: "aq-setting-header__title"
  }, [_c('aq-subheading', {
    attrs: {
      "tooltipWidth": _vm.option.tooltipWidth,
      "info": _vm.option.info
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$aqT(_vm.option.title)) + "\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "aq-setting-header__subtitle"
  }, [_vm.getSubtitle ? _c('aq-caption', [_vm._v("\n        " + _vm._s(_vm.$aqT(_vm.option.subtitle)) + "\n      ")]) : _c('aq-caption', [_c('span', [_vm._v(" ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "aq-setting-header__right"
  }, [_vm.showSlots && _vm.showEditButton ? _c('aq-button', {
    attrs: {
      "outline": ""
    },
    on: {
      "click": function click($event) {
        return _vm.openSetting(_vm.option.id);
      }
    }
  }, [_vm._v(_vm._s(_vm.$aqT(_vm.option.buttonEdit)))]) : _vm._e()], 1)]);
};
var __vue_staticRenderFns__$15 = [];

/* style */
var __vue_inject_styles__$15 = undefined;
/* scoped */
var __vue_scope_id__$15 = undefined;
/* module identifier */
var __vue_module_identifier__$15 = undefined;
/* functional template */
var __vue_is_functional_template__$15 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$15 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$15,
  staticRenderFns: __vue_staticRenderFns__$15
}, __vue_inject_styles__$15, __vue_script__$15, __vue_scope_id__$15, __vue_is_functional_template__$15, __vue_module_identifier__$15, false, undefined, undefined, undefined);
var AqSettingHeader = __vue_component__$15;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$14 = {
  name: 'aq-setting-content',
  props: {
    option: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    contentState: {
      type: String,
      default: 'initial',
      validator: function validator(x) {
        return ['initial', 'editing', 'summary'].includes(x.toLowerCase());
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    showSlots: function showSlots() {
      return this.option.contentState.toLowerCase();
    },
    getState: function getState() {
      return this.option.state.toLowerCase();
    },
    getIcon: function getIcon() {
      var icon = '';
      switch (this.option.state.toLowerCase()) {
        case 'default':
          icon = 'aq-icon-info-circle';
          break;
        case 'success':
          icon = 'aq-icon-check-circle-fill';
          break;
        case 'danger':
          icon = 'aq-icon-alert-circle-fill';
          break;
        default:
          icon = 'aq-icon-info-circle';
      }
      return icon;
    },
    initial: function initial() {
      return this.contentState === 'initial' ? 'aq-setting-header--initial' : '';
    },
    slotEdit: function slotEdit() {
      return "edit-".concat(this.option.id);
    },
    slotSummary: function slotSummary() {
      return "summary-".concat(this.option.id);
    }
  },
  methods: {
    tertiaryAction: function tertiaryAction(id) {
      this.$emit('clickTertiary', id);
    },
    secondaryAction: function secondaryAction(id) {
      this.$emit('clickSecondary', id);
    },
    primaryAction: function primaryAction(id) {
      this.$emit('clickPrimary', id);
    },
    openSetting: function openSetting(id) {
      this.$emit('clickEdit', id);
    }
  }
};

/* script */
var __vue_script__$14 = script$14;

/* template */
var __vue_render__$14 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-setting-content"
  }, [_c('aq-setting-header', {
    attrs: {
      "option": _vm.option
    },
    on: {
      "clickEdit": function clickEdit($event) {
        return _vm.openSetting(_vm.option.id);
      }
    }
  }), _vm._v(" "), _vm.showSlots !== 'initial' ? _c('div', [_vm.showSlots === 'editing' ? _c('div', {
    staticClass: "aq-setting-edit"
  }, [_vm._t(_vm.slotEdit, function () {
    return [_vm._v(" slot Edit ")];
  })], 2) : _vm._e(), _vm._v(" "), _vm.showSlots === 'summary' ? _c('div', {
    staticClass: "aq-setting-edit"
  }, [_vm._t(_vm.slotSummary, function () {
    return [_vm._v(" slot summary ")];
  })], 2) : _vm._e(), _vm._v(" "), _vm.showSlots === 'editing' ? _c('div', {
    staticClass: "aq-setting-footer"
  }, [_c('div', [_vm.option.buttonTertiary !== '' ? _c('aq-button', {
    staticClass: "aq-setting-footer-tertiary",
    attrs: {
      "plain": ""
    },
    on: {
      "click": function click($event) {
        return _vm.tertiaryAction(_vm.option.id);
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$aqT(_vm.option.buttonTertiary)) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', [_vm.option.buttonSecondary !== '' ? _c('aq-button', {
    attrs: {
      "outline": ""
    },
    on: {
      "click": function click($event) {
        return _vm.secondaryAction(_vm.option.id);
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$aqT(_vm.option.buttonSecondary)) + "\n        ")]) : _vm._e(), _vm._v(" "), _vm.option.buttonPrimary !== '' ? _c('aq-button', {
    staticClass: "aq-setting-footer__button-right",
    attrs: {
      "outline": "",
      "color": "blue"
    },
    on: {
      "click": function click($event) {
        return _vm.primaryAction(_vm.option.id);
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$aqT(_vm.option.buttonPrimary)) + "\n        ")]) : _vm._e()], 1)]) : _vm._e()]) : _vm._e()], 1);
};
var __vue_staticRenderFns__$14 = [];

/* style */
var __vue_inject_styles__$14 = undefined;
/* scoped */
var __vue_scope_id__$14 = undefined;
/* module identifier */
var __vue_module_identifier__$14 = undefined;
/* functional template */
var __vue_is_functional_template__$14 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$14 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$14,
  staticRenderFns: __vue_staticRenderFns__$14
}, __vue_inject_styles__$14, __vue_script__$14, __vue_scope_id__$14, __vue_is_functional_template__$14, __vue_module_identifier__$14, false, undefined, undefined, undefined);
var AqSettingContent = __vue_component__$14;

//
//
//
//
//
//

var script$13 = {
  name: 'aq-setting-footer',
  data: function data() {
    return {};
  }
};

/* script */
var __vue_script__$13 = script$13;

/* template */
var __vue_render__$13 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-setting-footer"
  }, [_vm._t("default", function () {
    return [_vm._v("Slot footer")];
  })], 2);
};
var __vue_staticRenderFns__$13 = [];

/* style */
var __vue_inject_styles__$13 = undefined;
/* scoped */
var __vue_scope_id__$13 = undefined;
/* module identifier */
var __vue_module_identifier__$13 = undefined;
/* functional template */
var __vue_is_functional_template__$13 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$13 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$13,
  staticRenderFns: __vue_staticRenderFns__$13
}, __vue_inject_styles__$13, __vue_script__$13, __vue_scope_id__$13, __vue_is_functional_template__$13, __vue_module_identifier__$13, false, undefined, undefined, undefined);
var AqSettingFooter = __vue_component__$13;

//
var script$12 = {
  mixins: [sizeMixin],
  props: {
    state: {
      type: String,
      default: ''
    },
    number: {
      type: [Number, String],
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isNumber: function isNumber() {
      var _this$$slots;
      return this.number !== null || !!((_this$$slots = this.$slots) !== null && _this$$slots !== void 0 && _this$$slots.default);
    },
    getState: function getState() {
      return this.state.toLowerCase();
    }
  }
};

/* script */
var __vue_script__$12 = script$12;

/* template */
var __vue_render__$12 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-badge', 'aq-badge--' + _vm.getState, {
      'aq-badge--number': _vm.isNumber,
      'aq-badge--disabled': _vm.disabled
    }],
    style: _vm.mixinSizeStyle
  }, [[_vm.isNumber ? _vm._t("default", function () {
    return [_vm._v("\n      " + _vm._s(_vm.number) + "\n    ")];
  }) : _vm._e()]], 2);
};
var __vue_staticRenderFns__$12 = [];

/* style */
var __vue_inject_styles__$12 = undefined;
/* scoped */
var __vue_scope_id__$12 = undefined;
/* module identifier */
var __vue_module_identifier__$12 = undefined;
/* functional template */
var __vue_is_functional_template__$12 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$12 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$12,
  staticRenderFns: __vue_staticRenderFns__$12
}, __vue_inject_styles__$12, __vue_script__$12, __vue_scope_id__$12, __vue_is_functional_template__$12, __vue_module_identifier__$12, false, undefined, undefined, undefined);
var AqBadge = __vue_component__$12;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable no-param-reassign */
var script$11 = {
  props: {
    title: {
      type: String,
      default: ''
    },
    close: {
      type: Boolean,
      default: true
    },
    value: {
      type: Boolean,
      default: true
    },
    state: {
      type: String,
      default: 'info',
      validator: function validator(x) {
        return ['info', 'success', 'warning', 'danger'].includes(x.toLowerCase());
      }
    }
  },
  watch: {
    value: function value(newVal) {
      this.onValueChange(newVal);
    }
  },
  data: function data() {
    return {
      visible: false,
      mounted: false,
      showActions: false
    };
  },
  computed: {
    getState: function getState() {
      return !this.state ? 'info' : this.state.toLowerCase();
    },
    getIcon: function getIcon() {
      var icon = 'aq-icon-info-circle-fill';
      if (this.getState === 'warning') {
        icon = 'aq-icon-info-major-triangle-up-fill';
      } else if (this.getState === 'danger') {
        icon = 'aq-icon-alert-circle-fill';
      } else if (this.getState === 'success') {
        icon = 'aq-icon-check-circle-fill';
      }
      return icon;
    }
  },
  methods: {
    onClose: function onClose() {
      this.onValueChange(false);
      this.$emit('input', false);
      this.$emit('close');
    },
    beforeEnter: function beforeEnter(el) {
      if (this.mounted) {
        el.style.height = '0';
      }
    },
    enter: function enter(el) {
      if (this.mounted) {
        el.style.height = "".concat(el.scrollHeight, "px");
      }
    },
    beforeLeave: function beforeLeave(el) {
      if (this.mounted) {
        el.style.height = "".concat(el.scrollHeight, "px");
      }
    },
    leave: function leave(el) {
      if (this.mounted) {
        el.style.height = '0';
      }
    },
    onValueChange: function onValueChange(newVal) {
      var _this = this;
      if (this.mounted) {
        var el = this.$refs.banner;
        el.style.height = "".concat(el.scrollHeight, "px");
      }
      setTimeout(function () {
        _this.visible = newVal;
      }, 10);
    }
  },
  mounted: function mounted() {
    var _this2 = this;
    this.onValueChange(this.value);
    this.showActions = typeof this.$slots.actions !== 'undefined';
    setTimeout(function () {
      _this2.mounted = true;
    }, 20);
  }
};

/* script */
var __vue_script__$11 = script$11;

/* template */
var __vue_render__$11 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('transition', {
    attrs: {
      "name": "collapse"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter,
      "before-leave": _vm.beforeLeave,
      "leave": _vm.leave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    ref: "banner",
    class: ['aq-banner', 'aq-banner--' + _vm.getState]
  }, [_c('div', {
    class: ['aq-banner__status', 'aq-banner__status--' + _vm.getState]
  }), _vm._v(" "), _c('div', {
    staticClass: "aq-banner__container"
  }, [_c('div', {
    class: ['aq-banner__icon', 'aq-banner__icon--' + _vm.getState]
  }, [_c('em', {
    class: _vm.getIcon
  })]), _vm._v(" "), _c('div', {
    staticClass: "aq-banner__content"
  }, [_c('div', {
    class: ['aq-banner__title', _vm.title && 'aq-banner__title--bottom-spacing']
  }, [_vm._v("\n          " + _vm._s(_vm.$aqT(_vm.title)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "aq-banner__text"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm.showActions ? _c('div', {
    staticClass: "aq-banner__actions"
  }, [_vm._t("actions")], 2) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "aq-banner__close",
    on: {
      "click": function click($event) {
        return _vm.onClose();
      }
    }
  }, [_vm.close ? _c('em', {
    staticClass: "aq-icon-close"
  }) : _vm._e()])])])]);
};
var __vue_staticRenderFns__$11 = [];

/* style */
var __vue_inject_styles__$11 = undefined;
/* scoped */
var __vue_scope_id__$11 = undefined;
/* module identifier */
var __vue_module_identifier__$11 = undefined;
/* functional template */
var __vue_is_functional_template__$11 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$11 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$11,
  staticRenderFns: __vue_staticRenderFns__$11
}, __vue_inject_styles__$11, __vue_script__$11, __vue_scope_id__$11, __vue_is_functional_template__$11, __vue_module_identifier__$11, false, undefined, undefined, undefined);
var AqBanner = __vue_component__$11;

//
var script$10 = {
  mixins: [LabelMixin, helperTextMixin],
  props: {
    value: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    text: {
      type: String,
      default: ''
    },
    progress: {
      type: String,
      default: 'number',
      validator: function validator(x) {
        return ['', 'none', 'number', 'text'].includes(x.toLowerCase());
      }
    },
    state: {
      type: String,
      default: 'active',
      validator: function validator(x) {
        return ['', 'active', 'success', 'error', 'paused'].includes(x.toLowerCase());
      }
    },
    isFile: {
      type: Boolean,
      default: false
    },
    name: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: ''
    },
    sizeInfo: {
      type: [String, Function],
      default: ''
    },
    rows: {
      type: String,
      default: ''
    },
    records: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      states: {
        success: 'aqua.completed',
        error: 'aqua.error',
        paused: 'aqua.paused'
      }
    };
  },
  computed: {
    getState: function getState() {
      return !this.state ? 'active' : this.state.toLowerCase();
    },
    isText: function isText() {
      var _this$$aqT;
      return ((_this$$aqT = this.$aqT(this.text)) === null || _this$$aqT === void 0 ? void 0 : _this$$aqT.length) > 0 || this.isLabelVisible;
    },
    valueText: function valueText() {
      var _this$$aqT2;
      return ((_this$$aqT2 = this.$aqT(this.text)) === null || _this$$aqT2 === void 0 ? void 0 : _this$$aqT2.length) > 0 ? this.text : this.label;
    },
    getProgress: function getProgress() {
      return !this.progress ? 'number' : this.progress.toLowerCase();
    },
    getProgressValue: function getProgressValue() {
      var num = this.value !== null ? this.value / this.max * 100 : 0;
      var progress = "".concat(Math.round(num * 100) / 100, "%");
      if (this.progress === 'text') {
        progress = this.$t(this.states[this.getState]);
      }
      return progress;
    },
    isProgress: function isProgress() {
      var isProgress = false;
      if (this.getProgress === 'text' && Object.keys(this.states).includes(this.getState) || this.getProgress === 'number') {
        isProgress = true;
      }
      return isProgress;
    },
    isRecords: function isRecords() {
      var _this$records;
      return ((_this$records = this.records) === null || _this$records === void 0 ? void 0 : _this$records.length) > 0;
    },
    isRows: function isRows() {
      var _this$records2;
      return ((_this$records2 = this.records) === null || _this$records2 === void 0 ? void 0 : _this$records2.length) > 0;
    },
    isSizeInfo: function isSizeInfo() {
      var _this$$aqT3;
      return ((_this$$aqT3 = this.$aqT(this.sizeInfo)) === null || _this$$aqT3 === void 0 ? void 0 : _this$$aqT3.length) > 0;
    },
    isSize: function isSize() {
      var _this$size;
      return ((_this$size = this.size) === null || _this$size === void 0 ? void 0 : _this$size.length) > 0;
    },
    isColor: function isColor() {
      var _this$color;
      return ((_this$color = this.color) === null || _this$color === void 0 ? void 0 : _this$color.length) > 0 && (this.color.startsWith('#') || this.color.startsWith('rgb'));
    },
    customStyle: function customStyle() {
      var style = {};
      if (this.isColor) {
        style['--custom-progress-color'] = this.color;
      }
      return style;
    }
  }
};

/* script */
var __vue_script__$10 = script$10;

/* template */
var __vue_render__$10 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-progress-bar"
  }, [_vm.isFile ? _c('div', [_c('em', {
    staticClass: "aq-progress-bar__icon aq-icon-file"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aq-progress-bar__content"
  }, [_c('div', {
    staticClass: "aq-progress-bar__content__header"
  }, [_c('div', {
    staticClass: "aq-progress-bar__content__label"
  }, [_vm.isText ? _c('aq-label', _vm._b({}, 'aq-label', _vm.bindsLabel, false), [_vm._v(_vm._s(_vm.$aqT(_vm.valueText)))]) : _vm._e(), _vm._v(" "), !_vm.isText && _vm.isFile ? [_c('span', {
    staticClass: "aq-progress-bar__content__label__name"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('div', {
    staticClass: "aq-progress-bar__content__label__size"
  }, [_c('span', {
    staticClass: "aq-progress-bar__content__label__size__text"
  }, [_vm._v(_vm._s(_vm.size))]), _vm._v(" "), _vm.isSizeInfo && _vm.isSize ? _c('aq-divider', {
    staticClass: "aq-progress-bar__content__label__size__divider",
    attrs: {
      "orientation": "vertical"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "aq-progress-bar__content__label__size__info"
  }, [_vm._v(_vm._s(_vm.$aqT(_vm.sizeInfo)))])], 1), _vm._v(" "), _c('div', {
    staticClass: "aq-progress-bar__content__label__rows-info"
  }, [_vm.isRows ? _c('span', {
    staticClass: "aq-progress-bar__content__label__rows-info__title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('aqua.rows')))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "aq-progress-bar__content__label__rows-info__value"
  }, [_vm._v(_vm._s(_vm.rows))]), _vm._v(" "), _vm.isRecords && _vm.isRows ? _c('aq-divider', {
    staticClass: "aq-progress-bar__content__label__rows-info__divider",
    attrs: {
      "orientation": "vertical"
    }
  }) : _vm._e(), _vm._v(" "), _vm.isRecords ? _c('span', {
    staticClass: "aq-progress-bar__content__label__rows-info__title"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('aqua.records')))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "aq-progress-bar__content__label__rows-info__value"
  }, [_vm._v(_vm._s(_vm.records))])], 1)] : _vm._e()], 2), _vm._v(" "), _c('div', {
    class: ['aq-progress-bar__content__status', {
      'aq-progress-bar__content__status--success': _vm.getState === 'success',
      'aq-progress-bar__content__status--error': _vm.getState === 'error',
      'aq-progress-bar__content__status--paused': _vm.getState === 'paused'
    }]
  }, [_vm.getState === 'success' ? _c('em', {
    staticClass: "aq-icon-check-circle-fill"
  }) : _vm._e(), _vm._v(" "), _vm.getState === 'error' ? _c('em', {
    staticClass: "aq-icon-alert-circle-fill"
  }) : _vm._e(), _vm._v(" "), _vm.isProgress ? [_vm._v(" " + _vm._s(_vm.getProgressValue) + " ")] : _vm._e()], 2)]), _vm._v(" "), _c('progress', {
    class: ['progress aq-progress-bar__content__progress', {
      'aq-progress-bar__content__progress--success': _vm.getState === 'success' && !_vm.isColor,
      'aq-progress-bar__content__progress--error': _vm.getState === 'error' && !_vm.isColor,
      'aq-progress-bar__content__progress--paused': _vm.getState === 'paused' && !_vm.isColor,
      'aq-progress-bar__content__progress--custom': _vm.isColor,
      'aq-progress-bar__content__progress__helper-text': _vm.isHelperTextVisible
    }],
    style: _vm.customStyle,
    attrs: {
      "max": _vm.max
    },
    domProps: {
      "value": _vm.value
    }
  }), _vm._v(" "), _vm.isHelperTextVisible ? _c('div', {
    staticClass: "aq-text-field__helper-text aq-progress-bar__helper-text"
  }, [_vm.isHelperTextVisible ? _c('aq-helper-text', _vm._b({}, 'aq-helper-text', _vm.bindsHelperText, false)) : _vm._e()], 1) : _vm._e()])]);
};
var __vue_staticRenderFns__$10 = [];

/* style */
var __vue_inject_styles__$10 = undefined;
/* scoped */
var __vue_scope_id__$10 = undefined;
/* module identifier */
var __vue_module_identifier__$10 = undefined;
/* functional template */
var __vue_is_functional_template__$10 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$10 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$10,
  staticRenderFns: __vue_staticRenderFns__$10
}, __vue_inject_styles__$10, __vue_script__$10, __vue_scope_id__$10, __vue_is_functional_template__$10, __vue_module_identifier__$10, false, undefined, undefined, undefined);
var AqProgressBar = __vue_component__$10;

//
//
//
//
//
//
//
//
//
//

var script$$ = {
  props: {
    size: {
      type: String,
      default: '48',
      validator: function validator(x) {
        return x === '16' || x === '24' || x === '48';
      }
    }
  },
  computed: {
    style: function style() {
      return {
        width: "".concat(this.size, "px"),
        height: "".concat(this.size, "px")
      };
    }
  }
};

/* script */
var __vue_script__$$ = script$$;

/* template */
var __vue_render__$$ = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-spinner"
  }, [_c('div', {
    staticClass: "aq-spinner-load-animation",
    style: _vm.style
  }, [_c('div', {
    staticClass: "aq-spinner-load-animation__1"
  }), _vm._v(" "), _c('div', {
    staticClass: "aq-spinner-load-animation__2"
  }), _vm._v(" "), _c('div', {
    staticClass: "aq-spinner-load-animation__3"
  })])]);
};
var __vue_staticRenderFns__$$ = [];

/* style */
var __vue_inject_styles__$$ = undefined;
/* scoped */
var __vue_scope_id__$$ = undefined;
/* module identifier */
var __vue_module_identifier__$$ = undefined;
/* functional template */
var __vue_is_functional_template__$$ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$$ = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$$,
  staticRenderFns: __vue_staticRenderFns__$$
}, __vue_inject_styles__$$, __vue_script__$$, __vue_scope_id__$$, __vue_is_functional_template__$$, __vue_module_identifier__$$, false, undefined, undefined, undefined);
var AqSpinner = __vue_component__$$;

//
var script$_ = {
  mixins: [sizeMixin],
  props: {
    state: {
      type: String,
      default: 'neutral',
      validator: function validator(x) {
        return ['', 'neutral', 'pending', 'inprogress', 'complete', 'cancel'].includes(x.toLowerCase());
      }
    },
    icon: {
      type: String,
      default: ''
    },
    dot: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    hasIcon: function hasIcon() {
      return this.showDot;
    },
    getState: function getState() {
      return this.state.toLowerCase();
    },
    showIcon: function showIcon() {
      return this.icon !== '';
    },
    showDot: function showDot() {
      return this.icon === '' && this.dot;
    }
  }
};

/* script */
var __vue_script__$_ = script$_;

/* template */
var __vue_render__$_ = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-status', 'aq-status--' + _vm.getState]
  }, [_c('div', {
    class: ['aq-status__content', _vm.hasIcon && 'aq-status__content--spaced'],
    style: _vm.mixinSizeStyle
  }, [_vm.showDot ? _c('div', {
    class: ['aq-status__circle', 'aq-status__circle--' + _vm.getState]
  }) : _vm._e(), _vm._v(" "), _vm.showIcon ? _c('em', {
    class: _vm.icon
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aq-status__content-slot"
  }, [_vm._t("default")], 2)])]);
};
var __vue_staticRenderFns__$_ = [];

/* style */
var __vue_inject_styles__$_ = undefined;
/* scoped */
var __vue_scope_id__$_ = undefined;
/* module identifier */
var __vue_module_identifier__$_ = undefined;
/* functional template */
var __vue_is_functional_template__$_ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$_ = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$_,
  staticRenderFns: __vue_staticRenderFns__$_
}, __vue_inject_styles__$_, __vue_script__$_, __vue_scope_id__$_, __vue_is_functional_template__$_, __vue_module_identifier__$_, false, undefined, undefined, undefined);
var AqStatus = __vue_component__$_;

//
var script$Z = {
  mixins: [sizeMixin],
  props: {
    text: {
      type: [String, Function],
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: ''
    },
    close: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isIcon: function isIcon() {
      var _this$icon;
      return ((_this$icon = this.icon) === null || _this$icon === void 0 ? void 0 : _this$icon.length) > 0;
    },
    getClass: function getClass() {
      var colors = ['', 'cyan', 'teal', 'lime', 'orange', 'rose', 'purple'];
      var className = '';
      var color = this.color.toLowerCase();
      var indexColor = colors.indexOf(color);
      if (color !== '' && indexColor !== -1) {
        className = "aq-tag__".concat(colors[indexColor]);
      } else {
        className = 'aq-tag__default';
      }
      return className;
    }
  },
  methods: {
    onClose: function onClose() {
      if (!this.disabled) {
        this.$emit('onClose');
        this.$emit('close');
      }
    }
  }
};

/* script */
var __vue_script__$Z = script$Z;

/* template */
var __vue_render__$Z = function __vue_render__() {
  var _obj;
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-tag', _vm.getClass, (_obj = {
      'aq-tag--disabled': _vm.disabled
    }, _obj[_vm.getClass + '--disabled'] = _vm.disabled, _obj[_vm.getClass + '--active'] = _vm.active, _obj)],
    style: _vm.mixinSizeStyle
  }, [_vm.isIcon ? _c('span', {
    staticClass: "aq-tag__icon"
  }, [_c('em', {
    class: _vm.icon
  })]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "aq-tag__text"
  }, [_vm._v(_vm._s(_vm.$aqT(_vm.text)))]), _vm._v(" "), _vm.close ? _c('em', {
    staticClass: "aq-icon-close aq-tag__icon-close",
    on: {
      "click": function click($event) {
        return _vm.onClose();
      }
    }
  }) : _vm._e()]);
};
var __vue_staticRenderFns__$Z = [];

/* style */
var __vue_inject_styles__$Z = undefined;
/* scoped */
var __vue_scope_id__$Z = undefined;
/* module identifier */
var __vue_module_identifier__$Z = undefined;
/* functional template */
var __vue_is_functional_template__$Z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$Z = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$Z,
  staticRenderFns: __vue_staticRenderFns__$Z
}, __vue_inject_styles__$Z, __vue_script__$Z, __vue_scope_id__$Z, __vue_is_functional_template__$Z, __vue_module_identifier__$Z, false, undefined, undefined, undefined);
var AqTag = __vue_component__$Z;

//
//
//
//
//
//
//

var script$Y = {
  data: function data() {
    return {
      rightSlot: false
    };
  },
  computed: {
    hasRightSlot: function hasRightSlot() {
      return this.rightSlot;
    }
  },
  mounted: function mounted() {
    this.rightSlot = !!this.$slots['tag-right'];
  }
};

/* script */
var __vue_script__$Y = script$Y;

/* template */
var __vue_render__$Y = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-tag-group"
  }, [_vm._t("default"), _vm._v(" "), _vm._t("content-right")], 2);
};
var __vue_staticRenderFns__$Y = [];

/* style */
var __vue_inject_styles__$Y = undefined;
/* scoped */
var __vue_scope_id__$Y = undefined;
/* module identifier */
var __vue_module_identifier__$Y = undefined;
/* functional template */
var __vue_is_functional_template__$Y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$Y = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$Y,
  staticRenderFns: __vue_staticRenderFns__$Y
}, __vue_inject_styles__$Y, __vue_script__$Y, __vue_scope_id__$Y, __vue_is_functional_template__$Y, __vue_module_identifier__$Y, false, undefined, undefined, undefined);
var AqTagGroup = __vue_component__$Y;

function ownKeys$a(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$a(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$a(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$a(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var script$X = {
  mixins: [LabelMixin, helperTextMixin],
  components: {
    CountryFlag: CountryFlag
  },
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    cleanOnEscape: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: false
    },
    cleanFilterOnSelect: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    allowSelectAll: {
      type: Boolean,
      default: false
    },
    showCheckbox: {
      type: Boolean,
      default: true
    },
    selectedsCounter: {
      type: Boolean,
      default: false
    },
    badgeCounter: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    plain: {
      type: Boolean,
      default: false
    },
    valueArray: {
      type: Boolean,
      default: true
    },
    sublabel: {
      type: [String, Function],
      default: ''
    },
    valueKey: {
      type: String,
      default: 'id'
    },
    textKey: {
      type: String,
      default: 'name'
    },
    type: {
      type: String,
      default: 'input',
      validator: function validator(value) {
        return ['', 'input', 'button'].indexOf(value) !== -1;
      }
    },
    placeholder: {
      type: [String, Function],
      default: ''
    },
    template: {
      type: [String, Function],
      default: ''
    },
    textButton: {
      type: [String, Function],
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    popoverWidth: {
      type: String,
      default: 'auto'
    },
    returnMode: {
      type: String,
      default: 'originalObject'
    },
    idParent: {
      type: String,
      default: ''
    },
    value: {
      default: function _default() {
        return [];
      }
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    maxShowSelect: {
      type: Number,
      default: -1
    },
    maxSelect: {
      type: Number,
      default: -1
    },
    infoBanner: {
      type: Object,
      default: function _default() {}
    },
    emptyStateMessage: {
      type: [String, Function],
      default: ''
    },
    isFlagSelector: {
      type: Boolean,
      default: false
    },
    fontSizeSelectedOption: {
      type: String,
      default: '',
      validator: function validator(value) {
        return ['', '14px', '16px', '20px', '28px', '32px', '42px', '54px'].indexOf(value) !== -1;
      }
    },
    isSlot: {
      type: Boolean,
      default: false
    },
    showRadio: {
      type: Boolean,
      default: false
    },
    isFullName: {
      type: Boolean,
      default: false
    },
    showIconClose: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      events: EVENTS,
      showDropdown: false,
      visibleIconClose: true,
      firstLoad: true,
      selected: [],
      returned: null,
      parsedValue: [],
      searchInput: '',
      withFilter: true,
      autocomplete: 'nope',
      style: {
        fontSize: ''
      }
    };
  },
  watch: {
    fontSizeSelectedOption: function fontSizeSelectedOption() {
      this.setFontSizeSelectedOption();
    }
  },
  computed: {
    getFontSpacing: function getFontSpacing() {
      switch (this.fontSizeSelectedOption) {
        case '14px':
        case '16px':
        case '20px':
          return 'aq-autocomplete-input__input--small';
        case '28px':
        case '32px':
        case '42px':
          return 'aq-autocomplete-input__input--medium';
        case '54px':
          return 'aq-autocomplete-input__input--bigger';
        default:
          return 'aq-autocomplete-input__input--small';
      }
    },
    isDisabled: function isDisabled() {
      return this.disabled || this.disabled && this.error;
    },
    isError: function isError() {
      return this.error && !this.disabled;
    },
    amountOtherOptons: function amountOtherOptons() {
      var _this$selected;
      var amount = 0;
      if (this.multiple && this.maxShowSelect > -1 && ((_this$selected = this.selected) === null || _this$selected === void 0 ? void 0 : _this$selected.length) - this.maxShowSelect > 0) {
        if (this.maxShowSelect === 0) {
          var _this$selected2;
          amount = (_this$selected2 = this.selected) === null || _this$selected2 === void 0 ? void 0 : _this$selected2.length;
        } else {
          var _this$selected3;
          amount = ((_this$selected3 = this.selected) === null || _this$selected3 === void 0 ? void 0 : _this$selected3.length) - this.maxShowSelect;
        }
      }
      return amount;
    },
    selectOptionsToDisplay: function selectOptionsToDisplay() {
      var selectedItems = this.selected;
      if (this.maxShowSelect > 0) {
        selectedItems = this.selected.slice(0, this.maxShowSelect);
      } else if (this.maxShowSelect === 0) {
        selectedItems = [];
      }
      return selectedItems;
    },
    getFilter: function getFilter() {
      return this.withFilter ? this.searchInput : '';
    },
    isLabelVisible: function isLabelVisible() {
      var _this$label;
      return typeof this.label === 'function' || ((_this$label = this.label) === null || _this$label === void 0 ? void 0 : _this$label.length) > 0;
    },
    isHelperTextVisible: function isHelperTextVisible() {
      var _this$helperText;
      return ((_this$helperText = this.helperText) === null || _this$helperText === void 0 ? void 0 : _this$helperText.length) > 0;
    },
    getCharcounter: function getCharcounter() {
      var _this$selected4, _this$selected5, _this$selected6;
      var charCounter = '';
      switch (true) {
        case this.selectedsCounter && this.maxSelect > 0:
          charCounter = "".concat((_this$selected4 = this.selected) === null || _this$selected4 === void 0 ? void 0 : _this$selected4.length, "/").concat(this.maxSelect);
          break;
        case this.selectedsCounter && this.maxSelect < 0 && ((_this$selected5 = this.selected) === null || _this$selected5 === void 0 ? void 0 : _this$selected5.length) >= 1:
          charCounter = "".concat((_this$selected6 = this.selected) === null || _this$selected6 === void 0 ? void 0 : _this$selected6.length);
          break;
        case !this.maxSelect && this.maxSelect < 0:
          charCounter = '';
          break;
      }
      return charCounter;
    },
    isCharCounterVisible: function isCharCounterVisible() {
      return this.selectedsCounter && this.maxSelect;
    },
    sublabelRequired: function sublabelRequired() {
      var _this$$aqT, _this$$aqT2;
      return this.required && ((_this$$aqT = this.$aqT(this.label)) === null || _this$$aqT === void 0 ? void 0 : _this$$aqT.length) === 0 && ((_this$$aqT2 = this.$aqT(this.sublabel)) === null || _this$$aqT2 === void 0 ? void 0 : _this$$aqT2.length) > 0;
    },
    getFlag: function getFlag() {
      var _this$selected$, _this$selected$$optio, _this$selected$$optio2;
      return (_this$selected$ = this.selected[0]) === null || _this$selected$ === void 0 ? void 0 : (_this$selected$$optio = _this$selected$.option) === null || _this$selected$$optio === void 0 ? void 0 : (_this$selected$$optio2 = _this$selected$$optio.flag) === null || _this$selected$$optio2 === void 0 ? void 0 : _this$selected$$optio2.toLowerCase();
    },
    getTop: function getTop() {
      return this.style.fontSize === '' && this.style.fontSize === '14px';
    },
    getIconLength: function getIconLength() {
      var _this$icon;
      return ((_this$icon = this.icon) === null || _this$icon === void 0 ? void 0 : _this$icon.length) > 0;
    },
    getSublabelLength: function getSublabelLength() {
      var _this$$aqT3;
      return ((_this$$aqT3 = this.$aqT(this.sublabel)) === null || _this$$aqT3 === void 0 ? void 0 : _this$$aqT3.length) > 0;
    },
    getSelectedLength: function getSelectedLength() {
      var _this$selected7;
      return (_this$selected7 = this.selected) === null || _this$selected7 === void 0 ? void 0 : _this$selected7.length;
    },
    isUsa: function isUsa() {
      var _this$selected$2, _this$selected$2$opti, _this$selected$2$opti2;
      return ((_this$selected$2 = this.selected[0]) === null || _this$selected$2 === void 0 ? void 0 : (_this$selected$2$opti = _this$selected$2.option) === null || _this$selected$2$opti === void 0 ? void 0 : (_this$selected$2$opti2 = _this$selected$2$opti.flag) === null || _this$selected$2$opti2 === void 0 ? void 0 : _this$selected$2$opti2.length) > 6;
    }
  },
  methods: {
    validateValue: function validateValue(newVal, oldVal) {
      if (newVal && oldVal) {
        var _Object$keys, _Object$keys2, _this$selected8, _this$parsedValue;
        if (!this.multiple && (this.value === '' || ((_Object$keys = Object.keys(newVal)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) === 0 && ((_Object$keys2 = Object.keys(oldVal)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2.length) > 0)) {
          this.cleanSelections();
        } else if (this.multiple && ((newVal === null || newVal === void 0 ? void 0 : newVal.length) !== ((_this$selected8 = this.selected) === null || _this$selected8 === void 0 ? void 0 : _this$selected8.length) || this.compareParsedValue(newVal, this.parsedValue))) {
          this.$refs.dropdown.selectItems(newVal);
        } else if (!this.multiple && this.valueArray && newVal[0] && oldVal[0] && ((_this$parsedValue = this.parsedValue) === null || _this$parsedValue === void 0 ? void 0 : _this$parsedValue.length) > 0 && newVal[0][this.valueKey] !== this.parsedValue[0][this.valueKey]) {
          this.$refs.dropdown.selectItems(newVal);
        }
      }
    },
    onOpen: function onOpen() {
      this.showDropdown = true;
      this.$emit(EVENT_NAME_OPEN);
    },
    onClose: function onClose() {
      this.showDropdown = false;
      this.$emit(EVENT_NAME_CLOSE);
      this.verifyInput();
    },
    onChange: function onChange(value) {
      this.selected = value;
      var parsedValue = this.parseValue(value);
      if (this.compareParsedValue(parsedValue, this.parsedValue)) {
        this.parsedValue = parsedValue;
        this.$emit('input', this.parsedValue);
        this.$emit(EVENT_NAME_CHANGE, this.parsedValue);
        this.verifyInput();
      }
    },
    compareParsedValue: function compareParsedValue(value1, value2) {
      var comparator;
      if (this.multiple || this.valueArray) {
        comparator = !compareValuesByPosition(value1, value2, this.valueKey, this.returnMode === 'keys');
      } else if (this.returnMode === 'keys') {
        comparator = value1 !== value2;
      } else {
        comparator = value1[this.valueKey] !== value2[this.valueKey];
      }
      return comparator;
    },
    parseValue: function parseValue(value) {
      var _this = this;
      var items;
      if (this.multiple) {
        if (this.returnMode === 'keys') {
          items = value.map(function (x) {
            return x[_this.valueKey];
          });
        } else if (this.returnMode === 'originalObject') {
          items = value.map(function (x) {
            return _objectSpread$a({}, x.originalData);
          });
        } else {
          items = value.map(function (x) {
            var _ref;
            return _ref = {}, _defineProperty$1(_ref, _this.valueKey, x[_this.valueKey]), _defineProperty$1(_ref, _this.textKey, x[_this.textKey]), _ref;
          });
        }
      } else if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
        var _value = _slicedToArray(value, 1),
          item = _value[0];
        if (this.returnMode === 'keys') {
          items = item[this.valueKey];
        } else if (this.returnMode === 'originalObject') {
          items = _objectSpread$a({}, item.originalData);
        } else {
          var _items;
          items = (_items = {}, _defineProperty$1(_items, this.valueKey, item[this.valueKey]), _defineProperty$1(_items, this.textKey, item[this.textKey]), _items);
        }
      } else if (this.returnMode === 'keys') {
        items = '';
      } else {
        items = {};
      }
      if (!this.multiple && this.valueArray) {
        var _Object$keys3;
        if (items === '' || _typeof$2(items) === 'object' && ((_Object$keys3 = Object.keys(items)) === null || _Object$keys3 === void 0 ? void 0 : _Object$keys3.length) === 0) {
          items = [];
        } else {
          items = [items];
        }
      }
      this.returned = items;
      return items;
    },
    setWithFilter: function setWithFilter($event) {
      this.withFilter = $event;
    },
    closeDropdown: function closeDropdown() {
      this.showDropdown = false;
      this.verifyInput();
    },
    toggleDropdown: function toggleDropdown() {
      var _this2 = this;
      if (this.showDropdown) {
        setTimeout(function () {
          return _this2.$refs.dropdown.hide();
        });
      }
    },
    cleanSelections: function cleanSelections() {
      this.$refs.dropdown.selectAll(false, true);
    },
    deselectItem: function deselectItem(item) {
      var _this3 = this;
      setTimeout(function () {
        return _this3.$refs.dropdown.selectItem({
          index: item.index,
          value: false
        });
      });
    },
    verifyInput: function verifyInput() {
      if (this.multiple) {
        if (this.cleanFilterOnSelect) {
          this.searchInput = '';
          this.withFilter = false;
        }
      } else {
        var _this$selected$3, _this$selected$4, _this$options, _this$selected9;
        var textKey = this.isFlagSelector ? (_this$selected$3 = this.selected[0]) === null || _this$selected$3 === void 0 ? void 0 : _this$selected$3.option.naming : this.$aqT((_this$selected$4 = this.selected[0]) === null || _this$selected$4 === void 0 ? void 0 : _this$selected$4[this.textKey]);
        this.searchInput = ((_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.length) > 0 && ((_this$selected9 = this.selected) === null || _this$selected9 === void 0 ? void 0 : _this$selected9.length) > 0 ? textKey : '';
        this.withFilter = false;
      }
    },
    setFontSizeSelectedOption: function setFontSizeSelectedOption() {
      this.style.fontSize = this.fontSizeSelectedOption;
    },
    getTagProperty: function getTagProperty(item, key) {
      return item.option[key] ? item.option[key] : '';
    }
  },
  mounted: function mounted() {
    this.setFontSizeSelectedOption();
  }
};

/* script */
var __vue_script__$X = script$X;

/* template */
var __vue_render__$X = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-autocomplete-content', {
      'aq-autocomplete-content--input': _vm.type === 'input'
    }]
  }, [_vm.isLabelVisible ? _c('aq-label', _vm._b({
    staticClass: "aq-autocomplete__label"
  }, 'aq-label', _vm.bindsLabel, false), [_vm._v("\n    " + _vm._s(_vm.$aqT(_vm.label)) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('aq-list-menu', {
    ref: "dropdown",
    attrs: {
      "options": _vm.options,
      "textKey": _vm.textKey,
      "valueKey": _vm.valueKey,
      "multiple": _vm.multiple,
      "allowSelectAll": _vm.allowSelectAll,
      "popoverWidth": _vm.popoverWidth,
      "cleanOnEscape": _vm.cleanOnEscape,
      "value": _vm.value,
      "returnMode": _vm.returnMode,
      "oldValue": _vm.parsedValue,
      "filter": _vm.getFilter,
      "focus": false,
      "disabled": _vm.disabled || _vm.readonly || _vm.loading,
      "valueArray": _vm.valueArray,
      "closeOnSelect": _vm.closeOnSelect,
      "idParent": _vm.idParent,
      "maxSelect": _vm.maxSelect,
      "infoBanner": _vm.infoBanner,
      "emptyStateMessage": _vm.emptyStateMessage,
      "isFlagSelector": _vm.isFlagSelector,
      "showCheckbox": _vm.showCheckbox,
      "showRadio": _vm.showRadio,
      "isFullName": _vm.isFullName
    },
    on: _vm._d({
      "setWithFilter": _vm.setWithFilter
    }, [_vm.events.EVENT_NAME_CLOSE, _vm.onClose, _vm.events.EVENT_NAME_OPEN, _vm.onOpen, _vm.events.EVENT_NAME_CHANGE, _vm.onChange]),
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_vm._t("header")];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function fn() {
        return [_vm._t("footer")];
      },
      proxy: true
    }, {
      key: "item",
      fn: function fn(ref) {
        var text = ref.text;
        var source = ref.source;
        return [_vm._t("item", null, {
          "text": text,
          "source": source
        })];
      }
    }], null, true)
  }, [_vm.type === 'input' ? _c('button', {
    class: ['aq-autocomplete-input', {
      'aq-autocomplete-input--focus': _vm.showDropdown,
      'aq-autocomplete-input--loading': _vm.loading,
      'aq-autocomplete-input--disabled': _vm.isDisabled,
      'aq-autocomplete-input--error': _vm.isError,
      'aq-autocomplete-input--readonly': _vm.readonly,
      'aq-autocomplete-input--badge': _vm.badgeCounter,
      'aq-autocomplete-input--plain': _vm.plain
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "mouseover": function mouseover($event) {
        _vm.visibleIconClose = true;
      },
      "mouseleave": function mouseleave($event) {
        _vm.visibleIconClose = false;
      }
    }
  }, [_vm.getIconLength && !_vm.isFlagSelector ? _c('em', {
    class: ['aq-autocomplete__icon', _vm.icon]
  }) : _vm._e(), _vm._v(" "), _vm.isFlagSelector && _vm.getSelectedLength > 0 && !_vm.isUsa ? _c('country-flag', {
    class: ['aq-dropdown-item__flag--country', {
      'aq-dropdown-item__flag--country--slot': _vm.isSlot
    }],
    attrs: {
      "country": _vm.getFlag,
      "size": "normal"
    }
  }) : _vm._e(), _vm._v(" "), _vm.getSublabelLength ? _c('span', {
    staticClass: "aq-autocomplete__sublabel"
  }, [_vm._v("\n        " + _vm._s(_vm.$aqT(_vm.sublabel)) + "\n        "), _vm.sublabelRequired ? _c('span', {
    staticClass: "aq-label__requided"
  }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.multiple ? [_vm._l(_vm.selectOptionsToDisplay, function (item, key, index) {
    return _c('aq-tag', {
      key: index,
      attrs: {
        "text": item[_vm.textKey],
        "close": !_vm.isDisabled && !_vm.readonly && !_vm.loading,
        "width": _vm.getTagProperty(item, 'tagWidth'),
        "icon": _vm.getTagProperty(item, 'tagIcon'),
        "color": _vm.getTagProperty(item, 'tagColor')
      },
      on: _vm._d({}, [_vm.events.EVENT_NAME_CLOSE, function ($event) {
        return _vm.deselectItem(item);
      }])
    });
  }), _vm._v(" "), _vm.amountOtherOptons > 0 ? _c('div', {
    staticClass: "aq-autocomplete-input__others"
  }, [_c('aq-tag', {
    attrs: {
      "text": _vm.amountOtherOptons + ' Sel.',
      "close": !_vm.isDisabled && !_vm.readonly && !_vm.loading
    },
    on: _vm._d({}, [_vm.events.EVENT_NAME_CLOSE, function ($event) {
      return _vm.cleanSelections();
    }])
  })], 1) : _vm._e()] : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchInput,
      expression: "searchInput"
    }],
    ref: "input_dropdown",
    class: ['aq-autocomplete-input__input', _vm.getFontSpacing, {
      'aq-autocomplete-input__input-flag--slot': _vm.isFlagSelector && _vm.isSlot
    }, {
      'aq-autocomplete-input__input-flag': _vm.isFlagSelector && !_vm.isSlot
    }],
    style: _vm.style,
    attrs: {
      "autocomplete": _vm.autocomplete,
      "type": "text",
      "placeholder": _vm.$aqT(_vm.placeholder),
      "disabled": _vm.isDisabled || _vm.loading,
      "readonly": _vm.readonly
    },
    domProps: {
      "value": _vm.searchInput
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.searchInput = $event.target.value;
      }
    }
  }), _vm._v(" "), _vm.badgeCounter && _vm.multiple && _vm.getSelectedLength > 0 ? _c('aq-badge', {
    class: ['aq-autocomplete__badge-counter', {
      'aq-autocomplete__badge-counter--readonly': _vm.readonly
    }],
    attrs: {
      "number": _vm.getSelectedLength,
      "disabled": _vm.isDisabled || _vm.loading
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('em', {
    class: ['aq-icon-close', 'aq-autocomplete-input__icon-close', {
      'aq-autocomplete-input__icon-close--active': _vm.visibleIconClose && _vm.showIconClose && _vm.getSelectedLength > 0 && !_vm.isDisabled && !_vm.readonly
    }, {
      'aq-autocomplete-input__icon--font': _vm.getTop
    }],
    on: {
      "click": function click($event) {
        return _vm.cleanSelections();
      }
    }
  }), _vm._v(" "), !_vm.readonly && !_vm.loading ? _c('em', {
    class: ['aq-icon-chevron-down', 'aq-autocomplete-input__icon', {
      'aq-autocomplete-input__icon--active': _vm.showDropdown
    }, {
      'aq-autocomplete-input__icon--font': _vm.getTop
    }],
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) {
          return null;
        }
        return _vm.toggleDropdown();
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.loading ? _c('span', {
    staticClass: "aq-autocomplete-input__loader-icon"
  }, [_c('aq-spinner', {
    attrs: {
      "size": "16",
      "value": _vm.loading
    }
  })], 1) : _vm._e()])], 2) : _c('aq-button', {
    class: [{
      'aq-select-input--focus': _vm.showDropdown,
      'aq-select-input--disabled': _vm.isDisabled,
      'aq-select-input--error': _vm.isError,
      'aq-select-input--readonly': _vm.readonly,
      'aq-select-input--badge': _vm.badgeCounter
    }],
    attrs: {
      "outline": "",
      "icon": _vm.icon
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$aqT(_vm.textButton)) + "\n      "), _vm.multiple ? _c('aq-badge', {
    attrs: {
      "number": _vm.getSelectedLength,
      "disabled": _vm.isDisabled || _vm.loading
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _vm.isHelperTextVisible || _vm.isCharCounterVisible ? _c('div', {
    staticClass: "aq-autocomplete__footer"
  }, [_vm.isHelperTextVisible ? _c('div', {
    staticClass: "aq-autocomplete__helper-text"
  }, [_vm.isHelperTextVisible ? _c('aq-helper-text', _vm._b({}, 'aq-helper-text', _vm.bindsHelperText, false)) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.isCharCounterVisible ? _c('div', {
    staticClass: "aq-char-counter"
  }, [_vm._v("\n      " + _vm._s(_vm.getCharcounter) + "\n    ")]) : _vm._e()]) : _vm._e()], 1);
};
var __vue_staticRenderFns__$X = [];

/* style */
var __vue_inject_styles__$X = undefined;
/* scoped */
var __vue_scope_id__$X = undefined;
/* module identifier */
var __vue_module_identifier__$X = undefined;
/* functional template */
var __vue_is_functional_template__$X = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$X = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$X,
  staticRenderFns: __vue_staticRenderFns__$X
}, __vue_inject_styles__$X, __vue_script__$X, __vue_scope_id__$X, __vue_is_functional_template__$X, __vue_module_identifier__$X, false, undefined, undefined, undefined);
var AqAutoComplete = __vue_component__$X;

//
var script$W = {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    label: {
      type: [String, Function],
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    info: {
      type: [String, Function],
      default: ''
    },
    tooltipWidth: {
      type: String,
      default: ''
    },
    isGroup: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: function value() {
      this.valueCheckbox = this.value;
    },
    valueCheckbox: function valueCheckbox() {
      this.$emit('input', this.valueCheckbox);
      this.$emit(EVENT_NAME_CHANGE, this.valueCheckbox);
    },
    indeterminate: function indeterminate() {
      this.verifyIndeterminate();
    },
    id: function id() {
      this.validateId();
    }
  },
  data: function data() {
    return {
      valueCheckbox: false,
      uid: this.id
    };
  },
  computed: {
    isLabelVisible: function isLabelVisible() {
      var _this$label;
      return typeof this.label === 'function' || ((_this$label = this.label) === null || _this$label === void 0 ? void 0 : _this$label.length) > 0;
    },
    infoIsVisible: function infoIsVisible() {
      var _this$info;
      return typeof this.info === 'function' || ((_this$info = this.info) === null || _this$info === void 0 ? void 0 : _this$info.length) > 0;
    }
  },
  methods: {
    setIndeterminate: function setIndeterminate() {
      var checkbox = this.$refs.checkbox;
      checkbox.indeterminate = this.indeterminate;
    },
    verifyClick: function verifyClick(event) {
      /*
      if (this.indeterminate) {
      event.preventDefault();
      }
      */
      event.stopPropagation();
      this.onClick(event);
    },
    onClick: function onClick(event) {
      this.$emit('click', event);
    },
    validateId: function validateId() {
      var _this$id;
      this.uid = ((_this$id = this.id) === null || _this$id === void 0 ? void 0 : _this$id.length) > 0 ? this.id : AquaRamdomId('-checkbox');
    },
    verifyIndeterminate: function verifyIndeterminate() {
      this.setIndeterminate();
    }
  },
  mounted: function mounted() {
    this.valueCheckbox = this.value;
    this.validateId();
    this.verifyIndeterminate();
  }
};

/* script */
var __vue_script__$W = script$W;

/* template */
var __vue_render__$W = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-checkbox-container', {
      'aq-checkbox-container__group': _vm.isGroup
    }]
  }, [_c('label', {
    class: ['aq-checkbox', {
      'aq-checkbox__group': _vm.isGroup
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.valueCheckbox,
      expression: "valueCheckbox"
    }],
    ref: "checkbox",
    staticClass: "aq-checkbox__input",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disabled,
      "id": _vm.uid,
      "indeterminate": _vm.indeterminate
    },
    domProps: {
      "checked": Array.isArray(_vm.valueCheckbox) ? _vm._i(_vm.valueCheckbox, null) > -1 : _vm.valueCheckbox
    },
    on: {
      "click": function click($event) {
        return _vm.verifyClick($event);
      },
      "change": function change($event) {
        var $$a = _vm.valueCheckbox,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.valueCheckbox = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.valueCheckbox = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.valueCheckbox = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    class: ['aq-checkbox__item', {
      'aq-checkbox__item__group': _vm.isGroup
    }]
  })]), _vm._v(" "), _c('div', {
    staticClass: "aq-checkbox__label_container"
  }, [_vm.isLabelVisible ? _c('label', {
    class: ['aq-checkbox__label', {
      'aq-checkbox__label__group': _vm.isGroup
    }],
    attrs: {
      "for": _vm.uid
    }
  }, [_vm.icon !== '' ? _c('em', {
    class: ['aq-checkbox__icon', _vm.icon]
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "aq-checkbox__span"
  }, [_vm._v(_vm._s(_vm.$aqT(_vm.label)))])]) : _vm._e(), _vm._v(" "), _vm.required ? _c('span', {
    staticClass: "aq-checkbox--required"
  }) : _vm._e(), _vm._v(" "), _vm.info !== '' ? _c('aq-tooltip', {
    attrs: {
      "width": _vm.tooltipWidth
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_vm.infoIsVisible ? _c('em', {
          staticClass: "aq-icon-info-circle aq-label__info",
          attrs: {
            "aria-hidden": "true"
          }
        }) : _vm._e()];
      },
      proxy: true
    }], null, false, 3469509749)
  }, [_vm._v(" "), [_vm._v("\n        " + _vm._s(_vm.$aqT(_vm.info)) + "\n      ")]], 2) : _vm._e()], 1)]);
};
var __vue_staticRenderFns__$W = [];

/* style */
var __vue_inject_styles__$W = undefined;
/* scoped */
var __vue_scope_id__$W = undefined;
/* module identifier */
var __vue_module_identifier__$W = undefined;
/* functional template */
var __vue_is_functional_template__$W = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$W = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$W,
  staticRenderFns: __vue_staticRenderFns__$W
}, __vue_inject_styles__$W, __vue_script__$W, __vue_scope_id__$W, __vue_is_functional_template__$W, __vue_module_identifier__$W, false, undefined, undefined, undefined);
var AqCheckbox = __vue_component__$W;

//
var script$V = {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    indeterminate: {
      type: Boolean,
      default: false
    },
    last: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    label: {
      type: [String, Function],
      default: ''
    },
    position: {
      type: String,
      default: ''
    },
    orientation: {
      type: String,
      default: '',
      validator: function validator(x) {
        return ['', 'vertical', 'horizontal'].includes(x.toLowerCase());
      }
    }
  },
  watch: {
    value: function value() {
      this.changeValue();
    },
    valueCheckbox: function valueCheckbox() {
      this.$emit('input', this.valueCheckbox);
      this.$emit(EVENT_NAME_CHANGE, this.valueCheckbox);
    },
    indeterminate: function indeterminate() {
      this.verifyIndeterminate();
    },
    id: function id() {
      this.validateId();
    }
  },
  data: function data() {
    return {
      valueCheckbox: false,
      uid: this.id
    };
  },
  computed: {
    colorButton: function colorButton() {
      var color = 'default';
      if (this.valueCheckbox) {
        color = 'blue';
      }
      return color;
    },
    getOrientation: function getOrientation() {
      return !this.vertical ? 'vertical' : 'horizontal';
    }
  },
  methods: {
    setIndeterminate: function setIndeterminate() {
      var checkbox = this.$refs.checkbox;
      checkbox.indeterminate = this.indeterminate;
    },
    verifyClick: function verifyClick(event) {
      if (this.indeterminate) {
        event.preventDefault();
      }
      this.onClick();
    },
    onClick: function onClick() {
      this.$emit(EVENT_NAME_CLICK);
    },
    validateId: function validateId() {
      var _this$id;
      this.uid = ((_this$id = this.id) === null || _this$id === void 0 ? void 0 : _this$id.length) > 0 ? this.id : AquaRamdomId('-checkbox-button');
    },
    toggleCheckbox: function toggleCheckbox() {
      this.valueCheckbox = !this.valueCheckbox;
    },
    changeValue: function changeValue() {
      this.valueCheckbox = this.value ? this.value : false;
    },
    verifyIndeterminate: function verifyIndeterminate() {
      this.setIndeterminate();
    }
  },
  mounted: function mounted() {
    this.changeValue();
    this.validateId();
  }
};

/* script */
var __vue_script__$V = script$V;

/* template */
var __vue_render__$V = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-checkbox-button', {
      'aq-checkbox-button--vertical': _vm.vertical
    }]
  }, [_c('label', {
    staticClass: "aq-checkbox-button-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.valueCheckbox,
      expression: "valueCheckbox"
    }],
    staticClass: "aq-checkbox__input",
    attrs: {
      "type": "checkbox",
      "disabled": _vm.disabled,
      "id": _vm.id
    },
    domProps: {
      "checked": Array.isArray(_vm.valueCheckbox) ? _vm._i(_vm.valueCheckbox, null) > -1 : _vm.valueCheckbox
    },
    on: {
      "click": function click($event) {
        return _vm.verifyClick($event);
      },
      "change": function change($event) {
        var $$a = _vm.valueCheckbox,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.valueCheckbox = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.valueCheckbox = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.valueCheckbox = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('aq-button', {
    class: ['aq-button--checkbox-' + _vm.position, {
      'aq-button--checkbox-vertical': _vm.vertical,
      'aq-button--orientation-vertical': _vm.orientation === 'vertical'
    }],
    attrs: {
      "disabled": _vm.disabled,
      "color": _vm.colorButton,
      "icon": _vm.icon,
      "outline": "",
      "orientation": _vm.orientation
    },
    on: {
      "click": _vm.toggleCheckbox
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$aqT(_vm.label)) + "\n    ")])], 1), _vm._v(" "), !_vm.last ? _c('aq-divider', {
    attrs: {
      "orientation": _vm.getOrientation
    }
  }) : _vm._e()], 1);
};
var __vue_staticRenderFns__$V = [];

/* style */
var __vue_inject_styles__$V = undefined;
/* scoped */
var __vue_scope_id__$V = undefined;
/* module identifier */
var __vue_module_identifier__$V = undefined;
/* functional template */
var __vue_is_functional_template__$V = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$V = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$V,
  staticRenderFns: __vue_staticRenderFns__$V
}, __vue_inject_styles__$V, __vue_script__$V, __vue_scope_id__$V, __vue_is_functional_template__$V, __vue_module_identifier__$V, false, undefined, undefined, undefined);
var AqCheckboxButton = __vue_component__$V;

//
var script$U = {
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    urlImage: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    iconrlImage: {
      type: String,
      default: ''
    },
    label: {
      type: [String, Function],
      default: ''
    },
    helperText: {
      type: [String, Function],
      default: ''
    },
    indeterminate: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: function value() {
      this.changeValue();
    },
    valueCheckbox: function valueCheckbox() {
      this.$emit('input', this.valueCheckbox);
      this.$emit(EVENT_NAME_CHANGE, this.valueCheckbox);
    },
    id: function id() {
      this.validateId();
    }
  },
  data: function data() {
    return {
      valueCheckbox: false,
      uid: this.id,
      localIndeterminate: false
    };
  },
  computed: {
    isSelected: function isSelected() {
      return this.valueCheckbox;
    },
    isIcon: function isIcon() {
      var _this$icon;
      return ((_this$icon = this.icon) === null || _this$icon === void 0 ? void 0 : _this$icon.length) > 0;
    },
    isImage: function isImage() {
      var _this$urlImage;
      return ((_this$urlImage = this.urlImage) === null || _this$urlImage === void 0 ? void 0 : _this$urlImage.length) > 0;
    },
    isHelperText: function isHelperText() {
      var _this$helperText;
      return typeof this.helperText === 'function' || ((_this$helperText = this.helperText) === null || _this$helperText === void 0 ? void 0 : _this$helperText.length) > 0;
    }
  },
  methods: {
    setValueRadio: function setValueRadio() {
      this.valueCheckbox = this.value;
    },
    toggleCheckbox: function toggleCheckbox() {
      this.valueCheckbox = !this.valueCheckbox;
      if (this.indeterminate) {
        this.localIndeterminate = !this.valueCheckbox;
      }
    },
    validateId: function validateId() {
      var _this$id;
      this.uid = ((_this$id = this.id) === null || _this$id === void 0 ? void 0 : _this$id.length) > 0 ? this.id : AquaRamdomId('-checkbox-card');
    },
    changeValue: function changeValue() {
      this.valueCheckbox = this.value;
    }
  },
  mounted: function mounted() {
    this.localIndeterminate = this.indeterminate;
    this.changeValue();
    this.validateId();
  }
};

/* script */
var __vue_script__$U = script$U;

/* template */
var __vue_render__$U = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    attrs: {
      "for": _vm.uid
    }
  }, [_c('aq-button', {
    class: ['aq-checkbox-card', {
      'aq-checkbox-card--helperText': _vm.isHelperText,
      'aq-checkbox-card--checked': _vm.valueCheckbox
    }],
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.toggleCheckbox
    }
  }, [_c('div', {
    class: ['aq-checkbox-card__header', {
      'aq-checkbox-card__header--helperText': _vm.isHelperText
    }]
  }, [_c('aq-checkbox', {
    attrs: {
      "indeterminate": _vm.localIndeterminate,
      "disabled": _vm.disabled,
      "id": _vm.uid
    },
    model: {
      value: _vm.valueCheckbox,
      callback: function callback($$v) {
        _vm.valueCheckbox = $$v;
      },
      expression: "valueCheckbox"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "aq-checkbox-card__content"
  }, [_c('div', {
    staticClass: "aq-checkbox-card__helperText"
  }, [_c('div', {
    staticClass: "aq-checkbox-card__title"
  }, [_vm.isIcon || _vm.isImage ? _c('div', {
    staticClass: "aq-checkbox-card__image"
  }, [_vm.isIcon ? _c('em', {
    class: _vm.icon
  }) : _vm._e(), _vm._v(" "), _vm.isImage ? _c('img', {
    attrs: {
      "src": _vm.urlImage,
      "alt": "checkbox card"
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aq-checkbox-card__label"
  }, [_vm._v(_vm._s(_vm.$aqT(_vm.label)))])]), _vm._v(" "), _c('aq-caption', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.$aqT(_vm.helperText)))])], 1)])])], 1);
};
var __vue_staticRenderFns__$U = [];

/* style */
var __vue_inject_styles__$U = undefined;
/* scoped */
var __vue_scope_id__$U = undefined;
/* module identifier */
var __vue_module_identifier__$U = undefined;
/* functional template */
var __vue_is_functional_template__$U = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$U = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$U,
  staticRenderFns: __vue_staticRenderFns__$U
}, __vue_inject_styles__$U, __vue_script__$U, __vue_scope_id__$U, __vue_is_functional_template__$U, __vue_module_identifier__$U, false, undefined, undefined, undefined);
var AqCheckboxCard = __vue_component__$U;

function ownKeys$9(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$9(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$9(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$9(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var script$T = {
  mixins: [LabelMixin, helperTextMixin],
  props: {
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    error: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'checkbox',
      validator: function validator(x) {
        return ['', 'checkbox', 'checkboxbutton', 'checkboxcard'].includes(x.toLowerCase());
      }
    },
    orientation: {
      type: String,
      default: 'vertical',
      validator: function validator(x) {
        return ['', 'vertical', 'horizontal'].includes(x.toLowerCase());
      }
    },
    returnMode: {
      type: String,
      default: 'values',
      validator: function validator(x) {
        return ['', 'values', 'originalobject'].includes(x.toLowerCase());
      }
    }
  },
  watch: {
    valueRadio: function valueRadio() {
      this.$emit('input', this.valueRadio);
      this.$emit(EVENT_NAME_CHANGE, this.valueRadio);
    },
    options: function options() {
      this.parseOptions();
    },
    selectedItems: function selectedItems() {
      this.onSelectedItemsChanged();
    },
    value: function value() {
      this.changeValue();
    }
  },
  data: function data() {
    return {
      valueRadio: '',
      optionsCheckbox: []
    };
  },
  computed: {
    isVertical: function isVertical() {
      return this.orientation && this.orientation.toLowerCase() === 'vertical';
    },
    getType: function getType() {
      return this.type.toLowerCase();
    },
    isLabel: function isLabel() {
      var _this$label;
      return ((_this$label = this.label) === null || _this$label === void 0 ? void 0 : _this$label.length) > 0;
    },
    getOrientation: function getOrientation() {
      return this.isVertical ? 'vertical' : 'horizontal';
    },
    selectedItems: function selectedItems() {
      var _this = this;
      var items = this.optionsCheckbox.map(function (item) {
        if (item.checked) {
          var localItem = _objectSpread$9({}, item);
          delete localItem.checked;
          var valueReturn = _this.returnMode === 'values' ? item.value : localItem;
          return valueReturn;
        }
        return false;
      }).filter(function (item) {
        return !!item;
      });
      return items;
    },
    getOptionsLength: function getOptionsLength() {
      var _this$options;
      return (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.length;
    },
    getHelperTextLength: function getHelperTextLength() {
      var _this$$aqT;
      return ((_this$$aqT = this.$aqT(this.helperText)) === null || _this$$aqT === void 0 ? void 0 : _this$$aqT.length) > 0;
    }
  },
  methods: {
    onSelectedItemsChanged: function onSelectedItemsChanged() {
      this.$emit('input', this.selectedItems);
    },
    getPosition: function getPosition(i) {
      var _this$options2;
      var position = 'center';
      var len = (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.length;
      if (len > 1) {
        if (i === 0) {
          position = this.isVertical ? 'top' : 'left';
        } else if (i === len - 1) {
          position = this.isVertical ? 'bottom' : 'right';
        }
      }
      return position;
    },
    compareValues: function compareValues(a, b) {
      return JSON.stringify(a) === JSON.stringify(b);
    },
    changeValue: function changeValue() {
      var _this$optionsCheckbox, _this$value;
      if (((_this$optionsCheckbox = this.optionsCheckbox) === null || _this$optionsCheckbox === void 0 ? void 0 : _this$optionsCheckbox.length) > 0 && ((_this$value = this.value) === null || _this$value === void 0 ? void 0 : _this$value.length) > 0 && !this.compareValues(this.value, this.selectedItems)) {
        for (var i = 0; i < ((_this$optionsCheckbox2 = this.optionsCheckbox) === null || _this$optionsCheckbox2 === void 0 ? void 0 : _this$optionsCheckbox2.length); i += 1) {
          var _this$optionsCheckbox2;
          this.optionsCheckbox[i].checked = false;
        }
        for (var _i = 0; _i < ((_this$optionsCheckbox3 = this.optionsCheckbox) === null || _this$optionsCheckbox3 === void 0 ? void 0 : _this$optionsCheckbox3.length); _i += 1) {
          var _this$optionsCheckbox3;
          for (var j = 0; j < ((_this$value2 = this.value) === null || _this$value2 === void 0 ? void 0 : _this$value2.length); j += 1) {
            var _this$value2;
            var value = this.value[j];
            var item = this.optionsCheckbox[_i];
            if ((item === null || item === void 0 ? void 0 : item.value) === value) {
              this.optionsCheckbox[_i].checked = true;
            }
          }
        }
      }
    },
    parseOptions: function parseOptions() {
      var _this$options3;
      this.optionsCheckbox = [];
      if (((_this$options3 = this.options) === null || _this$options3 === void 0 ? void 0 : _this$options3.length) > 0) {
        for (var i = 0; i < ((_this$options4 = this.options) === null || _this$options4 === void 0 ? void 0 : _this$options4.length); i += 1) {
          var _this$options4;
          var element = _objectSpread$9({
            checked: this.value.includes(this.options[i].value)
          }, this.options[i]);
          this.optionsCheckbox.push(element);
        }
      }
    }
  },
  mounted: function mounted() {
    this.changeValue();
    this.parseOptions();
  }
};

/* script */
var __vue_script__$T = script$T;

/* template */
var __vue_render__$T = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('fieldset', {
    class: ['aq-checkbox-group', 'aq-checkbox-group--' + _vm.getOrientation, {
      'aq-checkbox-group--checkbox-button': _vm.getType === 'checkboxbutton'
    }, {
      'aq-checkbox-group--checkbox': _vm.getType === 'checkbox'
    }, {
      'aq-checkbox-group--checkbox-card': _vm.getType === 'checkboxcard'
    }]
  }, [_vm.isLabelVisible ? _c('legend', {
    staticClass: "aq-checkbox-group__label"
  }, [_c('aq-label', _vm._b({}, 'aq-label', _vm.bindsLabel, false), [_vm._v(_vm._s(_vm.$aqT(_vm.label)))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: ['aq-checkbox-group__options', 'aq-checkbox-group__options--' + _vm.getOrientation, {
      'aq-checkbox-group__shadow': _vm.getType === 'checkboxbutton'
    }]
  }, [_vm.getType === 'checkboxcard' ? _vm._l(_vm.optionsCheckbox, function (item, i) {
    return _c('aq-checkbox-card', {
      key: i,
      attrs: {
        "label": item.label,
        "urlImage": item.urlImage,
        "icon": item.icon,
        "vertical": _vm.isVertical,
        "disabled": _vm.disabled || item.disabled,
        "helperText": item.subLabel,
        "indeterminate": item.indeterminate
      },
      model: {
        value: item.checked,
        callback: function callback($$v) {
          _vm.$set(item, "checked", $$v);
        },
        expression: "item.checked"
      }
    });
  }) : _vm._e(), _vm._v(" "), _vm.getType === 'checkboxbutton' ? _vm._l(_vm.optionsCheckbox, function (item, i) {
    return _c('aq-checkbox-button', {
      key: i,
      attrs: {
        "label": item.label,
        "vertical": _vm.isVertical,
        "icon": item.icon,
        "position": _vm.getPosition(i),
        "disabled": _vm.disabled || item.disabled,
        "last": i + 1 === _vm.getOptionsLength,
        "orientation": item.orientation
      },
      model: {
        value: item.checked,
        callback: function callback($$v) {
          _vm.$set(item, "checked", $$v);
        },
        expression: "item.checked"
      }
    });
  }) : _vm._e(), _vm._v(" "), _vm.getType === 'checkbox' ? _vm._l(_vm.optionsCheckbox, function (item, i) {
    return _c('aq-checkbox', {
      key: i,
      attrs: {
        "label": item.label,
        "vertical": _vm.isVertical,
        "disabled": _vm.disabled || item.disabled,
        "icon": item.icon,
        "required": item.required,
        "info": item.info,
        "tooltipWidth": item.tooltipWidth,
        "isGroup": true,
        "indeterminate": item.indeterminate
      },
      model: {
        value: item.checked,
        callback: function callback($$v) {
          _vm.$set(item, "checked", $$v);
        },
        expression: "item.checked"
      }
    });
  }) : _vm._e()], 2), _vm._v(" "), _vm.isHelperTextVisible ? _c('div', {
    staticClass: "aq-checkbox-group__helper-text"
  }, [_vm.isHelperTextVisible ? _c('aq-helper-text', _vm._b({}, 'aq-helper-text', _vm.bindsHelperText, false)) : _vm._e()], 1) : _vm._e()]);
};
var __vue_staticRenderFns__$T = [];

/* style */
var __vue_inject_styles__$T = undefined;
/* scoped */
var __vue_scope_id__$T = undefined;
/* module identifier */
var __vue_module_identifier__$T = undefined;
/* functional template */
var __vue_is_functional_template__$T = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$T = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$T,
  staticRenderFns: __vue_staticRenderFns__$T
}, __vue_inject_styles__$T, __vue_script__$T, __vue_scope_id__$T, __vue_is_functional_template__$T, __vue_module_identifier__$T, false, undefined, undefined, undefined);
var AqCheckboxGroup = __vue_component__$T;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var KEYCODE_ENTER = 13;
var KEYCODE_TAB = 9;
var KEYCODE_BACKSPACE = 8;
var KEYCODE_Y = 89;
var KEYCODE_Z = 90;
var KEYCODE_M = 77;
var KEYCODE_PARENS = 57;
var KEYCODE_BRACKETS = 219;
var KEYCODE_QUOTE = 222;
var KEYCODE_BACK_QUOTE = 192;
var KEYCODE_ESCAPE = 27;
var HISTORY_LIMIT = 100;
var HISTORY_TIME_GAP = 3000;
var isWindows = typeof window !== 'undefined' && navigator && /*#__PURE__*/ /Win/i.test(navigator.platform);
var isMacLike = typeof window !== 'undefined' && navigator && /*#__PURE__*/ /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform);
var PrismEditor = /*#__PURE__*/Vue.extend({
  props: {
    lineNumbers: {
      type: Boolean,
      "default": false
    },
    autoStyleLineNumbers: {
      type: Boolean,
      "default": true
    },
    readonly: {
      type: Boolean,
      "default": false
    },
    value: {
      type: String,
      "default": ''
    },
    highlight: {
      type: Function,
      required: true
    },
    tabSize: {
      type: Number,
      "default": 2
    },
    insertSpaces: {
      type: Boolean,
      "default": true
    },
    ignoreTabKey: {
      type: Boolean,
      "default": false
    },
    placeholder: {
      type: String,
      "default": ''
    }
  },
  data: function data() {
    return {
      capture: true,
      history: {
        stack: [],
        offset: -1
      },
      lineNumbersHeight: '20px',
      codeData: ''
    };
  },
  watch: {
    value: {
      immediate: true,
      handler: function handler(newVal) {
        if (!newVal) {
          this.codeData = '';
        } else {
          this.codeData = newVal;
        }
      }
    },
    content: {
      immediate: true,
      handler: function handler() {
        var _this = this;

        if (this.lineNumbers) {
          this.$nextTick(function () {
            _this.setLineNumbersHeight();
          });
        }
      }
    },
    lineNumbers: function lineNumbers() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.styleLineNumbers();

        _this2.setLineNumbersHeight();
      });
    }
  },
  computed: {
    isEmpty: function isEmpty() {
      return this.codeData.length === 0;
    },
    content: function content() {
      var result = this.highlight(this.codeData) + '<br />'; // todo: VNode support?

      return result;
    },
    lineNumbersCount: function lineNumbersCount() {
      var totalLines = this.codeData.split(/\r\n|\n/).length;
      return totalLines;
    }
  },
  mounted: function mounted() {
    this._recordCurrentState();

    this.styleLineNumbers();
  },
  methods: {
    setLineNumbersHeight: function setLineNumbersHeight() {
      this.lineNumbersHeight = getComputedStyle(this.$refs.pre).height;
    },
    styleLineNumbers: function styleLineNumbers() {
      if (!this.lineNumbers || !this.autoStyleLineNumbers) return;
      var $editor = this.$refs.pre;
      var $lineNumbers = this.$el.querySelector('.prism-editor__line-numbers');
      var editorStyles = window.getComputedStyle($editor);
      this.$nextTick(function () {
        var btlr = 'border-top-left-radius';
        var bblr = 'border-bottom-left-radius';
        if (!$lineNumbers) return;
        $lineNumbers.style[btlr] = editorStyles[btlr];
        $lineNumbers.style[bblr] = editorStyles[bblr];
        $editor.style[btlr] = '0';
        $editor.style[bblr] = '0';
        var stylesList = ['background-color', 'margin-top', 'padding-top', 'font-family', 'font-size', 'line-height'];
        stylesList.forEach(function (style) {
          $lineNumbers.style[style] = editorStyles[style];
        });
        $lineNumbers.style['margin-bottom'] = '-' + editorStyles['padding-top'];
      });
    },
    _recordCurrentState: function _recordCurrentState() {
      var input = this.$refs.textarea;
      if (!input) return; // Save current state of the input

      var value = input.value,
          selectionStart = input.selectionStart,
          selectionEnd = input.selectionEnd;

      this._recordChange({
        value: value,
        selectionStart: selectionStart,
        selectionEnd: selectionEnd
      });
    },
    _getLines: function _getLines(text, position) {
      return text.substring(0, position).split('\n');
    },
    _applyEdits: function _applyEdits(record) {
      // Save last selection state
      var input = this.$refs.textarea;
      var last = this.history.stack[this.history.offset];

      if (last && input) {
        this.history.stack[this.history.offset] = _extends({}, last, {
          selectionStart: input.selectionStart,
          selectionEnd: input.selectionEnd
        });
      } // Save the changes


      this._recordChange(record);

      this._updateInput(record);
    },
    _recordChange: function _recordChange(record, overwrite) {
      if (overwrite === void 0) {
        overwrite = false;
      }

      var _this$history = this.history,
          stack = _this$history.stack,
          offset = _this$history.offset;

      if (stack.length && offset > -1) {
        // When something updates, drop the redo operations
        this.history.stack = stack.slice(0, offset + 1); // Limit the number of operations to 100

        var count = this.history.stack.length;

        if (count > HISTORY_LIMIT) {
          var extras = count - HISTORY_LIMIT;
          this.history.stack = stack.slice(extras, count);
          this.history.offset = Math.max(this.history.offset - extras, 0);
        }
      }

      var timestamp = Date.now();

      if (overwrite) {
        var last = this.history.stack[this.history.offset];

        if (last && timestamp - last.timestamp < HISTORY_TIME_GAP) {
          var _this$_getLines$pop, _this$_getLines$pop2;

          // A previous entry exists and was in short interval
          // Match the last word in the line
          var re = /[^a-z0-9]([a-z0-9]+)$/i; // Get the previous line

          var previous = (_this$_getLines$pop = this._getLines(last.value, last.selectionStart).pop()) === null || _this$_getLines$pop === void 0 ? void 0 : _this$_getLines$pop.match(re); // Get the current line

          var current = (_this$_getLines$pop2 = this._getLines(record.value, record.selectionStart).pop()) === null || _this$_getLines$pop2 === void 0 ? void 0 : _this$_getLines$pop2.match(re);

          if (previous && current && current[1].startsWith(previous[1])) {
            // The last word of the previous line and current line match
            // Overwrite previous entry so that undo will remove whole word
            this.history.stack[this.history.offset] = _extends({}, record, {
              timestamp: timestamp
            });
            return;
          }
        }
      } // Add the new operation to the stack


      this.history.stack.push(_extends({}, record, {
        timestamp: timestamp
      }));
      this.history.offset++;
    },
    _updateInput: function _updateInput(record) {
      var input = this.$refs.textarea;
      if (!input) return; // Update values and selection state

      input.value = record.value;
      input.selectionStart = record.selectionStart;
      input.selectionEnd = record.selectionEnd;
      this.$emit('input', record.value); // this.props.onValueChange(record.value);
    },
    handleChange: function handleChange(e) {
      var _e$target = e.target,
          value = _e$target.value,
          selectionStart = _e$target.selectionStart,
          selectionEnd = _e$target.selectionEnd;

      this._recordChange({
        value: value,
        selectionStart: selectionStart,
        selectionEnd: selectionEnd
      }, true);

      this.$emit('input', value); // this.props.onValueChange(value);
    },
    _undoEdit: function _undoEdit() {
      var _this$history2 = this.history,
          stack = _this$history2.stack,
          offset = _this$history2.offset; // Get the previous edit

      var record = stack[offset - 1];

      if (record) {
        // Apply the changes and update the offset
        this._updateInput(record);

        this.history.offset = Math.max(offset - 1, 0);
      }
    },
    _redoEdit: function _redoEdit() {
      var _this$history3 = this.history,
          stack = _this$history3.stack,
          offset = _this$history3.offset; // Get the next edit

      var record = stack[offset + 1];

      if (record) {
        // Apply the changes and update the offset
        this._updateInput(record);

        this.history.offset = Math.min(offset + 1, stack.length - 1);
      }
    },
    handleKeyDown: function handleKeyDown(e) {
      // console.log(navigator.platform);
      var tabSize = this.tabSize,
          insertSpaces = this.insertSpaces,
          ignoreTabKey = this.ignoreTabKey;

      if (this.$listeners.keydown) {
        // onKeyDown(e);
        this.$emit('keydown', e);

        if (e.defaultPrevented) {
          return;
        }
      }

      if (e.keyCode === KEYCODE_ESCAPE) {
        e.target.blur();
        this.$emit('blur', e);
      }

      var _e$target2 = e.target,
          value = _e$target2.value,
          selectionStart = _e$target2.selectionStart,
          selectionEnd = _e$target2.selectionEnd;
      var tabCharacter = (insertSpaces ? ' ' : '\t').repeat(tabSize);

      if (e.keyCode === KEYCODE_TAB && !ignoreTabKey && this.capture) {
        // Prevent focus change
        e.preventDefault();

        if (e.shiftKey) {
          // Unindent selected lines
          var linesBeforeCaret = this._getLines(value, selectionStart);

          var startLine = linesBeforeCaret.length - 1;
          var endLine = this._getLines(value, selectionEnd).length - 1;
          var nextValue = value.split('\n').map(function (line, i) {
            if (i >= startLine && i <= endLine && line.startsWith(tabCharacter)) {
              return line.substring(tabCharacter.length);
            }

            return line;
          }).join('\n');

          if (value !== nextValue) {
            var startLineText = linesBeforeCaret[startLine];

            this._applyEdits({
              value: nextValue,
              // Move the start cursor if first line in selection was modified
              // It was modified only if it started with a tab
              selectionStart: startLineText.startsWith(tabCharacter) ? selectionStart - tabCharacter.length : selectionStart,
              // Move the end cursor by total number of characters removed
              selectionEnd: selectionEnd - (value.length - nextValue.length)
            });
          }
        } else if (selectionStart !== selectionEnd) {
          // Indent selected lines
          var _linesBeforeCaret = this._getLines(value, selectionStart);

          var _startLine = _linesBeforeCaret.length - 1;

          var _endLine = this._getLines(value, selectionEnd).length - 1;

          var _startLineText = _linesBeforeCaret[_startLine];

          this._applyEdits({
            value: value.split('\n').map(function (line, i) {
              if (i >= _startLine && i <= _endLine) {
                return tabCharacter + line;
              }

              return line;
            }).join('\n'),
            // Move the start cursor by number of characters added in first line of selection
            // Don't move it if it there was no text before cursor
            selectionStart: /\S/.test(_startLineText) ? selectionStart + tabCharacter.length : selectionStart,
            // Move the end cursor by total number of characters added
            selectionEnd: selectionEnd + tabCharacter.length * (_endLine - _startLine + 1)
          });
        } else {
          var updatedSelection = selectionStart + tabCharacter.length;

          this._applyEdits({
            // Insert tab character at caret
            value: value.substring(0, selectionStart) + tabCharacter + value.substring(selectionEnd),
            // Update caret position
            selectionStart: updatedSelection,
            selectionEnd: updatedSelection
          });
        }
      } else if (e.keyCode === KEYCODE_BACKSPACE) {
        var hasSelection = selectionStart !== selectionEnd;
        var textBeforeCaret = value.substring(0, selectionStart);

        if (textBeforeCaret.endsWith(tabCharacter) && !hasSelection) {
          // Prevent default delete behaviour
          e.preventDefault();

          var _updatedSelection = selectionStart - tabCharacter.length;

          this._applyEdits({
            // Remove tab character at caret
            value: value.substring(0, selectionStart - tabCharacter.length) + value.substring(selectionEnd),
            // Update caret position
            selectionStart: _updatedSelection,
            selectionEnd: _updatedSelection
          });
        }
      } else if (e.keyCode === KEYCODE_ENTER) {
        // Ignore selections
        if (selectionStart === selectionEnd) {
          // Get the current line
          var line = this._getLines(value, selectionStart).pop();

          var matches = line === null || line === void 0 ? void 0 : line.match(/^\s+/);

          if (matches && matches[0]) {
            e.preventDefault(); // Preserve indentation on inserting a new line

            var indent = '\n' + matches[0];

            var _updatedSelection2 = selectionStart + indent.length;

            this._applyEdits({
              // Insert indentation character at caret
              value: value.substring(0, selectionStart) + indent + value.substring(selectionEnd),
              // Update caret position
              selectionStart: _updatedSelection2,
              selectionEnd: _updatedSelection2
            });
          }
        }
      } else if (e.keyCode === KEYCODE_PARENS || e.keyCode === KEYCODE_BRACKETS || e.keyCode === KEYCODE_QUOTE || e.keyCode === KEYCODE_BACK_QUOTE) {
        var chars;

        if (e.keyCode === KEYCODE_PARENS && e.shiftKey) {
          chars = ['(', ')'];
        } else if (e.keyCode === KEYCODE_BRACKETS) {
          if (e.shiftKey) {
            chars = ['{', '}'];
          } else {
            chars = ['[', ']'];
          }
        } else if (e.keyCode === KEYCODE_QUOTE) {
          if (e.shiftKey) {
            chars = ['"', '"'];
          } else {
            chars = ["'", "'"];
          }
        } else if (e.keyCode === KEYCODE_BACK_QUOTE && !e.shiftKey) {
          chars = ['`', '`'];
        } // console.log(isMacLike, "navigator" in global && /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform));
        // If text is selected, wrap them in the characters


        if (selectionStart !== selectionEnd && chars) {
          e.preventDefault();

          this._applyEdits({
            value: value.substring(0, selectionStart) + chars[0] + value.substring(selectionStart, selectionEnd) + chars[1] + value.substring(selectionEnd),
            // Update caret position
            selectionStart: selectionStart,
            selectionEnd: selectionEnd + 2
          });
        }
      } else if ((isMacLike ? // Trigger undo with ⌘+Z on Mac
      e.metaKey && e.keyCode === KEYCODE_Z : // Trigger undo with Ctrl+Z on other platforms
      e.ctrlKey && e.keyCode === KEYCODE_Z) && !e.shiftKey && !e.altKey) {
        e.preventDefault();

        this._undoEdit();
      } else if ((isMacLike ? // Trigger redo with ⌘+Shift+Z on Mac
      e.metaKey && e.keyCode === KEYCODE_Z && e.shiftKey : isWindows ? // Trigger redo with Ctrl+Y on Windows
      e.ctrlKey && e.keyCode === KEYCODE_Y : // Trigger redo with Ctrl+Shift+Z on other platforms
      e.ctrlKey && e.keyCode === KEYCODE_Z && e.shiftKey) && !e.altKey) {
        e.preventDefault();

        this._redoEdit();
      } else if (e.keyCode === KEYCODE_M && e.ctrlKey && (isMacLike ? e.shiftKey : true)) {
        e.preventDefault(); // Toggle capturing tab key so users can focus away

        this.capture = !this.capture;
      }
    }
  },
  render: function render(h) {
    var _this3 = this;

    var lineNumberWidthCalculator = h('div', {
      attrs: {
        "class": 'prism-editor__line-width-calc',
        style: 'height: 0px; visibility: hidden; pointer-events: none;'
      }
    }, '999');
    var lineNumbers = h('div', {
      staticClass: 'prism-editor__line-numbers',
      style: {
        'min-height': this.lineNumbersHeight
      },
      attrs: {
        'aria-hidden': 'true'
      }
    }, [lineNumberWidthCalculator, Array.from(Array(this.lineNumbersCount).keys()).map(function (_, index) {
      return h('div', {
        attrs: {
          "class": 'prism-editor__line-number token comment'
        }
      }, "" + ++index);
    })]);
    var textarea = h('textarea', {
      ref: 'textarea',
      on: {
        input: this.handleChange,
        keydown: this.handleKeyDown,
        click: function click($event) {
          _this3.$emit('click', $event);
        },
        keyup: function keyup($event) {
          _this3.$emit('keyup', $event);
        },
        focus: function focus($event) {
          _this3.$emit('focus', $event);
        },
        blur: function blur($event) {
          _this3.$emit('blur', $event);
        }
      },
      staticClass: 'prism-editor__textarea',
      "class": {
        'prism-editor__textarea--empty': this.isEmpty
      },
      attrs: {
        spellCheck: 'false',
        autocapitalize: 'off',
        autocomplete: 'off',
        autocorrect: 'off',
        'data-gramm': 'false',
        placeholder: this.placeholder,
        'data-testid': 'textarea',
        readonly: this.readonly
      },
      domProps: {
        value: this.codeData
      }
    });
    var preview = h('pre', {
      ref: 'pre',
      staticClass: 'prism-editor__editor',
      attrs: {
        'data-testid': 'preview'
      },
      domProps: {
        innerHTML: this.content
      }
    });
    var editorContainer = h('div', {
      staticClass: 'prism-editor__container'
    }, [textarea, preview]);
    return h('div', {
      staticClass: 'prism-editor-wrapper'
    }, [this.lineNumbers && lineNumbers, editorContainer]);
  }
});

var prismCore = {exports: {}};

(function (module) {
/// <reference lib="WebWorker"/>

var _self = (typeof window !== 'undefined')
	? window   // if in browser
	: (
		(typeof WorkerGlobalScope !== 'undefined' && self instanceof WorkerGlobalScope)
			? self // if in worker
			: {}   // if in node js
	);

/**
 * Prism: Lightweight, robust, elegant syntax highlighting
 *
 * @license MIT <https://opensource.org/licenses/MIT>
 * @author Lea Verou <https://lea.verou.me>
 * @namespace
 * @public
 */
var Prism = (function (_self) {

	// Private helper vars
	var lang = /(?:^|\s)lang(?:uage)?-([\w-]+)(?=\s|$)/i;
	var uniqueId = 0;

	// The grammar object for plaintext
	var plainTextGrammar = {};


	var _ = {
		/**
		 * By default, Prism will attempt to highlight all code elements (by calling {@link Prism.highlightAll}) on the
		 * current page after the page finished loading. This might be a problem if e.g. you wanted to asynchronously load
		 * additional languages or plugins yourself.
		 *
		 * By setting this value to `true`, Prism will not automatically highlight all code elements on the page.
		 *
		 * You obviously have to change this value before the automatic highlighting started. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.manual = true;
		 * // add a new <script> to load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */
		manual: _self.Prism && _self.Prism.manual,
		/**
		 * By default, if Prism is in a web worker, it assumes that it is in a worker it created itself, so it uses
		 * `addEventListener` to communicate with its parent instance. However, if you're using Prism manually in your
		 * own worker, you don't want it to do this.
		 *
		 * By setting this value to `true`, Prism will not add its own listeners to the worker.
		 *
		 * You obviously have to change this value before Prism executes. To do this, you can add an
		 * empty Prism object into the global scope before loading the Prism script like this:
		 *
		 * ```js
		 * window.Prism = window.Prism || {};
		 * Prism.disableWorkerMessageHandler = true;
		 * // Load Prism's script
		 * ```
		 *
		 * @default false
		 * @type {boolean}
		 * @memberof Prism
		 * @public
		 */
		disableWorkerMessageHandler: _self.Prism && _self.Prism.disableWorkerMessageHandler,

		/**
		 * A namespace for utility methods.
		 *
		 * All function in this namespace that are not explicitly marked as _public_ are for __internal use only__ and may
		 * change or disappear at any time.
		 *
		 * @namespace
		 * @memberof Prism
		 */
		util: {
			encode: function encode(tokens) {
				if (tokens instanceof Token) {
					return new Token(tokens.type, encode(tokens.content), tokens.alias);
				} else if (Array.isArray(tokens)) {
					return tokens.map(encode);
				} else {
					return tokens.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/\u00a0/g, ' ');
				}
			},

			/**
			 * Returns the name of the type of the given value.
			 *
			 * @param {any} o
			 * @returns {string}
			 * @example
			 * type(null)      === 'Null'
			 * type(undefined) === 'Undefined'
			 * type(123)       === 'Number'
			 * type('foo')     === 'String'
			 * type(true)      === 'Boolean'
			 * type([1, 2])    === 'Array'
			 * type({})        === 'Object'
			 * type(String)    === 'Function'
			 * type(/abc+/)    === 'RegExp'
			 */
			type: function (o) {
				return Object.prototype.toString.call(o).slice(8, -1);
			},

			/**
			 * Returns a unique number for the given object. Later calls will still return the same number.
			 *
			 * @param {Object} obj
			 * @returns {number}
			 */
			objId: function (obj) {
				if (!obj['__id']) {
					Object.defineProperty(obj, '__id', { value: ++uniqueId });
				}
				return obj['__id'];
			},

			/**
			 * Creates a deep clone of the given object.
			 *
			 * The main intended use of this function is to clone language definitions.
			 *
			 * @param {T} o
			 * @param {Record<number, any>} [visited]
			 * @returns {T}
			 * @template T
			 */
			clone: function deepClone(o, visited) {
				visited = visited || {};

				var clone; var id;
				switch (_.util.type(o)) {
					case 'Object':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = /** @type {Record<string, any>} */ ({});
						visited[id] = clone;

						for (var key in o) {
							if (o.hasOwnProperty(key)) {
								clone[key] = deepClone(o[key], visited);
							}
						}

						return /** @type {any} */ (clone);

					case 'Array':
						id = _.util.objId(o);
						if (visited[id]) {
							return visited[id];
						}
						clone = [];
						visited[id] = clone;

						(/** @type {Array} */(/** @type {any} */(o))).forEach(function (v, i) {
							clone[i] = deepClone(v, visited);
						});

						return /** @type {any} */ (clone);

					default:
						return o;
				}
			},

			/**
			 * Returns the Prism language of the given element set by a `language-xxxx` or `lang-xxxx` class.
			 *
			 * If no language is set for the element or the element is `null` or `undefined`, `none` will be returned.
			 *
			 * @param {Element} element
			 * @returns {string}
			 */
			getLanguage: function (element) {
				while (element) {
					var m = lang.exec(element.className);
					if (m) {
						return m[1].toLowerCase();
					}
					element = element.parentElement;
				}
				return 'none';
			},

			/**
			 * Sets the Prism `language-xxxx` class of the given element.
			 *
			 * @param {Element} element
			 * @param {string} language
			 * @returns {void}
			 */
			setLanguage: function (element, language) {
				// remove all `language-xxxx` classes
				// (this might leave behind a leading space)
				element.className = element.className.replace(RegExp(lang, 'gi'), '');

				// add the new `language-xxxx` class
				// (using `classList` will automatically clean up spaces for us)
				element.classList.add('language-' + language);
			},

			/**
			 * Returns the script element that is currently executing.
			 *
			 * This does __not__ work for line script element.
			 *
			 * @returns {HTMLScriptElement | null}
			 */
			currentScript: function () {
				if (typeof document === 'undefined') {
					return null;
				}
				if ('currentScript' in document && 1 < 2 /* hack to trip TS' flow analysis */) {
					return /** @type {any} */ (document.currentScript);
				}

				// IE11 workaround
				// we'll get the src of the current script by parsing IE11's error stack trace
				// this will not work for inline scripts

				try {
					throw new Error();
				} catch (err) {
					// Get file src url from stack. Specifically works with the format of stack traces in IE.
					// A stack will look like this:
					//
					// Error
					//    at _.util.currentScript (http://localhost/components/prism-core.js:119:5)
					//    at Global code (http://localhost/components/prism-core.js:606:1)

					var src = (/at [^(\r\n]*\((.*):[^:]+:[^:]+\)$/i.exec(err.stack) || [])[1];
					if (src) {
						var scripts = document.getElementsByTagName('script');
						for (var i in scripts) {
							if (scripts[i].src == src) {
								return scripts[i];
							}
						}
					}
					return null;
				}
			},

			/**
			 * Returns whether a given class is active for `element`.
			 *
			 * The class can be activated if `element` or one of its ancestors has the given class and it can be deactivated
			 * if `element` or one of its ancestors has the negated version of the given class. The _negated version_ of the
			 * given class is just the given class with a `no-` prefix.
			 *
			 * Whether the class is active is determined by the closest ancestor of `element` (where `element` itself is
			 * closest ancestor) that has the given class or the negated version of it. If neither `element` nor any of its
			 * ancestors have the given class or the negated version of it, then the default activation will be returned.
			 *
			 * In the paradoxical situation where the closest ancestor contains __both__ the given class and the negated
			 * version of it, the class is considered active.
			 *
			 * @param {Element} element
			 * @param {string} className
			 * @param {boolean} [defaultActivation=false]
			 * @returns {boolean}
			 */
			isActive: function (element, className, defaultActivation) {
				var no = 'no-' + className;

				while (element) {
					var classList = element.classList;
					if (classList.contains(className)) {
						return true;
					}
					if (classList.contains(no)) {
						return false;
					}
					element = element.parentElement;
				}
				return !!defaultActivation;
			}
		},

		/**
		 * This namespace contains all currently loaded languages and the some helper functions to create and modify languages.
		 *
		 * @namespace
		 * @memberof Prism
		 * @public
		 */
		languages: {
			/**
			 * The grammar for plain, unformatted text.
			 */
			plain: plainTextGrammar,
			plaintext: plainTextGrammar,
			text: plainTextGrammar,
			txt: plainTextGrammar,

			/**
			 * Creates a deep copy of the language with the given id and appends the given tokens.
			 *
			 * If a token in `redef` also appears in the copied language, then the existing token in the copied language
			 * will be overwritten at its original position.
			 *
			 * ## Best practices
			 *
			 * Since the position of overwriting tokens (token in `redef` that overwrite tokens in the copied language)
			 * doesn't matter, they can technically be in any order. However, this can be confusing to others that trying to
			 * understand the language definition because, normally, the order of tokens matters in Prism grammars.
			 *
			 * Therefore, it is encouraged to order overwriting tokens according to the positions of the overwritten tokens.
			 * Furthermore, all non-overwriting tokens should be placed after the overwriting ones.
			 *
			 * @param {string} id The id of the language to extend. This has to be a key in `Prism.languages`.
			 * @param {Grammar} redef The new tokens to append.
			 * @returns {Grammar} The new language created.
			 * @public
			 * @example
			 * Prism.languages['css-with-colors'] = Prism.languages.extend('css', {
			 *     // Prism.languages.css already has a 'comment' token, so this token will overwrite CSS' 'comment' token
			 *     // at its original position
			 *     'comment': { ... },
			 *     // CSS doesn't have a 'color' token, so this token will be appended
			 *     'color': /\b(?:red|green|blue)\b/
			 * });
			 */
			extend: function (id, redef) {
				var lang = _.util.clone(_.languages[id]);

				for (var key in redef) {
					lang[key] = redef[key];
				}

				return lang;
			},

			/**
			 * Inserts tokens _before_ another token in a language definition or any other grammar.
			 *
			 * ## Usage
			 *
			 * This helper method makes it easy to modify existing languages. For example, the CSS language definition
			 * not only defines CSS highlighting for CSS documents, but also needs to define highlighting for CSS embedded
			 * in HTML through `<style>` elements. To do this, it needs to modify `Prism.languages.markup` and add the
			 * appropriate tokens. However, `Prism.languages.markup` is a regular JavaScript object literal, so if you do
			 * this:
			 *
			 * ```js
			 * Prism.languages.markup.style = {
			 *     // token
			 * };
			 * ```
			 *
			 * then the `style` token will be added (and processed) at the end. `insertBefore` allows you to insert tokens
			 * before existing tokens. For the CSS example above, you would use it like this:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'cdata', {
			 *     'style': {
			 *         // token
			 *     }
			 * });
			 * ```
			 *
			 * ## Special cases
			 *
			 * If the grammars of `inside` and `insert` have tokens with the same name, the tokens in `inside`'s grammar
			 * will be ignored.
			 *
			 * This behavior can be used to insert tokens after `before`:
			 *
			 * ```js
			 * Prism.languages.insertBefore('markup', 'comment', {
			 *     'comment': Prism.languages.markup.comment,
			 *     // tokens after 'comment'
			 * });
			 * ```
			 *
			 * ## Limitations
			 *
			 * The main problem `insertBefore` has to solve is iteration order. Since ES2015, the iteration order for object
			 * properties is guaranteed to be the insertion order (except for integer keys) but some browsers behave
			 * differently when keys are deleted and re-inserted. So `insertBefore` can't be implemented by temporarily
			 * deleting properties which is necessary to insert at arbitrary positions.
			 *
			 * To solve this problem, `insertBefore` doesn't actually insert the given tokens into the target object.
			 * Instead, it will create a new object and replace all references to the target object with the new one. This
			 * can be done without temporarily deleting properties, so the iteration order is well-defined.
			 *
			 * However, only references that can be reached from `Prism.languages` or `insert` will be replaced. I.e. if
			 * you hold the target object in a variable, then the value of the variable will not change.
			 *
			 * ```js
			 * var oldMarkup = Prism.languages.markup;
			 * var newMarkup = Prism.languages.insertBefore('markup', 'comment', { ... });
			 *
			 * assert(oldMarkup !== Prism.languages.markup);
			 * assert(newMarkup === Prism.languages.markup);
			 * ```
			 *
			 * @param {string} inside The property of `root` (e.g. a language id in `Prism.languages`) that contains the
			 * object to be modified.
			 * @param {string} before The key to insert before.
			 * @param {Grammar} insert An object containing the key-value pairs to be inserted.
			 * @param {Object<string, any>} [root] The object containing `inside`, i.e. the object that contains the
			 * object to be modified.
			 *
			 * Defaults to `Prism.languages`.
			 * @returns {Grammar} The new grammar object.
			 * @public
			 */
			insertBefore: function (inside, before, insert, root) {
				root = root || /** @type {any} */ (_.languages);
				var grammar = root[inside];
				/** @type {Grammar} */
				var ret = {};

				for (var token in grammar) {
					if (grammar.hasOwnProperty(token)) {

						if (token == before) {
							for (var newToken in insert) {
								if (insert.hasOwnProperty(newToken)) {
									ret[newToken] = insert[newToken];
								}
							}
						}

						// Do not insert token which also occur in insert. See #1525
						if (!insert.hasOwnProperty(token)) {
							ret[token] = grammar[token];
						}
					}
				}

				var old = root[inside];
				root[inside] = ret;

				// Update references in other language definitions
				_.languages.DFS(_.languages, function (key, value) {
					if (value === old && key != inside) {
						this[key] = ret;
					}
				});

				return ret;
			},

			// Traverse a language definition with Depth First Search
			DFS: function DFS(o, callback, type, visited) {
				visited = visited || {};

				var objId = _.util.objId;

				for (var i in o) {
					if (o.hasOwnProperty(i)) {
						callback.call(o, i, o[i], type || i);

						var property = o[i];
						var propertyType = _.util.type(property);

						if (propertyType === 'Object' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, null, visited);
						} else if (propertyType === 'Array' && !visited[objId(property)]) {
							visited[objId(property)] = true;
							DFS(property, callback, i, visited);
						}
					}
				}
			}
		},

		plugins: {},

		/**
		 * This is the most high-level function in Prism’s API.
		 * It fetches all the elements that have a `.language-xxxx` class and then calls {@link Prism.highlightElement} on
		 * each one of them.
		 *
		 * This is equivalent to `Prism.highlightAllUnder(document, async, callback)`.
		 *
		 * @param {boolean} [async=false] Same as in {@link Prism.highlightAllUnder}.
		 * @param {HighlightCallback} [callback] Same as in {@link Prism.highlightAllUnder}.
		 * @memberof Prism
		 * @public
		 */
		highlightAll: function (async, callback) {
			_.highlightAllUnder(document, async, callback);
		},

		/**
		 * Fetches all the descendants of `container` that have a `.language-xxxx` class and then calls
		 * {@link Prism.highlightElement} on each one of them.
		 *
		 * The following hooks will be run:
		 * 1. `before-highlightall`
		 * 2. `before-all-elements-highlight`
		 * 3. All hooks of {@link Prism.highlightElement} for each element.
		 *
		 * @param {ParentNode} container The root element, whose descendants that have a `.language-xxxx` class will be highlighted.
		 * @param {boolean} [async=false] Whether each element is to be highlighted asynchronously using Web Workers.
		 * @param {HighlightCallback} [callback] An optional callback to be invoked on each element after its highlighting is done.
		 * @memberof Prism
		 * @public
		 */
		highlightAllUnder: function (container, async, callback) {
			var env = {
				callback: callback,
				container: container,
				selector: 'code[class*="language-"], [class*="language-"] code, code[class*="lang-"], [class*="lang-"] code'
			};

			_.hooks.run('before-highlightall', env);

			env.elements = Array.prototype.slice.apply(env.container.querySelectorAll(env.selector));

			_.hooks.run('before-all-elements-highlight', env);

			for (var i = 0, element; (element = env.elements[i++]);) {
				_.highlightElement(element, async === true, env.callback);
			}
		},

		/**
		 * Highlights the code inside a single element.
		 *
		 * The following hooks will be run:
		 * 1. `before-sanity-check`
		 * 2. `before-highlight`
		 * 3. All hooks of {@link Prism.highlight}. These hooks will be run by an asynchronous worker if `async` is `true`.
		 * 4. `before-insert`
		 * 5. `after-highlight`
		 * 6. `complete`
		 *
		 * Some the above hooks will be skipped if the element doesn't contain any text or there is no grammar loaded for
		 * the element's language.
		 *
		 * @param {Element} element The element containing the code.
		 * It must have a class of `language-xxxx` to be processed, where `xxxx` is a valid language identifier.
		 * @param {boolean} [async=false] Whether the element is to be highlighted asynchronously using Web Workers
		 * to improve performance and avoid blocking the UI when highlighting very large chunks of code. This option is
		 * [disabled by default](https://prismjs.com/faq.html#why-is-asynchronous-highlighting-disabled-by-default).
		 *
		 * Note: All language definitions required to highlight the code must be included in the main `prism.js` file for
		 * asynchronous highlighting to work. You can build your own bundle on the
		 * [Download page](https://prismjs.com/download.html).
		 * @param {HighlightCallback} [callback] An optional callback to be invoked after the highlighting is done.
		 * Mostly useful when `async` is `true`, since in that case, the highlighting is done asynchronously.
		 * @memberof Prism
		 * @public
		 */
		highlightElement: function (element, async, callback) {
			// Find language
			var language = _.util.getLanguage(element);
			var grammar = _.languages[language];

			// Set language on the element, if not present
			_.util.setLanguage(element, language);

			// Set language on the parent, for styling
			var parent = element.parentElement;
			if (parent && parent.nodeName.toLowerCase() === 'pre') {
				_.util.setLanguage(parent, language);
			}

			var code = element.textContent;

			var env = {
				element: element,
				language: language,
				grammar: grammar,
				code: code
			};

			function insertHighlightedCode(highlightedCode) {
				env.highlightedCode = highlightedCode;

				_.hooks.run('before-insert', env);

				env.element.innerHTML = env.highlightedCode;

				_.hooks.run('after-highlight', env);
				_.hooks.run('complete', env);
				callback && callback.call(env.element);
			}

			_.hooks.run('before-sanity-check', env);

			// plugins may change/add the parent/element
			parent = env.element.parentElement;
			if (parent && parent.nodeName.toLowerCase() === 'pre' && !parent.hasAttribute('tabindex')) {
				parent.setAttribute('tabindex', '0');
			}

			if (!env.code) {
				_.hooks.run('complete', env);
				callback && callback.call(env.element);
				return;
			}

			_.hooks.run('before-highlight', env);

			if (!env.grammar) {
				insertHighlightedCode(_.util.encode(env.code));
				return;
			}

			if (async && _self.Worker) {
				var worker = new Worker(_.filename);

				worker.onmessage = function (evt) {
					insertHighlightedCode(evt.data);
				};

				worker.postMessage(JSON.stringify({
					language: env.language,
					code: env.code,
					immediateClose: true
				}));
			} else {
				insertHighlightedCode(_.highlight(env.code, env.grammar, env.language));
			}
		},

		/**
		 * Low-level function, only use if you know what you’re doing. It accepts a string of text as input
		 * and the language definitions to use, and returns a string with the HTML produced.
		 *
		 * The following hooks will be run:
		 * 1. `before-tokenize`
		 * 2. `after-tokenize`
		 * 3. `wrap`: On each {@link Token}.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @param {string} language The name of the language definition passed to `grammar`.
		 * @returns {string} The highlighted HTML.
		 * @memberof Prism
		 * @public
		 * @example
		 * Prism.highlight('var foo = true;', Prism.languages.javascript, 'javascript');
		 */
		highlight: function (text, grammar, language) {
			var env = {
				code: text,
				grammar: grammar,
				language: language
			};
			_.hooks.run('before-tokenize', env);
			if (!env.grammar) {
				throw new Error('The language "' + env.language + '" has no grammar.');
			}
			env.tokens = _.tokenize(env.code, env.grammar);
			_.hooks.run('after-tokenize', env);
			return Token.stringify(_.util.encode(env.tokens), env.language);
		},

		/**
		 * This is the heart of Prism, and the most low-level function you can use. It accepts a string of text as input
		 * and the language definitions to use, and returns an array with the tokenized code.
		 *
		 * When the language definition includes nested tokens, the function is called recursively on each of these tokens.
		 *
		 * This method could be useful in other contexts as well, as a very crude parser.
		 *
		 * @param {string} text A string with the code to be highlighted.
		 * @param {Grammar} grammar An object containing the tokens to use.
		 *
		 * Usually a language definition like `Prism.languages.markup`.
		 * @returns {TokenStream} An array of strings and tokens, a token stream.
		 * @memberof Prism
		 * @public
		 * @example
		 * let code = `var foo = 0;`;
		 * let tokens = Prism.tokenize(code, Prism.languages.javascript);
		 * tokens.forEach(token => {
		 *     if (token instanceof Prism.Token && token.type === 'number') {
		 *         console.log(`Found numeric literal: ${token.content}`);
		 *     }
		 * });
		 */
		tokenize: function (text, grammar) {
			var rest = grammar.rest;
			if (rest) {
				for (var token in rest) {
					grammar[token] = rest[token];
				}

				delete grammar.rest;
			}

			var tokenList = new LinkedList();
			addAfter(tokenList, tokenList.head, text);

			matchGrammar(text, tokenList, grammar, tokenList.head, 0);

			return toArray(tokenList);
		},

		/**
		 * @namespace
		 * @memberof Prism
		 * @public
		 */
		hooks: {
			all: {},

			/**
			 * Adds the given callback to the list of callbacks for the given hook.
			 *
			 * The callback will be invoked when the hook it is registered for is run.
			 * Hooks are usually directly run by a highlight function but you can also run hooks yourself.
			 *
			 * One callback function can be registered to multiple hooks and the same hook multiple times.
			 *
			 * @param {string} name The name of the hook.
			 * @param {HookCallback} callback The callback function which is given environment variables.
			 * @public
			 */
			add: function (name, callback) {
				var hooks = _.hooks.all;

				hooks[name] = hooks[name] || [];

				hooks[name].push(callback);
			},

			/**
			 * Runs a hook invoking all registered callbacks with the given environment variables.
			 *
			 * Callbacks will be invoked synchronously and in the order in which they were registered.
			 *
			 * @param {string} name The name of the hook.
			 * @param {Object<string, any>} env The environment variables of the hook passed to all callbacks registered.
			 * @public
			 */
			run: function (name, env) {
				var callbacks = _.hooks.all[name];

				if (!callbacks || !callbacks.length) {
					return;
				}

				for (var i = 0, callback; (callback = callbacks[i++]);) {
					callback(env);
				}
			}
		},

		Token: Token
	};
	_self.Prism = _;


	// Typescript note:
	// The following can be used to import the Token type in JSDoc:
	//
	//   @typedef {InstanceType<import("./prism-core")["Token"]>} Token

	/**
	 * Creates a new token.
	 *
	 * @param {string} type See {@link Token#type type}
	 * @param {string | TokenStream} content See {@link Token#content content}
	 * @param {string|string[]} [alias] The alias(es) of the token.
	 * @param {string} [matchedStr=""] A copy of the full string this token was created from.
	 * @class
	 * @global
	 * @public
	 */
	function Token(type, content, alias, matchedStr) {
		/**
		 * The type of the token.
		 *
		 * This is usually the key of a pattern in a {@link Grammar}.
		 *
		 * @type {string}
		 * @see GrammarToken
		 * @public
		 */
		this.type = type;
		/**
		 * The strings or tokens contained by this token.
		 *
		 * This will be a token stream if the pattern matched also defined an `inside` grammar.
		 *
		 * @type {string | TokenStream}
		 * @public
		 */
		this.content = content;
		/**
		 * The alias(es) of the token.
		 *
		 * @type {string|string[]}
		 * @see GrammarToken
		 * @public
		 */
		this.alias = alias;
		// Copy of the full string this token was created from
		this.length = (matchedStr || '').length | 0;
	}

	/**
	 * A token stream is an array of strings and {@link Token Token} objects.
	 *
	 * Token streams have to fulfill a few properties that are assumed by most functions (mostly internal ones) that process
	 * them.
	 *
	 * 1. No adjacent strings.
	 * 2. No empty strings.
	 *
	 *    The only exception here is the token stream that only contains the empty string and nothing else.
	 *
	 * @typedef {Array<string | Token>} TokenStream
	 * @global
	 * @public
	 */

	/**
	 * Converts the given token or token stream to an HTML representation.
	 *
	 * The following hooks will be run:
	 * 1. `wrap`: On each {@link Token}.
	 *
	 * @param {string | Token | TokenStream} o The token or token stream to be converted.
	 * @param {string} language The name of current language.
	 * @returns {string} The HTML representation of the token or token stream.
	 * @memberof Token
	 * @static
	 */
	Token.stringify = function stringify(o, language) {
		if (typeof o == 'string') {
			return o;
		}
		if (Array.isArray(o)) {
			var s = '';
			o.forEach(function (e) {
				s += stringify(e, language);
			});
			return s;
		}

		var env = {
			type: o.type,
			content: stringify(o.content, language),
			tag: 'span',
			classes: ['token', o.type],
			attributes: {},
			language: language
		};

		var aliases = o.alias;
		if (aliases) {
			if (Array.isArray(aliases)) {
				Array.prototype.push.apply(env.classes, aliases);
			} else {
				env.classes.push(aliases);
			}
		}

		_.hooks.run('wrap', env);

		var attributes = '';
		for (var name in env.attributes) {
			attributes += ' ' + name + '="' + (env.attributes[name] || '').replace(/"/g, '&quot;') + '"';
		}

		return '<' + env.tag + ' class="' + env.classes.join(' ') + '"' + attributes + '>' + env.content + '</' + env.tag + '>';
	};

	/**
	 * @param {RegExp} pattern
	 * @param {number} pos
	 * @param {string} text
	 * @param {boolean} lookbehind
	 * @returns {RegExpExecArray | null}
	 */
	function matchPattern(pattern, pos, text, lookbehind) {
		pattern.lastIndex = pos;
		var match = pattern.exec(text);
		if (match && lookbehind && match[1]) {
			// change the match to remove the text matched by the Prism lookbehind group
			var lookbehindLength = match[1].length;
			match.index += lookbehindLength;
			match[0] = match[0].slice(lookbehindLength);
		}
		return match;
	}

	/**
	 * @param {string} text
	 * @param {LinkedList<string | Token>} tokenList
	 * @param {any} grammar
	 * @param {LinkedListNode<string | Token>} startNode
	 * @param {number} startPos
	 * @param {RematchOptions} [rematch]
	 * @returns {void}
	 * @private
	 *
	 * @typedef RematchOptions
	 * @property {string} cause
	 * @property {number} reach
	 */
	function matchGrammar(text, tokenList, grammar, startNode, startPos, rematch) {
		for (var token in grammar) {
			if (!grammar.hasOwnProperty(token) || !grammar[token]) {
				continue;
			}

			var patterns = grammar[token];
			patterns = Array.isArray(patterns) ? patterns : [patterns];

			for (var j = 0; j < patterns.length; ++j) {
				if (rematch && rematch.cause == token + ',' + j) {
					return;
				}

				var patternObj = patterns[j];
				var inside = patternObj.inside;
				var lookbehind = !!patternObj.lookbehind;
				var greedy = !!patternObj.greedy;
				var alias = patternObj.alias;

				if (greedy && !patternObj.pattern.global) {
					// Without the global flag, lastIndex won't work
					var flags = patternObj.pattern.toString().match(/[imsuy]*$/)[0];
					patternObj.pattern = RegExp(patternObj.pattern.source, flags + 'g');
				}

				/** @type {RegExp} */
				var pattern = patternObj.pattern || patternObj;

				for ( // iterate the token list and keep track of the current token/string position
					var currentNode = startNode.next, pos = startPos;
					currentNode !== tokenList.tail;
					pos += currentNode.value.length, currentNode = currentNode.next
				) {

					if (rematch && pos >= rematch.reach) {
						break;
					}

					var str = currentNode.value;

					if (tokenList.length > text.length) {
						// Something went terribly wrong, ABORT, ABORT!
						return;
					}

					if (str instanceof Token) {
						continue;
					}

					var removeCount = 1; // this is the to parameter of removeBetween
					var match;

					if (greedy) {
						match = matchPattern(pattern, pos, text, lookbehind);
						if (!match || match.index >= text.length) {
							break;
						}

						var from = match.index;
						var to = match.index + match[0].length;
						var p = pos;

						// find the node that contains the match
						p += currentNode.value.length;
						while (from >= p) {
							currentNode = currentNode.next;
							p += currentNode.value.length;
						}
						// adjust pos (and p)
						p -= currentNode.value.length;
						pos = p;

						// the current node is a Token, then the match starts inside another Token, which is invalid
						if (currentNode.value instanceof Token) {
							continue;
						}

						// find the last node which is affected by this match
						for (
							var k = currentNode;
							k !== tokenList.tail && (p < to || typeof k.value === 'string');
							k = k.next
						) {
							removeCount++;
							p += k.value.length;
						}
						removeCount--;

						// replace with the new match
						str = text.slice(pos, p);
						match.index -= pos;
					} else {
						match = matchPattern(pattern, 0, str, lookbehind);
						if (!match) {
							continue;
						}
					}

					// eslint-disable-next-line no-redeclare
					var from = match.index;
					var matchStr = match[0];
					var before = str.slice(0, from);
					var after = str.slice(from + matchStr.length);

					var reach = pos + str.length;
					if (rematch && reach > rematch.reach) {
						rematch.reach = reach;
					}

					var removeFrom = currentNode.prev;

					if (before) {
						removeFrom = addAfter(tokenList, removeFrom, before);
						pos += before.length;
					}

					removeRange(tokenList, removeFrom, removeCount);

					var wrapped = new Token(token, inside ? _.tokenize(matchStr, inside) : matchStr, alias, matchStr);
					currentNode = addAfter(tokenList, removeFrom, wrapped);

					if (after) {
						addAfter(tokenList, currentNode, after);
					}

					if (removeCount > 1) {
						// at least one Token object was removed, so we have to do some rematching
						// this can only happen if the current pattern is greedy

						/** @type {RematchOptions} */
						var nestedRematch = {
							cause: token + ',' + j,
							reach: reach
						};
						matchGrammar(text, tokenList, grammar, currentNode.prev, pos, nestedRematch);

						// the reach might have been extended because of the rematching
						if (rematch && nestedRematch.reach > rematch.reach) {
							rematch.reach = nestedRematch.reach;
						}
					}
				}
			}
		}
	}

	/**
	 * @typedef LinkedListNode
	 * @property {T} value
	 * @property {LinkedListNode<T> | null} prev The previous node.
	 * @property {LinkedListNode<T> | null} next The next node.
	 * @template T
	 * @private
	 */

	/**
	 * @template T
	 * @private
	 */
	function LinkedList() {
		/** @type {LinkedListNode<T>} */
		var head = { value: null, prev: null, next: null };
		/** @type {LinkedListNode<T>} */
		var tail = { value: null, prev: head, next: null };
		head.next = tail;

		/** @type {LinkedListNode<T>} */
		this.head = head;
		/** @type {LinkedListNode<T>} */
		this.tail = tail;
		this.length = 0;
	}

	/**
	 * Adds a new node with the given value to the list.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {T} value
	 * @returns {LinkedListNode<T>} The added node.
	 * @template T
	 */
	function addAfter(list, node, value) {
		// assumes that node != list.tail && values.length >= 0
		var next = node.next;

		var newNode = { value: value, prev: node, next: next };
		node.next = newNode;
		next.prev = newNode;
		list.length++;

		return newNode;
	}
	/**
	 * Removes `count` nodes after the given node. The given node will not be removed.
	 *
	 * @param {LinkedList<T>} list
	 * @param {LinkedListNode<T>} node
	 * @param {number} count
	 * @template T
	 */
	function removeRange(list, node, count) {
		var next = node.next;
		for (var i = 0; i < count && next !== list.tail; i++) {
			next = next.next;
		}
		node.next = next;
		next.prev = node;
		list.length -= i;
	}
	/**
	 * @param {LinkedList<T>} list
	 * @returns {T[]}
	 * @template T
	 */
	function toArray(list) {
		var array = [];
		var node = list.head.next;
		while (node !== list.tail) {
			array.push(node.value);
			node = node.next;
		}
		return array;
	}


	if (!_self.document) {
		if (!_self.addEventListener) {
			// in Node.js
			return _;
		}

		if (!_.disableWorkerMessageHandler) {
			// In worker
			_self.addEventListener('message', function (evt) {
				var message = JSON.parse(evt.data);
				var lang = message.language;
				var code = message.code;
				var immediateClose = message.immediateClose;

				_self.postMessage(_.highlight(code, _.languages[lang], lang));
				if (immediateClose) {
					_self.close();
				}
			}, false);
		}

		return _;
	}

	// Get current script and highlight
	var script = _.util.currentScript();

	if (script) {
		_.filename = script.src;

		if (script.hasAttribute('data-manual')) {
			_.manual = true;
		}
	}

	function highlightAutomaticallyCallback() {
		if (!_.manual) {
			_.highlightAll();
		}
	}

	if (!_.manual) {
		// If the document state is "loading", then we'll use DOMContentLoaded.
		// If the document state is "interactive" and the prism.js script is deferred, then we'll also use the
		// DOMContentLoaded event because there might be some plugins or languages which have also been deferred and they
		// might take longer one animation frame to execute which can create a race condition where only some plugins have
		// been loaded when Prism.highlightAll() is executed, depending on how fast resources are loaded.
		// See https://github.com/PrismJS/prism/issues/2102
		var readyState = document.readyState;
		if (readyState === 'loading' || readyState === 'interactive' && script && script.defer) {
			document.addEventListener('DOMContentLoaded', highlightAutomaticallyCallback);
		} else {
			if (window.requestAnimationFrame) {
				window.requestAnimationFrame(highlightAutomaticallyCallback);
			} else {
				window.setTimeout(highlightAutomaticallyCallback, 16);
			}
		}
	}

	return _;

}(_self));

if (module.exports) {
	module.exports = Prism;
}

// hack for components to work correctly in node.js
if (typeof commonjsGlobal !== 'undefined') {
	commonjsGlobal.Prism = Prism;
}

// some additional documentation/types

/**
 * The expansion of a simple `RegExp` literal to support additional properties.
 *
 * @typedef GrammarToken
 * @property {RegExp} pattern The regular expression of the token.
 * @property {boolean} [lookbehind=false] If `true`, then the first capturing group of `pattern` will (effectively)
 * behave as a lookbehind group meaning that the captured text will not be part of the matched text of the new token.
 * @property {boolean} [greedy=false] Whether the token is greedy.
 * @property {string|string[]} [alias] An optional alias or list of aliases.
 * @property {Grammar} [inside] The nested grammar of this token.
 *
 * The `inside` grammar will be used to tokenize the text value of each token of this kind.
 *
 * This can be used to make nested and even recursive language definitions.
 *
 * Note: This can cause infinite recursion. Be careful when you embed different languages or even the same language into
 * each another.
 * @global
 * @public
 */

/**
 * @typedef Grammar
 * @type {Object<string, RegExp | GrammarToken | Array<RegExp | GrammarToken>>}
 * @property {Grammar} [rest] An optional grammar object that will be appended to this grammar.
 * @global
 * @public
 */

/**
 * A function which will invoked after an element was successfully highlighted.
 *
 * @callback HighlightCallback
 * @param {Element} element The element successfully highlighted.
 * @returns {void}
 * @global
 * @public
 */

/**
 * @callback HookCallback
 * @param {Object<string, any>} env The environment variables of the hook.
 * @returns {void}
 * @global
 * @public
 */
}(prismCore));

Prism.languages.clike = {
	'comment': [
		{
			pattern: /(^|[^\\])\/\*[\s\S]*?(?:\*\/|$)/,
			lookbehind: true,
			greedy: true
		},
		{
			pattern: /(^|[^\\:])\/\/.*/,
			lookbehind: true,
			greedy: true
		}
	],
	'string': {
		pattern: /(["'])(?:\\(?:\r\n|[\s\S])|(?!\1)[^\\\r\n])*\1/,
		greedy: true
	},
	'class-name': {
		pattern: /(\b(?:class|extends|implements|instanceof|interface|new|trait)\s+|\bcatch\s+\()[\w.\\]+/i,
		lookbehind: true,
		inside: {
			'punctuation': /[.\\]/
		}
	},
	'keyword': /\b(?:break|catch|continue|do|else|finally|for|function|if|in|instanceof|new|null|return|throw|try|while)\b/,
	'boolean': /\b(?:false|true)\b/,
	'function': /\b\w+(?=\()/,
	'number': /\b0x[\da-f]+\b|(?:\b\d+(?:\.\d*)?|\B\.\d+)(?:e[+-]?\d+)?/i,
	'operator': /[<>]=?|[!=]=?=?|--?|\+\+?|&&?|\|\|?|[?*/~^%]/,
	'punctuation': /[{}[\];(),.:]/
};

Prism.languages.javascript = Prism.languages.extend('clike', {
	'class-name': [
		Prism.languages.clike['class-name'],
		{
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$A-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\.(?:constructor|prototype))/,
			lookbehind: true
		}
	],
	'keyword': [
		{
			pattern: /((?:^|\})\s*)catch\b/,
			lookbehind: true
		},
		{
			pattern: /(^|[^.]|\.\.\.\s*)\b(?:as|assert(?=\s*\{)|async(?=\s*(?:function\b|\(|[$\w\xA0-\uFFFF]|$))|await|break|case|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally(?=\s*(?:\{|$))|for|from(?=\s*(?:['"]|$))|function|(?:get|set)(?=\s*(?:[#\[$\w\xA0-\uFFFF]|$))|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)\b/,
			lookbehind: true
		},
	],
	// Allow for all non-ASCII characters (See http://stackoverflow.com/a/2008444)
	'function': /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*(?:\.\s*(?:apply|bind|call)\s*)?\()/,
	'number': {
		pattern: RegExp(
			/(^|[^\w$])/.source +
			'(?:' +
			(
				// constant
				/NaN|Infinity/.source +
				'|' +
				// binary integer
				/0[bB][01]+(?:_[01]+)*n?/.source +
				'|' +
				// octal integer
				/0[oO][0-7]+(?:_[0-7]+)*n?/.source +
				'|' +
				// hexadecimal integer
				/0[xX][\dA-Fa-f]+(?:_[\dA-Fa-f]+)*n?/.source +
				'|' +
				// decimal bigint
				/\d+(?:_\d+)*n/.source +
				'|' +
				// decimal number (integer or float) but no bigint
				/(?:\d+(?:_\d+)*(?:\.(?:\d+(?:_\d+)*)?)?|\.\d+(?:_\d+)*)(?:[Ee][+-]?\d+(?:_\d+)*)?/.source
			) +
			')' +
			/(?![\w$])/.source
		),
		lookbehind: true
	},
	'operator': /--|\+\+|\*\*=?|=>|&&=?|\|\|=?|[!=]==|<<=?|>>>?=?|[-+*/%&|^!=<>]=?|\.{3}|\?\?=?|\?\.?|[~:]/
});

Prism.languages.javascript['class-name'][0].pattern = /(\b(?:class|extends|implements|instanceof|interface|new)\s+)[\w.\\]+/;

Prism.languages.insertBefore('javascript', 'keyword', {
	'regex': {
		pattern: RegExp(
			// lookbehind
			// eslint-disable-next-line regexp/no-dupe-characters-character-class
			/((?:^|[^$\w\xA0-\uFFFF."'\])\s]|\b(?:return|yield))\s*)/.source +
			// Regex pattern:
			// There are 2 regex patterns here. The RegExp set notation proposal added support for nested character
			// classes if the `v` flag is present. Unfortunately, nested CCs are both context-free and incompatible
			// with the only syntax, so we have to define 2 different regex patterns.
			/\//.source +
			'(?:' +
			/(?:\[(?:[^\]\\\r\n]|\\.)*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}/.source +
			'|' +
			// `v` flag syntax. This supports 3 levels of nested character classes.
			/(?:\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.|\[(?:[^[\]\\\r\n]|\\.)*\])*\])*\]|\\.|[^/\\\[\r\n])+\/[dgimyus]{0,7}v[dgimyus]{0,7}/.source +
			')' +
			// lookahead
			/(?=(?:\s|\/\*(?:[^*]|\*(?!\/))*\*\/)*(?:$|[\r\n,.;:})\]]|\/\/))/.source
		),
		lookbehind: true,
		greedy: true,
		inside: {
			'regex-source': {
				pattern: /^(\/)[\s\S]+(?=\/[a-z]*$)/,
				lookbehind: true,
				alias: 'language-regex',
				inside: Prism.languages.regex
			},
			'regex-delimiter': /^\/|\/$/,
			'regex-flags': /^[a-z]+$/,
		}
	},
	// This must be declared before keyword because we use "function" inside the look-forward
	'function-variable': {
		pattern: /#?(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*[=:]\s*(?:async\s*)?(?:\bfunction\b|(?:\((?:[^()]|\([^()]*\))*\)|(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)\s*=>))/,
		alias: 'function'
	},
	'parameter': [
		{
			pattern: /(function(?:\s+(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*)?\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\))/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /(^|[^$\w\xA0-\uFFFF])(?!\s)[_$a-z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*=>)/i,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /(\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*=>)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		},
		{
			pattern: /((?:\b|\s|^)(?!(?:as|async|await|break|case|catch|class|const|continue|debugger|default|delete|do|else|enum|export|extends|finally|for|from|function|get|if|implements|import|in|instanceof|interface|let|new|null|of|package|private|protected|public|return|set|static|super|switch|this|throw|try|typeof|undefined|var|void|while|with|yield)(?![$\w\xA0-\uFFFF]))(?:(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*\s*)\(\s*|\]\s*\(\s*)(?!\s)(?:[^()\s]|\s+(?![\s)])|\([^()]*\))+(?=\s*\)\s*\{)/,
			lookbehind: true,
			inside: Prism.languages.javascript
		}
	],
	'constant': /\b[A-Z](?:[A-Z_]|\dx?)*\b/
});

Prism.languages.insertBefore('javascript', 'string', {
	'hashbang': {
		pattern: /^#!.*/,
		greedy: true,
		alias: 'comment'
	},
	'template-string': {
		pattern: /`(?:\\[\s\S]|\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}|(?!\$\{)[^\\`])*`/,
		greedy: true,
		inside: {
			'template-punctuation': {
				pattern: /^`|`$/,
				alias: 'string'
			},
			'interpolation': {
				pattern: /((?:^|[^\\])(?:\\{2})*)\$\{(?:[^{}]|\{(?:[^{}]|\{[^}]*\})*\})+\}/,
				lookbehind: true,
				inside: {
					'interpolation-punctuation': {
						pattern: /^\$\{|\}$/,
						alias: 'punctuation'
					},
					rest: Prism.languages.javascript
				}
			},
			'string': /[\s\S]+/
		}
	},
	'string-property': {
		pattern: /((?:^|[,{])[ \t]*)(["'])(?:\\(?:\r\n|[\s\S])|(?!\2)[^\\\r\n])*\2(?=\s*:)/m,
		lookbehind: true,
		greedy: true,
		alias: 'property'
	}
});

Prism.languages.insertBefore('javascript', 'operator', {
	'literal-property': {
		pattern: /((?:^|[,{])[ \t]*)(?!\s)[_$a-zA-Z\xA0-\uFFFF](?:(?!\s)[$\w\xA0-\uFFFF])*(?=\s*:)/m,
		lookbehind: true,
		alias: 'property'
	},
});

if (Prism.languages.markup) {
	Prism.languages.markup.tag.addInlined('script', 'javascript');

	// add attribute support for all DOM events.
	// https://developer.mozilla.org/en-US/docs/Web/Events#Standard_events
	Prism.languages.markup.tag.addAttribute(
		/on(?:abort|blur|change|click|composition(?:end|start|update)|dblclick|error|focus(?:in|out)?|key(?:down|up)|load|mouse(?:down|enter|leave|move|out|over|up)|reset|resize|scroll|select|slotchange|submit|unload|wheel)/.source,
		'javascript'
	);
}

Prism.languages.js = Prism.languages.javascript;

//
var script$S = {
  components: {
    PrismEditor: PrismEditor
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    lineNumbers: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number,
      default: 300
    }
  },
  watch: {
    value: function value() {
      this.setValue();
    },
    code: function code() {
      this.emitValue();
    }
  },
  data: function data() {
    return {
      code: this.value
    };
  },
  computed: {
    getStyle: function getStyle() {
      var style = {};
      if (this.height > 0) {
        style = {
          height: "".concat(this.height, "px")
        };
      }
      return style;
    }
  },
  methods: {
    highlighter: function highlighter(code) {
      return prismCore.exports.highlight(code, prismCore.exports.languages.js);
    },
    emitValue: function emitValue() {
      this.$emit('input', this.code);
      this.$emit(EVENT_NAME_CHANGE, this.code);
    },
    setValue: function setValue() {
      this.code = this.value;
    }
  },
  mounted: function mounted() {
    this.setValue();
  }
};

/* script */
var __vue_script__$S = script$S;

/* template */
var __vue_render__$S = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('prism-editor', {
    staticClass: "aq-code-editor",
    style: _vm.getStyle,
    attrs: {
      "highlight": _vm.highlighter,
      "line-numbers": _vm.lineNumbers,
      "readonly": _vm.readonly
    },
    model: {
      value: _vm.code,
      callback: function callback($$v) {
        _vm.code = $$v;
      },
      expression: "code"
    }
  });
};
var __vue_staticRenderFns__$S = [];

/* style */
var __vue_inject_styles__$S = undefined;
/* scoped */
var __vue_scope_id__$S = undefined;
/* module identifier */
var __vue_module_identifier__$S = undefined;
/* functional template */
var __vue_is_functional_template__$S = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$S = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$S,
  staticRenderFns: __vue_staticRenderFns__$S
}, __vue_inject_styles__$S, __vue_script__$S, __vue_scope_id__$S, __vue_is_functional_template__$S, __vue_module_identifier__$S, false, undefined, undefined, undefined);
var AqCodeEditor = __vue_component__$S;

var defaultPresetColors = ['#24A852', '#61A824', '#0CA6AB', '#119AEB', '#0A5BFC', '#892CD1', '#BF2367', '#C7242B', '#EC7A22', '#F2C840', '#272A2F', '#FFFFFF', 'rgba(0,0,0,0)'];

// This file is autogenerated. It's used to publish ESM to npm.
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

// https://github.com/bgrins/TinyColor
// Brian Grinstead, MIT License

var trimLeft = /^\s+/;
var trimRight = /\s+$/;
function tinycolor(color, opts) {
  color = color ? color : "";
  opts = opts || {};

  // If input is already a tinycolor, return itself
  if (color instanceof tinycolor) {
    return color;
  }
  // If we are called as a function, call using new instead
  if (!(this instanceof tinycolor)) {
    return new tinycolor(color, opts);
  }
  var rgb = inputToRGB(color);
  this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
  this._gradientType = opts.gradientType;

  // Don't let the range of [0,255] come back in [0,1].
  // Potentially lose a little bit of precision here, but will fix issues where
  // .5 gets interpreted as half of the total, instead of half of 1
  // If it was supposed to be 128, this was already taken care of by `inputToRgb`
  if (this._r < 1) this._r = Math.round(this._r);
  if (this._g < 1) this._g = Math.round(this._g);
  if (this._b < 1) this._b = Math.round(this._b);
  this._ok = rgb.ok;
}
tinycolor.prototype = {
  isDark: function isDark() {
    return this.getBrightness() < 128;
  },
  isLight: function isLight() {
    return !this.isDark();
  },
  isValid: function isValid() {
    return this._ok;
  },
  getOriginalInput: function getOriginalInput() {
    return this._originalInput;
  },
  getFormat: function getFormat() {
    return this._format;
  },
  getAlpha: function getAlpha() {
    return this._a;
  },
  getBrightness: function getBrightness() {
    //http://www.w3.org/TR/AERT#color-contrast
    var rgb = this.toRgb();
    return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
  },
  getLuminance: function getLuminance() {
    //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
    var rgb = this.toRgb();
    var RsRGB, GsRGB, BsRGB, R, G, B;
    RsRGB = rgb.r / 255;
    GsRGB = rgb.g / 255;
    BsRGB = rgb.b / 255;
    if (RsRGB <= 0.03928) R = RsRGB / 12.92;else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
    if (GsRGB <= 0.03928) G = GsRGB / 12.92;else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
    if (BsRGB <= 0.03928) B = BsRGB / 12.92;else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
    return 0.2126 * R + 0.7152 * G + 0.0722 * B;
  },
  setAlpha: function setAlpha(value) {
    this._a = boundAlpha(value);
    this._roundA = Math.round(100 * this._a) / 100;
    return this;
  },
  toHsv: function toHsv() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    return {
      h: hsv.h * 360,
      s: hsv.s,
      v: hsv.v,
      a: this._a
    };
  },
  toHsvString: function toHsvString() {
    var hsv = rgbToHsv(this._r, this._g, this._b);
    var h = Math.round(hsv.h * 360),
      s = Math.round(hsv.s * 100),
      v = Math.round(hsv.v * 100);
    return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
  },
  toHsl: function toHsl() {
    var hsl = rgbToHsl(this._r, this._g, this._b);
    return {
      h: hsl.h * 360,
      s: hsl.s,
      l: hsl.l,
      a: this._a
    };
  },
  toHslString: function toHslString() {
    var hsl = rgbToHsl(this._r, this._g, this._b);
    var h = Math.round(hsl.h * 360),
      s = Math.round(hsl.s * 100),
      l = Math.round(hsl.l * 100);
    return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
  },
  toHex: function toHex(allow3Char) {
    return rgbToHex(this._r, this._g, this._b, allow3Char);
  },
  toHexString: function toHexString(allow3Char) {
    return "#" + this.toHex(allow3Char);
  },
  toHex8: function toHex8(allow4Char) {
    return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
  },
  toHex8String: function toHex8String(allow4Char) {
    return "#" + this.toHex8(allow4Char);
  },
  toRgb: function toRgb() {
    return {
      r: Math.round(this._r),
      g: Math.round(this._g),
      b: Math.round(this._b),
      a: this._a
    };
  },
  toRgbString: function toRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
  },
  toPercentageRgb: function toPercentageRgb() {
    return {
      r: Math.round(bound01(this._r, 255) * 100) + "%",
      g: Math.round(bound01(this._g, 255) * 100) + "%",
      b: Math.round(bound01(this._b, 255) * 100) + "%",
      a: this._a
    };
  },
  toPercentageRgbString: function toPercentageRgbString() {
    return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
  },
  toName: function toName() {
    if (this._a === 0) {
      return "transparent";
    }
    if (this._a < 1) {
      return false;
    }
    return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
  },
  toFilter: function toFilter(secondColor) {
    var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
    var secondHex8String = hex8String;
    var gradientType = this._gradientType ? "GradientType = 1, " : "";
    if (secondColor) {
      var s = tinycolor(secondColor);
      secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
    }
    return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
  },
  toString: function toString(format) {
    var formatSet = !!format;
    format = format || this._format;
    var formattedString = false;
    var hasAlpha = this._a < 1 && this._a >= 0;
    var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
    if (needsAlphaFormat) {
      // Special case for "transparent", all other non-alpha formats
      // will return rgba when there is transparency.
      if (format === "name" && this._a === 0) {
        return this.toName();
      }
      return this.toRgbString();
    }
    if (format === "rgb") {
      formattedString = this.toRgbString();
    }
    if (format === "prgb") {
      formattedString = this.toPercentageRgbString();
    }
    if (format === "hex" || format === "hex6") {
      formattedString = this.toHexString();
    }
    if (format === "hex3") {
      formattedString = this.toHexString(true);
    }
    if (format === "hex4") {
      formattedString = this.toHex8String(true);
    }
    if (format === "hex8") {
      formattedString = this.toHex8String();
    }
    if (format === "name") {
      formattedString = this.toName();
    }
    if (format === "hsl") {
      formattedString = this.toHslString();
    }
    if (format === "hsv") {
      formattedString = this.toHsvString();
    }
    return formattedString || this.toHexString();
  },
  clone: function clone() {
    return tinycolor(this.toString());
  },
  _applyModification: function _applyModification(fn, args) {
    var color = fn.apply(null, [this].concat([].slice.call(args)));
    this._r = color._r;
    this._g = color._g;
    this._b = color._b;
    this.setAlpha(color._a);
    return this;
  },
  lighten: function lighten() {
    return this._applyModification(_lighten, arguments);
  },
  brighten: function brighten() {
    return this._applyModification(_brighten, arguments);
  },
  darken: function darken() {
    return this._applyModification(_darken, arguments);
  },
  desaturate: function desaturate() {
    return this._applyModification(_desaturate, arguments);
  },
  saturate: function saturate() {
    return this._applyModification(_saturate, arguments);
  },
  greyscale: function greyscale() {
    return this._applyModification(_greyscale, arguments);
  },
  spin: function spin() {
    return this._applyModification(_spin, arguments);
  },
  _applyCombination: function _applyCombination(fn, args) {
    return fn.apply(null, [this].concat([].slice.call(args)));
  },
  analogous: function analogous() {
    return this._applyCombination(_analogous, arguments);
  },
  complement: function complement() {
    return this._applyCombination(_complement, arguments);
  },
  monochromatic: function monochromatic() {
    return this._applyCombination(_monochromatic, arguments);
  },
  splitcomplement: function splitcomplement() {
    return this._applyCombination(_splitcomplement, arguments);
  },
  // Disabled until https://github.com/bgrins/TinyColor/issues/254
  // polyad: function (number) {
  //   return this._applyCombination(polyad, [number]);
  // },
  triad: function triad() {
    return this._applyCombination(polyad, [3]);
  },
  tetrad: function tetrad() {
    return this._applyCombination(polyad, [4]);
  }
};

// If input is an object, force 1 into "1.0" to handle ratios properly
// String input requires "1.0" as input, so 1 will be treated as 1
tinycolor.fromRatio = function (color, opts) {
  if (_typeof(color) == "object") {
    var newColor = {};
    for (var i in color) {
      if (color.hasOwnProperty(i)) {
        if (i === "a") {
          newColor[i] = color[i];
        } else {
          newColor[i] = convertToPercentage(color[i]);
        }
      }
    }
    color = newColor;
  }
  return tinycolor(color, opts);
};

// Given a string or object, convert that input to RGB
// Possible string inputs:
//
//     "red"
//     "#f00" or "f00"
//     "#ff0000" or "ff0000"
//     "#ff000000" or "ff000000"
//     "rgb 255 0 0" or "rgb (255, 0, 0)"
//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
//
function inputToRGB(color) {
  var rgb = {
    r: 0,
    g: 0,
    b: 0
  };
  var a = 1;
  var s = null;
  var v = null;
  var l = null;
  var ok = false;
  var format = false;
  if (typeof color == "string") {
    color = stringInputToObject(color);
  }
  if (_typeof(color) == "object") {
    if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
      rgb = rgbToRgb(color.r, color.g, color.b);
      ok = true;
      format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
      s = convertToPercentage(color.s);
      v = convertToPercentage(color.v);
      rgb = hsvToRgb(color.h, s, v);
      ok = true;
      format = "hsv";
    } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
      s = convertToPercentage(color.s);
      l = convertToPercentage(color.l);
      rgb = hslToRgb(color.h, s, l);
      ok = true;
      format = "hsl";
    }
    if (color.hasOwnProperty("a")) {
      a = color.a;
    }
  }
  a = boundAlpha(a);
  return {
    ok: ok,
    format: color.format || format,
    r: Math.min(255, Math.max(rgb.r, 0)),
    g: Math.min(255, Math.max(rgb.g, 0)),
    b: Math.min(255, Math.max(rgb.b, 0)),
    a: a
  };
}

// Conversion Functions
// --------------------

// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

// `rgbToRgb`
// Handle bounds / percentage checking to conform to CSS color spec
// <http://www.w3.org/TR/css3-color/>
// *Assumes:* r, g, b in [0, 255] or [0, 1]
// *Returns:* { r, g, b } in [0, 255]
function rgbToRgb(r, g, b) {
  return {
    r: bound01(r, 255) * 255,
    g: bound01(g, 255) * 255,
    b: bound01(b, 255) * 255
  };
}

// `rgbToHsl`
// Converts an RGB color value to HSL.
// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
// *Returns:* { h, s, l } in [0,1]
function rgbToHsl(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  var h,
    s,
    l = (max + min) / 2;
  if (max == min) {
    h = s = 0; // achromatic
  } else {
    var d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return {
    h: h,
    s: s,
    l: l
  };
}

// `hslToRgb`
// Converts an HSL color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hslToRgb(h, s, l) {
  var r, g, b;
  h = bound01(h, 360);
  s = bound01(s, 100);
  l = bound01(l, 100);
  function hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 1 / 2) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
  }
  if (s === 0) {
    r = g = b = l; // achromatic
  } else {
    var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  return {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
}

// `rgbToHsv`
// Converts an RGB color value to HSV
// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
// *Returns:* { h, s, v } in [0,1]
function rgbToHsv(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max = Math.max(r, g, b),
    min = Math.min(r, g, b);
  var h,
    s,
    v = max;
  var d = max - min;
  s = max === 0 ? 0 : d / max;
  if (max == min) {
    h = 0; // achromatic
  } else {
    switch (max) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return {
    h: h,
    s: s,
    v: v
  };
}

// `hsvToRgb`
// Converts an HSV color value to RGB.
// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
// *Returns:* { r, g, b } in the set [0, 255]
function hsvToRgb(h, s, v) {
  h = bound01(h, 360) * 6;
  s = bound01(s, 100);
  v = bound01(v, 100);
  var i = Math.floor(h),
    f = h - i,
    p = v * (1 - s),
    q = v * (1 - f * s),
    t = v * (1 - (1 - f) * s),
    mod = i % 6,
    r = [v, q, p, p, t, v][mod],
    g = [t, v, v, q, p, p][mod],
    b = [p, p, t, v, v, q][mod];
  return {
    r: r * 255,
    g: g * 255,
    b: b * 255
  };
}

// `rgbToHex`
// Converts an RGB color to hex
// Assumes r, g, and b are contained in the set [0, 255]
// Returns a 3 or 6 character hex
function rgbToHex(r, g, b, allow3Char) {
  var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];

  // Return a 3 character hex if possible
  if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
  }
  return hex.join("");
}

// `rgbaToHex`
// Converts an RGBA color plus alpha transparency to hex
// Assumes r, g, b are contained in the set [0, 255] and
// a in [0, 1]. Returns a 4 or 8 character rgba hex
function rgbaToHex(r, g, b, a, allow4Char) {
  var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))];

  // Return a 4 character hex if possible
  if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
    return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
  }
  return hex.join("");
}

// `rgbaToArgbHex`
// Converts an RGBA color to an ARGB Hex8 string
// Rarely used, but required for "toFilter()"
function rgbaToArgbHex(r, g, b, a) {
  var hex = [pad2(convertDecimalToHex(a)), pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
  return hex.join("");
}

// `equals`
// Can be called with any tinycolor input
tinycolor.equals = function (color1, color2) {
  if (!color1 || !color2) return false;
  return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
};
tinycolor.random = function () {
  return tinycolor.fromRatio({
    r: Math.random(),
    g: Math.random(),
    b: Math.random()
  });
};

// Modification Functions
// ----------------------
// Thanks to less.js for some of the basics here
// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

function _desaturate(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.s -= amount / 100;
  hsl.s = clamp01(hsl.s);
  return tinycolor(hsl);
}
function _saturate(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.s += amount / 100;
  hsl.s = clamp01(hsl.s);
  return tinycolor(hsl);
}
function _greyscale(color) {
  return tinycolor(color).desaturate(100);
}
function _lighten(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.l += amount / 100;
  hsl.l = clamp01(hsl.l);
  return tinycolor(hsl);
}
function _brighten(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var rgb = tinycolor(color).toRgb();
  rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
  rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
  rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
  return tinycolor(rgb);
}
function _darken(color, amount) {
  amount = amount === 0 ? 0 : amount || 10;
  var hsl = tinycolor(color).toHsl();
  hsl.l -= amount / 100;
  hsl.l = clamp01(hsl.l);
  return tinycolor(hsl);
}

// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
// Values outside of this range will be wrapped into this range.
function _spin(color, amount) {
  var hsl = tinycolor(color).toHsl();
  var hue = (hsl.h + amount) % 360;
  hsl.h = hue < 0 ? 360 + hue : hue;
  return tinycolor(hsl);
}

// Combination Functions
// ---------------------
// Thanks to jQuery xColor for some of the ideas behind these
// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

function _complement(color) {
  var hsl = tinycolor(color).toHsl();
  hsl.h = (hsl.h + 180) % 360;
  return tinycolor(hsl);
}
function polyad(color, number) {
  if (isNaN(number) || number <= 0) {
    throw new Error("Argument to polyad must be a positive number");
  }
  var hsl = tinycolor(color).toHsl();
  var result = [tinycolor(color)];
  var step = 360 / number;
  for (var i = 1; i < number; i++) {
    result.push(tinycolor({
      h: (hsl.h + i * step) % 360,
      s: hsl.s,
      l: hsl.l
    }));
  }
  return result;
}
function _splitcomplement(color) {
  var hsl = tinycolor(color).toHsl();
  var h = hsl.h;
  return [tinycolor(color), tinycolor({
    h: (h + 72) % 360,
    s: hsl.s,
    l: hsl.l
  }), tinycolor({
    h: (h + 216) % 360,
    s: hsl.s,
    l: hsl.l
  })];
}
function _analogous(color, results, slices) {
  results = results || 6;
  slices = slices || 30;
  var hsl = tinycolor(color).toHsl();
  var part = 360 / slices;
  var ret = [tinycolor(color)];
  for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
    hsl.h = (hsl.h + part) % 360;
    ret.push(tinycolor(hsl));
  }
  return ret;
}
function _monochromatic(color, results) {
  results = results || 6;
  var hsv = tinycolor(color).toHsv();
  var h = hsv.h,
    s = hsv.s,
    v = hsv.v;
  var ret = [];
  var modification = 1 / results;
  while (results--) {
    ret.push(tinycolor({
      h: h,
      s: s,
      v: v
    }));
    v = (v + modification) % 1;
  }
  return ret;
}

// Utility Functions
// ---------------------

tinycolor.mix = function (color1, color2, amount) {
  amount = amount === 0 ? 0 : amount || 50;
  var rgb1 = tinycolor(color1).toRgb();
  var rgb2 = tinycolor(color2).toRgb();
  var p = amount / 100;
  var rgba = {
    r: (rgb2.r - rgb1.r) * p + rgb1.r,
    g: (rgb2.g - rgb1.g) * p + rgb1.g,
    b: (rgb2.b - rgb1.b) * p + rgb1.b,
    a: (rgb2.a - rgb1.a) * p + rgb1.a
  };
  return tinycolor(rgba);
};

// Readability Functions
// ---------------------
// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

// `contrast`
// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
tinycolor.readability = function (color1, color2) {
  var c1 = tinycolor(color1);
  var c2 = tinycolor(color2);
  return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
};

// `isReadable`
// Ensure that foreground and background color combinations meet WCAG2 guidelines.
// The third argument is an optional Object.
//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

// *Example*
//    tinycolor.isReadable("#000", "#111") => false
//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
tinycolor.isReadable = function (color1, color2, wcag2) {
  var readability = tinycolor.readability(color1, color2);
  var wcag2Parms, out;
  out = false;
  wcag2Parms = validateWCAG2Parms(wcag2);
  switch (wcag2Parms.level + wcag2Parms.size) {
    case "AAsmall":
    case "AAAlarge":
      out = readability >= 4.5;
      break;
    case "AAlarge":
      out = readability >= 3;
      break;
    case "AAAsmall":
      out = readability >= 7;
      break;
  }
  return out;
};

// `mostReadable`
// Given a base color and a list of possible foreground or background
// colors for that base, returns the most readable color.
// Optionally returns Black or White if the most readable color is unreadable.
// *Example*
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
tinycolor.mostReadable = function (baseColor, colorList, args) {
  var bestColor = null;
  var bestScore = 0;
  var readability;
  var includeFallbackColors, level, size;
  args = args || {};
  includeFallbackColors = args.includeFallbackColors;
  level = args.level;
  size = args.size;
  for (var i = 0; i < colorList.length; i++) {
    readability = tinycolor.readability(baseColor, colorList[i]);
    if (readability > bestScore) {
      bestScore = readability;
      bestColor = tinycolor(colorList[i]);
    }
  }
  if (tinycolor.isReadable(baseColor, bestColor, {
    level: level,
    size: size
  }) || !includeFallbackColors) {
    return bestColor;
  } else {
    args.includeFallbackColors = false;
    return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
  }
};

// Big List of Colors
// ------------------
// <https://www.w3.org/TR/css-color-4/#named-colors>
var names = tinycolor.names = {
  aliceblue: "f0f8ff",
  antiquewhite: "faebd7",
  aqua: "0ff",
  aquamarine: "7fffd4",
  azure: "f0ffff",
  beige: "f5f5dc",
  bisque: "ffe4c4",
  black: "000",
  blanchedalmond: "ffebcd",
  blue: "00f",
  blueviolet: "8a2be2",
  brown: "a52a2a",
  burlywood: "deb887",
  burntsienna: "ea7e5d",
  cadetblue: "5f9ea0",
  chartreuse: "7fff00",
  chocolate: "d2691e",
  coral: "ff7f50",
  cornflowerblue: "6495ed",
  cornsilk: "fff8dc",
  crimson: "dc143c",
  cyan: "0ff",
  darkblue: "00008b",
  darkcyan: "008b8b",
  darkgoldenrod: "b8860b",
  darkgray: "a9a9a9",
  darkgreen: "006400",
  darkgrey: "a9a9a9",
  darkkhaki: "bdb76b",
  darkmagenta: "8b008b",
  darkolivegreen: "556b2f",
  darkorange: "ff8c00",
  darkorchid: "9932cc",
  darkred: "8b0000",
  darksalmon: "e9967a",
  darkseagreen: "8fbc8f",
  darkslateblue: "483d8b",
  darkslategray: "2f4f4f",
  darkslategrey: "2f4f4f",
  darkturquoise: "00ced1",
  darkviolet: "9400d3",
  deeppink: "ff1493",
  deepskyblue: "00bfff",
  dimgray: "696969",
  dimgrey: "696969",
  dodgerblue: "1e90ff",
  firebrick: "b22222",
  floralwhite: "fffaf0",
  forestgreen: "228b22",
  fuchsia: "f0f",
  gainsboro: "dcdcdc",
  ghostwhite: "f8f8ff",
  gold: "ffd700",
  goldenrod: "daa520",
  gray: "808080",
  green: "008000",
  greenyellow: "adff2f",
  grey: "808080",
  honeydew: "f0fff0",
  hotpink: "ff69b4",
  indianred: "cd5c5c",
  indigo: "4b0082",
  ivory: "fffff0",
  khaki: "f0e68c",
  lavender: "e6e6fa",
  lavenderblush: "fff0f5",
  lawngreen: "7cfc00",
  lemonchiffon: "fffacd",
  lightblue: "add8e6",
  lightcoral: "f08080",
  lightcyan: "e0ffff",
  lightgoldenrodyellow: "fafad2",
  lightgray: "d3d3d3",
  lightgreen: "90ee90",
  lightgrey: "d3d3d3",
  lightpink: "ffb6c1",
  lightsalmon: "ffa07a",
  lightseagreen: "20b2aa",
  lightskyblue: "87cefa",
  lightslategray: "789",
  lightslategrey: "789",
  lightsteelblue: "b0c4de",
  lightyellow: "ffffe0",
  lime: "0f0",
  limegreen: "32cd32",
  linen: "faf0e6",
  magenta: "f0f",
  maroon: "800000",
  mediumaquamarine: "66cdaa",
  mediumblue: "0000cd",
  mediumorchid: "ba55d3",
  mediumpurple: "9370db",
  mediumseagreen: "3cb371",
  mediumslateblue: "7b68ee",
  mediumspringgreen: "00fa9a",
  mediumturquoise: "48d1cc",
  mediumvioletred: "c71585",
  midnightblue: "191970",
  mintcream: "f5fffa",
  mistyrose: "ffe4e1",
  moccasin: "ffe4b5",
  navajowhite: "ffdead",
  navy: "000080",
  oldlace: "fdf5e6",
  olive: "808000",
  olivedrab: "6b8e23",
  orange: "ffa500",
  orangered: "ff4500",
  orchid: "da70d6",
  palegoldenrod: "eee8aa",
  palegreen: "98fb98",
  paleturquoise: "afeeee",
  palevioletred: "db7093",
  papayawhip: "ffefd5",
  peachpuff: "ffdab9",
  peru: "cd853f",
  pink: "ffc0cb",
  plum: "dda0dd",
  powderblue: "b0e0e6",
  purple: "800080",
  rebeccapurple: "663399",
  red: "f00",
  rosybrown: "bc8f8f",
  royalblue: "4169e1",
  saddlebrown: "8b4513",
  salmon: "fa8072",
  sandybrown: "f4a460",
  seagreen: "2e8b57",
  seashell: "fff5ee",
  sienna: "a0522d",
  silver: "c0c0c0",
  skyblue: "87ceeb",
  slateblue: "6a5acd",
  slategray: "708090",
  slategrey: "708090",
  snow: "fffafa",
  springgreen: "00ff7f",
  steelblue: "4682b4",
  tan: "d2b48c",
  teal: "008080",
  thistle: "d8bfd8",
  tomato: "ff6347",
  turquoise: "40e0d0",
  violet: "ee82ee",
  wheat: "f5deb3",
  white: "fff",
  whitesmoke: "f5f5f5",
  yellow: "ff0",
  yellowgreen: "9acd32"
};

// Make it easy to access colors via `hexNames[hex]`
var hexNames = tinycolor.hexNames = flip(names);

// Utilities
// ---------

// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
function flip(o) {
  var flipped = {};
  for (var i in o) {
    if (o.hasOwnProperty(i)) {
      flipped[o[i]] = i;
    }
  }
  return flipped;
}

// Return a valid alpha value [0,1] with all invalid values being set to 1
function boundAlpha(a) {
  a = parseFloat(a);
  if (isNaN(a) || a < 0 || a > 1) {
    a = 1;
  }
  return a;
}

// Take input from [0, n] and return it as [0, 1]
function bound01(n, max) {
  if (isOnePointZero(n)) n = "100%";
  var processPercent = isPercentage(n);
  n = Math.min(max, Math.max(0, parseFloat(n)));

  // Automatically convert percentage into number
  if (processPercent) {
    n = parseInt(n * max, 10) / 100;
  }

  // Handle floating point rounding errors
  if (Math.abs(n - max) < 0.000001) {
    return 1;
  }

  // Convert into [0, 1] range if it isn't already
  return n % max / parseFloat(max);
}

// Force a number between 0 and 1
function clamp01(val) {
  return Math.min(1, Math.max(0, val));
}

// Parse a base-16 hex value into a base-10 integer
function parseIntFromHex(val) {
  return parseInt(val, 16);
}

// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
function isOnePointZero(n) {
  return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
}

// Check to see if string passed in is a percentage
function isPercentage(n) {
  return typeof n === "string" && n.indexOf("%") != -1;
}

// Force a hex value to have 2 characters
function pad2(c) {
  return c.length == 1 ? "0" + c : "" + c;
}

// Replace a decimal with it's percentage value
function convertToPercentage(n) {
  if (n <= 1) {
    n = n * 100 + "%";
  }
  return n;
}

// Converts a decimal to a hex value
function convertDecimalToHex(d) {
  return Math.round(parseFloat(d) * 255).toString(16);
}
// Converts a hex value to a decimal
function convertHexToDecimal(h) {
  return parseIntFromHex(h) / 255;
}
var matchers = function () {
  // <http://www.w3.org/TR/css3-values/#integers>
  var CSS_INTEGER = "[-\\+]?\\d+%?";

  // <http://www.w3.org/TR/css3-values/#number-value>
  var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

  // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
  var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

  // Actual matching.
  // Parentheses and commas are optional, but not required.
  // Whitespace can take the place of commas or opening paren
  var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
  return {
    CSS_UNIT: new RegExp(CSS_UNIT),
    rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
    rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
    hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
    hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
    hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
    hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
    hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
    hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
    hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
  };
}();

// `isValidCSSUnit`
// Take in a single string / number and check to see if it looks like a CSS unit
// (see `matchers` above for definition).
function isValidCSSUnit(color) {
  return !!matchers.CSS_UNIT.exec(color);
}

// `stringInputToObject`
// Permissive string parsing.  Take in a number of formats, and output an object
// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
function stringInputToObject(color) {
  color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
  var named = false;
  if (names[color]) {
    color = names[color];
    named = true;
  } else if (color == "transparent") {
    return {
      r: 0,
      g: 0,
      b: 0,
      a: 0,
      format: "name"
    };
  }

  // Try to match string input using regular expressions.
  // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
  // Just return an object and let the conversion functions handle that.
  // This way the result will be the same whether the tinycolor is initialized with string or object.
  var match;
  if (match = matchers.rgb.exec(color)) {
    return {
      r: match[1],
      g: match[2],
      b: match[3]
    };
  }
  if (match = matchers.rgba.exec(color)) {
    return {
      r: match[1],
      g: match[2],
      b: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hsl.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      l: match[3]
    };
  }
  if (match = matchers.hsla.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      l: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hsv.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      v: match[3]
    };
  }
  if (match = matchers.hsva.exec(color)) {
    return {
      h: match[1],
      s: match[2],
      v: match[3],
      a: match[4]
    };
  }
  if (match = matchers.hex8.exec(color)) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      a: convertHexToDecimal(match[4]),
      format: named ? "name" : "hex8"
    };
  }
  if (match = matchers.hex6.exec(color)) {
    return {
      r: parseIntFromHex(match[1]),
      g: parseIntFromHex(match[2]),
      b: parseIntFromHex(match[3]),
      format: named ? "name" : "hex"
    };
  }
  if (match = matchers.hex4.exec(color)) {
    return {
      r: parseIntFromHex(match[1] + "" + match[1]),
      g: parseIntFromHex(match[2] + "" + match[2]),
      b: parseIntFromHex(match[3] + "" + match[3]),
      a: convertHexToDecimal(match[4] + "" + match[4]),
      format: named ? "name" : "hex8"
    };
  }
  if (match = matchers.hex3.exec(color)) {
    return {
      r: parseIntFromHex(match[1] + "" + match[1]),
      g: parseIntFromHex(match[2] + "" + match[2]),
      b: parseIntFromHex(match[3] + "" + match[3]),
      format: named ? "name" : "hex"
    };
  }
  return false;
}
function validateWCAG2Parms(parms) {
  // return valid WCAG2 parms for isReadable.
  // If input parms are invalid, return {"level":"AA", "size":"small"}
  var level, size;
  parms = parms || {
    level: "AA",
    size: "small"
  };
  level = (parms.level || "AA").toUpperCase();
  size = (parms.size || "small").toLowerCase();
  if (level !== "AA" && level !== "AAA") {
    level = "AA";
  }
  if (size !== "small" && size !== "large") {
    size = "small";
  }
  return {
    level: level,
    size: size
  };
}

//
//
//
//
//
//
//
//
//
//
//
//

var script$R = {
  name: 'editableInput',
  props: {
    label: String,
    labelText: String,
    desc: String,
    value: [String, Number],
    max: Number,
    min: Number,
    arrowOffset: {
      type: Number,
      default: 1
    }
  },
  computed: {
    val: {
      get: function get() {
        return this.value;
      },
      set: function set(v) {
        // TODO: min
        if (!(this.max === undefined) && +v > this.max) {
          // eslint-disable-next-line no-param-reassign
          v = this.max;
        } else {
          return v;
        }
        return null;
      }
    },
    labelId: function labelId() {
      return "input__label__".concat(this.label, "__").concat(Math.random().toString().slice(2, 5));
    },
    labelSpanText: function labelSpanText() {
      return this.labelText || this.label;
    }
  },
  methods: {
    update: function update(value) {
      this.handleChange(value);
    },
    handleChange: function handleChange(newVal) {
      var data = {};
      data[this.label] = newVal;
      if (data.hex === undefined && data['#'] === undefined) {
        this.$emit('change', data);
      } else if ((newVal === null || newVal === void 0 ? void 0 : newVal.length) > 5) {
        this.$emit('change', data);
      }
    },
    // **** unused
    // handleBlur (e) {
    //   console.log(e)
    // },
    handleKeyDown: function handleKeyDown(e) {
      var val = this.val;
      var number = Number(val);
      if (number) {
        var amount = this.arrowOffset || 1;

        // Up
        if (e.keyCode === 38) {
          val = number + amount;
          this.handleChange(val);
          e.preventDefault();
        }

        // Down
        if (e.keyCode === 40) {
          val = number - amount;
          this.handleChange(val);
          e.preventDefault();
        }
      }
    } // **** unused
    // handleDrag (e) {
    //   console.log(e)
    // },
    // handleMouseDown (e) {
    //   console.log(e)
    // }
  }
};

/* script */
var __vue_script__$R = script$R;

/* template */
var __vue_render__$R = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('aq-text-field', {
    ref: "input",
    attrs: {
      "sublabel": _vm.labelText,
      "aria-labelledby": _vm.labelId
    },
    on: {
      "change": _vm.update,
      "keydown": _vm.handleKeyDown
    },
    model: {
      value: _vm.val,
      callback: function callback($$v) {
        _vm.val = $$v;
      },
      expression: "val"
    }
  });
};
var __vue_staticRenderFns__$R = [];

/* style */
var __vue_inject_styles__$R = undefined;
/* scoped */
var __vue_scope_id__$R = undefined;
/* module identifier */
var __vue_module_identifier__$R = undefined;
/* functional template */
var __vue_is_functional_template__$R = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$R = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$R,
  staticRenderFns: __vue_staticRenderFns__$R
}, __vue_inject_styles__$R, __vue_script__$R, __vue_scope_id__$R, __vue_is_functional_template__$R, __vue_module_identifier__$R, false, undefined, undefined, undefined);
var editableInput = __vue_component__$R;

var clamp_1 = clamp;

function clamp(value, min, max) {
  return min < max
    ? (value < min ? min : value > max ? max : value)
    : (value < max ? max : value > min ? min : value)
}

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject$1(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject$1(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject$1(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject$1(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

var lodash_throttle = throttle;

//
var script$Q = {
  name: 'Saturation',
  props: {
    value: Object
  },
  computed: {
    colors: function colors() {
      return this.value;
    },
    bgColor: function bgColor() {
      return "hsl(".concat(this.colors.hsv.h, ", 100%, 50%)");
    },
    pointerTop: function pointerTop() {
      return "".concat(-(this.colors.hsv.v * 100) + 1 + 100, "%");
    },
    pointerLeft: function pointerLeft() {
      return "".concat(this.colors.hsv.s * 100, "%");
    }
  },
  methods: {
    throttle: lodash_throttle(function (fn, data) {
      fn(data);
    }, 20, {
      leading: true,
      trailing: false
    }),
    handleChange: function handleChange(e, skip) {
      if (!skip) e.preventDefault();
      var container = this.$refs.container;
      if (!container) {
        // for some edge cases, container may not exist. see #220
        return;
      }
      var containerWidth = container.clientWidth;
      var containerHeight = container.clientHeight;
      var xOffset = container.getBoundingClientRect().left + window.pageXOffset;
      var yOffset = container.getBoundingClientRect().top + window.pageYOffset;
      var pageX = e.pageX || (e.touches ? e.touches[0].pageX : 0);
      var pageY = e.pageY || (e.touches ? e.touches[0].pageY : 0);
      var left = clamp_1(pageX - xOffset, 0, containerWidth);
      var top = clamp_1(pageY - yOffset, 0, containerHeight);
      var saturation = left / containerWidth;
      var bright = clamp_1(-(top / containerHeight) + 1, 0, 1);
      this.throttle(this.onChange, {
        h: this.colors.hsv.h,
        s: saturation,
        v: bright,
        a: this.colors.hsv.a,
        source: 'hsva'
      });
    },
    onChange: function onChange(param) {
      this.$emit('change', param);
    },
    handleMouseDown: function handleMouseDown() {
      // this.handleChange(e, true)
      document.addEventListener('mousemove', this.handleChange);
      document.addEventListener('mouseup', this.handleChange);
      document.addEventListener('mouseup', this.handleMouseUp);
    },
    handleMouseUp: function handleMouseUp() {
      this.unbindEventListeners();
    },
    unbindEventListeners: function unbindEventListeners() {
      document.removeEventListener('mousemove', this.handleChange);
      document.removeEventListener('mouseup', this.handleChange);
      document.removeEventListener('mouseup', this.handleMouseUp);
    }
  }
};

/* script */
var __vue_script__$Q = script$Q;

/* template */
var __vue_render__$Q = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "container",
    staticClass: "vc-saturation",
    style: {
      background: _vm.bgColor
    },
    on: {
      "mousedown": _vm.handleMouseDown,
      "touchmove": _vm.handleChange,
      "touchstart": _vm.handleChange
    }
  }, [_c('div', {
    staticClass: "vc-saturation--white"
  }), _vm._v(" "), _c('div', {
    staticClass: "vc-saturation--black"
  }), _vm._v(" "), _c('div', {
    staticClass: "vc-saturation-pointer",
    style: {
      top: _vm.pointerTop,
      left: _vm.pointerLeft
    }
  }, [_c('div', {
    staticClass: "vc-saturation-circle"
  })])]);
};
var __vue_staticRenderFns__$Q = [];

/* style */
var __vue_inject_styles__$Q = undefined;
/* scoped */
var __vue_scope_id__$Q = undefined;
/* module identifier */
var __vue_module_identifier__$Q = undefined;
/* functional template */
var __vue_is_functional_template__$Q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$Q = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$Q,
  staticRenderFns: __vue_staticRenderFns__$Q
}, __vue_inject_styles__$Q, __vue_script__$Q, __vue_scope_id__$Q, __vue_is_functional_template__$Q, __vue_module_identifier__$Q, false, undefined, undefined, undefined);
var saturation = __vue_component__$Q;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$P = {
  name: 'Hue',
  props: {
    value: Object,
    direction: {
      type: String,
      // [horizontal | vertical]
      default: 'horizontal'
    }
  },
  data: function data() {
    return {
      oldHue: 0,
      pullDirection: ''
    };
  },
  computed: {
    colors: function colors() {
      var h = this.value.hsl.h;
      // eslint-disable-next-line
      if (h !== 0 && h - this.oldHue > 0) this.pullDirection = 'right';
      // eslint-disable-next-line
      if (h !== 0 && h - this.oldHue < 0) this.pullDirection = 'left';
      // eslint-disable-next-line
      this.oldHue = h;
      return this.value;
    },
    directionClass: function directionClass() {
      return {
        'vc-hue--horizontal': this.direction === 'horizontal',
        'vc-hue--vertical': this.direction === 'vertical'
      };
    },
    pointerTop: function pointerTop() {
      if (this.direction === 'vertical') {
        if (this.colors.hsl.h === 0 && this.pullDirection === 'right') return 0;
        return "".concat(-(this.colors.hsl.h * 100 / 360) + 100, "%");
      }
      return 0;
    },
    pointerLeft: function pointerLeft() {
      if (this.direction === 'vertical') {
        return 0;
      }
      if (this.colors.hsl.h === 0 && this.pullDirection === 'right') return '100%';
      return "".concat(this.colors.hsl.h * 100 / 360, "%");
    }
  },
  methods: {
    handleChange: function handleChange(e, skip) {
      if (!skip) e.preventDefault();
      var container = this.$refs.container;
      if (!container) {
        // for some edge cases, container may not exist. see #220
        return;
      }
      var containerWidth = container.clientWidth;
      var containerHeight = container.clientHeight;
      var xOffset = container.getBoundingClientRect().left + window.pageXOffset;
      var yOffset = container.getBoundingClientRect().top + window.pageYOffset;
      var pageX = e.pageX || (e.touches ? e.touches[0].pageX : 0);
      var pageY = e.pageY || (e.touches ? e.touches[0].pageY : 0);
      var left = pageX - xOffset;
      var top = pageY - yOffset;
      var h;
      var percent;
      if (this.direction === 'vertical') {
        if (top < 0) {
          h = 360;
        } else if (top > containerHeight) {
          h = 0;
        } else {
          percent = -(top * 100 / containerHeight) + 100;
          h = 360 * percent / 100;
        }
        if (this.colors.hsl.h !== h) {
          this.$emit('change', {
            h: h,
            s: this.colors.hsl.s,
            l: this.colors.hsl.l,
            a: this.colors.hsl.a,
            source: 'hsl'
          });
        }
      } else {
        if (left < 0) {
          h = 0;
        } else if (left > containerWidth) {
          h = 360;
        } else {
          percent = left * 100 / containerWidth;
          h = 360 * percent / 100;
        }
        if (this.colors.hsl.h !== h) {
          this.$emit('change', {
            h: h,
            s: this.colors.hsl.s,
            l: this.colors.hsl.l,
            a: this.colors.hsl.a,
            source: 'hsl'
          });
        }
      }
    },
    handleMouseDown: function handleMouseDown(e) {
      this.handleChange(e, true);
      document.addEventListener('mousemove', this.handleChange);
      document.addEventListener('mouseup', this.handleMouseUp);
    },
    handleMouseUp: function handleMouseUp() {
      this.unbindEventListeners();
    },
    unbindEventListeners: function unbindEventListeners() {
      document.removeEventListener('mousemove', this.handleChange);
      document.removeEventListener('mouseup', this.handleMouseUp);
    }
  }
};

/* script */
var __vue_script__$P = script$P;

/* template */
var __vue_render__$P = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['vc-hue', _vm.directionClass]
  }, [_c('div', {
    ref: "container",
    staticClass: "vc-hue-container",
    attrs: {
      "role": "slider",
      "aria-valuenow": _vm.colors.hsl.h,
      "aria-valuemin": "0",
      "aria-valuemax": "360"
    },
    on: {
      "mousedown": _vm.handleMouseDown,
      "touchmove": _vm.handleChange,
      "touchstart": _vm.handleChange
    }
  }, [_c('div', {
    staticClass: "vc-hue-pointer",
    style: {
      top: _vm.pointerTop,
      left: _vm.pointerLeft
    },
    attrs: {
      "role": "presentation"
    }
  }, [_c('div', {
    staticClass: "vc-hue-picker"
  })])])]);
};
var __vue_staticRenderFns__$P = [];

/* style */
var __vue_inject_styles__$P = undefined;
/* scoped */
var __vue_scope_id__$P = undefined;
/* module identifier */
var __vue_module_identifier__$P = undefined;
/* functional template */
var __vue_is_functional_template__$P = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$P = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$P,
  staticRenderFns: __vue_staticRenderFns__$P
}, __vue_inject_styles__$P, __vue_script__$P, __vue_scope_id__$P, __vue_is_functional_template__$P, __vue_module_identifier__$P, false, undefined, undefined, undefined);
var hue = __vue_component__$P;

//
//
//
//

var checkboardCache = {};
/**
 * get base 64 data by canvas
 *
 * @param {String} c1 hex color
 * @param {String} c2 hex color
 * @param {Number} size
 */

function renderCheckboard(c1, c2, size) {
  // Dont Render On Server
  if (typeof document === 'undefined') {
    return null;
  }
  var canvas = document.createElement('canvas');
  // eslint-disable-next-line
  canvas.width = canvas.height = size * 2;
  var ctx = canvas.getContext('2d');
  // If no context can be found, return early.
  if (!ctx) {
    return null;
  }
  ctx.fillStyle = c1;
  ctx.fillRect(0, 0, canvas.width, canvas.height);
  ctx.fillStyle = c2;
  ctx.fillRect(0, 0, size, size);
  ctx.translate(size, size);
  ctx.fillRect(0, 0, size, size);
  return canvas.toDataURL();
}

/**
 * get checkboard base data and cache
 *
 * @param {String} c1 hex color
 * @param {String} c2 hex color
 * @param {Number} size
 */

function getCheckboard(c1, c2, size) {
  var key = "".concat(c1, ",").concat(c2, ",").concat(size);
  if (checkboardCache[key]) {
    return checkboardCache[key];
  }
  var checkboard = renderCheckboard(c1, c2, size);
  checkboardCache[key] = checkboard;
  return checkboard;
}
var script$O = {
  name: 'Checkboard',
  props: {
    size: {
      type: [Number, String],
      default: 8
    },
    white: {
      type: String,
      default: '#fff'
    },
    grey: {
      type: String,
      default: '#e6e6e6'
    }
  },
  computed: {
    bgStyle: function bgStyle() {
      return {
        'background-image': "url(".concat(getCheckboard(this.white, this.grey, this.size), ")")
      };
    }
  }
};

/* script */
var __vue_script__$O = script$O;

/* template */
var __vue_render__$O = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "vc-checkerboard",
    style: _vm.bgStyle
  });
};
var __vue_staticRenderFns__$O = [];

/* style */
var __vue_inject_styles__$O = undefined;
/* scoped */
var __vue_scope_id__$O = undefined;
/* module identifier */
var __vue_module_identifier__$O = undefined;
/* functional template */
var __vue_is_functional_template__$O = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$O = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$O,
  staticRenderFns: __vue_staticRenderFns__$O
}, __vue_inject_styles__$O, __vue_script__$O, __vue_scope_id__$O, __vue_is_functional_template__$O, __vue_module_identifier__$O, false, undefined, undefined, undefined);
var checkboard = __vue_component__$O;

//
var script$N = {
  name: 'Alpha',
  props: {
    value: Object,
    onChange: Function
  },
  components: {
    checkboard: checkboard
  },
  computed: {
    colors: function colors() {
      return this.value;
    },
    gradientColor: function gradientColor() {
      var rgba = this.colors.rgba;
      var rgbStr = [rgba.r, rgba.g, rgba.b].join(',');
      return "linear-gradient(to right, rgba(".concat(rgbStr, ", 0) 0%, rgba(").concat(rgbStr, ", 1) 100%)");
    }
  },
  methods: {
    handleChange: function handleChange(e, skip) {
      if (!skip) e.preventDefault();
      var container = this.$refs.container;
      if (!container) {
        // for some edge cases, container may not exist. see #220
        return;
      }
      var containerWidth = container.clientWidth;
      var xOffset = container.getBoundingClientRect().left + window.pageXOffset;
      var pageX = e.pageX || (e.touches ? e.touches[0].pageX : 0);
      var left = pageX - xOffset;
      var a;
      if (left < 0) {
        a = 0;
      } else if (left > containerWidth) {
        a = 1;
      } else {
        a = Math.round(left * 100 / containerWidth) / 100;
      }
      if (this.colors.a !== a) {
        this.$emit('change', {
          h: this.colors.hsl.h,
          s: this.colors.hsl.s,
          l: this.colors.hsl.l,
          a: a,
          source: 'rgba'
        });
      }
    },
    handleMouseDown: function handleMouseDown(e) {
      this.handleChange(e, true);
      document.addEventListener('mousemove', this.handleChange);
      document.addEventListener('mouseup', this.handleMouseUp);
    },
    handleMouseUp: function handleMouseUp() {
      this.unbindEventListeners();
    },
    unbindEventListeners: function unbindEventListeners() {
      document.removeEventListener('mousemove', this.handleChange);
      document.removeEventListener('mouseup', this.handleMouseUp);
    }
  }
};

/* script */
var __vue_script__$N = script$N;

/* template */
var __vue_render__$N = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "vc-alpha"
  }, [_c('div', {
    staticClass: "vc-alpha-checkboard-wrap"
  }, [_c('checkboard')], 1), _vm._v(" "), _c('div', {
    staticClass: "vc-alpha-gradient",
    style: {
      background: _vm.gradientColor
    }
  }), _vm._v(" "), _c('div', {
    ref: "container",
    staticClass: "vc-alpha-container",
    on: {
      "mousedown": _vm.handleMouseDown,
      "touchmove": _vm.handleChange,
      "touchstart": _vm.handleChange
    }
  }, [_c('div', {
    staticClass: "vc-alpha-pointer",
    style: {
      left: _vm.colors.a * 100 + '%'
    }
  }, [_c('div', {
    staticClass: "vc-alpha-picker"
  })])])]);
};
var __vue_staticRenderFns__$N = [];

/* style */
var __vue_inject_styles__$N = undefined;
/* scoped */
var __vue_scope_id__$N = undefined;
/* module identifier */
var __vue_module_identifier__$N = undefined;
/* functional template */
var __vue_is_functional_template__$N = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$N = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$N,
  staticRenderFns: __vue_staticRenderFns__$N
}, __vue_inject_styles__$N, __vue_script__$N, __vue_scope_id__$N, __vue_is_functional_template__$N, __vue_module_identifier__$N, false, undefined, undefined, undefined);
var alpha = __vue_component__$N;

//
function _colorChange(data, oldHue) {
  var _data$hex;
  var alphax = data && data.a;
  var color;

  // hsl is better than hex between conversions
  if (data && data.hsl) {
    color = tinycolor(data.hsl);
  } else if (data && data.hex && ((_data$hex = data.hex) === null || _data$hex === void 0 ? void 0 : _data$hex.length) > 0) {
    color = tinycolor(data.hex);
  } else if (data && data.hsv) {
    color = tinycolor(data.hsv);
  } else if (data && data.rgba) {
    color = tinycolor(data.rgba);
  } else if (data && data.rgb) {
    color = tinycolor(data.rgb);
  } else {
    color = tinycolor(data);
  }

  // eslint-disable-next-line
  if (color && (color._a === undefined || color._a === null)) {
    color.setAlpha(alphax || 1);
  }
  var hsl = color.toHsl();
  var hsv = color.toHsv();
  if (hsl.s === 0) {
    // eslint-disable-next-line
    hsv.h = hsl.h = data.h || data.hsl && data.hsl.h || oldHue || 0;
  }

  /* --- comment this block to fix #109, may cause #25 again --- */
  // when the hsv.v is less than 0.0164 (base on test)
  // because of possible loss of precision
  // the result of hue and saturation would be miscalculated
  // if (hsv.v < 0.0164) {
  //   hsv.h = data.h || (data.hsv && data.hsv.h) || 0
  //   hsv.s = data.s || (data.hsv && data.hsv.s) || 0
  // }

  // if (hsl.l < 0.01) {
  //   hsl.h = data.h || (data.hsl && data.hsl.h) || 0
  //   hsl.s = data.s || (data.hsl && data.hsl.s) || 0
  // }
  /* ------ */

  return {
    hsl: hsl,
    hex: color.toHexString().toUpperCase(),
    hex8: color.toHex8String().toUpperCase(),
    rgba: color.toRgb(),
    hsv: hsv,
    oldHue: data.h || oldHue || hsl.h,
    source: data.source,
    a: data.a || color.getAlpha()
  };
}
var presetColors = ['#FFFFFF', 'rgba(0,0,0,0)'];
var script$M = {
  name: 'Sketch',
  components: {
    saturation: saturation,
    hue: hue,
    alpha: alpha,
    'ed-in': editableInput,
    checkboard: checkboard
  },
  props: {
    presetColors: {
      type: Array,
      default: function _default() {
        return presetColors;
      }
    },
    disableAlpha: {
      type: Boolean,
      default: false
    },
    disableFields: {
      type: Boolean,
      default: false
    },
    alpha: {
      type: Boolean,
      default: true
    },
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    newColor: {
      type: String,
      default: function _default() {
        return '';
      }
    }
  },
  watch: {
    value: function value(newVal) {
      this.val = _colorChange(newVal);
    },
    newColor: function newColor(newVal) {
      this.inputChange({
        hex: newVal
      });
    }
  },
  data: function data() {
    return {
      val: _colorChange(this.value),
      fieldsIndex: 0,
      highlight: false,
      modelSelect: 0
    };
  },
  computed: {
    optionsSelect: function optionsSelect() {
      var _this = this;
      return [{
        id: 0,
        name: 'HEX'
      }, {
        id: 1,
        name: function name() {
          return _this.disableAlpha ? 'RGB' : 'RGBA';
        }
      }];
    },
    hsl: function hsl() {
      var _this$colors$hsl = this.colors.hsl,
        h = _this$colors$hsl.h,
        s = _this$colors$hsl.s,
        l = _this$colors$hsl.l;
      return {
        h: h.toFixed(),
        s: "".concat((s * 100).toFixed(), "%"),
        l: "".concat((l * 100).toFixed(), "%")
      };
    },
    hex: function hex() {
      var hex;
      if (this.colors.a < 1) {
        hex = this.colors.hex8;
      } else {
        hex = this.colors.hex;
      }
      return hex.replace('#', '');
    },
    activeColor: function activeColor() {
      var rgba = this.colors.rgba;
      return "rgba(".concat([rgba.r, rgba.g, rgba.b, rgba.a].join(','), ")");
    },
    hasAlpha: function hasAlpha() {
      return this.colors.a < 1;
    },
    colors: {
      get: function get() {
        return this.val;
      },
      set: function set(newVal) {
        this.val = newVal;
        this.$emit('input', newVal);
      }
    }
  },
  methods: {
    handlePreset: function handlePreset(c) {
      this.colorChange({
        hex: c,
        source: 'hex'
      });
    },
    childChange: function childChange(data) {
      this.colorChange(data);
    },
    inputChange: function inputChange(data) {
      if (!data) {
        return;
      }
      if (data.hex) {
        if (this.isValidHex(data.hex)) {
          this.colorChange({
            hex: data.hex,
            source: 'hex'
          });
        }
      } else if (data.r || data.g || data.b || data.a) {
        this.colorChange({
          r: data.r || this.colors.rgba.r,
          g: data.g || this.colors.rgba.g,
          b: data.b || this.colors.rgba.b,
          a: data.a || this.colors.rgba.a,
          source: 'rgba'
        });
      }
    },
    colorChange: function colorChange(data, oldHue) {
      this.oldHue = this.colors.hsl.h;
      this.colors = _colorChange(data, oldHue || this.oldHue);
    },
    isValidHex: function isValidHex(hex) {
      return tinycolor(hex).isValid();
    },
    simpleCheckForValidColor: function simpleCheckForValidColor(data) {
      var keysToCheck = ['r', 'g', 'b', 'a', 'h', 's', 'l', 'v'];
      var checked = 0;
      var passed = 0;
      keysToCheck.forEach(function (_, i) {
        var letter = keysToCheck[i];
        if (data[letter]) {
          checked += 1;
          if (!Number.isNaN(data[letter])) {
            passed += 1;
          }
        }
      });
      if (checked === passed) {
        return data;
      }
      return null;
    },
    paletteUpperCase: function paletteUpperCase(palette) {
      return palette.map(function (c) {
        return c.toUpperCase();
      });
    },
    isTransparent: function isTransparent(color) {
      return tinycolor(color).getAlpha() === 0;
    },
    showHighlight: function showHighlight() {
      this.highlight = true;
    },
    hideHighlight: function hideHighlight() {
      this.highlight = false;
    },
    textCopy: function textCopy() {
      var dummy = document.createElement('textarea');
      document.body.appendChild(dummy);
      dummy.value = this.value.hex8;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
    }
  }
};

/* script */
var __vue_script__$M = script$M;

/* template */
var __vue_render__$M = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['vc-sketch', _vm.disableAlpha ? 'vc-sketch__disable-alpha' : ''],
    attrs: {
      "role": "application",
      "aria-label": "Sketch color picker"
    }
  }, [_c('div', {
    staticClass: "vc-sketch-saturation-wrap"
  }, [_c('saturation', {
    on: {
      "change": _vm.childChange
    },
    model: {
      value: _vm.colors,
      callback: function callback($$v) {
        _vm.colors = $$v;
      },
      expression: "colors"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "vc-sketch-controls"
  }, [_c('div', {
    staticClass: "vc-sketch-color-wrap",
    on: {
      "click": _vm.textCopy
    }
  }, [_c('div', {
    staticClass: "vc-sketch-active-color",
    style: {
      background: _vm.activeColor
    },
    attrs: {
      "aria-label": "Current color is " + _vm.activeColor
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('checkboard')], 1), _vm._v(" "), _c('div', {
    staticClass: "vc-sketch-sliders"
  }, [_c('div', {
    staticClass: "vc-sketch-hue-wrap"
  }, [_c('hue', {
    on: {
      "change": _vm.childChange
    },
    model: {
      value: _vm.colors,
      callback: function callback($$v) {
        _vm.colors = $$v;
      },
      expression: "colors"
    }
  })], 1), _vm._v(" "), !_vm.disableAlpha ? _c('div', {
    staticClass: "vc-sketch-alpha-wrap"
  }, [_c('alpha', {
    on: {
      "change": _vm.childChange
    },
    model: {
      value: _vm.colors,
      callback: function callback($$v) {
        _vm.colors = $$v;
      },
      expression: "colors"
    }
  })], 1) : _vm._e()])]), _vm._v(" "), !_vm.disableFields ? _c('div', {
    staticClass: "vc-chrome-fields-wrap"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.fieldsIndex === 0,
      expression: "fieldsIndex === 0"
    }],
    staticClass: "vc-chrome-fields"
  }, [_c('div', {
    staticClass: "vc-chrome-field"
  }, [!_vm.hasAlpha ? _c('ed-in', {
    attrs: {
      "label": "hex",
      "labelText": "hex",
      "value": _vm.colors.hex
    },
    on: {
      "change": _vm.inputChange
    }
  }) : _vm._e(), _vm._v(" "), _vm.hasAlpha ? _c('ed-in', {
    attrs: {
      "label": "hex",
      "labelText": "hex",
      "value": _vm.colors.hex8
    },
    on: {
      "change": _vm.inputChange
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.fieldsIndex === 1,
      expression: "fieldsIndex === 1"
    }],
    staticClass: "vc-chrome-fields"
  }, [_c('div', {
    staticClass: "vc-chrome-field"
  }, [_c('aq-field-group', [_c('ed-in', {
    attrs: {
      "label": "r",
      "value": _vm.colors.rgba.r
    },
    on: {
      "change": _vm.inputChange
    }
  }), _vm._v(" "), _c('ed-in', {
    attrs: {
      "label": "g",
      "value": _vm.colors.rgba.g
    },
    on: {
      "change": _vm.inputChange
    }
  }), _vm._v(" "), _c('ed-in', {
    attrs: {
      "label": "b",
      "value": _vm.colors.rgba.b
    },
    on: {
      "change": _vm.inputChange
    }
  }), _vm._v(" "), !_vm.disableAlpha ? _c('ed-in', {
    attrs: {
      "label": "a",
      "value": _vm.colors.a,
      "arrow-offset": 0.01,
      "max": 1
    },
    on: {
      "change": _vm.inputChange
    }
  }) : _vm._e()], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "vc-chrome-toggle-btn",
    attrs: {
      "role": "button",
      "aria-label": "Change another color definition"
    }
  }, [_c('aq-select', {
    attrs: {
      "options": _vm.optionsSelect,
      "returnMode": "keys",
      "popoverWidth": "full",
      "valueArray": false,
      "closeOnSelect": ""
    },
    model: {
      value: _vm.fieldsIndex,
      callback: function callback($$v) {
        _vm.fieldsIndex = $$v;
      },
      expression: "fieldsIndex"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aq-color-picker__color-list"
  }, [_c('aq-divider'), _vm._v(" "), _c('div', {
    staticClass: "vc-sketch-presets",
    attrs: {
      "role": "group",
      "aria-label": "A color preset, pick one to set as current color"
    }
  }, [_vm._l(_vm.presetColors, function (c) {
    return [!_vm.isTransparent(c) ? _c('div', {
      key: c,
      staticClass: "vc-sketch-presets-color",
      style: {
        background: c
      },
      attrs: {
        "aria-label": 'Color:' + c
      },
      on: {
        "click": function click($event) {
          return _vm.handlePreset(c);
        }
      }
    }) : _c('div', {
      key: c,
      staticClass: "vc-sketch-presets-color",
      attrs: {
        "aria-label": 'Color:' + c
      },
      on: {
        "click": function click($event) {
          return _vm.handlePreset(c);
        }
      }
    }, [_c('checkboard')], 1)];
  })], 2)], 1)]);
};
var __vue_staticRenderFns__$M = [function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "vc-sketch-color-wrap__copy"
  }, [_c('em', {
    staticClass: "mui-icon-duplicate vc-sketch-color-wrap__copy-icon"
  })]);
}];

/* style */
var __vue_inject_styles__$M = undefined;
/* scoped */
var __vue_scope_id__$M = undefined;
/* module identifier */
var __vue_module_identifier__$M = undefined;
/* functional template */
var __vue_is_functional_template__$M = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$M = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$M,
  staticRenderFns: __vue_staticRenderFns__$M
}, __vue_inject_styles__$M, __vue_script__$M, __vue_scope_id__$M, __vue_is_functional_template__$M, __vue_module_identifier__$M, false, undefined, undefined, undefined);
var Sketch = __vue_component__$M;

//
var script$L = {
  mixins: [LabelMixin, PopoverMixin, zIndexMixin, helperTextMixin],
  components: {
    'sketch-picker': Sketch
  },
  props: {
    error: {
      type: Boolean,
      default: false
    },
    alpha: {
      type: Boolean,
      default: true
    },
    selectColor: {
      type: Boolean,
      default: true
    },
    hex: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: ''
    },
    presetColors: {
      type: Array,
      default: function _default() {
        return defaultPresetColors;
      }
    },
    full: {
      type: Boolean,
      default: true
    },
    plain: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    colors: function colors(newVal, oldVal) {
      if ('hex8' in newVal && 'hex8' in oldVal && newVal.hex8 !== oldVal.hex8) {
        this.stytleMiniature.backgroundColor = newVal.hex8;
        this.textColor = newVal.hex8;
        this.$emit('input', newVal.hex8);
      }
    },
    value: function value(newVal, oldVal) {
      this.onValueChange(newVal, oldVal);
    },
    id: function id() {
      this.validateId();
    }
  },
  data: function data() {
    return {
      poperInstance: null,
      isVisible: false,
      stytleMiniature: {
        backgroundColor: ''
      },
      textColor: '',
      colors: {}
    };
  },
  computed: {
    textColor2: {
      set: function set(newVal) {
        var _val;
        var val = newVal;
        if (((_val = val) === null || _val === void 0 ? void 0 : _val.length) === 7) {
          val += 'ff';
        }
        this.textColor = val;
      },
      get: function get() {
        var _textColor, _textColor2, _textColor3;
        var textColor = this.textColor;
        if (((_textColor = textColor) === null || _textColor === void 0 ? void 0 : _textColor.length) === 9 && ((_textColor2 = textColor) === null || _textColor2 === void 0 ? void 0 : _textColor2.substring(((_textColor3 = textColor) === null || _textColor3 === void 0 ? void 0 : _textColor3.length) - 2).toLowerCase()) === 'ff') {
          var _textColor4, _textColor5;
          textColor = (_textColor4 = textColor) === null || _textColor4 === void 0 ? void 0 : _textColor4.substring(0, ((_textColor5 = textColor) === null || _textColor5 === void 0 ? void 0 : _textColor5.length) - 2);
        }
        return textColor;
      }
    },
    isTransparent: function isTransparent() {
      var _this$value, _this$value$substring, _this$value2;
      return ((_this$value = this.value) === null || _this$value === void 0 ? void 0 : (_this$value$substring = _this$value.substring(((_this$value2 = this.value) === null || _this$value2 === void 0 ? void 0 : _this$value2.length) - 2)) === null || _this$value$substring === void 0 ? void 0 : _this$value$substring.toLowerCase()) === '00';
    },
    zIndex: function zIndex() {
      return {
        zIndex: this.baseZIndex
      };
    },
    isFull: function isFull() {
      return this.full;
    },
    getDisabled: function getDisabled() {
      return this.disabled || this.readonly;
    },
    showSelectColor: function showSelectColor() {
      return this.selectColor || !this.selectColor && !this.isFull;
    }
  },
  methods: {
    onValueChange: function onValueChange(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.textColor = newVal;
      }
    },
    validateValue: function validateValue() {
      if (this.value !== '#000000FF' && this.value !== '') {
        this.onValueChange(this.value);
      } else {
        this.onValueChange('#892CD1FF');
      }
    },
    validateId: function validateId() {
      var _this$id;
      this.uid = ((_this$id = this.id) === null || _this$id === void 0 ? void 0 : _this$id.length) > 0 ? this.id : AquaRamdomId('-color-picker');
    },
    show: function show() {
      if (!this.isVisible && !this.disabled && !this.readonly) {
        this.isVisible = true;
        this.$emit(EVENT_NAME_OPEN);
        this.updatePoperInstance();
        this.setZIndex();
        document.addEventListener('click', this.documentOutside);
      }
    },
    hide: function hide() {
      if (this.isVisible) {
        this.isVisible = false;
        this.$emit(EVENT_NAME_CLOSE);
        this.deleteZIndex();
        document.removeEventListener('click', this.documentOutside);
      }
    },
    documentOutside: function documentOutside(evt) {
      if (this.isVisible) {
        var refMenu = this.$refs.parent_color;
        var refPopover = this.$refs.cotainer_color;
        if (this.validateEventTargetDropdown(evt) && !refMenu.contains(evt.target) && !refPopover.contains(evt.target)) {
          this.hide();
        }
      }
    },
    validateEventTargetDropdown: function validateEventTargetDropdown(evt) {
      var _evt$target, _evt$target2, _evt$target3, _evt$target4, _evt$target4$parentEl, _evt$target5, _evt$target5$parentEl;
      var outside = true;
      if ((_evt$target = evt.target) !== null && _evt$target !== void 0 && _evt$target.classList.contains('aq-dropdown__container') || (_evt$target2 = evt.target) !== null && _evt$target2 !== void 0 && _evt$target2.classList.contains('aq-dropdown-item') || (_evt$target3 = evt.target) !== null && _evt$target3 !== void 0 && _evt$target3.classList.contains('aq-dropdown-item__text') || (_evt$target4 = evt.target) !== null && _evt$target4 !== void 0 && (_evt$target4$parentEl = _evt$target4.parentElement) !== null && _evt$target4$parentEl !== void 0 && _evt$target4$parentEl.classList.contains('aq-dropdown-item') || (_evt$target5 = evt.target) !== null && _evt$target5 !== void 0 && (_evt$target5$parentEl = _evt$target5.parentElement) !== null && _evt$target5$parentEl !== void 0 && _evt$target5$parentEl.classList.contains('aq-dropdown-item__text')) {
        outside = false;
      }
      return outside;
    },
    updatePoperInstance: function updatePoperInstance() {
      if (this.poperInstance) {
        this.poperInstance.update();
      }
    },
    definePopoverInstance: function definePopoverInstance() {
      if (!this.poperInstance) {
        this.addPopover();
      }
    },
    addPopover: function addPopover() {
      var parent = this.$refs.parent_color;
      var container = this.$refs.cotainer_color;
      if (parent && container && !global[CONFIG_AQUA_POPOVER_TEST_MODE]) {
        this.poperInstance = createPopper(parent, container, {
          placement: 'bottom-start',
          modifiers: [{
            name: 'offset',
            options: {
              offset: [1, 3]
            }
          }]
        });
      }
    },
    clickOnPopover: function clickOnPopover(event) {
      var refPopover = this.$refs.cotainer_color;
      return refPopover.contains(event.target);
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.definePopoverInstance();
    this.validateId();
    appendEl({
      children: this.$refs.cotainer_color
    });
    Vue.nextTick(function () {
      _this.validateValue();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.hide();
    removeEl({
      children: this.$refs.cotainer_color
    });
  }
};

/* script */
var __vue_script__$L = script$L;

/* template */
var __vue_render__$L = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-color-picker"
  }, [_vm.isLabelVisible ? _c('aq-label', _vm._b({
    staticClass: "aq-color-picker__label",
    attrs: {
      "for": _vm.uid
    }
  }, 'aq-label', _vm.bindsLabel, false), [_vm._v(_vm._s(_vm.$aqT(_vm.label)))]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "parent_color",
    class: ['aq-color-picker__selector', {
      'aq-color-picker__selector--error': _vm.error
    }, {
      'aq-color-picker__selector--mini': !_vm.isFull
    }, {
      'aq-color-picker__selector--full': _vm.isFull
    }, {
      'aq-color-picker__selector--readonly': _vm.readonly
    }, {
      'aq-color-picker__selector--plain': _vm.plain
    }],
    on: {
      "click": _vm.show
    }
  }, [_vm.showSelectColor ? _c('aq-button', {
    class: ['aq-color-picker__select-color', {
      'aq-color-picker__select-color--w-hex': _vm.hex
    }, {
      'aq-color-picker__selector--mini--border': !_vm.isFull
    }],
    attrs: {
      "disabled": _vm.getDisabled,
      "outline": "",
      "plain": _vm.plain
    }
  }, [_c('div', {
    staticClass: "aq-color-picker__miniature",
    style: _vm.stytleMiniature
  }, [_c('span', {
    staticClass: "aq-color-picker__miniature-vector"
  }), _vm._v(" "), _vm.isTransparent ? _c('span', {
    staticClass: "aq-color-picker__line-transparent-1"
  }) : _vm._e(), _vm._v(" "), _vm.isTransparent ? _c('span', {
    staticClass: "aq-color-picker__line-transparent-2"
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm.isFull ? _c('aq-text-field', {
    class: ['aq-color-picker__hex', {
      'aq-color-picker__hex--w-select-color': _vm.selectColor
    }],
    attrs: {
      "disabled": _vm.disabled,
      "error": _vm.error,
      "id": _vm.uid,
      "readonly": _vm.readonly,
      "plain": _vm.plain
    },
    model: {
      value: _vm.textColor2,
      callback: function callback($$v) {
        _vm.textColor2 = $$v;
      },
      expression: "textColor2"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    ref: "cotainer_color",
    class: ['aq-color-picker__container', {
      'aq-color-picker__container--show': _vm.isVisible,
      'aq-color-picker__container--hide': !_vm.isVisible
    }],
    style: _vm.zIndex
  }, [_c('sketch-picker', {
    attrs: {
      "newColor": _vm.textColor,
      "disableAlpha": !_vm.alpha,
      "presetColors": _vm.presetColors
    },
    model: {
      value: _vm.colors,
      callback: function callback($$v) {
        _vm.colors = $$v;
      },
      expression: "colors"
    }
  })], 1), _vm._v(" "), _vm.isHelperTextVisible ? _c('div', {
    staticClass: "aq-text-field__footer"
  }, [_vm.isHelperTextVisible ? _c('div', {
    staticClass: "aq-text-field__helper-text"
  }, [_vm.isHelperTextVisible ? _c('aq-helper-text', _vm._b({}, 'aq-helper-text', _vm.bindsHelperText, false)) : _vm._e()], 1) : _vm._e()]) : _vm._e()], 1);
};
var __vue_staticRenderFns__$L = [];

/* style */
var __vue_inject_styles__$L = undefined;
/* scoped */
var __vue_scope_id__$L = undefined;
/* module identifier */
var __vue_module_identifier__$L = undefined;
/* functional template */
var __vue_is_functional_template__$L = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$L = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$L,
  staticRenderFns: __vue_staticRenderFns__$L
}, __vue_inject_styles__$L, __vue_script__$L, __vue_scope_id__$L, __vue_is_functional_template__$L, __vue_module_identifier__$L, false, undefined, undefined, undefined);
var AqColorPicker = __vue_component__$L;

var moment$2 = {exports: {}};

(function (module, exports) {
(function (global, factory) {
    module.exports = factory() ;
}(commonjsGlobal, (function () {
    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            'object' !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = commonjsRequire;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));
}(moment$2));

var moment$1 = moment$2.exports;

function ownKeys$8(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$8(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$8(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$8(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var script$K = {
  name: 'DatePicker',
  mixins: [PopoverMixin, zIndexMixin, LabelMixin, helperTextMixin],
  props: {
    ranges: {
      type: Object,
      default: function _default() {
        return {
          'aqua.today': [moment$1().startOf('day'), moment$1().endOf('day')],
          'aqua.yesterday': [moment$1().startOf('day').subtract(1, 'days'), moment$1().endOf('day').subtract(1, 'days')],
          'aqua.last7Days': [moment$1().startOf('day').subtract(7, 'days'), moment$1().endOf('day')],
          'aqua.last30Days': [moment$1().startOf('day').subtract(29, 'days'), moment$1().endOf('day')],
          'aqua.thisMonth': [moment$1().startOf('day').startOf('month'), moment$1().endOf('day')],
          'aqua.lastMonth': [moment$1().startOf('day').subtract(1, 'month').startOf('month'), moment$1().endOf('day').subtract(1, 'month').endOf('month')]
        };
      }
    },
    value: [String, Array],
    format: {
      type: [String],
      default: function _default() {
        return 'YYYY/MM/DD';
      }
    },
    type: {
      type: String,
      default: 'input'
    },
    label: {
      type: [String, Function],
      default: ''
    },
    sublabel: {
      type: [String, Function],
      default: ''
    },
    showRanges: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    isRange: Boolean,
    parent: String,
    minDate: String,
    maxDate: String,
    showDaysInRange: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    showTimeInRange: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    showHeader: {
      type: Boolean,
      default: function _default() {
        return true;
      }
    },
    resetTime: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    error: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    readonly: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    plain: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    maxRange: {
      type: [Number, Array],
      default: function _default() {
        return -1;
      }
    },
    icon: {
      type: String,
      default: ''
    },
    infoBanner: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      showPicker: false,
      selectedRange: '',
      valuePicker: '',
      valueHourTemp: {
        start: '',
        end: ''
      },
      valueHour: {
        minMaxHour: '',
        minMinHour: '',
        maxMinHour: '',
        maxMaxHour: '',
        start: '',
        end: ''
      },
      orientaton: 'is-bottom',
      datePicker: {},
      calendar: {},
      params: {
        minDate: '',
        maxDate: ''
      },
      initialState: '',
      smallInput: false,
      hasTime: true,
      isLeft: false,
      poperInstance: null,
      isDrag: false,
      temporalDragDate: ''
    };
  },
  watch: {
    value: function value(newVal, oldVal) {
      if (this.isRange) {
        if (newVal[0] !== oldVal[0] || newVal[1] !== oldVal[1]) {
          this.parseDates();
        }
      } else if (newVal !== oldVal) {
        this.parseDates();
      }
    },
    realMinDate: function realMinDate() {
      this.setMinDate();
    },
    realMaxDate: function realMaxDate() {
      this.setMaxDate();
    },
    minDate: function minDate() {
      this.validateDates();
    },
    maxDate: function maxDate() {
      this.validateDates();
    }
  },
  computed: {
    hasError: function hasError() {
      return this.error && !this.disabled;
    },
    zIndex: function zIndex() {
      return {
        zIndex: this.baseZIndex
      };
    },
    realMinDate: function realMinDate() {
      var date = this.minDate;
      var _this$getParsedMaxRan = this.getParsedMaxRange(),
        time = _this$getParsedMaxRan.time,
        maxRange = _this$getParsedMaxRan.maxRange;
      if (this.isDrag && maxRange >= 0) {
        date = moment$1(new Date(this.temporalDragDate), this.format).subtract(maxRange, time);
        if (this.minDate) {
          if (date.diff(moment$1(this.minDate, this.format), time) <= 0) {
            date = moment$1(this.minDate, this.format);
          }
        }
        date = date.format(this.format);
      }
      return this.isDrag ? date : this.minDate;
    },
    realMaxDate: function realMaxDate() {
      var date = this.maxDate;
      var _this$getParsedMaxRan2 = this.getParsedMaxRange(),
        time = _this$getParsedMaxRan2.time,
        maxRange = _this$getParsedMaxRan2.maxRange;
      if (this.isDrag && maxRange >= 0) {
        date = moment$1(new Date(this.temporalDragDate)).add(maxRange, time);
        if (this.maxDate) {
          if (date.diff(moment$1(this.maxDate, this.format), time) >= 0) {
            date = moment$1(this.maxDate, this.format);
          }
        }
        date = date.format(this.format);
      }
      return this.isDrag ? date : this.maxDate;
    },
    getCurrentValueToMoment: function getCurrentValueToMoment() {
      var refsTime = this.$refs.time_initial;
      var refsTimeEnd = this.$refs.time_end;
      var currentDate = this.isRange ? {
        start: moment$1(this.valuePicker.start).hour(parseInt(refsTime ? refsTime.hour : 0, 10)).minutes(parseInt(refsTime ? refsTime.minutes : 0, 10)),
        end: moment$1(this.valuePicker.end).hour(parseInt(refsTimeEnd ? refsTimeEnd.hour : 0, 10)).minutes(parseInt(refsTimeEnd ? refsTimeEnd.minutes : 0, 10))
      } : moment$1(this.valuePicker).hour(parseInt(refsTime ? refsTime.hour : 0, 10)).minutes(parseInt(refsTime ? refsTime.minutes : 0, 10));
      return currentDate;
    },
    inputValueFormated: function inputValueFormated() {
      var valueFormated = '';
      if (this.isRange) {
        valueFormated = {
          start: moment$1(this.value[0], this.format).format(this.format),
          end: moment$1(this.value[1], this.format).format(this.format)
        };
      } else {
        valueFormated = moment$1(this.value, this.format).format(this.format);
      }
      return valueFormated;
    },
    valueFormated: function valueFormated() {
      var valueFormated = '';
      if (this.isRange) {
        valueFormated = {
          start: "".concat(this.getCurrentValueToMoment.start.format(this.format)),
          end: "".concat(this.getCurrentValueToMoment.end.format(this.format))
        };
      } else {
        valueFormated = "".concat(this.getCurrentValueToMoment.format(this.format));
      }
      return valueFormated;
    },
    rangesForDate: function rangesForDate() {
      var _this = this;
      var newRanges = Object.keys(this.ranges);
      return newRanges.map(function (date) {
        return {
          name: date,
          value: _this.ranges[date]
        };
      });
    },
    getFormattedRange: function getFormattedRange() {
      var formattedRange = {};
      if (this.isRange) {
        var diff = moment$1.duration(moment$1(this.getCurrentValueToMoment.end).diff(moment$1(this.getCurrentValueToMoment.start)));
        var days = parseInt(diff.asDays(), 10);
        var showDays = days !== 0 && this.showDaysInRange;
        var hours = parseInt(diff.asHours(), 10) - days * 24;
        var minutes = parseInt(diff.asMinutes(), 10) - (days * 24 * 60 + hours * 60);
        var showHours = hours !== 0;
        var showMinutes = minutes !== 0;
        var showTime = (showHours || showMinutes) && this.showTimeInRange && this.hasTime;
        formattedRange = {
          showDays: showDays,
          showTime: showTime,
          showHours: showHours,
          showMinutes: showMinutes,
          days: days,
          hours: hours,
          minutes: minutes
        };
      }
      return formattedRange;
    },
    isSameDay: function isSameDay() {
      return this.isRange && moment$1(this.valuePicker.start).isSameOrAfter(moment$1(this.valuePicker.end), 'day');
    },
    timePickerLabelStart: function timePickerLabelStart() {
      return this.isRange ? "".concat(this.$t('aqua.start'), ":") : '';
    },
    timePickerLabelEnd: function timePickerLabelEnd() {
      return this.isRange ? "".concat(this.$t('aqua.end'), ":") : '';
    },
    sublabelRequired: function sublabelRequired() {
      var _this$$aqT, _this$$aqT2;
      return this.required && ((_this$$aqT = this.$aqT(this.label)) === null || _this$$aqT === void 0 ? void 0 : _this$$aqT.length) === 0 && ((_this$$aqT2 = this.$aqT(this.sublabel)) === null || _this$$aqT2 === void 0 ? void 0 : _this$$aqT2.length) > 0;
    },
    getSublabelLength: function getSublabelLength() {
      var _this$$aqT3;
      return ((_this$$aqT3 = this.$aqT(this.sublabel)) === null || _this$$aqT3 === void 0 ? void 0 : _this$$aqT3.length) > 0;
    },
    showIcon: function showIcon() {
      return this.icon && this.icon !== '';
    },
    getBannerTitle: function getBannerTitle() {
      var _this$infoBanner;
      return (_this$infoBanner = this.infoBanner) !== null && _this$infoBanner !== void 0 && _this$infoBanner.title ? this.$aqT(this.infoBanner.title) : '';
    },
    getCloseBanner: function getCloseBanner() {
      var _this$infoBanner2;
      return (_this$infoBanner2 = this.infoBanner) !== null && _this$infoBanner2 !== void 0 && _this$infoBanner2.close ? this.infoBanner.close : false;
    },
    getBannerMessage: function getBannerMessage() {
      var _this$infoBanner3;
      return (_this$infoBanner3 = this.infoBanner) !== null && _this$infoBanner3 !== void 0 && _this$infoBanner3.message ? this.infoBanner.message : '';
    },
    getBannerState: function getBannerState() {
      var _this$infoBanner4;
      return (_this$infoBanner4 = this.infoBanner) !== null && _this$infoBanner4 !== void 0 && _this$infoBanner4.state ? this.infoBanner.state : 'warning';
    },
    showBannerNotification: function showBannerNotification() {
      var _this$infoBanner5;
      return (_this$infoBanner5 = this.infoBanner) === null || _this$infoBanner5 === void 0 ? void 0 : _this$infoBanner5.visible;
    }
  },
  methods: {
    clickOnPopover: function clickOnPopover(event) {
      var refPopover = this.$refs.calendar_container;
      return refPopover.contains(event.target);
    },
    initDates: function initDates() {
      this.listeners(); // init basic listeners
      this.parseDates(); // first call to set dates
      this.setContexts(); // expose context to global variables
    },
    validateDates: function validateDates() {
      var _this2 = this;
      var minDate = moment$1(this.realMinDate, this.format);
      var maxDate = moment$1(this.realMaxDate, this.format);
      var change = false;
      if (this.isRange) {
        if (moment$1(this.valuePicker.end, this.format).isAfter(maxDate)) {
          this.valuePicker.end = maxDate.toDate();
          change = true;
        } else if (moment$1(this.valuePicker.start, this.format).isBefore(minDate)) {
          this.valuePicker.start = minDate.toDate();
          change = true;
        }
      } else if (moment$1(this.valuePicker, this.format).isAfter(maxDate)) {
        this.valuePicker = maxDate.toDate();
        change = true;
      } else if (moment$1(this.valuePicker, this.format).isBefore(minDate)) {
        this.valuePicker = minDate.toDate();
        change = true;
      }
      if (change) {
        setTimeout(function () {
          _this2.emitDates(true);
        });
      }
    },
    parseDates: function parseDates() {
      // Set dates into data from props
      this.valuePicker = this.isRange ? {
        start: moment$1(this.value[0], this.format).toDate(),
        end: moment$1(this.value[1], this.format).toDate()
      } : this.valuePicker = moment$1(this.value, this.format).toDate();
      this.validateDates();
      this.initialState = this.validateInitalState() ? this.valuePicker : this.initialState;
      this.setContexts();
      this.setValueHour();
      this.setMaxDate();
      this.setMinDate();
      this.setTimes();
    },
    setTimes: function setTimes() {
      this.applyResetTime();
      var selectedDateSingle = moment$1(this.isRange ? this.valuePicker.start : this.valuePicker);
      var selectedDateEnds = moment$1(this.isRange ? this.valuePicker.end : this.valuePicker);
      var minDate = moment$1(this.params.minDate, this.format);
      var maxDate = moment$1(this.params.maxDate, this.format);
      if (selectedDateSingle.isSame(minDate, 'day')) {
        this.valueHour.minMinHour = this.realMinDate ? moment$1(this.realMinDate, this.format).format('HH:mm') : null;
      } else {
        this.valueHour.minMinHour = null;
      }
      if (selectedDateSingle.isSame(maxDate, 'day')) {
        this.valueHour.minMaxHour = this.realMaxDate ? moment$1(this.realMaxDate, this.format).format('HH:mm') : null;
      } else {
        this.valueHour.minMaxHour = null;
      }
      if (selectedDateEnds.isSame(minDate, 'day')) {
        this.valueHour.maxMinHour = this.realMinDate ? moment$1(this.realMinDate, this.format).format('HH:mm') : null;
      } else {
        this.valueHour.maxMinHour = null;
      }
      if (selectedDateEnds.isSame(maxDate, 'day')) {
        this.valueHour.maxMaxHour = this.realMaxDate ? moment$1(this.realMaxDate, this.format).format('HH:mm') : null;
      } else {
        this.valueHour.maxMaxHour = null;
      }
    },
    setMaxDate: function setMaxDate() {
      this.params.maxDate = this.realMaxDate ? moment$1(this.realMaxDate, this.format).toDate() : '';
    },
    setMinDate: function setMinDate() {
      this.params.minDate = this.realMinDate ? moment$1(this.realMinDate, this.format).toDate() : '';
    },
    setValueHour: function setValueHour() {
      if (this.isRange) {
        this.valueHour = _objectSpread$8(_objectSpread$8({}, this.valueHour), {}, {
          start: moment$1(this.value[0], this.format).format('HH:mm'),
          end: moment$1(this.value[1], this.format).format('HH:mm')
        });
      } else {
        this.valueHour = _objectSpread$8(_objectSpread$8({}, this.valueHour), {}, {
          start: moment$1(this.value, this.format).format('HH:mm')
        });
      }
    },
    listeners: function listeners() {
      var _this3 = this;
      var nearAncestor = function nearAncestor(elem, selector) {
        // Element.matches() polyfill
        if (!Element.prototype.matches) {
          Element.prototype.matches = Element.prototype.matchesSelector || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector || function (s) {
            var matches = (this.document || this.ownerDocument).querySelectorAll(s);
            var i = matches === null || matches === void 0 ? void 0 : matches.length;
            while (i >= 0 && matches.item(i) !== this) {
              i -= 1;
            }
            return i > -1;
          };
        }
        var tempElem = elem;
        // Get the closest matching element
        for (; tempElem && tempElem !== document; tempElem = tempElem.parentNode) {
          if (tempElem.matches(selector)) return tempElem;
        }
        return null;
      };
      var checkAncestor = nearAncestor(this.$refs.ancestor_datepicker, '.modal-dialog');
      if (is.not.null(checkAncestor)) {
        checkAncestor.classList.add('modal-fix-calendar');
      }
      this.$watch( /* eslint-disable arrow-body-style */
      function () {
        var _this3$valueHour, _this3$valueour;
        // eslint-disable-next-line
        return _this3.valuePicker, (_this3$valueHour = _this3.valueHour) !== null && _this3$valueHour !== void 0 && _this3$valueHour.start, (_this3$valueour = _this3.valueour) !== null && _this3$valueour !== void 0 && _this3$valueour.end, Date.now();
      }, function () {
        _this3.emitDates();
      });
    },
    setContexts: function setContexts() {
      var _this$$refs$calendar;
      var _this$$refs$calendar$ = (_this$$refs$calendar = this.$refs.calendar) === null || _this$$refs$calendar === void 0 ? void 0 : _this$$refs$calendar.$children;
      var _this$$refs$calendar$2 = _slicedToArray(_this$$refs$calendar$, 1);
      this.calendar = _this$$refs$calendar$2[0];
      this.datePicker = this.$refs.calendar;
      this.$refs.calendar.$children[0].showPageRange(moment$1(is.array(this.value) ? this.value[0] : this.value, this.format).toDate());
    },
    emitDates: function emitDates(manual) {
      this.setTimes();
      var emitDate = '';
      if (this.isRange) {
        emitDate = [this.getCurrentValueToMoment.start.format(this.format), this.getCurrentValueToMoment.end.format(this.format)];
      } else {
        emitDate = this.getCurrentValueToMoment.format(this.format);
      }
      this.selectRange();
      if (manual || !this.isRange && !this.hasTime) {
        this.$emit('input', emitDate);
        this.$emit(EVENT_NAME_CHANGE, emitDate);
        this.closeDatePicker();
      }
    },
    resetCalendar: function resetCalendar(emit) {
      var value = this.isCleaneable() ? this.initialState : this.valuePicker;
      this.valuePicker = value;
      this.valueHour.start = this.isCleaneable() ? moment$1(this.initialState, this.format).format('HH:mm') : this.valueHour.start;
      if (this.isRange) {
        value = this.isCleaneable() ? this.initialState.start : this.valuePicker.start;
        this.valueHour.start = this.isCleaneable() ? moment$1(this.initialState.start, this.format).format('HH:mm') : this.valueHour.start;
        this.valueHour.end = this.isCleaneable() ? moment$1(this.initialState.end, this.format).format('HH:mm') : this.valueHour.end;
      }
      if (this.calendar.showPageRange) {
        this.calendar.showPageRange(moment$1(value, this.format).toDate());
      }
      if (emit) {
        this.$emit('clean', this.valuePicker);
      }
      this.removeClick();
    },
    closeDatePicker: function closeDatePicker() {
      this.resetCalendar();
      this.showPicker = false;
      this.deleteZIndex();
      document.removeEventListener('click', this.documentOutside);
    },
    calculatePosition: function calculatePosition() {
      this.setZIndex();
      this.showPicker = true;
      if (this.poperInstance) {
        this.poperInstance.update();
      }
    },
    onDrag: function onDrag(event) {
      if (event === null && this.resetTime) {
        this.isDrag = false;
        this.temporalDragDate = '';
        this.resetTimes();
      } else if (event === null) {
        this.temporalDragDate = '';
        this.isDrag = false;
      } else {
        if (this.temporalDragDate === '') {
          this.temporalDragDate = event.start;
        }
        this.isDrag = true;
      }
    },
    resetTimes: function resetTimes() {
      this.valueHour.start = '00:00';
      this.valueHour.end = '23:59';
      this.valueHourTemp.start = '00:00';
      this.valueHourTemp.end = '23:59';
    },
    applyResetTime: function applyResetTime() {
      if (this.valueHourTemp.start !== '' && this.valueHourTemp.end !== '') {
        this.valueHour.start = this.valueHourTemp.start;
        this.valueHour.end = this.valueHourTemp.end;
        this.valueHourTemp.start = '';
        this.valueHourTemp.end = '';
      }
    },
    changeDates: function changeDates(value, index) {
      this.selectedRange = index;
      this.valuePicker = {
        start: moment$1(value[0]).toDate(),
        end: moment$1(value[1]).toDate()
      };
      if (this.isRange) {
        this.valueHour = {
          start: '00:00',
          end: '23:59'
        };
      }
      this.calendar.showPageRange(moment$1(value[0]).toDate());
    },
    showRangePicker: function showRangePicker() {
      if (!this.disabled && !this.readonly) {
        this.calculatePosition();
        document.addEventListener('click', this.documentOutside);
      }
    },
    documentOutside: function documentOutside(evt) {
      var flyoutElement = this.$refs.input_date;
      var flyoutConst = this.$refs.calendar_container;
      var label = this.$refs.label;
      var targetElement = evt.target;
      do {
        if (targetElement === flyoutElement || flyoutConst === targetElement || label && label.$el === targetElement) {
          // Do nothing, just return.
          return null;
        }
        targetElement = targetElement.parentNode;
      } while (targetElement);
      // Do something useful here. ouside
      this.closeDatePicker();
      return true;
    },
    removeClick: function removeClick() {
      this.selectedRange = '';
    },
    isCleaneable: function isCleaneable() {
      return this.initialState !== '' && !(!this.isRange && !this.hasTime);
    },
    acceptDate: function acceptDate() {
      this.valuePicker = this.isRange ? {
        start: this.getCurrentValueToMoment.start.toDate(),
        end: this.getCurrentValueToMoment.end.toDate()
      } : this.getCurrentValueToMoment.toDate();
      this.initialState = this.valuePicker;
      this.emitDates(true);
    },
    calculateWidth: function calculateWidth() {
      this.smallInput = this.$refs.input_date.clientWidth < 330;
    },
    showTime: function showTime() {
      var regex = /(HH|mm)/;
      this.hasTime = regex.test(this.format);
    },
    selectRange: function selectRange() {
      var _this4 = this;
      var i = this.rangesForDate.findIndex(function (range) {
        return moment$1(range.value[0]).format(_this4.format) === moment$1(_this4.getCurrentValueToMoment.start).format(_this4.format) && moment$1(range.value[1]).format(_this4.format) === moment$1(_this4.getCurrentValueToMoment.end).format(_this4.format);
      });
      if (i !== -1) {
        this.selectedRange = i;
      } else {
        this.selectedRange = '';
      }
    },
    validateInitalState: function validateInitalState() {
      var isInvalid = false;
      if (this.isRange) {
        isInvalid = !(this.initialState.start instanceof Date && !Number.isNaN(this.initialState.start)) || !(this.initialState.end instanceof Date && !Number.isNaN(this.initialState.end)) || this.initialState === '';
      } else {
        isInvalid = !(this.initialState instanceof Date && !Number.isNaN(this.initialState)) || this.initialState === '';
      }
      return isInvalid;
    },
    addPopover: function addPopover() {
      var parent = this.$refs.parent_datepicker;
      var container = this.$refs.calendar_container;
      if (parent && container && !global[CONFIG_AQUA_POPOVER_TEST_MODE]) {
        this.poperInstance = createPopper(parent, container, {
          placement: 'bottom-start',
          modifiers: [{
            name: 'offset',
            options: {
              offset: [1, 7]
            }
          }, {
            name: 'flip',
            options: {
              fallbackPlacements: ['auto']
            }
          }]
        });
      }
    },
    getParsedMaxRange: function getParsedMaxRange() {
      var time = 'days';
      var maxRange = this.maxRange;
      if (Array.isArray(this.maxRange)) {
        var _this$maxRange = _slicedToArray(this.maxRange, 2);
        maxRange = _this$maxRange[0];
        time = _this$maxRange[1];
      }
      return {
        time: time,
        maxRange: maxRange
      };
    }
  },
  mounted: function mounted() {
    this.initDates();
    this.calculateWidth();
    this.showTime();
    this.addPopover();
    appendEl({
      children: this.$refs.calendar_container
    });
    this.$root.$on('aq::popovers::close', this.closeDatePicker);
  },
  updated: function updated() {
    this.showTime();
  },
  beforeDestroy: function beforeDestroy() {
    removeEl({
      children: this.$refs.calendar_container
    });
    this.$root.$on('aq::popovers::close', this.closeDatePicker);
  }
};

/* script */
var __vue_script__$K = script$K;

/* template */
var __vue_render__$K = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "ancestor_datepicker",
    staticClass: "aq-datetimepicker-container aq-datepicker"
  }, [_vm.isLabelVisible ? _c('aq-label', _vm._b({
    ref: "label",
    staticClass: "aq-datepicker__label",
    attrs: {
      "for": _vm.uid
    },
    on: {
      "click": _vm.showRangePicker
    }
  }, 'aq-label', _vm.bindsLabel, false), [_vm._v(_vm._s(_vm.$aqT(_vm.label)))]) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "parent_datepicker",
    class: ['aq-datetimepicker-input', {
      'aq-datetimepicker-input--open': _vm.showPicker
    }]
  }, [_vm.type === 'button' ? _c('div', {
    ref: "input_date"
  }, [_c('aq-button', {
    staticClass: "aq-button aq-button--default aq-datetimepicker__activator",
    attrs: {
      "icon": "aq-icon-calendar-dots",
      "outline": ""
    },
    on: {
      "click": _vm.showRangePicker
    }
  })], 1) : _c('div', {
    ref: "input_date",
    class: ['aq-datetimepicker-input-item', {
      'aq-datetimepicker-input-active': _vm.showPicker,
      'aq-datetimepicker-input--error': _vm.hasError,
      'aq-datetimepicker-input--disabled': _vm.disabled,
      'aq-datetimepicker-input--plain': _vm.plain,
      'aq-datetimepicker-input--readonly': _vm.readonly
    }],
    on: {
      "click": _vm.showRangePicker
    }
  }, [_vm.showIcon ? _c('em', {
    class: "aq-datepicker__icon-left " + _vm.icon
  }) : _vm._e(), _vm._v(" "), _vm.getSublabelLength ? _c('span', {
    class: ['aq-datepicker__sublabel', {
      'aq-datepicker__sublabel--icon-left': _vm.showIcon
    }]
  }, [_vm._v(_vm._s(_vm.$aqT(_vm.sublabel)) + "\n        "), _vm.sublabelRequired ? _c('span', {
    staticClass: "aq-label__requided"
  }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), !_vm.smallInput ? _c('span', {
    staticClass: "aq-datetimepicker-input-icon"
  }) : _vm._e(), _vm._v(" "), _c('span', {
    class: ['aq-datetimepicker-input-date aq-datetimepicker-input-date--first', {
      'aq-datepicker__input': !_vm.showIcon && !_vm.getSublabelLength
    }]
  }, [_vm._v("\n        " + _vm._s(_vm.isRange ? _vm.inputValueFormated.start : _vm.inputValueFormated) + "\n      ")]), _vm._v(" "), _vm.isRange ? _c('span', {
    staticClass: "aq-datetimepicker-input-divider"
  }, [_vm._v("-")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "aq-datetimepicker-input-date"
  }, [_vm._v("\n        " + _vm._s(_vm.isRange ? _vm.inputValueFormated.end : '') + "\n      ")]), _vm._v(" "), _vm.showPicker ? _c('span', {
    staticClass: "aq-datetimepicker-input-close",
    on: {
      "click": _vm.closeDatePicker
    }
  }) : _vm._e()])]), _vm._v(" "), _vm.isHelperTextVisible ? _c('div', {
    staticClass: "aq-select__helper-text"
  }, [_vm.isHelperTextVisible ? _c('aq-helper-text', _vm._b({}, 'aq-helper-text', _vm.bindsHelperText, false)) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "calendar_container",
    class: ['aq-datetimepicker', {
      'aq-datetimepicker-hide': !_vm.showPicker,
      'aq-datetimepicker-show': _vm.showPicker,
      'aq-datetimepicker-is-ie': _vm.is.ie(),
      'aq-datetimepicker-has-ranges': _vm.isRange,
      'aq-datetimepicker-show-buttons': _vm.showRanges && _vm.isRange,
      'aq-datetimepicker-is-bottom': _vm.orientaton == 'is-bottom',
      'aq-datetimepicker-is-left': _vm.isLeft,
      'aq-is-top': _vm.orientaton == 'is-top'
    }],
    style: _vm.zIndex
  }, [_vm.showHeader && !(!_vm.isRange && !_vm.hasTime) ? _c('div', {
    staticClass: "aq-datetimepicker-header"
  }, [_c('div', {
    staticClass: "aq-datetimepicker-header-left"
  }, [_vm._m(0), _vm._v(" "), _vm.isRange ? _c('span', {
    staticClass: "aq-datetimepicker-header-labels"
  }, [_vm._v(_vm._s(_vm.$t('aqua.start')) + ":")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "aq-datetimepicker-header-date"
  }, [_vm._v("\n          " + _vm._s(_vm.isRange ? _vm.valueFormated.start : _vm.valueFormated) + "\n        ")]), _vm._v(" "), _vm.isRange ? _c('span', {
    staticClass: "aq-datetimepicker-header-labels"
  }, [_vm._v(_vm._s(_vm.$t('aqua.end')) + ":")]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "aq-datetimepicker-header-date"
  }, [_vm._v(_vm._s(_vm.isRange ? _vm.valueFormated.end : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "aq-datetimepicker-header-right"
  }, [_c('span', {
    staticClass: "aq-datetimepicker-header-close",
    on: {
      "click": _vm.closeDatePicker
    }
  }, [_c('em', {
    staticClass: "aq-icon-close"
  })])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aq-datetimepicker-content"
  }, [_vm.isRange && _vm.showRanges ? _c('div', {
    staticClass: "aq-datetimepicker-selector-buttons"
  }, [_vm._l(_vm.rangesForDate, function (item, index) {
    return _c('button', {
      key: index,
      class: ['aq-datetimepicker-item-button', {
        'aq-datetimepicker-item-selected': _vm.selectedRange === index
      }],
      attrs: {
        "type": "button"
      },
      on: {
        "click": function click($event) {
          return _vm.changeDates(item.value, index);
        }
      }
    }, [_vm._v("\n          " + _vm._s(_vm.$t(item.name)) + "\n        ")]);
  }), _vm._v(" "), _c('button', {
    class: ['aq-datetimepicker-item-button', {
      'aq-datetimepicker-item-selected': _vm.selectedRange === ''
    }],
    attrs: {
      "type": "button"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('aqua.personalized')) + "\n        ")])], 2) : _vm._e(), _vm._v(" "), _c('div', {
    class: ['aq-datetimepicker-selector-date', {
      'aq-datetimepicker-has-next': _vm.isRange && _vm.showRanges
    }]
  }, [_vm.showBannerNotification ? _c('aq-banner', {
    attrs: {
      "title": _vm.getBannerTitle,
      "close": _vm.getCloseBanner,
      "state": _vm.getBannerState
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$aqT(_vm.getBannerMessage)))]) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), _c('v-date-picker', {
    ref: "calendar",
    attrs: {
      "mode": _vm.isRange ? 'range' : 'single',
      "columns": _vm.isRange ? _vm.$screens({
        default: 1,
        lg: 2
      }) : 1,
      "is-inline": "",
      "is-required": true,
      "min-date": _vm.params.minDate ? _vm.params.minDate : null,
      "max-date": _vm.params.maxDate ? _vm.params.maxDate : null,
      "locale": _vm.$t('aqua.locale')
    },
    on: {
      "dayclick": _vm.removeClick,
      "drag": _vm.onDrag
    },
    model: {
      value: _vm.valuePicker,
      callback: function callback($$v) {
        _vm.valuePicker = $$v;
      },
      expression: "valuePicker"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "aq-datetimepicker-calendar"
  }), _vm._v(" "), _vm.hasTime ? _c('div', {
    staticClass: "aq-datetimepicker-calendar-hour"
  }, [_c('div', {
    class: ['aq-datetimepicker-item-hour', {
      'aq-datetimepicker-item-is-range': _vm.isRange
    }]
  }, [_c('aq-time-picker', {
    ref: "time_initial",
    attrs: {
      "min-time": _vm.valueHour.minMinHour,
      "max-time": _vm.valueHour.minMaxHour,
      "label": _vm.timePickerLabelStart
    },
    model: {
      value: _vm.valueHour.start,
      callback: function callback($$v) {
        _vm.$set(_vm.valueHour, "start", $$v);
      },
      expression: "valueHour.start"
    }
  })], 1), _vm._v(" "), _vm.isRange ? _c('div', {
    staticClass: "aq-datetimepicker-item-hour aq-datetimepicker-item-is-range"
  }, [_c('aq-time-picker', {
    ref: "time_end",
    attrs: {
      "min-time": _vm.isSameDay ? _vm.valueHour.start : _vm.valueHour.maxMinHour,
      "max-time": _vm.valueHour.maxMaxHour,
      "label": _vm.timePickerLabelEnd
    },
    model: {
      value: _vm.valueHour.end,
      callback: function callback($$v) {
        _vm.$set(_vm.valueHour, "end", $$v);
      },
      expression: "valueHour.end"
    }
  })], 1) : _vm._e()]) : _vm._e()], 2)]), _vm._v(" "), !(!_vm.isRange && !_vm.hasTime) ? _c('div', {
    staticClass: "aq-datetimepicker-footer"
  }, [_vm.getFormattedRange.showDays || _vm.getFormattedRange.showTime ? _c('div', {
    staticClass: "aq-datetimepicker-left aq-datetimepicker-date-range"
  }, [_c('span', {
    staticClass: "aq-datetimepicker-date-range-label"
  }, [_vm._v(_vm._s(_vm.$t('aqua.range')) + ": ")]), _vm._v(" "), _vm.getFormattedRange.showDays ? _c('span', {
    staticClass: "aq-datetimepicker-date-range-item"
  }, [_vm._v("\n          " + _vm._s(_vm.getFormattedRange.days) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("\n          " + _vm._s(_vm.getFormattedRange.showDays ? _vm.getFormattedRange.days === 1 ? _vm.$t('aqua.day') : _vm.$t('aqua.days') : '') + "\n        ")]), _vm._v(" "), _c('span', [_vm._v("\n          " + _vm._s(_vm.getFormattedRange.showDays && _vm.getFormattedRange.showTime && _vm.getFormattedRange.showHours ? ', ' : '') + "\n        ")]), _vm._v(" "), _vm.getFormattedRange.showTime && _vm.getFormattedRange.showHours ? _c('span', {
    staticClass: "aq-datetimepicker-date-range-item"
  }, [_vm._v("\n          " + _vm._s(_vm.getFormattedRange.hours) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("\n          " + _vm._s(_vm.getFormattedRange.showTime && _vm.getFormattedRange.showHours ? _vm.getFormattedRange.hours === 1 ? _vm.$t('aqua.hour') : _vm.$t('aqua.hours') : '') + "\n        ")]), _vm._v(" "), _c('span', [_vm._v("\n          " + _vm._s(_vm.getFormattedRange.showTime && _vm.getFormattedRange.showMinutes && _vm.getFormattedRange.hours !== 0 ? ', ' : '') + "\n        ")]), _vm._v(" "), _vm.getFormattedRange.showTime && _vm.getFormattedRange.showMinutes ? _c('span', {
    staticClass: "aq-datetimepicker-date-range-item"
  }, [_vm._v("\n          " + _vm._s(_vm.getFormattedRange.minutes) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("\n          " + _vm._s(_vm.getFormattedRange.showTime && _vm.getFormattedRange.showMinutes ? _vm.getFormattedRange.minutes === 1 ? _vm.$t('aqua.minute') : _vm.$t('aqua.minutes') : '') + "\n        ")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aq-datetimepicker-right"
  }, [_c('aq-button', {
    on: {
      "click": function click($event) {
        return _vm.resetCalendar(true);
      }
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('aqua.clean')) + "\n        ")]), _vm._v(" "), _c('aq-button', {
    attrs: {
      "outline": ""
    },
    on: {
      "click": _vm.closeDatePicker
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('aqua.cancel')) + "\n        ")]), _vm._v(" "), _c('aq-button', {
    attrs: {
      "color": "blue"
    },
    on: {
      "click": _vm.acceptDate
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('aqua.apply')) + "\n        ")])], 1)]) : _vm._e()])], 1);
};
var __vue_staticRenderFns__$K = [function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('span', {
    staticClass: "aq-datetimepicker-header-icon"
  }, [_c('em', {
    staticClass: "aq-icon-calendar-dots"
  })]);
}];

/* style */
var __vue_inject_styles__$K = undefined;
/* scoped */
var __vue_scope_id__$K = undefined;
/* module identifier */
var __vue_module_identifier__$K = undefined;
/* functional template */
var __vue_is_functional_template__$K = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$K = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$K,
  staticRenderFns: __vue_staticRenderFns__$K
}, __vue_inject_styles__$K, __vue_script__$K, __vue_scope_id__$K, __vue_is_functional_template__$K, __vue_module_identifier__$K, false, undefined, undefined, undefined);
var AqDatePicker = __vue_component__$K;

//
var script$J = {
  mixins: [LabelMixin, helperTextMixin],
  props: {
    showCounter: {
      type: Boolean,
      default: false
    },
    maxSelect: {
      type: Number,
      default: -1
    },
    selectedOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    isCounterVisible: function isCounterVisible() {
      return typeof this.$slots.default !== 'undefined' && this.showCounter && this.maxSelect > 0;
    },
    getcounter: function getcounter() {
      var _this$selectedOptions, _this$selectedOptions2, _this$selectedOptions3;
      var counter = '';
      switch (true) {
        case this.showCounter && this.maxSelect > 0:
          counter = "".concat((_this$selectedOptions = this.selectedOptions) === null || _this$selectedOptions === void 0 ? void 0 : _this$selectedOptions.length, "/").concat(this.maxSelect);
          break;
        case this.selectedsCounter && this.maxSelect < 0 && ((_this$selectedOptions2 = this.selectedOptions) === null || _this$selectedOptions2 === void 0 ? void 0 : _this$selectedOptions2.length) >= 1:
          counter = "".concat((_this$selectedOptions3 = this.selectedOptions) === null || _this$selectedOptions3 === void 0 ? void 0 : _this$selectedOptions3.length);
          break;
        case !this.maxSelect && this.maxSelect < 0:
          counter = '';
          break;
      }
      return counter;
    }
  }
};

/* script */
var __vue_script__$J = script$J;

/* template */
var __vue_render__$J = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-field-group-component"
  }, [_vm.isLabelVisible ? _c('aq-label', _vm._b({
    staticClass: "aq-field-group-component__label"
  }, 'aq-label', _vm.bindsLabel, false), [_vm._v("\n    " + _vm._s(_vm.$aqT(_vm.label)) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aq-field-group"
  }, [_vm._t("default", function () {
    return [_vm._v("FieldGroup")];
  })], 2), _vm._v(" "), _vm.isHelperTextVisible || _vm.isCounterVisible ? _c('div', {
    staticClass: "aq-field-group__footer"
  }, [_vm.isHelperTextVisible ? _c('div', {
    staticClass: "aq-select__helper-text"
  }, [_vm.isHelperTextVisible ? _c('aq-helper-text', _vm._b({}, 'aq-helper-text', _vm.bindsHelperText, false)) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.isCounterVisible ? _c('div', {
    staticClass: "aq-field-group__footer--counter"
  }, [_vm._v("\n      " + _vm._s(_vm.getcounter) + "\n    ")]) : _vm._e()]) : _vm._e()], 1);
};
var __vue_staticRenderFns__$J = [];

/* style */
var __vue_inject_styles__$J = undefined;
/* scoped */
var __vue_scope_id__$J = undefined;
/* module identifier */
var __vue_module_identifier__$J = undefined;
/* functional template */
var __vue_is_functional_template__$J = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$J = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$J,
  staticRenderFns: __vue_staticRenderFns__$J
}, __vue_inject_styles__$J, __vue_script__$J, __vue_scope_id__$J, __vue_is_functional_template__$J, __vue_module_identifier__$J, false, undefined, undefined, undefined);
var AqFieldGroup = __vue_component__$J;

var allCountries = [{
  name: 'aqua.BD',
  nameAbr: 'aqua.BDAbr',
  code: '880',
  flag: 'BD'
}, {
  name: 'aqua.BE',
  nameAbr: 'aqua.BEAbr',
  code: '32',
  flag: 'BE'
}, {
  name: 'aqua.BF',
  nameAbr: 'aqua.BFAbr',
  code: '226',
  flag: 'BF'
}, {
  name: 'aqua.BG',
  nameAbr: 'aqua.BGAbr',
  code: '359',
  flag: 'BG'
}, {
  name: 'aqua.BA',
  nameAbr: 'aqua.BAAbr',
  code: '387',
  flag: 'BA'
}, {
  name: 'aqua.BB',
  nameAbr: 'aqua.BBAbr',
  code: '1-246',
  flag: 'BB'
}, {
  name: 'aqua.WF',
  nameAbr: 'aqua.WFAbr',
  code: '681',
  flag: 'WF'
}, {
  name: 'aqua.BL',
  nameAbr: 'aqua.BLAbr',
  code: '590',
  flag: 'BL'
}, {
  name: 'aqua.BM',
  nameAbr: 'aqua.BMAbr',
  code: '1-441',
  flag: 'BM'
}, {
  name: 'aqua.BN',
  nameAbr: 'aqua.BNAbr',
  code: '673',
  flag: 'BN'
}, {
  name: 'aqua.BO',
  nameAbr: 'aqua.BOAbr',
  code: '591',
  flag: 'BO'
}, {
  name: 'aqua.BH',
  nameAbr: 'aqua.BHAbr',
  code: '973',
  flag: 'BH'
}, {
  name: 'aqua.BI',
  nameAbr: 'aqua.BIAbr',
  code: '257',
  flag: 'BI'
}, {
  name: 'aqua.BJ',
  nameAbr: 'aqua.BJAbr',
  code: '229',
  flag: 'BJ'
}, {
  name: 'aqua.BT',
  nameAbr: 'aqua.BTAbr',
  code: '975',
  flag: 'BT'
}, {
  name: 'aqua.JM',
  nameAbr: 'aqua.JMAbr',
  code: '1-876',
  flag: 'JM'
}, {
  name: 'aqua.BW',
  nameAbr: 'aqua.BWAbr',
  code: '267',
  flag: 'BW'
}, {
  name: 'aqua.WS',
  nameAbr: 'aqua.WSAbr',
  code: '685',
  flag: 'WS'
}, {
  name: 'aqua.BQ',
  nameAbr: 'aqua.BQAbr',
  code: '599',
  flag: 'BQ'
}, {
  name: 'aqua.BR',
  nameAbr: 'aqua.BRAbr',
  code: '55',
  flag: 'BR'
}, {
  name: 'aqua.BS',
  nameAbr: 'aqua.BSAbr',
  code: '1-242',
  flag: 'BS'
}, {
  name: 'aqua.JE',
  nameAbr: 'aqua.JEAbr',
  code: '44-1534',
  flag: 'JE'
}, {
  name: 'aqua.BY',
  nameAbr: 'aqua.BYAbr',
  code: '375',
  flag: 'BY'
}, {
  name: 'aqua.BZ',
  nameAbr: 'aqua.BZAbr',
  code: '501',
  flag: 'BZ'
}, {
  name: 'aqua.RU',
  nameAbr: 'aqua.RUAbr',
  code: '7',
  flag: 'RU'
}, {
  name: 'aqua.RW',
  nameAbr: 'aqua.RWAbr',
  code: '250',
  flag: 'RW'
}, {
  name: 'aqua.RS',
  nameAbr: 'aqua.RSAbr',
  code: '381',
  flag: 'RS'
}, {
  name: 'aqua.TL',
  nameAbr: 'aqua.TLAbr',
  code: '670',
  flag: 'TL'
}, {
  name: 'aqua.RE',
  nameAbr: 'aqua.REAbr',
  code: '262',
  flag: 'RE'
}, {
  name: 'aqua.TM',
  nameAbr: 'aqua.TMAbr',
  code: '993',
  flag: 'TM'
}, {
  name: 'aqua.TJ',
  nameAbr: 'aqua.TJAbr',
  code: '992',
  flag: 'TJ'
}, {
  name: 'aqua.RO',
  nameAbr: 'aqua.ROAbr',
  code: '40',
  flag: 'RO'
}, {
  name: 'aqua.TK',
  nameAbr: 'aqua.TKAbr',
  code: '690',
  flag: 'TK'
}, {
  name: 'aqua.GW',
  nameAbr: 'aqua.GWAbr',
  code: '245',
  flag: 'GW'
}, {
  name: 'aqua.GU',
  nameAbr: 'aqua.GUAbr',
  code: '1-671',
  flag: 'GU'
}, {
  name: 'aqua.GT',
  nameAbr: 'aqua.GTAbr',
  code: '502',
  flag: 'GT'
}, {
  name: 'aqua.GR',
  nameAbr: 'aqua.GRAbr',
  code: '30',
  flag: 'GR'
}, {
  name: 'aqua.GQ',
  nameAbr: 'aqua.GQAbr',
  code: '240',
  flag: 'GQ'
}, {
  name: 'aqua.GP',
  nameAbr: 'aqua.GPAbr',
  code: '590',
  flag: 'GP'
}, {
  name: 'aqua.JP',
  nameAbr: 'aqua.JPAbr',
  code: '81',
  flag: 'JP'
}, {
  name: 'aqua.GY',
  nameAbr: 'aqua.GYAbr',
  code: '592',
  flag: 'GY'
}, {
  name: 'aqua.GG',
  nameAbr: 'aqua.GGAbr',
  code: '44-1481',
  flag: 'GG'
}, {
  name: 'aqua.GF',
  nameAbr: 'aqua.GFAbr',
  code: '594',
  flag: 'GF'
}, {
  name: 'aqua.GE',
  nameAbr: 'aqua.GEAbr',
  code: '995',
  flag: 'GE'
}, {
  name: 'aqua.GD',
  nameAbr: 'aqua.GDAbr',
  code: '1-473',
  flag: 'GD'
}, {
  name: 'aqua.GB',
  nameAbr: 'aqua.GBAbr',
  code: '44',
  flag: 'GB-ENG'
}, {
  name: 'aqua.GA',
  nameAbr: 'aqua.GAAbr',
  code: '241',
  flag: 'GA'
}, {
  name: 'aqua.SV',
  nameAbr: 'aqua.SVAbr',
  code: '503',
  flag: 'SV'
}, {
  name: 'aqua.GN',
  nameAbr: 'aqua.GNAbr',
  code: '224',
  flag: 'GN'
}, {
  name: 'aqua.GM',
  nameAbr: 'aqua.GMAbr',
  code: '220',
  flag: 'GM'
}, {
  name: 'aqua.GL',
  nameAbr: 'aqua.GLAbr',
  code: '299',
  flag: 'GL'
}, {
  name: 'aqua.GI',
  nameAbr: 'aqua.GIAbr',
  code: '350',
  flag: 'GI'
}, {
  name: 'aqua.GH',
  nameAbr: 'aqua.GHAbr',
  code: '233',
  flag: 'GH'
}, {
  name: 'aqua.OM',
  nameAbr: 'aqua.OMAbr',
  code: '968',
  flag: 'OM'
}, {
  name: 'aqua.TN',
  nameAbr: 'aqua.TNAbr',
  code: '216',
  flag: 'TN'
}, {
  name: 'aqua.JO',
  nameAbr: 'aqua.JOAbr',
  code: '962',
  flag: 'JO'
}, {
  name: 'aqua.HR',
  nameAbr: 'aqua.HRAbr',
  code: '385',
  flag: 'HR'
}, {
  name: 'aqua.HT',
  nameAbr: 'aqua.HTAbr',
  code: '509',
  flag: 'HT'
}, {
  name: 'aqua.HU',
  nameAbr: 'aqua.HUAbr',
  code: '36',
  flag: 'HU'
}, {
  name: 'aqua.HK',
  nameAbr: 'aqua.HKAbr',
  code: '852',
  flag: 'HK'
}, {
  name: 'aqua.HN',
  nameAbr: 'aqua.HNAbr',
  code: '504',
  flag: 'HN'
}, {
  name: 'aqua.HM',
  nameAbr: 'aqua.HMAbr',
  code: ' ',
  flag: 'HM'
}, {
  name: 'aqua.VE',
  nameAbr: 'aqua.VEAbr',
  code: '58',
  flag: 'VE'
}, {
  name: 'aqua.PR',
  nameAbr: 'aqua.PRAbr',
  code: '1-787 and 1-939',
  flag: 'PR'
}, {
  name: 'aqua.PS',
  nameAbr: 'aqua.PSAbr',
  code: '970',
  flag: 'PS'
}, {
  name: 'aqua.PW',
  nameAbr: 'aqua.PWAbr',
  code: '680',
  flag: 'PW'
}, {
  name: 'aqua.PT',
  nameAbr: 'aqua.PTAbr',
  code: '351',
  flag: 'PT'
}, {
  name: 'aqua.SJ',
  nameAbr: 'aqua.SJAbr',
  code: '47',
  flag: 'SJ'
}, {
  name: 'aqua.PY',
  nameAbr: 'aqua.PYAbr',
  code: '595',
  flag: 'PY'
}, {
  name: 'aqua.IQ',
  nameAbr: 'aqua.IQAbr',
  code: '964',
  flag: 'IQ'
}, {
  name: 'aqua.PA',
  nameAbr: 'aqua.PAAbr',
  code: '507',
  flag: 'PA'
}, {
  name: 'aqua.PF',
  nameAbr: 'aqua.PFAbr',
  code: '689',
  flag: 'PF'
}, {
  name: 'aqua.PG',
  nameAbr: 'aqua.PGAbr',
  code: '675',
  flag: 'PG'
}, {
  name: 'aqua.PE',
  nameAbr: 'aqua.PEAbr',
  code: '51',
  flag: 'PE'
}, {
  name: 'aqua.PK',
  nameAbr: 'aqua.PKAbr',
  code: '92',
  flag: 'PK'
}, {
  name: 'aqua.PH',
  nameAbr: 'aqua.PHAbr',
  code: '63',
  flag: 'PH'
}, {
  name: 'aqua.PN',
  nameAbr: 'aqua.PNAbr',
  code: '870',
  flag: 'PN'
}, {
  name: 'aqua.PL',
  nameAbr: 'aqua.PLAbr',
  code: '48',
  flag: 'PL'
}, {
  name: 'aqua.PM',
  nameAbr: 'aqua.PMAbr',
  code: '508',
  flag: 'PM'
}, {
  name: 'aqua.ZM',
  nameAbr: 'aqua.ZMAbr',
  code: '260',
  flag: 'ZM'
}, {
  name: 'aqua.EH',
  nameAbr: 'aqua.EHAbr',
  code: '212',
  flag: 'EH'
}, {
  name: 'aqua.EE',
  nameAbr: 'aqua.EEAbr',
  code: '372',
  flag: 'EE'
}, {
  name: 'aqua.EG',
  nameAbr: 'aqua.EGAbr',
  code: '20',
  flag: 'EG'
}, {
  name: 'aqua.ZA',
  nameAbr: 'aqua.ZAAbr',
  code: '27',
  flag: 'ZA'
}, {
  name: 'aqua.EC',
  nameAbr: 'aqua.ECAbr',
  code: '593',
  flag: 'EC'
}, {
  name: 'aqua.IT',
  nameAbr: 'aqua.ITAbr',
  code: '39',
  flag: 'IT'
}, {
  name: 'aqua.VN',
  nameAbr: 'aqua.VNAbr',
  code: '84',
  flag: 'VN'
}, {
  name: 'aqua.SB',
  nameAbr: 'aqua.SBAbr',
  code: '677',
  flag: 'SB'
}, {
  name: 'aqua.ET',
  nameAbr: 'aqua.ETAbr',
  code: '251',
  flag: 'ET'
}, {
  name: 'aqua.SO',
  nameAbr: 'aqua.SOAbr',
  code: '252',
  flag: 'SO'
}, {
  name: 'aqua.ZW',
  nameAbr: 'aqua.ZWAbr',
  code: '263',
  flag: 'ZW'
}, {
  name: 'aqua.SA',
  nameAbr: 'aqua.SAAbr',
  code: '966',
  flag: 'SA'
}, {
  name: 'aqua.ES',
  nameAbr: 'aqua.ESAbr',
  code: '34',
  flag: 'ES'
}, {
  name: 'aqua.ER',
  nameAbr: 'aqua.ERAbr',
  code: '291',
  flag: 'ER'
}, {
  name: 'aqua.ME',
  nameAbr: 'aqua.MEAbr',
  code: '382',
  flag: 'ME'
}, {
  name: 'aqua.MD',
  nameAbr: 'aqua.MDAbr',
  code: '373',
  flag: 'MD'
}, {
  name: 'aqua.MG',
  nameAbr: 'aqua.MGAbr',
  code: '261',
  flag: 'MG'
}, {
  name: 'aqua.MF',
  nameAbr: 'aqua.MFAbr',
  code: '590',
  flag: 'MF'
}, {
  name: 'aqua.MA',
  nameAbr: 'aqua.MAAbr',
  code: '212',
  flag: 'MA'
}, {
  name: 'aqua.MC',
  nameAbr: 'aqua.MCAbr',
  code: '377',
  flag: 'MC'
}, {
  name: 'aqua.UZ',
  nameAbr: 'aqua.UZAbr',
  code: '998',
  flag: 'UZ'
}, {
  name: 'aqua.MM',
  nameAbr: 'aqua.MMAbr',
  code: '95',
  flag: 'MM'
}, {
  name: 'aqua.ML',
  nameAbr: 'aqua.MLAbr',
  code: '223',
  flag: 'ML'
}, {
  name: 'aqua.MO',
  nameAbr: 'aqua.MOAbr',
  code: '853',
  flag: 'MO'
}, {
  name: 'aqua.MN',
  nameAbr: 'aqua.MNAbr',
  code: '976',
  flag: 'MN'
}, {
  name: 'aqua.MH',
  nameAbr: 'aqua.MHAbr',
  code: '692',
  flag: 'MH'
}, {
  name: 'aqua.MK',
  nameAbr: 'aqua.MKAbr',
  code: '389',
  flag: 'MK'
}, {
  name: 'aqua.MU',
  nameAbr: 'aqua.MUAbr',
  code: '230',
  flag: 'MU'
}, {
  name: 'aqua.MT',
  nameAbr: 'aqua.MTAbr',
  code: '356',
  flag: 'MT'
}, {
  name: 'aqua.MW',
  nameAbr: 'aqua.MWAbr',
  code: '265',
  flag: 'MW'
}, {
  name: 'aqua.MV',
  nameAbr: 'aqua.MVAbr',
  code: '960',
  flag: 'MV'
}, {
  name: 'aqua.MQ',
  nameAbr: 'aqua.MQAbr',
  code: '596',
  flag: 'MQ'
}, {
  name: 'aqua.MP',
  nameAbr: 'aqua.MPAbr',
  code: '1-670',
  flag: 'MP'
}, {
  name: 'aqua.MS',
  nameAbr: 'aqua.MSAbr',
  code: '1-664',
  flag: 'MS'
}, {
  name: 'aqua.MR',
  nameAbr: 'aqua.MRAbr',
  code: '222',
  flag: 'MR'
}, {
  name: 'aqua.IM',
  nameAbr: 'aqua.IMAbr',
  code: '44-1624',
  flag: 'IM'
}, {
  name: 'aqua.UG',
  nameAbr: 'aqua.UGAbr',
  code: '256',
  flag: 'UG'
}, {
  name: 'aqua.TZ',
  nameAbr: 'aqua.TZAbr',
  code: '255',
  flag: 'TZ'
}, {
  name: 'aqua.MY',
  nameAbr: 'aqua.MYAbr',
  code: '60',
  flag: 'MY'
}, {
  name: 'aqua.MX',
  nameAbr: 'aqua.MXAbr',
  code: '52',
  flag: 'MX'
}, {
  name: 'aqua.IL',
  nameAbr: 'aqua.ILAbr',
  code: '972',
  flag: 'IL'
}, {
  name: 'aqua.FR',
  nameAbr: 'aqua.FRAbr',
  code: '33',
  flag: 'FR'
}, {
  name: 'aqua.IO',
  nameAbr: 'aqua.IOAbr',
  code: '246',
  flag: 'IO'
}, {
  name: 'aqua.SH',
  nameAbr: 'aqua.SHAbr',
  code: '290',
  flag: 'SH'
}, {
  name: 'aqua.FI',
  nameAbr: 'aqua.FIAbr',
  code: '358',
  flag: 'FI'
}, {
  name: 'aqua.FJ',
  nameAbr: 'aqua.FJAbr',
  code: '679',
  flag: 'FJ'
}, {
  name: 'aqua.FK',
  nameAbr: 'aqua.FKAbr',
  code: '500',
  flag: 'FK'
}, {
  name: 'aqua.FM',
  nameAbr: 'aqua.FMAbr',
  code: '691',
  flag: 'FM'
}, {
  name: 'aqua.FO',
  nameAbr: 'aqua.FOAbr',
  code: '298',
  flag: 'FO'
}, {
  name: 'aqua.NI',
  nameAbr: 'aqua.NIAbr',
  code: '505',
  flag: 'NI'
}, {
  name: 'aqua.NL',
  nameAbr: 'aqua.NLAbr',
  code: '31',
  flag: 'NL'
}, {
  name: 'aqua.NO',
  nameAbr: 'aqua.NOAbr',
  code: '47',
  flag: 'NO'
}, {
  name: 'aqua.NA',
  nameAbr: 'aqua.NAAbr',
  code: '264',
  flag: 'NA'
}, {
  name: 'aqua.VU',
  nameAbr: 'aqua.VUAbr',
  code: '678',
  flag: 'VU'
}, {
  name: 'aqua.NC',
  nameAbr: 'aqua.NCAbr',
  code: '687',
  flag: 'NC'
}, {
  name: 'aqua.NE',
  nameAbr: 'aqua.NEAbr',
  code: '227',
  flag: 'NE'
}, {
  name: 'aqua.NF',
  nameAbr: 'aqua.NFAbr',
  code: '672',
  flag: 'NF'
}, {
  name: 'aqua.NG',
  nameAbr: 'aqua.NGAbr',
  code: '234',
  flag: 'NG'
}, {
  name: 'aqua.NZ',
  nameAbr: 'aqua.NZAbr',
  code: '64',
  flag: 'NZ'
}, {
  name: 'aqua.NP',
  nameAbr: 'aqua.NPAbr',
  code: '977',
  flag: 'NP'
}, {
  name: 'aqua.NR',
  nameAbr: 'aqua.NRAbr',
  code: '674',
  flag: 'NR'
}, {
  name: 'aqua.NU',
  nameAbr: 'aqua.NUAbr',
  code: '683',
  flag: 'NU'
}, {
  name: 'aqua.CK',
  nameAbr: 'aqua.CKAbr',
  code: '682',
  flag: 'CK'
}, {
  name: 'aqua.CI',
  nameAbr: 'aqua.CIAbr',
  code: '225',
  flag: 'CI'
}, {
  name: 'aqua.CH',
  nameAbr: 'aqua.CHAbr',
  code: '41',
  flag: 'CH'
}, {
  name: 'aqua.CO',
  nameAbr: 'aqua.COAbr',
  code: '57',
  flag: 'CO'
}, {
  name: 'aqua.CN',
  nameAbr: 'aqua.CNAbr',
  code: '86',
  flag: 'CN'
}, {
  name: 'aqua.CM',
  nameAbr: 'aqua.CMAbr',
  code: '237',
  flag: 'CM'
}, {
  name: 'aqua.CL',
  nameAbr: 'aqua.CLAbr',
  code: '56',
  flag: 'CL'
}, {
  name: 'aqua.CC',
  nameAbr: 'aqua.CCAbr',
  code: '61',
  flag: 'CC'
},
// {
//   name: 'aqua.CA',
//   nameAbr: 'aqua.CAAbr',
//   code: '1',
//   flag: 'CA',
// },
{
  name: 'aqua.CG',
  nameAbr: 'aqua.CGAbr',
  code: '242',
  flag: 'CG'
}, {
  name: 'aqua.CF',
  nameAbr: 'aqua.CFAbr',
  code: '236',
  flag: 'CF'
}, {
  name: 'aqua.CD',
  nameAbr: 'aqua.CDAbr',
  code: '243',
  flag: 'CD'
}, {
  name: 'aqua.CZ',
  nameAbr: 'aqua.CZAbr',
  code: '420',
  flag: 'CZ'
}, {
  name: 'aqua.CY',
  nameAbr: 'aqua.CYAbr',
  code: '357',
  flag: 'CY'
}, {
  name: 'aqua.CX',
  nameAbr: 'aqua.CXAbr',
  code: '61',
  flag: 'CX'
}, {
  name: 'aqua.CR',
  nameAbr: 'aqua.CRAbr',
  code: '506',
  flag: 'CR'
}, {
  name: 'aqua.CW',
  nameAbr: 'aqua.CWAbr',
  code: '599',
  flag: 'CW'
}, {
  name: 'aqua.CV',
  nameAbr: 'aqua.CVAbr',
  code: '238',
  flag: 'CV'
}, {
  name: 'aqua.CU',
  nameAbr: 'aqua.CUAbr',
  code: '53',
  flag: 'CU'
}, {
  name: 'aqua.SZ',
  nameAbr: 'aqua.SZAbr',
  code: '268',
  flag: 'SZ'
}, {
  name: 'aqua.SY',
  nameAbr: 'aqua.SYAbr',
  code: '963',
  flag: 'SY'
}, {
  name: 'aqua.SX',
  nameAbr: 'aqua.SXAbr',
  code: '599',
  flag: 'SX'
}, {
  name: 'aqua.KG',
  nameAbr: 'aqua.KGAbr',
  code: '996',
  flag: 'KG'
}, {
  name: 'aqua.KE',
  nameAbr: 'aqua.KEAbr',
  code: '254',
  flag: 'KE'
}, {
  name: 'aqua.SS',
  nameAbr: 'aqua.SSAbr',
  code: '211',
  flag: 'SS'
}, {
  name: 'aqua.SR',
  nameAbr: 'aqua.SRAbr',
  code: '597',
  flag: 'SR'
}, {
  name: 'aqua.KI',
  nameAbr: 'aqua.KIAbr',
  code: '686',
  flag: 'KI'
}, {
  name: 'aqua.KH',
  nameAbr: 'aqua.KHAbr',
  code: '855',
  flag: 'KH'
}, {
  name: 'aqua.KN',
  nameAbr: 'aqua.KNAbr',
  code: '1-869',
  flag: 'KN'
}, {
  name: 'aqua.KM',
  nameAbr: 'aqua.KMAbr',
  code: '269',
  flag: 'KM'
}, {
  name: 'aqua.ST',
  nameAbr: 'aqua.STAbr',
  code: '239',
  flag: 'ST'
}, {
  name: 'aqua.SK',
  nameAbr: 'aqua.SKAbr',
  code: '421',
  flag: 'SK'
}, {
  name: 'aqua.KR',
  nameAbr: 'aqua.KRAbr',
  code: '82',
  flag: 'KR'
}, {
  name: 'aqua.SI',
  nameAbr: 'aqua.SIAbr',
  code: '386',
  flag: 'SI'
}, {
  name: 'aqua.KP',
  nameAbr: 'aqua.KPAbr',
  code: '850',
  flag: 'KP'
}, {
  name: 'aqua.KW',
  nameAbr: 'aqua.KWAbr',
  code: '965',
  flag: 'KW'
}, {
  name: 'aqua.SN',
  nameAbr: 'aqua.SNAbr',
  code: '221',
  flag: 'SN'
}, {
  name: 'aqua.SM',
  nameAbr: 'aqua.SMAbr',
  code: '378',
  flag: 'SM'
}, {
  name: 'aqua.SL',
  nameAbr: 'aqua.SLAbr',
  code: '232',
  flag: 'SL'
}, {
  name: 'aqua.SC',
  nameAbr: 'aqua.SCAbr',
  code: '248',
  flag: 'SC'
}, {
  name: 'aqua.KZ',
  nameAbr: 'aqua.KZAbr',
  code: '7',
  flag: 'KZ'
}, {
  name: 'aqua.KY',
  nameAbr: 'aqua.KYAbr',
  code: '1-345',
  flag: 'KY'
}, {
  name: 'aqua.SG',
  nameAbr: 'aqua.SGAbr',
  code: '65',
  flag: 'SG'
}, {
  name: 'aqua.SE',
  nameAbr: 'aqua.SEAbr',
  code: '46',
  flag: 'SE'
}, {
  name: 'aqua.SD',
  nameAbr: 'aqua.SDAbr',
  code: '249',
  flag: 'SD'
}, {
  name: 'aqua.DO',
  nameAbr: 'aqua.DOAbr',
  code: '1-809 and 1-829',
  flag: 'DO'
}, {
  name: 'aqua.DM',
  nameAbr: 'aqua.DMAbr',
  code: '1-767',
  flag: 'DM'
}, {
  name: 'aqua.DJ',
  nameAbr: 'aqua.DJAbr',
  code: '253',
  flag: 'DJ'
}, {
  name: 'aqua.DK',
  nameAbr: 'aqua.DKAbr',
  code: '45',
  flag: 'DK'
}, {
  name: 'aqua.VG',
  nameAbr: 'aqua.VGAbr',
  code: '1-284',
  flag: 'VG'
}, {
  name: 'aqua.DE',
  nameAbr: 'aqua.DEAbr',
  code: '49',
  flag: 'DE'
}, {
  name: 'aqua.YE',
  nameAbr: 'aqua.YEAbr',
  code: '967',
  flag: 'YE'
}, {
  name: 'aqua.DZ',
  nameAbr: 'aqua.DZAbr',
  code: '213',
  flag: 'DZ'
}, {
  name: 'aqua.US',
  nameAbr: 'aqua.USAbr',
  code: '1',
  // flag: 'https://upload.wikimedia.org/wikipedia/commons/2/26/Flags_of_Canada_and_the_United_States.svg',
  flag: 'US'
}, {
  name: 'aqua.UY',
  nameAbr: 'aqua.UYAbr',
  code: '598',
  flag: 'UY'
}, {
  name: 'aqua.YT',
  nameAbr: 'aqua.YTAbr',
  code: '262',
  flag: 'YT'
},
// {
//   name: 'aqua.UM',
//   nameAbr: 'aqua.UMAbr',
//   code: '1',
//   flag: 'UM',
// },
{
  name: 'aqua.LB',
  nameAbr: 'aqua.LBAbr',
  code: '961',
  flag: 'LB'
}, {
  name: 'aqua.LC',
  nameAbr: 'aqua.LCAbr',
  code: '1-758',
  flag: 'LC'
}, {
  name: 'aqua.LA',
  nameAbr: 'aqua.LAAbr',
  code: '856',
  flag: 'LA'
}, {
  name: 'aqua.TV',
  nameAbr: 'aqua.TVAbr',
  code: '688',
  flag: 'TV'
}, {
  name: 'aqua.TW',
  nameAbr: 'aqua.TWAbr',
  code: '886',
  flag: 'TW'
}, {
  name: 'aqua.TT',
  nameAbr: 'aqua.TTAbr',
  code: '1-868',
  flag: 'TT'
}, {
  name: 'aqua.TR',
  nameAbr: 'aqua.TRAbr',
  code: '90',
  flag: 'TR'
}, {
  name: 'aqua.LK',
  nameAbr: 'aqua.LKAbr',
  code: '94',
  flag: 'LK'
}, {
  name: 'aqua.LI',
  nameAbr: 'aqua.LIAbr',
  code: '423',
  flag: 'LI'
}, {
  name: 'aqua.LV',
  nameAbr: 'aqua.LVAbr',
  code: '371',
  flag: 'LV'
}, {
  name: 'aqua.TO',
  nameAbr: 'aqua.TOAbr',
  code: '676',
  flag: 'TO'
}, {
  name: 'aqua.LT',
  nameAbr: 'aqua.LTAbr',
  code: '370',
  flag: 'LT'
}, {
  name: 'aqua.LU',
  nameAbr: 'aqua.LUAbr',
  code: '352',
  flag: 'LU'
}, {
  name: 'aqua.LR',
  nameAbr: 'aqua.LRAbr',
  code: '231',
  flag: 'LR'
}, {
  name: 'aqua.LS',
  nameAbr: 'aqua.LSAbr',
  code: '266',
  flag: 'LS'
}, {
  name: 'aqua.TH',
  nameAbr: 'aqua.THAbr',
  code: '66',
  flag: 'TH'
}, {
  name: 'aqua.TG',
  nameAbr: 'aqua.TGAbr',
  code: '228',
  flag: 'TG'
}, {
  name: 'aqua.TD',
  nameAbr: 'aqua.TDAbr',
  code: '235',
  flag: 'TD'
}, {
  name: 'aqua.TC',
  nameAbr: 'aqua.TCAbr',
  code: '1-649',
  flag: 'TC'
}, {
  name: 'aqua.LY',
  nameAbr: 'aqua.LYAbr',
  code: '218',
  flag: 'LY'
}, {
  name: 'aqua.VA',
  nameAbr: 'aqua.VAAbr',
  code: '379',
  flag: 'VA'
}, {
  name: 'aqua.VC',
  nameAbr: 'aqua.VCAbr',
  code: '1-784',
  flag: 'VC'
}, {
  name: 'aqua.AE',
  nameAbr: 'aqua.AEAbr',
  code: '971',
  flag: 'AE'
}, {
  name: 'aqua.AD',
  nameAbr: 'aqua.ADAbr',
  code: '376',
  flag: 'AD'
}, {
  name: 'aqua.AG',
  nameAbr: 'aqua.AGAbr',
  code: '1-268',
  flag: 'AG'
}, {
  name: 'aqua.AF',
  nameAbr: 'aqua.AFAbr',
  code: '93',
  flag: 'AF'
}, {
  name: 'aqua.AI',
  nameAbr: 'aqua.AIAbr',
  code: '1-264',
  flag: 'AI'
}, {
  name: 'aqua.VI',
  nameAbr: 'aqua.VIAbr',
  code: '1-340',
  flag: 'VI'
}, {
  name: 'aqua.IS',
  nameAbr: 'aqua.ISAbr',
  code: '354',
  flag: 'IS'
}, {
  name: 'aqua.IR',
  nameAbr: 'aqua.IRAbr',
  code: '98',
  flag: 'IR'
}, {
  name: 'aqua.AM',
  nameAbr: 'aqua.AMAbr',
  code: '374',
  flag: 'AM'
}, {
  name: 'aqua.AL',
  nameAbr: 'aqua.ALAbr',
  code: '355',
  flag: 'AL'
}, {
  name: 'aqua.AO',
  nameAbr: 'aqua.AOAbr',
  code: '244',
  flag: 'AO'
}, {
  name: 'aqua.AS',
  nameAbr: 'aqua.ASAbr',
  code: '1-684',
  flag: 'AS'
}, {
  name: 'aqua.AR',
  nameAbr: 'aqua.ARAbr',
  code: '54',
  flag: 'AR'
}, {
  name: 'aqua.AU',
  nameAbr: 'aqua.AUAbr',
  code: '61',
  flag: 'AU'
}, {
  name: 'aqua.AT',
  nameAbr: 'aqua.ATAbr',
  code: '43',
  flag: 'AT'
}, {
  name: 'aqua.AW',
  nameAbr: 'aqua.AWAbr',
  code: '297',
  flag: 'AW'
}, {
  name: 'aqua.IN',
  nameAbr: 'aqua.INAbr',
  code: '91',
  flag: 'IN'
}, {
  name: 'aqua.AX',
  nameAbr: 'aqua.AXAbr',
  code: '358-18',
  flag: 'AX'
}, {
  name: 'aqua.AZ',
  nameAbr: 'aqua.AZAbr',
  code: '994',
  flag: 'AZ'
}, {
  name: 'aqua.IE',
  nameAbr: 'aqua.IEAbr',
  code: '353',
  flag: 'IE'
}, {
  name: 'aqua.ID',
  nameAbr: 'aqua.IDAbr',
  code: '62',
  flag: 'ID'
}, {
  name: 'aqua.UA',
  nameAbr: 'aqua.UAAbr',
  code: '380',
  flag: 'UA'
}, {
  name: 'aqua.QA',
  nameAbr: 'aqua.QAAbr',
  code: '974',
  flag: 'QA'
}, {
  name: 'aqua.MZ',
  nameAbr: 'aqua.MZAbr',
  code: '258',
  flag: 'MZ'
}];
var defaultCountries = [{
  name: 'aqua.CO',
  nameAbr: 'aqua.COAbr',
  code: '57',
  flag: 'CO'
}, {
  name: 'aqua.PE',
  nameAbr: 'aqua.PEAbr',
  code: '51',
  flag: 'PE'
}, {
  name: 'aqua.EC',
  nameAbr: 'aqua.ECAbr',
  code: '593',
  flag: 'EC'
}, {
  name: 'aqua.AR',
  nameAbr: 'aqua.ARAbr',
  code: '54',
  flag: 'AR'
}, {
  name: 'aqua.MX',
  nameAbr: 'aqua.MXAbr',
  code: '52',
  flag: 'MX'
}, {
  name: 'aqua.BO',
  nameAbr: 'aqua.BOAbr',
  code: '591',
  flag: 'BO'
}, {
  name: 'aqua.BR',
  nameAbr: 'aqua.BRAbr',
  code: '55',
  flag: 'BR'
}, {
  name: 'aqua.CL',
  nameAbr: 'aqua.CLAbr',
  code: '56',
  flag: 'CL'
}, {
  name: 'aqua.CR',
  nameAbr: 'aqua.CRAbr',
  code: '506',
  flag: 'CR'
}, {
  name: 'aqua.GT',
  nameAbr: 'aqua.GTAbr',
  code: '502',
  flag: 'GT'
}, {
  name: 'aqua.IN',
  nameAbr: 'aqua.INAbr',
  code: '91',
  flag: 'IN'
}, {
  name: 'aqua.NL',
  nameAbr: 'aqua.NLAbr',
  code: '31',
  flag: 'NL'
}, {
  name: 'aqua.PA',
  nameAbr: 'aqua.PAAbr',
  code: '507',
  flag: 'PA'
}, {
  name: 'aqua.US',
  nameAbr: 'aqua.USAbr',
  code: '1',
  // flag: 'https://upload.wikimedia.org/wikipedia/commons/2/26/Flags_of_Canada_and_the_United_States.svg',
  flag: 'US'
}, {
  name: 'aqua.VE',
  nameAbr: 'aqua.VEAbr',
  code: '58',
  flag: 'VE'
}, {
  name: 'aqua.CU',
  nameAbr: 'aqua.CUAbr',
  code: '53',
  flag: 'CU'
}, {
  name: 'aqua.SV',
  nameAbr: 'aqua.SVAbr',
  code: '503',
  flag: 'SV'
}, {
  name: 'aqua.ES',
  nameAbr: 'aqua.ESAbr',
  code: '34',
  flag: 'ES'
}, {
  name: 'aqua.HN',
  nameAbr: 'aqua.HNAbr',
  code: '504',
  flag: 'HN'
}, {
  name: 'aqua.GB',
  nameAbr: 'aqua.GBAbr',
  code: '44',
  flag: 'GB-ENG'
}, {
  name: 'aqua.NI',
  nameAbr: 'aqua.NIAbr',
  code: '505',
  flag: 'NI'
}, {
  name: 'aqua.UY',
  nameAbr: 'aqua.UYAbr',
  code: '598',
  flag: 'UY'
}];

//
var script$I = {
  name: 'aq-flag',
  components: {
    CountryFlag: CountryFlag
  },
  props: {
    showShortName: {
      type: Boolean,
      default: false
    },
    showFullName: {
      type: Boolean,
      default: true
    },
    showCallSign: {
      type: Boolean,
      default: false
    },
    alignFlag: {
      type: String,
      default: 'left',
      validator: function validator(x) {
        return ['', 'left', 'right'].includes(x.toLowerCase());
      }
    },
    country: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {};
  },
  methods: {
    getCountryName: function getCountryName() {
      var _this$getCountry = this.getCountry(),
        nameAbr = _this$getCountry.nameAbr,
        code = _this$getCountry.code,
        name = _this$getCountry.name;
      var countryName = this.getNaming(this.showFullName ? name : nameAbr, code);
      return countryName;
    },
    getFlag: function getFlag() {
      var _this$getCountry2 = this.getCountry(),
        flag = _this$getCountry2.flag;
      return flag;
    },
    getNaming: function getNaming(nameAbr, code) {
      var message = '';
      switch (true) {
        case this.showShortName && this.showCallSign && !this.showFullName:
          message = "".concat(this.$aqT(nameAbr), " (+").concat(code, ")");
          break;
        case this.showShortName && !this.showCallSign && !this.showFullName:
          message = "".concat(this.$aqT(nameAbr));
          break;
        case this.showFullName && this.showCallSign:
          message = "".concat(this.$aqT(nameAbr), " (+").concat(code, ")");
          break;
        case this.showFullName || !this.showShortName && this.showFullName:
          message = "".concat(this.$aqT(nameAbr));
          break;
        case !this.showShortName && !this.showCallSign:
          message = '';
          break;
        case !this.showShortName && this.showCallSign:
          message = "(+".concat(code, ")");
          break;
      }
      return message.trim();
    },
    getCountry: function getCountry() {
      var _this = this;
      var localCountries = JSON.parse(JSON.stringify(allCountries));
      var searchBy = /\d/.test(this.country) ? 'code' : 'flag';
      var country = localCountries.filter(function (auxCountry) {
        return auxCountry[searchBy] === _this.country;
      });
      return country[0];
    }
  }
};

/* script */
var __vue_script__$I = script$I;

/* template */
var __vue_render__$I = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-flag"
  }, [_vm.alignFlag === 'left' ? _c('country-flag', {
    staticClass: "aq-dropdown-item__flag--country",
    attrs: {
      "country": _vm.getFlag(),
      "size": "normal"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "aq-flag__country"
  }, [_vm._v(_vm._s(_vm.getCountryName()))]), _vm._v(" "), _vm.alignFlag === 'right' ? _c('country-flag', {
    staticClass: "aq-dropdown-item__flag--country",
    attrs: {
      "country": _vm.getFlag(),
      "size": "normal"
    }
  }) : _vm._e()], 1);
};
var __vue_staticRenderFns__$I = [];

/* style */
var __vue_inject_styles__$I = undefined;
/* scoped */
var __vue_scope_id__$I = undefined;
/* module identifier */
var __vue_module_identifier__$I = undefined;
/* functional template */
var __vue_is_functional_template__$I = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$I = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$I,
  staticRenderFns: __vue_staticRenderFns__$I
}, __vue_inject_styles__$I, __vue_script__$I, __vue_scope_id__$I, __vue_is_functional_template__$I, __vue_module_identifier__$I, false, undefined, undefined, undefined);
var AqFlag = __vue_component__$I;

var script$H = {
  name: 'aq-flag-selector',
  mixins: [LabelMixin, helperTextMixin],
  props: {
    countries: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    country: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isName: {
      type: Boolean,
      default: true
    },
    isCallSign: {
      type: Boolean,
      default: false
    },
    isSelect: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    cleanOnEscape: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: [String, Function],
      default: ''
    },
    isFullName: {
      type: Boolean,
      default: false
    },
    popoverWidth: {
      type: String,
      default: 'auto'
    },
    showCounter: {
      type: Boolean,
      default: false
    },
    maxSelect: {
      type: Number,
      default: -1
    },
    selectedNumbers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    outline: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      allCountries: [],
      key: 1,
      localCountry: []
    };
  },
  watch: {
    country: {
      handler: function handler() {
        this.key += 1;
      },
      deep: true
    },
    localCountry: {
      handler: function handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          this.setModel();
        }
      },
      deep: true
    }
  },
  computed: {
    getCountries: function getCountries() {
      var _this = this;
      var options = [];
      var message = '';
      var allCountries$1 = allCountries,
        defaultCountries$1 = defaultCountries;
      var allCountriesList = JSON.parse(JSON.stringify(allCountries$1));
      var originalCountriesList = JSON.parse(JSON.stringify(defaultCountries$1));
      var auxCountries = JSON.parse(JSON.stringify(this.countries));
      var countries = this.existentCountries ? this.getArrayFilter(allCountriesList, auxCountries) : originalCountriesList;
      countries.sort(function (a, b) {
        if (_this.$aqT(a.nameAbr) < _this.$aqT(b.nameAbr)) {
          return -1;
        }
        if (_this.$aqT(a.nameAbr) > _this.$aqT(b.nameAbr)) {
          return 1;
        }
        return 0;
      });
      countries.forEach(function (country, counter) {
        var internCountry = country;
        var nameAbr = country.nameAbr,
          code = country.code,
          name = country.name;
        message = _this.getNaming(_this.isFullName ? name : nameAbr, code);
        internCountry.naming = message;
        options[counter] = internCountry;
      });
      return options;
    },
    getCountry: {
      get: function get() {
        var _this$country, _this$country2;
        var existCountries = this.existentCountries;
        var defaultCountries$1 = defaultCountries;
        var originalCountriesList = JSON.parse(JSON.stringify(defaultCountries$1));
        var existCountry = this.existentCountry;
        var auxCountries = existCountries ? JSON.parse(JSON.stringify(this.countries)) : [];
        var auxCountry = [{}];
        switch (true) {
          case existCountries && existCountry:
            auxCountry = _typeof$2((_this$country = this.country) === null || _this$country === void 0 ? void 0 : _this$country[0]) === 'object' ? this.country : this.getCountryModel(auxCountries, this.country[0]);
            break;
          case !existCountries && !existCountry || existCountries && !existCountry:
            auxCountry = [{}];
            break;
          case !existCountries && existCountry:
            auxCountry = _typeof$2((_this$country2 = this.country) === null || _this$country2 === void 0 ? void 0 : _this$country2[0]) === 'object' ? this.country : this.getCountryModel(originalCountriesList, this.country[0]);
            break;
        }
        return auxCountry;
      },
      set: function set(val) {
        this.localCountry = [val];
      }
    },
    getType: function getType() {
      return this.isSelect;
    },
    isSlot: function isSlot() {
      return typeof this.$slots.content !== 'undefined';
    },
    getMinWidth: function getMinWidth() {
      var style = {};
      switch (true) {
        case this.isFullName && this.isCallSign:
          style.minWidth = '200px';
          break;
        case this.isName && this.isCallSign || this.isFullName:
          style.minWidth = '160px';
          break;
        case this.isName && !this.isCallSign:
          style.minWidth = '130px';
          break;
        case !this.isName && this.isCallSign:
          style.minWidth = '110px';
          break;
        case !this.isName && !this.isCallSign:
          style.minWidth = '65px';
          break;
      }
      return style;
    },
    existentCountries: function existentCountries() {
      var _this$countries;
      return this.countries && ((_this$countries = this.countries) === null || _this$countries === void 0 ? void 0 : _this$countries.length) > 0;
    },
    existentCountry: function existentCountry() {
      var _this$country3;
      return this.country && ((_this$country3 = this.country) === null || _this$country3 === void 0 ? void 0 : _this$country3.length) > 0;
    },
    isCounterVisible: function isCounterVisible() {
      return this.isSlot && this.showCounter && this.maxSelect > 0;
    },
    getCounter: function getCounter() {
      var _this$selectedNumbers, _this$selectedNumbers2, _this$selectedNumbers3;
      var counter = '';
      switch (true) {
        case this.showCounter && this.maxSelect > 0:
          counter = "".concat((_this$selectedNumbers = this.selectedNumbers) === null || _this$selectedNumbers === void 0 ? void 0 : _this$selectedNumbers.length, "/").concat(this.maxSelect);
          break;
        case this.selectedsCounter && this.maxSelect < 0 && ((_this$selectedNumbers2 = this.selectedNumbers) === null || _this$selectedNumbers2 === void 0 ? void 0 : _this$selectedNumbers2.length) >= 1:
          counter = "".concat((_this$selectedNumbers3 = this.selectedNumbers) === null || _this$selectedNumbers3 === void 0 ? void 0 : _this$selectedNumbers3.length);
          break;
        case !this.maxSelect && this.maxSelect < 0:
          counter = '';
          break;
      }
      return counter;
    }
  },
  methods: {
    getArrayFilter: function getArrayFilter(generalCountries, customCountries) {
      var options = [];
      generalCountries.forEach(function (country) {
        customCountries.forEach(function (element, index) {
          if (country.code === element) {
            options[index] = country;
          }
        });
      });
      return options;
    },
    getNaming: function getNaming(nameAbr, code) {
      var message = '';
      switch (true) {
        case this.isName && this.isCallSign && !this.isFullName:
          message = "".concat(this.$aqT(nameAbr), " (+").concat(code, ")");
          break;
        case this.isName && !this.isCallSign && !this.isFullName:
          message = "".concat(this.$aqT(nameAbr));
          break;
        case this.isFullName && this.isCallSign:
          message = "".concat(this.$aqT(nameAbr), " (+").concat(code, ")");
          break;
        case this.isFullName || !this.isName && this.isFullName:
          message = "".concat(this.$aqT(nameAbr));
          break;
        case !this.isName && !this.isCallSign:
          message = '';
          break;
        case !this.isName && this.isCallSign:
          message = "+".concat(code);
          break;
      }
      return message.trim();
    },
    setModel: function setModel() {
      var _this$localCountry$, _this$localCountry$2;
      var value = {
        countryCode: "".concat((_this$localCountry$ = this.localCountry[0]) !== null && _this$localCountry$ !== void 0 && _this$localCountry$.code ? "+".concat((_this$localCountry$2 = this.localCountry[0]) === null || _this$localCountry$2 === void 0 ? void 0 : _this$localCountry$2.code) : '')
      };
      this.$emit('input', value);
    },
    getCountryModel: function getCountryModel(countries, code) {
      var countryModel = [{}];
      countries.forEach(function (country) {
        var internCountry = _typeof$2(country) === 'object' ? country.code : country;
        if (internCountry === code) {
          countryModel = country;
        }
      });
      return countryModel;
    },
    cleanSelections: function cleanSelections() {
      this.$refs['flag-selector-ref'].cleanSelections();
    }
  }
};

/* script */
var __vue_script__$H = script$H;

/* template */
var __vue_render__$H = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-flag-selector"
  }, [_vm.isLabelVisible ? _c('aq-label', _vm._b({
    staticClass: "aq-flag-selector__label"
  }, 'aq-label', _vm.bindsLabel, false), [_vm._v("\n    " + _vm._s(_vm.$aqT(_vm.label)) + "\n  ")]) : _vm._e(), _vm._v(" "), _vm.isSlot ? _c('aq-field-group', [_vm.getType ? _c('aq-select', {
    key: _vm.key,
    ref: "flag-selector-ref",
    class: [{
      'aq-flag-selector__left--content--plain': _vm.outline
    }, {
      'aq-flag-selector__left--content': _vm.isSlot
    }, {
      'aq-flag-selector__NSlot': !_vm.isSlot
    }],
    style: _vm.getMinWidth,
    attrs: {
      "value-key": "code",
      "text-key": "nameAbr",
      "closeOnSelect": _vm.closeOnSelect,
      "cleanOnEscape": _vm.cleanOnEscape,
      "options": _vm.getCountries,
      "returnMode": "originalObject",
      "popoverWidth": _vm.popoverWidth,
      "valueArray": false,
      "isFlagSelector": true,
      "disabled": _vm.disabled,
      "fontSizeSelectedOption": "14px",
      "placeholder": _vm.placeholder,
      "isSlot": true,
      "readonly": _vm.readonly,
      "isFullName": _vm.isFullName,
      "error": _vm.error && !_vm.readonly,
      "plain": _vm.outline,
      "showIconClose": false
    },
    model: {
      value: _vm.getCountry,
      callback: function callback($$v) {
        _vm.getCountry = $$v;
      },
      expression: "getCountry"
    }
  }) : _c('aq-auto-complete', {
    key: _vm.key,
    ref: "flag-selector-ref",
    class: [{
      'aq-flag-selector__left--content': _vm.isSlot
    }, {
      'aq-flag-selector__NSlot': !_vm.isSlot
    }, {
      'aq-flag-selector__left--content--plain': _vm.outline
    }],
    attrs: {
      "value-key": "code",
      "text-key": "nameAbr",
      "closeOnSelect": _vm.closeOnSelect,
      "cleanOnEscape": _vm.cleanOnEscape,
      "options": _vm.getCountries,
      "returnMode": "originalObject",
      "popoverWidth": _vm.popoverWidth,
      "valueArray": false,
      "isFlagSelector": true,
      "disabled": _vm.disabled,
      "fontSizeSelectedOption": "14px",
      "placeholder": _vm.placeholder,
      "isSlot": true,
      "readonly": _vm.readonly,
      "isFullName": _vm.isFullName,
      "error": _vm.error && !_vm.readonly,
      "plain": _vm.outline,
      "showIconClose": false
    },
    model: {
      value: _vm.getCountry,
      callback: function callback($$v) {
        _vm.getCountry = $$v;
      },
      expression: "getCountry"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "aq-flag-selector__slot--container"
  }, [_vm._t("content")], 2)], 1) : [_vm.getType ? _c('aq-select', {
    key: _vm.key,
    ref: "flag-selector-ref",
    class: [{
      'aq-flag-selector__left--content': _vm.isSlot
    }, {
      'aq-flag-selector__NSlot': !_vm.isSlot
    }],
    style: _vm.getMinWidth,
    attrs: {
      "value-key": "code",
      "text-key": "nameAbr",
      "closeOnSelect": _vm.closeOnSelect,
      "cleanOnEscape": _vm.cleanOnEscape,
      "options": _vm.getCountries,
      "returnMode": "originalObject",
      "popoverWidth": _vm.popoverWidth,
      "valueArray": false,
      "isFlagSelector": true,
      "disabled": _vm.disabled,
      "fontSizeSelectedOption": "14px",
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "isFullName": _vm.isFullName,
      "error": _vm.error && !_vm.readonly,
      "plain": _vm.outline,
      "showIconClose": false
    },
    model: {
      value: _vm.getCountry,
      callback: function callback($$v) {
        _vm.getCountry = $$v;
      },
      expression: "getCountry"
    }
  }) : _c('aq-auto-complete', {
    key: _vm.key,
    ref: "flag-selector-ref",
    class: [{
      'aq-flag-selector__left--content': _vm.isSlot
    }, {
      'aq-flag-selector__NSlot': !_vm.isSlot
    }],
    attrs: {
      "value-key": "code",
      "text-key": "nameAbr",
      "closeOnSelect": _vm.closeOnSelect,
      "cleanOnEscape": _vm.cleanOnEscape,
      "options": _vm.getCountries,
      "returnMode": "originalObject",
      "popoverWidth": _vm.popoverWidth,
      "valueArray": false,
      "isFlagSelector": true,
      "disabled": _vm.disabled,
      "fontSizeSelectedOption": "14px",
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "isFullName": _vm.isFullName,
      "error": _vm.error && !_vm.readonly,
      "plain": _vm.outline,
      "showIconClose": false
    },
    model: {
      value: _vm.getCountry,
      callback: function callback($$v) {
        _vm.getCountry = $$v;
      },
      expression: "getCountry"
    }
  })], _vm._v(" "), _vm.isHelperTextVisible || _vm.isCounterVisible ? _c('div', {
    staticClass: "aq-flag-selector__footer"
  }, [_vm.isHelperTextVisible ? _c('div', {
    staticClass: "aq-select__helper-text"
  }, [_vm.isHelperTextVisible ? _c('aq-helper-text', _vm._b({}, 'aq-helper-text', _vm.bindsHelperText, false)) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.isCounterVisible ? _c('div', {
    staticClass: "aq-flag-selector__footer--counter"
  }, [_vm._v("\n      " + _vm._s(_vm.getCounter) + "\n    ")]) : _vm._e()]) : _vm._e()], 2);
};
var __vue_staticRenderFns__$H = [];

/* style */
var __vue_inject_styles__$H = undefined;
/* scoped */
var __vue_scope_id__$H = undefined;
/* module identifier */
var __vue_module_identifier__$H = undefined;
/* functional template */
var __vue_is_functional_template__$H = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$H = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$H,
  staticRenderFns: __vue_staticRenderFns__$H
}, __vue_inject_styles__$H, __vue_script__$H, __vue_scope_id__$H, __vue_is_functional_template__$H, __vue_module_identifier__$H, false, undefined, undefined, undefined);
var AqFlagSelector = __vue_component__$H;

var returnFileSize = function returnFileSize(number) {
  var size = '';
  if (number < 1024) {
    size = "".concat(number, "bytes");
  }
  if (number >= 1024 && number < 1048576) {
    size = "".concat((number / 1024).toFixed(1), "KB");
  }
  if (number >= 1048576 && number < 1073741824) {
    size = "".concat((number / 1048576).toFixed(1), "MB");
  }
  if (number >= 1073741824) {
    size = "".concat((number / 1073741824).toFixed(1), "GB");
  }
  return size;
};

var axios$3 = {exports: {}};

var bind$2 = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};

var bind$1 = bind$2;

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return toString.call(val) === '[object FormData]';
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (toString.call(val) !== '[object Object]') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return toString.call(val) === '[object URLSearchParams]';
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind$1(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

var utils$e = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM
};

var utils$d = utils$e;

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
var buildURL$2 = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils$d.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils$d.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils$d.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils$d.forEach(val, function parseValue(v) {
        if (utils$d.isDate(v)) {
          v = v.toISOString();
        } else if (utils$d.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};

var utils$c = utils$e;

function InterceptorManager$1() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager$1.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager$1.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager$1.prototype.forEach = function forEach(fn) {
  utils$c.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

var InterceptorManager_1 = InterceptorManager$1;

var utils$b = utils$e;

var normalizeHeaderName$1 = function normalizeHeaderName(headers, normalizedName) {
  utils$b.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};

/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
var enhanceError$2 = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  };
  return error;
};

var enhanceError$1 = enhanceError$2;

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
var createError$2 = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError$1(error, config, code, request, response);
};

var createError$1 = createError$2;

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
var settle$1 = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError$1(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};

var utils$a = utils$e;

var cookies$1 = (
  utils$a.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils$a.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils$a.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils$a.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);

/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
var isAbsoluteURL$1 = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};

/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
var combineURLs$1 = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};

var isAbsoluteURL = isAbsoluteURL$1;
var combineURLs = combineURLs$1;

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
var buildFullPath$1 = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};

var utils$9 = utils$e;

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
var parseHeaders$1 = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils$9.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils$9.trim(line.substr(0, i)).toLowerCase();
    val = utils$9.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};

var utils$8 = utils$e;

var isURLSameOrigin$1 = (
  utils$8.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils$8.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);

/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel$4(message) {
  this.message = message;
}

Cancel$4.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel$4.prototype.__CANCEL__ = true;

var Cancel_1 = Cancel$4;

var utils$7 = utils$e;
var settle = settle$1;
var cookies = cookies$1;
var buildURL$1 = buildURL$2;
var buildFullPath = buildFullPath$1;
var parseHeaders = parseHeaders$1;
var isURLSameOrigin = isURLSameOrigin$1;
var createError = createError$2;
var defaults$4 = defaults_1;
var Cancel$3 = Cancel_1;

var xhr = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils$7.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL$1(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || defaults$4.transitional;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(
        timeoutErrorMessage,
        config,
        transitional.clarifyTimeoutError ? 'ETIMEDOUT' : 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils$7.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils$7.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils$7.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new Cancel$3('canceled') : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};

var utils$6 = utils$e;
var normalizeHeaderName = normalizeHeaderName$1;
var enhanceError = enhanceError$2;

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils$6.isUndefined(headers) && utils$6.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = xhr;
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = xhr;
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils$6.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$6.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults$3 = {

  transitional: {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
  },

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils$6.isFormData(data) ||
      utils$6.isArrayBuffer(data) ||
      utils$6.isBuffer(data) ||
      utils$6.isStream(data) ||
      utils$6.isFile(data) ||
      utils$6.isBlob(data)
    ) {
      return data;
    }
    if (utils$6.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils$6.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils$6.isObject(data) || (headers && headers['Content-Type'] === 'application/json')) {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults$3.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils$6.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw enhanceError(e, this, 'E_JSON_PARSE');
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils$6.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults$3.headers[method] = {};
});

utils$6.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults$3.headers[method] = utils$6.merge(DEFAULT_CONTENT_TYPE);
});

var defaults_1 = defaults$3;

var utils$5 = utils$e;
var defaults$2 = defaults_1;

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
var transformData$1 = function transformData(data, headers, fns) {
  var context = this || defaults$2;
  /*eslint no-param-reassign:0*/
  utils$5.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};

var isCancel$1 = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};

var utils$4 = utils$e;
var transformData = transformData$1;
var isCancel = isCancel$1;
var defaults$1 = defaults_1;
var Cancel$2 = Cancel_1;

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new Cancel$2('canceled');
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
var dispatchRequest$1 = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils$4.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils$4.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults$1.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};

var utils$3 = utils$e;

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
var mergeConfig$2 = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils$3.isPlainObject(target) && utils$3.isPlainObject(source)) {
      return utils$3.merge(target, source);
    } else if (utils$3.isPlainObject(source)) {
      return utils$3.merge({}, source);
    } else if (utils$3.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils$3.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils$3.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils$3.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils$3.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};

var data = {
  "version": "0.25.0"
};

var VERSION = data.version;

var validators$1 = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators$1[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators$1.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new Error(formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')));
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new TypeError('options must be an object');
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new TypeError('option ' + opt + ' must be ' + result);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw Error('Unknown option ' + opt);
    }
  }
}

var validator$1 = {
  assertOptions: assertOptions,
  validators: validators$1
};

var utils$2 = utils$e;
var buildURL = buildURL$2;
var InterceptorManager = InterceptorManager_1;
var dispatchRequest = dispatchRequest$1;
var mergeConfig$1 = mergeConfig$2;
var validator = validator$1;

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios$1(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios$1.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  if (!config.url) {
    throw new Error('Provided config url is not valid');
  }

  config = mergeConfig$1(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios$1.prototype.getUri = function getUri(config) {
  if (!config.url) {
    throw new Error('Provided config url is not valid');
  }
  config = mergeConfig$1(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils$2.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils$2.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios$1.prototype[method] = function(url, data, config) {
    return this.request(mergeConfig$1(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

var Axios_1 = Axios$1;

var Cancel$1 = Cancel_1;

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken$1(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel$1(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken$1.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken$1.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken$1.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken$1.source = function source() {
  var cancel;
  var token = new CancelToken$1(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

var CancelToken_1 = CancelToken$1;

/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
var spread = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};

var utils$1 = utils$e;

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
var isAxiosError = function isAxiosError(payload) {
  return utils$1.isObject(payload) && (payload.isAxiosError === true);
};

var utils = utils$e;
var bind = bind$2;
var Axios = Axios_1;
var mergeConfig = mergeConfig$2;
var defaults = defaults_1;

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios$2 = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios$2.Axios = Axios;

// Expose Cancel & CancelToken
axios$2.Cancel = Cancel_1;
axios$2.CancelToken = CancelToken_1;
axios$2.isCancel = isCancel$1;
axios$2.VERSION = data.version;

// Expose all/spread
axios$2.all = function all(promises) {
  return Promise.all(promises);
};
axios$2.spread = spread;

// Expose isAxiosError
axios$2.isAxiosError = isAxiosError;

axios$3.exports = axios$2;

// Allow use of default import syntax in TypeScript
axios$3.exports.default = axios$2;

var axios$1 = axios$3.exports;

function ownKeys$7(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$7(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$7(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$7(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var CancelToken = axios$1.CancelToken;
var script$G = {
  props: {
    file: {
      default: {}
    },
    requests: {
      type: Object,
      default: function _default() {
        return {
          upload: null,
          cancel: null
        };
      }
    },
    isDummy: {
      type: Boolean,
      default: false
    },
    summary: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      valueLoading: 0,
      cancelTokenSource: CancelToken.source(),
      dataFileRequest: {},
      states: {
        active: 'active',
        canceled: 'error',
        completed: 'success',
        finished: 'success',
        error: 'error',
        failure: 'error',
        incomplete: 'error',
        loading: 'active',
        paused: 'paused',
        success: 'success'
      }
    };
  },
  computed: {
    getState: function getState() {
      var _this$file, _this$file2;
      return (_this$file = this.file) !== null && _this$file !== void 0 && _this$file.status && Object.keys(this.states).includes((_this$file2 = this.file) === null || _this$file2 === void 0 ? void 0 : _this$file2.status) ? this.states[this.file.status] : 'active';
    },
    isCanceled: function isCanceled() {
      return this.file.status === 'canceled';
    },
    isError: function isError() {
      return this.file.status === 'error';
    },
    isSuccess: function isSuccess() {
      return this.file.status === 'finished';
    },
    isSummary: function isSummary() {
      return this.summary;
    },
    isFile: function isFile() {
      var _this$file3;
      return !((_this$file3 = this.file) !== null && _this$file3 !== void 0 && _this$file3.isLoaded);
    },
    getProgress: function getProgress() {
      return this.getState === 'active' ? 'number' : 'text';
    }
  },
  watch: {
    'file.status': {
      handler: function handler(value) {
        if (value === 'loading' && !this.isDummy) {
          this.uploadFile();
        }
      }
    }
  },
  methods: {
    getFileInfo: function getFileInfo(type, file) {
      var _file$file, _file$file2;
      var fileInfo;
      var auxType = type === 'helpertext' ? 'progressHelperText' : type;
      switch (type) {
        case 'value':
          fileInfo = file === null || file === void 0 ? void 0 : file[auxType];
          break;
        case 'size':
        case 'name':
          fileInfo = file !== null && file !== void 0 && (_file$file = file.file) !== null && _file$file !== void 0 && _file$file[auxType] && type === 'size' ? returnFileSize(file === null || file === void 0 ? void 0 : (_file$file2 = file.file) === null || _file$file2 === void 0 ? void 0 : _file$file2[auxType]) : file.file[auxType];
          break;
        case 'sizeInfo':
        case 'helpertext':
          fileInfo = this.$aqT(file === null || file === void 0 ? void 0 : file[auxType]).length > 0 ? this.$aqT(file[auxType]) : '';
          break;
        case 'rows':
        case 'records':
          fileInfo = file !== null && file !== void 0 && file[auxType] ? file[auxType] : '';
          break;
      }
      return auxType === 'value' ? fileInfo : "".concat(fileInfo);
    },
    setValueLoading: function setValueLoading(_ref) {
      var value = _ref.value;
      this.file.value = value;
      this.valueLoading = value;
      if (value === 100) {
        this.file.status = 'finished';
        this.$emit('finish', this.file);
      }
    },
    cancel: function cancel() {
      this.cancelFileRequest();
      if (this.requests.cancel) {
        this.requests.cancel().then();
      }
      this.$emit('canceled', this.file);
      this.file.status = 'canceled';
    },
    getExtension: function getExtension(fileName) {
      var indexPoint = fileName.lastIndexOf('.');
      var extension = '';
      var pointExtension = '';
      var name = fileName;
      if (indexPoint !== -1) {
        extension = fileName.substring(indexPoint + 1);
        pointExtension = ".".concat(extension);
        name = fileName.substring(0, indexPoint);
      }
      return {
        extension: extension,
        name: name,
        pointExtension: pointExtension,
        fileName: fileName
      };
    },
    getFullName: function getFullName() {
      var fileNameStructure = this.getExtension(this.file.file.name);
      return "".concat(fileNameStructure.name).concat(fileNameStructure.pointExtension.toLowerCase());
    },
    onUploadProgress: function onUploadProgress(progressEvent) {
      var loaded = progressEvent.loaded,
        total = progressEvent.total;
      var percent = Math.floor(loaded * 100 / total);
      if (percent < 100) {
        this.setValueLoading({
          value: percent,
          state: 'uploading'
        });
      } else {
        this.setValueLoading({
          value: percent,
          state: 'loading'
        });
      }
    },
    cancelFileRequest: function cancelFileRequest() {
      this.cancelTokenSource.cancel('CANCELLED');
      this.cancelTokenSource = CancelToken.source();
    },
    deleteFile: function deleteFile() {
      this.$emit('deleted', _objectSpread$7(_objectSpread$7({}, this.file), this.dataFileRequest));
    },
    restartLoad: function restartLoad() {
      this.file.status = 'loading';
      this.file.value = 0;
      this.$emit('restart', this.file);
    },
    catchFunction: function catchFunction() {
      this.file.status = 'error';
      this.$emit('error', this.file);
    },
    uploadFile: function uploadFile() {
      var _this = this;
      if (!this.isDummy && this.file.value === 0) {
        this.requests.upload({
          name: this.getFullName(),
          type: this.file.file.type,
          file: this.file.file,
          callback: this.setValueLoading,
          // TODO: Eliminar propiedad al actualizar drive
          onUploadProgress: this.onUploadProgress,
          cancelToken: this.cancelTokenSource.token,
          catchFunction: this.catchFunction,
          aditionalData: this.setAditionalData
        }).then(function (data) {
          if (data) {
            _this.dataFileRequest = data;
          }
        });
        this.$emit('clearInput');
      }
    },
    setAditionalData: function setAditionalData(_ref2) {
      var rows = _ref2.rows,
        records = _ref2.records,
        sizeInfo = _ref2.sizeInfo,
        progressHelperText = _ref2.progressHelperText;
      this.file.rows = rows && typeof rows === 'string' && (rows === null || rows === void 0 ? void 0 : rows.length) > 0 ? rows : '';
      this.file.records = records && typeof records === 'string' && (records === null || records === void 0 ? void 0 : records.length) > 0 ? records : '';
      this.file.sizeInfo = sizeInfo && typeof sizeInfo === 'string' && (sizeInfo === null || sizeInfo === void 0 ? void 0 : sizeInfo.length) > 0 ? sizeInfo : '';
      this.file.progressHelperText = progressHelperText && typeof progressHelperText === 'string' && (progressHelperText === null || progressHelperText === void 0 ? void 0 : progressHelperText.length) > 0 ? progressHelperText : '';
    }
  },
  mounted: function mounted() {
    this.uploadFile();
  }
};

/* script */
var __vue_script__$G = script$G;

/* template */
var __vue_render__$G = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-file-uploader-progress-bar"
  }, [_c('aq-progress-bar', {
    staticClass: "aq-file-uploader-element__item-bar",
    attrs: {
      "value": _vm.getFileInfo('value', _vm.file),
      "max": 100,
      "progress": _vm.getProgress,
      "state": _vm.getState,
      "isFile": "",
      "size": _vm.getFileInfo('size', _vm.file),
      "sizeInfo": _vm.getFileInfo('sizeInfo', _vm.file),
      "name": _vm.getFileInfo('name', _vm.file),
      "rows": _vm.getFileInfo('rows', _vm.file),
      "records": _vm.getFileInfo('records', _vm.file),
      "helperText": _vm.getFileInfo('helpertext', _vm.file)
    }
  }), _vm._v(" "), !_vm.isSummary ? [(_vm.isError || _vm.isCanceled) && !_vm.isSuccess && _vm.isFile ? _c('aq-button', {
    attrs: {
      "plain": "",
      "size": "small",
      "icon": "aq-icon-arrow-refresh-clockwise"
    },
    on: {
      "click": _vm.restartLoad
    }
  }) : _vm._e(), _vm._v(" "), !_vm.isSuccess && !_vm.isCanceled && _vm.isFile ? _c('aq-button', {
    attrs: {
      "plain": "",
      "size": "small",
      "icon": "aq-icon-close"
    },
    on: {
      "click": _vm.cancel
    }
  }) : _vm._e(), _vm._v(" "), _vm.isSuccess || _vm.isCanceled || !_vm.isFile ? _c('aq-button', {
    attrs: {
      "plain": "",
      "size": "small",
      "icon": "aq-icon-trash"
    },
    on: {
      "click": _vm.deleteFile
    }
  }) : _vm._e()] : _vm._e()], 2);
};
var __vue_staticRenderFns__$G = [];

/* style */
var __vue_inject_styles__$G = undefined;
/* scoped */
var __vue_scope_id__$G = undefined;
/* module identifier */
var __vue_module_identifier__$G = undefined;
/* functional template */
var __vue_is_functional_template__$G = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$G = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$G,
  staticRenderFns: __vue_staticRenderFns__$G
}, __vue_inject_styles__$G, __vue_script__$G, __vue_scope_id__$G, __vue_is_functional_template__$G, __vue_module_identifier__$G, false, undefined, undefined, undefined);
var ProgressBar = __vue_component__$G;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$F = {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    var _this = this;
    return {
      visible: false,
      dialogCancelTitle: function dialogCancelTitle() {
        return _this.$t('aqua.cancelLoad');
      }
    };
  },
  watch: {
    value: function value() {
      this.visible = this.value;
    },
    visible: function visible(newVal) {
      this.closeModal(newVal);
    }
  },
  methods: {
    cancel: function cancel() {
      this.$emit('cancel');
    },
    closeModal: function closeModal() {
      var val = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      this.$emit('input', val);
    }
  }
};

/* script */
var __vue_script__$F = script$F;

/* template */
var __vue_render__$F = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('aq-dialog', {
    attrs: {
      "title": _vm.dialogCancelTitle
    },
    scopedSlots: _vm._u([{
      key: "footer-right",
      fn: function fn() {
        return [_c('aq-button', {
          staticClass: "mr-2",
          attrs: {
            "outline": ""
          },
          on: {
            "click": function click($event) {
              return _vm.closeModal(false);
            }
          }
        }, [_vm._v("\n      " + _vm._s(_vm.$t('aqua.cancel')) + "\n    ")]), _vm._v(" "), _c('aq-button', {
          attrs: {
            "color": "red"
          },
          on: {
            "click": _vm.cancel
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('aqua.cancelLoadConfirmation')))])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.visible,
      callback: function callback($$v) {
        _vm.visible = $$v;
      },
      expression: "visible"
    }
  }, [_vm._v("\n  " + _vm._s(_vm.$t('aqua.cancelLoadInfo')) + " "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm.$t('aqua.cancelLoadQuestion')))])]);
};
var __vue_staticRenderFns__$F = [];

/* style */
var __vue_inject_styles__$F = undefined;
/* scoped */
var __vue_scope_id__$F = undefined;
/* module identifier */
var __vue_module_identifier__$F = undefined;
/* functional template */
var __vue_is_functional_template__$F = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$F = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$F,
  staticRenderFns: __vue_staticRenderFns__$F
}, __vue_inject_styles__$F, __vue_script__$F, __vue_scope_id__$F, __vue_is_functional_template__$F, __vue_module_identifier__$F, false, undefined, undefined, undefined);
var Cancel = __vue_component__$F;

//
var script$E = {
  props: {
    files: {
      default: function _default() {
        return [];
      }
    },
    requests: {
      type: Object,
      default: function _default() {
        return {
          upload: null,
          cancel: null
        };
      }
    },
    closeAfterUpload: {
      type: Number,
      default: -1
    },
    isDummy: {
      type: Boolean,
      default: false
    },
    summary: {
      type: Boolean,
      default: false
    },
    progressHelperText: {
      type: [String, Function],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  components: {
    ProgressBar: ProgressBar,
    Cancel: Cancel
  },
  data: function data() {
    return {
      cancelModalVisible: false,
      visible: false
    };
  },
  watch: {
    files: function files(newVal) {
      if (newVal) {
        this.visible = true;
      }
      if ((newVal === null || newVal === void 0 ? void 0 : newVal.length) === 0) {
        this.visible = false;
      }
    },
    isLoading: function isLoading(newVal) {
      if (!newVal) {
        this.cancelModalVisible = false;
      }
    },
    isFinish: function isFinish(newVal, oldVal) {
      var _this = this;
      if (this.isDummy && newVal && newVal !== oldVal && this.visible && this.closeAfterUpload !== -1) {
        setTimeout(function () {
          if (_this.visible) {
            _this.visible = false;
          }
        }, this.closeAfterUpload);
      }
    }
  },
  computed: {
    stateText: function stateText() {
      var _this$filesFinished, _this$filesFinished2, _this$filesFinished3, _this$filesFinished4, _this$filesFinished5;
      var text = '';
      var error = '';
      if (this.countError > 0) {
        error = "(".concat(this.$t('aqua.errors'), ": ").concat(this.countError, ")");
      }
      if (this.isLoading) {
        text = "".concat(this.$t('aqua.uploading'), " ").concat(this.countLoading, " ").concat(this.countLoading > 1 ? this.$t('aqua.elements') : this.$t('aqua.element'), " ").concat(error);
      }
      if (this.isFinish) {
        switch (true) {
          case ((_this$filesFinished = this.filesFinished) === null || _this$filesFinished === void 0 ? void 0 : _this$filesFinished.length) > 1:
            text = "".concat(this.$t('aqua.loaded'), " ").concat((_this$filesFinished2 = this.filesFinished) === null || _this$filesFinished2 === void 0 ? void 0 : _this$filesFinished2.length, " ").concat(this.$t('aqua.elements'), " ").concat(error);
            break;
          case ((_this$filesFinished3 = this.filesFinished) === null || _this$filesFinished3 === void 0 ? void 0 : _this$filesFinished3.length) === 1:
            text = "".concat(this.$t('aqua.load'), " ").concat((_this$filesFinished4 = this.filesFinished) === null || _this$filesFinished4 === void 0 ? void 0 : _this$filesFinished4.length, " ").concat(this.$t('aqua.element'), " ").concat(error);
            break;
          case ((_this$filesFinished5 = this.filesFinished) === null || _this$filesFinished5 === void 0 ? void 0 : _this$filesFinished5.length) === 0:
            text = "".concat(this.$t('aqua.noLoad'), " ").concat(error);
            break;
        }
      }
      return text;
    },
    filesFinished: function filesFinished() {
      return this.files.filter(function (file) {
        return file.status === 'finished';
      });
    },
    countLoading: function countLoading() {
      var _this$files, _this$filesFinished6;
      return ((_this$files = this.files) === null || _this$files === void 0 ? void 0 : _this$files.length) - (((_this$filesFinished6 = this.filesFinished) === null || _this$filesFinished6 === void 0 ? void 0 : _this$filesFinished6.length) + this.countError);
    },
    countError: function countError() {
      var _this$files$filter;
      return (_this$files$filter = this.files.filter(function (file) {
        return file.status === 'error' || file.status === 'canceled';
      })) === null || _this$files$filter === void 0 ? void 0 : _this$files$filter.length;
    },
    isLoading: function isLoading() {
      return this.countLoading > 0;
    },
    isFinish: function isFinish() {
      var _this$files2;
      return ((_this$files2 = this.files) === null || _this$files2 === void 0 ? void 0 : _this$files2.length) > 0 && this.countLoading === 0;
    },
    isVisible: function isVisible() {
      return this.visible;
    },
    getCloseText: function getCloseText() {
      return this.isLoading && !this.isDummy ? "".concat(this.$t('aqua.cancel')) : "".concat(this.$t('aqua.close'));
    },
    isHelperTextVisible: function isHelperTextVisible() {
      var _this$progressHelperT;
      return ((_this$progressHelperT = this.progressHelperText) === null || _this$progressHelperT === void 0 ? void 0 : _this$progressHelperT.length) > 0;
    }
  },
  methods: {
    close: function close() {
      if (this.isLoading && !this.isDummy) {
        this.cancelModalVisible = true;
      } else {
        this.visible = false;
      }
    },
    finish: function finish(file) {
      this.$emit('finish', file);
      if (this.countLoading === 0) {
        this.$emit('finishAll');
      }
    },
    error: function error(file) {
      this.$emit('error', file);
    },
    cancel: function cancel() {
      this.requests.cancelFileRequest();
    },
    mountUploader: function mountUploader() {
      if (this.isDummy) {
        createFixedContainer();
        appendEl({
          parent: document.getElementById(DOM_AQUA_POPOVERS_RIGHT_BOTTOM),
          children: this.$el
        });
      }
    },
    unMountUploader: function unMountUploader() {
      if (this.isDummy) {
        removeEl({
          children: this.$el
        });
      }
    },
    restartLoad: function restartLoad(event) {
      this.$emit('restart', event);
    },
    canceledLoad: function canceledLoad(event) {
      this.$emit('canceled', event);
    },
    deleteFile: function deleteFile(event, index) {
      var _this$files3;
      this.files.splice(index, 1);
      if (((_this$files3 = this.files) === null || _this$files3 === void 0 ? void 0 : _this$files3.length) === 0) {
        this.close();
      }
      this.$emit('deleted', event);
    },
    clear: function clear() {
      this.$emit('clearInput');
    }
  },
  mounted: function mounted() {
    this.mountUploader();
  },
  beforeDestroy: function beforeDestroy() {
    this.unMountUploader();
  }
};

/* script */
var __vue_script__$E = script$E;

/* template */
var __vue_render__$E = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.visible ? _c('div', {
    class: ['aq-file-uploader-element', {
      'aq-file-uploader-element--finished': _vm.isFinish,
      'aq-file-uploader-element--floating': _vm.isDummy,
      'aq-file-uploader-element--loading': _vm.isDummy && _vm.isLoading
    }]
  }, [_c('div', {
    staticClass: "aq-file-uploader-element__header"
  }, [_c('span', {
    staticClass: "aq-file-uploader-element__loader"
  }, [_vm.isFinish ? [_c('em', {
    staticClass: "aq-icon-check-circle"
  })] : _vm._e(), _vm._v(" "), _vm.isLoading ? [_c('aq-spinner', {
    attrs: {
      "size": "24"
    }
  })] : _vm._e()], 2), _vm._v(" "), _c('span', {
    staticClass: "aq-file-uploader-element__status-text"
  }, [_vm._v(_vm._s(_vm.stateText))]), _vm._v(" "), _vm.isDummy ? _c('aq-button', {
    attrs: {
      "plain": ""
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v(_vm._s(_vm.getCloseText))]) : _vm._e(), _vm._v(" "), _c('Cancel', {
    on: {
      "cancel": _vm.cancel
    },
    model: {
      value: _vm.cancelModalVisible,
      callback: function callback($$v) {
        _vm.cancelModalVisible = $$v;
      },
      expression: "cancelModalVisible"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "aq-file-uploader-element__body aq-scroll-bar"
  }, _vm._l(_vm.files, function (file, index) {
    return _c('div', {
      key: index
    }, [_c('aq-divider', {
      staticClass: "aq-file-uploader-element__divider"
    }), _vm._v(" "), _c('ProgressBar', {
      ref: "progress",
      refInFor: true,
      staticClass: "aq-file-uploader-element__item",
      attrs: {
        "file": file,
        "requests": _vm.requests,
        "isDummy": _vm.isDummy,
        "summary": _vm.summary,
        "progressHelperText": _vm.progressHelperText
      },
      on: {
        "finish": _vm.finish,
        "error": _vm.error,
        "restart": _vm.restartLoad,
        "canceled": _vm.canceledLoad,
        "deleted": function deleted($event) {
          return _vm.deleteFile($event, index);
        },
        "clearInput": _vm.clear
      }
    })], 1);
  }), 0)]) : _vm._e();
};
var __vue_staticRenderFns__$E = [];

/* style */
var __vue_inject_styles__$E = undefined;
/* scoped */
var __vue_scope_id__$E = undefined;
/* module identifier */
var __vue_module_identifier__$E = undefined;
/* functional template */
var __vue_is_functional_template__$E = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$E = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$E,
  staticRenderFns: __vue_staticRenderFns__$E
}, __vue_inject_styles__$E, __vue_script__$E, __vue_scope_id__$E, __vue_is_functional_template__$E, __vue_module_identifier__$E, false, undefined, undefined, undefined);
var Uploader = __vue_component__$E;

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$6(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var script$D = {
  components: {
    Uploader: Uploader
  },
  mixins: [LabelMixin, idMixin, helperTextMixin],
  props: {
    isFileSelector: {
      type: Boolean,
      default: true
    },
    error: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isFolder: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: true
    },
    accept: {
      type: String,
      default: '',
      validator: function validator(x) {
        if (x.length > 0) {
          var validTypes = new RegExp(/^(\.|audio\/|video\/|image\/)/);
          var types = x.split(',');
          return types.every(function (item) {
            return item.trim().match(validTypes) !== null;
          });
        }
        return true;
      }
    },
    uploaderFloating: {
      type: Boolean,
      default: true
    },
    closeAfterUpload: {
      type: Number,
      default: -1
    },
    requests: {
      type: Object,
      default: function _default() {
        return {
          upload: function upload() {
            return Promise.resolve(console.log('requests.upload function'));
          },
          cancel: function cancel() {
            return Promise.resolve(console.log('requests.cancel function'));
          },
          cancelTokenSource: {
            cancel: function cancel() {
              console.log('cancelTokenSource');
            }
          },
          cancelFileRequest: function cancelFileRequest() {
            console.log('cancelFileRequest');
          }
        };
      }
    },
    maxSize: {
      type: Number,
      default: -1
    },
    maxUpload: {
      type: Number,
      default: -1
    },
    value: {
      type: [Array, Object],
      default: function _default() {
        return this.multiple ? [] : {};
      }
    },
    summary: {
      type: Boolean,
      default: false
    },
    altText: {
      type: [String, Function],
      default: ''
    },
    progressHelperText: {
      type: [String, Function],
      default: ''
    },
    loadFileText: {
      type: [String, Function],
      default: ''
    },
    allowSelectAll: {
      type: Boolean,
      default: false
    },
    blockDrop: {
      type: Boolean,
      default: false
    },
    infoBanner: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    var _this = this;
    return {
      files: [],
      hasFocus: false,
      state: 'default',
      // active, error, loading, failure, incomplete, paused, completed
      isDragOver: false,
      customEvent: {
        isX: true,
        handler: function handler(callback) {
          if (this.isX) {
            callback();
          }
          this.isX = true;
        },
        preventDefault: function preventDefault() {
          this.isX = false;
        }
      },
      openFloatingUploader: true,
      totalSize: 0,
      selectedFiles: [],
      exceedMaxUpload: false,
      exceedMaxUploadText: function exceedMaxUploadText() {
        return _this.$t('aqua.fileUploader.exceedMaxUpload');
      },
      exceedMaxWeight: false,
      exceedMaxWeightText: function exceedMaxWeightText() {
        return _this.$t('aqua.fileUploader.exceedMaxWeight');
      },
      temporalFiles: [],
      checkFiles: {
        files: []
      },
      checkboxValue: [],
      canContinueLoad: false,
      showTypeModal: false,
      typeModalTitle: function typeModalTitle() {
        return _this.$t('aqua.fileUploader.notAllowedFileTitle');
      },
      cantLoadFiles: true,
      openedByClick: null,
      showClassActive: false,
      selectAll: true,
      filesToLoad: [],
      temporalChoosenFiles: []
    };
  },
  watch: {
    value: function value(newVal) {
      this.setFiles(newVal);
    }
  },
  computed: {
    allProps: function allProps() {
      return {
        disabled: this.disabled,
        isFolder: this.isFolder,
        multiple: this.multiple,
        accept: this.accept,
        height: this.height,
        closeAfterUpload: this.closeAfterUpload
      };
    },
    isDefault: function isDefault() {
      return this.compareState('default');
    },
    getStyle: function getStyle() {
      var _this$height;
      var style = {};
      if (((_this$height = this.height) === null || _this$height === void 0 ? void 0 : _this$height.length) > 0) {
        style.height = this.height;
      }
      return style;
    },
    hasFiles: function hasFiles() {
      var _this$files;
      return ((_this$files = this.files) === null || _this$files === void 0 ? void 0 : _this$files.length) > 0;
    },
    getSize: function getSize() {
      return returnFileSize(this.size);
    },
    size: function size() {
      return this.files.reduce(function (acc, file) {
        return acc + file.file.size;
      }, 0);
    },
    showAccept: function showAccept() {
      var _this$accept, _this$$aqT;
      return ((_this$accept = this.accept) === null || _this$accept === void 0 ? void 0 : _this$accept.length) && ((_this$$aqT = this.$aqT(this.altText)) === null || _this$$aqT === void 0 ? void 0 : _this$$aqT.length) === 0;
    },
    getFilesLength: function getFilesLength() {
      var _this$files2;
      return (_this$files2 = this.files) === null || _this$files2 === void 0 ? void 0 : _this$files2.length;
    },
    getLoadFileText: function getLoadFileText() {
      var _this$$aqT2;
      return ((_this$$aqT2 = this.$aqT(this.loadFileText)) === null || _this$$aqT2 === void 0 ? void 0 : _this$$aqT2.length) > 0;
    },
    getMaxSize: function getMaxSize() {
      return returnFileSize(this.maxSize);
    },
    isMaxSize: function isMaxSize() {
      return this.maxSize > -1;
    },
    isMaxUpload: function isMaxUpload() {
      return this.maxUpload > -1;
    },
    selectedFilesLength: function selectedFilesLength() {
      var _this$selectedFiles;
      return (_this$selectedFiles = this.selectedFiles) === null || _this$selectedFiles === void 0 ? void 0 : _this$selectedFiles.length;
    },
    infoSizeAllowed: function infoSizeAllowed() {
      var text = this.isMaxSize ? "".concat(this.$t('aqua.fileUploader.totalWeight'), " ").concat(this.getSize, " / ").concat(this.$t('aqua.fileUploader.maxWeight'), " ").concat(this.getMaxSize) : "".concat(this.$t('aqua.fileUploader.totalWeight'), " ").concat(this.getSize);
      return text;
    },
    infoFilesAllowed: function infoFilesAllowed() {
      var textSingular = this.isMaxUpload ? "".concat(this.$t('aqua.fileUploader.maxFileUpload'), " ").concat(this.getFilesLength, " ").concat(this.$t('aqua.file'), " / ").concat(this.$t('aqua.fileUploader.totalFilesUpload'), " ").concat(this.maxUpload, " ").concat(this.$t('aqua.file')) : "".concat(this.getFilesLength, " ").concat(this.$t('aqua.file'));
      var textPlural = this.isMaxUpload ? "".concat(this.$t('aqua.fileUploader.maxFileUpload'), " ").concat(this.getFilesLength, " ").concat(this.$t('aqua.files'), " / ").concat(this.$t('aqua.fileUploader.totalFilesUpload'), " ").concat(this.maxUpload, " ").concat(this.$t('aqua.files')) : "".concat(this.getFilesLength, " ").concat(this.$t('aqua.files'));
      return this.texgetFilesLength > 1 ? textPlural : textSingular;
    },
    getExceedMaxWeightText: function getExceedMaxWeightText() {
      return "".concat(this.$t('aqua.fileUploader.exceedMaxWeightTextPart1'), " ").concat(this.getFilesLength > 1 ? this.$t('aqua.files') : this.$t('aqua.file'), " ").concat(this.$t('aqua.fileUploader.exceedMaxWeightTextPart2'), " ").concat(this.getMaxSize);
    },
    getDialogSizeExceedMaxUpload: function getDialogSizeExceedMaxUpload() {
      return this.cantLoadFiles ? 'small' : 'medium';
    },
    getExceedMaxUploadText: function getExceedMaxUploadText() {
      return "".concat(this.$t('aqua.fileUploader.exceedMaxUploadTextPart1'), " ").concat(this.maxUpload, " ").concat(this.getFilesLength >= 1 ? this.$t('aqua.files') : this.$t('aqua.file'), " ").concat(this.$t('aqua.fileUploader.exceedMaxUploadTextPart2'));
    },
    getDialogStateExceedMaxUpload: function getDialogStateExceedMaxUpload() {
      return this.cantLoadFiles ? 'danger' : 'info';
    },
    getBannerTitle: function getBannerTitle() {
      var _this$infoBanner;
      return (_this$infoBanner = this.infoBanner) !== null && _this$infoBanner !== void 0 && _this$infoBanner.title ? this.$aqT(this.infoBanner.title) : '';
    },
    getCloseBanner: function getCloseBanner() {
      var _this$infoBanner2;
      return (_this$infoBanner2 = this.infoBanner) !== null && _this$infoBanner2 !== void 0 && _this$infoBanner2.close ? this.infoBanner.close : false;
    },
    getBannerMessage: function getBannerMessage() {
      var _this$infoBanner3;
      return (_this$infoBanner3 = this.infoBanner) !== null && _this$infoBanner3 !== void 0 && _this$infoBanner3.message ? this.infoBanner.message : '';
    },
    getBannerState: function getBannerState() {
      var _this$infoBanner4;
      return (_this$infoBanner4 = this.infoBanner) !== null && _this$infoBanner4 !== void 0 && _this$infoBanner4.state ? this.infoBanner.state : 'info';
    },
    showBannerNotification: function showBannerNotification() {
      var _this$infoBanner5;
      return (_this$infoBanner5 = this.infoBanner) === null || _this$infoBanner5 === void 0 ? void 0 : _this$infoBanner5.visible;
    }
  },
  methods: {
    compareState: function compareState(state) {
      return this.state === state;
    },
    handleFileUpload: function handleFileUpload() {
      var _this$$refs;
      if (Object.values((_this$$refs = this.$refs) === null || _this$$refs === void 0 ? void 0 : _this$$refs.file.files).every(this.validateFileType)) {
        var _this$$refs2, _this$$refs2$file;
        this.loadFiles((_this$$refs2 = this.$refs) === null || _this$$refs2 === void 0 ? void 0 : (_this$$refs2$file = _this$$refs2.file) === null || _this$$refs2$file === void 0 ? void 0 : _this$$refs2$file.files, false);
      }
    },
    onDragOver: function onDragOver(event) {
      if (!this.disabled) {
        this.isDragOver = true;
      }
      event.preventDefault();
      event.stopPropagation();
    },
    onDrop: function onDrop(event) {
      var _this2 = this;
      event.preventDefault();
      if (!this.blockDrop) {
        this.openedByClick = false;
        this.$emit('selectFile', {
          from: 'drop',
          event: this.customEvent
        });
        this.customEvent.handler(function () {
          if (_this2.disabled || _this2.summary) {
            return;
          }
          _this2.isDragOver = false;
          var items = event.dataTransfer.items;
          _this2.selectedFiles = [].concat(_toConsumableArray$1(_this2.selectedFiles), _toConsumableArray$1(items));
          if (items && Object.values(items).every(function (item) {
            return _this2.validateFileType(item.getAsFile());
          })) {
            var listItems = [];
            if (!_this2.multiple) {
              listItems.push(items[0].getAsFile());
            } else {
              for (var index = 0; index < (items === null || items === void 0 ? void 0 : items.length); index += 1) {
                var element = items[index];
                listItems.push(element.getAsFile());
              }
            }
            _this2.loadFiles(listItems, false);
            return;
          }
          // TODO: invalidFile() !accept
          _this2.removeDragData(event);
        });
      } else {
        this.isDragOver = false;
      }
    },
    removeDragData: function removeDragData(event) {
      if (event.dataTransfer.items) {
        event.dataTransfer.items.clear();
      } else {
        event.dataTransfer.clearData();
      }
    },
    validateFileType: function validateFileType(file) {
      if (file) {
        var fileTypes = this.accept.split(',');
        if ((fileTypes === null || fileTypes === void 0 ? void 0 : fileTypes.length) === 1 && fileTypes[0] === '') {
          return true;
        }
        for (var i = 0; i < (fileTypes === null || fileTypes === void 0 ? void 0 : fileTypes.length); i += 1) {
          var type = fileTypes[i];
          if (type.startsWith('.')) {
            var fileNameSplitted = file.name.split('.');
            var fileExtension = ".".concat(fileNameSplitted[(fileNameSplitted === null || fileNameSplitted === void 0 ? void 0 : fileNameSplitted.length) - 1]);
            if (fileExtension.toLowerCase() === type.toLowerCase()) {
              return true;
            }
          } else if (type.includes('/')) {
            var fileTypeSplitted = file.type.split('/');
            var typeSplitted = type.split('/');
            if (typeSplitted[(typeSplitted === null || typeSplitted === void 0 ? void 0 : typeSplitted.length) - 1] === '*' && fileTypeSplitted[0].trim() === typeSplitted[0].trim() || file.type.trim().toLowerCase() === type.trim().toLowerCase()) {
              return true;
            }
          }
        }
      }
      this.showTypeModal = true;
      return false;
    },
    validateMaxUpload: function validateMaxUpload(files) {
      var _this$files3, _this$files4;
      var confirmation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var isValid = true;
      var condition = !confirmation ? this.maxUpload < ((_this$files3 = this.files) === null || _this$files3 === void 0 ? void 0 : _this$files3.length) + (files === null || files === void 0 ? void 0 : files.length) : this.maxUpload < (files === null || files === void 0 ? void 0 : files.length);
      if (this.maxUpload !== -1 && condition) {
        isValid = false;
      }
      this.selectedFiles = [].concat(_toConsumableArray$1(this.selectedFiles), [{
        total: ((_this$files4 = this.files) === null || _this$files4 === void 0 ? void 0 : _this$files4.length) + (files === null || files === void 0 ? void 0 : files.length),
        files: [].concat(_toConsumableArray$1(this.files), _toConsumableArray$1(files))
      }]);
      return isValid;
    },
    validateMaxSize: function validateMaxSize(files) {
      var confirmation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      if (this.maxSize !== -1) {
        var size = 0;
        var totalFiles = !confirmation ? [].concat(_toConsumableArray$1(this.files), _toConsumableArray$1(files)) : files;
        var totalFilesSize = totalFiles.length;
        for (var i = 0; i < totalFilesSize; i += 1) {
          var element = totalFiles[i].file;
          size += element.size;
        }
        this.totalSize = size;
        return size <= this.maxSize;
      }
      return true;
    },
    loadFiles: function loadFiles(files) {
      var confirmation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var choosenFiles = this.temporalChoosenFiles.sort(function (a, b) {
        return a.stickIndex - b.stickIndex;
      });
      var orderedFiles = [];
      choosenFiles.forEach(function (file, index) {
        orderedFiles[index] = file.auxFile;
      });
      var auxLocalFiles = confirmation ? [].concat(_toConsumableArray$1(this.files), orderedFiles) : files;
      if (this.validateMaxUpload(auxLocalFiles, confirmation)) {
        var parsedFiles = [];
        var auxLocalFilesSize = auxLocalFiles.length;
        for (var i = 0; i < auxLocalFilesSize; i += 1) {
          var _auxLocalFiles$i, _auxLocalFiles$i2, _auxLocalFiles$i3, _auxLocalFiles$i4, _auxLocalFiles$i5, _auxLocalFiles$i6;
          this.openFloatingUploader = !((_auxLocalFiles$i = auxLocalFiles[i]) !== null && _auxLocalFiles$i !== void 0 && _auxLocalFiles$i.isLoaded);
          var newFile = _objectSpread$6(_objectSpread$6({}, auxLocalFiles[i]), {}, {
            status: (_auxLocalFiles$i2 = auxLocalFiles[i]) !== null && _auxLocalFiles$i2 !== void 0 && _auxLocalFiles$i2.isConfirmed || (_auxLocalFiles$i3 = auxLocalFiles[i]) !== null && _auxLocalFiles$i3 !== void 0 && _auxLocalFiles$i3.isLoaded ? 'finished' : 'loading',
            file: (_auxLocalFiles$i4 = auxLocalFiles[i]) !== null && _auxLocalFiles$i4 !== void 0 && _auxLocalFiles$i4.file ? auxLocalFiles[i].file : auxLocalFiles[i],
            value: (_auxLocalFiles$i5 = auxLocalFiles[i]) !== null && _auxLocalFiles$i5 !== void 0 && _auxLocalFiles$i5.isConfirmed && confirmation || (_auxLocalFiles$i6 = auxLocalFiles[i]) !== null && _auxLocalFiles$i6 !== void 0 && _auxLocalFiles$i6.isLoaded ? 100 : 0,
            auxId: Math.random().toString(36).substr(2, 16)
          });
          parsedFiles.splice(i, 0, newFile);
          this.filesToLoad.splice(i, 0, newFile);
        }
        if (this.validateMaxSize(parsedFiles, confirmation)) {
          var confirmedFiles = [];
          parsedFiles.forEach(function (file, index) {
            confirmedFiles[index] = _objectSpread$6({}, file);
            confirmedFiles[index].isConfirmed = true;
          });
          if (confirmation) {
            this.files = [].concat(confirmedFiles);
          } else {
            var _this$files5;
            (_this$files5 = this.files).push.apply(_this$files5, confirmedFiles);
          }
          this.exceedMaxUpload = false;
        } else {
          this.exceedMaxWeight = true;
          this.$emit('maxSize', returnFileSize(this.totalSize));
        }
        this.filesToLoad = [];
      } else {
        var _this$files6, _this$files7;
        this.temporalFiles = auxLocalFiles;
        var arraySize = this.maxUpload - ((_this$files6 = this.files) === null || _this$files6 === void 0 ? void 0 : _this$files6.length);
        if (arraySize <= this.maxUpload && arraySize > 0) {
          for (var _i = 0; _i < arraySize; _i += 1) {
            this.checkFiles.files[_i] = true;
            this.temporalChoosenFiles[_i] = {
              auxFile: auxLocalFiles[_i],
              stickIndex: _i
            };
          }
        }
        this.cantLoadFiles = ((_this$files7 = this.files) === null || _this$files7 === void 0 ? void 0 : _this$files7.length) >= this.maxUpload && this.filesToLoad.length <= this.maxUpload;
        this.canContinueLoad = this.files.length + arraySize <= this.maxUpload;
        this.exceedMaxUpload = true;
        this.$emit('maxUpload', auxLocalFiles);
      }
      this.showClassActive = false;
    },
    onClose: function onClose() {
      this.files = [];
    },
    openFile: function openFile() {
      var _this3 = this;
      this.$emit('selectFile', {
        from: 'openFile',
        event: this.customEvent
      });
      this.openedByClick = true;
      this.customEvent.handler(function () {
        _this3.$refs.file.click();
        setTimeout(function () {
          if (_this3.$refs.file.files) {
            _this3.showClassActive = false;
          }
        }, 1000);
      });
    },
    openFileExternal: function openFileExternal() {
      this.$refs.file.click();
    },
    onDeletedFile: function onDeletedFile(file) {
      var auxFiles = _toConsumableArray$1(this.files);
      var indexLoadedFile = auxFiles.findIndex(function (auxFile) {
        return file.auxId === auxFile.auxId;
      });
      if (indexLoadedFile !== -1) {
        this.filesToLoad.splice(indexLoadedFile, 1);
      }
      this.$emit('deleted', file);
      this.$emit('input', this.files);
    },
    onCanceledFile: function onCanceledFile(file) {
      var auxFiles = _toConsumableArray$1(this.files);
      var indexLoadedFile = auxFiles.findIndex(function (auxFile) {
        return file.auxId === auxFile.auxId;
      });
      if (indexLoadedFile !== -1) {
        this.filesToLoad.splice(indexLoadedFile, 1);
      }
      this.$emit('canceled', file);
      this.$emit('input', this.files);
    },
    onRestartedLoad: function onRestartedLoad(file) {
      this.$emit('restart', file);
    },
    finishedLoad: function finishedLoad(file) {
      var auxFiles = _toConsumableArray$1(this.files);
      var indexLoadedFile = auxFiles.findIndex(function (auxFile) {
        return file.auxId === auxFile.auxId;
      });
      if (indexLoadedFile !== -1) {
        this.filesToLoad.splice(indexLoadedFile, 1);
      }
      this.$emit('finish', file);
      this.$emit('input', this.files);
    },
    finishedAllFiles: function finishedAllFiles() {
      this.$emit('finishAll');
      this.$emit('input', this.files);
    },
    setFiles: function setFiles() {
      var localFiles = [];
      if (!this.multiple) {
        localFiles = Object.keys(this.value).length > 0 ? this.value : [];
      }
      this.files = this.multiple ? this.value : localFiles;
    },
    clearInputData: function clearInputData() {
      this.$refs.file.value = '';
    },
    setValuesToEdit: function setValuesToEdit(files) {
      var _this4 = this;
      files.forEach(function (element) {
        _this4.openFloatingUploader = !(element !== null && element !== void 0 && element.isLoaded);
      });
    },
    closeDialogMaxUpload: function closeDialogMaxUpload() {
      this.checkFiles.files = [];
      this.filesToLoad = [];
      this.cantLoadFiles = true;
      this.exceedMaxUpload = false;
    },
    closeDialogMaxWeight: function closeDialogMaxWeight() {
      this.exceedMaxWeight = false;
    },
    isLast: function isLast(index) {
      var _this$temporalFiles;
      return ((_this$temporalFiles = this.temporalFiles) === null || _this$temporalFiles === void 0 ? void 0 : _this$temporalFiles.length) - 1 === index;
    },
    setTemporalFiles: function setTemporalFiles(file, index) {
      var _this$temporalChoosen, _this$files8;
      var selectAll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      if (!this.checkboxValue[index]) {
        var element = {
          auxFile: file,
          stickIndex: index
        };
        this.temporalChoosenFiles.push(element);
        if (selectAll) {
          this.checkFiles.files[index] = true;
          this.checkboxValue[index] = true;
        }
      } else if (!selectAll) {
        var findIndexFile = this.temporalChoosenFiles.findIndex(function (choosenFile) {
          return choosenFile.stickIndex === index;
        });
        this.temporalChoosenFiles.splice(findIndexFile, 1);
      }
      this.canContinueLoad = ((_this$temporalChoosen = this.temporalChoosenFiles) === null || _this$temporalChoosen === void 0 ? void 0 : _this$temporalChoosen.length) + ((_this$files8 = this.files) === null || _this$files8 === void 0 ? void 0 : _this$files8.length) <= this.maxUpload;
    },
    getFileSize: function getFileSize(file) {
      return returnFileSize(file);
    },
    closeDialogTypeFile: function closeDialogTypeFile() {
      this.selectedFiles = [];
      this.showTypeModal = false;
    },
    confirmMaxWeightDialog: function confirmMaxWeightDialog() {
      if (this.openedByClick && !this.exceedMaxUpload && !this.showTypeModal) {
        this.openFile();
      }
      this.exceedMaxWeight = false;
    },
    confirmTypeDialog: function confirmTypeDialog() {
      this.selectedFiles = [];
      if (this.openedByClick && !this.exceedMaxUpload && !this.exceedMaxWeight) {
        this.openFile();
      }
      this.showTypeModal = false;
    },
    selectAllFiles: function selectAllFiles(isSelectAll) {
      var _this5 = this;
      // TODO: finalizar funcionalidad de seleccionar todo y deseleccionar todo
      this.selectAll = isSelectAll;
      this.temporalFiles.forEach(function (file, index) {
        _this5.setTemporalFiles(file, index, _this5.selectAll);
      });
    },
    setActiveClass: function setActiveClass(set) {
      this.showClassActive = this.files.length < 1 && set;
    }
  },
  mounted: function mounted() {
    var _this$value;
    if (((_this$value = this.value) === null || _this$value === void 0 ? void 0 : _this$value.length) > 0) {
      this.setValuesToEdit(this.value);
    }
    this.setFiles();
  }
};

/* script */
var __vue_script__$D = script$D;

/* template */
var __vue_render__$D = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-file-uploader"
  }, [_vm.isLabelVisible ? _c('aq-label', _vm._b({
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isFileSelector,
      expression: "isFileSelector"
    }],
    attrs: {
      "for": _vm.uid
    }
  }, 'aq-label', _vm.bindsLabel, false), [_vm._v(_vm._s(_vm.$aqT(_vm.label)))]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isFileSelector,
      expression: "isFileSelector"
    }],
    class: ['aq-file-uploader__selector', {
      'aq-file-uploader__selector--default': _vm.isDefault,
      'aq-file-uploader__selector--error': _vm.error,
      'aq-file-uploader__selector--active': (_vm.isDragOver || _vm.showClassActive) && !_vm.summary && !_vm.disabled,
      'aq-file-uploader__selector--disabled': _vm.disabled
    }],
    style: _vm.getStyle,
    on: {
      "dragover": function dragover($event) {
        return _vm.onDragOver($event);
      },
      "dragenter": function dragenter($event) {
        return _vm.onDragOver($event);
      },
      "dragleave": function dragleave($event) {
        _vm.isDragOver = false;
      },
      "drop": function drop($event) {
        return _vm.onDrop($event);
      },
      "mouseenter": function mouseenter($event) {
        return _vm.setActiveClass(true);
      },
      "mouseleave": function mouseleave($event) {
        _vm.showClassActive = false;
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.hasFiles,
      expression: "!hasFiles"
    }],
    staticClass: "aq-file-uploader__file-selector"
  }, [_c('span', {
    class: ['aq-file-uploader__text', {
      'aq-file-uploader__text--disabled': _vm.disabled || this.summary
    }]
  }, [_vm._v(_vm._s(_vm.getLoadFileText ? _vm.$aqT(_vm.loadFileText) : _vm.$t('aqua.fileUploader.dropFile')))]), _vm._v(" "), _c('span', [_c('aq-button', {
    attrs: {
      "outline": "",
      "disabled": _vm.disabled || this.summary
    },
    on: {
      "click": _vm.openFile
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('aqua.fileUploader.selectFile')) + "\n        ")]), _vm._v(" "), _c('input', {
    ref: "file",
    staticClass: "input-hidden",
    attrs: {
      "type": "file",
      "id": _vm.uid,
      "webkitdirectory": _vm.isFolder,
      "mozdirectory": _vm.isFolder,
      "directory": _vm.isFolder,
      "multiple": _vm.multiple,
      "accept": _vm.accept,
      "disabled": _vm.disabled || this.summary,
      "hidden": ""
    },
    on: {
      "change": _vm.handleFileUpload
    }
  })], 1), _vm._v(" "), _vm.showAccept ? _c('span', {
    staticClass: "aq-file-uploader__formats"
  }, [_vm._v(_vm._s(_vm.$t('aqua.fileUploader.supportedFormats')) + " " + _vm._s(_vm.accept))]) : _c('span', {
    staticClass: "aq-file-uploader__formats"
  }, [_vm._v(_vm._s(_vm.$aqT(_vm.altText)))])]), _vm._v(" "), _vm.hasFiles ? _c('div', [_c('div', {
    staticClass: "aq-file-uploader__header"
  }, [_c('span', {
    staticClass: "aq-file-uploader__header-text"
  }, [_vm._v(_vm._s(_vm.$t('aqua.fileUploader.addFiles')))]), _vm._v(" "), _c('div', {
    staticClass: "aq-file-uploader__header-info"
  }, [_c('span', {
    class: [{
      'aq-file-uploader__text-files': !_vm.isMaxUpload
    }, {
      'aq-file-uploader__text-files-total-files': _vm.isMaxUpload
    }]
  }, [_vm.isMaxUpload ? _c('aq-label', {
    attrs: {
      "info": _vm.infoFilesAllowed
    }
  }, [_vm._v(_vm._s(_vm.$t('aqua.fileUploader.uploadedFilesInfo')))]) : _c('aq-label', [_vm._v(_vm._s(this.$t('aqua.fileUploader.filesUpload')) + " " + _vm._s(_vm.getFilesLength) + "\n              " + _vm._s(_vm.getFilesLength > 1 ? _vm.$t('aqua.files') : _vm.$t('aqua.file')))])], 1), _vm._v(" "), _c('aq-divider', {
    staticClass: "aq-file-uploader__text-files--divider",
    attrs: {
      "orientation": "vertical"
    }
  }), _vm._v(" "), _c('span', {
    class: [{
      'aq-file-uploader__text-size': !_vm.isMaxSize
    }, {
      'aq-file-uploader__text-size-max-size': _vm.isMaxSize
    }]
  }, [_vm.isMaxSize ? _c('aq-label', {
    attrs: {
      "info": _vm.infoSizeAllowed
    }
  }, [_vm._v(_vm._s(_vm.$t('aqua.fileUploader.uploadedWeightInfo')))]) : _c('aq-label', [_vm._v(_vm._s(this.$t('aqua.fileUploader.totalWeight')) + " " + _vm._s(_vm.getSize))])], 1), _vm._v(" "), !_vm.summary && (_vm.getFilesLength < _vm.maxUpload || _vm.maxUpload === -1) ? _c('aq-button', {
    attrs: {
      "plain": true,
      "icon": "aq-icon-plus"
    },
    on: {
      "click": _vm.openFile
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', [_vm.showBannerNotification ? _c('aq-banner', {
    staticClass: "aq-file-uploader__banner",
    attrs: {
      "title": _vm.getBannerTitle,
      "close": _vm.getCloseBanner,
      "state": _vm.getBannerState
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$aqT(_vm.getBannerMessage)))]) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('Uploader', _vm._b({
    attrs: {
      "files": _vm.files,
      "requests": _vm.requests,
      "summary": _vm.summary
    },
    on: {
      "close": _vm.onClose,
      "restart": _vm.onRestartedLoad,
      "canceled": _vm.onCanceledFile,
      "deleted": _vm.onDeletedFile,
      "finish": _vm.finishedLoad,
      "finishAll": _vm.finishedAllFiles,
      "clearInput": _vm.clearInputData
    }
  }, 'Uploader', _vm.allProps, false))], 1), _vm._v(" "), _vm.isHelperTextVisible && _vm.isFileSelector ? _c('div', {
    staticClass: "aq-text-field__helper-text"
  }, [_vm.isHelperTextVisible ? _c('aq-helper-text', _vm._b({}, 'aq-helper-text', _vm.bindsHelperText, false)) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('Uploader', _vm._b({
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.uploaderFloating && _vm.openFloatingUploader,
      expression: "uploaderFloating && openFloatingUploader"
    }],
    attrs: {
      "isDummy": "",
      "files": _vm.files,
      "requests": _vm.requests,
      "summary": _vm.summary
    },
    on: {
      "close": _vm.onClose,
      "restart": _vm.onRestartedLoad,
      "canceled": _vm.onCanceledFile,
      "deleted": _vm.onDeletedFile,
      "finish": _vm.finishedLoad,
      "finishAll": _vm.finishedAllFiles
    }
  }, 'Uploader', _vm.allProps, false)), _vm._v(" "), _c('aq-dialog', {
    attrs: {
      "title": _vm.exceedMaxUploadText,
      "closeOnBackdrop": false,
      "size": _vm.getDialogSizeExceedMaxUpload,
      "state": _vm.getDialogStateExceedMaxUpload
    },
    on: {
      "close": _vm.closeDialogMaxUpload
    },
    scopedSlots: _vm._u([{
      key: "footer-right",
      fn: function fn() {
        return [!_vm.cantLoadFiles ? _c('aq-button', {
          attrs: {
            "color": "default"
          },
          on: {
            "click": _vm.closeDialogMaxUpload
          }
        }, [_vm._v(_vm._s(_vm.$t('aqua.cancel')))]) : _vm._e(), _vm._v(" "), !_vm.cantLoadFiles ? _c('aq-button', {
          attrs: {
            "color": "blue",
            "disabled": !_vm.canContinueLoad
          },
          on: {
            "click": function click($event) {
              return _vm.loadFiles([], true);
            }
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$t('aqua.continue')) + "\n      ")]) : _vm._e(), _vm._v(" "), _vm.cantLoadFiles ? _c('aq-button', {
          attrs: {
            "color": "red",
            "disabled": !_vm.canContinueLoad
          },
          on: {
            "click": _vm.closeDialogMaxUpload
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$t('aqua.close')) + "\n      ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.exceedMaxUpload,
      callback: function callback($$v) {
        _vm.exceedMaxUpload = $$v;
      },
      expression: "exceedMaxUpload"
    }
  }, [!_vm.cantLoadFiles ? _c('div', [_c('span', [_vm._v(_vm._s(_vm.getExceedMaxUploadText))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm.allowSelectAll ? _c('div', {
    staticClass: "aq-dropdown-item__buttons-select-all"
  }, [_c('div', [_c('aq-button', {
    staticClass: "aq-dropdown-item__button-select-all-left",
    attrs: {
      "disabled": !_vm.selectAll,
      "outline": true
    },
    on: {
      "click": function click($event) {
        return _vm.selectAllFiles(true);
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('aqua.selectAll')) + "\n          ")])], 1), _vm._v(" "), _c('div', [_c('aq-button', {
    staticClass: "aq-dropdown-item__button-select-all-right",
    attrs: {
      "disabled": _vm.selectAll,
      "outline": true
    },
    on: {
      "click": function click($event) {
        return _vm.selectAllFiles(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('aqua.deselectAll')))])], 1)]) : _vm._e(), _vm._v(" "), _vm._l(_vm.temporalFiles, function (file, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      class: ['aq-file-uploader__max-upload', {
        'aq-file-uploader__max-upload--not-first': !_vm.isLast(index)
      }, {
        'aq-file-uploader__max-upload--not-last': index > 0
      }]
    }, [_c('aq-checkbox', {
      staticClass: "aq-file-uploader__max-upload-items",
      on: {
        "click": function click($event) {
          return _vm.setTemporalFiles(file, index, false);
        },
        "change": function change($event) {
          _vm.checkboxValue[index] = $event;
        }
      },
      model: {
        value: _vm.checkFiles.files[index],
        callback: function callback($$v) {
          _vm.$set(_vm.checkFiles.files, index, $$v);
        },
        expression: "checkFiles.files[index]"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "aq-progress-bar"
    }, [_c('div', [_c('em', {
      staticClass: "aq-progress-bar__icon aq-icon-file"
    })]), _vm._v(" "), _c('div', {
      staticClass: "aq-progress-bar__content"
    }, [_c('div', {
      staticClass: "aq-progress-bar__content__header"
    }, [_c('div', {
      staticClass: "aq-progress-bar__content__label"
    }, [_c('span', {
      staticClass: "aq-progress-bar__content__label__name"
    }, [_vm._v(_vm._s(file.name))]), _vm._v(" "), _c('div', {
      staticClass: "aq-progress-bar__content__label__size"
    }, [_c('span', {
      staticClass: "aq-progress-bar__content__label__size__text"
    }, [_vm._v(_vm._s(_vm.getFileSize(file.size)))])])])])])])], 1), _vm._v(" "), !_vm.isLast(index) ? _c('aq-divider') : _vm._e()], 1);
  })], 2) : _vm._e(), _vm._v(" "), _vm.cantLoadFiles ? _c('div', [_vm._v("\n      " + _vm._s(_vm.$t('aqua.fileUploader.cantLoadFiles')) + "\n    ")]) : _vm._e()]), _vm._v(" "), _c('aq-dialog', {
    attrs: {
      "title": _vm.exceedMaxWeightText,
      "closeOnBackdrop": false,
      "state": "danger"
    },
    on: {
      "close": _vm.closeDialogMaxWeight
    },
    scopedSlots: _vm._u([{
      key: "footer-right",
      fn: function fn() {
        return [_c('aq-button', {
          attrs: {
            "color": "red"
          },
          on: {
            "click": _vm.confirmMaxWeightDialog
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$t('aqua.close')) + "\n      ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.exceedMaxWeight,
      callback: function callback($$v) {
        _vm.exceedMaxWeight = $$v;
      },
      expression: "exceedMaxWeight"
    }
  }, [_c('aq-label', [_vm._v(_vm._s(_vm.getExceedMaxWeightText))])], 1), _vm._v(" "), _c('aq-dialog', {
    attrs: {
      "title": _vm.typeModalTitle,
      "closeOnBackdrop": false,
      "state": "danger"
    },
    on: {
      "close": _vm.closeDialogTypeFile
    },
    scopedSlots: _vm._u([{
      key: "footer-right",
      fn: function fn() {
        return [_c('aq-button', {
          attrs: {
            "color": "red"
          },
          on: {
            "click": _vm.confirmTypeDialog
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$t('aqua.close')) + "\n      ")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.showTypeModal,
      callback: function callback($$v) {
        _vm.showTypeModal = $$v;
      },
      expression: "showTypeModal"
    }
  }, [_c('aq-label', [_vm._v("\n      " + _vm._s(_vm.selectedFilesLength > 1 ? _vm.$t('aqua.fileUploader.notAllowedFiles') : _vm.$t('aqua.fileUploader.notAllowedFile')))])], 1)], 1);
};
var __vue_staticRenderFns__$D = [];

/* style */
var __vue_inject_styles__$D = undefined;
/* scoped */
var __vue_scope_id__$D = undefined;
/* module identifier */
var __vue_module_identifier__$D = undefined;
/* functional template */
var __vue_is_functional_template__$D = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$D = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$D,
  staticRenderFns: __vue_staticRenderFns__$D
}, __vue_inject_styles__$D, __vue_script__$D, __vue_scope_id__$D, __vue_is_functional_template__$D, __vue_module_identifier__$D, false, undefined, undefined, undefined);
var AqFileUploader = __vue_component__$D;

var INVALID_CHARTS = ['A', 'a', 'C', 'c', 'D', 'd', 'e', 'E', 'F', 'f', 'G', 'g', 'H', 'h', 'I', 'i', 'J', 'j', 'L', 'l', 'N', 'n', 'Ñ', 'ñ', 'O', 'o', 'P', 'p', 'Q', 'q', 'R', 'r', 'S', 's', 'U', 'u', 'V', 'v', 'W', 'w', 'X', 'x', 'Y', 'y', 'Z', 'z', '+', ','];

var script$C = {
  mixins: [LabelMixin, helperTextMixin],
  props: {
    size: {
      type: String,
      default: 'large',
      validator: function validator(x) {
        return ['', 'large', 'small'].includes(x.toLowerCase());
      }
    },
    id: {
      type: String,
      default: ''
    },
    step: {
      type: Number,
      default: 1
    },
    min: {
      type: Number,
      default: -1000000000
    },
    max: {
      type: Number,
      default: 1000000000
    },
    value: {
      type: [Number, String],
      default: ''
    },
    disabled: {
      // TODO: implement!
      type: Boolean,
      default: false
    },
    plain: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: true
    },
    strict: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: '0'
    },
    icon: {
      type: String,
      default: ''
    },
    tooltip: {
      type: String,
      default: ''
    }
  },
  watch: {
    id: function id() {
      this.validateId();
    },
    value: function value() {
      this.setValue();
    },
    number: function number() {
      this.$emit('input', numeral(this.number).value());
      this.$emit(EVENT_NAME_CHANGE, numeral(this.number).value());
    }
  },
  data: function data() {
    return {
      number: '',
      uid: this.id
    };
  },
  computed: {
    isSmall: function isSmall() {
      return this.size.toLowerCase() === 'small';
    },
    isSmallInfo: function isSmallInfo() {
      return this.size.toLowerCase() === 'small' && this.icon !== '';
    },
    getInput: function getInput() {
      return document.getElementById(this.uid);
    },
    invalidCharacters: function invalidCharacters() {
      var _this$format;
      return !((_this$format = this.format) !== null && _this$format !== void 0 && _this$format.includes('.')) ? [].concat(_toConsumableArray$1(INVALID_CHARTS), ['.']) : INVALID_CHARTS;
    }
  },
  methods: {
    up: function up() {
      var aux = numeral(this.number);
      var sum = +aux.value() + this.step;
      this.number = sum <= this.max ? numeral(sum).format(this.format) : this.number;
      if (aux.value() < this.min) {
        this.number = numeral(this.min).format(this.format);
      }
    },
    down: function down() {
      var aux = numeral(this.number);
      var sub = aux.value() - this.step;
      this.number = sub >= this.min ? numeral(sub).format(this.format) : this.number;
      if (this.number > this.max) {
        this.number = numeral(this.max).format(this.format);
      }
    },
    validateId: function validateId() {
      var _this$id;
      this.uid = ((_this$id = this.id) === null || _this$id === void 0 ? void 0 : _this$id.length) > 0 ? this.id : AquaRamdomId('-number-field');
    },
    setValue: function setValue() {
      if (this.value !== undefined && this.value !== null && this.value !== '') {
        this.number = typeof this.value === 'string' ? numeral(this.value).format(this.format) : numeral(this.value).value();
      }
    },
    onInput: function onInput() {
      var _this$number, _this$number2, _this$number3;
      if (this.number.charAt(((_this$number = this.number) === null || _this$number === void 0 ? void 0 : _this$number.length) - 1) === '0' && (_this$number2 = this.number) !== null && _this$number2 !== void 0 && _this$number2.includes('.')) {
        return;
      }
      var aux = numeral(this.number);
      if (this.number !== '' && this.number.charAt(((_this$number3 = this.number) === null || _this$number3 === void 0 ? void 0 : _this$number3.length) - 1) !== '.') {
        var value = aux.value();
        if (value) {
          var _value$toString;
          if ((_value$toString = value.toString()) !== null && _value$toString !== void 0 && _value$toString.includes('e')) {
            var _value$toString2;
            this.number = (_value$toString2 = value.toString()) !== null && _value$toString2 !== void 0 && _value$toString2.includes('e-') ? this.min : this.max;
            return;
          }
          this.number = numeral(value.toString()).format(this.format);
        }
      }
    },
    onKeyDown: function onKeyDown(e) {
      var _this$invalidCharacte, _this$number4;
      // TODO: cambiar constante por reGex
      if ((_this$invalidCharacte = this.invalidCharacters) !== null && _this$invalidCharacte !== void 0 && _this$invalidCharacte.includes(e.key) || e.key === '.' && (_this$number4 = this.number) !== null && _this$number4 !== void 0 && _this$number4.includes('.')) {
        e.preventDefault();
      } else if (e.key === '-') {
        var _this$number5;
        e.preventDefault();
        if (!((_this$number5 = this.number) !== null && _this$number5 !== void 0 && _this$number5.includes('-')) && (!this.strict || this.min < 0)) {
          this.number = "-".concat(this.number);
          this.onInput();
        }
      } else if (e.key === 'Backspace' && this.number === '$') {
        e.preventDefault();
      }
    },
    validateMinMax: function validateMinMax() {
      if (this.strict) {
        var aux = numeral(this.number);
        if (aux.value() > this.max) {
          this.number = numeral(this.max).format(this.format);
        } else if (aux.value() < this.min) {
          this.number = numeral(this.min).format(this.format);
        }
      }
    }
  },
  mounted: function mounted() {
    this.setValue();
  }
};

/* script */
var __vue_script__$C = script$C;

/* template */
var __vue_render__$C = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-number-field', {
      'aq-number-field--error': _vm.error,
      'aq-number-field--plain': _vm.plain
    }]
  }, [_vm.isLabelVisible ? _c('div', {
    staticClass: "aq-number-field__label"
  }, [_c('aq-label', _vm._b({
    attrs: {
      "for": _vm.uid
    }
  }, 'aq-label', _vm.bindsLabel, false), [_vm._v(_vm._s(_vm.$aqT(_vm.label)))])], 1) : _vm._e(), _vm._v(" "), _vm.readonly ? _c('div', {
    staticClass: "aq-number-field__readonly"
  }, [_vm._v("\n    " + _vm._s(_vm.number) + "\n  ")]) : _vm._e(), _vm._v(" "), !_vm.readonly ? _c('div', {
    staticClass: "aq-number-field__container"
  }, [!_vm.isSmall & !_vm.disabled ? _c('button', {
    staticClass: "button aq-number-field__left-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.down();
      }
    }
  }, [_c('em', {
    staticClass: "aq-icon-chevron-down"
  })]) : _vm._e(), _vm._v(" "), _vm.isSmall & _vm.icon !== '' & !_vm.disabled ? _c('em', {
    directives: [{
      name: "aq-tooltip",
      rawName: "v-aq-tooltip",
      value: _vm.tooltip,
      expression: "tooltip"
    }],
    staticClass: "button aq-number-field__left-button",
    class: _vm.icon
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.number,
      expression: "number"
    }],
    ref: "input",
    class: ['aq-number-field__input', {
      'aq-number-field__input--zero': _vm.number === 0,
      'aq-number-field__input--small': _vm.isSmall,
      'aq-number-field__input--small--info': _vm.isSmallInfo,
      'aq-number-field__input--inactive': !_vm.active,
      'aq-number-field__input--disabled': _vm.disabled
    }],
    attrs: {
      "type": "text",
      "id": _vm.uid,
      "min": _vm.min,
      "max": _vm.max,
      "readonly": !_vm.active,
      "step": _vm.step,
      "required": _vm.required,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.number
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.number = $event.target.value;
      }, function ($event) {
        return _vm.onInput();
      }],
      "keydown": function keydown($event) {
        return _vm.onKeyDown($event);
      },
      "blur": function blur($event) {
        return _vm.validateMinMax();
      }
    }
  }), _vm._v(" "), !_vm.isSmall & !_vm.disabled ? _c('button', {
    staticClass: "button aq-number-field__right-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.up();
      }
    }
  }, [_c('em', {
    staticClass: "aq-icon-chevron-up"
  })]) : _vm._e(), _vm._v(" "), _c('div', [_vm.isSmall & !_vm.disabled ? _c('button', {
    staticClass: "button aq-number-field__top-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.up();
      }
    }
  }, [_c('em', {
    staticClass: "aq-icon-chevron-up"
  })]) : _vm._e(), _vm._v(" "), _vm.isSmall & !_vm.disabled ? _c('button', {
    staticClass: "button aq-number-field__bottom-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.down();
      }
    }
  }, [_c('em', {
    staticClass: "aq-icon-chevron-down"
  })]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _vm.isHelperTextVisible ? _c('div', {
    staticClass: "aq-number-field__helper-text"
  }, [_vm.isHelperTextVisible ? _c('aq-helper-text', _vm._b({}, 'aq-helper-text', _vm.bindsHelperText, false)) : _vm._e()], 1) : _vm._e()]);
};
var __vue_staticRenderFns__$C = [];

/* style */
var __vue_inject_styles__$C = undefined;
/* scoped */
var __vue_scope_id__$C = undefined;
/* module identifier */
var __vue_module_identifier__$C = undefined;
/* functional template */
var __vue_is_functional_template__$C = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$C = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$C,
  staticRenderFns: __vue_staticRenderFns__$C
}, __vue_inject_styles__$C, __vue_script__$C, __vue_scope_id__$C, __vue_is_functional_template__$C, __vue_module_identifier__$C, false, undefined, undefined, undefined);
var AqNumberField = __vue_component__$C;

//
var script$B = {
  props: {
    label: {
      type: [String, Function],
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    valueRadio: {
      type: String,
      default: null
    },
    name: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: null
    },
    helperText: {
      type: [String, Function],
      default: ''
    },
    info: {
      type: [String, Function],
      default: ''
    },
    tooltipWidth: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: function value() {
      this.changeValue();
    },
    checkedRadio: function checkedRadio(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('input', this.checkedRadio);
        this.$emit(EVENT_NAME_CHANGE, this.checkedRadio);
      }
    }
  },
  data: function data() {
    return {
      checkedRadio: this.value
    };
  },
  computed: {
    isLabelVisible: function isLabelVisible() {
      var _this$label;
      return typeof this.label === 'function' || ((_this$label = this.label) === null || _this$label === void 0 ? void 0 : _this$label.length) > 0;
    },
    isHelperTextVisible: function isHelperTextVisible() {
      var _this$helperText;
      return typeof this.helperText === 'function' || ((_this$helperText = this.helperText) === null || _this$helperText === void 0 ? void 0 : _this$helperText.length) > 0;
    },
    infoIsVisible: function infoIsVisible() {
      var _this$info;
      return typeof this.info === 'function' || ((_this$info = this.info) === null || _this$info === void 0 ? void 0 : _this$info.length) > 0;
    },
    isIcon: function isIcon() {
      var _this$icon;
      return ((_this$icon = this.icon) === null || _this$icon === void 0 ? void 0 : _this$icon.length) > 0;
    }
  },
  methods: {
    changeValue: function changeValue() {
      this.checkedRadio = this.value;
    },
    verifyClick: function verifyClick(event) {
      /*
      if (this.indeterminate) {
      event.preventDefault();
      }
      */
      event.stopPropagation();
      this.onClick(event);
    },
    onClick: function onClick(event) {
      this.$emit('click', event);
    }
  }
};

/* script */
var __vue_script__$B = script$B;

/* template */
var __vue_render__$B = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-radio"
  }, [_c('label', {
    staticClass: "aq-radio-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.checkedRadio,
      expression: "checkedRadio"
    }],
    ref: "radio",
    attrs: {
      "type": "radio",
      "name": _vm.name,
      "disabled": _vm.disabled,
      "id": _vm.id
    },
    domProps: {
      "value": _vm.valueRadio,
      "checked": _vm._q(_vm.checkedRadio, _vm.valueRadio)
    },
    on: {
      "click": function click($event) {
        return _vm.verifyClick($event);
      },
      "change": function change($event) {
        _vm.checkedRadio = _vm.valueRadio;
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "aq-radio-container__radio"
  }), _vm._v(" "), _c('div', {
    staticClass: "aq-radio-container__title"
  }, [_vm.isIcon ? _c('em', {
    class: _vm.icon
  }) : _vm._e(), _vm._v(" "), _vm.isLabelVisible ? _c('span', {
    staticClass: "aq-radio-container__label"
  }, [_vm._v(_vm._s(_vm.$aqT(_vm.label)))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "aq-radio-container__helperText"
  }, [_vm.isHelperTextVisible ? _c('aq-caption', [_vm._v(_vm._s(_vm.$aqT(_vm.helperText)))]) : _vm._e()], 1), _vm._v(" "), _vm.required ? _c('span', {
    staticClass: "aq-checkbox--required"
  }) : _vm._e(), _vm._v(" "), _c('aq-tooltip', {
    attrs: {
      "width": _vm.tooltipWidth
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_vm.infoIsVisible ? _c('em', {
          staticClass: "aq-icon-info-circle aq-label__info",
          attrs: {
            "aria-hidden": "true"
          }
        }) : _vm._e()];
      },
      proxy: true
    }])
  }, [_vm._v(" "), [_vm._v("\n        " + _vm._s(_vm.$aqT(_vm.info)) + "\n      ")]], 2)], 1)]);
};
var __vue_staticRenderFns__$B = [];

/* style */
var __vue_inject_styles__$B = undefined;
/* scoped */
var __vue_scope_id__$B = undefined;
/* module identifier */
var __vue_module_identifier__$B = undefined;
/* functional template */
var __vue_is_functional_template__$B = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$B = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$B,
  staticRenderFns: __vue_staticRenderFns__$B
}, __vue_inject_styles__$B, __vue_script__$B, __vue_scope_id__$B, __vue_is_functional_template__$B, __vue_module_identifier__$B, false, undefined, undefined, undefined);
var AqRadio = __vue_component__$B;

//
var script$A = {
  mixins: [sizeMixin],
  props: {
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    label: {
      type: [String, Function],
      default: ''
    },
    position: {
      type: String,
      default: 'center'
    },
    valueRadio: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    last: {
      type: Boolean,
      default: false
    },
    vertical: {
      type: Boolean,
      default: false
    },
    orientation: {
      type: String,
      default: 'horizontal',
      validator: function validator(x) {
        return ['', 'horizontal', 'vertical'].includes(x);
      }
    },
    info: {
      type: [String, Function],
      default: ''
    },
    tooltipWidth: {
      type: String,
      default: ''
    }
  },
  watch: {
    value: function value() {
      this.checkedRadio = this.value;
    },
    checkedRadio: function checkedRadio() {
      this.$emit('input', this.checkedRadio);
      this.$emit(EVENT_NAME_CHANGE, this.checkedRadio);
    }
  },
  data: function data() {
    return {
      checkedRadio: ''
    };
  },
  computed: {
    isLabelVisible: function isLabelVisible() {
      var _this$label;
      return typeof this.label === 'function' || ((_this$label = this.label) === null || _this$label === void 0 ? void 0 : _this$label.length) > 0;
    },
    colorButton: function colorButton() {
      var color = 'default';
      if (this.checkedRadio === this.valueRadio) {
        color = 'blue';
      }
      return color;
    },
    getOrientation: function getOrientation() {
      return !this.vertical ? 'vertical' : 'horizontal';
    },
    getInfo: function getInfo() {
      return "".concat(this.info);
    },
    getTooltipWidth: function getTooltipWidth() {
      return "".concat(this.tooltipWidth);
    },
    infoIsVisible: function infoIsVisible() {
      var _this$info;
      return typeof this.info === 'function' || ((_this$info = this.info) === null || _this$info === void 0 ? void 0 : _this$info.length) > 0;
    }
  },
  methods: {
    setValueRadio: function setValueRadio() {
      this.checkedRadio = this.valueRadio;
    },
    changed: function changed() {
      this.$emit('change');
    }
  }
};

/* script */
var __vue_script__$A = script$A;

/* template */
var __vue_render__$A = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-radio-button', {
      'aq-radio-button--vertical': _vm.vertical
    }]
  }, [_c('label', {
    staticClass: "aq-radio-button-container",
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.checkedRadio,
      expression: "checkedRadio"
    }],
    ref: "radio",
    attrs: {
      "type": "radio",
      "name": _vm.name,
      "disabled": _vm.disabled,
      "id": _vm.id
    },
    domProps: {
      "value": _vm.valueRadio,
      "checked": _vm._q(_vm.checkedRadio, _vm.valueRadio)
    },
    on: {
      "change": [function ($event) {
        _vm.checkedRadio = _vm.valueRadio;
      }, _vm.changed]
    }
  }), _vm._v(" "), !_vm.infoIsVisible ? _c('aq-button', {
    class: ['aq-button--radio-' + _vm.position, {
      'aq-button--radio-vertical': _vm.vertical,
      'aq-button--orientation-vertical': _vm.orientation === 'vertical'
    }],
    style: _vm.mixinSizeStyle,
    attrs: {
      "disabled": _vm.disabled,
      "color": _vm.colorButton,
      "icon": _vm.icon,
      "outline": "",
      "orientation": _vm.orientation
    },
    on: {
      "click": _vm.setValueRadio
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$aqT(_vm.label)) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.infoIsVisible ? _c('aq-button', {
    directives: [{
      name: "aq-tooltip",
      rawName: "v-aq-tooltip",
      value: {
        text: _vm.getInfo,
        width: _vm.getTooltipWidth
      },
      expression: "{ text: getInfo, width: getTooltipWidth }"
    }],
    class: ['aq-button--radio-' + _vm.position, {
      'aq-button--radio-vertical': _vm.vertical,
      'aq-button--orientation-vertical': _vm.orientation === 'vertical'
    }],
    style: _vm.mixinSizeStyle,
    attrs: {
      "disabled": _vm.disabled,
      "color": _vm.colorButton,
      "icon": _vm.icon,
      "outline": "",
      "orientation": _vm.orientation
    },
    on: {
      "click": _vm.setValueRadio
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$aqT(_vm.label)) + "\n    ")]) : _vm._e()], 1), _vm._v(" "), !_vm.last ? _c('aq-divider', {
    attrs: {
      "orientation": _vm.getOrientation
    }
  }) : _vm._e()], 1);
};
var __vue_staticRenderFns__$A = [];

/* style */
var __vue_inject_styles__$A = undefined;
/* scoped */
var __vue_scope_id__$A = undefined;
/* module identifier */
var __vue_module_identifier__$A = undefined;
/* functional template */
var __vue_is_functional_template__$A = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$A = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$A,
  staticRenderFns: __vue_staticRenderFns__$A
}, __vue_inject_styles__$A, __vue_script__$A, __vue_scope_id__$A, __vue_is_functional_template__$A, __vue_module_identifier__$A, false, undefined, undefined, undefined);
var AqRadioButton = __vue_component__$A;

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$5(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var script$z = {
  mixins: [LabelMixin, helperTextMixin],
  components: {
    CountryFlag: CountryFlag
  },
  props: {
    multiple: {
      type: Boolean,
      default: false
    },
    cleanOnEscape: {
      type: Boolean,
      default: false
    },
    closeOnSelect: {
      type: Boolean,
      default: false
    },
    cleanFilterOnSelect: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    allowSelectAll: {
      type: Boolean,
      default: false
    },
    showCheckbox: {
      type: Boolean,
      default: true
    },
    selectedsCounter: {
      type: Boolean,
      default: false
    },
    badgeCounter: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    plain: {
      type: Boolean,
      default: false
    },
    valueArray: {
      type: Boolean,
      default: true
    },
    sublabel: {
      type: [String, Function],
      default: ''
    },
    valueKey: {
      type: String,
      default: 'id'
    },
    textKey: {
      type: String,
      default: 'name'
    },
    type: {
      type: String,
      default: 'input',
      validator: function validator(value) {
        return ['', 'input', 'button'].indexOf(value) !== -1;
      }
    },
    placeholder: {
      type: [String, Function],
      default: ''
    },
    template: {
      type: [String, Function],
      default: ''
    },
    textButton: {
      type: [String, Function],
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    popoverWidth: {
      type: String,
      default: 'auto'
    },
    returnMode: {
      type: String,
      default: 'originalObject'
    },
    idParent: {
      type: String,
      default: ''
    },
    value: {
      default: function _default() {
        return [];
      }
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    maxShowSelect: {
      type: Number,
      default: -1
    },
    maxSelect: {
      type: Number,
      default: -1
    },
    infoBanner: {
      type: Object,
      default: function _default() {}
    },
    emptyStateMessage: {
      type: String,
      default: ''
    },
    isFlagSelector: {
      type: Boolean,
      default: false
    },
    fontSizeSelectedOption: {
      type: String,
      default: '',
      validator: function validator(value) {
        return ['', '14px', '16px', '20px', '28px', '32px', '42px', '54px'].indexOf(value) !== -1;
      }
    },
    isSlot: {
      type: Boolean,
      default: false
    },
    showRadio: {
      type: Boolean,
      default: false
    },
    contentOption: {
      type: Boolean,
      default: false
    },
    isFullName: {
      type: Boolean,
      default: false
    },
    showIconClose: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      events: EVENTS,
      showDropdown: false,
      visibleIconClose: false,
      firstLoad: true,
      selected: [],
      returned: null,
      parsedValue: [],
      style: {
        fontSize: ''
      }
    };
  },
  watch: {
    fontSizeSelectedOption: function fontSizeSelectedOption() {
      this.setFontSizeSelectedOption();
    }
  },
  computed: {
    getFontSpacing: function getFontSpacing() {
      switch (this.fontSizeSelectedOption) {
        case '14px':
        case '16px':
        case '20px':
          return 'aq-select-input__item-selected--small';
        case '28px':
        case '32px':
        case '42px':
          return 'aq-select-input__item-selected--medium';
        case '54px':
          return 'aq-select-input__item-selected--bigger';
        default:
          return '';
      }
    },
    isDisabled: function isDisabled() {
      return this.disabled || this.disabled && this.error;
    },
    isError: function isError() {
      return this.error && !this.disabled;
    },
    amountOtherOptons: function amountOtherOptons() {
      var _this$selected;
      var amount = 0;
      if (this.multiple && this.maxShowSelect > -1 && ((_this$selected = this.selected) === null || _this$selected === void 0 ? void 0 : _this$selected.length) - this.maxShowSelect > 0) {
        if (this.maxShowSelect === 0) {
          var _this$selected2;
          amount = (_this$selected2 = this.selected) === null || _this$selected2 === void 0 ? void 0 : _this$selected2.length;
        } else {
          var _this$selected3;
          amount = ((_this$selected3 = this.selected) === null || _this$selected3 === void 0 ? void 0 : _this$selected3.length) - this.maxShowSelect;
        }
      }
      return amount;
    },
    selectOptionsToDisplay: function selectOptionsToDisplay() {
      var selectedItems = this.selected;
      if (this.maxShowSelect > 0) {
        selectedItems = this.selected.slice(0, this.maxShowSelect);
      } else if (this.maxShowSelect === 0) {
        selectedItems = [];
      }
      return selectedItems;
    },
    isLabelVisible: function isLabelVisible() {
      var _this$label;
      return typeof this.label === 'function' || ((_this$label = this.label) === null || _this$label === void 0 ? void 0 : _this$label.length) > 0;
    },
    getCharcounter: function getCharcounter() {
      var _this$selected4, _this$selected5, _this$selected6;
      var charCounter = '';
      switch (true) {
        case this.selectedsCounter && this.maxSelect > 0:
          charCounter = "".concat((_this$selected4 = this.selected) === null || _this$selected4 === void 0 ? void 0 : _this$selected4.length, "/").concat(this.maxSelect);
          break;
        case this.selectedsCounter && this.maxSelect < 0 && ((_this$selected5 = this.selected) === null || _this$selected5 === void 0 ? void 0 : _this$selected5.length) >= 1:
          charCounter = "".concat((_this$selected6 = this.selected) === null || _this$selected6 === void 0 ? void 0 : _this$selected6.length);
          break;
        case !this.maxSelect && this.maxSelect < 0:
          charCounter = '';
          break;
      }
      return charCounter;
    },
    isCharCounterVisible: function isCharCounterVisible() {
      return this.selectedsCounter && this.maxSelect;
    },
    sublabelRequired: function sublabelRequired() {
      var _this$$aqT, _this$$aqT2;
      return this.required && ((_this$$aqT = this.$aqT(this.label)) === null || _this$$aqT === void 0 ? void 0 : _this$$aqT.length) === 0 && ((_this$$aqT2 = this.$aqT(this.sublabel)) === null || _this$$aqT2 === void 0 ? void 0 : _this$$aqT2.length) > 0;
    },
    getFlag: function getFlag() {
      var _this$selected$, _this$selected$$optio, _this$selected$$optio2;
      return (_this$selected$ = this.selected[0]) === null || _this$selected$ === void 0 ? void 0 : (_this$selected$$optio = _this$selected$.option) === null || _this$selected$$optio === void 0 ? void 0 : (_this$selected$$optio2 = _this$selected$$optio.flag) === null || _this$selected$$optio2 === void 0 ? void 0 : _this$selected$$optio2.toLowerCase();
    },
    getTop: function getTop() {
      return this.style.fontSize === '' && this.style.fontSize === '14px';
    },
    getIconLength: function getIconLength() {
      var _this$icon;
      return ((_this$icon = this.icon) === null || _this$icon === void 0 ? void 0 : _this$icon.length) > 0;
    },
    getSublabelLength: function getSublabelLength() {
      var _this$$aqT3;
      return ((_this$$aqT3 = this.$aqT(this.sublabel)) === null || _this$$aqT3 === void 0 ? void 0 : _this$$aqT3.length) > 0;
    },
    getSelectedLength: function getSelectedLength() {
      var _this$selected7;
      return (_this$selected7 = this.selected) === null || _this$selected7 === void 0 ? void 0 : _this$selected7.length;
    }
  },
  methods: {
    validateValue: function validateValue(newVal, oldVal) {
      if (newVal && oldVal) {
        var _Object$keys, _Object$keys2, _this$selected8, _this$parsedValue;
        if (!this.multiple && (this.value === '' || ((_Object$keys = Object.keys(newVal)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) === 0 && ((_Object$keys2 = Object.keys(oldVal)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2.length) > 0)) {
          this.cleanSelections();
        } else if (this.multiple && ((newVal === null || newVal === void 0 ? void 0 : newVal.length) !== ((_this$selected8 = this.selected) === null || _this$selected8 === void 0 ? void 0 : _this$selected8.length) || this.compareParsedValue(newVal, this.parsedValue))) {
          this.$refs.dropdown.selectItems(newVal);
        } else if (!this.multiple && this.valueArray && newVal[0] && oldVal[0] && ((_this$parsedValue = this.parsedValue) === null || _this$parsedValue === void 0 ? void 0 : _this$parsedValue.length) > 0 && newVal[0][this.valueKey] !== this.parsedValue[0][this.valueKey]) {
          this.$refs.dropdown.selectItems(newVal);
        }
      }
    },
    onOpen: function onOpen() {
      this.showDropdown = true;
      this.$emit(EVENT_NAME_OPEN);
    },
    onClose: function onClose() {
      this.showDropdown = false;
      this.$emit(EVENT_NAME_CLOSE);
    },
    onChange: function onChange(value) {
      this.selected = value;
      var parsedValue = this.parseValue(value);
      if (this.compareParsedValue(parsedValue, this.parsedValue)) {
        this.parsedValue = parsedValue;
        this.$emit('input', this.parsedValue);
        this.$emit(EVENT_NAME_CHANGE, this.parsedValue);
      }
    },
    compareParsedValue: function compareParsedValue(value1, value2) {
      var comparator;
      if (this.multiple || this.valueArray) {
        comparator = !compareValuesByPosition(value1, value2, this.valueKey, this.returnMode === 'keys');
      } else if (this.returnMode === 'keys') {
        comparator = value1 !== value2;
      } else {
        comparator = value1[this.valueKey] !== value2[this.valueKey];
      }
      return comparator;
    },
    parseValue: function parseValue(value) {
      var _this = this;
      var items;
      if (this.multiple) {
        if (this.returnMode === 'keys') {
          items = value.map(function (x) {
            return x[_this.valueKey];
          });
        } else if (this.returnMode === 'originalObject') {
          items = value.map(function (x) {
            return _objectSpread$5({}, x.originalData);
          });
        } else {
          items = value.map(function (x) {
            var _ref;
            return _ref = {}, _defineProperty$1(_ref, _this.valueKey, x[_this.valueKey]), _defineProperty$1(_ref, _this.textKey, x[_this.textKey]), _ref;
          });
        }
      } else if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
        var _value = _slicedToArray(value, 1),
          item = _value[0];
        if (this.returnMode === 'keys') {
          items = item[this.valueKey];
        } else if (this.returnMode === 'originalObject') {
          items = _objectSpread$5({}, item.originalData);
        } else {
          var _items;
          items = (_items = {}, _defineProperty$1(_items, this.valueKey, item[this.valueKey]), _defineProperty$1(_items, this.textKey, item[this.textKey]), _items);
        }
      } else if (this.returnMode === 'keys') {
        items = '';
      } else {
        items = {};
      }
      if (!this.multiple && this.valueArray) {
        var _Object$keys3;
        if (items === '' || _typeof$2(items) === 'object' && ((_Object$keys3 = Object.keys(items)) === null || _Object$keys3 === void 0 ? void 0 : _Object$keys3.length) === 0) {
          items = [];
        } else {
          items = [items];
        }
      }
      this.returned = items;
      return items;
    },
    toggleDropdown: function toggleDropdown() {
      var _this2 = this;
      if (this.showDropdown) {
        setTimeout(function () {
          return _this2.$refs.dropdown.hide();
        });
      }
    },
    cleanSelections: function cleanSelections() {
      this.$refs.dropdown.selectAll(false, true);
    },
    deselectItem: function deselectItem(item) {
      var _this3 = this;
      setTimeout(function () {
        return _this3.$refs.dropdown.selectItem({
          index: item.index,
          value: false
        });
      });
    },
    setFontSizeSelectedOption: function setFontSizeSelectedOption() {
      this.style.fontSize = this.fontSizeSelectedOption;
    },
    getTagProperty: function getTagProperty(item, key) {
      return item.option[key] ? item.option[key] : '';
    }
  },
  mounted: function mounted() {
    this.setFontSizeSelectedOption();
  }
};

/* script */
var __vue_script__$z = script$z;

/* template */
var __vue_render__$z = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-select-content', {
      'aq-select-content--input': _vm.type === 'input'
    }]
  }, [_vm.isLabelVisible ? _c('aq-label', _vm._b({
    staticClass: "aq-select__label"
  }, 'aq-label', _vm.bindsLabel, false), [_vm._v("\n    " + _vm._s(_vm.$aqT(_vm.label)) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('aq-list-menu', {
    ref: "dropdown",
    attrs: {
      "options": _vm.options,
      "textKey": _vm.textKey,
      "valueKey": _vm.valueKey,
      "multiple": _vm.multiple,
      "allowSelectAll": _vm.allowSelectAll,
      "popoverWidth": _vm.popoverWidth,
      "cleanOnEscape": _vm.cleanOnEscape,
      "value": _vm.value,
      "returnMode": _vm.returnMode,
      "oldValue": _vm.parsedValue,
      "disabled": _vm.disabled || _vm.readonly || _vm.loading,
      "valueArray": _vm.valueArray,
      "closeOnSelect": _vm.closeOnSelect,
      "idParent": _vm.idParent,
      "maxSelect": _vm.maxSelect,
      "infoBanner": _vm.infoBanner,
      "emptyStateMessage": _vm.emptyStateMessage,
      "isFlagSelector": _vm.isFlagSelector,
      "showCheckbox": _vm.showCheckbox,
      "showRadio": _vm.showRadio,
      "contentOption": _vm.contentOption,
      "isFullName": _vm.isFullName
    },
    on: _vm._d({}, [_vm.events.EVENT_NAME_CLOSE, _vm.onClose, _vm.events.EVENT_NAME_OPEN, _vm.onOpen, _vm.events.EVENT_NAME_CHANGE, _vm.onChange]),
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_vm._t("header")];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function fn() {
        return [_vm._t("footer")];
      },
      proxy: true
    }, {
      key: "item",
      fn: function fn(ref) {
        var text = ref.text;
        var source = ref.source;
        return [_vm._t("item", null, {
          "text": text,
          "source": source
        })];
      }
    }], null, true)
  }, [_vm.type === 'input' ? _c('button', {
    class: ['aq-select-input', {
      'aq-select-input--focus': _vm.showDropdown,
      'aq-select-input--readonly': _vm.readonly,
      'aq-select-input--badge': _vm.badgeCounter,
      'aq-select-input--loading': _vm.loading,
      'aq-select-input--disabled': _vm.isDisabled,
      'aq-select-input--error': _vm.isError,
      'aq-select-input--plain': _vm.plain
    }],
    attrs: {
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.toggleDropdown();
      },
      "mouseover": function mouseover($event) {
        _vm.visibleIconClose = true;
      },
      "mouseleave": function mouseleave($event) {
        _vm.visibleIconClose = false;
      }
    }
  }, [_vm.getIconLength > 0 && !_vm.isFlagSelector ? _c('em', {
    class: ['aq-select__icon', _vm.icon]
  }) : _vm._e(), _vm._v(" "), _vm.isFlagSelector && _vm.getSelectedLength > 0 ? _c('country-flag', {
    class: ['aq-dropdown-item__flag--country', {
      'aq-dropdown-item__flag--country--slot': _vm.isSlot
    }],
    attrs: {
      "country": _vm.getFlag,
      "size": "normal"
    }
  }) : _vm._e(), _vm._v(" "), _vm.getSublabelLength ? _c('span', {
    staticClass: "aq-select__sublabel"
  }, [_vm._v("\n        " + _vm._s(_vm.$aqT(_vm.sublabel)) + "\n        "), _vm.sublabelRequired ? _c('span', {
    staticClass: "aq-label__requided"
  }, [_vm._v("*")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm.multiple ? [_vm._l(_vm.selectOptionsToDisplay, function (item, key, index) {
    return _c('aq-tag', {
      key: index,
      attrs: {
        "text": item[_vm.textKey],
        "close": !_vm.isDisabled && !_vm.readonly && !_vm.loading,
        "width": _vm.getTagProperty(item, 'tagWidth'),
        "icon": _vm.getTagProperty(item, 'tagIcon'),
        "color": _vm.getTagProperty(item, 'tagColor')
      },
      on: _vm._d({}, [_vm.events.EVENT_NAME_CLOSE, function ($event) {
        return _vm.deselectItem(item);
      }])
    });
  }), _vm._v(" "), _vm.amountOtherOptons > 0 ? _c('div', {
    staticClass: "aq-select-input__others"
  }, [_c('aq-tag', {
    attrs: {
      "text": _vm.amountOtherOptons + ' Sel.',
      "close": !_vm.isDisabled && !_vm.readonly && !_vm.loading
    },
    on: _vm._d({}, [_vm.events.EVENT_NAME_CLOSE, function ($event) {
      return _vm.cleanSelections();
    }])
  })], 1) : _vm._e()] : _vm.getSelectedLength > 0 && !_vm.isFlagSelector ? [_vm.contentOption && !_vm.multiple ? [_vm._t("contentOption")] : _vm._e(), _vm._v(" "), !_vm.contentOption ? _c('span', {
    class: ['aq-select-input__item-selected', _vm.getFontSpacing],
    style: _vm.style
  }, [_vm._v("\n          " + _vm._s(_vm.$aqT(_vm.selected[0][_vm.textKey])) + "\n        ")]) : _vm._e()] : _vm.getSelectedLength > 0 && _vm.isFlagSelector ? [_c('span', {
    staticClass: "aq-select-input__item-selected"
  }, [_vm._v("\n          " + _vm._s(_vm.selected[0].option.naming) + "\n        ")])] : _vm._e(), _vm._v(" "), _vm.getSelectedLength === 0 ? _c('span', {
    staticClass: "aq-select-input__placeholder"
  }, [_vm._v(_vm._s(_vm.$aqT(_vm.placeholder)))]) : _vm._e(), _vm._v(" "), _vm.badgeCounter && _vm.multiple && _vm.getSelectedLength > 0 ? _c('aq-badge', {
    class: ['aq-select__badge-counter', {
      'aq-select__badge-counter--readonly': _vm.readonly
    }],
    attrs: {
      "number": _vm.getSelectedLength,
      "disabled": _vm.isDisabled || _vm.loading
    }
  }) : _vm._e(), _vm._v(" "), _c('div', [_c('em', {
    class: ['aq-icon-close', 'aq-select-input__icon-close', {
      'aq-select-input__icon-close--active': _vm.visibleIconClose && _vm.showIconClose && _vm.getSelectedLength > 0 && !_vm.isDisabled && !_vm.readonly
    }, {
      'aq-select-input__icon-close--font': _vm.getTop
    }],
    on: {
      "click": function click($event) {
        return _vm.cleanSelections();
      }
    }
  }), _vm._v(" "), !_vm.readonly && !_vm.loading ? _c('em', {
    class: ['aq-icon-chevron-down', 'aq-select-input__icon', {
      'aq-select-input__icon--active': _vm.showDropdown
    }, {
      'aq-select-input__icon--font': _vm.getTop
    }],
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) {
          return null;
        }
        return _vm.toggleDropdown();
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.loading ? _c('span', {
    staticClass: "aq-select-input__loader-icon"
  }, [_c('aq-spinner', {
    attrs: {
      "size": "16",
      "value": _vm.loading
    }
  })], 1) : _vm._e()])], 2) : _c('aq-button', {
    class: [{
      'aq-select-input--focus': _vm.showDropdown,
      'aq-select-input--disabled': _vm.isDisabled,
      'aq-select-input--error': _vm.isError,
      'aq-select-input--readonly': _vm.readonly,
      'aq-select-input--badge': _vm.badgeCounter
    }],
    attrs: {
      "outline": "",
      "icon": _vm.icon
    },
    on: {
      "click": function click($event) {
        return _vm.toggleDropdown();
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$aqT(_vm.textButton))), _vm.multiple ? _c('aq-badge', {
    attrs: {
      "number": _vm.getSelectedLength,
      "disabled": _vm.isDisabled || _vm.loading
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _vm.isHelperTextVisible || _vm.isCharCounterVisible ? _c('div', {
    staticClass: "aq-select__footer"
  }, [_vm.isHelperTextVisible ? _c('div', {
    staticClass: "aq-select__helper-text"
  }, [_vm.isHelperTextVisible ? _c('aq-helper-text', _vm._b({}, 'aq-helper-text', _vm.bindsHelperText, false)) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.isCharCounterVisible ? _c('div', {
    staticClass: "aq-char-counter"
  }, [_vm._v("\n      " + _vm._s(_vm.getCharcounter) + "\n    ")]) : _vm._e()]) : _vm._e()], 1);
};
var __vue_staticRenderFns__$z = [];

/* style */
var __vue_inject_styles__$z = undefined;
/* scoped */
var __vue_scope_id__$z = undefined;
/* module identifier */
var __vue_module_identifier__$z = undefined;
/* functional template */
var __vue_is_functional_template__$z = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$z = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$z,
  staticRenderFns: __vue_staticRenderFns__$z
}, __vue_inject_styles__$z, __vue_script__$z, __vue_scope_id__$z, __vue_is_functional_template__$z, __vue_module_identifier__$z, false, undefined, undefined, undefined);
var AqSelect = __vue_component__$z;

//
var script$y = {
  mixins: [sizeMixin],
  props: {
    id: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    urlImage: {
      type: String,
      default: ''
    },
    label: {
      type: [String, Function],
      default: ''
    },
    valueRadio: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    helperText: {
      type: [String, Function],
      default: ''
    }
  },
  watch: {
    value: function value() {
      this.checkedRadio = this.value;
    },
    checkedRadio: function checkedRadio() {
      this.$emit('input', this.checkedRadio);
      this.$emit(EVENT_NAME_CHANGE, this.checkedRadio);
    },
    id: function id() {
      this.validateId();
    }
  },
  data: function data() {
    return {
      uid: this.id,
      checkedRadio: ''
    };
  },
  computed: {
    isLabelVisible: function isLabelVisible() {
      var _this$label;
      return typeof this.label === 'function' || ((_this$label = this.label) === null || _this$label === void 0 ? void 0 : _this$label.length) > 0;
    },
    isSelected: function isSelected() {
      return this.checkedRadio === this.valueRadio;
    },
    isIcon: function isIcon() {
      var _this$icon;
      return ((_this$icon = this.icon) === null || _this$icon === void 0 ? void 0 : _this$icon.length) > 0;
    },
    isImage: function isImage() {
      var _this$urlImage;
      return ((_this$urlImage = this.urlImage) === null || _this$urlImage === void 0 ? void 0 : _this$urlImage.length) > 0;
    },
    isHelperText: function isHelperText() {
      var _this$helperText;
      return typeof this.helperText === 'function' || ((_this$helperText = this.helperText) === null || _this$helperText === void 0 ? void 0 : _this$helperText.length) > 0;
    }
  },
  methods: {
    validateId: function validateId() {
      var _this$id;
      this.uid = ((_this$id = this.id) === null || _this$id === void 0 ? void 0 : _this$id.length) > 0 ? this.id : AquaRamdomId('-radio-card');
    },
    changed: function changed() {
      this.$emit('change');
    },
    setValueRadio: function setValueRadio() {
      this.checkedRadio = this.valueRadio;
    }
  },
  mounted: function mounted() {
    this.validateId();
  }
};

/* script */
var __vue_script__$y = script$y;

/* template */
var __vue_render__$y = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    attrs: {
      "for": _vm.uid
    }
  }, [_c('aq-button', {
    class: ['aq-radio-card', {
      'aq-radio-card--helperText': _vm.isHelperText,
      'aq-radio-card--checked': _vm.isSelected
    }],
    style: _vm.mixinSizeStyle,
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.setValueRadio
    }
  }, [_c('div', {
    class: ['aq-radio-card__header', {
      'aq-radio-card__header--helperText': _vm.isHelperText
    }]
  }, [_c('aq-radio', {
    attrs: {
      "valueRadio": _vm.valueRadio,
      "disabled": _vm.disabled,
      "name": _vm.name,
      "id": _vm.uid
    },
    model: {
      value: _vm.checkedRadio,
      callback: function callback($$v) {
        _vm.checkedRadio = $$v;
      },
      expression: "checkedRadio"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "aq-radio-card__content"
  }, [_c('div', {
    staticClass: "aq-radio-container__helperText"
  }, [_c('div', {
    staticClass: "aq-radio-card__title"
  }, [_vm.isIcon ? _c('em', {
    class: _vm.icon
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aq-radio-card__label"
  }, [_vm._v(_vm._s(_vm.$aqT(_vm.label)))])]), _vm._v(" "), _c('aq-caption', {
    staticClass: "caption"
  }, [_vm._v(_vm._s(_vm.$aqT(_vm.helperText)))])], 1)])])], 1);
};
var __vue_staticRenderFns__$y = [];

/* style */
var __vue_inject_styles__$y = undefined;
/* scoped */
var __vue_scope_id__$y = undefined;
/* module identifier */
var __vue_module_identifier__$y = undefined;
/* functional template */
var __vue_is_functional_template__$y = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$y = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$y,
  staticRenderFns: __vue_staticRenderFns__$y
}, __vue_inject_styles__$y, __vue_script__$y, __vue_scope_id__$y, __vue_is_functional_template__$y, __vue_module_identifier__$y, false, undefined, undefined, undefined);
var AqRadioCard = __vue_component__$y;

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$4(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var script$x = {
  mixins: [LabelMixin, sizeMixin, helperTextMixin],
  props: {
    value: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    error: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: '',
      validator: function validator(x) {
        return ['', 'radio', 'radiobutton', 'radiocard'].includes(x.toLowerCase());
      }
    },
    orientation: {
      type: String,
      default: '',
      validator: function validator(x) {
        return ['', 'vertical', 'horizontal'].includes(x.toLowerCase());
      }
    },
    returnMode: {
      type: String,
      default: 'values',
      validator: function validator(x) {
        return ['', 'values', 'originalobject'].includes(x.toLowerCase());
      }
    }
  },
  watch: {
    valueRadio: function valueRadio(newVal, oldVal) {
      this.$emit('input', this.valueRadio);
      this.$emit(EVENT_NAME_CHANGE, this.valueRadio);
      if (newVal !== oldVal && oldVal !== '' && this.returnMode === 'originalObject') {
        this.$emit('getOriginalObject', this.selectedItem());
      }
    },
    value: function value() {
      this.changeValue();
    }
  },
  data: function data() {
    return {
      valueRadio: ''
    };
  },
  computed: {
    isVertical: function isVertical() {
      return this.orientation && this.orientation.toLowerCase() === 'vertical';
    },
    getType: function getType() {
      return this.type.toLowerCase();
    },
    getOrientation: function getOrientation() {
      return this.isVertical ? 'vertical' : 'horizontal';
    },
    getOptionsLength: function getOptionsLength() {
      var _this$options;
      return (_this$options = this.options) === null || _this$options === void 0 ? void 0 : _this$options.length;
    }
  },
  methods: {
    getPosition: function getPosition(i) {
      var _this$options2;
      var position = 'center';
      var len = (_this$options2 = this.options) === null || _this$options2 === void 0 ? void 0 : _this$options2.length;
      if (len > 1) {
        if (i === 0) {
          position = this.isVertical ? 'top' : 'left';
        } else if (i === len - 1) {
          position = this.isVertical ? 'bottom' : 'right';
        }
      }
      return position;
    },
    changeValue: function changeValue() {
      this.valueRadio = this.value;
    },
    selectedItem: function selectedItem() {
      var _this = this;
      var itemSelected = _toConsumableArray$1(this.options).map(function (item) {
        if (item.value === _this.value) {
          return _objectSpread$4({}, item);
        }
        return false;
      }).filter(function (item) {
        return !!item;
      });
      return itemSelected[0];
    }
  },
  mounted: function mounted() {
    this.changeValue();
  }
};

/* script */
var __vue_script__$x = script$x;

/* template */
var __vue_render__$x = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('fieldset', {
    class: ['aq-radio-group', 'aq-radio-group--' + _vm.getOrientation, {
      'aq-radio-group--radio-button': _vm.getType === 'radiobutton'
    }, {
      'aq-radio-group--radio': _vm.getType === 'radio'
    }, {
      'aq-radio-group--radio-card': _vm.getType === 'radiocard'
    }]
  }, [_vm.isLabelVisible ? _c('legend', {
    staticClass: "aq-radio-group__label"
  }, [_c('aq-label', _vm._b({}, 'aq-label', _vm.bindsLabel, false), [_vm._v(_vm._s(_vm.$aqT(_vm.label)))])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    class: ['aq-radio-group__options', 'aq-radio-group__options--' + _vm.getOrientation, {
      'aq-radio-group__shadow': _vm.getType === 'radiobutton'
    }],
    style: _vm.mixinSizeStyle
  }, [_vm.getType === 'radiocard' ? _vm._l(_vm.options, function (item, i) {
    return _c('aq-radio-card', {
      key: i,
      attrs: {
        "label": item.label,
        "valueRadio": item.value,
        "urlImage": item.urlImage,
        "icon": item.icon,
        "vertical": _vm.isVertical,
        "disabled": _vm.disabled || item.disabled,
        "helperText": item.subLabel
      },
      model: {
        value: _vm.valueRadio,
        callback: function callback($$v) {
          _vm.valueRadio = $$v;
        },
        expression: "valueRadio"
      }
    });
  }) : _vm._e(), _vm._v(" "), _vm.getType === 'radiobutton' ? _vm._l(_vm.options, function (item, i) {
    return _c('aq-radio-button', {
      key: i,
      attrs: {
        "label": item.label,
        "valueRadio": item.value,
        "vertical": _vm.isVertical,
        "icon": item.icon,
        "position": _vm.getPosition(i),
        "disabled": _vm.disabled || item.disabled,
        "last": i + 1 === _vm.getOptionsLength,
        "info": item.info,
        "tooltipWidth": item.tooltipWidth,
        "orientation": item.orientation
      },
      model: {
        value: _vm.valueRadio,
        callback: function callback($$v) {
          _vm.valueRadio = $$v;
        },
        expression: "valueRadio"
      }
    });
  }) : _vm._e(), _vm._v(" "), _vm.getType === 'radio' ? _vm._l(_vm.options, function (item, i) {
    return _c('aq-radio', {
      key: i,
      attrs: {
        "label": item.label,
        "valueRadio": item.value,
        "vertical": _vm.isVertical,
        "disabled": _vm.disabled || item.disabled,
        "info": item.info,
        "tooltipWidth": item.tooltipWidth,
        "icon": item.icon
      },
      model: {
        value: _vm.valueRadio,
        callback: function callback($$v) {
          _vm.valueRadio = $$v;
        },
        expression: "valueRadio"
      }
    });
  }) : _vm._e()], 2), _vm._v(" "), _vm.isHelperTextVisible ? _c('div', {
    staticClass: "aq-radio-group__helper-text"
  }, [_vm.isHelperTextVisible ? _c('aq-helper-text', _vm._b({}, 'aq-helper-text', _vm.bindsHelperText, false)) : _vm._e()], 1) : _vm._e()]);
};
var __vue_staticRenderFns__$x = [];

/* style */
var __vue_inject_styles__$x = undefined;
/* scoped */
var __vue_scope_id__$x = undefined;
/* module identifier */
var __vue_module_identifier__$x = undefined;
/* functional template */
var __vue_is_functional_template__$x = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$x = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$x,
  staticRenderFns: __vue_staticRenderFns__$x
}, __vue_inject_styles__$x, __vue_script__$x, __vue_scope_id__$x, __vue_is_functional_template__$x, __vue_module_identifier__$x, false, undefined, undefined, undefined);
var AqRadioGroup = __vue_component__$x;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$w = {
  name: 'aq-search-bar',
  data: function data() {
    return {
      text: '',
      icon: 'aq-icon-search',
      showButton: true
    };
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    isButton: {
      type: Boolean,
      default: true
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: [String, Function],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isLoading: function isLoading() {
      this.getButton();
    },
    disabled: function disabled() {
      this.getButton();
    },
    isButton: function isButton() {
      this.getButton();
    }
  },
  computed: {
    getValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        this.text = val;
        this.$emit('input', this.text);
      }
    }
  },
  methods: {
    openSearchBar: function openSearchBar() {
      this.showButton = false;
    },
    close: function close() {
      this.showButton = true;
      this.text = '';
    },
    getButton: function getButton() {
      if (this.disabled || this.isLoading) {
        this.showButton = true;
      } else {
        this.showButton = this.isButton;
      }
    }
  },
  mounted: function mounted() {
    this.getButton();
  }
};

/* script */
var __vue_script__$w = script$w;

/* template */
var __vue_render__$w = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-search-bar"
  }, [_vm.showButton ? _c('aq-button', {
    attrs: {
      "icon": _vm.icon,
      "isLoading": _vm.isLoading,
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.openSearchBar
    }
  }) : _vm._e(), _vm._v(" "), !_vm.showButton ? _c('aq-text-field', {
    attrs: {
      "placeholder": _vm.placeholder,
      "close": true,
      "disabled": _vm.disabled
    },
    on: {
      "clickClose": _vm.close
    },
    scopedSlots: _vm._u([{
      key: "leftcontent",
      fn: function fn() {
        return [_c('em', {
          class: _vm.icon
        })];
      },
      proxy: true
    }], null, false, 3525010279),
    model: {
      value: _vm.getValue,
      callback: function callback($$v) {
        _vm.getValue = $$v;
      },
      expression: "getValue"
    }
  }) : _vm._e()], 1);
};
var __vue_staticRenderFns__$w = [];

/* style */
var __vue_inject_styles__$w = undefined;
/* scoped */
var __vue_scope_id__$w = undefined;
/* module identifier */
var __vue_module_identifier__$w = undefined;
/* functional template */
var __vue_is_functional_template__$w = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$w = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$w,
  staticRenderFns: __vue_staticRenderFns__$w
}, __vue_inject_styles__$w, __vue_script__$w, __vue_scope_id__$w, __vue_is_functional_template__$w, __vue_module_identifier__$w, false, undefined, undefined, undefined);
var AqSearchBar = __vue_component__$w;

var vueSliderComponent_umd_min = {exports: {}};

(function (module, exports) {
(function(t,e){module.exports=e(Vue);})("undefined"!==typeof self?self:commonjsGlobal,(function(t){return function(t){var e={};function r(n){if(e[n])return e[n].exports;var o=e[n]={i:n,l:!1,exports:{}};return t[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}return r.m=t,r.c=e,r.d=function(t,e,n){r.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:n});},r.r=function(t){"undefined"!==typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0});},r.t=function(t,e){if(1&e&&(t=r(t)),8&e)return t;if(4&e&&"object"===typeof t&&t&&t.__esModule)return t;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)r.d(n,o,function(e){return t[e]}.bind(null,o));return n},r.n=function(t){var e=t&&t.__esModule?function(){return t["default"]}:function(){return t};return r.d(e,"a",e),e},r.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},r.p="",r(r.s="fb15")}({"091b":function(t,e,r){var n=r("24fb");e=n(!1),e.push([t.i,".vue-slider-dot{position:absolute;-webkit-transition:all 0s;transition:all 0s;z-index:5}.vue-slider-dot:focus{outline:none}.vue-slider-dot-tooltip{position:absolute;visibility:hidden}.vue-slider-dot-hover:hover .vue-slider-dot-tooltip,.vue-slider-dot-tooltip-show{visibility:visible}.vue-slider-dot-tooltip-top{top:-10px;left:50%;-webkit-transform:translate(-50%,-100%);transform:translate(-50%,-100%)}.vue-slider-dot-tooltip-bottom{bottom:-10px;left:50%;-webkit-transform:translate(-50%,100%);transform:translate(-50%,100%)}.vue-slider-dot-tooltip-left{left:-10px;top:50%;-webkit-transform:translate(-100%,-50%);transform:translate(-100%,-50%)}.vue-slider-dot-tooltip-right{right:-10px;top:50%;-webkit-transform:translate(100%,-50%);transform:translate(100%,-50%)}",""]),t.exports=e;},"24fb":function(t,e,r){function n(t,e){var r=t[1]||"",n=t[3];if(!n)return r;if(e&&"function"===typeof btoa){var i=o(n),a=n.sources.map((function(t){return "/*# sourceURL=".concat(n.sourceRoot||"").concat(t," */")}));return [r].concat(a).concat([i]).join("\n")}return [r].join("\n")}function o(t){var e=btoa(unescape(encodeURIComponent(JSON.stringify(t)))),r="sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(e);return "/*# ".concat(r," */")}t.exports=function(t){var e=[];return e.toString=function(){return this.map((function(e){var r=n(e,t);return e[2]?"@media ".concat(e[2]," {").concat(r,"}"):r})).join("")},e.i=function(t,r,n){"string"===typeof t&&(t=[[null,t,""]]);var o={};if(n)for(var i=0;i<this.length;i++){var a=this[i][0];null!=a&&(o[a]=!0);}for(var s=0;s<t.length;s++){var u=[].concat(t[s]);n&&o[u[0]]||(r&&(u[2]?u[2]="".concat(r," and ").concat(u[2]):u[2]=r),e.push(u));}},e};},2638:function(t,e,r){function n(){return n=Object.assign||function(t){for(var e,r=1;r<arguments.length;r++)for(var n in e=arguments[r],e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n]);return t},n.apply(this,arguments)}var o=["attrs","props","domProps"],i=["class","style","directives"],a=["on","nativeOn"],s=function(t){return t.reduce((function(t,e){for(var r in e)if(t[r])if(-1!==o.indexOf(r))t[r]=n({},t[r],e[r]);else if(-1!==i.indexOf(r)){var s=t[r]instanceof Array?t[r]:[t[r]],l=e[r]instanceof Array?e[r]:[e[r]];t[r]=s.concat(l);}else if(-1!==a.indexOf(r))for(var c in e[r])if(t[r][c]){var d=t[r][c]instanceof Array?t[r][c]:[t[r][c]],f=e[r][c]instanceof Array?e[r][c]:[e[r][c]];t[r][c]=d.concat(f);}else t[r][c]=e[r][c];else if("hook"==r)for(var h in e[r])t[r][h]=t[r][h]?u(t[r][h],e[r][h]):e[r][h];else t[r]=e[r];else t[r]=e[r];return t}),{})},u=function(t,e){return function(){t&&t.apply(this,arguments),e&&e.apply(this,arguments);}};t.exports=s;},"499e":function(t,e,r){function n(t,e){for(var r=[],n={},o=0;o<e.length;o++){var i=e[o],a=i[0],s=i[1],u=i[2],l=i[3],c={id:t+":"+o,css:s,media:u,sourceMap:l};n[a]?n[a].parts.push(c):r.push(n[a]={id:a,parts:[c]});}return r}r.r(e),r.d(e,"default",(function(){return p}));var o="undefined"!==typeof document;if("undefined"!==typeof DEBUG&&DEBUG&&!o)throw new Error("vue-style-loader cannot be used in a non-browser environment. Use { target: 'node' } in your Webpack config to indicate a server-rendering environment.");var i={},a=o&&(document.head||document.getElementsByTagName("head")[0]),s=null,u=0,l=!1,c=function(){},d=null,f="data-vue-ssr-id",h="undefined"!==typeof navigator&&/msie [6-9]\b/.test(navigator.userAgent.toLowerCase());function p(t,e,r,o){l=r,d=o||{};var a=n(t,e);return y(a),function(e){for(var r=[],o=0;o<a.length;o++){var s=a[o],u=i[s.id];u.refs--,r.push(u);}e?(a=n(t,e),y(a)):a=[];for(o=0;o<r.length;o++){u=r[o];if(0===u.refs){for(var l=0;l<u.parts.length;l++)u.parts[l]();delete i[u.id];}}}}function y(t){for(var e=0;e<t.length;e++){var r=t[e],n=i[r.id];if(n){n.refs++;for(var o=0;o<n.parts.length;o++)n.parts[o](r.parts[o]);for(;o<r.parts.length;o++)n.parts.push(m(r.parts[o]));n.parts.length>r.parts.length&&(n.parts.length=r.parts.length);}else {var a=[];for(o=0;o<r.parts.length;o++)a.push(m(r.parts[o]));i[r.id]={id:r.id,refs:1,parts:a};}}}function v(){var t=document.createElement("style");return t.type="text/css",a.appendChild(t),t}function m(t){var e,r,n=document.querySelector("style["+f+'~="'+t.id+'"]');if(n){if(l)return c;n.parentNode.removeChild(n);}if(h){var o=u++;n=s||(s=v()),e=g.bind(null,n,o,!1),r=g.bind(null,n,o,!0);}else n=v(),e=k.bind(null,n),r=function(){n.parentNode.removeChild(n);};return e(t),function(n){if(n){if(n.css===t.css&&n.media===t.media&&n.sourceMap===t.sourceMap)return;e(t=n);}else r();}}var b=function(){var t=[];return function(e,r){return t[e]=r,t.filter(Boolean).join("\n")}}();function g(t,e,r,n){var o=r?"":n.css;if(t.styleSheet)t.styleSheet.cssText=b(e,o);else {var i=document.createTextNode(o),a=t.childNodes;a[e]&&t.removeChild(a[e]),a.length?t.insertBefore(i,a[e]):t.appendChild(i);}}function k(t,e){var r=e.css,n=e.media,o=e.sourceMap;if(n&&t.setAttribute("media",n),d.ssrId&&t.setAttribute(f,e.id),o&&(r+="\n/*# sourceURL="+o.sources[0]+" */",r+="\n/*# sourceMappingURL=data:application/json;base64,"+btoa(unescape(encodeURIComponent(JSON.stringify(o))))+" */"),t.styleSheet)t.styleSheet.cssText=r;else {while(t.firstChild)t.removeChild(t.firstChild);t.appendChild(document.createTextNode(r));}}},"4abb":function(t,e,r){var n=r("7a57");"string"===typeof n&&(n=[[t.i,n,""]]),n.locals&&(t.exports=n.locals);var o=r("499e").default;o("b2af7572",n,!0,{sourceMap:!1,shadowMode:!1});},"4ed8":function(t,e,r){var n=r("091b");"string"===typeof n&&(n=[[t.i,n,""]]),n.locals&&(t.exports=n.locals);var o=r("499e").default;o("2f6bee1a",n,!0,{sourceMap:!1,shadowMode:!1});},"556c":function(t,e,r){var n=r("eef2");"string"===typeof n&&(n=[[t.i,n,""]]),n.locals&&(t.exports=n.locals);var o=r("499e").default;o("1209fd47",n,!0,{sourceMap:!1,shadowMode:!1});},"65d9":function(t,e,r){/**
  * vue-class-component v7.0.1
  * (c) 2015-present Evan You
  * @license MIT
  */function n(t){return t&&"object"===typeof t&&"default"in t?t["default"]:t}Object.defineProperty(e,"__esModule",{value:!0});var o=n(r("8bbf")),i="undefined"!==typeof Reflect&&Reflect.defineMetadata&&Reflect.getOwnMetadataKeys;function a(t,e){s(t,e),Object.getOwnPropertyNames(e.prototype).forEach((function(r){s(t.prototype,e.prototype,r);})),Object.getOwnPropertyNames(e).forEach((function(r){s(t,e,r);}));}function s(t,e,r){var n=r?Reflect.getOwnMetadataKeys(e,r):Reflect.getOwnMetadataKeys(e);n.forEach((function(n){var o=r?Reflect.getOwnMetadata(n,e,r):Reflect.getOwnMetadata(n,e);r?Reflect.defineMetadata(n,o,t,r):Reflect.defineMetadata(n,o,t);}));}var u={__proto__:[]},l=u instanceof Array;function c(t){return function(e,r,n){var o="function"===typeof e?e:e.constructor;o.__decorators__||(o.__decorators__=[]),"number"!==typeof n&&(n=void 0),o.__decorators__.push((function(e){return t(e,r,n)}));}}function d(){for(var t=[],e=0;e<arguments.length;e++)t[e]=arguments[e];return o.extend({mixins:t})}function f(t){var e=typeof t;return null==t||"object"!==e&&"function"!==e}function h(t,e){var r=e.prototype._init;e.prototype._init=function(){var e=this,r=Object.getOwnPropertyNames(t);if(t.$options.props)for(var n in t.$options.props)t.hasOwnProperty(n)||r.push(n);r.forEach((function(r){"_"!==r.charAt(0)&&Object.defineProperty(e,r,{get:function(){return t[r]},set:function(e){t[r]=e;},configurable:!0});}));};var n=new e;e.prototype._init=r;var o={};return Object.keys(n).forEach((function(t){void 0!==n[t]&&(o[t]=n[t]);})),o}var p=["data","beforeCreate","created","beforeMount","mounted","beforeDestroy","destroyed","beforeUpdate","updated","activated","deactivated","render","errorCaptured","serverPrefetch"];function y(t,e){void 0===e&&(e={}),e.name=e.name||t._componentTag||t.name;var r=t.prototype;Object.getOwnPropertyNames(r).forEach((function(t){if("constructor"!==t)if(p.indexOf(t)>-1)e[t]=r[t];else {var n=Object.getOwnPropertyDescriptor(r,t);void 0!==n.value?"function"===typeof n.value?(e.methods||(e.methods={}))[t]=n.value:(e.mixins||(e.mixins=[])).push({data:function(){var e;return e={},e[t]=n.value,e}}):(n.get||n.set)&&((e.computed||(e.computed={}))[t]={get:n.get,set:n.set});}})),(e.mixins||(e.mixins=[])).push({data:function(){return h(this,t)}});var n=t.__decorators__;n&&(n.forEach((function(t){return t(e)})),delete t.__decorators__);var s=Object.getPrototypeOf(t.prototype),u=s instanceof o?s.constructor:o,l=u.extend(e);return v(l,t,u),i&&a(l,t),l}function v(t,e,r){Object.getOwnPropertyNames(e).forEach((function(n){if("prototype"!==n){var o=Object.getOwnPropertyDescriptor(t,n);if(!o||o.configurable){var i=Object.getOwnPropertyDescriptor(e,n);if(!l){if("cid"===n)return;var a=Object.getOwnPropertyDescriptor(r,n);if(!f(i.value)&&a&&a.value===i.value)return}Object.defineProperty(t,n,i);}}}));}function m(t){return "function"===typeof t?y(t):function(e){return y(e,t)}}m.registerHooks=function(t){p.push.apply(p,t);},e.default=m,e.createDecorator=c,e.mixins=d;},"7a57":function(t,e,r){var n=r("24fb");e=n(!1),e.push([t.i,".vue-slider{position:relative;-webkit-box-sizing:content-box;box-sizing:content-box;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;display:block;-webkit-tap-highlight-color:rgba(0,0,0,0)}.vue-slider-rail{position:relative;width:100%;height:100%;-webkit-transition-property:width,height,left,right,top,bottom;transition-property:width,height,left,right,top,bottom}.vue-slider-process{position:absolute;z-index:1}",""]),t.exports=e;},8875:function(t,e,r){var n,o,i;(function(r,a){o=[],n=a,i="function"===typeof n?n.apply(e,o):n,void 0===i||(t.exports=i);})("undefined"!==typeof self&&self,(function(){function t(){var e=Object.getOwnPropertyDescriptor(document,"currentScript");if(!e&&"currentScript"in document&&document.currentScript)return document.currentScript;if(e&&e.get!==t&&document.currentScript)return document.currentScript;try{throw new Error}catch(h){var r,n,o,i=/.*at [^(]*\((.*):(.+):(.+)\)$/gi,a=/@([^@]*):(\d+):(\d+)\s*$/gi,s=i.exec(h.stack)||a.exec(h.stack),u=s&&s[1]||!1,l=s&&s[2]||!1,c=document.location.href.replace(document.location.hash,""),d=document.getElementsByTagName("script");u===c&&(r=document.documentElement.outerHTML,n=new RegExp("(?:[^\\n]+?\\n){0,"+(l-2)+"}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*","i"),o=r.replace(n,"$1").trim());for(var f=0;f<d.length;f++){if("interactive"===d[f].readyState)return d[f];if(d[f].src===u)return d[f];if(u===c&&d[f].innerHTML&&d[f].innerHTML.trim()===o)return d[f]}return null}}return t}));},"8bbf":function(e,r){e.exports=t;},eef2:function(t,e,r){var n=r("24fb");e=n(!1),e.push([t.i,".vue-slider-marks{position:relative;width:100%;height:100%}.vue-slider-mark{position:absolute;z-index:1}.vue-slider-ltr .vue-slider-mark,.vue-slider-rtl .vue-slider-mark{width:0;height:100%;top:50%}.vue-slider-ltr .vue-slider-mark-step,.vue-slider-rtl .vue-slider-mark-step{top:0}.vue-slider-ltr .vue-slider-mark-label,.vue-slider-rtl .vue-slider-mark-label{top:100%;margin-top:10px}.vue-slider-ltr .vue-slider-mark{-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.vue-slider-ltr .vue-slider-mark-step{left:0}.vue-slider-ltr .vue-slider-mark-label{left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}.vue-slider-rtl .vue-slider-mark{-webkit-transform:translate(50%,-50%);transform:translate(50%,-50%)}.vue-slider-rtl .vue-slider-mark-step{right:0}.vue-slider-rtl .vue-slider-mark-label{right:50%;-webkit-transform:translateX(50%);transform:translateX(50%)}.vue-slider-btt .vue-slider-mark,.vue-slider-ttb .vue-slider-mark{width:100%;height:0;left:50%}.vue-slider-btt .vue-slider-mark-step,.vue-slider-ttb .vue-slider-mark-step{left:0}.vue-slider-btt .vue-slider-mark-label,.vue-slider-ttb .vue-slider-mark-label{left:100%;margin-left:10px}.vue-slider-btt .vue-slider-mark{-webkit-transform:translate(-50%,50%);transform:translate(-50%,50%)}.vue-slider-btt .vue-slider-mark-step{top:0}.vue-slider-btt .vue-slider-mark-label{top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.vue-slider-ttb .vue-slider-mark{-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.vue-slider-ttb .vue-slider-mark-step{bottom:0}.vue-slider-ttb .vue-slider-mark-label{bottom:50%;-webkit-transform:translateY(50%);transform:translateY(50%)}.vue-slider-mark-label,.vue-slider-mark-step{position:absolute}",""]),t.exports=e;},fb15:function(t,e,r){if(r.r(e),r.d(e,"ERROR_TYPE",(function(){return J})),r.d(e,"VueSliderMark",(function(){return U})),r.d(e,"VueSliderDot",(function(){return j})),"undefined"!==typeof window){var n=window.document.currentScript,o=r("8875");n=o(),"currentScript"in document||Object.defineProperty(document,"currentScript",{get:o});var i=n&&n.src.match(/(.+\/)[^/]+\.js(\?.*)?$/);i&&(r.p=i[1]);}var a=r("2638"),s=r.n(a);function u(t,e,r,n){var o,i=arguments.length,a=i<3?e:null===n?n=Object.getOwnPropertyDescriptor(e,r):n;if("object"===typeof Reflect&&"function"===typeof Reflect.decorate)a=Reflect.decorate(t,e,r,n);else for(var s=t.length-1;s>=0;s--)(o=t[s])&&(a=(i<3?o(a):i>3?o(e,r,a):o(e,r))||a);return i>3&&a&&Object.defineProperty(e,r,a),a}var l=r("8bbf"),c=r.n(l),d=r("65d9"),f=r.n(d);function h(t,e){return void 0===e&&(e={}),Object(d["createDecorator"])((function(r,n){(r.props||(r.props={}))[n]=e,r.model={prop:n,event:t||n};}))}function p(t){return void 0===t&&(t={}),Object(d["createDecorator"])((function(e,r){(e.props||(e.props={}))[r]=t;}))}function y(t,e){void 0===e&&(e={});var r=e.deep,n=void 0!==r&&r,o=e.immediate,i=void 0!==o&&o;return Object(d["createDecorator"])((function(e,r){"object"!==typeof e.watch&&(e.watch=Object.create(null));var o=e.watch;"object"!==typeof o[t]||Array.isArray(o[t])?"undefined"===typeof o[t]&&(o[t]=[]):o[t]=[o[t]],o[t].push({handler:r,deep:n,immediate:i});}))}r("4ed8");function v(t){return v="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"===typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},v(t)}function m(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function b(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n);}}function g(t,e,r){return e&&b(t.prototype,e),r&&b(t,r),t}function k(t,e){if("function"!==typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&O(t,e);}function O(t,e){return O=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t},O(t,e)}function x(t){var e=P();return function(){var r,n=D(t);if(e){var o=D(this).constructor;r=Reflect.construct(n,arguments,o);}else r=n.apply(this,arguments);return w(this,r)}}function w(t,e){return !e||"object"!==v(e)&&"function"!==typeof e?S(t):e}function S(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function P(){if("undefined"===typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"===typeof Proxy)return !0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return !1}}function D(t){return D=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)},D(t)}var R=function(){var t=function(t){k(r,t);var e=x(r);function r(){return m(this,r),e.apply(this,arguments)}return g(r,[{key:"dragStart",value:function(t){if(this.disabled)return !1;this.$emit("drag-start");}},{key:"render",value:function(){var t=arguments[0];return t("div",{ref:"dot",class:this.dotClasses,attrs:{"aria-valuetext":"number"===typeof this.tooltipValue?this.tooltipValue.toString():this.tooltipValue},on:{mousedown:this.dragStart,touchstart:this.dragStart}},[this.$slots.dot||t("div",{class:this.handleClasses,style:this.dotStyle}),"none"!==this.tooltip?t("div",{class:this.tooltipClasses},[this.$slots.tooltip||t("div",{class:this.tooltipInnerClasses,style:this.tooltipStyle},[t("span",{class:"vue-slider-dot-tooltip-text"},[this.tooltipValue])])]):null])}},{key:"dotClasses",get:function(){return ["vue-slider-dot",{"vue-slider-dot-hover":"hover"===this.tooltip||"active"===this.tooltip,"vue-slider-dot-disabled":this.disabled,"vue-slider-dot-focus":this.focus}]}},{key:"handleClasses",get:function(){return ["vue-slider-dot-handle",{"vue-slider-dot-handle-disabled":this.disabled,"vue-slider-dot-handle-focus":this.focus}]}},{key:"tooltipClasses",get:function(){return ["vue-slider-dot-tooltip",["vue-slider-dot-tooltip-".concat(this.tooltipPlacement)],{"vue-slider-dot-tooltip-show":this.showTooltip}]}},{key:"tooltipInnerClasses",get:function(){return ["vue-slider-dot-tooltip-inner",["vue-slider-dot-tooltip-inner-".concat(this.tooltipPlacement)],{"vue-slider-dot-tooltip-inner-disabled":this.disabled,"vue-slider-dot-tooltip-inner-focus":this.focus}]}},{key:"showTooltip",get:function(){switch(this.tooltip){case"always":return !0;case"none":return !1;case"focus":case"active":return !!this.focus;default:return !1}}},{key:"tooltipValue",get:function(){return this.tooltipFormatter?"string"===typeof this.tooltipFormatter?this.tooltipFormatter.replace(/\{value\}/,String(this.value)):this.tooltipFormatter(this.value):this.value}}]),r}(c.a);return u([p({default:0})],t.prototype,"value",void 0),u([p()],t.prototype,"tooltip",void 0),u([p()],t.prototype,"dotStyle",void 0),u([p()],t.prototype,"tooltipStyle",void 0),u([p({type:String,validator:function(t){return ["top","right","bottom","left"].indexOf(t)>-1},required:!0})],t.prototype,"tooltipPlacement",void 0),u([p({type:[String,Function]})],t.prototype,"tooltipFormatter",void 0),u([p({type:Boolean,default:!1})],t.prototype,"focus",void 0),u([p({default:!1})],t.prototype,"disabled",void 0),t=u([f()({name:"VueSliderDot"})],t),t}(),j=R;r("556c");function E(t){return E="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"===typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},E(t)}function A(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function V(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n);}}function M(t,e,r){return e&&V(t.prototype,e),r&&V(t,r),t}function _(t,e){if("function"!==typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&C(t,e);}function C(t,e){return C=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t},C(t,e)}function I(t){var e=B();return function(){var r,n=N(t);if(e){var o=N(this).constructor;r=Reflect.construct(n,arguments,o);}else r=n.apply(this,arguments);return L(this,r)}}function L(t,e){return !e||"object"!==E(e)&&"function"!==typeof e?T(t):e}function T(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function B(){if("undefined"===typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"===typeof Proxy)return !0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return !1}}function N(t){return N=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)},N(t)}var z,H=function(){var t=function(t){_(r,t);var e=I(r);function r(){return A(this,r),e.apply(this,arguments)}return M(r,[{key:"labelClickHandle",value:function(t){t.stopPropagation(),this.$emit("pressLabel",this.mark.pos);}},{key:"render",value:function(){var t=arguments[0],e=this.mark;return t("div",{class:this.marksClasses},[this.$slots.step||t("div",{class:this.stepClasses,style:[this.stepStyle||{},e.style||{},e.active&&this.stepActiveStyle||{},e.active&&e.activeStyle||{}]}),this.hideLabel?null:this.$slots.label||t("div",{class:this.labelClasses,style:[this.labelStyle||{},e.labelStyle||{},e.active&&this.labelActiveStyle||{},e.active&&e.labelActiveStyle||{}],on:{click:this.labelClickHandle}},[e.label])])}},{key:"marksClasses",get:function(){return ["vue-slider-mark",{"vue-slider-mark-active":this.mark.active}]}},{key:"stepClasses",get:function(){return ["vue-slider-mark-step",{"vue-slider-mark-step-active":this.mark.active}]}},{key:"labelClasses",get:function(){return ["vue-slider-mark-label",{"vue-slider-mark-label-active":this.mark.active}]}}]),r}(c.a);return u([p({required:!0})],t.prototype,"mark",void 0),u([p(Boolean)],t.prototype,"hideLabel",void 0),u([p()],t.prototype,"stepStyle",void 0),u([p()],t.prototype,"stepActiveStyle",void 0),u([p()],t.prototype,"labelStyle",void 0),u([p()],t.prototype,"labelActiveStyle",void 0),t=u([f()({name:"VueSlideMark"})],t),t}(),U=H,F=function(t){return "number"===typeof t?"".concat(t,"px"):t},$=function(t){var e=document.documentElement,r=document.body,n=t.getBoundingClientRect(),o={y:n.top+(window.pageYOffset||e.scrollTop)-(e.clientTop||r.clientTop||0),x:n.left+(window.pageXOffset||e.scrollLeft)-(e.clientLeft||r.clientLeft||0)};return o},W=function(t,e,r){var n=arguments.length>3&&void 0!==arguments[3]?arguments[3]:1,o="targetTouches"in t?t.targetTouches[0]:t,i=$(e),a={x:o.pageX-i.x,y:o.pageY-i.y};return {x:r?e.offsetWidth*n-a.x:a.x,y:r?e.offsetHeight*n-a.y:a.y}};(function(t){t[t["PAGE_UP"]=33]="PAGE_UP",t[t["PAGE_DOWN"]=34]="PAGE_DOWN",t[t["END"]=35]="END",t[t["HOME"]=36]="HOME",t[t["LEFT"]=37]="LEFT",t[t["UP"]=38]="UP",t[t["RIGHT"]=39]="RIGHT",t[t["DOWN"]=40]="DOWN";})(z||(z={}));var G=function(t,e){if(e.hook){var r=e.hook(t);if("function"===typeof r)return r;if(!r)return null}switch(t.keyCode){case z.UP:return function(t){return "ttb"===e.direction?t-1:t+1};case z.RIGHT:return function(t){return "rtl"===e.direction?t-1:t+1};case z.DOWN:return function(t){return "ttb"===e.direction?t+1:t-1};case z.LEFT:return function(t){return "rtl"===e.direction?t+1:t-1};case z.END:return function(){return e.max};case z.HOME:return function(){return e.min};case z.PAGE_UP:return function(t){return t+10};case z.PAGE_DOWN:return function(t){return t-10};default:return null}};function X(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function q(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n);}}function K(t,e,r){return e&&q(t.prototype,e),r&&q(t,r),t}var Y,J,Q=function(){function t(e){X(this,t),this.num=e;}return K(t,[{key:"decimal",value:function(t,e){var r=this.num,n=this.getDecimalLen(r),o=this.getDecimalLen(t),i=0;switch(e){case"+":i=this.getExponent(n,o),this.num=(this.safeRoundUp(r,i)+this.safeRoundUp(t,i))/i;break;case"-":i=this.getExponent(n,o),this.num=(this.safeRoundUp(r,i)-this.safeRoundUp(t,i))/i;break;case"*":this.num=this.safeRoundUp(this.safeRoundUp(r,this.getExponent(n)),this.safeRoundUp(t,this.getExponent(o)))/this.getExponent(n+o);break;case"/":i=this.getExponent(n,o),this.num=this.safeRoundUp(r,i)/this.safeRoundUp(t,i);break;case"%":i=this.getExponent(n,o),this.num=this.safeRoundUp(r,i)%this.safeRoundUp(t,i)/i;break}return this}},{key:"plus",value:function(t){return this.decimal(t,"+")}},{key:"minus",value:function(t){return this.decimal(t,"-")}},{key:"multiply",value:function(t){return this.decimal(t,"*")}},{key:"divide",value:function(t){return this.decimal(t,"/")}},{key:"remainder",value:function(t){return this.decimal(t,"%")}},{key:"toNumber",value:function(){return this.num}},{key:"getDecimalLen",value:function(t){var e="".concat(t).split("e");return ("".concat(e[0]).split(".")[1]||"").length-(e[1]?+e[1]:0)}},{key:"getExponent",value:function(t,e){return Math.pow(10,void 0!==e?Math.max(t,e):t)}},{key:"safeRoundUp",value:function(t,e){return Math.round(t*e)}}]),t}();function Z(t,e){var r=Object.keys(t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(t);e&&(n=n.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),r.push.apply(r,n);}return r}function tt(t){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{};e%2?Z(Object(r),!0).forEach((function(e){pt(t,e,r[e]);})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(r)):Z(Object(r)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(r,e));}));}return t}function et(t,e){return ot(t)||nt(t,e)||st(t,e)||rt()}function rt(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function nt(t,e){if("undefined"!==typeof Symbol&&Symbol.iterator in Object(t)){var r=[],n=!0,o=!1,i=void 0;try{for(var a,s=t[Symbol.iterator]();!(n=(a=s.next()).done);n=!0)if(r.push(a.value),e&&r.length===e)break}catch(u){o=!0,i=u;}finally{try{n||null==s["return"]||s["return"]();}finally{if(o)throw i}}return r}}function ot(t){if(Array.isArray(t))return t}function it(t){return lt(t)||ut(t)||st(t)||at()}function at(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function st(t,e){if(t){if("string"===typeof t)return ct(t,e);var r=Object.prototype.toString.call(t).slice(8,-1);return "Object"===r&&t.constructor&&(r=t.constructor.name),"Map"===r||"Set"===r?Array.from(t):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?ct(t,e):void 0}}function ut(t){if("undefined"!==typeof Symbol&&Symbol.iterator in Object(t))return Array.from(t)}function lt(t){if(Array.isArray(t))return ct(t)}function ct(t,e){(null==e||e>t.length)&&(e=t.length);for(var r=0,n=new Array(e);r<e;r++)n[r]=t[r];return n}function dt(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function ft(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n);}}function ht(t,e,r){return e&&ft(t.prototype,e),r&&ft(t,r),t}function pt(t,e,r){return e in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}(function(t){t[t["VALUE"]=1]="VALUE",t[t["INTERVAL"]=2]="INTERVAL",t[t["MIN"]=3]="MIN",t[t["MAX"]=4]="MAX",t[t["ORDER"]=5]="ORDER";})(J||(J={}));var yt=(Y={},pt(Y,J.VALUE,'The type of the "value" is illegal'),pt(Y,J.INTERVAL,'The prop "interval" is invalid, "(max - min)" must be divisible by "interval"'),pt(Y,J.MIN,'The "value" must be greater than or equal to the "min".'),pt(Y,J.MAX,'The "value" must be less than or equal to the "max".'),pt(Y,J.ORDER,'When "order" is false, the parameters "minRange", "maxRange", "fixed", "enabled" are invalid.'),Y),vt=function(){function t(e){dt(this,t),this.dotsPos=[],this.dotsValue=[],this.cacheRangeDir={},this.data=e.data,this.max=e.max,this.min=e.min,this.interval=e.interval,this.order=e.order,this.marks=e.marks,this.included=e.included,this.process=e.process,this.adsorb=e.adsorb,this.dotOptions=e.dotOptions,this.onError=e.onError,this.order?(this.minRange=e.minRange||0,this.maxRange=e.maxRange||0,this.enableCross=e.enableCross,this.fixed=e.fixed):((e.minRange||e.maxRange||!e.enableCross||e.fixed)&&this.emitError(J.ORDER),this.minRange=0,this.maxRange=0,this.enableCross=!0,this.fixed=!1),this.setValue(e.value);}return ht(t,[{key:"setValue",value:function(t){var e=this;this.setDotsValue(Array.isArray(t)?this.order?it(t).sort((function(t,r){return e.getIndexByValue(t)-e.getIndexByValue(r)})):it(t):[t],!0);}},{key:"setDotsValue",value:function(t,e){this.dotsValue=t,e&&this.syncDotsPos();}},{key:"setDotsPos",value:function(t){var e=this,r=this.order?it(t).sort((function(t,e){return t-e})):t;this.dotsPos=r,this.setDotsValue(r.map((function(t){return e.getValueByPos(t)})),this.adsorb);}},{key:"getValueByPos",value:function(t){var e=this.parsePos(t);if(this.included){var r=100;this.markList.forEach((function(n){var o=Math.abs(n.pos-t);o<r&&(r=o,e=n.value);}));}return e}},{key:"syncDotsPos",value:function(){var t=this;this.dotsPos=this.dotsValue.map((function(e){return t.parseValue(e)}));}},{key:"getRecentDot",value:function(t){var e=this,r=this.dotsPos.filter((function(t,r){return !(e.getDotOption(r)&&e.getDotOption(r).disabled)})).map((function(e){return Math.abs(e-t)}));return r.indexOf(Math.min.apply(Math,it(r)))}},{key:"getIndexByValue",value:function(t){return this.data?this.data.indexOf(t):new Q(+t).minus(this.min).divide(this.interval).toNumber()}},{key:"getValueByIndex",value:function(t){return t<0?t=0:t>this.total&&(t=this.total),this.data?this.data[t]:new Q(t).multiply(this.interval).plus(this.min).toNumber()}},{key:"setDotPos",value:function(t,e){t=this.getValidPos(t,e).pos;var r=t-this.dotsPos[e];if(r){var n=new Array(this.dotsPos.length);this.fixed?n=this.getFixedChangePosArr(r,e):this.minRange||this.maxRange?n=this.getLimitRangeChangePosArr(t,r,e):n[e]=r,this.setDotsPos(this.dotsPos.map((function(t,e){return t+(n[e]||0)})));}}},{key:"getFixedChangePosArr",value:function(t,e){var r=this;return this.dotsPos.forEach((function(n,o){if(o!==e){var i=r.getValidPos(n+t,o),a=i.pos,s=i.inRange;s||(t=Math.min(Math.abs(a-n),Math.abs(t))*(t<0?-1:1));}})),this.dotsPos.map((function(e){return t}))}},{key:"getLimitRangeChangePosArr",value:function(t,e,r){var n=this,o=[{index:r,changePos:e}],i=e;return [this.minRange,this.maxRange].forEach((function(a,s){if(!a)return !1;var u=0===s,l=e>0,c=0;c=u?l?1:-1:l?-1:1;var d=function(t,e){var r=Math.abs(t-e);return u?r<n.minRangeDir:r>n.maxRangeDir},f=r+c,h=n.dotsPos[f],p=t;while(n.isPos(h)&&d(h,p)){var y=n.getValidPos(h+i,f),v=y.pos;o.push({index:f,changePos:v-h}),f+=c,p=v,h=n.dotsPos[f];}})),this.dotsPos.map((function(t,e){var r=o.filter((function(t){return t.index===e}));return r.length?r[0].changePos:0}))}},{key:"isPos",value:function(t){return "number"===typeof t}},{key:"getValidPos",value:function(t,e){var r=this.valuePosRange[e],n=!0;return t<r[0]?(t=r[0],n=!1):t>r[1]&&(t=r[1],n=!1),{pos:t,inRange:n}}},{key:"parseValue",value:function(t){if(this.data)t=this.data.indexOf(t);else if("number"===typeof t||"string"===typeof t){if(t=+t,t<this.min)return this.emitError(J.MIN),0;if(t>this.max)return this.emitError(J.MAX),0;if("number"!==typeof t||t!==t)return this.emitError(J.VALUE),0;t=new Q(t).minus(this.min).divide(this.interval).toNumber();}var e=new Q(t).multiply(this.gap).toNumber();return e<0?0:e>100?100:e}},{key:"parsePos",value:function(t){var e=Math.round(t/this.gap);return this.getValueByIndex(e)}},{key:"isActiveByPos",value:function(t){return this.processArray.some((function(e){var r=et(e,2),n=r[0],o=r[1];return t>=n&&t<=o}))}},{key:"getValues",value:function(){if(this.data)return this.data;for(var t=[],e=0;e<=this.total;e++)t.push(new Q(e).multiply(this.interval).plus(this.min).toNumber());return t}},{key:"getRangeDir",value:function(t){return t?new Q(t).divide(new Q(this.data?this.data.length-1:this.max).minus(this.data?0:this.min).toNumber()).multiply(100).toNumber():100}},{key:"emitError",value:function(t){this.onError&&this.onError(t,yt[t]);}},{key:"getDotOption",value:function(t){return Array.isArray(this.dotOptions)?this.dotOptions[t]:this.dotOptions}},{key:"getDotRange",value:function(t,e,r){if(!this.dotOptions)return r;var n=this.getDotOption(t);return n&&void 0!==n[e]?this.parseValue(n[e]):r}},{key:"markList",get:function(){var t=this;if(!this.marks)return [];var e=function(e,r){var n=t.parseValue(e);return tt({pos:n,value:e,label:e,active:t.isActiveByPos(n)},r)};return !0===this.marks?this.getValues().map((function(t){return e(t)})):"[object Object]"===Object.prototype.toString.call(this.marks)?Object.keys(this.marks).sort((function(t,e){return +t-+e})).map((function(r){var n=t.marks[r];return e(r,"string"!==typeof n?n:{label:n})})):Array.isArray(this.marks)?this.marks.map((function(t){return e(t)})):"function"===typeof this.marks?this.getValues().map((function(e){return {value:e,result:t.marks(e)}})).filter((function(t){var e=t.result;return !!e})).map((function(t){var r=t.value,n=t.result;return e(r,n)})):[]}},{key:"processArray",get:function(){if(this.process){if("function"===typeof this.process)return this.process(this.dotsPos);if(1===this.dotsPos.length)return [[0,this.dotsPos[0]]];if(this.dotsPos.length>1)return [[Math.min.apply(Math,it(this.dotsPos)),Math.max.apply(Math,it(this.dotsPos))]]}return []}},{key:"total",get:function(){var t=0;return t=this.data?this.data.length-1:new Q(this.max).minus(this.min).divide(this.interval).toNumber(),t-Math.floor(t)!==0?(this.emitError(J.INTERVAL),0):t}},{key:"gap",get:function(){return 100/this.total}},{key:"minRangeDir",get:function(){return this.cacheRangeDir[this.minRange]?this.cacheRangeDir[this.minRange]:this.cacheRangeDir[this.minRange]=this.getRangeDir(this.minRange)}},{key:"maxRangeDir",get:function(){return this.cacheRangeDir[this.maxRange]?this.cacheRangeDir[this.maxRange]:this.cacheRangeDir[this.maxRange]=this.getRangeDir(this.maxRange)}},{key:"valuePosRange",get:function(){var t=this,e=this.dotsPos,r=[];return e.forEach((function(n,o){r.push([Math.max(t.minRange?t.minRangeDir*o:0,t.enableCross?0:e[o-1]||0,t.getDotRange(o,"min",0)),Math.min(t.minRange?100-t.minRangeDir*(e.length-1-o):100,t.enableCross?100:e[o+1]||100,t.getDotRange(o,"max",100))]);})),r}},{key:"dotsIndex",get:function(){var t=this;return this.dotsValue.map((function(e){return t.getIndexByValue(e)}))}}]),t}();function mt(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function bt(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n);}}function gt(t,e,r){return e&&bt(t.prototype,e),r&&bt(t,r),t}var kt=function(){function t(e){mt(this,t),this.states=0,this.map=e;}return gt(t,[{key:"add",value:function(t){this.states|=t;}},{key:"delete",value:function(t){this.states&=~t;}},{key:"toggle",value:function(t){this.has(t)?this.delete(t):this.add(t);}},{key:"has",value:function(t){return !!(this.states&t)}}]),t}();r("4abb");function Ot(t,e){return St(t)||wt(t,e)||At(t,e)||xt()}function xt(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function wt(t,e){if("undefined"!==typeof Symbol&&Symbol.iterator in Object(t)){var r=[],n=!0,o=!1,i=void 0;try{for(var a,s=t[Symbol.iterator]();!(n=(a=s.next()).done);n=!0)if(r.push(a.value),e&&r.length===e)break}catch(u){o=!0,i=u;}finally{try{n||null==s["return"]||s["return"]();}finally{if(o)throw i}}return r}}function St(t){if(Array.isArray(t))return t}function Pt(t,e){var r=Object.keys(t);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(t);e&&(n=n.filter((function(e){return Object.getOwnPropertyDescriptor(t,e).enumerable}))),r.push.apply(r,n);}return r}function Dt(t){for(var e=1;e<arguments.length;e++){var r=null!=arguments[e]?arguments[e]:{};e%2?Pt(Object(r),!0).forEach((function(e){Rt(t,e,r[e]);})):Object.getOwnPropertyDescriptors?Object.defineProperties(t,Object.getOwnPropertyDescriptors(r)):Pt(Object(r)).forEach((function(e){Object.defineProperty(t,e,Object.getOwnPropertyDescriptor(r,e));}));}return t}function Rt(t,e,r){return e in t?Object.defineProperty(t,e,{value:r,enumerable:!0,configurable:!0,writable:!0}):t[e]=r,t}function jt(t){return Mt(t)||Vt(t)||At(t)||Et()}function Et(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}function At(t,e){if(t){if("string"===typeof t)return _t(t,e);var r=Object.prototype.toString.call(t).slice(8,-1);return "Object"===r&&t.constructor&&(r=t.constructor.name),"Map"===r||"Set"===r?Array.from(t):"Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)?_t(t,e):void 0}}function Vt(t){if("undefined"!==typeof Symbol&&Symbol.iterator in Object(t))return Array.from(t)}function Mt(t){if(Array.isArray(t))return _t(t)}function _t(t,e){(null==e||e>t.length)&&(e=t.length);for(var r=0,n=new Array(e);r<e;r++)n[r]=t[r];return n}function Ct(t){return Ct="function"===typeof Symbol&&"symbol"===typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"===typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t},Ct(t)}function It(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}function Lt(t,e){for(var r=0;r<e.length;r++){var n=e[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(t,n.key,n);}}function Tt(t,e,r){return e&&Lt(t.prototype,e),r&&Lt(t,r),t}function Bt(t,e){if("function"!==typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&Nt(t,e);}function Nt(t,e){return Nt=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t},Nt(t,e)}function zt(t){var e=Ft();return function(){var r,n=$t(t);if(e){var o=$t(this).constructor;r=Reflect.construct(n,arguments,o);}else r=n.apply(this,arguments);return Ht(this,r)}}function Ht(t,e){return !e||"object"!==Ct(e)&&"function"!==typeof e?Ut(t):e}function Ut(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function Ft(){if("undefined"===typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"===typeof Proxy)return !0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return !1}}function $t(t){return $t=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)},$t(t)}var Wt={None:0,Drag:2,Focus:4},Gt=4,Xt=function(){var t=function(t){Bt(r,t);var e=zt(r);function r(){var t;return It(this,r),t=e.apply(this,arguments),t.states=new kt(Wt),t.scale=1,t.focusDotIndex=0,t}return Tt(r,[{key:"isObjectData",value:function(t){return !!t&&"[object Object]"===Object.prototype.toString.call(t)}},{key:"isObjectArrayData",value:function(t){return !!t&&Array.isArray(t)&&t.length>0&&"object"===Ct(t[0])}},{key:"onValueChanged",value:function(){this.control&&!this.states.has(Wt.Drag)&&this.isNotSync&&(this.control.setValue(this.value),this.syncValueByPos());}},{key:"created",value:function(){this.initControl();}},{key:"mounted",value:function(){this.bindEvent();}},{key:"beforeDestroy",value:function(){this.unbindEvent();}},{key:"bindEvent",value:function(){document.addEventListener("touchmove",this.dragMove,{passive:!1}),document.addEventListener("touchend",this.dragEnd,{passive:!1}),document.addEventListener("mousedown",this.blurHandle),document.addEventListener("mousemove",this.dragMove,{passive:!1}),document.addEventListener("mouseup",this.dragEnd),document.addEventListener("mouseleave",this.dragEnd),document.addEventListener("keydown",this.keydownHandle);}},{key:"unbindEvent",value:function(){document.removeEventListener("touchmove",this.dragMove),document.removeEventListener("touchend",this.dragEnd),document.removeEventListener("mousedown",this.blurHandle),document.removeEventListener("mousemove",this.dragMove),document.removeEventListener("mouseup",this.dragEnd),document.removeEventListener("mouseleave",this.dragEnd),document.removeEventListener("keydown",this.keydownHandle);}},{key:"setScale",value:function(){var t=new Q(Math.floor(this.isHorizontal?this.$refs.rail.offsetWidth:this.$refs.rail.offsetHeight));void 0!==this.zoom&&t.multiply(this.zoom),t.divide(100),this.scale=t.toNumber();}},{key:"initControl",value:function(){var t=this;this.control=new vt({value:this.value,data:this.sliderData,enableCross:this.enableCross,fixed:this.fixed,max:this.max,min:this.min,interval:this.interval,minRange:this.minRange,maxRange:this.maxRange,order:this.order,marks:this.sliderMarks,included:this.included,process:this.process,adsorb:this.adsorb,dotOptions:this.dotOptions,onError:this.emitError}),this.syncValueByPos(),["data","enableCross","fixed","max","min","interval","minRange","maxRange","order","marks","process","adsorb","included","dotOptions"].forEach((function(e){t.$watch(e,(function(r){if("data"===e&&Array.isArray(t.control.data)&&Array.isArray(r)&&t.control.data.length===r.length&&r.every((function(e,r){return e===t.control.data[r]})))return !1;switch(e){case"data":case"dataLabel":case"dataValue":t.control.data=t.sliderData;break;case"mark":t.control.marks=t.sliderMarks;break;default:t.control[e]=r;}["data","max","min","interval"].indexOf(e)>-1&&t.control.syncDotsPos();}));}));}},{key:"syncValueByPos",value:function(){var t=this.control.dotsValue;this.isDiff(t,Array.isArray(this.value)?this.value:[this.value])&&this.$emit("change",1===t.length?t[0]:jt(t),this.focusDotIndex);}},{key:"isDiff",value:function(t,e){return t.length!==e.length||t.some((function(t,r){return t!==e[r]}))}},{key:"emitError",value:function(t,e){this.silent||console.error("[VueSlider error]: ".concat(e)),this.$emit("error",t,e);}},{key:"dragStartOnProcess",value:function(t){if(this.dragOnClick){this.setScale();var e=this.getPosByEvent(t),r=this.control.getRecentDot(e);if(this.dots[r].disabled)return;this.dragStart(r),this.control.setDotPos(e,this.focusDotIndex),this.lazy||this.syncValueByPos();}}},{key:"dragStart",value:function(t){this.focusDotIndex=t,this.setScale(),this.states.add(Wt.Drag),this.states.add(Wt.Focus),this.$emit("drag-start",this.focusDotIndex);}},{key:"dragMove",value:function(t){if(!this.states.has(Wt.Drag))return !1;t.preventDefault();var e=this.getPosByEvent(t);this.isCrossDot(e),this.control.setDotPos(e,this.focusDotIndex),this.lazy||this.syncValueByPos();var r=this.control.dotsValue;this.$emit("dragging",1===r.length?r[0]:jt(r),this.focusDotIndex);}},{key:"isCrossDot",value:function(t){if(this.canSort){var e=this.focusDotIndex,r=t;if(r>this.dragRange[1]?(r=this.dragRange[1],this.focusDotIndex++):r<this.dragRange[0]&&(r=this.dragRange[0],this.focusDotIndex--),e!==this.focusDotIndex){var n=this.$refs["dot-".concat(this.focusDotIndex)];n&&n.$el&&n.$el.focus(),this.control.setDotPos(r,e);}}}},{key:"dragEnd",value:function(t){var e=this;if(!this.states.has(Wt.Drag))return !1;setTimeout((function(){e.lazy&&e.syncValueByPos(),e.included&&e.isNotSync?e.control.setValue(e.value):e.control.syncDotsPos(),e.states.delete(Wt.Drag),e.useKeyboard&&!("targetTouches"in t)||e.states.delete(Wt.Focus),e.$emit("drag-end",e.focusDotIndex);}));}},{key:"blurHandle",value:function(t){if(!this.states.has(Wt.Focus)||!this.$refs.container||this.$refs.container.contains(t.target))return !1;this.states.delete(Wt.Focus);}},{key:"clickHandle",value:function(t){if(!this.clickable||this.disabled)return !1;if(!this.states.has(Wt.Drag)){this.setScale();var e=this.getPosByEvent(t);this.setValueByPos(e);}}},{key:"focus",value:function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0;this.states.add(Wt.Focus),this.focusDotIndex=t;}},{key:"blur",value:function(){this.states.delete(Wt.Focus);}},{key:"getValue",value:function(){var t=this.control.dotsValue;return 1===t.length?t[0]:t}},{key:"getIndex",value:function(){var t=this.control.dotsIndex;return 1===t.length?t[0]:t}},{key:"setValue",value:function(t){this.control.setValue(Array.isArray(t)?jt(t):[t]),this.syncValueByPos();}},{key:"setIndex",value:function(t){var e=this,r=Array.isArray(t)?t.map((function(t){return e.control.getValueByIndex(t)})):this.control.getValueByIndex(t);this.setValue(r);}},{key:"setValueByPos",value:function(t){var e=this,r=this.control.getRecentDot(t);if(this.disabled||this.dots[r].disabled)return !1;this.focusDotIndex=r,this.control.setDotPos(t,r),this.syncValueByPos(),this.useKeyboard&&this.states.add(Wt.Focus),setTimeout((function(){e.included&&e.isNotSync?e.control.setValue(e.value):e.control.syncDotsPos();}));}},{key:"keydownHandle",value:function(t){var e=this;if(!this.useKeyboard||!this.states.has(Wt.Focus))return !1;var r=this.included&&this.marks,n=G(t,{direction:this.direction,max:r?this.control.markList.length-1:this.control.total,min:0,hook:this.keydownHook});if(n){t.preventDefault();var o=-1,i=0;r?(this.control.markList.some((function(t,r){return t.value===e.control.dotsValue[e.focusDotIndex]&&(o=n(r),!0)})),o<0?o=0:o>this.control.markList.length-1&&(o=this.control.markList.length-1),i=this.control.markList[o].pos):(o=n(this.control.getIndexByValue(this.control.dotsValue[this.focusDotIndex])),i=this.control.parseValue(this.control.getValueByIndex(o))),this.isCrossDot(i),this.control.setDotPos(i,this.focusDotIndex),this.syncValueByPos();}}},{key:"getPosByEvent",value:function(t){return W(t,this.$refs.rail,this.isReverse,this.zoom)[this.isHorizontal?"x":"y"]/this.scale}},{key:"renderSlot",value:function(t,e,r,n){var o=this.$createElement,i=this.$scopedSlots[t];return i?n?i(e):o("template",{slot:t},[i(e)]):r}},{key:"render",value:function(){var t=this,e=arguments[0];return e("div",s()([{ref:"container",class:this.containerClasses,style:this.containerStyles,on:{click:this.clickHandle,touchstart:this.dragStartOnProcess,mousedown:this.dragStartOnProcess}},this.$attrs]),[e("div",{ref:"rail",class:"vue-slider-rail",style:this.railStyle},[this.processArray.map((function(r,n){return t.renderSlot("process",r,e("div",{class:"vue-slider-process",key:"process-".concat(n),style:r.style}),!0)})),this.sliderMarks?e("div",{class:"vue-slider-marks"},[this.control.markList.map((function(r,n){var o;return t.renderSlot("mark",r,e("vue-slider-mark",{key:"mark-".concat(n),attrs:{mark:r,hideLabel:t.hideLabel,stepStyle:t.stepStyle,stepActiveStyle:t.stepActiveStyle,labelStyle:t.labelStyle,labelActiveStyle:t.labelActiveStyle},style:(o={},Rt(o,t.isHorizontal?"height":"width","100%"),Rt(o,t.isHorizontal?"width":"height",t.tailSize),Rt(o,t.mainDirection,"".concat(r.pos,"%")),o),on:{pressLabel:function(e){return t.clickable&&t.setValueByPos(e)}}},[t.renderSlot("step",r,null),t.renderSlot("label",r,null)]),!0)}))]):null,this.dots.map((function(r,n){var o;return e("vue-slider-dot",{ref:"dot-".concat(n),key:"dot-".concat(n),attrs:Dt({value:r.value,disabled:r.disabled,focus:r.focus,"dot-style":[r.style,r.disabled?r.disabledStyle:null,r.focus?r.focusStyle:null],tooltip:r.tooltip||t.tooltip,"tooltip-style":[t.tooltipStyle,r.tooltipStyle,r.disabled?r.tooltipDisabledStyle:null,r.focus?r.tooltipFocusStyle:null],"tooltip-formatter":Array.isArray(t.sliderTooltipFormatter)?t.sliderTooltipFormatter[n]:t.sliderTooltipFormatter,"tooltip-placement":t.tooltipDirections[n],role:"slider","aria-valuenow":r.value,"aria-valuemin":t.min,"aria-valuemax":t.max,"aria-orientation":t.isHorizontal?"horizontal":"vertical",tabindex:"0"},t.dotAttrs),style:[t.dotBaseStyle,(o={},Rt(o,t.mainDirection,"".concat(r.pos,"%")),Rt(o,"transition","".concat(t.mainDirection," ").concat(t.animateTime,"s")),o)],on:{"drag-start":function(){return t.dragStart(n)}},nativeOn:{focus:function(){return !r.disabled&&t.focus(n)},blur:function(){return t.blur()}}},[t.renderSlot("dot",r,null),t.renderSlot("tooltip",r,null)])})),this.renderSlot("default",{value:this.getValue()},null,!0)])])}},{key:"tailSize",get:function(){return F((this.isHorizontal?this.height:this.width)||Gt)}},{key:"containerClasses",get:function(){return ["vue-slider",["vue-slider-".concat(this.direction)],{"vue-slider-disabled":this.disabled}]}},{key:"containerStyles",get:function(){var t=Array.isArray(this.dotSize)?this.dotSize:[this.dotSize,this.dotSize],e=Ot(t,2),r=e[0],n=e[1],o=this.width?F(this.width):this.isHorizontal?"auto":F(Gt),i=this.height?F(this.height):this.isHorizontal?F(Gt):"auto";return {padding:this.contained?"".concat(n/2,"px ").concat(r/2,"px"):this.isHorizontal?"".concat(n/2,"px 0"):"0 ".concat(r/2,"px"),width:o,height:i}}},{key:"processArray",get:function(){var t=this;return this.control.processArray.map((function(e,r){var n,o=Ot(e,3),i=o[0],a=o[1],s=o[2];if(i>a){var u=[a,i];i=u[0],a=u[1];}var l=t.isHorizontal?"width":"height";return {start:i,end:a,index:r,style:Dt(Dt((n={},Rt(n,t.isHorizontal?"height":"width","100%"),Rt(n,t.isHorizontal?"top":"left",0),Rt(n,t.mainDirection,"".concat(i,"%")),Rt(n,l,"".concat(a-i,"%")),Rt(n,"transitionProperty","".concat(l,",").concat(t.mainDirection)),Rt(n,"transitionDuration","".concat(t.animateTime,"s")),n),t.processStyle),s)}}))}},{key:"dotBaseStyle",get:function(){var t,e=Array.isArray(this.dotSize)?this.dotSize:[this.dotSize,this.dotSize],r=Ot(e,2),n=r[0],o=r[1];return t=this.isHorizontal?Rt({transform:"translate(".concat(this.isReverse?"50%":"-50%",", -50%)"),"-WebkitTransform":"translate(".concat(this.isReverse?"50%":"-50%",", -50%)"),top:"50%"},"ltr"===this.direction?"left":"right","0"):Rt({transform:"translate(-50%, ".concat(this.isReverse?"50%":"-50%",")"),"-WebkitTransform":"translate(-50%, ".concat(this.isReverse?"50%":"-50%",")"),left:"50%"},"btt"===this.direction?"bottom":"top","0"),Dt({width:"".concat(n,"px"),height:"".concat(o,"px")},t)}},{key:"mainDirection",get:function(){switch(this.direction){case"ltr":return "left";case"rtl":return "right";case"btt":return "bottom";case"ttb":return "top"}}},{key:"isHorizontal",get:function(){return "ltr"===this.direction||"rtl"===this.direction}},{key:"isReverse",get:function(){return "rtl"===this.direction||"btt"===this.direction}},{key:"tooltipDirections",get:function(){var t=this.tooltipPlacement||(this.isHorizontal?"top":"left");return Array.isArray(t)?t:this.dots.map((function(){return t}))}},{key:"dots",get:function(){var t=this;return this.control.dotsPos.map((function(e,r){return Dt({pos:e,index:r,value:t.control.dotsValue[r],focus:t.states.has(Wt.Focus)&&t.focusDotIndex===r,disabled:t.disabled,style:t.dotStyle},(Array.isArray(t.dotOptions)?t.dotOptions[r]:t.dotOptions)||{})}))}},{key:"animateTime",get:function(){return this.states.has(Wt.Drag)?0:this.duration}},{key:"canSort",get:function(){return this.order&&!this.minRange&&!this.maxRange&&!this.fixed&&this.enableCross}},{key:"sliderData",get:function(){var t=this;return this.isObjectArrayData(this.data)?this.data.map((function(e){return e[t.dataValue]})):this.isObjectData(this.data)?Object.keys(this.data):this.data}},{key:"sliderMarks",get:function(){var t=this;return this.marks?this.marks:this.isObjectArrayData(this.data)?function(e){var r={label:e};return t.data.some((function(n){return n[t.dataValue]===e&&(r.label=n[t.dataLabel],!0)})),r}:this.isObjectData(this.data)?this.data:void 0}},{key:"sliderTooltipFormatter",get:function(){var t=this;if(this.tooltipFormatter)return this.tooltipFormatter;if(this.isObjectArrayData(this.data))return function(e){var r=""+e;return t.data.some((function(n){return n[t.dataValue]===e&&(r=n[t.dataLabel],!0)})),r};if(this.isObjectData(this.data)){var e=this.data;return function(t){return e[t]}}}},{key:"isNotSync",get:function(){var t=this.control.dotsValue;return Array.isArray(this.value)?this.value.length!==t.length||this.value.some((function(e,r){return e!==t[r]})):this.value!==t[0]}},{key:"dragRange",get:function(){var t=this.dots[this.focusDotIndex-1],e=this.dots[this.focusDotIndex+1];return [t?t.pos:-1/0,e?e.pos:1/0]}}]),r}(c.a);return u([h("change",{default:0})],t.prototype,"value",void 0),u([p({type:Boolean,default:!1})],t.prototype,"silent",void 0),u([p({default:"ltr",validator:function(t){return ["ltr","rtl","ttb","btt"].indexOf(t)>-1}})],t.prototype,"direction",void 0),u([p({type:[Number,String]})],t.prototype,"width",void 0),u([p({type:[Number,String]})],t.prototype,"height",void 0),u([p({default:14})],t.prototype,"dotSize",void 0),u([p({default:!1})],t.prototype,"contained",void 0),u([p({type:Number,default:0})],t.prototype,"min",void 0),u([p({type:Number,default:100})],t.prototype,"max",void 0),u([p({type:Number,default:1})],t.prototype,"interval",void 0),u([p({type:Boolean,default:!1})],t.prototype,"disabled",void 0),u([p({type:Boolean,default:!0})],t.prototype,"clickable",void 0),u([p({type:Boolean,default:!1})],t.prototype,"dragOnClick",void 0),u([p({type:Number,default:.5})],t.prototype,"duration",void 0),u([p({type:[Object,Array]})],t.prototype,"data",void 0),u([p({type:String,default:"value"})],t.prototype,"dataValue",void 0),u([p({type:String,default:"label"})],t.prototype,"dataLabel",void 0),u([p({type:Boolean,default:!1})],t.prototype,"lazy",void 0),u([p({type:String,validator:function(t){return ["none","always","focus","hover","active"].indexOf(t)>-1},default:"active"})],t.prototype,"tooltip",void 0),u([p({type:[String,Array],validator:function(t){return (Array.isArray(t)?t:[t]).every((function(t){return ["top","right","bottom","left"].indexOf(t)>-1}))}})],t.prototype,"tooltipPlacement",void 0),u([p({type:[String,Array,Function]})],t.prototype,"tooltipFormatter",void 0),u([p({type:Boolean,default:!0})],t.prototype,"useKeyboard",void 0),u([p(Function)],t.prototype,"keydownHook",void 0),u([p({type:Boolean,default:!0})],t.prototype,"enableCross",void 0),u([p({type:Boolean,default:!1})],t.prototype,"fixed",void 0),u([p({type:Boolean,default:!0})],t.prototype,"order",void 0),u([p(Number)],t.prototype,"minRange",void 0),u([p(Number)],t.prototype,"maxRange",void 0),u([p({type:[Boolean,Object,Array,Function],default:!1})],t.prototype,"marks",void 0),u([p({type:[Boolean,Function],default:!0})],t.prototype,"process",void 0),u([p({type:[Number]})],t.prototype,"zoom",void 0),u([p(Boolean)],t.prototype,"included",void 0),u([p(Boolean)],t.prototype,"adsorb",void 0),u([p(Boolean)],t.prototype,"hideLabel",void 0),u([p()],t.prototype,"dotOptions",void 0),u([p()],t.prototype,"dotAttrs",void 0),u([p()],t.prototype,"railStyle",void 0),u([p()],t.prototype,"processStyle",void 0),u([p()],t.prototype,"dotStyle",void 0),u([p()],t.prototype,"tooltipStyle",void 0),u([p()],t.prototype,"stepStyle",void 0),u([p()],t.prototype,"stepActiveStyle",void 0),u([p()],t.prototype,"labelStyle",void 0),u([p()],t.prototype,"labelActiveStyle",void 0),u([y("value")],t.prototype,"onValueChanged",null),t=u([f()({name:"VueSlider",data:function(){return {control:null}},components:{VueSliderDot:j,VueSliderMark:U}})],t),t}(),qt=Xt;qt.VueSliderMark=U,qt.VueSliderDot=j;var Kt=qt;e["default"]=Kt;}})["default"]}));

}(vueSliderComponent_umd_min));

var VueSlider = /*@__PURE__*/getDefaultExportFromCjs(vueSliderComponent_umd_min.exports);

//
var script$v = {
  components: {
    VueSlider: VueSlider
  },
  mixins: [LabelMixin],
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: [Number, Array],
      default: function _default() {
        return [];
      }
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    interval: {
      type: Number,
      default: 1
    },
    label: {
      type: [String, Function],
      default: ''
    },
    type: {
      type: String,
      default: 'continous',
      validator: function validator(x) {
        return x.toLowerCase() === '' || x.toLowerCase() === 'continous' || x.toLowerCase() === 'discrete';
      }
    },
    dotOptions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    value: function value() {
      this.setValue();
    },
    valueSlider: function valueSlider() {
      this.$emit('input', this.valueSlider);
      this.$emit(EVENT_NAME_CHANGE, this.valueSlider);
    }
  },
  data: function data() {
    return {
      valueSlider: this.min > 0 ? this.min : 0,
      inlineStyles: {
        padding: '8px 0px',
        width: 'auto',
        height: '4px'
      }
    };
  },
  computed: {
    isMarks: function isMarks() {
      return this.type.toLowerCase() === 'discrete';
    },
    railStyle: function railStyle() {
      return this.disabled ? {
        background: '#F7F7F8'
      } : {
        background: '#EAEBEE'
      };
    },
    processStyle: function processStyle() {
      return this.disabled ? {
        background: '#9EC5FF'
      } : {
        background: '#0A5BFC'
      };
    }
  },
  methods: {
    setValue: function setValue() {
      this.valueSlider = this.value;
    }
  },
  mounted: function mounted() {
    this.setValue();
  }
};

/* script */
var __vue_script__$v = script$v;

/* template */
var __vue_render__$v = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-slider"
  }, [_vm.isLabelVisible ? _c('aq-label', _vm._b({}, 'aq-label', _vm.bindsLabel, false), [_vm._v(_vm._s(_vm.$aqT(_vm.label)))]) : _vm._e(), _vm._v(" "), _c('vue-slider', {
    style: _vm.inlineStyles,
    attrs: {
      "min": _vm.min,
      "max": _vm.max,
      "disabled": _vm.disabled,
      "marks": _vm.isMarks,
      "processStyle": _vm.processStyle,
      "railStyle": _vm.railStyle,
      "interval": _vm.interval,
      "dotOptions": _vm.dotOptions
    },
    scopedSlots: _vm._u([{
      key: "tooltip",
      fn: function fn(ref) {
        var value = ref.value;
        var focus = ref.focus;
        return [_c('div', {
          class: ['aq-slider__tooltip', {
            'aq-slider__tooltip--focus': focus,
            'aq-slider__tooltip--disabled': _vm.disabled
          }]
        }, [_vm._v("\n        " + _vm._s(value) + "\n      ")])];
      }
    }, {
      key: "dot",
      fn: function fn(ref) {
        var focus = ref.focus;
        return [_c('div', {
          class: ['aq-slider__dot', {
            'aq-slider__dot--focus': focus,
            'aq-slider__dot--disabled': _vm.disabled
          }]
        })];
      }
    }, {
      key: "step",
      fn: function fn(ref) {
        var active = ref.active;
        return [_c('div', {
          class: ['aq-slider__step', {
            'aq-slider__step--active': active
          }]
        })];
      }
    }]),
    model: {
      value: _vm.valueSlider,
      callback: function callback($$v) {
        _vm.valueSlider = $$v;
      },
      expression: "valueSlider"
    }
  }), _vm._v(" "), _c('div', {
    class: ['aq-slider__footer', {
      'aq-slider__footer--disabled': _vm.disabled
    }]
  }, [_c('div', [_vm._v(_vm._s(_vm.min))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.max))])])], 1);
};
var __vue_staticRenderFns__$v = [];

/* style */
var __vue_inject_styles__$v = undefined;
/* scoped */
var __vue_scope_id__$v = undefined;
/* module identifier */
var __vue_module_identifier__$v = undefined;
/* functional template */
var __vue_is_functional_template__$v = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$v = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$v,
  staticRenderFns: __vue_staticRenderFns__$v
}, __vue_inject_styles__$v, __vue_script__$v, __vue_scope_id__$v, __vue_is_functional_template__$v, __vue_module_identifier__$v, false, undefined, undefined, undefined);
var AqSlider = __vue_component__$v;

var script$u = {
  mixins: [LabelMixin, helperTextMixin],
  props: {
    cleanOnEscape: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    selectedsCounter: {
      type: Boolean,
      default: false
    },
    strict: {
      type: Boolean,
      default: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    id: {
      type: [String, Function],
      default: ''
    },
    sublabel: {
      type: [String, Function],
      default: ''
    },
    placeholder: {
      type: [String, Function],
      default: ''
    },
    sublabelIcon: {
      type: [String, Function],
      default: ''
    },
    icon: {
      onDelete: String,
      default: 'edit',
      validator: function validator(val) {
        return ['edit', 'delete'].indexOf(val.toLowerCase()) !== -1;
      }
    },
    maxShowSelect: {
      type: Number,
      default: -1
    },
    maxSelect: {
      type: Number,
      default: -1
    },
    allowSpaces: {
      type: Boolean,
      default: false
    },
    validator: {
      type: Function,
      default: function _default() {
        return true;
      }
    },
    plain: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: {
      deep: true,
      handler: function handler(newVal, oldVal) {
        if (!this.compareValue(newVal, oldVal)) {
          this.values = newVal;
        }
      }
    }
  },
  data: function data() {
    return {
      uid: this.id,
      events: EVENTS,
      inputFocus: false,
      inputActive: false,
      values: [],
      valueInput: ''
    };
  },
  computed: {
    showIcon: function showIcon() {
      return this.icon !== '';
    },
    amountOtherOptons: function amountOtherOptons() {
      var _this$values;
      var amount = 0;
      if (this.maxShowSelect > -1 && ((_this$values = this.values) === null || _this$values === void 0 ? void 0 : _this$values.length) - this.maxShowSelect > 0) {
        if (this.maxShowSelect === 0) {
          var _this$values2;
          amount = (_this$values2 = this.values) === null || _this$values2 === void 0 ? void 0 : _this$values2.length;
        } else {
          var _this$values3;
          amount = ((_this$values3 = this.values) === null || _this$values3 === void 0 ? void 0 : _this$values3.length) - this.maxShowSelect;
        }
      }
      return amount;
    },
    selectOptionsToDisplay: function selectOptionsToDisplay() {
      var selectedItems = this.values;
      if (this.maxShowSelect > 0) {
        var _this$values4;
        selectedItems = (_this$values4 = this.values) === null || _this$values4 === void 0 ? void 0 : _this$values4.slice(0, this.maxShowSelect);
      } else if (this.maxShowSelect === 0) {
        selectedItems = [];
      }
      return selectedItems;
    },
    getCharcounter: function getCharcounter() {
      var _this$values5;
      return "".concat((_this$values5 = this.values) === null || _this$values5 === void 0 ? void 0 : _this$values5.length, "/").concat(this.maxSelect);
    },
    isCharCounterVisible: function isCharCounterVisible() {
      return this.selectedsCounter && this.maxSelect;
    },
    sublabelRequired: function sublabelRequired() {
      var _this$$aqT, _this$$aqT2;
      return this.required && ((_this$$aqT = this.$aqT(this.label)) === null || _this$$aqT === void 0 ? void 0 : _this$$aqT.length) === 0 && ((_this$$aqT2 = this.$aqT(this.sublabel)) === null || _this$$aqT2 === void 0 ? void 0 : _this$$aqT2.length) > 0;
    },
    getSublabelLength: function getSublabelLength() {
      var _this$$aqT3;
      return ((_this$$aqT3 = this.$aqT(this.sublabel)) === null || _this$$aqT3 === void 0 ? void 0 : _this$$aqT3.length) > 0;
    },
    getValuesLength: function getValuesLength() {
      var _this$values6;
      return (_this$values6 = this.values) === null || _this$values6 === void 0 ? void 0 : _this$values6.length;
    },
    showSublabelIcon: function showSublabelIcon() {
      return this.sublabelIcon !== '';
    }
  },
  methods: {
    emitValue: function emitValue() {
      this.$emit('input', this.values);
      this.$emit(EVENT_NAME_CHANGE, this.values);
    },
    compareValue: function compareValue(val1, val2) {
      var equals = (val1 === null || val1 === void 0 ? void 0 : val1.length) > 0;
      for (var i = 0; i < (val1 === null || val1 === void 0 ? void 0 : val1.length) && equals; i += 1) {
        if (val1[i] !== val2[i]) {
          equals = false;
        }
      }
      return equals;
    },
    focusInput: function focusInput() {
      this.$refs.input.focus();
    },
    onEnterEvent: function onEnterEvent(event) {
      if (event === 'enter' && !this.allowSpaces || event === 'space' && this.allowSpaces) {
        var _this$valueInput;
        this.valueInput = event === 'space' ? (_this$valueInput = this.valueInput) === null || _this$valueInput === void 0 ? void 0 : _this$valueInput.trim() : this.valueInput;
        if (this.validateInputValue() && this.validateMaxSelection() && this.validator(this.valueInput)) {
          this.values.push(this.valueInput);
          this.valueInput = '';
          this.emitValue();
        }
      }
    },
    onDeleteEvent: function onDeleteEvent() {
      var _this$valueInput2,
        _this$values7,
        _this = this;
      if (((_this$valueInput2 = this.valueInput) === null || _this$valueInput2 === void 0 ? void 0 : _this$valueInput2.length) === 0 && ((_this$values7 = this.values) === null || _this$values7 === void 0 ? void 0 : _this$values7.length) > 0) {
        var _this$deleteItem = this.deleteItem(-1),
          _this$deleteItem2 = _slicedToArray(_this$deleteItem, 1),
          item = _this$deleteItem2[0];
        if (this.onDelete === 'edit') {
          setTimeout(function () {
            _this.valueInput = item;
          });
        }
      }
    },
    onEscEvent: function onEscEvent() {
      if (this.cleanOnEscape) {
        this.valueInput = '';
        this.values = [];
        this.emitValue();
      }
    },
    deleteItem: function deleteItem(index) {
      var _this$values8;
      var newVal = (_this$values8 = this.values) === null || _this$values8 === void 0 ? void 0 : _this$values8.splice(index, 1);
      this.emitValue();
      return newVal;
    },
    cleanSelections: function cleanSelections() {
      this.values = [];
      this.emitValue();
    },
    validateInputValue: function validateInputValue() {
      var _this$valueInput3;
      return ((_this$valueInput3 = this.valueInput) === null || _this$valueInput3 === void 0 ? void 0 : _this$valueInput3.length) > 0;
    },
    validateMaxSelection: function validateMaxSelection() {
      var _this$values9;
      return !(this.maxSelect > 0 && this.strict && ((_this$values9 = this.values) === null || _this$values9 === void 0 ? void 0 : _this$values9.length) >= this.maxSelect);
    },
    validateId: function validateId() {
      var _this$id;
      this.uid = ((_this$id = this.id) === null || _this$id === void 0 ? void 0 : _this$id.length) > 0 ? this.id : AquaRamdomId('-tag-field');
    },
    keyup: function keyup(event) {
      this.$emit('keyup', event);
    },
    keypress: function keypress(event) {
      this.$emit('keypress', event);
    },
    focus: function focus(event) {
      this.inputFocus = true;
      this.$emit('focus', event);
    },
    blur: function blur(event) {
      this.inputFocus = false;
      this.$emit('blur', event);
    }
  },
  mounted: function mounted() {
    this.values = this.value;
    this.validateId();
  }
};

/* script */
var __vue_script__$u = script$u;

/* template */
var __vue_render__$u = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-tag-field"
  }, [_vm.isLabelVisible ? _c('aq-label', _vm._b({
    staticClass: "aq-tag-field__label",
    attrs: {
      "for": _vm.uid
    }
  }, 'aq-label', _vm.bindsLabel, false), [_vm._v("\n    " + _vm._s(_vm.$aqT(_vm.label)) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: ['aq-tag-field__input', {
      'aq-tag-field__input--focus': _vm.inputFocus,
      'aq-tag-field__input--active': _vm.inputActive,
      'aq-tag-field__input--error': _vm.error,
      'aq-tag-field__input--readonly': _vm.readonly,
      'aq-tag-field__input--disabled': _vm.disabled,
      'aq-tag-field__input--plain': _vm.plain
    }],
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) {
          return null;
        }
        return _vm.focusInput.apply(null, arguments);
      }
    }
  }, [_vm.getSublabelLength || _vm.showSublabelIcon ? _c('span', {
    staticClass: "aq-tag-field__sublabel",
    on: {
      "click": function click($event) {
        if ($event.target !== $event.currentTarget) {
          return null;
        }
        return _vm.focusInput.apply(null, arguments);
      }
    }
  }, [_vm.showSublabelIcon ? _c('em', {
    class: _vm.sublabelIcon
  }) : _vm._e(), _vm._v(" "), _vm.getSublabelLength ? _c('span', [_vm._v("\n        " + _vm._s(_vm.$aqT(_vm.sublabel))), _vm.sublabelRequired ? _c('span', {
    staticClass: "aq-label__requided"
  }, [_vm._v("*")]) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l(_vm.selectOptionsToDisplay, function (item, index) {
    return _c('aq-tag', {
      key: index,
      attrs: {
        "text": item,
        "close": !_vm.disabled && !_vm.readonly && !_vm.loading
      },
      on: _vm._d({}, [_vm.events.EVENT_NAME_CLOSE, function ($event) {
        return _vm.deleteItem(index);
      }])
    });
  }), _vm._v(" "), _vm.amountOtherOptons > 0 ? _c('aq-tag', {
    attrs: {
      "text": _vm.amountOtherOptons + ' Sel.',
      "close": !_vm.disabled && !_vm.readonly && !_vm.loading
    },
    on: _vm._d({}, [_vm.events.EVENT_NAME_CLOSE, function ($event) {
      return _vm.cleanSelections();
    }])
  }) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.valueInput,
      expression: "valueInput"
    }],
    ref: "input",
    attrs: {
      "autocomplete": "off",
      "id": _vm.uid,
      "type": "text",
      "icon": _vm.icon,
      "placeholder": _vm.placeholder,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "allowSpaces": _vm.allowSpaces
    },
    domProps: {
      "value": _vm.valueInput
    },
    on: {
      "focus": _vm.focus,
      "blur": _vm.blur,
      "mousedown": function mousedown($event) {
        _vm.inputActive = true;
      },
      "mouseup": function mouseup($event) {
        _vm.inputActive = false;
      },
      "keyup": [function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }
        return _vm.onEnterEvent('enter');
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) {
          return null;
        }
        return _vm.onEnterEvent('space');
      }, function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) {
          return null;
        }
        return _vm.onEscEvent.apply(null, arguments);
      }, _vm.keyup],
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "delete", [8, 46], $event.key, ["Backspace", "Delete", "Del"])) {
          return null;
        }
        return _vm.onDeleteEvent.apply(null, arguments);
      },
      "keypress": _vm.keypress,
      "input": function input($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.valueInput = $event.target.value;
      }
    }
  }), _vm._v(" "), _c('em', {
    class: ['aq-icon-close', 'aq-tag-field__icon-close', {
      'aq-tag-field__icon-close--active': _vm.getValuesLength > 0 && !_vm.disabled && !_vm.readonly
    }],
    attrs: {
      "canVisible": _vm.getValuesLength > 0 && !_vm.disabled && !_vm.readonly
    },
    on: {
      "click": function click($event) {
        return _vm.cleanSelections();
      }
    }
  })], 2), _vm._v(" "), _vm.isHelperTextVisible || _vm.isCharCounterVisible ? _c('div', {
    staticClass: "aq-text-field__footer"
  }, [_vm.isHelperTextVisible ? _c('div', {
    staticClass: "aq-text-field__helper-text"
  }, [_vm.isHelperTextVisible ? _c('aq-helper-text', _vm._b({}, 'aq-helper-text', _vm.bindsHelperText, false)) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.isCharCounterVisible ? _c('div', {
    staticClass: "aq-char-counter"
  }, [_vm._v("\n      " + _vm._s(_vm.getCharcounter) + "\n    ")]) : _vm._e()]) : _vm._e()], 1);
};
var __vue_staticRenderFns__$u = [];

/* style */
var __vue_inject_styles__$u = undefined;
/* scoped */
var __vue_scope_id__$u = undefined;
/* module identifier */
var __vue_module_identifier__$u = undefined;
/* functional template */
var __vue_is_functional_template__$u = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$u = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$u,
  staticRenderFns: __vue_staticRenderFns__$u
}, __vue_inject_styles__$u, __vue_script__$u, __vue_scope_id__$u, __vue_is_functional_template__$u, __vue_module_identifier__$u, false, undefined, undefined, undefined);
var AqTagField = __vue_component__$u;

function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

var ckeditor = {exports: {}};

/*! For license information please see ckeditor.js.LICENSE.txt */

(function (module, exports) {
/*!*
 * @license Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */
!function(t,e){module.exports=e();}(window,(function(){return function(t){var e={};function n(i){if(e[i])return e[i].exports;var r=e[i]={i:i,l:!1,exports:{}};return t[i].call(r.exports,r,r.exports,n),r.l=!0,r.exports}return n.m=t,n.c=e,n.d=function(t,e,i){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:i});},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0});},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var i=Object.create(null);if(n.r(i),Object.defineProperty(i,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var r in t)n.d(i,r,function(e){return t[e]}.bind(null,r));return i},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=0)}([function(t,e,n){t.exports=n(1);},function(t,e,n){function i(t,e){t.onload=function(){this.onerror=this.onload=null,e(null,t);},t.onerror=function(){this.onerror=this.onload=null,e(new Error("Failed to load "+this.src),t);};}function r(t,e){t.onreadystatechange=function(){"complete"!=this.readyState&&"loaded"!=this.readyState||(this.onreadystatechange=null,e(null,t));};}var o;function a(t,e){return "CKEDITOR"in window?Promise.resolve(CKEDITOR):"string"!=typeof t||t.length<1?Promise.reject(new TypeError("CKEditor URL must be a non-empty string.")):(o||(o=a.scriptLoader(t).then((function(t){return e&&e(t),t}))),o)}n.r(e),a.scriptLoader=function(t){return new Promise((function(e,n){!function(t,e,n){var o=document.head||document.getElementsByTagName("head")[0],a=document.createElement("script");"function"==typeof e&&(n=e,e={}),e=e||{},n=n||function(){},a.type=e.type||"text/javascript",a.charset=e.charset||"utf8",a.async=!("async"in e)||!!e.async,a.src=t,e.attrs&&function(t,e){for(var n in e)t.setAttribute(n,e[n]);}(a,e.attrs),e.text&&(a.text=String(e.text)),("onload"in a?i:r)(a,n),a.onload||i(a,n),o.appendChild(a);}(t,(function(t){return o=void 0,t?n(t):window.CKEDITOR?void e(CKEDITOR):n(new Error("Script loaded from editorUrl doesn't provide CKEDITOR namespace."))}));}))};var s={name:"ckeditor",render(t){return t("div",{},[t(this.tagName)])},props:{value:{type:String,default:""},type:{type:String,default:"classic",validator:t=>["classic","inline"].includes(t)},editorUrl:{type:String,default:"https://cdn.ckeditor.com/4.21.0/standard-all/ckeditor.js"},config:{type:Object,default:()=>{}},tagName:{type:String,default:"textarea"},readOnly:{type:Boolean,default:null},throttle:{type:Number,default:80}},mounted(){a(this.editorUrl,(t=>{this.$emit("namespaceloaded",t);})).then((()=>{if(this.$_destroyed)return;const t=this.prepareConfig(),e="inline"===this.type?"inline":"replace",n=this.$el.firstElementChild;CKEDITOR[e](n,t);}));},beforeDestroy(){this.instance&&this.instance.destroy(),this.$_destroyed=!0;},watch:{value(t){this.instance&&this.instance.getData()!==t&&this.instance.setData(t);},readOnly(t){this.instance&&this.instance.setReadOnly(t);}},methods:{prepareConfig(){const t=this.config||{};t.on=t.on||{},void 0===t.delayIfDetached&&(t.delayIfDetached=!0),null!==this.readOnly&&(t.readOnly=this.readOnly);const e=t.on.instanceReady;return t.on.instanceReady=t=>{this.instance=t.editor,this.$nextTick().then((()=>{this.prepareComponentData(),e&&e(t);}));},t},prepareComponentData(){const t=this.value;this.instance.fire("lockSnapshot"),this.instance.setData(t,{callback:()=>{this.$_setUpEditorEvents();const e=this.instance.getData();t!==e?(this.$once("input",(()=>{this.$emit("ready",this.instance);})),this.$emit("input",e)):this.$emit("ready",this.instance),this.instance.fire("unlockSnapshot");}});},$_setUpEditorEvents(){const t=this.instance,e=function(t,e){var n,i=arguments.length>2&&void 0!==arguments[2]?arguments[2]:{};return function(){clearTimeout(n);for(var r=arguments.length,o=new Array(r),a=0;a<r;a++)o[a]=arguments[a];n=setTimeout(t.bind.apply(t,[i].concat(o)),e);}}((e=>{const n=t.getData();this.value!==n&&this.$emit("input",n,e,t);}),this.throttle);t.on("change",e),t.on("focus",(e=>{this.$emit("focus",e,t);})),t.on("blur",(e=>{this.$emit("blur",e,t);}));}}};const c={install(t){t.component("ckeditor",s);},component:s};e.default=c;}]).default}));

}(ckeditor));

var CKEditor = /*@__PURE__*/getDefaultExportFromCjs(ckeditor.exports);

var _this4 = undefined;
function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$3(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var script$t = {
  components: {
    ckeditor: CKEditor.component
  },
  mixins: [LabelMixin, helperTextMixin],
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    label: {
      type: [String, Function],
      default: ''
    },
    field: {
      type: Object,
      default: null
    },
    type: String,
    'replacement-tags': {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    audios: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: {
      type: [String, Function],
      default: ''
    },
    height: {
      type: Number,
      required: true
    },
    toolbar: {
      type: Array,
      default: function _default() {
        return [{
          name: 'document',
          items: ['EmojiPanel', '-', 'Undo', 'Redo']
        }];
      }
    },
    extraPlugins: {
      type: String,
      default: ''
    },
    removePlugins: {
      type: String,
      default: 'elementspath'
    },
    hasWordCount: {
      type: Boolean,
      default: false
    },
    isPlainText: {
      type: Boolean,
      default: false
    },
    configCount: {
      type: Object,
      default: function _default() {
        return {
          showCharCount: true,
          showParagraphs: false,
          showWordCount: true,
          maxWordCount: 150,
          maxCharCount: 250
        };
      }
    },
    placeholderField: {
      type: Object,
      default: function _default() {
        return {
          replacementTags: ['asd'],
          callback: function callback() {
            console.log('Necesita agregar Tags de reemplazo');
          }
        };
      }
    },
    readonly: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    disabled: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    error: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    required: {
      type: Boolean,
      default: false
    },
    info: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      editorInput: '',
      range: {},
      codeEditor: {},
      editor: {},
      plugins: 'dialog, colorbutton, font, justify, widget, emoji, textmatch, autocomplete, xml, textwatcher, panel, floatpanel,',
      config: {
        removePlugins: 'resize, autogrow, ',
        language: this.$i18n ? this.$i18n.locale : 'es',
        allowedContent: true,
        toolbarCanCollapse: false,
        pasteFromWordRemoveFontStyles: false,
        wordcount: {},
        baseFloatZIndex: 15000,
        placeholderFieldFormat: {
          format: '{{%placeholder%}}',
          placeholders: this.placeholderField.replacementTags,
          callback: this.placeholderField.callback
        },
        placeholderAudio: {
          format: '{{audio:%placeholder%}}',
          placeholders: this.audios
        },
        enterMode: 1,
        codemirror: {
          autoCloseBrackets: true,
          autoCloseTags: true,
          autoFormatOnStart: false,
          autoFormatOnUncomment: false,
          autoFormatOnModeChange: false,
          continueComments: true,
          enableCodeFolding: true,
          enableCodeFormatting: true,
          enableSearchTools: false,
          highlightMatches: true,
          indentWithTabs: false,
          lineNumbers: true,
          lineWrapping: true,
          matchBrackets: true,
          matchTags: true,
          mode: 'htmlmixed',
          showAutoCompleteButton: true,
          showCommentButton: true,
          showFormatButton: true,
          showSearchButton: true,
          showTrailingSpace: true,
          showUncommentButton: true,
          styleActiveLine: true,
          theme: 'material',
          useBeautifyOnStart: false
        },
        removeDialogTabs: 'link:upload;image2:Upload'
      },
      focus: false
    };
  },
  watch: {
    field: function field(newVal) {
      if (newVal.value !== '') {
        this.validateTarget(newVal.target, newVal.value);
      }
    },
    type: function type(val) {
      this.editor.setData(this.value);
      this.editor.setMode(val);
    },
    config: function config() {
      this.resetEditor();
    },
    height: function height() {
      this.resetEditor();
    },
    readonly: function readonly() {
      this.resetEditor();
    },
    disabled: function disabled() {
      this.resetEditor();
    },
    value: function value(newVal) {
      var editorText = this.isPlainText ? this.getPlainText() : this.getText();
      if (newVal !== editorText) {
        this.editorInput = newVal;
      }
    },
    'placeholderField.replacementTags': {
      handler: function handler() {
        this.resetEditor();
      }
    },
    toolbar: {
      handler: function handler() {
        this.resetEditor();
      }
    },
    audios: {
      handler: function handler() {
        this.resetEditor();
      }
    },
    '$i18n.locale': {
      handler: function handler() {
        this.setLanguage();
        this.resetEditor();
      },
      deep: true
    },
    configCount: {
      handler: function handler() {
        this.resetEditor();
      },
      deep: true
    }
  },
  computed: {
    getConfig: function getConfig() {
      var config = _objectSpread$3(_objectSpread$3({}, this.config), {
        toolbar: this.toolbar
      });
      var _this$removePlugins = _toArray(this.removePlugins),
        removePlugins = _this$removePlugins.slice(0);
      removePlugins = removePlugins.join('');
      config.height = this.height;
      config.readOnly = this.readonly || this.disabled;
      config.callbackDialog = this.callbackDialog;
      config.editorplaceholder = this.placeholder;
      if (this.hasWordCount) {
        config.wordcount = this.configCount;
      }
      if (this.extraPlugins.indexOf('elementspath') !== -1) {
        removePlugins = removePlugins.replace('elementspath', '');
      }
      config.removePlugins = this.config.removePlugins.concat(removePlugins);
      config.extraPlugins = this.plugins.concat(this.extraPlugins);
      if (this.extraPlugins.indexOf('placeholderFieldFormat') !== -1) {
        config.placeholderFieldFormat.placeholders = this.placeholderField.replacementTags;
        config.placeholderFieldFormat.callback = this.placeholderField.callback;
      }
      if (this.extraPlugins.indexOf('placeholderAudio') !== -1) {
        config.placeholderAudio.placeholders = this.audios;
      }
      return config !== {} ? config : this.config;
    },
    editorUrl: function editorUrl() {
      // http://127.0.0.1:5500/ckeditor.js
      return "".concat(global.conf.aqua.URL_PLUGINS_TEXT_EDITOR, "/js/ckeditor/ckeditor.js");
    }
  },
  methods: {
    callbackDialog: function callbackDialog() {
      this.$aqDrawer.show('drawer-prueba-1');
    },
    getText: function getText() {
      var _this$editor;
      return ((_this$editor = this.editor) === null || _this$editor === void 0 ? void 0 : _this$editor.status) === 'ready' ? this.editor.getData() : this.value;
    },
    getPlainText: function getPlainText() {
      var _this$editor2;
      return ((_this$editor2 = this.editor) === null || _this$editor2 === void 0 ? void 0 : _this$editor2.status) === 'ready' ? this.editor.document.getBody().getText() : this.value;
    },
    setText: function setText(value) {
      this.editor.setData(value);
    },
    resetEditor: function resetEditor() {
      var _this = this;
      var CkeditorI = Vue.extend(CKEditor.component);
      var component = new CkeditorI().$mount();
      component.config = this.getConfig;
      component.value = this.value;
      component.$refs[this.id] = component;
      this.destroyEditor();
      this.$refs.container.replaceChild(component.$el, this.$refs.container.childNodes[1]);
      var processID = setInterval(function () {
        if (component.instance) {
          _this.editor = component.instance;
          _this.init();
          clearInterval(processID);
        }
      }, 100);
    },
    updateText: function updateText() {
      var value = this.isPlainText ? this.getPlainText() : this.getText();
      this.$emit('input', value);
    },
    insertValue: function insertValue(value) {
      if (this.editor.mode === 'source') {
        var doc = this.codeEditor.getDoc();
        var cursor = doc.getCursor();
        doc.replaceRange(value, cursor);
      } else {
        this.editor.insertHtml(value);
      }
    },
    destroyEditor: function destroyEditor() {
      if (this.editor) {
        this.editor.destroy();
      }
    },
    destroy: function destroy() {
      this.destroyEditor();
      this.$el.remove();
    },
    onNamespaceLoaded: function onNamespaceLoaded(CKEDITOR) {
      var _this2 = this;
      var publicPlugins = ['codemirror', 'urlfield', 'wordcount', 'placeholderFieldFormat', 'pastetext', 'placeholderAudio', 'image2', 'templatesfield', 'dropoff'];
      var filterExtraPlugins = function filterExtraPlugins(val) {
        return _this2.extraPlugins.match(val);
      };
      publicPlugins.forEach(function (x) {
        if (filterExtraPlugins(x) !== null) {
          switch (filterExtraPlugins(x)[0]) {
            case 'codemirror':
              CKEDITOR.plugins.addExternal('codemirror', "".concat(global.conf.aqua.URL_PLUGINS_TEXT_EDITOR, "/js/ckeditor/plugins/codemirror/"), 'codemirror.js');
              break;
            case 'urlfield':
              CKEDITOR.plugins.addExternal('urlfield', "".concat(global.conf.aqua.URL_PLUGINS_TEXT_EDITOR, "/js/ckeditor/plugins/url_field/"), 'url_field.js');
              break;
            case 'wordcount':
              CKEDITOR.plugins.addExternal('wordcount', "".concat(global.conf.aqua.URL_PLUGINS_TEXT_EDITOR, "/js/ckeditor/plugins/wordcount/"), 'wordcount.js');
              break;
            case 'pastetext':
              CKEDITOR.plugins.addExternal('pastetext', "".concat(global.conf.aqua.URL_PLUGINS_TEXT_EDITOR, "/js/ckeditor/plugins/pastetext/"), 'pastetext.js');
              break;
            case 'placeholderFieldFormat':
              CKEDITOR.plugins.addExternal('placeholderFieldFormat', "".concat(global.conf.aqua.URL_PLUGINS_TEXT_EDITOR, "/js/ckeditor/plugins/placeholder_field_format/"), 'placeholder_field_format.js');
              break;
            case 'placeholderAudio':
              CKEDITOR.plugins.addExternal('placeholderAudio', "".concat(global.conf.aqua.URL_PLUGINS_TEXT_EDITOR, "/js/ckeditor/plugins/placeholder_audio/"), 'placeholderAudio.js');
              break;
            case 'image2':
              CKEDITOR.plugins.addExternal('image2', "".concat(global.conf.aqua.URL_PLUGINS_TEXT_EDITOR, "/js/ckeditor/plugins/image2/"), 'plugin.js');
              break;
            case 'templatesfield':
              CKEDITOR.plugins.addExternal('templatesfield', "".concat(global.conf.aqua.URL_PLUGINS_TEXT_EDITOR, "/js/ckeditor/plugins/templates_field/"), 'templates_field.js');
              break;
            case 'dropoff':
              CKEDITOR.plugins.addExternal('dropoff', "".concat(global.conf.aqua.URL_PLUGINS_TEXT_EDITOR, "/js/ckeditor/plugins/dropoff/"), 'plugin.js');
              break;
            default:
              console.log("El plugin ".concat(x, " no esta disponible"));
          }
        }
      });
    },
    ready: function ready() {
      this.init();
      this.$emit('ready');
    },
    init: function init() {
      var _this3 = this;
      if (!this.editor || !this.editor.config) {
        this.editor = this.$refs[this.id].instance;
      }
      if (this.editor) {
        this.editorInput = this.value;
        this.editor.on('change', function () {
          _this3.updateText();
        });
        this.editor.on('mode', function (evt) {
          if (evt.editor.mode === 'source') {
            // setTimeout(() => {
            _this3.codeEditor = window["codemirror_".concat(evt.editor.id)];
            window["codemirror_".concat(evt.editor.id)].refresh();
            // }, 500);
          }
        });

        this.editor.on('focus', function () {
          _this3.focus = true;
          _this3.$emit('focus');
        });
        this.editor.on('blur', function () {
          _this3.focus = false;
          _this3.$emit('blur');
        });
        this.editor.setMode(this.type);
      }
    },
    validateTarget: function validateTarget(target, value) {
      if (target === _this4.id) {
        _this4.insertValue(value);
      }
    },
    setLanguage: function setLanguage() {
      this.config.language = this.$i18n ? this.$i18n.locale : 'es';
    }
  },
  mounted: function mounted() {
    global.aqua.getZIndex = getZIndex;
    global.aqua.deleteZIndex = deleteZIndex;
    this.init();
  },
  beforeDestroy: function beforeDestroy() {
    deleteZIndex('ckeditor-modal-prueba');
    if (this) {
      this.destroy();
    }
  }
};

/* script */
var __vue_script__$t = script$t;

/* template */
var __vue_render__$t = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    ref: "container",
    class: ['aq-text-editor', {
      'aq-text-editor--focus': _vm.focus,
      'aq-text-editor--error': _vm.error,
      'aq-text-editor--disabled': _vm.disabled,
      'aq-text-editor--readonly': _vm.readonly
    }]
  }, [_vm.isLabelVisible ? _c('aq-label', _vm._b({
    staticClass: "aq-text-editor__label",
    attrs: {
      "for": _vm.id
    }
  }, 'aq-label', _vm.bindsLabel, false), [_vm._v(_vm._s(_vm.$aqT(_vm.label)))]) : _vm._e(), _vm._v(" "), _c('ckeditor', {
    ref: _vm.id,
    attrs: {
      "config": _vm.getConfig,
      "id": _vm.id,
      "editorUrl": _vm.editorUrl
    },
    on: {
      "ready": _vm.ready,
      "namespaceloaded": _vm.onNamespaceLoaded
    },
    model: {
      value: _vm.editorInput,
      callback: function callback($$v) {
        _vm.editorInput = $$v;
      },
      expression: "editorInput"
    }
  }), _vm._v(" "), _vm.isHelperTextVisible ? _c('aq-helper-text', _vm._b({}, 'aq-helper-text', _vm.bindsHelperText, false)) : _vm._e()], 1);
};
var __vue_staticRenderFns__$t = [];

/* style */
var __vue_inject_styles__$t = undefined;
/* scoped */
var __vue_scope_id__$t = undefined;
/* module identifier */
var __vue_module_identifier__$t = undefined;
/* functional template */
var __vue_is_functional_template__$t = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$t = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$t,
  staticRenderFns: __vue_staticRenderFns__$t
}, __vue_inject_styles__$t, __vue_script__$t, __vue_scope_id__$t, __vue_is_functional_template__$t, __vue_module_identifier__$t, false, undefined, undefined, undefined);
var AqTextEditor = __vue_component__$t;

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$2(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var script$s = {
  mixins: [LabelMixin, helperTextMixin],
  props: {
    error: {
      type: Boolean,
      default: false
    },
    textarea: {
      type: Boolean,
      default: false
    },
    charCounter: {
      type: Boolean,
      default: false
    },
    strictMaxlength: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disclosure: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: [String, Function],
      default: ''
    },
    sublabel: {
      type: [String, Function],
      default: ''
    },
    value: {
      type: [String, Number],
      default: ''
    },
    id: {
      type: String,
      default: ''
    },
    stroke: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    autocomplete: {
      type: String,
      default: 'nope'
    },
    iconDisclosure: {
      type: String,
      default: 'aq-icon-chevron-down'
    },
    maxlength: {
      type: [Number, String],
      default: ''
    },
    height: {
      type: Number,
      default: 32
    },
    close: {
      type: Boolean,
      default: false
    },
    iconClose: {
      type: String,
      default: 'aq-icon-close'
    },
    showPassword: {
      type: Boolean,
      default: false
    },
    plain: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    valueInput: function valueInput() {
      this.emitValue();
    },
    value: function value() {
      this.setValue();
    },
    id: function id() {
      this.validateId();
    },
    sublabel: function sublabel() {
      this.onSubLabelChanged();
    },
    showPassword: function showPassword() {
      this.isShowPassword();
    },
    type: function type() {
      this.isShowPassword();
    }
  },
  data: function data() {
    return {
      valueInput: '',
      uid: this.id,
      observer: null,
      widthSubLabel: 0,
      styleInput: {
        textIndent: '0px'
      },
      focus: false,
      localType: 'text',
      visibilityOn: false
    };
  },
  computed: {
    getFieldType: function getFieldType() {
      return this.type;
    },
    paddingInput: function paddingInput() {
      var height = "".concat(this.textarea ? this.height : 30, "px");
      var style = {
        height: height
      };
      if (this.readonly && this.styleInput.textIndent === '0px') {
        return style;
      }
      return _objectSpread$2(_objectSpread$2({}, this.styleInput), style);
    },
    getCharcounter: function getCharcounter() {
      var _this$valueInput, _this$valueInput2;
      return this.maxlength !== '' ? "".concat((_this$valueInput = this.valueInput) === null || _this$valueInput === void 0 ? void 0 : _this$valueInput.length, "/").concat(this.maxlength) : "".concat((_this$valueInput2 = this.valueInput) === null || _this$valueInput2 === void 0 ? void 0 : _this$valueInput2.length);
    },
    isCharCounterVisible: function isCharCounterVisible() {
      return this.charCounter && this.maxlength !== 524288 && this.type !== 'number';
    },
    finalMaxlength: function finalMaxlength() {
      return this.strictMaxlength ? this.maxlength : 524288;
    },
    classStroke: function classStroke() {
      var classStrocke = '';
      if (this.stroke === 'plain') {
        classStrocke = 'aq-text-field--plain';
      }
      return classStrocke;
    },
    sublabelRequired: function sublabelRequired() {
      var _this$$aqT, _this$$aqT2;
      return this.required && ((_this$$aqT = this.$aqT(this.label)) === null || _this$$aqT === void 0 ? void 0 : _this$$aqT.length) === 0 && ((_this$$aqT2 = this.$aqT(this.sublabel)) === null || _this$$aqT2 === void 0 ? void 0 : _this$$aqT2.length) > 0;
    },
    getStateDelete: function getStateDelete() {
      return this.close && !this.disclosure && !this.showPassword;
    },
    showIcon: function showIcon() {
      return this.icon !== '' && !this.textarea;
    },
    isSublabel: function isSublabel() {
      var _this$$aqT3;
      return ((_this$$aqT3 = this.$aqT(this.sublabel)) === null || _this$$aqT3 === void 0 ? void 0 : _this$$aqT3.length) > 0;
    },
    getReadonly: function getReadonly() {
      return !this.error && !this.disabled && this.readonly;
    },
    getType: {
      get: function get() {
        return this.localType;
      },
      set: function set(type) {
        this.localType = type;
      }
    },
    getVisibilityIcon: function getVisibilityIcon() {
      return this.visibilityOn ? 'aq-icon-sight-on' : 'aq-icon-sight-off';
    },
    showIconPassword: function showIconPassword() {
      return this.showPassword && !this.textarea && !this.disabled && !this.readonly;
    },
    showIconDisclosure: function showIconDisclosure() {
      return this.disclosure && !this.close && !this.showPassword;
    },
    showStyleSublabel: function showStyleSublabel() {
      return this.readonly && !this.error && !this.disabled;
    }
  },
  methods: {
    emitValue: function emitValue() {
      this.$emit('input', this.valueInput);
      this.$emit(EVENT_NAME_CHANGE, this.valueInput);
    },
    onSubLabelChanged: function onSubLabelChanged() {
      var _this = this;
      Vue.nextTick(function () {
        var subLabel = _this.$refs.sublabel;
        _this.widthSubLabel = subLabel && subLabel.scrollWidth !== 0 ? subLabel.scrollWidth + 20 : 12;
        // this.styleInput.textIndent = `${this.widthSubLabel - 12}px`;
      });
    },
    validateId: function validateId() {
      var _this$id;
      this.uid = ((_this$id = this.id) === null || _this$id === void 0 ? void 0 : _this$id.length) > 0 ? this.id : AquaRamdomId('-text-field');
    },
    setValue: function setValue() {
      var value = "".concat(this.value);
      var emitNewVal = false;
      if (this.maxlength !== 524288 && this.maxlength !== '') {
        var _value, _ref;
        value = value.substring(0, this.maxlength);
        emitNewVal = ((_value = value) === null || _value === void 0 ? void 0 : _value.length) !== ((_ref = "".concat(this.value)) === null || _ref === void 0 ? void 0 : _ref.length);
      }
      this.valueInput = value;
      if (emitNewVal) {
        this.emitValue();
      }
    },
    rezise: function rezise(value) {
      if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
        this.onSubLabelChanged();
      }
    },
    addObserver: function addObserver() {
      this.observer = new index(this.rezise);
      this.observer.observe(this.$refs.sublabel);
    },
    rmObserver: function rmObserver() {
      if (this.observer) {
        this.observer.disconnect();
      }
    },
    onKeyUp: function onKeyUp(e) {
      this.$emit('keyup', e);
    },
    onKeyDown: function onKeyDown(e) {
      this.$emit('keydown', e);
    },
    onClickDisclosure: function onClickDisclosure() {
      this.$emit('clickDisclosure');
    },
    isLeftContentUsed: function isLeftContentUsed() {
      return typeof this.$slots.leftcontent !== 'undefined';
    },
    isRightContentUsed: function isRightContentUsed() {
      return typeof this.$slots.rightcontent !== 'undefined';
    },
    onClickClose: function onClickClose() {
      this.$emit('clickClose');
    },
    isShowPassword: function isShowPassword() {
      this.localType = this.showPassword ? 'password' : this.type;
    },
    showHidePassword: function showHidePassword() {
      if (!this.disabled) {
        this.localType = this.visibilityOn && this.showPassword ? 'password' : 'text';
        this.visibilityOn = !this.visibilityOn;
      }
    },
    onKeyPress: function onKeyPress(e) {
      this.$emit('keypress', e);
    }
  },
  mounted: function mounted() {
    this.setValue();
    this.validateId();
    this.onSubLabelChanged();
    this.addObserver();
    this.isShowPassword();
  },
  beforeDestroy: function beforeDestroy() {
    this.rmObserver();
  }
};

/* script */
var __vue_script__$s = script$s;

/* template */
var __vue_render__$s = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-text-field', _vm.classStroke]
  }, [_vm.isLabelVisible ? _c('aq-label', _vm._b({
    staticClass: "aq-text-field__label",
    attrs: {
      "for": _vm.uid
    }
  }, 'aq-label', _vm.bindsLabel, false), [_vm._v(_vm._s(_vm.$aqT(_vm.label)) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('div', {
    class: ['aq-text-field__container', {
      'aq-text-field__container--focus': _vm.focus,
      'aq-text-field__container--disabled': _vm.disabled,
      'aq-text-field__container--read-only': _vm.getReadonly,
      'aq-text-field__container--error': _vm.error,
      'aq-text-field__container--plain': _vm.plain
    }]
  }, [_c('label', {
    ref: "sublabel",
    class: ['aq-text-field__sublabel aq-text-field__container__leftLabel', {
      'aq-text-field__sublabel--readonly': _vm.showStyleSublabel
    }, {
      'aq-text-field__sublabel--maximize': !_vm.isLeftContentUsed()
    }],
    attrs: {
      "for": _vm.uid
    }
  }, [_vm.showIcon ? _c('em', {
    class: [_vm.icon, !_vm.isSublabel && 'aq-text-field__sublabel--paddingless']
  }) : _vm._e(), _vm._v(" "), _c('div', [_vm._t("sublabel", function () {
    return [_vm._v("\n          " + _vm._s(_vm.$aqT(_vm.sublabel)) + "\n          "), _vm.sublabelRequired ? _c('span', {
      staticClass: "aq-label__requided"
    }, [_vm._v("*")]) : _vm._e()];
  })], 2)]), _vm._v(" "), _c('label', {
    class: {
      'aq-text-field__container__leftcontent': _vm.isLeftContentUsed()
    },
    attrs: {
      "for": _vm.uid
    }
  }, [_vm._t("leftcontent")], 2), _vm._v(" "), _vm.getType === 'checkbox' && !_vm.textarea ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.valueInput,
      expression: "valueInput"
    }],
    class: ['aq-text-field__input', {
      'aq-text-field__input--onlytext': !_vm.isLeftContentUsed() && !_vm.isSublabel && !_vm.showIcon,
      'aq-text-field__input--error': _vm.error,
      'aq-text-field__input__leftcontent': _vm.isLeftContentUsed(),
      'aq-text-field__container--read-only': _vm.getReadonly,
      'aq-text-field__input--password': _vm.showPassword
    }],
    attrs: {
      "id": _vm.uid,
      "placeholder": _vm.$aqT(_vm.placeholder),
      "maxlength": _vm.finalMaxlength,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "required": _vm.required,
      "autocomplete": _vm.autocomplete,
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.valueInput) ? _vm._i(_vm.valueInput, null) > -1 : _vm.valueInput
    },
    on: {
      "keyup": function keyup($event) {
        return _vm.onKeyUp($event);
      },
      "keydown": function keydown($event) {
        return _vm.onKeyDown($event);
      },
      "focus": function focus($event) {
        _vm.focus = true;
      },
      "blur": function blur($event) {
        _vm.focus = false;
      },
      "keypress": function keypress($event) {
        return _vm.onKeyPress($event);
      },
      "change": function change($event) {
        var $$a = _vm.valueInput,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.valueInput = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.valueInput = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.valueInput = $$c;
        }
      }
    }
  }) : _vm.getType === 'radio' && !_vm.textarea ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.valueInput,
      expression: "valueInput"
    }],
    class: ['aq-text-field__input', {
      'aq-text-field__input--onlytext': !_vm.isLeftContentUsed() && !_vm.isSublabel && !_vm.showIcon,
      'aq-text-field__input--error': _vm.error,
      'aq-text-field__input__leftcontent': _vm.isLeftContentUsed(),
      'aq-text-field__container--read-only': _vm.getReadonly,
      'aq-text-field__input--password': _vm.showPassword
    }],
    attrs: {
      "id": _vm.uid,
      "placeholder": _vm.$aqT(_vm.placeholder),
      "maxlength": _vm.finalMaxlength,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "required": _vm.required,
      "autocomplete": _vm.autocomplete,
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.valueInput, null)
    },
    on: {
      "keyup": function keyup($event) {
        return _vm.onKeyUp($event);
      },
      "keydown": function keydown($event) {
        return _vm.onKeyDown($event);
      },
      "focus": function focus($event) {
        _vm.focus = true;
      },
      "blur": function blur($event) {
        _vm.focus = false;
      },
      "keypress": function keypress($event) {
        return _vm.onKeyPress($event);
      },
      "change": function change($event) {
        _vm.valueInput = null;
      }
    }
  }) : !_vm.textarea ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.valueInput,
      expression: "valueInput"
    }],
    class: ['aq-text-field__input', {
      'aq-text-field__input--onlytext': !_vm.isLeftContentUsed() && !_vm.isSublabel && !_vm.showIcon,
      'aq-text-field__input--error': _vm.error,
      'aq-text-field__input__leftcontent': _vm.isLeftContentUsed(),
      'aq-text-field__container--read-only': _vm.getReadonly,
      'aq-text-field__input--password': _vm.showPassword
    }],
    attrs: {
      "id": _vm.uid,
      "placeholder": _vm.$aqT(_vm.placeholder),
      "maxlength": _vm.finalMaxlength,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "required": _vm.required,
      "autocomplete": _vm.autocomplete,
      "type": _vm.getType
    },
    domProps: {
      "value": _vm.valueInput
    },
    on: {
      "keyup": function keyup($event) {
        return _vm.onKeyUp($event);
      },
      "keydown": function keydown($event) {
        return _vm.onKeyDown($event);
      },
      "focus": function focus($event) {
        _vm.focus = true;
      },
      "blur": function blur($event) {
        _vm.focus = false;
      },
      "keypress": function keypress($event) {
        return _vm.onKeyPress($event);
      },
      "input": function input($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.valueInput = $event.target.value;
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.textarea ? _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.valueInput,
      expression: "valueInput"
    }],
    class: ['aq-text-field__input', {
      'aq-text-field__input--error': _vm.error
    }],
    style: _vm.paddingInput,
    attrs: {
      "id": _vm.uid,
      "placeholder": _vm.$aqT(_vm.placeholder),
      "maxlength": _vm.finalMaxlength,
      "type": _vm.getType,
      "readonly": _vm.readonly,
      "disabled": _vm.disabled,
      "required": _vm.required,
      "autocomplete": _vm.autocomplete
    },
    domProps: {
      "value": _vm.valueInput
    },
    on: {
      "keyup": function keyup($event) {
        return _vm.onKeyUp($event);
      },
      "keydown": function keydown($event) {
        return _vm.onKeyDown($event);
      },
      "focus": function focus($event) {
        _vm.focus = true;
      },
      "blur": function blur($event) {
        _vm.focus = false;
      },
      "keypress": function keypress($event) {
        return _vm.onKeyPress($event);
      },
      "input": function input($event) {
        if ($event.target.composing) {
          return;
        }
        _vm.valueInput = $event.target.value;
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aq-text-field__disclosure"
  }, [_vm.showIconDisclosure ? _c('em', {
    class: "" + _vm.iconDisclosure,
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.onClickDisclosure
    }
  }) : _vm._e(), _vm._v(" "), _vm.getStateDelete ? _c('em', {
    class: " " + _vm.iconClose,
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.onClickClose
    }
  }) : _vm._e(), _vm._v(" "), _vm.showIconPassword ? _c('em', {
    class: "aq-text-field__disclosure--password " + _vm.getVisibilityIcon,
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.showHidePassword
    }
  }) : _vm._e()])]), _vm._v(" "), _vm.isHelperTextVisible || _vm.isCharCounterVisible ? _c('div', {
    staticClass: "aq-text-field__footer"
  }, [_vm.isHelperTextVisible ? _c('div', {
    staticClass: "aq-text-field__helper-text"
  }, [_vm.isHelperTextVisible ? _c('aq-helper-text', _vm._b({}, 'aq-helper-text', _vm.bindsHelperText, false)) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _vm.isCharCounterVisible ? _c('div', {
    staticClass: "aq-char-counter"
  }, [_vm._v("\n      " + _vm._s(_vm.getCharcounter) + "\n    ")]) : _vm._e()]) : _vm._e()], 1);
};
var __vue_staticRenderFns__$s = [];

/* style */
var __vue_inject_styles__$s = undefined;
/* scoped */
var __vue_scope_id__$s = undefined;
/* module identifier */
var __vue_module_identifier__$s = undefined;
/* functional template */
var __vue_is_functional_template__$s = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$s = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$s,
  staticRenderFns: __vue_staticRenderFns__$s
}, __vue_inject_styles__$s, __vue_script__$s, __vue_scope_id__$s, __vue_is_functional_template__$s, __vue_module_identifier__$s, false, undefined, undefined, undefined);
var AqTextField = __vue_component__$s;

//
var script$r = {
  data: function data() {
    return {
      hour: 0,
      minutes: 0,
      hour2: 0,
      minutes2: 0
    };
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    inline: {
      type: Boolean,
      default: false
    },
    maxTime: {
      type: String,
      default: ''
    },
    minTime: {
      type: String,
      default: ''
    },
    label: {
      type: [String, Function],
      default: ''
    }
  },
  computed: {
    optionsHour: function optionsHour() {
      var hours = [];
      for (var i = 1; i <= 24; i += 1) {
        hours.push({
          id: i,
          name: "".concat(numeral(i - 1).format('00')),
          disabled: this.disabledHour(i - 1)
        });
      }
      return hours;
    },
    optionsMinutes: function optionsMinutes() {
      var minutes = [];
      for (var i = 1; i <= 60; i += 1) {
        minutes.push({
          id: i,
          name: "".concat(numeral(i - 1).format('00')),
          disabled: this.disableMinutes(i - 1)
        });
      }
      return minutes;
    }
  },
  methods: {
    parseTime: function parseTime() {
      if (this.value) {
        this.hour = moment$1(this.value, 'HH:mm').hours();
        this.minutes = moment$1(this.value, 'HH:mm').minute();
      }
    },
    emitHours: function emitHours() {
      this.$emit('input', "".concat(numeral(this.hour).format('00'), ":").concat(numeral(this.minutes).format('00')));
    },
    getTimesBySplit: function getTimesBySplit(string) {
      var time = string.split(':');
      return {
        hour: parseInt(time[0], 10),
        minutes: parseInt(time[1], 10)
      };
    },
    disabledHour: function disabledHour(hour) {
      var maxHour = this.maxTime ? this.getTimesBySplit(this.maxTime).hour : null;
      var minHour = this.minTime ? this.getTimesBySplit(this.minTime).hour : null;
      if (minHour) {
        if (hour < minHour) {
          return true;
        }
      }
      if (maxHour) {
        if (hour > maxHour) {
          return true;
        }
      }
      return false;
    },
    disableMinutes: function disableMinutes(minutes) {
      var hour = this.hour;
      if (this.maxTime !== null) {
        var maxHour = this ? this.getTimesBySplit(this.maxTime).hour : null;
        var maxMinutes = this.maxTime ? this.getTimesBySplit(this.maxTime).minutes : null;
        if (maxHour) {
          if (hour === maxHour && minutes > maxMinutes) {
            return true;
          }
        }
      }
      if (this.minTime !== null) {
        var minHour = this.minTime ? this.getTimesBySplit(this.minTime).hour : null;
        var minMinutes = this.minTime ? this.getTimesBySplit(this.minTime).minutes : null;
        if (minHour) {
          if (hour === minHour && minutes < minMinutes) {
            return true;
          }
        }
      }
      return false;
    },
    getRawTime: function getRawTime() {
      return {
        hour: this.hour,
        minutes: this.minute
      };
    },
    setTimeMinMax: function setTimeMinMax(_val) {
      var minHour = this.minTime ? this.getTimesBySplit(this.minTime).hour : null;
      var minMinutes = this.minTime ? this.getTimesBySplit(this.minTime).minutes : null;
      if (minHour) {
        if (this.hour <= minHour) {
          this.hour = minHour;
          if (this.minutes <= minMinutes) {
            this.minutes = minMinutes;
          }
        }
      }
      var maxHour = this.maxTime ? this.getTimesBySplit(this.maxTime).hour : null;
      var maxMinutes = this.maxTime ? this.getTimesBySplit(this.maxTime).minutes : null;
      if (maxHour) {
        if (this.hour >= maxHour) {
          this.hour = maxHour;
          if (this.minutes >= maxMinutes) {
            this.minutes = maxMinutes;
          }
        }
      }
      if (_val) {
        this.emitHours();
      }
    }
  },
  watch: {
    value: function value() {
      this.parseTime();
    },
    minTime: function minTime() {
      this.setTimeMinMax(false);
    },
    maxTime: function maxTime() {
      this.setTimeMinMax(false);
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.parseTime();
    this.$watch(function () {
      return (
        // eslint-disable-next-line
        _this.hour, _this.minutes, Date.now()
      );
    }, function () {
      _this.setTimeMinMax(true);
    });
  }
};

/* script */
var __vue_script__$r = script$r;

/* template */
var __vue_render__$r = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-time-picker"
  }, [_c('span', [_c('em', {
    staticClass: "aq-icon-timer aq-time-picker-icon"
  }), _vm._v(" " + _vm._s(_vm.label))]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.hour,
      expression: "hour"
    }],
    staticClass: "aq-time-item aq-time-hour-select",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.hour = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, _vm._l(24, function (i) {
    return _c('option', {
      key: i - 1,
      attrs: {
        "disabled": _vm.disabledHour(i - 1)
      },
      domProps: {
        "value": i - 1
      }
    }, [_vm._v("\n      " + _vm._s(_vm.numeral(i - 1).format('00')) + "\n    ")]);
  }), 0), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.minutes,
      expression: "minutes"
    }],
    staticClass: "aq-time-item aq-date-minute-select",
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.minutes = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, _vm._l(60, function (i) {
    return _c('option', {
      key: i - 1,
      attrs: {
        "disabled": _vm.disableMinutes(i - 1)
      },
      domProps: {
        "value": i - 1
      }
    }, [_vm._v("\n      " + _vm._s(_vm.numeral(i - 1).format('00')) + "\n    ")]);
  }), 0)]);
};
var __vue_staticRenderFns__$r = [];

/* style */
var __vue_inject_styles__$r = undefined;
/* scoped */
var __vue_scope_id__$r = undefined;
/* module identifier */
var __vue_module_identifier__$r = undefined;
/* functional template */
var __vue_is_functional_template__$r = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$r = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$r,
  staticRenderFns: __vue_staticRenderFns__$r
}, __vue_inject_styles__$r, __vue_script__$r, __vue_scope_id__$r, __vue_is_functional_template__$r, __vue_module_identifier__$r, false, undefined, undefined, undefined);
var AqTimePicker = __vue_component__$r;

//
var script$q = {
  mixins: [helperTextMixin],
  props: {
    helperText: {
      type: [String, Function],
      default: ''
    },
    value: {
      type: Boolean,
      default: false
    },
    id: {
      type: String,
      default: ''
    },
    label: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    model: function model() {
      this.onModelChanged();
    },
    value: function value() {
      this.onValueChanged();
    },
    id: function id() {
      this.onIdChanged();
    }
  },
  data: function data() {
    return {
      model: this.value,
      uid: this.id
    };
  },
  methods: {
    onModelChanged: function onModelChanged() {
      this.$emit('input', this.model);
      this.$emit(EVENT_NAME_CHANGE, this.model);
    },
    onValueChanged: function onValueChanged() {
      this.model = this.value;
    },
    onIdChanged: function onIdChanged() {
      this.validateId();
    },
    validateId: function validateId() {
      var _this$id;
      this.uid = ((_this$id = this.id) === null || _this$id === void 0 ? void 0 : _this$id.length) > 0 ? this.id : AquaRamdomId('-toggle');
    }
  },
  mounted: function mounted() {
    this.validateId();
  }
};

/* script */
var __vue_script__$q = script$q;

/* template */
var __vue_render__$q = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-toggle', _vm.disabled && 'aq-toggle--disabled']
  }, [_c('div', {
    staticClass: "aq-toggle__content"
  }, [_c('label', {
    staticClass: "aq-toggle__element"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.model,
      expression: "model"
    }],
    attrs: {
      "type": "checkbox",
      "id": _vm.uid,
      "disabled": _vm.disabled
    },
    domProps: {
      "checked": Array.isArray(_vm.model) ? _vm._i(_vm.model, null) > -1 : _vm.model
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.model,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.model = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.model = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.model = $$c;
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "aq-toggle__slider"
  })]), _vm._v(" "), _vm.label ? _c('label', {
    staticClass: "aq-toggle__label",
    attrs: {
      "for": _vm.uid
    }
  }, [_vm.model ? [_vm._t("on", function () {
    return [_vm._v("On")];
  })] : [_vm._t("off", function () {
    return [_vm._v("Off")];
  })]], 2) : _vm._e()]), _vm._v(" "), _vm.isHelperTextVisible ? _c('div', {
    staticClass: "aq-toggle__helper-text"
  }, [_vm.isHelperTextVisible ? _c('aq-helper-text', _vm._b({}, 'aq-helper-text', _vm.bindsHelperText, false)) : _vm._e()], 1) : _vm._e()]);
};
var __vue_staticRenderFns__$q = [];

/* style */
var __vue_inject_styles__$q = undefined;
/* scoped */
var __vue_scope_id__$q = undefined;
/* module identifier */
var __vue_module_identifier__$q = undefined;
/* functional template */
var __vue_is_functional_template__$q = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$q = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$q,
  staticRenderFns: __vue_staticRenderFns__$q
}, __vue_inject_styles__$q, __vue_script__$q, __vue_scope_id__$q, __vue_is_functional_template__$q, __vue_module_identifier__$q, false, undefined, undefined, undefined);
var AqToggle = __vue_component__$q;

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var script$p = {
  name: 'aq-list-group',
  components: {
    draggable: draggable
  },
  mixins: [LabelMixin, helperTextMixin],
  directives: {
    DynamicEvents: {
      bind: function bind(el, binding, vnode) {
        var allEvents = binding.value;
        allEvents.forEach(function (event) {
          vnode.componentInstance.$on(event, function (eventData) {
            var _vnode$data$attrs, _vnode$data$attrs2, _vnode$componentInsta;
            var data = {
              event: event,
              value: eventData,
              element: (_vnode$data$attrs = vnode.data.attrs) === null || _vnode$data$attrs === void 0 ? void 0 : _vnode$data$attrs['data-element'],
              originComponent: (_vnode$data$attrs2 = vnode.data.attrs) === null || _vnode$data$attrs2 === void 0 ? void 0 : _vnode$data$attrs2['data-component']
            };
            var customEvent = (_vnode$componentInsta = vnode.componentInstance.$attrs) === null || _vnode$componentInsta === void 0 ? void 0 : _vnode$componentInsta.event;
            if (event === customEvent) vnode.context.proxyEvent(data);
          });
        });
      },
      unbind: function unbind(el, binding, vnode) {
        vnode.componentInstance.$off();
      }
    }
  },
  data: function data() {
    return {
      drag: false,
      enabled: true,
      list: [],
      knownEvents: ['click', 'open', 'close', 'input', 'change'],
      localItems: [],
      enterDragAndDrop: false
    };
  },
  props: {
    label: {
      type: [String, Function],
      default: ''
    },
    text: {
      type: [String, Function],
      default: ''
    },
    info: {
      type: [String, Function],
      default: ''
    },
    emptyStateMessage: {
      type: [String, Function],
      default: ''
    },
    tooltipWidth: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    draggable: {
      type: Boolean,
      default: true
    },
    max: {
      type: Number,
      default: 0
    },
    showDelete: {
      type: Boolean,
      default: false
    },
    showOptionsItem: {
      type: Boolean,
      default: false
    },
    showCounter: {
      type: Boolean,
      default: false
    },
    showOptions: {
      type: Boolean,
      default: true
    },
    showAdd: {
      type: Boolean,
      default: true
    },
    showDivider: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    items: {
      handler: function handler() {
        this.evaluateItems();
      },
      deep: true
    },
    max: function max() {
      this.evaluateItems();
    }
  },
  computed: {
    showText: function showText() {
      var _this$text;
      return ((_this$text = this.text) === null || _this$text === void 0 ? void 0 : _this$text.length) > 0 || typeof this.text === 'function' || this.showCounter;
    },
    getOptions: function getOptions() {
      return this.options.length > 0 && Array.isArray(this.options);
    },
    getText: function getText() {
      var text = '';
      switch (true) {
        case this.showCounter && this.max > 0:
          text = this.items.length > this.max ? "".concat(this.text, " (").concat(this.max, "/").concat(this.max, ")") : "".concat(this.text, " (").concat(this.items.length, "/").concat(this.max, ")");
          break;
        case this.showCounter && this.max === 0:
          text = "".concat(this.text, " (").concat(this.items.length, ")");
          break;
        case !this.showCounter:
          text = "".concat(this.text);
          break;
      }
      return text;
    },
    getEmptyStateMessage: function getEmptyStateMessage() {
      return this.emptyStateMessage !== '' ? this.emptyStateMessage : this.$t('aqua.emptyState');
    },
    getItemsLength: function getItemsLength() {
      return this.items.length > 0;
    }
  },
  methods: {
    addItem: function addItem(event) {
      this.$emit('addItem', event);
    },
    displayOptions: function displayOptions(event) {
      this.$emit('displayOptions', event);
    },
    selectedOption: function selectedOption(event) {
      this.$emit('selectedOption', event);
    },
    getProps: function getProps(item) {
      var props = item.props.props;
      return _objectSpread$1({}, props);
    },
    getSlot: function getSlot(item) {
      return item.nameSlot;
    },
    proxyEvent: function proxyEvent(data) {
      var _this = this;
      var event = data.event,
        value = data.value,
        element = data.element;
      this.items.forEach(function (item) {
        item.components.forEach(function (component) {
          if (component.id === element) {
            var localComponent = component;
            if (component.model !== data.value && !_this.enterDragAndDrop) {
              localComponent.model = value;
            }
          }
        });
      });
      var eventValue = {
        event: event,
        value: value,
        element: element
      };
      this.$emit("".concat(event), eventValue);
    },
    checkMove: function checkMove(event) {
      this.drag = false;
      var oldIndex = event.oldIndex,
        newIndex = event.newIndex;
      var orderedItems = [];
      this.items.forEach(function (item, index) {
        orderedItems[index] = item.components;
      });
      var data = {
        oldIndex: oldIndex,
        newIndex: newIndex,
        order: orderedItems
      };
      this.$emit('dragInfo', data);
    },
    startMove: function startMove() {
      this.drag = true;
      this.enterDragAndDrop = true;
    },
    evaluateItems: function evaluateItems() {
      var itemsTemp = [];
      var originalItems = this.items;
      switch (true) {
        case this.max > 0 && this.items.length > this.max:
          for (var item = 0; item < this.max; item += 1) {
            itemsTemp[item] = originalItems[item];
          }
          break;
        case this.max > 0 && this.items.length <= this.max || this.max === 0:
          itemsTemp = originalItems;
          break;
      }
      this.localItems = itemsTemp;
    },
    returnAction: function returnAction(item, index, action) {
      var itemData = {
        position: index,
        listItem: item
      };
      this.$emit("".concat(action), itemData);
    },
    getComponentsLength: function getComponentsLength(item) {
      return item.length;
    }
  },
  mounted: function mounted() {
    this.evaluateItems();
  }
};

/* script */
var __vue_script__$p = script$p;

/* template */
var __vue_render__$p = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-list-group"
  }, [_c('div', {
    staticClass: "aq-list-group__header"
  }, [_c('div', {
    staticClass: "aq-list-group__header__left-content"
  }, [_vm.isLabelVisible ? _c('aq-label', _vm._b({}, 'aq-label', _vm.bindsLabel, false), [_vm._v(_vm._s(_vm.$aqT(_vm.label)))]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "aq-list-group__header__rigth-content"
  }, [_vm.showText ? _c('aq-helper-text', {
    attrs: {
      "text": _vm.getText
    }
  }) : _vm._e(), _vm._v(" "), _vm.showText ? _c('aq-divider', {
    attrs: {
      "orientation": "vertical"
    }
  }) : _vm._e(), _vm._v(" "), _vm.showAdd ? _c('aq-button', {
    attrs: {
      "icon": "aq-icon-plus"
    },
    on: {
      "click": _vm.addItem
    }
  }) : _vm._e(), _vm._v(" "), _vm.getOptions && _vm.showOptions ? _c('aq-dropdown', {
    attrs: {
      "closeOnClick": "",
      "disabled": _vm.disabled
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_c('aq-dropdown-content', _vm._l(_vm.options, function (option, index) {
          return _c('aq-dropdown-item', {
            key: index,
            on: {
              "click": function click($event) {
                return _vm.selectedOption(option);
              }
            }
          }, [_vm._v("\n              " + _vm._s(option.name) + "\n            ")]);
        }), 1)];
      },
      proxy: true
    }], null, false, 2883701558)
  }, [_vm.showOptions ? _c('aq-button', {
    attrs: {
      "icon": "aq-icon-three-dots-vertical"
    },
    on: {
      "click": _vm.displayOptions
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), !_vm.getOptions && _vm.showOptions ? _c('aq-button', {
    attrs: {
      "icon": "aq-icon-three-dots-vertical"
    },
    on: {
      "click": _vm.displayOptions
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _vm.getItemsLength ? _c('div', {
    staticClass: "aq-list-group__content"
  }, [_c('draggable', {
    staticClass: "list-group",
    attrs: {
      "list": _vm.localItems,
      "group": "general",
      "ghost-class": "ghost",
      "disabled": !_vm.draggable
    },
    on: {
      "start": _vm.startMove,
      "end": _vm.checkMove
    }
  }, _vm._l(_vm.localItems, function (item, index) {
    return _c('aq-list-group-item', {
      key: index,
      staticClass: "list-group-item",
      attrs: {
        "draggable": _vm.draggable,
        "showDelete": _vm.showDelete,
        "showDivider": _vm.showDivider,
        "showOptions": _vm.showOptionsItem
      },
      on: {
        "deleteItem": function deleteItem($event) {
          return _vm.returnAction(item, index, 'deleteItem');
        },
        "clickOptionsItem": function clickOptionsItem($event) {
          return _vm.returnAction(item, index, 'clickOptionsItem');
        }
      }
    }, [_c('div', {
      staticClass: "aq-list-group__item"
    }, _vm._l(item.components, function (component, index) {
      return _c(component.name, _vm._b({
        directives: [{
          name: "dynamic-events",
          rawName: "v-dynamic-events",
          value: _vm.knownEvents,
          expression: "knownEvents"
        }],
        key: index,
        tag: "component",
        staticClass: "aq-list-group__component",
        style: "width: " + 100 / _vm.getComponentsLength(item.components) + "%;",
        attrs: {
          "data-element": component.id,
          "data-component": component.name
        },
        model: {
          value: component.model,
          callback: function callback($$v) {
            _vm.$set(component, "model", $$v);
          },
          expression: "component.model"
        }
      }, 'component', component.props, false), [component.slot ? _c('template', {
        slot: _vm.getSlot(component)
      }, [_c('div', {
        domProps: {
          "innerHTML": _vm._s(component.templateContent)
        }
      })]) : _vm._e()], 2);
    }), 1)]);
  }), 1)], 1) : _c('div', {
    class: ['aq-list-group__empty', {
      'aq-list-group__empty--helperText': !_vm.isHelperTextVisible
    }]
  }, [_c('span', [_vm._v(_vm._s(_vm.getEmptyStateMessage))])]), _vm._v(" "), _vm.isHelperTextVisible ? _c('div', {
    staticClass: "aq-select__footer"
  }, [_c('div', {
    staticClass: "aq-select__helper-text"
  }, [_vm.isHelperTextVisible ? _c('aq-helper-text', _vm._b({}, 'aq-helper-text', _vm.bindsHelperText, false)) : _vm._e()], 1)]) : _vm._e()]);
};
var __vue_staticRenderFns__$p = [];

/* style */
var __vue_inject_styles__$p = undefined;
/* scoped */
var __vue_scope_id__$p = undefined;
/* module identifier */
var __vue_module_identifier__$p = undefined;
/* functional template */
var __vue_is_functional_template__$p = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$p = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$p,
  staticRenderFns: __vue_staticRenderFns__$p
}, __vue_inject_styles__$p, __vue_script__$p, __vue_scope_id__$p, __vue_is_functional_template__$p, __vue_module_identifier__$p, false, undefined, undefined, undefined);
var AqListGroup = __vue_component__$p;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$o = {
  name: 'aq-list-group-item',
  props: {
    draggable: {
      type: Boolean,
      default: true
    },
    showDelete: {
      type: Boolean,
      default: false
    },
    showOptions: {
      type: Boolean,
      default: false
    },
    showDivider: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    deleteItem: function deleteItem() {
      this.$emit('deleteItem');
    },
    optionsItem: function optionsItem() {
      this.$emit('clickOptionsItem');
    }
  }
};

/* script */
var __vue_script__$o = script$o;

/* template */
var __vue_render__$o = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-list-group-item"
  }, [_c('div', {
    staticClass: "aq-list-group-item__divider--bottom"
  }, [_vm.showDivider ? _c('aq-divider') : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "aq-list-group-item__content"
  }, [_vm.draggable ? _c('em', {
    staticClass: "aq-icon-six-dots aq-list-group-item__draggable"
  }) : _vm._e(), _vm._v(" "), _vm._t("default"), _vm._v(" "), _vm.showDelete ? _c('aq-button', {
    staticClass: "aq-list-group-item__options",
    attrs: {
      "icon": "aq-icon-trash"
    },
    on: {
      "click": _vm.deleteItem
    }
  }) : _vm._e(), _vm._v(" "), _vm.showOptions ? _c('aq-button', {
    staticClass: "aq-list-group-item__options",
    attrs: {
      "icon": "aq-icon-three-dots-vertical"
    },
    on: {
      "click": _vm.optionsItem
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "aq-list-group-item__divider--top"
  }, [_vm.showDivider ? _c('aq-divider') : _vm._e()], 1)]);
};
var __vue_staticRenderFns__$o = [];

/* style */
var __vue_inject_styles__$o = undefined;
/* scoped */
var __vue_scope_id__$o = undefined;
/* module identifier */
var __vue_module_identifier__$o = undefined;
/* functional template */
var __vue_is_functional_template__$o = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$o = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$o,
  staticRenderFns: __vue_staticRenderFns__$o
}, __vue_inject_styles__$o, __vue_script__$o, __vue_scope_id__$o, __vue_is_functional_template__$o, __vue_module_identifier__$o, false, undefined, undefined, undefined);
var AqListGroupItem = __vue_component__$o;

//
//
//
//
//
//
//
//
//
//
//

var script$n = {
  props: {
    userName: {
      type: String,
      default: ''
    },
    isUserNameVisible: {
      type: Boolean,
      default: true
    },
    isAvatarVisible: {
      type: Boolean,
      default: true
    },
    isActive: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      // isActive: false,
      style: {
        backgroundColor: '',
        color: ''
      }
    };
  },
  watch: {
    backgroundColor: function backgroundColor() {
      this.getStyle();
    },
    textColor: function textColor() {
      this.getStyle();
    }
  },
  computed: {
    initial: function initial() {
      var letters = '';
      this.userName.split(' ').forEach(function (letter) {
        var _letters;
        if (((_letters = letters) === null || _letters === void 0 ? void 0 : _letters.length) < 2) {
          letters += letter.charAt(0);
        }
      });
      return letters;
    },
    getIsUserNameVisible: function getIsUserNameVisible() {
      return this.isUserNameVisible;
    },
    getIsAvatarVisible: function getIsAvatarVisible() {
      return this.isAvatarVisible;
    },
    isColor: function isColor() {
      var _this$color;
      return this.color !== '' && ((_this$color = this.color) === null || _this$color === void 0 ? void 0 : _this$color.length) > 0 && (this.color.startsWith('#') || this.color.startsWith('rgb'));
    }
  },
  methods: {
    getStyle: function getStyle() {
      this.style.backgroundColor = this.backgroundColor !== '' && (this.backgroundColor.startsWith('#') || this.backgroundColor.startsWith('rgb')) ? this.backgroundColor : '';
      this.style.color = this.textColor !== '' && (this.textColor.startsWith('#') || this.textColor.startsWith('rgb')) ? this.textColor : '';
    }
  },
  mounted: function mounted() {
    this.getStyle();
  }
};

/* script */
var __vue_script__$n = script$n;

/* template */
var __vue_render__$n = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-avatar__user-item', {
      'aq-avatar__user-item--active': _vm.isActive
    }]
  }, [_c('div', {
    staticClass: "aq-avatar__user-content-item"
  }, [_vm.getIsAvatarVisible ? _c('span', {
    staticClass: "aq-avatar__initial",
    style: _vm.style
  }, [_vm._v("\n      " + _vm._s(_vm.initial) + "\n    ")]) : _vm._e(), _vm._v(" "), _vm.getIsUserNameVisible ? _c('span', {
    staticClass: "aq-avatar__name"
  }, [_vm._v(_vm._s(_vm.userName))]) : _vm._e()])]);
};
var __vue_staticRenderFns__$n = [];

/* style */
var __vue_inject_styles__$n = undefined;
/* scoped */
var __vue_scope_id__$n = undefined;
/* module identifier */
var __vue_module_identifier__$n = undefined;
/* functional template */
var __vue_is_functional_template__$n = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$n = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$n,
  staticRenderFns: __vue_staticRenderFns__$n
}, __vue_inject_styles__$n, __vue_script__$n, __vue_scope_id__$n, __vue_is_functional_template__$n, __vue_module_identifier__$n, false, undefined, undefined, undefined);
var AqAvatar = __vue_component__$n;

//
//
//
//
//
//
//

var script$m = {
  props: {
    height: {
      type: [String, Number],
      default: function _default() {
        return '';
      }
    },
    orientation: {
      type: String,
      default: function _default() {
        return 'horizontal';
      }
    }
  }
};

/* script */
var __vue_script__$m = script$m;

/* template */
var __vue_render__$m = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-divider', 'aq-divider--' + _vm.orientation],
    style: _vm.orientation === 'vertical' && _vm.height ? {
      height: _vm.height + "px"
    } : {}
  });
};
var __vue_staticRenderFns__$m = [];

/* style */
var __vue_inject_styles__$m = undefined;
/* scoped */
var __vue_scope_id__$m = undefined;
/* module identifier */
var __vue_module_identifier__$m = undefined;
/* functional template */
var __vue_is_functional_template__$m = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$m = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$m,
  staticRenderFns: __vue_staticRenderFns__$m
}, __vue_inject_styles__$m, __vue_script__$m, __vue_scope_id__$m, __vue_is_functional_template__$m, __vue_module_identifier__$m, false, undefined, undefined, undefined);
var AqDivider = __vue_component__$m;

//
var script$l = {
  mixins: [sizeMixin],
  props: {
    alt: {
      type: String,
      default: ''
    },
    src: {
      type: String,
      default: ''
    },
    sizes: {
      default: ''
    },
    crossorigin: {
      type: String,
      default: 'anonymous'
    },
    loading: {
      type: String,
      default: ''
    }
  },
  computed: {
    allProps: function allProps() {
      return {
        /*  alt: this.alt, */
        src: this.src /*
                      sizes: this.sizes,
                      crossorigin: this.crossorigin,
                      loading: this.loading, */
      };
    }
  }
};

/* script */
var __vue_script__$l = script$l;

/* template */
var __vue_render__$l = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('img', _vm._b({
    staticClass: "aq-img",
    style: _vm.mixinSizeStyle,
    attrs: {
      "alt": _vm.alt
    }
  }, 'img', _vm.allProps, false));
};
var __vue_staticRenderFns__$l = [];

/* style */
var __vue_inject_styles__$l = undefined;
/* scoped */
var __vue_scope_id__$l = undefined;
/* module identifier */
var __vue_module_identifier__$l = undefined;
/* functional template */
var __vue_is_functional_template__$l = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$l = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$l,
  staticRenderFns: __vue_staticRenderFns__$l
}, __vue_inject_styles__$l, __vue_script__$l, __vue_scope_id__$l, __vue_is_functional_template__$l, __vue_module_identifier__$l, false, undefined, undefined, undefined);
var AqImg = __vue_component__$l;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$k = {
  props: {
    defaultBreadcrumbs: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    existsRoute: function existsRoute() {
      this.onChangeRoute();
    },
    defaultBreadcrumbs: function defaultBreadcrumbs() {
      this.onChangeRoute();
    }
  },
  data: function data() {
    return {
      breadcrumbs: []
    };
  },
  computed: {
    beforeLastBreadCrumb: function beforeLastBreadCrumb() {
      var _this$breadcrumbs;
      var breadcrumbs = [];
      if (((_this$breadcrumbs = this.breadcrumbs) === null || _this$breadcrumbs === void 0 ? void 0 : _this$breadcrumbs.length) > 1) {
        var _this$breadcrumbs2;
        breadcrumbs = this.breadcrumbs.slice(0, ((_this$breadcrumbs2 = this.breadcrumbs) === null || _this$breadcrumbs2 === void 0 ? void 0 : _this$breadcrumbs2.length) - 1);
      }
      return breadcrumbs;
    },
    lastBreadCrumb: function lastBreadCrumb() {
      var _this$breadcrumbs3;
      var breadcrumb = '';
      if (((_this$breadcrumbs3 = this.breadcrumbs) === null || _this$breadcrumbs3 === void 0 ? void 0 : _this$breadcrumbs3.length) > 0) {
        var _this$breadcrumbs4;
        breadcrumb = this.breadcrumbs[((_this$breadcrumbs4 = this.breadcrumbs) === null || _this$breadcrumbs4 === void 0 ? void 0 : _this$breadcrumbs4.length) - 1].label;
      }
      return breadcrumb;
    },
    existsRoute: function existsRoute() {
      return typeof this.$route !== 'undefined' && this.$route.meta && this.$route.meta.breadCrumb;
    }
  },
  methods: {
    loadBreadCrumbs: function loadBreadCrumbs() {
      var _this$defaultBreadcru;
      if (this.existsRoute) {
        this.breadcrumbs = this.$route.meta.breadCrumb;
      } else if (((_this$defaultBreadcru = this.defaultBreadcrumbs) === null || _this$defaultBreadcru === void 0 ? void 0 : _this$defaultBreadcru.length) > 0) {
        this.breadcrumbs = this.defaultBreadcrumbs;
      }
    },
    isTagA: function isTagA(url) {
      return url.includes('http');
    },
    onChangeRoute: function onChangeRoute() {
      this.loadBreadCrumbs();
    }
  },
  mounted: function mounted() {
    this.loadBreadCrumbs();
  }
};

/* script */
var __vue_script__$k = script$k;

/* template */
var __vue_render__$k = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('p', {
    staticClass: "aq-breadcrumb"
  }, [_vm._l(_vm.beforeLastBreadCrumb, function (item, i) {
    return _c('span', {
      key: i,
      staticClass: "aq-breadcrumb__item"
    }, [_vm.isTagA(item.url) ? [_c('a', {
      attrs: {
        "href": item.url,
        "rel": "noopener"
      }
    }, [_vm._v(_vm._s(_vm.$aqT(item.label)))])] : [_c('router-link', {
      attrs: {
        "to": {
          path: item.url
        }
      }
    }, [_vm._v("\n        " + _vm._s(_vm.$aqT(item.label)) + "\n      ")])], _vm._v(" "), _c('span', {
      staticClass: "aq-breadcrumb__separator"
    }, [_vm._v("/")])], 2);
  }), _vm._v(" "), _c('span', {
    staticClass: "aq-breadcrumb__last-item"
  }, [_vm._v(" " + _vm._s(_vm.$aqT(_vm.lastBreadCrumb)) + " ")])], 2);
};
var __vue_staticRenderFns__$k = [];

/* style */
var __vue_inject_styles__$k = undefined;
/* scoped */
var __vue_scope_id__$k = undefined;
/* module identifier */
var __vue_module_identifier__$k = undefined;
/* functional template */
var __vue_is_functional_template__$k = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$k = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$k,
  staticRenderFns: __vue_staticRenderFns__$k
}, __vue_inject_styles__$k, __vue_script__$k, __vue_scope_id__$k, __vue_is_functional_template__$k, __vue_module_identifier__$k, false, undefined, undefined, undefined);
var AqBreadcrumb = __vue_component__$k;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$j = {
  props: {
    complete: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      number: 0,
      styleLine: {},
      parent: null,
      isSiblingError: false,
      isSiblingActive: false
    };
  },
  watch: {
    error: function error() {
      this.setIsSibling('error', 'isSiblingError');
    },
    active: function active() {
      this.setIsSibling('active', 'isSiblingActive');
    }
  },
  computed: {
    isActive: function isActive() {
      return this.active || this.complete;
    },
    isVertical: function isVertical() {
      return this.parent.vertical;
    },
    isFirst: function isFirst() {
      var _this$parent;
      return ((_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.steps[0]) === this;
    },
    index: function index() {
      var _this$parent2;
      var steps = (_this$parent2 = this.parent) === null || _this$parent2 === void 0 ? void 0 : _this$parent2.steps;
      var index = steps.indexOf(this);
      return index;
    },
    numberStep: function numberStep() {
      return this.index + 1;
    },
    isLast: function isLast() {
      var _this$parent3, _this$parent4, _this$parent4$steps;
      return ((_this$parent3 = this.parent) === null || _this$parent3 === void 0 ? void 0 : _this$parent3.steps[((_this$parent4 = this.parent) === null || _this$parent4 === void 0 ? void 0 : (_this$parent4$steps = _this$parent4.steps) === null || _this$parent4$steps === void 0 ? void 0 : _this$parent4$steps.length) - 1]) === this;
    },
    beforeLine: function beforeLine() {
      var style = {
        error: false,
        isActive: false
      };
      if (!this.isFirst) {
        var _this$parent5, _steps, _steps2;
        var steps = (_this$parent5 = this.parent) === null || _this$parent5 === void 0 ? void 0 : _this$parent5.steps;
        style.error = (_steps = steps[this.index - 1]) === null || _steps === void 0 ? void 0 : _steps.error;
        style.isActive = (_steps2 = steps[this.index - 1]) === null || _steps2 === void 0 ? void 0 : _steps2.isActive;
      }
      return style;
    },
    children: function children() {
      return this.parent.$children;
    }
  },
  methods: {
    getParent: function getParent() {
      var parent = this.$parent;
      var name = parent.$options.name;
      while (parent && (!name || name !== 'aq-step-group')) {
        parent = parent.$parent;
        if (parent) {
          name = parent.$options.name;
        }
      }
      return parent;
    },
    setIsSibling: function setIsSibling(property, propertySibling) {
      var arr = this.parent.$children;
      var index = arr.indexOf(this);
      if (arr[index - 1]) {
        arr[index - 1][propertySibling] = this[property];
      }
    }
  },
  created: function created() {
    this.parent = this.getParent();
  },
  mounted: function mounted() {
    if (this.parent) {
      this.parent.registerStep(this);
      this.setIsSibling('error', 'isSiblingError');
      this.setIsSibling('active', 'isSiblingActive');
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.parent) {
      this.parent.unregisterStep(this);
    }
  }
};

/* script */
var __vue_script__$j = script$j;

/* template */
var __vue_render__$j = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    class: ['aq-step', {
      'aq-step--vertical': _vm.isVertical,
      'aq-step--horizontal': !_vm.isVertical,
      'aq-step--active': _vm.active,
      'aq-step--error': _vm.error,
      'aq-step--horizontal-active': _vm.active,
      'aq-step--horizontal-error': _vm.error,
      'aq-step--horizontal-active-sibling': _vm.isSiblingActive,
      'aq-step--horizontal-error-sibling': _vm.isSiblingError
    }]
  }, [_c('div', {
    class: ['aq-step__step', {
      'aq-step__step--vertical': _vm.isVertical
    }, {
      'aq-step__step--horizontal': !_vm.isVertical
    }]
  }, [_c('div', {
    staticClass: "aq-step__circle-line"
  }, [_vm.isVertical ? _c('span', {
    class: ['aq-step__line-top', {
      'aq-step__line-top--invisible': _vm.isFirst,
      'aq-step__line-top--active': _vm.beforeLine.isActive,
      'aq-step__line-top--error': _vm.beforeLine.error
    }]
  }) : _vm._e(), _vm._v(" "), _c('div', {
    class: ['aq-step__circle', {
      'aq-step__circle--complete': _vm.complete,
      'aq-step__circle--error': _vm.error,
      'aq-step__circle--active': _vm.active
    }]
  }, [!_vm.complete ? _c('span', [_vm._v(_vm._s(_vm.numberStep))]) : _c('span', [_c('em', {
    staticClass: "aq-icon-check-circle"
  })])]), _vm._v(" "), _vm.isVertical && !_vm.isLast ? _c('span', {
    class: ['aq-step__line-bottom', {
      'aq-step__line-bottom--active': _vm.isActive,
      'aq-step__line-bottom--error': _vm.error
    }]
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "aq-step__content"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    class: ['aq-step__line', {
      'aq-step__line--active': _vm.isActive,
      'aq-step__line--error': _vm.error
    }],
    style: _vm.styleLine
  })])]);
};
var __vue_staticRenderFns__$j = [];

/* style */
var __vue_inject_styles__$j = undefined;
/* scoped */
var __vue_scope_id__$j = undefined;
/* module identifier */
var __vue_module_identifier__$j = undefined;
/* functional template */
var __vue_is_functional_template__$j = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$j = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$j,
  staticRenderFns: __vue_staticRenderFns__$j
}, __vue_inject_styles__$j, __vue_script__$j, __vue_scope_id__$j, __vue_is_functional_template__$j, __vue_module_identifier__$j, false, undefined, undefined, undefined);
var AqStep = __vue_component__$j;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$i = {
  name: 'aq-step-group',
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    vertical: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      steps: [],
      example: '<aq-step :complete="false" :active="true" :error="false"> Step 1 </aq-step>'
    };
  },
  methods: {
    registerStep: function registerStep(vm) {
      var _this$steps;
      this.steps.push(vm);
      return ((_this$steps = this.steps) === null || _this$steps === void 0 ? void 0 : _this$steps.length) - 1;
    },
    unregisterStep: function unregisterStep(vm) {
      this.steps.splice(this.steps.indexOf(vm), 1);
    }
  }
};

/* script */
var __vue_script__$i = script$i;

/* template */
var __vue_render__$i = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', [_vm.visible ? _c('div', {
    class: ['aq-step-group', {
      'aq-step-group--vertical': _vm.vertical
    }, {
      'aq-step-group--horizontal': !_vm.vertical
    }]
  }, [_vm._t("default", function () {
    return [_vm._v(" Example: " + _vm._s(_vm.example) + " ")];
  })], 2) : _vm._e(), _vm._v(" "), _vm._t("items")], 2);
};
var __vue_staticRenderFns__$i = [];

/* style */
var __vue_inject_styles__$i = undefined;
/* scoped */
var __vue_scope_id__$i = undefined;
/* module identifier */
var __vue_module_identifier__$i = undefined;
/* functional template */
var __vue_is_functional_template__$i = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$i = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$i,
  staticRenderFns: __vue_staticRenderFns__$i
}, __vue_inject_styles__$i, __vue_script__$i, __vue_scope_id__$i, __vue_is_functional_template__$i, __vue_module_identifier__$i, false, undefined, undefined, undefined);
var AqStepGroup = __vue_component__$i;

//
var script$h = {
  inject: ['select', 'tabGroup'],
  mixins: [sizeMixin],
  props: {
    text: {
      type: [String, Function],
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    draggable: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    state: {
      type: String,
      default: 'default'
    },
    number: {
      type: Number,
      default: null
    },
    icon: {
      type: String,
      default: ''
    },
    badgeWidth: {
      type: String,
      default: ''
    }
  },
  watch: {
    '$parent.selectedIndex': function $parentSelectedIndex() {
      var _this$$parent;
      this.selectedIndex = (_this$$parent = this.$parent) === null || _this$$parent === void 0 ? void 0 : _this$$parent.selectedIndex;
    }
  },
  data: function data() {
    return {
      index: -1,
      selectedIndex: 0
    };
  },
  computed: {
    isActive: function isActive() {
      return this.select === this.$aqT(this.text);
    },
    isActive2: function isActive2() {
      return this.selectedIndex === this.index;
    },
    isText: function isText() {
      var _this$$aqT;
      return ((_this$$aqT = this.$aqT(this.text)) === null || _this$$aqT === void 0 ? void 0 : _this$$aqT.length) > 0;
    },
    getIcon: function getIcon() {
      return this.icon && this.icon !== '';
    },
    getNumber: function getNumber() {
      return this.number && this.number !== null;
    },
    isVertical: function isVertical() {
      var _this$tabGroup;
      return (_this$tabGroup = this.tabGroup) === null || _this$tabGroup === void 0 ? void 0 : _this$tabGroup.vertical;
    }
  },
  methods: {
    clickTab: function clickTab() {
      this.tabGroup.clickTab(this.index);
    }
  },
  mounted: function mounted() {
    if (this.tabGroup) {
      this.index = this.tabGroup.registerTab(this);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.tabGroup) {
      this.tabGroup.unregisterTab(this);
      this.index = -1;
    }
  }
};

/* script */
var __vue_script__$h = script$h;

/* template */
var __vue_render__$h = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isActive2 || !_vm.isText && !_vm.isActive2,
      expression: "isActive2 || (!isText && !isActive2)"
    }],
    staticClass: "aq-tab-container"
  }, [_vm.isText ? [_c('div', {
    staticClass: "aq-tab__container"
  }, [_vm._t("default")], 2)] : [_c('button', {
    class: ['aq-tab button', {
      'aq-tab--selected': _vm.isActive2
    }],
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.clickTab
    }
  }, [_vm.draggable ? _c('span', {
    staticClass: "aq-tab__draggable"
  }, [_c('em', {
    staticClass: "aq-icon-six-dots"
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aq-tab__content",
    style: _vm.mixinSizeStyle
  }, [_c('div', {
    staticClass: "aq-tab__content--justify"
  }, [_c('div', {
    class: ['aq-tab__text', {
      'aq-tab__text--vertical': _vm.isVertical,
      'aq-tab__text-badge': _vm.getNumber
    }]
  }, [_vm.getIcon ? _c('em', {
    class: [_vm.icon, 'aq-tab__content__icon']
  }) : _vm._e(), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _vm.getNumber ? _c('aq-badge', {
    attrs: {
      "number": _vm.number,
      "state": _vm.state,
      "minWidth": _vm.badgeWidth,
      "width": _vm.badgeWidth
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', [_vm._t("subtitle")], 2)]), _vm._v(" "), _c('div', {
    class: ['aq-tab__selected-bar', {
      'aq-tab__selected-bar--active': _vm.isActive2
    }]
  })])]], 2);
};
var __vue_staticRenderFns__$h = [];

/* style */
var __vue_inject_styles__$h = undefined;
/* scoped */
var __vue_scope_id__$h = undefined;
/* module identifier */
var __vue_module_identifier__$h = undefined;
/* functional template */
var __vue_is_functional_template__$h = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$h = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$h,
  staticRenderFns: __vue_staticRenderFns__$h
}, __vue_inject_styles__$h, __vue_script__$h, __vue_scope_id__$h, __vue_is_functional_template__$h, __vue_module_identifier__$h, false, undefined, undefined, undefined);
var AqTab = __vue_component__$h;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var script$g = {
  provide: function provide() {
    return {
      selectedTab: [],
      tabGroup: this,
      select: 0
    };
  },
  props: {
    value: {
      type: Number,
      default: 0
    },
    vertical: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    }
  },
  watch: {
    value: function value(newVal) {
      this.onValueChange(newVal);
    }
  },
  data: function data() {
    return {
      tabsX: [],
      selectedIndex: 0,
      tabs: []
    };
  },
  computed: {
    tabsFiltered: function tabsFiltered() {
      var _this = this;
      return this.tabsX.filter(function (tab) {
        var _this$$aqT;
        return ((_this$$aqT = _this.$aqT(tab.text)) === null || _this$$aqT === void 0 ? void 0 : _this$$aqT.length) > 0;
      });
    },
    getIcon: function getIcon() {
      return this.icon && this.icon !== '';
    },
    getTabsFilteredLength: function getTabsFilteredLength() {
      var _this$tabsFiltered;
      return (_this$tabsFiltered = this.tabsFiltered) === null || _this$tabsFiltered === void 0 ? void 0 : _this$tabsFiltered.length;
    },
    hasContentRight: function hasContentRight() {
      return typeof this.$slots.contentRight !== 'undefined';
    }
  },
  methods: {
    onValueChange: function onValueChange(newVal) {
      this.selectedIndex = newVal;
    },
    updateTabs: function updateTabs() {
      if (this.$slots.default) {
        this.tabs = this.$slots.default.map(function (slot) {
          var _slot$componentOption;
          return _objectSpread({}, (_slot$componentOption = slot.componentOptions) === null || _slot$componentOption === void 0 ? void 0 : _slot$componentOption.propsData);
        }).filter(function (item) {
          return !!item;
        });
      }
      this.selectTab(this.selectedIndex);
    },
    selectTab: function selectTab(i) {
      var _this$tabs;
      if (((_this$tabs = this.tabs) === null || _this$tabs === void 0 ? void 0 : _this$tabs.length) > 0) {
        this.selectedIndex = i;
        this.selectedTab = this.tabsX[i];
        this.select = this.$aqT(this.tabsX[i].text);
      }
    },
    clickTab: function clickTab(i) {
      if (this.selectedIndex !== i) {
        this.$emit(EVENT_NAME_CHANGE, i);
        this.$emit('input', i);
      }
      this.selectTab(i);
    },
    selectFirstTab: function selectFirstTab() {
      var _this$tabsX;
      if (!this.selectedTab && ((_this$tabsX = this.tabsX) === null || _this$tabsX === void 0 ? void 0 : _this$tabsX.length) > 0) {
        var _this$tabsX2 = _slicedToArray(this.tabsX, 1);
        this.selectedTab = _this$tabsX2[0];
      }
    },
    registerTab: function registerTab(vm) {
      var _this$tabsX3;
      this.tabsX.push(vm);
      this.selectFirstTab();
      return ((_this$tabsX3 = this.tabsX) === null || _this$tabsX3 === void 0 ? void 0 : _this$tabsX3.length) - 1;
    },
    unregisterTab: function unregisterTab(vm) {
      this.tabsX.splice(this.tabsX.indexOf(vm), 1);
    },
    getTabOption: function getTabOption(tab) {
      var _tab$options;
      return (tab === null || tab === void 0 ? void 0 : tab.options) && (tab === null || tab === void 0 ? void 0 : (_tab$options = tab.options) === null || _tab$options === void 0 ? void 0 : _tab$options.length) > 0 && !(tab !== null && tab !== void 0 && tab.disabled);
    },
    isLastTab: function isLastTab(index) {
      return this.getTabsFilteredLength - 1 === index;
    }
  },
  mounted: function mounted() {
    this.$on('tabUpdated', this.updateTabs);
    this.updateTabs();
    this.selectTab(0);
    this.onValueChange(this.value);
  },
  destroy: function destroy() {
    this.$off('tabUpdated', this.updateTabs);
  }
};

/* script */
var __vue_script__$g = script$g;

/* template */
var __vue_render__$g = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-tab-group"
  }, [_vm.getTabsFilteredLength > 0 ? _c('div', {
    class: ['aq-tab-group__tabs', {
      'aq-tab-group__tabs--vertical': _vm.vertical
    }]
  }, _vm._l(_vm.tabsFiltered, function (tab, i) {
    return _c('button', {
      key: i,
      class: ['aq-tab button', {
        'aq-tab--selected': _vm.selectedIndex === i
      }],
      attrs: {
        "type": "button",
        "disabled": tab.disabled
      },
      on: {
        "click": function click($event) {
          return _vm.clickTab(i);
        }
      }
    }, [tab.draggable ? _c('span', {
      staticClass: "aq-tab__draggable"
    }, [_c('em', {
      staticClass: "aq-icon-six-dots"
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "aq-tab__content"
    }, [_c('div', {
      staticClass: "aq-tab__text"
    }, [_vm.getIcon ? _c('em', {
      class: ['aq-tab__text', {
        'aq-tab__text--vertical': _vm.vertical
      }]
    }) : _vm._e(), _vm._v("\n          " + _vm._s(_vm.$aqT(tab.text)) + "\n          "), (tab.state && tab.state !== 'default' || tab.number) && !tab.disabled ? _c('aq-badge', {
      attrs: {
        "state": tab.state,
        "number": tab.number ? tab.number : null
      }
    }) : _vm._e()], 1)]), _vm._v(" "), _vm.getTabOption(tab) ? _c('span', {
      staticClass: "aq-tab__divider"
    }, [_c('aq-divider', {
      attrs: {
        "orientation": "vertical"
      }
    })], 1) : _vm._e(), _vm._v(" "), _vm.getTabOption(tab) ? _c('span', {
      staticClass: "aq-tab__options"
    }, [_c('aq-dropdown', {
      attrs: {
        "closeOnClick": "",
        "items": tab.options,
        "dataCallback": tab,
        "disabled": tab.disabled
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn() {
          return [_c('em', {
            staticClass: "aq-icon-chevron-down"
          })];
        },
        proxy: true
      }], null, true)
    })], 1) : _vm._e(), _vm._v(" "), _c('div', {
      class: ['aq-tab__selected-bar', {
        'aq-tab__selected-bar--active': _vm.selectedIndex === i
      }]
    })]);
  }), 0) : _vm._e(), _vm._v(" "), _vm.getTabsFilteredLength === 0 ? _c('div', {
    staticClass: "aq-tab-group__container"
  }, [_vm.getTabsFilteredLength === 0 ? _c('div', {
    class: ['aq-tab-group__tabs', {
      'aq-tab-group__tabs--vertical': _vm.vertical
    }]
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), _vm._t("items")], 2) : [_vm._t("default")]], 2);
};
var __vue_staticRenderFns__$g = [];

/* style */
var __vue_inject_styles__$g = undefined;
/* scoped */
var __vue_scope_id__$g = undefined;
/* module identifier */
var __vue_module_identifier__$g = undefined;
/* functional template */
var __vue_is_functional_template__$g = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$g = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$g,
  staticRenderFns: __vue_staticRenderFns__$g
}, __vue_inject_styles__$g, __vue_script__$g, __vue_scope_id__$g, __vue_is_functional_template__$g, __vue_module_identifier__$g, false, undefined, undefined, undefined);
var AqTabGroup = __vue_component__$g;

//
//
//
//
//
//

var script$f = {
  inject: ['tabItemsParent'],
  watch: {
    '$parent.selectedIndex': function $parentSelectedIndex() {
      var _this$$parent;
      var val = (_this$$parent = this.$parent) === null || _this$$parent === void 0 ? void 0 : _this$$parent.selectedIndex;
      if (typeof val === 'number') {
        this.selectedIndex = val;
      }
    }
  },
  data: function data() {
    return {
      selectedIndex: 0,
      index: -1
    };
  },
  computed: {
    isActive: function isActive() {
      return this.selectedIndex === this.index;
    }
  },
  mounted: function mounted() {
    if (this.tabItemsParent) {
      this.index = this.tabItemsParent.registerTabItem(this);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.tabItemsParent) {
      this.tabItemsParent.unregisterTabItem(this);
      this.index = -1;
    }
  }
};

/* script */
var __vue_script__$f = script$f;

/* template */
var __vue_render__$f = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isActive,
      expression: "isActive"
    }],
    staticClass: "aq-tab-item"
  }, [_vm._t("default")], 2);
};
var __vue_staticRenderFns__$f = [];

/* style */
var __vue_inject_styles__$f = undefined;
/* scoped */
var __vue_scope_id__$f = undefined;
/* module identifier */
var __vue_module_identifier__$f = undefined;
/* functional template */
var __vue_is_functional_template__$f = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$f = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$f,
  staticRenderFns: __vue_staticRenderFns__$f
}, __vue_inject_styles__$f, __vue_script__$f, __vue_scope_id__$f, __vue_is_functional_template__$f, __vue_module_identifier__$f, false, undefined, undefined, undefined);
var AqTabItem = __vue_component__$f;

//
var script$e = {
  mixins: [sizeMixin],
  provide: function provide() {
    return {
      tabItemsParent: this
    };
  },
  props: {
    value: {
      type: Number,
      default: -1
    }
  },
  watch: {
    value: function value(newVal) {
      this.onValueChange(newVal);
    }
  },
  data: function data() {
    return {
      tabItems: [],
      selectedIndex: 0
    };
  },
  methods: {
    onValueChange: function onValueChange(newVal) {
      this.selectedIndex = newVal;
    },
    registerTabItem: function registerTabItem(vm) {
      var _this$tabItems;
      this.tabItems.push(vm);
      return ((_this$tabItems = this.tabItems) === null || _this$tabItems === void 0 ? void 0 : _this$tabItems.length) - 1;
    },
    unregisterTabItem: function unregisterTabItem(vm) {
      this.tabItems.splice(this.tabItems.indexOf(vm), 1);
    }
  },
  mounted: function mounted() {
    this.onValueChange(this.value);
  }
};

/* script */
var __vue_script__$e = script$e;

/* template */
var __vue_render__$e = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-tab-items aq-scroll-bar",
    style: _vm.mixinSizeStyle
  }, [_vm._t("default")], 2);
};
var __vue_staticRenderFns__$e = [];

/* style */
var __vue_inject_styles__$e = undefined;
/* scoped */
var __vue_scope_id__$e = undefined;
/* module identifier */
var __vue_module_identifier__$e = undefined;
/* functional template */
var __vue_is_functional_template__$e = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$e = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$e,
  staticRenderFns: __vue_staticRenderFns__$e
}, __vue_inject_styles__$e, __vue_script__$e, __vue_scope_id__$e, __vue_is_functional_template__$e, __vue_module_identifier__$e, false, undefined, undefined, undefined);
var AqTabItems = __vue_component__$e;

//
//
//
//
//
//

var script$d = {
  inject: ['stepItemsParent'],
  watch: {
    '$parent.selectedIndex': function $parentSelectedIndex() {
      var _this$$parent;
      var val = (_this$$parent = this.$parent) === null || _this$$parent === void 0 ? void 0 : _this$$parent.selectedIndex;
      if (typeof val === 'number') {
        this.selectedIndex = val;
      }
    }
  },
  data: function data() {
    return {
      selectedIndex: 0,
      index: -1
    };
  },
  computed: {
    isActive: function isActive() {
      return this.selectedIndex === this.index;
    }
  },
  mounted: function mounted() {
    if (this.stepItemsParent) {
      this.index = this.stepItemsParent.registerStepItem(this);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.stepItemsParent) {
      this.stepItemsParent.unregisterStepItem(this);
      this.index = -1;
    }
  }
};

/* script */
var __vue_script__$d = script$d;

/* template */
var __vue_render__$d = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isActive,
      expression: "isActive"
    }],
    staticClass: "aq-step-item"
  }, [_vm._t("default")], 2);
};
var __vue_staticRenderFns__$d = [];

/* style */
var __vue_inject_styles__$d = undefined;
/* scoped */
var __vue_scope_id__$d = undefined;
/* module identifier */
var __vue_module_identifier__$d = undefined;
/* functional template */
var __vue_is_functional_template__$d = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$d = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$d,
  staticRenderFns: __vue_staticRenderFns__$d
}, __vue_inject_styles__$d, __vue_script__$d, __vue_scope_id__$d, __vue_is_functional_template__$d, __vue_module_identifier__$d, false, undefined, undefined, undefined);
var AqStepItem = __vue_component__$d;

//
var script$c = {
  mixins: [sizeMixin],
  provide: function provide() {
    return {
      stepItemsParent: this
    };
  },
  props: {
    value: {
      type: Number,
      default: -1
    }
  },
  watch: {
    value: function value(newVal) {
      this.onValueChange(newVal);
    }
  },
  data: function data() {
    return {
      stepItems: [],
      selectedIndex: 0
    };
  },
  methods: {
    onValueChange: function onValueChange(newVal) {
      this.selectedIndex = newVal;
    },
    registerStepItem: function registerStepItem(vm) {
      var _this$stepItems;
      this.stepItems.push(vm);
      return ((_this$stepItems = this.stepItems) === null || _this$stepItems === void 0 ? void 0 : _this$stepItems.length) - 1;
    },
    unregisterStepItem: function unregisterStepItem(vm) {
      this.stepItems.splice(this.stepItems.indexOf(vm), 1);
    }
  },
  mounted: function mounted() {
    this.onValueChange(this.value);
  }
};

/* script */
var __vue_script__$c = script$c;

/* template */
var __vue_render__$c = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-step-items aq-scroll-bar",
    style: _vm.mixinSizeStyle
  }, [_vm._t("default")], 2);
};
var __vue_staticRenderFns__$c = [];

/* style */
var __vue_inject_styles__$c = undefined;
/* scoped */
var __vue_scope_id__$c = undefined;
/* module identifier */
var __vue_module_identifier__$c = undefined;
/* functional template */
var __vue_is_functional_template__$c = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$c = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$c,
  staticRenderFns: __vue_staticRenderFns__$c
}, __vue_inject_styles__$c, __vue_script__$c, __vue_scope_id__$c, __vue_is_functional_template__$c, __vue_module_identifier__$c, false, undefined, undefined, undefined);
var AqStepItems = __vue_component__$c;

//
var script$b = {
  name: 'aq-dialog',
  mixins: [idMixin, zIndexMixin],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    header: {
      type: Boolean,
      default: true
    },
    footer: {
      type: Boolean,
      default: true
    },
    close: {
      type: Boolean,
      default: true
    },
    allowMaximize: {
      type: Boolean,
      default: false
    },
    closeOnBackdrop: {
      type: Boolean,
      default: true
    },
    woPadding: {
      type: Boolean,
      default: false
    },
    title: {
      type: [String, Function],
      default: ''
    },
    size: {
      type: String,
      default: 'small',
      validator: function validator(x) {
        return ['', 'small', 'medium', 'large', 'full'].includes(x.toLowerCase());
      }
    },
    state: {
      type: String,
      default: 'default'
    },
    closeOnEscape: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: function value(newVal, type) {
      this.onValueChanged(newVal, type);
    },
    visible: function visible() {
      this.$emit('input', this.visible);
    },
    footer: function footer() {
      this.setFooterVisible();
    }
  },
  data: function data() {
    return {
      visible: false,
      isMaximize: false,
      overflow: null,
      style: {},
      footerVisible: this.footer
    };
  },
  computed: {
    hasHeader: function hasHeader() {
      return this.header && this.title;
    },
    showMaximize: function showMaximize() {
      return this.allowMaximize && this.size !== 'full';
    },
    contentStyle: function contentStyle() {
      return {
        zIndex: this.zIndexContent
      };
    },
    backDropStyle: function backDropStyle() {
      return {
        zIndex: this.zIndexBackdrop
      };
    },
    zIndexContent: function zIndexContent() {
      return this.baseZIndex + 1;
    },
    zIndexBackdrop: function zIndexBackdrop() {
      return this.baseZIndex;
    },
    getState: function getState() {
      return this.state.toLowerCase();
    },
    getIcon: function getIcon() {
      var icon = '';
      switch (this.state.toLowerCase()) {
        case 'info':
          icon = 'aq-icon-info-circle-fill';
          break;
        case 'success':
          icon = 'aq-icon-check-circle-fill';
          break;
        case 'warning':
          icon = 'aq-icon-info-major-triangle-up-fill';
          break;
        case 'danger':
          icon = 'aq-icon-alert-circle-fill';
          break;
        default:
          icon = '';
      }
      return icon;
    },
    existState: function existState() {
      return this.getState !== '' && this.getState !== 'default';
    }
  },
  methods: {
    show: function show(newVal) {
      if (!this.visible) {
        this.visible = newVal;
        this.$emit('onOpen');
        this.overflow = document.getElementsByTagName('html')[0].style.overflow;
        document.getElementsByTagName('html')[0].style.overflow = 'hidden';
      }
    },
    hide: function hide() {
      var closeType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      document.getElementsByTagName('html')[0].style.overflow = this.overflow;
      this.visible = false;
      this.validateCloseType(closeType);
      this.$root.$emit('aq::popovers::close');
    },
    maximizeDialog: function maximizeDialog() {
      this.isMaximize = !this.isMaximize;
      this.$root.$emit('aq::popovers::close');
    },
    validateCloseType: function validateCloseType(closeType) {
      if (closeType === EVENT_NAME_CLOSE_CANCEL) {
        this.$emit(EVENT_NAME_CLOSE_CANCEL);
      } else if (closeType === EVENT_NAME_CLOSE_OK) {
        this.$emit(EVENT_NAME_CLOSE_OK);
      } else if (closeType === '') {
        this.$emit('onClose');
        this.$emit(EVENT_NAME_CLOSE);
      }
    },
    closeBackdrop: function closeBackdrop() {
      if (this.closeOnBackdrop) {
        this.hide();
      }
    },
    eventOpenModal: function eventOpenModal(data) {
      if ('value' in data && data.value === this.id) {
        this.onValueChanged(true);
      }
    },
    eventCloseModal: function eventCloseModal(data) {
      if ('value' in data && data.value === this.id || 'noId' in data) {
        var type = 'type' in data ? data.type : '';
        this.onValueChanged(false, type);
      }
    },
    setFooterVisible: function setFooterVisible() {
      if (this.footer) {
        this.footerVisible = !!this.$slots['footer-left'] || !!this.$slots['footer-right'];
      }
    },
    onValueChanged: function onValueChanged(newVal, type) {
      if (newVal) {
        this.show(newVal);
        setTimeout(function () {
          global.vtEvent.$emit('aq-table.setHeader');
        });
      } else {
        this.hide(type);
      }
    },
    keyDownEvent: function keyDownEvent(event) {
      if (event.keyCode === CODE_ESC && this.closeOnEscape) {
        event.preventDefault();
        this.hide();
      }
    }
  },
  mounted: function mounted() {
    this.setFooterVisible();
    if (this.value) {
      this.onValueChanged(this.value);
    }
    appendEl({
      children: this.$el
    });
    this.$root.$on(EVENT_NAME_GLOBAL_SHOW_DIALOG, this.eventOpenModal);
    this.$root.$on(EVENT_NAME_GLOBAL_HIDE_DIALOG, this.eventCloseModal);
    this.$on("_".concat(EVENT_NAME_GLOBAL_SHOW_DIALOG), this.eventOpenModal);
    this.$on("_".concat(EVENT_NAME_GLOBAL_HIDE_DIALOG), this.eventCloseModal);
    document.addEventListener('keydown', this.keyDownEvent);
  },
  beforeDestroy: function beforeDestroy() {
    this.hide();
    removeEl({
      children: this.$el
    });
    this.$root.$off(EVENT_NAME_GLOBAL_SHOW_DIALOG, this.eventOpenModal);
    this.$root.$off(EVENT_NAME_GLOBAL_HIDE_DIALOG, this.eventCloseModal);
    this.$off("_".concat(EVENT_NAME_GLOBAL_SHOW_DIALOG), this.eventOpenModal);
    this.$off("_".concat(EVENT_NAME_GLOBAL_HIDE_DIALOG), this.eventCloseModal);
    document.removeEventListener('keydown', this.keyDownEvent);
  }
};

/* script */
var __vue_script__$b = script$b;

/* template */
var __vue_render__$b = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    staticClass: "aq-dialog",
    attrs: {
      "id": _vm.id
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade-transtion-4"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    class: ['aq-dialog__content', _vm.isMaximize ? 'aq-dialog__content--full' : 'aq-dialog__content--' + _vm.size],
    style: _vm.contentStyle
  }, [_vm.hasHeader ? _c('div', {
    staticClass: "aq-dialog__header"
  }, [_c('div', {
    staticClass: "aq-dialog__header-right"
  }, [_vm.existState ? _c('em', {
    class: [_vm.getIcon, 'aq-dialog__icon-state', 'aq-dialog__state--' + _vm.getState]
  }) : _vm._e(), _vm._v(" "), _vm._t("before-title"), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$aqT(_vm.title)))]), _vm._v(" "), _vm._t("after-title")], 2), _vm._v(" "), _c('div', {
    staticClass: "aq-dialog__header-left"
  }, [_vm._t("header-right"), _vm._v(" "), _vm.showMaximize ? _c('em', {
    class: [_vm.isMaximize && this.size ? 'aq-icon-arrows-in' : 'aq-icon-arrows-out', 'aq-dialog__maximize'],
    on: {
      "click": function click($event) {
        return _vm.maximizeDialog();
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.close ? _c('em', {
    staticClass: "aq-icon-close aq-dialog__close",
    on: {
      "click": function click($event) {
        return _vm.hide();
      }
    }
  }) : _vm._e()], 2)]) : _vm._e(), _vm._v(" "), _vm.header ? _c('aq-divider') : _vm._e(), _vm._v(" "), _c('div', {
    ref: "body",
    class: ['aq-dialog__body aq-scroll-bar', {
      'aq-dialog__body--wo-padding': _vm.woPadding
    }]
  }, [_vm._t("default", null, {
    "visible": _vm.visible
  })], 2), _vm._v(" "), _vm.footerVisible ? _c('div', {
    staticClass: "aq-dialog__footer"
  }, [_c('aq-divider'), _vm._v(" "), _c('div', {
    staticClass: "aq-dialog__footer-content"
  }, [_c('div', [_vm._t("footer-left")], 2), _vm._v(" "), _c('div', [_vm._t("footer-right")], 2)])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-transtion-4"
    }
  }, [_vm.visible ? _c('div', {
    ref: "backdrop",
    class: ['aq-dialog__backdrop'],
    style: _vm.backDropStyle,
    on: {
      "click": _vm.closeBackdrop
    }
  }) : _vm._e()])], 1);
};
var __vue_staticRenderFns__$b = [];

/* style */
var __vue_inject_styles__$b = undefined;
/* scoped */
var __vue_scope_id__$b = undefined;
/* module identifier */
var __vue_module_identifier__$b = undefined;
/* functional template */
var __vue_is_functional_template__$b = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$b = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$b,
  staticRenderFns: __vue_staticRenderFns__$b
}, __vue_inject_styles__$b, __vue_script__$b, __vue_scope_id__$b, __vue_is_functional_template__$b, __vue_module_identifier__$b, false, undefined, undefined, undefined);
var AqDialog = __vue_component__$b;

//
var script$a = {
  name: 'aq-drawer',
  mixins: [idMixin, zIndexMixin],
  props: {
    value: {
      type: Boolean,
      default: false
    },
    header: {
      type: Boolean,
      default: true
    },
    footer: {
      type: Boolean,
      default: true
    },
    close: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: ''
    },
    options: {
      type: Object,
      default: function _default() {
        return {
          active: false,
          items: []
        };
      }
    },
    closeOnBackdrop: {
      type: Boolean,
      default: true
    },
    title: {
      type: [String, Function],
      default: ''
    },
    state: {
      type: String,
      default: '',
      validator: function validator(x) {
        return ['', 'info', 'success', 'warning', 'danger'].includes(x.toLowerCase());
      }
    },
    type: {
      type: String,
      default: 'overlay',
      validator: function validator(x) {
        return ['', 'overlay', 'plain'].includes(x.toLowerCase());
      }
    },
    size: {
      type: String,
      default: 'small',
      validator: function validator(x) {
        return ['', 'small', 'medium', 'large', 'full'].includes(x.toLowerCase());
      }
    },
    back: {
      type: Boolean,
      default: false
    },
    closeOnEscape: {
      type: Boolean,
      default: false
    },
    floatLeft: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: function value(newVal, type) {
      this.onValueChanged(newVal, type);
    },
    visible: function visible() {
      this.$emit('input', this.visible);
    }
  },
  data: function data() {
    return {
      visible: false,
      overflow: null
    };
  },
  computed: {
    getTransition: function getTransition() {
      var transtion = '';
      if (this.isOverlay) {
        transtion = !this.floatLeft ? 'right-fade-in-transtion' : 'left-fade-in-transtion';
        if (this.size === 'large') {
          transtion = "".concat(transtion, "-large");
        } else if (this.size === 'medium') {
          transtion = "".concat(transtion, "-medium");
        } else {
          transtion = "".concat(transtion, "-small");
        }
      }
      return transtion;
    },
    getParentTransition: function getParentTransition() {
      return !this.isOverlay ? 'right-fade-parent' : '';
    },
    disabledZIndex: function disabledZIndex() {
      return !this.isOverlay;
    },
    parentVisible: function parentVisible() {
      var visible = true;
      if (!this.isOverlay) {
        visible = this.visible;
      }
      return visible;
    },
    childVisible: function childVisible() {
      var visible = true;
      if (this.isOverlay) {
        visible = this.visible;
      }
      return visible;
    },
    contentStyle: function contentStyle() {
      return {
        zIndex: this.zIndexContent
      };
    },
    backDropStyle: function backDropStyle() {
      return {
        zIndex: this.zIndexBackdrop
      };
    },
    zIndexContent: function zIndexContent() {
      return this.baseZIndex + 1;
    },
    zIndexBackdrop: function zIndexBackdrop() {
      return this.baseZIndex;
    },
    isOverlay: function isOverlay() {
      return this.type === 'overlay';
    },
    isBackdrop: function isBackdrop() {
      return this.visible && this.isOverlay;
    },
    hasInfo: function hasInfo() {
      return this.$slots.header !== undefined || this.back;
    },
    hasOnlySlot: function hasOnlySlot() {
      return !this.back && this.$slots.header === undefined;
    },
    hasOnlyBack: function hasOnlyBack() {
      return this.back && this.$slots.header !== undefined;
    },
    hasOnlyTitle: function hasOnlyTitle() {
      return !this.back && !this.hasIcon && this.$slots.header === undefined;
    },
    hasIcon: function hasIcon() {
      return !!this.icon;
    },
    hasHeader: function hasHeader() {
      return this.header && !!this.title;
    },
    hasFooter: function hasFooter() {
      return this.footer && (this.$slots['footer-left'] !== undefined || this.$slots['footer-right'] !== undefined);
    },
    getIcon: function getIcon() {
      var icon = '';
      switch (this.state.toLowerCase()) {
        case 'info':
          icon = 'aq-icon-info-circle-fill';
          break;
        case 'success':
          icon = 'aq-icon-check-circle-fill';
          break;
        case 'warning':
          icon = 'aq-icon-info-major-triangle-up-fill';
          break;
        case 'danger':
          icon = 'aq-icon-alert-circle-fill';
          break;
        default:
          icon = '';
      }
      return icon;
    }
  },
  methods: {
    emitSelectOption: function emitSelectOption(val) {
      this.$emit('option:click', val);
    },
    onValueChanged: function onValueChanged(newVal, type) {
      if (newVal) {
        this.show(newVal);
        global.vtEvent.$emit('aq-table.setHeader');
      } else {
        this.hide(type);
      }
    },
    show: function show(newVal) {
      if (!this.visible) {
        this.visible = newVal;
        this.$emit('onOpen');
        if (this.isOverlay) {
          this.overflow = document.getElementsByTagName('html')[0].style.overflow;
          document.getElementsByTagName('html')[0].style.overflow = 'hidden';
        }
      }
    },
    hide: function hide() {
      var closeType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      if (this.isOverlay) {
        document.getElementsByTagName('html')[0].style.overflow = this.overflow;
      }
      this.visible = false;
      this.validateCloseType(closeType);
      this.$root.$emit('aq::popovers::close');
    },
    validateCloseType: function validateCloseType(closeType) {
      if (closeType === EVENT_NAME_CLOSE_CANCEL) {
        this.$emit(EVENT_NAME_CLOSE_CANCEL);
      } else if (closeType === EVENT_NAME_CLOSE_OK) {
        this.$emit(EVENT_NAME_CLOSE_OK);
      } else if (closeType === '') {
        this.$emit('onClose');
        this.$emit(EVENT_NAME_CLOSE);
      }
    },
    closeBackdrop: function closeBackdrop() {
      if (this.closeOnBackdrop) {
        this.hide();
      }
    },
    eventOpenDrawer: function eventOpenDrawer(data) {
      if ('value' in data && data.value === this.id) {
        this.onValueChanged(true);
      }
    },
    eventCloseDrawer: function eventCloseDrawer(data) {
      if ('value' in data && data.value === this.id || 'noId' in data) {
        var type = 'type' in data ? data.type : '';
        this.onValueChanged(false, type);
      }
    },
    keyDownEvent: function keyDownEvent(event) {
      if (event.keyCode === CODE_ESC && this.closeOnEscape) {
        event.preventDefault();
        this.hide();
      }
    }
  },
  mounted: function mounted() {
    this.onValueChanged(this.value, 'initial');
    if (this.isOverlay) {
      appendEl({
        children: this.$el
      });
    }
    this.$root.$on(EVENT_NAME_GLOBAL_SHOW_DRAWER, this.eventOpenDrawer);
    this.$root.$on(EVENT_NAME_GLOBAL_HIDE_DRAWER, this.eventCloseDrawer);
    this.$on("_".concat(EVENT_NAME_GLOBAL_SHOW_DRAWER), this.eventOpenDrawer);
    this.$on("_".concat(EVENT_NAME_GLOBAL_HIDE_DRAWER), this.eventCloseDrawer);
    document.addEventListener('keydown', this.keyDownEvent);
  },
  beforeDestroy: function beforeDestroy() {
    this.hide();
    if (this.isOverlay) {
      removeEl({
        children: this.$el
      });
    }
    this.$root.$off(EVENT_NAME_GLOBAL_SHOW_DRAWER, this.eventOpenDrawer);
    this.$root.$off(EVENT_NAME_GLOBAL_HIDE_DRAWER, this.eventCloseDrawer);
    this.$off("_".concat(EVENT_NAME_GLOBAL_SHOW_DRAWER), this.eventOpenDrawer);
    this.$off("_".concat(EVENT_NAME_GLOBAL_HIDE_DRAWER), this.eventCloseDrawer);
    document.removeEventListener('keydown', this.keyDownEvent);
  }
};

/* script */
var __vue_script__$a = script$a;

/* template */
var __vue_render__$a = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('transition', {
    attrs: {
      "name": _vm.getParentTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.parentVisible,
      expression: "parentVisible"
    }],
    class: ['aq-drawer', 'aq-drawer--' + _vm.size, {
      'aq-drawer--plain': !_vm.isOverlay
    }],
    attrs: {
      "id": _vm.id
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.getTransition
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.childVisible,
      expression: "childVisible"
    }],
    class: ['aq-drawer__content', 'aq-drawer__content--' + _vm.size, {
      'aq-drawer__content--overlay': _vm.isOverlay,
      'aq-drawer__content--plain': !_vm.isOverlay
    }, {
      'aq-drawer__content--left': _vm.floatLeft
    }],
    style: _vm.contentStyle
  }, [_vm.hasHeader ? _c('div', {
    staticClass: "aq-drawer__header"
  }, [_c('div', {
    class: ['aq-drawer__header-content']
  }, [_vm.back ? _c('em', {
    staticClass: "aq-icon-chevron-left aq-drawer__back",
    on: {
      "click": function click($event) {
        return _vm.hide();
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.hasIcon ? _c('em', {
    class: [_vm.icon, 'aq-drawer__icon']
  }) : _vm._e(), _vm._v(" "), _vm.hasInfo ? _c('div', {
    class: [{
      'aq-drawer__header-content-slot': _vm.hasOnlySlot
    }, {
      'aq-drawer__header-content-back': _vm.hasOnlyBack
    }]
  }, [_vm._t("header")], 2) : _vm._e(), _vm._v(" "), _c('span', {
    class: {
      'aq-drawer__back-title': _vm.hasOnlyTitle
    }
  }, [_vm._v(_vm._s(_vm.$aqT(_vm.title)))]), _vm._v(" "), _c('em', {
    class: ['aq-drawer__header-state-icon', _vm.getIcon]
  })]), _vm._v(" "), _c('div', {
    staticClass: "aq-drawer__header-right"
  }, [_vm.options.active ? _c('aq-dropdown', {
    staticClass: "aq-drawer__header-options",
    attrs: {
      "items": _vm.options.items
    },
    on: {
      "click": _vm.emitSelectOption
    }
  }, [_c('aq-button', {
    attrs: {
      "icon": "aq-icon-three-dots-vertical"
    }
  })], 1) : _vm._e(), _vm._v(" "), _vm.close ? _c('em', {
    staticClass: "aq-icon-close aq-drawer__close",
    on: {
      "click": function click($event) {
        return _vm.hide();
      }
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _vm.header ? _c('aq-divider') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "aq-drawer__body aq-scroll-bar"
  }, [_vm._t("default", null, {
    "visible": _vm.visible
  })], 2), _vm._v(" "), _vm.hasFooter ? _c('div', {
    staticClass: "aq-drawer__footer"
  }, [_c('aq-divider'), _vm._v(" "), _c('div', {
    staticClass: "aq-drawer__footer-content"
  }, [_c('div', [_vm._t("footer-left")], 2), _vm._v(" "), _c('div', [_vm._t("footer-right")], 2)])], 1) : _vm._e()], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade-transtion-4"
    }
  }, [_vm.isBackdrop ? _c('div', {
    class: ['aq-drawer__backdrop'],
    style: _vm.backDropStyle,
    on: {
      "click": _vm.closeBackdrop
    }
  }) : _vm._e()])], 1)]);
};
var __vue_staticRenderFns__$a = [];

/* style */
var __vue_inject_styles__$a = undefined;
/* scoped */
var __vue_scope_id__$a = undefined;
/* module identifier */
var __vue_module_identifier__$a = undefined;
/* functional template */
var __vue_is_functional_template__$a = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$a = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$a,
  staticRenderFns: __vue_staticRenderFns__$a
}, __vue_inject_styles__$a, __vue_script__$a, __vue_scope_id__$a, __vue_is_functional_template__$a, __vue_module_identifier__$a, false, undefined, undefined, undefined);
var AqDrawer = __vue_component__$a;

//
var script$9 = {
  name: 'aq-popover',
  mixins: [zIndexMixin],
  props: {
    value: {
      type: Boolean,
      default: null
    },
    closeOnBackdrop: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom-start'
    },
    idParent: {
      type: String,
      default: 'bottom-start'
    },
    isHover: {
      type: Boolean,
      default: false
    },
    showArrow: {
      type: Boolean,
      default: true
    },
    header: {
      type: Boolean,
      default: false
    },
    footer: {
      type: Boolean,
      default: false
    },
    close: {
      type: Boolean,
      default: true
    },
    title: {
      type: [String, Function],
      default: ''
    },
    state: {
      type: String,
      default: 'default'
    },
    icon: {
      type: String,
      default: ''
    },
    woPadding: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    value: function value(newVal) {
      if (newVal) {
        this.show();
      } else {
        this.hide();
      }
    },
    visible: function visible() {
      this.$emit('input', this.visible);
    }
  },
  data: function data() {
    return {
      visible: false,
      poperInstance: null,
      popoverChild: [],
      footerVisible: this.footer,
      headerVisible: this.header
    };
  },
  computed: {
    style: function style() {
      return {
        zIndex: this.baseZIndex
      };
    },
    styleHeader: function styleHeader() {
      return {
        display: this.header && this.headerVisible ? 'flex' : 'none'
      };
    },
    styleFooter: function styleFooter() {
      return {
        display: this.footer && this.footerVisible ? 'block' : 'none'
      };
    }
  },
  methods: {
    show: function show() {
      this.visible = true;
      this.poperInstance.update();
    },
    hide: function hide() {
      this.visible = false;
    },
    validateClickOnBackdrop: function validateClickOnBackdrop(event) {
      if (this.visible) {
        var parent = document.getElementById(this.idParent);
        if (parent && !parent.contains(event.target) && !this.validateClickChild(event) && !this.$refs.popover.contains(event.target)) {
          this.hide();
        }
      }
    },
    validateClickChild: function validateClickChild(event) {
      var onChild = false;
      this.popoverChild.forEach(function (val) {
        if (val.clickOnPopover(event)) {
          onChild = true;
        }
      });
      return onChild;
    },
    addListeners: function addListeners() {
      var _this$idParent;
      if (this.closeOnBackdrop) {
        document.addEventListener('click', this.validateClickOnBackdrop);
      }
      if (this.value === null && ((_this$idParent = this.idParent) === null || _this$idParent === void 0 ? void 0 : _this$idParent.length) > 0) {
        var parent = document.getElementById(this.idParent);
        if (parent) {
          if (this.isHover) {
            parent.addEventListener('mouseover', this.toggleVisible);
            parent.addEventListener('mouseleave', this.toggleVisible);
          } else {
            parent.addEventListener('click', this.toggleVisible);
          }
        }
      }
    },
    toggleVisible: function toggleVisible() {
      var _this = this;
      setTimeout(function () {
        if (_this.visible) {
          _this.visible = false;
        } else {
          _this.visible = true;
          _this.poperInstance.update();
        }
      });
    },
    removeListeners: function removeListeners() {
      var _this$idParent2;
      if (this.closeOnBackdrop) {
        document.removeEventListener('click', this.validateClickOnBackdrop);
      }
      if (this.value === null && ((_this$idParent2 = this.idParent) === null || _this$idParent2 === void 0 ? void 0 : _this$idParent2.length) > 0) {
        var parent = document.getElementById(this.idParent);
        if (parent) {
          if (this.isHover) {
            parent.removeEventListener('mouseover', this.toggleVisible);
            parent.removeEventListener('mouseleave', this.toggleVisible);
          } else {
            parent.removeEventListener('click', this.toggleVisible);
          }
        }
      }
    },
    setFooterVisible: function setFooterVisible() {
      if (this.footer) {
        this.footerVisible = !!this.$slots['footer-left'] || !!this.$slots['footer-right'];
      }
    },
    setHeaderVisible: function setHeaderVisible() {
      this.headerVisible = this.title !== '';
    }
  },
  mounted: function mounted() {
    var _this$idParent3,
      _this2 = this;
    this.setFooterVisible();
    this.setHeaderVisible();
    var arrow = this.$refs.arrow;
    var parent;
    if (((_this$idParent3 = this.idParent) === null || _this$idParent3 === void 0 ? void 0 : _this$idParent3.length) > 0) {
      parent = document.getElementById(this.idParent);
    }
    if (parent && this.$refs.popover && arrow && !global[CONFIG_AQUA_POPOVER_TEST_MODE]) {
      this.poperInstance = createPopper(parent, this.$refs.popover, {
        placement: this.position,
        modifiers: [{
          name: 'arrow',
          options: {
            element: arrow,
            padding: 5
          }
        }, {
          name: 'offset',
          options: {
            offset: [7, 10]
          }
        }]
      });
      this.addListeners();
    }
    setTimeout(function () {
      appendEl({
        children: _this2.$el
      });
    });
  },
  beforeDestroy: function beforeDestroy() {
    removeEl({
      children: this.$el
    });
    this.removeListeners();
  }
};

/* script */
var __vue_script__$9 = script$9;

/* template */
var __vue_render__$9 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    ref: "popover",
    staticClass: "aq-popover",
    style: _vm.style,
    attrs: {
      "id": _vm.uid
    }
  }, [_vm.visible ? [_c('div', {
    staticClass: "aq-popover__header",
    style: _vm.styleHeader
  }, [_vm.icon !== '' ? _c('em', {
    class: [_vm.icon, 'aq-popover__icon-state']
  }) : _vm._e(), _vm._v(" "), _vm._t("before-title"), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$aqT(_vm.title)))]), _vm._v(" "), _vm._t("after-title"), _vm._v(" "), _c('div', {
    staticClass: "aq-popover__header-left"
  }, [_vm._t("header-right"), _vm._v(" "), _vm.close ? _c('em', {
    staticClass: "aq-icon-close aq-popover__close",
    on: {
      "click": function click($event) {
        return _vm.hide();
      }
    }
  }) : _vm._e()], 2)], 2), _vm._v(" "), _c('aq-divider', {
    style: _vm.styleHeader
  }), _vm._v(" "), _c('div', {
    ref: "body",
    class: ['aq-popover__body aq-scroll-bar', {
      'aq-popover__body--wo-padding': _vm.woPadding
    }]
  }, [_vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "aq-popover__footer",
    style: _vm.styleFooter
  }, [_c('aq-divider'), _vm._v(" "), _c('div', {
    staticClass: "aq-popover__footer-content"
  }, [_c('div', [_vm._t("footer-left")], 2), _vm._v(" "), _c('div', [_vm._t("footer-right")], 2)])], 1)] : _vm._e(), _vm._v(" "), _c('div', {
    ref: "arrow",
    class: {
      'aq-popover__arrow': _vm.showArrow
    },
    attrs: {
      "data-popper-arrow": ""
    }
  })], 2);
};
var __vue_staticRenderFns__$9 = [];

/* style */
var __vue_inject_styles__$9 = undefined;
/* scoped */
var __vue_scope_id__$9 = undefined;
/* module identifier */
var __vue_module_identifier__$9 = undefined;
/* functional template */
var __vue_is_functional_template__$9 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$9 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$9,
  staticRenderFns: __vue_staticRenderFns__$9
}, __vue_inject_styles__$9, __vue_script__$9, __vue_scope_id__$9, __vue_is_functional_template__$9, __vue_module_identifier__$9, false, undefined, undefined, undefined);
var AqPopover = __vue_component__$9;

//
//
//
//

var script$8 = {};

/* script */
var __vue_script__$8 = script$8;

/* template */
var __vue_render__$8 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('code', {
    staticClass: "aq-code"
  }, [_vm._t("default")], 2);
};
var __vue_staticRenderFns__$8 = [];

/* style */
var __vue_inject_styles__$8 = undefined;
/* scoped */
var __vue_scope_id__$8 = undefined;
/* module identifier */
var __vue_module_identifier__$8 = undefined;
/* functional template */
var __vue_is_functional_template__$8 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$8 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$8,
  staticRenderFns: __vue_staticRenderFns__$8
}, __vue_inject_styles__$8, __vue_script__$8, __vue_scope_id__$8, __vue_is_functional_template__$8, __vue_module_identifier__$8, false, undefined, undefined, undefined);
var AqCode = __vue_component__$8;

//
//
//
//

var script$7 = {};

/* script */
var __vue_script__$7 = script$7;

/* template */
var __vue_render__$7 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('p', {
    staticClass: "aq-caption"
  }, [_vm._t("default")], 2);
};
var __vue_staticRenderFns__$7 = [];

/* style */
var __vue_inject_styles__$7 = undefined;
/* scoped */
var __vue_scope_id__$7 = undefined;
/* module identifier */
var __vue_module_identifier__$7 = undefined;
/* functional template */
var __vue_is_functional_template__$7 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$7 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$7,
  staticRenderFns: __vue_staticRenderFns__$7
}, __vue_inject_styles__$7, __vue_script__$7, __vue_scope_id__$7, __vue_is_functional_template__$7, __vue_module_identifier__$7, false, undefined, undefined, undefined);
var AqCaption = __vue_component__$7;

//
var script$6 = {
  mixins: [eventsMixin],
  computed: {
    infoIsVisible: function infoIsVisible() {
      var _this$$aqT;
      return ((_this$$aqT = this.$aqT(this.info)) === null || _this$$aqT === void 0 ? void 0 : _this$$aqT.length) > 0;
    }
  },
  props: {
    info: {
      type: String,
      default: ''
    },
    tooltipWidth: {
      type: String,
      default: ''
    }
  }
};

/* script */
var __vue_script__$6 = script$6;

/* template */
var __vue_render__$6 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('span', [_c('h1', {
    staticClass: "aq-heading",
    on: {
      "click": _vm.onClick
    }
  }, [_vm._t("default"), _vm._v(" "), _vm.info !== '' ? _c('aq-tooltip', {
    attrs: {
      "width": _vm.tooltipWidth
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_vm.infoIsVisible ? _c('em', {
          staticClass: "aq-icon-alert-circle",
          attrs: {
            "aria-hidden": "true"
          }
        }) : _vm._e()];
      },
      proxy: true
    }], null, false, 2818392992)
  }, [_vm._v(" "), [_vm._v("\n        " + _vm._s(_vm.$aqT(_vm.info)) + "\n      ")]], 2) : _vm._e()], 2)]);
};
var __vue_staticRenderFns__$6 = [];

/* style */
var __vue_inject_styles__$6 = undefined;
/* scoped */
var __vue_scope_id__$6 = undefined;
/* module identifier */
var __vue_module_identifier__$6 = undefined;
/* functional template */
var __vue_is_functional_template__$6 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$6 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$6,
  staticRenderFns: __vue_staticRenderFns__$6
}, __vue_inject_styles__$6, __vue_script__$6, __vue_scope_id__$6, __vue_is_functional_template__$6, __vue_module_identifier__$6, false, undefined, undefined, undefined);
var AqHeading = __vue_component__$6;

//
//
//
//
//
//

var script$5 = {
  props: {
    text: {
      type: [String, Function],
      default: ''
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isVisible: function isVisible() {
      var _this$$aqT;
      return ((_this$$aqT = this.$aqT(this.text)) === null || _this$$aqT === void 0 ? void 0 : _this$$aqT.length) > 0;
    }
  }
};

/* script */
var __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _vm.isVisible ? _c('div', {
    class: ['aq-helper-text', {
      'aq-helper-text--error': _vm.error
    }]
  }, [_vm._v("\n  " + _vm._s(_vm.$aqT(_vm.text)) + "\n")]) : _vm._e();
};
var __vue_staticRenderFns__$5 = [];

/* style */
var __vue_inject_styles__$5 = undefined;
/* scoped */
var __vue_scope_id__$5 = undefined;
/* module identifier */
var __vue_module_identifier__$5 = undefined;
/* functional template */
var __vue_is_functional_template__$5 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$5 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$5,
  staticRenderFns: __vue_staticRenderFns__$5
}, __vue_inject_styles__$5, __vue_script__$5, __vue_scope_id__$5, __vue_is_functional_template__$5, __vue_module_identifier__$5, false, undefined, undefined, undefined);
var AqHelperText = __vue_component__$5;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var script$4 = {
  props: {
    for: {
      type: String,
      default: ''
    },
    info: {
      type: [String, Function],
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    tooltipWidth: {
      type: String,
      default: ''
    }
  },
  computed: {
    getFor: function getFor() {
      return this.for;
    },
    infoIsVisible: function infoIsVisible() {
      var _this$$aqT;
      return ((_this$$aqT = this.$aqT(this.info)) === null || _this$$aqT === void 0 ? void 0 : _this$$aqT.length) > 0;
    }
  },
  methods: {
    onClick: function onClick(e) {
      this.$emit('click', e);
    }
  }
};

/* script */
var __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('label', {
    class: ['aq-label', {
      'aq-label--disabled': _vm.disabled
    }],
    attrs: {
      "for": _vm.getFor
    },
    on: {
      "click": _vm.onClick
    }
  }, [_vm._t("default"), _vm._v(" "), _vm.required ? _c('span', {
    staticClass: "aq-label__requided"
  }, [_vm._v("*")]) : _vm._e(), _vm._v(" "), _c('aq-tooltip', {
    attrs: {
      "width": _vm.tooltipWidth
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_vm.infoIsVisible ? _c('em', {
          staticClass: "aq-icon-info-circle aq-label__info",
          attrs: {
            "aria-hidden": "true"
          }
        }) : _vm._e()];
      },
      proxy: true
    }])
  }, [_vm._v(" "), [_vm._v("\n      " + _vm._s(_vm.$aqT(_vm.info)) + "\n    ")]], 2)], 2);
};
var __vue_staticRenderFns__$4 = [];

/* style */
var __vue_inject_styles__$4 = undefined;
/* scoped */
var __vue_scope_id__$4 = undefined;
/* module identifier */
var __vue_module_identifier__$4 = undefined;
/* functional template */
var __vue_is_functional_template__$4 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$4 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$4,
  staticRenderFns: __vue_staticRenderFns__$4
}, __vue_inject_styles__$4, __vue_script__$4, __vue_scope_id__$4, __vue_is_functional_template__$4, __vue_module_identifier__$4, false, undefined, undefined, undefined);
var AqLabel = __vue_component__$4;

//
//
//
//
//
//
//
//
//
//

var script$3 = {
  props: {
    href: {
      type: String,
      default: ''
    },
    target: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};

/* script */
var __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('a', {
    class: ['aq-link', {
      'aq-link--disabled': _vm.disabled
    }],
    attrs: {
      "rel": "noopener",
      "href": _vm.href,
      "target": _vm.target
    }
  }, [_vm._t("default")], 2);
};
var __vue_staticRenderFns__$3 = [];

/* style */
var __vue_inject_styles__$3 = undefined;
/* scoped */
var __vue_scope_id__$3 = undefined;
/* module identifier */
var __vue_module_identifier__$3 = undefined;
/* functional template */
var __vue_is_functional_template__$3 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$3 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$3,
  staticRenderFns: __vue_staticRenderFns__$3
}, __vue_inject_styles__$3, __vue_script__$3, __vue_scope_id__$3, __vue_is_functional_template__$3, __vue_module_identifier__$3, false, undefined, undefined, undefined);
var AqLink = __vue_component__$3;

//
var script$2 = {
  mixins: [eventsMixin],
  props: {
    required: {
      type: Boolean,
      default: false
    },
    info: {
      type: String,
      default: ''
    },
    tooltipWidth: {
      type: String,
      default: ''
    }
  },
  computed: {
    infoIsVisible: function infoIsVisible() {
      var _this$$aqT;
      return ((_this$$aqT = this.$aqT(this.info)) === null || _this$$aqT === void 0 ? void 0 : _this$$aqT.length) > 0;
    }
  }
};

/* script */
var __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('h3', {
    staticClass: "aq-subheading",
    on: {
      "click": _vm.onClick
    }
  }, [_vm._t("default"), _vm.required ? _c('span', {
    staticClass: "aq-subheading--required"
  }) : _vm._e(), _vm._v(" "), _vm.info !== '' ? _c('aq-tooltip', {
    attrs: {
      "width": _vm.tooltipWidth
    },
    scopedSlots: _vm._u([{
      key: "content",
      fn: function fn() {
        return [_vm.infoIsVisible ? _c('em', {
          staticClass: "aq-icon-alert-circle aq-subheading__info-icon aq-subheading__info",
          attrs: {
            "aria-hidden": "true"
          }
        }) : _vm._e()];
      },
      proxy: true
    }], null, false, 1417985606)
  }, [_vm._v(" "), [_vm._v("\n      " + _vm._s(_vm.$aqT(_vm.info)) + "\n    ")]], 2) : _vm._e()], 2);
};
var __vue_staticRenderFns__$2 = [];

/* style */
var __vue_inject_styles__$2 = undefined;
/* scoped */
var __vue_scope_id__$2 = undefined;
/* module identifier */
var __vue_module_identifier__$2 = undefined;
/* functional template */
var __vue_is_functional_template__$2 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$2 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$2,
  staticRenderFns: __vue_staticRenderFns__$2
}, __vue_inject_styles__$2, __vue_script__$2, __vue_scope_id__$2, __vue_is_functional_template__$2, __vue_module_identifier__$2, false, undefined, undefined, undefined);
var AqSubheading = __vue_component__$2;

//
//
//
//
//
//

var script$1 = {};

/* script */
var __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('section', {
    staticClass: "aq-main-content"
  }, [_vm._t("default")], 2);
};
var __vue_staticRenderFns__$1 = [];

/* style */
var __vue_inject_styles__$1 = undefined;
/* scoped */
var __vue_scope_id__$1 = undefined;
/* module identifier */
var __vue_module_identifier__$1 = undefined;
/* functional template */
var __vue_is_functional_template__$1 = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__$1 = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__$1,
  staticRenderFns: __vue_staticRenderFns__$1
}, __vue_inject_styles__$1, __vue_script__$1, __vue_scope_id__$1, __vue_is_functional_template__$1, __vue_module_identifier__$1, false, undefined, undefined, undefined);
var AqMainContent = __vue_component__$1;

//
var script = {
  components: {
    AqContent: AqMainContent
  }
};

/* script */
var __vue_script__ = script;

/* template */
var __vue_render__ = function __vue_render__() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('section', {
    staticClass: "aq-main-container"
  }, [_c('aq-content', [_vm._t("default")], 2)], 1);
};
var __vue_staticRenderFns__ = [];

/* style */
var __vue_inject_styles__ = undefined;
/* scoped */
var __vue_scope_id__ = undefined;
/* module identifier */
var __vue_module_identifier__ = undefined;
/* functional template */
var __vue_is_functional_template__ = false;
/* style inject */

/* style inject SSR */

/* style inject shadow dom */

var __vue_component__ = /*#__PURE__*/normalizeComponent$1({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, false, undefined, undefined, undefined);
var AqMainContainer = __vue_component__;

// actions
var Components = {
  AqButton: AqButton,
  AqButtonGroup: AqButtonGroup,
  AqButtonSplit: AqButtonSplit,
  AqLabel: AqLabel,
  AqHelperText: AqHelperText,
  AqHeading: AqHeading,
  AqCaption: AqCaption,
  AqVoicePlayer: AqVoicePlayer,
  MiniAudio: MiniAudio,
  AqCode: AqCode,
  AqLink: AqLink,
  AqSubheading: AqSubheading,
  AqBanner: AqBanner,
  AqToggle: AqToggle,
  AqCheckbox: AqCheckbox,
  AqRadioButton: AqRadioButton,
  AqTag: AqTag,
  AqAvatar: AqAvatar,
  AqTimePicker: AqTimePicker,
  AqDatePicker: AqDatePicker,
  AqTooltip: AqTooltip,
  AqMenu: AqMenu,
  AqMenuItem: AqMenuItem,
  AqMenuContent: AqMenuContent,
  AqTextField: AqTextField,
  AqTextEditor: AqTextEditor,
  AqAutoComplete: AqAutoComplete,
  AqMainContainer: AqMainContainer,
  AqMainContent: AqMainContent,
  AqDivider: AqDivider,
  AqNumberField: AqNumberField,
  AqSlider: AqSlider,
  AqBadge: AqBadge,
  AqProgressBar: AqProgressBar,
  AqTab: AqTab,
  AqTabGroup: AqTabGroup,
  AqBreadcrumb: AqBreadcrumb,
  AqDrawer: AqDrawer,
  AqSpinner: AqSpinner,
  AqDialog: AqDialog,
  AqPopover: AqPopover,
  AqRadio: AqRadio,
  AqRadioGroup: AqRadioGroup,
  AqRadioCard: AqRadioCard,
  AqSearchBar: AqSearchBar,
  AqStatus: AqStatus,
  AqSelect: AqSelect,
  AqCheckboxButton: AqCheckboxButton,
  AqCheckboxGroup: AqCheckboxGroup,
  AqCheckboxCard: AqCheckboxCard,
  AqStep: AqStep,
  AqStepGroup: AqStepGroup,
  AqDropdown: AqDropdown,
  AqDropdownContent: AqDropdownContent,
  AqDropdownItem: AqDropdownItem,
  AqCodeEditor: AqCodeEditor,
  AqTagGroup: AqTagGroup,
  AqListMenu: AqListMenu,
  AqListMenuItem: AqListMenuItem,
  AqColorPicker: AqColorPicker,
  AqTagField: AqTagField,
  AqFieldGroup: AqFieldGroup,
  AqFlag: AqFlag,
  AqFlagSelector: AqFlagSelector,
  AqCollapse: AqCollapse,
  AqCollapseHeader: AqCollapseHeader,
  AqCollapseContent: AqCollapseContent,
  AqCollapseGroup: AqCollapseGroup,
  AqPagination: AqPagination,
  AqCard: AqCard,
  AqCardHeader: AqCardHeader,
  AqCardContent: AqCardContent,
  AqCardFooter: AqCardFooter,
  AqCardGroup: AqCardGroup,
  AqImg: AqImg,
  AqList: AqList,
  AqTotalsRow: AqTotalsRow,
  AqTabItem: AqTabItem,
  AqTabItems: AqTabItems,
  AqSettingGroup: AqSettingGroup,
  AqSettingStep: AqSettingStep,
  AqSettingHeader: AqSettingHeader,
  AqSettingContent: AqSettingContent,
  AqSettingFooter: AqSettingFooter,
  AqTreeMenu: AqTreeMenu,
  AqFileUploader: AqFileUploader,
  AqListGroup: AqListGroup,
  AqListGroupItem: AqListGroupItem,
  AqStepItems: AqStepItems,
  AqStepItem: AqStepItem
};
var ComponentsTable = {
  TableHeading: TableHeading,
  SortControl: SortControl,
  HeadingsRow: HeadingsRow,
  TableCell: TableCell,
  DataTable: DataTable,
  TableHead: TableHead,
  Pagination: AqPagination,
  PerPageSelector: PerPageSelector,
  GenericFilter: GenericFilter,
  TableRow: TableRow,
  TableBody: TableBody,
  ChildRowToggler: ChildRowToggler,
  RowSelector: RowSelector,
  ColumnsDropdown: ColumnsDropdown,
  Table: Table,
  NoResultsRow: NoResultsRow
};
var customTemplatesTable = {
  table: ComponentsTable.Table,
  tableHeading: ComponentsTable.TableHeading,
  sortControl: ComponentsTable.SortControl,
  headingsRow: ComponentsTable.HeadingsRow,
  tableCell: ComponentsTable.TableCell,
  dataTable: ComponentsTable.DataTable,
  tableHead: ComponentsTable.TableHead,
  pagination: ComponentsTable.Pagination,
  perPageSelector: ComponentsTable.PerPageSelector,
  genericFilter: ComponentsTable.GenericFilter,
  tableRow: ComponentsTable.TableRow,
  tableBody: ComponentsTable.TableBody,
  childRowToggler: ComponentsTable.ChildRowToggler,
  rowSelector: ComponentsTable.RowSelector,
  columnsDropdown: ComponentsTable.ColumnsDropdown,
  noResultsRow: ComponentsTable.NoResultsRow
};

var es = {
  test: 'ES',
  locale: 'es',
  completed: 'Completado',
  paused: 'En pausa',
  error: 'Error',
  errors: 'errores',
  emptyState: 'No se encontraron coincidencias',
  selectAll: 'Seleccionar todo',
  deselectAll: 'Deseleccionar todo',
  apply: 'Aplicar',
  cancel: 'Cancelar',
  clean: 'Limpiar',
  start: 'Inicio',
  end: 'Fin',
  range: 'Rango',
  day: 'día',
  days: 'días',
  hour: 'hora',
  hours: 'horas',
  minute: 'minuto',
  minutes: 'minutos',
  personalized: 'Personalizado',
  today: 'Hoy',
  yesterday: 'Ayer',
  last7Days: 'Últimos 7 días',
  last30Days: 'Últimos 30 días',
  thisMonth: 'Este mes',
  lastMonth: 'Último mes',
  notResultsRows: 'No se encontraron registros',
  notRequestsRows: 'No se encontraron busquedas',
  loadingMessage: 'Cargando datos',
  header: 'Paso',
  subheader: 'Descripción del contenido',
  copy: 'Copiar',
  discard: 'Descartar',
  continue: 'Continuar',
  edit: 'Editar',
  itemsPerPage: 'Elementos por página',
  numberOfElements: '{0}-{1} de {2} Elementos',
  selectedItems: '{0} Items seleccionados',
  selectOptions: 'Seleccione opción(es)',
  file: 'archivo',
  files: 'archivos',
  element: 'elemento',
  elements: 'elementos',
  uploading: 'Subiendo',
  close: 'Cerrar',
  loaded: 'Se han subido',
  load: 'Se ha subido',
  noLoad: 'No se han subido archivos',
  cancelLoad: 'Cancelar carga de archivos',
  cancelLoadInfo: 'La carga de tus archivos no se ha completado',
  cancelLoadQuestion: '¿Deseas cancelar la carga de archivos?',
  cancelLoadConfirmation: 'Cancelar Carga ',
  rows: 'Filas:',
  records: 'Registros:',
  fileUploader: {
    dropFile: 'Suelta tu archivo aquí para cargarlo ó',
    selectFile: 'Seleccionar Archivo',
    supportedFormats: 'Formatos soportados:',
    addFiles: 'Agregar archivos',
    totalWeight: 'Peso cargado:',
    maxWeight: 'Peso permitido:',
    maxFileUpload: 'Archivos agregados:',
    totalFilesUpload: 'Archivos permitidos:',
    filesUpload: 'Archivos cargados:',
    exceedMaxUploadTitle: 'Limite de archivos excedido',
    exceedMaxWeightTitle: 'Limite de peso excedido',
    notAllowedFileTitle: 'Formato de archivo no permitido',
    notAllowedFile: 'Lo sentimos, pero el archivo que intentas cargar tiene un formato no permitido.',
    notAllowedFiles: 'Lo sentimos, pero al menos uno de los archivos que intentas cargar tiene un formato no permitido.',
    uploadedFilesInfo: 'Inf. archivos',
    uploadedWeightInfo: 'Inf. peso',
    exceedMaxWeightTextPart1: 'Lo sentimos pero el(los) ',
    exceedMaxWeightTextPart2: ' excede(n) el peso de',
    cantLoadFiles: 'El limite permitido de archivos cargados ha sido excedido, por tal razón, no es posible cargar más archivos.',
    exceedMaxUploadTextPart1: 'Se está excediendo el limite de ',
    exceedMaxUploadTextPart2: 'para cargar, por favor seleccione los archivos que en realidad desea cargar'
  },
  BD: 'Bangladesh',
  BE: 'Bélgica',
  BF: 'Burkina Faso',
  BG: 'Bulgaria',
  BA: 'Bosnia y Herzegovina',
  BB: 'Barbados',
  WF: 'Wallis y Futuna',
  BL: 'San Bartolomé',
  BM: 'Bermudas',
  BN: 'Brunei',
  BO: 'Bolivia',
  BH: 'Bahrein',
  BI: 'Burundi',
  BJ: 'Benín',
  BT: 'Bután',
  JM: 'Jamaica',
  BV: 'Isla Bouvet',
  BW: 'Botsuana',
  WS: 'Samoa',
  BQ: 'Bonaire, San Eustaquio y Saba',
  BR: 'Brasil',
  BS: 'Bahamas',
  JE: 'Jersey',
  BY: 'Bielorrusia',
  BZ: 'Belice',
  RU: 'Rusia',
  RW: 'Ruanda',
  RS: 'Serbia',
  TL: 'Timor Oriental',
  RE: 'Reunión',
  TM: 'Turkmenistán',
  TJ: 'Tayikistán',
  RO: 'Rumanía',
  TK: 'Tokelau',
  GW: 'Guinea-Bissau',
  GU: 'Guam',
  GT: 'Guatemala',
  GS: 'Georgia del Sur y las Islas Sandwich del Sur',
  GR: 'Grecia',
  GQ: 'Guinea Ecuatorial',
  GP: 'Guadalupe',
  JP: 'Japón',
  GY: 'Guyana',
  GG: 'Guernsey',
  GF: 'Guayana Francesa',
  GE: 'Georgia',
  GD: 'Granada',
  GB: 'Inglaterra',
  GA: 'Gabón',
  SV: 'El Salvador',
  GN: 'Guinea',
  GM: 'Gambia',
  GL: 'Groenlandia',
  GI: 'Gibraltar',
  GH: 'Ghana',
  OM: 'Omán',
  TN: 'Túnez',
  JO: 'Jordania',
  HR: 'Croacia',
  HT: 'Haití',
  HU: 'Hungría',
  HK: 'Hong Kong',
  HN: 'Honduras',
  HM: 'Isla Heard e Islas McDonald',
  VE: 'Venezuela',
  PR: 'Puerto Rico',
  PS: 'Territorio Palestino',
  PW: 'Palau',
  PT: 'Portugal',
  SJ: 'Svalbard y Jan Mayen',
  PY: 'Paraguay',
  IQ: 'Iraq',
  PA: 'Panamá',
  PF: 'Polinesia Francesa',
  PG: 'Papúa Nueva Guinea',
  PE: 'Perú',
  PK: 'Pakistán',
  PH: 'Filipinas',
  PN: 'Pitcairn',
  PL: 'Polonia',
  PM: 'San Pedro y Miquelón',
  ZM: 'Zambia',
  EH: 'Sahara Occidental',
  EE: 'Estonia',
  EG: 'Egipto',
  ZA: 'África del Sur',
  EC: 'Ecuador',
  IT: 'Italia',
  VN: 'Vietnam',
  SB: 'Islas Salomón',
  ET: 'Etiopía',
  SO: 'Somalia',
  ZW: 'Zimbabue',
  SA: 'Arabia Saudí',
  ES: 'España',
  ER: 'Eritrea',
  ME: 'Montenegro',
  MD: 'Moldavia',
  MG: 'Madagascar',
  MF: 'San Martín',
  MA: 'Marruecos',
  MC: 'Mónaco',
  UZ: 'Uzbekistán',
  MM: 'Myanmar',
  ML: 'Malí',
  MO: 'Macao',
  MN: 'Mongolia',
  MH: 'Islas Marshall',
  MK: 'Macedonia',
  MU: 'Mauricio',
  MT: 'Malta',
  MW: 'Malawi',
  MV: 'Maldivas',
  MQ: 'Martinica',
  MP: 'Islas Marianas del Norte',
  MS: 'Montserrat',
  MR: 'Mauritania',
  IM: 'Isla de Man',
  UG: 'Uganda',
  TZ: 'Tanzania',
  MY: 'Malasia',
  MX: 'México',
  IL: 'Israel',
  FR: 'Francia',
  IO: 'Territorio Británico del Océano Índico',
  SH: 'Santa Helena',
  FI: 'Finlandia',
  FJ: 'Fiji',
  FK: 'Islas Malvinas',
  FM: 'Micronesia',
  FO: 'Islas Feroe',
  NI: 'Nicaragua',
  NL: 'Países Bajos',
  NO: 'Noruega',
  NA: 'Namibia',
  VU: 'Vanuatu',
  NC: 'Nueva Caledonia',
  NE: 'Níger',
  NF: 'Isla de Norfolk',
  NG: 'Nigeria',
  NZ: 'Nueva Zelanda',
  NP: 'Nepal',
  NR: 'Nauru',
  NU: 'Niue',
  CK: 'Islas Cook',
  XK: 'Kosovo',
  CI: 'Costa de Marfil',
  CH: 'Suiza',
  CO: 'Colombia',
  CN: 'China',
  CM: 'Camerún',
  CL: 'Chile',
  CC: 'Islas Cocos',
  // CA: 'Canadá',
  CG: 'República del Congo',
  CF: 'República Centroafricana',
  CD: 'República Democrática del Congo',
  CZ: 'República Checa',
  CY: 'Chipre',
  CX: 'Isla de Navidad',
  CR: 'Costa Rica',
  CW: 'Curazao',
  CV: 'Cabo Verde',
  CU: 'Cuba',
  SZ: 'Suazilandia',
  SY: 'Siria',
  SX: 'San Martín',
  KG: 'Kirguistán',
  KE: 'Kenia',
  SS: 'Sudán del Sur',
  SR: 'Surinam',
  KI: 'Kiribati',
  KH: 'Camboya',
  KN: 'San Cristóbal y Nieves',
  KM: 'Comoras',
  ST: 'Santo Tomé y Príncipe',
  SK: 'Eslovaquia',
  KR: 'Corea del Sur',
  SI: 'Eslovenia',
  KP: 'Corea del Norte',
  KW: 'Kuwait',
  SN: 'Senegal',
  SM: 'San Marino',
  SL: 'Sierra Leona',
  SC: 'Seychelles',
  KZ: 'Kazajstán',
  KY: 'Islas Caimán',
  SG: 'Singapur',
  SE: 'Suecia',
  SD: 'Sudán',
  DO: 'República Dominicana',
  DM: 'Dominica',
  DJ: 'Yibuti',
  DK: 'Dinamarca',
  VG: 'Islas Vírgenes Británicas',
  DE: 'Alemania',
  YE: 'Yemen',
  DZ: 'Argelia',
  US: 'Estados Unidos',
  UY: 'Uruguay',
  YT: 'Mayotte',
  UM: 'Estados Unidos Islas periféricas menores',
  LB: 'Líbano',
  LC: 'Santa Lucía',
  LA: 'Laos',
  TV: 'Tuvalu',
  TW: 'Taiwán',
  TT: 'Trinidad y Tobago',
  TR: 'Turquía',
  LK: 'Sri Lanka',
  LI: 'Liechtenstein',
  LV: 'Letonia',
  TO: 'Tonga',
  LT: 'Lituania',
  LU: 'Luxemburgo',
  LR: 'Liberia',
  LS: 'Lesotho',
  TH: 'Tailandia',
  TF: 'Territorios Franceses del Sur',
  TG: 'Togo',
  TD: 'Chad',
  TC: 'Islas Turcas y Caicos',
  LY: 'Libia',
  VA: 'Vaticano',
  VC: 'San Vicente y las Granadinas',
  AE: 'Emiratos Árabes Unidos',
  AD: 'Andorra',
  AG: 'Antigua y Barbuda',
  AF: 'Afganistán',
  AI: 'Anguila',
  VI: 'Islas Vírgenes de los Estados Unidos',
  IS: 'Islandia',
  IR: 'Irán',
  AM: 'Armenia',
  AL: 'Albania',
  AO: 'Angola',
  AQ: 'Antártida',
  AS: 'Samoa Americana',
  AR: 'Argentina',
  AU: 'Australia',
  AT: 'Austria',
  AW: 'Aruba',
  IN: 'India',
  AX: 'Isla de Aland',
  AZ: 'Azerbaiyán',
  IE: 'Irlanda',
  ID: 'Indonesia',
  UA: 'Ucrania',
  QA: 'Qatar',
  MZ: 'Mozambique',
  BDAbr: 'BGD',
  BEAbr: 'BEL',
  BFAbr: 'BFA',
  BGAbr: 'BGR',
  BAAbr: 'BIH',
  BBAbr: 'BRB',
  WFAbr: 'WLF',
  BLAbr: 'BLM',
  BMAbr: 'BMU',
  BNAbr: 'BRN',
  BOAbr: 'BOL',
  BHAbr: 'BHR',
  BIAbr: 'BDI',
  BJAbr: 'BEN',
  BTAbr: 'BTN',
  JMAbr: 'JAM',
  BVAbr: 'BVT',
  BWAbr: 'BWA',
  WSAbr: 'WSM',
  BQAbr: 'BES',
  BRAbr: 'BRA',
  BSAbr: 'BHS',
  JEAbr: 'JEY',
  BYAbr: 'BLR',
  BZAbr: 'BLZ',
  RUAbr: 'RUS',
  RWAbr: 'RWA',
  RSAbr: 'SRB',
  TLAbr: 'TLS',
  REAbr: 'REU',
  TMAbr: 'TKM',
  TJAbr: 'TJK',
  ROAbr: 'ROU',
  TKAbr: 'TKL',
  GWAbr: 'GNB',
  GUAbr: 'GUM',
  GTAbr: 'GTM',
  GSAbr: 'SGS',
  GRAbr: 'GRC',
  GQAbr: 'GNQ',
  GPAbr: 'GLP',
  JPAbr: 'JPN',
  GYAbr: 'GUY',
  GGAbr: 'GGY',
  GFAbr: 'GUF',
  GEAbr: 'GEO',
  GDAbr: 'GRD',
  GBAbr: 'ENG',
  GAAbr: 'GAB',
  SVAbr: 'SLV',
  GNAbr: 'GIN',
  GMAbr: 'GMB',
  GLAbr: 'GRL',
  GIAbr: 'GIB',
  GHAbr: 'GHA',
  OMAbr: 'OMN',
  TNAbr: 'TUN',
  JOAbr: 'JOR',
  HRAbr: 'HRV',
  HTAbr: 'HTI',
  HUAbr: 'HUN',
  HKAbr: 'HKG',
  HNAbr: 'HND',
  HMAbr: 'HMD',
  VEAbr: 'VEN',
  PRAbr: 'PRI',
  PSAbr: 'PSE',
  PWAbr: 'PLW',
  PTAbr: 'PRT',
  SJAbr: 'SJM',
  PYAbr: 'PRY',
  IQAbr: 'IRQ',
  PAAbr: 'PAN',
  PFAbr: 'PYF',
  PGAbr: 'PNG',
  PEAbr: 'PER',
  PKAbr: 'PAK',
  PHAbr: 'PHL',
  PNAbr: 'PCN',
  PLAbr: 'POL',
  PMAbr: 'SPM',
  ZMAbr: 'ZMB',
  EHAbr: 'ESH',
  EEAbr: 'EST',
  EGAbr: 'EGY',
  ZAAbr: 'ZAF',
  ECAbr: 'ECU',
  ITAbr: 'ITA',
  VNAbr: 'VNM',
  SBAbr: 'SLB',
  ETAbr: 'ETH',
  SOAbr: 'SOM',
  ZWAbr: 'ZWE',
  SAAbr: 'SAU',
  ESAbr: 'ESP',
  ERAbr: 'ERI',
  MEAbr: 'MNE',
  MDAbr: 'MDA',
  MGAbr: 'MDG',
  MFAbr: 'MAF',
  MAAbr: 'MAR',
  MCAbr: 'MCO',
  UZAbr: 'UZB',
  MMAbr: 'MMR',
  MLAbr: 'MLI',
  MOAbr: 'MAC',
  MNAbr: 'MNG',
  MHAbr: 'MHL',
  MKAbr: 'MKD',
  MUAbr: 'MUS',
  MTAbr: 'MLT',
  MWAbr: 'MWI',
  MVAbr: 'MDV',
  MQAbr: 'MTQ',
  MPAbr: 'MNP',
  MSAbr: 'MSR',
  MRAbr: 'MRT',
  IMAbr: 'IMN',
  UGAbr: 'UGA',
  TZAbr: 'TZA',
  MYAbr: 'MYS',
  MXAbr: 'MEX',
  ILAbr: 'ISR',
  FRAbr: 'FRA',
  IOAbr: 'IOT',
  SHAbr: 'SHN',
  FIAbr: 'FIN',
  FJAbr: 'FJI',
  FKAbr: 'FLK',
  FMAbr: 'FSM',
  FOAbr: 'FRO',
  NIAbr: 'NIC',
  NLAbr: 'NLD',
  NOAbr: 'NOR',
  NAAbr: 'NAM',
  VUAbr: 'VUT',
  NCAbr: 'NCL',
  NEAbr: 'NER',
  NFAbr: 'NFK',
  NGAbr: 'NGA',
  NZAbr: 'NZL',
  NPAbr: 'NPL',
  NRAbr: 'NRU',
  NUAbr: 'NIU',
  CKAbr: 'COK',
  XKAbr: 'XKX',
  CIAbr: 'CIV',
  CHAbr: 'CHE',
  COAbr: 'COL',
  CNAbr: 'CHN',
  CMAbr: 'CMR',
  CLAbr: 'CHL',
  CCAbr: 'CCK',
  // Abr C'CAN',
  CGAbr: 'COG',
  CFAbr: 'CAF',
  CDAbr: 'COD',
  CZAbr: 'CZE',
  CYAbr: 'CYP',
  CXAbr: 'CXR',
  CRAbr: 'CRI',
  CWAbr: 'CUW',
  CVAbr: 'CPV',
  CUAbr: 'CUB',
  SZAbr: 'SWZ',
  SYAbr: 'SYR',
  SXAbr: 'SXM',
  KGAbr: 'KGZ',
  KEAbr: 'KEN',
  SSAbr: 'SSD',
  SRAbr: 'SUR',
  KIAbr: 'KIR',
  KHAbr: 'KHM',
  KNAbr: 'KNA',
  KMAbr: 'COM',
  STAbr: 'STP',
  SKAbr: 'SVK',
  KRAbr: 'KOR',
  SIAbr: 'SVN',
  KPAbr: 'PRK',
  KWAbr: 'KWT',
  SNAbr: 'SEN',
  SMAbr: 'SMR',
  SLAbr: 'SLE',
  SCAbr: 'SYC',
  KZAbr: 'KAZ',
  KYAbr: 'CYM',
  SGAbr: 'SGP',
  SEAbr: 'SWE',
  SDAbr: 'SDN',
  DOAbr: 'DOM',
  DMAbr: 'DMA',
  DJAbr: 'DJI',
  DKAbr: 'DNK',
  VGAbr: 'VGB',
  DEAbr: 'DEU',
  YEAbr: 'YEM',
  DZAbr: 'DZA',
  // USAbr: 'USA-CAN',
  USAbr: 'USA',
  UYAbr: 'URY',
  YTAbr: 'MYT',
  UMAbr: 'UMI',
  LBAbr: 'LBN',
  LCAbr: 'LCA',
  LAAbr: 'LAO',
  TVAbr: 'TUV',
  TWAbr: 'TWN',
  TTAbr: 'TTO',
  TRAbr: 'TUR',
  LKAbr: 'LKA',
  LIAbr: 'LIE',
  LVAbr: 'LVA',
  TOAbr: 'TON',
  LTAbr: 'LTU',
  LUAbr: 'LUX',
  LRAbr: 'LBR',
  LSAbr: 'LSO',
  THAbr: 'THA',
  TFAbr: 'ATF',
  TGAbr: 'TGO',
  TDAbr: 'TCD',
  TCAbr: 'TCA',
  LYAbr: 'LBY',
  VAAbr: 'VAT',
  VCAbr: 'VCT',
  AEAbr: 'ARE',
  ADAbr: 'AND',
  AGAbr: 'ATG',
  AFAbr: 'AFG',
  AIAbr: 'AIA',
  VIAbr: 'VIR',
  ISAbr: 'ISL',
  IRAbr: 'IRN',
  AMAbr: 'ARM',
  ALAbr: 'ALB',
  AOAbr: 'AGO',
  AQAbr: 'ATA',
  ASAbr: 'ASM',
  ARAbr: 'ARG',
  AUAbr: 'AUS',
  ATAbr: 'AUT',
  AWAbr: 'ABW',
  INAbr: 'IND',
  AXAbr: 'ALA',
  AZAbr: 'AZE',
  IEAbr: 'IRL',
  IDAbr: 'IDN',
  UAAbr: 'UKR',
  QAAbr: 'QAT',
  MZAbr: 'MOZ'
};

var en = {
  test: 'EN',
  locale: 'en',
  completed: 'Completed',
  paused: 'Paused',
  error: 'Error',
  errors: 'errors',
  emptyState: 'No matches found',
  selectAll: 'Select all',
  deselectAll: 'Deselect all',
  apply: 'Apply',
  cancel: 'Cancel',
  clean: 'Clean',
  start: 'Start',
  end: 'End',
  range: 'Range',
  day: 'day',
  days: 'days',
  hour: 'hour',
  hours: 'hours',
  minute: 'minute',
  minutes: 'minutes',
  personalized: 'Custom',
  today: 'Today',
  yesterday: 'Yesterday',
  last7Days: 'Last 7 days',
  last30Days: 'Last 30 days',
  thisMonth: 'This month',
  lastMonth: 'Last month',
  notResultsRows: 'No records found',
  notRequestsRows: 'No request found',
  loadingMessage: 'Loading data',
  header: 'Step Header',
  subheader: 'Description of content',
  copy: 'Copy',
  discard: 'Discard',
  continue: 'Continue',
  edit: 'Edit',
  itemsPerPage: 'Items per page',
  numberOfElements: '{0}-{1} of {2} items',
  selectedItems: '{0} Selected items',
  testPlatform: {
    textStrong: 'There are <strong>%{numberTest} errors</strong> records that cannot be supported in your campaing'
  },
  selectOptions: 'Select option(s)',
  file: 'file',
  files: 'files',
  element: 'element',
  elements: 'elements',
  uploading: 'Uploading',
  close: 'Close',
  loaded: 'Have been uploaded',
  load: 'It has been loaded',
  noLoad: 'No files have been uploaded',
  cancelLoad: 'Cancel file upload',
  cancelLoadInfo: 'Uploading of your files has not been completed',
  cancelLoadQuestion: 'Do you want to cancel the file upload?',
  cancelLoadConfirmation: 'Cancel Load',
  rows: 'Rows:',
  records: 'Records:',
  fileUploader: {
    dropFile: 'Drop your file here to upload it or',
    selectFile: 'Select File',
    supportedFormats: 'Supported formats:',
    addFiles: 'Add files',
    totalWeight: 'Weight uploaded:',
    maxWeight: 'Weight allowed:',
    maxFileUpload: 'Aggregated files:',
    totalFilesUpload: 'Files allowed:',
    filesUpload: 'Files uploaded:',
    exceedMaxUploadTitle: 'File limit exceeded',
    exceedMaxWeightTitle: 'Weight limit exceeded',
    notAllowedFileTitle: 'File format not allowed',
    exceedMaxUpload: 'File limit exceeded',
    exceedMaxWeight: 'Weight limit exceeded',
    notAllowedFile: 'We are sorry, but the file you are trying to upload is in a not allowed format.',
    notAllowedFiles: 'We are Sorry, but at least one of the files you are trying to upload is in a not allowed format.',
    uploadedFilesInfo: 'Files info',
    uploadedWeightInfo: 'Weight info',
    exceedMaxWeightTextPart1: 'We are sorry but the ',
    exceedMaxWeightTextPart2: ' exceeds the allowed weight of',
    cantLoadFiles: 'The limit of allowed files has been reached, therefore it is not possible to upload more files',
    exceedMaxUploadTextPart1: 'You are exceeding the limit of ',
    exceedMaxUploadTextPart2: 'to upload, please select the files that you really want to upload'
  },
  BD: 'Bangladesh',
  BE: 'Belgium',
  BF: 'Burkina Faso',
  BG: 'Bulgaria',
  BA: 'Bosnia and Herzegovina',
  BB: 'Barbados',
  WF: 'Wallis and Futuna',
  BL: 'Saint Barthelemy',
  BM: 'Bermuda',
  BN: 'Brunei',
  BO: 'Bolivia',
  BH: 'Bahrain',
  BI: 'Burundi',
  BJ: 'Benin',
  BT: 'Bhutan',
  JM: 'Jamaica',
  BV: 'Bouvet Island',
  BW: 'Botswana',
  WS: 'Samoa',
  BQ: 'Bonaire, Saint Eustatius and Saba',
  BR: 'Brazil',
  BS: 'Bahamas',
  JE: 'Jersey',
  BY: 'Belarus',
  BZ: 'Belize',
  RU: 'Russia',
  RW: 'Rwanda',
  RS: 'Serbia',
  TL: 'East Timor',
  RE: 'Reunion',
  TM: 'Turkmenistan',
  TJ: 'Tajikistan',
  RO: 'Romania',
  TK: 'Tokelau',
  GW: 'Guinea-Bissau',
  GU: 'Guam',
  GT: 'Guatemala',
  GS: 'South Georgia and the South Sandwich Islands',
  GR: 'Greece',
  GQ: 'Equatorial Guinea',
  GP: 'Guadeloupe',
  JP: 'Japan',
  GY: 'Guyana',
  GG: 'Guernsey',
  GF: 'French Guiana',
  GE: 'Georgia',
  GD: 'Grenada',
  GB: 'England',
  GA: 'Gabon',
  SV: 'El Salvador',
  GN: 'Guinea',
  GM: 'Gambia',
  GL: 'Greenland',
  GI: 'Gibraltar',
  GH: 'Ghana',
  OM: 'Oman',
  TN: 'Tunisia',
  JO: 'Jordan',
  HR: 'Croatia',
  HT: 'Haiti',
  HU: 'Hungar',
  HK: 'Hong Kong',
  HN: 'Honduras',
  HM: 'Heard Island and McDonald Islands',
  VE: 'Venezuela',
  PR: 'Puerto Rico',
  PS: 'Palestinian Territory',
  PW: 'Palau',
  PT: 'Portugal',
  SJ: 'Svalbard and Jan Mayen',
  PY: 'Paraguay',
  IQ: 'Iraq',
  PA: 'Panama',
  PF: 'French Polynesia',
  PG: 'Papua New Guinea',
  PE: 'Peru',
  PK: 'Pakistan',
  PH: 'Philippines',
  PN: 'Pitcairn',
  PL: 'Poland',
  PM: 'Saint Pierre and Miquelon',
  ZM: 'Zambia',
  EH: 'Western Sahar',
  EE: 'Estonia',
  EG: 'Egypt',
  ZA: 'South Africa',
  EC: 'Ecuador',
  IT: 'Italy',
  VN: 'Vietnam',
  SB: 'Solomon Islands',
  ET: 'Ethiopia',
  SO: 'Somali',
  ZW: 'Zimbabwe',
  SA: 'Saudi Arabia',
  ES: 'Spain',
  ER: 'Eritrea',
  ME: 'Montenegro',
  MD: 'Moldova',
  MG: 'Madagascar',
  MF: 'Saint Martin',
  MA: 'Morocco',
  MC: 'Monaco',
  UZ: 'Uzbekistan',
  MM: 'Myanmar',
  ML: 'Mali',
  MO: 'Macao',
  MN: 'Mongolia',
  MH: 'Marshall Islands',
  MK: 'Macedonia',
  MU: 'Mauritius',
  MT: 'Malta',
  MW: 'Malawi',
  MV: 'Maldives',
  MQ: 'Martinique',
  MP: 'Northern Mariana Islands',
  MS: 'Montserrat',
  MR: 'Mauritania',
  IM: 'Isle of Man',
  UG: 'Uganda',
  TZ: 'Tanzania',
  MY: 'Malaysia',
  MX: 'Mexico',
  IL: 'Israel',
  FR: 'France',
  IO: 'British Indian Ocean Territory',
  SH: 'Saint Helena',
  FI: 'Finland',
  FJ: 'Fiji',
  FK: 'Falkland Islands',
  FM: 'Micronesia',
  FO: 'Faroe Island',
  NI: 'Nicaragua',
  NL: 'Netherlands',
  NO: 'Norway',
  NA: 'Namibia',
  VU: 'Vanuatu',
  NC: 'New Caledonia',
  NE: 'Niger',
  NF: 'Norfolk Island',
  NG: 'Nigeria',
  NZ: 'New Zealand',
  NP: 'Nepal',
  NR: 'Nauru',
  NU: 'Niue',
  CK: 'Cook Islands',
  XK: 'Kosovo',
  CI: 'Ivory Coast',
  CH: 'Switzerland',
  CO: 'Colombia',
  CN: 'China',
  CM: 'Cameroon',
  CL: 'Chile',
  CC: 'Cocos Islands',
  // CA: 'Canada',
  CG: 'Republic of the Congo',
  CF: 'Central African Republic',
  CD: 'Democratic Republic of the Congo',
  CZ: 'Czech Republic',
  CY: 'Cyprus',
  CX: 'Christmas Island',
  CR: 'Costa Rica',
  CW: 'Curacao',
  CV: 'Cape Verde',
  CU: 'Cuba',
  SZ: 'Swaziland',
  SY: 'Syria',
  SX: 'Sint Maarten',
  KG: 'Kyrgyzstan',
  KE: 'Kenya',
  SS: 'South Sudan',
  SR: 'Suriname',
  KI: 'Kiribati',
  KH: 'Cambodia',
  KN: 'Saint Kittsand Nevis',
  KM: 'Comoros',
  ST: 'Sao Tome and Principe',
  SK: 'Slovakia',
  KR: 'South Korea',
  SI: 'Slovenia',
  KP: 'North Korea',
  KW: 'Kuwait',
  SN: 'Senegal',
  SM: 'San Marino',
  SL: 'Sierra Leone',
  SC: 'Seychelles',
  KZ: 'Kazakhstan',
  KY: 'Cayman Islands',
  SG: 'Singapore',
  SE: 'Sweden',
  SD: 'Sudan',
  DO: 'Dominican Republic',
  DM: 'Dominica',
  DJ: 'Djibouti',
  DK: 'Denmark',
  VG: 'British Virgin Islands',
  DE: 'Germany',
  YE: 'Yemen',
  DZ: 'Algeria',
  // US: 'United States / Canada',
  US: 'United States',
  UY: 'Uruguay',
  YT: 'Mayotte',
  UM: 'United States Minor Outlying Islands',
  LB: 'Lebanon',
  LC: 'Saint Lucia',
  LA: 'Laos',
  TV: 'Tuvalu',
  TW: 'Taiwan',
  TT: 'Trinidad and Tobago',
  TR: 'Turkey',
  LK: 'Sri Lanka',
  LI: 'Liechtenstein',
  LV: 'Latvia',
  TO: 'Tonga',
  LT: 'Lithuania',
  LU: 'Luxembourg',
  LR: 'Liberia',
  LS: 'Lesotho',
  TH: 'Thailand',
  TF: 'French Southern Territories',
  TG: 'Togo',
  TD: 'Chad',
  TC: 'Turks and Caicos Islands',
  LY: 'Libya',
  VA: 'Vatican',
  VC: 'Saint Vincent and the Grenadines',
  AE: 'United Arab Emirates',
  AD: 'Andorra',
  AG: 'Antigua and Barbuda',
  AF: 'Afghanistan',
  AI: 'Anguilla',
  VI: 'U.S. Virgin Islands',
  IS: 'Iceland',
  IR: 'Iran',
  AM: 'Armenia',
  AL: 'Albania',
  AO: 'Angola',
  AQ: 'Antarctica',
  AS: 'American Samoa',
  AR: 'Argentina',
  AU: 'Australia',
  AT: 'Austria',
  AW: 'Aruba',
  IN: 'India',
  AX: 'Aland Island',
  AZ: 'Azerbaijan',
  IE: 'Ireland',
  ID: 'Indonesia',
  UA: 'Ukraine',
  QA: 'Qatar',
  MZ: 'Mozambique',
  BDAbr: 'BGD',
  BEAbr: 'BEL',
  BFAbr: 'BFA',
  BGAbr: 'BGR',
  BAAbr: 'BIH',
  BBAbr: 'BRB',
  WFAbr: 'WLF',
  BLAbr: 'BLM',
  BMAbr: 'BMU',
  BNAbr: 'BRN',
  BOAbr: 'BOL',
  BHAbr: 'BHR',
  BIAbr: 'BDI',
  BJAbr: 'BEN',
  BTAbr: 'BTN',
  JMAbr: 'JAM',
  BVAbr: 'BVT',
  BWAbr: 'BWA',
  WSAbr: 'WSM',
  BQAbr: 'BES',
  BRAbr: 'BRA',
  BSAbr: 'BHS',
  JEAbr: 'JEY',
  BYAbr: 'BLR',
  BZAbr: 'BLZ',
  RUAbr: 'RUS',
  RWAbr: 'RWA',
  RSAbr: 'SRB',
  TLAbr: 'TLS',
  REAbr: 'REU',
  TMAbr: 'TKM',
  TJAbr: 'TJK',
  ROAbr: 'ROU',
  TKAbr: 'TKL',
  GWAbr: 'GNB',
  GUAbr: 'GUM',
  GTAbr: 'GTM',
  GSAbr: 'SGS',
  GRAbr: 'GRC',
  GQAbr: 'GNQ',
  GPAbr: 'GLP',
  JPAbr: 'JPN',
  GYAbr: 'GUY',
  GGAbr: 'GGY',
  GFAbr: 'GUF',
  GEAbr: 'GEO',
  GDAbr: 'GRD',
  GBAbr: 'ENG',
  GAAbr: 'GAB',
  SVAbr: 'SLV',
  GNAbr: 'GIN',
  GMAbr: 'GMB',
  GLAbr: 'GRL',
  GIAbr: 'GIB',
  GHAbr: 'GHA',
  OMAbr: 'OMN',
  TNAbr: 'TUN',
  JOAbr: 'JOR',
  HRAbr: 'HRV',
  HTAbr: 'HTI',
  HUAbr: 'HUN',
  HKAbr: 'HKG',
  HNAbr: 'HND',
  HMAbr: 'HMD',
  VEAbr: 'VEN',
  PRAbr: 'PRI',
  PSAbr: 'PSE',
  PWAbr: 'PLW',
  PTAbr: 'PRT',
  SJAbr: 'SJM',
  PYAbr: 'PRY',
  IQAbr: 'IRQ',
  PAAbr: 'PAN',
  PFAbr: 'PYF',
  PGAbr: 'PNG',
  PEAbr: 'PER',
  PKAbr: 'PAK',
  PHAbr: 'PHL',
  PNAbr: 'PCN',
  PLAbr: 'POL',
  PMAbr: 'SPM',
  ZMAbr: 'ZMB',
  EHAbr: 'ESH',
  EEAbr: 'EST',
  EGAbr: 'EGY',
  ZAAbr: 'ZAF',
  ECAbr: 'ECU',
  ITAbr: 'ITA',
  VNAbr: 'VNM',
  SBAbr: 'SLB',
  ETAbr: 'ETH',
  SOAbr: 'SOM',
  ZWAbr: 'ZWE',
  SAAbr: 'SAU',
  ESAbr: 'ESP',
  ERAbr: 'ERI',
  MEAbr: 'MNE',
  MDAbr: 'MDA',
  MGAbr: 'MDG',
  MFAbr: 'MAF',
  MAAbr: 'MAR',
  MCAbr: 'MCO',
  UZAbr: 'UZB',
  MMAbr: 'MMR',
  MLAbr: 'MLI',
  MOAbr: 'MAC',
  MNAbr: 'MNG',
  MHAbr: 'MHL',
  MKAbr: 'MKD',
  MUAbr: 'MUS',
  MTAbr: 'MLT',
  MWAbr: 'MWI',
  MVAbr: 'MDV',
  MQAbr: 'MTQ',
  MPAbr: 'MNP',
  MSAbr: 'MSR',
  MRAbr: 'MRT',
  IMAbr: 'IMN',
  UGAbr: 'UGA',
  TZAbr: 'TZA',
  MYAbr: 'MYS',
  MXAbr: 'MEX',
  ILAbr: 'ISR',
  FRAbr: 'FRA',
  IOAbr: 'IOT',
  SHAbr: 'SHN',
  FIAbr: 'FIN',
  FJAbr: 'FJI',
  FKAbr: 'FLK',
  FMAbr: 'FSM',
  FOAbr: 'FRO',
  NIAbr: 'NIC',
  NLAbr: 'NLD',
  NOAbr: 'NOR',
  NAAbr: 'NAM',
  VUAbr: 'VUT',
  NCAbr: 'NCL',
  NEAbr: 'NER',
  NFAbr: 'NFK',
  NGAbr: 'NGA',
  NZAbr: 'NZL',
  NPAbr: 'NPL',
  NRAbr: 'NRU',
  NUAbr: 'NIU',
  CKAbr: 'COK',
  XKAbr: 'XKX',
  CIAbr: 'CIV',
  CHAbr: 'CHE',
  COAbr: 'COL',
  CNAbr: 'CHN',
  CMAbr: 'CMR',
  CLAbr: 'CHL',
  CCAbr: 'CCK',
  // Abr C'CAN',
  CGAbr: 'COG',
  CFAbr: 'CAF',
  CDAbr: 'COD',
  CZAbr: 'CZE',
  CYAbr: 'CYP',
  CXAbr: 'CXR',
  CRAbr: 'CRI',
  CWAbr: 'CUW',
  CVAbr: 'CPV',
  CUAbr: 'CUB',
  SZAbr: 'SWZ',
  SYAbr: 'SYR',
  SXAbr: 'SXM',
  KGAbr: 'KGZ',
  KEAbr: 'KEN',
  SSAbr: 'SSD',
  SRAbr: 'SUR',
  KIAbr: 'KIR',
  KHAbr: 'KHM',
  KNAbr: 'KNA',
  KMAbr: 'COM',
  STAbr: 'STP',
  SKAbr: 'SVK',
  KRAbr: 'KOR',
  SIAbr: 'SVN',
  KPAbr: 'PRK',
  KWAbr: 'KWT',
  SNAbr: 'SEN',
  SMAbr: 'SMR',
  SLAbr: 'SLE',
  SCAbr: 'SYC',
  KZAbr: 'KAZ',
  KYAbr: 'CYM',
  SGAbr: 'SGP',
  SEAbr: 'SWE',
  SDAbr: 'SDN',
  DOAbr: 'DOM',
  DMAbr: 'DMA',
  DJAbr: 'DJI',
  DKAbr: 'DNK',
  VGAbr: 'VGB',
  DEAbr: 'DEU',
  YEAbr: 'YEM',
  DZAbr: 'DZA',
  // USAbr: 'USA-CAN',
  USAbr: 'USA',
  UYAbr: 'URY',
  YTAbr: 'MYT',
  UMAbr: 'UMI',
  LBAbr: 'LBN',
  LCAbr: 'LCA',
  LAAbr: 'LAO',
  TVAbr: 'TUV',
  TWAbr: 'TWN',
  TTAbr: 'TTO',
  TRAbr: 'TUR',
  LKAbr: 'LKA',
  LIAbr: 'LIE',
  LVAbr: 'LVA',
  TOAbr: 'TON',
  LTAbr: 'LTU',
  LUAbr: 'LUX',
  LRAbr: 'LBR',
  LSAbr: 'LSO',
  THAbr: 'THA',
  TFAbr: 'ATF',
  TGAbr: 'TGO',
  TDAbr: 'TCD',
  TCAbr: 'TCA',
  LYAbr: 'LBY',
  VAAbr: 'VAT',
  VCAbr: 'VCT',
  AEAbr: 'ARE',
  ADAbr: 'AND',
  AGAbr: 'ATG',
  AFAbr: 'AFG',
  AIAbr: 'AIA',
  VIAbr: 'VIR',
  ISAbr: 'ISL',
  IRAbr: 'IRN',
  AMAbr: 'ARM',
  ALAbr: 'ALB',
  AOAbr: 'AGO',
  AQAbr: 'ATA',
  ASAbr: 'ASM',
  ARAbr: 'ARG',
  AUAbr: 'AUS',
  ATAbr: 'AUT',
  AWAbr: 'ABW',
  INAbr: 'IND',
  AXAbr: 'ALA',
  AZAbr: 'AZE',
  IEAbr: 'IRL',
  IDAbr: 'IDN',
  UAAbr: 'UKR',
  QAAbr: 'QAT',
  MZAbr: 'MOZ'
};

var pt = {
  test: 'PT',
  locale: 'pt',
  completed: 'Completado',
  paused: 'Pausado',
  error: 'Erro',
  errors: 'erros',
  emptyState: 'Nenhuma equivalência encontrada',
  selectAll: 'Selecionar tudo',
  deselectAll: 'Desmarcar todos',
  apply: 'Aplicar',
  cancel: 'Cancelar',
  clean: 'Limpiar',
  start: 'Inicio',
  end: 'Fin',
  range: 'Faixa',
  day: 'dia',
  days: 'dias',
  hour: 'hora',
  hours: 'horas',
  minute: 'minuto',
  minutes: 'minutos',
  personalized: 'Personalizado',
  today: 'Hoje',
  yesterday: 'Ontem',
  last7Days: 'Últimos 7 dias',
  last30Days: 'Últimos 30 dias',
  thisMonth: 'Este mês',
  lastMonth: 'Último mês',
  notResultsRows: 'Sem registros encontrados',
  notRequestsRows: 'Sem busquedas encontrados',
  loadingMessage: 'Carregando dados',
  header: 'Passo',
  subheader: 'descrição do conteúdo',
  copy: 'cópia de',
  discard: 'descartar',
  continue: 'Prosseguir',
  edit: 'Editar',
  itemsPerPage: 'Itens por página',
  numberOfElements: '{0}-{1} of {2} Itens',
  selectedItems: '{0} Itens selecionados',
  selectOptions: 'Seleccionar opção(ões)',
  file: 'ficheiro',
  files: 'ficheiros',
  element: 'elemento',
  elements: 'elementos',
  uploading: 'Carregando',
  close: 'Fechar',
  loaded: 'Foram carregados',
  load: 'Foi carregad',
  noLoad: 'Nenhum arquivo foi carregado',
  cancelLoad: 'Cancelar o upload do arquivo',
  cancelLoadInfo: 'O upload de seus arquivos ainda não foi concluído',
  cancelLoadQuestion: 'Você quer cancelar o upload do arquivo?',
  cancelLoadConfirmation: 'Cancelar upload',
  rows: 'Linhas:',
  records: 'Registros:',
  fileUploader: {
    dropFile: 'Largue aqui o seu ficheiro para o carregar ou',
    selectFile: 'Seleccione o ficheiro',
    supportedFormats: 'Formatos suportados:',
    addFiles: 'Adicionar ficheiros',
    totalWeight: 'Peso carregado:',
    maxWeight: 'Peso permitido:',
    maxFileUpload: 'Ficheiros agregados:',
    totalFilesUpload: 'Ficheiros permitidos:',
    filesUpload: 'Ficheiros carregados:',
    exceedMaxUploadTitle: 'Limite de ficheiros excedido',
    exceedMaxWeightTitle: 'Limite de peso excedido',
    notAllowedFileTitle: 'Formato do ficheiro não permitido',
    notAllowedFile: 'Desculpe, mas o ficheiro que está a tentar carregar está num formato não permitido.',
    notAllowedFiles: 'Lamentamos, mas pelo menos um dos ficheiros que está a tentar carregar está no formato não permitido.',
    uploadedFilesInfo: 'Inf. Ficheiros',
    uploadedWeightInfo: 'Inf. peso',
    exceedMaxWeightTextPart1: 'Lamentamos, mas o ',
    exceedMaxWeightTextPart2: ' excede o peso de',
    cantLoadFiles: 'O limite permitido de ficheiros carregados foi ultrapassado, portanto, não é possível carregar mais ficheiros..',
    exceedMaxUploadTextPart1: 'Está a exceder o limite de ',
    exceedMaxUploadTextPart2: 'para carregar, por favor seleccione os ficheiros que deseja realmente carregar'
  },
  BD: 'Bangladeche',
  BE: 'Bélgica',
  BF: 'Burkina Faso',
  BG: 'Bulgária',
  BA: 'Bósnia e Herzegovina',
  BB: 'Barbados',
  WF: 'Wallis e Futuna',
  BL: 'São Bartolomeu',
  BM: 'Bermudas',
  BN: 'Brunei',
  BO: 'Bolívia',
  BH: 'Bahrein',
  BI: 'Burundi',
  BJ: 'Benim',
  BT: 'Butão',
  JM: 'Jamaica',
  BV: 'Ilha Bouvet',
  BW: 'Botsuana',
  WS: 'Samoa',
  BQ: 'Bonaire, Santo Eustáquio e Saba',
  BR: 'Brasil',
  BS: 'Bahamas',
  JE: 'Jersey',
  BY: 'Bielorrússia',
  BZ: 'Belize',
  RU: 'Rússia',
  RW: 'Ruanda',
  RS: 'Sérvia',
  TL: 'Timor Leste',
  RE: 'Reunião',
  TM: 'Turquemenistão',
  TJ: 'Tajiquistão',
  RO: 'Roménia',
  TK: 'Tokelau',
  GW: 'Guiné-Bissau',
  GU: 'Guam',
  GT: 'Guatemala',
  GS: 'Geórgia do Sul e as Ilhas Sandwich do Sul',
  GR: 'Grécia',
  GQ: 'Guiné Equatorial',
  GP: 'Guadalupe',
  JP: 'Japão',
  GY: 'Guiana',
  GG: 'Guernsey',
  GF: 'Guiana Francesa',
  GE: 'Geórgia',
  GD: 'Grenada',
  GB: 'Inglaterra',
  GA: 'Gabão',
  SV: 'El Salvador',
  GN: 'Guiné',
  GM: 'Gâmbia',
  GL: 'Gronelândia',
  GI: 'Gibraltar',
  GH: 'Gana',
  OM: 'Omã',
  TN: 'Tunísia',
  JO: 'Jordânia',
  HR: 'Croácia',
  HT: 'Haiti',
  HU: 'Hungar',
  HK: 'Hong Kong',
  HN: 'Honduras',
  HM: 'Ilha Heard e Ilhas McDonald',
  VE: 'Venezuela',
  PR: 'Porto Rico',
  PS: 'Território Palestino',
  PW: 'Palau',
  PT: 'Portugal',
  SJ: 'Svalbard e Jan Mayen',
  PY: 'Paraguai',
  IQ: 'Iraque',
  PA: 'Panamá',
  PF: 'Polinésia Francesa',
  PG: 'Papua Nova Guiné',
  PE: 'Peru',
  PK: 'Paquistão',
  PH: 'Filipinas',
  PN: 'Pitcairn',
  PL: 'Polónia',
  PM: 'São Pedro e Miquelon',
  ZM: 'Zâmbia',
  EH: 'Sahara Ocidental',
  EE: 'Estónia',
  EG: 'Egipto',
  ZA: 'África do Sul',
  EC: 'Equador',
  IT: 'Itália',
  VN: 'Vietname',
  SB: 'Ilhas Salomão',
  ET: 'Etiópia',
  SO: 'Somali',
  ZW: 'Zimbabué',
  SA: 'Arábia Saudita',
  ES: 'Espanha',
  ER: 'Eritreia',
  ME: 'Montenegro',
  MD: 'Moldávia',
  MG: 'Madagáscar',
  MF: 'São Martinho',
  MA: 'Marrocos',
  MC: 'Mónaco',
  UZ: 'Uzbequistão',
  MM: 'Myanmar',
  ML: 'Mali',
  MO: 'Macau',
  MN: 'Mongólia',
  MH: 'Ilhas Marshall',
  MK: 'Macedónia',
  MU: 'Maurícia',
  MT: 'Malta',
  MW: 'Malawi',
  MV: 'Maldivas',
  MQ: 'Martinica',
  MP: 'Ilhas Marianas do Norte',
  MS: 'Montserrat',
  MR: 'Mauritânia',
  IM: 'Ilha de Man',
  UG: 'Uganda',
  TZ: 'Tanzânia',
  MY: 'Malásia',
  MX: 'México',
  IL: 'Israel',
  FR: 'França',
  IO: 'Território Britânico do Oceano Índico',
  SH: 'Santa Helena',
  FI: 'Finlândia',
  FJ: 'Fiji',
  FK: 'Ilhas Malvinas',
  FM: 'Micronésia',
  FO: 'Ilha Faroe',
  NI: 'Nicarágua',
  NL: 'Países Baixos',
  NO: 'Noruega',
  NA: 'Namíbia',
  VU: 'Vanuatu',
  NC: 'Nova Caledónia',
  NE: 'Níger',
  NF: 'Ilha de Norfolk',
  NG: 'Nigéria',
  NZ: 'Nova Zelândia',
  NP: 'Nepal',
  NR: 'Nauru',
  NU: 'Niue',
  CK: 'Ilhas Cook',
  XK: 'Kosovo',
  CI: 'Costa do Marfim',
  CH: 'Suíça',
  CO: 'Colômbia',
  CN: 'China',
  CM: 'Camarões',
  CL: 'Chile',
  CC: 'Ilhas Cocos',
  // CACanada',
  CG: 'República do Congo',
  CF: 'República Centro-Africana',
  CD: 'República Democrática do Congo',
  CZ: 'República Checa',
  CY: 'Chipre',
  CX: 'Ilha de Natal',
  CR: 'Costa Rica',
  CW: 'Curaçao',
  CV: 'Cabo Verde',
  CU: 'Cuba',
  SZ: 'Suazilândia',
  SY: 'Síria',
  SX: 'Sint Maarten',
  KG: 'Quirguizistão',
  KE: 'Quénia',
  SS: 'Sul do Sudão',
  SR: 'Suriname',
  KI: 'Kiribati',
  KH: 'Camboja',
  KN: 'São Cristóvão e Nevis',
  KM: 'Comores',
  ST: 'São Tomé e Príncipe',
  SK: 'Eslováquia',
  KR: 'Coreia do Sul',
  SI: 'Eslovénia',
  KP: 'Coreia do Norte',
  KW: 'Kuwait',
  SN: 'Senegal',
  SM: 'São Marino',
  SL: 'Serra Leoa',
  SC: 'Seychelles',
  KZ: 'Cazaquistão',
  KY: 'Ilhas Caimão',
  SG: 'Singapura',
  SE: 'Suécia',
  SD: 'Sudão',
  DO: 'República Dominicana',
  DM: 'Domínica',
  DJ: 'Djibouti',
  DK: 'Dinamarca',
  VG: 'Ilhas Virgens Britânicas',
  DE: 'Alemanha',
  YE: 'Iémen',
  DZ: 'Argélia',
  US: 'Estados Unidos',
  UY: 'Uruguai',
  YT: 'Mayotte',
  UM: 'Ilhas Menores Distantes dos Estados Unidos',
  LB: 'Líbano',
  LC: 'Santa Lúcia',
  LA: 'Laos',
  TV: 'Tuvalu',
  TW: 'Taiwan',
  TT: 'Trindade e Tobago',
  TR: 'Turquia',
  LK: 'Sri Lanka',
  LI: 'Liechtenstein',
  LV: 'Letónia',
  TO: 'Tonga',
  LT: 'Lituânia',
  LU: 'Luxemburgo',
  LR: 'Libéria',
  LS: 'Lesotho',
  TH: 'Tailândia',
  TF: 'Territórios Franceses do Sul',
  TG: 'Togo',
  TD: 'Chade',
  TC: 'Ilhas Turcas e Caicos',
  LY: 'Líbia',
  VA: 'Vaticano',
  VC: 'São Vicente e as Granadinas',
  AE: 'Emirados Árabes Unidos',
  AD: 'Andorra',
  AG: 'Antígua e Barbuda',
  AF: 'Afeganistão',
  AI: 'Anguila',
  VI: 'Ilhas Virgens Americanas',
  IS: 'Islândia',
  IR: 'Irão',
  AM: 'Arménia',
  AL: 'Albânia',
  AO: 'Angola',
  AQ: 'Antárctida',
  AS: 'Samoa Americana',
  AR: 'Argentina',
  AU: 'Austrália',
  AT: 'Áustria',
  AW: 'Aruba',
  IN: 'Índia',
  AX: 'Ilha Aland',
  AZ: 'Azerbaijão',
  IE: 'Irlanda',
  ID: 'Indonésia',
  UA: 'Ucrânia',
  QA: 'Qatar',
  MZ: 'Moçambique',
  BDAbr: 'BGD',
  BEAbr: 'BEL',
  BFAbr: 'BFA',
  BGAbr: 'BGR',
  BAAbr: 'BIH',
  BBAbr: 'BRB',
  WFAbr: 'WLF',
  BLAbr: 'BLM',
  BMAbr: 'BMU',
  BNAbr: 'BRN',
  BOAbr: 'BOL',
  BHAbr: 'BHR',
  BIAbr: 'BDI',
  BJAbr: 'BEN',
  BTAbr: 'BTN',
  JMAbr: 'JAM',
  BVAbr: 'BVT',
  BWAbr: 'BWA',
  WSAbr: 'WSM',
  BQAbr: 'BES',
  BRAbr: 'BRA',
  BSAbr: 'BHS',
  JEAbr: 'JEY',
  BYAbr: 'BLR',
  BZAbr: 'BLZ',
  RUAbr: 'RUS',
  RWAbr: 'RWA',
  RSAbr: 'SRB',
  TLAbr: 'TLS',
  REAbr: 'REU',
  TMAbr: 'TKM',
  TJAbr: 'TJK',
  ROAbr: 'ROU',
  TKAbr: 'TKL',
  GWAbr: 'GNB',
  GUAbr: 'GUM',
  GTAbr: 'GTM',
  GSAbr: 'SGS',
  GRAbr: 'GRC',
  GQAbr: 'GNQ',
  GPAbr: 'GLP',
  JPAbr: 'JPN',
  GYAbr: 'GUY',
  GGAbr: 'GGY',
  GFAbr: 'GUF',
  GEAbr: 'GEO',
  GDAbr: 'GRD',
  GBAbr: 'ENG',
  GAAbr: 'GAB',
  SVAbr: 'SLV',
  GNAbr: 'GIN',
  GMAbr: 'GMB',
  GLAbr: 'GRL',
  GIAbr: 'GIB',
  GHAbr: 'GHA',
  OMAbr: 'OMN',
  TNAbr: 'TUN',
  JOAbr: 'JOR',
  HRAbr: 'HRV',
  HTAbr: 'HTI',
  HUAbr: 'HUN',
  HKAbr: 'HKG',
  HNAbr: 'HND',
  HMAbr: 'HMD',
  VEAbr: 'VEN',
  PRAbr: 'PRI',
  PSAbr: 'PSE',
  PWAbr: 'PLW',
  PTAbr: 'PRT',
  SJAbr: 'SJM',
  PYAbr: 'PRY',
  IQAbr: 'IRQ',
  PAAbr: 'PAN',
  PFAbr: 'PYF',
  PGAbr: 'PNG',
  PEAbr: 'PER',
  PKAbr: 'PAK',
  PHAbr: 'PHL',
  PNAbr: 'PCN',
  PLAbr: 'POL',
  PMAbr: 'SPM',
  ZMAbr: 'ZMB',
  EHAbr: 'ESH',
  EEAbr: 'EST',
  EGAbr: 'EGY',
  ZAAbr: 'ZAF',
  ECAbr: 'ECU',
  ITAbr: 'ITA',
  VNAbr: 'VNM',
  SBAbr: 'SLB',
  ETAbr: 'ETH',
  SOAbr: 'SOM',
  ZWAbr: 'ZWE',
  SAAbr: 'SAU',
  ESAbr: 'ESP',
  ERAbr: 'ERI',
  MEAbr: 'MNE',
  MDAbr: 'MDA',
  MGAbr: 'MDG',
  MFAbr: 'MAF',
  MAAbr: 'MAR',
  MCAbr: 'MCO',
  UZAbr: 'UZB',
  MMAbr: 'MMR',
  MLAbr: 'MLI',
  MOAbr: 'MAC',
  MNAbr: 'MNG',
  MHAbr: 'MHL',
  MKAbr: 'MKD',
  MUAbr: 'MUS',
  MTAbr: 'MLT',
  MWAbr: 'MWI',
  MVAbr: 'MDV',
  MQAbr: 'MTQ',
  MPAbr: 'MNP',
  MSAbr: 'MSR',
  MRAbr: 'MRT',
  IMAbr: 'IMN',
  UGAbr: 'UGA',
  TZAbr: 'TZA',
  MYAbr: 'MYS',
  MXAbr: 'MEX',
  ILAbr: 'ISR',
  FRAbr: 'FRA',
  IOAbr: 'IOT',
  SHAbr: 'SHN',
  FIAbr: 'FIN',
  FJAbr: 'FJI',
  FKAbr: 'FLK',
  FMAbr: 'FSM',
  FOAbr: 'FRO',
  NIAbr: 'NIC',
  NLAbr: 'NLD',
  NOAbr: 'NOR',
  NAAbr: 'NAM',
  VUAbr: 'VUT',
  NCAbr: 'NCL',
  NEAbr: 'NER',
  NFAbr: 'NFK',
  NGAbr: 'NGA',
  NZAbr: 'NZL',
  NPAbr: 'NPL',
  NRAbr: 'NRU',
  NUAbr: 'NIU',
  CKAbr: 'COK',
  XKAbr: 'XKX',
  CIAbr: 'CIV',
  CHAbr: 'CHE',
  COAbr: 'COL',
  CNAbr: 'CHN',
  CMAbr: 'CMR',
  CLAbr: 'CHL',
  CCAbr: 'CCK',
  // Abr C'CAN',
  CGAbr: 'COG',
  CFAbr: 'CAF',
  CDAbr: 'COD',
  CZAbr: 'CZE',
  CYAbr: 'CYP',
  CXAbr: 'CXR',
  CRAbr: 'CRI',
  CWAbr: 'CUW',
  CVAbr: 'CPV',
  CUAbr: 'CUB',
  SZAbr: 'SWZ',
  SYAbr: 'SYR',
  SXAbr: 'SXM',
  KGAbr: 'KGZ',
  KEAbr: 'KEN',
  SSAbr: 'SSD',
  SRAbr: 'SUR',
  KIAbr: 'KIR',
  KHAbr: 'KHM',
  KNAbr: 'KNA',
  KMAbr: 'COM',
  STAbr: 'STP',
  SKAbr: 'SVK',
  KRAbr: 'KOR',
  SIAbr: 'SVN',
  KPAbr: 'PRK',
  KWAbr: 'KWT',
  SNAbr: 'SEN',
  SMAbr: 'SMR',
  SLAbr: 'SLE',
  SCAbr: 'SYC',
  KZAbr: 'KAZ',
  KYAbr: 'CYM',
  SGAbr: 'SGP',
  SEAbr: 'SWE',
  SDAbr: 'SDN',
  DOAbr: 'DOM',
  DMAbr: 'DMA',
  DJAbr: 'DJI',
  DKAbr: 'DNK',
  VGAbr: 'VGB',
  DEAbr: 'DEU',
  YEAbr: 'YEM',
  DZAbr: 'DZA',
  // USAbr: 'USA-CAN',
  USAbr: 'USA',
  UYAbr: 'URY',
  YTAbr: 'MYT',
  UMAbr: 'UMI',
  LBAbr: 'LBN',
  LCAbr: 'LCA',
  LAAbr: 'LAO',
  TVAbr: 'TUV',
  TWAbr: 'TWN',
  TTAbr: 'TTO',
  TRAbr: 'TUR',
  LKAbr: 'LKA',
  LIAbr: 'LIE',
  LVAbr: 'LVA',
  TOAbr: 'TON',
  LTAbr: 'LTU',
  LUAbr: 'LUX',
  LRAbr: 'LBR',
  LSAbr: 'LSO',
  THAbr: 'THA',
  TFAbr: 'ATF',
  TGAbr: 'TGO',
  TDAbr: 'TCD',
  TCAbr: 'TCA',
  LYAbr: 'LBY',
  VAAbr: 'VAT',
  VCAbr: 'VCT',
  AEAbr: 'ARE',
  ADAbr: 'AND',
  AGAbr: 'ATG',
  AFAbr: 'AFG',
  AIAbr: 'AIA',
  VIAbr: 'VIR',
  ISAbr: 'ISL',
  IRAbr: 'IRN',
  AMAbr: 'ARM',
  ALAbr: 'ALB',
  AOAbr: 'AGO',
  AQAbr: 'ATA',
  ASAbr: 'ASM',
  ARAbr: 'ARG',
  AUAbr: 'AUS',
  ATAbr: 'AUT',
  AWAbr: 'ABW',
  INAbr: 'IND',
  AXAbr: 'ALA',
  AZAbr: 'AZE',
  IEAbr: 'IRL',
  IDAbr: 'IDN',
  UAAbr: 'UKR',
  QAAbr: 'QAT',
  MZAbr: 'MOZ'
};

var lang = {
  es: es,
  en: en,
  pt: pt
};

var existsComponent = function existsComponent(component) {
  return Vue.options.components[component];
};
var registerComponent = function registerComponent(components) {
  Object.keys(components).forEach(function (name) {
    if (!existsComponent(name)) {
      Vue.component(name, components[name]);
    }
  });
};
On.registerLangAsScope({
  lang: lang,
  scope: 'aqua'
});
Vue.set(Vue.prototype, 'numeral', numeral);
Vue.set(Vue.prototype, 'is', is);
Vue.use(VCalendar);
Vue.use(compiled.ServerTable, {}, false, 'bulma', customTemplatesTable);
Vue.use(compiled.ClientTable, {}, false, 'bulma', customTemplatesTable);
ThirdParty.loadThirdPartyAqua();
global.vtEvent = compiled.Event;
global.aqua = {};
var PackButtons = buttons_packs;
var registerAllComponents = function registerAllComponents() {
  return registerComponent(Components);
};
var install = function install(Vue, options) {
  setOptions(options);
  useDirectives();
  usePrototypes();
  useMixins();
};

// To allow individual component use, export components
// each can be registered via Vue.component()
// export * from '@/lib-components/index';

export { Components, PackButtons, install as default, registerAllComponents };
